import React__default, { useMemo, useRef, Component, useState as useState$2, useEffect, useCallback, createElement, useContext, useReducer, Fragment, useLayoutEffect } from 'react';
import { withRouter, Route, HashRouter, Switch, Redirect } from 'react-router-dom';
import PropTypes, { string as string$1 } from 'prop-types';
import { ProgressCircle, Icon, Tooltip, ButtonCircle, Pill, TextField, Button, NavigationBar, Dialog, SmartText, Select, Table, Checkbox, EditableText, withClickOutside, TextFieldWithIcon, DatesPicker, Opener, SVG_HOST_URL, Modal, Tabs, ImageCard, LoadingBar, CollapsibleBlock, DisplayItems, AllowlistBlocklistTooltip } from 'factor';
import axios from 'axios';
import isEmpty from 'lodash/isEmpty';
import get$1 from 'lodash/get';
import { createPortal } from 'react-dom';
import { useHistory } from 'react-router';
import isEqual from 'lodash/isEqual';
import debounce from 'lodash/debounce';
import isArray$5 from 'lodash/isArray';
import uniqBy from 'lodash/uniqBy';
import find$1 from 'lodash/find';
import isFunction$1 from 'lodash/isFunction';
import startCase from 'lodash/startCase';
import moment from 'moment';
import lowerCase from 'lodash/lowerCase';
import moment$1 from 'moment-timezone';
import isObject$1 from 'lodash/isObject';
import { get as get$2, isObject as isObject$2, sortBy, isEqual as isEqual$1, debounce as debounce$1, truncate as truncate$1 } from 'lodash';
import keyBy from 'lodash/keyBy';
import difference from 'lodash/difference';
import intersectionWith from 'lodash/intersectionWith';
import truncate$1$1 from 'lodash/truncate';
import capitalize from 'lodash/capitalize';

var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

function unwrapExports (x) {
	return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
}

function createCommonjsModule(fn, module) {
	return module = { exports: {} }, fn(module, module.exports), module.exports;
}

var runtime_1 = createCommonjsModule(function (module) {
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var runtime = (function (exports) {

  var Op = Object.prototype;
  var hasOwn = Op.hasOwnProperty;
  var undefined$1; // More compressible than void 0.
  var $Symbol = typeof Symbol === "function" ? Symbol : {};
  var iteratorSymbol = $Symbol.iterator || "@@iterator";
  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

  function define(obj, key, value) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
    return obj[key];
  }
  try {
    // IE 8 has a broken Object.defineProperty that only works on DOM objects.
    define({}, "");
  } catch (err) {
    define = function(obj, key, value) {
      return obj[key] = value;
    };
  }

  function wrap(innerFn, outerFn, self, tryLocsList) {
    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
    var generator = Object.create(protoGenerator.prototype);
    var context = new Context(tryLocsList || []);

    // The ._invoke method unifies the implementations of the .next,
    // .throw, and .return methods.
    generator._invoke = makeInvokeMethod(innerFn, self, context);

    return generator;
  }
  exports.wrap = wrap;

  // Try/catch helper to minimize deoptimizations. Returns a completion
  // record like context.tryEntries[i].completion. This interface could
  // have been (and was previously) designed to take a closure to be
  // invoked without arguments, but in all the cases we care about we
  // already have an existing method we want to call, so there's no need
  // to create a new function object. We can even get away with assuming
  // the method takes exactly one argument, since that happens to be true
  // in every case, so we don't have to touch the arguments object. The
  // only additional allocation required is the completion record, which
  // has a stable shape and so hopefully should be cheap to allocate.
  function tryCatch(fn, obj, arg) {
    try {
      return { type: "normal", arg: fn.call(obj, arg) };
    } catch (err) {
      return { type: "throw", arg: err };
    }
  }

  var GenStateSuspendedStart = "suspendedStart";
  var GenStateSuspendedYield = "suspendedYield";
  var GenStateExecuting = "executing";
  var GenStateCompleted = "completed";

  // Returning this object from the innerFn has the same effect as
  // breaking out of the dispatch switch statement.
  var ContinueSentinel = {};

  // Dummy constructor functions that we use as the .constructor and
  // .constructor.prototype properties for functions that return Generator
  // objects. For full spec compliance, you may wish to configure your
  // minifier not to mangle the names of these two functions.
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}

  // This is a polyfill for %IteratorPrototype% for environments that
  // don't natively support it.
  var IteratorPrototype = {};
  define(IteratorPrototype, iteratorSymbol, function () {
    return this;
  });

  var getProto = Object.getPrototypeOf;
  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  if (NativeIteratorPrototype &&
      NativeIteratorPrototype !== Op &&
      hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
    // This environment has a native %IteratorPrototype%; use it instead
    // of the polyfill.
    IteratorPrototype = NativeIteratorPrototype;
  }

  var Gp = GeneratorFunctionPrototype.prototype =
    Generator.prototype = Object.create(IteratorPrototype);
  GeneratorFunction.prototype = GeneratorFunctionPrototype;
  define(Gp, "constructor", GeneratorFunctionPrototype);
  define(GeneratorFunctionPrototype, "constructor", GeneratorFunction);
  GeneratorFunction.displayName = define(
    GeneratorFunctionPrototype,
    toStringTagSymbol,
    "GeneratorFunction"
  );

  // Helper for defining the .next, .throw, and .return methods of the
  // Iterator interface in terms of a single ._invoke method.
  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function(method) {
      define(prototype, method, function(arg) {
        return this._invoke(method, arg);
      });
    });
  }

  exports.isGeneratorFunction = function(genFun) {
    var ctor = typeof genFun === "function" && genFun.constructor;
    return ctor
      ? ctor === GeneratorFunction ||
        // For the native GeneratorFunction constructor, the best we can
        // do is to check its .name property.
        (ctor.displayName || ctor.name) === "GeneratorFunction"
      : false;
  };

  exports.mark = function(genFun) {
    if (Object.setPrototypeOf) {
      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
    } else {
      genFun.__proto__ = GeneratorFunctionPrototype;
      define(genFun, toStringTagSymbol, "GeneratorFunction");
    }
    genFun.prototype = Object.create(Gp);
    return genFun;
  };

  // Within the body of any async function, `await x` is transformed to
  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
  // `hasOwn.call(value, "__await")` to determine if the yielded value is
  // meant to be awaited.
  exports.awrap = function(arg) {
    return { __await: arg };
  };

  function AsyncIterator(generator, PromiseImpl) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);
      if (record.type === "throw") {
        reject(record.arg);
      } else {
        var result = record.arg;
        var value = result.value;
        if (value &&
            typeof value === "object" &&
            hasOwn.call(value, "__await")) {
          return PromiseImpl.resolve(value.__await).then(function(value) {
            invoke("next", value, resolve, reject);
          }, function(err) {
            invoke("throw", err, resolve, reject);
          });
        }

        return PromiseImpl.resolve(value).then(function(unwrapped) {
          // When a yielded Promise is resolved, its final value becomes
          // the .value of the Promise<{value,done}> result for the
          // current iteration.
          result.value = unwrapped;
          resolve(result);
        }, function(error) {
          // If a rejected Promise was yielded, throw the rejection back
          // into the async generator function so it can be handled there.
          return invoke("throw", error, resolve, reject);
        });
      }
    }

    var previousPromise;

    function enqueue(method, arg) {
      function callInvokeWithMethodAndArg() {
        return new PromiseImpl(function(resolve, reject) {
          invoke(method, arg, resolve, reject);
        });
      }

      return previousPromise =
        // If enqueue has been called before, then we want to wait until
        // all previous Promises have been resolved before calling invoke,
        // so that results are always delivered in the correct order. If
        // enqueue has not been called before, then it is important to
        // call invoke immediately, without waiting on a callback to fire,
        // so that the async generator function has the opportunity to do
        // any necessary setup in a predictable way. This predictability
        // is why the Promise constructor synchronously invokes its
        // executor callback, and why async functions synchronously
        // execute code before the first await. Since we implement simple
        // async functions in terms of async generators, it is especially
        // important to get this right, even though it requires care.
        previousPromise ? previousPromise.then(
          callInvokeWithMethodAndArg,
          // Avoid propagating failures to Promises returned by later
          // invocations of the iterator.
          callInvokeWithMethodAndArg
        ) : callInvokeWithMethodAndArg();
    }

    // Define the unified helper method that is used to implement .next,
    // .throw, and .return (see defineIteratorMethods).
    this._invoke = enqueue;
  }

  defineIteratorMethods(AsyncIterator.prototype);
  define(AsyncIterator.prototype, asyncIteratorSymbol, function () {
    return this;
  });
  exports.AsyncIterator = AsyncIterator;

  // Note that simple async functions are implemented on top of
  // AsyncIterator objects; they just return a Promise for the value of
  // the final result produced by the iterator.
  exports.async = function(innerFn, outerFn, self, tryLocsList, PromiseImpl) {
    if (PromiseImpl === void 0) PromiseImpl = Promise;

    var iter = new AsyncIterator(
      wrap(innerFn, outerFn, self, tryLocsList),
      PromiseImpl
    );

    return exports.isGeneratorFunction(outerFn)
      ? iter // If outerFn is a generator, return the full iterator.
      : iter.next().then(function(result) {
          return result.done ? result.value : iter.next();
        });
  };

  function makeInvokeMethod(innerFn, self, context) {
    var state = GenStateSuspendedStart;

    return function invoke(method, arg) {
      if (state === GenStateExecuting) {
        throw new Error("Generator is already running");
      }

      if (state === GenStateCompleted) {
        if (method === "throw") {
          throw arg;
        }

        // Be forgiving, per 25.3.3.3.3 of the spec:
        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
        return doneResult();
      }

      context.method = method;
      context.arg = arg;

      while (true) {
        var delegate = context.delegate;
        if (delegate) {
          var delegateResult = maybeInvokeDelegate(delegate, context);
          if (delegateResult) {
            if (delegateResult === ContinueSentinel) continue;
            return delegateResult;
          }
        }

        if (context.method === "next") {
          // Setting context._sent for legacy support of Babel's
          // function.sent implementation.
          context.sent = context._sent = context.arg;

        } else if (context.method === "throw") {
          if (state === GenStateSuspendedStart) {
            state = GenStateCompleted;
            throw context.arg;
          }

          context.dispatchException(context.arg);

        } else if (context.method === "return") {
          context.abrupt("return", context.arg);
        }

        state = GenStateExecuting;

        var record = tryCatch(innerFn, self, context);
        if (record.type === "normal") {
          // If an exception is thrown from innerFn, we leave state ===
          // GenStateExecuting and loop back for another invocation.
          state = context.done
            ? GenStateCompleted
            : GenStateSuspendedYield;

          if (record.arg === ContinueSentinel) {
            continue;
          }

          return {
            value: record.arg,
            done: context.done
          };

        } else if (record.type === "throw") {
          state = GenStateCompleted;
          // Dispatch the exception by looping back around to the
          // context.dispatchException(context.arg) call above.
          context.method = "throw";
          context.arg = record.arg;
        }
      }
    };
  }

  // Call delegate.iterator[context.method](context.arg) and handle the
  // result, either by returning a { value, done } result from the
  // delegate iterator, or by modifying context.method and context.arg,
  // setting context.delegate to null, and returning the ContinueSentinel.
  function maybeInvokeDelegate(delegate, context) {
    var method = delegate.iterator[context.method];
    if (method === undefined$1) {
      // A .throw or .return when the delegate iterator has no .throw
      // method always terminates the yield* loop.
      context.delegate = null;

      if (context.method === "throw") {
        // Note: ["return"] must be used for ES3 parsing compatibility.
        if (delegate.iterator["return"]) {
          // If the delegate iterator has a return method, give it a
          // chance to clean up.
          context.method = "return";
          context.arg = undefined$1;
          maybeInvokeDelegate(delegate, context);

          if (context.method === "throw") {
            // If maybeInvokeDelegate(context) changed context.method from
            // "return" to "throw", let that override the TypeError below.
            return ContinueSentinel;
          }
        }

        context.method = "throw";
        context.arg = new TypeError(
          "The iterator does not provide a 'throw' method");
      }

      return ContinueSentinel;
    }

    var record = tryCatch(method, delegate.iterator, context.arg);

    if (record.type === "throw") {
      context.method = "throw";
      context.arg = record.arg;
      context.delegate = null;
      return ContinueSentinel;
    }

    var info = record.arg;

    if (! info) {
      context.method = "throw";
      context.arg = new TypeError("iterator result is not an object");
      context.delegate = null;
      return ContinueSentinel;
    }

    if (info.done) {
      // Assign the result of the finished delegate to the temporary
      // variable specified by delegate.resultName (see delegateYield).
      context[delegate.resultName] = info.value;

      // Resume execution at the desired location (see delegateYield).
      context.next = delegate.nextLoc;

      // If context.method was "throw" but the delegate handled the
      // exception, let the outer generator proceed normally. If
      // context.method was "next", forget context.arg since it has been
      // "consumed" by the delegate iterator. If context.method was
      // "return", allow the original .return call to continue in the
      // outer generator.
      if (context.method !== "return") {
        context.method = "next";
        context.arg = undefined$1;
      }

    } else {
      // Re-yield the result returned by the delegate method.
      return info;
    }

    // The delegate iterator is finished, so forget it and continue with
    // the outer generator.
    context.delegate = null;
    return ContinueSentinel;
  }

  // Define Generator.prototype.{next,throw,return} in terms of the
  // unified ._invoke helper method.
  defineIteratorMethods(Gp);

  define(Gp, toStringTagSymbol, "Generator");

  // A Generator should always return itself as the iterator object when the
  // @@iterator function is called on it. Some browsers' implementations of the
  // iterator prototype chain incorrectly implement this, causing the Generator
  // object to not be returned from this call. This ensures that doesn't happen.
  // See https://github.com/facebook/regenerator/issues/274 for more details.
  define(Gp, iteratorSymbol, function() {
    return this;
  });

  define(Gp, "toString", function() {
    return "[object Generator]";
  });

  function pushTryEntry(locs) {
    var entry = { tryLoc: locs[0] };

    if (1 in locs) {
      entry.catchLoc = locs[1];
    }

    if (2 in locs) {
      entry.finallyLoc = locs[2];
      entry.afterLoc = locs[3];
    }

    this.tryEntries.push(entry);
  }

  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal";
    delete record.arg;
    entry.completion = record;
  }

  function Context(tryLocsList) {
    // The root entry object (effectively a try statement without a catch
    // or a finally block) gives us a place to store values thrown from
    // locations where there is no enclosing try statement.
    this.tryEntries = [{ tryLoc: "root" }];
    tryLocsList.forEach(pushTryEntry, this);
    this.reset(true);
  }

  exports.keys = function(object) {
    var keys = [];
    for (var key in object) {
      keys.push(key);
    }
    keys.reverse();

    // Rather than returning an object with a next method, we keep
    // things simple and return the next function itself.
    return function next() {
      while (keys.length) {
        var key = keys.pop();
        if (key in object) {
          next.value = key;
          next.done = false;
          return next;
        }
      }

      // To avoid creating an additional object, we just hang the .value
      // and .done properties off the next function object itself. This
      // also ensures that the minifier will not anonymize the function.
      next.done = true;
      return next;
    };
  };

  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) {
        return iteratorMethod.call(iterable);
      }

      if (typeof iterable.next === "function") {
        return iterable;
      }

      if (!isNaN(iterable.length)) {
        var i = -1, next = function next() {
          while (++i < iterable.length) {
            if (hasOwn.call(iterable, i)) {
              next.value = iterable[i];
              next.done = false;
              return next;
            }
          }

          next.value = undefined$1;
          next.done = true;

          return next;
        };

        return next.next = next;
      }
    }

    // Return an iterator with no values.
    return { next: doneResult };
  }
  exports.values = values;

  function doneResult() {
    return { value: undefined$1, done: true };
  }

  Context.prototype = {
    constructor: Context,

    reset: function(skipTempReset) {
      this.prev = 0;
      this.next = 0;
      // Resetting context._sent for legacy support of Babel's
      // function.sent implementation.
      this.sent = this._sent = undefined$1;
      this.done = false;
      this.delegate = null;

      this.method = "next";
      this.arg = undefined$1;

      this.tryEntries.forEach(resetTryEntry);

      if (!skipTempReset) {
        for (var name in this) {
          // Not sure about the optimal order of these conditions:
          if (name.charAt(0) === "t" &&
              hasOwn.call(this, name) &&
              !isNaN(+name.slice(1))) {
            this[name] = undefined$1;
          }
        }
      }
    },

    stop: function() {
      this.done = true;

      var rootEntry = this.tryEntries[0];
      var rootRecord = rootEntry.completion;
      if (rootRecord.type === "throw") {
        throw rootRecord.arg;
      }

      return this.rval;
    },

    dispatchException: function(exception) {
      if (this.done) {
        throw exception;
      }

      var context = this;
      function handle(loc, caught) {
        record.type = "throw";
        record.arg = exception;
        context.next = loc;

        if (caught) {
          // If the dispatched exception was caught by a catch block,
          // then let that catch block handle the exception normally.
          context.method = "next";
          context.arg = undefined$1;
        }

        return !! caught;
      }

      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        var record = entry.completion;

        if (entry.tryLoc === "root") {
          // Exception thrown outside of any try block that could handle
          // it, so set the completion value of the entire function to
          // throw the exception.
          return handle("end");
        }

        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc");
          var hasFinally = hasOwn.call(entry, "finallyLoc");

          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            } else if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            }

          } else if (hasFinally) {
            if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else {
            throw new Error("try statement without catch or finally");
          }
        }
      }
    },

    abrupt: function(type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc <= this.prev &&
            hasOwn.call(entry, "finallyLoc") &&
            this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }

      if (finallyEntry &&
          (type === "break" ||
           type === "continue") &&
          finallyEntry.tryLoc <= arg &&
          arg <= finallyEntry.finallyLoc) {
        // Ignore the finally entry if control is not jumping to a
        // location outside the try/catch block.
        finallyEntry = null;
      }

      var record = finallyEntry ? finallyEntry.completion : {};
      record.type = type;
      record.arg = arg;

      if (finallyEntry) {
        this.method = "next";
        this.next = finallyEntry.finallyLoc;
        return ContinueSentinel;
      }

      return this.complete(record);
    },

    complete: function(record, afterLoc) {
      if (record.type === "throw") {
        throw record.arg;
      }

      if (record.type === "break" ||
          record.type === "continue") {
        this.next = record.arg;
      } else if (record.type === "return") {
        this.rval = this.arg = record.arg;
        this.method = "return";
        this.next = "end";
      } else if (record.type === "normal" && afterLoc) {
        this.next = afterLoc;
      }

      return ContinueSentinel;
    },

    finish: function(finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) {
          this.complete(entry.completion, entry.afterLoc);
          resetTryEntry(entry);
          return ContinueSentinel;
        }
      }
    },

    "catch": function(tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;
          if (record.type === "throw") {
            var thrown = record.arg;
            resetTryEntry(entry);
          }
          return thrown;
        }
      }

      // The context.catch method must only be called with a location
      // argument that corresponds to a known catch block.
      throw new Error("illegal catch attempt");
    },

    delegateYield: function(iterable, resultName, nextLoc) {
      this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      };

      if (this.method === "next") {
        // Deliberately forget the last sent value so that we don't
        // accidentally pass it on to the delegate.
        this.arg = undefined$1;
      }

      return ContinueSentinel;
    }
  };

  // Regardless of whether this script is executing as a CommonJS module
  // or not, return the runtime object so that we can declare the variable
  // regeneratorRuntime in the outer scope, which allows this module to be
  // injected easily by `bin/regenerator --include-runtime script.js`.
  return exports;

}(
  // If this script is executing as a CommonJS module, use module.exports
  // as the regeneratorRuntime namespace. Otherwise create a new empty
  // object. Either way, the resulting object will be used to initialize
  // the regeneratorRuntime variable at the top of this file.
   module.exports 
));

try {
  regeneratorRuntime = runtime;
} catch (accidentalStrictMode) {
  // This module should not be running in strict mode, so the above
  // assignment should always work unless something is misconfigured. Just
  // in case runtime.js accidentally runs in strict mode, in modern engines
  // we can explicitly access globalThis. In older engines we can escape
  // strict mode using a global Function call. This could conceivably fail
  // if a Content Security Policy forbids using Function, but in that case
  // the proper solution is to fix the accidental strict mode problem. If
  // you've misconfigured your bundler to force strict mode and applied a
  // CSP to forbid Function, and you're not willing to fix either of those
  // problems, please detail your unique predicament in a GitHub issue.
  if (typeof globalThis === "object") {
    globalThis.regeneratorRuntime = runtime;
  } else {
    Function("r", "regeneratorRuntime = r")(runtime);
  }
}
});

var regenerator = runtime_1;

var _extends_1 = createCommonjsModule(function (module) {
function _extends() {
  module.exports = _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  }, module.exports.__esModule = true, module.exports["default"] = module.exports;
  return _extends.apply(this, arguments);
}

module.exports = _extends, module.exports.__esModule = true, module.exports["default"] = module.exports;
});

var _extends = unwrapExports(_extends_1);

var asyncToGenerator = createCommonjsModule(function (module) {
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

module.exports = _asyncToGenerator, module.exports.__esModule = true, module.exports["default"] = module.exports;
});

var _asyncToGenerator = unwrapExports(asyncToGenerator);

var classCallCheck = createCommonjsModule(function (module) {
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

module.exports = _classCallCheck, module.exports.__esModule = true, module.exports["default"] = module.exports;
});

var _classCallCheck = unwrapExports(classCallCheck);

var createClass = createCommonjsModule(function (module) {
function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
}

module.exports = _createClass, module.exports.__esModule = true, module.exports["default"] = module.exports;
});

var _createClass = unwrapExports(createClass);

var setPrototypeOf = createCommonjsModule(function (module) {
function _setPrototypeOf(o, p) {
  module.exports = _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  }, module.exports.__esModule = true, module.exports["default"] = module.exports;
  return _setPrototypeOf(o, p);
}

module.exports = _setPrototypeOf, module.exports.__esModule = true, module.exports["default"] = module.exports;
});

unwrapExports(setPrototypeOf);

var inherits = createCommonjsModule(function (module) {
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  Object.defineProperty(subClass, "prototype", {
    writable: false
  });
  if (superClass) setPrototypeOf(subClass, superClass);
}

module.exports = _inherits, module.exports.__esModule = true, module.exports["default"] = module.exports;
});

var _inherits = unwrapExports(inherits);

var _typeof_1 = createCommonjsModule(function (module) {
function _typeof(obj) {
  "@babel/helpers - typeof";

  return (module.exports = _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, module.exports.__esModule = true, module.exports["default"] = module.exports), _typeof(obj);
}

module.exports = _typeof, module.exports.__esModule = true, module.exports["default"] = module.exports;
});

unwrapExports(_typeof_1);

var assertThisInitialized = createCommonjsModule(function (module) {
function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

module.exports = _assertThisInitialized, module.exports.__esModule = true, module.exports["default"] = module.exports;
});

unwrapExports(assertThisInitialized);

var possibleConstructorReturn = createCommonjsModule(function (module) {
var _typeof = _typeof_1["default"];



function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }

  return assertThisInitialized(self);
}

module.exports = _possibleConstructorReturn, module.exports.__esModule = true, module.exports["default"] = module.exports;
});

var _possibleConstructorReturn = unwrapExports(possibleConstructorReturn);

var getPrototypeOf = createCommonjsModule(function (module) {
function _getPrototypeOf(o) {
  module.exports = _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  }, module.exports.__esModule = true, module.exports["default"] = module.exports;
  return _getPrototypeOf(o);
}

module.exports = _getPrototypeOf, module.exports.__esModule = true, module.exports["default"] = module.exports;
});

var _getPrototypeOf = unwrapExports(getPrototypeOf);

var defineProperty = createCommonjsModule(function (module) {
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

module.exports = _defineProperty, module.exports.__esModule = true, module.exports["default"] = module.exports;
});

var _defineProperty = unwrapExports(defineProperty);

var REACT_APP_VERSION = process.env.REACT_APP_VERSION || '';
var REACT_APP_ENVIRONMENT = process.env.REACT_APP_ENVIRONMENT || '';
var isProd = REACT_APP_ENVIRONMENT === 'production';
var IS_SUPER_USER = process.env.REACT_APP_SUPER_ADMIN === 'true';
var REACT_APP_WORKSPACE_URL = process.env.REACT_APP_WORKSPACE_URL || 'https://admin1.stage.inhousebuying.com';
var DEFAULT_URL = isProd ? 'https://app.inousebuying.com' : process.env.REACT_APP_IHP === 'true' ? 'https://app.stage.inhousebuying.com' : REACT_APP_WORKSPACE_URL; // const DEFAULT_SUPER_URL = isProd ? 'https://super.iqm.com' : 'https://super.stage.iqm.com';
// const DEFAULT = IS_SUPER_USER ? DEFAULT_SUPER_URL : DEFAULT_URL;

var ORIGIN_URL = window.location.origin.includes('localhost') ? DEFAULT_URL : window.location.origin;
var IS_LOCAL_ENV = window.location.origin.includes('localhost');
var LOGIN_URL = "".concat(ORIGIN_URL, "/api/v3/ua/login");
var LOGOUT_URL_END = IS_SUPER_USER ? '/api/v2/auth/oauth2/logout' : '/api/logout';
var ADVERTISER_PROFILE_URL = "".concat(ORIGIN_URL, "/api/manage/profile");
var ADMIN_PROFILE_URL = isProd ? '/api/manage/profile' : 'https://admin1.stage.iqm.com/api/manage/profile';
var USER_AVATAR_URL = "".concat(ORIGIN_URL, "/api/v2/avatar");
var VALIDATE_TOKEN_URL = "".concat(ORIGIN_URL, "/api/v2/auth/validate-token");
var EXPORT_DOWNLOAD_URL = "".concat(ORIGIN_URL, "/api/v2/rb/export");
var BASIC_AUTH_HEADER_VALUE = 'Basic N3BuaWJrdWpleTFvanJnbnNsbjU6MTIzNDU2';
var isIHPOwner = function isIHPOwner() {
  var initData = JSON.parse(localStorage.getItem('initData') || '{}');
  return Boolean(initData.ihpOwner);
};
var getPathNumber = function getPathNumber() {
  var href = window.location.href;

  if (href.includes('localhost')) {
    return 0;
  }

  try {
    var num = Number(href.match(/\/u\/[0-9]+/)[0].substring(3));
    return isNaN(num) ? 0 : num;
  } catch (e) {
    return 0;
  }
};
var isLocalhost = function isLocalhost() {
  return Boolean(window.location.hostname === 'localhost' || window.location.hostname === '[::1]' || window.location.hostname.match(/^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/));
};
var owIdMap = [];
var getOwId = function getOwId() {
  try {
    var num = getPathNumber();

    if (owIdMap[num] != null) {
      return owIdMap[num];
    }

    var owIds = JSON.parse(localStorage.getItem('owIds'));

    if (!Array.isArray(owIds) || !owIds.length) {
      throw new Error('owIds array in localStorage has some issues');
    }

    owIdMap[num] = String(owIds[num]);
    return owIdMap[num];
  } catch (e) {
    return null;
  }
};
var setColorVariables = function setColorVariables() {
  var r = document.querySelector(':root');
  r.style.setProperty('--primary1', '#04363D');
  r.style.setProperty('--primary2', '#3A827E');
  r.style.setProperty('--primary3', '#3FD4AD');
  r.style.setProperty('--primary4', '#80F2D4');
  r.style.setProperty('--primary5', '#CCFBEE');
  r.style.setProperty('--primary6', '#CCFBEE');
  r.style.setProperty('--primary7', '#F3FFFC');
};
var INTERCOM_APP_ID = 'p7yzll40';
var getConfig = function getConfig() {
  return {
    IS_SUPER_USER: IS_SUPER_USER,
    LOGIN_URL: LOGIN_URL,
    LOGOUT_URL_END: LOGOUT_URL_END,
    ADVERTISER_PROFILE_URL: ADVERTISER_PROFILE_URL,
    ADMIN_PROFILE_URL: ADMIN_PROFILE_URL,
    USER_AVATAR_URL: USER_AVATAR_URL,
    VALIDATE_TOKEN_URL: VALIDATE_TOKEN_URL,
    EXPORT_DOWNLOAD_URL: EXPORT_DOWNLOAD_URL
  };
};

var isNativeFunction = createCommonjsModule(function (module) {
function _isNativeFunction(fn) {
  return Function.toString.call(fn).indexOf("[native code]") !== -1;
}

module.exports = _isNativeFunction, module.exports.__esModule = true, module.exports["default"] = module.exports;
});

unwrapExports(isNativeFunction);

var isNativeReflectConstruct = createCommonjsModule(function (module) {
function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

module.exports = _isNativeReflectConstruct, module.exports.__esModule = true, module.exports["default"] = module.exports;
});

unwrapExports(isNativeReflectConstruct);

var construct = createCommonjsModule(function (module) {
function _construct(Parent, args, Class) {
  if (isNativeReflectConstruct()) {
    module.exports = _construct = Reflect.construct, module.exports.__esModule = true, module.exports["default"] = module.exports;
  } else {
    module.exports = _construct = function _construct(Parent, args, Class) {
      var a = [null];
      a.push.apply(a, args);
      var Constructor = Function.bind.apply(Parent, a);
      var instance = new Constructor();
      if (Class) setPrototypeOf(instance, Class.prototype);
      return instance;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports;
  }

  return _construct.apply(null, arguments);
}

module.exports = _construct, module.exports.__esModule = true, module.exports["default"] = module.exports;
});

unwrapExports(construct);

var wrapNativeSuper = createCommonjsModule(function (module) {
function _wrapNativeSuper(Class) {
  var _cache = typeof Map === "function" ? new Map() : undefined;

  module.exports = _wrapNativeSuper = function _wrapNativeSuper(Class) {
    if (Class === null || !isNativeFunction(Class)) return Class;

    if (typeof Class !== "function") {
      throw new TypeError("Super expression must either be null or a function");
    }

    if (typeof _cache !== "undefined") {
      if (_cache.has(Class)) return _cache.get(Class);

      _cache.set(Class, Wrapper);
    }

    function Wrapper() {
      return construct(Class, arguments, getPrototypeOf(this).constructor);
    }

    Wrapper.prototype = Object.create(Class.prototype, {
      constructor: {
        value: Wrapper,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    return setPrototypeOf(Wrapper, Class);
  }, module.exports.__esModule = true, module.exports["default"] = module.exports;
  return _wrapNativeSuper(Class);
}

module.exports = _wrapNativeSuper, module.exports.__esModule = true, module.exports["default"] = module.exports;
});

var _wrapNativeSuper = unwrapExports(wrapNativeSuper);

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var ServerError = /*#__PURE__*/function (_Error) {
  _inherits(ServerError, _Error);

  var _super = _createSuper(ServerError);

  function ServerError(props) {
    var _this;

    _classCallCheck(this, ServerError);

    _this = _super.call(this, props);
    _this.name = 'ServerError';

    if (props.response) {
      var _ref = props.response.data || {},
          errorObjects = _ref.errorObjects;

      _this.errorMessage = Array.isArray(errorObjects) ? errorObjects[0].error : '';
      _this.status = props.response.status;
      _this.data = props.response.data;

      if (props.response.status === 401) {
        if (AuthService.logout) {
          AuthService.logout();
        } else {
          window.localStorage.removeItem(BASE_INFO_NAME);
          window.location.href = '/';
        }
      }
    } else {
      _this.message = 'Endpoint is not available';
    }

    return _this;
  }

  return _createClass(ServerError);
}( /*#__PURE__*/_wrapNativeSuper(Error));

var getDomainURL = function getDomainURL() {
  return ORIGIN_URL.replace(/^https?:\/\//, '');
};

var userAuth = function userAuth(data) {
  return {
    userType: data.userType,
    domainURL: getDomainURL(),
    apiToken: data.access_token
  };
};

var userProfile = function userProfile(data) {
  return {
    firstName: data.firstName || data.first_name,
    lastName: data.lastName || data.last_name,
    email: data.email,
    organizationName: data.organizationName,
    userAvatar: data.userAvatar,
    organizationLogo: data.organizationLogo,
    failureDetails: data.failureDetails,
    displayName: data.displayName,
    invoiceId: data.invoiceId,
    dspId: data.dsp_id,
    userId: data.user_id,
    userType: data.user_type_id,
    loginEmail: data.login_email,
    timezoneId: data.timezone || data.user_timezone_id,
    timezoneName: data.timezone_country_name,
    address: data.address,
    zipCode: data.zip_code,
    phone: data.phone,
    websiteUrl: data.website,
    version: data.version,
    isCampaignApprovalAccess: data.is_campaign_approval_access,
    isCreativeApprovalAccess: data.is_creative_approval_access,
    isSegmentedAudienceAllowed: data.is_segmented_audience_allowed,
    allowExtendedReportDuration: data.allowExtendedReportDuration,
    isWorkspaceOwnerOrg: data.isWorkspaceOwnerOrg,
    isCampaignAppOwner: data.isCampaignAppOwner,
    isPlatformOwnerOrg: data.isPlatformOwnerOrg,
    segmentedCountryId: data.segmentedCountryId,
    owId: data.owId,
    isOwnerUser: data.isOwnerUser,
    parentOrganization: data.parentOrganization,
    organizationTimezone: data.organizationTimezone
  };
};

var getToken = function getToken() {
  var _AuthService$getUser;

  return ((_AuthService$getUser = AuthService.getUser()) === null || _AuthService$getUser === void 0 ? void 0 : _AuthService$getUser.apiToken) || '';
};

var getHeaders = function getHeaders() {
  var user = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var owId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : getOwId();
  return {
    'x-iaa-ow-id': owId,
    authorization: "Bearer ".concat(user.apiToken || getToken())
  };
};

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var config = getConfig();
var INIT_DATA = 'initData';

var Api = /*#__PURE__*/function () {
  function Api() {
    var _this$initData;

    _classCallCheck(this, Api);

    this.initData = undefined;
    this.initData = JSON.parse(localStorage.getItem(INIT_DATA) || 'null');

    if (((_this$initData = this.initData) === null || _this$initData === void 0 ? void 0 : _this$initData.ihpOwner) === false) {
      setColorVariables();
    }
  }

  _createClass(Api, [{
    key: "authenticate",
    value: function () {
      var _authenticate = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee(_ref) {
        var email, password, response, owId;
        return regenerator.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                email = _ref.email, password = _ref.password;
                _context.prev = 1;
                _context.next = 4;
                return axios.post("".concat(config.LOGIN_URL, "?advertiserId=login"), {
                  email: email,
                  password: password,
                  grantType: 'password'
                }, {
                  headers: {
                    Authorization: BASIC_AUTH_HEADER_VALUE
                  }
                });

              case 4:
                response = _context.sent;

                if (!response.data.success) {
                  _context.next = 9;
                  break;
                }

                owId = response.data.data.owId;
                localStorage.setItem('owIds', JSON.stringify([owId]));
                return _context.abrupt("return", userAuth(response.data.data));

              case 9:
                throw {
                  response: response
                };

              case 12:
                _context.prev = 12;
                _context.t0 = _context["catch"](1);
                throw new ServerError(_context.t0);

              case 15:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[1, 12]]);
      }));

      function authenticate(_x) {
        return _authenticate.apply(this, arguments);
      }

      return authenticate;
    }()
  }, {
    key: "fetchUserProfile",
    value: function () {
      var _fetchUserProfile = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee2(_ref2, owId) {
        var apiToken, response;
        return regenerator.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                apiToken = _ref2.apiToken;
                _context2.prev = 1;
                _context2.next = 4;
                return axios({
                  url: "".concat(ORIGIN_URL, "/api/v3/ua/profile"),
                  headers: getHeaders({
                    apiToken: apiToken
                  }, owId)
                });

              case 4:
                response = _context2.sent;
                return _context2.abrupt("return", userProfile(response.data.data));

              case 8:
                _context2.prev = 8;
                _context2.t0 = _context2["catch"](1);
                throw new ServerError(_context2.t0);

              case 11:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, null, [[1, 8]]);
      }));

      function fetchUserProfile(_x2, _x3) {
        return _fetchUserProfile.apply(this, arguments);
      }

      return fetchUserProfile;
    }()
  }, {
    key: "uploadUserAvatar",
    value: function () {
      var _uploadUserAvatar = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee3(base64, ext) {
        var user, response;
        return regenerator.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.prev = 0;
                user = AuthService.getUser();

                if (user) {
                  _context3.next = 4;
                  break;
                }

                return _context3.abrupt("return", null);

              case 4:
                _context3.next = 6;
                return axios.put("".concat(config.USER_AVATAR_URL, "/").concat(ext), base64, {
                  headers: _objectSpread(_objectSpread({}, getHeaders(user)), {}, {
                    'Content-Type': 'text/plain'
                  })
                });

              case 6:
                response = _context3.sent;
                return _context3.abrupt("return", response.data.avatar);

              case 10:
                _context3.prev = 10;
                _context3.t0 = _context3["catch"](0);
                throw new ServerError(_context3.t0);

              case 13:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, null, [[0, 10]]);
      }));

      function uploadUserAvatar(_x4, _x5) {
        return _uploadUserAvatar.apply(this, arguments);
      }

      return uploadUserAvatar;
    }()
  }, {
    key: "fetchAdvertiserBalance",
    value: function () {
      var _fetchAdvertiserBalance = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee4(advertiserId) {
        var user, response;
        return regenerator.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.prev = 0;
                user = AuthService.getUser();

                if (user) {
                  _context4.next = 4;
                  break;
                }

                return _context4.abrupt("return", null);

              case 4:
                _context4.next = 6;
                return axios({
                  url: "".concat(ORIGIN_URL, "/api/v2/advertiser/getavailablebalance"),
                  headers: getHeaders(user),
                  params: {
                    list_adv: advertiserId,
                    advertiserId: user.userId
                  }
                });

              case 6:
                response = _context4.sent;
                return _context4.abrupt("return", get$1(response, 'data[0].finance_available_balance', 0));

              case 10:
                _context4.prev = 10;
                _context4.t0 = _context4["catch"](0);
                console.log(_context4.t0);
                throw new ServerError(_context4.t0);

              case 14:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, null, [[0, 10]]);
      }));

      function fetchAdvertiserBalance(_x6) {
        return _fetchAdvertiserBalance.apply(this, arguments);
      }

      return fetchAdvertiserBalance;
    }()
  }, {
    key: "fetchUserApps",
    value: function () {
      var _fetchUserApps = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee5() {
        var user, owId, response;
        return regenerator.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.prev = 0;
                user = AuthService.getUser();
                owId = getOwId();

                if (!(!(owId !== null && owId !== void 0 && owId.length) || !user)) {
                  _context5.next = 5;
                  break;
                }

                throw new Error('ow ID or user not present');

              case 5:
                _context5.next = 7;
                return axios({
                  url: "".concat(ORIGIN_URL, "/api/v3/ua/user/allowed-applications"),
                  headers: getHeaders(user, owId)
                });

              case 7:
                response = _context5.sent;
                return _context5.abrupt("return", response.data.data);

              case 11:
                _context5.prev = 11;
                _context5.t0 = _context5["catch"](0);
                throw new ServerError(_context5.t0);

              case 14:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, null, [[0, 11]]);
      }));

      function fetchUserApps() {
        return _fetchUserApps.apply(this, arguments);
      }

      return fetchUserApps;
    }()
  }, {
    key: "fetchOrganizations",
    value: function () {
      var _fetchOrganizations = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee6(_ref3) {
        var searchField, params, user, owId, response;
        return regenerator.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                searchField = _ref3.searchField;
                params = new URLSearchParams({
                  searchField: searchField
                });
                _context6.prev = 2;
                user = AuthService.getUser();
                owId = getOwId();

                if (!(!(owId !== null && owId !== void 0 && owId.length) || !user)) {
                  _context6.next = 7;
                  break;
                }

                throw new Error('ow ID or user not present');

              case 7:
                _context6.next = 9;
                return axios({
                  url: "".concat(ORIGIN_URL, "/api/v3/ua/user/allowed-organizations?&pageNo=1&limit=4&sortBy=-lastActive&isOrganizationAccess=false"),
                  headers: getHeaders(user, owId),
                  params: params
                });

              case 9:
                response = _context6.sent;
                return _context6.abrupt("return", response.data.data);

              case 13:
                _context6.prev = 13;
                _context6.t0 = _context6["catch"](2);
                throw new ServerError(_context6.t0);

              case 16:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, null, [[2, 13]]);
      }));

      function fetchOrganizations(_x7) {
        return _fetchOrganizations.apply(this, arguments);
      }

      return fetchOrganizations;
    }()
  }, {
    key: "logout",
    value: function () {
      var _logout = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee7(token) {
        var user, owId, response;
        return regenerator.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _context7.prev = 0;
                user = AuthService.getUser();
                owId = getOwId();

                if (!(!(owId !== null && owId !== void 0 && owId.length) || !user)) {
                  _context7.next = 5;
                  break;
                }

                throw new Error('ow ID or user not present');

              case 5:
                _context7.next = 7;
                return axios.post("".concat(ORIGIN_URL, "/api/v3/ua/logout"), {}, {
                  headers: getHeaders(user, owId)
                });

              case 7:
                response = _context7.sent;
                return _context7.abrupt("return", response.data);

              case 11:
                _context7.prev = 11;
                _context7.t0 = _context7["catch"](0);
                throw new ServerError(_context7.t0);

              case 14:
                _context7.prev = 14;
                localStorage.removeItem(BASE_INFO_NAME);
                localStorage.removeItem('owIds');
                return _context7.finish(14);

              case 18:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, null, [[0, 11, 14, 18]]);
      }));

      function logout(_x8) {
        return _logout.apply(this, arguments);
      }

      return logout;
    }()
  }, {
    key: "fetchTimezones",
    value: function () {
      var _fetchTimezones = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee8() {
        var result, user, response, serverTimezones, mapTimezone, UTCTimezoneOption, USTimezoneOptions, otherTimezoneOptions, currentUserTimezone;
        return regenerator.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                result = {
                  defaultUserTimezone: {
                    value: 'UTC',
                    label: 'UTC',
                    id: 11
                  },
                  timezoneOptions: []
                };
                _context8.prev = 1;
                user = AuthService.getUser();

                if (user && user.apiToken) {
                  _context8.next = 5;
                  break;
                }

                return _context8.abrupt("return", result);

              case 5:
                _context8.next = 7;
                return axios({
                  url: "".concat(ORIGIN_URL, "/api/v2/adv/static/timezones"),
                  headers: getHeaders(user)
                });

              case 7:
                response = _context8.sent;

                if (!(response && isEmpty(response.data))) {
                  _context8.next = 10;
                  break;
                }

                return _context8.abrupt("return", result);

              case 10:
                serverTimezones = response.data.responseObject;

                mapTimezone = function mapTimezone(timezone) {
                  return {
                    label: timezone.label,
                    value: timezone.name,
                    id: timezone.id
                  };
                };

                UTCTimezoneOption = [];
                USTimezoneOptions = [];
                otherTimezoneOptions = [];
                currentUserTimezone = {
                  value: 'UTC',
                  label: 'UTC',
                  id: 11
                };
                serverTimezones.forEach(function (serverTimezone) {
                  var timezone = mapTimezone(serverTimezone);

                  if (timezone.id === user.timezoneId) {
                    currentUserTimezone = timezone;
                  }

                  if (timezone.label.startsWith('US/')) {
                    USTimezoneOptions.push(timezone);
                  } else if (timezone.value === 'UTC') {
                    UTCTimezoneOption.push(timezone);
                  } else {
                    otherTimezoneOptions.push(timezone);
                  }
                });
                result.timezoneOptions = [].concat(USTimezoneOptions, UTCTimezoneOption, otherTimezoneOptions);
                result.defaultUserTimezone = currentUserTimezone;
                return _context8.abrupt("return", result);

              case 22:
                _context8.prev = 22;
                _context8.t0 = _context8["catch"](1);
                console.error(_context8.t0);
                return _context8.abrupt("return", _objectSpread(_objectSpread({}, result), {}, {
                  error: _context8.t0
                }));

              case 26:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, null, [[1, 22]]);
      }));

      function fetchTimezones() {
        return _fetchTimezones.apply(this, arguments);
      }

      return fetchTimezones;
    }()
  }, {
    key: "GetCreativeMediaSource",
    value: function () {
      var _GetCreativeMediaSource = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee9(id) {
        var user, response;
        return regenerator.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                _context9.prev = 0;
                user = AuthService.getUser();

                if (user) {
                  _context9.next = 4;
                  break;
                }

                return _context9.abrupt("return", null);

              case 4:
                _context9.next = 6;
                return axios({
                  url: "".concat(ORIGIN_URL, "/api/v2/crt/creative/").concat(id),
                  headers: getHeaders(user),
                  params: {
                    advertiserId: user.userId,
                    dspId: user.dspId
                  }
                });

              case 6:
                response = _context9.sent;
                return _context9.abrupt("return", response.data.responseObject.creativeSource);

              case 10:
                _context9.prev = 10;
                _context9.t0 = _context9["catch"](0);
                return _context9.abrupt("return", null);

              case 13:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9, null, [[0, 10]]);
      }));

      function GetCreativeMediaSource(_x9) {
        return _GetCreativeMediaSource.apply(this, arguments);
      }

      return GetCreativeMediaSource;
    }()
  }, {
    key: "getInitData",
    value: function () {
      var _getInitData = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee10() {
        var response;
        return regenerator.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                _context10.prev = 0;
                _context10.next = 3;
                return axios({
                  url: "".concat(ORIGIN_URL, "/api/v3/ua/init")
                });

              case 3:
                response = _context10.sent;
                this.initData = response.data.data;
                localStorage.setItem(INIT_DATA, JSON.stringify(this.initData));

                if (this.initData.ihpOwner === false) {
                  setColorVariables();
                }

                return _context10.abrupt("return", response.data.data);

              case 10:
                _context10.prev = 10;
                _context10.t0 = _context10["catch"](0);
                console.error(_context10.t0);
                return _context10.abrupt("return", null);

              case 14:
              case "end":
                return _context10.stop();
            }
          }
        }, _callee10, this, [[0, 10]]);
      }));

      function getInitData() {
        return _getInitData.apply(this, arguments);
      }

      return getInitData;
    }()
  }, {
    key: "getIntercomId",
    value: function () {
      var _getIntercomId = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee11() {
        var response;
        return regenerator.wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                _context11.prev = 0;
                _context11.next = 3;
                return axios.get("".concat(ORIGIN_URL, "/api/v3/ua/chatbot"), {
                  headers: getHeaders()
                });

              case 3:
                response = _context11.sent;
                return _context11.abrupt("return", response.data);

              case 7:
                _context11.prev = 7;
                _context11.t0 = _context11["catch"](0);
                console.error(_context11.t0);
                return _context11.abrupt("return", null);

              case 11:
              case "end":
                return _context11.stop();
            }
          }
        }, _callee11, null, [[0, 7]]);
      }));

      function getIntercomId() {
        return _getIntercomId.apply(this, arguments);
      }

      return getIntercomId;
    }()
  }, {
    key: "getMultiLevelCustomersData",
    value: function () {
      var _getMultiLevelCustomersData = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee12(params) {
        var response;
        return regenerator.wrap(function _callee12$(_context12) {
          while (1) {
            switch (_context12.prev = _context12.next) {
              case 0:
                _context12.prev = 0;
                _context12.next = 3;
                return axios.get("".concat(ORIGIN_URL, "/api/v3/ua/customers/list/multi-level"), {
                  params: _objectSpread({
                    limit: 20,
                    searchField: ''
                  }, params),
                  headers: getHeaders()
                });

              case 3:
                response = _context12.sent;
                return _context12.abrupt("return", response.data.data);

              case 7:
                _context12.prev = 7;
                _context12.t0 = _context12["catch"](0);
                console.error(_context12.t0);
                return _context12.abrupt("return", null);

              case 11:
              case "end":
                return _context12.stop();
            }
          }
        }, _callee12, null, [[0, 7]]);
      }));

      function getMultiLevelCustomersData(_x10) {
        return _getMultiLevelCustomersData.apply(this, arguments);
      }

      return getMultiLevelCustomersData;
    }()
  }, {
    key: "getWorkspacesData",
    value: function () {
      var _getWorkspacesData = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee13(params) {
        var response;
        return regenerator.wrap(function _callee13$(_context13) {
          while (1) {
            switch (_context13.prev = _context13.next) {
              case 0:
                _context13.prev = 0;
                _context13.next = 3;
                return axios.get("".concat(ORIGIN_URL, "/api/v3/ua/customers/workspaces/list"), {
                  params: _objectSpread({
                    limit: 20,
                    searchField: ''
                  }, params),
                  headers: getHeaders()
                });

              case 3:
                response = _context13.sent;
                return _context13.abrupt("return", response.data.data);

              case 7:
                _context13.prev = 7;
                _context13.t0 = _context13["catch"](0);
                console.error(_context13.t0);
                return _context13.abrupt("return", null);

              case 11:
              case "end":
                return _context13.stop();
            }
          }
        }, _callee13, null, [[0, 7]]);
      }));

      function getWorkspacesData(_x11) {
        return _getWorkspacesData.apply(this, arguments);
      }

      return getWorkspacesData;
    }()
  }]);

  return Api;
}();

var ApiService = new Api();

function ownKeys$1(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$1(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$1(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$1(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var BASE_INFO_NAME = 'authorizedUser';

var Auth = /*#__PURE__*/_createClass(function Auth() {
  var _this = this;

  _classCallCheck(this, Auth);

  this.autoLogin = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee(email, password, owId) {
      var user, _owId, profile, userData;

      return regenerator.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 3;
              return ApiService.authenticate({
                email: email,
                password: password
              });

            case 3:
              user = _context.sent;
              _owId = getOwId();

              if (Boolean(owId)) {
                _owId = owId;
              }

              localStorage.setItem('owIds', JSON.stringify([Number.parseInt(_owId, 10)]));
              _context.next = 9;
              return ApiService.fetchUserProfile(user, _owId);

            case 9:
              profile = _context.sent;
              userData = _objectSpread$1(_objectSpread$1({}, user), profile);
              _this._user = userData;
              localStorage.setItem(BASE_INFO_NAME, JSON.stringify(userData));
              _context.next = 18;
              break;

            case 15:
              _context.prev = 15;
              _context.t0 = _context["catch"](0);
              throw _context.t0;

            case 18:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[0, 15]]);
    }));

    return function (_x, _x2, _x3) {
      return _ref.apply(this, arguments);
    };
  }();

  this.authorize = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee2(credentials, rememberMe) {
      var user, owId, profile, userData;
      return regenerator.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.prev = 0;
              user = credentials;

              if (credentials.apiToken) {
                _context2.next = 6;
                break;
              }

              _context2.next = 5;
              return ApiService.authenticate(credentials);

            case 5:
              user = _context2.sent;

            case 6:
              owId = getOwId();

              if (owId !== null && owId !== void 0 && owId.length) {
                _context2.next = 9;
                break;
              }

              throw new Error('ow ID not present');

            case 9:
              _context2.next = 11;
              return ApiService.fetchUserProfile(user, owId);

            case 11:
              profile = _context2.sent;
              userData = _objectSpread$1(_objectSpread$1({}, user), profile);
              _this._user = userData;
              _this._rememberMe = rememberMe;

              if (rememberMe) {
                localStorage.setItem(BASE_INFO_NAME, JSON.stringify(userData));
              } else {
                localStorage.removeItem(BASE_INFO_NAME);
              }

              return _context2.abrupt("return", userData);

            case 19:
              _context2.prev = 19;
              _context2.t0 = _context2["catch"](0);
              throw _context2.t0;

            case 22:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, null, [[0, 19]]);
    }));

    return function (_x4, _x5) {
      return _ref2.apply(this, arguments);
    };
  }();

  this.singleSignon = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee3(apiToken, owId) {
      var profile, userData;
      return regenerator.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.prev = 0;

              if (owId !== null && owId !== void 0 && owId.length) {
                _context3.next = 3;
                break;
              }

              throw new Error('ow ID not present');

            case 3:
              _context3.next = 5;
              return ApiService.fetchUserProfile({
                apiToken: apiToken
              }, owId);

            case 5:
              profile = _context3.sent;
              userData = _objectSpread$1(_objectSpread$1({}, userAuth({
                access_token: apiToken
              })), profile);
              _this._user = userData;
              localStorage.setItem(BASE_INFO_NAME, JSON.stringify(userData));
              return _context3.abrupt("return", userData);

            case 12:
              _context3.prev = 12;
              _context3.t0 = _context3["catch"](0);
              throw _context3.t0;

            case 15:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, null, [[0, 12]]);
    }));

    return function (_x6, _x7) {
      return _ref3.apply(this, arguments);
    };
  }();

  this.updateUser = function (data) {
    _this._user = _objectSpread$1(_objectSpread$1({}, _this._user), data);
    localStorage.setItem(BASE_INFO_NAME, JSON.stringify(_this._user));
  };

  this.getToken = function () {
    return _this._user && _this._user.apiToken;
  };

  this.getUserApps = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee4() {
    var apps;
    return regenerator.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            _context4.prev = 0;

            if (!_this._userApps) {
              _context4.next = 5;
              break;
            }

            return _context4.abrupt("return", _this._userApps);

          case 5:
            _context4.next = 7;
            return ApiService.fetchUserApps();

          case 7:
            apps = _context4.sent;
            _this._userApps = apps;
            return _context4.abrupt("return", apps);

          case 10:
            _context4.next = 15;
            break;

          case 12:
            _context4.prev = 12;
            _context4.t0 = _context4["catch"](0);
            throw _context4.t0;

          case 15:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4, null, [[0, 12]]);
  }));

  this.getUser = function () {
    return _this._user;
  };

  this.isAuthenticated = function () {
    return !!_this._user;
  };

  this.unauthorize = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee5() {
    return regenerator.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            ApiService.logout();
            _this._user = null;
            _this._userApps = null;

          case 3:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5);
  }));
  this._user = JSON.parse(localStorage.getItem(BASE_INFO_NAME));
});

var AuthService = new Auth();

var build_umd = createCommonjsModule(function (module, exports) {
(function webpackUniversalModuleDefinition(root, factory) {
	module.exports = factory();
})(commonjsGlobal, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 0);
/******/ })
/************************************************************************/
/******/ ({

/***/ "./node_modules/@babel/runtime/helpers/arrayLikeToArray.js":
/*!*****************************************************************!*\
  !*** ./node_modules/@babel/runtime/helpers/arrayLikeToArray.js ***!
  \*****************************************************************/
/*! no static exports found */
/***/ (function(module, exports) {

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

module.exports = _arrayLikeToArray;
module.exports["default"] = module.exports, module.exports.__esModule = true;

/***/ }),

/***/ "./node_modules/@babel/runtime/helpers/arrayWithoutHoles.js":
/*!******************************************************************!*\
  !*** ./node_modules/@babel/runtime/helpers/arrayWithoutHoles.js ***!
  \******************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var arrayLikeToArray = __webpack_require__(/*! ./arrayLikeToArray.js */ "./node_modules/@babel/runtime/helpers/arrayLikeToArray.js");

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return arrayLikeToArray(arr);
}

module.exports = _arrayWithoutHoles;
module.exports["default"] = module.exports, module.exports.__esModule = true;

/***/ }),

/***/ "./node_modules/@babel/runtime/helpers/classCallCheck.js":
/*!***************************************************************!*\
  !*** ./node_modules/@babel/runtime/helpers/classCallCheck.js ***!
  \***************************************************************/
/*! no static exports found */
/***/ (function(module, exports) {

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

module.exports = _classCallCheck;
module.exports["default"] = module.exports, module.exports.__esModule = true;

/***/ }),

/***/ "./node_modules/@babel/runtime/helpers/createClass.js":
/*!************************************************************!*\
  !*** ./node_modules/@babel/runtime/helpers/createClass.js ***!
  \************************************************************/
/*! no static exports found */
/***/ (function(module, exports) {

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

module.exports = _createClass;
module.exports["default"] = module.exports, module.exports.__esModule = true;

/***/ }),

/***/ "./node_modules/@babel/runtime/helpers/defineProperty.js":
/*!***************************************************************!*\
  !*** ./node_modules/@babel/runtime/helpers/defineProperty.js ***!
  \***************************************************************/
/*! no static exports found */
/***/ (function(module, exports) {

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

module.exports = _defineProperty;
module.exports["default"] = module.exports, module.exports.__esModule = true;

/***/ }),

/***/ "./node_modules/@babel/runtime/helpers/interopRequireDefault.js":
/*!**********************************************************************!*\
  !*** ./node_modules/@babel/runtime/helpers/interopRequireDefault.js ***!
  \**********************************************************************/
/*! no static exports found */
/***/ (function(module, exports) {

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

module.exports = _interopRequireDefault;
module.exports["default"] = module.exports, module.exports.__esModule = true;

/***/ }),

/***/ "./node_modules/@babel/runtime/helpers/interopRequireWildcard.js":
/*!***********************************************************************!*\
  !*** ./node_modules/@babel/runtime/helpers/interopRequireWildcard.js ***!
  \***********************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var _typeof = __webpack_require__(/*! @babel/runtime/helpers/typeof */ "./node_modules/@babel/runtime/helpers/typeof.js")["default"];

function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}

function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }

  var cache = _getRequireWildcardCache(nodeInterop);

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

module.exports = _interopRequireWildcard;
module.exports["default"] = module.exports, module.exports.__esModule = true;

/***/ }),

/***/ "./node_modules/@babel/runtime/helpers/iterableToArray.js":
/*!****************************************************************!*\
  !*** ./node_modules/@babel/runtime/helpers/iterableToArray.js ***!
  \****************************************************************/
/*! no static exports found */
/***/ (function(module, exports) {

function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}

module.exports = _iterableToArray;
module.exports["default"] = module.exports, module.exports.__esModule = true;

/***/ }),

/***/ "./node_modules/@babel/runtime/helpers/nonIterableSpread.js":
/*!******************************************************************!*\
  !*** ./node_modules/@babel/runtime/helpers/nonIterableSpread.js ***!
  \******************************************************************/
/*! no static exports found */
/***/ (function(module, exports) {

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

module.exports = _nonIterableSpread;
module.exports["default"] = module.exports, module.exports.__esModule = true;

/***/ }),

/***/ "./node_modules/@babel/runtime/helpers/objectWithoutProperties.js":
/*!************************************************************************!*\
  !*** ./node_modules/@babel/runtime/helpers/objectWithoutProperties.js ***!
  \************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var objectWithoutPropertiesLoose = __webpack_require__(/*! ./objectWithoutPropertiesLoose.js */ "./node_modules/@babel/runtime/helpers/objectWithoutPropertiesLoose.js");

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = objectWithoutPropertiesLoose(source, excluded);
  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

module.exports = _objectWithoutProperties;
module.exports["default"] = module.exports, module.exports.__esModule = true;

/***/ }),

/***/ "./node_modules/@babel/runtime/helpers/objectWithoutPropertiesLoose.js":
/*!*****************************************************************************!*\
  !*** ./node_modules/@babel/runtime/helpers/objectWithoutPropertiesLoose.js ***!
  \*****************************************************************************/
/*! no static exports found */
/***/ (function(module, exports) {

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

module.exports = _objectWithoutPropertiesLoose;
module.exports["default"] = module.exports, module.exports.__esModule = true;

/***/ }),

/***/ "./node_modules/@babel/runtime/helpers/toConsumableArray.js":
/*!******************************************************************!*\
  !*** ./node_modules/@babel/runtime/helpers/toConsumableArray.js ***!
  \******************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var arrayWithoutHoles = __webpack_require__(/*! ./arrayWithoutHoles.js */ "./node_modules/@babel/runtime/helpers/arrayWithoutHoles.js");

var iterableToArray = __webpack_require__(/*! ./iterableToArray.js */ "./node_modules/@babel/runtime/helpers/iterableToArray.js");

var unsupportedIterableToArray = __webpack_require__(/*! ./unsupportedIterableToArray.js */ "./node_modules/@babel/runtime/helpers/unsupportedIterableToArray.js");

var nonIterableSpread = __webpack_require__(/*! ./nonIterableSpread.js */ "./node_modules/@babel/runtime/helpers/nonIterableSpread.js");

function _toConsumableArray(arr) {
  return arrayWithoutHoles(arr) || iterableToArray(arr) || unsupportedIterableToArray(arr) || nonIterableSpread();
}

module.exports = _toConsumableArray;
module.exports["default"] = module.exports, module.exports.__esModule = true;

/***/ }),

/***/ "./node_modules/@babel/runtime/helpers/typeof.js":
/*!*******************************************************!*\
  !*** ./node_modules/@babel/runtime/helpers/typeof.js ***!
  \*******************************************************/
/*! no static exports found */
/***/ (function(module, exports) {

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    module.exports = _typeof = function _typeof(obj) {
      return typeof obj;
    };

    module.exports["default"] = module.exports, module.exports.__esModule = true;
  } else {
    module.exports = _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };

    module.exports["default"] = module.exports, module.exports.__esModule = true;
  }

  return _typeof(obj);
}

module.exports = _typeof;
module.exports["default"] = module.exports, module.exports.__esModule = true;

/***/ }),

/***/ "./node_modules/@babel/runtime/helpers/unsupportedIterableToArray.js":
/*!***************************************************************************!*\
  !*** ./node_modules/@babel/runtime/helpers/unsupportedIterableToArray.js ***!
  \***************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var arrayLikeToArray = __webpack_require__(/*! ./arrayLikeToArray.js */ "./node_modules/@babel/runtime/helpers/arrayLikeToArray.js");

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return arrayLikeToArray(o, minLen);
}

module.exports = _unsupportedIterableToArray;
module.exports["default"] = module.exports, module.exports.__esModule = true;

/***/ }),

/***/ "./node_modules/webpack/buildin/global.js":
/*!***********************************!*\
  !*** (webpack)/buildin/global.js ***!
  \***********************************/
/*! no static exports found */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || new Function("return this")();
} catch (e) {
	// This works if the window reference is available
	if (typeof window === "object") g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),

/***/ "./packages/@apphub:logrocket-console/src/index.js":
/*!*********************************************************!*\
  !*** ./packages/@apphub:logrocket-console/src/index.js ***!
  \*********************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {


var _interopRequireDefault = __webpack_require__(/*! @babel/runtime/helpers/interopRequireDefault */ "./node_modules/@babel/runtime/helpers/interopRequireDefault.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _registerConsole = _interopRequireDefault(__webpack_require__(/*! ./registerConsole */ "./packages/@apphub:logrocket-console/src/registerConsole.js"));

var _default = _registerConsole.default;
exports.default = _default;
module.exports = exports.default;

/***/ }),

/***/ "./packages/@apphub:logrocket-console/src/registerConsole.js":
/*!*******************************************************************!*\
  !*** ./packages/@apphub:logrocket-console/src/registerConsole.js ***!
  \*******************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {


var _interopRequireDefault = __webpack_require__(/*! @babel/runtime/helpers/interopRequireDefault */ "./node_modules/@babel/runtime/helpers/interopRequireDefault.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = registerConsole;

var _typeof2 = _interopRequireDefault(__webpack_require__(/*! @babel/runtime/helpers/typeof */ "./node_modules/@babel/runtime/helpers/typeof.js"));

var _enhanceFunc = _interopRequireDefault(__webpack_require__(/*! @apphub/logrocket-utils/src/enhanceFunc */ "./packages/@apphub:logrocket-utils/src/enhanceFunc.js"));

var _logrocketExceptions = __webpack_require__(/*! @apphub/logrocket-exceptions */ "./packages/@apphub:logrocket-exceptions/src/index.js");

function registerConsole(logger) {
  var unsubFunctions = [];
  var methods = ['log', 'warn', 'info', 'error', 'debug'];
  methods.forEach(function (method) {
    unsubFunctions.push((0, _enhanceFunc.default)(console, method, function () {
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      logger.addEvent('lr.core.LogEvent', function () {
        var consoleOptions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var isEnabled = consoleOptions.isEnabled;

        if ((0, _typeof2.default)(isEnabled) === 'object' && isEnabled[method] === false || isEnabled === false) {
          return null;
        }

        if (method === 'error' && consoleOptions.shouldAggregateConsoleErrors) {
          _logrocketExceptions.Capture.captureMessage(logger, args[0], {}, true);
        }

        return {
          logLevel: method.toUpperCase(),
          args: args
        };
      });
    }));
  });
  return function () {
    unsubFunctions.forEach(function (unsubFunction) {
      return unsubFunction();
    });
  };
}

module.exports = exports.default;

/***/ }),

/***/ "./packages/@apphub:logrocket-exceptions/src/Capture.js":
/*!**************************************************************!*\
  !*** ./packages/@apphub:logrocket-exceptions/src/Capture.js ***!
  \**************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {


var _interopRequireDefault = __webpack_require__(/*! @babel/runtime/helpers/interopRequireDefault */ "./node_modules/@babel/runtime/helpers/interopRequireDefault.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.captureMessage = captureMessage;
exports.captureException = captureException;

var _typeof2 = _interopRequireDefault(__webpack_require__(/*! @babel/runtime/helpers/typeof */ "./node_modules/@babel/runtime/helpers/typeof.js"));

var _TraceKit = _interopRequireDefault(__webpack_require__(/*! @apphub/logrocket-utils/src/TraceKit */ "./packages/@apphub:logrocket-utils/src/TraceKit.js"));

var _stackTraceFromError = _interopRequireDefault(__webpack_require__(/*! ./stackTraceFromError */ "./packages/@apphub:logrocket-exceptions/src/stackTraceFromError.js"));

/* eslint-disable no-param-reassign */
function isScalar(value) {
  return /boolean|number|string/.test((0, _typeof2.default)(value));
}

function scrub(data, options) {
  if (options) {
    var optionalScalars = [// Valid values for 'level' are 'fatal', 'error', 'warning', 'info',
    // and 'debug'. Defaults to 'error'.
    'level', 'logger'];

    for (var _i = 0, _optionalScalars = optionalScalars; _i < _optionalScalars.length; _i++) {
      var field = _optionalScalars[_i];
      var value = options[field];

      if (isScalar(value)) {
        data[field] = value.toString();
      }
    }

    var optionalMaps = ['tags', 'extra'];

    for (var _i2 = 0, _optionalMaps = optionalMaps; _i2 < _optionalMaps.length; _i2++) {
      var _field = _optionalMaps[_i2];
      var dirty = options[_field] || {};
      var scrubbed = {};

      for (var _i3 = 0, _Object$keys = Object.keys(dirty); _i3 < _Object$keys.length; _i3++) {
        var key = _Object$keys[_i3];
        var _value = dirty[key];

        if (isScalar(_value)) {
          scrubbed[key.toString()] = _value.toString();
        }
      }

      data[_field] = scrubbed;
    }
  }
}

function captureMessage(logger, message) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var isConsole = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
  var data = {
    exceptionType: isConsole ? 'CONSOLE' : 'MESSAGE',
    message: message,
    browserHref: window.location ? window.location.href : ''
  };
  scrub(data, options);
  logger.addEvent('lr.core.Exception', function () {
    return data;
  });
}

function captureException(logger, exception) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var preppedTrace = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;

  var trace = preppedTrace || _TraceKit.default.computeStackTrace(exception);

  var data = {
    exceptionType: 'WINDOW',
    errorType: trace.name,
    message: trace.message,
    browserHref: window.location ? window.location.href : ''
  };
  scrub(data, options);
  var addEventOptions = {
    _stackTrace: (0, _stackTraceFromError.default)(trace)
  };
  logger.addEvent('lr.core.Exception', function () {
    return data;
  }, addEventOptions);
}

/***/ }),

/***/ "./packages/@apphub:logrocket-exceptions/src/index.js":
/*!************************************************************!*\
  !*** ./packages/@apphub:logrocket-exceptions/src/index.js ***!
  \************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {


var _interopRequireWildcard = __webpack_require__(/*! @babel/runtime/helpers/interopRequireWildcard */ "./node_modules/@babel/runtime/helpers/interopRequireWildcard.js");

var _interopRequireDefault = __webpack_require__(/*! @babel/runtime/helpers/interopRequireDefault */ "./node_modules/@babel/runtime/helpers/interopRequireDefault.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "registerExceptions", {
  enumerable: true,
  get: function get() {
    return _registerExceptions.default;
  }
});
exports.Capture = void 0;

var _registerExceptions = _interopRequireDefault(__webpack_require__(/*! ./registerExceptions */ "./packages/@apphub:logrocket-exceptions/src/registerExceptions.js"));

var Capture = _interopRequireWildcard(__webpack_require__(/*! ./Capture */ "./packages/@apphub:logrocket-exceptions/src/Capture.js"));

exports.Capture = Capture;

/***/ }),

/***/ "./packages/@apphub:logrocket-exceptions/src/raven/raven.js":
/*!******************************************************************!*\
  !*** ./packages/@apphub:logrocket-exceptions/src/raven/raven.js ***!
  \******************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {
/* WEBPACK VAR INJECTION */(function(global) {

var _interopRequireDefault = __webpack_require__(/*! @babel/runtime/helpers/interopRequireDefault */ "./node_modules/@babel/runtime/helpers/interopRequireDefault.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js"));

var _createClass2 = _interopRequireDefault(__webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js"));

var _TraceKit = _interopRequireDefault(__webpack_require__(/*! @apphub/logrocket-utils/src/TraceKit */ "./packages/@apphub:logrocket-utils/src/TraceKit.js"));

/* eslint-disable */

/*
Some contents of this file were originaly from raven-js, BSD-2 Clause

Copyright (c) 2018 Sentry (https://sentry.io) and individual contributors.
All rights reserved.

Redistribution and use in source and binary forms, with or without modification, are permitted provided that the following conditions are met:

* Redistributions of source code must retain the above copyright notice, this list of conditions and the following disclaimer.
* Redistributions in binary form must reproduce the above copyright notice, this list of conditions and the following disclaimer in the documentation and/or other materials provided with the distribution.

THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
*/
var objectPrototype = Object.prototype;

function isUndefined(what) {
  return what === void 0;
}

function isFunction(what) {
  return typeof what === 'function';
}
/**
 * hasKey, a better form of hasOwnProperty
 * Example: hasKey(MainHostObject, property) === true/false
 *
 * @param {Object} host object to check property
 * @param {string} key to check
 */


function hasKey(object, key) {
  return objectPrototype.hasOwnProperty.call(object, key);
}
/**
 * Polyfill a method
 * @param obj object e.g. `document`
 * @param name method name present on object e.g. `addEventListener`
 * @param replacement replacement function
 * @param track {optional} record instrumentation to an array
 */


function fill(obj, name, replacement, track) {
  var orig = obj[name];
  obj[name] = replacement(orig);

  if (track) {
    track.push([obj, name, orig]);
  }
}

var _window = typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

var _document = _window.document;

var Handler = /*#__PURE__*/function () {
  function Handler(_ref) {
    var captureException = _ref.captureException;
    (0, _classCallCheck2.default)(this, Handler);
    this._errorHandler = this._errorHandler.bind(this);
    this._ignoreOnError = 0;
    this._wrappedBuiltIns = [];
    this.captureException = captureException;

    _TraceKit.default.report.subscribe(this._errorHandler);

    this._instrumentTryCatch();
  }

  (0, _createClass2.default)(Handler, [{
    key: "uninstall",
    value: function uninstall() {
      _TraceKit.default.report.unsubscribe(this._errorHandler); // restore any wrapped builtins


      var builtin;

      while (this._wrappedBuiltIns.length) {
        builtin = this._wrappedBuiltIns.shift();
        var obj = builtin[0],
            name = builtin[1],
            orig = builtin[2];
        obj[name] = orig;
      }
    }
  }, {
    key: "_errorHandler",
    value: function _errorHandler(report) {
      if (!this._ignoreOnError) {
        this.captureException(report);
      }
    }
  }, {
    key: "_ignoreNextOnError",
    value: function _ignoreNextOnError() {
      var _this = this;

      this._ignoreOnError += 1;
      setTimeout(function () {
        // onerror should trigger before setTimeout
        _this._ignoreOnError -= 1;
      });
    }
    /*
     * Wrap code within a context so Handler can capture errors
     * reliably across domains that is executed immediately.
     *
     * @param {object} options A specific set of options for this context [optional]
     * @param {function} func The callback to be immediately executed within the context
     * @param {array} args An array of arguments to be called with the callback [optional]
     */

  }, {
    key: "context",
    value: function context(options, func, args) {
      if (isFunction(options)) {
        args = func || [];
        func = options;
        options = undefined;
      }

      return this.wrap(options, func).apply(this, args);
    }
  }, {
    key: "wrap",
    value:
    /*
     * Wrap code within a context and returns back a new function to be executed
     *
     * @param {object} options A specific set of options for this context [optional]
     * @param {function} func The function to be wrapped in a new context
     * @param {function} func A function to call before the try/catch wrapper [optional, private]
     * @return {function} The newly wrapped functions with a context
     */
    function wrap(options, func, _before) {
      var self = this; // 1 argument has been passed, and it's not a function
      // so just return it

      if (isUndefined(func) && !isFunction(options)) {
        return options;
      } // options is optional


      if (isFunction(options)) {
        func = options;
        options = undefined;
      } // At this point, we've passed along 2 arguments, and the second one
      // is not a function either, so we'll just return the second argument.


      if (!isFunction(func)) {
        return func;
      } // We don't wanna wrap it twice!


      try {
        if (func.__lr__) {
          return func;
        } // If this has already been wrapped in the past, return that


        if (func.__lr_wrapper__) {
          return func.__lr_wrapper__;
        } // If func is not extensible, return the function as-is to prevent TypeErrors
        // when trying to add new props & to assure immutable funcs aren't changed


        if (!Object.isExtensible(func)) {
          return func;
        }
      } catch (e) {
        // Just accessing custom props in some Selenium environments
        // can cause a "Permission denied" exception (see lr-js#495).
        // Bail on wrapping and return the function as-is (defers to window.onerror).
        return func;
      }

      function wrapped() {
        var args = [],
            i = arguments.length,
            deep = !options || options && options.deep !== false;

        if (_before && isFunction(_before)) {
          _before.apply(this, arguments);
        } // Recursively wrap all of a function's arguments that are
        // functions themselves.


        while (i--) {
          args[i] = deep ? self.wrap(options, arguments[i]) : arguments[i];
        }

        try {
          // Attempt to invoke user-land function. This is part of the LogRocket SDK.
          // If you're seeing this frame in a stack trace, it means that LogRocket caught
          // an unhandled error thrown by your application code, reported it, then bubbled
          // it up. This is expected behavior and is not a bug with LogRocket.
          return func.apply(this, args);
        } catch (e) {
          self._ignoreNextOnError();

          self.captureException(_TraceKit.default.computeStackTrace(e), options);
          throw e;
        }
      } // copy over properties of the old function


      for (var property in func) {
        if (hasKey(func, property)) {
          wrapped[property] = func[property];
        }
      }

      wrapped.prototype = func.prototype;
      func.__lr_wrapper__ = wrapped; // Signal that this function has been wrapped already
      // for both debugging and to prevent it to being wrapped twice

      wrapped.__lr__ = true;
      wrapped.__inner__ = func;
      return wrapped;
    }
  }, {
    key: "_instrumentTryCatch",
    value:
    /**
     * Install any queued plugins
     */
    function _instrumentTryCatch() {
      var self = this;
      var wrappedBuiltIns = self._wrappedBuiltIns;

      function wrapTimeFn(orig) {
        return function (fn, t) {
          // preserve arity
          // Make a copy of the arguments to prevent deoptimization
          // https://github.com/petkaantonov/bluebird/wiki/Optimization-killers#32-leaking-arguments
          var args = new Array(arguments.length);

          for (var i = 0; i < args.length; ++i) {
            args[i] = arguments[i];
          }

          var originalCallback = args[0];

          if (isFunction(originalCallback)) {
            args[0] = self.wrap(originalCallback);
          } // IE < 9 doesn't support .call/.apply on setInterval/setTimeout, but it
          // also supports only two arguments and doesn't care what this is, so we
          // can just call the original function directly.


          if (orig.apply) {
            return orig.apply(this, args);
          } else {
            return orig(args[0], args[1]);
          }
        };
      }

      function wrapEventTarget(global) {
        var proto = _window[global] && _window[global].prototype;

        if (proto && proto.hasOwnProperty && proto.hasOwnProperty('addEventListener')) {
          fill(proto, 'addEventListener', function (orig) {
            return function (evtName, fn, capture, secure) {
              // preserve arity
              try {
                if (fn && fn.handleEvent) {
                  fn.handleEvent = self.wrap(fn.handleEvent);
                }
              } catch (err) {// can sometimes get 'Permission denied to access property "handle Event'
              } // More breadcrumb DOM capture ... done here and not in `_instrumentBreadcrumbs`
              // so that we don't have more than one wrapper function


              var before;
              return orig.call(this, evtName, self.wrap(fn, undefined, before), capture, secure);
            };
          }, wrappedBuiltIns);
          fill(proto, 'removeEventListener', function (orig) {
            return function (evt, fn, capture, secure) {
              try {
                fn = fn && (fn.__lr_wrapper__ ? fn.__lr_wrapper__ : fn);
              } catch (e) {// ignore, accessing __lr_wrapper__ will throw in some Selenium environments
              }

              return orig.call(this, evt, fn, capture, secure);
            };
          }, wrappedBuiltIns);
        }
      }

      fill(_window, 'setTimeout', wrapTimeFn, wrappedBuiltIns);
      fill(_window, 'setInterval', wrapTimeFn, wrappedBuiltIns);

      if (_window.requestAnimationFrame) {
        fill(_window, 'requestAnimationFrame', function (orig) {
          return function (cb) {
            return orig(self.wrap(cb));
          };
        }, wrappedBuiltIns);
      } // event targets borrowed from bugsnag-js:
      // https://github.com/bugsnag/bugsnag-js/blob/master/src/bugsnag.js#L666


      var eventTargets = ['EventTarget', 'Window', 'Node', 'ApplicationCache', 'AudioTrackList', 'ChannelMergerNode', 'CryptoOperation', 'EventSource', 'FileReader', 'HTMLUnknownElement', 'IDBDatabase', 'IDBRequest', 'IDBTransaction', 'KeyOperation', 'MediaController', 'MessagePort', 'ModalWindow', 'Notification', 'SVGElementInstance', 'Screen', 'TextTrack', 'TextTrackCue', 'TextTrackList', 'WebSocket', 'WebSocketWorker', 'Worker', 'XMLHttpRequest', 'XMLHttpRequestEventTarget', 'XMLHttpRequestUpload'];

      for (var i = 0; i < eventTargets.length; i++) {
        wrapEventTarget(eventTargets[i]);
      }

      var $ = _window.jQuery || _window.$;

      if ($ && $.fn && $.fn.ready) {
        fill($.fn, 'ready', function (orig) {
          return function (fn) {
            return orig.call(this, self.wrap(fn));
          };
        }, wrappedBuiltIns);
      }
    }
  }]);
  return Handler;
}();

exports.default = Handler;
module.exports = exports.default;
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(/*! ./../../../../node_modules/webpack/buildin/global.js */ "./node_modules/webpack/buildin/global.js")));

/***/ }),

/***/ "./packages/@apphub:logrocket-exceptions/src/registerExceptions.js":
/*!*************************************************************************!*\
  !*** ./packages/@apphub:logrocket-exceptions/src/registerExceptions.js ***!
  \*************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {


var _interopRequireWildcard = __webpack_require__(/*! @babel/runtime/helpers/interopRequireWildcard */ "./node_modules/@babel/runtime/helpers/interopRequireWildcard.js");

var _interopRequireDefault = __webpack_require__(/*! @babel/runtime/helpers/interopRequireDefault */ "./node_modules/@babel/runtime/helpers/interopRequireDefault.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = registerCore;

var _raven = _interopRequireDefault(__webpack_require__(/*! ./raven/raven */ "./packages/@apphub:logrocket-exceptions/src/raven/raven.js"));

var Capture = _interopRequireWildcard(__webpack_require__(/*! ./Capture */ "./packages/@apphub:logrocket-exceptions/src/Capture.js"));

function registerCore(logger) {
  var raven = new _raven.default({
    captureException: function captureException(errorReport) {
      Capture.captureException(logger, null, null, errorReport);
    }
  });

  var rejectionHandler = function rejectionHandler(evt) {
    // http://2ality.com/2016/04/unhandled-rejections.html
    logger.addEvent('lr.core.Exception', function () {
      return {
        exceptionType: 'UNHANDLED_REJECTION',
        message: evt.reason || 'Unhandled Promise rejection'
      };
    });
  };

  window.addEventListener('unhandledrejection', rejectionHandler);
  return function () {
    window.removeEventListener('unhandledrejection', rejectionHandler);
    raven.uninstall();
  };
}

module.exports = exports.default;

/***/ }),

/***/ "./packages/@apphub:logrocket-exceptions/src/stackTraceFromError.js":
/*!**************************************************************************!*\
  !*** ./packages/@apphub:logrocket-exceptions/src/stackTraceFromError.js ***!
  \**************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = stackTraceFromError;

function stackTraceFromError(errorReport) {
  function makeNotNull(val) {
    return val === null ? undefined : val;
  }

  return errorReport.stack ? errorReport.stack.map(function (frame) {
    return {
      lineNumber: makeNotNull(frame.line),
      columnNumber: makeNotNull(frame.column),
      fileName: makeNotNull(frame.url),
      functionName: makeNotNull(frame.func)
    };
  }) : undefined;
}

module.exports = exports.default;

/***/ }),

/***/ "./packages/@apphub:logrocket-network/src/fetchIntercept.js":
/*!******************************************************************!*\
  !*** ./packages/@apphub:logrocket-network/src/fetchIntercept.js ***!
  \******************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {


var _interopRequireDefault = __webpack_require__(/*! @babel/runtime/helpers/interopRequireDefault */ "./node_modules/@babel/runtime/helpers/interopRequireDefault.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _toConsumableArray2 = _interopRequireDefault(__webpack_require__(/*! @babel/runtime/helpers/toConsumableArray */ "./node_modules/@babel/runtime/helpers/toConsumableArray.js"));

var _registerXHR = __webpack_require__(/*! ./registerXHR */ "./packages/@apphub:logrocket-network/src/registerXHR.js");

var interceptors = [];

function makeInterceptor(fetch, fetchId) {
  var reversedInterceptors = interceptors.reduce(function (array, interceptor) {
    return [interceptor].concat(array);
  }, []);

  for (var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
    args[_key - 2] = arguments[_key];
  }

  var promise = Promise.resolve(args); // Register request interceptors

  reversedInterceptors.forEach(function (_ref) {
    var request = _ref.request,
        requestError = _ref.requestError;

    if (request || requestError) {
      promise = promise.then(function (args) {
        return request.apply(void 0, [fetchId].concat((0, _toConsumableArray2.default)(args)));
      }, function (args) {
        return requestError.apply(void 0, [fetchId].concat((0, _toConsumableArray2.default)(args)));
      });
    }
  });
  promise = promise.then(function (args) {
    (0, _registerXHR.setActive)(false);
    var res;
    var err;

    try {
      res = fetch.apply(void 0, (0, _toConsumableArray2.default)(args));
    } catch (_err) {
      err = _err;
    }

    (0, _registerXHR.setActive)(true);

    if (err) {
      throw err;
    }

    return res;
  });
  reversedInterceptors.forEach(function (_ref2) {
    var response = _ref2.response,
        responseError = _ref2.responseError;

    if (response || responseError) {
      promise = promise.then(function (res) {
        return response(fetchId, res);
      }, function (err) {
        return responseError && responseError(fetchId, err);
      });
    }
  });
  return promise;
}

function attach(env) {
  if (!env.fetch || !env.Promise) {
    // Make sure fetch is available in the given environment. If it's not, then
    // default to using XHR intercept.
    return;
  }

  var isPolyfill = env.fetch.polyfill; // eslint-disable-next-line no-param-reassign

  env.fetch = function (fetch) {
    var fetchId = 0;
    return function () {
      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }

      return makeInterceptor.apply(void 0, [fetch, fetchId++].concat(args));
    };
  }(env.fetch); // Forward the polyfill properly from fetch (set by github/whatwg-fetch).


  if (isPolyfill) {
    // eslint-disable-next-line no-param-reassign
    env.fetch.polyfill = isPolyfill;
  }
} // TODO: React Native
//   attach(global);


var didAttach = false;
var _default = {
  register: function register(interceptor) {
    if (!didAttach) {
      didAttach = true;
      attach(window);
    }

    interceptors.push(interceptor);
    return function () {
      var index = interceptors.indexOf(interceptor);

      if (index >= 0) {
        interceptors.splice(index, 1);
      }
    };
  },
  clear: function clear() {
    interceptors = [];
  }
};
exports.default = _default;
module.exports = exports.default;

/***/ }),

/***/ "./packages/@apphub:logrocket-network/src/index.js":
/*!*********************************************************!*\
  !*** ./packages/@apphub:logrocket-network/src/index.js ***!
  \*********************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {


var _interopRequireDefault = __webpack_require__(/*! @babel/runtime/helpers/interopRequireDefault */ "./node_modules/@babel/runtime/helpers/interopRequireDefault.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = registerNetwork;

var _defineProperty2 = _interopRequireDefault(__webpack_require__(/*! @babel/runtime/helpers/defineProperty */ "./node_modules/@babel/runtime/helpers/defineProperty.js"));

var _typeof2 = _interopRequireDefault(__webpack_require__(/*! @babel/runtime/helpers/typeof */ "./node_modules/@babel/runtime/helpers/typeof.js"));

var _registerFetch = _interopRequireDefault(__webpack_require__(/*! ./registerFetch */ "./packages/@apphub:logrocket-network/src/registerFetch.js"));

var _registerNetworkInformation = _interopRequireDefault(__webpack_require__(/*! ./registerNetworkInformation */ "./packages/@apphub:logrocket-network/src/registerNetworkInformation.js"));

var _registerXHR = _interopRequireDefault(__webpack_require__(/*! ./registerXHR */ "./packages/@apphub:logrocket-network/src/registerXHR.js"));

var _mapValues = _interopRequireDefault(__webpack_require__(/*! @apphub/logrocket-utils/src/mapValues */ "./packages/@apphub:logrocket-utils/src/mapValues.js"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function registerNetwork(logger) {
  var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
    isReactNative: false
  };
  var isReactNative = config.isReactNative,
      shouldAugmentNPS = config.shouldAugmentNPS;
  var ignoredNetwork = {}; // truncate if > 4MB in size

  var truncate = function truncate(data) {
    var limit = 1024 * 1000 * 4;
    var str = data;

    if ((0, _typeof2.default)(data) === 'object' && data != null) {
      var proto = Object.getPrototypeOf(data);

      if (proto === Object.prototype || proto === null) {
        // plain object - jsonify for the size check
        str = JSON.stringify(data);
      }
    }

    if (str && str.length && str.length > limit && typeof str === 'string') {
      var beginning = str.substring(0, 1000);
      return "".concat(beginning, " ... LogRocket truncating to first 1000 characters.\n      Keep data under 4MB to prevent truncation. https://docs.logrocket.com/reference#network");
    }

    return data;
  };

  var addRequest = function addRequest(reqId, request) {
    var method = request.method;
    logger.addEvent('lr.network.RequestEvent', function () {
      var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          _ref$isEnabled = _ref.isEnabled,
          isEnabled = _ref$isEnabled === void 0 ? true : _ref$isEnabled,
          _ref$requestSanitizer = _ref.requestSanitizer,
          requestSanitizer = _ref$requestSanitizer === void 0 ? function (f) {
        return f;
      } : _ref$requestSanitizer;

      if (!isEnabled) {
        return null;
      }

      var sanitized = null;

      try {
        // only try catch user defined functions
        sanitized = requestSanitizer(_objectSpread(_objectSpread({}, request), {}, {
          reqId: reqId
        }));
      } catch (err) {
        console.error(err);
      }

      if (sanitized) {
        var url = sanitized.url;

        if (typeof document !== 'undefined' && typeof document.createElement === 'function') {
          // Writing and then reading from an a tag turns a relative
          // url into an absolute one.
          var a = document.createElement('a');
          a.href = sanitized.url;
          url = a.href;
        }

        return {
          reqId: reqId,
          // default
          url: url,
          // sanitized
          headers: (0, _mapValues.default)(sanitized.headers, function (headerValue) {
            // sanitized
            return "".concat(headerValue);
          }),
          body: truncate(sanitized.body),
          // sanitized
          method: method,
          // default
          referrer: sanitized.referrer || undefined,
          // sanitized
          mode: sanitized.mode || undefined,
          // sanitized
          credentials: sanitized.credentials || undefined // sanitized

        };
      }

      ignoredNetwork[reqId] = true;
      return null;
    });
  };

  var addResponse = function addResponse(reqId, response) {
    var method = response.method,
        status = response.status;
    logger.addEvent('lr.network.ResponseEvent', function () {
      var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          _ref2$isEnabled = _ref2.isEnabled,
          isEnabled = _ref2$isEnabled === void 0 ? true : _ref2$isEnabled,
          _ref2$responseSanitiz = _ref2.responseSanitizer,
          responseSanitizer = _ref2$responseSanitiz === void 0 ? function (f) {
        return f;
      } : _ref2$responseSanitiz;

      if (!isEnabled) {
        return null;
      } else if (ignoredNetwork[reqId]) {
        delete ignoredNetwork[reqId];
        return null;
      }

      var sanitized = null;

      try {
        // only try catch user defined functions
        sanitized = responseSanitizer(_objectSpread(_objectSpread({}, response), {}, {
          reqId: reqId
        }));
      } catch (err) {
        console.error(err); // fall through to redacted log
      }

      if (sanitized) {
        return {
          reqId: reqId,
          // default
          status: sanitized.status,
          // sanitized
          headers: (0, _mapValues.default)(sanitized.headers, function (headerValue) {
            // sanitized
            return "".concat(headerValue);
          }),
          body: truncate(sanitized.body),
          // sanitized
          method: method // default

        };
      }

      return {
        reqId: reqId,
        // default
        status: status,
        // default
        headers: {},
        // redacted
        body: null,
        // redacted
        method: method // default

      };
    });
  };

  var isIgnored = function isIgnored(reqId) {
    return logger.isDisabled || ignoredNetwork[reqId] === true;
  };

  var unsubFetch = (0, _registerFetch.default)({
    addRequest: addRequest,
    addResponse: addResponse,
    isIgnored: isIgnored
  });
  var unsubXHR = (0, _registerXHR.default)({
    addRequest: addRequest,
    addResponse: addResponse,
    isIgnored: isIgnored,
    logger: logger,
    shouldAugmentNPS: shouldAugmentNPS
  });
  var unsubNetworkInformation = isReactNative ? function () {} : (0, _registerNetworkInformation.default)(logger);
  return function () {
    unsubNetworkInformation();
    unsubFetch();
    unsubXHR();
  };
}

module.exports = exports.default;

/***/ }),

/***/ "./packages/@apphub:logrocket-network/src/registerFetch.js":
/*!*****************************************************************!*\
  !*** ./packages/@apphub:logrocket-network/src/registerFetch.js ***!
  \*****************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {


var _interopRequireDefault = __webpack_require__(/*! @babel/runtime/helpers/interopRequireDefault */ "./node_modules/@babel/runtime/helpers/interopRequireDefault.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = registerFetch;

var _defineProperty2 = _interopRequireDefault(__webpack_require__(/*! @babel/runtime/helpers/defineProperty */ "./node_modules/@babel/runtime/helpers/defineProperty.js"));

var _mapValues = _interopRequireDefault(__webpack_require__(/*! @apphub/logrocket-utils/src/mapValues */ "./packages/@apphub:logrocket-utils/src/mapValues.js"));

var _fetchIntercept = _interopRequireDefault(__webpack_require__(/*! ./fetchIntercept */ "./packages/@apphub:logrocket-network/src/fetchIntercept.js"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function makeObjectFromHeaders(headers) {
  // If using real fetch, we must stringify the Headers object.
  if (headers == null || typeof headers.forEach !== 'function') {
    return headers;
  }

  var result = {};
  headers.forEach(function (value, key) {
    if (result[key]) {
      result[key] = "".concat(result[key], ",").concat(value);
    } else {
      result[key] = "".concat(value);
    }
  });
  return result;
} // XHR specification is unclear of what types to allow in value so using toString method for now


var stringifyHeaders = function stringifyHeaders(headers) {
  return (0, _mapValues.default)(makeObjectFromHeaders(headers), function (value) {
    return "".concat(value);
  });
};

function pluckFetchFields() {
  var arg = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return {
    url: arg.url,
    headers: stringifyHeaders(arg.headers),
    method: arg.method && arg.method.toUpperCase(),
    referrer: arg.referrer || undefined,
    mode: arg.mode || undefined,
    credentials: arg.credentials || undefined
  };
}

function registerFetch(_ref) {
  var addRequest = _ref.addRequest,
      addResponse = _ref.addResponse,
      isIgnored = _ref.isIgnored;
  var LOGROCKET_FETCH_LABEL = 'fetch-';
  var fetchMethodMap = {};

  var unregister = _fetchIntercept.default.register({
    request: function request(fetchId) {
      for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }

      var p;

      if (typeof Request !== 'undefined' && args[0] instanceof Request) {
        var clonedText; // Request.clone() and Request.text() may throw in Safari (e.g., when
        // request body contains FormData)

        try {
          clonedText = args[0].clone().text();
        } catch (err) {
          clonedText = Promise.resolve("LogRocket fetch error: ".concat(err.message));
        }

        p = clonedText.then(function (body) {
          return _objectSpread(_objectSpread({}, pluckFetchFields(args[0])), {}, {
            body: body
          });
        }, function (err) {
          return _objectSpread(_objectSpread({}, pluckFetchFields(args[0])), {}, {
            body: "LogRocket fetch error: ".concat(err.message)
          });
        });
      } else {
        p = Promise.resolve(_objectSpread(_objectSpread({}, pluckFetchFields(args[1])), {}, {
          url: "".concat(args[0]),
          body: (args[1] || {}).body
        }));
      }

      return p.then(function (req) {
        fetchMethodMap[fetchId] = req.method;
        addRequest("".concat(LOGROCKET_FETCH_LABEL).concat(fetchId), req);
        return args;
      });
    },
    requestError: function requestError(fetchId, error) {
      return Promise.reject(error);
    },
    response: function response(fetchId, _response) {
      var clonedText;

      if (isIgnored("".concat(LOGROCKET_FETCH_LABEL).concat(fetchId))) {
        // Don't even try to read ignored requests
        return _response;
      }

      try {
        // TODO: enhance function on original response and future clones for:
        // text(), json(), blob(), formdata(), arraybuffer()
        clonedText = _response.clone().text();
      } catch (err) {
        // safari has a bug where cloning can fail
        clonedText = Promise.resolve("LogRocket fetch error: ".concat(err.message));
      }

      return clonedText.then(function (data) {
        var responseHash = {
          url: _response.url,
          status: _response.status,
          headers: stringifyHeaders(_response.headers),
          body: data,
          method: fetchMethodMap[fetchId]
        };
        delete fetchMethodMap[fetchId];
        addResponse("".concat(LOGROCKET_FETCH_LABEL).concat(fetchId), responseHash);
        return _response;
      });
    },
    responseError: function responseError(fetchId, error) {
      var response = {
        url: undefined,
        status: 0,
        headers: {},
        body: "".concat(error)
      };
      addResponse("".concat(LOGROCKET_FETCH_LABEL).concat(fetchId), response);
      return Promise.reject(error);
    }
  });

  return unregister;
}

module.exports = exports.default;

/***/ }),

/***/ "./packages/@apphub:logrocket-network/src/registerNetworkInformation.js":
/*!******************************************************************************!*\
  !*** ./packages/@apphub:logrocket-network/src/registerNetworkInformation.js ***!
  \******************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = registerNetworkInformation;
var EFFECTIVE_TYPE_VALS = {
  'slow-2g': 'SLOW2G',
  '2g': 'TWOG',
  '3g': 'THREEG',
  '4g': 'FOURG'
};

function registerNetworkInformation(logger) {
  var lastStatus = undefined;

  function sendNetworkInformation() {
    var newStatus = {
      online: window.navigator.onLine,
      effectiveType: 'UNKOWN'
    };

    if (!window.navigator.onLine) {
      newStatus.effectiveType = 'NONE';
    } else if (window.navigator.connection && window.navigator.connection.effectiveType) {
      newStatus.effectiveType = EFFECTIVE_TYPE_VALS[window.navigator.connection.effectiveType] || 'UNKNOWN';
    }

    if (lastStatus && newStatus.online === lastStatus.online && newStatus.effectiveType === lastStatus.effectiveType) {
      return;
    }

    lastStatus = newStatus;
    logger.addEvent('lr.network.NetworkStatusEvent', function () {
      return newStatus;
    });
  }

  setTimeout(sendNetworkInformation);

  if (window.navigator.connection && typeof window.navigator.connection.addEventListener === 'function') {
    window.navigator.connection.addEventListener('change', sendNetworkInformation);
  }

  window.addEventListener('online', sendNetworkInformation);
  window.addEventListener('offline', sendNetworkInformation);
  return function () {
    window.removeEventListener('offline', sendNetworkInformation);
    window.removeEventListener('online', sendNetworkInformation);

    if (window.navigator.connection && typeof window.navigator.connection.removeEventListener === 'function') {
      window.navigator.connection.removeEventListener('change', sendNetworkInformation);
    }
  };
}

module.exports = exports.default;

/***/ }),

/***/ "./packages/@apphub:logrocket-network/src/registerXHR.js":
/*!***************************************************************!*\
  !*** ./packages/@apphub:logrocket-network/src/registerXHR.js ***!
  \***************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {


var _interopRequireDefault = __webpack_require__(/*! @babel/runtime/helpers/interopRequireDefault */ "./node_modules/@babel/runtime/helpers/interopRequireDefault.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setActive = setActive;
exports.default = registerXHR;

var _mapValues = _interopRequireDefault(__webpack_require__(/*! @apphub/logrocket-utils/src/mapValues */ "./packages/@apphub:logrocket-utils/src/mapValues.js"));

var _enhanceFunc = _interopRequireDefault(__webpack_require__(/*! @apphub/logrocket-utils/src/enhanceFunc */ "./packages/@apphub:logrocket-utils/src/enhanceFunc.js"));

var _startsWith = _interopRequireDefault(__webpack_require__(/*! @apphub/logrocket-utils/src/startsWith */ "./packages/@apphub:logrocket-utils/src/startsWith.js"));

var _nps = __webpack_require__(/*! @apphub/logrocket-utils/src/constants/nps */ "./packages/@apphub:logrocket-utils/src/constants/nps.js");

var isActive = true;

function setActive(shouldBeActive) {
  isActive = shouldBeActive;
}

var currentXHRId = 0;

function registerXHR(_ref) {
  var addRequest = _ref.addRequest,
      addResponse = _ref.addResponse,
      isIgnored = _ref.isIgnored,
      logger = _ref.logger,
      _ref$shouldAugmentNPS = _ref.shouldAugmentNPS,
      shouldAugmentNPS = _ref$shouldAugmentNPS === void 0 ? true : _ref$shouldAugmentNPS;
  var _XHR = XMLHttpRequest;
  var xhrMap = new WeakMap();
  var unsubscribedFromXhr = false;
  var LOGROCKET_XHR_LABEL = 'xhr-';
  window._lrXMLHttpRequest = XMLHttpRequest; // eslint-disable-next-line no-native-reassign

  XMLHttpRequest = function XMLHttpRequest(mozAnon, mozSystem) {
    var xhrObject = new _XHR(mozAnon, mozSystem);

    if (!isActive) {
      return xhrObject;
    }

    xhrMap.set(xhrObject, {
      xhrId: ++currentXHRId,
      headers: {}
    });
    var openOriginal = xhrObject.open;

    function openShim() {
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      try {
        var url = args[1];

        if (window.URL && typeof window.URL === 'function' && url.search(_nps.WOOTRIC_RESPONSES_REGEX) === 0) {
          var logrocketSessionURL = new window.URL(logger.recordingURL);
          logrocketSessionURL.searchParams.set('nps', 'wootric');
          var urlObj = new window.URL(url);
          var responseText = urlObj.searchParams.get('response[text]');
          var feedback = responseText ? "".concat(responseText, "\n\n") : '';
          urlObj.searchParams.set('response[text]', "".concat(feedback, "<").concat(logrocketSessionURL.href, "|View LogRocket session>"));
          args[1] = urlObj.href; // eslint-disable-line no-param-reassign
        }
      } catch (e) {
        /* do nothing */
      }

      return openOriginal.apply(this, args);
    }

    var sendOriginal = xhrObject.send;

    function sendShim() {
      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }

      try {
        var currentXHR = xhrMap.get(xhrObject);

        if (window.URL && typeof window.URL === 'function' && currentXHR && currentXHR.url && currentXHR.url.search(_nps.DELIGHTED_RESPONSES_REGEX) === 0 && args.length && args[0].indexOf(_nps.DELIGHTED_FEEDBACK_PREFIX) !== -1) {
          var recordingURL = new window.URL(logger.recordingURL);
          recordingURL.searchParams.set('nps', 'delighted');
          var logrocketSessionURL = encodeURIComponent(recordingURL.href);
          var data = args[0].split('&').map(function (dataString) {
            if ((0, _startsWith.default)(dataString, _nps.DELIGHTED_FEEDBACK_PREFIX)) {
              var isEmpty = dataString === _nps.DELIGHTED_FEEDBACK_PREFIX;
              return "".concat(dataString).concat(isEmpty ? '' : '\n\n', "<").concat(logrocketSessionURL, "|View LogRocket session>");
            }

            return dataString;
          }).join('&');
          args[0] = data; // eslint-disable-line no-param-reassign
        }
      } catch (e) {
        /* do nothing */
      }

      return sendOriginal.apply(this, args);
    }

    if (shouldAugmentNPS) {
      xhrObject.open = openShim;
      xhrObject.send = sendShim;
    } // ..., 'open', (method, url, async, username, password) => {


    (0, _enhanceFunc.default)(xhrObject, 'open', function (method, url) {
      if (unsubscribedFromXhr) {
        return;
      }

      var currentXHR = xhrMap.get(xhrObject);
      currentXHR.method = method;
      currentXHR.url = url;
    });
    (0, _enhanceFunc.default)(xhrObject, 'send', function (data) {
      if (unsubscribedFromXhr) {
        return;
      }

      var currentXHR = xhrMap.get(xhrObject);

      if (!currentXHR) {
        return;
      }

      var request = {
        url: currentXHR.url,
        method: currentXHR.method && currentXHR.method.toUpperCase(),
        headers: (0, _mapValues.default)(currentXHR.headers || {}, function (headerValues) {
          return headerValues.join(', ');
        }),
        body: data
      };
      addRequest("".concat(LOGROCKET_XHR_LABEL).concat(currentXHR.xhrId), request);
    });
    (0, _enhanceFunc.default)(xhrObject, 'setRequestHeader', function (header, value) {
      if (unsubscribedFromXhr) {
        return;
      }

      var currentXHR = xhrMap.get(xhrObject);

      if (!currentXHR) {
        return;
      }

      currentXHR.headers = currentXHR.headers || {};
      currentXHR.headers[header] = currentXHR.headers[header] || [];
      currentXHR.headers[header].push(value);
    });
    var xhrListeners = {
      readystatechange: function readystatechange() {
        if (unsubscribedFromXhr) {
          return;
        }

        if (xhrObject.readyState === 4) {
          var currentXHR = xhrMap.get(xhrObject);

          if (!currentXHR) {
            return;
          } // Do not read ignored requests at all.


          if (isIgnored("".concat(LOGROCKET_XHR_LABEL).concat(currentXHR.xhrId))) {
            return;
          }

          var headerString = xhrObject.getAllResponseHeaders();
          var headers = headerString.split(/[\r\n]+/).reduce(function (previous, current) {
            var next = previous;
            var headerParts = current.split(': ');

            if (headerParts.length > 0) {
              var key = headerParts.shift(); // first index of the array

              var value = headerParts.join(': '); // rest of the array repaired

              if (previous[key]) {
                next[key] += ", ".concat(value);
              } else {
                next[key] = value;
              }
            }

            return next;
          }, {});
          var body; // IE 11 sometimes throws when trying to access large responses

          try {
            switch (xhrObject.responseType) {
              case 'json':
                body = logger._shouldCloneResponse ? JSON.parse(JSON.stringify(xhrObject.response)) : xhrObject.response;
                break;

              case 'arraybuffer':
              case 'blob':
                {
                  body = xhrObject.response;
                  break;
                }

              case 'document':
                {
                  body = xhrObject.responseXML;
                  break;
                }

              case 'text':
              case '':
                {
                  body = xhrObject.responseText;
                  break;
                }

              default:
                {
                  body = '';
                }
            }
          } catch (err) {
            body = 'LogRocket: Error accessing response.';
          }

          var response = {
            url: currentXHR.url,
            status: xhrObject.status,
            headers: headers,
            body: body,
            method: (currentXHR.method || '').toUpperCase()
          };
          addResponse("".concat(LOGROCKET_XHR_LABEL).concat(currentXHR.xhrId), response);
        }
      } // // Unused Event Listeners
      // loadstart: () => {},
      // progress: () => {},
      // abort: () => {},
      // error: () => {},
      // load: () => {},
      // timeout: () => {},
      // loadend: () => {},

    };
    Object.keys(xhrListeners).forEach(function (key) {
      xhrObject.addEventListener(key, xhrListeners[key]);
    });
    return xhrObject;
  }; // this allows "instanceof XMLHttpRequest" to work


  XMLHttpRequest.prototype = _XHR.prototype; // Persist the static variables.

  ['UNSENT', 'OPENED', 'HEADERS_RECEIVED', 'LOADING', 'DONE'].forEach(function (variable) {
    XMLHttpRequest[variable] = _XHR[variable];
  });
  return function () {
    unsubscribedFromXhr = true; // eslint-disable-next-line no-native-reassign

    XMLHttpRequest = _XHR;
  };
}

/***/ }),

/***/ "./packages/@apphub:logrocket-redux/src/createEnhancer.js":
/*!****************************************************************!*\
  !*** ./packages/@apphub:logrocket-redux/src/createEnhancer.js ***!
  \****************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {


var _interopRequireDefault = __webpack_require__(/*! @babel/runtime/helpers/interopRequireDefault */ "./node_modules/@babel/runtime/helpers/interopRequireDefault.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = createEnhancer;

var _defineProperty2 = _interopRequireDefault(__webpack_require__(/*! @babel/runtime/helpers/defineProperty */ "./node_modules/@babel/runtime/helpers/defineProperty.js"));

var _now = _interopRequireDefault(__webpack_require__(/*! @apphub/now */ "./packages/@apphub:now/src/index.js"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var storeIdCounter = 0;

function createEnhancer(logger) {
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      _ref$stateSanitizer = _ref.stateSanitizer,
      stateSanitizer = _ref$stateSanitizer === void 0 ? function (f) {
    return f;
  } : _ref$stateSanitizer,
      _ref$actionSanitizer = _ref.actionSanitizer,
      actionSanitizer = _ref$actionSanitizer === void 0 ? function (f) {
    return f;
  } : _ref$actionSanitizer;

  // an enhancer is a function that returns a Store
  return function (createStore) {
    return function (reducer, initialState, enhancer) {
      var store = createStore(reducer, initialState, enhancer);
      var originalDispatch = store.dispatch;
      var storeId = storeIdCounter++;
      logger.addEvent('lr.redux.InitialState', function () {
        var sanitizedState;

        try {
          // only try catch user defined functions
          sanitizedState = stateSanitizer(store.getState());
        } catch (err) {
          console.error(err.toString());
        }

        return {
          state: sanitizedState,
          storeId: storeId
        };
      });

      var dispatch = function dispatch(action) {
        var start = (0, _now.default)();
        var err;
        var res;

        try {
          res = originalDispatch(action);
        } catch (_err) {
          err = _err;
        } finally {
          var duration = (0, _now.default)() - start;
          logger.addEvent('lr.redux.ReduxAction', function () {
            var sanitizedState = null;
            var sanitizedAction = null;

            try {
              // only try catch user defined functions
              sanitizedState = stateSanitizer(store.getState());
              sanitizedAction = actionSanitizer(action);
            } catch (err) {
              console.error(err.toString());
            }

            if (sanitizedState && sanitizedAction) {
              return {
                storeId: storeId,
                action: sanitizedAction,
                duration: duration,
                stateDelta: sanitizedState
              };
            }

            return null;
          });
        }

        if (err) {
          throw err;
        }

        return res;
      };

      return _objectSpread(_objectSpread({}, store), {}, {
        dispatch: dispatch
      });
    };
  };
}

module.exports = exports.default;

/***/ }),

/***/ "./packages/@apphub:logrocket-redux/src/createMiddleware.js":
/*!******************************************************************!*\
  !*** ./packages/@apphub:logrocket-redux/src/createMiddleware.js ***!
  \******************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {


var _interopRequireDefault = __webpack_require__(/*! @babel/runtime/helpers/interopRequireDefault */ "./node_modules/@babel/runtime/helpers/interopRequireDefault.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = createMiddleware;

var _now = _interopRequireDefault(__webpack_require__(/*! @apphub/now */ "./packages/@apphub:now/src/index.js"));

var storeIdCounter = 0;

function createMiddleware(logger) {
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      _ref$stateSanitizer = _ref.stateSanitizer,
      stateSanitizer = _ref$stateSanitizer === void 0 ? function (f) {
    return f;
  } : _ref$stateSanitizer,
      _ref$actionSanitizer = _ref.actionSanitizer,
      actionSanitizer = _ref$actionSanitizer === void 0 ? function (f) {
    return f;
  } : _ref$actionSanitizer;

  return function (store) {
    var storeId = storeIdCounter++;
    logger.addEvent('lr.redux.InitialState', function () {
      var sanitizedState;

      try {
        // only try catch user defined functions
        sanitizedState = stateSanitizer(store.getState());
      } catch (err) {
        console.error(err.toString());
      }

      return {
        state: sanitizedState,
        storeId: storeId
      };
    });
    return function (next) {
      return function (action) {
        var start = (0, _now.default)();
        var err;
        var res;

        try {
          res = next(action);
        } catch (_err) {
          err = _err;
        } finally {
          var duration = (0, _now.default)() - start;
          logger.addEvent('lr.redux.ReduxAction', function () {
            var sanitizedState = null;
            var sanitizedAction = null;

            try {
              // only try catch user defined functions
              sanitizedState = stateSanitizer(store.getState());
              sanitizedAction = actionSanitizer(action);
            } catch (err) {
              console.error(err.toString());
            }

            if (sanitizedState && sanitizedAction) {
              return {
                storeId: storeId,
                action: sanitizedAction,
                duration: duration,
                stateDelta: sanitizedState
              };
            }

            return null;
          });
        }

        if (err) {
          throw err;
        }

        return res;
      };
    };
  };
}

module.exports = exports.default;

/***/ }),

/***/ "./packages/@apphub:logrocket-redux/src/index.js":
/*!*******************************************************!*\
  !*** ./packages/@apphub:logrocket-redux/src/index.js ***!
  \*******************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {


var _interopRequireDefault = __webpack_require__(/*! @babel/runtime/helpers/interopRequireDefault */ "./node_modules/@babel/runtime/helpers/interopRequireDefault.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "createEnhancer", {
  enumerable: true,
  get: function get() {
    return _createEnhancer.default;
  }
});
Object.defineProperty(exports, "createMiddleware", {
  enumerable: true,
  get: function get() {
    return _createMiddleware.default;
  }
});

var _createEnhancer = _interopRequireDefault(__webpack_require__(/*! ./createEnhancer */ "./packages/@apphub:logrocket-redux/src/createEnhancer.js"));

var _createMiddleware = _interopRequireDefault(__webpack_require__(/*! ./createMiddleware */ "./packages/@apphub:logrocket-redux/src/createMiddleware.js"));

/***/ }),

/***/ "./packages/@apphub:logrocket-utils/src/TraceKit.js":
/*!**********************************************************!*\
  !*** ./packages/@apphub:logrocket-utils/src/TraceKit.js ***!
  \**********************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {
/* WEBPACK VAR INJECTION */(function(global) {/* eslint-disable */

/*
 TraceKit - Cross brower stack traces - github.com/occ/TraceKit

 This was originally forked from github.com/occ/TraceKit, but has since been
 largely re-written and is now maintained as part of raven-js.  Tests for
 this are in test/vendor.

 MIT license
*/

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var TraceKit = {
  collectWindowErrors: true,
  debug: false
}; // This is to be defensive in environments where window does not exist (see https://github.com/getsentry/raven-js/pull/785)

var _window = typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}; // global reference to slice


var _slice = [].slice;
var UNKNOWN_FUNCTION = '?'; // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Error#Error_types

var ERROR_TYPES_RE = /^(?:Uncaught (?:exception: )?)?((?:Eval|Internal|Range|Reference|Syntax|Type|URI)Error): ?(.*)$/;

function getLocationHref() {
  if (typeof document === 'undefined' || typeof document.location === 'undefined') return '';
  return document.location.href;
}
/**
 * TraceKit.report: cross-browser processing of unhandled exceptions
 *
 * Syntax:
 *   TraceKit.report.subscribe(function(stackInfo) { ... })
 *   TraceKit.report.unsubscribe(function(stackInfo) { ... })
 *   TraceKit.report(exception)
 *   try { ...code... } catch(ex) { TraceKit.report(ex); }
 *
 * Supports:
 *   - Firefox: full stack trace with line numbers, plus column number
 *              on top frame; column number is not guaranteed
 *   - Opera:   full stack trace with line and column numbers
 *   - Chrome:  full stack trace with line and column numbers
 *   - Safari:  line and column number for the top frame only; some frames
 *              may be missing, and column number is not guaranteed
 *   - IE:      line and column number for the top frame only; some frames
 *              may be missing, and column number is not guaranteed
 *
 * In theory, TraceKit should work on all of the following versions:
 *   - IE5.5+ (only 8.0 tested)
 *   - Firefox 0.9+ (only 3.5+ tested)
 *   - Opera 7+ (only 10.50 tested; versions 9 and earlier may require
 *     Exceptions Have Stacktrace to be enabled in opera:config)
 *   - Safari 3+ (only 4+ tested)
 *   - Chrome 1+ (only 5+ tested)
 *   - Konqueror 3.5+ (untested)
 *
 * Requires TraceKit.computeStackTrace.
 *
 * Tries to catch all unhandled exceptions and report them to the
 * subscribed handlers. Please note that TraceKit.report will rethrow the
 * exception. This is REQUIRED in order to get a useful stack trace in IE.
 * If the exception does not reach the top of the browser, you will only
 * get a stack trace from the point where TraceKit.report was called.
 *
 * Handlers receive a stackInfo object as described in the
 * TraceKit.computeStackTrace docs.
 */


TraceKit.report = function reportModuleWrapper() {
  var handlers = [],
      lastArgs = null,
      lastException = null,
      lastExceptionStack = null;
  /**
   * Add a crash handler.
   * @param {Function} handler
   */

  function subscribe(handler) {
    installGlobalHandler();
    handlers.push(handler);
  }
  /**
   * Remove a crash handler.
   * @param {Function} handler
   */


  function unsubscribe(handler) {
    for (var i = handlers.length - 1; i >= 0; --i) {
      if (handlers[i] === handler) {
        handlers.splice(i, 1);
      }
    }
  }
  /**
   * Remove all crash handlers.
   */


  function unsubscribeAll() {
    uninstallGlobalHandler();
    handlers = [];
  }
  /**
   * Dispatch stack information to all handlers.
   * @param {Object.<string, *>} stack
   */


  function notifyHandlers(stack, isWindowError) {
    var exception = null;

    if (isWindowError && !TraceKit.collectWindowErrors) {
      return;
    }

    for (var i in handlers) {
      if (handlers.hasOwnProperty(i)) {
        try {
          handlers[i].apply(null, [stack].concat(_slice.call(arguments, 2)));
        } catch (inner) {
          exception = inner;
        }
      }
    }

    if (exception) {
      throw exception;
    }
  }

  var _oldOnerrorHandler, _onErrorHandlerInstalled;
  /**
   * Ensures all global unhandled exceptions are recorded.
   * Supported by Gecko and IE.
   * @param {string} message Error message.
   * @param {string} url URL of script that generated the exception.
   * @param {(number|string)} lineNo The line number at which the error
   * occurred.
   * @param {?(number|string)} colNo The column number at which the error
   * occurred.
   * @param {?Error} ex The actual Error object.
   */


  function traceKitWindowOnError(message, url, lineNo, colNo, ex) {
    var stack = null;

    if (lastExceptionStack) {
      TraceKit.computeStackTrace.augmentStackTraceWithInitialElement(lastExceptionStack, url, lineNo, message);
      processLastException();
    } else if (ex) {
      // New chrome and blink send along a real error object
      // Let's just report that like a normal error.
      // See: https://mikewest.org/2013/08/debugging-runtime-errors-with-window-onerror
      stack = TraceKit.computeStackTrace(ex);
      notifyHandlers(stack, true);
    } else {
      var location = {
        'url': url,
        'line': lineNo,
        'column': colNo
      };
      var name = undefined;
      var msg = message; // must be new var or will modify original `arguments`

      var groups;

      if ({}.toString.call(message) === '[object String]') {
        var groups = message.match(ERROR_TYPES_RE);

        if (groups) {
          name = groups[1];
          msg = groups[2];
        }
      }

      location.func = UNKNOWN_FUNCTION;
      stack = {
        'name': name,
        'message': msg,
        'url': getLocationHref(),
        'stack': [location]
      };
      notifyHandlers(stack, true);
    }

    if (_oldOnerrorHandler) {
      return _oldOnerrorHandler.apply(this, arguments);
    }

    return false;
  }

  function installGlobalHandler() {
    if (_onErrorHandlerInstalled) {
      return;
    }

    _oldOnerrorHandler = _window.onerror;
    _window.onerror = traceKitWindowOnError;
    _onErrorHandlerInstalled = true;
  }

  function uninstallGlobalHandler() {
    if (!_onErrorHandlerInstalled) {
      return;
    }

    _window.onerror = _oldOnerrorHandler;
    _onErrorHandlerInstalled = false;
    _oldOnerrorHandler = undefined;
  }

  function processLastException() {
    var _lastExceptionStack = lastExceptionStack,
        _lastArgs = lastArgs;
    lastArgs = null;
    lastExceptionStack = null;
    lastException = null;
    notifyHandlers.apply(null, [_lastExceptionStack, false].concat(_lastArgs));
  }
  /**
   * Reports an unhandled Error to TraceKit.
   * @param {Error} ex
   * @param {?boolean} rethrow If false, do not re-throw the exception.
   * Only used for window.onerror to not cause an infinite loop of
   * rethrowing.
   */


  function report(ex, rethrow) {
    var args = _slice.call(arguments, 1);

    if (lastExceptionStack) {
      if (lastException === ex) {
        return; // already caught by an inner catch block, ignore
      } else {
        processLastException();
      }
    }

    var stack = TraceKit.computeStackTrace(ex);
    lastExceptionStack = stack;
    lastException = ex;
    lastArgs = args; // If the stack trace is incomplete, wait for 2 seconds for
    // slow slow IE to see if onerror occurs or not before reporting
    // this exception; otherwise, we will end up with an incomplete
    // stack trace

    setTimeout(function () {
      if (lastException === ex) {
        processLastException();
      }
    }, stack.incomplete ? 2000 : 0);

    if (rethrow !== false) {
      throw ex; // re-throw to propagate to the top level (and cause window.onerror)
    }
  }

  report.subscribe = subscribe;
  report.unsubscribe = unsubscribe;
  report.uninstall = unsubscribeAll;
  return report;
}();
/**
 * TraceKit.computeStackTrace: cross-browser stack traces in JavaScript
 *
 * Syntax:
 *   s = TraceKit.computeStackTrace(exception) // consider using TraceKit.report instead (see below)
 * Returns:
 *   s.name              - exception name
 *   s.message           - exception message
 *   s.stack[i].url      - JavaScript or HTML file URL
 *   s.stack[i].func     - function name, or empty for anonymous functions (if guessing did not work)
 *   s.stack[i].args     - arguments passed to the function, if known
 *   s.stack[i].line     - line number, if known
 *   s.stack[i].column   - column number, if known
 *
 * Supports:
 *   - Firefox:  full stack trace with line numbers and unreliable column
 *               number on top frame
 *   - Opera 10: full stack trace with line and column numbers
 *   - Opera 9-: full stack trace with line numbers
 *   - Chrome:   full stack trace with line and column numbers
 *   - Safari:   line and column number for the topmost stacktrace element
 *               only
 *   - IE:       no line numbers whatsoever
 *
 * Tries to guess names of anonymous functions by looking for assignments
 * in the source code. In IE and Safari, we have to guess source file names
 * by searching for function bodies inside all page scripts. This will not
 * work for scripts that are loaded cross-domain.
 * Here be dragons: some function names may be guessed incorrectly, and
 * duplicate functions may be mismatched.
 *
 * TraceKit.computeStackTrace should only be used for tracing purposes.
 * Logging of unhandled exceptions should be done with TraceKit.report,
 * which builds on top of TraceKit.computeStackTrace and provides better
 * IE support by utilizing the window.onerror event to retrieve information
 * about the top of the stack.
 *
 * Note: In IE and Safari, no stack trace is recorded on the Error object,
 * so computeStackTrace instead walks its *own* chain of callers.
 * This means that:
 *  * in Safari, some methods may be missing from the stack trace;
 *  * in IE, the topmost function in the stack trace will always be the
 *    caller of computeStackTrace.
 *
 * This is okay for tracing (because you are likely to be calling
 * computeStackTrace from the function you want to be the topmost element
 * of the stack trace anyway), but not okay for logging unhandled
 * exceptions (because your catch block will likely be far away from the
 * inner function that actually caused the exception).
 *
 */


TraceKit.computeStackTrace = function computeStackTraceWrapper() {
  //
  // SAFARI:
  // ex.message = Can't find variable: qq
  // ex.line = 59
  // ex.sourceId = 580238192
  // ex.sourceURL = http://...
  // ex.expressionBeginOffset = 96
  // ex.expressionCaretOffset = 98
  // ex.expressionEndOffset = 98
  // ex.name = ReferenceError
  //
  // FIREFOX:
  // ex.message = qq is not defined
  // ex.fileName = http://...
  // ex.lineNumber = 59
  // ex.columnNumber = 69
  // ex.stack = ...stack trace... (see the example below)
  // ex.name = ReferenceError
  //
  // CHROME:
  // ex.message = qq is not defined
  // ex.name = ReferenceError
  // ex.type = not_defined
  // ex.arguments = ['aa']
  // ex.stack = ...stack trace...
  //
  // INTERNET EXPLORER:
  // ex.message = ...
  // ex.name = ReferenceError
  //
  // OPERA:
  // ex.message = ...message... (see the example below)
  // ex.name = ReferenceError
  // ex.opera#sourceloc = 11  (pretty much useless, duplicates the info in ex.message)
  // ex.stacktrace = n/a; see 'opera:config#UserPrefs|Exceptions Have Stacktrace'

  /**
   * Computes stack trace information from the stack property.
   * Chrome and Gecko use this property.
   * @param {Error} ex
   * @return {?Object.<string, *>} Stack trace information.
   */


  function computeStackTraceFromStackProp(ex) {
    if (typeof ex.stack === 'undefined' || !ex.stack) return;
    var chrome = /^\s*at (.*?) ?\(((?:file|https?|blob|chrome-extension|native|eval|<anonymous>).*?)(?::(\d+))?(?::(\d+))?\)?\s*$/i,
        gecko = /^\s*(.*?)(?:\((.*?)\))?(?:^|@)((?:file|https?|blob|chrome|resource|\[native).*?)(?::(\d+))?(?::(\d+))?\s*$/i,
        winjs = /^\s*at (?:((?:\[object object\])?.+) )?\(?((?:file|ms-appx|https?|blob):.*?):(\d+)(?::(\d+))?\)?\s*$/i,
        lines = ex.stack.split('\n'),
        stack = [],
        parts,
        element,
        reference = /^(.*) is undefined$/.exec(ex.message);

    for (var i = 0, j = lines.length; i < j; ++i) {
      if (parts = chrome.exec(lines[i])) {
        var isNative = parts[2] && parts[2].indexOf('native') !== -1;
        element = {
          'url': !isNative ? parts[2] : null,
          'func': parts[1] || UNKNOWN_FUNCTION,
          'args': isNative ? [parts[2]] : [],
          'line': parts[3] ? +parts[3] : null,
          'column': parts[4] ? +parts[4] : null
        };
      } else if (parts = winjs.exec(lines[i])) {
        element = {
          'url': parts[2],
          'func': parts[1] || UNKNOWN_FUNCTION,
          'args': [],
          'line': +parts[3],
          'column': parts[4] ? +parts[4] : null
        };
      } else if (parts = gecko.exec(lines[i])) {
        element = {
          'url': parts[3],
          'func': parts[1] || UNKNOWN_FUNCTION,
          'args': parts[2] ? parts[2].split(',') : [],
          'line': parts[4] ? +parts[4] : null,
          'column': parts[5] ? +parts[5] : null
        };
      } else {
        continue;
      }

      if (!element.func && element.line) {
        element.func = UNKNOWN_FUNCTION;
      }

      stack.push(element);
    }

    if (!stack.length) {
      return null;
    }

    if (!stack[0].column && typeof ex.columnNumber !== 'undefined') {
      // FireFox uses this awesome columnNumber property for its top frame
      // Also note, Firefox's column number is 0-based and everything else expects 1-based,
      // so adding 1
      stack[0].column = ex.columnNumber + 1;
    }

    return {
      'name': ex.name,
      'message': ex.message,
      'url': getLocationHref(),
      'stack': stack
    };
  }
  /**
   * Adds information about the first frame to incomplete stack traces.
   * Safari and IE require this to get complete data on the first frame.
   * @param {Object.<string, *>} stackInfo Stack trace information from
   * one of the compute* methods.
   * @param {string} url The URL of the script that caused an error.
   * @param {(number|string)} lineNo The line number of the script that
   * caused an error.
   * @param {string=} message The error generated by the browser, which
   * hopefully contains the name of the object that caused the error.
   * @return {boolean} Whether or not the stack information was
   * augmented.
   */


  function augmentStackTraceWithInitialElement(stackInfo, url, lineNo, message) {
    var initial = {
      'url': url,
      'line': lineNo
    };

    if (initial.url && initial.line) {
      stackInfo.incomplete = false;

      if (!initial.func) {
        initial.func = UNKNOWN_FUNCTION;
      }

      if (stackInfo.stack.length > 0) {
        if (stackInfo.stack[0].url === initial.url) {
          if (stackInfo.stack[0].line === initial.line) {
            return false; // already in stack trace
          } else if (!stackInfo.stack[0].line && stackInfo.stack[0].func === initial.func) {
            stackInfo.stack[0].line = initial.line;
            return false;
          }
        }
      }

      stackInfo.stack.unshift(initial);
      stackInfo.partial = true;
      return true;
    } else {
      stackInfo.incomplete = true;
    }

    return false;
  }
  /**
   * Computes stack trace information by walking the arguments.caller
   * chain at the time the exception occurred. This will cause earlier
   * frames to be missed but is the only way to get any stack trace in
   * Safari and IE. The top frame is restored by
   * {@link augmentStackTraceWithInitialElement}.
   * @param {Error} ex
   * @return {?Object.<string, *>} Stack trace information.
   */


  function computeStackTraceByWalkingCallerChain(ex, depth) {
    var functionName = /function\s+([_$a-zA-Z\xA0-\uFFFF][_$a-zA-Z0-9\xA0-\uFFFF]*)?\s*\(/i,
        stack = [],
        funcs = {},
        recursion = false,
        parts,
        item;

    for (var curr = computeStackTraceByWalkingCallerChain.caller; curr && !recursion; curr = curr.caller) {
      if (curr === computeStackTrace || curr === TraceKit.report) {
        // console.log('skipping internal function');
        continue;
      }

      item = {
        'url': null,
        'func': UNKNOWN_FUNCTION,
        'line': null,
        'column': null
      };

      if (curr.name) {
        item.func = curr.name;
      } else if (parts = functionName.exec(curr.toString())) {
        item.func = parts[1];
      }

      if (typeof item.func === 'undefined') {
        try {
          item.func = parts.input.substring(0, parts.input.indexOf('{'));
        } catch (e) {}
      }

      if (funcs['' + curr]) {
        recursion = true;
      } else {
        funcs['' + curr] = true;
      }

      stack.push(item);
    }

    if (depth) {
      // console.log('depth is ' + depth);
      // console.log('stack is ' + stack.length);
      stack.splice(0, depth);
    }

    var result = {
      'name': ex.name,
      'message': ex.message,
      'url': getLocationHref(),
      'stack': stack
    };
    augmentStackTraceWithInitialElement(result, ex.sourceURL || ex.fileName, ex.line || ex.lineNumber, ex.message || ex.description);
    return result;
  }
  /**
   * Computes a stack trace for an exception.
   * @param {Error} ex
   * @param {(string|number)=} depth
   */


  function computeStackTrace(ex, depth) {
    var stack = null;
    depth = depth == null ? 0 : +depth;

    try {
      stack = computeStackTraceFromStackProp(ex);

      if (stack) {
        return stack;
      }
    } catch (e) {
      if (TraceKit.debug) {
        throw e;
      }
    }

    try {
      stack = computeStackTraceByWalkingCallerChain(ex, depth + 1);

      if (stack) {
        return stack;
      }
    } catch (e) {
      if (TraceKit.debug) {
        throw e;
      }
    }

    return {
      'name': ex.name,
      'message': ex.message,
      'url': getLocationHref()
    };
  }

  computeStackTrace.augmentStackTraceWithInitialElement = augmentStackTraceWithInitialElement;
  computeStackTrace.computeStackTraceFromStackProp = computeStackTraceFromStackProp;
  return computeStackTrace;
}();

var _default = TraceKit;
exports.default = _default;
module.exports = exports.default;
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(/*! ./../../../node_modules/webpack/buildin/global.js */ "./node_modules/webpack/buildin/global.js")));

/***/ }),

/***/ "./packages/@apphub:logrocket-utils/src/constants/nps.js":
/*!***************************************************************!*\
  !*** ./packages/@apphub:logrocket-utils/src/constants/nps.js ***!
  \***************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DELIGHTED_FEEDBACK_PREFIX = exports.DELIGHTED_RESPONSES_REGEX = exports.WOOTRIC_RESPONSES_REGEX = void 0;
var WOOTRIC_RESPONSES_REGEX = /^https:\/\/production.wootric.com\/responses/;
exports.WOOTRIC_RESPONSES_REGEX = WOOTRIC_RESPONSES_REGEX;
var DELIGHTED_RESPONSES_REGEX = /^https:\/\/web.delighted.com\/e\/[a-zA-Z-]*\/c/;
exports.DELIGHTED_RESPONSES_REGEX = DELIGHTED_RESPONSES_REGEX;
var DELIGHTED_FEEDBACK_PREFIX = 'comment=';
exports.DELIGHTED_FEEDBACK_PREFIX = DELIGHTED_FEEDBACK_PREFIX;

/***/ }),

/***/ "./packages/@apphub:logrocket-utils/src/enhanceFunc.js":
/*!*************************************************************!*\
  !*** ./packages/@apphub:logrocket-utils/src/enhanceFunc.js ***!
  \*************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = enhanceFunc;

/* eslint no-param-reassign: ["error", { "props": false }] */
function enhanceFunc(obj, method, handler) {
  var original = obj[method];

  function shim() {
    var res;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    if (original) {
      res = original.apply(this, args);
    }

    handler.apply(this, args);
    return res;
  }

  obj[method] = shim;
  return function () {
    obj[method] = original;
  };
}

module.exports = exports.default;

/***/ }),

/***/ "./packages/@apphub:logrocket-utils/src/mapValues.js":
/*!***********************************************************!*\
  !*** ./packages/@apphub:logrocket-utils/src/mapValues.js ***!
  \***********************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = mapValues;

function mapValues(obj, f) {
  if (obj == null) {
    return {};
  }

  var res = {};
  Object.keys(obj).forEach(function (key) {
    res[key] = f(obj[key]);
  });
  return res;
}

module.exports = exports.default;

/***/ }),

/***/ "./packages/@apphub:logrocket-utils/src/startsWith.js":
/*!************************************************************!*\
  !*** ./packages/@apphub:logrocket-utils/src/startsWith.js ***!
  \************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = startsWith;

function startsWith(value, search) {
  var pos = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
  return value && search && value.substring(pos, pos + search.length) === search;
}

module.exports = exports.default;

/***/ }),

/***/ "./packages/@apphub:now/src/index.js":
/*!*******************************************!*\
  !*** ./packages/@apphub:now/src/index.js ***!
  \*******************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var dateNow = Date.now.bind(Date);
var loadTime = dateNow();

var _default = typeof performance !== 'undefined' && performance.now ? performance.now.bind(performance) : function () {
  return dateNow() - loadTime;
};

exports.default = _default;
module.exports = exports.default;

/***/ }),

/***/ "./packages/logrocket/src/LogRocket.js":
/*!*********************************************!*\
  !*** ./packages/logrocket/src/LogRocket.js ***!
  \*********************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {


var _interopRequireDefault = __webpack_require__(/*! @babel/runtime/helpers/interopRequireDefault */ "./node_modules/@babel/runtime/helpers/interopRequireDefault.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.MAX_QUEUE_SIZE = void 0;

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js"));

var _createClass2 = _interopRequireDefault(__webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js"));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(/*! @babel/runtime/helpers/defineProperty */ "./node_modules/@babel/runtime/helpers/defineProperty.js"));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(/*! @babel/runtime/helpers/objectWithoutProperties */ "./node_modules/@babel/runtime/helpers/objectWithoutProperties.js"));

var _logrocketNetwork = _interopRequireDefault(__webpack_require__(/*! @apphub/logrocket-network */ "./packages/@apphub:logrocket-network/src/index.js"));

var _logrocketExceptions = __webpack_require__(/*! @apphub/logrocket-exceptions */ "./packages/@apphub:logrocket-exceptions/src/index.js");

var _logrocketConsole = _interopRequireDefault(__webpack_require__(/*! @apphub/logrocket-console */ "./packages/@apphub:logrocket-console/src/index.js"));

var _logrocketRedux = __webpack_require__(/*! @apphub/logrocket-redux */ "./packages/@apphub:logrocket-redux/src/index.js");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var MAX_QUEUE_SIZE = 1000;
exports.MAX_QUEUE_SIZE = MAX_QUEUE_SIZE;

var considerIngestServerOption = function considerIngestServerOption() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      ingestServer = _ref.ingestServer,
      options = (0, _objectWithoutProperties2.default)(_ref, ["ingestServer"]);

  if (ingestServer) {
    return _objectSpread({
      serverURL: "".concat(ingestServer, "/i"),
      statsURL: "".concat(ingestServer, "/s")
    }, options);
  }

  return options;
};

var LogRocket = /*#__PURE__*/function () {
  function LogRocket() {
    var _this = this;

    (0, _classCallCheck2.default)(this, LogRocket);
    this._buffer = [];
    // TODO: tests for these exposed methods.
    ['log', 'info', 'warn', 'error', 'debug'].forEach(function (method) {
      _this[method] = function () {
        for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        _this.addEvent('lr.core.LogEvent', function () {
          var consoleOptions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

          if (method === 'error' && consoleOptions.shouldAggregateConsoleErrors) {
            _logrocketExceptions.Capture.captureMessage(_this, args[0], {}, true);
          }

          return {
            logLevel: method.toUpperCase(),
            args: args
          };
        }, {
          shouldCaptureStackTrace: true
        });
      };
    });
    this._isInitialized = false;
    this._installed = [];
  }

  (0, _createClass2.default)(LogRocket, [{
    key: "addEvent",
    value: function addEvent(type, getMessage) {
      var opts = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      var time = Date.now();

      this._run(function (logger) {
        logger.addEvent(type, getMessage, _objectSpread(_objectSpread({}, opts), {}, {
          timeOverride: time
        }));
      });
    }
  }, {
    key: "onLogger",
    value: function onLogger(logger) {
      this._logger = logger;

      while (this._buffer.length > 0) {
        var f = this._buffer.shift();

        f(this._logger);
      }
    }
  }, {
    key: "_run",
    value: function _run(f) {
      if (this._isDisabled) {
        return;
      }

      if (this._logger) {
        f(this._logger);
      } else {
        if (this._buffer.length >= MAX_QUEUE_SIZE) {
          this._isDisabled = true;
          console.warn('LogRocket: script did not load. Check that you have a valid network connection.');
          this.uninstall();
          return;
        }

        this._buffer.push(f.bind(this));
      }
    }
  }, {
    key: "init",
    value: function init(appID) {
      var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      if (!this._isInitialized) {
        var _opts$shouldAugmentNP = opts.shouldAugmentNPS,
            shouldAugmentNPS = _opts$shouldAugmentNP === void 0 ? true : _opts$shouldAugmentNP;

        this._installed.push((0, _logrocketExceptions.registerExceptions)(this));

        this._installed.push((0, _logrocketNetwork.default)(this, {
          shouldAugmentNPS: !!shouldAugmentNPS
        }));

        this._installed.push((0, _logrocketConsole.default)(this));

        this._isInitialized = true;

        this._run(function (logger) {
          logger.init(appID, considerIngestServerOption(opts));
        });
      }
    }
  }, {
    key: "start",
    value: function start() {
      this._run(function (logger) {
        logger.start();
      });
    }
  }, {
    key: "uninstall",
    value: function uninstall() {
      this._installed.forEach(function (f) {
        return f();
      });

      this._buffer = [];

      this._run(function (logger) {
        logger.uninstall();
      });
    }
  }, {
    key: "identify",
    value: function identify(id, opts) {
      this._run(function (logger) {
        logger.identify(id, opts);
      });
    }
  }, {
    key: "startNewSession",
    value: function startNewSession() {
      this._run(function (logger) {
        logger.startNewSession();
      });
    }
  }, {
    key: "track",
    value: function track(customEventName, eventProperties) {
      this._run(function (logger) {
        logger.track(customEventName, eventProperties);
      });
    }
  }, {
    key: "getSessionURL",
    value: function getSessionURL(cb) {
      if (typeof cb !== 'function') {
        throw new Error('LogRocket: must pass callback to getSessionURL()');
      }

      this._run(function (logger) {
        if (logger.getSessionURL) {
          logger.getSessionURL(cb);
        } else {
          cb(logger.recordingURL);
        }
      });
    }
  }, {
    key: "getVersion",
    value: function getVersion(cb) {
      this._run(function (logger) {
        cb(logger.version);
      });
    }
  }, {
    key: "captureMessage",
    value: function captureMessage(message) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      _logrocketExceptions.Capture.captureMessage(this, message, options);
    }
  }, {
    key: "captureException",
    value: function captureException(exception) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      _logrocketExceptions.Capture.captureException(this, exception, options);
    }
  }, {
    key: "version",
    get: function get() {
      return this._logger && this._logger.version;
    }
  }, {
    key: "sessionURL",
    get: function get() {
      return this._logger && this._logger.recordingURL;
    }
  }, {
    key: "recordingURL",
    get: function get() {
      return this._logger && this._logger.recordingURL;
    }
  }, {
    key: "recordingID",
    get: function get() {
      return this._logger && this._logger.recordingID;
    }
  }, {
    key: "threadID",
    get: function get() {
      return this._logger && this._logger.threadID;
    }
  }, {
    key: "tabID",
    get: function get() {
      return this._logger && this._logger.tabID;
    }
  }, {
    key: "reduxEnhancer",
    value: function reduxEnhancer() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return (0, _logrocketRedux.createEnhancer)(this, options);
    }
  }, {
    key: "reduxMiddleware",
    value: function reduxMiddleware() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return (0, _logrocketRedux.createMiddleware)(this, options);
    }
  }, {
    key: "isDisabled",
    get: function get() {
      return !!(this._isDisabled || this._logger && this._logger._isDisabled);
    }
  }]);
  return LogRocket;
}();

exports.default = LogRocket;

/***/ }),

/***/ "./packages/logrocket/src/makeLogRocket.js":
/*!*************************************************!*\
  !*** ./packages/logrocket/src/makeLogRocket.js ***!
  \*************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {


var _interopRequireDefault = __webpack_require__(/*! @babel/runtime/helpers/interopRequireDefault */ "./node_modules/@babel/runtime/helpers/interopRequireDefault.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = makeLogRocket;

var _LogRocket = _interopRequireDefault(__webpack_require__(/*! ./LogRocket */ "./packages/logrocket/src/LogRocket.js"));

var REACT_NATIVE_NOTICE = 'LogRocket does not yet support React Native.';

var makeNoopPolyfill = function makeNoopPolyfill() {
  return {
    init: function init() {},
    uninstall: function uninstall() {},
    log: function log() {},
    info: function info() {},
    warn: function warn() {},
    error: function error() {},
    debug: function debug() {},
    addEvent: function addEvent() {},
    identify: function identify() {},
    start: function start() {},

    get threadID() {
      return null;
    },

    get recordingID() {
      return null;
    },

    get recordingURL() {
      return null;
    },

    reduxEnhancer: function reduxEnhancer() {
      return function (store) {
        return function () {
          return store.apply(void 0, arguments);
        };
      };
    },
    reduxMiddleware: function reduxMiddleware() {
      return function () {
        return function (next) {
          return function (action) {
            return next(action);
          };
        };
      };
    },
    track: function track() {},
    getSessionURL: function getSessionURL() {},
    getVersion: function getVersion() {},
    startNewSession: function startNewSession() {},
    onLogger: function onLogger() {},
    setClock: function setClock() {},
    captureMessage: function captureMessage() {},
    captureException: function captureException() {}
  };
};

function makeLogRocket() {
  var getLogger = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : function () {};

  if (typeof navigator !== 'undefined' && navigator.product === 'ReactNative') {
    throw new Error(REACT_NATIVE_NOTICE);
  }

  if (typeof window !== 'undefined') {
    if (window._disableLogRocket) {
      return makeNoopPolyfill();
    }

    if (window.MutationObserver && window.WeakMap) {
      // Save window globals that we rely on.
      window._lrMutationObserver = window.MutationObserver;
      var instance = new _LogRocket.default();
      getLogger(instance);
      return instance;
    }
  }

  return makeNoopPolyfill();
}

module.exports = exports.default;

/***/ }),

/***/ "./packages/logrocket/src/module-npm.js":
/*!**********************************************!*\
  !*** ./packages/logrocket/src/module-npm.js ***!
  \**********************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {


var _interopRequireDefault = __webpack_require__(/*! @babel/runtime/helpers/interopRequireDefault */ "./node_modules/@babel/runtime/helpers/interopRequireDefault.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _setup = _interopRequireDefault(__webpack_require__(/*! ./setup */ "./packages/logrocket/src/setup.js"));

var instance = (0, _setup.default)();
var _default = instance;
exports.default = _default;
module.exports = exports.default;

/***/ }),

/***/ "./packages/logrocket/src/setup.js":
/*!*****************************************!*\
  !*** ./packages/logrocket/src/setup.js ***!
  \*****************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {


var _interopRequireDefault = __webpack_require__(/*! @babel/runtime/helpers/interopRequireDefault */ "./node_modules/@babel/runtime/helpers/interopRequireDefault.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = setup;

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(/*! @babel/runtime/helpers/objectWithoutProperties */ "./node_modules/@babel/runtime/helpers/objectWithoutProperties.js"));

var _makeLogRocket = _interopRequireDefault(__webpack_require__(/*! ./makeLogRocket */ "./packages/logrocket/src/makeLogRocket.js"));

var CDN_SERVER_MAP = {
  'cdn.logrocket.io': 'https://r.logrocket.io',
  'cdn.lr-ingest.io': 'https://r.lr-ingest.io',
  'cdn-staging.logrocket.io': 'https://staging-i.logrocket.io',
  'cdn-staging.lr-ingest.io': 'https://staging-i.lr-ingest.io'
};

function setup() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      enterpriseServer = _ref.enterpriseServer,
      _ref$sdkVersion = _ref.sdkVersion,
      sdkVersion = _ref$sdkVersion === void 0 ? "1.3.0" : _ref$sdkVersion,
      opts = (0, _objectWithoutProperties2.default)(_ref, ["enterpriseServer", "sdkVersion"]);

  var scriptOrigin =  'https://cdn.logrocket.io';
  var scriptIngest;

  if (sdkVersion === 'script') {
    try {
      var scriptTag = document.currentScript;
      var matches = scriptTag.src.match(/^(https?:\/\/([^\\]+))\/.+$/);
      var scriptHostname = matches && matches[2];

      if (scriptHostname && CDN_SERVER_MAP[scriptHostname]) {
        scriptOrigin = matches && matches[1];
        scriptIngest = CDN_SERVER_MAP[scriptHostname];
      }
    } catch (_) {
      /* no-op */
    }
  } else {
    // NPM
    scriptOrigin =  'https://cdn.lr-ingest.io';
    scriptIngest =  'https://r.lr-ingest.io';
  }

  var sdkServer = opts.sdkServer || enterpriseServer;
  var ingestServer = opts.ingestServer || enterpriseServer || scriptIngest;
  var instance = (0, _makeLogRocket.default)(function () {
    var script = document.createElement('script');

    if (ingestServer) {
      if (typeof window.__SDKCONFIG__ === 'undefined') {
        window.__SDKCONFIG__ = {};
      }

      window.__SDKCONFIG__.serverURL = "".concat(ingestServer, "/i");
      window.__SDKCONFIG__.statsURL = "".concat(ingestServer, "/s");
    }

    if (sdkServer) {
      script.src = "".concat(sdkServer, "/logger.min.js");
    } else if (window.__SDKCONFIG__ && window.__SDKCONFIG__.loggerURL) {
      script.src = window.__SDKCONFIG__.loggerURL;
    } else if (window._lrAsyncScript) {
      script.src = window._lrAsyncScript;
    } else {
      script.src = "".concat(scriptOrigin, "/logger-1.min.js");
    }

    script.async = true;
    document.head.appendChild(script);

    script.onload = function () {
      // Brave browser: Advertises its user-agent as Chrome ##.##... then
      // loads logger.min.js, but blocks the execution of the script
      // causing _LRlogger to be undefined.  Let's make sure its there first.
      if (typeof window._LRLogger === 'function') {
        instance.onLogger(new window._LRLogger({
          sdkVersion: sdkVersion
        }));
      } else {
        console.warn('LogRocket: script execution has been blocked by a product or service.');
        instance.uninstall();
      }
    };

    script.onerror = function () {
      console.warn('LogRocket: script could not load. Check that you have a valid network connection.');
      instance.uninstall();
    };
  });
  return instance;
}

module.exports = exports.default;

/***/ }),

/***/ 0:
/*!****************************************************!*\
  !*** multi ./packages/logrocket/src/module-npm.js ***!
  \****************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(/*! /root/project/packages/logrocket/src/module-npm.js */"./packages/logrocket/src/module-npm.js");


/***/ })

/******/ });
});
});

var LogRocket = unwrapExports(build_umd);

var APPS_ID = {
  'report-builder': 'hoo2i2/reports-qwk97',
  'dashboard': 'hoo2i2/dashboard',
  'creatives': 'hoo2i2/creatives',
  'campaigns': 'hoo2i2/campaigns',
  'audiences': 'hoo2i2/audiences-0p09u',
  'inventory': 'hoo2i2/inventory-sgeag',
  'bid-model': 'hoo2i2/bid-model',
  'customers': 'hoo2i2/customers',
  'conversions': 'hoo2i2/events-cb0lz'
};
function enableLogRocket(app) {
  var id = APPS_ID[app];

  if (id) {
    LogRocket.init(id);
  }
}
function identifyLogRocket() {
  var user = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  LogRocket.identify(user.apiToken, {
    name: "".concat(user.displayName || user.organizationName),
    email: user.email
  });
}

function _createSuper$1(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$1(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct$1() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var LoginFormContainer = /*#__PURE__*/function (_React$Component) {
  _inherits(LoginFormContainer, _React$Component);

  var _super = _createSuper$1(LoginFormContainer);

  function LoginFormContainer() {
    var _this;

    _classCallCheck(this, LoginFormContainer);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _this.getFullSuccessRedirectPath = function () {
      var search = _this.props.location.search;

      if (!_this.props.successLoginRedirectPath) {
        return "/".concat(search);
      }

      return _this.props.transformSuccessRedirectPath ? _this.props.transformSuccessRedirectPath(_this.props.successLoginRedirectPath, search) : _this.props.successLoginRedirectPath + search;
    };

    _this.onSuccessLogin = function (userData) {
      var _userData$failureDeta;

      AuthService.updateUser(userData);

      if (((_userData$failureDeta = userData.failureDetails) === null || _userData$failureDeta === void 0 ? void 0 : _userData$failureDeta.status) === 'ON_HOLD') {
        window.location.href = "/marketplace/u/".concat(getPathNumber(), "/#/on-hold");
        return;
      }

      identifyLogRocket(userData);

      var successLoginRedirectPath = _this.getFullSuccessRedirectPath();

      _this.props.history.push(successLoginRedirectPath);
    };

    return _this;
  }

  _createClass(LoginFormContainer, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (!this.props.loginForm) {
        window.location.href = "".concat(window.location.origin, "/#/login");
      }
    }
  }, {
    key: "render",
    value: function render() {
      if (this.props.loginForm) {
        var LoginFormComponent = this.props.loginForm;
        return /*#__PURE__*/React__default.createElement(LoginFormComponent, {
          onSuccess: this.onSuccessLogin,
          docTitle: this.props.documentTitle
        });
      }

      return /*#__PURE__*/React__default.createElement("div", {
        className: "d-flex align-items-center justify-content-center",
        style: {
          height: '100vh'
        }
      }, /*#__PURE__*/React__default.createElement(ProgressCircle, {
        size: 200
      }));
    }
  }]);

  return LoginFormContainer;
}(React__default.Component);
LoginFormContainer.propTypes = {
  documentTitle: PropTypes.string,
  successLoginRedirectPath: PropTypes.string,
  transformSuccessRedirectPath: PropTypes.func,
  // onLogout: PropTypes.func,
  // match: PropTypes.object,
  history: PropTypes.object,
  location: PropTypes.object,
  loginForm: PropTypes.elementType
};

var Timezones = /*#__PURE__*/_createClass(function Timezones() {
  var _this = this;

  _classCallCheck(this, Timezones);

  this.fetchingTimezones = null;

  this.clearState = function () {
    _this.state = null;
    _this.fetchingTimezones = null;
  };

  this.getState = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee() {
    var state;
    return regenerator.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (!_this.state) {
              _context.next = 2;
              break;
            }

            return _context.abrupt("return", _this.state);

          case 2:
            if (!_this.fetchingTimezones) {
              _context.next = 8;
              break;
            }

            _context.next = 5;
            return _this.fetchingTimezones;

          case 5:
            _this.state = _context.sent;
            _context.next = 18;
            break;

          case 8:
            _this.fetchingTimezones = ApiService.fetchTimezones();
            _context.prev = 9;
            _context.next = 12;
            return _this.fetchingTimezones;

          case 12:
            state = _context.sent;
            _this.state = state;
            _context.next = 18;
            break;

          case 16:
            _context.prev = 16;
            _context.t0 = _context["catch"](9);

          case 18:
            return _context.abrupt("return", _this.state);

          case 19:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[9, 16]]);
  }));
});

var TimezonesService = new Timezones();

function _createSuper$2(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$2(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct$2() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var PrivateRoutesContainer = /*#__PURE__*/function (_React$Component) {
  _inherits(PrivateRoutesContainer, _React$Component);

  var _super = _createSuper$2(PrivateRoutesContainer);

  function PrivateRoutesContainer() {
    _classCallCheck(this, PrivateRoutesContainer);

    return _super.apply(this, arguments);
  }

  _createClass(PrivateRoutesContainer, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _authorizedUser$failu,
          _this = this;

      var authorizedUser = AuthService.getUser();

      if (!authorizedUser) {
        window.location.href = '/#/login';
        return;
      } else if (((_authorizedUser$failu = authorizedUser.failureDetails) === null || _authorizedUser$failu === void 0 ? void 0 : _authorizedUser$failu.status) === 'SUSPENDED') {
        window.location.href = "/marketplace/u/".concat(getPathNumber(), "/#/suspended");
      }

      AuthService.logout = function () {
        TimezonesService.clearState();

        _this.props.onLogout();

        window.location.href = '/';
      };

      this.props.onSuccessLogin(authorizedUser, this.props.history);
    }
  }, {
    key: "render",
    value: function render() {
      return this.props.children;
    }
  }]);

  return PrivateRoutesContainer;
}(React__default.Component);

PrivateRoutesContainer.propTypes = {
  onSuccessLogin: PropTypes.func,
  onLogout: PropTypes.func,
  history: PropTypes.object
};
var PrivateRoutesContainer$1 = withRouter(PrivateRoutesContainer);

var arrayLikeToArray = createCommonjsModule(function (module) {
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

module.exports = _arrayLikeToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;
});

unwrapExports(arrayLikeToArray);

var arrayWithoutHoles = createCommonjsModule(function (module) {
function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return arrayLikeToArray(arr);
}

module.exports = _arrayWithoutHoles, module.exports.__esModule = true, module.exports["default"] = module.exports;
});

unwrapExports(arrayWithoutHoles);

var iterableToArray = createCommonjsModule(function (module) {
function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}

module.exports = _iterableToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;
});

unwrapExports(iterableToArray);

var unsupportedIterableToArray = createCommonjsModule(function (module) {
function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return arrayLikeToArray(o, minLen);
}

module.exports = _unsupportedIterableToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;
});

unwrapExports(unsupportedIterableToArray);

var nonIterableSpread = createCommonjsModule(function (module) {
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

module.exports = _nonIterableSpread, module.exports.__esModule = true, module.exports["default"] = module.exports;
});

unwrapExports(nonIterableSpread);

var toConsumableArray = createCommonjsModule(function (module) {
function _toConsumableArray(arr) {
  return arrayWithoutHoles(arr) || iterableToArray(arr) || unsupportedIterableToArray(arr) || nonIterableSpread();
}

module.exports = _toConsumableArray, module.exports.__esModule = true, module.exports["default"] = module.exports;
});

var _toConsumableArray = unwrapExports(toConsumableArray);

/* eslint-disable no-console, local-rules/disallow-side-effects */
/**
 * Keep references on console methods to avoid triggering patched behaviors
 *
 * NB: in some setup, console could already be patched by another SDK.
 * In this case, some display messages can be sent by the other SDK
 * but we should be safe from infinite loop nonetheless.
 */
var display = {
    log: console.log.bind(console),
    warn: console.warn.bind(console),
    error: console.error.bind(console),
};

var UNKNOWN_FUNCTION = '?';
/**
 * Computes a stack trace for an exception.
 */
function computeStackTrace(ex) {
    var stack = [];
    var stackProperty = tryToGetString(ex, 'stack');
    if (stackProperty) {
        stackProperty.split('\n').forEach(function (line) {
            var stackFrame = parseChromeLine(line) || parseWinLine(line) || parseGeckoLine(line);
            if (stackFrame) {
                if (!stackFrame.func && stackFrame.line) {
                    stackFrame.func = UNKNOWN_FUNCTION;
                }
                stack.push(stackFrame);
            }
        });
    }
    return {
        message: tryToGetString(ex, 'message'),
        name: tryToGetString(ex, 'name'),
        stack: stack,
    };
}
var CHROME_LINE_RE = 
// eslint-disable-next-line max-len
/^\s*at (.*?) ?\(((?:file|https?|blob|chrome-extension|native|eval|webpack|<anonymous>|\/).*?)(?::(\d+))?(?::(\d+))?\)?\s*$/i;
var CHROME_EVAL_RE = /\((\S*)(?::(\d+))(?::(\d+))\)/;
function parseChromeLine(line) {
    var parts = CHROME_LINE_RE.exec(line);
    if (!parts) {
        return;
    }
    var isNative = parts[2] && parts[2].indexOf('native') === 0; // start of line
    var isEval = parts[2] && parts[2].indexOf('eval') === 0; // start of line
    var submatch = CHROME_EVAL_RE.exec(parts[2]);
    if (isEval && submatch) {
        // throw out eval line/column and use top-most line/column number
        parts[2] = submatch[1]; // url
        parts[3] = submatch[2]; // line
        parts[4] = submatch[3]; // column
    }
    return {
        args: isNative ? [parts[2]] : [],
        column: parts[4] ? +parts[4] : undefined,
        func: parts[1] || UNKNOWN_FUNCTION,
        line: parts[3] ? +parts[3] : undefined,
        url: !isNative ? parts[2] : undefined,
    };
}
var WINJS_LINE_RE = /^\s*at (?:((?:\[object object\])?.+) )?\(?((?:file|ms-appx|https?|webpack|blob):.*?):(\d+)(?::(\d+))?\)?\s*$/i;
function parseWinLine(line) {
    var parts = WINJS_LINE_RE.exec(line);
    if (!parts) {
        return;
    }
    return {
        args: [],
        column: parts[4] ? +parts[4] : undefined,
        func: parts[1] || UNKNOWN_FUNCTION,
        line: +parts[3],
        url: parts[2],
    };
}
var GECKO_LINE_RE = 
// eslint-disable-next-line max-len
/^\s*(.*?)(?:\((.*?)\))?(?:^|@)((?:file|https?|blob|chrome|webpack|resource|capacitor|\[native).*?|[^@]*bundle)(?::(\d+))?(?::(\d+))?\s*$/i;
var GECKO_EVAL_RE = /(\S+) line (\d+)(?: > eval line \d+)* > eval/i;
function parseGeckoLine(line) {
    var parts = GECKO_LINE_RE.exec(line);
    if (!parts) {
        return;
    }
    var isEval = parts[3] && parts[3].indexOf(' > eval') > -1;
    var submatch = GECKO_EVAL_RE.exec(parts[3]);
    if (isEval && submatch) {
        // throw out eval line/column and use top-most line number
        parts[3] = submatch[1];
        parts[4] = submatch[2];
        parts[5] = undefined; // no column when eval
    }
    return {
        args: parts[2] ? parts[2].split(',') : [],
        column: parts[5] ? +parts[5] : undefined,
        func: parts[1] || UNKNOWN_FUNCTION,
        line: parts[4] ? +parts[4] : undefined,
        url: parts[3],
    };
}
function tryToGetString(candidate, property) {
    if (typeof candidate !== 'object' || !candidate || !(property in candidate)) {
        return undefined;
    }
    var value = candidate[property];
    return typeof value === 'string' ? value : undefined;
}

function instrumentMethod(object, method, instrumentationFactory) {
    var original = object[method];
    var instrumentation = instrumentationFactory(original);
    var instrumentationWrapper = function () {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-return
        return instrumentation.apply(this, arguments);
    };
    object[method] = instrumentationWrapper;
    return {
        stop: function () {
            if (object[method] === instrumentationWrapper) {
                object[method] = original;
            }
            else {
                instrumentation = original;
            }
        },
    };
}
function instrumentMethodAndCallOriginal(object, method, _a) {
    var before = _a.before, after = _a.after;
    return instrumentMethod(object, method, function (original) {
        return function () {
            var args = arguments;
            var result;
            if (before) {
                callMonitored(before, this, args);
            }
            if (typeof original === 'function') {
                // eslint-disable-next-line @typescript-eslint/no-unsafe-call
                result = original.apply(this, args);
            }
            if (after) {
                callMonitored(after, this, args);
            }
            // eslint-disable-next-line @typescript-eslint/no-unsafe-return
            return result;
        };
    });
}

// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Error#Error_types
var ERROR_TYPES_RE = /^(?:[Uu]ncaught (?:exception: )?)?(?:((?:Eval|Internal|Range|Reference|Syntax|Type|URI|)Error): )?(.*)$/;
/**
 * Cross-browser collection of unhandled errors
 *
 * Supports:
 * - Firefox: full stack trace with line numbers, plus column number
 * on top frame; column number is not guaranteed
 * - Opera: full stack trace with line and column numbers
 * - Chrome: full stack trace with line and column numbers
 * - Safari: line and column number for the top frame only; some frames
 * may be missing, and column number is not guaranteed
 * - IE: line and column number for the top frame only; some frames
 * may be missing, and column number is not guaranteed
 *
 * In theory, TraceKit should work on all of the following versions:
 * - IE5.5+ (only 8.0 tested)
 * - Firefox 0.9+ (only 3.5+ tested)
 * - Opera 7+ (only 10.50 tested; versions 9 and earlier may require
 * Exceptions Have Stacktrace to be enabled in opera:config)
 * - Safari 3+ (only 4+ tested)
 * - Chrome 1+ (only 5+ tested)
 * - Konqueror 3.5+ (untested)
 *
 * Tries to catch all unhandled errors and report them to the
 * callback.
 *
 * Callbacks receive a StackTrace object as described in the
 * computeStackTrace docs.
 *
 * @memberof TraceKit
 * @namespace
 */
function startUnhandledErrorCollection(callback) {
    var stopInstrumentingOnError = instrumentOnError(callback).stop;
    var stopInstrumentingOnUnhandledRejection = instrumentUnhandledRejection(callback).stop;
    return {
        stop: function () {
            stopInstrumentingOnError();
            stopInstrumentingOnUnhandledRejection();
        },
    };
}
/**
 * Install a global onerror handler
 */
function instrumentOnError(callback) {
    return instrumentMethodAndCallOriginal(window, 'onerror', {
        before: function (message, url, lineNo, columnNo, errorObj) {
            var stack;
            if (errorObj) {
                stack = computeStackTrace(errorObj);
                callback(stack, errorObj);
            }
            else {
                var location_1 = {
                    url: url,
                    column: columnNo,
                    line: lineNo,
                };
                var name_1;
                var msg = message;
                if ({}.toString.call(message) === '[object String]') {
                    var groups = ERROR_TYPES_RE.exec(msg);
                    if (groups) {
                        name_1 = groups[1];
                        msg = groups[2];
                    }
                }
                stack = {
                    name: name_1,
                    message: typeof msg === 'string' ? msg : undefined,
                    stack: [location_1],
                };
                callback(stack, message);
            }
        },
    });
}
/**
 * Install a global onunhandledrejection handler
 */
function instrumentUnhandledRejection(callback) {
    return instrumentMethodAndCallOriginal(window, 'onunhandledrejection', {
        before: function (e) {
            var reason = e.reason || 'Empty reason';
            var stack = computeStackTrace(reason);
            callback(stack, reason);
        },
    });
}

var ErrorSource = {
    AGENT: 'agent',
    CONSOLE: 'console',
    CUSTOM: 'custom',
    LOGGER: 'logger',
    NETWORK: 'network',
    SOURCE: 'source',
    REPORT: 'report',
};
function formatUnknownError(stackTrace, errorObject, nonErrorPrefix, handlingStack) {
    if (!stackTrace || (stackTrace.message === undefined && !(errorObject instanceof Error))) {
        return {
            message: "".concat(nonErrorPrefix, " ").concat(jsonStringify(errorObject)),
            stack: 'No stack, consider using an instance of Error',
            handlingStack: handlingStack,
            type: stackTrace && stackTrace.name,
        };
    }
    return {
        message: stackTrace.message || 'Empty message',
        stack: toStackTraceString(stackTrace),
        handlingStack: handlingStack,
        type: stackTrace.name,
    };
}
function toStackTraceString(stack) {
    var result = formatErrorMessage(stack);
    stack.stack.forEach(function (frame) {
        var func = frame.func === '?' ? '<anonymous>' : frame.func;
        var args = frame.args && frame.args.length > 0 ? "(".concat(frame.args.join(', '), ")") : '';
        var line = frame.line ? ":".concat(frame.line) : '';
        var column = frame.line && frame.column ? ":".concat(frame.column) : '';
        result += "\n  at ".concat(func).concat(args, " @ ").concat(frame.url).concat(line).concat(column);
    });
    return result;
}
function formatErrorMessage(stack) {
    return "".concat(stack.name || 'Error', ": ").concat(stack.message);
}
/**
 Creates a stacktrace without SDK internal frames.
 
 Constraints:
 - Has to be called at the utmost position of the call stack.
 - No internal monitoring should encapsulate the function, that is why we need to use callMonitored inside of it.
 */
function createHandlingStack() {
    /**
     * Skip the two internal frames:
     * - SDK API (console.error, ...)
     * - this function
     * in order to keep only the user calls
     */
    var internalFramesToSkip = 2;
    var error = new Error();
    var formattedStack;
    // IE needs to throw the error to fill in the stack trace
    if (!error.stack) {
        try {
            throw error;
        }
        catch (e) {
        }
    }
    callMonitored(function () {
        var stackTrace = computeStackTrace(error);
        stackTrace.stack = stackTrace.stack.slice(internalFramesToSkip);
        formattedStack = toStackTraceString(stackTrace);
    });
    return formattedStack;
}

var Observable = /** @class */ (function () {
    function Observable(onFirstSubscribe) {
        this.onFirstSubscribe = onFirstSubscribe;
        this.observers = [];
    }
    Observable.prototype.subscribe = function (f) {
        var _this = this;
        if (!this.observers.length && this.onFirstSubscribe) {
            this.onLastUnsubscribe = this.onFirstSubscribe() || undefined;
        }
        this.observers.push(f);
        return {
            unsubscribe: function () {
                _this.observers = _this.observers.filter(function (other) { return f !== other; });
                if (!_this.observers.length && _this.onLastUnsubscribe) {
                    _this.onLastUnsubscribe();
                }
            },
        };
    };
    Observable.prototype.notify = function (data) {
        this.observers.forEach(function (observer) { return observer(data); });
    };
    return Observable;
}());
function mergeObservables() {
    var observables = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        observables[_i] = arguments[_i];
    }
    var globalObservable = new Observable(function () {
        var subscriptions = observables.map(function (observable) {
            return observable.subscribe(function (data) { return globalObservable.notify(data); });
        });
        return function () { return subscriptions.forEach(function (subscription) { return subscription.unsubscribe(); }); };
    });
    return globalObservable;
}

function relativeToClocks(relative) {
    return { relative: relative, timeStamp: getCorrectedTimeStamp(relative) };
}
function getCorrectedTimeStamp(relativeTime) {
    var correctedOrigin = Date.now() - performance.now();
    // apply correction only for positive drift
    if (correctedOrigin > getNavigationStart()) {
        // eslint-disable-next-line @typescript-eslint/restrict-plus-operands
        return Math.round(correctedOrigin + relativeTime);
    }
    return getTimeStamp(relativeTime);
}
function currentDrift() {
    // eslint-disable-next-line @typescript-eslint/restrict-plus-operands
    return Math.round(Date.now() - (getNavigationStart() + performance.now()));
}
function toServerDuration(duration) {
    if (!isNumber(duration)) {
        return duration;
    }
    return round(duration * 1e6, 0);
}
function timeStampNow() {
    return Date.now();
}
function relativeNow() {
    return performance.now();
}
function clocksNow() {
    return { relative: relativeNow(), timeStamp: timeStampNow() };
}
function clocksOrigin() {
    return { relative: 0, timeStamp: getNavigationStart() };
}
function elapsed(start, end) {
    return (end - start);
}
/**
 * Get the time since the navigation was started.
 *
 * Note: this does not use `performance.timeOrigin` because it doesn't seem to reflect the actual
 * time on which the navigation has started: it may be much farther in the past, at least in Firefox 71.
 * Related issue in Firefox: https://bugzilla.mozilla.org/show_bug.cgi?id=1429926
 */
function getRelativeTime(timestamp) {
    return (timestamp - getNavigationStart());
}
function getTimeStamp(relativeTime) {
    // eslint-disable-next-line @typescript-eslint/restrict-plus-operands
    return Math.round(getNavigationStart() + relativeTime);
}
function looksLikeRelativeTime(time) {
    return time < ONE_YEAR;
}
/**
 * Navigation start slightly change on some rare cases
 */
var navigationStart;
function getNavigationStart() {
    if (navigationStart === undefined) {
        navigationStart = performance.timing.navigationStart;
    }
    return navigationStart;
}

var monitoringConfiguration = { maxMessagesPerPage: 0, sentMessageCount: 0 };
var onInternalMonitoringMessageCollected;
function startInternalMonitoring(configuration) {
    var externalContextProvider;
    var telemetryContextProvider;
    var monitoringMessageObservable = new Observable();
    var telemetryEventObservable = new Observable();
    onInternalMonitoringMessageCollected = function (message) {
        monitoringMessageObservable.notify(withContext(message));
        if (isExperimentalFeatureEnabled('telemetry')) {
            telemetryEventObservable.notify(toTelemetryEvent(message));
        }
    };
    assign(monitoringConfiguration, {
        maxMessagesPerPage: configuration.maxInternalMonitoringMessagesPerPage,
        sentMessageCount: 0,
    });
    function withContext(message) {
        return combine({ date: timeStampNow() }, externalContextProvider !== undefined ? externalContextProvider() : {}, message);
    }
    function toTelemetryEvent(message) {
        return combine({
            date: timeStampNow(),
            service: 'browser-sdk',
            version: "4.6.1",
            _dd: {
                event_type: 'internal_telemetry',
            },
        }, telemetryContextProvider !== undefined ? telemetryContextProvider() : {}, message);
    }
    return {
        setExternalContextProvider: function (provider) {
            externalContextProvider = provider;
        },
        monitoringMessageObservable: monitoringMessageObservable,
        setTelemetryContextProvider: function (provider) {
            telemetryContextProvider = provider;
        },
        telemetryEventObservable: telemetryEventObservable,
    };
}
function monitor(fn) {
    return function () {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-return
        return callMonitored(fn, this, arguments);
    }; // consider output type has input type
}
function callMonitored(fn, context, args) {
    try {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-return
        return fn.apply(context, args);
    }
    catch (e) {
        logErrorIfDebug(e);
        try {
            addMonitoringError(e);
        }
        catch (e) {
            logErrorIfDebug(e);
        }
    }
}
function addMonitoringMessage(message, context) {
    logMessageIfDebug(message, context);
    addToMonitoring(assign({
        message: message,
        status: "debug" /* debug */,
    }, context));
}
function addMonitoringError(e) {
    addToMonitoring(assign({
        status: "error" /* error */,
    }, formatError(e)));
}
function addToMonitoring(message) {
    if (onInternalMonitoringMessageCollected &&
        monitoringConfiguration.sentMessageCount < monitoringConfiguration.maxMessagesPerPage) {
        monitoringConfiguration.sentMessageCount += 1;
        onInternalMonitoringMessageCollected(message);
    }
}
function formatError(e) {
    if (e instanceof Error) {
        var stackTrace = computeStackTrace(e);
        return {
            error: {
                kind: stackTrace.name,
                stack: toStackTraceString(stackTrace),
            },
            message: stackTrace.message,
        };
    }
    return {
        error: {
            stack: 'Not an instance of error',
        },
        message: "Uncaught ".concat(jsonStringify(e)),
    };
}
function setDebugMode(debugMode) {
    monitoringConfiguration.debugMode = debugMode;
}
function logErrorIfDebug(e) {
    if (monitoringConfiguration.debugMode) {
        display.error('[INTERNAL ERROR]', e);
    }
}
function logMessageIfDebug(message, context) {
    if (monitoringConfiguration.debugMode) {
        display.log('[MONITORING MESSAGE]', message, context);
    }
}

var ONE_SECOND = 1000;
var ONE_MINUTE = 60 * ONE_SECOND;
var ONE_HOUR = 60 * ONE_MINUTE;
var ONE_DAY = 24 * ONE_HOUR;
var ONE_YEAR = 365 * ONE_DAY;
var ONE_KILO_BYTE = 1024;
// use lodash API
function throttle(fn, wait, options) {
    var needLeadingExecution = options && options.leading !== undefined ? options.leading : true;
    var needTrailingExecution = options && options.trailing !== undefined ? options.trailing : true;
    var inWaitPeriod = false;
    var pendingExecutionWithParameters;
    var pendingTimeoutId;
    return {
        throttled: function () {
            var parameters = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                parameters[_i] = arguments[_i];
            }
            if (inWaitPeriod) {
                pendingExecutionWithParameters = parameters;
                return;
            }
            if (needLeadingExecution) {
                fn.apply(void 0, parameters);
            }
            else {
                pendingExecutionWithParameters = parameters;
            }
            inWaitPeriod = true;
            pendingTimeoutId = setTimeout(function () {
                if (needTrailingExecution && pendingExecutionWithParameters) {
                    fn.apply(void 0, pendingExecutionWithParameters);
                }
                inWaitPeriod = false;
                pendingExecutionWithParameters = undefined;
            }, wait);
        },
        cancel: function () {
            clearTimeout(pendingTimeoutId);
            inWaitPeriod = false;
            pendingExecutionWithParameters = undefined;
        },
    };
}
function assign(target) {
    var toAssign = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        toAssign[_i - 1] = arguments[_i];
    }
    toAssign.forEach(function (source) {
        for (var key in source) {
            if (Object.prototype.hasOwnProperty.call(source, key)) {
                target[key] = source[key];
            }
        }
    });
    return target;
}
function shallowClone(object) {
    return assign({}, object);
}
/**
 * UUID v4
 * from https://gist.github.com/jed/982883
 */
function generateUUID(placeholder) {
    return placeholder
        ? // eslint-disable-next-line  no-bitwise
            (parseInt(placeholder, 10) ^ ((Math.random() * 16) >> (parseInt(placeholder, 10) / 4))).toString(16)
        : "".concat(1e7, "-").concat(1e3, "-").concat(4e3, "-").concat(8e3, "-").concat(1e11).replace(/[018]/g, generateUUID);
}
/**
 * Return true if the draw is successful
 * @param threshold between 0 and 100
 */
function performDraw(threshold) {
    return threshold !== 0 && Math.random() * 100 <= threshold;
}
function round(num, decimals) {
    return +num.toFixed(decimals);
}
// eslint-disable-next-line @typescript-eslint/no-empty-function
function noop() { }
/**
 * Custom implementation of JSON.stringify that ignores value.toJSON.
 * We need to do that because some sites badly override toJSON on certain objects.
 * Note this still supposes that JSON.stringify is correct...
 */
function jsonStringify(value, replacer, space) {
    if (value === null || value === undefined) {
        return JSON.stringify(value);
    }
    var originalToJSON = [false, undefined];
    if (hasToJSON(value)) {
        // We need to add a flag and not rely on the truthiness of value.toJSON
        // because it can be set but undefined and that's actually significant.
        originalToJSON = [true, value.toJSON];
        delete value.toJSON;
    }
    var originalProtoToJSON = [false, undefined];
    var prototype;
    if (typeof value === 'object') {
        prototype = Object.getPrototypeOf(value);
        if (hasToJSON(prototype)) {
            originalProtoToJSON = [true, prototype.toJSON];
            delete prototype.toJSON;
        }
    }
    var result;
    try {
        result = JSON.stringify(value, replacer, space);
    }
    catch (_a) {
        result = '<error: unable to serialize object>';
    }
    finally {
        if (originalToJSON[0]) {
            value.toJSON = originalToJSON[1];
        }
        if (originalProtoToJSON[0]) {
            prototype.toJSON = originalProtoToJSON[1];
        }
    }
    return result;
}
function hasToJSON(value) {
    return typeof value === 'object' && value !== null && Object.prototype.hasOwnProperty.call(value, 'toJSON');
}
function includes(candidate, search) {
    return candidate.indexOf(search) !== -1;
}
function find(array, predicate) {
    for (var i = 0; i < array.length; i += 1) {
        var item = array[i];
        if (predicate(item, i, array)) {
            return item;
        }
    }
    return undefined;
}
function findLast(array, predicate) {
    for (var i = array.length - 1; i >= 0; i -= 1) {
        var item = array[i];
        if (predicate(item, i, array)) {
            return item;
        }
    }
    return undefined;
}
function isPercentage(value) {
    return isNumber(value) && value >= 0 && value <= 100;
}
function isNumber(value) {
    return typeof value === 'number';
}
function objectValues(object) {
    return Object.keys(object).map(function (key) { return object[key]; });
}
function objectHasValue(object, value) {
    return Object.keys(object).some(function (key) { return object[key] === value; });
}
function objectEntries(object) {
    return Object.keys(object).map(function (key) { return [key, object[key]]; });
}
function isEmptyObject(object) {
    return Object.keys(object).length === 0;
}
function mapValues(object, fn) {
    var newObject = {};
    for (var _i = 0, _a = Object.keys(object); _i < _a.length; _i++) {
        var key = _a[_i];
        newObject[key] = fn(object[key]);
    }
    return newObject;
}
/**
 * inspired by https://mathiasbynens.be/notes/globalthis
 */
function getGlobalObject() {
    if (typeof globalThis === 'object') {
        return globalThis;
    }
    Object.defineProperty(Object.prototype, '_dd_temp_', {
        get: function () {
            return this;
        },
        configurable: true,
    });
    // @ts-ignore _dd_temp is defined using defineProperty
    var globalObject = _dd_temp_;
    // @ts-ignore _dd_temp is defined using defineProperty
    delete Object.prototype._dd_temp_;
    if (typeof globalObject !== 'object') {
        // on safari _dd_temp_ is available on window but not globally
        // fallback on other browser globals check
        if (typeof self === 'object') {
            globalObject = self;
        }
        else if (typeof window === 'object') {
            globalObject = window;
        }
        else {
            globalObject = {};
        }
    }
    return globalObject;
}
function getLocationOrigin() {
    return getLinkElementOrigin(window.location);
}
/**
 * IE fallback
 * https://developer.mozilla.org/en-US/docs/Web/API/HTMLHyperlinkElementUtils/origin
 */
function getLinkElementOrigin(element) {
    if (element.origin) {
        return element.origin;
    }
    var sanitizedHost = element.host.replace(/(:80|:443)$/, '');
    return "".concat(element.protocol, "//").concat(sanitizedHost);
}
function findCommaSeparatedValue(rawString, name) {
    var regex = new RegExp("(?:^|;)\\s*".concat(name, "\\s*=\\s*([^;]+)"));
    var matches = regex.exec(rawString);
    return matches ? matches[1] : undefined;
}
function safeTruncate(candidate, length, suffix) {
    if (suffix === void 0) { suffix = ''; }
    var lastChar = candidate.charCodeAt(length - 1);
    var isLastCharSurrogatePair = lastChar >= 0xd800 && lastChar <= 0xdbff;
    var correctedLength = isLastCharSurrogatePair ? length + 1 : length;
    if (candidate.length <= correctedLength)
        return candidate;
    return "".concat(candidate.slice(0, correctedLength)).concat(suffix);
}
/**
 * Add an event listener to an event emitter object (Window, Element, mock object...).  This provides
 * a few conveniences compared to using `element.addEventListener` directly:
 *
 * * supports IE11 by: using an option object only if needed and emulating the `once` option
 *
 * * wraps the listener with a `monitor` function
 *
 * * returns a `stop` function to remove the listener
 */
function addEventListener(emitter, event, listener, options) {
    return addEventListeners(emitter, [event], listener, options);
}
/**
 * Add event listeners to an event emitter object (Window, Element, mock object...).  This provides
 * a few conveniences compared to using `element.addEventListener` directly:
 *
 * * supports IE11 by: using an option object only if needed and emulating the `once` option
 *
 * * wraps the listener with a `monitor` function
 *
 * * returns a `stop` function to remove the listener
 *
 * * with `once: true`, the listener will be called at most once, even if different events are listened
 */
function addEventListeners(emitter, events, listener, _a) {
    var _b = _a === void 0 ? {} : _a, once = _b.once, capture = _b.capture, passive = _b.passive;
    var wrappedListener = monitor(once
        ? function (event) {
            stop();
            listener(event);
        }
        : listener);
    var options = passive ? { capture: capture, passive: passive } : capture;
    events.forEach(function (event) { return emitter.addEventListener(event, wrappedListener, options); });
    var stop = function () { return events.forEach(function (event) { return emitter.removeEventListener(event, wrappedListener, options); }); };
    return {
        stop: stop,
    };
}
function runOnReadyState(expectedReadyState, callback) {
    if (document.readyState === expectedReadyState || document.readyState === 'complete') {
        callback();
    }
    else {
        var eventName = expectedReadyState === 'complete' ? "load" /* LOAD */ : "DOMContentLoaded" /* DOM_CONTENT_LOADED */;
        addEventListener(window, eventName, callback, { once: true });
    }
}
/**
 * Similar to `typeof`, but distinguish plain objects from `null` and arrays
 */
function getType(value) {
    if (value === null) {
        return 'null';
    }
    if (Array.isArray(value)) {
        return 'array';
    }
    return typeof value;
}
function createCircularReferenceChecker() {
    if (typeof WeakSet !== 'undefined') {
        var set_1 = new WeakSet();
        return {
            hasAlreadyBeenSeen: function (value) {
                var has = set_1.has(value);
                if (!has) {
                    set_1.add(value);
                }
                return has;
            },
        };
    }
    var array = [];
    return {
        hasAlreadyBeenSeen: function (value) {
            var has = array.indexOf(value) >= 0;
            if (!has) {
                array.push(value);
            }
            return has;
        },
    };
}
/**
 * Iterate over source and affect its sub values into destination, recursively.
 * If the source and destination can't be merged, return source.
 */
function mergeInto(destination, source, circularReferenceChecker) {
    if (circularReferenceChecker === void 0) { circularReferenceChecker = createCircularReferenceChecker(); }
    // ignore the source if it is undefined
    if (source === undefined) {
        return destination;
    }
    if (typeof source !== 'object' || source === null) {
        // primitive values - just return source
        return source;
    }
    else if (source instanceof Date) {
        return new Date(source.getTime());
    }
    else if (source instanceof RegExp) {
        var flags = source.flags ||
            // old browsers compatibility
            [
                source.global ? 'g' : '',
                source.ignoreCase ? 'i' : '',
                source.multiline ? 'm' : '',
                source.sticky ? 'y' : '',
                source.unicode ? 'u' : '',
            ].join('');
        return new RegExp(source.source, flags);
    }
    if (circularReferenceChecker.hasAlreadyBeenSeen(source)) {
        // remove circular references
        return undefined;
    }
    else if (Array.isArray(source)) {
        var merged_1 = Array.isArray(destination) ? destination : [];
        for (var i = 0; i < source.length; ++i) {
            merged_1[i] = mergeInto(merged_1[i], source[i], circularReferenceChecker);
        }
        return merged_1;
    }
    var merged = getType(destination) === 'object' ? destination : {};
    for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
            merged[key] = mergeInto(merged[key], source[key], circularReferenceChecker);
        }
    }
    return merged;
}
/**
 * A simplistic implementation of a deep clone algorithm.
 * Caveats:
 * - It doesn't maintain prototype chains - don't use with instances of custom classes.
 * - It doesn't handle Map and Set
 */
function deepClone(value) {
    return mergeInto(undefined, value);
}
function combine() {
    var sources = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        sources[_i] = arguments[_i];
    }
    var destination;
    for (var _a = 0, sources_1 = sources; _a < sources_1.length; _a++) {
        var source = sources_1[_a];
        // Ignore any undefined or null sources.
        if (source === undefined || source === null) {
            continue;
        }
        destination = mergeInto(destination, source);
    }
    return destination;
}
function requestIdleCallback(callback, opts) {
    // Use 'requestIdleCallback' when available: it will throttle the mutation processing if the
    // browser is busy rendering frames (ex: when frames are below 60fps). When not available, the
    // fallback on 'requestAnimationFrame' will still ensure the mutations are processed after any
    // browser rendering process (Layout, Recalculate Style, etc.), so we can serialize DOM nodes
    // efficiently.
    if (window.requestIdleCallback) {
        var id_1 = window.requestIdleCallback(monitor(callback), opts);
        return function () { return window.cancelIdleCallback(id_1); };
    }
    var id = window.requestAnimationFrame(monitor(callback));
    return function () { return window.cancelAnimationFrame(id); };
}

var COOKIE_ACCESS_DELAY = ONE_SECOND;
function setCookie(name, value, expireDelay, options) {
    var date = new Date();
    date.setTime(date.getTime() + expireDelay);
    var expires = "expires=".concat(date.toUTCString());
    var sameSite = options && options.crossSite ? 'none' : 'strict';
    var domain = options && options.domain ? ";domain=".concat(options.domain) : '';
    var secure = options && options.secure ? ';secure' : '';
    document.cookie = "".concat(name, "=").concat(value, ";").concat(expires, ";path=/;samesite=").concat(sameSite).concat(domain).concat(secure);
}
function getCookie(name) {
    return findCommaSeparatedValue(document.cookie, name);
}
function deleteCookie(name, options) {
    setCookie(name, '', 0, options);
}
function areCookiesAuthorized(options) {
    if (document.cookie === undefined || document.cookie === null) {
        return false;
    }
    try {
        // Use a unique cookie name to avoid issues when the SDK is initialized multiple times during
        // the test cookie lifetime
        var testCookieName = "dd_cookie_test_".concat(generateUUID());
        var testCookieValue = 'test';
        setCookie(testCookieName, testCookieValue, ONE_SECOND, options);
        var isCookieCorrectlySet = getCookie(testCookieName) === testCookieValue;
        deleteCookie(testCookieName, options);
        return isCookieCorrectlySet;
    }
    catch (error) {
        display.error(error);
        return false;
    }
}
/**
 * No API to retrieve it, number of levels for subdomain and suffix are unknown
 * strategy: find the minimal domain on which cookies are allowed to be set
 * https://web.dev/same-site-same-origin/#site
 */
var getCurrentSiteCache;
function getCurrentSite() {
    if (getCurrentSiteCache === undefined) {
        // Use a unique cookie name to avoid issues when the SDK is initialized multiple times during
        // the test cookie lifetime
        var testCookieName = "dd_site_test_".concat(generateUUID());
        var testCookieValue = 'test';
        var domainLevels = window.location.hostname.split('.');
        var candidateDomain = domainLevels.pop();
        while (domainLevels.length && !getCookie(testCookieName)) {
            candidateDomain = "".concat(domainLevels.pop(), ".").concat(candidateDomain);
            setCookie(testCookieName, testCookieValue, ONE_SECOND, { domain: candidateDomain });
        }
        deleteCookie(testCookieName, { domain: candidateDomain });
        getCurrentSiteCache = candidateDomain;
    }
    return getCurrentSiteCache;
}

function catchUserErrors(fn, errorMsg) {
    return function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        try {
            return fn.apply(void 0, args);
        }
        catch (err) {
            display.error(errorMsg, err);
        }
    };
}

/**
 * LIMITATION:
 * For NPM setup, this feature flag singleton is shared between RUM and Logs product.
 * This means that an experimental flag set on the RUM product will be set on the Logs product.
 * So keep in mind that in certain configurations, your experimental feature flag may affect other products.
 */
var enabledExperimentalFeatures;
function updateExperimentalFeatures(enabledFeatures) {
    // Safely handle external data
    if (!Array.isArray(enabledFeatures)) {
        return;
    }
    if (!enabledExperimentalFeatures) {
        enabledExperimentalFeatures = new Set(enabledFeatures);
    }
    enabledFeatures
        .filter(function (flag) { return typeof flag === 'string'; })
        .forEach(function (flag) {
        enabledExperimentalFeatures.add(flag);
    });
}
function isExperimentalFeatureEnabled(featureName) {
    return !!enabledExperimentalFeatures && enabledExperimentalFeatures.has(featureName);
}

function normalizeUrl(url) {
    return buildUrl(url, getLocationOrigin()).href;
}
function isValidUrl(url) {
    try {
        return !!buildUrl(url);
    }
    catch (_a) {
        return false;
    }
}
function getOrigin(url) {
    return getLinkElementOrigin(buildUrl(url));
}
function getPathName(url) {
    var pathname = buildUrl(url).pathname;
    return pathname[0] === '/' ? pathname : "/".concat(pathname);
}
function buildUrl(url, base) {
    if (checkURLSupported()) {
        return base !== undefined ? new URL(url, base) : new URL(url);
    }
    if (base === undefined && !/:/.test(url)) {
        throw new Error("Invalid URL: '".concat(url, "'"));
    }
    var doc = document;
    var anchorElement = doc.createElement('a');
    if (base !== undefined) {
        doc = document.implementation.createHTMLDocument('');
        var baseElement = doc.createElement('base');
        baseElement.href = base;
        doc.head.appendChild(baseElement);
        doc.body.appendChild(anchorElement);
    }
    anchorElement.href = url;
    return anchorElement;
}
var isURLSupported;
function checkURLSupported() {
    if (isURLSupported !== undefined) {
        return isURLSupported;
    }
    try {
        var url = new URL('http://test/path');
        isURLSupported = url.href === 'http://test/path';
        return isURLSupported;
    }
    catch (_a) {
        isURLSupported = false;
    }
    return isURLSupported;
}

var ENDPOINTS = {
    logs: 'logs',
    rum: 'rum',
    sessionReplay: 'session-replay',
};
var INTAKE_TRACKS = {
    logs: 'logs',
    rum: 'rum',
    sessionReplay: 'replay',
};
var INTAKE_SITE_US = 'datadoghq.com';
function createEndpointBuilder(initConfiguration, endpointType, tags, source) {
    var _a = initConfiguration.site, site = _a === void 0 ? INTAKE_SITE_US : _a, clientToken = initConfiguration.clientToken;
    var domainParts = site.split('.');
    var extension = domainParts.pop();
    var host = "".concat(ENDPOINTS[endpointType], ".browser-intake-").concat(domainParts.join('-'), ".").concat(extension);
    var baseUrl = "https://".concat(host, "/api/v2/").concat(INTAKE_TRACKS[endpointType]);
    var proxyUrl = initConfiguration.proxyUrl && normalizeUrl(initConfiguration.proxyUrl);
    return {
        build: function () {
            var parameters = "ddsource=".concat(source || 'browser') +
                "&ddtags=".concat(encodeURIComponent(["sdk_version:".concat("4.6.1")].concat(tags).join(','))) +
                "&dd-api-key=".concat(clientToken) +
                "&dd-evp-origin-version=".concat(encodeURIComponent("4.6.1")) +
                '&dd-evp-origin=browser' +
                "&dd-request-id=".concat(generateUUID());
            if (endpointType === 'rum') {
                parameters += "&batch_time=".concat(timeStampNow());
            }
            var endpointUrl = "".concat(baseUrl, "?").concat(parameters);
            return proxyUrl ? "".concat(proxyUrl, "?ddforward=").concat(encodeURIComponent(endpointUrl)) : endpointUrl;
        },
        buildIntakeUrl: function () {
            return proxyUrl ? "".concat(proxyUrl, "?ddforward") : baseUrl;
        },
    };
}

var TAG_SIZE_LIMIT = 200;
function buildTags(configuration) {
    var env = configuration.env, service = configuration.service, version = configuration.version, datacenter = configuration.datacenter;
    var tags = [];
    if (env) {
        tags.push(buildTag('env', env));
    }
    if (service) {
        tags.push(buildTag('service', service));
    }
    if (version) {
        tags.push(buildTag('version', version));
    }
    if (datacenter) {
        tags.push(buildTag('datacenter', datacenter));
    }
    return tags;
}
var FORBIDDEN_CHARACTERS = /[^a-z0-9_:./-]/;
function buildTag(key, rawValue) {
    // See https://docs.datadoghq.com/getting_started/tagging/#defining-tags for tags syntax. Note
    // that the backend may not follow the exact same rules, so we only want to display an informal
    // warning.
    var valueSizeLimit = TAG_SIZE_LIMIT - key.length - 1;
    if (rawValue.length > valueSizeLimit || FORBIDDEN_CHARACTERS.test(rawValue)) {
        display.warn("".concat(key, " value doesn't meet tag requirements and will be sanitized"));
    }
    // Let the backend do most of the sanitization, but still make sure multiple tags can't be crafted
    // by forging a value containing commas.
    var sanitizedValue = rawValue.replace(/,/g, '_');
    return "".concat(key, ":").concat(sanitizedValue);
}

function computeTransportConfiguration(initConfiguration) {
    var tags = buildTags(initConfiguration);
    var endpointBuilders = computeEndpointBuilders(initConfiguration, tags);
    var intakeEndpoints = objectValues(endpointBuilders).map(function (builder) { return builder.buildIntakeUrl(); });
    var replicaConfiguration = computeReplicaConfiguration(initConfiguration, intakeEndpoints, tags);
    return assign({
        isIntakeUrl: function (url) { return intakeEndpoints.some(function (intakeEndpoint) { return url.indexOf(intakeEndpoint) === 0; }); },
        replica: replicaConfiguration,
    }, endpointBuilders);
}
function computeEndpointBuilders(initConfiguration, tags) {
    var endpointBuilders = {
        logsEndpointBuilder: createEndpointBuilder(initConfiguration, 'logs', tags),
        rumEndpointBuilder: createEndpointBuilder(initConfiguration, 'rum', tags),
        sessionReplayEndpointBuilder: createEndpointBuilder(initConfiguration, 'sessionReplay', tags),
    };
    if (initConfiguration.internalMonitoringApiKey) {
        return assign(endpointBuilders, {
            internalMonitoringEndpointBuilder: createEndpointBuilder(assign({}, initConfiguration, { clientToken: initConfiguration.internalMonitoringApiKey }), 'logs', tags, 'browser-agent-internal-monitoring'),
        });
    }
    return endpointBuilders;
}
function computeReplicaConfiguration(initConfiguration, intakeEndpoints, tags) {
    if (!initConfiguration.replica) {
        return;
    }
    var replicaConfiguration = assign({}, initConfiguration, {
        site: INTAKE_SITE_US,
        clientToken: initConfiguration.replica.clientToken,
    });
    var replicaEndpointBuilders = {
        logsEndpointBuilder: createEndpointBuilder(replicaConfiguration, 'logs', tags),
        rumEndpointBuilder: createEndpointBuilder(replicaConfiguration, 'rum', tags),
        internalMonitoringEndpointBuilder: createEndpointBuilder(replicaConfiguration, 'logs', tags, 'browser-agent-internal-monitoring'),
    };
    intakeEndpoints.push.apply(intakeEndpoints, objectValues(replicaEndpointBuilders).map(function (builder) { return builder.buildIntakeUrl(); }));
    return assign({ applicationId: initConfiguration.replica.applicationId }, replicaEndpointBuilders);
}

var DefaultPrivacyLevel = {
    ALLOW: 'allow',
    MASK: 'mask',
    MASK_USER_INPUT: 'mask-user-input',
};
function validateAndBuildConfiguration(initConfiguration) {
    var _a;
    if (!initConfiguration || !initConfiguration.clientToken) {
        display.error('Client Token is not configured, we will not send any data.');
        return;
    }
    if (initConfiguration.sampleRate !== undefined && !isPercentage(initConfiguration.sampleRate)) {
        display.error('Sample Rate should be a number between 0 and 100');
        return;
    }
    // Set the experimental feature flags as early as possible, so we can use them in most places
    updateExperimentalFeatures(initConfiguration.enableExperimentalFeatures);
    return assign({
        beforeSend: initConfiguration.beforeSend && catchUserErrors(initConfiguration.beforeSend, 'beforeSend threw an error:'),
        cookieOptions: buildCookieOptions(initConfiguration),
        sampleRate: (_a = initConfiguration.sampleRate) !== null && _a !== void 0 ? _a : 100,
        service: initConfiguration.service,
        silentMultipleInit: !!initConfiguration.silentMultipleInit,
        /**
         * beacon payload max queue size implementation is 64kb
         * ensure that we leave room for logs, rum and potential other users
         */
        batchBytesLimit: 16 * ONE_KILO_BYTE,
        eventRateLimiterThreshold: 3000,
        maxInternalMonitoringMessagesPerPage: 15,
        /**
         * flush automatically, aim to be lower than ALB connection timeout
         * to maximize connection reuse.
         */
        flushTimeout: 30 * ONE_SECOND,
        /**
         * Logs intake limit
         */
        maxBatchSize: 50,
        maxMessageSize: 256 * ONE_KILO_BYTE,
    }, computeTransportConfiguration(initConfiguration));
}
function buildCookieOptions(initConfiguration) {
    var cookieOptions = {};
    cookieOptions.secure = mustUseSecureCookie(initConfiguration);
    cookieOptions.crossSite = !!initConfiguration.useCrossSiteSessionCookie;
    if (initConfiguration.trackSessionAcrossSubdomains) {
        cookieOptions.domain = getCurrentSite();
    }
    return cookieOptions;
}
function mustUseSecureCookie(initConfiguration) {
    return !!initConfiguration.useSecureSessionCookie || !!initConfiguration.useCrossSiteSessionCookie;
}

function trackRuntimeError(errorObservable) {
    return startUnhandledErrorCollection(function (stackTrace, errorObject) {
        var _a = formatUnknownError(stackTrace, errorObject, 'Uncaught'), stack = _a.stack, message = _a.message, type = _a.type;
        errorObservable.notify({
            message: message,
            stack: stack,
            type: type,
            source: ErrorSource.SOURCE,
            startClocks: clocksNow(),
            originalError: errorObject,
            handling: "unhandled" /* UNHANDLED */,
        });
    });
}

function makePublicApi(stub) {
    var publicApi = assign({
        version: "4.6.1",
        // This API method is intentionally not monitored, since the only thing executed is the
        // user-provided 'callback'.  All SDK usages executed in the callback should be monitored, and
        // we don't want to interfere with the user uncaught exceptions.
        onReady: function (callback) {
            callback();
        },
    }, stub);
    // Add a "hidden" property to set debug mode. We define it that way to hide it
    // as much as possible but of course it's not a real protection.
    Object.defineProperty(publicApi, '_setDebug', {
        get: function () {
            return setDebugMode;
        },
        enumerable: false,
    });
    return publicApi;
}
function defineGlobal(global, name, api) {
    var existingGlobalVariable = global[name];
    global[name] = api;
    if (existingGlobalVariable && existingGlobalVariable.q) {
        existingGlobalVariable.q.forEach(function (fn) { return catchUserErrors(fn, 'onReady callback threw an error:')(); });
    }
}

var RawReportType = {
    intervention: 'intervention',
    deprecation: 'deprecation',
    cspViolation: 'csp_violation',
};
function initReportObservable(apis) {
    var observables = [];
    if (includes(apis, RawReportType.cspViolation)) {
        observables.push(createCspViolationReportObservable());
    }
    var reportTypes = apis.filter(function (api) { return api !== RawReportType.cspViolation; });
    if (reportTypes.length) {
        observables.push(createReportObservable(reportTypes));
    }
    return mergeObservables.apply(void 0, observables);
}
function createReportObservable(reportTypes) {
    var observable = new Observable(function () {
        if (!window.ReportingObserver) {
            return;
        }
        var handleReports = monitor(function (reports) {
            return reports.forEach(function (report) {
                observable.notify(buildRawReportFromReport(report));
            });
        });
        var observer = new window.ReportingObserver(handleReports, {
            types: reportTypes,
            buffered: true,
        });
        observer.observe();
        return function () {
            observer.disconnect();
        };
    });
    return observable;
}
function createCspViolationReportObservable() {
    var observable = new Observable(function () {
        var handleCspViolation = monitor(function (event) {
            observable.notify(buildRawReportFromCspViolation(event));
        });
        var stop = addEventListener(document, "securitypolicyviolation" /* SECURITY_POLICY_VIOLATION */, handleCspViolation).stop;
        return stop;
    });
    return observable;
}
function buildRawReportFromReport(_a) {
    var type = _a.type, body = _a.body;
    return {
        type: type,
        subtype: body.id,
        message: "".concat(type, ": ").concat(body.message),
        stack: buildStack(body.id, body.message, body.sourceFile, body.lineNumber, body.columnNumber),
    };
}
function buildRawReportFromCspViolation(event) {
    var type = RawReportType.cspViolation;
    var message = "'".concat(event.blockedURI, "' blocked by '").concat(event.effectiveDirective, "' directive");
    return {
        type: RawReportType.cspViolation,
        subtype: event.effectiveDirective,
        message: "".concat(type, ": ").concat(message),
        stack: buildStack(event.effectiveDirective, "".concat(message, " of the policy \"").concat(safeTruncate(event.originalPolicy, 100, '...'), "\""), event.sourceFile, event.lineNumber, event.columnNumber),
    };
}
function buildStack(name, message, sourceFile, lineNumber, columnNumber) {
    return (sourceFile &&
        toStackTraceString({
            name: name,
            message: message,
            stack: [
                {
                    func: '?',
                    url: sourceFile,
                    line: lineNumber,
                    column: columnNumber,
                },
            ],
        }));
}

var CLEAR_OLD_CONTEXTS_INTERVAL = ONE_MINUTE;
var ContextHistory = /** @class */ (function () {
    function ContextHistory(expireDelay) {
        var _this = this;
        this.expireDelay = expireDelay;
        this.previousContexts = [];
        this.clearOldContextsInterval = setInterval(function () { return _this.clearOldContexts(); }, CLEAR_OLD_CONTEXTS_INTERVAL);
    }
    ContextHistory.prototype.find = function (startTime) {
        if (startTime === undefined ||
            (this.current !== undefined && this.currentStart !== undefined && startTime >= this.currentStart)) {
            return this.current;
        }
        for (var _i = 0, _a = this.previousContexts; _i < _a.length; _i++) {
            var previousContext = _a[_i];
            if (startTime > previousContext.endTime) {
                break;
            }
            if (startTime >= previousContext.startTime) {
                return previousContext.context;
            }
        }
        return undefined;
    };
    ContextHistory.prototype.setCurrent = function (current, startTime) {
        this.current = current;
        this.currentStart = startTime;
    };
    ContextHistory.prototype.getCurrent = function () {
        return this.current;
    };
    ContextHistory.prototype.clearCurrent = function () {
        this.current = undefined;
        this.currentStart = undefined;
    };
    ContextHistory.prototype.closeCurrent = function (endTime) {
        if (this.current !== undefined && this.currentStart !== undefined) {
            this.previousContexts.unshift({
                endTime: endTime,
                context: this.current,
                startTime: this.currentStart,
            });
            this.clearCurrent();
        }
    };
    ContextHistory.prototype.clearOldContexts = function () {
        var oldTimeThreshold = relativeNow() - this.expireDelay;
        while (this.previousContexts.length > 0 &&
            this.previousContexts[this.previousContexts.length - 1].startTime < oldTimeThreshold) {
            this.previousContexts.pop();
        }
    };
    ContextHistory.prototype.reset = function () {
        this.clearCurrent();
        this.previousContexts = [];
    };
    ContextHistory.prototype.stop = function () {
        clearInterval(this.clearOldContextsInterval);
    };
    return ContextHistory;
}());

function isIE() {
    return Boolean(document.documentMode);
}
function isChromium() {
    return !!window.chrome || /HeadlessChrome/.test(window.navigator.userAgent);
}

var SESSION_EXPIRATION_DELAY = 15 * ONE_MINUTE;
var SESSION_TIME_OUT_DELAY = 4 * ONE_HOUR;
/**
 * Different session concepts:
 * - tracked, the session has an id and is updated along the user navigation
 * - not tracked, the session does not have an id but it is updated along the user navigation
 * - inactive, no session in store or session expired, waiting for a renew session
 */
function startSessionStore(options, productKey, computeSessionState) {
    var renewObservable = new Observable();
    var expireObservable = new Observable();
    var watchSessionTimeoutId = setInterval(monitor(watchSession), COOKIE_ACCESS_DELAY);
    var sessionCache = retrieveActiveSession();
    function expandOrRenewSession() {
        var isTracked;
        withCookieLockAccess({
            options: options,
            process: function (cookieSession) {
                var synchronizedSession = synchronizeSession(cookieSession);
                isTracked = expandOrRenewCookie(synchronizedSession);
                return synchronizedSession;
            },
            after: function (cookieSession) {
                if (isTracked && !hasSessionInCache()) {
                    renewSession(cookieSession);
                }
                sessionCache = cookieSession;
            },
        });
    }
    function expandSession() {
        withCookieLockAccess({
            options: options,
            process: function (cookieSession) { return (hasSessionInCache() ? synchronizeSession(cookieSession) : undefined); },
        });
    }
    /**
     * allows two behaviors:
     * - if the session is active, synchronize the session cache without updating the session cookie
     * - if the session is not active, clear the session cookie and expire the session cache
     */
    function watchSession() {
        withCookieLockAccess({
            options: options,
            process: function (cookieSession) { return (!isActiveSession(cookieSession) ? {} : undefined); },
            after: synchronizeSession,
        });
    }
    function synchronizeSession(cookieSession) {
        if (!isActiveSession(cookieSession)) {
            cookieSession = {};
        }
        if (hasSessionInCache()) {
            if (isSessionInCacheOutdated(cookieSession)) {
                expireSession();
            }
            else {
                sessionCache = cookieSession;
            }
        }
        return cookieSession;
    }
    function expandOrRenewCookie(cookieSession) {
        var _a = computeSessionState(cookieSession[productKey]), trackingType = _a.trackingType, isTracked = _a.isTracked;
        cookieSession[productKey] = trackingType;
        if (isTracked && !cookieSession.id) {
            cookieSession.id = generateUUID();
            cookieSession.created = String(Date.now());
        }
        return isTracked;
    }
    function hasSessionInCache() {
        return sessionCache[productKey] !== undefined;
    }
    function isSessionInCacheOutdated(cookieSession) {
        return sessionCache.id !== cookieSession.id || sessionCache[productKey] !== cookieSession[productKey];
    }
    function expireSession() {
        sessionCache = {};
        expireObservable.notify();
    }
    function renewSession(cookieSession) {
        sessionCache = cookieSession;
        renewObservable.notify();
    }
    function retrieveActiveSession() {
        var session = retrieveSession();
        if (isActiveSession(session)) {
            return session;
        }
        return {};
    }
    function isActiveSession(session) {
        // created and expire can be undefined for versions which was not storing them
        // these checks could be removed when older versions will not be available/live anymore
        return ((session.created === undefined || Date.now() - Number(session.created) < SESSION_TIME_OUT_DELAY) &&
            (session.expire === undefined || Date.now() < Number(session.expire)));
    }
    return {
        expandOrRenewSession: throttle(monitor(expandOrRenewSession), COOKIE_ACCESS_DELAY).throttled,
        expandSession: expandSession,
        getSession: function () { return sessionCache; },
        renewObservable: renewObservable,
        expireObservable: expireObservable,
        stop: function () {
            clearInterval(watchSessionTimeoutId);
        },
    };
}

var SESSION_ENTRY_REGEXP = /^([a-z]+)=([a-z0-9-]+)$/;
var SESSION_ENTRY_SEPARATOR = '&';
var SESSION_COOKIE_NAME = '_dd_s';
// arbitrary values
var LOCK_RETRY_DELAY = 10;
var MAX_NUMBER_OF_LOCK_RETRIES = 100;
var bufferedOperations = [];
var ongoingOperations;
function withCookieLockAccess(operations, numberOfRetries) {
    var _a;
    if (numberOfRetries === void 0) { numberOfRetries = 0; }
    if (!ongoingOperations) {
        ongoingOperations = operations;
    }
    if (operations !== ongoingOperations) {
        bufferedOperations.push(operations);
        return;
    }
    if (numberOfRetries >= MAX_NUMBER_OF_LOCK_RETRIES) {
        next();
        return;
    }
    var currentLock;
    var currentSession = retrieveSession();
    if (isCookieLockEnabled()) {
        // if someone has lock, retry later
        if (currentSession.lock) {
            retryLater(operations, numberOfRetries);
            return;
        }
        // acquire lock
        currentLock = generateUUID();
        currentSession.lock = currentLock;
        setSession(currentSession, operations.options);
        // if lock is not acquired, retry later
        currentSession = retrieveSession();
        if (currentSession.lock !== currentLock) {
            retryLater(operations, numberOfRetries);
            return;
        }
    }
    var processedSession = operations.process(currentSession);
    if (isCookieLockEnabled()) {
        // if lock corrupted after process, retry later
        currentSession = retrieveSession();
        if (currentSession.lock !== currentLock) {
            retryLater(operations, numberOfRetries);
            return;
        }
    }
    if (processedSession) {
        persistSession(processedSession, operations.options);
    }
    if (isCookieLockEnabled()) {
        // correctly handle lock around expiration would require to handle this case properly at several levels
        // since we don't have evidence of lock issues around expiration, let's just not do the corruption check for it
        if (!(processedSession && isExpiredState(processedSession))) {
            // if lock corrupted after persist, retry later
            currentSession = retrieveSession();
            if (currentSession.lock !== currentLock) {
                retryLater(operations, numberOfRetries);
                return;
            }
            delete currentSession.lock;
            setSession(currentSession, operations.options);
            processedSession = currentSession;
        }
    }
    // call after even if session is not persisted in order to perform operations on
    // up-to-date cookie value, the value could have been modified by another tab
    (_a = operations.after) === null || _a === void 0 ? void 0 : _a.call(operations, processedSession || currentSession);
    next();
}
/**
 * Cookie lock strategy allows mitigating issues due to concurrent access to cookie.
 * This issue concerns only chromium browsers and enabling this on firefox increase cookie write failures.
 */
function isCookieLockEnabled() {
    return isChromium();
}
function retryLater(operations, currentNumberOfRetries) {
    setTimeout(monitor(function () {
        withCookieLockAccess(operations, currentNumberOfRetries + 1);
    }), LOCK_RETRY_DELAY);
}
function next() {
    ongoingOperations = undefined;
    var nextOperations = bufferedOperations.shift();
    if (nextOperations) {
        withCookieLockAccess(nextOperations);
    }
}
function persistSession(session, options) {
    if (isExpiredState(session)) {
        clearSession(options);
        return;
    }
    session.expire = String(Date.now() + SESSION_EXPIRATION_DELAY);
    setSession(session, options);
}
function setSession(session, options) {
    setCookie(SESSION_COOKIE_NAME, toSessionString(session), SESSION_EXPIRATION_DELAY, options);
}
function toSessionString(session) {
    return objectEntries(session)
        .map(function (_a) {
        var key = _a[0], value = _a[1];
        return "".concat(key, "=").concat(value);
    })
        .join(SESSION_ENTRY_SEPARATOR);
}
function retrieveSession() {
    var sessionString = getCookie(SESSION_COOKIE_NAME);
    var session = {};
    if (isValidSessionString(sessionString)) {
        sessionString.split(SESSION_ENTRY_SEPARATOR).forEach(function (entry) {
            var matches = SESSION_ENTRY_REGEXP.exec(entry);
            if (matches !== null) {
                var key = matches[1], value = matches[2];
                session[key] = value;
            }
        });
    }
    return session;
}
function isValidSessionString(sessionString) {
    return (sessionString !== undefined &&
        (sessionString.indexOf(SESSION_ENTRY_SEPARATOR) !== -1 || SESSION_ENTRY_REGEXP.test(sessionString)));
}
function isExpiredState(session) {
    return isEmptyObject(session);
}
function clearSession(options) {
    setCookie(SESSION_COOKIE_NAME, '', 0, options);
}

var OLD_SESSION_COOKIE_NAME = '_dd';
var OLD_RUM_COOKIE_NAME = '_dd_r';
var OLD_LOGS_COOKIE_NAME = '_dd_l';
// duplicate values to avoid dependency issues
var RUM_SESSION_KEY = 'rum';
var LOGS_SESSION_KEY = 'logs';
/**
 * This migration should remain in the codebase as long as older versions are available/live
 * to allow older sdk versions to be upgraded to newer versions without compatibility issues.
 */
function tryOldCookiesMigration(options) {
    var sessionString = getCookie(SESSION_COOKIE_NAME);
    var oldSessionId = getCookie(OLD_SESSION_COOKIE_NAME);
    var oldRumType = getCookie(OLD_RUM_COOKIE_NAME);
    var oldLogsType = getCookie(OLD_LOGS_COOKIE_NAME);
    if (!sessionString) {
        var session = {};
        if (oldSessionId) {
            session.id = oldSessionId;
        }
        if (oldLogsType && /^[01]$/.test(oldLogsType)) {
            session[LOGS_SESSION_KEY] = oldLogsType;
        }
        if (oldRumType && /^[012]$/.test(oldRumType)) {
            session[RUM_SESSION_KEY] = oldRumType;
        }
        persistSession(session, options);
    }
}

var VISIBILITY_CHECK_DELAY = ONE_MINUTE;
var SESSION_CONTEXT_TIMEOUT_DELAY = SESSION_TIME_OUT_DELAY;
function startSessionManager(options, productKey, computeSessionState) {
    tryOldCookiesMigration(options);
    var sessionStore = startSessionStore(options, productKey, computeSessionState);
    var sessionContextHistory = new ContextHistory(SESSION_CONTEXT_TIMEOUT_DELAY);
    sessionStore.renewObservable.subscribe(function () {
        sessionContextHistory.setCurrent(buildSessionContext(), relativeNow());
    });
    sessionStore.expireObservable.subscribe(function () {
        sessionContextHistory.closeCurrent(relativeNow());
    });
    sessionStore.expandOrRenewSession();
    sessionContextHistory.setCurrent(buildSessionContext(), clocksOrigin().relative);
    trackActivity(function () { return sessionStore.expandOrRenewSession(); });
    trackVisibility(function () { return sessionStore.expandSession(); });
    function buildSessionContext() {
        return {
            id: sessionStore.getSession().id,
            trackingType: sessionStore.getSession()[productKey],
        };
    }
    return {
        findActiveSession: function (startTime) { return sessionContextHistory.find(startTime); },
        renewObservable: sessionStore.renewObservable,
        expireObservable: sessionStore.expireObservable,
    };
}
function trackActivity(expandOrRenewSession) {
    var stop = addEventListeners(window, ["click" /* CLICK */, "touchstart" /* TOUCH_START */, "keydown" /* KEY_DOWN */, "scroll" /* SCROLL */], expandOrRenewSession, { capture: true, passive: true }).stop;
}
function trackVisibility(expandSession) {
    var expandSessionWhenVisible = monitor(function () {
        if (document.visibilityState === 'visible') {
            expandSession();
        }
    });
    var stop = addEventListener(document, "visibilitychange" /* VISIBILITY_CHANGE */, expandSessionWhenVisible).stop;
    var visibilityCheckInterval = setInterval(expandSessionWhenVisible, VISIBILITY_CHECK_DELAY);
}

var hasReportedXhrError = false;
/**
 * Use POST request without content type to:
 * - avoid CORS preflight requests
 * - allow usage of sendBeacon
 *
 * multiple elements are sent separated by \n in order
 * to be parsed correctly without content type header
 */
var HttpRequest = /** @class */ (function () {
    function HttpRequest(endpointBuilder, bytesLimit) {
        this.endpointBuilder = endpointBuilder;
        this.bytesLimit = bytesLimit;
    }
    HttpRequest.prototype.send = function (data, size, flushReason) {
        var url = this.endpointBuilder.build();
        var tryBeacon = !!navigator.sendBeacon && size < this.bytesLimit;
        if (tryBeacon) {
            try {
                var isQueued = navigator.sendBeacon(url, data);
                if (isQueued) {
                    return;
                }
            }
            catch (e) {
                reportBeaconError(e);
            }
        }
        var transportIntrospection = function (event) {
            var req = event === null || event === void 0 ? void 0 : event.currentTarget;
            if (req.status >= 200 && req.status < 300) {
                return;
            }
            if (!hasReportedXhrError) {
                hasReportedXhrError = true;
                addMonitoringMessage('XHR fallback failed', {
                    on_line: navigator.onLine,
                    size: size,
                    url: url,
                    try_beacon: tryBeacon,
                    flush_reason: flushReason,
                    event: {
                        is_trusted: event.isTrusted,
                        total: event.total,
                        loaded: event.loaded,
                    },
                    request: {
                        status: req.status,
                        ready_state: req.readyState,
                        response_text: req.responseText.slice(0, 512),
                    },
                });
            }
        };
        var request = new XMLHttpRequest();
        request.addEventListener('loadend', monitor(function (event) { return transportIntrospection(event); }));
        request.open('POST', url, true);
        request.send(data);
    };
    return HttpRequest;
}());
var hasReportedBeaconError = false;
function reportBeaconError(e) {
    if (!hasReportedBeaconError) {
        hasReportedBeaconError = true;
        addMonitoringError(e);
    }
}

// https://en.wikipedia.org/wiki/UTF-8
// eslint-disable-next-line no-control-regex
var HAS_MULTI_BYTES_CHARACTERS = /[^\u0000-\u007F]/;
var Batch = /** @class */ (function () {
    function Batch(request, maxSize, bytesLimit, maxMessageSize, flushTimeout, beforeUnloadCallback) {
        if (beforeUnloadCallback === void 0) { beforeUnloadCallback = noop; }
        this.request = request;
        this.maxSize = maxSize;
        this.bytesLimit = bytesLimit;
        this.maxMessageSize = maxMessageSize;
        this.flushTimeout = flushTimeout;
        this.beforeUnloadCallback = beforeUnloadCallback;
        this.pushOnlyBuffer = [];
        this.upsertBuffer = {};
        this.bufferBytesSize = 0;
        this.bufferMessageCount = 0;
        this.flushOnVisibilityHidden();
        this.flushPeriodically();
    }
    Batch.prototype.add = function (message) {
        this.addOrUpdate(message);
    };
    Batch.prototype.upsert = function (message, key) {
        this.addOrUpdate(message, key);
    };
    Batch.prototype.flush = function (reason) {
        if (this.bufferMessageCount !== 0) {
            var messages = this.pushOnlyBuffer.concat(objectValues(this.upsertBuffer));
            this.request.send(messages.join('\n'), this.bufferBytesSize, reason);
            this.pushOnlyBuffer = [];
            this.upsertBuffer = {};
            this.bufferBytesSize = 0;
            this.bufferMessageCount = 0;
        }
    };
    Batch.prototype.sizeInBytes = function (candidate) {
        // Accurate byte size computations can degrade performances when there is a lot of events to process
        if (!HAS_MULTI_BYTES_CHARACTERS.test(candidate)) {
            return candidate.length;
        }
        if (window.TextEncoder !== undefined) {
            return new TextEncoder().encode(candidate).length;
        }
        return new Blob([candidate]).size;
    };
    Batch.prototype.addOrUpdate = function (message, key) {
        var _a = this.process(message), processedMessage = _a.processedMessage, messageBytesSize = _a.messageBytesSize;
        if (messageBytesSize >= this.maxMessageSize) {
            display.warn("Discarded a message whose size was bigger than the maximum allowed size ".concat(this.maxMessageSize, "KB."));
            return;
        }
        if (this.hasMessageFor(key)) {
            this.remove(key);
        }
        if (this.willReachedBytesLimitWith(messageBytesSize)) {
            this.flush('willReachedBytesLimitWith');
        }
        this.push(processedMessage, messageBytesSize, key);
        if (this.isFull()) {
            this.flush('isFull');
        }
    };
    Batch.prototype.process = function (message) {
        var processedMessage = jsonStringify(message);
        var messageBytesSize = this.sizeInBytes(processedMessage);
        return { processedMessage: processedMessage, messageBytesSize: messageBytesSize };
    };
    Batch.prototype.push = function (processedMessage, messageBytesSize, key) {
        if (this.bufferMessageCount > 0) {
            // \n separator at serialization
            this.bufferBytesSize += 1;
        }
        if (key !== undefined) {
            this.upsertBuffer[key] = processedMessage;
        }
        else {
            this.pushOnlyBuffer.push(processedMessage);
        }
        this.bufferBytesSize += messageBytesSize;
        this.bufferMessageCount += 1;
    };
    Batch.prototype.remove = function (key) {
        var removedMessage = this.upsertBuffer[key];
        delete this.upsertBuffer[key];
        var messageBytesSize = this.sizeInBytes(removedMessage);
        this.bufferBytesSize -= messageBytesSize;
        this.bufferMessageCount -= 1;
        if (this.bufferMessageCount > 0) {
            this.bufferBytesSize -= 1;
        }
    };
    Batch.prototype.hasMessageFor = function (key) {
        return key !== undefined && this.upsertBuffer[key] !== undefined;
    };
    Batch.prototype.willReachedBytesLimitWith = function (messageBytesSize) {
        // byte of the separator at the end of the message
        return this.bufferBytesSize + messageBytesSize + 1 >= this.bytesLimit;
    };
    Batch.prototype.isFull = function () {
        return this.bufferMessageCount === this.maxSize || this.bufferBytesSize >= this.bytesLimit;
    };
    Batch.prototype.flushPeriodically = function () {
        var _this = this;
        setTimeout(monitor(function () {
            _this.flush('flushPeriodically');
            _this.flushPeriodically();
        }), this.flushTimeout);
    };
    Batch.prototype.flushOnVisibilityHidden = function () {
        var _this = this;
        /**
         * With sendBeacon, requests are guaranteed to be successfully sent during document unload
         */
        // @ts-ignore this function is not always defined
        if (navigator.sendBeacon) {
            /**
             * beforeunload is called before visibilitychange
             * register first to be sure to be called before flush on beforeunload
             * caveat: unload can still be canceled by another listener
             */
            addEventListener(window, "beforeunload" /* BEFORE_UNLOAD */, this.beforeUnloadCallback);
            /**
             * Only event that guarantee to fire on mobile devices when the page transitions to background state
             * (e.g. when user switches to a different application, goes to homescreen, etc), or is being unloaded.
             */
            addEventListener(document, "visibilitychange" /* VISIBILITY_CHANGE */, function () {
                if (document.visibilityState === 'hidden') {
                    _this.flush("visibilitychange" /* VISIBILITY_CHANGE */);
                }
            });
            /**
             * Safari does not support yet to send a request during:
             * - a visibility change during doc unload (cf: https://bugs.webkit.org/show_bug.cgi?id=194897)
             * - a page hide transition (cf: https://bugs.webkit.org/show_bug.cgi?id=188329)
             */
            addEventListener(window, "beforeunload" /* BEFORE_UNLOAD */, function () { return _this.flush("beforeunload" /* BEFORE_UNLOAD */); });
        }
    };
    return Batch;
}());

function getEventBridge() {
    var eventBridgeGlobal = getEventBridgeGlobal();
    if (!eventBridgeGlobal) {
        return;
    }
    return {
        getAllowedWebViewHosts: function () {
            return JSON.parse(eventBridgeGlobal.getAllowedWebViewHosts());
        },
        send: function (eventType, event) {
            eventBridgeGlobal.send(JSON.stringify({ eventType: eventType, event: event }));
        },
    };
}
function canUseEventBridge() {
    var bridge = getEventBridge();
    return !!bridge && includes(bridge.getAllowedWebViewHosts(), window.location.hostname);
}
function getEventBridgeGlobal() {
    return getGlobalObject().DatadogEventBridge;
}

function startBatchWithReplica(configuration, endpoint, replicaEndpoint) {
    var primaryBatch = createBatch(endpoint);
    var replicaBatch;
    if (replicaEndpoint) {
        replicaBatch = createBatch(replicaEndpoint);
    }
    function createBatch(endpointBuilder) {
        return new Batch(new HttpRequest(endpointBuilder, configuration.batchBytesLimit), configuration.maxBatchSize, configuration.batchBytesLimit, configuration.maxMessageSize, configuration.flushTimeout);
    }
    return {
        add: function (message) {
            primaryBatch.add(message);
            if (replicaBatch) {
                replicaBatch.add(message);
            }
        },
    };
}

function createEventRateLimiter(eventType, limit, onLimitReached) {
    var eventCount = 0;
    var allowNextEvent = false;
    return {
        isLimitReached: function () {
            if (eventCount === 0) {
                setTimeout(function () {
                    eventCount = 0;
                }, ONE_MINUTE);
            }
            eventCount += 1;
            if (eventCount <= limit || allowNextEvent) {
                allowNextEvent = false;
                return false;
            }
            if (eventCount === limit + 1) {
                allowNextEvent = true;
                try {
                    onLimitReached({
                        message: "Reached max number of ".concat(eventType, "s by minute: ").concat(limit),
                        source: ErrorSource.AGENT,
                        startClocks: clocksNow(),
                    });
                }
                finally {
                    allowNextEvent = false;
                }
            }
            return true;
        },
    };
}

var xhrObservable;
var xhrContexts = new WeakMap();
function initXhrObservable() {
    if (!xhrObservable) {
        xhrObservable = createXhrObservable();
    }
    return xhrObservable;
}
function createXhrObservable() {
    var observable = new Observable(function () {
        var stopInstrumentingStart = instrumentMethodAndCallOriginal(XMLHttpRequest.prototype, 'open', {
            before: openXhr,
        }).stop;
        var stopInstrumentingSend = instrumentMethodAndCallOriginal(XMLHttpRequest.prototype, 'send', {
            before: function () {
                sendXhr.call(this, observable);
            },
        }).stop;
        var stopInstrumentingAbort = instrumentMethodAndCallOriginal(XMLHttpRequest.prototype, 'abort', {
            before: abortXhr,
        }).stop;
        return function () {
            stopInstrumentingStart();
            stopInstrumentingSend();
            stopInstrumentingAbort();
        };
    });
    return observable;
}
function openXhr(method, url) {
    xhrContexts.set(this, {
        state: 'open',
        method: method,
        url: normalizeUrl(url.toString()),
    });
}
function sendXhr(observable) {
    var _this = this;
    var context = xhrContexts.get(this);
    if (!context) {
        return;
    }
    var startContext = context;
    startContext.state = 'start';
    startContext.startTime = relativeNow();
    startContext.startClocks = clocksNow();
    startContext.isAborted = false;
    startContext.xhr = this;
    var hasBeenReported = false;
    var stopInstrumentingOnReadyStateChange = instrumentMethodAndCallOriginal(this, 'onreadystatechange', {
        before: function () {
            if (this.readyState === XMLHttpRequest.DONE) {
                // Try to report the XHR as soon as possible, because the XHR may be mutated by the
                // application during a future event. For example, Angular is calling .abort() on
                // completed requests during a onreadystatechange event, so the status becomes '0'
                // before the request is collected.
                onEnd();
            }
        },
    }).stop;
    var onEnd = monitor(function () {
        _this.removeEventListener('loadend', onEnd);
        stopInstrumentingOnReadyStateChange();
        if (hasBeenReported) {
            return;
        }
        hasBeenReported = true;
        var completeContext = context;
        completeContext.state = 'complete';
        completeContext.duration = elapsed(startContext.startClocks.timeStamp, timeStampNow());
        completeContext.status = _this.status;
        observable.notify(shallowClone(completeContext));
    });
    this.addEventListener('loadend', onEnd);
    observable.notify(startContext);
}
function abortXhr() {
    var context = xhrContexts.get(this);
    if (context) {
        context.isAborted = true;
    }
}

var fetchObservable;
function initFetchObservable() {
    if (!fetchObservable) {
        fetchObservable = createFetchObservable();
    }
    return fetchObservable;
}
function createFetchObservable() {
    var observable = new Observable(function () {
        if (!window.fetch) {
            return;
        }
        var stop = instrumentMethod(window, 'fetch', function (originalFetch) {
            return function (input, init) {
                var responsePromise;
                var context = callMonitored(beforeSend, null, [observable, input, init]);
                if (context) {
                    responsePromise = originalFetch.call(this, context.input, context.init);
                    callMonitored(afterSend, null, [observable, responsePromise, context]);
                }
                else {
                    responsePromise = originalFetch.call(this, input, init);
                }
                return responsePromise;
            };
        }).stop;
        return stop;
    });
    return observable;
}
function beforeSend(observable, input, init) {
    var method = (init && init.method) || (typeof input === 'object' && input.method) || 'GET';
    var url = normalizeUrl((typeof input === 'object' && input.url) || input);
    var startClocks = clocksNow();
    var context = {
        state: 'start',
        init: init,
        input: input,
        method: method,
        startClocks: startClocks,
        url: url,
    };
    observable.notify(context);
    return context;
}
function afterSend(observable, responsePromise, startContext) {
    var reportFetch = function (response) {
        var context = startContext;
        context.state = 'complete';
        context.duration = elapsed(context.startClocks.timeStamp, timeStampNow());
        if ('stack' in response || response instanceof Error) {
            context.status = 0;
            context.isAborted = response instanceof DOMException && response.code === DOMException.ABORT_ERR;
            context.error = response;
            observable.notify(context);
        }
        else if ('status' in response) {
            context.response = response;
            context.responseType = response.type;
            context.status = response.status;
            context.isAborted = false;
            observable.notify(context);
        }
    };
    responsePromise.then(monitor(reportFetch), monitor(reportFetch));
}

var ConsoleApiName = {
    log: 'log',
    debug: 'debug',
    info: 'info',
    warn: 'warn',
    error: 'error',
};
var consoleObservablesByApi = {};
function initConsoleObservable(apis) {
    var consoleObservables = apis.map(function (api) {
        if (!consoleObservablesByApi[api]) {
            consoleObservablesByApi[api] = createConsoleObservable(api);
        }
        return consoleObservablesByApi[api];
    });
    return mergeObservables.apply(void 0, consoleObservables);
}
/* eslint-disable no-console */
function createConsoleObservable(api) {
    var observable = new Observable(function () {
        var originalConsoleApi = console[api];
        console[api] = function () {
            var params = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                params[_i] = arguments[_i];
            }
            originalConsoleApi.apply(console, params);
            var handlingStack = createHandlingStack();
            callMonitored(function () {
                observable.notify(buildConsoleLog(params, api, handlingStack));
            });
        };
        return function () {
            console[api] = originalConsoleApi;
        };
    });
    return observable;
}
function buildConsoleLog(params, api, handlingStack) {
    var log = {
        message: ["console ".concat(api, ":")]
            .concat(params)
            .map(function (param) { return formatConsoleParameters(param); })
            .join(' '),
        api: api,
    };
    if (api === ConsoleApiName.error) {
        var firstErrorParam = find(params, function (param) { return param instanceof Error; });
        log.stack = firstErrorParam ? toStackTraceString(computeStackTrace(firstErrorParam)) : undefined;
        log.handlingStack = handlingStack;
    }
    return log;
}
function formatConsoleParameters(param) {
    if (typeof param === 'string') {
        return param;
    }
    if (param instanceof Error) {
        return formatErrorMessage(computeStackTrace(param));
    }
    return jsonStringify(param, undefined, 2);
}

var BUFFER_LIMIT = 500;
var BoundedBuffer = /** @class */ (function () {
    function BoundedBuffer() {
        this.buffer = [];
    }
    BoundedBuffer.prototype.add = function (callback) {
        var length = this.buffer.push(callback);
        if (length > BUFFER_LIMIT) {
            this.buffer.splice(0, 1);
        }
    };
    BoundedBuffer.prototype.drain = function () {
        this.buffer.forEach(function (callback) { return callback(); });
        this.buffer.length = 0;
    };
    return BoundedBuffer;
}());

function createContextManager() {
    var context = {};
    return {
        get: function () { return context; },
        add: function (key, value) {
            context[key] = value;
        },
        remove: function (key) {
            delete context[key];
        },
        set: function (newContext) {
            context = newContext;
        },
    };
}

/**
 * Current limitation:
 * - field path do not support array, 'a.b.c' only
 */
function limitModification(object, modifiableFieldPaths, modifier) {
    var clone = deepClone(object);
    var result = modifier(clone);
    modifiableFieldPaths.forEach(function (path) {
        var originalValue = get(object, path);
        var newValue = get(clone, path);
        var originalType = getType(originalValue);
        var newType = getType(newValue);
        if (newType === originalType) {
            set(object, path, newValue);
        }
        else if (originalType === 'object' && (newType === 'undefined' || newType === 'null')) {
            set(object, path, {});
        }
    });
    return result;
}
function get(object, path) {
    var current = object;
    for (var _i = 0, _a = path.split('.'); _i < _a.length; _i++) {
        var field = _a[_i];
        if (!isValidObjectContaining(current, field)) {
            return;
        }
        current = current[field];
    }
    return current;
}
function set(object, path, value) {
    var current = object;
    var fields = path.split('.');
    for (var i = 0; i < fields.length; i += 1) {
        var field = fields[i];
        if (!isValidObjectContaining(current, field)) {
            return;
        }
        if (i !== fields.length - 1) {
            current = current[field];
        }
        else {
            current[field] = value;
        }
    }
}
function isValidObjectContaining(object, field) {
    return typeof object === 'object' && object !== null && field in object;
}

var SYNTHETICS_TEST_ID_COOKIE_NAME = 'datadog-synthetics-public-id';
var SYNTHETICS_RESULT_ID_COOKIE_NAME = 'datadog-synthetics-result-id';
var SYNTHETICS_INJECTS_RUM_COOKIE_NAME = 'datadog-synthetics-injects-rum';
function getSyntheticsContext() {
    var testId = window._DATADOG_SYNTHETICS_PUBLIC_ID || getCookie(SYNTHETICS_TEST_ID_COOKIE_NAME);
    var resultId = window._DATADOG_SYNTHETICS_RESULT_ID || getCookie(SYNTHETICS_RESULT_ID_COOKIE_NAME);
    if (typeof testId === 'string' && typeof resultId === 'string') {
        return {
            test_id: testId,
            result_id: resultId,
            injected: willSyntheticsInjectRum(),
        };
    }
}
function willSyntheticsInjectRum() {
    return Boolean(window._DATADOG_SYNTHETICS_INJECTS_RUM || getCookie(SYNTHETICS_INJECTS_RUM_COOKIE_NAME));
}

function validateAndBuildRumConfiguration(initConfiguration) {
    var _a, _b;
    if (!initConfiguration.applicationId) {
        display.error('Application ID is not configured, no RUM data will be collected.');
        return;
    }
    if (initConfiguration.replaySampleRate !== undefined && !isPercentage(initConfiguration.replaySampleRate)) {
        display.error('Replay Sample Rate should be a number between 0 and 100');
        return;
    }
    if (initConfiguration.allowedTracingOrigins !== undefined) {
        if (!Array.isArray(initConfiguration.allowedTracingOrigins)) {
            display.error('Allowed Tracing Origins should be an array');
            return;
        }
        if (initConfiguration.allowedTracingOrigins.length !== 0 && initConfiguration.service === undefined) {
            display.error('Service need to be configured when tracing is enabled');
            return;
        }
    }
    var baseConfiguration = validateAndBuildConfiguration(initConfiguration);
    if (!baseConfiguration) {
        return;
    }
    return assign({
        applicationId: initConfiguration.applicationId,
        actionNameAttribute: initConfiguration.actionNameAttribute,
        replaySampleRate: (_a = initConfiguration.replaySampleRate) !== null && _a !== void 0 ? _a : 100,
        allowedTracingOrigins: (_b = initConfiguration.allowedTracingOrigins) !== null && _b !== void 0 ? _b : [],
        trackInteractions: !!initConfiguration.trackInteractions,
        trackViewsManually: !!initConfiguration.trackViewsManually,
        defaultPrivacyLevel: objectHasValue(DefaultPrivacyLevel, initConfiguration.defaultPrivacyLevel)
            ? initConfiguration.defaultPrivacyLevel
            : DefaultPrivacyLevel.MASK_USER_INPUT,
    }, baseConfiguration);
}

function makeRumPublicApi(startRumImpl, recorderApi, _a) {
    var _b = _a === void 0 ? {} : _a, _c = _b.ignoreInitIfSyntheticsWillInjectRum, ignoreInitIfSyntheticsWillInjectRum = _c === void 0 ? true : _c;
    var isAlreadyInitialized = false;
    var globalContextManager = createContextManager();
    var user = {};
    var getInternalContextStrategy = function () { return undefined; };
    var getInitConfigurationStrategy = function () { return undefined; };
    var bufferApiCalls = new BoundedBuffer();
    var addTimingStrategy = function (name, time) {
        if (time === void 0) { time = timeStampNow(); }
        bufferApiCalls.add(function () { return addTimingStrategy(name, time); });
    };
    var startViewStrategy = function (name, startClocks) {
        if (startClocks === void 0) { startClocks = clocksNow(); }
        bufferApiCalls.add(function () { return startViewStrategy(name, startClocks); });
    };
    var addActionStrategy = function (action, commonContext) {
        if (commonContext === void 0) { commonContext = clonedCommonContext(); }
        bufferApiCalls.add(function () { return addActionStrategy(action, commonContext); });
    };
    var addErrorStrategy = function (providedError, commonContext) {
        if (commonContext === void 0) { commonContext = clonedCommonContext(); }
        bufferApiCalls.add(function () { return addErrorStrategy(providedError, commonContext); });
    };
    function clonedCommonContext() {
        return deepClone({
            context: globalContextManager.get(),
            user: user,
        });
    }
    function initRum(initConfiguration) {
        // If we are in a Synthetics test configured to automatically inject a RUM instance, we want to
        // completely discard the customer application RUM instance by ignoring their init() call.  But,
        // we should not ignore the init() call from the Synthetics-injected RUM instance, so the
        // internal `ignoreInitIfSyntheticsWillInjectRum` option is here to bypass this condition.
        if (ignoreInitIfSyntheticsWillInjectRum && willSyntheticsInjectRum()) {
            return;
        }
        if (canUseEventBridge()) {
            initConfiguration = overrideInitConfigurationForBridge(initConfiguration);
        }
        else if (!canHandleSession(initConfiguration)) {
            return;
        }
        if (!canInitRum(initConfiguration)) {
            return;
        }
        var configuration = validateAndBuildRumConfiguration(initConfiguration);
        if (!configuration) {
            return;
        }
        if (!configuration.trackViewsManually) {
            doStartRum(configuration);
        }
        else {
            // drain beforeInitCalls by buffering them until we start RUM
            // if we get a startView, drain re-buffered calls before continuing to drain beforeInitCalls
            // in order to ensure that calls are processed in order
            var beforeInitCalls = bufferApiCalls;
            bufferApiCalls = new BoundedBuffer();
            startViewStrategy = function (name) {
                doStartRum(configuration, name);
            };
            beforeInitCalls.drain();
        }
        getInitConfigurationStrategy = function () { return deepClone(initConfiguration); };
        isAlreadyInitialized = true;
    }
    function doStartRum(configuration, initialViewName) {
        var startRumResults = startRumImpl(configuration, function () { return ({
            user: user,
            context: globalContextManager.get(),
            hasReplay: recorderApi.isRecording() ? true : undefined,
        }); }, recorderApi, initialViewName);
        (startViewStrategy = startRumResults.startView, addActionStrategy = startRumResults.addAction, addErrorStrategy = startRumResults.addError, addTimingStrategy = startRumResults.addTiming, getInternalContextStrategy = startRumResults.getInternalContext);
        bufferApiCalls.drain();
        recorderApi.onRumStart(startRumResults.lifeCycle, configuration, startRumResults.session, startRumResults.parentContexts);
    }
    var rumPublicApi = makePublicApi({
        init: monitor(initRum),
        addRumGlobalContext: monitor(globalContextManager.add),
        removeRumGlobalContext: monitor(globalContextManager.remove),
        getRumGlobalContext: monitor(globalContextManager.get),
        setRumGlobalContext: monitor(globalContextManager.set),
        getInternalContext: monitor(function (startTime) { return getInternalContextStrategy(startTime); }),
        getInitConfiguration: monitor(function () { return getInitConfigurationStrategy(); }),
        addAction: monitor(function (name, context) {
            addActionStrategy({
                name: name,
                context: deepClone(context),
                startClocks: clocksNow(),
                type: "custom" /* CUSTOM */,
            });
        }),
        addError: function (error, context) {
            var handlingStack = createHandlingStack();
            callMonitored(function () {
                addErrorStrategy({
                    error: error,
                    handlingStack: handlingStack,
                    context: deepClone(context),
                    startClocks: clocksNow(),
                });
            });
        },
        addTiming: monitor(function (name, time) {
            addTimingStrategy(name, time);
        }),
        setUser: monitor(function (newUser) {
            var sanitizedUser = sanitizeUser(newUser);
            if (sanitizedUser) {
                user = sanitizedUser;
            }
            else {
                display.error('Unsupported user:', newUser);
            }
        }),
        removeUser: monitor(function () {
            user = {};
        }),
        startView: monitor(function (name) {
            startViewStrategy(name);
        }),
        startSessionReplayRecording: monitor(recorderApi.start),
        stopSessionReplayRecording: monitor(recorderApi.stop),
    });
    return rumPublicApi;
    function sanitizeUser(newUser) {
        if (typeof newUser !== 'object' || !newUser) {
            return;
        }
        var result = deepClone(newUser);
        if ('id' in result) {
            result.id = String(result.id);
        }
        if ('name' in result) {
            result.name = String(result.name);
        }
        if ('email' in result) {
            result.email = String(result.email);
        }
        return result;
    }
    function canHandleSession(initConfiguration) {
        if (!areCookiesAuthorized(buildCookieOptions(initConfiguration))) {
            display.warn('Cookies are not authorized, we will not send any data.');
            return false;
        }
        if (isLocalFile()) {
            display.error('Execution is not allowed in the current context.');
            return false;
        }
        return true;
    }
    function canInitRum(initConfiguration) {
        if (isAlreadyInitialized) {
            if (!initConfiguration.silentMultipleInit) {
                display.error('DD_RUM is already initialized.');
            }
            return false;
        }
        return true;
    }
    function overrideInitConfigurationForBridge(initConfiguration) {
        return assign({}, initConfiguration, {
            applicationId: '00000000-aaaa-0000-aaaa-000000000000',
            clientToken: 'empty',
            sampleRate: 100,
        });
    }
    function isLocalFile() {
        return window.location.protocol === 'file:';
    }
}

function createDOMMutationObservable() {
    var MutationObserver = getMutationObserverConstructor();
    var observable = new Observable(function () {
        if (!MutationObserver) {
            return;
        }
        var observer = new MutationObserver(monitor(function () { return observable.notify(); }));
        observer.observe(document, {
            attributes: true,
            characterData: true,
            childList: true,
            subtree: true,
        });
        return function () { return observer.disconnect(); };
    });
    return observable;
}
function getMutationObserverConstructor() {
    var constructor;
    var browserWindow = window;
    // Angular uses Zone.js to provide a context persisting across async tasks.  Zone.js replaces the
    // global MutationObserver constructor with a patched version to support the context propagation.
    // There is an ongoing issue[1][2] with this setup when using a MutationObserver within a Angular
    // component: on some occasions, the callback is being called in an infinite loop, causing the
    // page to freeze (even if the callback is completely empty).
    //
    // To work around this issue, we are using the Zone __symbol__ API to get the original, unpatched
    // MutationObserver constructor.
    //
    // [1] https://github.com/angular/angular/issues/26948
    // [2] https://github.com/angular/angular/issues/31712
    if (browserWindow.Zone) {
        var symbol = browserWindow.Zone.__symbol__('MutationObserver');
        constructor = browserWindow[symbol];
    }
    if (!constructor) {
        constructor = browserWindow.MutationObserver;
    }
    return constructor;
}

var FAKE_INITIAL_DOCUMENT = 'initial_document';
var RESOURCE_TYPES = [
    ["document" /* DOCUMENT */, function (initiatorType) { return FAKE_INITIAL_DOCUMENT === initiatorType; }],
    ["xhr" /* XHR */, function (initiatorType) { return 'xmlhttprequest' === initiatorType; }],
    ["fetch" /* FETCH */, function (initiatorType) { return 'fetch' === initiatorType; }],
    ["beacon" /* BEACON */, function (initiatorType) { return 'beacon' === initiatorType; }],
    ["css" /* CSS */, function (_, path) { return /\.css$/i.test(path); }],
    ["js" /* JS */, function (_, path) { return /\.js$/i.test(path); }],
    [
        "image" /* IMAGE */,
        function (initiatorType, path) {
            return includes(['image', 'img', 'icon'], initiatorType) || /\.(gif|jpg|jpeg|tiff|png|svg|ico)$/i.exec(path) !== null;
        },
    ],
    ["font" /* FONT */, function (_, path) { return /\.(woff|eot|woff2|ttf)$/i.exec(path) !== null; }],
    [
        "media" /* MEDIA */,
        function (initiatorType, path) {
            return includes(['audio', 'video'], initiatorType) || /\.(mp3|mp4)$/i.exec(path) !== null;
        },
    ],
];
function computeResourceKind(timing) {
    var url = timing.name;
    if (!isValidUrl(url)) {
        addMonitoringMessage("Failed to construct URL for \"".concat(timing.name, "\""));
        return "other" /* OTHER */;
    }
    var path = getPathName(url);
    for (var _i = 0, RESOURCE_TYPES_1 = RESOURCE_TYPES; _i < RESOURCE_TYPES_1.length; _i++) {
        var _a = RESOURCE_TYPES_1[_i], type = _a[0], isType = _a[1];
        if (isType(timing.initiatorType, path)) {
            return type;
        }
    }
    return "other" /* OTHER */;
}
function areInOrder() {
    var numbers = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        numbers[_i] = arguments[_i];
    }
    for (var i = 1; i < numbers.length; i += 1) {
        if (numbers[i - 1] > numbers[i]) {
            return false;
        }
    }
    return true;
}
function isRequestKind(timing) {
    return timing.initiatorType === 'xmlhttprequest' || timing.initiatorType === 'fetch';
}
function computePerformanceResourceDuration(entry) {
    var duration = entry.duration, startTime = entry.startTime, responseEnd = entry.responseEnd;
    // Safari duration is always 0 on timings blocked by cross origin policies.
    if (duration === 0 && startTime < responseEnd) {
        return toServerDuration(elapsed(startTime, responseEnd));
    }
    return toServerDuration(duration);
}
function computePerformanceResourceDetails(entry) {
    var validEntry = toValidEntry(entry);
    if (!validEntry) {
        return undefined;
    }
    var startTime = validEntry.startTime, fetchStart = validEntry.fetchStart, redirectStart = validEntry.redirectStart, redirectEnd = validEntry.redirectEnd, domainLookupStart = validEntry.domainLookupStart, domainLookupEnd = validEntry.domainLookupEnd, connectStart = validEntry.connectStart, secureConnectionStart = validEntry.secureConnectionStart, connectEnd = validEntry.connectEnd, requestStart = validEntry.requestStart, responseStart = validEntry.responseStart, responseEnd = validEntry.responseEnd;
    var details = {
        download: formatTiming(startTime, responseStart, responseEnd),
        first_byte: formatTiming(startTime, requestStart, responseStart),
    };
    // Make sure a connection occurred
    if (connectEnd !== fetchStart) {
        details.connect = formatTiming(startTime, connectStart, connectEnd);
        // Make sure a secure connection occurred
        if (areInOrder(connectStart, secureConnectionStart, connectEnd)) {
            details.ssl = formatTiming(startTime, secureConnectionStart, connectEnd);
        }
    }
    // Make sure a domain lookup occurred
    if (domainLookupEnd !== fetchStart) {
        details.dns = formatTiming(startTime, domainLookupStart, domainLookupEnd);
    }
    if (hasRedirection(entry)) {
        details.redirect = formatTiming(startTime, redirectStart, redirectEnd);
    }
    return details;
}
function toValidEntry(entry) {
    // Ensure timings are in the right order. On top of filtering out potential invalid
    // RumPerformanceResourceTiming, it will ignore entries from requests where timings cannot be
    // collected, for example cross origin requests without a "Timing-Allow-Origin" header allowing
    // it.
    if (!areInOrder(entry.startTime, entry.fetchStart, entry.domainLookupStart, entry.domainLookupEnd, entry.connectStart, entry.connectEnd, entry.requestStart, entry.responseStart, entry.responseEnd)) {
        return undefined;
    }
    if (!hasRedirection(entry)) {
        return entry;
    }
    var redirectStart = entry.redirectStart, redirectEnd = entry.redirectEnd;
    // Firefox doesn't provide redirect timings on cross origin requests.
    // Provide a default for those.
    if (redirectStart < entry.startTime) {
        redirectStart = entry.startTime;
    }
    if (redirectEnd < entry.startTime) {
        redirectEnd = entry.fetchStart;
    }
    // Make sure redirect timings are in order
    if (!areInOrder(entry.startTime, redirectStart, redirectEnd, entry.fetchStart)) {
        return undefined;
    }
    return assign({}, entry, {
        redirectEnd: redirectEnd,
        redirectStart: redirectStart,
    });
}
function hasRedirection(entry) {
    // The only time fetchStart is different than startTime is if a redirection occurred.
    return entry.fetchStart !== entry.startTime;
}
function formatTiming(origin, start, end) {
    return {
        duration: toServerDuration(elapsed(start, end)),
        start: toServerDuration(elapsed(origin, start)),
    };
}
function computeSize(entry) {
    // Make sure a request actually occurred
    if (entry.startTime < entry.responseStart) {
        return entry.decodedBodySize;
    }
    return undefined;
}
function isAllowedRequestUrl(configuration, url) {
    return url && !configuration.isIntakeUrl(url);
}

var INITIAL_DOCUMENT_OUTDATED_TRACE_ID_THRESHOLD = 2 * ONE_MINUTE;
function getDocumentTraceId(document) {
    var data = getDocumentTraceDataFromMeta(document) || getDocumentTraceDataFromComment(document);
    if (!data || data.traceTime <= Date.now() - INITIAL_DOCUMENT_OUTDATED_TRACE_ID_THRESHOLD) {
        return undefined;
    }
    return data.traceId;
}
function getDocumentTraceDataFromMeta(document) {
    var traceIdMeta = document.querySelector('meta[name=dd-trace-id]');
    var traceTimeMeta = document.querySelector('meta[name=dd-trace-time]');
    return createDocumentTraceData(traceIdMeta && traceIdMeta.content, traceTimeMeta && traceTimeMeta.content);
}
function getDocumentTraceDataFromComment(document) {
    var comment = findTraceComment(document);
    if (!comment) {
        return undefined;
    }
    return createDocumentTraceData(findCommaSeparatedValue(comment, 'trace-id'), findCommaSeparatedValue(comment, 'trace-time'));
}
function createDocumentTraceData(traceId, rawTraceTime) {
    var traceTime = rawTraceTime && Number(rawTraceTime);
    if (!traceId || !traceTime) {
        return undefined;
    }
    return {
        traceId: traceId,
        traceTime: traceTime,
    };
}
function findTraceComment(document) {
    // 1. Try to find the comment as a direct child of the document
    // Note: TSLint advises to use a 'for of', but TS doesn't allow to use 'for of' if the iterated
    // value is not an array or string (here, a NodeList).
    // eslint-disable-next-line @typescript-eslint/prefer-for-of
    for (var i = 0; i < document.childNodes.length; i += 1) {
        var comment = getTraceCommentFromNode(document.childNodes[i]);
        if (comment) {
            return comment;
        }
    }
    // 2. If the comment is placed after the </html> tag, but have some space or new lines before or
    // after, the DOM parser will lift it (and the surrounding text) at the end of the <body> tag.
    // Try to look for the comment at the end of the <body> by by iterating over its child nodes in
    // reverse order, stopping if we come across a non-text node.
    if (document.body) {
        for (var i = document.body.childNodes.length - 1; i >= 0; i -= 1) {
            var node = document.body.childNodes[i];
            var comment = getTraceCommentFromNode(node);
            if (comment) {
                return comment;
            }
            if (!isTextNode(node)) {
                break;
            }
        }
    }
}
function getTraceCommentFromNode(node) {
    if (node && isCommentNode(node)) {
        var match = /^\s*DATADOG;(.*?)\s*$/.exec(node.data);
        if (match) {
            return match[1];
        }
    }
}
function isCommentNode(node) {
    return node.nodeName === '#comment';
}
function isTextNode(node) {
    return node.nodeName === '#text';
}

function supportPerformanceObject() {
    return window.performance !== undefined && 'getEntries' in performance;
}
function supportPerformanceTimingEvent(entryType) {
    return (window.PerformanceObserver &&
        PerformanceObserver.supportedEntryTypes !== undefined &&
        PerformanceObserver.supportedEntryTypes.includes(entryType));
}
function supportPerformanceEntry() {
    // Safari 10 doesn't support PerformanceEntry
    return typeof PerformanceEntry === 'function';
}
function startPerformanceCollection(lifeCycle, configuration) {
    retrieveInitialDocumentResourceTiming(function (timing) {
        handleRumPerformanceEntries(lifeCycle, configuration, [timing]);
    });
    if (supportPerformanceObject()) {
        var performanceEntries_1 = performance.getEntries();
        // Because the performance entry list can be quite large
        // delay the computation to prevent the SDK from blocking the main thread on init
        setTimeout(monitor(function () { return handleRumPerformanceEntries(lifeCycle, configuration, performanceEntries_1); }));
    }
    if (window.PerformanceObserver) {
        var handlePerformanceEntryList_1 = monitor(function (entries) {
            return handleRumPerformanceEntries(lifeCycle, configuration, entries.getEntries());
        });
        var mainEntries = ['resource', 'navigation', 'longtask', 'paint'];
        var experimentalEntries = ['largest-contentful-paint', 'first-input', 'layout-shift'];
        try {
            // Experimental entries are not retrieved by performance.getEntries()
            // use a single PerformanceObserver with buffered flag by type
            // to get values that could happen before SDK init
            experimentalEntries.forEach(function (type) {
                var observer = new PerformanceObserver(handlePerformanceEntryList_1);
                observer.observe({ type: type, buffered: true });
            });
        }
        catch (e) {
            // Some old browser versions (ex: chrome 67) don't support the PerformanceObserver type and buffered options
            // In these cases, fallback to PerformanceObserver with entryTypes
            mainEntries.push.apply(mainEntries, experimentalEntries);
        }
        var mainObserver = new PerformanceObserver(handlePerformanceEntryList_1);
        mainObserver.observe({ entryTypes: mainEntries });
        if (supportPerformanceObject() && 'addEventListener' in performance) {
            // https://bugzilla.mozilla.org/show_bug.cgi?id=1559377
            performance.addEventListener('resourcetimingbufferfull', function () {
                performance.clearResourceTimings();
            });
        }
    }
    if (!supportPerformanceTimingEvent('navigation')) {
        retrieveNavigationTiming(function (timing) {
            handleRumPerformanceEntries(lifeCycle, configuration, [timing]);
        });
    }
    if (!supportPerformanceTimingEvent('first-input')) {
        retrieveFirstInputTiming(function (timing) {
            handleRumPerformanceEntries(lifeCycle, configuration, [timing]);
        });
    }
}
function retrieveInitialDocumentResourceTiming(callback) {
    runOnReadyState('interactive', function () {
        var timing;
        var forcedAttributes = {
            entryType: 'resource',
            initiatorType: FAKE_INITIAL_DOCUMENT,
            traceId: getDocumentTraceId(document),
        };
        if (supportPerformanceTimingEvent('navigation') && performance.getEntriesByType('navigation').length > 0) {
            var navigationEntry = performance.getEntriesByType('navigation')[0];
            timing = assign(navigationEntry.toJSON(), forcedAttributes);
        }
        else {
            var relativePerformanceTiming = computeRelativePerformanceTiming();
            timing = assign(relativePerformanceTiming, {
                decodedBodySize: 0,
                duration: relativePerformanceTiming.responseEnd,
                name: window.location.href,
                startTime: 0,
            }, forcedAttributes);
        }
        callback(timing);
    });
}
function retrieveNavigationTiming(callback) {
    function sendFakeTiming() {
        callback(assign(computeRelativePerformanceTiming(), {
            entryType: 'navigation',
        }));
    }
    runOnReadyState('complete', function () {
        // Send it a bit after the actual load event, so the "loadEventEnd" timing is accurate
        setTimeout(monitor(sendFakeTiming));
    });
}
/**
 * first-input timing entry polyfill based on
 * https://github.com/GoogleChrome/web-vitals/blob/master/src/lib/polyfills/firstInputPolyfill.ts
 */
function retrieveFirstInputTiming(callback) {
    var startTimeStamp = Date.now();
    var timingSent = false;
    var removeEventListeners = addEventListeners(window, ["click" /* CLICK */, "mousedown" /* MOUSE_DOWN */, "keydown" /* KEY_DOWN */, "touchstart" /* TOUCH_START */, "pointerdown" /* POINTER_DOWN */], function (evt) {
        // Only count cancelable events, which should trigger behavior important to the user.
        if (!evt.cancelable) {
            return;
        }
        // This timing will be used to compute the "first Input delay", which is the delta between
        // when the system received the event (e.g. evt.timeStamp) and when it could run the callback
        // (e.g. performance.now()).
        var timing = {
            entryType: 'first-input',
            processingStart: relativeNow(),
            startTime: evt.timeStamp,
        };
        if (evt.type === "pointerdown" /* POINTER_DOWN */) {
            sendTimingIfPointerIsNotCancelled(timing);
        }
        else {
            sendTiming(timing);
        }
    }, { passive: true, capture: true }).stop;
    /**
     * Pointer events are a special case, because they can trigger main or compositor thread behavior.
     * We differentiate these cases based on whether or not we see a pointercancel event, which are
     * fired when we scroll. If we're scrolling we don't need to report input delay since FID excludes
     * scrolling and pinch/zooming.
     */
    function sendTimingIfPointerIsNotCancelled(timing) {
        addEventListeners(window, ["pointerup" /* POINTER_UP */, "pointercancel" /* POINTER_CANCEL */], function (event) {
            if (event.type === "pointerup" /* POINTER_UP */) {
                sendTiming(timing);
            }
        }, { once: true });
    }
    function sendTiming(timing) {
        if (!timingSent) {
            timingSent = true;
            removeEventListeners();
            // In some cases the recorded delay is clearly wrong, e.g. it's negative or it's larger than
            // the time between now and when the page was loaded.
            // - https://github.com/GoogleChromeLabs/first-input-delay/issues/4
            // - https://github.com/GoogleChromeLabs/first-input-delay/issues/6
            // - https://github.com/GoogleChromeLabs/first-input-delay/issues/7
            var delay = timing.processingStart - timing.startTime;
            if (delay >= 0 && delay < Date.now() - startTimeStamp) {
                callback(timing);
            }
        }
    }
}
function computeRelativePerformanceTiming() {
    var result = {};
    var timing = performance.timing;
    for (var key in timing) {
        if (isNumber(timing[key])) {
            var numberKey = key;
            // eslint-disable-next-line @typescript-eslint/no-unnecessary-type-assertion
            var timingElement = timing[numberKey];
            result[numberKey] = timingElement === 0 ? 0 : getRelativeTime(timingElement);
        }
    }
    return result;
}
function handleRumPerformanceEntries(lifeCycle, configuration, entries) {
    var rumPerformanceEntries = entries.filter(function (entry) {
        return entry.entryType === 'resource' ||
            entry.entryType === 'navigation' ||
            entry.entryType === 'paint' ||
            entry.entryType === 'longtask' ||
            entry.entryType === 'largest-contentful-paint' ||
            entry.entryType === 'first-input' ||
            entry.entryType === 'layout-shift';
    });
    var rumAllowedPerformanceEntries = rumPerformanceEntries.filter(function (entry) { return !isIncompleteNavigation(entry) && !isForbiddenResource(configuration, entry); });
    if (rumAllowedPerformanceEntries.length) {
        lifeCycle.notify(0 /* PERFORMANCE_ENTRIES_COLLECTED */, rumAllowedPerformanceEntries);
    }
}
function isIncompleteNavigation(entry) {
    return entry.entryType === 'navigation' && entry.loadEventEnd <= 0;
}
function isForbiddenResource(configuration, entry) {
    return entry.entryType === 'resource' && !isAllowedRequestUrl(configuration, entry.name);
}

function getCiTestContext() {
    var _a;
    var testExecutionId = (_a = window.Cypress) === null || _a === void 0 ? void 0 : _a.env('traceId');
    if (typeof testExecutionId === 'string') {
        return {
            test_execution_id: testExecutionId,
        };
    }
}

var VIEW_EVENTS_MODIFIABLE_FIELD_PATHS = [
    // Fields with sensitive data
    'view.url',
    'view.referrer',
    'action.target.name',
    'error.message',
    'error.stack',
    'error.resource.url',
    'resource.url',
];
var OTHER_EVENTS_MODIFIABLE_FIELD_PATHS = VIEW_EVENTS_MODIFIABLE_FIELD_PATHS.concat([
    // User-customizable field
    'context',
]);
function startRumAssembly(configuration, lifeCycle, sessionManager, parentContexts, urlContexts, getCommonContext) {
    var _a;
    var reportError = function (error) {
        lifeCycle.notify(14 /* RAW_ERROR_COLLECTED */, { error: error });
    };
    var eventRateLimiters = (_a = {},
        _a["error" /* ERROR */] = createEventRateLimiter("error" /* ERROR */, configuration.eventRateLimiterThreshold, reportError),
        _a["action" /* ACTION */] = createEventRateLimiter("action" /* ACTION */, configuration.eventRateLimiterThreshold, reportError),
        _a);
    var syntheticsContext = getSyntheticsContext();
    var ciTestContext = getCiTestContext();
    lifeCycle.subscribe(12 /* RAW_RUM_EVENT_COLLECTED */, function (_a) {
        var startTime = _a.startTime, rawRumEvent = _a.rawRumEvent, domainContext = _a.domainContext, savedCommonContext = _a.savedCommonContext, customerContext = _a.customerContext;
        var viewContext = parentContexts.findView(startTime);
        var urlContext = urlContexts.findUrl(startTime);
        // allow to send events if the session was tracked when they start
        // except for views which are continuously updated
        // TODO: stop sending view updates when session is expired
        var session = sessionManager.findTrackedSession(rawRumEvent.type !== "view" /* VIEW */ ? startTime : undefined);
        if (session && viewContext && urlContext) {
            var actionContext = parentContexts.findAction(startTime);
            var commonContext = savedCommonContext || getCommonContext();
            var rumContext = {
                _dd: {
                    format_version: 2,
                    drift: currentDrift(),
                    session: {
                        plan: session.hasReplayPlan ? 2 /* REPLAY */ : 1 /* LITE */,
                    },
                    browser_sdk_version: canUseEventBridge() ? "4.6.1" : undefined,
                },
                application: {
                    id: configuration.applicationId,
                },
                date: timeStampNow(),
                service: configuration.service,
                source: 'browser',
                session: {
                    id: session.id,
                    type: syntheticsContext ? "synthetics" /* SYNTHETICS */ : ciTestContext ? "ci_test" /* CI_TEST */ : "user" /* USER */,
                },
                synthetics: syntheticsContext,
                ci_test: ciTestContext,
            };
            var serverRumEvent = (needToAssembleWithAction(rawRumEvent)
                ? combine(rumContext, urlContext, viewContext, actionContext, rawRumEvent)
                : combine(rumContext, urlContext, viewContext, rawRumEvent));
            serverRumEvent.context = combine(commonContext.context, customerContext);
            if (!('has_replay' in serverRumEvent.session)) {
                serverRumEvent.session.has_replay = commonContext.hasReplay;
            }
            if (!isEmptyObject(commonContext.user)) {
                serverRumEvent.usr = commonContext.user;
            }
            if (shouldSend(serverRumEvent, configuration.beforeSend, domainContext, eventRateLimiters)) {
                if (isEmptyObject(serverRumEvent.context)) {
                    delete serverRumEvent.context;
                }
                lifeCycle.notify(13 /* RUM_EVENT_COLLECTED */, serverRumEvent);
            }
        }
    });
}
function shouldSend(event, beforeSend, domainContext, eventRateLimiters) {
    var _a;
    if (beforeSend) {
        var result = limitModification(event, event.type === "view" /* VIEW */ ? VIEW_EVENTS_MODIFIABLE_FIELD_PATHS : OTHER_EVENTS_MODIFIABLE_FIELD_PATHS, function (event) { return beforeSend(event, domainContext); });
        if (result === false && event.type !== "view" /* VIEW */) {
            return false;
        }
        if (result === false) {
            display.warn("Can't dismiss view events using beforeSend!");
        }
    }
    var rateLimitReached = (_a = eventRateLimiters[event.type]) === null || _a === void 0 ? void 0 : _a.isLimitReached();
    return !rateLimitReached;
}
function needToAssembleWithAction(event) {
    return ["error" /* ERROR */, "resource" /* RESOURCE */, "long_task" /* LONG_TASK */].indexOf(event.type) !== -1;
}

// Arbitrary value to cap number of element mostly for backend & to save bandwidth
var MAX_NUMBER_OF_SELECTABLE_FOREGROUND_PERIODS = 500;
// Arbitrary value to cap number of element mostly for memory consumption in the browser
var MAX_NUMBER_OF_STORED_FOREGROUND_PERIODS = 2500;
var foregroundPeriods = [];
function startForegroundContexts() {
    if (document.hasFocus()) {
        addNewForegroundPeriod();
    }
    var stopForegroundTracking = trackFocus(addNewForegroundPeriod).stop;
    var stopBlurTracking = trackBlur(closeForegroundPeriod).stop;
    return {
        isInForegroundAt: isInForegroundAt,
        selectInForegroundPeriodsFor: selectInForegroundPeriodsFor,
        stop: function () {
            foregroundPeriods = [];
            stopForegroundTracking();
            stopBlurTracking();
        },
    };
}
function addNewForegroundPeriod() {
    if (foregroundPeriods.length > MAX_NUMBER_OF_STORED_FOREGROUND_PERIODS) {
        return;
    }
    var currentForegroundPeriod = foregroundPeriods[foregroundPeriods.length - 1];
    var now = relativeNow();
    if (currentForegroundPeriod !== undefined && currentForegroundPeriod.end === undefined) {
        return;
    }
    foregroundPeriods.push({
        start: now,
    });
}
function closeForegroundPeriod() {
    if (foregroundPeriods.length === 0) {
        return;
    }
    var currentForegroundPeriod = foregroundPeriods[foregroundPeriods.length - 1];
    var now = relativeNow();
    if (currentForegroundPeriod.end !== undefined) {
        return;
    }
    currentForegroundPeriod.end = now;
}
function trackFocus(onFocusChange) {
    return addEventListener(window, "focus" /* FOCUS */, function (event) {
        if (!event.isTrusted) {
            return;
        }
        onFocusChange();
    });
}
function trackBlur(onBlurChange) {
    return addEventListener(window, "blur" /* BLUR */, function (event) {
        if (!event.isTrusted) {
            return;
        }
        onBlurChange();
    });
}
function isInForegroundAt(startTime) {
    for (var i = foregroundPeriods.length - 1; i >= 0; i--) {
        var foregroundPeriod = foregroundPeriods[i];
        if (foregroundPeriod.end !== undefined && startTime > foregroundPeriod.end) {
            break;
        }
        if (startTime > foregroundPeriod.start &&
            (foregroundPeriod.end === undefined || startTime < foregroundPeriod.end)) {
            return true;
        }
    }
    return false;
}
function selectInForegroundPeriodsFor(eventStartTime, duration) {
    // eslint-disable-next-line @typescript-eslint/restrict-plus-operands
    var eventEndTime = (eventStartTime + duration);
    var filteredForegroundPeriods = [];
    var earliestIndex = Math.max(0, foregroundPeriods.length - MAX_NUMBER_OF_SELECTABLE_FOREGROUND_PERIODS);
    for (var i = foregroundPeriods.length - 1; i >= earliestIndex; i--) {
        var foregroundPeriod = foregroundPeriods[i];
        if (foregroundPeriod.end !== undefined && eventStartTime > foregroundPeriod.end) {
            // event starts after the end of the current focus period
            // since the array is sorted, we can stop looking for foreground periods
            break;
        }
        if (eventEndTime < foregroundPeriod.start) {
            // event ends before the start of the current focus period
            // continue to previous one
            continue;
        }
        var startTime = eventStartTime > foregroundPeriod.start ? eventStartTime : foregroundPeriod.start;
        var startDuration = elapsed(eventStartTime, startTime);
        var endTime = foregroundPeriod.end === undefined || eventEndTime < foregroundPeriod.end ? eventEndTime : foregroundPeriod.end;
        var endDuration = elapsed(startTime, endTime);
        filteredForegroundPeriods.unshift({
            start: toServerDuration(startDuration),
            duration: toServerDuration(endDuration),
        });
    }
    return filteredForegroundPeriods;
}

/**
 * Internal context keep returning v1 format
 * to not break compatibility with logs data format
 */
function startInternalContext(applicationId, sessionManager, parentContexts, urlContexts) {
    return {
        get: function (startTime) {
            var viewContext = parentContexts.findView(startTime);
            var urlContext = urlContexts.findUrl(startTime);
            var session = sessionManager.findTrackedSession(startTime);
            if (session && viewContext && urlContext) {
                var actionContext = parentContexts.findAction(startTime);
                return {
                    application_id: applicationId,
                    session_id: session.id,
                    user_action: actionContext
                        ? {
                            id: actionContext.action.id,
                        }
                        : undefined,
                    view: assign({}, viewContext.view, urlContext.view),
                };
            }
        },
    };
}

var LifeCycle = /** @class */ (function () {
    function LifeCycle() {
        this.callbacks = {};
    }
    LifeCycle.prototype.notify = function (eventType, data) {
        var eventCallbacks = this.callbacks[eventType];
        if (eventCallbacks) {
            eventCallbacks.forEach(function (callback) { return callback(data); });
        }
    };
    LifeCycle.prototype.subscribe = function (eventType, callback) {
        var _this = this;
        if (!this.callbacks[eventType]) {
            this.callbacks[eventType] = [];
        }
        this.callbacks[eventType].push(callback);
        return {
            unsubscribe: function () {
                _this.callbacks[eventType] = _this.callbacks[eventType].filter(function (other) { return callback !== other; });
            },
        };
    };
    return LifeCycle;
}());

var VIEW_CONTEXT_TIME_OUT_DELAY = SESSION_TIME_OUT_DELAY;
var ACTION_CONTEXT_TIME_OUT_DELAY = 5 * ONE_MINUTE; // arbitrary
function startParentContexts(lifeCycle) {
    var viewContextHistory = new ContextHistory(VIEW_CONTEXT_TIME_OUT_DELAY);
    var actionContextHistory = new ContextHistory(ACTION_CONTEXT_TIME_OUT_DELAY);
    lifeCycle.subscribe(4 /* VIEW_CREATED */, function (view) {
        viewContextHistory.setCurrent(buildViewContext(view), view.startClocks.relative);
    });
    lifeCycle.subscribe(5 /* VIEW_UPDATED */, function (view) {
        // A view can be updated after its end.  We have to ensure that the view being updated is the
        // most recently created.
        var current = viewContextHistory.getCurrent();
        if (current && current.view.id === view.id) {
            viewContextHistory.setCurrent(buildViewContext(view), view.startClocks.relative);
        }
    });
    lifeCycle.subscribe(6 /* VIEW_ENDED */, function (_a) {
        var endClocks = _a.endClocks;
        viewContextHistory.closeCurrent(endClocks.relative);
    });
    lifeCycle.subscribe(1 /* AUTO_ACTION_CREATED */, function (action) {
        actionContextHistory.setCurrent(buildActionContext(action), action.startClocks.relative);
    });
    lifeCycle.subscribe(2 /* AUTO_ACTION_COMPLETED */, function (action) {
        if (actionContextHistory.getCurrent()) {
            // eslint-disable-next-line @typescript-eslint/restrict-plus-operands
            var actionEndTime = (action.startClocks.relative + action.duration);
            actionContextHistory.closeCurrent(actionEndTime);
        }
    });
    lifeCycle.subscribe(3 /* AUTO_ACTION_DISCARDED */, function () {
        actionContextHistory.clearCurrent();
    });
    lifeCycle.subscribe(10 /* SESSION_RENEWED */, function () {
        viewContextHistory.reset();
        actionContextHistory.reset();
    });
    function buildViewContext(view) {
        return {
            view: {
                id: view.id,
                name: view.name,
            },
        };
    }
    function buildActionContext(action) {
        return { action: { id: action.id } };
    }
    return {
        findAction: function (startTime) { return actionContextHistory.find(startTime); },
        findView: function (startTime) { return viewContextHistory.find(startTime); },
        stop: function () {
            viewContextHistory.stop();
            actionContextHistory.stop();
        },
    };
}

/**
 * Clear tracing information to avoid incomplete traces. Ideally, we should do it when the the
 * request did not reach the server, but we the browser does not expose this. So, we clear tracing
 * information if the request ended with status 0 without being aborted by the application.
 *
 * Reasoning:
 *
 * * Applications are usually aborting requests after a bit of time, for example when the user is
 * typing (autocompletion) or navigating away (in a SPA). With a performant device and good
 * network conditions, the request is likely to reach the server before being canceled.
 *
 * * Requests aborted otherwise (ex: lack of internet, CORS issue, blocked by a privacy extension)
 * are likely to finish quickly and without reaching the server.
 *
 * Of course it might not be the case every time, but it should limit having incomplete traces a
 * bit..
 * */
function clearTracingIfNeeded(context) {
    if (context.status === 0 && !context.isAborted) {
        context.traceId = undefined;
        context.spanId = undefined;
    }
}
function startTracer(configuration, sessionManager) {
    return {
        clearTracingIfNeeded: clearTracingIfNeeded,
        traceFetch: function (context) {
            return injectHeadersIfTracingAllowed(configuration, context, sessionManager, function (tracingHeaders) {
                var _a;
                if (context.input instanceof Request && !((_a = context.init) === null || _a === void 0 ? void 0 : _a.headers)) {
                    context.input = new Request(context.input);
                    Object.keys(tracingHeaders).forEach(function (key) {
                        context.input.headers.append(key, tracingHeaders[key]);
                    });
                }
                else {
                    context.init = shallowClone(context.init);
                    var headers_1 = [];
                    if (context.init.headers instanceof Headers) {
                        context.init.headers.forEach(function (value, key) {
                            headers_1.push([key, value]);
                        });
                    }
                    else if (Array.isArray(context.init.headers)) {
                        context.init.headers.forEach(function (header) {
                            headers_1.push(header);
                        });
                    }
                    else if (context.init.headers) {
                        Object.keys(context.init.headers).forEach(function (key) {
                            headers_1.push([key, context.init.headers[key]]);
                        });
                    }
                    context.init.headers = headers_1.concat(objectEntries(tracingHeaders));
                }
            });
        },
        traceXhr: function (context, xhr) {
            return injectHeadersIfTracingAllowed(configuration, context, sessionManager, function (tracingHeaders) {
                Object.keys(tracingHeaders).forEach(function (name) {
                    xhr.setRequestHeader(name, tracingHeaders[name]);
                });
            });
        },
    };
}
function injectHeadersIfTracingAllowed(configuration, context, sessionManager, inject) {
    if (!isTracingSupported() || !isAllowedUrl(configuration, context.url) || !sessionManager.findTrackedSession()) {
        return;
    }
    context.traceId = new TraceIdentifier();
    context.spanId = new TraceIdentifier();
    inject(makeTracingHeaders(context.traceId, context.spanId));
}
function isAllowedUrl(configuration, requestUrl) {
    var requestOrigin = getOrigin(requestUrl);
    for (var _i = 0, _a = configuration.allowedTracingOrigins; _i < _a.length; _i++) {
        var allowedOrigin = _a[_i];
        if (requestOrigin === allowedOrigin || (allowedOrigin instanceof RegExp && allowedOrigin.test(requestOrigin))) {
            return true;
        }
    }
    return false;
}
function isTracingSupported() {
    return getCrypto() !== undefined;
}
function getCrypto() {
    return window.crypto || window.msCrypto;
}
function makeTracingHeaders(traceId, spanId) {
    return {
        'x-datadog-origin': 'rum',
        'x-datadog-parent-id': spanId.toDecimalString(),
        'x-datadog-sampled': '1',
        'x-datadog-sampling-priority': '1',
        'x-datadog-trace-id': traceId.toDecimalString(),
    };
}
/* eslint-disable no-bitwise */
var TraceIdentifier = /** @class */ (function () {
    function TraceIdentifier() {
        this.buffer = new Uint8Array(8);
        getCrypto().getRandomValues(this.buffer);
        this.buffer[0] = this.buffer[0] & 0x7f; // force 63-bit
    }
    TraceIdentifier.prototype.toString = function (radix) {
        var high = this.readInt32(0);
        var low = this.readInt32(4);
        var str = '';
        do {
            var mod = (high % radix) * 4294967296 + low;
            high = Math.floor(high / radix);
            low = Math.floor(mod / radix);
            str = (mod % radix).toString(radix) + str;
        } while (high || low);
        return str;
    };
    /**
     * Format used everywhere except the trace intake
     */
    TraceIdentifier.prototype.toDecimalString = function () {
        return this.toString(10);
    };
    TraceIdentifier.prototype.readInt32 = function (offset) {
        return (this.buffer[offset] * 16777216 +
            (this.buffer[offset + 1] << 16) +
            (this.buffer[offset + 2] << 8) +
            this.buffer[offset + 3]);
    };
    return TraceIdentifier;
}());
/* eslint-enable no-bitwise */

var nextRequestIndex = 1;
function startRequestCollection(lifeCycle, configuration, sessionManager) {
    var tracer = startTracer(configuration, sessionManager);
    trackXhr(lifeCycle, configuration, tracer);
    trackFetch(lifeCycle, configuration, tracer);
}
function trackXhr(lifeCycle, configuration, tracer) {
    var subscription = initXhrObservable().subscribe(function (rawContext) {
        var context = rawContext;
        if (!isAllowedRequestUrl(configuration, context.url)) {
            return;
        }
        switch (context.state) {
            case 'start':
                tracer.traceXhr(context, context.xhr);
                context.requestIndex = getNextRequestIndex();
                lifeCycle.notify(7 /* REQUEST_STARTED */, {
                    requestIndex: context.requestIndex,
                });
                break;
            case 'complete':
                tracer.clearTracingIfNeeded(context);
                lifeCycle.notify(8 /* REQUEST_COMPLETED */, {
                    duration: context.duration,
                    method: context.method,
                    requestIndex: context.requestIndex,
                    spanId: context.spanId,
                    startClocks: context.startClocks,
                    status: context.status,
                    traceId: context.traceId,
                    type: "xhr" /* XHR */,
                    url: context.url,
                    xhr: context.xhr,
                });
                break;
        }
    });
    return { stop: function () { return subscription.unsubscribe(); } };
}
function trackFetch(lifeCycle, configuration, tracer) {
    var subscription = initFetchObservable().subscribe(function (rawContext) {
        var context = rawContext;
        if (!isAllowedRequestUrl(configuration, context.url)) {
            return;
        }
        switch (context.state) {
            case 'start':
                tracer.traceFetch(context);
                context.requestIndex = getNextRequestIndex();
                lifeCycle.notify(7 /* REQUEST_STARTED */, {
                    requestIndex: context.requestIndex,
                });
                break;
            case 'complete':
                tracer.clearTracingIfNeeded(context);
                lifeCycle.notify(8 /* REQUEST_COMPLETED */, {
                    duration: context.duration,
                    method: context.method,
                    requestIndex: context.requestIndex,
                    responseType: context.responseType,
                    spanId: context.spanId,
                    startClocks: context.startClocks,
                    status: context.status,
                    traceId: context.traceId,
                    type: "fetch" /* FETCH */,
                    url: context.url,
                    response: context.response,
                    init: context.init,
                    input: context.input,
                });
                break;
        }
    });
    return { stop: function () { return subscription.unsubscribe(); } };
}
function getNextRequestIndex() {
    var result = nextRequestIndex;
    nextRequestIndex += 1;
    return result;
}

function trackEventCounts(lifeCycle, callback) {
    if (callback === void 0) { callback = noop; }
    var eventCounts = {
        errorCount: 0,
        longTaskCount: 0,
        resourceCount: 0,
        userActionCount: 0,
    };
    var subscription = lifeCycle.subscribe(13 /* RUM_EVENT_COLLECTED */, function (_a) {
        var type = _a.type;
        switch (type) {
            case "error" /* ERROR */:
                eventCounts.errorCount += 1;
                callback(eventCounts);
                break;
            case "action" /* ACTION */:
                eventCounts.userActionCount += 1;
                callback(eventCounts);
                break;
            case "long_task" /* LONG_TASK */:
                eventCounts.longTaskCount += 1;
                callback(eventCounts);
                break;
            case "resource" /* RESOURCE */:
                eventCounts.resourceCount += 1;
                callback(eventCounts);
                break;
        }
    });
    return {
        stop: function () {
            subscription.unsubscribe();
        },
        eventCounts: eventCounts,
    };
}

// Delay to wait for a page activity to validate the tracking process
var PAGE_ACTIVITY_VALIDATION_DELAY = 100;
// Delay to wait after a page activity to end the tracking process
var PAGE_ACTIVITY_END_DELAY = 100;
/**
 * Wait for the next idle page time
 *
 * Detection lifecycle:
 * ```
 *                           Wait idle page
 *              .-------------------'--------------------.
 *              v                                        v
 *     [Wait for a page activity ]          [Wait for a maximum duration]
 *     [timeout: VALIDATION_DELAY]          [  timeout: maxDuration     ]
 *          /                  \                           |
 *         v                    v                          |
 *  [No page activity]   [Page activity]                   |
 *         |                   |,----------------------.   |
 *         v                   v                       |   |
 *     (Discard)     [Wait for a page activity]        |   |
 *                   [   timeout: END_DELAY   ]        |   |
 *                       /                \            |   |
 *                      v                  v           |   |
 *             [No page activity]    [Page activity]   |   |
 *                      |                 |            |   |
 *                      |                 '------------'   |
 *                      '-----------. ,--------------------'
 *                                   v
 *                                 (End)
 * ```
 *
 * Note: by assuming that maxDuration is greater than VALIDATION_DELAY, we are sure that if the
 * process is still alive after maxDuration, it has been validated.
 */
function waitIdlePage(lifeCycle, domMutationObservable, idlePageCallback, maxDuration) {
    var pageActivityObservable = createPageActivityObservable(lifeCycle, domMutationObservable);
    return doWaitIdlePage(pageActivityObservable, idlePageCallback, maxDuration);
}
function doWaitIdlePage(pageActivityObservable, idlePageCallback, maxDuration) {
    var idleTimeoutId;
    var hasCompleted = false;
    var validationTimeoutId = setTimeout(monitor(function () { return complete({ hadActivity: false }); }), PAGE_ACTIVITY_VALIDATION_DELAY);
    var maxDurationTimeoutId = maxDuration &&
        setTimeout(monitor(function () { return complete({ hadActivity: true, end: timeStampNow() }); }), maxDuration);
    var pageActivitySubscription = pageActivityObservable.subscribe(function (_a) {
        var isBusy = _a.isBusy;
        clearTimeout(validationTimeoutId);
        clearTimeout(idleTimeoutId);
        var lastChangeTime = timeStampNow();
        if (!isBusy) {
            idleTimeoutId = setTimeout(monitor(function () { return complete({ hadActivity: true, end: lastChangeTime }); }), PAGE_ACTIVITY_END_DELAY);
        }
    });
    var stop = function () {
        hasCompleted = true;
        clearTimeout(validationTimeoutId);
        clearTimeout(idleTimeoutId);
        clearTimeout(maxDurationTimeoutId);
        pageActivitySubscription.unsubscribe();
    };
    function complete(event) {
        if (hasCompleted) {
            return;
        }
        stop();
        idlePageCallback(event);
    }
    return { stop: stop };
}
function createPageActivityObservable(lifeCycle, domMutationObservable) {
    var observable = new Observable(function () {
        var subscriptions = [];
        var firstRequestIndex;
        var pendingRequestsCount = 0;
        subscriptions.push(domMutationObservable.subscribe(function () { return notifyPageActivity(pendingRequestsCount); }), lifeCycle.subscribe(0 /* PERFORMANCE_ENTRIES_COLLECTED */, function (entries) {
            if (entries.some(function (_a) {
                var entryType = _a.entryType;
                return entryType === 'resource';
            })) {
                notifyPageActivity(pendingRequestsCount);
            }
        }), lifeCycle.subscribe(7 /* REQUEST_STARTED */, function (startEvent) {
            if (firstRequestIndex === undefined) {
                firstRequestIndex = startEvent.requestIndex;
            }
            notifyPageActivity(++pendingRequestsCount);
        }), lifeCycle.subscribe(8 /* REQUEST_COMPLETED */, function (request) {
            // If the request started before the tracking start, ignore it
            if (firstRequestIndex === undefined || request.requestIndex < firstRequestIndex) {
                return;
            }
            notifyPageActivity(--pendingRequestsCount);
        }));
        return function () { return subscriptions.forEach(function (s) { return s.unsubscribe(); }); };
    });
    function notifyPageActivity(pendingRequestsCount) {
        observable.notify({ isBusy: pendingRequestsCount > 0 });
    }
    return observable;
}

/**
 * Get the action name from the attribute 'data-dd-action-name' on the element or any of its parent.
 * It can also be retrieved from a user defined attribute.
 */
var DEFAULT_PROGRAMMATIC_ATTRIBUTE = 'data-dd-action-name';
function getActionNameFromElement(element, userProgrammaticAttribute) {
    // Proceed to get the action name in two steps:
    // * first, get the name programmatically, explicitly defined by the user.
    // * then, use strategies that are known to return good results. Those strategies will be used on
    //   the element and a few parents, but it's likely that they won't succeed at all.
    // * if no name is found this way, use strategies returning less accurate names as a fallback.
    //   Those are much likely to succeed.
    return (getActionNameFromElementProgrammatically(element, DEFAULT_PROGRAMMATIC_ATTRIBUTE) ||
        (userProgrammaticAttribute && getActionNameFromElementProgrammatically(element, userProgrammaticAttribute)) ||
        getActionNameFromElementForStrategies(element, userProgrammaticAttribute, priorityStrategies) ||
        getActionNameFromElementForStrategies(element, userProgrammaticAttribute, fallbackStrategies) ||
        '');
}
function getActionNameFromElementProgrammatically(targetElement, programmaticAttribute) {
    var elementWithAttribute;
    // We don't use getActionNameFromElementForStrategies here, because we want to consider all parents,
    // without limit. It is up to the user to declare a relevant naming strategy.
    // If available, use element.closest() to match get the attribute from the element or any of its
    // parent.  Else fallback to a more traditional implementation.
    if (supportsElementClosest()) {
        elementWithAttribute = targetElement.closest("[".concat(programmaticAttribute, "]"));
    }
    else {
        var element = targetElement;
        while (element) {
            if (element.hasAttribute(programmaticAttribute)) {
                elementWithAttribute = element;
                break;
            }
            element = element.parentElement;
        }
    }
    if (!elementWithAttribute) {
        return;
    }
    var name = elementWithAttribute.getAttribute(programmaticAttribute);
    return truncate(normalizeWhitespace(name.trim()));
}
var priorityStrategies = [
    // associated LABEL text
    function (element, userProgrammaticAttribute) {
        // IE does not support element.labels, so we fallback to a CSS selector based on the element id
        // instead
        if (supportsLabelProperty()) {
            if ('labels' in element && element.labels && element.labels.length > 0) {
                return getTextualContent(element.labels[0], userProgrammaticAttribute);
            }
        }
        else if (element.id) {
            var label = element.ownerDocument && element.ownerDocument.querySelector("label[for=\"".concat(element.id.replace('"', '\\"'), "\"]"));
            return label && getTextualContent(label, userProgrammaticAttribute);
        }
    },
    // INPUT button (and associated) value
    function (element) {
        if (element.nodeName === 'INPUT') {
            var input = element;
            var type = input.getAttribute('type');
            if (type === 'button' || type === 'submit' || type === 'reset') {
                return input.value;
            }
        }
    },
    // BUTTON, LABEL or button-like element text
    function (element, userProgrammaticAttribute) {
        if (element.nodeName === 'BUTTON' || element.nodeName === 'LABEL' || element.getAttribute('role') === 'button') {
            return getTextualContent(element, userProgrammaticAttribute);
        }
    },
    function (element) { return element.getAttribute('aria-label'); },
    // associated element text designated by the aria-labelledby attribute
    function (element, userProgrammaticAttribute) {
        var labelledByAttribute = element.getAttribute('aria-labelledby');
        if (labelledByAttribute) {
            return labelledByAttribute
                .split(/\s+/)
                .map(function (id) { return getElementById(element, id); })
                .filter(function (label) { return Boolean(label); })
                .map(function (element) { return getTextualContent(element, userProgrammaticAttribute); })
                .join(' ');
        }
    },
    function (element) { return element.getAttribute('alt'); },
    function (element) { return element.getAttribute('name'); },
    function (element) { return element.getAttribute('title'); },
    function (element) { return element.getAttribute('placeholder'); },
    // SELECT first OPTION text
    function (element, userProgrammaticAttribute) {
        if ('options' in element && element.options.length > 0) {
            return getTextualContent(element.options[0], userProgrammaticAttribute);
        }
    },
];
var fallbackStrategies = [
    function (element, userProgrammaticAttribute) { return getTextualContent(element, userProgrammaticAttribute); },
];
/**
 * Iterates over the target element and its parent, using the strategies list to get an action name.
 * Each strategies are applied on each element, stopping as soon as a non-empty value is returned.
 */
var MAX_PARENTS_TO_CONSIDER = 10;
function getActionNameFromElementForStrategies(targetElement, userProgrammaticAttribute, strategies) {
    var element = targetElement;
    var recursionCounter = 0;
    while (recursionCounter <= MAX_PARENTS_TO_CONSIDER &&
        element &&
        element.nodeName !== 'BODY' &&
        element.nodeName !== 'HTML' &&
        element.nodeName !== 'HEAD') {
        for (var _i = 0, strategies_1 = strategies; _i < strategies_1.length; _i++) {
            var strategy = strategies_1[_i];
            var name_1 = strategy(element, userProgrammaticAttribute);
            if (typeof name_1 === 'string') {
                var trimmedName = name_1.trim();
                if (trimmedName) {
                    return truncate(normalizeWhitespace(trimmedName));
                }
            }
        }
        // Consider a FORM as a contextual limit to get the action name.  This is experimental and may
        // be reconsidered in the future.
        if (element.nodeName === 'FORM') {
            break;
        }
        element = element.parentElement;
        recursionCounter += 1;
    }
}
function normalizeWhitespace(s) {
    return s.replace(/\s+/g, ' ');
}
function truncate(s) {
    return s.length > 100 ? "".concat(safeTruncate(s, 100), " [...]") : s;
}
function getElementById(refElement, id) {
    // Use the element ownerDocument here, because tests are executed in an iframe, so
    // document.getElementById won't work.
    return refElement.ownerDocument ? refElement.ownerDocument.getElementById(id) : null;
}
function getTextualContent(element, userProgrammaticAttribute) {
    if (element.isContentEditable) {
        return;
    }
    if ('innerText' in element) {
        var text_1 = element.innerText;
        var removeTextFromElements = function (query) {
            var list = element.querySelectorAll(query);
            for (var index = 0; index < list.length; index += 1) {
                var element_1 = list[index];
                if ('innerText' in element_1) {
                    var textToReplace = element_1.innerText;
                    if (textToReplace && textToReplace.trim().length > 0) {
                        text_1 = text_1.replace(textToReplace, '');
                    }
                }
            }
        };
        if (!supportsInnerTextScriptAndStyleRemoval()) {
            // remove the inner text of SCRIPT and STYLES from the result. This is a bit dirty, but should
            // be relatively fast and work in most cases.
            removeTextFromElements('script, style');
        }
        // remove the text of elements with programmatic attribute value
        removeTextFromElements("[".concat(DEFAULT_PROGRAMMATIC_ATTRIBUTE, "]"));
        if (userProgrammaticAttribute) {
            removeTextFromElements("[".concat(userProgrammaticAttribute, "]"));
        }
        return text_1;
    }
    return element.textContent;
}
/**
 * Returns true if element.innerText excludes the text from inline SCRIPT and STYLE element. This
 * should be the case everywhere except on Internet Explorer 10 and 11 (see [1])
 *
 * The innerText property relies on what is actually rendered to compute its output, so to check if
 * it actually excludes SCRIPT and STYLE content, a solution would be to create a style element, set
 * its content to '*', inject it in the document body, and check if the style element innerText
 * property returns '*'. Using a new `document` instance won't work as it is not rendered.
 *
 * This solution requires specific CSP rules (see [2]) to be set by the customer. We want to avoid
 * this, so instead we rely on browser detection. In case of false negative, the impact should be
 * low, since we rely on this result to remove the SCRIPT and STYLE innerText (which will be empty)
 * from a parent element innerText.
 *
 * [1]: https://web.archive.org/web/20210602165716/http://perfectionkills.com/the-poor-misunderstood-innerText/#diff-with-textContent
 * [2]: https://github.com/DataDog/browser-sdk/issues/1084
 */
function supportsInnerTextScriptAndStyleRemoval() {
    return !isIE();
}
/**
 * Returns true if the browser supports the element.labels property.  This should be the case
 * everywhere except on Internet Explorer.
 * Note: The result is computed lazily, because we don't want any DOM access when the SDK is
 * evaluated.
 */
var supportsLabelPropertyResult;
function supportsLabelProperty() {
    if (supportsLabelPropertyResult === undefined) {
        supportsLabelPropertyResult = 'labels' in HTMLInputElement.prototype;
    }
    return supportsLabelPropertyResult;
}
/**
 * Returns true if the browser supports the element.closest method.  This should be the case
 * everywhere except on Internet Explorer.
 * Note: The result is computed lazily, because we don't want any DOM access when the SDK is
 * evaluated.
 */
var supportsElementClosestResult;
function supportsElementClosest() {
    if (supportsElementClosestResult === undefined) {
        supportsElementClosestResult = 'closest' in HTMLElement.prototype;
    }
    return supportsElementClosestResult;
}

// Maximum duration for automatic actions
var AUTO_ACTION_MAX_DURATION = 10 * ONE_SECOND;
function trackActions(lifeCycle, domMutationObservable, _a) {
    var actionNameAttribute = _a.actionNameAttribute;
    var action = startActionManagement(lifeCycle, domMutationObservable);
    // New views trigger the discard of the current pending Action
    lifeCycle.subscribe(4 /* VIEW_CREATED */, function () {
        action.discardCurrent();
    });
    var stopListener = addEventListener(window, "click" /* CLICK */, function (event) {
        if (!(event.target instanceof Element)) {
            return;
        }
        var name = getActionNameFromElement(event.target, actionNameAttribute);
        if (!name) {
            return;
        }
        action.create("click" /* CLICK */, name, event);
    }, { capture: true }).stop;
    return {
        stop: function () {
            action.discardCurrent();
            stopListener();
        },
    };
}
function startActionManagement(lifeCycle, domMutationObservable) {
    var currentAction;
    var stopWaitingIdlePage;
    return {
        create: function (type, name, event) {
            if (currentAction) {
                // Ignore any new action if another one is already occurring.
                return;
            }
            var pendingAutoAction = new PendingAutoAction(lifeCycle, type, name, event);
            currentAction = pendingAutoAction;
            (stopWaitingIdlePage = waitIdlePage(lifeCycle, domMutationObservable, function (event) {
                if (event.hadActivity) {
                    var duration = elapsed(pendingAutoAction.startClocks.timeStamp, event.end);
                    if (duration >= 0) {
                        pendingAutoAction.complete(duration);
                    }
                    else {
                        pendingAutoAction.discard();
                    }
                }
                else {
                    pendingAutoAction.discard();
                }
                currentAction = undefined;
            }, AUTO_ACTION_MAX_DURATION).stop);
        },
        discardCurrent: function () {
            if (currentAction) {
                stopWaitingIdlePage();
                currentAction.discard();
                currentAction = undefined;
            }
        },
    };
}
var PendingAutoAction = /** @class */ (function () {
    function PendingAutoAction(lifeCycle, type, name, event) {
        this.lifeCycle = lifeCycle;
        this.type = type;
        this.name = name;
        this.event = event;
        this.id = generateUUID();
        this.startClocks = clocksNow();
        this.eventCountsSubscription = trackEventCounts(lifeCycle);
        this.lifeCycle.notify(1 /* AUTO_ACTION_CREATED */, { id: this.id, startClocks: this.startClocks });
    }
    PendingAutoAction.prototype.complete = function (duration) {
        var eventCounts = this.eventCountsSubscription.eventCounts;
        this.lifeCycle.notify(2 /* AUTO_ACTION_COMPLETED */, {
            counts: {
                errorCount: eventCounts.errorCount,
                longTaskCount: eventCounts.longTaskCount,
                resourceCount: eventCounts.resourceCount,
            },
            duration: duration,
            id: this.id,
            name: this.name,
            startClocks: this.startClocks,
            type: this.type,
            event: this.event,
        });
        this.eventCountsSubscription.stop();
    };
    PendingAutoAction.prototype.discard = function () {
        this.lifeCycle.notify(3 /* AUTO_ACTION_DISCARDED */);
        this.eventCountsSubscription.stop();
    };
    return PendingAutoAction;
}());

function startActionCollection(lifeCycle, domMutationObservable, configuration, foregroundContexts) {
    lifeCycle.subscribe(2 /* AUTO_ACTION_COMPLETED */, function (action) {
        return lifeCycle.notify(12 /* RAW_RUM_EVENT_COLLECTED */, processAction(action, foregroundContexts));
    });
    if (configuration.trackInteractions) {
        trackActions(lifeCycle, domMutationObservable, configuration);
    }
    return {
        addAction: function (action, savedCommonContext) {
            lifeCycle.notify(12 /* RAW_RUM_EVENT_COLLECTED */, assign({
                savedCommonContext: savedCommonContext,
            }, processAction(action, foregroundContexts)));
        },
    };
}
function processAction(action, foregroundContexts) {
    var autoActionProperties = isAutoAction(action)
        ? {
            action: {
                error: {
                    count: action.counts.errorCount,
                },
                id: action.id,
                loading_time: toServerDuration(action.duration),
                long_task: {
                    count: action.counts.longTaskCount,
                },
                resource: {
                    count: action.counts.resourceCount,
                },
            },
        }
        : undefined;
    var customerContext = !isAutoAction(action) ? action.context : undefined;
    var actionEvent = combine({
        action: {
            id: generateUUID(),
            target: {
                name: action.name,
            },
            type: action.type,
        },
        date: action.startClocks.timeStamp,
        type: "action" /* ACTION */,
    }, autoActionProperties);
    var inForeground = foregroundContexts.isInForegroundAt(action.startClocks.relative);
    if (inForeground !== undefined) {
        actionEvent.view = { in_foreground: inForeground };
    }
    return {
        customerContext: customerContext,
        rawRumEvent: actionEvent,
        startTime: action.startClocks.relative,
        domainContext: isAutoAction(action) ? { event: action.event } : {},
    };
}
function isAutoAction(action) {
    return action.type !== "custom" /* CUSTOM */;
}

function trackConsoleError(errorObservable) {
    var subscription = initConsoleObservable([ConsoleApiName.error]).subscribe(function (consoleError) {
        return errorObservable.notify({
            startClocks: clocksNow(),
            message: consoleError.message,
            stack: consoleError.stack,
            source: ErrorSource.CONSOLE,
            handling: "handled" /* HANDLED */,
            handlingStack: consoleError.handlingStack,
        });
    });
    return {
        stop: function () {
            subscription.unsubscribe();
        },
    };
}

function trackReportError(errorObservable) {
    if (!isExperimentalFeatureEnabled('forward-reports')) {
        return {
            stop: noop,
        };
    }
    var subscription = initReportObservable([RawReportType.cspViolation, RawReportType.intervention]).subscribe(function (reportError) {
        return errorObservable.notify({
            startClocks: clocksNow(),
            message: reportError.message,
            stack: reportError.stack,
            type: reportError.subtype,
            source: ErrorSource.REPORT,
            handling: "unhandled" /* UNHANDLED */,
        });
    });
    return {
        stop: function () {
            subscription.unsubscribe();
        },
    };
}

function startErrorCollection(lifeCycle, foregroundContexts) {
    var errorObservable = new Observable();
    trackConsoleError(errorObservable);
    trackRuntimeError(errorObservable);
    trackReportError(errorObservable);
    errorObservable.subscribe(function (error) { return lifeCycle.notify(14 /* RAW_ERROR_COLLECTED */, { error: error }); });
    return doStartErrorCollection(lifeCycle, foregroundContexts);
}
function doStartErrorCollection(lifeCycle, foregroundContexts) {
    lifeCycle.subscribe(14 /* RAW_ERROR_COLLECTED */, function (_a) {
        var error = _a.error, customerContext = _a.customerContext, savedCommonContext = _a.savedCommonContext;
        lifeCycle.notify(12 /* RAW_RUM_EVENT_COLLECTED */, assign({
            customerContext: customerContext,
            savedCommonContext: savedCommonContext,
        }, processError(error, foregroundContexts)));
    });
    return {
        addError: function (_a, savedCommonContext) {
            var error = _a.error, handlingStack = _a.handlingStack, startClocks = _a.startClocks, customerContext = _a.context;
            var rawError = computeRawError(error, handlingStack, startClocks);
            lifeCycle.notify(14 /* RAW_ERROR_COLLECTED */, {
                customerContext: customerContext,
                savedCommonContext: savedCommonContext,
                error: rawError,
            });
        },
    };
}
function computeRawError(error, handlingStack, startClocks) {
    var stackTrace = error instanceof Error ? computeStackTrace(error) : undefined;
    return assign({
        startClocks: startClocks,
        source: ErrorSource.CUSTOM,
        originalError: error,
        handling: "handled" /* HANDLED */,
    }, formatUnknownError(stackTrace, error, 'Provided', handlingStack));
}
function processError(error, foregroundContexts) {
    var rawRumEvent = {
        date: error.startClocks.timeStamp,
        error: {
            id: generateUUID(),
            message: error.message,
            source: error.source,
            stack: error.stack,
            handling_stack: error.handlingStack,
            type: error.type,
            handling: error.handling,
            source_type: 'browser',
        },
        type: "error" /* ERROR */,
    };
    var inForeground = foregroundContexts.isInForegroundAt(error.startClocks.relative);
    if (inForeground !== undefined) {
        rawRumEvent.view = { in_foreground: inForeground };
    }
    return {
        rawRumEvent: rawRumEvent,
        startTime: error.startClocks.relative,
        domainContext: {
            error: error.originalError,
        },
    };
}

function startLongTaskCollection(lifeCycle, sessionManager) {
    lifeCycle.subscribe(0 /* PERFORMANCE_ENTRIES_COLLECTED */, function (entries) {
        for (var _i = 0, entries_1 = entries; _i < entries_1.length; _i++) {
            var entry = entries_1[_i];
            if (entry.entryType !== 'longtask') {
                break;
            }
            var session = sessionManager.findTrackedSession(entry.startTime);
            if (!session || session.hasLitePlan) {
                break;
            }
            var startClocks = relativeToClocks(entry.startTime);
            var rawRumEvent = {
                date: startClocks.timeStamp,
                long_task: {
                    id: generateUUID(),
                    duration: toServerDuration(entry.duration),
                },
                type: "long_task" /* LONG_TASK */,
            };
            lifeCycle.notify(12 /* RAW_RUM_EVENT_COLLECTED */, {
                rawRumEvent: rawRumEvent,
                startTime: startClocks.relative,
                domainContext: { performanceEntry: entry.toJSON() },
            });
        }
    });
}

/**
 * Look for corresponding timing in resource timing buffer
 *
 * Observations:
 * - Timing (start, end) are nested inside the request (start, end)
 * - Some timing can be not exactly nested, being off by < 1 ms
 * - Browsers generate a timing entry for OPTIONS request
 *
 * Strategy:
 * - from valid nested entries (with 1 ms error margin)
 * - if a single timing match, return the timing
 * - if two following timings match (OPTIONS request), return the timing for the actual request
 * - otherwise we can't decide, return undefined
 */
function matchRequestTiming(request) {
    if (!performance || !('getEntriesByName' in performance)) {
        return;
    }
    var sameNameEntries = performance.getEntriesByName(request.url, 'resource');
    if (!sameNameEntries.length || !('toJSON' in sameNameEntries[0])) {
        return;
    }
    var candidates = sameNameEntries
        .map(function (entry) { return entry.toJSON(); })
        .filter(toValidEntry)
        .filter(function (entry) {
        return isBetween(entry, request.startClocks.relative, endTime({ startTime: request.startClocks.relative, duration: request.duration }));
    });
    if (candidates.length === 1) {
        return candidates[0];
    }
    if (candidates.length === 2 && firstCanBeOptionRequest(candidates)) {
        return candidates[1];
    }
    return;
}
function firstCanBeOptionRequest(correspondingEntries) {
    return endTime(correspondingEntries[0]) <= correspondingEntries[1].startTime;
}
function endTime(timing) {
    // eslint-disable-next-line @typescript-eslint/restrict-plus-operands
    return (timing.startTime + timing.duration);
}
function isBetween(timing, start, end) {
    var errorMargin = 1;
    // eslint-disable-next-line @typescript-eslint/restrict-plus-operands
    return timing.startTime >= start - errorMargin && endTime(timing) <= end + errorMargin;
}

function startResourceCollection(lifeCycle) {
    lifeCycle.subscribe(8 /* REQUEST_COMPLETED */, function (request) {
        lifeCycle.notify(12 /* RAW_RUM_EVENT_COLLECTED */, processRequest(request));
    });
    lifeCycle.subscribe(0 /* PERFORMANCE_ENTRIES_COLLECTED */, function (entries) {
        for (var _i = 0, entries_1 = entries; _i < entries_1.length; _i++) {
            var entry = entries_1[_i];
            if (entry.entryType === 'resource' && !isRequestKind(entry)) {
                lifeCycle.notify(12 /* RAW_RUM_EVENT_COLLECTED */, processResourceEntry(entry));
            }
        }
    });
}
function processRequest(request) {
    var type = request.type === "xhr" /* XHR */ ? "xhr" /* XHR */ : "fetch" /* FETCH */;
    var matchingTiming = matchRequestTiming(request);
    var startClocks = matchingTiming ? relativeToClocks(matchingTiming.startTime) : request.startClocks;
    var correspondingTimingOverrides = matchingTiming ? computePerformanceEntryMetrics(matchingTiming) : undefined;
    var tracingInfo = computeRequestTracingInfo(request);
    var resourceEvent = combine({
        date: startClocks.timeStamp,
        resource: {
            id: generateUUID(),
            type: type,
            duration: toServerDuration(request.duration),
            method: request.method,
            status_code: request.status,
            url: request.url,
        },
        type: "resource" /* RESOURCE */,
    }, tracingInfo, correspondingTimingOverrides);
    return {
        startTime: startClocks.relative,
        rawRumEvent: resourceEvent,
        domainContext: {
            performanceEntry: matchingTiming && toPerformanceEntryRepresentation(matchingTiming),
            xhr: request.xhr,
            response: request.response,
            requestInput: request.input,
            requestInit: request.init,
            error: request.error,
        },
    };
}
function processResourceEntry(entry) {
    var type = computeResourceKind(entry);
    var entryMetrics = computePerformanceEntryMetrics(entry);
    var tracingInfo = computeEntryTracingInfo(entry);
    var startClocks = relativeToClocks(entry.startTime);
    var resourceEvent = combine({
        date: startClocks.timeStamp,
        resource: {
            id: generateUUID(),
            type: type,
            url: entry.name,
        },
        type: "resource" /* RESOURCE */,
    }, tracingInfo, entryMetrics);
    return {
        startTime: startClocks.relative,
        rawRumEvent: resourceEvent,
        domainContext: {
            performanceEntry: toPerformanceEntryRepresentation(entry),
        },
    };
}
function computePerformanceEntryMetrics(timing) {
    return {
        resource: assign({
            duration: computePerformanceResourceDuration(timing),
            size: computeSize(timing),
        }, computePerformanceResourceDetails(timing)),
    };
}
function computeRequestTracingInfo(request) {
    var hasBeenTraced = request.traceId && request.spanId;
    if (!hasBeenTraced) {
        return undefined;
    }
    return {
        _dd: {
            span_id: request.spanId.toDecimalString(),
            trace_id: request.traceId.toDecimalString(),
        },
    };
}
function computeEntryTracingInfo(entry) {
    return entry.traceId ? { _dd: { trace_id: entry.traceId } } : undefined;
}
function toPerformanceEntryRepresentation(entry) {
    if (supportPerformanceEntry() && entry instanceof PerformanceEntry) {
        entry.toJSON();
    }
    return entry;
}

var trackFirstHiddenSingleton;
var stopListeners;
function trackFirstHidden(emitter) {
    if (emitter === void 0) { emitter = window; }
    if (!trackFirstHiddenSingleton) {
        if (document.visibilityState === 'hidden') {
            trackFirstHiddenSingleton = {
                timeStamp: 0,
            };
        }
        else {
            trackFirstHiddenSingleton = {
                timeStamp: Infinity,
            };
            (stopListeners = addEventListeners(emitter, ["pagehide" /* PAGE_HIDE */, "visibilitychange" /* VISIBILITY_CHANGE */], function (event) {
                if (event.type === 'pagehide' || document.visibilityState === 'hidden') {
                    trackFirstHiddenSingleton.timeStamp = event.timeStamp;
                    stopListeners();
                }
            }, { capture: true }).stop);
        }
    }
    return trackFirstHiddenSingleton;
}

// Discard LCP and FCP timings above a certain delay to avoid incorrect data
// It happens in some cases like sleep mode or some browser implementations
var TIMING_MAXIMUM_DELAY = 10 * ONE_MINUTE;
function trackInitialViewTimings(lifeCycle, callback) {
    var timings = {};
    function setTimings(newTimings) {
        assign(timings, newTimings);
        callback(timings);
    }
    var stopNavigationTracking = trackNavigationTimings(lifeCycle, setTimings).stop;
    var stopFCPTracking = trackFirstContentfulPaintTiming(lifeCycle, function (firstContentfulPaint) {
        return setTimings({ firstContentfulPaint: firstContentfulPaint });
    }).stop;
    var stopLCPTracking = trackLargestContentfulPaintTiming(lifeCycle, window, function (largestContentfulPaint) {
        setTimings({
            largestContentfulPaint: largestContentfulPaint,
        });
    }).stop;
    var stopFIDTracking = trackFirstInputTimings(lifeCycle, function (_a) {
        var firstInputDelay = _a.firstInputDelay, firstInputTime = _a.firstInputTime;
        setTimings({
            firstInputDelay: firstInputDelay,
            firstInputTime: firstInputTime,
        });
    }).stop;
    return {
        stop: function () {
            stopNavigationTracking();
            stopFCPTracking();
            stopLCPTracking();
            stopFIDTracking();
        },
    };
}
function trackNavigationTimings(lifeCycle, callback) {
    var stop = lifeCycle.subscribe(0 /* PERFORMANCE_ENTRIES_COLLECTED */, function (entries) {
        for (var _i = 0, entries_1 = entries; _i < entries_1.length; _i++) {
            var entry = entries_1[_i];
            if (entry.entryType === 'navigation') {
                callback({
                    domComplete: entry.domComplete,
                    domContentLoaded: entry.domContentLoadedEventEnd,
                    domInteractive: entry.domInteractive,
                    loadEvent: entry.loadEventEnd,
                });
            }
        }
    }).unsubscribe;
    return { stop: stop };
}
function trackFirstContentfulPaintTiming(lifeCycle, callback) {
    var firstHidden = trackFirstHidden();
    var stop = lifeCycle.subscribe(0 /* PERFORMANCE_ENTRIES_COLLECTED */, function (entries) {
        var fcpEntry = find(entries, function (entry) {
            return entry.entryType === 'paint' &&
                entry.name === 'first-contentful-paint' &&
                entry.startTime < firstHidden.timeStamp &&
                entry.startTime < TIMING_MAXIMUM_DELAY;
        });
        if (fcpEntry) {
            callback(fcpEntry.startTime);
        }
    }).unsubscribe;
    return { stop: stop };
}
/**
 * Track the largest contentful paint (LCP) occurring during the initial View.  This can yield
 * multiple values, only the most recent one should be used.
 * Documentation: https://web.dev/lcp/
 * Reference implementation: https://github.com/GoogleChrome/web-vitals/blob/master/src/getLCP.ts
 */
function trackLargestContentfulPaintTiming(lifeCycle, emitter, callback) {
    var firstHidden = trackFirstHidden();
    // Ignore entries that come after the first user interaction.  According to the documentation, the
    // browser should not send largest-contentful-paint entries after a user interact with the page,
    // but the web-vitals reference implementation uses this as a safeguard.
    var firstInteractionTimestamp = Infinity;
    var stopEventListener = addEventListeners(emitter, ["pointerdown" /* POINTER_DOWN */, "keydown" /* KEY_DOWN */], function (event) {
        firstInteractionTimestamp = event.timeStamp;
    }, { capture: true, once: true }).stop;
    var unsubscribeLifeCycle = lifeCycle.subscribe(0 /* PERFORMANCE_ENTRIES_COLLECTED */, function (entries) {
        var lcpEntry = findLast(entries, function (entry) {
            return entry.entryType === 'largest-contentful-paint' &&
                entry.startTime < firstInteractionTimestamp &&
                entry.startTime < firstHidden.timeStamp &&
                entry.startTime < TIMING_MAXIMUM_DELAY;
        });
        if (lcpEntry) {
            callback(lcpEntry.startTime);
        }
    }).unsubscribe;
    return {
        stop: function () {
            stopEventListener();
            unsubscribeLifeCycle();
        },
    };
}
/**
 * Track the first input occurring during the initial View to return:
 * - First Input Delay
 * - First Input Time
 * Callback is called at most one time.
 * Documentation: https://web.dev/fid/
 * Reference implementation: https://github.com/GoogleChrome/web-vitals/blob/master/src/getFID.ts
 */
function trackFirstInputTimings(lifeCycle, callback) {
    var firstHidden = trackFirstHidden();
    var stop = lifeCycle.subscribe(0 /* PERFORMANCE_ENTRIES_COLLECTED */, function (entries) {
        var firstInputEntry = find(entries, function (entry) {
            return entry.entryType === 'first-input' && entry.startTime < firstHidden.timeStamp;
        });
        if (firstInputEntry) {
            var firstInputDelay = elapsed(firstInputEntry.startTime, firstInputEntry.processingStart);
            callback({
                // Ensure firstInputDelay to be positive, see
                // https://bugs.chromium.org/p/chromium/issues/detail?id=1185815
                firstInputDelay: firstInputDelay >= 0 ? firstInputDelay : 0,
                firstInputTime: firstInputEntry.startTime,
            });
        }
    }).unsubscribe;
    return {
        stop: stop,
    };
}

function trackViewMetrics(lifeCycle, domMutationObservable, scheduleViewUpdate, loadingType, viewStart) {
    var viewMetrics = {
        eventCounts: {
            errorCount: 0,
            longTaskCount: 0,
            resourceCount: 0,
            userActionCount: 0,
        },
    };
    var stopEventCountsTracking = trackEventCounts(lifeCycle, function (newEventCounts) {
        viewMetrics.eventCounts = newEventCounts;
        scheduleViewUpdate();
    }).stop;
    var _a = trackLoadingTime(lifeCycle, domMutationObservable, loadingType, viewStart, function (newLoadingTime) {
        viewMetrics.loadingTime = newLoadingTime;
        scheduleViewUpdate();
    }), stopLoadingTimeTracking = _a.stop, setLoadEvent = _a.setLoadEvent;
    var stopCLSTracking;
    if (isLayoutShiftSupported()) {
        viewMetrics.cumulativeLayoutShift = 0;
        (stopCLSTracking = trackCumulativeLayoutShift(lifeCycle, function (cumulativeLayoutShift) {
            viewMetrics.cumulativeLayoutShift = cumulativeLayoutShift;
            scheduleViewUpdate();
        }).stop);
    }
    else {
        stopCLSTracking = noop;
    }
    return {
        stop: function () {
            stopEventCountsTracking();
            stopLoadingTimeTracking();
            stopCLSTracking();
        },
        setLoadEvent: setLoadEvent,
        viewMetrics: viewMetrics,
    };
}
function trackLoadingTime(lifeCycle, domMutationObservable, loadType, viewStart, callback) {
    var isWaitingForLoadEvent = loadType === "initial_load" /* INITIAL_LOAD */;
    var isWaitingForActivityLoadingTime = true;
    var loadingTimeCandidates = [];
    function invokeCallbackIfAllCandidatesAreReceived() {
        if (!isWaitingForActivityLoadingTime && !isWaitingForLoadEvent && loadingTimeCandidates.length > 0) {
            callback(Math.max.apply(Math, loadingTimeCandidates));
        }
    }
    var stop = waitIdlePage(lifeCycle, domMutationObservable, function (event) {
        if (isWaitingForActivityLoadingTime) {
            isWaitingForActivityLoadingTime = false;
            if (event.hadActivity) {
                loadingTimeCandidates.push(elapsed(viewStart.timeStamp, event.end));
            }
            invokeCallbackIfAllCandidatesAreReceived();
        }
    }).stop;
    return {
        stop: stop,
        setLoadEvent: function (loadEvent) {
            if (isWaitingForLoadEvent) {
                isWaitingForLoadEvent = false;
                loadingTimeCandidates.push(loadEvent);
                invokeCallbackIfAllCandidatesAreReceived();
            }
        },
    };
}
/**
 * Track the cumulative layout shifts (CLS).
 * Layout shifts are grouped into session windows.
 * The minimum gap between session windows is 1 second.
 * The maximum duration of a session window is 5 second.
 * The session window layout shift value is the sum of layout shifts inside it.
 * The CLS value is the max of session windows values.
 *
 * This yields a new value whenever the CLS value is updated (a higher session window value is computed).
 *
 * See isLayoutShiftSupported to check for browser support.
 *
 * Documentation:
 * https://web.dev/cls/
 * https://web.dev/evolving-cls/
 * Reference implementation: https://github.com/GoogleChrome/web-vitals/blob/master/src/getCLS.ts
 */
function trackCumulativeLayoutShift(lifeCycle, callback) {
    var maxClsValue = 0;
    var window = slidingSessionWindow();
    var stop = lifeCycle.subscribe(0 /* PERFORMANCE_ENTRIES_COLLECTED */, function (entries) {
        for (var _i = 0, entries_1 = entries; _i < entries_1.length; _i++) {
            var entry = entries_1[_i];
            if (entry.entryType === 'layout-shift' && !entry.hadRecentInput) {
                window.update(entry);
                if (window.value() > maxClsValue) {
                    maxClsValue = window.value();
                    callback(round(maxClsValue, 4));
                }
            }
        }
    }).unsubscribe;
    return {
        stop: stop,
    };
}
function slidingSessionWindow() {
    var value = 0;
    var startTime;
    var endTime;
    return {
        update: function (entry) {
            var shouldCreateNewWindow = startTime === undefined ||
                entry.startTime - endTime >= ONE_SECOND ||
                entry.startTime - startTime >= 5 * ONE_SECOND;
            if (shouldCreateNewWindow) {
                startTime = endTime = entry.startTime;
                value = entry.value;
            }
            else {
                value += entry.value;
                endTime = entry.startTime;
            }
        },
        value: function () { return value; },
    };
}
/**
 * Check whether `layout-shift` is supported by the browser.
 */
function isLayoutShiftSupported() {
    return supportPerformanceTimingEvent('layout-shift');
}

var THROTTLE_VIEW_UPDATE_PERIOD = 3000;
var SESSION_KEEP_ALIVE_INTERVAL = 5 * ONE_MINUTE;
function trackViews(location, lifeCycle, domMutationObservable, locationChangeObservable, areViewsTrackedAutomatically, initialViewName) {
    var _a = trackInitialView(initialViewName), stopInitialViewTracking = _a.stop, initialView = _a.initialView;
    var currentView = initialView;
    var stopViewLifeCycle = startViewLifeCycle().stop;
    var locationChangeSubscription;
    if (areViewsTrackedAutomatically) {
        locationChangeSubscription = renewViewOnLocationChange(locationChangeObservable);
    }
    function trackInitialView(name) {
        var initialView = newView(lifeCycle, domMutationObservable, location, "initial_load" /* INITIAL_LOAD */, clocksOrigin(), name);
        var stop = trackInitialViewTimings(lifeCycle, function (timings) {
            initialView.updateTimings(timings);
            initialView.scheduleUpdate();
        }).stop;
        return { initialView: initialView, stop: stop };
    }
    function trackViewChange(startClocks, name) {
        return newView(lifeCycle, domMutationObservable, location, "route_change" /* ROUTE_CHANGE */, startClocks, name);
    }
    function startViewLifeCycle() {
        lifeCycle.subscribe(10 /* SESSION_RENEWED */, function () {
            // do not trigger view update to avoid wrong data
            currentView.end();
            // Renew view on session renewal
            currentView = trackViewChange(undefined, currentView.name);
        });
        // End the current view on page unload
        lifeCycle.subscribe(11 /* BEFORE_UNLOAD */, function () {
            currentView.end();
            currentView.triggerUpdate();
        });
        // Session keep alive
        var keepAliveInterval = window.setInterval(monitor(function () {
            currentView.triggerUpdate();
        }), SESSION_KEEP_ALIVE_INTERVAL);
        return {
            stop: function () {
                clearInterval(keepAliveInterval);
            },
        };
    }
    function renewViewOnLocationChange(locationChangeObservable) {
        return locationChangeObservable.subscribe(function (_a) {
            var oldLocation = _a.oldLocation, newLocation = _a.newLocation;
            if (areDifferentLocation(oldLocation, newLocation)) {
                currentView.end();
                currentView.triggerUpdate();
                currentView = trackViewChange();
                return;
            }
        });
    }
    return {
        addTiming: function (name, time) {
            if (time === void 0) { time = timeStampNow(); }
            currentView.addTiming(name, time);
            currentView.scheduleUpdate();
        },
        startView: function (name, startClocks) {
            currentView.end(startClocks);
            currentView.triggerUpdate();
            currentView = trackViewChange(startClocks, name);
        },
        stop: function () {
            locationChangeSubscription === null || locationChangeSubscription === void 0 ? void 0 : locationChangeSubscription.unsubscribe();
            stopInitialViewTracking();
            stopViewLifeCycle();
            currentView.end();
        },
    };
}
function newView(lifeCycle, domMutationObservable, initialLocation, loadingType, startClocks, name) {
    if (startClocks === void 0) { startClocks = clocksNow(); }
    // Setup initial values
    var id = generateUUID();
    var timings = {};
    var customTimings = {};
    var documentVersion = 0;
    var endClocks;
    var location = shallowClone(initialLocation);
    lifeCycle.notify(4 /* VIEW_CREATED */, { id: id, name: name, startClocks: startClocks });
    // Update the view every time the measures are changing
    var _a = throttle(monitor(triggerViewUpdate), THROTTLE_VIEW_UPDATE_PERIOD, {
        leading: false,
    }), scheduleViewUpdate = _a.throttled, cancelScheduleViewUpdate = _a.cancel;
    var _b = trackViewMetrics(lifeCycle, domMutationObservable, scheduleViewUpdate, loadingType, startClocks), setLoadEvent = _b.setLoadEvent, stopViewMetricsTracking = _b.stop, viewMetrics = _b.viewMetrics;
    // Initial view update
    triggerViewUpdate();
    function triggerViewUpdate() {
        documentVersion += 1;
        var currentEnd = endClocks === undefined ? timeStampNow() : endClocks.timeStamp;
        lifeCycle.notify(5 /* VIEW_UPDATED */, assign({
            customTimings: customTimings,
            documentVersion: documentVersion,
            id: id,
            name: name,
            loadingType: loadingType,
            location: location,
            startClocks: startClocks,
            timings: timings,
            duration: elapsed(startClocks.timeStamp, currentEnd),
            isActive: endClocks === undefined,
        }, viewMetrics));
    }
    return {
        name: name,
        scheduleUpdate: scheduleViewUpdate,
        end: function (clocks) {
            if (clocks === void 0) { clocks = clocksNow(); }
            endClocks = clocks;
            stopViewMetricsTracking();
            lifeCycle.notify(6 /* VIEW_ENDED */, { endClocks: endClocks });
        },
        triggerUpdate: function () {
            // cancel any pending view updates execution
            cancelScheduleViewUpdate();
            triggerViewUpdate();
        },
        updateTimings: function (newTimings) {
            timings = newTimings;
            if (newTimings.loadEvent !== undefined) {
                setLoadEvent(newTimings.loadEvent);
            }
        },
        addTiming: function (name, time) {
            var relativeTime = looksLikeRelativeTime(time) ? time : elapsed(startClocks.timeStamp, time);
            customTimings[sanitizeTiming(name)] = relativeTime;
        },
    };
}
/**
 * Timing name is used as facet path that must contain only letters, digits, or the characters - _ . @ $
 */
function sanitizeTiming(name) {
    var sanitized = name.replace(/[^a-zA-Z0-9-_.@$]/g, '_');
    if (sanitized !== name) {
        display.warn("Invalid timing name: ".concat(name, ", sanitized to: ").concat(sanitized));
    }
    return sanitized;
}
function areDifferentLocation(currentLocation, otherLocation) {
    return (currentLocation.pathname !== otherLocation.pathname ||
        (!isHashAnAnchor(otherLocation.hash) &&
            getPathFromHash(otherLocation.hash) !== getPathFromHash(currentLocation.hash)));
}
function isHashAnAnchor(hash) {
    var correspondingId = hash.substr(1);
    return !!document.getElementById(correspondingId);
}
function getPathFromHash(hash) {
    var index = hash.indexOf('?');
    return index < 0 ? hash : hash.slice(0, index);
}

function startViewCollection(lifeCycle, configuration, location, domMutationObservable, locationChangeObservable, foregroundContexts, recorderApi, initialViewName) {
    lifeCycle.subscribe(5 /* VIEW_UPDATED */, function (view) {
        return lifeCycle.notify(12 /* RAW_RUM_EVENT_COLLECTED */, processViewUpdate(view, foregroundContexts, recorderApi));
    });
    return trackViews(location, lifeCycle, domMutationObservable, locationChangeObservable, !configuration.trackViewsManually, initialViewName);
}
function processViewUpdate(view, foregroundContexts, recorderApi) {
    var replayStats = recorderApi.getReplayStats(view.id);
    var viewEvent = {
        _dd: {
            document_version: view.documentVersion,
            replay_stats: replayStats,
        },
        date: view.startClocks.timeStamp,
        type: "view" /* VIEW */,
        view: {
            action: {
                count: view.eventCounts.userActionCount,
            },
            cumulative_layout_shift: view.cumulativeLayoutShift,
            dom_complete: toServerDuration(view.timings.domComplete),
            dom_content_loaded: toServerDuration(view.timings.domContentLoaded),
            dom_interactive: toServerDuration(view.timings.domInteractive),
            error: {
                count: view.eventCounts.errorCount,
            },
            first_contentful_paint: toServerDuration(view.timings.firstContentfulPaint),
            first_input_delay: toServerDuration(view.timings.firstInputDelay),
            first_input_time: toServerDuration(view.timings.firstInputTime),
            is_active: view.isActive,
            name: view.name,
            largest_contentful_paint: toServerDuration(view.timings.largestContentfulPaint),
            load_event: toServerDuration(view.timings.loadEvent),
            loading_time: discardNegativeDuration(toServerDuration(view.loadingTime)),
            loading_type: view.loadingType,
            long_task: {
                count: view.eventCounts.longTaskCount,
            },
            resource: {
                count: view.eventCounts.resourceCount,
            },
            time_spent: toServerDuration(view.duration),
            in_foreground_periods: foregroundContexts.selectInForegroundPeriodsFor(view.startClocks.relative, view.duration),
        },
        session: {
            has_replay: replayStats ? true : undefined,
        },
    };
    if (!isEmptyObject(view.customTimings)) {
        viewEvent.view.custom_timings = mapValues(view.customTimings, toServerDuration);
    }
    return {
        rawRumEvent: viewEvent,
        startTime: view.startClocks.relative,
        domainContext: {
            location: view.location,
        },
    };
}
function discardNegativeDuration(duration) {
    return isNumber(duration) && duration < 0 ? undefined : duration;
}

var RUM_SESSION_KEY$1 = 'rum';
function startRumSessionManager(configuration, lifeCycle) {
    var sessionManager = startSessionManager(configuration.cookieOptions, RUM_SESSION_KEY$1, function (rawTrackingType) {
        return computeSessionState(configuration, rawTrackingType);
    });
    sessionManager.expireObservable.subscribe(function () {
        lifeCycle.notify(9 /* SESSION_EXPIRED */);
    });
    sessionManager.renewObservable.subscribe(function () {
        lifeCycle.notify(10 /* SESSION_RENEWED */);
    });
    return {
        findTrackedSession: function (startTime) {
            var session = sessionManager.findActiveSession(startTime);
            if (!session || !isTypeTracked(session.trackingType)) {
                return;
            }
            return {
                id: session.id,
                hasReplayPlan: session.trackingType === "1" /* TRACKED_REPLAY */,
                hasLitePlan: session.trackingType === "2" /* TRACKED_LITE */,
            };
        },
    };
}
/**
 * Start a tracked replay session stub
 * It needs to be a replay plan in order to get long tasks
 */
function startRumSessionManagerStub() {
    var session = {
        id: '00000000-aaaa-0000-aaaa-000000000000',
        hasReplayPlan: true,
        hasLitePlan: false,
    };
    return {
        findTrackedSession: function () { return session; },
    };
}
function computeSessionState(configuration, rawTrackingType) {
    var trackingType;
    if (hasValidRumSession(rawTrackingType)) {
        trackingType = rawTrackingType;
    }
    else if (!performDraw(configuration.sampleRate)) {
        trackingType = "0" /* NOT_TRACKED */;
    }
    else if (!performDraw(configuration.replaySampleRate)) {
        trackingType = "2" /* TRACKED_LITE */;
    }
    else {
        trackingType = "1" /* TRACKED_REPLAY */;
    }
    return {
        trackingType: trackingType,
        isTracked: isTypeTracked(trackingType),
    };
}
function hasValidRumSession(trackingType) {
    return (trackingType === "0" /* NOT_TRACKED */ ||
        trackingType === "1" /* TRACKED_REPLAY */ ||
        trackingType === "2" /* TRACKED_LITE */);
}
function isTypeTracked(rumSessionType) {
    return rumSessionType === "2" /* TRACKED_LITE */ || rumSessionType === "1" /* TRACKED_REPLAY */;
}

function startRumBatch(configuration, lifeCycle, telemetryEventObservable) {
    var batch = makeRumBatch(configuration, lifeCycle);
    lifeCycle.subscribe(13 /* RUM_EVENT_COLLECTED */, function (serverRumEvent) {
        if (serverRumEvent.type === "view" /* VIEW */) {
            batch.upsert(serverRumEvent, serverRumEvent.view.id);
        }
        else {
            batch.add(serverRumEvent);
        }
    });
    telemetryEventObservable.subscribe(function (event) { return batch.add(event); });
}
function makeRumBatch(configuration, lifeCycle) {
    var primaryBatch = createRumBatch(configuration.rumEndpointBuilder, function () {
        return lifeCycle.notify(11 /* BEFORE_UNLOAD */);
    });
    var replicaBatch;
    var replica = configuration.replica;
    if (replica !== undefined) {
        replicaBatch = createRumBatch(replica.rumEndpointBuilder);
    }
    function createRumBatch(endpointBuilder, unloadCallback) {
        return new Batch(new HttpRequest(endpointBuilder, configuration.batchBytesLimit), configuration.maxBatchSize, configuration.batchBytesLimit, configuration.maxMessageSize, configuration.flushTimeout, unloadCallback);
    }
    function withReplicaApplicationId(message) {
        return combine(message, { application: { id: replica.applicationId } });
    }
    return {
        add: function (message) {
            primaryBatch.add(message);
            if (replicaBatch) {
                replicaBatch.add(withReplicaApplicationId(message));
            }
        },
        upsert: function (message, key) {
            primaryBatch.upsert(message, key);
            if (replicaBatch) {
                replicaBatch.upsert(withReplicaApplicationId(message), key);
            }
        },
    };
}

function startRumEventBridge(lifeCycle) {
    var bridge = getEventBridge();
    lifeCycle.subscribe(13 /* RUM_EVENT_COLLECTED */, function (serverRumEvent) {
        bridge.send('rum', serverRumEvent);
    });
}

/**
 * We want to attach to an event:
 * - the url corresponding to its start
 * - the referrer corresponding to the previous view url (or document referrer for initial view)
 */
var URL_CONTEXT_TIME_OUT_DELAY = SESSION_TIME_OUT_DELAY;
function startUrlContexts(lifeCycle, locationChangeObservable, location) {
    var urlContextHistory = new ContextHistory(URL_CONTEXT_TIME_OUT_DELAY);
    var previousViewUrl;
    lifeCycle.subscribe(6 /* VIEW_ENDED */, function (_a) {
        var endClocks = _a.endClocks;
        urlContextHistory.closeCurrent(endClocks.relative);
    });
    lifeCycle.subscribe(4 /* VIEW_CREATED */, function (_a) {
        var startClocks = _a.startClocks;
        var viewUrl = location.href;
        urlContextHistory.setCurrent(buildUrlContext({
            url: viewUrl,
            referrer: !previousViewUrl ? document.referrer : previousViewUrl,
        }), startClocks.relative);
        previousViewUrl = viewUrl;
    });
    var locationChangeSubscription = locationChangeObservable.subscribe(function (_a) {
        var newLocation = _a.newLocation;
        var current = urlContextHistory.getCurrent();
        if (current) {
            var changeTime = relativeNow();
            urlContextHistory.closeCurrent(changeTime);
            urlContextHistory.setCurrent(buildUrlContext({
                url: newLocation.href,
                referrer: current.view.referrer,
            }), changeTime);
        }
    });
    function buildUrlContext(_a) {
        var url = _a.url, referrer = _a.referrer;
        return {
            view: {
                url: url,
                referrer: referrer,
            },
        };
    }
    return {
        findUrl: function (startTime) { return urlContextHistory.find(startTime); },
        stop: function () {
            locationChangeSubscription.unsubscribe();
            urlContextHistory.stop();
        },
    };
}

function createLocationChangeObservable(location) {
    var currentLocation = shallowClone(location);
    var observable = new Observable(function () {
        var stopHistoryTracking = trackHistory(onLocationChange).stop;
        var stopHashTracking = trackHash(onLocationChange).stop;
        return function () {
            stopHistoryTracking();
            stopHashTracking();
        };
    });
    function onLocationChange() {
        if (currentLocation.href === location.href) {
            return;
        }
        var newLocation = shallowClone(location);
        observable.notify({
            newLocation: newLocation,
            oldLocation: currentLocation,
        });
        currentLocation = newLocation;
    }
    return observable;
}
function trackHistory(onHistoryChange) {
    var stopInstrumentingPushState = instrumentMethodAndCallOriginal(history, 'pushState', {
        after: onHistoryChange,
    }).stop;
    var stopInstrumentingReplaceState = instrumentMethodAndCallOriginal(history, 'replaceState', {
        after: onHistoryChange,
    }).stop;
    var removeListener = addEventListener(window, "popstate" /* POP_STATE */, onHistoryChange).stop;
    return {
        stop: function () {
            stopInstrumentingPushState();
            stopInstrumentingReplaceState();
            removeListener();
        },
    };
}
function trackHash(onHashChange) {
    return addEventListener(window, "hashchange" /* HASH_CHANGE */, onHashChange);
}

function startRum(configuration, getCommonContext, recorderApi, initialViewName) {
    var lifeCycle = new LifeCycle();
    var internalMonitoring = startRumInternalMonitoring(configuration);
    internalMonitoring.setExternalContextProvider(function () {
        var _a;
        return combine({
            application_id: configuration.applicationId,
            session: {
                id: (_a = session.findTrackedSession()) === null || _a === void 0 ? void 0 : _a.id,
            },
        }, parentContexts.findView(), { view: { name: null } });
    });
    internalMonitoring.setTelemetryContextProvider(function () {
        var _a, _b, _c;
        return ({
            application: {
                id: configuration.applicationId,
            },
            session: {
                id: (_a = session.findTrackedSession()) === null || _a === void 0 ? void 0 : _a.id,
            },
            view: {
                id: (_b = parentContexts.findView()) === null || _b === void 0 ? void 0 : _b.view.id,
            },
            action: {
                id: (_c = parentContexts.findAction()) === null || _c === void 0 ? void 0 : _c.action.id,
            },
        });
    });
    if (!canUseEventBridge()) {
        startRumBatch(configuration, lifeCycle, internalMonitoring.telemetryEventObservable);
    }
    else {
        startRumEventBridge(lifeCycle);
    }
    var session = !canUseEventBridge() ? startRumSessionManager(configuration, lifeCycle) : startRumSessionManagerStub();
    var domMutationObservable = createDOMMutationObservable();
    var locationChangeObservable = createLocationChangeObservable(location);
    var _a = startRumEventCollection(lifeCycle, configuration, location, session, locationChangeObservable, getCommonContext), parentContexts = _a.parentContexts, foregroundContexts = _a.foregroundContexts, urlContexts = _a.urlContexts;
    startLongTaskCollection(lifeCycle, session);
    startResourceCollection(lifeCycle);
    var _b = startViewCollection(lifeCycle, configuration, location, domMutationObservable, locationChangeObservable, foregroundContexts, recorderApi, initialViewName), addTiming = _b.addTiming, startView = _b.startView;
    var addError = startErrorCollection(lifeCycle, foregroundContexts).addError;
    var addAction = startActionCollection(lifeCycle, domMutationObservable, configuration, foregroundContexts).addAction;
    startRequestCollection(lifeCycle, configuration, session);
    startPerformanceCollection(lifeCycle, configuration);
    var internalContext = startInternalContext(configuration.applicationId, session, parentContexts, urlContexts);
    return {
        addAction: addAction,
        addError: addError,
        addTiming: addTiming,
        startView: startView,
        lifeCycle: lifeCycle,
        parentContexts: parentContexts,
        session: session,
        getInternalContext: internalContext.get,
    };
}
function startRumInternalMonitoring(configuration) {
    var _a;
    var internalMonitoring = startInternalMonitoring(configuration);
    if (canUseEventBridge()) {
        var bridge_1 = getEventBridge();
        internalMonitoring.monitoringMessageObservable.subscribe(function (message) { return bridge_1.send('internal_log', message); });
        internalMonitoring.telemetryEventObservable.subscribe(function (message) { return bridge_1.send('internal_telemetry', message); });
    }
    else if (configuration.internalMonitoringEndpointBuilder) {
        var batch_1 = startBatchWithReplica(configuration, configuration.internalMonitoringEndpointBuilder, (_a = configuration.replica) === null || _a === void 0 ? void 0 : _a.internalMonitoringEndpointBuilder);
        internalMonitoring.monitoringMessageObservable.subscribe(function (message) { return batch_1.add(message); });
    }
    return internalMonitoring;
}
function startRumEventCollection(lifeCycle, configuration, location, sessionManager, locationChangeObservable, getCommonContext) {
    var parentContexts = startParentContexts(lifeCycle);
    var urlContexts = startUrlContexts(lifeCycle, locationChangeObservable, location);
    var foregroundContexts = startForegroundContexts();
    startRumAssembly(configuration, lifeCycle, sessionManager, parentContexts, urlContexts, getCommonContext);
    return {
        parentContexts: parentContexts,
        foregroundContexts: foregroundContexts,
        urlContexts: urlContexts,
        stop: function () {
            parentContexts.stop();
            foregroundContexts.stop();
        },
    };
}

var RecordType = {
    FullSnapshot: 2,
    IncrementalSnapshot: 3,
    Meta: 4,
    Focus: 6,
    ViewEnd: 7,
    VisualViewport: 8,
};

var NodePrivacyLevel = {
    IGNORE: 'ignore',
    HIDDEN: 'hidden',
    ALLOW: DefaultPrivacyLevel.ALLOW,
    MASK: DefaultPrivacyLevel.MASK,
    MASK_USER_INPUT: DefaultPrivacyLevel.MASK_USER_INPUT,
};
var PRIVACY_ATTR_NAME = 'data-dd-privacy';
// Privacy Attrs
var PRIVACY_ATTR_VALUE_ALLOW = 'allow';
var PRIVACY_ATTR_VALUE_MASK = 'mask';
var PRIVACY_ATTR_VALUE_MASK_USER_INPUT = 'mask-user-input';
var PRIVACY_ATTR_VALUE_HIDDEN = 'hidden';
// Privacy Classes - not all customers can set plain HTML attributes, so support classes too
var PRIVACY_CLASS_ALLOW = 'dd-privacy-allow';
var PRIVACY_CLASS_MASK = 'dd-privacy-mask';
var PRIVACY_CLASS_MASK_USER_INPUT = 'dd-privacy-mask-user-input';
var PRIVACY_CLASS_HIDDEN = 'dd-privacy-hidden';
// Private Replacement Templates
var CENSORED_STRING_MARK = '***';
var CENSORED_IMG_MARK = 'data:image/gif;base64,R0lGODlhAQABAIAAAMLCwgAAACH5BAAAAAAALAAAAAABAAEAAAICRAEAOw==';
var FORM_PRIVATE_TAG_NAMES = {
    INPUT: true,
    OUTPUT: true,
    TEXTAREA: true,
    SELECT: true,
    OPTION: true,
    DATALIST: true,
    OPTGROUP: true,
};

var MAX_ATTRIBUTE_VALUE_CHAR_LENGTH = 100000;
var TEXT_MASKING_CHAR = 'x';
/**
 * Get node privacy level by iterating over its ancestors. When the direct parent privacy level is
 * know, it is best to use something like:
 *
 * derivePrivacyLevelGivenParent(getNodeSelfPrivacyLevel(node), parentNodePrivacyLevel)
 */
function getNodePrivacyLevel(node, defaultPrivacyLevel) {
    var parentNodePrivacyLevel = node.parentNode
        ? getNodePrivacyLevel(node.parentNode, defaultPrivacyLevel)
        : defaultPrivacyLevel;
    var selfNodePrivacyLevel = getNodeSelfPrivacyLevel(node);
    return reducePrivacyLevel(selfNodePrivacyLevel, parentNodePrivacyLevel);
}
/**
 * Reduces the next privacy level based on self + parent privacy levels
 */
function reducePrivacyLevel(childPrivacyLevel, parentNodePrivacyLevel) {
    switch (parentNodePrivacyLevel) {
        // These values cannot be overridden
        case NodePrivacyLevel.HIDDEN:
        case NodePrivacyLevel.IGNORE:
            return parentNodePrivacyLevel;
    }
    switch (childPrivacyLevel) {
        case NodePrivacyLevel.ALLOW:
        case NodePrivacyLevel.MASK:
        case NodePrivacyLevel.MASK_USER_INPUT:
        case NodePrivacyLevel.HIDDEN:
        case NodePrivacyLevel.IGNORE:
            return childPrivacyLevel;
        default:
            return parentNodePrivacyLevel;
    }
}
/**
 * Determines the node's own privacy level without checking for ancestors.
 */
function getNodeSelfPrivacyLevel(node) {
    // Only Element types can have a privacy level set
    if (!isElement(node)) {
        return;
    }
    var privAttr = node.getAttribute(PRIVACY_ATTR_NAME);
    // Overrules for replay purpose
    if (node.tagName === 'BASE') {
        return NodePrivacyLevel.ALLOW;
    }
    // Overrules to enforce end-user protection
    if (node.tagName === 'INPUT') {
        var inputElement = node;
        if (inputElement.type === 'password' || inputElement.type === 'email' || inputElement.type === 'tel') {
            return NodePrivacyLevel.MASK;
        }
        if (inputElement.type === 'hidden') {
            return NodePrivacyLevel.MASK;
        }
        var autocomplete = inputElement.getAttribute('autocomplete');
        // Handle input[autocomplete=cc-number/cc-csc/cc-exp/cc-exp-month/cc-exp-year]
        if (autocomplete && autocomplete.indexOf('cc-') === 0) {
            return NodePrivacyLevel.MASK;
        }
    }
    // Check HTML privacy attributes and classes
    if (privAttr === PRIVACY_ATTR_VALUE_HIDDEN || node.classList.contains(PRIVACY_CLASS_HIDDEN)) {
        return NodePrivacyLevel.HIDDEN;
    }
    if (privAttr === PRIVACY_ATTR_VALUE_MASK || node.classList.contains(PRIVACY_CLASS_MASK)) {
        return NodePrivacyLevel.MASK;
    }
    if (privAttr === PRIVACY_ATTR_VALUE_MASK_USER_INPUT || node.classList.contains(PRIVACY_CLASS_MASK_USER_INPUT)) {
        return NodePrivacyLevel.MASK_USER_INPUT;
    }
    if (privAttr === PRIVACY_ATTR_VALUE_ALLOW || node.classList.contains(PRIVACY_CLASS_ALLOW)) {
        return NodePrivacyLevel.ALLOW;
    }
    if (shouldIgnoreElement(node)) {
        return NodePrivacyLevel.IGNORE;
    }
}
/**
 * Helper aiming to unify `mask` and `mask-user-input` privacy levels:
 *
 * In the `mask` case, it is trivial: we should mask the element.
 *
 * In the `mask-user-input` case, we should mask the element only if it is a "form" element or the
 * direct parent is a form element for text nodes).
 *
 * Other `shouldMaskNode` cases are edge cases that should not matter too much (ex: should we mask a
 * node if it is ignored or hidden? it doesn't matter since it won't be serialized).
 */
function shouldMaskNode(node, privacyLevel) {
    switch (privacyLevel) {
        case NodePrivacyLevel.MASK:
        case NodePrivacyLevel.HIDDEN:
        case NodePrivacyLevel.IGNORE:
            return true;
        case NodePrivacyLevel.MASK_USER_INPUT:
            return isTextNode$1(node) ? isFormElement(node.parentNode) : isFormElement(node);
        default:
            return false;
    }
}
function isElement(node) {
    return node.nodeType === node.ELEMENT_NODE;
}
function isTextNode$1(node) {
    return node.nodeType === node.TEXT_NODE;
}
function isFormElement(node) {
    if (!node || node.nodeType !== node.ELEMENT_NODE) {
        return false;
    }
    var element = node;
    if (element.tagName === 'INPUT') {
        switch (element.type) {
            case 'button':
            case 'color':
            case 'reset':
            case 'submit':
                return false;
        }
    }
    return !!FORM_PRIVATE_TAG_NAMES[element.tagName];
}
/**
 * Text censoring non-destructively maintains whitespace characters in order to preserve text shape
 * during replay.
 */
var censorText = function (text) { return text.replace(/\S/g, TEXT_MASKING_CHAR); };
function getTextContent(textNode, ignoreWhiteSpace, parentNodePrivacyLevel) {
    var _a;
    // The parent node may not be a html element which has a tagName attribute.
    // So just let it be undefined which is ok in this use case.
    var parentTagName = (_a = textNode.parentElement) === null || _a === void 0 ? void 0 : _a.tagName;
    var textContent = textNode.textContent || '';
    if (ignoreWhiteSpace && !textContent.trim()) {
        return;
    }
    var nodePrivacyLevel = parentNodePrivacyLevel;
    var isStyle = parentTagName === 'STYLE' ? true : undefined;
    var isScript = parentTagName === 'SCRIPT';
    if (isScript) {
        // For perf reasons, we don't record script (heuristic)
        textContent = CENSORED_STRING_MARK;
    }
    else if (nodePrivacyLevel === NodePrivacyLevel.HIDDEN) {
        // Should never occur, but just in case, we set to CENSORED_MARK.
        textContent = CENSORED_STRING_MARK;
    }
    else if (shouldMaskNode(textNode, nodePrivacyLevel) &&
        // Style tags are `overruled` (Use `hide` to enforce privacy)
        !isStyle) {
        if (
        // Scrambling the child list breaks text nodes for DATALIST/SELECT/OPTGROUP
        parentTagName === 'DATALIST' ||
            parentTagName === 'SELECT' ||
            parentTagName === 'OPTGROUP') {
            if (!textContent.trim()) {
                return;
            }
        }
        else if (parentTagName === 'OPTION') {
            // <Option> has low entropy in charset + text length, so use `CENSORED_STRING_MARK` when masked
            textContent = CENSORED_STRING_MARK;
        }
        else {
            textContent = censorText(textContent);
        }
    }
    return textContent;
}

var serializedNodeIds = new WeakMap();
function hasSerializedNode(node) {
    return serializedNodeIds.has(node);
}
function nodeAndAncestorsHaveSerializedNode(node) {
    var current = node;
    while (current) {
        if (!hasSerializedNode(current)) {
            return false;
        }
        current = current.parentNode;
    }
    return true;
}
function getSerializedNodeId(node) {
    return serializedNodeIds.get(node);
}
function setSerializedNodeId(node, serializeNodeId) {
    serializedNodeIds.set(node, serializeNodeId);
}
/**
 * Get the element "value" to be serialized as an attribute or an input update record. It respects
 * the input privacy mode of the element.
 * PERFROMANCE OPTIMIZATION: Assumes that privacy level `HIDDEN` is never encountered because of earlier checks.
 */
function getElementInputValue(element, nodePrivacyLevel) {
    /*
     BROWSER SPEC NOTE: <input>, <select>
     For some <input> elements, the `value` is an exceptional property/attribute that has the
     value synced between el.value and el.getAttribute()
     input[type=button,checkbox,hidden,image,radio,reset,submit]
     */
    var tagName = element.tagName;
    var value = element.value;
    if (shouldMaskNode(element, nodePrivacyLevel)) {
        var type = element.type;
        if (tagName === 'INPUT' && (type === 'button' || type === 'submit' || type === 'reset')) {
            // Overrule `MASK` privacy level for button-like element values, as they are used during replay
            // to display their label. They can still be hidden via the "hidden" privacy attribute or class name.
            return value;
        }
        else if (!value || tagName === 'OPTION') {
            // <Option> value provides no benefit
            return;
        }
        return CENSORED_STRING_MARK;
    }
    if (tagName === 'OPTION' || tagName === 'SELECT') {
        return element.value;
    }
    if (tagName !== 'INPUT' && tagName !== 'TEXTAREA') {
        return;
    }
    return value;
}

function hookSetter(target, key, d) {
    var original = Object.getOwnPropertyDescriptor(target, key);
    Object.defineProperty(target, key, {
        set: function (value) {
            var _this = this;
            // put hooked setter into event loop to avoid of set latency
            setTimeout(function () {
                d.set.call(_this, value);
            }, 0);
            if (original && original.set) {
                original.set.call(this, value);
            }
        },
    });
    return function () {
        Object.defineProperty(target, key, original || {});
    };
}
function isTouchEvent(event) {
    return Boolean(event.changedTouches);
}
function forEach(list, callback) {
    Array.prototype.forEach.call(list, callback);
}

function serializeDocument(document, defaultPrivacyLevel) {
    // We are sure that Documents are never ignored, so this function never returns null
    return serializeNodeWithId(document, {
        document: document,
        parentNodePrivacyLevel: defaultPrivacyLevel,
    });
}
function serializeNodeWithId(node, options) {
    var serializedNode = serializeNode(node, options);
    if (!serializedNode) {
        return null;
    }
    // Try to reuse the previous id
    var id = getSerializedNodeId(node) || generateNextId();
    var serializedNodeWithId = serializedNode;
    serializedNodeWithId.id = id;
    setSerializedNodeId(node, id);
    if (options.serializedNodeIds) {
        options.serializedNodeIds.add(id);
    }
    return serializedNodeWithId;
}
function serializeNode(node, options) {
    switch (node.nodeType) {
        case node.DOCUMENT_NODE:
            return serializeDocumentNode(node, options);
        case node.DOCUMENT_TYPE_NODE:
            return serializeDocumentTypeNode(node);
        case node.ELEMENT_NODE:
            return serializeElementNode(node, options);
        case node.TEXT_NODE:
            return serializeTextNode(node, options);
        case node.CDATA_SECTION_NODE:
            return serializeCDataNode();
    }
}
function serializeDocumentNode(document, options) {
    return {
        type: 0 /* Document */,
        childNodes: serializeChildNodes(document, options),
    };
}
function serializeDocumentTypeNode(documentType) {
    return {
        type: 1 /* DocumentType */,
        name: documentType.name,
        publicId: documentType.publicId,
        systemId: documentType.systemId,
    };
}
/**
 * Serialzing Element nodes involves capturing:
 * 1. HTML ATTRIBUTES:
 * 2. JS STATE:
 * - scroll offsets
 * - Form fields (input value, checkbox checked, otpion selection, range)
 * - Canvas state,
 * - Media (video/audio) play mode + currentTime
 * - iframe contents
 * - webcomponents
 * 3. CUSTOM PROPERTIES:
 * - height+width for when `hidden` to cover the element
 * 4. EXCLUDED INTERACTION STATE:
 * - focus (possible, but not worth perf impact)
 * - hover (tracked only via mouse activity)
 * - fullscreen mode
 */
function serializeElementNode(element, options) {
    var _a;
    var tagName = getValidTagName(element.tagName);
    var isSVG = isSVGElement(element) || undefined;
    // For performance reason, we don't use getNodePrivacyLevel directly: we leverage the
    // parentNodePrivacyLevel option to avoid iterating over all parents
    var nodePrivacyLevel = reducePrivacyLevel(getNodeSelfPrivacyLevel(element), options.parentNodePrivacyLevel);
    if (nodePrivacyLevel === NodePrivacyLevel.HIDDEN) {
        var _b = element.getBoundingClientRect(), width = _b.width, height = _b.height;
        return {
            type: 2 /* Element */,
            tagName: tagName,
            attributes: (_a = {
                    rr_width: "".concat(width, "px"),
                    rr_height: "".concat(height, "px")
                },
                _a[PRIVACY_ATTR_NAME] = PRIVACY_ATTR_VALUE_HIDDEN,
                _a),
            childNodes: [],
            isSVG: isSVG,
        };
    }
    // Ignore Elements like Script and some Link, Metas
    if (nodePrivacyLevel === NodePrivacyLevel.IGNORE) {
        return;
    }
    var attributes = getAttributesForPrivacyLevel(element, nodePrivacyLevel);
    var childNodes = [];
    if (element.childNodes.length) {
        // OBJECT POOLING OPTIMIZATION:
        // We should not create a new object systematically as it could impact performances. Try to reuse
        // the same object as much as possible, and clone it only if we need to.
        var childNodesSerializationOptions = void 0;
        if (options.parentNodePrivacyLevel === nodePrivacyLevel && options.ignoreWhiteSpace === (tagName === 'head')) {
            childNodesSerializationOptions = options;
        }
        else {
            childNodesSerializationOptions = assign({}, options, {
                parentNodePrivacyLevel: nodePrivacyLevel,
                ignoreWhiteSpace: tagName === 'head',
            });
        }
        childNodes = serializeChildNodes(element, childNodesSerializationOptions);
    }
    return {
        type: 2 /* Element */,
        tagName: tagName,
        attributes: attributes,
        childNodes: childNodes,
        isSVG: isSVG,
    };
}
/**
 * TODO: Preserve CSS element order, and record the presence of the tag, just don't render
 * We don't need this logic on the recorder side.
 * For security related meta's, customer can mask themmanually given they
 * are easy to identify in the HEAD tag.
 */
function shouldIgnoreElement(element) {
    if (element.nodeName === 'SCRIPT') {
        return true;
    }
    if (element.nodeName === 'LINK') {
        var relAttribute = getLowerCaseAttribute('rel');
        return (
        // Scripts
        (relAttribute === 'preload' && getLowerCaseAttribute('as') === 'script') ||
            // Favicons
            relAttribute === 'shortcut icon' ||
            relAttribute === 'icon');
    }
    if (element.nodeName === 'META') {
        var nameAttribute = getLowerCaseAttribute('name');
        var relAttribute = getLowerCaseAttribute('rel');
        var propertyAttribute = getLowerCaseAttribute('property');
        return (
        // Favicons
        /^msapplication-tile(image|color)$/.test(nameAttribute) ||
            nameAttribute === 'application-name' ||
            relAttribute === 'icon' ||
            relAttribute === 'apple-touch-icon' ||
            relAttribute === 'shortcut icon' ||
            // Description
            nameAttribute === 'keywords' ||
            nameAttribute === 'description' ||
            // Social
            /^(og|twitter|fb):/.test(propertyAttribute) ||
            /^(og|twitter):/.test(nameAttribute) ||
            nameAttribute === 'pinterest' ||
            // Robots
            nameAttribute === 'robots' ||
            nameAttribute === 'googlebot' ||
            nameAttribute === 'bingbot' ||
            // Http headers. Ex: X-UA-Compatible, Content-Type, Content-Language, cache-control,
            // X-Translated-By
            element.hasAttribute('http-equiv') ||
            // Authorship
            nameAttribute === 'author' ||
            nameAttribute === 'generator' ||
            nameAttribute === 'framework' ||
            nameAttribute === 'publisher' ||
            nameAttribute === 'progid' ||
            /^article:/.test(propertyAttribute) ||
            /^product:/.test(propertyAttribute) ||
            // Verification
            nameAttribute === 'google-site-verification' ||
            nameAttribute === 'yandex-verification' ||
            nameAttribute === 'csrf-token' ||
            nameAttribute === 'p:domain_verify' ||
            nameAttribute === 'verify-v1' ||
            nameAttribute === 'verification' ||
            nameAttribute === 'shopify-checkout-api-token');
    }
    function getLowerCaseAttribute(name) {
        return (element.getAttribute(name) || '').toLowerCase();
    }
    return false;
}
/**
 * Text Nodes are dependant on Element nodes
 * Privacy levels are set on elements so we check the parentElement of a text node
 * for privacy level.
 */
function serializeTextNode(textNode, options) {
    var _a;
    // The parent node may not be a html element which has a tagName attribute.
    // So just let it be undefined which is ok in this use case.
    var parentTagName = (_a = textNode.parentElement) === null || _a === void 0 ? void 0 : _a.tagName;
    var textContent = getTextContent(textNode, options.ignoreWhiteSpace || false, options.parentNodePrivacyLevel);
    if (!textContent) {
        return;
    }
    return {
        type: 3 /* Text */,
        textContent: textContent,
        isStyle: parentTagName === 'STYLE' ? true : undefined,
    };
}
function serializeCDataNode() {
    return {
        type: 4 /* CDATA */,
        textContent: '',
    };
}
function serializeChildNodes(node, options) {
    var result = [];
    forEach(node.childNodes, function (childNode) {
        var serializedChildNode = serializeNodeWithId(childNode, options);
        if (serializedChildNode) {
            result.push(serializedChildNode);
        }
    });
    return result;
}
function serializeAttribute(element, nodePrivacyLevel, attributeName) {
    if (nodePrivacyLevel === NodePrivacyLevel.HIDDEN) {
        // dup condition for direct access case
        return null;
    }
    var attributeValue = element.getAttribute(attributeName);
    if (nodePrivacyLevel === NodePrivacyLevel.MASK) {
        var tagName = element.tagName;
        switch (attributeName) {
            // Mask Attribute text content
            case 'title':
            case 'alt':
                return CENSORED_STRING_MARK;
        }
        // mask image URLs
        if (tagName === 'IMG' || tagName === 'SOURCE') {
            if (attributeName === 'src' || attributeName === 'srcset') {
                return CENSORED_IMG_MARK;
            }
        }
        // mask <a> URLs
        if (tagName === 'A' && attributeName === 'href') {
            return CENSORED_STRING_MARK;
        }
        // mask data-* attributes
        if (attributeValue && attributeName.indexOf('data-') === 0 && attributeName !== PRIVACY_ATTR_NAME) {
            // Exception: it's safe to reveal the `${PRIVACY_ATTR_NAME}` attr
            return CENSORED_STRING_MARK;
        }
    }
    if (!attributeValue || typeof attributeValue !== 'string') {
        return attributeValue;
    }
    // Minimum Fix for customer.
    if (attributeValue.length > MAX_ATTRIBUTE_VALUE_CHAR_LENGTH && attributeValue.slice(0, 5) === 'data:') {
        return 'data:truncated';
    }
    return attributeValue;
}
var _nextId = 1;
function generateNextId() {
    return _nextId++;
}
var TAG_NAME_REGEX = /[^a-z1-6-_]/;
function getValidTagName(tagName) {
    var processedTagName = tagName.toLowerCase().trim();
    if (TAG_NAME_REGEX.test(processedTagName)) {
        // if the tag name is odd and we cannot extract
        // anything from the string, then we return a
        // generic div
        return 'div';
    }
    return processedTagName;
}
function getCssRulesString(s) {
    try {
        var rules = s.rules || s.cssRules;
        return rules ? Array.from(rules).map(getCssRuleString).join('') : null;
    }
    catch (error) {
        return null;
    }
}
function getCssRuleString(rule) {
    return isCSSImportRule(rule) ? getCssRulesString(rule.styleSheet) || '' : rule.cssText;
}
function isCSSImportRule(rule) {
    return 'styleSheet' in rule;
}
function isSVGElement(el) {
    return el.tagName === 'svg' || el instanceof SVGElement;
}
function getAttributesForPrivacyLevel(element, nodePrivacyLevel) {
    if (nodePrivacyLevel === NodePrivacyLevel.HIDDEN) {
        return {};
    }
    var safeAttrs = {};
    var tagName = getValidTagName(element.tagName);
    var doc = element.ownerDocument;
    for (var i = 0; i < element.attributes.length; i += 1) {
        var attribute = element.attributes.item(i);
        var attributeName = attribute.name;
        var attributeValue = serializeAttribute(element, nodePrivacyLevel, attributeName);
        if (attributeValue !== null) {
            safeAttrs[attributeName] = attributeValue;
        }
    }
    if (element.value &&
        (tagName === 'textarea' || tagName === 'select' || tagName === 'option' || tagName === 'input')) {
        var formValue = getElementInputValue(element, nodePrivacyLevel);
        if (formValue !== undefined) {
            safeAttrs.value = formValue;
        }
    }
    /**
     * <Option> can be selected, which occurs if its `value` matches ancestor `<Select>.value`
     */
    if (tagName === 'option' && nodePrivacyLevel === NodePrivacyLevel.ALLOW) {
        // For privacy=`MASK`, all the values would be the same, so skip.
        var optionElement = element;
        if (optionElement.selected) {
            safeAttrs.selected = optionElement.selected;
        }
    }
    // remote css
    if (tagName === 'link') {
        var stylesheet = Array.from(doc.styleSheets).find(function (s) { return s.href === element.href; });
        var cssText = getCssRulesString(stylesheet);
        if (cssText && stylesheet) {
            delete safeAttrs.rel;
            delete safeAttrs.href;
            safeAttrs._cssText = cssText;
        }
    }
    // dynamic stylesheet
    if (tagName === 'style' &&
        element.sheet &&
        // TODO: Currently we only try to get dynamic stylesheet when it is an empty style element
        !(element.innerText || element.textContent || '').trim().length) {
        var cssText = getCssRulesString(element.sheet);
        if (cssText) {
            safeAttrs._cssText = cssText;
        }
    }
    /**
     * Forms: input[type=checkbox,radio]
     * The `checked` property for <input> is a little bit special:
     * 1. el.checked is a setter that returns if truthy.
     * 2. getAttribute returns the string value
     * getAttribute('checked') does not sync with `Element.checked`, so use JS property
     * NOTE: `checked` property exists on `HTMLInputElement`. For serializer assumptions, we check for type=radio|check.
     */
    var inputElement = element;
    if (tagName === 'input' && (inputElement.type === 'radio' || inputElement.type === 'checkbox')) {
        if (nodePrivacyLevel === NodePrivacyLevel.ALLOW) {
            safeAttrs.checked = !!inputElement.checked;
        }
        else if (shouldMaskNode(inputElement, nodePrivacyLevel)) {
            safeAttrs.checked = CENSORED_STRING_MARK;
        }
    }
    /**
     * Serialize the media playback state
     */
    if (tagName === 'audio' || tagName === 'video') {
        var mediaElement = element;
        safeAttrs.rr_mediaState = mediaElement.paused ? 'paused' : 'played';
    }
    /**
     * Serialize the scroll state for each element
     */
    if (element.scrollLeft) {
        safeAttrs.rr_scrollLeft = Math.round(element.scrollLeft);
    }
    if (element.scrollTop) {
        safeAttrs.rr_scrollTop = Math.round(element.scrollTop);
    }
    return safeAttrs;
}

var IncrementalSource = {
    Mutation: 0,
    MouseMove: 1,
    MouseInteraction: 2,
    Scroll: 3,
    ViewportResize: 4,
    Input: 5,
    TouchMove: 6,
    MediaInteraction: 7,
    StyleSheetRule: 8,
    // CanvasMutation : 9,
    // Font : 10,
};
var MouseInteractions = {
    MouseUp: 0,
    MouseDown: 1,
    Click: 2,
    ContextMenu: 3,
    DblClick: 4,
    Focus: 5,
    Blur: 6,
    TouchStart: 7,
    TouchEnd: 9,
};
var MediaInteractions = {
    Play: 0,
    Pause: 1,
};

/**
 * Maximum duration to wait before processing mutations. If the browser is idle, mutations will be
 * processed more quickly. If the browser is busy executing small tasks (ex: rendering frames), the
 * mutations will wait MUTATION_PROCESS_MAX_DELAY milliseconds before being processed. If the
 * browser is busy executing a longer task, mutations will be processed after this task.
 */
var MUTATION_PROCESS_MAX_DELAY = 100;
function createMutationBatch(processMutationBatch) {
    var cancelScheduledFlush = noop;
    var pendingMutations = [];
    function flush() {
        cancelScheduledFlush();
        processMutationBatch(pendingMutations);
        pendingMutations = [];
    }
    return {
        addMutations: function (mutations) {
            if (pendingMutations.length === 0) {
                cancelScheduledFlush = requestIdleCallback(flush, { timeout: MUTATION_PROCESS_MAX_DELAY });
            }
            pendingMutations.push.apply(pendingMutations, mutations);
        },
        flush: flush,
        stop: function () {
            cancelScheduledFlush();
        },
    };
}

/**
 * Buffers and aggregate mutations generated by a MutationObserver into MutationPayload
 */
function startMutationObserver(controller, mutationCallback, defaultPrivacyLevel) {
    var MutationObserver = getMutationObserverConstructor();
    if (!MutationObserver) {
        return { stop: noop };
    }
    var mutationBatch = createMutationBatch(function (mutations) {
        processMutations(mutations.concat(observer.takeRecords()), mutationCallback, defaultPrivacyLevel);
    });
    var observer = new MutationObserver(monitor(mutationBatch.addMutations));
    observer.observe(document, {
        attributeOldValue: true,
        attributes: true,
        characterData: true,
        characterDataOldValue: true,
        childList: true,
        subtree: true,
    });
    controller.onFlush(mutationBatch.flush);
    return {
        stop: function () {
            observer.disconnect();
            mutationBatch.stop();
        },
    };
}
/**
 * Controls how mutations are processed, allowing to flush pending mutations.
 */
var MutationController = /** @class */ (function () {
    function MutationController() {
    }
    MutationController.prototype.flush = function () {
        var _a;
        (_a = this.flushListener) === null || _a === void 0 ? void 0 : _a.call(this);
    };
    MutationController.prototype.onFlush = function (listener) {
        this.flushListener = listener;
    };
    return MutationController;
}());
function processMutations(mutations, mutationCallback, defaultPrivacyLevel) {
    // Discard any mutation with a 'target' node that:
    // * isn't injected in the current document or isn't known/serialized yet: those nodes are likely
    // part of a mutation occurring in a parent Node
    // * should be hidden or ignored
    var filteredMutations = mutations.filter(function (mutation) {
        return document.contains(mutation.target) &&
            nodeAndAncestorsHaveSerializedNode(mutation.target) &&
            getNodePrivacyLevel(mutation.target, defaultPrivacyLevel) !== NodePrivacyLevel.HIDDEN;
    });
    var _a = processChildListMutations(filteredMutations.filter(function (mutation) { return mutation.type === 'childList'; }), defaultPrivacyLevel), adds = _a.adds, removes = _a.removes, hasBeenSerialized = _a.hasBeenSerialized;
    var texts = processCharacterDataMutations(filteredMutations.filter(function (mutation) {
        return mutation.type === 'characterData' && !hasBeenSerialized(mutation.target);
    }), defaultPrivacyLevel);
    var attributes = processAttributesMutations(filteredMutations.filter(function (mutation) {
        return mutation.type === 'attributes' && !hasBeenSerialized(mutation.target);
    }), defaultPrivacyLevel);
    if (!texts.length && !attributes.length && !removes.length && !adds.length) {
        return;
    }
    mutationCallback({
        adds: adds,
        removes: removes,
        texts: texts,
        attributes: attributes,
    });
}
function processChildListMutations(mutations, defaultPrivacyLevel) {
    // First, we iterate over mutations to collect:
    //
    // * nodes that have been added in the document and not removed by a subsequent mutation
    // * nodes that have been removed from the document but were not added in a previous mutation
    //
    // For this second category, we also collect their previous parent (mutation.target) because we'll
    // need it to emit a 'remove' mutation.
    //
    // Those two categories may overlap: if a node moved from a position to another, it is reported as
    // two mutation records, one with a "removedNodes" and the other with "addedNodes". In this case,
    // the node will be in both sets.
    var addedAndMovedNodes = new Set();
    var removedNodes = new Map();
    var _loop_1 = function (mutation) {
        forEach(mutation.addedNodes, function (node) {
            addedAndMovedNodes.add(node);
        });
        forEach(mutation.removedNodes, function (node) {
            if (!addedAndMovedNodes.has(node)) {
                removedNodes.set(node, mutation.target);
            }
            addedAndMovedNodes.delete(node);
        });
    };
    for (var _i = 0, mutations_1 = mutations; _i < mutations_1.length; _i++) {
        var mutation = mutations_1[_i];
        _loop_1(mutation);
    }
    // Then, we sort nodes that are still in the document by topological order, for two reasons:
    //
    // * We will serialize each added nodes with their descendants. We don't want to serialize a node
    // twice, so we need to iterate over the parent nodes first and skip any node that is contained in
    // a precedent node.
    //
    // * To emit "add" mutations, we need references to the parent and potential next sibling of each
    // added node. So we need to iterate over the parent nodes first, and when multiple nodes are
    // siblings, we want to iterate from last to first. This will ensure that any "next" node is
    // already serialized and have an id.
    var sortedAddedAndMovedNodes = Array.from(addedAndMovedNodes);
    sortAddedAndMovedNodes(sortedAddedAndMovedNodes);
    // Then, we iterate over our sorted node sets to emit mutations. We collect the newly serialized
    // node ids in a set to be able to skip subsequent related mutations.
    var serializedNodeIds = new Set();
    var addedNodeMutations = [];
    for (var _a = 0, sortedAddedAndMovedNodes_1 = sortedAddedAndMovedNodes; _a < sortedAddedAndMovedNodes_1.length; _a++) {
        var node = sortedAddedAndMovedNodes_1[_a];
        if (hasBeenSerialized(node)) {
            continue;
        }
        var parentNodePrivacyLevel = getNodePrivacyLevel(node.parentNode, defaultPrivacyLevel);
        if (parentNodePrivacyLevel === NodePrivacyLevel.HIDDEN || parentNodePrivacyLevel === NodePrivacyLevel.IGNORE) {
            continue;
        }
        var serializedNode = serializeNodeWithId(node, {
            document: document,
            serializedNodeIds: serializedNodeIds,
            parentNodePrivacyLevel: parentNodePrivacyLevel,
        });
        if (!serializedNode) {
            continue;
        }
        addedNodeMutations.push({
            nextId: getNextSibling(node),
            parentId: getSerializedNodeId(node.parentNode),
            node: serializedNode,
        });
    }
    // Finally, we emit remove mutations.
    var removedNodeMutations = [];
    removedNodes.forEach(function (parent, node) {
        if (hasSerializedNode(node)) {
            removedNodeMutations.push({
                parentId: getSerializedNodeId(parent),
                id: getSerializedNodeId(node),
            });
        }
    });
    return { adds: addedNodeMutations, removes: removedNodeMutations, hasBeenSerialized: hasBeenSerialized };
    function hasBeenSerialized(node) {
        return hasSerializedNode(node) && serializedNodeIds.has(getSerializedNodeId(node));
    }
    function getNextSibling(node) {
        var nextSibling = node.nextSibling;
        while (nextSibling) {
            if (hasSerializedNode(nextSibling)) {
                return getSerializedNodeId(nextSibling);
            }
            nextSibling = nextSibling.nextSibling;
        }
        return null;
    }
}
function processCharacterDataMutations(mutations, defaultPrivacyLevel) {
    var _a;
    var textMutations = [];
    // Deduplicate mutations based on their target node
    var handledNodes = new Set();
    var filteredMutations = mutations.filter(function (mutation) {
        if (handledNodes.has(mutation.target)) {
            return false;
        }
        handledNodes.add(mutation.target);
        return true;
    });
    // Emit mutations
    for (var _i = 0, filteredMutations_1 = filteredMutations; _i < filteredMutations_1.length; _i++) {
        var mutation = filteredMutations_1[_i];
        var value = mutation.target.textContent;
        if (value === mutation.oldValue) {
            continue;
        }
        var parentNodePrivacyLevel = getNodePrivacyLevel(mutation.target.parentNode, defaultPrivacyLevel);
        if (parentNodePrivacyLevel === NodePrivacyLevel.HIDDEN || parentNodePrivacyLevel === NodePrivacyLevel.IGNORE) {
            continue;
        }
        textMutations.push({
            id: getSerializedNodeId(mutation.target),
            // TODO: pass a valid "ignoreWhiteSpace" argument
            value: (_a = getTextContent(mutation.target, false, parentNodePrivacyLevel)) !== null && _a !== void 0 ? _a : null,
        });
    }
    return textMutations;
}
function processAttributesMutations(mutations, defaultPrivacyLevel) {
    var attributeMutations = [];
    // Deduplicate mutations based on their target node and changed attribute
    var handledElements = new Map();
    var filteredMutations = mutations.filter(function (mutation) {
        var handledAttributes = handledElements.get(mutation.target);
        if (handledAttributes === null || handledAttributes === void 0 ? void 0 : handledAttributes.has(mutation.attributeName)) {
            return false;
        }
        if (!handledAttributes) {
            handledElements.set(mutation.target, new Set([mutation.attributeName]));
        }
        else {
            handledAttributes.add(mutation.attributeName);
        }
        return true;
    });
    // Emit mutations
    var emittedMutations = new Map();
    for (var _i = 0, filteredMutations_2 = filteredMutations; _i < filteredMutations_2.length; _i++) {
        var mutation = filteredMutations_2[_i];
        var uncensoredValue = mutation.target.getAttribute(mutation.attributeName);
        if (uncensoredValue === mutation.oldValue) {
            continue;
        }
        var privacyLevel = getNodePrivacyLevel(mutation.target, defaultPrivacyLevel);
        var attributeValue = serializeAttribute(mutation.target, privacyLevel, mutation.attributeName);
        var transformedValue = void 0;
        if (mutation.attributeName === 'value') {
            var inputValue = getElementInputValue(mutation.target, privacyLevel);
            if (inputValue === undefined) {
                continue;
            }
            transformedValue = inputValue;
        }
        else if (attributeValue && typeof attributeValue === 'string') {
            transformedValue = attributeValue;
        }
        else {
            transformedValue = null;
        }
        var emittedMutation = emittedMutations.get(mutation.target);
        if (!emittedMutation) {
            emittedMutation = {
                id: getSerializedNodeId(mutation.target),
                attributes: {},
            };
            attributeMutations.push(emittedMutation);
            emittedMutations.set(mutation.target, emittedMutation);
        }
        emittedMutation.attributes[mutation.attributeName] = transformedValue;
    }
    return attributeMutations;
}
function sortAddedAndMovedNodes(nodes) {
    nodes.sort(function (a, b) {
        var position = a.compareDocumentPosition(b);
        /* eslint-disable no-bitwise */
        if (position & Node.DOCUMENT_POSITION_CONTAINED_BY) {
            return -1;
        }
        else if (position & Node.DOCUMENT_POSITION_CONTAINS) {
            return 1;
        }
        else if (position & Node.DOCUMENT_POSITION_FOLLOWING) {
            return 1;
        }
        else if (position & Node.DOCUMENT_POSITION_PRECEDING) {
            return -1;
        }
        /* eslint-enable no-bitwise */
        return 0;
    });
}

/**
 * Browsers have not standardized various dimension properties. Mobile devices typically report
 * dimensions in reference to the visual viewport, while desktop uses the layout viewport. For example,
 * Mobile Chrome will change innerWidth when a pinch zoom takes place, while Chrome Desktop (mac) will not.
 *
 * With the new Viewport API, we now calculate and normalize dimension properties to the layout viewport.
 * If the VisualViewport API is not supported by a browser, it isn't reasonably possible to detect or normalize
 * which viewport is being measured. Therefore these exported functions will fallback to assuming that the layout
 * viewport is being measured by the browser
 */
// Scrollbar widths vary across properties on different devices and browsers
var TOLERANCE = 25;
/**
 * Use the Visual Viewport API's properties to measure scrollX/Y in reference to the layout viewport
 * in order to determine if window.scrollX/Y is measuring the layout or visual viewport.
 * This finding corresponds to which viewport mouseEvent.clientX/Y and window.innerWidth/Height measures.
 */
function isVisualViewportFactoredIn() {
    var visual = window.visualViewport;
    return (Math.abs(visual.pageTop - visual.offsetTop - window.scrollY) > TOLERANCE ||
        Math.abs(visual.pageLeft - visual.offsetLeft - window.scrollX) > TOLERANCE);
}
var convertMouseEventToLayoutCoordinates = function (clientX, clientY) {
    var visual = window.visualViewport;
    var normalised = {
        layoutViewportX: clientX,
        layoutViewportY: clientY,
        visualViewportX: clientX,
        visualViewportY: clientY,
    };
    if (!visual) {
        // On old browsers, we cannot normalise, so fallback to clientX/Y
        return normalised;
    }
    else if (isVisualViewportFactoredIn()) {
        // Typically Mobile Devices
        normalised.layoutViewportX = Math.round(clientX + visual.offsetLeft);
        normalised.layoutViewportY = Math.round(clientY + visual.offsetTop);
    }
    else {
        // Typically Desktop Devices
        normalised.visualViewportX = Math.round(clientX - visual.offsetLeft);
        normalised.visualViewportY = Math.round(clientY - visual.offsetTop);
    }
    return normalised;
};
var getVisualViewport = function () {
    var visual = window.visualViewport;
    return {
        scale: visual.scale,
        offsetLeft: visual.offsetLeft,
        offsetTop: visual.offsetTop,
        pageLeft: visual.pageLeft,
        pageTop: visual.pageTop,
        height: visual.height,
        width: visual.width,
    };
};
// excludes the width of any rendered classic scrollbar that is fixed to the visual viewport
function getWindowWidth() {
    var visual = window.visualViewport;
    if (visual) {
        return visual.width * visual.scale;
    }
    return window.innerWidth || 0;
}
// excludes the height of any rendered classic scrollbar that is fixed to the visual viewport
function getWindowHeight() {
    var visual = window.visualViewport;
    if (visual) {
        return visual.height * visual.scale;
    }
    return window.innerHeight || 0;
}
function getScrollX() {
    var visual = window.visualViewport;
    if (visual) {
        return visual.pageLeft - visual.offsetLeft;
    }
    if (window.scrollX !== undefined) {
        return window.scrollX;
    }
    return window.pageXOffset || 0;
}
function getScrollY() {
    var visual = window.visualViewport;
    if (visual) {
        return visual.pageTop - visual.offsetTop;
    }
    if (window.scrollY !== undefined) {
        return window.scrollY;
    }
    return window.pageYOffset || 0;
}

var _a;
var MOUSE_MOVE_OBSERVER_THRESHOLD = 50;
var SCROLL_OBSERVER_THRESHOLD = 100;
var VISUAL_VIEWPORT_OBSERVER_THRESHOLD = 200;
function initObservers(o) {
    var mutationHandler = initMutationObserver(o.mutationController, o.mutationCb, o.defaultPrivacyLevel);
    var mousemoveHandler = initMoveObserver(o.mousemoveCb);
    var mouseInteractionHandler = initMouseInteractionObserver(o.mouseInteractionCb, o.defaultPrivacyLevel);
    var scrollHandler = initScrollObserver(o.scrollCb, o.defaultPrivacyLevel);
    var viewportResizeHandler = initViewportResizeObserver(o.viewportResizeCb);
    var inputHandler = initInputObserver(o.inputCb, o.defaultPrivacyLevel);
    var mediaInteractionHandler = initMediaInteractionObserver(o.mediaInteractionCb, o.defaultPrivacyLevel);
    var styleSheetObserver = initStyleSheetObserver(o.styleSheetRuleCb);
    var focusHandler = initFocusObserver(o.focusCb);
    var visualViewportResizeHandler = initVisualViewportResizeObserver(o.visualViewportResizeCb);
    return function () {
        mutationHandler();
        mousemoveHandler();
        mouseInteractionHandler();
        scrollHandler();
        viewportResizeHandler();
        inputHandler();
        mediaInteractionHandler();
        styleSheetObserver();
        focusHandler();
        visualViewportResizeHandler();
    };
}
function initMutationObserver(mutationController, cb, defaultPrivacyLevel) {
    return startMutationObserver(mutationController, cb, defaultPrivacyLevel).stop;
}
function initMoveObserver(cb) {
    var updatePosition = throttle(monitor(function (event) {
        var target = event.target;
        if (hasSerializedNode(target)) {
            var _a = isTouchEvent(event) ? event.changedTouches[0] : event, clientX = _a.clientX, clientY = _a.clientY;
            var position = {
                id: getSerializedNodeId(target),
                timeOffset: 0,
                x: clientX,
                y: clientY,
            };
            if (window.visualViewport) {
                var _b = convertMouseEventToLayoutCoordinates(clientX, clientY), visualViewportX = _b.visualViewportX, visualViewportY = _b.visualViewportY;
                position.x = visualViewportX;
                position.y = visualViewportY;
            }
            cb([position], isTouchEvent(event) ? IncrementalSource.TouchMove : IncrementalSource.MouseMove);
        }
    }), MOUSE_MOVE_OBSERVER_THRESHOLD, {
        trailing: false,
    }).throttled;
    return addEventListeners(document, ["mousemove" /* MOUSE_MOVE */, "touchmove" /* TOUCH_MOVE */], updatePosition, {
        capture: true,
        passive: true,
    }).stop;
}
var eventTypeToMouseInteraction = (_a = {},
    _a["mouseup" /* MOUSE_UP */] = MouseInteractions.MouseUp,
    _a["mousedown" /* MOUSE_DOWN */] = MouseInteractions.MouseDown,
    _a["click" /* CLICK */] = MouseInteractions.Click,
    _a["contextmenu" /* CONTEXT_MENU */] = MouseInteractions.ContextMenu,
    _a["dblclick" /* DBL_CLICK */] = MouseInteractions.DblClick,
    _a["focus" /* FOCUS */] = MouseInteractions.Focus,
    _a["blur" /* BLUR */] = MouseInteractions.Blur,
    _a["touchstart" /* TOUCH_START */] = MouseInteractions.TouchStart,
    _a["touchend" /* TOUCH_END */] = MouseInteractions.TouchEnd,
    _a);
function initMouseInteractionObserver(cb, defaultPrivacyLevel) {
    var handler = function (event) {
        var target = event.target;
        if (getNodePrivacyLevel(target, defaultPrivacyLevel) === NodePrivacyLevel.HIDDEN || !hasSerializedNode(target)) {
            return;
        }
        var _a = isTouchEvent(event) ? event.changedTouches[0] : event, clientX = _a.clientX, clientY = _a.clientY;
        var position = {
            id: getSerializedNodeId(target),
            type: eventTypeToMouseInteraction[event.type],
            x: clientX,
            y: clientY,
        };
        if (window.visualViewport) {
            var _b = convertMouseEventToLayoutCoordinates(clientX, clientY), visualViewportX = _b.visualViewportX, visualViewportY = _b.visualViewportY;
            position.x = visualViewportX;
            position.y = visualViewportY;
        }
        cb(position);
    };
    return addEventListeners(document, Object.keys(eventTypeToMouseInteraction), handler, {
        capture: true,
        passive: true,
    }).stop;
}
function initScrollObserver(cb, defaultPrivacyLevel) {
    var updatePosition = throttle(monitor(function (event) {
        var target = event.target;
        if (!target ||
            getNodePrivacyLevel(target, defaultPrivacyLevel) === NodePrivacyLevel.HIDDEN ||
            !hasSerializedNode(target)) {
            return;
        }
        var id = getSerializedNodeId(target);
        if (target === document) {
            cb({
                id: id,
                x: getScrollX(),
                y: getScrollY(),
            });
        }
        else {
            cb({
                id: id,
                x: target.scrollLeft,
                y: target.scrollTop,
            });
        }
    }), SCROLL_OBSERVER_THRESHOLD).throttled;
    return addEventListener(document, "scroll" /* SCROLL */, updatePosition, { capture: true, passive: true }).stop;
}
function initViewportResizeObserver(cb) {
    var updateDimension = throttle(monitor(function () {
        var height = getWindowHeight();
        var width = getWindowWidth();
        cb({
            height: Number(height),
            width: Number(width),
        });
    }), 200).throttled;
    return addEventListener(window, "resize" /* RESIZE */, updateDimension, { capture: true, passive: true }).stop;
}
var INPUT_TAGS = ['INPUT', 'TEXTAREA', 'SELECT'];
var lastInputStateMap = new WeakMap();
function initInputObserver(cb, defaultPrivacyLevel) {
    function eventHandler(event) {
        var target = event.target;
        var nodePrivacyLevel = getNodePrivacyLevel(target, defaultPrivacyLevel);
        if (!target ||
            !target.tagName ||
            !includes(INPUT_TAGS, target.tagName) ||
            nodePrivacyLevel === NodePrivacyLevel.HIDDEN) {
            return;
        }
        var type = target.type;
        var inputState;
        if (type === 'radio' || type === 'checkbox') {
            if (shouldMaskNode(target, nodePrivacyLevel)) {
                return;
            }
            inputState = { isChecked: target.checked };
        }
        else {
            var value = getElementInputValue(target, nodePrivacyLevel);
            if (value === undefined) {
                return;
            }
            inputState = { text: value };
        }
        // Can be multiple changes on the same node within the same batched mutation observation.
        cbWithDedup(target, inputState);
        // If a radio was checked, other radios with the same name attribute will be unchecked.
        var name = target.name;
        if (type === 'radio' && name && target.checked) {
            forEach(document.querySelectorAll("input[type=\"radio\"][name=\"".concat(name, "\"]")), function (el) {
                if (el !== target) {
                    // TODO: Consider the privacy implications for various differing input privacy levels
                    cbWithDedup(el, { isChecked: false });
                }
            });
        }
    }
    /**
     * There can be multiple changes on the same node within the same batched mutation observation.
     */
    function cbWithDedup(target, inputState) {
        if (!hasSerializedNode(target)) {
            return;
        }
        var lastInputState = lastInputStateMap.get(target);
        if (!lastInputState ||
            lastInputState.text !== inputState.text ||
            lastInputState.isChecked !== inputState.isChecked) {
            lastInputStateMap.set(target, inputState);
            cb(assign({
                id: getSerializedNodeId(target),
            }, inputState));
        }
    }
    var stopEventListeners = addEventListeners(document, ["input" /* INPUT */, "change" /* CHANGE */], eventHandler, {
        capture: true,
        passive: true,
    }).stop;
    var propertyDescriptor = Object.getOwnPropertyDescriptor(HTMLInputElement.prototype, 'value');
    var hookProperties = [
        [HTMLInputElement.prototype, 'value'],
        [HTMLInputElement.prototype, 'checked'],
        [HTMLSelectElement.prototype, 'value'],
        [HTMLTextAreaElement.prototype, 'value'],
        // Some UI library use selectedIndex to set select value
        [HTMLSelectElement.prototype, 'selectedIndex'],
    ];
    var hookResetters = [];
    if (propertyDescriptor && propertyDescriptor.set) {
        hookResetters.push.apply(hookResetters, hookProperties.map(function (p) {
            return hookSetter(p[0], p[1], {
                set: monitor(function () {
                    // mock to a normal event
                    eventHandler({ target: this });
                }),
            });
        }));
    }
    return function () {
        hookResetters.forEach(function (h) { return h(); });
        stopEventListeners();
    };
}
function initStyleSheetObserver(cb) {
    // eslint-disable-next-line @typescript-eslint/unbound-method
    var insertRule = CSSStyleSheet.prototype.insertRule;
    CSSStyleSheet.prototype.insertRule = function (rule, index) {
        var _this = this;
        callMonitored(function () {
            if (hasSerializedNode(_this.ownerNode)) {
                cb({
                    id: getSerializedNodeId(_this.ownerNode),
                    adds: [{ rule: rule, index: index }],
                });
            }
        });
        return insertRule.call(this, rule, index);
    };
    // eslint-disable-next-line @typescript-eslint/unbound-method
    var deleteRule = CSSStyleSheet.prototype.deleteRule;
    CSSStyleSheet.prototype.deleteRule = function (index) {
        var _this = this;
        callMonitored(function () {
            if (hasSerializedNode(_this.ownerNode)) {
                cb({
                    id: getSerializedNodeId(_this.ownerNode),
                    removes: [{ index: index }],
                });
            }
        });
        return deleteRule.call(this, index);
    };
    return function () {
        CSSStyleSheet.prototype.insertRule = insertRule;
        CSSStyleSheet.prototype.deleteRule = deleteRule;
    };
}
function initMediaInteractionObserver(mediaInteractionCb, defaultPrivacyLevel) {
    var handler = function (event) {
        var target = event.target;
        if (!target ||
            getNodePrivacyLevel(target, defaultPrivacyLevel) === NodePrivacyLevel.HIDDEN ||
            !hasSerializedNode(target)) {
            return;
        }
        mediaInteractionCb({
            id: getSerializedNodeId(target),
            type: event.type === "play" /* PLAY */ ? MediaInteractions.Play : MediaInteractions.Pause,
        });
    };
    return addEventListeners(document, ["play" /* PLAY */, "pause" /* PAUSE */], handler, { capture: true, passive: true }).stop;
}
function initFocusObserver(focusCb) {
    return addEventListeners(window, ["focus" /* FOCUS */, "blur" /* BLUR */], function () {
        focusCb({ has_focus: document.hasFocus() });
    }).stop;
}
function initVisualViewportResizeObserver(cb) {
    if (!window.visualViewport) {
        return noop;
    }
    var _a = throttle(monitor(function () {
        cb(getVisualViewport());
    }), VISUAL_VIEWPORT_OBSERVER_THRESHOLD, {
        trailing: false,
    }), updateDimension = _a.throttled, cancelThrottle = _a.cancel;
    var removeListener = addEventListeners(window.visualViewport, ["resize" /* RESIZE */, "scroll" /* SCROLL */], updateDimension, {
        capture: true,
        passive: true,
    }).stop;
    return function stop() {
        removeListener();
        cancelThrottle();
    };
}

function record(options) {
    var emit = options.emit;
    // runtime checks for user options
    if (!emit) {
        throw new Error('emit function is required');
    }
    var mutationController = new MutationController();
    var takeFullSnapshot = function () {
        mutationController.flush(); // process any pending mutation before taking a full snapshot
        emit({
            data: {
                height: getWindowHeight(),
                href: window.location.href,
                width: getWindowWidth(),
            },
            type: RecordType.Meta,
        });
        emit({
            data: {
                has_focus: document.hasFocus(),
            },
            type: RecordType.Focus,
        });
        emit({
            data: {
                node: serializeDocument(document, options.defaultPrivacyLevel),
                initialOffset: {
                    left: getScrollX(),
                    top: getScrollY(),
                },
            },
            type: RecordType.FullSnapshot,
        });
        if (window.visualViewport) {
            emit({
                data: getVisualViewport(),
                type: RecordType.VisualViewport,
            });
        }
    };
    takeFullSnapshot();
    var stopObservers = initObservers({
        mutationController: mutationController,
        defaultPrivacyLevel: options.defaultPrivacyLevel,
        inputCb: function (v) { return emit(assembleIncrementalSnapshot(IncrementalSource.Input, v)); },
        mediaInteractionCb: function (p) {
            return emit(assembleIncrementalSnapshot(IncrementalSource.MediaInteraction, p));
        },
        mouseInteractionCb: function (d) {
            return emit(assembleIncrementalSnapshot(IncrementalSource.MouseInteraction, d));
        },
        mousemoveCb: function (positions, source) { return emit(assembleIncrementalSnapshot(source, { positions: positions })); },
        mutationCb: function (m) { return emit(assembleIncrementalSnapshot(IncrementalSource.Mutation, m)); },
        scrollCb: function (p) { return emit(assembleIncrementalSnapshot(IncrementalSource.Scroll, p)); },
        styleSheetRuleCb: function (r) { return emit(assembleIncrementalSnapshot(IncrementalSource.StyleSheetRule, r)); },
        viewportResizeCb: function (d) { return emit(assembleIncrementalSnapshot(IncrementalSource.ViewportResize, d)); },
        focusCb: function (data) {
            return emit({
                type: RecordType.Focus,
                data: data,
            });
        },
        visualViewportResizeCb: function (data) {
            emit({
                data: data,
                type: RecordType.VisualViewport,
            });
        },
    });
    return {
        stop: stopObservers,
        takeFullSnapshot: takeFullSnapshot,
        flushMutations: function () { return mutationController.flush(); },
    };
}
function assembleIncrementalSnapshot(source, data) {
    return {
        data: assign({
            source: source,
        }, data),
        type: RecordType.IncrementalSnapshot,
    };
}

var SEND_BEACON_BYTE_LENGTH_LIMIT = 60000;
function send(endpointBuilder, data, metadata, rawSegmentSize, flushReason) {
    var formData = new FormData();
    formData.append('segment', new Blob([data], {
        type: 'application/octet-stream',
    }), "".concat(metadata.session.id, "-").concat(metadata.start));
    toFormEntries(metadata, function (key, value) { return formData.append(key, value); });
    formData.append('raw_segment_size', rawSegmentSize.toString());
    var request = new HttpRequest(endpointBuilder, SEND_BEACON_BYTE_LENGTH_LIMIT);
    request.send(formData, data.byteLength, flushReason);
}
function toFormEntries(input, onEntry, prefix) {
    if (prefix === void 0) { prefix = ''; }
    objectEntries(input).forEach(function (_a) {
        var key = _a[0], value = _a[1];
        if (typeof value === 'object' && value !== null) {
            toFormEntries(value, onEntry, "".concat(prefix).concat(key, "."));
        }
        else {
            onEntry("".concat(prefix).concat(key), String(value));
        }
    });
}

var MAX_STATS_HISTORY = 10;
var statsPerView;
function getSegmentsCount(viewId) {
    return getOrCreateReplayStats(viewId).segments_count;
}
function addSegment(viewId) {
    getOrCreateReplayStats(viewId).segments_count += 1;
}
function addRecord(viewId) {
    getOrCreateReplayStats(viewId).records_count += 1;
}
function addWroteData(viewId, additionalRawSize) {
    getOrCreateReplayStats(viewId).segments_total_raw_size += additionalRawSize;
}
function getReplayStats(viewId) {
    return statsPerView === null || statsPerView === void 0 ? void 0 : statsPerView.get(viewId);
}
function getOrCreateReplayStats(viewId) {
    if (!statsPerView) {
        statsPerView = new Map();
    }
    var replayStats;
    if (statsPerView.has(viewId)) {
        replayStats = statsPerView.get(viewId);
    }
    else {
        replayStats = {
            records_count: 0,
            segments_count: 0,
            segments_total_raw_size: 0,
        };
        statsPerView.set(viewId, replayStats);
        if (statsPerView.size > MAX_STATS_HISTORY) {
            deleteOldestStats();
        }
    }
    return replayStats;
}
function deleteOldestStats() {
    if (!statsPerView) {
        return;
    }
    if (statsPerView.keys) {
        statsPerView.delete(statsPerView.keys().next().value);
    }
    else {
        // IE11 doesn't support map.keys
        var isFirst_1 = true;
        statsPerView.forEach(function (_value, key) {
            if (isFirst_1) {
                statsPerView.delete(key);
                isFirst_1 = false;
            }
        });
    }
}

var nextId = 0;
var Segment = /** @class */ (function () {
    function Segment(worker, context, creationReason, initialRecord, onWrote, onFlushed) {
        var _this = this;
        this.worker = worker;
        this.isFlushed = false;
        this.id = nextId++;
        var viewId = context.view.id;
        this.metadata = assign({
            start: initialRecord.timestamp,
            end: initialRecord.timestamp,
            creation_reason: creationReason,
            records_count: 1,
            has_full_snapshot: initialRecord.type === RecordType.FullSnapshot,
            index_in_view: getSegmentsCount(viewId),
        }, context);
        addSegment(viewId);
        addRecord(viewId);
        var listener = monitor(function (_a) {
            var data = _a.data;
            if (data.type === 'errored' || data.type === 'initialized') {
                return;
            }
            if (data.id === _this.id) {
                addWroteData(viewId, data.additionalRawSize);
                if (data.type === 'flushed') {
                    onFlushed(data.result, data.rawSize);
                    worker.removeEventListener('message', listener);
                }
                else {
                    onWrote(data.compressedSize);
                }
            }
            else if (data.id > _this.id) {
                // Messages should be received in the same order as they are sent, so if we receive a
                // message with an id superior to this Segment instance id, we know that another, more
                // recent Segment instance is being used.
                //
                // In theory, a "flush" response should have been received at this point, so the listener
                // should already have been removed. But if something goes wrong and we didn't receive a
                // "flush" response, remove the listener to avoid any leak, and send a monitor message to
                // help investigate the issue.
                worker.removeEventListener('message', listener);
                addMonitoringMessage("Segment did not receive a 'flush' response before being replaced.");
            }
        });
        worker.addEventListener('message', listener);
        this.worker.postMessage({ data: "{\"records\":[".concat(JSON.stringify(initialRecord)), id: this.id, action: 'write' });
    }
    Segment.prototype.addRecord = function (record) {
        var _a;
        this.metadata.end = record.timestamp;
        this.metadata.records_count += 1;
        addRecord(this.metadata.view.id);
        (_a = this.metadata).has_full_snapshot || (_a.has_full_snapshot = record.type === RecordType.FullSnapshot);
        this.worker.postMessage({ data: ",".concat(JSON.stringify(record)), id: this.id, action: 'write' });
    };
    Segment.prototype.flush = function (reason) {
        this.worker.postMessage({
            data: "],".concat(JSON.stringify(this.metadata).slice(1), "\n"),
            id: this.id,
            action: 'flush',
        });
        this.isFlushed = true;
        this.flushReason = reason;
    };
    return Segment;
}());

var MAX_SEGMENT_DURATION = 30000;
var MAX_SEGMENT_SIZE = SEND_BEACON_BYTE_LENGTH_LIMIT;
// Segments are the main data structure for session replays. They contain context information used
// for indexing or UI needs, and a list of records (RRWeb 'events', renamed to avoid confusing
// namings). They are stored without any processing from the intake, and fetched one after the
// other while a session is being replayed. Their encoding (deflate) are carefully crafted to allow
// concatenating multiple segments together. Segments have a size overhead (metadata), so our goal is to
// build segments containing as much records as possible while complying with the various flush
// strategies to guarantee a good replay quality.
//
// When the recording starts, a segment is initially created.  The segment is flushed (finalized and
// sent) based on various events (non-exhaustive list):
//
// * the page visibility change or becomes to unload
// * the segment duration reaches a limit
// * the encoded segment size reaches a limit
// * ...
//
// A segment cannot be created without its context.  If the RUM session ends and no session id is
// available when creating a new segment, records will be ignored, until the session is renewed and
// a new session id is available.
//
// Empty segments (segments with no record) aren't useful and should be ignored.
//
// To help investigate session replays issues, each segment is created with a "creation reason",
// indicating why the session has been created.
function startSegmentCollection(lifeCycle, applicationId, sessionManager, parentContexts, send, worker) {
    return doStartSegmentCollection(lifeCycle, function () { return computeSegmentContext(applicationId, sessionManager, parentContexts); }, send, worker);
}
function doStartSegmentCollection(lifeCycle, getSegmentContext, send, worker, emitter) {
    if (emitter === void 0) { emitter = window; }
    var state = {
        status: 0 /* WaitingForInitialRecord */,
        nextSegmentCreationReason: 'init',
    };
    var unsubscribeViewCreated = lifeCycle.subscribe(4 /* VIEW_CREATED */, function () {
        flushSegment('view_change');
    }).unsubscribe;
    var unsubscribeBeforeUnload = lifeCycle.subscribe(11 /* BEFORE_UNLOAD */, function () {
        flushSegment('before_unload');
    }).unsubscribe;
    var unsubscribeVisibilityChange = addEventListener(emitter, "visibilitychange" /* VISIBILITY_CHANGE */, function () {
        if (document.visibilityState === 'hidden') {
            flushSegment('visibility_hidden');
        }
    }, { capture: true }).stop;
    function flushSegment(nextSegmentCreationReason) {
        if (state.status === 1 /* SegmentPending */) {
            state.segment.flush(nextSegmentCreationReason || 'sdk_stopped');
            clearTimeout(state.expirationTimeoutId);
        }
        if (nextSegmentCreationReason) {
            state = {
                status: 0 /* WaitingForInitialRecord */,
                nextSegmentCreationReason: nextSegmentCreationReason,
            };
        }
        else {
            state = {
                status: 2 /* Stopped */,
            };
        }
    }
    function createNewSegment(creationReason, initialRecord) {
        var context = getSegmentContext();
        if (!context) {
            return;
        }
        var segment = new Segment(worker, context, creationReason, initialRecord, function (compressedSegmentSize) {
            if (!segment.isFlushed && compressedSegmentSize > MAX_SEGMENT_SIZE) {
                flushSegment('max_size');
            }
        }, function (data, rawSegmentSize) {
            send(data, segment.metadata, rawSegmentSize, segment.flushReason);
        });
        state = {
            status: 1 /* SegmentPending */,
            segment: segment,
            expirationTimeoutId: setTimeout(monitor(function () {
                flushSegment('max_duration');
            }), MAX_SEGMENT_DURATION),
        };
    }
    return {
        addRecord: function (record) {
            switch (state.status) {
                case 0 /* WaitingForInitialRecord */:
                    createNewSegment(state.nextSegmentCreationReason, record);
                    break;
                case 1 /* SegmentPending */:
                    state.segment.addRecord(record);
                    break;
            }
        },
        stop: function () {
            flushSegment();
            unsubscribeViewCreated();
            unsubscribeBeforeUnload();
            unsubscribeVisibilityChange();
        },
    };
}
function computeSegmentContext(applicationId, sessionManager, parentContexts) {
    var session = sessionManager.findTrackedSession();
    var viewContext = parentContexts.findView();
    if (!session || !viewContext) {
        return undefined;
    }
    return {
        application: {
            id: applicationId,
        },
        session: {
            id: session.id,
        },
        view: {
            id: viewContext.view.id,
        },
    };
}

var workerURL;
function createDeflateWorker() {
    // Lazily compute the worker URL to allow importing the SDK in NodeJS
    if (!workerURL) {
        workerURL = URL.createObjectURL(new Blob(["(".concat(workerCodeFn, ")(self)")]));
    }
    return new Worker(workerURL);
}
function workerCodeFn() {
    monitor(function () {
        var _a = makePakoDeflate(), Deflate = _a.Deflate, constants = _a.constants, string2buf = _a.string2buf;
        var deflate = new Deflate();
        var rawSize = 0;
        self.addEventListener('message', monitor(function (event) {
            var data = event.data;
            switch (data.action) {
                case 'init':
                    self.postMessage({
                        type: 'initialized',
                    });
                    break;
                case 'write': {
                    var additionalRawSize = pushData(data.data);
                    self.postMessage({
                        type: 'wrote',
                        id: data.id,
                        compressedSize: deflate.chunks.reduce(function (total, chunk) { return total + chunk.length; }, 0),
                        additionalRawSize: additionalRawSize,
                    });
                    break;
                }
                case 'flush': {
                    var additionalRawSize = data.data ? pushData(data.data) : 0;
                    deflate.push('', constants.Z_FINISH);
                    self.postMessage({
                        type: 'flushed',
                        id: data.id,
                        result: deflate.result,
                        additionalRawSize: additionalRawSize,
                        rawSize: rawSize,
                    });
                    deflate = new Deflate();
                    rawSize = 0;
                    break;
                }
            }
        }));
        function pushData(data) {
            // TextEncoder is not supported on old browser version like Edge 18, therefore we use string2buf
            var binaryData = string2buf(data);
            deflate.push(binaryData, constants.Z_SYNC_FLUSH);
            rawSize += binaryData.length;
            return binaryData.length;
        }
    })();
    function monitor(fn) {
        return function () {
            try {
                return fn.apply(this, arguments);
            }
            catch (e) {
                try {
                    self.postMessage({
                        type: 'errored',
                        error: e,
                    });
                }
                catch (_) {
                    // DATA_CLONE_ERR, cf https://developer.mozilla.org/en-US/docs/Web/API/Web_Workers_API/Structured_clone_algorithm
                    self.postMessage({
                        type: 'errored',
                        error: "".concat(e),
                    });
                }
            }
        };
    }
    // https://github.com/nodeca/pako/blob/034669ba0f1a4c0590e45f7c2820128200f972b3/dist/pako_deflate.es5.js
    function makePakoDeflate() {
        /* eslint-disable camelcase, no-bitwise */
        // (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
        //
        // This software is provided 'as-is', without any express or implied
        // warranty. In no event will the authors be held liable for any damages
        // arising from the use of this software.
        //
        // Permission is granted to anyone to use this software for any purpose,
        // including commercial applications, and to alter it and redistribute it
        // freely, subject to the following restrictions:
        //
        // 1. The origin of this software must not be misrepresented; you must not
        //   claim that you wrote the original software. If you use this software
        //   in a product, an acknowledgment in the product documentation would be
        //   appreciated but is not required.
        // 2. Altered source versions must be plainly marked as such, and must not be
        //   misrepresented as being the original software.
        // 3. This notice may not be removed or altered from any source distribution.
        /* Public constants ========================================================== */
        /* =========================================================================== */
        // const Z_FILTERED          = 1;
        // const Z_HUFFMAN_ONLY      = 2;
        // const Z_RLE               = 3;
        var Z_FIXED = 4; // const Z_DEFAULT_STRATEGY  = 0;
        /* Possible values of the data_type field (though see inflate()) */
        var Z_BINARY = 0;
        var Z_TEXT = 1; // const Z_ASCII             = 1; // = Z_TEXT
        var Z_UNKNOWN = 2;
        /* ============================================================================ */
        function zero(buf) {
            var len = buf.length;
            while (--len >= 0) {
                buf[len] = 0;
            }
        } // From zutil.h
        var STORED_BLOCK = 0;
        var STATIC_TREES = 1;
        var DYN_TREES = 2;
        /* The three kinds of block type */
        var MIN_MATCH = 3;
        var MAX_MATCH = 258;
        /* The minimum and maximum match lengths */
        // From deflate.h
        /* ===========================================================================
         * Internal compression state.
         */
        var LENGTH_CODES = 29;
        /* number of length codes, not counting the special END_BLOCK code */
        var LITERALS = 256;
        /* number of literal bytes 0..255 */
        var L_CODES = LITERALS + 1 + LENGTH_CODES;
        /* number of Literal or Length codes, including the END_BLOCK code */
        var D_CODES = 30;
        /* number of distance codes */
        var BL_CODES = 19;
        /* number of codes used to transfer the bit lengths */
        var HEAP_SIZE = 2 * L_CODES + 1;
        /* maximum heap size */
        var MAX_BITS = 15;
        /* All codes must not exceed MAX_BITS bits */
        var Buf_size = 16;
        /* size of bit buffer in bi_buf */
        /* ===========================================================================
         * Constants
         */
        var MAX_BL_BITS = 7;
        /* Bit length codes must not exceed MAX_BL_BITS bits */
        var END_BLOCK = 256;
        /* end of block literal code */
        var REP_3_6 = 16;
        /* repeat previous bit length 3-6 times (2 bits of repeat count) */
        var REPZ_3_10 = 17;
        /* repeat a zero length 3-10 times  (3 bits of repeat count) */
        var REPZ_11_138 = 18;
        /* repeat a zero length 11-138 times  (7 bits of repeat count) */
        var extra_lbits = 
        /* extra bits for each length code */
        new Uint8Array([0, 0, 0, 0, 0, 0, 0, 0, 1, 1, 1, 1, 2, 2, 2, 2, 3, 3, 3, 3, 4, 4, 4, 4, 5, 5, 5, 5, 0]);
        var extra_dbits = 
        /* extra bits for each distance code */
        new Uint8Array([0, 0, 0, 0, 1, 1, 2, 2, 3, 3, 4, 4, 5, 5, 6, 6, 7, 7, 8, 8, 9, 9, 10, 10, 11, 11, 12, 12, 13, 13]);
        var extra_blbits = 
        /* extra bits for each bit length code */
        new Uint8Array([0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 2, 3, 7]);
        var bl_order = new Uint8Array([16, 17, 18, 0, 8, 7, 9, 6, 10, 5, 11, 4, 12, 3, 13, 2, 14, 1, 15]);
        /* eslint-enable comma-spacing,array-bracket-spacing */
        /* The lengths of the bit length codes are sent in order of decreasing
         * probability, to avoid transmitting the lengths for unused bit length codes.
         */
        /* ===========================================================================
         * Local data. These are initialized only once.
         */
        // We pre-fill arrays with 0 to avoid uninitialized gaps
        var DIST_CODE_LEN = 512;
        /* see definition of array dist_code below */
        // !!!! Use flat array instead of structure, Freq = i*2, Len = i*2+1
        var static_ltree = new Array((L_CODES + 2) * 2);
        zero(static_ltree);
        /* The static literal tree. Since the bit lengths are imposed, there is no
         * need for the L_CODES extra codes used during heap construction. However
         * The codes 286 and 287 are needed to build a canonical tree (see _tr_init
         * below).
         */
        var static_dtree = new Array(D_CODES * 2);
        zero(static_dtree);
        /* The static distance tree. (Actually a trivial tree since all codes use
         * 5 bits.)
         */
        var _dist_code = new Array(DIST_CODE_LEN);
        zero(_dist_code);
        /* Distance codes. The first 256 values correspond to the distances
         * 3 .. 258, the last 256 values correspond to the top 8 bits of
         * the 15 bit distances.
         */
        var _length_code = new Array(MAX_MATCH - MIN_MATCH + 1);
        zero(_length_code);
        /* length code for each normalized match length (0 == MIN_MATCH) */
        var base_length = new Array(LENGTH_CODES);
        zero(base_length);
        /* First normalized length for each code (0 = MIN_MATCH) */
        var base_dist = new Array(D_CODES);
        zero(base_dist);
        /* First normalized distance for each code (0 = distance of 1) */
        function StaticTreeDesc(static_tree, extra_bits, extra_base, elems, max_length) {
            this.static_tree = static_tree;
            /* static tree or NULL */
            this.extra_bits = extra_bits;
            /* extra bits for each code or NULL */
            this.extra_base = extra_base;
            /* base index for extra_bits */
            this.elems = elems;
            /* max number of elements in the tree */
            this.max_length = max_length;
            /* max bit length for the codes */
            // show if `static_tree` has data or dummy - needed for monomorphic objects
            this.has_stree = static_tree && static_tree.length;
        }
        var static_l_desc;
        var static_d_desc;
        var static_bl_desc;
        function TreeDesc(dyn_tree, stat_desc) {
            this.dyn_tree = dyn_tree;
            /* the dynamic tree */
            this.max_code = 0;
            /* largest code with non zero frequency */
            this.stat_desc = stat_desc;
            /* the corresponding static tree */
        }
        var d_code = function d_code(dist) {
            return dist < 256 ? _dist_code[dist] : _dist_code[256 + (dist >>> 7)];
        };
        /* ===========================================================================
         * Output a short LSB first on the stream.
         * IN assertion: there is enough room in pendingBuf.
         */
        var put_short = function put_short(s, w) {
            //    put_byte(s, (uch)((w) & 0xff));
            //    put_byte(s, (uch)((ush)(w) >> 8));
            s.pending_buf[s.pending++] = w & 0xff;
            s.pending_buf[s.pending++] = (w >>> 8) & 0xff;
        };
        /* ===========================================================================
         * Send a value on a given number of bits.
         * IN assertion: length <= 16 and value fits in length bits.
         */
        var send_bits = function send_bits(s, value, length) {
            if (s.bi_valid > Buf_size - length) {
                s.bi_buf |= (value << s.bi_valid) & 0xffff;
                put_short(s, s.bi_buf);
                s.bi_buf = value >> (Buf_size - s.bi_valid);
                s.bi_valid += length - Buf_size;
            }
            else {
                s.bi_buf |= (value << s.bi_valid) & 0xffff;
                s.bi_valid += length;
            }
        };
        var send_code = function send_code(s, c, tree) {
            send_bits(s, tree[c * 2], 
            /* .Code */
            tree[c * 2 + 1]
            /* .Len */
            );
        };
        /* ===========================================================================
         * Reverse the first len bits of a code, using straightforward code (a faster
         * method would use a table)
         * IN assertion: 1 <= len <= 15
         */
        var bi_reverse = function bi_reverse(code, len) {
            var res = 0;
            do {
                res |= code & 1;
                code >>>= 1;
                res <<= 1;
            } while (--len > 0);
            return res >>> 1;
        };
        /* ===========================================================================
         * Flush the bit buffer, keeping at most 7 bits in it.
         */
        var bi_flush = function bi_flush(s) {
            if (s.bi_valid === 16) {
                put_short(s, s.bi_buf);
                s.bi_buf = 0;
                s.bi_valid = 0;
            }
            else if (s.bi_valid >= 8) {
                s.pending_buf[s.pending++] = s.bi_buf & 0xff;
                s.bi_buf >>= 8;
                s.bi_valid -= 8;
            }
        };
        /* ===========================================================================
         * Compute the optimal bit lengths for a tree and update the total bit length
         * for the current block.
         * IN assertion: the fields freq and dad are set, heap[heap_max] and
         *    above are the tree nodes sorted by increasing frequency.
         * OUT assertions: the field len is set to the optimal bit length, the
         *     array bl_count contains the frequencies for each bit length.
         *     The length opt_len is updated; static_len is also updated if stree is
         *     not null.
         */
        var gen_bitlen = function gen_bitlen(s, desc //    deflate_state *s; //    tree_desc *desc;    /* the tree descriptor */
        ) {
            var tree = desc.dyn_tree;
            var max_code = desc.max_code;
            var stree = desc.stat_desc.static_tree;
            var has_stree = desc.stat_desc.has_stree;
            var extra = desc.stat_desc.extra_bits;
            var base = desc.stat_desc.extra_base;
            var max_length = desc.stat_desc.max_length;
            var h;
            /* heap index */
            var n;
            var m;
            /* iterate over the tree elements */
            var bits;
            /* bit length */
            var xbits;
            /* extra bits */
            var f;
            /* frequency */
            var overflow = 0;
            /* number of elements with bit length too large */
            for (bits = 0; bits <= MAX_BITS; bits++) {
                s.bl_count[bits] = 0;
            }
            /* In a first pass, compute the optimal bit lengths (which may
             * overflow in the case of the bit length tree).
             */
            tree[s.heap[s.heap_max] * 2 + 1] =
                /* .Len */
                0;
            /* root of the heap */
            for (h = s.heap_max + 1; h < HEAP_SIZE; h++) {
                n = s.heap[h];
                bits =
                    tree[tree[n * 2 + 1] *
                        /* .Dad */
                        2 +
                        1] +
                        /* .Len */
                        1;
                if (bits > max_length) {
                    bits = max_length;
                    overflow++;
                }
                tree[n * 2 + 1] =
                    /* .Len */
                    bits;
                /* We overwrite tree[n].Dad which is no longer needed */
                if (n > max_code) {
                    continue;
                }
                /* not a leaf node */
                s.bl_count[bits]++;
                xbits = 0;
                if (n >= base) {
                    xbits = extra[n - base];
                }
                f = tree[n * 2];
                /* .Freq */
                s.opt_len += f * (bits + xbits);
                if (has_stree) {
                    s.static_len +=
                        f *
                            (stree[n * 2 + 1] +
                                /* .Len */
                                xbits);
                }
            }
            if (overflow === 0) {
                return;
            } // Trace((stderr,"\nbit length overflow\n"));
            /* This happens for example on obj2 and pic of the Calgary corpus */
            /* Find the first bit length which could increase: */
            do {
                bits = max_length - 1;
                while (s.bl_count[bits] === 0) {
                    bits--;
                }
                s.bl_count[bits]--;
                /* move one leaf down the tree */
                s.bl_count[bits + 1] += 2;
                /* move one overflow item as its brother */
                s.bl_count[max_length]--;
                /* The brother of the overflow item also moves one step up,
                 * but this does not affect bl_count[max_length]
                 */
                overflow -= 2;
            } while (overflow > 0);
            /* Now recompute all bit lengths, scanning in increasing frequency.
             * h is still equal to HEAP_SIZE. (It is simpler to reconstruct all
             * lengths instead of fixing only the wrong ones. This idea is taken
             * from 'ar' written by Haruhiko Okumura.)
             */
            for (bits = max_length; bits !== 0; bits--) {
                n = s.bl_count[bits];
                while (n !== 0) {
                    m = s.heap[--h];
                    if (m > max_code) {
                        continue;
                    }
                    if (tree[m * 2 + 1] !==
                        /* .Len */
                        bits) {
                        // Trace((stderr,"code %d bits %d->%d\n", m, tree[m].Len, bits));
                        s.opt_len +=
                            (bits - tree[m * 2 + 1]) *
                                /* .Len */
                                tree[m * 2];
                        /* .Freq */
                        tree[m * 2 + 1] =
                            /* .Len */
                            bits;
                    }
                    n--;
                }
            }
        };
        /* ===========================================================================
         * Generate the codes for a given tree and bit counts (which need not be
         * optimal).
         * IN assertion: the array bl_count contains the bit length statistics for
         * the given tree and the field len is set for all tree elements.
         * OUT assertion: the field code is set for all tree elements of non
         *     zero code length.
         */
        var gen_codes = function gen_codes(tree, max_code, bl_count
        //    ct_data *tree;             /* the tree to decorate */
        //    int max_code;              /* largest code with non zero frequency */
        //    ushf *bl_count;            /* number of codes at each bit length */
        ) {
            var next_code = new Array(MAX_BITS + 1);
            /* next code value for each bit length */
            var code = 0;
            /* running code value */
            var bits;
            /* bit index */
            var n;
            /* code index */
            /* The distribution counts are first used to generate the code values
             * without bit reversal.
             */
            for (bits = 1; bits <= MAX_BITS; bits++) {
                next_code[bits] = code = (code + bl_count[bits - 1]) << 1;
            }
            /* Check that the bit counts in bl_count are consistent. The last code
             * must be all ones.
             */
            // Assert (code + bl_count[MAX_BITS]-1 == (1<<MAX_BITS)-1,
            //        "inconsistent bit counts");
            // Tracev((stderr,"\ngen_codes: max_code %d ", max_code));
            for (n = 0; n <= max_code; n++) {
                var len = tree[n * 2 + 1];
                /* .Len */
                if (len === 0) {
                    continue;
                }
                /* Now reverse the bits */
                tree[n * 2] =
                    /* .Code */
                    bi_reverse(next_code[len]++, len); // Tracecv(tree != static_ltree, (stderr,"\nn %3d %c l %2d c %4x (%x) ",
                //     n, (isgraph(n) ? n : ' '), len, tree[n].Code, next_code[len]-1));
            }
        };
        /* ===========================================================================
         * Initialize the various 'constant' tables.
         */
        var tr_static_init = function tr_static_init() {
            var n;
            /* iterates over tree elements */
            var bits;
            /* bit counter */
            var length;
            /* length value */
            var code;
            /* code value */
            var dist;
            /* distance index */
            var bl_count = new Array(MAX_BITS + 1);
            /* number of codes at each bit length for an optimal tree */
            // do check in _tr_init()
            // if (static_init_done) return;
            /* For some embedded targets, global variables are not initialized: */
            /* #ifdef NO_INIT_GLOBAL_POINTERS
            static_l_desc.static_tree = static_ltree;
            static_l_desc.extra_bits = extra_lbits;
            static_d_desc.static_tree = static_dtree;
            static_d_desc.extra_bits = extra_dbits;
            static_bl_desc.extra_bits = extra_blbits;
          #endif */
            /* Initialize the mapping length (0..255) -> length code (0..28) */
            length = 0;
            for (code = 0; code < LENGTH_CODES - 1; code++) {
                base_length[code] = length;
                for (n = 0; n < 1 << extra_lbits[code]; n++) {
                    _length_code[length++] = code;
                }
            } // Assert (length == 256, "tr_static_init: length != 256");
            /* Note that the length 255 (match length 258) can be represented
             * in two different ways: code 284 + 5 bits or code 285, so we
             * overwrite length_code[255] to use the best encoding:
             */
            _length_code[length - 1] = code;
            /* Initialize the mapping dist (0..32K) -> dist code (0..29) */
            dist = 0;
            for (code = 0; code < 16; code++) {
                base_dist[code] = dist;
                for (n = 0; n < 1 << extra_dbits[code]; n++) {
                    _dist_code[dist++] = code;
                }
            } // Assert (dist == 256, "tr_static_init: dist != 256");
            dist >>= 7;
            /* from now on, all distances are divided by 128 */
            for (; code < D_CODES; code++) {
                base_dist[code] = dist << 7;
                for (n = 0; n < 1 << (extra_dbits[code] - 7); n++) {
                    _dist_code[256 + dist++] = code;
                }
            } // Assert (dist == 256, "tr_static_init: 256+dist != 512");
            /* Construct the codes of the static literal tree */
            for (bits = 0; bits <= MAX_BITS; bits++) {
                bl_count[bits] = 0;
            }
            n = 0;
            while (n <= 143) {
                static_ltree[n * 2 + 1] =
                    /* .Len */
                    8;
                n++;
                bl_count[8]++;
            }
            while (n <= 255) {
                static_ltree[n * 2 + 1] =
                    /* .Len */
                    9;
                n++;
                bl_count[9]++;
            }
            while (n <= 279) {
                static_ltree[n * 2 + 1] =
                    /* .Len */
                    7;
                n++;
                bl_count[7]++;
            }
            while (n <= 287) {
                static_ltree[n * 2 + 1] =
                    /* .Len */
                    8;
                n++;
                bl_count[8]++;
            }
            /* Codes 286 and 287 do not exist, but we must include them in the
             * tree construction to get a canonical Huffman tree (longest code
             * all ones)
             */
            gen_codes(static_ltree, L_CODES + 1, bl_count);
            /* The static distance tree is trivial: */
            for (n = 0; n < D_CODES; n++) {
                static_dtree[n * 2 + 1] =
                    /* .Len */
                    5;
                static_dtree[n * 2] =
                    /* .Code */
                    bi_reverse(n, 5);
            } // Now data ready and we can init static trees
            static_l_desc = new StaticTreeDesc(static_ltree, extra_lbits, LITERALS + 1, L_CODES, MAX_BITS);
            static_d_desc = new StaticTreeDesc(static_dtree, extra_dbits, 0, D_CODES, MAX_BITS);
            static_bl_desc = new StaticTreeDesc(new Array(0), extra_blbits, 0, BL_CODES, MAX_BL_BITS);
            // static_init_done = true;
        };
        /* ===========================================================================
         * Initialize a new block.
         */
        var init_block = function init_block(s) {
            var n;
            /* iterates over tree elements */
            /* Initialize the trees. */
            for (n = 0; n < L_CODES; n++) {
                s.dyn_ltree[n * 2] =
                    /* .Freq */
                    0;
            }
            for (n = 0; n < D_CODES; n++) {
                s.dyn_dtree[n * 2] =
                    /* .Freq */
                    0;
            }
            for (n = 0; n < BL_CODES; n++) {
                s.bl_tree[n * 2] =
                    /* .Freq */
                    0;
            }
            s.dyn_ltree[END_BLOCK * 2] =
                /* .Freq */
                1;
            s.opt_len = s.static_len = 0;
            s.last_lit = s.matches = 0;
        };
        /* ===========================================================================
         * Flush the bit buffer and align the output on a byte boundary
         */
        var bi_windup = function bi_windup(s) {
            if (s.bi_valid > 8) {
                put_short(s, s.bi_buf);
            }
            else if (s.bi_valid > 0) {
                // put_byte(s, (Byte)s->bi_buf);
                s.pending_buf[s.pending++] = s.bi_buf;
            }
            s.bi_buf = 0;
            s.bi_valid = 0;
        };
        /* ===========================================================================
         * Copy a stored block, storing first the length and its
         * one's complement if requested.
         */
        var copy_block = function copy_block(s, buf, len, header
        // DeflateState *s;
        // charf    *buf;    /* the input data */
        // unsigned len;     /* its length */
        // int      header;  /* true if block header must be written */
        ) {
            bi_windup(s);
            /* align on byte boundary */
            if (header) {
                put_short(s, len);
                put_short(s, ~len);
            }
            //  while (len--) {
            //    put_byte(s, *buf++);
            //  }
            s.pending_buf.set(s.window.subarray(buf, buf + len), s.pending);
            s.pending += len;
        };
        /* ===========================================================================
         * Compares to subtrees, using the tree depth as tie breaker when
         * the subtrees have equal frequency. This minimizes the worst case length.
         */
        var smaller = function smaller(tree, n, m, depth) {
            var _n2 = n * 2;
            var _m2 = m * 2;
            return (tree[_n2] <
                /* .Freq */
                tree[_m2] ||
                /* .Freq */
                (tree[_n2] ===
                    /* .Freq */
                    tree[_m2] &&
                    /* .Freq */
                    depth[n] <= depth[m]));
        };
        /* ===========================================================================
         * Restore the heap property by moving down the tree starting at node k,
         * exchanging a node with the smallest of its two sons if necessary, stopping
         * when the heap property is re-established (each father smaller than its
         * two sons).
         */
        var pqdownheap = function pqdownheap(s, tree, k
        //    deflate_state *s;
        //    ct_data *tree;  /* the tree to restore */
        //    int k;               /* node to move down */
        ) {
            var v = s.heap[k];
            var j = k << 1;
            /* left son of k */
            while (j <= s.heap_len) {
                /* Set j to the smallest of the two sons: */
                if (j < s.heap_len && smaller(tree, s.heap[j + 1], s.heap[j], s.depth)) {
                    j++;
                }
                /* Exit if v is smaller than both sons */
                if (smaller(tree, v, s.heap[j], s.depth)) {
                    break;
                }
                /* Exchange v with the smallest son */
                s.heap[k] = s.heap[j];
                k = j;
                /* And continue down the tree, setting j to the left son of k */
                j <<= 1;
            }
            s.heap[k] = v;
        }; // inlined manually
        // const SMALLEST = 1;
        /* ===========================================================================
         * Send the block data compressed using the given Huffman trees
         */
        var compress_block = function compress_block(s, ltree, dtree
        //    deflate_state *s;
        //    const ct_data *ltree; /* literal tree */
        //    const ct_data *dtree; /* distance tree */
        ) {
            var dist;
            /* distance of matched string */
            var lc;
            /* match length or unmatched char (if dist == 0) */
            var lx = 0;
            /* running index in l_buf */
            var code;
            /* the code to send */
            var extra;
            /* number of extra bits to send */
            if (s.last_lit !== 0) {
                do {
                    dist = (s.pending_buf[s.d_buf + lx * 2] << 8) | s.pending_buf[s.d_buf + lx * 2 + 1];
                    lc = s.pending_buf[s.l_buf + lx];
                    lx++;
                    if (dist === 0) {
                        send_code(s, lc, ltree);
                        /* send a literal byte */
                        // Tracecv(isgraph(lc), (stderr," '%c' ", lc));
                    }
                    else {
                        /* Here, lc is the match length - MIN_MATCH */
                        code = _length_code[lc];
                        send_code(s, code + LITERALS + 1, ltree);
                        /* send the length code */
                        extra = extra_lbits[code];
                        if (extra !== 0) {
                            lc -= base_length[code];
                            send_bits(s, lc, extra);
                            /* send the extra length bits */
                        }
                        dist--;
                        /* dist is now the match distance - 1 */
                        code = d_code(dist); // Assert (code < D_CODES, "bad d_code");
                        send_code(s, code, dtree);
                        /* send the distance code */
                        extra = extra_dbits[code];
                        if (extra !== 0) {
                            dist -= base_dist[code];
                            send_bits(s, dist, extra);
                            /* send the extra distance bits */
                        }
                    }
                    /* literal or match pair ? */
                    /* Check that the overlay between pending_buf and d_buf+l_buf is ok: */
                    // Assert((uInt)(s->pending) < s->lit_bufsize + 2*lx,
                    //       "pendingBuf overflow");
                } while (lx < s.last_lit);
            }
            send_code(s, END_BLOCK, ltree);
        };
        /* ===========================================================================
         * Construct one Huffman tree and assigns the code bit strings and lengths.
         * Update the total bit length for the current block.
         * IN assertion: the field freq is set for all tree elements.
         * OUT assertions: the fields len and code are set to the optimal bit length
         *     and corresponding code. The length opt_len is updated; static_len is
         *     also updated if stree is not null. The field max_code is set.
         */
        var build_tree = function build_tree(s, desc //    deflate_state *s; //    tree_desc *desc; /* the tree descriptor */
        ) {
            var tree = desc.dyn_tree;
            var stree = desc.stat_desc.static_tree;
            var has_stree = desc.stat_desc.has_stree;
            var elems = desc.stat_desc.elems;
            var n;
            var m;
            /* iterate over heap elements */
            var max_code = -1;
            /* largest code with non zero frequency */
            var node;
            /* new node being created */
            /* Construct the initial heap, with least frequent element in
             * heap[SMALLEST]. The sons of heap[n] are heap[2*n] and heap[2*n+1].
             * heap[0] is not used.
             */
            s.heap_len = 0;
            s.heap_max = HEAP_SIZE;
            for (n = 0; n < elems; n++) {
                if (tree[n * 2] !==
                    /* .Freq */
                    0) {
                    s.heap[++s.heap_len] = max_code = n;
                    s.depth[n] = 0;
                }
                else {
                    tree[n * 2 + 1] =
                        /* .Len */
                        0;
                }
            }
            /* The pkzip format requires that at least one distance code exists,
             * and that at least one bit should be sent even if there is only one
             * possible code. So to avoid special checks later on we force at least
             * two codes of non zero frequency.
             */
            while (s.heap_len < 2) {
                node = s.heap[++s.heap_len] = max_code < 2 ? ++max_code : 0;
                tree[node * 2] =
                    /* .Freq */
                    1;
                s.depth[node] = 0;
                s.opt_len--;
                if (has_stree) {
                    s.static_len -= stree[node * 2 + 1];
                    /* .Len */
                }
                /* node is 0 or 1 so it does not have extra bits */
            }
            desc.max_code = max_code;
            /* The elements heap[heap_len/2+1 .. heap_len] are leaves of the tree,
             * establish sub-heaps of increasing lengths:
             */
            for (n = s.heap_len >> 1; 
            /* int /2 */
            n >= 1; n--) {
                pqdownheap(s, tree, n);
            }
            /* Construct the Huffman tree by repeatedly combining the least two
             * frequent nodes.
             */
            node = elems;
            /* next internal node of the tree */
            do {
                // pqremove(s, tree, n);  /* n = node of least frequency */
                /** * pqremove ** */
                n = s.heap[1];
                /* SMALLEST */
                s.heap[1] = s.heap[s.heap_len--];
                /* SMALLEST */
                pqdownheap(s, tree, 1
                /* SMALLEST */
                );
                /***/
                m = s.heap[1];
                /* SMALLEST */
                /* m = node of next least frequency */
                s.heap[--s.heap_max] = n;
                /* keep the nodes sorted by frequency */
                s.heap[--s.heap_max] = m;
                /* Create a new node father of n and m */
                tree[node * 2] =
                    /* .Freq */
                    tree[n * 2] +
                        /* .Freq */
                        tree[m * 2];
                /* .Freq */
                s.depth[node] = (s.depth[n] >= s.depth[m] ? s.depth[n] : s.depth[m]) + 1;
                tree[n * 2 + 1] =
                    /* .Dad */
                    tree[m * 2 + 1] =
                        /* .Dad */
                        node;
                /* and insert the new node in the heap */
                s.heap[1] = node++;
                /* SMALLEST */
                pqdownheap(s, tree, 1
                /* SMALLEST */
                );
            } while (s.heap_len >= 2);
            s.heap[--s.heap_max] = s.heap[1];
            /* SMALLEST */
            /* At this point, the fields freq and dad are set. We can now
             * generate the bit lengths.
             */
            gen_bitlen(s, desc);
            /* The field len is now set, we can generate the bit codes */
            gen_codes(tree, max_code, s.bl_count);
        };
        /* ===========================================================================
         * Scan a literal or distance tree to determine the frequencies of the codes
         * in the bit length tree.
         */
        var scan_tree = function scan_tree(s, tree, max_code
        //    deflate_state *s;
        //    ct_data *tree;   /* the tree to be scanned */
        //    int max_code;    /* and its largest code of non zero frequency */
        ) {
            var n;
            /* iterates over all tree elements */
            var prevlen = -1;
            /* last emitted length */
            var curlen;
            /* length of current code */
            var nextlen = tree[0 * 2 + 1];
            /* .Len */
            /* length of next code */
            var count = 0;
            /* repeat count of the current code */
            var max_count = 7;
            /* max repeat count */
            var min_count = 4;
            /* min repeat count */
            if (nextlen === 0) {
                max_count = 138;
                min_count = 3;
            }
            tree[(max_code + 1) * 2 + 1] =
                /* .Len */
                0xffff;
            /* guard */
            for (n = 0; n <= max_code; n++) {
                curlen = nextlen;
                nextlen = tree[(n + 1) * 2 + 1];
                /* .Len */
                if (++count < max_count && curlen === nextlen) {
                    continue;
                }
                else if (count < min_count) {
                    s.bl_tree[curlen * 2] +=
                        /* .Freq */
                        count;
                }
                else if (curlen !== 0) {
                    if (curlen !== prevlen) {
                        s.bl_tree[curlen * 2] /* .Freq */++;
                    }
                    s.bl_tree[REP_3_6 * 2] /* .Freq */++;
                }
                else if (count <= 10) {
                    s.bl_tree[REPZ_3_10 * 2] /* .Freq */++;
                }
                else {
                    s.bl_tree[REPZ_11_138 * 2] /* .Freq */++;
                }
                count = 0;
                prevlen = curlen;
                if (nextlen === 0) {
                    max_count = 138;
                    min_count = 3;
                }
                else if (curlen === nextlen) {
                    max_count = 6;
                    min_count = 3;
                }
                else {
                    max_count = 7;
                    min_count = 4;
                }
            }
        };
        /* ===========================================================================
         * Send a literal or distance tree in compressed form, using the codes in
         * bl_tree.
         */
        var send_tree = function send_tree(s, tree, max_code
        //    deflate_state *s;
        //    ct_data *tree; /* the tree to be scanned */
        //    int max_code;       /* and its largest code of non zero frequency */
        ) {
            var n;
            /* iterates over all tree elements */
            var prevlen = -1;
            /* last emitted length */
            var curlen;
            /* length of current code */
            var nextlen = tree[0 * 2 + 1];
            /* .Len */
            /* length of next code */
            var count = 0;
            /* repeat count of the current code */
            var max_count = 7;
            /* max repeat count */
            var min_count = 4;
            /* min repeat count */
            /* tree[max_code+1].Len = -1; */
            /* guard already set */
            if (nextlen === 0) {
                max_count = 138;
                min_count = 3;
            }
            for (n = 0; n <= max_code; n++) {
                curlen = nextlen;
                nextlen = tree[(n + 1) * 2 + 1];
                /* .Len */
                if (++count < max_count && curlen === nextlen) {
                    continue;
                }
                else if (count < min_count) {
                    do {
                        send_code(s, curlen, s.bl_tree);
                    } while (--count !== 0);
                }
                else if (curlen !== 0) {
                    if (curlen !== prevlen) {
                        send_code(s, curlen, s.bl_tree);
                        count--;
                    } // Assert(count >= 3 && count <= 6, " 3_6?");
                    send_code(s, REP_3_6, s.bl_tree);
                    send_bits(s, count - 3, 2);
                }
                else if (count <= 10) {
                    send_code(s, REPZ_3_10, s.bl_tree);
                    send_bits(s, count - 3, 3);
                }
                else {
                    send_code(s, REPZ_11_138, s.bl_tree);
                    send_bits(s, count - 11, 7);
                }
                count = 0;
                prevlen = curlen;
                if (nextlen === 0) {
                    max_count = 138;
                    min_count = 3;
                }
                else if (curlen === nextlen) {
                    max_count = 6;
                    min_count = 3;
                }
                else {
                    max_count = 7;
                    min_count = 4;
                }
            }
        };
        /* ===========================================================================
         * Construct the Huffman tree for the bit lengths and return the index in
         * bl_order of the last bit length code to send.
         */
        var build_bl_tree = function build_bl_tree(s) {
            var max_blindex;
            /* index of last bit length code of non zero freq */
            /* Determine the bit length frequencies for literal and distance trees */
            scan_tree(s, s.dyn_ltree, s.l_desc.max_code);
            scan_tree(s, s.dyn_dtree, s.d_desc.max_code);
            /* Build the bit length tree: */
            build_tree(s, s.bl_desc);
            /* opt_len now includes the length of the tree representations, except
             * the lengths of the bit lengths codes and the 5+5+4 bits for the counts.
             */
            /* Determine the number of bit length codes to send. The pkzip format
             * requires that at least 4 bit length codes be sent. (appnote.txt says
             * 3 but the actual value used is 4.)
             */
            for (max_blindex = BL_CODES - 1; max_blindex >= 3; max_blindex--) {
                if (s.bl_tree[bl_order[max_blindex] * 2 + 1] !==
                    /* .Len */
                    0) {
                    break;
                }
            }
            /* Update opt_len to include the bit length tree and counts */
            s.opt_len += 3 * (max_blindex + 1) + 5 + 5 + 4; // Tracev((stderr, "\ndyn trees: dyn %ld, stat %ld",
            //        s->opt_len, s->static_len));
            return max_blindex;
        };
        /* ===========================================================================
         * Send the header for a block using dynamic Huffman trees: the counts, the
         * lengths of the bit length codes, the literal tree and the distance tree.
         * IN assertion: lcodes >= 257, dcodes >= 1, blcodes >= 4.
         */
        var send_all_trees = function send_all_trees(s, lcodes, dcodes, blcodes //    deflate_state *s; //    int lcodes, dcodes, blcodes; /* number of codes for each tree */
        ) {
            var rank;
            /* index in bl_order */
            // Assert (lcodes >= 257 && dcodes >= 1 && blcodes >= 4, "not enough codes");
            // Assert (lcodes <= L_CODES && dcodes <= D_CODES && blcodes <= BL_CODES,
            //        "too many codes");
            // Tracev((stderr, "\nbl counts: "));
            send_bits(s, lcodes - 257, 5);
            /* not +255 as stated in appnote.txt */
            send_bits(s, dcodes - 1, 5);
            send_bits(s, blcodes - 4, 4);
            /* not -3 as stated in appnote.txt */
            for (rank = 0; rank < blcodes; rank++) {
                // Tracev((stderr, "\nbl code %2d ", bl_order[rank]));
                send_bits(s, s.bl_tree[bl_order[rank] * 2 + 1], 
                /* .Len */
                3);
            } // Tracev((stderr, "\nbl tree: sent %ld", s->bits_sent));
            send_tree(s, s.dyn_ltree, lcodes - 1);
            /* literal tree */
            // Tracev((stderr, "\nlit tree: sent %ld", s->bits_sent));
            send_tree(s, s.dyn_dtree, dcodes - 1);
            /* distance tree */
            // Tracev((stderr, "\ndist tree: sent %ld", s->bits_sent));
        };
        /* ===========================================================================
         * Check if the data type is TEXT or BINARY, using the following algorithm:
         * - TEXT if the two conditions below are satisfied:
         *    a) There are no non-portable control characters belonging to the
         *       "black list" (0..6, 14..25, 28..31).
         *    b) There is at least one printable character belonging to the
         *       "white list" (9 {TAB}, 10 {LF}, 13 {CR}, 32..255).
         * - BINARY otherwise.
         * - The following partially-portable control characters form a
         *   "gray list" that is ignored in this detection algorithm:
         *   (7 {BEL}, 8 {BS}, 11 {VT}, 12 {FF}, 26 {SUB}, 27 {ESC}).
         * IN assertion: the fields Freq of dyn_ltree are set.
         */
        var detect_data_type = function detect_data_type(s) {
            /* black_mask is the bit mask of black-listed bytes
             * set bits 0..6, 14..25, and 28..31
             * 0xf3ffc07f = binary 11110011111111111100000001111111
             */
            var black_mask = 0xf3ffc07f;
            var n;
            /* Check for non-textual ("black-listed") bytes. */
            for (n = 0; n <= 31; n++, black_mask >>>= 1) {
                if (black_mask & 1 &&
                    s.dyn_ltree[n * 2] !==
                        /* .Freq */
                        0) {
                    return Z_BINARY;
                }
            }
            /* Check for textual ("white-listed") bytes. */
            if (s.dyn_ltree[9 * 2] !==
                /* .Freq */
                0 ||
                s.dyn_ltree[10 * 2] !==
                    /* .Freq */
                    0 ||
                s.dyn_ltree[13 * 2] !==
                    /* .Freq */
                    0) {
                return Z_TEXT;
            }
            for (n = 32; n < LITERALS; n++) {
                if (s.dyn_ltree[n * 2] !==
                    /* .Freq */
                    0) {
                    return Z_TEXT;
                }
            }
            /* There are no "black-listed" or "white-listed" bytes:
             * this stream either is empty or has tolerated ("gray-listed") bytes only.
             */
            return Z_BINARY;
        };
        var static_init_done = false;
        /* ===========================================================================
         * Initialize the tree data structures for a new zlib stream.
         */
        var _tr_init = function _tr_init(s) {
            if (!static_init_done) {
                tr_static_init();
                static_init_done = true;
            }
            s.l_desc = new TreeDesc(s.dyn_ltree, static_l_desc);
            s.d_desc = new TreeDesc(s.dyn_dtree, static_d_desc);
            s.bl_desc = new TreeDesc(s.bl_tree, static_bl_desc);
            s.bi_buf = 0;
            s.bi_valid = 0;
            /* Initialize the first block of the first file: */
            init_block(s);
        };
        /* ===========================================================================
         * Send a stored block
         */
        var _tr_stored_block = function _tr_stored_block(s, buf, stored_len, last
        // DeflateState *s;
        // charf *buf;       /* input block */
        // ulg stored_len;   /* length of input block */
        // int last;         /* one if this is the last block for a file */
        ) {
            send_bits(s, (STORED_BLOCK << 1) + (last ? 1 : 0), 3);
            /* send block type */
            copy_block(s, buf, stored_len, true);
            /* with header */
        };
        /* ===========================================================================
         * Send one empty static block to give enough lookahead for inflate.
         * This takes 10 bits, of which 7 may remain in the bit buffer.
         */
        var _tr_align = function _tr_align(s) {
            send_bits(s, STATIC_TREES << 1, 3);
            send_code(s, END_BLOCK, static_ltree);
            bi_flush(s);
        };
        /* ===========================================================================
         * Determine the best encoding for the current block: dynamic trees, static
         * trees or store, and output the encoded block to the zip file.
         */
        var _tr_flush_block = function _tr_flush_block(s, buf, stored_len, last
        // DeflateState *s;
        // charf *buf;       /* input block, or NULL if too old */
        // ulg stored_len;   /* length of input block */
        // int last;         /* one if this is the last block for a file */
        ) {
            var opt_lenb;
            var static_lenb;
            /* opt_len and static_len in bytes */
            var max_blindex = 0;
            /* index of last bit length code of non zero freq */
            /* Build the Huffman trees unless a stored block is forced */
            if (s.level > 0) {
                /* Check if the file is binary or text */
                if (s.strm.data_type === Z_UNKNOWN) {
                    s.strm.data_type = detect_data_type(s);
                }
                /* Construct the literal and distance trees */
                build_tree(s, s.l_desc); // Tracev((stderr, "\nlit data: dyn %ld, stat %ld", s->opt_len,
                //        s->static_len));
                build_tree(s, s.d_desc); // Tracev((stderr, "\ndist data: dyn %ld, stat %ld", s->opt_len,
                //        s->static_len));
                /* At this point, opt_len and static_len are the total bit lengths of
                 * the compressed block data, excluding the tree representations.
                 */
                /* Build the bit length tree for the above two trees, and get the index
                 * in bl_order of the last bit length code to send.
                 */
                max_blindex = build_bl_tree(s);
                /* Determine the best encoding. Compute the block lengths in bytes. */
                opt_lenb = (s.opt_len + 3 + 7) >>> 3;
                static_lenb = (s.static_len + 3 + 7) >>> 3; // Tracev((stderr, "\nopt %lu(%lu) stat %lu(%lu) stored %lu lit %u ",
                //        opt_lenb, s->opt_len, static_lenb, s->static_len, stored_len,
                //        s->last_lit));
                if (static_lenb <= opt_lenb) {
                    opt_lenb = static_lenb;
                }
            }
            else {
                // Assert(buf != (char*)0, "lost buf");
                opt_lenb = static_lenb = stored_len + 5;
                /* force a stored block */
            }
            if (stored_len + 4 <= opt_lenb && buf !== -1) {
                /* 4: two words for the lengths */
                /* The test buf != NULL is only necessary if LIT_BUFSIZE > WSIZE.
                 * Otherwise we can't have processed more than WSIZE input bytes since
                 * the last block flush, because compression would have been
                 * successful. If LIT_BUFSIZE <= WSIZE, it is never too late to
                 * transform a block into a stored block.
                 */
                _tr_stored_block(s, buf, stored_len, last);
            }
            else if (s.strategy === Z_FIXED || static_lenb === opt_lenb) {
                send_bits(s, (STATIC_TREES << 1) + (last ? 1 : 0), 3);
                compress_block(s, static_ltree, static_dtree);
            }
            else {
                send_bits(s, (DYN_TREES << 1) + (last ? 1 : 0), 3);
                send_all_trees(s, s.l_desc.max_code + 1, s.d_desc.max_code + 1, max_blindex + 1);
                compress_block(s, s.dyn_ltree, s.dyn_dtree);
            } // Assert (s->compressed_len == s->bits_sent, "bad compressed size");
            /* The above check is made mod 2^32, for files larger than 512 MB
             * and uLong implemented on 32 bits.
             */
            init_block(s);
            if (last) {
                bi_windup(s);
            } // Tracev((stderr,"\ncomprlen %lu(%lu) ", s->compressed_len>>3,
            //       s->compressed_len-7*last));
        };
        /* ===========================================================================
         * Save the match info and tally the frequency counts. Return true if
         * the current block must be flushed.
         */
        var _tr_tally = function _tr_tally(s, dist, lc
        //    deflate_state *s;
        //    unsigned dist;  /* distance of matched string */
        //    unsigned lc;    /* match length-MIN_MATCH or unmatched char (if dist==0) */
        ) {
            // let out_length, in_length, dcode;
            s.pending_buf[s.d_buf + s.last_lit * 2] = (dist >>> 8) & 0xff;
            s.pending_buf[s.d_buf + s.last_lit * 2 + 1] = dist & 0xff;
            s.pending_buf[s.l_buf + s.last_lit] = lc & 0xff;
            s.last_lit++;
            if (dist === 0) {
                /* lc is the unmatched char */
                s.dyn_ltree[lc * 2] /* .Freq */++;
            }
            else {
                s.matches++;
                /* Here, lc is the match length - MIN_MATCH */
                dist--;
                /* dist = match distance - 1 */
                // Assert((ush)dist < (ush)MAX_DIST(s) &&
                //       (ush)lc <= (ush)(MAX_MATCH-MIN_MATCH) &&
                //       (ush)d_code(dist) < (ush)D_CODES,  "_tr_tally: bad match");
                s.dyn_ltree[(_length_code[lc] + LITERALS + 1) * 2] /* .Freq */++;
                s.dyn_dtree[d_code(dist) * 2] /* .Freq */++;
            } // (!) This block is disabled in zlib defaults,
            // don't enable it for binary compatibility
            // #ifdef TRUNCATE_BLOCK
            //  /* Try to guess if it is profitable to stop the current block here */
            //  if ((s.last_lit & 0x1fff) === 0 && s.level > 2) {
            //    /* Compute an upper bound for the compressed length */
            //    out_length = s.last_lit*8;
            //    in_length = s.strstart - s.block_start;
            //
            //    for (dcode = 0; dcode < D_CODES; dcode++) {
            //      out_length += s.dyn_dtree[dcode*2]/*.Freq*/ * (5 + extra_dbits[dcode]);
            //    }
            //    out_length >>>= 3;
            //    //Tracev((stderr,"\nlast_lit %u, in %ld, out ~%ld(%ld%%) ",
            //    //       s->last_lit, in_length, out_length,
            //    //       100L - out_length*100L/in_length));
            //    if (s.matches < (s.last_lit>>1)/*int /2*/ && out_length < (in_length>>1)/*int /2*/) {
            //      return true;
            //    }
            //  }
            // #endif
            return s.last_lit === s.lit_bufsize - 1;
            /* We avoid equality with lit_bufsize because of wraparound at 64K
             * on 16 bit machines and because stored blocks are restricted to
             * 64K-1 bytes.
             */
        };
        var _tr_init_1 = _tr_init;
        var _tr_stored_block_1 = _tr_stored_block;
        var _tr_flush_block_1 = _tr_flush_block;
        var _tr_tally_1 = _tr_tally;
        var _tr_align_1 = _tr_align;
        var trees = {
            _tr_init: _tr_init_1,
            _tr_stored_block: _tr_stored_block_1,
            _tr_flush_block: _tr_flush_block_1,
            _tr_tally: _tr_tally_1,
            _tr_align: _tr_align_1,
        };
        // It isn't worth it to make additional optimizations as in original.
        // Small size is preferable.
        // (C) 1995-2013 Jean-loup Gailly and Mark Adler
        // (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
        //
        // This software is provided 'as-is', without any express or implied
        // warranty. In no event will the authors be held liable for any damages
        // arising from the use of this software.
        //
        // Permission is granted to anyone to use this software for any purpose,
        // including commercial applications, and to alter it and redistribute it
        // freely, subject to the following restrictions:
        //
        // 1. The origin of this software must not be misrepresented; you must not
        //   claim that you wrote the original software. If you use this software
        //   in a product, an acknowledgment in the product documentation would be
        //   appreciated but is not required.
        // 2. Altered source versions must be plainly marked as such, and must not be
        //   misrepresented as being the original software.
        // 3. This notice may not be removed or altered from any source distribution.
        var adler32 = function adler32(adler, buf, len, pos) {
            var s1 = (adler & 0xffff) | 0;
            var s2 = ((adler >>> 16) & 0xffff) | 0;
            var n = 0;
            while (len !== 0) {
                // Set limit ~ twice less than 5552, to keep
                // s2 in 31-bits, because we force signed ints.
                // in other case %= will fail.
                n = len > 2000 ? 2000 : len;
                len -= n;
                do {
                    s1 = (s1 + buf[pos++]) | 0;
                    s2 = (s2 + s1) | 0;
                } while (--n);
                s1 %= 65521;
                s2 %= 65521;
            }
            return s1 | (s2 << 16) | 0;
        };
        var adler32_1 = adler32;
        // So write code to minimize size - no pregenerated tables
        // and array tools dependencies.
        // (C) 1995-2013 Jean-loup Gailly and Mark Adler
        // (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
        //
        // This software is provided 'as-is', without any express or implied
        // warranty. In no event will the authors be held liable for any damages
        // arising from the use of this software.
        //
        // Permission is granted to anyone to use this software for any purpose,
        // including commercial applications, and to alter it and redistribute it
        // freely, subject to the following restrictions:
        //
        // 1. The origin of this software must not be misrepresented; you must not
        //   claim that you wrote the original software. If you use this software
        //   in a product, an acknowledgment in the product documentation would be
        //   appreciated but is not required.
        // 2. Altered source versions must be plainly marked as such, and must not be
        //   misrepresented as being the original software.
        // 3. This notice may not be removed or altered from any source distribution.
        // Use ordinary array, since untyped makes no boost here
        var makeTable = function makeTable() {
            var c;
            var table = [];
            for (var n = 0; n < 256; n++) {
                c = n;
                for (var k = 0; k < 8; k++) {
                    c = c & 1 ? 0xedb88320 ^ (c >>> 1) : c >>> 1;
                }
                table[n] = c;
            }
            return table;
        }; // Create table on load. Just 255 signed longs. Not a problem.
        var crcTable = new Uint32Array(makeTable());
        var crc32 = function crc32(crc, buf, len, pos) {
            var t = crcTable;
            var end = pos + len;
            crc ^= -1;
            for (var i = pos; i < end; i++) {
                crc = (crc >>> 8) ^ t[(crc ^ buf[i]) & 0xff];
            }
            return crc ^ -1; // >>> 0;
        };
        var crc32_1 = crc32;
        // (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
        //
        // This software is provided 'as-is', without any express or implied
        // warranty. In no event will the authors be held liable for any damages
        // arising from the use of this software.
        //
        // Permission is granted to anyone to use this software for any purpose,
        // including commercial applications, and to alter it and redistribute it
        // freely, subject to the following restrictions:
        //
        // 1. The origin of this software must not be misrepresented; you must not
        //   claim that you wrote the original software. If you use this software
        //   in a product, an acknowledgment in the product documentation would be
        //   appreciated but is not required.
        // 2. Altered source versions must be plainly marked as such, and must not be
        //   misrepresented as being the original software.
        // 3. This notice may not be removed or altered from any source distribution.
        var messages = {
            2: 'need dictionary',
            /* Z_NEED_DICT       2  */
            1: 'stream end',
            /* Z_STREAM_END      1  */
            0: '',
            /* Z_OK              0  */
            '-1': 'file error',
            /* Z_ERRNO         (-1) */
            '-2': 'stream error',
            /* Z_STREAM_ERROR  (-2) */
            '-3': 'data error',
            /* Z_DATA_ERROR    (-3) */
            '-4': 'insufficient memory',
            /* Z_MEM_ERROR     (-4) */
            '-5': 'buffer error',
            /* Z_BUF_ERROR     (-5) */
            '-6': 'incompatible version',
            /* Z_VERSION_ERROR (-6) */
        };
        // (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
        //
        // This software is provided 'as-is', without any express or implied
        // warranty. In no event will the authors be held liable for any damages
        // arising from the use of this software.
        //
        // Permission is granted to anyone to use this software for any purpose,
        // including commercial applications, and to alter it and redistribute it
        // freely, subject to the following restrictions:
        //
        // 1. The origin of this software must not be misrepresented; you must not
        //   claim that you wrote the original software. If you use this software
        //   in a product, an acknowledgment in the product documentation would be
        //   appreciated but is not required.
        // 2. Altered source versions must be plainly marked as such, and must not be
        //   misrepresented as being the original software.
        // 3. This notice may not be removed or altered from any source distribution.
        var constants = {
            /* Allowed flush values; see deflate() and inflate() below for details */
            Z_NO_FLUSH: 0,
            Z_PARTIAL_FLUSH: 1,
            Z_SYNC_FLUSH: 2,
            Z_FULL_FLUSH: 3,
            Z_FINISH: 4,
            Z_BLOCK: 5,
            Z_TREES: 6,
            /* Return codes for the compression/decompression functions. Negative values
             * are errors, positive values are used for special but normal events.
             */
            Z_OK: 0,
            Z_STREAM_END: 1,
            Z_NEED_DICT: 2,
            Z_ERRNO: -1,
            Z_STREAM_ERROR: -2,
            Z_DATA_ERROR: -3,
            Z_MEM_ERROR: -4,
            Z_BUF_ERROR: -5,
            // Z_VERSION_ERROR: -6,
            /* compression levels */
            Z_NO_COMPRESSION: 0,
            Z_BEST_SPEED: 1,
            Z_BEST_COMPRESSION: 9,
            Z_DEFAULT_COMPRESSION: -1,
            Z_FILTERED: 1,
            Z_HUFFMAN_ONLY: 2,
            Z_RLE: 3,
            Z_FIXED: 4,
            Z_DEFAULT_STRATEGY: 0,
            /* Possible values of the data_type field (though see inflate()) */
            Z_BINARY: 0,
            Z_TEXT: 1,
            // Z_ASCII:                1, // = Z_TEXT (deprecated)
            Z_UNKNOWN: 2,
            /* The deflate compression method */
            Z_DEFLATED: 8, // Z_NULL:                 null // Use -1 or null inline, depending on var type
        };
        // (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
        //
        // This software is provided 'as-is', without any express or implied
        // warranty. In no event will the authors be held liable for any damages
        // arising from the use of this software.
        //
        // Permission is granted to anyone to use this software for any purpose,
        // including commercial applications, and to alter it and redistribute it
        // freely, subject to the following restrictions:
        //
        // 1. The origin of this software must not be misrepresented; you must not
        //   claim that you wrote the original software. If you use this software
        //   in a product, an acknowledgment in the product documentation would be
        //   appreciated but is not required.
        // 2. Altered source versions must be plainly marked as such, and must not be
        //   misrepresented as being the original software.
        // 3. This notice may not be removed or altered from any source distribution.
        var _tr_init$1 = trees._tr_init;
        var _tr_stored_block$1 = trees._tr_stored_block;
        var _tr_flush_block$1 = trees._tr_flush_block;
        var _tr_tally$1 = trees._tr_tally;
        var _tr_align$1 = trees._tr_align;
        /* Public constants ========================================================== */
        /* =========================================================================== */
        var Z_NO_FLUSH = constants.Z_NO_FLUSH;
        var Z_PARTIAL_FLUSH = constants.Z_PARTIAL_FLUSH;
        var Z_FULL_FLUSH = constants.Z_FULL_FLUSH;
        var Z_FINISH = constants.Z_FINISH;
        var Z_BLOCK = constants.Z_BLOCK;
        var Z_OK = constants.Z_OK;
        var Z_STREAM_END = constants.Z_STREAM_END;
        var Z_STREAM_ERROR = constants.Z_STREAM_ERROR;
        var Z_DATA_ERROR = constants.Z_DATA_ERROR;
        var Z_BUF_ERROR = constants.Z_BUF_ERROR;
        var Z_DEFAULT_COMPRESSION = constants.Z_DEFAULT_COMPRESSION;
        var Z_FILTERED = constants.Z_FILTERED;
        var Z_HUFFMAN_ONLY = constants.Z_HUFFMAN_ONLY;
        var Z_RLE = constants.Z_RLE;
        var Z_FIXED$1 = constants.Z_FIXED;
        var Z_DEFAULT_STRATEGY = constants.Z_DEFAULT_STRATEGY;
        var Z_UNKNOWN$1 = constants.Z_UNKNOWN;
        var Z_DEFLATED = constants.Z_DEFLATED;
        /* ============================================================================ */
        var MAX_MEM_LEVEL = 9;
        /* Maximum value for memLevel in deflateInit2 */
        var MAX_WBITS = 15;
        /* 32K LZ77 window */
        var DEF_MEM_LEVEL = 8;
        var LENGTH_CODES$1 = 29;
        /* number of length codes, not counting the special END_BLOCK code */
        var LITERALS$1 = 256;
        /* number of literal bytes 0..255 */
        var L_CODES$1 = LITERALS$1 + 1 + LENGTH_CODES$1;
        /* number of Literal or Length codes, including the END_BLOCK code */
        var D_CODES$1 = 30;
        /* number of distance codes */
        var BL_CODES$1 = 19;
        /* number of codes used to transfer the bit lengths */
        var HEAP_SIZE$1 = 2 * L_CODES$1 + 1;
        /* maximum heap size */
        var MAX_BITS$1 = 15;
        /* All codes must not exceed MAX_BITS bits */
        var MIN_MATCH$1 = 3;
        var MAX_MATCH$1 = 258;
        var MIN_LOOKAHEAD = MAX_MATCH$1 + MIN_MATCH$1 + 1;
        var PRESET_DICT = 0x20;
        var INIT_STATE = 42;
        var EXTRA_STATE = 69;
        var NAME_STATE = 73;
        var COMMENT_STATE = 91;
        var HCRC_STATE = 103;
        var BUSY_STATE = 113;
        var FINISH_STATE = 666;
        var BS_NEED_MORE = 1;
        /* block not completed, need more input or more output */
        var BS_BLOCK_DONE = 2;
        /* block flush performed */
        var BS_FINISH_STARTED = 3;
        /* finish started, need only more output at next deflate */
        var BS_FINISH_DONE = 4;
        /* finish done, accept no more input or output */
        var OS_CODE = 0x03; // Unix :) . Don't detect, use this default.
        var err = function err(strm, errorCode) {
            strm.msg = messages[errorCode];
            return errorCode;
        };
        var rank = function rank(f) {
            return (f << 1) - (f > 4 ? 9 : 0);
        };
        var zero$1 = function zero(buf) {
            var len = buf.length;
            while (--len >= 0) {
                buf[len] = 0;
            }
        };
        var HASH_ZLIB = function HASH_ZLIB(s, prev, data) {
            return ((prev << s.hash_shift) ^ data) & s.hash_mask;
        }; // This hash causes less collisions, https://github.com/nodeca/pako/issues/135
        // But breaks binary compatibility
        // let HASH_FAST = (s, prev, data) => ((prev << 8) + (prev >> 8) + (data << 4)) & s.hash_mask;
        var HASH = HASH_ZLIB;
        /* =========================================================================
         * Flush as much pending output as possible. All deflate() output goes
         * through this function so some applications may wish to modify it
         * to avoid allocating a large strm->output buffer and copying into it.
         * (See also read_buf()).
         */
        var flush_pending = function flush_pending(strm) {
            var s = strm.state; // _tr_flush_bits(s);
            var len = s.pending;
            if (len > strm.avail_out) {
                len = strm.avail_out;
            }
            if (len === 0) {
                return;
            }
            strm.output.set(s.pending_buf.subarray(s.pending_out, s.pending_out + len), strm.next_out);
            strm.next_out += len;
            s.pending_out += len;
            strm.total_out += len;
            strm.avail_out -= len;
            s.pending -= len;
            if (s.pending === 0) {
                s.pending_out = 0;
            }
        };
        var flush_block_only = function flush_block_only(s, last) {
            _tr_flush_block$1(s, s.block_start >= 0 ? s.block_start : -1, s.strstart - s.block_start, last);
            s.block_start = s.strstart;
            flush_pending(s.strm);
        };
        var put_byte = function put_byte(s, b) {
            s.pending_buf[s.pending++] = b;
        };
        /* =========================================================================
         * Put a short in the pending buffer. The 16-bit value is put in MSB order.
         * IN assertion: the stream state is correct and there is enough room in
         * pending_buf.
         */
        var putShortMSB = function putShortMSB(s, b) {
            //  put_byte(s, (Byte)(b >> 8));
            //  put_byte(s, (Byte)(b & 0xff));
            s.pending_buf[s.pending++] = (b >>> 8) & 0xff;
            s.pending_buf[s.pending++] = b & 0xff;
        };
        /* ===========================================================================
         * Read a new buffer from the current input stream, update the adler32
         * and total number of bytes read.  All deflate() input goes through
         * this function so some applications may wish to modify it to avoid
         * allocating a large strm->input buffer and copying from it.
         * (See also flush_pending()).
         */
        var read_buf = function read_buf(strm, buf, start, size) {
            var len = strm.avail_in;
            if (len > size) {
                len = size;
            }
            if (len === 0) {
                return 0;
            }
            strm.avail_in -= len; // zmemcpy(buf, strm->next_in, len);
            buf.set(strm.input.subarray(strm.next_in, strm.next_in + len), start);
            if (strm.state.wrap === 1) {
                strm.adler = adler32_1(strm.adler, buf, len, start);
            }
            else if (strm.state.wrap === 2) {
                strm.adler = crc32_1(strm.adler, buf, len, start);
            }
            strm.next_in += len;
            strm.total_in += len;
            return len;
        };
        /* ===========================================================================
         * Set match_start to the longest match starting at the given string and
         * return its length. Matches shorter or equal to prev_length are discarded,
         * in which case the result is equal to prev_length and match_start is
         * garbage.
         * IN assertions: cur_match is the head of the hash chain for the current
         *   string (strstart) and its distance is <= MAX_DIST, and prev_length >= 1
         * OUT assertion: the match length is not greater than s->lookahead.
         */
        var longest_match = function longest_match(s, cur_match) {
            var chain_length = s.max_chain_length;
            /* max hash chain length */
            var scan = s.strstart;
            /* current string */
            var match;
            /* matched string */
            var len;
            /* length of current match */
            var best_len = s.prev_length;
            /* best match length so far */
            var nice_match = s.nice_match;
            /* stop if match long enough */
            var limit = s.strstart > s.w_size - MIN_LOOKAHEAD ? s.strstart - (s.w_size - MIN_LOOKAHEAD) : 0;
            /* NIL */
            var _win = s.window; // shortcut
            var wmask = s.w_mask;
            var prev = s.prev;
            /* Stop when cur_match becomes <= limit. To simplify the code,
             * we prevent matches with the string of window index 0.
             */
            var strend = s.strstart + MAX_MATCH$1;
            var scan_end1 = _win[scan + best_len - 1];
            var scan_end = _win[scan + best_len];
            /* The code is optimized for HASH_BITS >= 8 and MAX_MATCH-2 multiple of 16.
             * It is easy to get rid of this optimization if necessary.
             */
            // Assert(s->hash_bits >= 8 && MAX_MATCH == 258, "Code too clever");
            /* Do not waste too much time if we already have a good match: */
            if (s.prev_length >= s.good_match) {
                chain_length >>= 2;
            }
            /* Do not look for matches beyond the end of the input. This is necessary
             * to make deflate deterministic.
             */
            if (nice_match > s.lookahead) {
                nice_match = s.lookahead;
            } // Assert((ulg)s->strstart <= s->window_size-MIN_LOOKAHEAD, "need lookahead");
            do {
                // Assert(cur_match < s->strstart, "no future");
                match = cur_match;
                /* Skip to next match if the match length cannot increase
                 * or if the match length is less than 2.  Note that the checks below
                 * for insufficient lookahead only occur occasionally for performance
                 * reasons.  Therefore uninitialized memory will be accessed, and
                 * conditional jumps will be made that depend on those values.
                 * However the length of the match is limited to the lookahead, so
                 * the output of deflate is not affected by the uninitialized values.
                 */
                if (_win[match + best_len] !== scan_end ||
                    _win[match + best_len - 1] !== scan_end1 ||
                    _win[match] !== _win[scan] ||
                    _win[++match] !== _win[scan + 1]) {
                    continue;
                }
                /* The check at best_len-1 can be removed because it will be made
                 * again later. (This heuristic is not always a win.)
                 * It is not necessary to compare scan[2] and match[2] since they
                 * are always equal when the other bytes match, given that
                 * the hash keys are equal and that HASH_BITS >= 8.
                 */
                scan += 2;
                match++; // Assert(*scan == *match, "match[2]?");
                /* We check for insufficient lookahead only every 8th comparison;
                 * the 256th check will be made at strstart+258.
                 */
                do {
                    /* jshint noempty:false */
                } while (_win[++scan] === _win[++match] &&
                    _win[++scan] === _win[++match] &&
                    _win[++scan] === _win[++match] &&
                    _win[++scan] === _win[++match] &&
                    _win[++scan] === _win[++match] &&
                    _win[++scan] === _win[++match] &&
                    _win[++scan] === _win[++match] &&
                    _win[++scan] === _win[++match] &&
                    scan < strend); // Assert(scan <= s->window+(unsigned)(s->window_size-1), "wild scan");
                len = MAX_MATCH$1 - (strend - scan);
                scan = strend - MAX_MATCH$1;
                if (len > best_len) {
                    s.match_start = cur_match;
                    best_len = len;
                    if (len >= nice_match) {
                        break;
                    }
                    scan_end1 = _win[scan + best_len - 1];
                    scan_end = _win[scan + best_len];
                }
            } while ((cur_match = prev[cur_match & wmask]) > limit && --chain_length !== 0);
            if (best_len <= s.lookahead) {
                return best_len;
            }
            return s.lookahead;
        };
        /* ===========================================================================
         * Fill the window when the lookahead becomes insufficient.
         * Updates strstart and lookahead.
         *
         * IN assertion: lookahead < MIN_LOOKAHEAD
         * OUT assertions: strstart <= window_size-MIN_LOOKAHEAD
         *    At least one byte has been read, or avail_in == 0; reads are
         *    performed for at least two bytes (required for the zip translate_eol
         *    option -- not supported here).
         */
        var fill_window = function fill_window(s) {
            var _w_size = s.w_size;
            var p;
            var n;
            var m;
            var more;
            var str; // Assert(s->lookahead < MIN_LOOKAHEAD, "already enough lookahead");
            do {
                more = s.window_size - s.lookahead - s.strstart; // JS ints have 32 bit, block below not needed
                /* Deal with !@#$% 64K limit: */
                // if (sizeof(int) <= 2) {
                //    if (more == 0 && s->strstart == 0 && s->lookahead == 0) {
                //        more = wsize;
                //
                //  } else if (more == (unsigned)(-1)) {
                //        /* Very unlikely, but possible on 16 bit machine if
                //         * strstart == 0 && lookahead == 1 (input done a byte at time)
                //         */
                //        more--;
                //    }
                // }
                /* If the window is almost full and there is insufficient lookahead,
                 * move the upper half to the lower one to make room in the upper half.
                 */
                if (s.strstart >= _w_size + (_w_size - MIN_LOOKAHEAD)) {
                    s.window.set(s.window.subarray(_w_size, _w_size + _w_size), 0);
                    s.match_start -= _w_size;
                    s.strstart -= _w_size;
                    /* we now have strstart >= MAX_DIST */
                    s.block_start -= _w_size;
                    /* Slide the hash table (could be avoided with 32 bit values
                   at the expense of memory usage). We slide even when level == 0
                   to keep the hash table consistent if we switch back to level > 0
                   later. (Using level 0 permanently is not an optimal usage of
                   zlib, so we don't care about this pathological case.)
                   */
                    n = s.hash_size;
                    p = n;
                    do {
                        m = s.head[--p];
                        s.head[p] = m >= _w_size ? m - _w_size : 0;
                    } while (--n);
                    n = _w_size;
                    p = n;
                    do {
                        m = s.prev[--p];
                        s.prev[p] = m >= _w_size ? m - _w_size : 0;
                        /* If n is not on any hash chain, prev[n] is garbage but
                         * its value will never be used.
                         */
                    } while (--n);
                    more += _w_size;
                }
                if (s.strm.avail_in === 0) {
                    break;
                }
                /* If there was no sliding:
                 *    strstart <= WSIZE+MAX_DIST-1 && lookahead <= MIN_LOOKAHEAD - 1 &&
                 *    more == window_size - lookahead - strstart
                 * => more >= window_size - (MIN_LOOKAHEAD-1 + WSIZE + MAX_DIST-1)
                 * => more >= window_size - 2*WSIZE + 2
                 * In the BIG_MEM or MMAP case (not yet supported),
                 *   window_size == input_size + MIN_LOOKAHEAD  &&
                 *   strstart + s->lookahead <= input_size => more >= MIN_LOOKAHEAD.
                 * Otherwise, window_size == 2*WSIZE so more >= 2.
                 * If there was sliding, more >= WSIZE. So in all cases, more >= 2.
                 */
                // Assert(more >= 2, "more < 2");
                n = read_buf(s.strm, s.window, s.strstart + s.lookahead, more);
                s.lookahead += n;
                /* Initialize the hash value now that we have some input: */
                if (s.lookahead + s.insert >= MIN_MATCH$1) {
                    str = s.strstart - s.insert;
                    s.ins_h = s.window[str];
                    /* UPDATE_HASH(s, s->ins_h, s->window[str + 1]); */
                    s.ins_h = HASH(s, s.ins_h, s.window[str + 1]); // #if MIN_MATCH != 3
                    //        Call update_hash() MIN_MATCH-3 more times
                    // #endif
                    while (s.insert) {
                        /* UPDATE_HASH(s, s->ins_h, s->window[str + MIN_MATCH-1]); */
                        s.ins_h = HASH(s, s.ins_h, s.window[str + MIN_MATCH$1 - 1]);
                        s.prev[str & s.w_mask] = s.head[s.ins_h];
                        s.head[s.ins_h] = str;
                        str++;
                        s.insert--;
                        if (s.lookahead + s.insert < MIN_MATCH$1) {
                            break;
                        }
                    }
                }
                /* If the whole input has less than MIN_MATCH bytes, ins_h is garbage,
                 * but this is not important since only literal bytes will be emitted.
                 */
            } while (s.lookahead < MIN_LOOKAHEAD && s.strm.avail_in !== 0);
            /* If the WIN_INIT bytes after the end of the current data have never been
             * written, then zero those bytes in order to avoid memory check reports of
             * the use of uninitialized (or uninitialised as Julian writes) bytes by
             * the longest match routines.  Update the high water mark for the next
             * time through here.  WIN_INIT is set to MAX_MATCH since the longest match
             * routines allow scanning to strstart + MAX_MATCH, ignoring lookahead.
             */
            //  if (s.high_water < s.window_size) {
            //    const curr = s.strstart + s.lookahead;
            //    let init = 0;
            //
            //    if (s.high_water < curr) {
            //      /* Previous high water mark below current data -- zero WIN_INIT
            //       * bytes or up to end of window, whichever is less.
            //       */
            //      init = s.window_size - curr;
            //      if (init > WIN_INIT)
            //        init = WIN_INIT;
            //      zmemzero(s->window + curr, (unsigned)init);
            //      s->high_water = curr + init;
            //    }
            //    else if (s->high_water < (ulg)curr + WIN_INIT) {
            //      /* High water mark at or above current data, but below current data
            //       * plus WIN_INIT -- zero out to current data plus WIN_INIT, or up
            //       * to end of window, whichever is less.
            //       */
            //      init = (ulg)curr + WIN_INIT - s->high_water;
            //      if (init > s->window_size - s->high_water)
            //        init = s->window_size - s->high_water;
            //      zmemzero(s->window + s->high_water, (unsigned)init);
            //      s->high_water += init;
            //    }
            //  }
            //
            //  Assert((ulg)s->strstart <= s->window_size - MIN_LOOKAHEAD,
            //    "not enough room for search");
        };
        /* ===========================================================================
         * Copy without compression as much as possible from the input stream, return
         * the current block state.
         * This function does not insert new strings in the dictionary since
         * uncompressible data is probably not useful. This function is used
         * only for the level=0 compression option.
         * NOTE: this function should be optimized to avoid extra copying from
         * window to pending_buf.
         */
        var deflate_stored = function deflate_stored(s, flush) {
            /* Stored blocks are limited to 0xffff bytes, pending_buf is limited
             * to pending_buf_size, and each stored block has a 5 byte header:
             */
            var max_block_size = 0xffff;
            if (max_block_size > s.pending_buf_size - 5) {
                max_block_size = s.pending_buf_size - 5;
            }
            /* Copy as much as possible from input to output: */
            for (;;) {
                /* Fill the window as much as possible: */
                if (s.lookahead <= 1) {
                    // Assert(s->strstart < s->w_size+MAX_DIST(s) ||
                    //  s->block_start >= (long)s->w_size, "slide too late");
                    //      if (!(s.strstart < s.w_size + (s.w_size - MIN_LOOKAHEAD) ||
                    //        s.block_start >= s.w_size)) {
                    //        throw  new Error("slide too late");
                    //      }
                    fill_window(s);
                    if (s.lookahead === 0 && flush === Z_NO_FLUSH) {
                        return BS_NEED_MORE;
                    }
                    if (s.lookahead === 0) {
                        break;
                    }
                    /* flush the current block */
                } // Assert(s->block_start >= 0L, "block gone");
                //    if (s.block_start < 0) throw new Error("block gone");
                s.strstart += s.lookahead;
                s.lookahead = 0;
                /* Emit a stored block if pending_buf will be full: */
                var max_start = s.block_start + max_block_size;
                if (s.strstart === 0 || s.strstart >= max_start) {
                    /* strstart == 0 is possible when wraparound on 16-bit machine */
                    s.lookahead = s.strstart - max_start;
                    s.strstart = max_start;
                    /** * FLUSH_BLOCK(s, 0); ** */
                    flush_block_only(s, false);
                    if (s.strm.avail_out === 0) {
                        return BS_NEED_MORE;
                    }
                    /***/
                }
                /* Flush if we may have to slide, otherwise block_start may become
                 * negative and the data will be gone:
                 */
                if (s.strstart - s.block_start >= s.w_size - MIN_LOOKAHEAD) {
                    /** * FLUSH_BLOCK(s, 0); ** */
                    flush_block_only(s, false);
                    if (s.strm.avail_out === 0) {
                        return BS_NEED_MORE;
                    }
                    /***/
                }
            }
            s.insert = 0;
            if (flush === Z_FINISH) {
                /** * FLUSH_BLOCK(s, 1); ** */
                flush_block_only(s, true);
                if (s.strm.avail_out === 0) {
                    return BS_FINISH_STARTED;
                }
                /***/
                return BS_FINISH_DONE;
            }
            if (s.strstart > s.block_start) {
                /** * FLUSH_BLOCK(s, 0); ** */
                flush_block_only(s, false);
                if (s.strm.avail_out === 0) {
                    return BS_NEED_MORE;
                }
                /***/
            }
            return BS_NEED_MORE;
        };
        /* ===========================================================================
         * Compress as much as possible from the input stream, return the current
         * block state.
         * This function does not perform lazy evaluation of matches and inserts
         * new strings in the dictionary only for unmatched strings or for short
         * matches. It is used only for the fast compression options.
         */
        var deflate_fast = function deflate_fast(s, flush) {
            var hash_head;
            /* head of the hash chain */
            var bflush;
            /* set if current block must be flushed */
            for (;;) {
                /* Make sure that we always have enough lookahead, except
                 * at the end of the input file. We need MAX_MATCH bytes
                 * for the next match, plus MIN_MATCH bytes to insert the
                 * string following the next match.
                 */
                if (s.lookahead < MIN_LOOKAHEAD) {
                    fill_window(s);
                    if (s.lookahead < MIN_LOOKAHEAD && flush === Z_NO_FLUSH) {
                        return BS_NEED_MORE;
                    }
                    if (s.lookahead === 0) {
                        break;
                        /* flush the current block */
                    }
                }
                /* Insert the string window[strstart .. strstart+2] in the
                 * dictionary, and set hash_head to the head of the hash chain:
                 */
                hash_head = 0;
                /* NIL */
                if (s.lookahead >= MIN_MATCH$1) {
                    /** * INSERT_STRING(s, s.strstart, hash_head); ** */
                    s.ins_h = HASH(s, s.ins_h, s.window[s.strstart + MIN_MATCH$1 - 1]);
                    hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
                    s.head[s.ins_h] = s.strstart;
                    /***/
                }
                /* Find the longest match, discarding those <= prev_length.
                 * At this point we have always match_length < MIN_MATCH
                 */
                if (hash_head !== 0 &&
                    /* NIL */
                    s.strstart - hash_head <= s.w_size - MIN_LOOKAHEAD) {
                    /* To simplify the code, we prevent matches with the string
                     * of window index 0 (in particular we have to avoid a match
                     * of the string with itself at the start of the input file).
                     */
                    s.match_length = longest_match(s, hash_head);
                    /* longest_match() sets match_start */
                }
                if (s.match_length >= MIN_MATCH$1) {
                    // check_match(s, s.strstart, s.match_start, s.match_length); // for debug only
                    /** * _tr_tally_dist(s, s.strstart - s.match_start,
                                 s.match_length - MIN_MATCH, bflush); ** */
                    bflush = _tr_tally$1(s, s.strstart - s.match_start, s.match_length - MIN_MATCH$1);
                    s.lookahead -= s.match_length;
                    /* Insert new strings in the hash table only if the match length
                     * is not too large. This saves time but degrades compression.
                     */
                    if (s.match_length <= s.max_lazy_match &&
                        /* max_insert_length */
                        s.lookahead >= MIN_MATCH$1) {
                        s.match_length--;
                        /* string at strstart already in table */
                        do {
                            s.strstart++;
                            /** * INSERT_STRING(s, s.strstart, hash_head); ** */
                            s.ins_h = HASH(s, s.ins_h, s.window[s.strstart + MIN_MATCH$1 - 1]);
                            hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
                            s.head[s.ins_h] = s.strstart;
                            /***/
                            /* strstart never exceeds WSIZE-MAX_MATCH, so there are
                             * always MIN_MATCH bytes ahead.
                             */
                        } while (--s.match_length !== 0);
                        s.strstart++;
                    }
                    else {
                        s.strstart += s.match_length;
                        s.match_length = 0;
                        s.ins_h = s.window[s.strstart];
                        /* UPDATE_HASH(s, s.ins_h, s.window[s.strstart+1]); */
                        s.ins_h = HASH(s, s.ins_h, s.window[s.strstart + 1]); // #if MIN_MATCH != 3
                        //                Call UPDATE_HASH() MIN_MATCH-3 more times
                        // #endif
                        /* If lookahead < MIN_MATCH, ins_h is garbage, but it does not
                         * matter since it will be recomputed at next deflate call.
                         */
                    }
                }
                else {
                    /* No match, output a literal byte */
                    // Tracevv((stderr,"%c", s.window[s.strstart]));
                    /** * _tr_tally_lit(s, s.window[s.strstart], bflush); ** */
                    bflush = _tr_tally$1(s, 0, s.window[s.strstart]);
                    s.lookahead--;
                    s.strstart++;
                }
                if (bflush) {
                    /** * FLUSH_BLOCK(s, 0); ** */
                    flush_block_only(s, false);
                    if (s.strm.avail_out === 0) {
                        return BS_NEED_MORE;
                    }
                    /***/
                }
            }
            s.insert = s.strstart < MIN_MATCH$1 - 1 ? s.strstart : MIN_MATCH$1 - 1;
            if (flush === Z_FINISH) {
                /** * FLUSH_BLOCK(s, 1); ** */
                flush_block_only(s, true);
                if (s.strm.avail_out === 0) {
                    return BS_FINISH_STARTED;
                }
                /***/
                return BS_FINISH_DONE;
            }
            if (s.last_lit) {
                /** * FLUSH_BLOCK(s, 0); ** */
                flush_block_only(s, false);
                if (s.strm.avail_out === 0) {
                    return BS_NEED_MORE;
                }
                /***/
            }
            return BS_BLOCK_DONE;
        };
        /* ===========================================================================
         * Same as above, but achieves better compression. We use a lazy
         * evaluation for matches: a match is finally adopted only if there is
         * no better match at the next window position.
         */
        var deflate_slow = function deflate_slow(s, flush) {
            var hash_head;
            /* head of hash chain */
            var bflush;
            /* set if current block must be flushed */
            var max_insert;
            /* Process the input block. */
            for (;;) {
                /* Make sure that we always have enough lookahead, except
                 * at the end of the input file. We need MAX_MATCH bytes
                 * for the next match, plus MIN_MATCH bytes to insert the
                 * string following the next match.
                 */
                if (s.lookahead < MIN_LOOKAHEAD) {
                    fill_window(s);
                    if (s.lookahead < MIN_LOOKAHEAD && flush === Z_NO_FLUSH) {
                        return BS_NEED_MORE;
                    }
                    if (s.lookahead === 0) {
                        break;
                    }
                    /* flush the current block */
                }
                /* Insert the string window[strstart .. strstart+2] in the
                 * dictionary, and set hash_head to the head of the hash chain:
                 */
                hash_head = 0;
                /* NIL */
                if (s.lookahead >= MIN_MATCH$1) {
                    /** * INSERT_STRING(s, s.strstart, hash_head); ** */
                    s.ins_h = HASH(s, s.ins_h, s.window[s.strstart + MIN_MATCH$1 - 1]);
                    hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
                    s.head[s.ins_h] = s.strstart;
                    /***/
                }
                /* Find the longest match, discarding those <= prev_length.
                 */
                s.prev_length = s.match_length;
                s.prev_match = s.match_start;
                s.match_length = MIN_MATCH$1 - 1;
                if (hash_head !== 0 &&
                    /* NIL */
                    s.prev_length < s.max_lazy_match &&
                    s.strstart - hash_head <= s.w_size - MIN_LOOKAHEAD
                /* MAX_DIST(s) */
                ) {
                    /* To simplify the code, we prevent matches with the string
                     * of window index 0 (in particular we have to avoid a match
                     * of the string with itself at the start of the input file).
                     */
                    s.match_length = longest_match(s, hash_head);
                    /* longest_match() sets match_start */
                    if (s.match_length <= 5 &&
                        (s.strategy === Z_FILTERED || (s.match_length === MIN_MATCH$1 && s.strstart - s.match_start > 4096))
                    /* TOO_FAR */
                    ) {
                        /* If prev_match is also MIN_MATCH, match_start is garbage
                         * but we will ignore the current match anyway.
                         */
                        s.match_length = MIN_MATCH$1 - 1;
                    }
                }
                /* If there was a match at the previous step and the current
                 * match is not better, output the previous match:
                 */
                if (s.prev_length >= MIN_MATCH$1 && s.match_length <= s.prev_length) {
                    max_insert = s.strstart + s.lookahead - MIN_MATCH$1;
                    /* Do not insert strings in hash table beyond this. */
                    // check_match(s, s.strstart-1, s.prev_match, s.prev_length);
                    /** *_tr_tally_dist(s, s.strstart - 1 - s.prev_match,
                                 s.prev_length - MIN_MATCH, bflush);** */
                    bflush = _tr_tally$1(s, s.strstart - 1 - s.prev_match, s.prev_length - MIN_MATCH$1);
                    /* Insert in hash table all strings up to the end of the match.
                     * strstart-1 and strstart are already inserted. If there is not
                     * enough lookahead, the last two strings are not inserted in
                     * the hash table.
                     */
                    s.lookahead -= s.prev_length - 1;
                    s.prev_length -= 2;
                    do {
                        if (++s.strstart <= max_insert) {
                            /** * INSERT_STRING(s, s.strstart, hash_head); ** */
                            s.ins_h = HASH(s, s.ins_h, s.window[s.strstart + MIN_MATCH$1 - 1]);
                            hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
                            s.head[s.ins_h] = s.strstart;
                            /***/
                        }
                    } while (--s.prev_length !== 0);
                    s.match_available = 0;
                    s.match_length = MIN_MATCH$1 - 1;
                    s.strstart++;
                    if (bflush) {
                        /** * FLUSH_BLOCK(s, 0); ** */
                        flush_block_only(s, false);
                        if (s.strm.avail_out === 0) {
                            return BS_NEED_MORE;
                        }
                        /***/
                    }
                }
                else if (s.match_available) {
                    /* If there was no match at the previous position, output a
                     * single literal. If there was a match but the current match
                     * is longer, truncate the previous match to a single literal.
                     */
                    // Tracevv((stderr,"%c", s->window[s->strstart-1]));
                    /** * _tr_tally_lit(s, s.window[s.strstart-1], bflush); ** */
                    bflush = _tr_tally$1(s, 0, s.window[s.strstart - 1]);
                    if (bflush) {
                        /** * FLUSH_BLOCK_ONLY(s, 0) ** */
                        flush_block_only(s, false);
                        /***/
                    }
                    s.strstart++;
                    s.lookahead--;
                    if (s.strm.avail_out === 0) {
                        return BS_NEED_MORE;
                    }
                }
                else {
                    /* There is no previous match to compare with, wait for
                     * the next step to decide.
                     */
                    s.match_available = 1;
                    s.strstart++;
                    s.lookahead--;
                }
            } // Assert (flush != Z_NO_FLUSH, "no flush?");
            if (s.match_available) {
                // Tracevv((stderr,"%c", s->window[s->strstart-1]));
                /** * _tr_tally_lit(s, s.window[s.strstart-1], bflush); ** */
                bflush = _tr_tally$1(s, 0, s.window[s.strstart - 1]);
                s.match_available = 0;
            }
            s.insert = s.strstart < MIN_MATCH$1 - 1 ? s.strstart : MIN_MATCH$1 - 1;
            if (flush === Z_FINISH) {
                /** * FLUSH_BLOCK(s, 1); ** */
                flush_block_only(s, true);
                if (s.strm.avail_out === 0) {
                    return BS_FINISH_STARTED;
                }
                /***/
                return BS_FINISH_DONE;
            }
            if (s.last_lit) {
                /** * FLUSH_BLOCK(s, 0); ** */
                flush_block_only(s, false);
                if (s.strm.avail_out === 0) {
                    return BS_NEED_MORE;
                }
                /***/
            }
            return BS_BLOCK_DONE;
        };
        /* ===========================================================================
         * For Z_RLE, simply look for runs of bytes, generate matches only of distance
         * one.  Do not maintain a hash table.  (It will be regenerated if this run of
         * deflate switches away from Z_RLE.)
         */
        var deflate_rle = function deflate_rle(s, flush) {
            var bflush;
            /* set if current block must be flushed */
            var prev;
            /* byte at distance one to match */
            var scan;
            var strend;
            /* scan goes up to strend for length of run */
            var _win = s.window;
            for (;;) {
                /* Make sure that we always have enough lookahead, except
                 * at the end of the input file. We need MAX_MATCH bytes
                 * for the longest run, plus one for the unrolled loop.
                 */
                if (s.lookahead <= MAX_MATCH$1) {
                    fill_window(s);
                    if (s.lookahead <= MAX_MATCH$1 && flush === Z_NO_FLUSH) {
                        return BS_NEED_MORE;
                    }
                    if (s.lookahead === 0) {
                        break;
                    }
                    /* flush the current block */
                }
                /* See how many times the previous byte repeats */
                s.match_length = 0;
                if (s.lookahead >= MIN_MATCH$1 && s.strstart > 0) {
                    scan = s.strstart - 1;
                    prev = _win[scan];
                    if (prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan]) {
                        strend = s.strstart + MAX_MATCH$1;
                        do {
                            /* jshint noempty:false */
                        } while (prev === _win[++scan] &&
                            prev === _win[++scan] &&
                            prev === _win[++scan] &&
                            prev === _win[++scan] &&
                            prev === _win[++scan] &&
                            prev === _win[++scan] &&
                            prev === _win[++scan] &&
                            prev === _win[++scan] &&
                            scan < strend);
                        s.match_length = MAX_MATCH$1 - (strend - scan);
                        if (s.match_length > s.lookahead) {
                            s.match_length = s.lookahead;
                        }
                    } // Assert(scan <= s->window+(uInt)(s->window_size-1), "wild scan");
                }
                /* Emit match if have run of MIN_MATCH or longer, else emit literal */
                if (s.match_length >= MIN_MATCH$1) {
                    // check_match(s, s.strstart, s.strstart - 1, s.match_length);
                    /** * _tr_tally_dist(s, 1, s.match_length - MIN_MATCH, bflush); ** */
                    bflush = _tr_tally$1(s, 1, s.match_length - MIN_MATCH$1);
                    s.lookahead -= s.match_length;
                    s.strstart += s.match_length;
                    s.match_length = 0;
                }
                else {
                    /* No match, output a literal byte */
                    // Tracevv((stderr,"%c", s->window[s->strstart]));
                    /** * _tr_tally_lit(s, s.window[s.strstart], bflush); ** */
                    bflush = _tr_tally$1(s, 0, s.window[s.strstart]);
                    s.lookahead--;
                    s.strstart++;
                }
                if (bflush) {
                    /** * FLUSH_BLOCK(s, 0); ** */
                    flush_block_only(s, false);
                    if (s.strm.avail_out === 0) {
                        return BS_NEED_MORE;
                    }
                    /***/
                }
            }
            s.insert = 0;
            if (flush === Z_FINISH) {
                /** * FLUSH_BLOCK(s, 1); ** */
                flush_block_only(s, true);
                if (s.strm.avail_out === 0) {
                    return BS_FINISH_STARTED;
                }
                /***/
                return BS_FINISH_DONE;
            }
            if (s.last_lit) {
                /** * FLUSH_BLOCK(s, 0); ** */
                flush_block_only(s, false);
                if (s.strm.avail_out === 0) {
                    return BS_NEED_MORE;
                }
                /***/
            }
            return BS_BLOCK_DONE;
        };
        /* ===========================================================================
         * For Z_HUFFMAN_ONLY, do not look for matches.  Do not maintain a hash table.
         * (It will be regenerated if this run of deflate switches away from Huffman.)
         */
        var deflate_huff = function deflate_huff(s, flush) {
            var bflush;
            /* set if current block must be flushed */
            for (;;) {
                /* Make sure that we have a literal to write. */
                if (s.lookahead === 0) {
                    fill_window(s);
                    if (s.lookahead === 0) {
                        if (flush === Z_NO_FLUSH) {
                            return BS_NEED_MORE;
                        }
                        break;
                        /* flush the current block */
                    }
                }
                /* Output a literal byte */
                s.match_length = 0; // Tracevv((stderr,"%c", s->window[s->strstart]));
                /** * _tr_tally_lit(s, s.window[s.strstart], bflush); ** */
                bflush = _tr_tally$1(s, 0, s.window[s.strstart]);
                s.lookahead--;
                s.strstart++;
                if (bflush) {
                    /** * FLUSH_BLOCK(s, 0); ** */
                    flush_block_only(s, false);
                    if (s.strm.avail_out === 0) {
                        return BS_NEED_MORE;
                    }
                    /***/
                }
            }
            s.insert = 0;
            if (flush === Z_FINISH) {
                /** * FLUSH_BLOCK(s, 1); ** */
                flush_block_only(s, true);
                if (s.strm.avail_out === 0) {
                    return BS_FINISH_STARTED;
                }
                /***/
                return BS_FINISH_DONE;
            }
            if (s.last_lit) {
                /** * FLUSH_BLOCK(s, 0); ** */
                flush_block_only(s, false);
                if (s.strm.avail_out === 0) {
                    return BS_NEED_MORE;
                }
                /***/
            }
            return BS_BLOCK_DONE;
        };
        /* Values for max_lazy_match, good_match and max_chain_length, depending on
         * the desired pack level (0..9). The values given below have been tuned to
         * exclude worst case performance for pathological files. Better values may be
         * found for specific files.
         */
        function Config(good_length, max_lazy, nice_length, max_chain, func) {
            this.good_length = good_length;
            this.max_lazy = max_lazy;
            this.nice_length = nice_length;
            this.max_chain = max_chain;
            this.func = func;
        }
        var configuration_table = [
            /*      good lazy nice chain */
            new Config(0, 0, 0, 0, deflate_stored),
            /* 0 store only */
            new Config(4, 4, 8, 4, deflate_fast),
            /* 1 max speed, no lazy matches */
            new Config(4, 5, 16, 8, deflate_fast),
            /* 2 */
            new Config(4, 6, 32, 32, deflate_fast),
            /* 3 */
            new Config(4, 4, 16, 16, deflate_slow),
            /* 4 lazy matches */
            new Config(8, 16, 32, 32, deflate_slow),
            /* 5 */
            new Config(8, 16, 128, 128, deflate_slow),
            /* 6 */
            new Config(8, 32, 128, 256, deflate_slow),
            /* 7 */
            new Config(32, 128, 258, 1024, deflate_slow),
            /* 8 */
            new Config(32, 258, 258, 4096, deflate_slow),
            /* 9 max compression */
        ];
        /* ===========================================================================
         * Initialize the "longest match" routines for a new zlib stream
         */
        var lm_init = function lm_init(s) {
            s.window_size = 2 * s.w_size;
            /** * CLEAR_HASH(s); ** */
            zero$1(s.head); // Fill with NIL (= 0);
            /* Set the default configuration parameters:
             */
            s.max_lazy_match = configuration_table[s.level].max_lazy;
            s.good_match = configuration_table[s.level].good_length;
            s.nice_match = configuration_table[s.level].nice_length;
            s.max_chain_length = configuration_table[s.level].max_chain;
            s.strstart = 0;
            s.block_start = 0;
            s.lookahead = 0;
            s.insert = 0;
            s.match_length = s.prev_length = MIN_MATCH$1 - 1;
            s.match_available = 0;
            s.ins_h = 0;
        };
        function DeflateState() {
            this.strm = null;
            /* pointer back to this zlib stream */
            this.status = 0;
            /* as the name implies */
            this.pending_buf = null;
            /* output still pending */
            this.pending_buf_size = 0;
            /* size of pending_buf */
            this.pending_out = 0;
            /* next pending byte to output to the stream */
            this.pending = 0;
            /* nb of bytes in the pending buffer */
            this.wrap = 0;
            /* bit 0 true for zlib, bit 1 true for gzip */
            this.gzhead = null;
            /* gzip header information to write */
            this.gzindex = 0;
            /* where in extra, name, or comment */
            this.method = Z_DEFLATED;
            /* can only be DEFLATED */
            this.last_flush = -1;
            /* value of flush param for previous deflate call */
            this.w_size = 0;
            /* LZ77 window size (32K by default) */
            this.w_bits = 0;
            /* log2(w_size)  (8..16) */
            this.w_mask = 0;
            /* w_size - 1 */
            this.window = null;
            /* Sliding window. Input bytes are read into the second half of the window,
             * and move to the first half later to keep a dictionary of at least wSize
             * bytes. With this organization, matches are limited to a distance of
             * wSize-MAX_MATCH bytes, but this ensures that IO is always
             * performed with a length multiple of the block size.
             */
            this.window_size = 0;
            /* Actual size of window: 2*wSize, except when the user input buffer
             * is directly used as sliding window.
             */
            this.prev = null;
            /* Link to older string with same hash index. To limit the size of this
             * array to 64K, this link is maintained only for the last 32K strings.
             * An index in this array is thus a window index modulo 32K.
             */
            this.head = null;
            /* Heads of the hash chains or NIL. */
            this.ins_h = 0;
            /* hash index of string to be inserted */
            this.hash_size = 0;
            /* number of elements in hash table */
            this.hash_bits = 0;
            /* log2(hash_size) */
            this.hash_mask = 0;
            /* hash_size-1 */
            this.hash_shift = 0;
            /* Number of bits by which ins_h must be shifted at each input
             * step. It must be such that after MIN_MATCH steps, the oldest
             * byte no longer takes part in the hash key, that is:
             *   hash_shift * MIN_MATCH >= hash_bits
             */
            this.block_start = 0;
            /* Window position at the beginning of the current output block. Gets
             * negative when the window is moved backwards.
             */
            this.match_length = 0;
            /* length of best match */
            this.prev_match = 0;
            /* previous match */
            this.match_available = 0;
            /* set if previous match exists */
            this.strstart = 0;
            /* start of string to insert */
            this.match_start = 0;
            /* start of matching string */
            this.lookahead = 0;
            /* number of valid bytes ahead in window */
            this.prev_length = 0;
            /* Length of the best match at previous step. Matches not greater than this
             * are discarded. This is used in the lazy match evaluation.
             */
            this.max_chain_length = 0;
            /* To speed up deflation, hash chains are never searched beyond this
             * length.  A higher limit improves compression ratio but degrades the
             * speed.
             */
            this.max_lazy_match = 0;
            /* Attempt to find a better match only when the current match is strictly
             * smaller than this value. This mechanism is used only for compression
             * levels >= 4.
             */
            // That's alias to max_lazy_match, don't use directly
            // this.max_insert_length = 0;
            /* Insert new strings in the hash table only if the match length is not
             * greater than this length. This saves time but degrades compression.
             * max_insert_length is used only for compression levels <= 3.
             */
            this.level = 0;
            /* compression level (1..9) */
            this.strategy = 0;
            /* favor or force Huffman coding */
            this.good_match = 0;
            /* Use a faster search when the previous match is longer than this */
            this.nice_match = 0;
            /* Stop searching when current match exceeds this */
            /* used by trees.c: */
            /* Didn't use ct_data typedef below to suppress compiler warning */
            // struct ct_data_s dyn_ltree[HEAP_SIZE];   /* literal and length tree */
            // struct ct_data_s dyn_dtree[2*D_CODES+1]; /* distance tree */
            // struct ct_data_s bl_tree[2*BL_CODES+1];  /* Huffman tree for bit lengths */
            // Use flat array of DOUBLE size, with interleaved fata,
            // because JS does not support effective
            this.dyn_ltree = new Uint16Array(HEAP_SIZE$1 * 2);
            this.dyn_dtree = new Uint16Array((2 * D_CODES$1 + 1) * 2);
            this.bl_tree = new Uint16Array((2 * BL_CODES$1 + 1) * 2);
            zero$1(this.dyn_ltree);
            zero$1(this.dyn_dtree);
            zero$1(this.bl_tree);
            this.l_desc = null;
            /* desc. for literal tree */
            this.d_desc = null;
            /* desc. for distance tree */
            this.bl_desc = null;
            /* desc. for bit length tree */
            // ush bl_count[MAX_BITS+1];
            this.bl_count = new Uint16Array(MAX_BITS$1 + 1);
            /* number of codes at each bit length for an optimal tree */
            // int heap[2*L_CODES+1];      /* heap used to build the Huffman trees */
            this.heap = new Uint16Array(2 * L_CODES$1 + 1);
            /* heap used to build the Huffman trees */
            zero$1(this.heap);
            this.heap_len = 0;
            /* number of elements in the heap */
            this.heap_max = 0;
            /* element of largest frequency */
            /* The sons of heap[n] are heap[2*n] and heap[2*n+1]. heap[0] is not used.
             * The same heap array is used to build all trees.
             */
            this.depth = new Uint16Array(2 * L_CODES$1 + 1); // uch depth[2*L_CODES+1];
            zero$1(this.depth);
            /* Depth of each subtree used as tie breaker for trees of equal frequency
             */
            this.l_buf = 0;
            /* buffer index for literals or lengths */
            this.lit_bufsize = 0;
            /* Size of match buffer for literals/lengths.  There are 4 reasons for
             * limiting lit_bufsize to 64K:
             *   - frequencies can be kept in 16 bit counters
             *   - if compression is not successful for the first block, all input
             *     data is still in the window so we can still emit a stored block even
             *     when input comes from standard input.  (This can also be done for
             *     all blocks if lit_bufsize is not greater than 32K.)
             *   - if compression is not successful for a file smaller than 64K, we can
             *     even emit a stored file instead of a stored block (saving 5 bytes).
             *     This is applicable only for zip (not gzip or zlib).
             *   - creating new Huffman trees less frequently may not provide fast
             *     adaptation to changes in the input data statistics. (Take for
             *     example a binary file with poorly compressible code followed by
             *     a highly compressible string table.) Smaller buffer sizes give
             *     fast adaptation but have of course the overhead of transmitting
             *     trees more frequently.
             *   - I can't count above 4
             */
            this.last_lit = 0;
            /* running index in l_buf */
            this.d_buf = 0;
            /* Buffer index for distances. To simplify the code, d_buf and l_buf have
             * the same number of elements. To use different lengths, an extra flag
             * array would be necessary.
             */
            this.opt_len = 0;
            /* bit length of current block with optimal trees */
            this.static_len = 0;
            /* bit length of current block with static trees */
            this.matches = 0;
            /* number of string matches in current block */
            this.insert = 0;
            /* bytes at end of window left to insert */
            this.bi_buf = 0;
            /* Output buffer. bits are inserted starting at the bottom (least
             * significant bits).
             */
            this.bi_valid = 0;
            /* Number of valid bits in bi_buf.  All bits above the last valid bit
             * are always zero.
             */
            // Used for window memory init. We safely ignore it for JS. That makes
            // sense only for pointers and memory check tools.
            // this.high_water = 0;
            /* High water mark offset in window for initialized bytes -- bytes above
             * this are set to zero in order to avoid memory check warnings when
             * longest match routines access bytes past the input.  This is then
             * updated to the new high water mark.
             */
        }
        var deflateResetKeep = function deflateResetKeep(strm) {
            if (!strm || !strm.state) {
                return err(strm, Z_STREAM_ERROR);
            }
            strm.total_in = strm.total_out = 0;
            strm.data_type = Z_UNKNOWN$1;
            var s = strm.state;
            s.pending = 0;
            s.pending_out = 0;
            if (s.wrap < 0) {
                s.wrap = -s.wrap;
                /* was made negative by deflate(..., Z_FINISH); */
            }
            s.status = s.wrap ? INIT_STATE : BUSY_STATE;
            strm.adler =
                s.wrap === 2
                    ? 0 // crc32(0, Z_NULL, 0)
                    : 1; // adler32(0, Z_NULL, 0)
            s.last_flush = Z_NO_FLUSH;
            _tr_init$1(s);
            return Z_OK;
        };
        var deflateReset = function deflateReset(strm) {
            var ret = deflateResetKeep(strm);
            if (ret === Z_OK) {
                lm_init(strm.state);
            }
            return ret;
        };
        var deflateSetHeader = function deflateSetHeader(strm, head) {
            if (!strm || !strm.state) {
                return Z_STREAM_ERROR;
            }
            if (strm.state.wrap !== 2) {
                return Z_STREAM_ERROR;
            }
            strm.state.gzhead = head;
            return Z_OK;
        };
        var deflateInit2 = function deflateInit2(strm, level, method, windowBits, memLevel, strategy) {
            if (!strm) {
                // === Z_NULL
                return Z_STREAM_ERROR;
            }
            var wrap = 1;
            if (level === Z_DEFAULT_COMPRESSION) {
                level = 6;
            }
            if (windowBits < 0) {
                /* suppress zlib wrapper */
                wrap = 0;
                windowBits = -windowBits;
            }
            else if (windowBits > 15) {
                wrap = 2;
                /* write gzip wrapper instead */
                windowBits -= 16;
            }
            if (memLevel < 1 ||
                memLevel > MAX_MEM_LEVEL ||
                method !== Z_DEFLATED ||
                windowBits < 8 ||
                windowBits > 15 ||
                level < 0 ||
                level > 9 ||
                strategy < 0 ||
                strategy > Z_FIXED$1) {
                return err(strm, Z_STREAM_ERROR);
            }
            if (windowBits === 8) {
                windowBits = 9;
            }
            /* until 256-byte window bug fixed */
            var s = new DeflateState();
            strm.state = s;
            s.strm = strm;
            s.wrap = wrap;
            s.gzhead = null;
            s.w_bits = windowBits;
            s.w_size = 1 << s.w_bits;
            s.w_mask = s.w_size - 1;
            s.hash_bits = memLevel + 7;
            s.hash_size = 1 << s.hash_bits;
            s.hash_mask = s.hash_size - 1;
            s.hash_shift = ~~((s.hash_bits + MIN_MATCH$1 - 1) / MIN_MATCH$1);
            s.window = new Uint8Array(s.w_size * 2);
            s.head = new Uint16Array(s.hash_size);
            s.prev = new Uint16Array(s.w_size); // Don't need mem init magic for JS.
            // s.high_water = 0;  /* nothing written to s->window yet */
            s.lit_bufsize = 1 << (memLevel + 6);
            /* 16K elements by default */
            s.pending_buf_size = s.lit_bufsize * 4;
            // overlay = (ushf *) ZALLOC(strm, s->lit_bufsize, sizeof(ush)+2);
            // s->pending_buf = (uchf *) overlay;
            // It is offset from `s.pending_buf` (size is `s.lit_bufsize * 2`)
            s.pending_buf = new Uint8Array(s.pending_buf_size);
            // s->d_buf = overlay + s->lit_bufsize/sizeof(ush);
            s.d_buf = 1 * s.lit_bufsize; // s->l_buf = s->pending_buf + (1+sizeof(ush))*s->lit_bufsize;
            s.l_buf = (1 + 2) * s.lit_bufsize;
            s.level = level;
            s.strategy = strategy;
            s.method = method;
            return deflateReset(strm);
        };
        var deflateInit = function deflateInit(strm, level) {
            return deflateInit2(strm, level, Z_DEFLATED, MAX_WBITS, DEF_MEM_LEVEL, Z_DEFAULT_STRATEGY);
        };
        var deflate = function deflate(strm, flush) {
            var beg;
            var val; // for gzip header write only
            if (!strm || !strm.state || flush > Z_BLOCK || flush < 0) {
                return strm ? err(strm, Z_STREAM_ERROR) : Z_STREAM_ERROR;
            }
            var s = strm.state;
            if (!strm.output || (!strm.input && strm.avail_in !== 0) || (s.status === FINISH_STATE && flush !== Z_FINISH)) {
                return err(strm, strm.avail_out === 0 ? Z_BUF_ERROR : Z_STREAM_ERROR);
            }
            s.strm = strm;
            /* just in case */
            var old_flush = s.last_flush;
            s.last_flush = flush;
            /* Write the header */
            if (s.status === INIT_STATE) {
                if (s.wrap === 2) {
                    // GZIP header
                    strm.adler = 0; // crc32(0L, Z_NULL, 0);
                    put_byte(s, 31);
                    put_byte(s, 139);
                    put_byte(s, 8);
                    if (!s.gzhead) {
                        // s->gzhead == Z_NULL
                        put_byte(s, 0);
                        put_byte(s, 0);
                        put_byte(s, 0);
                        put_byte(s, 0);
                        put_byte(s, 0);
                        put_byte(s, s.level === 9 ? 2 : s.strategy >= Z_HUFFMAN_ONLY || s.level < 2 ? 4 : 0);
                        put_byte(s, OS_CODE);
                        s.status = BUSY_STATE;
                    }
                    else {
                        put_byte(s, (s.gzhead.text ? 1 : 0) +
                            (s.gzhead.hcrc ? 2 : 0) +
                            (!s.gzhead.extra ? 0 : 4) +
                            (!s.gzhead.name ? 0 : 8) +
                            (!s.gzhead.comment ? 0 : 16));
                        put_byte(s, s.gzhead.time & 0xff);
                        put_byte(s, (s.gzhead.time >> 8) & 0xff);
                        put_byte(s, (s.gzhead.time >> 16) & 0xff);
                        put_byte(s, (s.gzhead.time >> 24) & 0xff);
                        put_byte(s, s.level === 9 ? 2 : s.strategy >= Z_HUFFMAN_ONLY || s.level < 2 ? 4 : 0);
                        put_byte(s, s.gzhead.os & 0xff);
                        if (s.gzhead.extra && s.gzhead.extra.length) {
                            put_byte(s, s.gzhead.extra.length & 0xff);
                            put_byte(s, (s.gzhead.extra.length >> 8) & 0xff);
                        }
                        if (s.gzhead.hcrc) {
                            strm.adler = crc32_1(strm.adler, s.pending_buf, s.pending, 0);
                        }
                        s.gzindex = 0;
                        s.status = EXTRA_STATE;
                    }
                } // DEFLATE header
                else {
                    var header = (Z_DEFLATED + ((s.w_bits - 8) << 4)) << 8;
                    var level_flags = -1;
                    if (s.strategy >= Z_HUFFMAN_ONLY || s.level < 2) {
                        level_flags = 0;
                    }
                    else if (s.level < 6) {
                        level_flags = 1;
                    }
                    else if (s.level === 6) {
                        level_flags = 2;
                    }
                    else {
                        level_flags = 3;
                    }
                    header |= level_flags << 6;
                    if (s.strstart !== 0) {
                        header |= PRESET_DICT;
                    }
                    header += 31 - (header % 31);
                    s.status = BUSY_STATE;
                    putShortMSB(s, header);
                    /* Save the adler32 of the preset dictionary: */
                    if (s.strstart !== 0) {
                        putShortMSB(s, strm.adler >>> 16);
                        putShortMSB(s, strm.adler & 0xffff);
                    }
                    strm.adler = 1; // adler32(0L, Z_NULL, 0);
                }
            } // #ifdef GZIP
            if (s.status === EXTRA_STATE) {
                if (s.gzhead.extra
                /* != Z_NULL */
                ) {
                    beg = s.pending;
                    /* start of bytes to update crc */
                    while (s.gzindex < (s.gzhead.extra.length & 0xffff)) {
                        if (s.pending === s.pending_buf_size) {
                            if (s.gzhead.hcrc && s.pending > beg) {
                                strm.adler = crc32_1(strm.adler, s.pending_buf, s.pending - beg, beg);
                            }
                            flush_pending(strm);
                            beg = s.pending;
                            if (s.pending === s.pending_buf_size) {
                                break;
                            }
                        }
                        put_byte(s, s.gzhead.extra[s.gzindex] & 0xff);
                        s.gzindex++;
                    }
                    if (s.gzhead.hcrc && s.pending > beg) {
                        strm.adler = crc32_1(strm.adler, s.pending_buf, s.pending - beg, beg);
                    }
                    if (s.gzindex === s.gzhead.extra.length) {
                        s.gzindex = 0;
                        s.status = NAME_STATE;
                    }
                }
                else {
                    s.status = NAME_STATE;
                }
            }
            if (s.status === NAME_STATE) {
                if (s.gzhead.name
                /* != Z_NULL */
                ) {
                    beg = s.pending;
                    /* start of bytes to update crc */
                    // int val;
                    do {
                        if (s.pending === s.pending_buf_size) {
                            if (s.gzhead.hcrc && s.pending > beg) {
                                strm.adler = crc32_1(strm.adler, s.pending_buf, s.pending - beg, beg);
                            }
                            flush_pending(strm);
                            beg = s.pending;
                            if (s.pending === s.pending_buf_size) {
                                val = 1;
                                break;
                            }
                        } // JS specific: little magic to add zero terminator to end of string
                        if (s.gzindex < s.gzhead.name.length) {
                            val = s.gzhead.name.charCodeAt(s.gzindex++) & 0xff;
                        }
                        else {
                            val = 0;
                        }
                        put_byte(s, val);
                    } while (val !== 0);
                    if (s.gzhead.hcrc && s.pending > beg) {
                        strm.adler = crc32_1(strm.adler, s.pending_buf, s.pending - beg, beg);
                    }
                    if (val === 0) {
                        s.gzindex = 0;
                        s.status = COMMENT_STATE;
                    }
                }
                else {
                    s.status = COMMENT_STATE;
                }
            }
            if (s.status === COMMENT_STATE) {
                if (s.gzhead.comment
                /* != Z_NULL */
                ) {
                    beg = s.pending;
                    /* start of bytes to update crc */
                    // int val;
                    do {
                        if (s.pending === s.pending_buf_size) {
                            if (s.gzhead.hcrc && s.pending > beg) {
                                strm.adler = crc32_1(strm.adler, s.pending_buf, s.pending - beg, beg);
                            }
                            flush_pending(strm);
                            beg = s.pending;
                            if (s.pending === s.pending_buf_size) {
                                val = 1;
                                break;
                            }
                        } // JS specific: little magic to add zero terminator to end of string
                        if (s.gzindex < s.gzhead.comment.length) {
                            val = s.gzhead.comment.charCodeAt(s.gzindex++) & 0xff;
                        }
                        else {
                            val = 0;
                        }
                        put_byte(s, val);
                    } while (val !== 0);
                    if (s.gzhead.hcrc && s.pending > beg) {
                        strm.adler = crc32_1(strm.adler, s.pending_buf, s.pending - beg, beg);
                    }
                    if (val === 0) {
                        s.status = HCRC_STATE;
                    }
                }
                else {
                    s.status = HCRC_STATE;
                }
            }
            if (s.status === HCRC_STATE) {
                if (s.gzhead.hcrc) {
                    if (s.pending + 2 > s.pending_buf_size) {
                        flush_pending(strm);
                    }
                    if (s.pending + 2 <= s.pending_buf_size) {
                        put_byte(s, strm.adler & 0xff);
                        put_byte(s, (strm.adler >> 8) & 0xff);
                        strm.adler = 0; // crc32(0L, Z_NULL, 0);
                        s.status = BUSY_STATE;
                    }
                }
                else {
                    s.status = BUSY_STATE;
                }
            } // #endif
            /* Flush as much pending output as possible */
            if (s.pending !== 0) {
                flush_pending(strm);
                if (strm.avail_out === 0) {
                    /* Since avail_out is 0, deflate will be called again with
                     * more output space, but possibly with both pending and
                     * avail_in equal to zero. There won't be anything to do,
                     * but this is not an error situation so make sure we
                     * return OK instead of BUF_ERROR at next call of deflate:
                     */
                    s.last_flush = -1;
                    return Z_OK;
                }
                /* Make sure there is something to do and avoid duplicate consecutive
                 * flushes. For repeated and useless calls with Z_FINISH, we keep
                 * returning Z_STREAM_END instead of Z_BUF_ERROR.
                 */
            }
            else if (strm.avail_in === 0 && rank(flush) <= rank(old_flush) && flush !== Z_FINISH) {
                return err(strm, Z_BUF_ERROR);
            }
            /* User must not provide more input after the first FINISH: */
            if (s.status === FINISH_STATE && strm.avail_in !== 0) {
                return err(strm, Z_BUF_ERROR);
            }
            /* Start a new block or continue the current one.
             */
            if (strm.avail_in !== 0 || s.lookahead !== 0 || (flush !== Z_NO_FLUSH && s.status !== FINISH_STATE)) {
                var bstate = s.strategy === Z_HUFFMAN_ONLY
                    ? deflate_huff(s, flush)
                    : s.strategy === Z_RLE
                        ? deflate_rle(s, flush)
                        : configuration_table[s.level].func(s, flush);
                if (bstate === BS_FINISH_STARTED || bstate === BS_FINISH_DONE) {
                    s.status = FINISH_STATE;
                }
                if (bstate === BS_NEED_MORE || bstate === BS_FINISH_STARTED) {
                    if (strm.avail_out === 0) {
                        s.last_flush = -1;
                        /* avoid BUF_ERROR next call, see above */
                    }
                    return Z_OK;
                    /* If flush != Z_NO_FLUSH && avail_out == 0, the next call
                     * of deflate should use the same flush parameter to make sure
                     * that the flush is complete. So we don't have to output an
                     * empty block here, this will be done at next call. This also
                     * ensures that for a very small output buffer, we emit at most
                     * one empty block.
                     */
                }
                if (bstate === BS_BLOCK_DONE) {
                    if (flush === Z_PARTIAL_FLUSH) {
                        _tr_align$1(s);
                    }
                    else if (flush !== Z_BLOCK) {
                        /* FULL_FLUSH or SYNC_FLUSH */
                        _tr_stored_block$1(s, 0, 0, false);
                        /* For a full flush, this empty block will be recognized
                         * as a special marker by inflate_sync().
                         */
                        if (flush === Z_FULL_FLUSH) {
                            /** * CLEAR_HASH(s); ** */
                            /* forget history */
                            zero$1(s.head); // Fill with NIL (= 0);
                            if (s.lookahead === 0) {
                                s.strstart = 0;
                                s.block_start = 0;
                                s.insert = 0;
                            }
                        }
                    }
                    flush_pending(strm);
                    if (strm.avail_out === 0) {
                        s.last_flush = -1;
                        /* avoid BUF_ERROR at next call, see above */
                        return Z_OK;
                    }
                }
            } // Assert(strm->avail_out > 0, "bug2");
            // if (strm.avail_out <= 0) { throw new Error("bug2");}
            if (flush !== Z_FINISH) {
                return Z_OK;
            }
            if (s.wrap <= 0) {
                return Z_STREAM_END;
            }
            /* Write the trailer */
            if (s.wrap === 2) {
                put_byte(s, strm.adler & 0xff);
                put_byte(s, (strm.adler >> 8) & 0xff);
                put_byte(s, (strm.adler >> 16) & 0xff);
                put_byte(s, (strm.adler >> 24) & 0xff);
                put_byte(s, strm.total_in & 0xff);
                put_byte(s, (strm.total_in >> 8) & 0xff);
                put_byte(s, (strm.total_in >> 16) & 0xff);
                put_byte(s, (strm.total_in >> 24) & 0xff);
            }
            else {
                putShortMSB(s, strm.adler >>> 16);
                putShortMSB(s, strm.adler & 0xffff);
            }
            flush_pending(strm);
            /* If avail_out is zero, the application will call deflate again
             * to flush the rest.
             */
            if (s.wrap > 0) {
                s.wrap = -s.wrap;
            }
            /* write the trailer only once! */
            return s.pending !== 0 ? Z_OK : Z_STREAM_END;
        };
        var deflateEnd = function deflateEnd(strm) {
            if (!strm ||
                /* == Z_NULL */
                !strm.state
            /* == Z_NULL */
            ) {
                return Z_STREAM_ERROR;
            }
            var status = strm.state.status;
            if (status !== INIT_STATE &&
                status !== EXTRA_STATE &&
                status !== NAME_STATE &&
                status !== COMMENT_STATE &&
                status !== HCRC_STATE &&
                status !== BUSY_STATE &&
                status !== FINISH_STATE) {
                return err(strm, Z_STREAM_ERROR);
            }
            strm.state = null;
            return status === BUSY_STATE ? err(strm, Z_DATA_ERROR) : Z_OK;
        };
        /* =========================================================================
         * Initializes the compression dictionary from the given byte
         * sequence without producing any compressed output.
         */
        var deflateSetDictionary = function deflateSetDictionary(strm, dictionary) {
            var dictLength = dictionary.length;
            if (!strm ||
                /* == Z_NULL */
                !strm.state
            /* == Z_NULL */
            ) {
                return Z_STREAM_ERROR;
            }
            var s = strm.state;
            var wrap = s.wrap;
            if (wrap === 2 || (wrap === 1 && s.status !== INIT_STATE) || s.lookahead) {
                return Z_STREAM_ERROR;
            }
            /* when using zlib wrappers, compute Adler-32 for provided dictionary */
            if (wrap === 1) {
                /* adler32(strm->adler, dictionary, dictLength); */
                strm.adler = adler32_1(strm.adler, dictionary, dictLength, 0);
            }
            s.wrap = 0;
            /* avoid computing Adler-32 in read_buf */
            /* if dictionary would fill window, just replace the history */
            if (dictLength >= s.w_size) {
                if (wrap === 0) {
                    /* already empty otherwise */
                    /** * CLEAR_HASH(s); ** */
                    zero$1(s.head); // Fill with NIL (= 0);
                    s.strstart = 0;
                    s.block_start = 0;
                    s.insert = 0;
                }
                /* use the tail */
                // dictionary = dictionary.slice(dictLength - s.w_size);
                var tmpDict = new Uint8Array(s.w_size);
                tmpDict.set(dictionary.subarray(dictLength - s.w_size, dictLength), 0);
                dictionary = tmpDict;
                dictLength = s.w_size;
            }
            /* insert dictionary into window and hash */
            var avail = strm.avail_in;
            var next = strm.next_in;
            var input = strm.input;
            strm.avail_in = dictLength;
            strm.next_in = 0;
            strm.input = dictionary;
            fill_window(s);
            while (s.lookahead >= MIN_MATCH$1) {
                var str = s.strstart;
                var n = s.lookahead - (MIN_MATCH$1 - 1);
                do {
                    /* UPDATE_HASH(s, s->ins_h, s->window[str + MIN_MATCH-1]); */
                    s.ins_h = HASH(s, s.ins_h, s.window[str + MIN_MATCH$1 - 1]);
                    s.prev[str & s.w_mask] = s.head[s.ins_h];
                    s.head[s.ins_h] = str;
                    str++;
                } while (--n);
                s.strstart = str;
                s.lookahead = MIN_MATCH$1 - 1;
                fill_window(s);
            }
            s.strstart += s.lookahead;
            s.block_start = s.strstart;
            s.insert = s.lookahead;
            s.lookahead = 0;
            s.match_length = s.prev_length = MIN_MATCH$1 - 1;
            s.match_available = 0;
            strm.next_in = next;
            strm.input = input;
            strm.avail_in = avail;
            s.wrap = wrap;
            return Z_OK;
        };
        var deflateInit_1 = deflateInit;
        var deflateInit2_1 = deflateInit2;
        var deflateReset_1 = deflateReset;
        var deflateResetKeep_1 = deflateResetKeep;
        var deflateSetHeader_1 = deflateSetHeader;
        var deflate_2 = deflate;
        var deflateEnd_1 = deflateEnd;
        var deflateSetDictionary_1 = deflateSetDictionary;
        var deflateInfo = 'pako deflate (from Nodeca project)';
        /* Not implemented
      module.exports.deflateBound = deflateBound;
      module.exports.deflateCopy = deflateCopy;
      module.exports.deflateParams = deflateParams;
      module.exports.deflatePending = deflatePending;
      module.exports.deflatePrime = deflatePrime;
      module.exports.deflateTune = deflateTune;
      */
        var deflate_1 = {
            deflateInit: deflateInit_1,
            deflateInit2: deflateInit2_1,
            deflateReset: deflateReset_1,
            deflateResetKeep: deflateResetKeep_1,
            deflateSetHeader: deflateSetHeader_1,
            deflate: deflate_2,
            deflateEnd: deflateEnd_1,
            deflateSetDictionary: deflateSetDictionary_1,
            deflateInfo: deflateInfo,
        };
        // Join array of chunks to single array.
        function flattenChunks(chunks) {
            // calculate data length
            var len = 0;
            for (var i = 0, l = chunks.length; i < l; i++) {
                len += chunks[i].length;
            } // join chunks
            var result = new Uint8Array(len);
            for (var _i = 0, pos = 0, _l = chunks.length; _i < _l; _i++) {
                var chunk = chunks[_i];
                result.set(chunk, pos);
                pos += chunk.length;
            }
            return result;
        }
        // String encode/decode helpers
        //
        // - apply(Array) can fail on Android 2.2
        // - apply(Uint8Array) can fail on iOS 5.1 Safari
        //
        // Table with utf8 lengths (calculated by first byte of sequence)
        // Note, that 5 & 6-byte values and some 4-byte values can not be represented in JS,
        // because max possible codepoint is 0x10ffff
        var _utf8len = new Uint8Array(256);
        for (var q = 0; q < 256; q++) {
            _utf8len[q] = q >= 252 ? 6 : q >= 248 ? 5 : q >= 240 ? 4 : q >= 224 ? 3 : q >= 192 ? 2 : 1;
        }
        _utf8len[254] = _utf8len[254] = 1; // Invalid sequence start
        // convert string to array (typed, when possible)
        // (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
        //
        // This software is provided 'as-is', without any express or implied
        // warranty. In no event will the authors be held liable for any damages
        // arising from the use of this software.
        //
        // Permission is granted to anyone to use this software for any purpose,
        // including commercial applications, and to alter it and redistribute it
        // freely, subject to the following restrictions:
        //
        // 1. The origin of this software must not be misrepresented; you must not
        //   claim that you wrote the original software. If you use this software
        //   in a product, an acknowledgment in the product documentation would be
        //   appreciated but is not required.
        // 2. Altered source versions must be plainly marked as such, and must not be
        //   misrepresented as being the original software.
        // 3. This notice may not be removed or altered from any source distribution.
        function ZStream() {
            /* next input byte */
            this.input = null; // JS specific, because we have no pointers
            this.next_in = 0;
            /* number of bytes available at input */
            this.avail_in = 0;
            /* total number of input bytes read so far */
            this.total_in = 0;
            /* next output byte should be put there */
            this.output = null; // JS specific, because we have no pointers
            this.next_out = 0;
            /* remaining free space at output */
            this.avail_out = 0;
            /* total number of bytes output so far */
            this.total_out = 0;
            /* last error message, NULL if no error */
            this.msg = '';
            /* Z_NULL */
            /* not visible by applications */
            this.state = null;
            /* best guess about the data type: binary or text */
            this.data_type = 2;
            /* Z_UNKNOWN */
            /* adler32 value of the uncompressed data */
            this.adler = 0;
        }
        var zstream = ZStream;
        // eslint-disable-next-line @typescript-eslint/unbound-method
        var toString = Object.prototype.toString;
        /* Public constants ========================================================== */
        /* =========================================================================== */
        var Z_NO_FLUSH$1 = constants.Z_NO_FLUSH;
        var Z_SYNC_FLUSH = constants.Z_SYNC_FLUSH;
        var Z_FULL_FLUSH$1 = constants.Z_FULL_FLUSH;
        var Z_FINISH$1 = constants.Z_FINISH;
        var Z_OK$1 = constants.Z_OK;
        var Z_STREAM_END$1 = constants.Z_STREAM_END;
        var Z_DEFAULT_COMPRESSION$1 = constants.Z_DEFAULT_COMPRESSION;
        var Z_DEFAULT_STRATEGY$1 = constants.Z_DEFAULT_STRATEGY;
        var Z_DEFLATED$1 = constants.Z_DEFLATED;
        /* =========================================================================== */
        /**
         * class Deflate
         *
         * Generic JS-style wrapper for zlib calls. If you don't need
         * streaming behaviour - use more simple functions: [[deflate]],
         * [[deflateRaw]] and [[gzip]].
         * */
        /* internal
         * Deflate.chunks -> Array
         *
         * Chunks of output data, if [[Deflate#onData]] not overridden.
         * */
        /**
         * Deflate.result -> Uint8Array
         *
         * Compressed result, generated by default [[Deflate#onData]]
         * and [[Deflate#onEnd]] handlers. Filled after you push last chunk
         * (call [[Deflate#push]] with `Z_FINISH` / `true` param).
         * */
        /**
         * Deflate.err -> Number
         *
         * Error code after deflate finished. 0 (Z_OK) on success.
         * You will not need it in real life, because deflate errors
         * are possible only on wrong options or bad `onData` / `onEnd`
         * custom handlers.
         * */
        /**
         * Deflate.msg -> String
         *
         * Error message, if [[Deflate.err]] != 0
         * */
        /**
         * new Deflate(options)
         * - options (Object): zlib deflate options.
         *
         * Creates new deflator instance with specified params. Throws exception
         * on bad params. Supported options:
         *
         * - `level`
         * - `windowBits`
         * - `memLevel`
         * - `strategy`
         * - `dictionary`
         *
         * [http://zlib.net/manual.html#Advanced](http://zlib.net/manual.html#Advanced)
         * for more information on these.
         *
         * Additional options, for internal needs:
         *
         * * `chunkSize` - size of generated data chunks (16K by default)
         * * `raw` (Boolean) - do raw deflate
         * * `gzip` (Boolean) - create gzip wrapper
         * * `header` (Object) - custom header for gzip
         * ** `text` (Boolean) - true if compressed data believed to be text
         * ** `time` (Number) - modification time, unix timestamp
         * ** `os` (Number) - operation system code
         * ** `extra` (Array) - array of bytes with extra data (max 65536)
         * ** `name` (String) - file name (binary string)
         * ** `comment` (String) - comment (binary string)
         * ** `hcrc` (Boolean) - true if header crc should be added
         *
         * ##### Example:
         *
         * ```javascript
         * const pako = require('pako')
         *   , chunk1 = new Uint8Array([1,2,3,4,5,6,7,8,9])
         *   , chunk2 = new Uint8Array([10,11,12,13,14,15,16,17,18,19]);
         *
         * const deflate = new pako.Deflate({ level: 3});
         *
         * deflate.push(chunk1, false);
         * deflate.push(chunk2, true);  // true -> last chunk
         *
         * if (deflate.err) { throw new Error(deflate.err); }
         *
         * console.log(deflate.result);
         * ```
         * */
        function Deflate() {
            this.options = {
                level: Z_DEFAULT_COMPRESSION$1,
                method: Z_DEFLATED$1,
                chunkSize: 16384,
                windowBits: 15,
                memLevel: 8,
                strategy: Z_DEFAULT_STRATEGY$1,
            };
            var opt = this.options;
            if (opt.raw && opt.windowBits > 0) {
                opt.windowBits = -opt.windowBits;
            }
            else if (opt.gzip && opt.windowBits > 0 && opt.windowBits < 16) {
                opt.windowBits += 16;
            }
            this.err = 0; // error code, if happens (0 = Z_OK)
            this.msg = ''; // error message
            this.ended = false; // used to avoid multiple onEnd() calls
            this.chunks = []; // chunks of compressed data
            this.strm = new zstream();
            this.strm.avail_out = 0;
            var status = deflate_1.deflateInit2(this.strm, opt.level, opt.method, opt.windowBits, opt.memLevel, opt.strategy);
            if (status !== Z_OK$1) {
                throw new Error(messages[status]);
            }
            if (opt.header) {
                deflate_1.deflateSetHeader(this.strm, opt.header);
            }
            if (opt.dictionary) {
                var dict; // Convert data if needed
                if (toString.call(opt.dictionary) === '[object ArrayBuffer]') {
                    dict = new Uint8Array(opt.dictionary);
                }
                else {
                    dict = opt.dictionary;
                }
                status = deflate_1.deflateSetDictionary(this.strm, dict);
                if (status !== Z_OK$1) {
                    throw new Error(messages[status]);
                }
                this._dict_set = true;
            }
        }
        /**
         * Deflate#push(data[, flush_mode]) -> Boolean
         * - data (Uint8Array|ArrayBuffer|String): input data. Strings will be
         * converted to utf8 byte sequence.
         * - flush_mode (Number|Boolean): 0..6 for corresponding Z_NO_FLUSH..Z_TREE modes.
         * See constants. Skipped or `false` means Z_NO_FLUSH, `true` means Z_FINISH.
         *
         * Sends input data to deflate pipe, generating [[Deflate#onData]] calls with
         * new compressed chunks. Returns `true` on success. The last data block must
         * have `flush_mode` Z_FINISH (or `true`). That will flush internal pending
         * buffers and call [[Deflate#onEnd]].
         *
         * On fail call [[Deflate#onEnd]] with error code and return false.
         *
         * ##### Example
         *
         * ```javascript
         * push(chunk, false); // push one of data chunks
         * ...
         * push(chunk, true);  // push last chunk
         * ```
         * */
        Deflate.prototype.push = function (data, flush_mode) {
            var strm = this.strm;
            var chunkSize = this.options.chunkSize;
            var status;
            var _flush_mode;
            if (this.ended) {
                return false;
            }
            if (flush_mode === ~~flush_mode) {
                _flush_mode = flush_mode;
            }
            else {
                _flush_mode = flush_mode === true ? Z_FINISH$1 : Z_NO_FLUSH$1;
            } // Convert data if needed
            if (toString.call(data) === '[object ArrayBuffer]') {
                strm.input = new Uint8Array(data);
            }
            else {
                strm.input = data;
            }
            strm.next_in = 0;
            strm.avail_in = strm.input.length;
            for (;;) {
                if (strm.avail_out === 0) {
                    strm.output = new Uint8Array(chunkSize);
                    strm.next_out = 0;
                    strm.avail_out = chunkSize;
                } // Make sure avail_out > 6 to avoid repeating markers
                if ((_flush_mode === Z_SYNC_FLUSH || _flush_mode === Z_FULL_FLUSH$1) && strm.avail_out <= 6) {
                    this.onData(strm.output.subarray(0, strm.next_out));
                    strm.avail_out = 0;
                    continue;
                }
                status = deflate_1.deflate(strm, _flush_mode); // Ended => flush and finish
                if (status === Z_STREAM_END$1) {
                    if (strm.next_out > 0) {
                        this.onData(strm.output.subarray(0, strm.next_out));
                    }
                    status = deflate_1.deflateEnd(this.strm);
                    this.onEnd(status);
                    this.ended = true;
                    return status === Z_OK$1;
                } // Flush if out buffer full
                if (strm.avail_out === 0) {
                    this.onData(strm.output);
                    continue;
                } // Flush if requested and has data
                if (_flush_mode > 0 && strm.next_out > 0) {
                    this.onData(strm.output.subarray(0, strm.next_out));
                    strm.avail_out = 0;
                    continue;
                }
                if (strm.avail_in === 0) {
                    break;
                }
            }
            return true;
        };
        /**
         * Deflate#onData(chunk) -> Void
         * - chunk (Uint8Array): output data.
         *
         * By default, stores data blocks in `chunks[]` property and glue
         * those in `onEnd`. Override this handler, if you need another behaviour.
         * */
        Deflate.prototype.onData = function (chunk) {
            this.chunks.push(chunk);
        };
        /**
         * Deflate#onEnd(status) -> Void
         * - status (Number): deflate status. 0 (Z_OK) on success,
         * other if not.
         *
         * Called once after you tell deflate that the input stream is
         * complete (Z_FINISH). By default - join collected chunks,
         * free memory and fill `results` / `err` properties.
         * */
        Deflate.prototype.onEnd = function (status) {
            // On success - join
            if (status === Z_OK$1) {
                this.result = flattenChunks(this.chunks);
            }
            this.chunks = [];
            this.err = status;
            this.msg = this.strm.msg;
        };
        // https://github.com/nodeca/pako/blob/26dff4fb3472c5532b3bd8856421146d35ab7592/lib/utils/strings.js#L26
        function string2buf(str) {
            if (typeof TextEncoder === 'function' && TextEncoder.prototype.encode) {
                return new TextEncoder().encode(str);
            }
            var buf;
            var c;
            var c2;
            var m_pos;
            var i;
            var str_len = str.length;
            var buf_len = 0;
            // count binary size
            for (m_pos = 0; m_pos < str_len; m_pos++) {
                c = str.charCodeAt(m_pos);
                if ((c & 0xfc00) === 0xd800 && m_pos + 1 < str_len) {
                    c2 = str.charCodeAt(m_pos + 1);
                    if ((c2 & 0xfc00) === 0xdc00) {
                        c = 0x10000 + ((c - 0xd800) << 10) + (c2 - 0xdc00);
                        m_pos++;
                    }
                }
                buf_len += c < 0x80 ? 1 : c < 0x800 ? 2 : c < 0x10000 ? 3 : 4;
            }
            // allocate buffer
            buf = new Uint8Array(buf_len);
            // convert
            for (i = 0, m_pos = 0; i < buf_len; m_pos++) {
                c = str.charCodeAt(m_pos);
                if ((c & 0xfc00) === 0xd800 && m_pos + 1 < str_len) {
                    c2 = str.charCodeAt(m_pos + 1);
                    if ((c2 & 0xfc00) === 0xdc00) {
                        c = 0x10000 + ((c - 0xd800) << 10) + (c2 - 0xdc00);
                        m_pos++;
                    }
                }
                if (c < 0x80) {
                    /* one byte */
                    buf[i++] = c;
                }
                else if (c < 0x800) {
                    /* two bytes */
                    buf[i++] = 0xc0 | (c >>> 6);
                    buf[i++] = 0x80 | (c & 0x3f);
                }
                else if (c < 0x10000) {
                    /* three bytes */
                    buf[i++] = 0xe0 | (c >>> 12);
                    buf[i++] = 0x80 | ((c >>> 6) & 0x3f);
                    buf[i++] = 0x80 | (c & 0x3f);
                }
                else {
                    /* four bytes */
                    buf[i++] = 0xf0 | (c >>> 18);
                    buf[i++] = 0x80 | ((c >>> 12) & 0x3f);
                    buf[i++] = 0x80 | ((c >>> 6) & 0x3f);
                    buf[i++] = 0x80 | (c & 0x3f);
                }
            }
            return buf;
        }
        return { Deflate: Deflate, constants: constants, string2buf: string2buf };
    }
}

var state = { status: 0 /* Nil */ };
function startDeflateWorker(callback, createDeflateWorkerImpl) {
    if (createDeflateWorkerImpl === void 0) { createDeflateWorkerImpl = createDeflateWorker; }
    switch (state.status) {
        case 0 /* Nil */:
            state = { status: 1 /* Loading */, callbacks: [callback] };
            doStartDeflateWorker(createDeflateWorkerImpl);
            break;
        case 1 /* Loading */:
            state.callbacks.push(callback);
            break;
        case 2 /* Error */:
            callback();
            break;
        case 3 /* Initialized */:
            callback(state.worker);
            break;
    }
}
/**
 * Starts the deflate worker and handle messages and errors
 *
 * The spec allow browsers to handle worker errors differently:
 * - Chromium throws an exception
 * - Firefox fires an error event
 *
 * more details: https://bugzilla.mozilla.org/show_bug.cgi?id=1736865#c2
 */
function doStartDeflateWorker(createDeflateWorkerImpl) {
    if (createDeflateWorkerImpl === void 0) { createDeflateWorkerImpl = createDeflateWorker; }
    try {
        var worker_1 = createDeflateWorkerImpl();
        worker_1.addEventListener('error', monitor(onError));
        worker_1.addEventListener('message', monitor(function (_a) {
            var data = _a.data;
            if (data.type === 'errored') {
                onError(data.error);
            }
            else if (data.type === 'initialized') {
                onInitialized(worker_1);
            }
        }));
        worker_1.postMessage({ action: 'init' });
        return worker_1;
    }
    catch (error) {
        onError(error);
    }
}
function onInitialized(worker) {
    if (state.status === 1 /* Loading */) {
        state.callbacks.forEach(function (callback) { return callback(worker); });
        state = { status: 3 /* Initialized */, worker: worker };
    }
}
function onError(error) {
    if (state.status === 1 /* Loading */) {
        display.error('Session Replay recording failed to start: an error occurred while creating the Worker:', error);
        if (error instanceof Event || (error instanceof Error && includes(error.message, 'Content Security Policy'))) {
            display.error('Please make sure CSP is correctly configured ' +
                'https://docs.datadoghq.com/real_user_monitoring/faq/content_security_policy');
        }
        else {
            addMonitoringError(error);
        }
        state.callbacks.forEach(function (callback) { return callback(); });
        state = { status: 2 /* Error */ };
    }
    else {
        addMonitoringError(error);
    }
}

function startRecording(lifeCycle, configuration, sessionManager, parentContexts, worker) {
    var _a = startSegmentCollection(lifeCycle, configuration.applicationId, sessionManager, parentContexts, function (data, metadata, rawSegmentSize, flushReason) {
        return send(configuration.sessionReplayEndpointBuilder, data, metadata, rawSegmentSize, flushReason);
    }, worker), addRecord = _a.addRecord, stopSegmentCollection = _a.stop;
    function addRawRecord(rawRecord) {
        addRecord(assign({ timestamp: Date.now() }, rawRecord));
    }
    var _b = record({
        emit: addRawRecord,
        defaultPrivacyLevel: configuration.defaultPrivacyLevel,
    }), stopRecording = _b.stop, takeFullSnapshot = _b.takeFullSnapshot, flushMutations = _b.flushMutations;
    var unsubscribeViewEnded = lifeCycle.subscribe(6 /* VIEW_ENDED */, function () {
        flushMutations();
        addRawRecord({
            type: RecordType.ViewEnd,
        });
    }).unsubscribe;
    var unsubscribeViewCreated = lifeCycle.subscribe(4 /* VIEW_CREATED */, takeFullSnapshot).unsubscribe;
    return {
        stop: function () {
            unsubscribeViewEnded();
            unsubscribeViewCreated();
            stopRecording();
            stopSegmentCollection();
        },
    };
}

function makeRecorderApi(startRecordingImpl, startDeflateWorkerImpl) {
    if (startDeflateWorkerImpl === void 0) { startDeflateWorkerImpl = startDeflateWorker; }
    if (canUseEventBridge()) {
        return {
            start: noop,
            stop: noop,
            getReplayStats: function () { return undefined; },
            onRumStart: noop,
            isRecording: function () { return false; },
        };
    }
    var state = {
        status: 0 /* Stopped */,
    };
    var startStrategy = function () {
        state = { status: 1 /* IntentToStart */ };
    };
    var stopStrategy = function () {
        state = { status: 0 /* Stopped */ };
    };
    return {
        start: function () { return startStrategy(); },
        stop: function () { return stopStrategy(); },
        getReplayStats: getReplayStats,
        onRumStart: function (lifeCycle, configuration, sessionManager, parentContexts) {
            lifeCycle.subscribe(9 /* SESSION_EXPIRED */, function () {
                if (state.status === 2 /* Starting */ || state.status === 3 /* Started */) {
                    stopStrategy();
                    state = { status: 1 /* IntentToStart */ };
                }
            });
            lifeCycle.subscribe(10 /* SESSION_RENEWED */, function () {
                if (state.status === 1 /* IntentToStart */) {
                    startStrategy();
                }
            });
            startStrategy = function () {
                var session = sessionManager.findTrackedSession();
                if (!session || !session.hasReplayPlan) {
                    state = { status: 1 /* IntentToStart */ };
                    return;
                }
                if (state.status === 2 /* Starting */ || state.status === 3 /* Started */) {
                    return;
                }
                state = { status: 2 /* Starting */ };
                runOnReadyState('interactive', function () {
                    if (state.status !== 2 /* Starting */) {
                        return;
                    }
                    startDeflateWorkerImpl(function (worker) {
                        if (state.status !== 2 /* Starting */) {
                            return;
                        }
                        if (!worker) {
                            state = {
                                status: 0 /* Stopped */,
                            };
                            return;
                        }
                        var stopRecording = startRecordingImpl(lifeCycle, configuration, sessionManager, parentContexts, worker).stop;
                        state = {
                            status: 3 /* Started */,
                            stopRecording: stopRecording,
                        };
                    });
                });
            };
            stopStrategy = function () {
                if (state.status === 0 /* Stopped */) {
                    return;
                }
                if (state.status === 3 /* Started */) {
                    state.stopRecording();
                }
                state = {
                    status: 0 /* Stopped */,
                };
            };
            if (state.status === 1 /* IntentToStart */) {
                startStrategy();
            }
        },
        isRecording: function () { return state.status === 3 /* Started */; },
    };
}

// Keep the following in sync with packages/rum-slim/src/entries/main.ts
var recorderApi = makeRecorderApi(startRecording);
var datadogRum = makeRumPublicApi(startRum, recorderApi);
defineGlobal(getGlobalObject(), 'DD_RUM', datadogRum);

function ownKeys$2(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$2(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$2(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$2(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var initView = function initView(props, componentParams) {
  var match = props.match;

  try {
    var _datadogRum$getInitCo, _datadogRum$getIntern, _datadogRum$getIntern2;

    var manualTracking = datadogRum === null || datadogRum === void 0 ? void 0 : (_datadogRum$getInitCo = datadogRum.getInitConfiguration()) === null || _datadogRum$getInitCo === void 0 ? void 0 : _datadogRum$getInitCo.trackViewsManually;
    var matchStr = componentParams.useHashForViewName ? window.location.hash : match === null || match === void 0 ? void 0 : match.path;
    var viewName = matchStr ? "".concat(window.location.pathname, "/").concat(componentParams.useHashForViewName ? '' : '#/').concat(matchStr).split('').reduce(function (chars, currentChar) {
      if (chars[chars.length - 1] === '/' && currentChar === '/') {
        return chars;
      }

      return [].concat(_toConsumableArray(chars), [currentChar]);
    }, []).join('') : window.location.pathname;
    var oldView = datadogRum === null || datadogRum === void 0 ? void 0 : (_datadogRum$getIntern = datadogRum.getInternalContext()) === null || _datadogRum$getIntern === void 0 ? void 0 : (_datadogRum$getIntern2 = _datadogRum$getIntern.view) === null || _datadogRum$getIntern2 === void 0 ? void 0 : _datadogRum$getIntern2.name;
    var isNewView = oldView !== viewName;
    var generateNewView = componentParams.newView ? componentParams.newView(oldView, viewName, match) : isNewView;

    if (manualTracking && generateNewView) {
      datadogRum.startView(typeof generateNewView === 'string' ? generateNewView : viewName);
    }
  } catch (err) {}
};

var getDataDogRumRoute = function getDataDogRumRoute(componentParams) {
  return function (props) {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    useRef(function () {
      initView(props, componentParams);
    }());

    if (componentParams.children) {
      return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, componentParams.children);
    } else if (componentParams.component) {
      var Component = componentParams.component;
      return /*#__PURE__*/React__default.createElement(Component, props);
    }

    return null;
  };
};

var DataDogRumRoute = function DataDogRumRoute(props) {
  var children = props.children,
      component = props.component,
      _render = props.render;
  var withRum = useMemo(function () {
    if (_render && !children && !component) {
      return {
        render: function render(renderProps) {
          initView(renderProps, props);
          return _render(renderProps);
        }
      };
    }

    return {
      component: getDataDogRumRoute(props)
    }; // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [children, component, _render]);
  return /*#__PURE__*/React__default.createElement(Route, _extends({}, props, withRum));
};
DataDogRumRoute.propTypes = _objectSpread$2(_objectSpread$2({}, Route.propTypes), {}, {
  useHashForViewName: PropTypes.bool,
  newView: PropTypes.func
});

function _createSuper$3(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$3(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct$3() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var IQMRouter = /*#__PURE__*/function (_Component) {
  _inherits(IQMRouter, _Component);

  var _super = _createSuper$3(IQMRouter);

  function IQMRouter(props) {
    var _this;

    _classCallCheck(this, IQMRouter);

    _this = _super.call(this, props);
    _this.state = {
      autoLogin: process.env.REACT_APP_AUTO_LOGIN === 'true',
      // this is to make sure we dont get redirected to /#/login screen and we defer rendering until we login or detect if there is a login token.
      autoLoginInProcess: process.env.REACT_APP_AUTO_LOGIN === 'true'
    };
    return _this;
  }

  _createClass(IQMRouter, [{
    key: "componentDidMount",
    value: function () {
      var _componentDidMount = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee() {
        var _this2 = this;

        var _JSON$parse, apiToken, _process$env$REACT_AP;

        return regenerator.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!this.state.autoLogin) {
                  _context.next = 16;
                  break;
                }

                _context.prev = 1;
                apiToken = (_JSON$parse = JSON.parse(window.localStorage.getItem('authorizedUser'))) === null || _JSON$parse === void 0 ? void 0 : _JSON$parse.apiToken;

                if (apiToken) {
                  _context.next = 6;
                  break;
                }

                _context.next = 6;
                return AuthService.autoLogin(process.env.REACT_APP_EMAIL, process.env.REACT_APP_PASSWORD, (_process$env$REACT_AP = process.env.REACT_APP_OWID) !== null && _process$env$REACT_AP !== void 0 ? _process$env$REACT_AP : '');

              case 6:
                _context.next = 11;
                break;

              case 8:
                _context.prev = 8;
                _context.t0 = _context["catch"](1);
                console.log('error logging in the user', _context.t0);

              case 11:
                _context.prev = 11;
                this.setState({
                  autoLoginInProcess: false
                });
                return _context.finish(11);

              case 14:
                _context.next = 17;
                break;

              case 16:
                this.setState({
                  autoLoginInProcess: false
                });

              case 17:
                window.onstorage = function () {
                  var _JSON$parse2;

                  var apiToken = (_JSON$parse2 = JSON.parse(window.localStorage.getItem('authorizedUser'))) === null || _JSON$parse2 === void 0 ? void 0 : _JSON$parse2.apiToken;

                  if (!apiToken) {
                    console.log('No apiToken in LocalStorage');

                    _this2.props.onLogout();

                    window.location.href = '/#/login';
                  }
                };

              case 18:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[1, 8, 11, 14]]);
      }));

      function componentDidMount() {
        return _componentDidMount.apply(this, arguments);
      }

      return componentDidMount;
    }()
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          onLogout = _this$props.onLogout,
          documentTitle = _this$props.documentTitle,
          onSuccessLogin = _this$props.onSuccessLogin,
          transformSuccessRedirectPath = _this$props.transformSuccessRedirectPath,
          successLoginRedirectPath = _this$props.successLoginRedirectPath,
          children = _this$props.children,
          publicRoutes = _this$props.publicRoutes,
          loginForm = _this$props.loginForm;
      var autoLoginInProcess = this.state.autoLoginInProcess;
      return autoLoginInProcess ? /*#__PURE__*/React__default.createElement("span", null, "'Auto Login in Process....'") : /*#__PURE__*/React__default.createElement(HashRouter, {
        basename: "/"
      }, /*#__PURE__*/React__default.createElement(Switch, null, /*#__PURE__*/React__default.createElement(DataDogRumRoute, {
        path: "/login",
        component: function component(props) {
          return /*#__PURE__*/React__default.createElement(LoginFormContainer, _extends({}, props, {
            onLogout: onLogout,
            documentTitle: documentTitle,
            onSuccessLogin: onSuccessLogin,
            transformSuccessRedirectPath: transformSuccessRedirectPath,
            successLoginRedirectPath: successLoginRedirectPath,
            loginForm: loginForm
          }));
        }
      }), publicRoutes ? publicRoutes(this.props) : null, /*#__PURE__*/React__default.createElement(PrivateRoutesContainer$1, {
        onSuccessLogin: onSuccessLogin,
        successLoginRedirectPath: successLoginRedirectPath,
        onLogout: onLogout
      }, children), /*#__PURE__*/React__default.createElement(Redirect, {
        to: successLoginRedirectPath
      })));
    }
  }]);

  return IQMRouter;
}(Component);

IQMRouter.propTypes = {
  documentTitle: PropTypes.string,
  successLoginRedirectPath: PropTypes.string,
  transformSuccessRedirectPath: PropTypes.func,
  onSuccessLogin: PropTypes.func,
  onLogout: PropTypes.func,
  publicRoutes: PropTypes.func,
  loginForm: PropTypes.elementType
};

var arrayWithHoles = createCommonjsModule(function (module) {
function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

module.exports = _arrayWithHoles, module.exports.__esModule = true, module.exports["default"] = module.exports;
});

unwrapExports(arrayWithHoles);

var iterableToArrayLimit = createCommonjsModule(function (module) {
function _iterableToArrayLimit(arr, i) {
  var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];

  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;

  var _s, _e;

  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

module.exports = _iterableToArrayLimit, module.exports.__esModule = true, module.exports["default"] = module.exports;
});

unwrapExports(iterableToArrayLimit);

var nonIterableRest = createCommonjsModule(function (module) {
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

module.exports = _nonIterableRest, module.exports.__esModule = true, module.exports["default"] = module.exports;
});

unwrapExports(nonIterableRest);

var slicedToArray = createCommonjsModule(function (module) {
function _slicedToArray(arr, i) {
  return arrayWithHoles(arr) || iterableToArrayLimit(arr, i) || unsupportedIterableToArray(arr, i) || nonIterableRest();
}

module.exports = _slicedToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;
});

var _slicedToArray = unwrapExports(slicedToArray);

var ICON_NAME_MAPPING = {
  Reports: 'Report Builder',
  Campaigns: 'Campaign Builder',
  Creatives: 'Creative Builder',
  Audiences: 'Audience Builder',
  Organizations: 'Organization'
};

var NavMenuList = function NavMenuList(props) {
  var list = props.list,
      toggleMenu = props.toggleMenu;
  return /*#__PURE__*/React__default.createElement("ul", {
    className: "nav-menu__list"
  }, list.map(function (app, i) {
    return /*#__PURE__*/React__default.createElement("li", {
      className: "nav-menu__item",
      key: i,
      title: app.appName
    }, /*#__PURE__*/React__default.createElement("a", {
      href: "".concat(app.appUrl, "/u/").concat(getPathNumber(), "/"),
      className: "nav-menu__link",
      onClick: toggleMenu
    }, /*#__PURE__*/React__default.createElement("span", {
      className: "nav-menu__image"
    }, /*#__PURE__*/React__default.createElement(Icon, {
      name: ICON_NAME_MAPPING[app.appName] || app.appName
    })), /*#__PURE__*/React__default.createElement("span", {
      className: "nav-menu__title"
    }, app.appName)));
  }));
};

NavMenuList.propTypes = {
  list: PropTypes.array,
  toggleMenu: PropTypes.func
};

function _createSuper$4(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$4(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct$4() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var NavMenu = /*#__PURE__*/function (_Component) {
  _inherits(NavMenu, _Component);

  var _super = _createSuper$4(NavMenu);

  function NavMenu() {
    var _this;

    _classCallCheck(this, NavMenu);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    _this.state = {
      apps: []
    };
    return _this;
  }

  _createClass(NavMenu, [{
    key: "componentDidMount",
    value: function () {
      var _componentDidMount = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee() {
        var apps, currentURL, shouldRestrictUser;
        return regenerator.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return AuthService.getUserApps();

              case 3:
                apps = _context.sent;
                currentURL = window.location.href.split("/");
                shouldRestrictUser = true;
                apps.forEach(function (element) {
                  var allowedApp = element.appUrl.slice(1, element.appUrl.length);

                  if (currentURL.includes(allowedApp)) {
                    shouldRestrictUser = false;
                  }
                });

                if (shouldRestrictUser && !currentURL.includes("marketplace") && !window.location.origin.includes("localhost")) {
                  window.location.href = "".concat(ORIGIN_URL, "/#/404");
                }

                this.setState({
                  apps: apps || []
                });
                _context.next = 14;
                break;

              case 11:
                _context.prev = 11;
                _context.t0 = _context["catch"](0);
                console.error(_context.t0);

              case 14:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[0, 11]]);
      }));

      function componentDidMount() {
        return _componentDidMount.apply(this, arguments);
      }

      return componentDidMount;
    }()
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          className = _this$props.className,
          toggleMenu = _this$props.toggleMenu;
      return /*#__PURE__*/React__default.createElement("div", {
        className: "nav-menu ".concat(className || '')
      }, /*#__PURE__*/React__default.createElement(NavMenuList, {
        list: this.state.apps,
        toggleMenu: toggleMenu
      }));
    }
  }]);

  return NavMenu;
}(Component);

NavMenu.propTypes = {
  className: PropTypes.string,
  toggleMenu: PropTypes.func
};
var NavMenu$1 = withRouter(NavMenu);

function styleInject(css, ref) {
  if ( ref === void 0 ) ref = {};
  var insertAt = ref.insertAt;

  if (!css || typeof document === 'undefined') { return; }

  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';

  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}

var css_248z = ":root {\n  --primary1: #123787;\n  --primary2: #1d58d7;\n  --primary3: #5173fb;\n  --primary4: #7a93ff;\n  --primary5: #c2d0ff;\n  --primary6: #e5ebff;\n  --primary7: #f2f5ff; }\n\n@keyframes styles-module_hover-ripples__1ZM1n {\n  0% {\n    top: -0.1875em;\n    left: -0.1875em;\n    right: -0.1875em;\n    bottom: -0.1875em;\n    opacity: 1; }\n  100% {\n    top: -0.8125em;\n    left: -0.8125em;\n    right: -0.8125em;\n    bottom: -0.8125em;\n    opacity: 0; } }\n\n.styles-module_BtnWrapper__WJiWu {\n  position: relative; }\n  .styles-module_BtnWrapper__WJiWu svg {\n    fill: none !important; }\n  .styles-module_BtnWrapper__WJiWu .styles-module_chatIcon__1ZAcI {\n    width: 1.5rem;\n    height: 1.5rem; }\n  .styles-module_BtnWrapper__WJiWu .styles-module_count__1XuzQ {\n    font-family: 'Avenir Next Demi', sans-serif;\n    font-weight: normal;\n    position: absolute;\n    top: -0.25rem;\n    right: -0.125rem;\n    border-radius: 0.25rem;\n    background-color: #ffbb43;\n    font-size: 12px;\n    padding: 0 0.25rem; }\n";
var styles = {"BtnWrapper":"styles-module_BtnWrapper__WJiWu","chatIcon":"styles-module_chatIcon__1ZAcI","count":"styles-module_count__1XuzQ","hover-ripples":"styles-module_hover-ripples__1ZM1n"};
styleInject(css_248z);

var NavbarContent = function NavbarContent(props) {
  var _window$Intercom, _window, _window$Intercom2, _window2;

  var children = props.children,
      helpLink = props.helpLink;

  var _useState = useState$2(false),
      _useState2 = _slicedToArray(_useState, 2),
      open = _useState2[0],
      setOpen = _useState2[1];

  var _useState3 = useState$2(false),
      _useState4 = _slicedToArray(_useState3, 2),
      isIntercomOpen = _useState4[0],
      setIsIntercomOpen = _useState4[1];

  var _useState5 = useState$2({}),
      _useState6 = _slicedToArray(_useState5, 2),
      conversations = _useState6[0],
      setConversations = _useState6[1];

  var _useState7 = useState$2(null),
      _useState8 = _slicedToArray(_useState7, 2),
      intercomId = _useState8[0],
      setIntercomId = _useState8[1];

  var navMenuWrapper = useRef();

  var findParentWithId = function findParentWithId(elem, idToFound) {
    if (!elem) {
      throw new Error('Could not find element with that selector');
    }

    var parent = elem.parentElement;

    while (parent) {
      var id = parent.id;

      if (id === idToFound) {
        return true;
      }

      parent = parent.parentElement;
    }

    return false;
  };

  useEffect( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee() {
    var _data$data, data, id;

    return regenerator.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            _context.next = 3;
            return ApiService.getIntercomId();

          case 3:
            data = _context.sent;
            id = data === null || data === void 0 ? void 0 : (_data$data = data.data) === null || _data$data === void 0 ? void 0 : _data$data.chatbotAppId;
            setIntercomId(id);
            _context.next = 11;
            break;

          case 8:
            _context.prev = 8;
            _context.t0 = _context["catch"](0);
            console.log('intercom:', _context.t0);

          case 11:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[0, 8]]);
  })), []);
  useEffect(function () {
    var setConv = function setConv() {
      if (intercomId) {
        var _JSON$parse;

        setConversations((_JSON$parse = JSON.parse(localStorage.getItem("intercom.intercom-state-".concat(intercomId)))) === null || _JSON$parse === void 0 ? void 0 : _JSON$parse.conversations);
      }
    };

    window.addEventListener('storage', setConv);
    return function () {
      return window.removeEventListener('storage', setConv);
    };
  }, [intercomId]);
  var unreadMessageCount = useMemo(function () {
    if (!!(conversations !== null && conversations !== void 0 && conversations.byId)) {
      var count = Object.values(conversations.byId).filter(function (con) {
        return !con.read;
      }).length;
      return count;
    }

    return 0;
  }, [conversations]);
  (_window$Intercom = (_window = window).Intercom) === null || _window$Intercom === void 0 ? void 0 : _window$Intercom.call(_window, 'onShow', function () {
    setIsIntercomOpen(true);
  });
  (_window$Intercom2 = (_window2 = window).Intercom) === null || _window$Intercom2 === void 0 ? void 0 : _window$Intercom2.call(_window2, 'onHide', function () {
    setIsIntercomOpen(false);
  });

  var handleChatIconClickOut = function handleChatIconClickOut() {
    var _window$Intercom3, _window3;

    (_window$Intercom3 = (_window3 = window).Intercom) === null || _window$Intercom3 === void 0 ? void 0 : _window$Intercom3.call(_window3, 'hide');
  };

  var handleChatIconClick = function handleChatIconClick() {
    if (isIntercomOpen) {
      handleChatIconClickOut();
    } else {
      var _window$Intercom4, _window4;

      (_window$Intercom4 = (_window4 = window).Intercom) === null || _window$Intercom4 === void 0 ? void 0 : _window$Intercom4.call(_window4, 'show');
    }
  };

  var togglePopup = useCallback(function () {
    setOpen(function (open) {
      return !open;
    });
  }, []);
  var handleClickOutside = useCallback(function (e) {
    if (navMenuWrapper.current && (!navMenuWrapper.current.contains(e.target) || navMenuWrapper.current.isSameNode(e.target)) && open) {
      togglePopup();
    }

    if (!findParentWithId(e.target, 'intercomChatBtn')) {
      handleChatIconClickOut();
    }
  }, [open, togglePopup]);
  useEffect(function () {
    document.addEventListener('click', handleClickOutside);
    return function () {
      document.removeEventListener('click', handleClickOutside);
    };
  }, [handleClickOutside]);
  return /*#__PURE__*/React__default.createElement("div", {
    className: "nav-bar__wrapper"
  }, children, /*#__PURE__*/React__default.createElement("div", {
    className: "nav-bar__wrapper-right"
  }, !!intercomId && /*#__PURE__*/React__default.createElement("div", {
    id: "intercomChatBtn"
  }, /*#__PURE__*/React__default.createElement(Tooltip, {
    label: "Chat",
    position: "bottom",
    auto: false
  }, /*#__PURE__*/React__default.createElement("div", {
    className: styles.BtnWrapper
  }, /*#__PURE__*/React__default.createElement(ButtonCircle, {
    iconName: "MessageDots",
    onClick: handleChatIconClick
  }), !!unreadMessageCount && /*#__PURE__*/React__default.createElement("span", {
    className: styles.count
  }, unreadMessageCount)))), helpLink.length > 0 && /*#__PURE__*/React__default.createElement(Tooltip, {
    label: "Support",
    position: "bottom",
    auto: false
  }, /*#__PURE__*/React__default.createElement("a", {
    href: "https://help.iqm.com",
    rel: "noopener noreferrer",
    target: "_blank"
  }, /*#__PURE__*/React__default.createElement(ButtonCircle, {
    iconName: "HelpCircle",
    className: "nav-bar__link-icon"
  }))), /*#__PURE__*/React__default.createElement(Tooltip, {
    label: "Home",
    position: "bottom",
    auto: false
  }, /*#__PURE__*/React__default.createElement("a", {
    href: "/marketplace/u/".concat(getPathNumber(), "/")
  }, /*#__PURE__*/React__default.createElement(ButtonCircle, {
    iconName: "Home",
    className: "nav-bar__link-icon"
  }))), /*#__PURE__*/React__default.createElement("div", {
    className: "nav-menu-wrapper ".concat(children ? '' : '_ml', " ").concat(open ? '_is-open' : ''),
    ref: navMenuWrapper
  }, /*#__PURE__*/React__default.createElement(Tooltip, {
    label: "All your Apps",
    position: "bottom",
    auto: false
  }, /*#__PURE__*/React__default.createElement(ButtonCircle, {
    className: "nav-menu-btn",
    iconName: "Apps",
    onClick: togglePopup
  })), /*#__PURE__*/React__default.createElement(NavMenu$1, {
    key: "nav-menu",
    className: "".concat(open ? '' : '_hidden'),
    toggleMenu: togglePopup
  }))));
};

NavbarContent.propTypes = {
  children: PropTypes.node,
  helpLink: PropTypes.string
};

var isCurrentOrg = function isCurrentOrg(org) {
  return getOwId() === String(org.owId);
};

var prepareURL = function prepareURL(org, appToRedirect, currentApp) {
  var shouldCheckCurrentOrg = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;

  if (isCurrentOrg(org) && shouldCheckCurrentOrg) {
    return window.location.href;
  }

  if (ORIGIN_URL.includes(org.workspaceDomain)) {
    var currentPathNumber = getPathNumber();
    var savedOwIds = JSON.parse(localStorage.getItem('owIds')) || [];
    var index = savedOwIds.indexOf(org.owId);

    if (index !== -1) {
      var newURL = window.location.href.replace(new RegExp("/u/".concat(currentPathNumber)), "/u/".concat(index));
      return appToRedirect ? newURL.replace(currentApp, appToRedirect) : newURL;
    } else {
      var newList = [].concat(_toConsumableArray(savedOwIds), [org.owId]);
      localStorage.setItem('owIds', JSON.stringify(newList));

      var _newURL = window.location.href.replace(new RegExp("/u/".concat(currentPathNumber)), "/u/".concat(newList.length - 1));

      return appToRedirect ? _newURL.replace(currentApp, appToRedirect) : _newURL;
    }
  }

  var apiToken = JSON.parse(localStorage.getItem('authorizedUser')).apiToken;
  return "https://".concat(org.workspaceDomain, "/#/login?owner=").concat(btoa(window.location.origin), "&ow=").concat(org.owId, "&apiToken=").concat(btoa(apiToken));
};

var getAccountType = function getAccountType(data) {
  var _localStorage$getItem;

  var user = data || JSON.parse((_localStorage$getItem = localStorage.getItem('authorizedUser')) !== null && _localStorage$getItem !== void 0 ? _localStorage$getItem : '{}');

  if (user.isPlatformOwnerOrg) {
    return 'PlatformOwnerOrg'; // for super account
  }

  if (user.isWorkspaceOwnerOrg && !user.isPlatformOwnerOrg) {
    return 'WorkspaceOwnerOrg';
  }

  return 'Advertiser';
};
var bootIntercomFn = function bootIntercomFn(INTERCOM_APP_ID) {
  var APP_ID = INTERCOM_APP_ID;

  (function () {
    var w = window;
    var ic = w.Intercom;

    if (typeof ic === 'function') {
      ic('reattach_activator');
      ic('update', w.intercomSettings);
    } else {
      var d = document;

      var i = function i() {
        i.c(arguments);
      };

      i.q = [];

      i.c = function (args) {
        i.q.push(args);
      };

      w.Intercom = i;

      var l = function l() {
        var s = d.createElement('script');
        s.type = 'text/javascript';
        s.async = true;
        s.src = 'https://widget.intercom.io/widget/' + APP_ID;
        var x = d.getElementsByTagName('script')[0];
        x.parentNode.insertBefore(s, x);
      };

      if (document.readyState === 'complete') {
        l();
      } else if (w.attachEvent) {
        w.attachEvent('onload', l);
      } else {
        w.addEventListener('load', l, false);
      }
    }
  })();
};

var css_248z$1 = ":root {\n  --primary1: #123787;\n  --primary2: #1d58d7;\n  --primary3: #5173fb;\n  --primary4: #7a93ff;\n  --primary5: #c2d0ff;\n  --primary6: #e5ebff;\n  --primary7: #f2f5ff; }\n\n@keyframes styles-module_hover-ripples__1gR4P {\n  0% {\n    top: -0.1875em;\n    left: -0.1875em;\n    right: -0.1875em;\n    bottom: -0.1875em;\n    opacity: 1; }\n  100% {\n    top: -0.8125em;\n    left: -0.8125em;\n    right: -0.8125em;\n    bottom: -0.8125em;\n    opacity: 0; } }\n\n.styles-module_superUserContainer__2qmJT {\n  position: fixed;\n  display: flex;\n  background-color: #000000;\n  z-index: 50;\n  left: 0;\n  top: 0;\n  right: 0;\n  height: 2.5rem;\n  width: 100%;\n  align-items: center; }\n  .styles-module_superUserContainer__2qmJT .styles-module_pill__1Fbnb {\n    font-family: 'Avenir Next Demi', sans-serif;\n    font-weight: normal;\n    margin-left: 1rem;\n    font-size: 0.875rem;\n    line-height: 1;\n    letter-spacing: 0.0125rem;\n    width: 3.75rem;\n    color: #000000;\n    background-color: #e7e7e7;\n    height: 1.5rem;\n    border-radius: 0.25rem; }\n  .styles-module_superUserContainer__2qmJT .styles-module_userInfo__2daA7 {\n    color: #f4f4f4;\n    margin-left: 0.75rem;\n    font-family: 'Avenir Next Regular', sans-serif;\n    font-weight: normal;\n    font-weight: 400;\n    font-size: 0.875rem;\n    line-height: 1;\n    display: contents; }\n    .styles-module_superUserContainer__2qmJT .styles-module_userInfo__2daA7 .styles-module_highlight__y6e-S {\n      color: #f4f4f4;\n      font-family: 'Avenir Next Demi', sans-serif;\n      font-weight: normal;\n      letter-spacing: .2px;\n      font-weight: 600;\n      font-size: 0.875rem;\n      line-height: 1;\n      margin: 0 0.25rem; }\n      .styles-module_superUserContainer__2qmJT .styles-module_userInfo__2daA7 .styles-module_highlight__y6e-S .styles-module_link__3OFWN {\n        color: #f4f4f4;\n        font-family: 'Avenir Next Demi', sans-serif;\n        font-weight: normal;\n        letter-spacing: .2px;\n        font-weight: 600;\n        font-size: 0.875rem;\n        line-height: 1;\n        text-decoration: underline;\n        cursor: pointer; }\n      .styles-module_superUserContainer__2qmJT .styles-module_userInfo__2daA7 .styles-module_highlight__y6e-S .styles-module_disabledLink__1wVlx {\n        color: #f4f4f4;\n        font-family: 'Avenir Next Demi', sans-serif;\n        font-weight: normal;\n        letter-spacing: .2px;\n        font-weight: 600;\n        font-size: 0.875rem;\n        line-height: 1;\n        cursor: default;\n        pointer-events: none;\n        text-decoration: none; }\n  .styles-module_superUserContainer__2qmJT .styles-module_closeButton__30Bbg {\n    height: 0.625rem;\n    width: 0.625rem; }\n    .styles-module_superUserContainer__2qmJT .styles-module_closeButton__30Bbg.btn-v2 {\n      position: absolute;\n      right: 0.5rem;\n      border: none;\n      background-color: #000000; }\n      .styles-module_superUserContainer__2qmJT .styles-module_closeButton__30Bbg.btn-v2:hover {\n        background-color: #000000; }\n    .styles-module_superUserContainer__2qmJT .styles-module_closeButton__30Bbg .svg-icon {\n      fill: #f4f4f4; }\n\n.styles-module_workspaceUserContainer__xhGNR {\n  position: fixed;\n  display: flex;\n  background-color: #123787;\n  z-index: 50;\n  left: 0;\n  top: 0;\n  right: 0;\n  height: 2.5rem;\n  width: 100%;\n  align-items: center; }\n  .styles-module_workspaceUserContainer__xhGNR .styles-module_pill__1Fbnb {\n    font-family: 'Avenir Next Demi', sans-serif;\n    font-weight: normal;\n    margin-left: 1rem;\n    font-size: 0.875rem;\n    line-height: 1;\n    letter-spacing: 0.0125rem;\n    width: 3.75rem;\n    color: #000000;\n    background-color: #c2d0ff;\n    height: 1.5rem;\n    border-radius: 0.25rem; }\n  .styles-module_workspaceUserContainer__xhGNR .styles-module_userInfo__2daA7 {\n    color: #f4f4f4;\n    margin-left: 0.75rem;\n    font-family: 'Avenir Next Regular', sans-serif;\n    font-weight: normal;\n    font-weight: 400;\n    font-size: 0.875rem;\n    line-height: 1;\n    display: contents; }\n    .styles-module_workspaceUserContainer__xhGNR .styles-module_userInfo__2daA7 .styles-module_highlight__y6e-S {\n      color: #f4f4f4;\n      font-family: 'Avenir Next Demi', sans-serif;\n      font-weight: normal;\n      letter-spacing: .2px;\n      font-weight: 600;\n      font-size: 0.875rem;\n      line-height: 1;\n      margin: 0 0.25rem; }\n      .styles-module_workspaceUserContainer__xhGNR .styles-module_userInfo__2daA7 .styles-module_highlight__y6e-S .styles-module_link__3OFWN {\n        color: #f4f4f4;\n        font-family: 'Avenir Next Demi', sans-serif;\n        font-weight: normal;\n        letter-spacing: .2px;\n        font-weight: 600;\n        font-size: 0.875rem;\n        line-height: 1;\n        text-decoration: underline;\n        cursor: pointer; }\n      .styles-module_workspaceUserContainer__xhGNR .styles-module_userInfo__2daA7 .styles-module_highlight__y6e-S .styles-module_disabledLink__1wVlx {\n        color: #f4f4f4;\n        font-family: 'Avenir Next Demi', sans-serif;\n        font-weight: normal;\n        letter-spacing: .2px;\n        font-weight: 600;\n        font-size: 0.875rem;\n        line-height: 1;\n        cursor: default;\n        pointer-events: none;\n        text-decoration: none; }\n  .styles-module_workspaceUserContainer__xhGNR .styles-module_closeButton__30Bbg {\n    height: 0.625rem;\n    width: 0.625rem; }\n    .styles-module_workspaceUserContainer__xhGNR .styles-module_closeButton__30Bbg.btn-v2 {\n      position: absolute;\n      right: 0.5rem;\n      border: none;\n      background-color: #123787; }\n      .styles-module_workspaceUserContainer__xhGNR .styles-module_closeButton__30Bbg.btn-v2:hover {\n        background-color: #123787; }\n    .styles-module_workspaceUserContainer__xhGNR .styles-module_closeButton__30Bbg .svg-icon {\n      fill: #f4f4f4; }\n\n.styles-module_advertiserUserContainer__1Yuqx {\n  position: fixed;\n  display: flex;\n  background-color: #f4f4f4;\n  z-index: 50;\n  left: 0;\n  top: 0;\n  right: 0;\n  height: 2.5rem;\n  width: 100%;\n  align-items: center; }\n  .styles-module_advertiserUserContainer__1Yuqx .styles-module_pill__1Fbnb {\n    font-family: 'Avenir Next Demi', sans-serif;\n    font-weight: normal;\n    margin-left: 1rem;\n    font-size: 0.875rem;\n    line-height: 1;\n    letter-spacing: 0.0125rem;\n    width: 3.75rem;\n    color: #000000;\n    background-color: #e7e7e7;\n    height: 1.5rem;\n    border-radius: 0.25rem; }\n  .styles-module_advertiserUserContainer__1Yuqx .styles-module_userInfo__2daA7 {\n    color: #000000;\n    margin-left: 0.75rem;\n    font-family: 'Avenir Next Regular', sans-serif;\n    font-weight: normal;\n    font-weight: 400;\n    font-size: 0.875rem;\n    line-height: 1;\n    display: contents; }\n    .styles-module_advertiserUserContainer__1Yuqx .styles-module_userInfo__2daA7 .styles-module_highlight__y6e-S {\n      color: #000000;\n      font-family: 'Avenir Next Demi', sans-serif;\n      font-weight: normal;\n      letter-spacing: .2px;\n      font-weight: 600;\n      font-size: 0.875rem;\n      line-height: 1;\n      margin: 0 0.25rem; }\n      .styles-module_advertiserUserContainer__1Yuqx .styles-module_userInfo__2daA7 .styles-module_highlight__y6e-S .styles-module_link__3OFWN {\n        color: #000000;\n        font-family: 'Avenir Next Demi', sans-serif;\n        font-weight: normal;\n        letter-spacing: .2px;\n        font-weight: 600;\n        font-size: 0.875rem;\n        line-height: 1;\n        text-decoration: underline;\n        cursor: pointer; }\n      .styles-module_advertiserUserContainer__1Yuqx .styles-module_userInfo__2daA7 .styles-module_highlight__y6e-S .styles-module_disabledLink__1wVlx {\n        color: #000000;\n        font-family: 'Avenir Next Demi', sans-serif;\n        font-weight: normal;\n        letter-spacing: .2px;\n        font-weight: 600;\n        font-size: 0.875rem;\n        line-height: 1;\n        cursor: default;\n        pointer-events: none;\n        text-decoration: none; }\n  .styles-module_advertiserUserContainer__1Yuqx .styles-module_closeButton__30Bbg {\n    height: 0.625rem;\n    width: 0.625rem; }\n    .styles-module_advertiserUserContainer__1Yuqx .styles-module_closeButton__30Bbg.btn-v2 {\n      position: absolute;\n      right: 0.5rem;\n      border: none;\n      background-color: #f4f4f4; }\n      .styles-module_advertiserUserContainer__1Yuqx .styles-module_closeButton__30Bbg.btn-v2:hover {\n        background-color: #f4f4f4; }\n    .styles-module_advertiserUserContainer__1Yuqx .styles-module_closeButton__30Bbg .svg-icon {\n      fill: #000000; }\n\n.styles-module_noDisplay__ZXwFR {\n  display: none; }\n";
var styles$1 = {"superUserContainer":"styles-module_superUserContainer__2qmJT","pill":"styles-module_pill__1Fbnb","userInfo":"styles-module_userInfo__2daA7","highlight":"styles-module_highlight__y6e-S","link":"styles-module_link__3OFWN","disabledLink":"styles-module_disabledLink__1wVlx","closeButton":"styles-module_closeButton__30Bbg","workspaceUserContainer":"styles-module_workspaceUserContainer__xhGNR","advertiserUserContainer":"styles-module_advertiserUserContainer__1Yuqx","noDisplay":"styles-module_noDisplay__ZXwFR","hover-ripples":"styles-module_hover-ripples__1gR4P"};
styleInject(css_248z$1);

var UserInfoBreadCrumb = function UserInfoBreadCrumb(_ref) {
  var userData = _ref.userData;

  var _useState = useState$2(false),
      _useState2 = _slicedToArray(_useState, 2),
      showBreadCrumb = _useState2[0],
      setBreadCrumbVisibility = _useState2[1];

  var _useState3 = useState$2(''),
      _useState4 = _slicedToArray(_useState3, 2),
      currentApp = _useState4[0],
      setCurrentApp = _useState4[1];

  var _useState5 = useState$2(''),
      _useState6 = _slicedToArray(_useState5, 2),
      currentAccount = _useState6[0],
      setCurrentAccount = _useState6[1];

  var appsToNotDisplayBreadCrumb = ['reports'];
  useEffect(function () {
    if (!isEmpty(userData)) {
      var accountType = getAccountType(userData);

      if (accountType === 'PlatformOwnerOrg') {
        setCurrentAccount('Super');
        setBreadCrumbVisibility(true);
      } else if (accountType === 'WorkspaceOwnerOrg') {
        setCurrentAccount('Workspace');
        setBreadCrumbVisibility(true);
      } else if (accountType === 'Advertiser' && userData.parentOrganization) {
        // to display breadcrumb only when super or workspace has logged in to an advertiser account
        setCurrentAccount('Advertiser');
        setBreadCrumbVisibility(true);
      }
    }
  }, [userData, setCurrentAccount, setBreadCrumbVisibility]);
  useEffect(function () {
    if (showBreadCrumb) {
      document.body.classList.add('breadcrumb-added');
    } else {
      document.body.classList.remove('breadcrumb-added');
    }
  }, [showBreadCrumb]);
  useEffect(function () {
    var currentURLSplit = window.location.href.split(/[//]/);
    var appList = ['bidmodel', 'audiences', 'campaigns', 'dashboard', 'organization', 'creatives', 'inventory', 'conversions', 'reports', 'accounts', 'customers', 'supertweak', 'campaign-insights', 'marketplace'];
    setCurrentApp(currentURLSplit.find(function (value) {
      return appList.includes(value);
    }));
  }, [window.location.href, setCurrentApp]);

  var setStyleWhenElementAppears = function setStyleWhenElementAppears(query) {
    var attribute = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
    var value = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
    var shouldStopObserving = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
    return new Promise(function (resolve) {
      //resolve if element already exists
      if (query && query.length) {
        if (attribute) {
          query[0].style[attribute] = value;
        }

        if (shouldStopObserving) {
          return resolve(query);
        }
      }

      var observer = new MutationObserver(function () {
        if (query && query.length) {
          if (attribute) {
            query[0].style[attribute] = value;
          }

          if (shouldStopObserving) {
            resolve(query);
            observer.disconnect();
          }
        }
      });
      observer.observe(document.body, {
        childList: true,
        subtree: true
      });
    });
  };

  var setCustomerAppStyling = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee() {
      var sectionElement;
      return regenerator.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              setStyleWhenElementAppears(document.getElementsByTagName('aside'), 'top', showBreadCrumb ? '6.5rem' : '4rem', false);
              setStyleWhenElementAppears(document.getElementsByClassName('customerDetailHeaderWrapper'), 'top', showBreadCrumb ? '6.25rem' : '3.75rem', false);
              setStyleWhenElementAppears(document.getElementsByClassName('financeDetailHeaderWrapper'), 'top', showBreadCrumb ? '6.25rem' : '3.75rem', false);
              setStyleWhenElementAppears(document.getElementsByClassName('financecontent'), 'paddingTop', showBreadCrumb ? '2.5rem' : '1rem', false);
              setStyleWhenElementAppears(document.getElementsByClassName('accountsidebar'), 'top', showBreadCrumb ? '12.5rem' : '10rem', false);
              setStyleWhenElementAppears(document.getElementsByClassName('approvalheader'), 'top', showBreadCrumb ? '6.2rem' : '3.7rem', false);
              setStyleWhenElementAppears(document.getElementsByClassName('accountsmain'), 'paddingTop', showBreadCrumb ? '8.4375rem' : '5.9375rem', false);
              setStyleWhenElementAppears(document.getElementsByClassName('customersmaincontainer'), 'top', showBreadCrumb ? '2.5rem' : '0');
              setStyleWhenElementAppears(document.getElementsByClassName('financemain'), 'top', showBreadCrumb ? '2.5rem' : '0');
              _context.next = 11;
              return setStyleWhenElementAppears(document.getElementsByTagName('section'));

            case 11:
              sectionElement = _context.sent;
              sectionElement[0].firstChild.style.top = showBreadCrumb ? '6.25rem' : '3.75rem';

            case 13:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function setCustomerAppStyling() {
      return _ref2.apply(this, arguments);
    };
  }();

  var setBidModelAppStyling = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee2() {
      return regenerator.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              setStyleWhenElementAppears(document.getElementsByTagName('aside'), 'top', showBreadCrumb ? '11.5rem' : '9rem', false);
              setStyleWhenElementAppears(document.getElementsByTagName('main'), 'top', showBreadCrumb ? '2.5rem' : '0', false);
              setStyleWhenElementAppears(document.getElementsByClassName('middleBarWrapper'), 'top', showBreadCrumb ? '6.5rem' : '4rem', false);

            case 3:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function setBidModelAppStyling() {
      return _ref3.apply(this, arguments);
    };
  }();

  var setAudiencesAppStyling = /*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee3() {
      var sectionElement;
      return regenerator.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              document.getElementsByTagName('aside')[0].style.top = showBreadCrumb ? '6.5rem' : '4rem';
              _context3.next = 3;
              return setStyleWhenElementAppears(document.getElementsByTagName('section'));

            case 3:
              sectionElement = _context3.sent;
              sectionElement[0].firstChild.style.paddingTop = showBreadCrumb ? '5rem' : '2.5rem';

            case 5:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }));

    return function setAudiencesAppStyling() {
      return _ref4.apply(this, arguments);
    };
  }();

  var setCreativesAppStyling = function setCreativesAppStyling() {
    setStyleWhenElementAppears(document.getElementsByTagName('aside'), 'top', showBreadCrumb ? '6.5rem' : '4rem');
    setStyleWhenElementAppears(document.getElementsByTagName('main'), 'top', showBreadCrumb ? '2.5rem' : '0');
  };

  var setDashboardOrCampaignAppStyling = function setDashboardOrCampaignAppStyling() {
    setStyleWhenElementAppears(document.getElementsByTagName('aside'), 'top', showBreadCrumb ? '6.5rem' : '4rem');
    setStyleWhenElementAppears(document.getElementsByTagName('main'), 'paddingTop', showBreadCrumb ? '2.5rem' : '0');
  };

  var setOrganizationAppStyling = function setOrganizationAppStyling() {
    setStyleWhenElementAppears(document.getElementsByTagName('aside'), 'top', showBreadCrumb ? '6.5rem' : '4rem');
    setStyleWhenElementAppears(document.getElementsByTagName('main'), 'top', showBreadCrumb ? '2.5rem' : '0', false);
  };

  var setAccountsAppStyling = function setAccountsAppStyling() {
    setStyleWhenElementAppears(document.getElementsByTagName('section'), 'top', showBreadCrumb ? '2.5rem' : '0');
  };

  var setInventoryAppStyling = function setInventoryAppStyling() {
    setStyleWhenElementAppears(document.getElementsByClassName('inventoryGroups'), 'top', showBreadCrumb ? '6.25rem' : '3.75rem', false);
    setStyleWhenElementAppears(document.getElementsByClassName('exchangeSidebar'), 'top', showBreadCrumb ? '10.875rem' : '8.375rem', false);
    setStyleWhenElementAppears(document.getElementsByClassName('dealsSidebar'), 'top', showBreadCrumb ? '10.875rem' : '8.375rem', false);
    setStyleWhenElementAppears(document.getElementsByClassName('contextualSidebar'), 'top', showBreadCrumb ? '10.875rem' : '8.375rem', false);
    setStyleWhenElementAppears(document.getElementsByTagName('section'), 'top', showBreadCrumb ? '2.5rem' : '0', false);
    setStyleWhenElementAppears(document.getElementsByClassName('subnavbar'), 'top', showBreadCrumb ? '2.5rem' : '0', false);
    setStyleWhenElementAppears(document.getElementsByClassName('blockedpage'), 'paddingTop', showBreadCrumb ? '6.25rem' : '3.75rem', false);
  };

  var setCampaignInsightOrConversionAppStyling = function setCampaignInsightOrConversionAppStyling() {
    setStyleWhenElementAppears(document.getElementsByTagName('aside'), 'top', showBreadCrumb ? '6.5rem' : '4rem');
    setStyleWhenElementAppears(document.getElementsByTagName('main'), 'top', showBreadCrumb ? '2.5rem' : '0');
  };

  var setSuperTweakAppStyling = function setSuperTweakAppStyling() {
    setStyleWhenElementAppears(document.getElementsByTagName('section'), 'paddingTop', showBreadCrumb ? '3.5rem' : '1rem', false);
  };

  var setMarketplaceAppStyling = function setMarketplaceAppStyling() {
    setStyleWhenElementAppears(document.getElementsByTagName('section'), 'paddingTop', showBreadCrumb ? '6.25rem' : '3.75rem');
  };

  useEffect(function () {
    if (!appsToNotDisplayBreadCrumb.includes(currentApp)) {
      document.getElementsByClassName('nav-bar')[0].style.top = showBreadCrumb ? '2.5rem' : '0';
      var breadCrumb = document.getElementsByClassName('breadcrumb');

      if (breadCrumb.length && !showBreadCrumb) {
        breadCrumb[0].style.display = 'none';
      }
    }

    switch (currentApp) {
      case 'customers':
        setCustomerAppStyling();
        break;

      case 'audiences':
        setAudiencesAppStyling();
        break;

      case 'inventory':
        setInventoryAppStyling();
        break;

      case 'campaign-insights':
      case 'conversions':
        setCampaignInsightOrConversionAppStyling();
        break;

      case 'campaigns':
      case 'dashboard':
        setDashboardOrCampaignAppStyling();
        break;

      case 'organization':
        setOrganizationAppStyling();
        break;

      case 'creatives':
        setCreativesAppStyling();
        break;

      case 'accounts':
        setAccountsAppStyling();
        break;

      case 'bidmodel':
        setBidModelAppStyling();
        break;

      case 'supertweak':
        setSuperTweakAppStyling();
        break;

      case 'marketplace':
        setMarketplaceAppStyling();
        break;
    }
  }, [currentApp, showBreadCrumb, setAudiencesAppStyling, setCreativesAppStyling, setDashboardOrCampaignAppStyling, setCustomerAppStyling, setBidModelAppStyling, setOrganizationAppStyling, setAccountsAppStyling, setInventoryAppStyling, setCampaignInsightOrConversionAppStyling, setMarketplaceAppStyling]);

  var getBreadCrumbStyles = function getBreadCrumbStyles() {
    if (currentAccount) {
      if (currentAccount === 'Super') {
        return styles$1.superUserContainer;
      }

      if (currentAccount === 'Workspace') {
        return styles$1.workspaceUserContainer;
      }

      if (currentAccount === 'Advertiser') {
        return styles$1.advertiserUserContainer;
      }
    }

    return styles$1.noDisplay;
  };

  var trimLength = function trimLength(text, length) {
    return text.length > length ? "".concat(text.slice(0, length), "...") : text;
  };

  var getParentOrganizationInfo = function getParentOrganizationInfo(parentOrganization) {
    var results = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    var parentsInfo = results;
    parentsInfo.push({
      organizationName: parentOrganization.organizationName,
      workspaceDomain: parentOrganization.workspaceDomain,
      isAccess: parentOrganization.isAccess,
      owId: parentOrganization.owId
    });
    return parentOrganization.parentOrganization ? getParentOrganizationInfo(parentOrganization.parentOrganization, parentsInfo) : parentsInfo.reverse();
  };

  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, showBreadCrumb && !appsToNotDisplayBreadCrumb.includes(currentApp) ? /*#__PURE__*/React__default.createElement("div", {
    className: "breadcrumb ".concat(getBreadCrumbStyles())
  }, /*#__PURE__*/React__default.createElement(Pill, {
    className: styles$1.pill,
    label: userData.isOwnerUser ? 'Owner' : 'User'
  }), /*#__PURE__*/React__default.createElement("div", {
    className: styles$1.userInfo
  }, "Logged in as", ' ', /*#__PURE__*/React__default.createElement("div", {
    className: styles$1.highlight,
    title: userData.displayName || userData.email
  }, trimLength(userData.displayName || userData.email, 25)), ' ', "in", ' ', userData.parentOrganization && getParentOrganizationInfo(userData.parentOrganization).map(function (parent, idx) {
    return /*#__PURE__*/React__default.createElement("div", {
      className: styles$1.highlight,
      key: idx
    }, /*#__PURE__*/React__default.createElement("a", {
      className: parent.isAccess ? styles$1.link : styles$1.disabledLink,
      href: prepareURL(parent, 'dashboard', currentApp, false),
      title: parent.organizationName
    }, trimLength(parent.organizationName, 25)), ' > ');
  }), /*#__PURE__*/React__default.createElement("div", {
    className: styles$1.highlight,
    title: userData.organizationName
  }, trimLength(userData.organizationName, 25))), /*#__PURE__*/React__default.createElement(ButtonCircle, {
    className: styles$1.closeButton,
    iconName: "Close",
    onClick: function onClick() {
      return setBreadCrumbVisibility(false);
    }
  })) : null);
};

var css_248z$2 = ":root {\n  --primary1: #123787;\n  --primary2: #1d58d7;\n  --primary3: #5173fb;\n  --primary4: #7a93ff;\n  --primary5: #c2d0ff;\n  --primary6: #e5ebff;\n  --primary7: #f2f5ff; }\n\n@keyframes index-module_hover-ripples__LSy_T {\n  0% {\n    top: -0.1875em;\n    left: -0.1875em;\n    right: -0.1875em;\n    bottom: -0.1875em;\n    opacity: 1; }\n  100% {\n    top: -0.8125em;\n    left: -0.8125em;\n    right: -0.8125em;\n    bottom: -0.8125em;\n    opacity: 0; } }\n\n.index-module_popupContent__3SrmP {\n  width: 100%;\n  border: 1px solid var(--primary3);\n  border-radius: 0.25rem;\n  background-color: #ffffff;\n  border-top-right-radius: 0;\n  position: relative;\n  margin-top: 0.1875rem;\n  height: 0;\n  opacity: 0;\n  pointer-events: none;\n  box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.05), 0px 0px 8px rgba(0, 0, 0, 0.04); }\n  .index-module_popupContent__3SrmP .index-module_currentUser__2b5Z3 {\n    display: flex;\n    align-items: center;\n    margin: 1.25rem 1rem 0.75rem; }\n    .index-module_popupContent__3SrmP .index-module_currentUser__2b5Z3 .index-module_userAvatar__37WPs {\n      border-radius: 50%;\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      margin-right: 0.5rem;\n      overflow: hidden;\n      flex-shrink: 0; }\n      .index-module_popupContent__3SrmP .index-module_currentUser__2b5Z3 .index-module_userAvatar__37WPs img {\n        border-radius: 50%;\n        width: 5.5rem;\n        height: 5.5rem;\n        object-fit: contain; }\n    .index-module_popupContent__3SrmP .index-module_currentUser__2b5Z3 .index-module_currUserDetails__288Jk .index-module_manageProfileAction__F_xcJ {\n      margin-top: 0.5rem; }\n      .index-module_popupContent__3SrmP .index-module_currentUser__2b5Z3 .index-module_currUserDetails__288Jk .index-module_manageProfileAction__F_xcJ a {\n        font-family: 'Avenir Next Demi', sans-serif;\n        font-weight: normal;\n        color: var(--primary2);\n        font-size: 0.875rem;\n        line-height: 1.25rem;\n        text-decoration: none; }\n    .index-module_popupContent__3SrmP .index-module_currentUser__2b5Z3 .index-module_currUserDetails__288Jk .index-module_userEmail__3HWHz {\n      font-family: 'Avenir Next Regular', sans-serif;\n      font-weight: normal;\n      letter-spacing: .2px;\n      font-size: 1rem;\n      line-height: 1.1875rem;\n      color: #666666;\n      max-width: 13rem;\n      white-space: nowrap;\n      text-overflow: ellipsis;\n      overflow: hidden; }\n    .index-module_popupContent__3SrmP .index-module_currentUser__2b5Z3 .index-module_currUserDetails__288Jk .index-module_userName__3j1au {\n      font-family: 'Avenir Next Demi', sans-serif;\n      font-weight: normal;\n      font-size: 1.125rem;\n      line-height: 1.5rem;\n      max-width: 12.25rem;\n      white-space: nowrap;\n      overflow: hidden;\n      text-overflow: ellipsis; }\n  .index-module_popupContent__3SrmP .index-module_currentOrganization__32_3M {\n    max-height: 5.375rem;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    padding: 0.75rem;\n    border-radius: 0.25rem;\n    border: 1px solid transparent;\n    margin: 0 1rem;\n    background-color: var(--primary7);\n    max-height: 4.125rem; }\n  .index-module_popupContent__3SrmP .index-module_organizations__15ODT .index-module_search__3L2Vd {\n    padding: 0 1.125rem;\n    width: 100%;\n    font-family: 'Avenir Next Regular', sans-serif;\n    font-weight: normal;\n    font-size: 12px;\n    line-height: 16px; }\n    .index-module_popupContent__3SrmP .index-module_organizations__15ODT .index-module_search__3L2Vd .index-module_searchField__1CDCC input {\n      z-index: 99; }\n    .index-module_popupContent__3SrmP .index-module_organizations__15ODT .index-module_search__3L2Vd .index-module_searchField__1CDCC span {\n      max-width: 85%; }\n  .index-module_popupContent__3SrmP .index-module_organizations__15ODT .index-module_listContainer__3KBQ8 {\n    position: relative;\n    min-height: fit-content;\n    max-height: 30vh; }\n    .index-module_popupContent__3SrmP .index-module_organizations__15ODT .index-module_listContainer__3KBQ8 .index-module_organizationList__30mHx {\n      max-height: 30vh;\n      overflow: auto;\n      position: relative;\n      display: block;\n      width: 100%; }\n      .index-module_popupContent__3SrmP .index-module_organizations__15ODT .index-module_listContainer__3KBQ8 .index-module_organizationList__30mHx .index-module_orgDetails__3oyRY {\n        box-shadow: 0px 0px 2px rgba(0, 0, 0, 0.05), 0px 0px 4px rgba(0, 0, 0, 0.05);\n        margin: 0.75rem 1.125rem;\n        height: 5.625rem; }\n        .index-module_popupContent__3SrmP .index-module_organizations__15ODT .index-module_listContainer__3KBQ8 .index-module_organizationList__30mHx .index-module_orgDetails__3oyRY a {\n          display: block; }\n  .index-module_popupContent__3SrmP .index-module_orgLink__1Tfcg {\n    text-decoration: none;\n    color: #000000;\n    cursor: unset; }\n  .index-module_popupContent__3SrmP .index-module_organization___DBKy {\n    display: flex;\n    padding: 0.75rem;\n    border-radius: 0.25rem;\n    border: 1px solid transparent; }\n    .index-module_popupContent__3SrmP .index-module_organization___DBKy:hover .index-module_action__1KRqt {\n      background-color: var(--primary2); }\n    .index-module_popupContent__3SrmP .index-module_organization___DBKy.index-module_currentOrg__2m4Ta {\n      border: 1px solid var(--primary4);\n      background-color: var(--primary7); }\n    .index-module_popupContent__3SrmP .index-module_organization___DBKy:hover:not(.index-module_currentOrg__2m4Ta) {\n      background-color: #f4f4f4;\n      cursor: pointer; }\n  .index-module_popupContent__3SrmP .index-module_orgAvatar__3tsMU {\n    border-radius: 50%;\n    width: 2.5rem;\n    height: 2.5rem;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    margin-right: 1rem;\n    border: 1px solid #cbcbcb;\n    position: relative;\n    flex-shrink: 0; }\n    .index-module_popupContent__3SrmP .index-module_orgAvatar__3tsMU.index-module_isWorkspace__18tSz {\n      border-color: var(--primary2); }\n      .index-module_popupContent__3SrmP .index-module_orgAvatar__3tsMU.index-module_isWorkspace__18tSz .index-module_crown__3_-Qd {\n        position: absolute;\n        top: 0;\n        right: 0;\n        width: 0.625rem;\n        height: 0.625rem;\n        background-color: var(--primary2);\n        border-radius: 0.375rem;\n        padding: 0.0625rem;\n        z-index: 1;\n        fill: #ffffff; }\n        .index-module_popupContent__3SrmP .index-module_orgAvatar__3tsMU.index-module_isWorkspace__18tSz .index-module_crown__3_-Qd path {\n          stroke: #ffffff; }\n    .index-module_popupContent__3SrmP .index-module_orgAvatar__3tsMU img {\n      border-radius: 50%;\n      width: 2.125rem;\n      height: 2.125rem;\n      object-fit: contain;\n      background-color: #ffffff; }\n  .index-module_popupContent__3SrmP .index-module_orgName__3iCLz {\n    font-family: 'Avenir Next Demi', sans-serif;\n    font-weight: normal;\n    font-size: 1rem;\n    line-height: 1.5rem;\n    max-width: 12.625rem;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis; }\n  .index-module_popupContent__3SrmP .index-module_orgUrl__3OTdd {\n    font-size: 0.875rem;\n    line-height: 1.125rem;\n    font-family: 'Avenir Next Regular', sans-serif;\n    font-weight: normal;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    max-width: 12rem; }\n  .index-module_popupContent__3SrmP .index-module_ownerUserEmail__2mbzb {\n    font-family: 'Avenir Next Regular', sans-serif;\n    font-weight: normal;\n    font-size: 0.875rem;\n    line-height: 0.875rem;\n    height: 1rem;\n    white-space: nowrap;\n    overflow: hidden;\n    min-height: 0.875rem;\n    text-overflow: ellipsis;\n    max-width: 12.625rem; }\n    .index-module_popupContent__3SrmP .index-module_ownerUserEmail__2mbzb span {\n      color: #666666; }\n  .index-module_popupContent__3SrmP .index-module_titleInOrg__20Zm6 {\n    margin-top: 0.25rem;\n    font-family: 'Avenir Next Regular', sans-serif;\n    font-weight: normal;\n    letter-spacing: .2px;\n    font-size: 0.75rem;\n    line-height: 0.875rem; }\n  .index-module_popupContent__3SrmP .index-module_footer__2kQ4x {\n    padding: 1rem 1rem;\n    height: 3.9375rem;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    position: relative; }\n    .index-module_popupContent__3SrmP .index-module_footer__2kQ4x::before {\n      content: '';\n      position: absolute;\n      top: -0.0625rem;\n      left: 0;\n      right: 0;\n      height: 0.0625rem;\n      width: 100%;\n      background-color: #e7e7e7; }\n  .index-module_popupContent__3SrmP .index-module_topFooterMargin__zJz8O {\n    margin-top: 1rem; }\n  .index-module_popupContent__3SrmP .index-module_action__1KRqt {\n    width: 1.5rem;\n    height: 1.5rem;\n    border-radius: 0.875rem;\n    background-color: #787878; }\n    .index-module_popupContent__3SrmP .index-module_actionIcon__2Wc35 {\n      width: 100%;\n      height: 100%;\n      padding: 0.1875rem;\n      cursor: pointer; }\n      .index-module_popupContent__3SrmP .index-module_actionIcon__2Wc35.stroke-icon.svg-icon {\n        fill: #ffffff; }\n      .index-module_popupContent__3SrmP .index-module_actionIcon__2Wc35.stroke-icon.svg-icon path {\n        stroke: #ffffff; }\n  .index-module_popupContent__3SrmP .actions > div {\n    display: none; }\n\n.nav-bar__popup._show .index-module_popupContent__3SrmP {\n  opacity: 1;\n  height: unset;\n  min-height: 14.5rem;\n  pointer-events: unset; }\n\n.index-module_seperator__PGUIn {\n  display: block;\n  margin: 1rem;\n  border-top: 1px solid #e7e7e7; }\n\n.index-module_copyIcon__34gzX {\n  z-index: 99; }\n  .index-module_copyIcon__34gzX svg.svg-icon {\n    width: 1.5rem !important;\n    height: 1.5rem !important; }\n  .index-module_copyIcon__34gzX svg.svg-icon.stroke-icon path {\n    stroke: var(--primary2) !important; }\n\n.index-module_buttonRight__gy7Kb {\n  margin-left: auto; }\n\n.index-module_noDataContainer__2dI_W {\n  min-height: 12.625rem;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-direction: column;\n  text-align: center;\n  font-family: 'Avenir Next Regular', sans-serif;\n  font-weight: normal;\n  font-size: 0.875rem;\n  line-height: 1.125rem;\n  padding: 0 1rem; }\n\n.index-module_copied__11Vod {\n  position: absolute;\n  top: -30px;\n  right: -20px;\n  background-color: #ffffff;\n  font-family: 'Avenir Next Regular', sans-serif;\n  font-weight: normal;\n  font-size: 0.875rem;\n  color: #000000;\n  box-shadow: 0px 0px 2px rgba(0, 0, 0, 0.05), 0px 0px 4px rgba(0, 0, 0, 0.05);\n  padding: 0.25rem;\n  border-radius: 0.25rem; }\n\n.index-module_addMargin__XIFW- {\n  margin-top: 0.3rem;\n  height: 1rem; }\n\n.index-module_skeleton__2UvtJ {\n  display: block;\n  height: 1.3rem;\n  border-radius: 0.3125rem;\n  background-image: linear-gradient(90deg, var(--primary7) 0, #e8e8e8 2rem, var(--primary7) 4rem);\n  background-size: 200%;\n  background-position: 100%;\n  animation: index-module_skeleton__2UvtJ 1.5s infinite linear; }\n\n.index-module_skeletonImage__3l4TI {\n  display: block;\n  height: 2.125rem;\n  border-radius: 0.3125rem;\n  background-image: linear-gradient(90deg, var(--primary7) 0, #e8e8e8 2rem, var(--primary7) 4rem);\n  background-size: 200%;\n  background-position: 100%;\n  animation: index-module_skeleton__2UvtJ 1.5s infinite linear; }\n  .index-module_skeletonImage__3l4TI:not(:first) {\n    margin-top: 0.5rem; }\n\n@keyframes index-module_skeleton__2UvtJ {\n  0% {\n    background-position: 100%; }\n  100% {\n    background-position: -100%; } }\n\n.index-module_workspaceDomain__3zcps {\n  margin-top: -0.3rem; }\n";
var styles$2 = {"popupContent":"index-module_popupContent__3SrmP","currentUser":"index-module_currentUser__2b5Z3","userAvatar":"index-module_userAvatar__37WPs","currUserDetails":"index-module_currUserDetails__288Jk","manageProfileAction":"index-module_manageProfileAction__F_xcJ","userEmail":"index-module_userEmail__3HWHz","userName":"index-module_userName__3j1au","currentOrganization":"index-module_currentOrganization__32_3M","organizations":"index-module_organizations__15ODT","search":"index-module_search__3L2Vd","searchField":"index-module_searchField__1CDCC","listContainer":"index-module_listContainer__3KBQ8","organizationList":"index-module_organizationList__30mHx","orgDetails":"index-module_orgDetails__3oyRY","orgLink":"index-module_orgLink__1Tfcg","organization":"index-module_organization___DBKy","action":"index-module_action__1KRqt","currentOrg":"index-module_currentOrg__2m4Ta","orgAvatar":"index-module_orgAvatar__3tsMU","isWorkspace":"index-module_isWorkspace__18tSz","crown":"index-module_crown__3_-Qd","orgName":"index-module_orgName__3iCLz","orgUrl":"index-module_orgUrl__3OTdd","ownerUserEmail":"index-module_ownerUserEmail__2mbzb","titleInOrg":"index-module_titleInOrg__20Zm6","footer":"index-module_footer__2kQ4x","topFooterMargin":"index-module_topFooterMargin__zJz8O","actionIcon":"index-module_actionIcon__2Wc35","seperator":"index-module_seperator__PGUIn","copyIcon":"index-module_copyIcon__34gzX","buttonRight":"index-module_buttonRight__gy7Kb","noDataContainer":"index-module_noDataContainer__2dI_W","copied":"index-module_copied__11Vod","addMargin":"index-module_addMargin__XIFW-","skeleton":"index-module_skeleton__2UvtJ","skeletonImage":"index-module_skeletonImage__3l4TI","workspaceDomain":"index-module_workspaceDomain__3zcps","hover-ripples":"index-module_hover-ripples__LSy_T"};
styleInject(css_248z$2);

var PopupContent = function PopupContent(_ref) {
  var userData = _ref.userData,
      open = _ref.open;

  var _useState = useState$2([]),
      _useState2 = _slicedToArray(_useState, 2),
      selectedUserOrgs = _useState2[0],
      setSelectedUserOrgs = _useState2[1];

  var _useState3 = useState$2(),
      _useState4 = _slicedToArray(_useState3, 2),
      currentOrg = _useState4[0],
      setCurrentOrg = _useState4[1];

  var _useState5 = useState$2(false),
      _useState6 = _slicedToArray(_useState5, 2),
      isSearchingWorkspace = _useState6[0],
      setIsSearchingWorkspace = _useState6[1];

  var _useState7 = useState$2(0),
      _useState8 = _slicedToArray(_useState7, 2),
      totalRecords = _useState8[0],
      setTotalRecords = _useState8[1];

  var _useState9 = useState$2(false),
      _useState10 = _slicedToArray(_useState9, 2),
      showLoadMore = _useState10[0],
      setShowLoadMore = _useState10[1];

  var _useState11 = useState$2(0),
      _useState12 = _slicedToArray(_useState11, 2),
      isCopied = _useState12[0],
      setIsCopied = _useState12[1];

  var _useState13 = useState$2(userData.userAvatar || ''),
      _useState14 = _slicedToArray(_useState13, 2),
      userAvatar = _useState14[0],
      setUserAvatar = _useState14[1];

  var _useState15 = useState$2(userData.displayName || ''),
      _useState16 = _slicedToArray(_useState15, 2),
      displayName = _useState16[0],
      setDisplayName = _useState16[1];

  var _useState17 = useState$2(''),
      _useState18 = _slicedToArray(_useState17, 2),
      organizationLogo = _useState18[0],
      setOrganizationLogo = _useState18[1];

  var _useState19 = useState$2(''),
      _useState20 = _slicedToArray(_useState19, 2),
      apiToken = _useState20[0],
      setApiToken = _useState20[1];

  var _useState21 = useState$2(''),
      _useState22 = _slicedToArray(_useState21, 2),
      searchField = _useState22[0],
      setSearchField = _useState22[1];

  var currentOwId = useMemo(function () {
    return getOwId();
  }, []);
  var currentPathNumber = useMemo(function () {
    return getPathNumber();
  }, []);
  useEffect(function () {
    if (open) {
      try {
        var newUserData = JSON.parse(localStorage.getItem('authorizedUser'));
        setUserAvatar(newUserData.userAvatar);
        setDisplayName(newUserData.displayName);
        setOrganizationLogo(newUserData.organizationLogo);
        setApiToken(newUserData.apiToken);
      } catch (e) {
        console.error(e);
      }
    }
  }, [open]);
  useEffect(function () {
    var fetchData = /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee() {
        var res;
        return regenerator.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                setIsSearchingWorkspace(true);
                _context.next = 3;
                return ApiService.fetchOrganizations({
                  searchField: searchField
                });

              case 3:
                res = _context.sent;
                setCurrentOrg(res.currentOrganization);

                if (res.totalRecords > res.data.length) {
                  setShowLoadMore(true);
                }

                setTotalRecords(res.totalRecords);
                setSelectedUserOrgs(res.data || []);
                setIsSearchingWorkspace(false);

              case 9:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function fetchData() {
        return _ref2.apply(this, arguments);
      };
    }();

    fetchData();
  }, [searchField]);

  var handleLogout = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee2() {
      return regenerator.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.prev = 0;
              _context2.next = 3;
              return ApiService.logout();

            case 3:
              _context2.prev = 3;
              window.location.href = '/#/login';
              return _context2.finish(3);

            case 6:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, null, [[0,, 3, 6]]);
    }));

    return function handleLogout() {
      return _ref3.apply(this, arguments);
    };
  }();

  var isCurrentOrg = useCallback(function (org) {
    return currentOwId === String(org.owId);
  }, [currentOwId]);
  var isWorkspace = useCallback(function (org) {
    return (org === null || org === void 0 ? void 0 : org.customerType) === 'Workspace';
  }, []);
  var isOrgAvailable = useMemo(function () {
    return searchField && !totalRecords || !(!searchField && !totalRecords);
  }, [searchField, totalRecords]);
  var copyDomain = useCallback( /*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee3(domain, evt, org) {
      return regenerator.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              evt.stopPropagation();
              _context3.next = 3;
              return navigator.clipboard.writeText(domain.trim()).then(function (clipText) {
                return setIsCopied(org.owId);
              });

            case 3:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }));

    return function (_x, _x2, _x3) {
      return _ref4.apply(this, arguments);
    };
  }(), [setIsCopied]);
  useEffect(function () {
    if (isCopied) {
      setTimeout(function () {
        setIsCopied(false);
      }, 1000);
    }
  }, [isCopied]);
  var clearDataInside = useCallback(function () {
    setSearchField('');
  }, [setSearchField]);
  var prepareURL = useCallback(function (org) {
    if (isCurrentOrg(org)) {
      return window.location.href;
    }

    if (ORIGIN_URL.includes(org.workspaceDomain)) {
      var savedOwIds = JSON.parse(localStorage.getItem('owIds')) || [];
      var index = savedOwIds.indexOf(org.owId);

      if (index !== -1) {
        return "https://".concat(org.workspaceDomain, "/dashboard/u/").concat(index, "/");
      } else {
        var newList = [].concat(_toConsumableArray(savedOwIds), [org.owId]);
        localStorage.setItem('owIds', JSON.stringify(newList));
        return window.location.href.replace(new RegExp("/u/".concat(currentPathNumber)), "/u/".concat(newList.length - 1));
      }
    }

    return "https://".concat(org.workspaceDomain, "/#/login?owner=").concat(btoa(window.location.origin), "&ow=").concat(org.owId, "&apiToken=").concat(btoa(apiToken));
  }, [isCurrentOrg, currentPathNumber, apiToken]);
  var redirectToWorkspace = useCallback(function (org) {
    window.open(prepareURL(org), '_blank');
  }, [prepareURL]);
  var renderNoResultScreen = useCallback(function () {
    if (!selectedUserOrgs.length && !isSearchingWorkspace && searchField) {
      return /*#__PURE__*/React__default.createElement("div", {
        className: styles$2.noDataContainer
      }, /*#__PURE__*/React__default.createElement("div", null, "No results found for ", /*#__PURE__*/React__default.createElement("strong", null, "\"", searchField, "\"")), /*#__PURE__*/React__default.createElement("div", null, "Please try a different keyword"));
    }

    if (!selectedUserOrgs.length && !isSearchingWorkspace) {
      return /*#__PURE__*/React__default.createElement("div", {
        className: styles$2.noDataContainer
      }, /*#__PURE__*/React__default.createElement("div", null, "You don't have access to", /*#__PURE__*/React__default.createElement("br", null), "any other organization"));
    }

    return /*#__PURE__*/React__default.createElement("div", {
      className: "w-100 d-flex justify-content-center align-items-center ".concat(styles$2.noDataContainer)
    }, /*#__PURE__*/React__default.createElement(ProgressCircle, null));
  }, [selectedUserOrgs.length, isSearchingWorkspace, searchField]);

  if (!userData) {
    return /*#__PURE__*/React__default.createElement("div", {
      className: styles$2.popupContent
    }, /*#__PURE__*/React__default.createElement(ProgressCircle, null));
  }

  return /*#__PURE__*/React__default.createElement("div", {
    className: styles$2.popupContent
  }, /*#__PURE__*/React__default.createElement("div", {
    className: styles$2.currentUser
  }, /*#__PURE__*/React__default.createElement("span", {
    className: styles$2.userAvatar
  }, /*#__PURE__*/React__default.createElement("img", {
    src: userAvatar,
    alt: "user avatar"
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "d-flex flex-column flex-grow-1 ".concat(styles$2.currUserDetails)
  }, /*#__PURE__*/React__default.createElement("div", {
    className: styles$2.userName
  }, displayName), /*#__PURE__*/React__default.createElement("div", {
    className: styles$2.userEmail,
    title: userData.email || ''
  }, userData.email), /*#__PURE__*/React__default.createElement("div", {
    className: styles$2.manageProfileAction
  }, /*#__PURE__*/React__default.createElement("a", {
    href: "/accounts/u/".concat(getPathNumber(), "/#/user-settings")
  }, "Manage my profile")))), /*#__PURE__*/React__default.createElement("div", {
    className: styles$2.currentOrganization
  }, /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("span", {
    className: "".concat(styles$2.orgAvatar, " ").concat(isWorkspace(currentOrg) && styles$2.isWorkspace)
  }, isWorkspace(currentOrg) ? /*#__PURE__*/React__default.createElement(Icon, {
    name: "Crown",
    className: styles$2.crown
  }) : null, currentOrg !== null && currentOrg !== void 0 && currentOrg.logoUrl ? /*#__PURE__*/React__default.createElement("img", {
    src: currentOrg === null || currentOrg === void 0 ? void 0 : currentOrg.logoUrl,
    alt: "org avatar"
  }) : null), /*#__PURE__*/React__default.createElement("div", {
    className: "d-flex flex-column justify-content-center flex-grow-1"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "".concat(styles$2.orgName, " ").concat(!(currentOrg !== null && currentOrg !== void 0 && currentOrg.organizationName) ? styles$2.skeleton : ''),
    title: (currentOrg === null || currentOrg === void 0 ? void 0 : currentOrg.organizationName) || ''
  }, currentOrg === null || currentOrg === void 0 ? void 0 : currentOrg.organizationName), /*#__PURE__*/React__default.createElement("div", {
    title: "".concat((currentOrg === null || currentOrg === void 0 ? void 0 : currentOrg.contactPersonName) || '', " (").concat((currentOrg === null || currentOrg === void 0 ? void 0 : currentOrg.ownerUserEmail) || '', ")"),
    className: "".concat(styles$2.ownerUserEmail, " ").concat(!(currentOrg !== null && currentOrg !== void 0 && currentOrg.ownerUserEmail) ? styles$2.skeleton : '')
  }, currentOrg !== null && currentOrg !== void 0 && currentOrg.contactPersonName || currentOrg !== null && currentOrg !== void 0 && currentOrg.ownerUserEmail ? /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("span", null, "Owner"), " ", currentOrg === null || currentOrg === void 0 ? void 0 : currentOrg.contactPersonName, " (", currentOrg === null || currentOrg === void 0 ? void 0 : currentOrg.ownerUserEmail, ")") : null)))), isOrgAvailable ? /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("span", {
    className: styles$2.seperator
  }), /*#__PURE__*/React__default.createElement("div", {
    className: styles$2.organizations
  }, /*#__PURE__*/React__default.createElement("div", {
    className: styles$2.search
  }, /*#__PURE__*/React__default.createElement(Tooltip, {
    label: "Search other organization by name, email or ID",
    auto: false,
    position: "top"
  }, /*#__PURE__*/React__default.createElement(TextField, {
    name: "Search",
    placeholder: "Search other organization by name, email or ID",
    value: searchField,
    onChange: setSearchField,
    iconName: "Search",
    onResetClick: clearDataInside,
    hasAlwaysResetButton: !!searchField,
    variant: "withoutTickbox",
    autoFocus: true,
    className: styles$2.searchField
  }))), /*#__PURE__*/React__default.createElement("div", {
    className: styles$2.listContainer
  }, /*#__PURE__*/React__default.createElement("div", {
    className: styles$2.organizationList
  }, selectedUserOrgs.length && !isSearchingWorkspace ? selectedUserOrgs.map(function (org) {
    return /*#__PURE__*/React__default.createElement("div", {
      key: org.owId,
      className: styles$2.orgDetails
    }, /*#__PURE__*/React__default.createElement("div", {
      className: styles$2.orgLink,
      onClick: function onClick() {
        return redirectToWorkspace(org);
      }
    }, /*#__PURE__*/React__default.createElement("div", {
      className: "".concat(styles$2.organization, " ").concat(isCurrentOrg(org) ? styles$2.currentOrg : '')
    }, /*#__PURE__*/React__default.createElement("span", {
      className: "".concat(styles$2.orgAvatar, " ").concat(isWorkspace(org) ? styles$2.isWorkspace : '')
    }, isWorkspace(org) ? /*#__PURE__*/React__default.createElement(Icon, {
      name: "Crown",
      className: styles$2.crown
    }) : null, /*#__PURE__*/React__default.createElement("img", {
      src: isCurrentOrg(org) ? organizationLogo : org.logoUrl,
      alt: "org avatar"
    })), /*#__PURE__*/React__default.createElement("div", {
      className: "d-flex flex-column justify-content-center flex-grow-1"
    }, /*#__PURE__*/React__default.createElement("div", {
      title: org.organizationName || '',
      className: styles$2.orgName
    }, org.organizationName), /*#__PURE__*/React__default.createElement("div", {
      title: isWorkspace(org) ? org.workspaceDomain : org.workspaceOwnerOrganizationName || '',
      className: "d-flex align-items-center position-relative  ".concat(isWorkspace(org) ? styles$2.workspaceDomain : styles$2.workspaceOwnerOrganizationName)
    }, isWorkspace(org) ? /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("div", {
      className: styles$2.orgUrl
    }, org.workspaceDomain), /*#__PURE__*/React__default.createElement("div", {
      onClick: function onClick(evt) {
        return copyDomain(org.workspaceDomain, evt, org);
      },
      title: "Click to copy domain",
      className: styles$2.copyIcon
    }, isCopied === org.owId ? /*#__PURE__*/React__default.createElement("div", {
      className: styles$2.copied
    }, "Copied!!") : '', /*#__PURE__*/React__default.createElement(Icon, {
      name: "CopyRounded",
      className: styles$2.crown
    }))) : /*#__PURE__*/React__default.createElement("div", {
      className: styles$2.orgUrl
    }, "By ", org.workspaceOwnerOrganizationName || '')), /*#__PURE__*/React__default.createElement("div", {
      title: org.ownerUserEmail || '',
      className: "".concat(styles$2.ownerUserEmail, " ").concat(isWorkspace(org) ? '' : styles$2.addMargin)
    }, /*#__PURE__*/React__default.createElement("span", null, "Owner"), " ", org.contactPersonName, " (", org.ownerUserEmail, ")")))));
  }) : /*#__PURE__*/React__default.createElement(React__default.Fragment, null, " ", renderNoResultScreen()))))) : null, /*#__PURE__*/React__default.createElement("div", {
    className: "".concat(styles$2.footer, " ").concat(isOrgAvailable ? '' : styles$2.topFooterMargin)
  }, isOrgAvailable ? /*#__PURE__*/React__default.createElement("a", {
    href: "/accounts/u/".concat(getPathNumber(), "/#/user-settings"),
    className: "text-decoration-none"
  }, /*#__PURE__*/React__default.createElement(Button, {
    variant: "tertiary2"
  }, "See all accesses")) : null, /*#__PURE__*/React__default.createElement(Button, {
    className: showLoadMore ? '' : styles$2.buttonRight,
    onClick: handleLogout
  }, "Logout")));
};
PopupContent.propTypes = {
  userData: PropTypes.object,
  open: PropTypes.bool
};

function ownKeys$3(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$3(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$3(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$3(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var APPS_UNIQUES = {
  dashboard: {
    applicationId: 'a945b49c-0bea-43fd-834f-7d8b0a227f71',
    clientToken: 'pub52d840b41891711e1311b7b18dc8e28d'
  },
  reports: {
    applicationId: '35577291-72a9-4dd2-8257-e0fba0641aa0',
    clientToken: 'pub331b24a2b59e5996437941d456ded62a'
  },
  campaigns: {
    applicationId: '75d9a680-0dc1-4923-b2dc-9aafa44645b7',
    clientToken: 'pub52dc1701d8b2678cb0be805f5f617575'
  },
  creatives: {
    applicationId: '5baf4aa9-eb4d-4865-b08c-2ec81bf0a59e',
    clientToken: 'pubea8941296dfacc5df69808a2e6aa8c8f'
  },
  inventory: {
    applicationId: '43136919-94f8-4d67-9735-856f8f3531de',
    clientToken: 'pubf618ff725868f734e22cc26a702d9c1d'
  },
  audiences: {
    applicationId: '42e38ab2-ff0e-42ba-9f04-af32c0e6987c',
    clientToken: 'puba4a498daceeedd3bac2cf658370f8f40'
  },
  bidmodel: {
    applicationId: 'f28e7051-47cb-4b3a-ac9c-2a1d98660edd',
    clientToken: 'pub78155a1ca1eb65a60d10cb98dc548586'
  },
  customers: {
    applicationId: '9f36fc4b-4bde-4d72-b783-eb07ab133683',
    clientToken: 'pubca2516fd2166fd85369df4a2ded58531'
  },
  organization: {
    applicationId: '6178937b-c10d-49b4-a0bd-c4eaa46910a5',
    clientToken: 'pub732dae82481272be47a8d1b312ac1f41'
  },
  conversions: {
    applicationId: 'b92bc1af-7007-4397-8239-45bb9d77b679',
    clientToken: 'pub7ef50f501372f559c80c976ba50c2243'
  },
  marketplace: {
    applicationId: 'f5257345-06cd-43a3-bf1f-b3c9158d8bf1',
    clientToken: 'pube8a851bac1126b5e0244f067b8f2e9cf'
  },
  'auth-pages': {
    applicationId: '21a993e8-1e45-4bb0-97f2-25cbf66f28c1',
    clientToken: 'pubb73ae63e345d0ed7824a96c17c4e644a'
  },
  accounts: {
    applicationId: 'cdbe2115-0e03-415c-9f43-0eaa215add90',
    clientToken: 'pub5f18c00c34087cb1ba249f35c74206a2'
  }
};
function initDataDog(appName) {
  var env = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'production';
  var config = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var selectedUniques = APPS_UNIQUES[appName];

  if (selectedUniques) {
    datadogRum.init(_objectSpread$3(_objectSpread$3(_objectSpread$3({}, selectedUniques), {}, {
      sampleRate: 100,
      trackInteractions: true
    }, config), {}, {
      site: 'datadoghq.com',
      service: appName,
      env: env,
      version: REACT_APP_VERSION || '0.1.0'
    }));
  }

  if (config !== null && config !== void 0 && config.trackViewsManually) {
    try {
      datadogRum.startView(window.location.pathname);
    } catch (err) {}
  }
}
function setDataDogSessionUser() {
  var user = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : AuthService.getUser();

  if (user) {
    datadogRum.setUser({
      id: user.owId,
      name: user.displayName || '',
      email: user.email || '',
      organization: user.organizationName || '',
      customer_id: user.owId,
      user_email: user.email
    });
  }
}
function logDataDogAction(action, info) {
  datadogRum.addAction(action, info);
}
var ddRum = datadogRum;

var css_248z$3 = ".nav-bar__logo {\n  display: flex;\n  align-items: center;\n  width: 3rem;\n  height: 3rem;\n  position: relative;\n  border-radius: 0.25rem;\n  margin-right: 0.5rem; }\n  .nav-bar__logo svg {\n    height: 100%;\n    width: auto; }\n\n.nav-bar__link-icon .svg-icon {\n  width: 2rem;\n  height: 2rem; }\n";
styleInject(css_248z$3);

var css_248z$4 = ":root {\n  --primary1: #123787;\n  --primary2: #1d58d7;\n  --primary3: #5173fb;\n  --primary4: #7a93ff;\n  --primary5: #c2d0ff;\n  --primary6: #e5ebff;\n  --primary7: #f2f5ff; }\n\n@keyframes styles-module_hover-ripples__2CBaY {\n  0% {\n    top: -0.1875em;\n    left: -0.1875em;\n    right: -0.1875em;\n    bottom: -0.1875em;\n    opacity: 1; }\n  100% {\n    top: -0.8125em;\n    left: -0.8125em;\n    right: -0.8125em;\n    bottom: -0.8125em;\n    opacity: 0; } }\n\n.styles-module_profileAvatarLabel__1QP4P {\n  width: 6.25rem;\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis; }\n\n.styles-module_storageEventTrigger__3zcuu {\n  display: none; }\n\n.msg-responsive .modalV2 > .modalV2__overlay {\n  height: 100%;\n  width: 100%;\n  align-items: start;\n  justify-content: start;\n  padding: 2rem; }\n  .msg-responsive .modalV2 > .modalV2__overlay .dialogV2 {\n    display: flex;\n    flex-direction: column;\n    align-items: stretch;\n    height: auto;\n    min-height: auto;\n    width: 90%;\n    max-width: 22rem;\n    min-width: 20rem;\n    border: 0;\n    border-radius: 0; }\n    .msg-responsive .modalV2 > .modalV2__overlay .dialogV2 main {\n      width: 100%;\n      height: 100%;\n      padding: 2rem; }\n      @media screen and (max-width: 576px) {\n        .msg-responsive .modalV2 > .modalV2__overlay .dialogV2 main {\n          padding: 1rem; } }\n      .msg-responsive .modalV2 > .modalV2__overlay .dialogV2 main .text-center {\n        text-align: center; }\n        .msg-responsive .modalV2 > .modalV2__overlay .dialogV2 main .text-center .img-msg {\n          width: 150px;\n          height: 100px;\n          display: block;\n          margin: 0 auto 1rem; }\n        .msg-responsive .modalV2 > .modalV2__overlay .dialogV2 main .text-center h2 {\n          margin-bottom: 0.5rem; }\n        .msg-responsive .modalV2 > .modalV2__overlay .dialogV2 main .text-center p {\n          color: #000000;\n          font-size: 1rem; }\n        .msg-responsive .modalV2 > .modalV2__overlay .dialogV2 main .text-center .btn-square {\n          margin: 1rem auto 0; }\n";
var styles$3 = {"profileAvatarLabel":"styles-module_profileAvatarLabel__1QP4P","storageEventTrigger":"styles-module_storageEventTrigger__3zcuu","hover-ripples":"styles-module_hover-ripples__2CBaY"};
styleInject(css_248z$4);

function ownKeys$4(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$4(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$4(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$4(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var getLogo = function getLogo() {
  var logo = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'Report Builder';
  if (typeof logo !== 'string') return logo;
  return /*#__PURE__*/React__default.createElement("div", {
    className: "nav-bar__logo"
  }, /*#__PURE__*/React__default.createElement(Icon, {
    name: logo
  }));
};

var DefalutIntercomSetting = {
  alignment: 'right',
  horizontal_padding: 20,
  vertical_padding: 20,
  hide_default_launcher: true
};

var Header = function Header(props) {
  var _userData$organizatio;

  var leftLogo = props.leftLogo,
      title = props.title,
      _props$backButton = props.backButton,
      backButton = _props$backButton === void 0 ? false : _props$backButton,
      backHandler = props.backHandler,
      children = props.children,
      _props$isElevated = props.isElevated,
      isElevated = _props$isElevated === void 0 ? true : _props$isElevated,
      _props$isTitleShow = props.isTitleShow,
      isTitleShow = _props$isTitleShow === void 0 ? true : _props$isTitleShow,
      _props$bootIntercom = props.bootIntercom,
      bootIntercom = _props$bootIntercom === void 0 ? true : _props$bootIntercom,
      onAuthorizeUser = props.onAuthorizeUser,
      _props$intercomChatSe = props.intercomChatSettings,
      intercomChatSettings = _props$intercomChatSe === void 0 ? DefalutIntercomSetting : _props$intercomChatSe;

  var _useState = useState$2({}),
      _useState2 = _slicedToArray(_useState, 2),
      userData = _useState2[0],
      setUserData = _useState2[1];

  var _useState3 = useState$2(''),
      _useState4 = _slicedToArray(_useState3, 2),
      helpLink = _useState4[0],
      setHelpLink = _useState4[1];

  var _useState5 = useState$2(false),
      _useState6 = _slicedToArray(_useState5, 2),
      showDialog = _useState6[0],
      setShowDialog = _useState6[1];

  var _useState7 = useState$2(''),
      _useState8 = _slicedToArray(_useState7, 2),
      intercomId = _useState8[0],
      setIntercomId = _useState8[1];

  var setIntercom = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee() {
      var _data$data, data;

      return regenerator.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 3;
              return ApiService.getIntercomId();

            case 3:
              data = _context.sent;
              setIntercomId((_data$data = data.data) === null || _data$data === void 0 ? void 0 : _data$data.chatbotAppId);
              _context.next = 10;
              break;

            case 7:
              _context.prev = 7;
              _context.t0 = _context["catch"](0);
              console.log('intercom:', _context.t0);

            case 10:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[0, 7]]);
    }));

    return function setIntercom() {
      return _ref.apply(this, arguments);
    };
  }();

  useEffect(function () {
    setIntercom();

    if (bootIntercom && !!intercomId) {
      var APP_ID = intercomId;

      (function () {
        var w = window;
        var ic = w.Intercom;

        if (typeof ic === 'function') {
          ic('reattach_activator');
          ic('update', w.intercomSettings);
        } else {
          var d = document;

          var i = function i() {
            i.c(arguments);
          };

          i.q = [];

          i.c = function (args) {
            i.q.push(args);
          };

          w.Intercom = i;

          var l = function l() {
            var s = d.createElement('script');
            s.type = 'text/javascript';
            s.async = true;
            s.src = 'https://widget.intercom.io/widget/' + APP_ID;
            var x = d.getElementsByTagName('script')[0];
            x.parentNode.insertBefore(s, x);
          };

          if (document.readyState === 'complete') {
            l();
          } else if (w.attachEvent) {
            w.attachEvent('onload', l);
          } else {
            w.addEventListener('load', l, false);
          }
        }
      })();

      window.intercomSettings = _objectSpread$4({
        app_id: APP_ID
      }, intercomChatSettings);
    }
  }, [bootIntercom, intercomChatSettings, intercomId]);
  useEffect(function () {
    if (bootIntercom && window.localStorage.getItem('authorizedUser') && !!intercomId) {
      try {
        var _window, _window$Intercom;

        var data = JSON.parse(window.localStorage.getItem('authorizedUser')); // eslint-disable-next-line

        (_window = window) === null || _window === void 0 ? void 0 : (_window$Intercom = _window.Intercom) === null || _window$Intercom === void 0 ? void 0 : _window$Intercom.call(_window, 'boot', {
          app_id: intercomId,
          email: data.email,
          name: data.displayName
        });
      } catch (e) {
        Logger.log('error initalizing intercom', e);
      }
    }

    return function () {
      var _window$Intercom2, _window2;

      // eslint-disable-next-line
      (_window$Intercom2 = (_window2 = window).Intercom) === null || _window$Intercom2 === void 0 ? void 0 : _window$Intercom2.call(_window2, 'shutdown');
    };
  }, [window.localStorage.getItem('authorizedUser'), bootIntercom, intercomChatSettings, intercomId]);

  var updateFavicon = function updateFavicon(iconURL) {
    var link = document.querySelector("link[rel*='icon']");
    link.href = iconURL;
    link.type = 'image/x-icon';
    link.rel = 'shortcut icon';
    document.getElementsByTagName('head')[0].appendChild(link);
  };

  useEffect(function () {
    if (!sessionStorage.getItem('isResMsgShown')) {
      var _window$matchMedia = window.matchMedia("(max-width: 1200px)"),
          matches = _window$matchMedia.matches;

      setShowDialog(matches);
    }
  }, []);

  var getUpdatedUser = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee2() {
      var authorizedUser;
      return regenerator.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              authorizedUser = AuthService.getUser();
              return _context2.abrupt("return", AuthService.authorize(authorizedUser, true));

            case 2:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function getUpdatedUser() {
      return _ref2.apply(this, arguments);
    };
  }();

  var getAvatar = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee3() {
      var userDataToSave;
      return regenerator.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.prev = 0;
              _context3.next = 3;
              return getUpdatedUser();

            case 3:
              userDataToSave = _context3.sent;
              setUserData(userDataToSave);

              if (onAuthorizeUser) {
                onAuthorizeUser(userDataToSave);
              }

              setDataDogSessionUser(userDataToSave);
              _context3.next = 12;
              break;

            case 9:
              _context3.prev = 9;
              _context3.t0 = _context3["catch"](0);
              console.error(_context3.t0);

            case 12:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, null, [[0, 9]]);
    }));

    return function getAvatar() {
      return _ref3.apply(this, arguments);
    };
  }();

  useEffect(function () {
    var getInitData = /*#__PURE__*/function () {
      var _ref4 = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee4() {
        var res;
        return regenerator.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return ApiService.getInitData();

              case 2:
                res = _context4.sent;
                setHelpLink(get$1(res, 'pages.help_url[0].url', ''));
                updateFavicon(res.smallLogoUrl || '');

              case 5:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }));

      return function getInitData() {
        return _ref4.apply(this, arguments);
      };
    }();

    getInitData();
    getAvatar();
  }, []);

  var storageEventHandler = function storageEventHandler() {
    getAvatar();
  };

  var closeDialog = function closeDialog() {
    setShowDialog(false);
    sessionStorage.setItem('isResMsgShown', 'true');
  };

  return /*#__PURE__*/React__default.createElement("div", null, !IS_LOCAL_ENV && /*#__PURE__*/React__default.createElement(UserInfoBreadCrumb, {
    userData: userData
  }), /*#__PURE__*/React__default.createElement(NavigationBar, {
    title: isTitleShow ? title : null,
    leftLogo: getLogo(leftLogo),
    titleTooltip: "".concat(title).concat(REACT_APP_VERSION ? ' · ' + REACT_APP_VERSION : ''),
    backButton: backButton,
    backHandler: backHandler,
    profileLogo: /*#__PURE__*/React__default.createElement("div", {
      className: "nav-bar__profile-logo"
    }, Boolean(userData === null || userData === void 0 ? void 0 : userData.organizationLogo) ? /*#__PURE__*/React__default.createElement("img", {
      src: userData === null || userData === void 0 ? void 0 : userData.organizationLogo
    }) : /*#__PURE__*/React__default.createElement(ProgressCircle, {
      className: "ml-2 mr-2",
      size: 24,
      borderWidth: 3
    })),
    profileAvatar: /*#__PURE__*/React__default.createElement("div", {
      className: "nav-bar__profile-avatar",
      style: (userData === null || userData === void 0 ? void 0 : (_userData$organizatio = userData.organizationName) === null || _userData$organizatio === void 0 ? void 0 : _userData$organizatio.length) < 10 ? {
        fontSize: '1rem',
        lineHeight: '24/16+rem'
      } : {}
    }, /*#__PURE__*/React__default.createElement("span", {
      className: styles$3.profileAvatarLabel,
      title: userData === null || userData === void 0 ? void 0 : userData.organizationName
    }, userData === null || userData === void 0 ? void 0 : userData.organizationName)),
    popupContent: function popupContent(open) {
      return /*#__PURE__*/React__default.createElement(PopupContent, {
        userData: userData,
        open: open
      });
    },
    isElevated: isElevated
  }, /*#__PURE__*/React__default.createElement(NavbarContent, {
    helpLink: helpLink
  }, children), /*#__PURE__*/React__default.createElement("button", {
    className: styles$3.storageEventTrigger,
    onClick: storageEventHandler,
    id: "hiddenBtn"
  }, "Hidden Button")), showDialog === true && /*#__PURE__*/createPortal( /*#__PURE__*/React__default.createElement("div", {
    className: "msg-responsive"
  }, /*#__PURE__*/React__default.createElement(Dialog, {
    open: true,
    className: styles$3.dialog,
    onClickOutside: closeDialog
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "text-center"
  }, /*#__PURE__*/React__default.createElement(Icon, {
    name: 'responsiveMessage',
    className: "img-msg"
  }), /*#__PURE__*/React__default.createElement("h2", null, "Want a better Experience?"), /*#__PURE__*/React__default.createElement("p", null, "Use a tablet or computer for a better and smoother platform experience."), /*#__PURE__*/React__default.createElement(Button, {
    className: "btn-square _conflower-blue _filled _md",
    onClick: closeDialog
  }, "Ok, Got It")))), document.body));
};

var css_248z$5 = ":root {\n  --primary1: #123787;\n  --primary2: #1d58d7;\n  --primary3: #5173fb;\n  --primary4: #7a93ff;\n  --primary5: #c2d0ff;\n  --primary6: #e5ebff;\n  --primary7: #f2f5ff; }\n\n@keyframes index-module_hover-ripples__2m6qN {\n  0% {\n    top: -0.1875em;\n    left: -0.1875em;\n    right: -0.1875em;\n    bottom: -0.1875em;\n    opacity: 1; }\n  100% {\n    top: -0.8125em;\n    left: -0.8125em;\n    right: -0.8125em;\n    bottom: -0.8125em;\n    opacity: 0; } }\n\n.index-module_wrapper__AIQeS {\n  display: flex;\n  position: static;\n  height: auto;\n  left: 0;\n  top: 0;\n  width: 100vw;\n  padding-top: 3.75rem; }\n  @media (max-width: 1200px) {\n    .index-module_wrapper__AIQeS {\n      z-index: 1;\n      height: auto; } }\n  .index-module_wrapper__AIQeS .index-module_topBar__zDn1P {\n    position: fixed;\n    height: 3.75rem;\n    top: 0;\n    left: 0;\n    width: 100vw;\n    z-index: 2;\n    background-color: #ffffff;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    padding: 0.75rem 2rem;\n    box-shadow: 0px 8px 18px rgba(0, 0, 0, 0.05), 0px 0px 8px rgba(0, 0, 0, 0.04);\n    font-family: 'Avenir Next Regular', sans-serif;\n    font-weight: normal; }\n    .index-module_wrapper__AIQeS .index-module_topBar__zDn1P .index-module_orgInfoContainer__3FfN1 {\n      display: flex;\n      align-items: center; }\n      .index-module_wrapper__AIQeS .index-module_topBar__zDn1P .index-module_orgInfoContainer__3FfN1 .index-module_largeLogo__l7iiy {\n        height: 2.25rem; }\n    @media (min-width: 992px) {\n      .index-module_wrapper__AIQeS .index-module_topBar__zDn1P .index-module_navToggler__3ZFdW {\n        display: none; } }\n    .index-module_wrapper__AIQeS .index-module_topBar__zDn1P .index-module_overlay__2mfT9 {\n      position: fixed;\n      top: 0;\n      left: 0;\n      width: 100%;\n      height: 100vh;\n      background-color: #000000;\n      opacity: 0.25;\n      z-index: 99; }\n    .index-module_wrapper__AIQeS .index-module_topBar__zDn1P .index-module_headerUrlsContainer__1YyCa {\n      position: fixed;\n      right: 0;\n      background: #ffffff;\n      width: 90%;\n      height: 100vh;\n      top: 0;\n      padding: 0;\n      transition: transform 0.3s ease-in-out;\n      z-index: 100;\n      transform: translateX(100%); }\n      .index-module_wrapper__AIQeS .index-module_topBar__zDn1P .index-module_headerUrlsContainer__1YyCa .index-module_sidebarHeader__1eHwq {\n        display: flex;\n        align-items: center;\n        justify-content: space-between;\n        padding: 0.75rem 2rem;\n        box-shadow: 0px 8px 18px rgba(0, 0, 0, 0.05), 0px 0px 8px rgba(0, 0, 0, 0.04); }\n        @media (min-width: 992px) {\n          .index-module_wrapper__AIQeS .index-module_topBar__zDn1P .index-module_headerUrlsContainer__1YyCa .index-module_sidebarHeader__1eHwq {\n            display: none; } }\n        .index-module_wrapper__AIQeS .index-module_topBar__zDn1P .index-module_headerUrlsContainer__1YyCa .index-module_sidebarHeader__1eHwq .index-module_close__2IyiH.btn-circle {\n          background-color: inherit; }\n      .index-module_wrapper__AIQeS .index-module_topBar__zDn1P .index-module_headerUrlsContainer__1YyCa ul {\n        display: flex;\n        align-items: center;\n        justify-content: flex-end;\n        flex-direction: row;\n        padding: 0; }\n        .index-module_wrapper__AIQeS .index-module_topBar__zDn1P .index-module_headerUrlsContainer__1YyCa ul li {\n          margin-left: 1.5rem; }\n          .index-module_wrapper__AIQeS .index-module_topBar__zDn1P .index-module_headerUrlsContainer__1YyCa ul li a {\n            font-family: 'Avenir Next Regular', sans-serif;\n            font-weight: normal;\n            text-decoration: none;\n            color: var(--primary2);\n            font-size: 0.875rem; }\n        @media (max-width: 992px) {\n          .index-module_wrapper__AIQeS .index-module_topBar__zDn1P .index-module_headerUrlsContainer__1YyCa ul {\n            align-items: flex-start;\n            flex-direction: column;\n            padding: 1rem 2rem; }\n            .index-module_wrapper__AIQeS .index-module_topBar__zDn1P .index-module_headerUrlsContainer__1YyCa ul li {\n              margin-top: 1rem;\n              margin-left: 0; } }\n      @media (min-width: 992px) {\n        .index-module_wrapper__AIQeS .index-module_topBar__zDn1P .index-module_headerUrlsContainer__1YyCa {\n          display: flex !important;\n          flex-basis: auto;\n          position: static;\n          right: unset;\n          background-color: inherit;\n          width: auto;\n          height: auto;\n          top: unset;\n          transform: unset; } }\n\n.index-module_showSidebar__3Z3gm {\n  transform: translateX(0) !important; }\n  .index-module_showSidebar__3Z3gm .index-module_headerOrgName__2-iNA {\n    max-width: 9.375rem;\n    font-size: 1rem; }\n\n.index-module_headerOrgName__2-iNA {\n  font-family: 'Avenir Next Demi', sans-serif;\n  font-weight: normal;\n  letter-spacing: .2px;\n  font-size: 1.25rem;\n  line-height: 2rem;\n  color: #000000;\n  margin-left: 1rem;\n  max-width: 12.5rem; }\n  .index-module_headerOrgName__2-iNA .tooltipV2.tooltipV2_bottom.tooltipV2_visible .tooltipV2__label {\n    transform: translateY(0) translateX(-21%); }\n";
var styles$4 = {"wrapper":"index-module_wrapper__AIQeS","topBar":"index-module_topBar__zDn1P","orgInfoContainer":"index-module_orgInfoContainer__3FfN1","largeLogo":"index-module_largeLogo__l7iiy","navToggler":"index-module_navToggler__3ZFdW","overlay":"index-module_overlay__2mfT9","headerUrlsContainer":"index-module_headerUrlsContainer__1YyCa","sidebarHeader":"index-module_sidebarHeader__1eHwq","close":"index-module_close__2IyiH","showSidebar":"index-module_showSidebar__3Z3gm","headerOrgName":"index-module_headerOrgName__2-iNA","hover-ripples":"index-module_hover-ripples__2m6qN"};
styleInject(css_248z$5);

var customerLogoURL = "".concat(ORIGIN_URL, "/api/v3/ua/logo");

var SimpleHeader = function SimpleHeader(props) {
  var _initData$pages, _initData$pages$heade;

  var docTitle = props.docTitle,
      setParentInitData = props.setParentInitData,
      _props$for404Page = props.for404Page,
      for404Page = _props$for404Page === void 0 ? false : _props$for404Page;

  var _useState = useState$2({}),
      _useState2 = _slicedToArray(_useState, 2),
      initData = _useState2[0],
      setInitData = _useState2[1];

  var _useState3 = useState$2(false),
      _useState4 = _slicedToArray(_useState3, 2),
      isSidebarOpen = _useState4[0],
      setIsSidebarOpen = _useState4[1];

  var history = useHistory();

  var updateFavicon = function updateFavicon() {
    var iconURL = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    var link = document.querySelector("link[rel*='icon']");
    link.href = iconURL;
    link.type = 'image/x-icon';
    link.rel = 'shortcut icon';
    document.getElementsByTagName('head')[0].appendChild(link);
  };

  var toggleSidebar = function toggleSidebar() {
    return setIsSidebarOpen(function (state) {
      return !state;
    });
  };

  useEffect(function () {
    var getInitData = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee() {
        var res;
        return regenerator.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return ApiService.getInitData();

              case 2:
                res = _context.sent;

                if (res != null) {
                  setInitData(res);

                  if (setParentInitData) {
                    setParentInitData(res);
                  }

                  document.title = "".concat(docTitle, " | ").concat(res.organizationName);
                  updateFavicon(res.smallLogoUrl);
                } else {
                  if (!for404Page) {
                    history.push('/404');
                  }
                }

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function getInitData() {
        return _ref.apply(this, arguments);
      };
    }();

    getInitData(); // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [docTitle, history]);
  return /*#__PURE__*/React__default.createElement("div", {
    className: styles$4.wrapper
  }, /*#__PURE__*/React__default.createElement("div", {
    className: styles$4.topBar
  }, /*#__PURE__*/React__default.createElement("div", {
    className: styles$4.orgInfoContainer
  }, initData.largeLogoUrl === '' && /*#__PURE__*/React__default.createElement(ProgressCircle, {
    size: 36
  }), initData.largeLogoUrl !== '' && initData.largeLogoUrl !== null && /*#__PURE__*/React__default.createElement("img", {
    src: customerLogoURL,
    alt: "Company logo",
    className: styles$4.largeLogo
  }), (initData.largeLogoUrl === null || initData.isIncludeOrganizationName) && /*#__PURE__*/React__default.createElement("div", {
    className: styles$4.headerOrgName
  }, /*#__PURE__*/React__default.createElement(SmartText, {
    tooltipParams: {
      position: 'bottom',
      auto: false
    },
    label: initData.organizationName
  }))), /*#__PURE__*/React__default.createElement(ButtonCircle, {
    "aria-controls": "basic-navbar-nav",
    type: "button",
    "aria-label": "Toggle navigation",
    className: "".concat(styles$4.navToggler, " navbar-toggler"),
    onClick: toggleSidebar,
    iconName: "Menu"
  }), isSidebarOpen && /*#__PURE__*/React__default.createElement("div", {
    className: styles$4.overlay
  }), /*#__PURE__*/React__default.createElement("div", {
    className: "".concat(styles$4.headerUrlsContainer, " ").concat(isSidebarOpen ? styles$4.showSidebar : '', " navbar-collapse collapse")
  }, /*#__PURE__*/React__default.createElement("div", {
    className: styles$4.sidebarHeader
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "".concat(styles$4.orgInfoContainer, " ").concat(styles$4.inner)
  }, initData.largeLogoUrl === '' && /*#__PURE__*/React__default.createElement(ProgressCircle, {
    size: 36
  }), initData.largeLogoUrl !== '' && initData.largeLogoUrl !== null && /*#__PURE__*/React__default.createElement("img", {
    src: customerLogoURL,
    alt: "Company logo",
    className: styles$4.largeLogo
  }), (initData.largeLogoUrl === null || initData.isIncludeOrganizationName) && /*#__PURE__*/React__default.createElement("div", {
    className: styles$4.headerOrgName
  }, /*#__PURE__*/React__default.createElement(SmartText, {
    tooltipParams: {
      position: 'bottom',
      auto: false
    },
    label: initData.organizationName
  }))), /*#__PURE__*/React__default.createElement(ButtonCircle, {
    iconName: "Close",
    className: styles$4.close,
    onClick: toggleSidebar
  })), /*#__PURE__*/React__default.createElement("ul", null, (_initData$pages = initData.pages) === null || _initData$pages === void 0 ? void 0 : (_initData$pages$heade = _initData$pages.header) === null || _initData$pages$heade === void 0 ? void 0 : _initData$pages$heade.map(function (headerObj) {
    return /*#__PURE__*/React__default.createElement("li", null, /*#__PURE__*/React__default.createElement("a", {
      target: "_blank",
      href: headerObj.url
    }, headerObj.label));
  })))));
};

SimpleHeader.propTypes = {
  docTitle: PropTypes.string.isRequired,
  setParentInitData: PropTypes.func,
  for404Page: PropTypes.bool
};

function _createSuper$5(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$5(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct$5() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
var TableWithOptionsContext = /*#__PURE__*/React__default.createContext({
  allColumns: [],
  selectedColumns: [],
  onColumnsChanged: function onColumnsChanged() {}
});
var TableBaseRoot = /*#__PURE__*/function (_React$Component) {
  _inherits(TableBaseRoot, _React$Component);

  var _super = _createSuper$5(TableBaseRoot);

  function TableBaseRoot() {
    _classCallCheck(this, TableBaseRoot);

    return _super.apply(this, arguments);
  }

  _createClass(TableBaseRoot, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          _this$props$allColumn = _this$props.allColumns,
          allColumns = _this$props$allColumn === void 0 ? [] : _this$props$allColumn,
          _this$props$selectedC = _this$props.selectedColumns,
          selectedColumns = _this$props$selectedC === void 0 ? [] : _this$props$selectedC,
          _this$props$onColumns = _this$props.onColumnsChanged,
          onColumnsChanged = _this$props$onColumns === void 0 ? function () {} : _this$props$onColumns,
          _this$props$dataReque = _this$props.dataRequest,
          dataRequest = _this$props$dataReque === void 0 ? {} : _this$props$dataReque,
          _this$props$csvDownlo = _this$props.csvDownloadRequest,
          csvDownloadRequest = _this$props$csvDownlo === void 0 ? {} : _this$props$csvDownlo,
          _this$props$transform = _this$props.transformCSVDownloadRequest,
          transformCSVDownloadRequest = _this$props$transform === void 0 ? null : _this$props$transform,
          children = _this$props.children;
      return /*#__PURE__*/React__default.createElement(TableWithOptionsContext.Provider, {
        value: {
          allColumns: allColumns,
          selectedColumns: selectedColumns,
          onColumnsChanged: onColumnsChanged,
          dataRequest: dataRequest,
          csvDownloadRequest: csvDownloadRequest,
          transformCSVDownloadRequest: transformCSVDownloadRequest
        }
      }, children);
    }
  }]);

  return TableBaseRoot;
}(React__default.Component);
TableBaseRoot.propTypes = {
  allColumns: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string.required,
    value: PropTypes.string.required
  })),
  selectedColumns: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string.required,
    value: PropTypes.string.required
  })),
  onColumnsChanged: PropTypes.func,
  dataRequest: PropTypes.shape({
    url: PropTypes.string.isRequired,
    method: PropTypes.oneOf(['get', 'post']),
    data: PropTypes.object,
    params: PropTypes.object,
    headers: PropTypes.object
  }).isRequired,
  transformCSVDownloadRequest: PropTypes.func,
  csvDownloadRequest: PropTypes.shape({
    url: PropTypes.string.isRequired,
    method: PropTypes.oneOf(['get', 'post']),
    data: PropTypes.object,
    params: PropTypes.object,
    headers: PropTypes.object
  })
};

function ownKeys$5(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$5(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$5(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$5(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _createSuper$6(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$6(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct$6() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
var columnsGroupMapper = {
  Spending: ['spent', 'dataCost', 'mediaSpent'],
  Budget: ['maxBid', 'budgetDay', 'budgetTotal', 'percentageOfTotalSpent'],
  Counts: ['impressions', 'clicks', 'reach'],
  Rates: ['conversionRate', 'winRate', 'CTR', 'VCR', 'frequency', 'spentDistribution', 'pixalateViewAbility'],
  Cost: ['eCPM', 'eCPC', 'eCPCV'],
  Video: ['startCount', 'firstCount', 'midCount', 'thirdCount', 'completeCount', 'audioVideoViewed'],
  'Date & Time': ['timezone', 'startTime', 'endTime', 'date']
};
var TableSortedOptions = /*#__PURE__*/function (_React$Component) {
  _inherits(TableSortedOptions, _React$Component);

  var _super = _createSuper$6(TableSortedOptions);

  function TableSortedOptions(props, context) {
    var _this;

    _classCallCheck(this, TableSortedOptions);

    _this = _super.call(this, props, context);

    _this.handleChange = function (newValues, selectedItem) {
      var _this$props = _this.props,
          selectedColumns = _this$props.selectedColumns,
          addcols = _this$props.addcols,
          transformColumnsOrder = _this$props.transformColumnsOrder;
      var allColumnsState = _this.state.allColumnsState;
      var alwaysEnabledColumns = allColumnsState.filter(function (column) {
        return column.alwaysEnabled && (!selectedItem || selectedItem.value !== column.value);
      }); // no selected item when clicked select/deselect all

      newValues = selectedItem && selectedColumns ? _toConsumableArray(selectedColumns) : newValues;

      var _newValues$reduce = newValues.reduce(function (result, value) {
        if (value.isGroupTitle) {
          result.headers.push(value);
        } else {
          result.columns.push(value);
        }

        return result;
      }, {
        columns: [],
        headers: []
      }),
          columns = _newValues$reduce.columns,
          headers = _newValues$reduce.headers;

      var resultCols = [];

      if (selectedItem) {
        // action: clicked group header column
        if (selectedItem.options) {
          // select item
          if (!selectedItem.isActive) {
            // get column order
            var orderedColumnValues = transformColumnsOrder ? transformColumnsOrder(getCols(addcols)) : getCols(addcols);
            selectedItem.options.forEach(function (groupSelectedColumn) {
              // find selected column index of all available columns
              var selectedColumnIndex = orderedColumnValues.findIndex(function (columnValue) {
                return columnValue === groupSelectedColumn.value;
              }); // slice columns before the selected column

              var previousColumns = orderedColumnValues.slice(0, selectedColumnIndex).reverse();
              var destinationIndex; // find the closest column from selected columns

              previousColumns.forEach(function (columnValue, index) {
                if (!destinationIndex) {
                  var columnIndex = columns.findIndex(function (column) {
                    return column.value === columnValue;
                  });

                  if (~columnIndex) {
                    destinationIndex = columnIndex;
                  }
                }
              }); // remove groupSelectedColumn from the selected columns

              columns = columns.filter(function (column) {
                return column.value !== groupSelectedColumn.value;
              }); // add groupSelectedColumn after the closest column

              columns = [].concat(_toConsumableArray(columns.slice(0, destinationIndex + 1)), [groupSelectedColumn], _toConsumableArray(columns.slice(destinationIndex + 1)));
            });
            columns = [].concat(_toConsumableArray(columns), _toConsumableArray(headers), [// add header column
            _objectSpread$5(_objectSpread$5({}, selectedItem), {}, {
              options: null
            })]);
          } else {
            var selectedGroupColumnsMap = selectedItem.options.reduce(function (selectedGroupColumnsMap, column) {
              selectedGroupColumnsMap[column.value] = true;
              return selectedGroupColumnsMap;
            }, _defineProperty({}, selectedItem.value, true));
            columns = columns.filter(function (column) {
              var columnValue = column.value;
              return columnValue !== selectedItem.value && !selectedGroupColumnsMap[columnValue];
            });
            headers.forEach(function (headerColumn) {
              var values = columnsGroupMapper[headerColumn.value];

              if (values) {
                // if all columns are selected, add the group into result
                if (!values.find(function (value) {
                  return selectedGroupColumnsMap[value];
                })) {
                  columns.push(headerColumn);
                }
              }
            });
          }
        } else {
          if (!selectedItem.isActive) {
            var _orderedColumnValues = transformColumnsOrder ? transformColumnsOrder(getCols(addcols)) : getCols(addcols);

            var selectedColumnIndex = _orderedColumnValues.findIndex(function (columnValue) {
              return columnValue === selectedItem.value;
            }); // slice columns before the selected column


            var previousColumns = _orderedColumnValues.slice(0, selectedColumnIndex).reverse();

            var destinationIndex; // find the closest column from selected columns

            previousColumns.forEach(function (columnValue, index) {
              if (!destinationIndex) {
                var columnIndex = columns.findIndex(function (column) {
                  return column.value === columnValue;
                });

                if (~columnIndex) {
                  destinationIndex = columnIndex;
                }
              }
            }); // remove groupSelectedColumn from the selected columns

            columns = columns.filter(function (column) {
              return column.value !== selectedItem.value;
            }); // add groupSelectedColumn after the closest column

            columns = [].concat(_toConsumableArray(columns.slice(0, destinationIndex + 1)), [selectedItem], _toConsumableArray(columns.slice(destinationIndex + 1)));
          } else {
            columns = _toConsumableArray(columns.filter(function (c) {
              return c.value !== selectedItem.value;
            }));
            headers.forEach(function (groupCol) {
              var values = columnsGroupMapper[groupCol.value];

              if (values) {
                if (!values.find(function (v) {
                  return selectedItem.value === v;
                })) {
                  columns.push(groupCol);
                }
              }
            });
          }
        }
      } else {
        columns = [].concat(_toConsumableArray(alwaysEnabledColumns), _toConsumableArray(columns), _toConsumableArray(headers));
      }

      resultCols = _toConsumableArray(columns);

      if (!resultCols.length && alwaysEnabledColumns.length) {
        resultCols = _toConsumableArray(alwaysEnabledColumns);
      }

      _this.context.onColumnsChanged && _this.context.onColumnsChanged(resultCols);
    };

    _this.createGroupedList = function () {
      var _this$context = _this.context,
          allColumns = _this$context.allColumns,
          selectedColumns = _this$context.selectedColumns;
      var result = [];
      var alwaysEnabledItems = [];
      var groupedResult = {};
      var selectedGroups = [];
      var groupMap = {};

      if (_this.props.additionalGroupMap) {
        groupMap = Object.keys(_this.props.additionalGroupMap).reduce(function (groupMap, groupName) {
          groupMap[groupName] = _this.props.additionalGroupMap[groupName].reduce(function (groupMap, value) {
            groupMap[value] = true;
            return groupMap;
          }, {});
          return groupMap;
        }, {});
      }

      Object.keys(columnsGroupMapper).reduce(function (groupMap, groupName) {
        groupMap[groupName] = columnsGroupMapper[groupName].reduce(function (groupMap, value) {
          groupMap[value] = true;
          return groupMap;
        }, {});
        return groupMap;
      }, groupMap);
      allColumns.forEach(function (column) {
        var isColumnWithGroup = false;

        for (var key in groupMap) {
          if (groupMap[key][column.value]) {
            if (!groupedResult[key]) {
              groupedResult[key] = [];
            }

            isColumnWithGroup = true;
            groupedResult[key].push(column);
          }
        }

        if (!isColumnWithGroup && selectedColumns.find(function (i) {
          return i.value === column.value;
        })) {
          alwaysEnabledItems.push(column);
        }
      });

      for (var key in groupedResult) {
        result.push({
          value: key,
          label: key,
          isGroupTitle: true,
          options: groupedResult[key]
        });
      }

      _this.setState({
        groupedItems: result,
        selectedGroups: selectedGroups,
        alwaysEnabledItems: alwaysEnabledItems
      });
    };

    _this.getSelectedColumns = function () {
      var selectedColumns = _this.context.selectedColumns;
      var selectedGroupsLabels = [];
      var selectedValues = selectedColumns.map(function (col) {
        return col.value;
      });
      var columnsGroupMapperLabels = Object.keys(columnsGroupMapper);
      columnsGroupMapperLabels.forEach(function (label) {
        // if all items of group are selected
        if (columnsGroupMapper[label].every(function (groupValue) {
          return selectedValues.indexOf(groupValue) !== -1;
        })) {
          // if group is not selected (active) yet
          if (!selectedColumns.some(function (col) {
            return col.label === label;
          })) {
            selectedGroupsLabels.push(label);
          }
        }
      });
      return [].concat(_toConsumableArray(selectedColumns), _toConsumableArray(selectedGroupsLabels.length ? selectedGroupsLabels.map(function (label) {
        return {
          label: label,
          value: label,
          isGroupTitle: true
        };
      }) : []));
    };

    _this.getCountWithoutHeader = function (selectedColumns) {
      return selectedColumns.filter(function (col) {
        return !col.isGroupTitle;
      });
    };

    _this.getFilterCount = function (selectedColumns) {
      return selectedColumns.filter(function (col) {
        return col.alwaysEnabled !== true && col.isGroupTitle !== true && col.excludeFromSortCount !== true;
      });
    };

    _this.getPlaceholder = function (selectedColumns) {
      return function () {
        return "".concat(_this.getFilterCount(selectedColumns).length, " Selected");
      };
    };

    _this.state = {
      groupedItems: [],
      alwaysEnabledItems: [],
      allColumnsState: context.allColumns
    };
    return _this;
  }

  _createClass(TableSortedOptions, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.createGroupedList();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      var allColumns = this.context.allColumns;
      var allColumnsState = this.state.allColumnsState;

      if (!isEqual(allColumns, allColumnsState)) {
        this.setState({
          allColumnsState: allColumns
        });
        this.createGroupedList();
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props2 = this.props,
          _this$props2$selectPr = _this$props2.selectProps,
          selectProps = _this$props2$selectPr === void 0 ? {} : _this$props2$selectPr,
          _this$props2$tooltipP = _this$props2.tooltipPosition,
          tooltipPosition = _this$props2$tooltipP === void 0 ? 'left' : _this$props2$tooltipP;
      var groupedItems = this.state.groupedItems;
      var className = "table__columns ".concat(selectProps.className || '');
      var selectedColumns = this.getSelectedColumns();
      return /*#__PURE__*/React__default.createElement(Select, _extends({
        onChange: this.handleChange,
        options: groupedItems,
        value: selectedColumns,
        isMulti: true,
        isMenu: true,
        renderMenuTarget: function renderMenuTarget() {
          return /*#__PURE__*/React__default.createElement(ButtonCircle, {
            type: "button",
            className: "opener__btn",
            iconName: "ViewColumn"
          }, selectedColumns && selectedColumns.length > 0 && /*#__PURE__*/React__default.createElement("span", {
            className: "table__columns-menu-badge"
          }, _this2.getFilterCount(selectedColumns).length));
        },
        multiPlaceholder: this.getPlaceholder(selectedColumns),
        allSelectable: true,
        hideCrossIfClosed: true,
        showValueOnOpen: true,
        showControlLabel: true,
        allSelectedText: 'All Selected',
        tooltipParams: {
          label: 'Select and order the columns to include in the table',
          auto: false,
          position: tooltipPosition
        },
        className: className,
        menuClassName: "table-menu-width"
      }, selectProps));
    }
  }]);

  return TableSortedOptions;
}(React__default.Component);
TableSortedOptions.contextType = TableWithOptionsContext;
var ColumnOptions = {
  ColumnId: {
    value: 'id',
    label: 'ID',
    alwaysEnabled: true,
    draggableGroup: 1
  },
  ColumnCheckbox: {
    value: 'checkbox',
    label: '',
    alwaysEnabled: true,
    draggableGroup: 1
  },
  ColumnCampaignName: {
    value: 'campaignName',
    label: 'Campaign Name',
    alwaysEnabled: true,
    draggableGroup: 1
  },
  ColumnMaxBid: {
    value: 'maxBid',
    label: 'Max Bid($)',
    draggableGroup: 1
  },
  ColumnBudget: {
    value: 'budget',
    label: 'Budget($)'
  },
  ColumnDailyBudget: {
    value: 'budgetDay',
    label: 'Daily Budget($)',
    draggableGroup: 1
  },
  ColumnTotalBudget: {
    value: 'budgetTotal',
    label: 'Total Budget($)',
    draggableGroup: 1
  },
  ColumnTotalSpent: {
    value: 'spent',
    label: 'Total Spent($)'
  },
  ColumnSpentDistribution: {
    value: 'spentDistribution',
    label: 'Spent Distribution(%)'
  },
  ColumnStartDate: {
    value: 'startTime',
    label: 'Start date',
    draggableGroup: 1
  },
  ColumnEndDate: {
    value: 'endTime',
    label: 'End date',
    draggableGroup: 1
  },
  ColumnImpressions: {
    value: 'impressions',
    label: 'Impressions'
  },
  ColumnReach: {
    value: 'reach',
    label: 'Reach'
  },
  ColumnFrequency: {
    value: 'frequency',
    label: 'Frequency'
  },
  ColumnCreated: {
    value: 'created',
    label: 'Created'
  },
  ColumnModified: {
    value: 'modified',
    label: 'Modified'
  },
  ColumnGoal: {
    value: 'campaignType',
    label: 'Goal'
  },
  // previously 'Type'
  ColumnEcpm: {
    value: 'eCPM',
    label: 'eCPM($)'
  },
  ColumnEcpc: {
    value: 'eCPC',
    label: 'eCPC($)'
  },
  ColumnClicks: {
    value: 'clicks',
    label: 'Clicks'
  },
  ColumnConversionCount: {
    label: 'Conversions',
    value: 'conversionCount'
  },
  ColumnConversionRate: {
    label: 'Conversion Rate(%)',
    value: 'conversionRate'
  },
  ColumnWinrate: {
    value: 'winRate',
    label: 'WinRate(%)'
  },
  ColumnCtr: {
    value: 'CTR',
    label: 'CTR(%)'
  },
  ColumnViewability: {
    value: 'pixalateViewAbility',
    label: 'Viewability(%)'
  },
  ColumnDataCost: {
    value: 'dataCost',
    label: 'Data Cost($)'
  },
  ColumnMediaSpent: {
    value: 'mediaSpent',
    label: 'Media Spent($)'
  },
  ColumnTotalSpentPercent: {
    value: 'percentageOfTotalSpent',
    label: 'Total Spent(%)'
  },
  ColumnVcr: {
    value: 'VCR',
    label: 'VCR(%)'
  },
  ColumnStartCount: {
    value: 'startCount',
    label: 'Video Start'
  },
  ColumnFirstCount: {
    value: 'firstCount',
    label: 'Video 25%'
  },
  ColumnMidCount: {
    value: 'midCount',
    label: 'Video 50%'
  },
  ColumnThirdCount: {
    value: 'thirdCount',
    label: 'Video 75%'
  },
  ColumnCompleteCount: {
    value: 'completeCount',
    label: 'Video 100%'
  },
  ColumnCpcv: {
    value: 'eCPCV',
    label: 'CPCV($)'
  },
  ColumnAge: {
    label: 'Age Group',
    value: 'age'
  },
  ColumnGender: {
    label: 'Gender',
    value: 'gender'
  },
  ColumnIncomeGroup: {
    label: 'Income Range',
    value: 'incomeRange'
  },
  ColumnEthnicity: {
    label: 'Ethnicity',
    value: 'ethnicity'
  },
  ColumnLanguage: {
    label: 'Language',
    value: 'language'
  },
  ColumnCampaignGroupName: {
    label: 'Campaign Group Name',
    value: 'campaignGroupName'
  },
  ColumnHoursViewed: {
    label: 'Hours Viewed',
    value: 'audioVideoViewed'
  }
};

function getCols() {
  var addcols = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  return [].concat(_toConsumableArray(addcols), [ColumnOptions.ColumnReach.value, ColumnOptions.ColumnImpressions.value, ColumnOptions.ColumnClicks.value, ColumnOptions.ColumnConversionCount.value, ColumnOptions.ColumnConversionRate.value, ColumnOptions.ColumnMediaSpent.value, ColumnOptions.ColumnTotalSpent.value, ColumnOptions.ColumnDataCost.value, ColumnOptions.ColumnFrequency.value, ColumnOptions.ColumnWinrate.value, ColumnOptions.ColumnCtr.value, ColumnOptions.ColumnVcr.value, ColumnOptions.ColumnViewability.value, ColumnOptions.ColumnEcpc.value, ColumnOptions.ColumnEcpm.value, ColumnOptions.ColumnCpcv.value, ColumnOptions.ColumnStartCount.value, ColumnOptions.ColumnFirstCount.value, ColumnOptions.ColumnMidCount.value, ColumnOptions.ColumnThirdCount.value, ColumnOptions.ColumnCompleteCount.value, ColumnOptions.ColumnHoursViewed.value]);
}

var SkeletonBlock = function SkeletonBlock(props) {
  var style = props.style,
      tag = props.tag;
  return tag ? /*#__PURE__*/React__default.createElement(tag, {
    className: 'skeleton-block',
    style: style
  }, null) : /*#__PURE__*/React__default.createElement("div", {
    className: "skeleton-block",
    style: style
  });
};

var Skeleton = function Skeleton(_ref) {
  var _ref$colN = _ref.colN,
      colN = _ref$colN === void 0 ? 10 : _ref$colN,
      _ref$rowN = _ref.rowN,
      rowN = _ref$rowN === void 0 ? 10 : _ref$rowN,
      _ref$classes = _ref.classes,
      classes = _ref$classes === void 0 ? [] : _ref$classes,
      theadRowHeight = _ref.theadRowHeight,
      tbodyRowHeight = _ref.tbodyRowHeight;
  var table = {};

  var colArr = _toConsumableArray(new Array(colN));

  var rowArr = _toConsumableArray(new Array(rowN));

  var skeleton = /*#__PURE__*/React__default.createElement(SkeletonBlock, {
    style: {
      width: '100%',
      height: "".concat(17 / 16, "rem")
    }
  });
  table.header = colArr.map(function (value, index) {
    return {
      label: skeleton,
      className: classes[index] || ''
    };
  });
  table.body = colArr.map(function (item, index) {
    return {
      key: index,
      className: classes[index] || ''
    };
  });
  table.data = rowArr.map(function () {
    return colArr.reduce(function (acc, item, i) {
      acc[i] = skeleton;
      return acc;
    }, {});
  });
  return /*#__PURE__*/React__default.createElement("div", {
    className: "no-interaction",
    style: {
      width: '100%'
    }
  }, /*#__PURE__*/React__default.createElement(Table, {
    className: "_skeleton",
    header: table.header,
    body: table.body,
    data: table.data,
    fixedHeader: false,
    rowKeyExtractor: function rowKeyExtractor(data, rowIndex) {
      return "".concat(data.id, "_").concat(rowIndex);
    },
    enableContextMenu: false,
    theadRowHeight: theadRowHeight,
    tbodyRowHeight: tbodyRowHeight
  }));
};

function ownKeys$6(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$6(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$6(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$6(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var config$1 = getConfig();

var TableApi = /*#__PURE__*/function () {
  function TableApi() {
    _classCallCheck(this, TableApi);
  }

  _createClass(TableApi, [{
    key: "fetchData",
    value: function fetchData(_ref) {
      var url = _ref.url,
          _ref$method = _ref.method,
          method = _ref$method === void 0 ? 'post' : _ref$method,
          _ref$params = _ref.params,
          params = _ref$params === void 0 ? {} : _ref$params,
          _ref$data = _ref.data,
          data = _ref$data === void 0 ? {} : _ref$data,
          _ref$headers = _ref.headers,
          headers = _ref$headers === void 0 ? {} : _ref$headers;
      var source = axios.CancelToken.source();

      try {
        var user = AuthService.getUser();
        if (!user) return null;
        var request = axios({
          url: url,
          headers: headers,
          data: data,
          params: params,
          method: method,
          cancelToken: source.token
        });
        return {
          promise: request,
          source: source,
          requestTimestamp: Date.now()
        };
      } catch (e) {
        throw new ServerError(e);
      }
    }
  }, {
    key: "downloadCSV",
    value: function () {
      var _downloadCSV = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee(data) {
        var user, response;
        return regenerator.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                user = AuthService.getUser();

                if (user) {
                  _context.next = 4;
                  break;
                }

                return _context.abrupt("return", null);

              case 4:
                _context.next = 6;
                return axios({
                  url: "".concat(config$1.EXPORT_DOWNLOAD_URL, "/").concat(data.url.includes('bidModel') ? 'bidModel/csv' : 'csv'),
                  method: 'post',
                  headers: getHeaders(user),
                  data: _objectSpread$6(_objectSpread$6({}, data), {}, {
                    token: user.apiToken
                  })
                });

              case 6:
                response = _context.sent;
                return _context.abrupt("return", response.data.responseURL);

              case 10:
                _context.prev = 10;
                _context.t0 = _context["catch"](0);
                throw new SyntaxError(_context.t0);

              case 13:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[0, 10]]);
      }));

      function downloadCSV(_x) {
        return _downloadCSV.apply(this, arguments);
      }

      return downloadCSV;
    }()
  }, {
    key: "downloadXLSX",
    value: function () {
      var _downloadXLSX = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee2(data) {
        var user, response;
        return regenerator.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                user = AuthService.getUser();

                if (user) {
                  _context2.next = 4;
                  break;
                }

                return _context2.abrupt("return", null);

              case 4:
                _context2.next = 6;
                return axios({
                  url: "".concat(config$1.EXPORT_DOWNLOAD_URL, "/").concat(data.url.includes('bidModel') ? 'bidModel/xlsx' : 'xlsx'),
                  method: 'post',
                  headers: getHeaders(),
                  data: _objectSpread$6(_objectSpread$6({}, data), {}, {
                    token: user.apiToken
                  })
                });

              case 6:
                response = _context2.sent;
                return _context2.abrupt("return", response.data.responseURL);

              case 10:
                _context2.prev = 10;
                _context2.t0 = _context2["catch"](0);
                throw new SyntaxError(_context2.t0);

              case 13:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, null, [[0, 10]]);
      }));

      function downloadXLSX(_x2) {
        return _downloadXLSX.apply(this, arguments);
      }

      return downloadXLSX;
    }()
  }, {
    key: "updateCampaignName",
    value: function () {
      var _updateCampaignName = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee3(id, value) {
        var user;
        return regenerator.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.prev = 0;
                user = AuthService.getUser();

                if (!(!user || !id)) {
                  _context3.next = 4;
                  break;
                }

                return _context3.abrupt("return", null);

              case 4:
                _context3.next = 6;
                return axios.patch("".concat(ORIGIN_URL, "/api/campaign/").concat(id), {
                  campaign_name: value
                }, {
                  headers: getHeaders(user)
                });

              case 6:
                return _context3.abrupt("return", true);

              case 9:
                _context3.prev = 9;
                _context3.t0 = _context3["catch"](0);
                throw new ServerError(_context3.t0);

              case 12:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, null, [[0, 9]]);
      }));

      function updateCampaignName(_x3, _x4) {
        return _updateCampaignName.apply(this, arguments);
      }

      return updateCampaignName;
    }()
  }, {
    key: "downloadBidmodelTable",
    value: function () {
      var _downloadBidmodelTable = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee4(data) {
        var user, response;
        return regenerator.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.prev = 0;
                user = AuthService.getUser();

                if (user) {
                  _context4.next = 4;
                  break;
                }

                return _context4.abrupt("return", null);

              case 4:
                _context4.next = 6;
                return axios({
                  url: data.url,
                  method: 'post',
                  headers: getHeaders(user),
                  data: _objectSpread$6(_objectSpread$6({}, data), {}, {
                    token: user.apiToken,
                    download: true,
                    fileType: data.fileType
                  })
                });

              case 6:
                response = _context4.sent;
                return _context4.abrupt("return", response.data.data.url);

              case 10:
                _context4.prev = 10;
                _context4.t0 = _context4["catch"](0);
                throw new SyntaxError(_context4.t0);

              case 13:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, null, [[0, 10]]);
      }));

      function downloadBidmodelTable(_x5) {
        return _downloadBidmodelTable.apply(this, arguments);
      }

      return downloadBidmodelTable;
    }()
  }]);

  return TableApi;
}();

var TableApiService = new TableApi();

var CurrencyFormat = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD'
});
var NumberFormat = new Intl.NumberFormat('en-US');
var DateTimeFormat = 'MM/DD/YYYY hh:mm A';
var DateFormat = 'MM/DD/YYYY';
var percentFormat = function percentFormat(value) {
  return "".concat((value || 0).toFixed(2), "%");
};
var timeFormat = function timeFormat(secs) {
  var secNum = parseInt(secs, 10);
  var hours = Math.floor(secNum / 3600);
  var minutes = Math.floor(secNum / 60) % 60;
  var seconds = secNum % 60;
  return [hours, minutes, seconds].map(function (v) {
    return v < 10 ? '0' + v : v;
  }).join(':');
};

var displayCurrency = function displayCurrency() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  return data !== null ? CurrencyFormat.format(data) : '—';
};

var displayNumber = function displayNumber() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  return data !== null ? NumberFormat.format(data) : '—';
};

var displayPercent = function displayPercent() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  return data !== null ? percentFormat(+data) : '—';
};

var displayTime = function displayTime() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  return data !== null ? timeFormat(+data) : '—';
};

var TableHeaderMapping = {
  id: {
    label: 'ID',
    tooltip: 'Unique system-generated number assigned to each campaign',
    sortingKey: 'campaignId',
    className: 'w-120-120',
    draggableGroup: 'group1'
  },
  checkbox: {
    label: '',
    className: '_checkbox',
    draggable: false
  },
  campaignName: {
    label: 'Campaign Name',
    tooltip: 'Campaign Name',
    sortingKey: 'campaignName',
    className: 'w-250-650',
    draggableGroup: 'group1'
  },
  campaignGroupId: {
    label: 'Campaign Group ID',
    tooltip: 'Unique system-generated number assigned to each Campaign Group',
    sortingKey: 'campaignGroupId',
    className: 'w-150-200',
    draggableGroup: 'group1'
  },
  campaignGroupName: {
    label: 'Campaign Group',
    tooltip: 'Campaign Group',
    sortingKey: 'campaignGroupName',
    className: 'w-250-650',
    draggableGroup: 'group1'
  },
  budget: {
    label: 'Budget',
    tooltip: 'Budget',
    sortingKey: 'budget',
    className: 'w-100-200'
  },
  budgetDay: {
    label: 'Daily Budget',
    tooltip: 'Amount up to which you allow us to spend on average each day',
    sortingKey: 'budgetDay',
    className: 'w-100-200',
    draggableGroup: 'group1'
  },
  budgetTotal: {
    label: 'Total Budget',
    tooltip: 'Amount up to which you allow us to spend',
    sortingKey: 'budgetTotal',
    className: 'w-100-200',
    draggableGroup: 'group1'
  },
  reach: {
    label: 'Reach',
    tooltip: 'Reach',
    sortingKey: 'reach',
    className: 'w-100-200'
  },
  frequency: {
    label: 'Frequency',
    tooltip: 'Frequency',
    sortingKey: 'frequency',
    className: 'w-100-200'
  },
  created: {
    label: 'Created',
    tooltip: 'Created',
    sortingKey: 'created',
    className: 'w-100-200'
  },
  modified: {
    label: 'Modified',
    tooltip: 'Modified',
    sortingKey: 'lastModified',
    className: 'w-100-200'
  },
  campaignType: {
    label: 'Goal',
    tooltip: 'Campaign Goal, cpm - Impressions, cpc - Clicks',
    sortingKey: 'campaignType',
    className: 'w-60-60'
  },
  eCPM: {
    label: 'eCPM',
    tooltip: 'Effective Cost Per Mile is the amount you pay per one thousand Impressions',
    sortingKey: 'eCPM',
    className: 'w-70-200'
  },
  eCPC: {
    label: 'eCPC',
    tooltip: 'Effective Cost Per Click is the amount spent divided by the number of clicks',
    sortingKey: 'eCPC',
    className: 'w-70-200'
  },
  dataCost: {
    label: 'Data Cost',
    tooltip: 'Amount spent to serve Impressions to Audience you matched or purchased',
    sortingKey: 'dataCost',
    className: 'w-90-90'
  },
  spent: {
    label: 'Total Spent',
    tooltip: 'Sum of the Media Spent and Data Spent',
    sortingKey: 'spent',
    className: 'w-100-200'
  },
  mediaSpent: {
    label: 'Media Spent',
    tooltip: 'Amount spent to win Impressions',
    sortingKey: 'mediaSpent',
    className: 'w-100-200'
  },
  percentageOfTotalSpent: {
    label: 'Budget Completion',
    tooltip: 'Percentage of the Total Budget that was Spent',
    sortingKey: 'percentageOfTotalSpent',
    className: 'w-100-200'
  },
  creativeId: {
    label: 'Creative ID',
    tooltip: 'Unique system-generated number assigned to each Creative',
    sortingKey: 'creative_id',
    className: 'w-100-100',
    draggableGroup: 'group1'
  },
  campaignId: {
    label: 'Campaign ID',
    tooltip: 'Unique system-generated number assigned to each Campaign',
    sortingKey: 'campaignId',
    className: 'w-100-100',
    draggableGroup: 'group1'
  },
  creativeName: {
    label: 'Creative Name',
    tooltip: 'Creative Name',
    sortingKey: 'creativeName',
    className: 'w-250-650',
    draggableGroup: 'group1'
  },
  creativeType: {
    label: 'Creative Type',
    tooltip: 'Creative Type',
    sortingKey: 'creativeTypeName',
    className: 'w-150-300',
    draggableGroup: 'group1'
  },
  devOs: {
    label: 'OS',
    tooltip: 'OS',
    sortingKey: 'devOs',
    className: 'w-150-300',
    draggableGroup: 'group1'
  },
  startTime: {
    label: 'Start Date',
    tooltip: 'Campaign Start Date',
    sortingKey: 'startTime',
    className: 'w-90-90',
    draggableGroup: 'group1'
  },
  endTime: {
    label: 'End Date',
    tooltip: 'Campaign End Date',
    sortingKey: 'endTime',
    className: 'w-90-90',
    draggableGroup: 'group1'
  },
  date: {
    label: 'Date',
    tooltip: 'Date',
    sortingKey: 'date',
    className: 'w-100-200',
    draggableGroup: 'group1'
  },
  winRate: {
    label: 'Win Rate',
    tooltip: 'Percentage of Impressions won per the Bids made',
    sortingKey: 'winRate',
    className: 'w-90-90'
  },
  conversionCount: {
    label: 'Conversions',
    tooltip: 'Conversions',
    className: 'w-120-120',
    sortingKey: 'conversionCount'
  },
  conversionRate: {
    label: 'Conversion Rate',
    tooltip: 'Conversion Rate',
    className: 'w-150-200',
    sortingKey: 'conversionRate'
  },
  clicks: {
    label: 'Clicks',
    tooltip: 'Number of times someone clicks your ad',
    sortingKey: 'clicks',
    className: 'w-60-60'
  },
  CTR: {
    label: 'CTR',
    tooltip: 'Click-through rate is the percentage of Clicks received per the Impressions served',
    sortingKey: 'CTR',
    className: 'w-60-60'
  },
  impressions: {
    label: 'Impressions',
    tooltip: 'Number of times ad displayed on the someone\'s screen',
    sortingKey: 'impressions',
    className: 'w-90-90'
  },
  maxBid: {
    label: 'Max Bid',
    tooltip: 'Amount up to which you allow us to Bid',
    sortingKey: 'maxBid',
    className: 'w-80-80',
    draggableGroup: 'group1'
  },
  deviceType: {
    label: 'Device Type',
    tooltip: 'Device Type',
    sortingKey: 'deviceType',
    className: 'w-150-300',
    draggableGroup: 'group1'
  },
  trafficType: {
    label: 'Channel',
    tooltip: 'Environment for the Creative delivery, App (in-app) or Web',
    sortingKey: 'trafficType',
    className: 'w-150-300',
    draggableGroup: 'group1'
  },
  manufacturerName: {
    label: 'Manufacturer',
    tooltip: 'Manufacturer',
    sortingKey: 'manufacturerName',
    className: 'w-150-300',
    draggableGroup: 'group1'
  },
  exchName: {
    label: 'Exchange',
    tooltip: 'Exchange',
    sortingKey: 'exchName',
    className: 'w-150-300',
    draggableGroup: 'group1'
  },
  VCR: {
    label: 'VCR',
    tooltip: 'Video Completion Rate is the percentage of video ads that play through to completion',
    sortingKey: 'VCR',
    className: 'w-65-65'
  },
  startCount: {
    label: 'Video Start',
    tooltip: 'Number of video ads that start to play',
    sortingKey: 'startCount',
    className: 'w-90-90'
  },
  firstCount: {
    label: 'Video 25%',
    tooltip: 'Number of video ads that play through 25% of their duration',
    sortingKey: 'firstCount',
    className: 'w-90-90'
  },
  midCount: {
    label: 'Video 50%',
    tooltip: 'Number of video ads that play through 50% of their duration',
    sortingKey: 'midCount',
    className: 'w-90-90'
  },
  thirdCount: {
    label: 'Video 75%',
    tooltip: 'Number of video ads that play through 75% of their duration',
    sortingKey: 'thirdCount',
    className: 'w-90-90'
  },
  completeCount: {
    label: 'Video 100%',
    tooltip: 'Number of video ads that play through to completion',
    sortingKey: 'completeCount',
    className: 'w-100-200'
  },
  eCPCV: {
    label: 'CPCV',
    tooltip: 'Cost Per Completed View is the amount spent divided by video ads that play through to completion',
    sortingKey: 'eCPCV',
    className: 'w-70-200'
  },
  age: {
    label: 'Age Group',
    tooltip: 'Age Group',
    sortingKey: 'age',
    className: 'w-150-300',
    draggableGroup: 'group1'
  },
  gender: {
    label: 'Gender',
    tooltip: 'Gender',
    sortingKey: 'gender',
    className: 'w-150-300',
    draggableGroup: 'group1'
  },
  incomeGroup: {
    label: 'Income Range',
    tooltip: 'Income Range',
    sortingKey: 'incomeGroup',
    className: 'w-150-300',
    draggableGroup: 'group1'
  },
  ethnicity: {
    label: 'Ethnicity',
    tooltip: 'Ethnicity',
    sortingKey: 'ethnicity',
    className: 'w-150-300',
    draggableGroup: 'group1'
  },
  language: {
    label: 'Language',
    tooltip: 'Language',
    sortingKey: 'language',
    className: 'w-150-300',
    draggableGroup: 'group1'
  },
  audioVideoViewed: {
    label: 'Hours Viewed',
    tooltip: 'Hours Viewed',
    sortingKey: 'audioVideoViewed',
    className: 'w-100-200'
  },
  spentDistribution: {
    label: 'Spent Distribution',
    tooltip: 'Spent Distribution',
    sortingKey: 'spentDistribution',
    className: 'w-100-200'
  },
  pixalateViewAbility: {
    label: 'Viewability',
    tooltip: 'Viewability',
    sortingKey: 'pixalateViewAbility',
    className: 'w-100-200'
  }
};
var TableBodyMapping = {
  id: {
    key: 'campaignId',
    className: '_id w-100-100 _right'
  },
  budget: {
    key: function key(data) {
      return displayCurrency(data.budget);
    },
    className: '_right w-100-200'
  },
  budgetDay: {
    key: function key(data) {
      return displayCurrency(data.budgetDay);
    },
    className: '_right w-100-200'
  },
  budgetTotal: {
    key: function key(data) {
      return displayCurrency(data.budgetTotal);
    },
    className: '_right w-100-200'
  },
  spent: {
    key: function key(data) {
      return /*#__PURE__*/createElement("div", {
        className: data.isBlocked || !!data.isExcluded ? 'blocked' : ''
      }, displayCurrency(data.spent));
    },
    className: 'w-100-200 _right'
  },
  startTime: {
    key: function key(data) {
      return data.startTime ? data.campaignTimezone ? moment.unix(data.startTime).tz(data.campaignTimezone).format(DateFormat) : moment.unix(data.startTime).format(DateFormat) : '—';
    },
    className: '_start-date w-90-90'
  },
  endTime: {
    key: function key(data) {
      return data.endTime ? data.campaignTimezone ? moment.unix(data.endTime).tz(data.campaignTimezone).format(DateFormat) : moment.unix(data.endTime).format(DateFormat) : '—';
    },
    className: '_end-date w-90-90'
  },
  reach: {
    key: function key(data) {
      return displayNumber(data.reach);
    },
    className: 'w-100-200 _right'
  },
  frequency: {
    key: function key(data) {
      return displayNumber(data.frequency);
    },
    className: 'w-100-200 _right'
  },
  created: {
    key: function key(data) {
      return data.created ? moment.unix(data.created).format(DateTimeFormat) : '—';
    },
    className: '_start-date w-100-200'
  },
  modified: {
    key: function key(data) {
      return data.lastModified ? moment.unix(data.lastModified).format(DateTimeFormat) : '—';
    },
    className: '_end-date w-100-200'
  },
  campaignType: {
    key: function key(data) {
      return data.campaignType ? data.campaignType : '—';
    },
    className: 'w-100 w-60-60'
  },
  eCPM: {
    key: function key(data) {
      return /*#__PURE__*/createElement("div", {
        className: data.isBlocked || !!data.isExcluded ? 'blocked' : ''
      }, displayCurrency(data.eCPM));
    },
    className: '_right w-70-200'
  },
  eCPC: {
    key: function key(data) {
      return /*#__PURE__*/createElement("div", {
        className: data.isBlocked || !!data.isExcluded ? 'blocked' : ''
      }, displayCurrency(data.eCPC));
    },
    className: '_right w-70-200'
  },
  dataCost: {
    key: function key(data) {
      return /*#__PURE__*/createElement("div", {
        className: data.isBlocked || !!data.isExcluded ? 'blocked' : ''
      }, displayCurrency(data.dataCost));
    },
    className: '_right w-90-90'
  },
  mediaSpent: {
    key: function key(data) {
      return /*#__PURE__*/createElement("div", {
        className: data.isBlocked || !!data.isExcluded ? 'blocked' : ''
      }, displayCurrency(data.mediaSpent));
    },
    className: '_right w-100-200'
  },
  percentageOfTotalSpent: {
    key: function key(data) {
      return displayPercent(data.percentageOfTotalSpent);
    },
    className: '_right w-100-200'
  },
  campaignGroupId: {
    key: 'campaignGroupId',
    className: 'w-150-200'
  },
  campaignGroupName: {
    key: 'campaignGroupName',
    className: 'w-250-650'
  },
  creativeId: {
    key: 'creativeId',
    className: 'w-100-100 _right'
  },
  campaignId: {
    key: 'campaignId',
    className: 'w-100-100 _right'
  },
  campaignName: {
    key: 'campaignName',
    className: 'w-250-650'
  },
  creativeName: {
    key: 'creativeName',
    className: 'w-250-650'
  },
  creativeType: {
    key: 'creativeTypeName',
    className: 'w-150-300'
  },
  deviceType: {
    key: 'deviceType',
    className: 'w-150-300'
  },
  manufacturerName: {
    key: 'manufacturerName',
    className: 'w-150-300'
  },
  trafficType: {
    key: 'trafficType',
    className: 'w-150-300'
  },
  exchName: {
    key: 'exchName',
    className: 'w-150-300'
  },
  age: {
    key: 'age',
    className: 'w-150-300'
  },
  gender: {
    key: 'gender',
    className: 'w-150-300'
  },
  incomeGroup: {
    key: 'incomeGroup',
    className: 'w-150-300'
  },
  ethnicity: {
    key: 'ethnicity',
    className: 'w-150-300'
  },
  language: {
    key: 'language',
    className: 'w-150-300'
  },
  date: {
    key: function key(data) {
      if (!data.date) {
        return '';
      }

      var momentDate = moment(data.date);
      return momentDate.isValid() ? momentDate.format(DateFormat) : data.date;
    },
    className: 'w-100-200'
  },
  impressions: {
    key: function key(data) {
      return /*#__PURE__*/createElement("div", {
        className: data.isBlocked || !!data.isExcluded ? 'blocked' : ''
      }, displayNumber(data.impressions));
    },
    className: 'w-90-90 _right'
  },
  conversionCount: {
    key: function key(data) {
      return /*#__PURE__*/createElement("div", {
        className: data.isBlocked || !!data.isExcluded ? 'blocked' : ''
      }, data.conversionCount);
    },
    className: "_right w-90-90"
  },
  conversionRate: {
    key: function key(data) {
      return /*#__PURE__*/createElement("div", {
        className: data.isBlocked || !!data.isExcluded ? 'blocked' : ''
      }, "".concat(data.conversionRate, " %"));
    },
    className: "_right w-90-90"
  },
  devOs: {
    key: 'devOs',
    className: 'w-150-300'
  },
  winRate: {
    key: function key(data) {
      return /*#__PURE__*/createElement("div", {
        className: data.isBlocked || !!data.isExcluded ? 'blocked' : ''
      }, displayPercent(data.winRate));
    },
    className: '_right w-90-90'
  },
  clicks: {
    key: function key(data) {
      return /*#__PURE__*/createElement("div", {
        className: data.isBlocked || !!data.isExcluded ? 'blocked' : ''
      }, displayNumber(data.clicks));
    },
    className: '_right w-60-60'
  },
  maxBid: {
    key: function key(data) {
      return displayCurrency(data.maxBid);
    },
    className: '_right w-80-80'
  },
  CTR: {
    key: function key(data) {
      return /*#__PURE__*/createElement("div", {
        className: data.isBlocked || !!data.isExcluded ? 'blocked' : ''
      }, displayPercent(data.CTR));
    },
    className: '_right w-60-60'
  },
  VCR: {
    key: function key(data) {
      return /*#__PURE__*/createElement("div", {
        className: data.isBlocked || !!data.isExcluded ? 'blocked' : ''
      }, displayPercent(data.VCR));
    },
    className: '_right w-65-65'
  },
  startCount: {
    key: function key(data) {
      return /*#__PURE__*/createElement("div", {
        className: data.isBlocked || !!data.isExcluded ? 'blocked' : ''
      }, displayNumber(data.startCount));
    },
    className: '_right w-90-90'
  },
  firstCount: {
    key: function key(data) {
      return /*#__PURE__*/createElement("div", {
        className: data.isBlocked || !!data.isExcluded ? 'blocked' : ''
      }, displayNumber(data.firstCount));
    },
    className: '_right w-90-90'
  },
  midCount: {
    key: function key(data) {
      return /*#__PURE__*/createElement("div", {
        className: data.isBlocked || !!data.isExcluded ? 'blocked' : ''
      }, displayNumber(data.midCount));
    },
    className: '_right w-90-90'
  },
  thirdCount: {
    key: function key(data) {
      return /*#__PURE__*/createElement("div", {
        className: data.isBlocked || !!data.isExcluded ? 'blocked' : ''
      }, displayNumber(data.thirdCount));
    },
    className: '_right w-90-90'
  },
  completeCount: {
    key: function key(data) {
      return /*#__PURE__*/createElement("div", {
        className: data.isBlocked || !!data.isExcluded ? 'blocked' : ''
      }, displayNumber(data.completeCount));
    },
    className: '_right w-100-200'
  },
  eCPCV: {
    key: function key(data) {
      return displayCurrency(data.eCPCV);
    },
    className: '_right w-70-200'
  },
  audioVideoViewed: {
    key: function key(data) {
      return /*#__PURE__*/createElement("div", {
        className: data.isBlocked || !!data.isExcluded ? 'blocked' : ''
      }, displayTime(data.audioVideoViewed));
    },
    className: '_right w-90-90'
  },
  spentDistribution: {
    key: function key(data) {
      return /*#__PURE__*/createElement("div", {
        className: !!data.isExcluded ? 'blocked' : ''
      }, displayPercent(data.spentDistribution));
    },
    className: '_right w-100-200'
  },
  pixalateViewAbility: {
    key: function key(data) {
      return displayPercent(data.pixalateViewAbility);
    },
    className: '_right w-100-200'
  }
};

var LoadAllDialogContent = function LoadAllDialogContent(_ref) {
  var campaignCount = _ref.campaignCount,
      _ref$entityName = _ref.entityName,
      entityName = _ref$entityName === void 0 ? 'Campaigns' : _ref$entityName;
  return /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement("h5", {
    className: "title-card-subtitle"
  }, "To make selection we need to load all", ' ', /*#__PURE__*/React__default.createElement("span", {
    className: "_black"
  }, campaignCount), ' ', lowerCase(entityName)));
};
LoadAllDialogContent.propTypes = {
  campaignCount: PropTypes.number,
  entityName: PropTypes.string
};

function ownKeys$7(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$7(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$7(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$7(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _createSuper$7(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$7(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct$7() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
var SELECTED_CLASS_NAME = '_selected';
var MAX_SELECTED_ITEMS = 10000;
var MAX_ITEMS_IN_ONE_REQUEST = 500;
var DEBOUNCE_TIME = 300;
var defaultSorting = {
  direction: null,
  field: null
};
var STORAGE_NAME = 'changeCampaignName';

var moveItem = function moveItem(a, from, to) {
  if (from === to || to === null) return a;

  var clone = _toConsumableArray(a);

  clone.splice(to, 0, clone.splice(from, 1)[0]);
  return clone;
};

var TableComp = /*#__PURE__*/function (_React$Component) {
  _inherits(TableComp, _React$Component);

  var _super = _createSuper$7(TableComp);

  function TableComp(props) {
    var _this;

    _classCallCheck(this, TableComp);

    _this = _super.call(this, props);

    _this.componentDidUpdate = function (prevProps, prevState) {
      var countPath = _this.props.countPath;

      if (!isEqual(prevProps.dataRequest, _this.props.dataRequest)) {
        if (_this.prevSourceRequest) {
          _this.prevSourceRequest.cancel();
        }

        _this.allowLoad = false;

        _this.setState({
          isNewArray: true,
          sorting: _this.props.defaultSorting || _this.defaultSorting,
          loading: true
        }, function () {
          _this.props.onLoading && _this.props.onLoading(_this.state.loading);
          _this.allowLoad = true;

          _this.getData();
        });
      } else if (!isEqual(prevProps.defaultSorting, _this.props.defaultSorting)) {
        _this.setState({
          sorting: _this.props.defaultSorting || _this.defaultSorting
        });
      }

      if (_this.state.loading !== prevState.loading) {
        if (_this.props.onLoading) {
          _this.props.onLoading(_this.state.loading);
        }
      }

      if (_this.state.loadingData !== prevState.loadingData) {
        if (_this.props.onDataLoading) {
          _this.props.onDataLoading(_this.state.loadingData);
        }
      } else if (!prevState.loadingData && _this.props.data !== prevProps.data) {
        _this.setState({
          data: _this.props.data || []
        });
      }

      if (typeof countPath === 'number' && countPath !== prevProps.countPath) {
        setTimeout(_this.getNewData, DEBOUNCE_TIME);
      }
    };

    _this._mounted = false;

    _this.componentDidMount = function () {
      _this._mounted = true;

      if (_this.state.loading) {
        _this.getData();
      }
    };

    _this.componentWillUnmount = function () {
      _this._mounted = false;

      if (_this.prevSourceRequest) {
        _this.prevSourceRequest.cancel();
      }
    };

    _this.HeaderMapping = _objectSpread$7({}, TableHeaderMapping);
    _this.BodyMapping = _objectSpread$7(_objectSpread$7({}, TableBodyMapping), {}, {
      checkbox: {
        key: function key(data) {
          var _this$props = _this.props,
              idField = _this$props.idField,
              checkboxInHeader = _this$props.checkboxInHeader;
          var _this$state = _this.state,
              selected = _this$state.selected,
              propsData = _this$state.data;
          var checked = !!find$1(selected, function (d) {
            return d[idField] === data[idField];
          });
          var checkedAll = selected.length === propsData.length;
          var checkedPartly = selected.length > 0 && !checkedAll;
          return data.total ? !checkboxInHeader ? /*#__PURE__*/React__default.createElement(Checkbox, {
            className: checkedPartly ? '_dirty' : '',
            checked: checkedAll,
            name: "checkbox-id-".concat(data[idField]),
            onChange: _this.handleTableAllCampaignsSelection(data, checkedPartly)
          }) : null : /*#__PURE__*/React__default.createElement(Checkbox, {
            checked: checked,
            name: "checkbox-id-".concat(data[idField]),
            onChange: _this.handleTableCampaignSelection(data[idField])
          });
        },
        className: '_checkbox'
      },
      campaignName: {
        key: function key(data) {
          return data.name;
        },
        hover: function hover(data) {
          return !data.total && /*#__PURE__*/React__default.createElement(EditableText, {
            value: data.name,
            confirm: function confirm(value) {
              _this.updateName(data, value);
            },
            Popup: {
              title: 'Change Campaign Name',
              remember: true,
              storageKey: STORAGE_NAME
            }
          }, /*#__PURE__*/React__default.createElement("div", null, "Campaign Name will be changed across all products. Are you sure?"));
        },
        className: '_campaign-name'
      }
    });
    _this.getData = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee() {
      var _ref2,
          itemsCount,
          requestTimestamp,
          _this$props2,
          dataPath,
          dataRequest,
          totalPath,
          transformRequestParams,
          transformData,
          removeTotalTag,
          _this$state2,
          itemsCountPerPage,
          currentPage,
          sorting,
          isNewArray,
          allSelected,
          selected,
          page,
          isGet,
          query,
          sortKey,
          request,
          _TableApiService$fetc,
          promise,
          source,
          apiRequestTimestamp,
          axiosResponse,
          latency,
          response,
          data,
          totalObj,
          totalData,
          totalItems,
          newData,
          hasMore,
          _latency,
          _args = arguments;

      return regenerator.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _ref2 = _args.length > 0 && _args[0] !== undefined ? _args[0] : {}, itemsCount = _ref2.itemsCount;

              if (_this.allowLoad) {
                _context.next = 5;
                break;
              }

              return _context.abrupt("return");

            case 5:
              _this.allowLoad = false;

            case 6:
              _context.prev = 6;
              _this$props2 = _this.props, dataPath = _this$props2.dataPath, dataRequest = _this$props2.dataRequest, totalPath = _this$props2.totalPath, transformRequestParams = _this$props2.transformRequestParams, transformData = _this$props2.transformData, removeTotalTag = _this$props2.removeTotalTag;
              _this$state2 = _this.state, itemsCountPerPage = _this$state2.itemsCountPerPage, currentPage = _this$state2.currentPage, sorting = _this$state2.sorting, isNewArray = _this$state2.isNewArray, allSelected = _this$state2.allSelected, selected = _this$state2.selected;

              _this.setState({
                loadingData: true
              });

              page = !_this.state.data.length || isNewArray ? 1 : currentPage + 1;
              isGet = dataRequest.method.toLowerCase() === 'get';
              query = _objectSpread$7(_objectSpread$7({
                no_of_entries: itemsCountPerPage,
                draw: 1,
                pgno: page
              }, sorting.field ? {
                sort_by: sorting.field,
                sort_type: sorting.direction || 'asc'
              } : {}), isGet ? dataRequest.params : dataRequest.data);

              if (itemsCount) {
                query = _objectSpread$7(_objectSpread$7({}, query), {}, {
                  pgno: -1
                });
              }

              if (transformRequestParams && isFunction$1(transformRequestParams)) {
                query = transformRequestParams(query, _this.state);
              }

              sortKey = query.sort_by;

              if (sortKey && !_this.props.selectedColumns.some(function (c) {
                return _this.headerMapping[c.value] && _this.headerMapping[c.value].sortingKey === sortKey;
              })) {
                query.sort_by = _this.defaultSorting.field;
                query.sort_type = _this.defaultSorting.direction;

                _this.setState({
                  sorting: _this.defaultSorting
                });
              }

              request = _objectSpread$7(_objectSpread$7({}, dataRequest), isGet ? {
                params: query
              } : {
                data: query
              });
              _TableApiService$fetc = TableApiService.fetchData(_objectSpread$7({}, request)), promise = _TableApiService$fetc.promise, source = _TableApiService$fetc.source, apiRequestTimestamp = _TableApiService$fetc.requestTimestamp;
              requestTimestamp = apiRequestTimestamp;
              _this.prevSourceRequest = source;
              _context.next = 23;
              return promise;

            case 23:
              axiosResponse = _context.sent;
              latency = Date.now() - requestTimestamp;
              response = axiosResponse.data;
              _this.prevSourceRequest = null;
              _this.props.onDataSuccess && _this.props.onDataSuccess(response, axiosResponse, latency);

              if (_this.props.onDataLoaded) {
                _this.props.onDataLoaded(response, axiosResponse, latency);
              }

              data = get$1(response, dataPath);
              totalObj = get$1(response, totalPath, []);
              totalData = (Array.isArray(totalObj) ? totalObj : [totalObj]).map(function (d) {
                var _objectSpread2;

                return _objectSpread$7(_objectSpread$7({}, d), {}, (_objectSpread2 = {
                  total: true
                }, _defineProperty(_objectSpread2, _this.props.idField, removeTotalTag ? '' : 'Total'), _defineProperty(_objectSpread2, "rowClassName", '_aggregated'), _objectSpread2));
              });
              totalItems = typeof _this.props.countPath === 'number' ? _this.props.countPath : get$1(response, _this.props.countPath, 0);
              newData = isNewArray ? [] : _this.state.data;

              if (isArray$5(data)) {
                newData = newData.concat(data);
              }

              if (transformData) {
                newData = transformData(newData);
              }

              hasMore = totalItems !== null && totalItems > newData.length;

              if (_this._mounted) {
                _this.setState({
                  loading: false,
                  loadingData: false,
                  showProcessLoading: false,
                  isNewArray: false,
                  data: newData,
                  currentPage: page,
                  totalItems: totalItems,
                  hasMore: hasMore,
                  totalData: Array.isArray(totalData) ? totalData : [totalData]
                }, function () {
                  return _this.handleOnChange(!!itemsCount);
                });

                if (allSelected) {
                  if (newData.length <= MAX_SELECTED_ITEMS) {
                    _this.setState({
                      selected: [].concat(_toConsumableArray(selected), _toConsumableArray(data))
                    }, _this.onSelect);
                  } else {
                    _this.setState({
                      allSelected: false
                    }, _this.onSelect);
                  }
                }
              }

              _context.next = 48;
              break;

            case 40:
              _context.prev = 40;
              _context.t0 = _context["catch"](6);

              if (!axios.isCancel(_context.t0)) {
                _context.next = 45;
                break;
              }

              if (_this.props.onCancel) {
                _this.props.onCancel(_context.t0);
              }

              return _context.abrupt("return");

            case 45:
              if (_this._mounted) {
                _this.setState({
                  loading: false,
                  loadingData: false
                });
              }

              _latency = requestTimestamp ? Date.now() - requestTimestamp : null;
              _this.props.onFetchDataError && _this.props.onFetchDataError(_context.t0, _latency);

            case 48:
              _context.prev = 48;
              _this.allowLoad = true;
              return _context.finish(48);

            case 51:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[6, 40, 48, 51]]);
    }));

    _this.handleOnChange = function (isAllSelected) {
      var data = _this.state.data;

      if (isAllSelected) {
        _this.setState({
          selected: _toConsumableArray(data)
        }, _this.onSelect);
      }

      if (_this.props.onDataChanged) {
        _this.props.onDataChanged(_this.state.data, _this.state.totalData);
      }
    };

    _this.getNewData = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee2() {
      var _ref4,
          totalCount,
          _args2 = arguments;

      return regenerator.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _ref4 = _args2.length > 0 && _args2[0] !== undefined ? _args2[0] : {}, totalCount = _ref4.totalCount;

              if (_this.prevSourceRequest) {
                _this.prevSourceRequest.cancel();
              }

              _this.allowLoad = false;

              _this.setState({
                isNewArray: true,
                showProcessLoading: true,
                allSelected: false
              }, function () {
                _this.allowLoad = true;

                _this.getData({
                  itemsCount: totalCount
                });
              });

            case 4:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    _this.onSelect = function () {
      var _this$state3 = _this.state,
          allSelected = _this$state3.allSelected,
          data = _this$state3.data,
          selected = _this$state3.selected,
          totalItems = _this$state3.totalItems;
      var totalCount = (totalItems < MAX_SELECTED_ITEMS ? totalItems : MAX_SELECTED_ITEMS) - (data.length - selected.length);

      _this.props.onSelect(_this.state.selected, allSelected ? totalCount : null);
    };

    _this.handleTableCampaignSelection = function (idFieldValue) {
      return function (isSelected) {
        var idField = _this.props.idField;
        var _this$state4 = _this.state,
            selected = _this$state4.selected,
            data = _this$state4.data;
        var value = data.find(function (obj) {
          return obj[idField] === idFieldValue;
        });

        if (isSelected) {
          selected.push(value);

          _this.setState({
            selected: selected.map(function (d) {
              return _objectSpread$7({}, d);
            })
          }, _this.onSelect);
        } else {
          var foundDataItem = data.find(function (d) {
            return d[idField] === idFieldValue;
          });

          if (foundDataItem && foundDataItem.rowClassName) {
            delete foundDataItem.rowClassName;
          }

          _this.setState({
            selected: selected.filter(function (i) {
              return i[idField] !== idFieldValue;
            })
          }, _this.onSelect);
        }
      };
    };

    _this._clearSelection = function () {
      _this.setState({
        selected: [],
        allSelected: false
      }, _this.onSelect);
    };

    _this.handleTableAllCampaignsSelection = function (value, isCheckedPartly) {
      return function (isSelected) {
        var selectAllWithoutLoading = _this.props.selectAllWithoutLoading;
        var _this$state5 = _this.state,
            data = _this$state5.data,
            totalItems = _this$state5.totalItems;

        if (isCheckedPartly || !isCheckedPartly && !isSelected) {
          _this._clearSelection();
        } else {
          if (selectAllWithoutLoading && totalItems > MAX_ITEMS_IN_ONE_REQUEST) {
            _this.setState({
              selected: _toConsumableArray(data),
              allSelected: true
            }, _this.onSelect);

            return;
          }

          if (_this.dataWithUniqId.length >= +totalItems) {
            _this.setState({
              selected: _toConsumableArray(data)
            }, _this.onSelect);
          } else if (+totalItems <= 100) {
            _this.getNewData({
              totalCount: +totalItems
            });
          } else {
            _this.setState({
              showDialog: true
            });
          }
        }
      };
    };

    _this.handleSort = function (_ref5) {
      var sorting = _ref5.sorting;
      var stateSorting = _this.state.sorting;

      if (sorting.field !== stateSorting.field || sorting.direction !== stateSorting.direction) {
        if (_this.prevSourceRequest) {
          _this.prevSourceRequest.cancel();
        }

        _this.allowLoad = false;

        _this.setState({
          sorting: sorting,
          isNewArray: true,
          selected: [],
          showProcessLoading: true
        }, function () {
          _this.allowLoad = true;

          _this.getData();
        });
      }
    };

    _this.updateName = /*#__PURE__*/function () {
      var _ref6 = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee3(data, value) {
        var idField, id, done, _data;

        return regenerator.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                idField = _this.props.idField;
                id = data[idField];
                _context3.prev = 2;
                _context3.next = 5;
                return TableApiService.updateCampaignName(id, value);

              case 5:
                done = _context3.sent;

                if (done) {
                  _data = _this.state.data;

                  _this.setState({
                    data: _data.map(function (d) {
                      return d[idField] === id ? _objectSpread$7(_objectSpread$7({}, d), {}, {
                        name: value
                      }) : _objectSpread$7({}, d);
                    })
                  });
                }

                _context3.next = 12;
                break;

              case 9:
                _context3.prev = 9;
                _context3.t0 = _context3["catch"](2);
                console.log('Error update name', _context3.t0);

              case 12:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, null, [[2, 9]]);
      }));

      return function (_x, _x2) {
        return _ref6.apply(this, arguments);
      };
    }();

    _this.tableRef = void 0;

    _this.clearSelected = function () {
      _this._clearSelection();
    };

    _this.handleDragEnd = function (item, _ref7) {
      var start = _ref7.start,
          end = _ref7.end;
      var _this$props3 = _this.props,
          checkbox = _this$props3.checkbox,
          selectedColumns = _this$props3.selectedColumns;
      var startPos = checkbox ? Math.max(start - 1, 0) : start;
      var endPos = checkbox && end !== null ? Math.max(end - 1, 0) : end;
      var mainCols = selectedColumns.filter(function (c) {
        return !c.isGroupTitle;
      });
      var groupCols = selectedColumns.filter(function (c) {
        return c.isGroupTitle;
      });
      _this.props.onColumnsChanged && _this.props.onColumnsChanged(moveItem([].concat(_toConsumableArray(mainCols), _toConsumableArray(groupCols)), startPos, endPos));
    };

    _this.closeDialog = function () {
      _this.setState({
        showDialog: false
      });
    };

    _this.defaultSorting = props.defaultSorting || defaultSorting;
    _this.skeletonRowsNumber = 5;
    _this.allowLoad = true;
    _this.state = {
      currentPage: 1,
      itemsCountPerPage: 50,
      loading: true,
      loadingData: false,
      showProcessLoading: false,
      data: [],
      totalData: [],
      selected: [],
      totalItems: null,
      sorting: _this.defaultSorting,
      hasMore: true,
      isNewArray: true,
      dataRequest: props.dataRequest,
      showDialog: false,
      allSelected: false
    };

    if (props.data) {
      _this.state.data = props.data;
      _this.state.totalItems = props.totalItems;
      _this.state.loading = false;
      _this.state.isNewArray = false;

      if (_this.state.totalItems === _this.state.data.length) {
        _this.state.hasMore = false;
      }

      _this.state.currentPage = Math.ceil(_this.state.data.length / _this.state.itemsCountPerPage);
    }

    _this.getData = debounce(_this.getData, DEBOUNCE_TIME);
    return _this;
  }

  _createClass(TableComp, [{
    key: "headerMapping",
    get: function get() {
      return _objectSpread$7(_objectSpread$7({}, this.HeaderMapping), this.props.headerMapping);
    }
  }, {
    key: "bodyMapping",
    get: function get() {
      return _objectSpread$7(_objectSpread$7({}, this.BodyMapping), this.props.bodyMapping);
    }
  }, {
    key: "dataWithUniqId",
    get: function get() {
      var idField = this.props.idField;
      var data = this.state.data;
      return idField ? uniqBy(data, idField) : data;
    }
  }, {
    key: "cancelDataRequest",
    value: function cancelDataRequest() {
      if (this.prevSourceRequest) {
        this.prevSourceRequest.cancel();
      }
    }
  }, {
    key: "header",
    get: function get() {
      var _this2 = this;

      var _this$props4 = this.props,
          checkbox = _this$props4.checkbox,
          checkboxInHeader = _this$props4.checkboxInHeader,
          selectedColumns = _this$props4.selectedColumns;
      var header = [];

      if (checkbox) {
        header.push(checkboxInHeader ? {
          className: '_checkbox',
          label: function label() {
            var _this2$state = _this2.state,
                selected = _this2$state.selected,
                propsData = _this2$state.data;
            var checkedAll = selected.length === propsData.length;
            var checkedPartly = selected.length > 0 && !checkedAll;
            return /*#__PURE__*/React__default.createElement(Checkbox, {
              className: checkedPartly ? '_dirty' : '',
              checked: checkedAll,
              name: "checkbox-id-total",
              onChange: _this2.handleTableAllCampaignsSelection(null, checkedPartly)
            });
          }
        } : this.headerMapping.checkbox);
      }

      selectedColumns.map(function (option) {
        return option.value;
      }).forEach(function (value) {
        var map = _this2.headerMapping[value];

        if (map) {
          header.push(map);
        }
      });
      return header;
    }
  }, {
    key: "body",
    get: function get() {
      var _this3 = this;

      var _this$props5 = this.props,
          checkbox = _this$props5.checkbox,
          selectedColumns = _this$props5.selectedColumns;
      var body = [];

      if (checkbox) {
        body.push(this.bodyMapping.checkbox);
      }

      selectedColumns.map(function (option) {
        return option.value;
      }).forEach(function (value) {
        var map = _this3.bodyMapping[value];

        if (map) {
          body.push(map);
        }
      });
      return body;
    }
  }, {
    key: "dialog",
    get: function get() {
      var _this4 = this;

      var _this$state6 = this.state,
          showDialog = _this$state6.showDialog,
          totalItems = _this$state6.totalItems;
      var entityName = this.props.entityName;
      return /*#__PURE__*/React__default.createElement(Dialog, {
        open: showDialog,
        dialogTitle: "Load All ".concat(startCase(entityName), "?"),
        onClickOutside: this.closeDialog,
        crossButton: true,
        onCrossButtonClick: this.closeDialog,
        actionButtons: [{
          variant: 'secondary',
          title: 'Cancel',
          handler: this.closeDialog
        }, {
          variant: 'primary',
          title: 'Load',
          handler: function handler() {
            _this4.getNewData({
              totalCount: +totalItems
            });

            _this4.closeDialog();
          }
        }]
      }, /*#__PURE__*/React__default.createElement(LoadAllDialogContent, {
        campaignCount: +totalItems,
        entityName: entityName
      }));
    }
  }, {
    key: "renderLoading",
    value: function renderLoading() {
      var _this$props6 = this.props,
          loadingComponent = _this$props6.loadingComponent,
          skeleton = _this$props6.skeleton,
          _this$props6$tablePar = _this$props6.tableParams,
          tableParams = _this$props6$tablePar === void 0 ? {} : _this$props6$tablePar;
      return loadingComponent || /*#__PURE__*/React__default.createElement(Skeleton, {
        colN: skeleton.columns,
        rowN: skeleton.rows,
        classes: skeleton.classes,
        theadRowHeight: tableParams.theadRowHeight,
        tbodyRowHeight: tableParams.tbodyRowHeight
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this5 = this;

      var _this$props7 = this.props,
          className = _this$props7.className,
          offsetTop = _this$props7.offsetTop,
          total = _this$props7.total,
          _this$props7$scrollPa = _this$props7.scrollParams,
          scrollParams = _this$props7$scrollPa === void 0 ? {} : _this$props7$scrollPa,
          _this$props7$tablePar = _this$props7.tableParams,
          tableParams = _this$props7$tablePar === void 0 ? {} : _this$props7$tablePar,
          innerRef = _this$props7.innerRef,
          filter = _this$props7.filter,
          idField = _this$props7.idField,
          emptyTableLabel = _this$props7.emptyTableLabel,
          emptyTableNode = _this$props7.emptyTableNode,
          draggable = _this$props7.draggable,
          removeTotalTag = _this$props7.removeTotalTag;
      var _this$state7 = this.state,
          loadingData = _this$state7.loadingData,
          data = _this$state7.data,
          loading = _this$state7.loading,
          hasMore = _this$state7.hasMore,
          totalData = _this$state7.totalData,
          selected = _this$state7.selected,
          showProcessLoading = _this$state7.showProcessLoading,
          totalItems = _this$state7.totalItems;
      var selectedIds = selected.map(function (s) {
        return s[idField];
      });
      var formattedData = data.map(function (d) {
        return selectedIds.includes(d[idField]) ? _objectSpread$7(_objectSpread$7({}, d), {}, {
          rowClassName: SELECTED_CLASS_NAME
        }) : _objectSpread$7({}, d);
      });
      var filtered = formattedData;

      if (filter) {
        filtered = filter(formattedData);
      }

      return /*#__PURE__*/React__default.createElement("div", {
        className: "table-wrapper ".concat(className, " ").concat(loading || showProcessLoading ? '_show-skeleton' : ''),
        ref: function ref() {
          _this5.tableRef = _this5;

          if (innerRef) {
            innerRef(_this5);
          }
        }
      }, !loadingData && !loading && !data.length ? /*#__PURE__*/React__default.createElement("div", {
        className: "no-data-placeholder",
        style: {
          height: tableParams.tableMaxHeight || 'auto'
        }
      }, emptyTableNode || /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(Icon, {
        name: "NoData"
      }), /*#__PURE__*/React__default.createElement("h3", {
        className: "no-data-placeholder__subtitle"
      }, emptyTableLabel || 'No Data Available'))) : /*#__PURE__*/React__default.createElement(React__default.Fragment, null, this.renderLoading(), /*#__PURE__*/React__default.createElement(Table, _extends({
        header: this.header,
        body: this.body,
        server: true,
        loading: loading,
        data: filtered,
        offsetTop: offsetTop,
        rowKeyExtractor: function rowKeyExtractor(data, rowIndex) {
          return "".concat(data[idField], "_").concat(rowIndex);
        },
        infiniteScroll: true,
        fixedXScroller: true,
        InfiniteScrollComponent: _objectSpread$7({
          loadMore: function loadMore() {
            hasMore && _this5.getData();
          },
          hasMore: hasMore,
          useWindow: false,
          initialLoad: false,
          threshold: 700
        }, scrollParams),
        skeletonRowsNumber: this.skeletonRowsNumber,
        onChange: this.handleSort,
        unsortedData: total && data.length ? totalData : null,
        draggable: draggable,
        onDragEnd: this.handleDragEnd,
        sorting: this.state.sorting || this.defaultSorting,
        totalItemsCount: totalItems
      }, tableParams)), /*#__PURE__*/createPortal(this.dialog, document.body)));
    }
  }]);

  return TableComp;
}(React__default.Component);

var TableComponent = function TableComponent(props) {
  return /*#__PURE__*/React__default.createElement(TableWithOptionsContext.Consumer, null, function (value) {
    return /*#__PURE__*/React__default.createElement(TableComp, _extends({}, props, value));
  });
};
TableComponent.defaultProps = {
  entityName: 'campaigns',
  headerMapping: {},
  bodyMapping: {},
  className: '',
  offsetTop: 70,
  checkboxInHeader: false,
  checkbox: true,
  dataPath: 'data',
  totalPath: 'total',
  countPath: 'recordsFiltered',
  onSelect: function onSelect() {},
  total: true,
  skeleton: {
    columns: 10,
    rows: 10,
    classes: []
  },
  idField: 'campaign_id',
  draggable: true,
  removeTotalTag: false
};
var props = {
  className: PropTypes.string,
  entityName: PropTypes.string,
  headerMapping: PropTypes.objectOf(PropTypes.shape({
    label: PropTypes.oneOfType([PropTypes.string, PropTypes.node])
  })),
  bodyMapping: PropTypes.objectOf(PropTypes.shape({
    key: PropTypes.oneOfType([PropTypes.string, PropTypes.func])
  })),
  offsetTop: PropTypes.number,
  checkbox: PropTypes.bool,
  checkboxInHeader: PropTypes.bool,
  data: PropTypes.array,
  selectedColumns: PropTypes.array,
  emptyTableLabel: PropTypes.string,
  emptyTableNode: PropTypes.node,
  dataPath: PropTypes.string,
  totalPath: PropTypes.string,
  totalItems: PropTypes.number,
  countPath: PropTypes.string || PropTypes.number,
  onSelect: PropTypes.func,
  total: PropTypes.bool,
  scrollParams: PropTypes.object,
  defaultSorting: PropTypes.object,
  tableParams: PropTypes.object,
  innerRef: PropTypes.func,
  filter: PropTypes.func,
  onColumnsChanged: PropTypes.func,
  onDataChanged: PropTypes.func,
  onDataLoaded: PropTypes.func,
  onFetchDataError: PropTypes.func,
  onLoading: PropTypes.func,
  onDataLoading: PropTypes.func,
  skeleton: PropTypes.shape({
    columns: PropTypes.number,
    rows: PropTypes.number,
    classes: PropTypes.array
  }),
  loadingComponent: PropTypes.element,
  dataRequest: PropTypes.object,
  transformRequestParams: PropTypes.func,
  transformData: PropTypes.func,
  idField: PropTypes.string,
  selectAllWithoutLoading: PropTypes.bool,
  draggable: PropTypes.bool,
  removeTotalTag: PropTypes.bool,
  onDataSuccess: PropTypes.func,
  onCancel: PropTypes.func
};
TableComp.propTypes = props;
TableComponent.propTypes = props;

function ownKeys$8(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$8(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$8(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$8(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var options = [{
  value: 'csv',
  label: 'Download CSV'
}, {
  value: 'xlsx',
  label: 'Download XLSX'
}];
var urlMap = {
  csv: '#/download-csv',
  xlsx: '#/download-xlsx'
};

var getColumns = function getColumns(value, mapper) {
  return value.filter(function (column) {
    return !column.isGroupTitle;
  }).map(function (_ref) {
    var value = _ref.value,
        label = _ref.label;
    var obj = {
      value: value
    };
    var map = mapper[value];

    if (map) {
      obj = map;
    }

    return _objectSpread$8({
      label: label
    }, obj);
  }).filter(function (column) {
    return Boolean(column.value);
  });
};

var TableDownloadOptions = function TableDownloadOptions(props) {
  var fileName = props.fileName,
      columnsMapper = props.columnsMapper;

  var _useContext = useContext(TableWithOptionsContext),
      selectedColumns = _useContext.selectedColumns,
      csvDownloadRequest = _useContext.csvDownloadRequest,
      transformCSVDownloadRequest = _useContext.transformCSVDownloadRequest;

  var _useState = useState$2(null),
      _useState2 = _slicedToArray(_useState, 2),
      value = _useState2[0],
      setValue = _useState2[1];

  var removeValue = function removeValue() {
    setTimeout(function () {
      setValue(null);
    }, 1000);
  };

  var handleDownload = function handleDownload(newValue) {
    var url = urlMap[newValue.value];
    setValue(newValue);
    removeValue();

    var mapper = _objectSpread$8({}, columnsMapper);

    var calledApp = columnsMapper.calledApp || '';
    var activeTable = !!(mapper !== null && mapper !== void 0 && mapper.activeTable) ? {
      activeTable: mapper === null || mapper === void 0 ? void 0 : mapper.activeTable
    } : {};
    var columns = getColumns(selectedColumns, mapper);
    var baseCSVRequestParams = transformCSVDownloadRequest ? transformCSVDownloadRequest(csvDownloadRequest) : csvDownloadRequest;
    var params = {
      request: _objectSpread$8(_objectSpread$8(_objectSpread$8({}, baseCSVRequestParams), activeTable), {}, {
        columns: columns,
        calledApp: calledApp
      }),
      component: {
        fileName: fileName
      }
    }; // base64 doesn't work with unicode symbols, line below remove all unicode

    var base64 = btoa(JSON.stringify(params).replace(/[\u00A0-\u2666]/g, ''));
    window.open("".concat(url, "?params=").concat(base64), '_blank');
  };

  return /*#__PURE__*/React__default.createElement(Select, {
    isMenu: true,
    renderMenuTarget: function renderMenuTarget(onMenuTargetClick, isOpen) {
      return /*#__PURE__*/React__default.createElement(ButtonCircle, {
        type: "button",
        iconName: "Download",
        className: "opener__btn",
        onClick: function onClick(e) {
          e.stopPropagation();
          document.body.click(); // clickaway issue fix

          onMenuTargetClick(e);
        }
      });
    },
    options: options,
    onChange: handleDownload,
    value: value,
    className: "table__download",
    maxSelectedLimit: 0,
    menuClassName: "table-menu-width-small"
  });
};
TableDownloadOptions.defaultProps = {
  columnsMapper: {}
};
TableDownloadOptions.propTypes = {
  fileName: PropTypes.string,
  columnsMapper: PropTypes.objectOf(PropTypes.shape({
    value: PropTypes.string,
    label: PropTypes.string,
    format: PropTypes.oneOf(['date'])
  }))
};

var TimezoneContext = /*#__PURE__*/React__default.createContext({
  timezone: null,
  onTimezoneChange: null,
  isChangedByTimezonePicker: true
});

function _createSuper$8(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$8(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct$8() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var TimezoneProvider = /*#__PURE__*/function (_React$Component) {
  _inherits(TimezoneProvider, _React$Component);

  var _super = _createSuper$8(TimezoneProvider);

  function TimezoneProvider(props) {
    var _this;

    _classCallCheck(this, TimezoneProvider);

    _this = _super.call(this, props);

    _this.updateTimezone = function (activeTimezone) {
      _this.setState({
        activeTimezone: activeTimezone,
        isChangedByTimezonePicker: true
      });
    };

    var user = AuthService.getUser();
    _this.state = {
      activeTimezone: props.timezone,
      isChangedByTimezonePicker: true
    };

    if (!_this.state.activeTimezone) {
      _this.state.activeTimezone = user && user.timezoneName ? {
        value: user.timezoneName,
        id: user.timezoneId
      } : {
        value: moment$1.tz.guess(),
        label: moment$1.tz.guess()
      };
    }

    return _this;
  }

  _createClass(TimezoneProvider, [{
    key: "componentDidMount",
    value: function () {
      var _componentDidMount = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee() {
        var _yield$TimezoneServic, defaultUserTimezone;

        return regenerator.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return TimezonesService.getState();

              case 2:
                _yield$TimezoneServic = _context.sent;
                defaultUserTimezone = _yield$TimezoneServic.defaultUserTimezone;

                if (!this.state.activeTimezone || this.state.activeTimezone.value === defaultUserTimezone.value) {
                  this.setState({
                    activeTimezone: defaultUserTimezone
                  });
                }

              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function componentDidMount() {
        return _componentDidMount.apply(this, arguments);
      }

      return componentDidMount;
    }()
  }, {
    key: "componentDidUpdate",
    value: function () {
      var _componentDidUpdate = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee2(oldProps, oldState) {
        var _yield$TimezoneServic2, defaultUserTimezone;

        return regenerator.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!(oldProps.timezone !== this.props.timezone && this.props.timezone !== this.state.activeTimezone)) {
                  _context2.next = 4;
                  break;
                }

                this.setState({
                  activeTimezone: this.props.timezone,
                  isChangedByTimezonePicker: false
                });
                _context2.next = 10;
                break;

              case 4:
                if (this.props.timezone) {
                  _context2.next = 10;
                  break;
                }

                _context2.next = 7;
                return TimezonesService.getState();

              case 7:
                _yield$TimezoneServic2 = _context2.sent;
                defaultUserTimezone = _yield$TimezoneServic2.defaultUserTimezone;

                if (!isEqual(this.state.activeTimezone, defaultUserTimezone)) {
                  this.setState({
                    activeTimezone: defaultUserTimezone,
                    isChangedByTimezonePicker: true
                  });
                }

              case 10:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function componentDidUpdate(_x, _x2) {
        return _componentDidUpdate.apply(this, arguments);
      }

      return componentDidUpdate;
    }()
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/React__default.createElement(TimezoneContext.Provider, {
        value: {
          isChangedByTimezonePicker: this.state.isChangedByTimezonePicker,
          timezone: this.state.activeTimezone,
          onTimezoneChange: this.updateTimezone
        }
      }, this.props.children);
    }
  }]);

  return TimezoneProvider;
}(React__default.Component);
TimezoneProvider.propTypes = {
  timezone: PropTypes.shape({
    label: PropTypes.string,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
  })
};

function _createSuper$9(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$9(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct$9() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var BtnWrapper = function BtnWrapper(_ref) {
  var children = _ref.children,
      className = _ref.className,
      tooltipParams = _ref.tooltipParams;
  return tooltipParams ? /*#__PURE__*/React__default.createElement(Tooltip, _extends({
    className: className
  }, tooltipParams), children) : /*#__PURE__*/React__default.createElement("div", {
    className: className
  }, children);
};

var TimezonePicker = /*#__PURE__*/function (_React$Component) {
  _inherits(TimezonePicker, _React$Component);

  var _super = _createSuper$9(TimezonePicker);

  function TimezonePicker() {
    var _this;

    _classCallCheck(this, TimezonePicker);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    _this.state = {
      isOpen: false,
      defaultUserTimezone: null,
      timezoneOptions: [],
      selectedTimezone: _this.context.timezone,
      previousTimezone: _this.context.timezone,
      search: ''
    };

    _this.toggleDropdown = function (_ref2) {
      var target = _ref2.target;

      if (target === _this.searchEl || _this.searchEl.contains(target)) {
        return;
      }

      _this.setState({
        isOpen: !_this.state.isOpen
      });
    };

    _this.handleClickOutside = function () {
      var _this$state$previousT;

      if (_this.state.isOpen) {
        _this.setState({
          isOpen: !_this.state.isOpen
        });
      }

      if (_this.props.variant === 'withTickbox' && (_this$state$previousT = _this.state.previousTimezone) !== null && _this$state$previousT !== void 0 && _this$state$previousT.value) {
        var _this$state$previousT2;

        // revert to previously selected timezone on click outside (not saving if user didn't click the tickbox)
        _this.onChange((_this$state$previousT2 = _this.state.previousTimezone) === null || _this$state$previousT2 === void 0 ? void 0 : _this$state$previousT2.value)();
      }
    };

    _this.onChange = function (value) {
      return function () {
        var timezoneOptions = _this.state.timezoneOptions;
        var timezoneOption = timezoneOptions.filter(function (i) {
          return i.value === value;
        })[0];

        if (_this.context.onTimezoneChange) {
          _this.context.onTimezoneChange(timezoneOption);
        }

        if (_this.props.onTimezoneChange) {
          _this.props.onTimezoneChange(timezoneOption);
        }
      };
    };

    _this.onSearchChange = function (_ref3) {
      var target = _ref3.target;

      _this.setState({
        search: target.value
      });
    };

    return _this;
  }

  _createClass(TimezonePicker, [{
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(newProps, newState) {
      return newState.isOpen !== this.state.isOpen || newState.timezoneOptions !== this.state.timezoneOptions || newState.selectedTimezone !== this.state.selectedTimezone || newProps.selectedTimezone !== this.props.selectedTimezone || newState.search !== this.state.search;
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      TimezonesService.clearState();
    }
  }, {
    key: "componentDidMount",
    value: function () {
      var _componentDidMount = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee() {
        var _this$props, onLoaded, onError, _yield$TimezoneServic, defaultUserTimezone, timezoneOptions, error, newState;

        return regenerator.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this$props = this.props, onLoaded = _this$props.onLoaded, onError = _this$props.onError;
                _context.next = 3;
                return TimezonesService.getState();

              case 3:
                _yield$TimezoneServic = _context.sent;
                defaultUserTimezone = _yield$TimezoneServic.defaultUserTimezone;
                timezoneOptions = _yield$TimezoneServic.timezoneOptions;
                error = _yield$TimezoneServic.error;
                newState = {
                  timezoneOptions: timezoneOptions,
                  defaultUserTimezone: defaultUserTimezone
                };

                if (!this.state.selectedTimezone || this.state.selectedTimezone.value === defaultUserTimezone.value) {
                  newState.selectedTimezone = defaultUserTimezone;

                  if (this.context.onTimezoneChange) {
                    this.context.onTimezoneChange(defaultUserTimezone);
                  }

                  if (this.props.onTimezoneChange) {
                    this.props.onTimezoneChange(defaultUserTimezone);
                  }
                }

                this.setState(newState);

                if (onLoaded) {
                  onLoaded(timezoneOptions, error);
                }

                if (onError && error) {
                  onError(error);
                }

              case 12:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function componentDidMount() {
        return _componentDidMount.apply(this, arguments);
      }

      return componentDidMount;
    }()
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props2 = this.props,
          className = _this$props2.className,
          placeholder = _this$props2.placeholder,
          label = _this$props2.label,
          tooltipParams = _this$props2.tooltipParams,
          noLabel = _this$props2.noLabel,
          variant = _this$props2.variant,
          confirmButtonClicked = _this$props2.confirmButtonClicked,
          showLabelAlways = _this$props2.showLabelAlways,
          isReadOnly = _this$props2.isReadOnly;
      var _this$state = this.state,
          isOpen = _this$state.isOpen,
          search = _this$state.search;
      var timezoneOptions = this.state.timezoneOptions;
      var selectedTimezone = this.context.timezone || this.props.selectedTimezone;
      var selectedTimezoneValue = get$1(selectedTimezone, 'value');
      var selectedTimezoneLabel = get$1(selectedTimezone, 'label');
      var timezoneOptionButtons;

      if (timezoneOptions) {
        if (search) {
          timezoneOptions = timezoneOptions.filter(function (i) {
            return new RegExp("".concat(search), 'i').test(i.label);
          });
        }

        timezoneOptionButtons = timezoneOptions.map(function (timezoneOption) {
          return /*#__PURE__*/React__default.createElement("button", {
            className: "timezone-picker__option ".concat(timezoneOption.value === selectedTimezoneValue ? '_active' : ''),
            key: timezoneOption.value,
            onClick: _this2.onChange(timezoneOption.value)
          }, timezoneOption.label);
        });
      }

      return /*#__PURE__*/React__default.createElement("div", {
        tabIndex: 0,
        className: "timezone-picker ".concat(isOpen ? '_opened' : '', " ").concat(className, " _").concat(variant),
        onClick: (!this.state.isOpen || variant !== 'withTickbox') && !isReadOnly ? this.toggleDropdown : null,
        onKeyDown: !isReadOnly ? function (e) {
          if (e.keyCode === 13 || e.keyCode === 32) {
            _this2.toggleDropdown(e);

            e.stopPropagation();
          }
        } : undefined
      }, (!noLabel || showLabelAlways) && /*#__PURE__*/React__default.createElement("div", {
        className: "timezone-picker__label"
      }, label || 'Timezone'), /*#__PURE__*/React__default.createElement("div", {
        className: "timezone-picker__wrapper"
      }, /*#__PURE__*/React__default.createElement(BtnWrapper, {
        className: "timezone-picker__btn",
        tooltipParams: tooltipParams
      }, !isOpen && /*#__PURE__*/React__default.createElement(Icon, {
        className: "_size-20 timezone-picker__icon",
        fill: "#a2a2a2",
        name: "Timezone"
      }), /*#__PURE__*/React__default.createElement("span", {
        className: "timezone-picker__title"
      }, selectedTimezoneLabel || placeholder || 'Select...')), /*#__PURE__*/React__default.createElement("div", {
        className: "timezone-picker__list-wrapper"
      }, /*#__PURE__*/React__default.createElement("div", {
        ref: function ref(el) {
          _this2.searchEl = el;
        },
        className: "timezone-picker__search"
      }, /*#__PURE__*/React__default.createElement(TextFieldWithIcon, {
        iconName: "Search",
        value: search,
        onChange: this.onSearchChange
      })), /*#__PURE__*/React__default.createElement("div", {
        className: "timezone-picker__list"
      }, timezoneOptionButtons)), variant === 'withTickbox' && this.state.isOpen ? /*#__PURE__*/React__default.createElement(ButtonCircle, {
        onClick: function onClick(e) {
          var tz = _this2.context.timezone || _this2.props.selectedTimezone;

          _this2.toggleDropdown(e);

          _this2.setState({
            previousTimezone: tz
          });

          confirmButtonClicked(tz);
        },
        variant: "primary",
        iconName: "CheckCircleBW",
        className: "timezone-picker__confirmBtn",
        tabIndex: 0
      }) : null));
    }
  }]);

  return TimezonePicker;
}(React__default.Component);

TimezonePicker.contextType = TimezoneContext;
var TimezonePicker$1 = withClickOutside(TimezonePicker);
BtnWrapper.propTypes = {
  className: PropTypes.string,
  tooltipParams: PropTypes.object
};
TimezonePicker.defaultProps = {
  variant: 'withoutTickbox',
  showLabelAlways: false,
  noLabel: true,
  className: ''
};
TimezonePicker.propTypes = {
  selectedTimezone: PropTypes.shape({
    label: PropTypes.string,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
  }),
  onTimezoneChange: PropTypes.func,
  placeholder: PropTypes.string,
  className: PropTypes.string,
  label: PropTypes.string,
  noLabel: PropTypes.bool,
  tooltipParams: PropTypes.object,
  onLoaded: PropTypes.func,
  onError: PropTypes.func,
  variant: PropTypes.oneOf(['withTickbox', 'withoutTickbox']),
  confirmButtonClicked: PropTypes.func,
  showLabelAlways: PropTypes.bool
};

var EMAIL_REGEX = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
var FULL_DAY_FORMAT = 'YYYY-MM-DD HH:mm:ss';
var AM_PM_DATE_TIME_FORMAT = 'MM/DD/YYYY hh:mm A';
var IQM_VIDEO_URL = 'https://d1l57a72s0sxfy.cloudfront.net/1/1/065f2389fdf134.mp4';
var AD_URL = 'https://www3.doubleclick.net';

function ownKeys$9(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$9(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$9(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$9(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _createSuper$a(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$a(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct$a() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
var getTimezoneCurrentDay = function getTimezoneCurrentDay(timezone) {
  return moment$1.tz(moment$1().utc(), 'UTC').tz(timezone);
};
var convertTimezoneDayToOSTimezone = function convertTimezoneDayToOSTimezone(date) {
  return moment$1.tz(date.format('YYYY-MM-DD HH:mm:ss'), moment$1.tz.guess());
};
var PRESELECT_KEYS = {
  START_TO_NOW: 'START_TO_NOW',
  TODAY: 'TODAY',
  YESTERDAY: 'YESTERDAY',
  LAST_WEEK: 'LAST_WEEK',
  LAST_MONTH: 'LAST_MONTH',
  LAST_THREE_MONTHS: 'LAST_THREE_MONTHS'
};

var EpochDateRangePicker = /*#__PURE__*/function (_React$Component) {
  _inherits(EpochDateRangePicker, _React$Component);

  var _super = _createSuper$a(EpochDateRangePicker);

  function EpochDateRangePicker() {
    var _PRESELECTED_VALUES;

    var _this;

    _classCallCheck(this, EpochDateRangePicker);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    _this.state = {
      PRESELECTED_VALUES: (_PRESELECTED_VALUES = {}, _defineProperty(_PRESELECTED_VALUES, PRESELECT_KEYS.START_TO_NOW, {
        key: PRESELECT_KEYS.START_TO_NOW,
        title: 'Start To Now',
        start: function start(tz) {
          return moment$1.unix(_this.props.startDate).tz(tz).startOf('day');
        },
        end: function end(tz) {
          return convertTimezoneDayToOSTimezone(getTimezoneCurrentDay(tz).endOf('day'));
        }
      }), _defineProperty(_PRESELECTED_VALUES, PRESELECT_KEYS.TODAY, {
        key: PRESELECT_KEYS.TODAY,
        title: 'Today',
        start: function start(tz) {
          return convertTimezoneDayToOSTimezone(getTimezoneCurrentDay(tz).startOf('day'));
        },
        end: function end(tz) {
          return convertTimezoneDayToOSTimezone(getTimezoneCurrentDay(tz).endOf('day'));
        }
      }), _defineProperty(_PRESELECTED_VALUES, PRESELECT_KEYS.YESTERDAY, {
        key: PRESELECT_KEYS.YESTERDAY,
        title: 'Yesterday',
        start: function start(tz) {
          return convertTimezoneDayToOSTimezone(getTimezoneCurrentDay(tz).startOf('day').add(-1, 'day'));
        },
        end: function end(tz) {
          return convertTimezoneDayToOSTimezone(getTimezoneCurrentDay(tz).endOf('day').add(-1, 'day'));
        }
      }), _defineProperty(_PRESELECTED_VALUES, PRESELECT_KEYS.LAST_WEEK, {
        key: PRESELECT_KEYS.LAST_WEEK,
        title: 'Week',
        start: function start(tz) {
          return convertTimezoneDayToOSTimezone(getTimezoneCurrentDay(tz).startOf('day').add(-1, 'week').add(1, 'day'));
        },
        end: function end(tz) {
          return convertTimezoneDayToOSTimezone(getTimezoneCurrentDay(tz).endOf('day'));
        }
      }), _defineProperty(_PRESELECTED_VALUES, PRESELECT_KEYS.LAST_MONTH, {
        key: PRESELECT_KEYS.LAST_MONTH,
        title: 'Month',
        start: function start(tz) {
          return convertTimezoneDayToOSTimezone(getTimezoneCurrentDay(tz).startOf('day').add(-1, 'month').add(1, 'day'));
        },
        end: function end(tz) {
          return convertTimezoneDayToOSTimezone(getTimezoneCurrentDay(tz).endOf('day'));
        }
      }), _defineProperty(_PRESELECTED_VALUES, PRESELECT_KEYS.LAST_THREE_MONTHS, {
        key: PRESELECT_KEYS.LAST_THREE_MONTHS,
        title: '3 Months',
        start: function start(tz) {
          return convertTimezoneDayToOSTimezone(getTimezoneCurrentDay(tz).startOf('day').add(-3, 'month').add(1, 'day'));
        },
        end: function end(tz) {
          return convertTimezoneDayToOSTimezone(getTimezoneCurrentDay(tz).endOf('day'));
        }
      }), _PRESELECTED_VALUES)
    };

    _this.getActiveTimezone = function () {
      return _this.context.timezone || _this.state.activeTimezone;
    };

    _this.getCalendarMaximaAndMinima = function (timezone) {
      var activeTimezone = timezone || _this.getActiveTimezone();

      var activeTimezoneCurrentDate = moment$1.tz(moment$1().utc(), 'UTC').tz(activeTimezone.value);
      var activeTimezoneStartDate = activeTimezoneCurrentDate.clone().add(-1, 'year').startOf('day');
      var activeTimezoneEndDate = activeTimezoneCurrentDate.clone().endOf('day');
      var calendarMinimumDate = moment$1.tz(activeTimezoneStartDate.format(FULL_DAY_FORMAT), moment$1.tz.guess());
      var calendarMaximumDate = moment$1.tz(activeTimezoneEndDate.format(FULL_DAY_FORMAT), moment$1.tz.guess());
      return {
        calendarMinimumDate: calendarMinimumDate.toDate(),
        calendarMaximumDate: calendarMaximumDate.toDate()
      };
    };

    _this.getDateRangeState = function (props, activeTimezone) {
      var recievedThruPropsEpochDateRange = props.dateRange;
      var calendarStartDate;
      var calendarEndDate;
      var activeTimezoneStartDate;
      var activeTimezoneEndDate;

      if (!recievedThruPropsEpochDateRange) {
        if (props.defaultDateRange) {
          calendarStartDate = props.defaultDateRange.getStartDate(activeTimezone.value);
          calendarEndDate = props.defaultDateRange.getEndDate(activeTimezone.value);
        } else {
          throw new Error('A default date range getter [defaultDateRange] is required when no a date range is passed');
        }

        activeTimezoneStartDate = moment$1.tz(calendarStartDate.clone().format(FULL_DAY_FORMAT), activeTimezone.value);
        activeTimezoneEndDate = moment$1.tz(calendarEndDate.clone().format(FULL_DAY_FORMAT), activeTimezone.value);
      } else {
        activeTimezoneStartDate = moment$1.tz(recievedThruPropsEpochDateRange.startDate, activeTimezone.value);
        activeTimezoneEndDate = moment$1.tz(recievedThruPropsEpochDateRange.endDate, activeTimezone.value);
        calendarStartDate = moment$1.tz(activeTimezoneStartDate.format(FULL_DAY_FORMAT), moment$1.tz.guess());
        calendarEndDate = moment$1.tz(activeTimezoneEndDate.format(FULL_DAY_FORMAT), moment$1.tz.guess());
      }

      return {
        epochDateRange: {
          startDate: activeTimezoneStartDate.valueOf(),
          endDate: activeTimezoneEndDate.valueOf()
        },
        calendarDateRange: {
          start: calendarStartDate.startOf('day').toDate(),
          end: calendarEndDate.endOf('day').toDate()
        }
      };
    };

    _this.getInitialState = function (props) {
      var activeTimezone = _this.context.timezone;
      return _objectSpread$9(_objectSpread$9({
        activeTimezone: activeTimezone,
        preselectKey: null
      }, _this.getCalendarMaximaAndMinima(activeTimezone)), _this.getDateRangeState(props, activeTimezone));
    };

    _this.updateEpochForNewTimezone = function (activeTimezone) {
      var newState = _this.getCalendarMaximaAndMinima(activeTimezone);

      newState.activeTimezone = activeTimezone;

      if (_this.state.preselectKey) {
        Object.assign(newState, _this.getPreselectedDateRanges(_this.state.preselectKey, activeTimezone));
      } else {
        var calendarStartDate = moment$1.tz(_this.state.calendarDateRange.start, moment$1.tz.guess());
        var calendarEndDate = moment$1.tz(_this.state.calendarDateRange.end, moment$1.tz.guess());
        var activeTimezoneStartDate = moment$1.tz(calendarStartDate.clone().format(FULL_DAY_FORMAT), activeTimezone.value);
        var activeTimezoneEndDate = moment$1.tz(calendarEndDate.clone().format(FULL_DAY_FORMAT), activeTimezone.value);
        var epochStartDate = activeTimezoneStartDate.valueOf();
        var epochEndDate = activeTimezoneEndDate.valueOf();

        if (_this.sameDay(_this.state.calendarMaximumDate, _this.state.calendarDateRange.end) && !_this.sameDay(_this.state.calendarMaximumDate, newState.calendarMaximumDate)) {
          if (calendarEndDate.isAfter(moment$1(newState.calendarMaximumDate))) {
            calendarStartDate.add(-1, 'day');
            calendarEndDate.add(-1, 'day');
            epochStartDate = activeTimezoneStartDate.clone().add(-1, 'day').valueOf();
            epochEndDate = activeTimezoneEndDate.clone().add(-1, 'day').valueOf();
          } else {
            calendarStartDate.add(1, 'day');
            calendarEndDate.add(1, 'day');
            epochStartDate = activeTimezoneStartDate.clone().add(1, 'day').valueOf();
            epochEndDate = activeTimezoneEndDate.clone().add(1, 'day').valueOf();
          }
        }

        Object.assign(newState, {
          epochDateRange: {
            startDate: epochStartDate,
            endDate: epochEndDate
          },
          calendarDateRange: {
            start: calendarStartDate.toDate(),
            end: calendarEndDate.toDate()
          }
        });
      }

      _this.setState(newState);
    };

    _this.sameDay = function (d1, d2) {
      return d1.getFullYear() === d2.getFullYear() && d1.getMonth() === d2.getMonth() && d1.getDate() === d2.getDate();
    };

    _this.getPreselectedDateRanges = function (preselectKey, activeTimezone) {
      var preselect = _this.props.preselected.find(function (preselect) {
        return isObject$1(preselect) ? preselectKey === preselect.key : preselectKey === preselect;
      });

      if (!isObject$1(preselect)) {
        preselect = _this.state.PRESELECTED_VALUES[preselect];
      }

      if (!preselect) {
        throw new Error('Cannot get a preselect object.');
      }

      var calendarStartDate = preselect.start(activeTimezone.value);
      var calendarEndDate = preselect.end(activeTimezone.value);
      var activeTimezoneStartDate = moment$1.tz(calendarStartDate.format(FULL_DAY_FORMAT), activeTimezone.value);
      var activeTimezoneEndDate = moment$1.tz(calendarEndDate.format(FULL_DAY_FORMAT), activeTimezone.value);
      var epochStartDate = activeTimezoneStartDate.valueOf();
      var epochEndDate = activeTimezoneEndDate.valueOf();
      return {
        epochDateRange: {
          startDate: epochStartDate,
          endDate: epochEndDate
        },
        calendarDateRange: {
          start: calendarStartDate.toDate(),
          end: calendarEndDate.toDate()
        }
      };
    };

    _this.updateDateRange = function (startDate, endDate, preselectKey) {
      var activeTimezone = _this.getActiveTimezone();

      if (!moment$1.isMoment(startDate)) {
        startDate = moment$1(startDate);
      }

      if (!moment$1.isMoment(endDate)) {
        endDate = moment$1(endDate);
      }

      startDate = startDate.startOf('day');
      endDate = endDate.endOf('day');
      var stateUpdater = {
        preselectKey: preselectKey
      };

      if (preselectKey) {
        Object.assign(stateUpdater, _this.getPreselectedDateRanges(preselectKey, activeTimezone));
      } else {
        var activeTimezoneStartDate = moment$1.tz(startDate.format(FULL_DAY_FORMAT), activeTimezone.value);
        var activeTimezoneEndDate = moment$1.tz(endDate.format(FULL_DAY_FORMAT), activeTimezone.value);
        var epochStartDate = activeTimezoneStartDate.valueOf();
        var epochEndDate = activeTimezoneEndDate.valueOf();
        Object.assign(stateUpdater, {
          epochDateRange: {
            startDate: epochStartDate,
            endDate: epochEndDate
          },
          calendarDateRange: {
            start: startDate.toDate(),
            end: endDate.toDate()
          }
        });
      }

      _this.setState(stateUpdater);
    };

    _this.getPreselect = function (timezone) {
      var currentTimezone = timezone || _this.getActiveTimezone();

      return currentTimezone && _this.props.preselected.map(function (preselect) {
        if (!isObject$1(preselect)) {
          preselect = _this.state.PRESELECTED_VALUES[preselect];
        }

        if (!preselect) {
          throw new Error('Cannot get a preselect object.');
        }

        var calendarStartDate = preselect.start(currentTimezone.value);
        var calendarEndDate = preselect.end(currentTimezone.value);
        return _objectSpread$9(_objectSpread$9({}, preselect), {}, {
          start: calendarStartDate.toDate(),
          end: calendarEndDate.toDate()
        });
      });
    };

    return _this;
  }

  _createClass(EpochDateRangePicker, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.setState(this.getInitialState(this.props));
      this.setState(function (state, props) {
        return {
          PRESELECTED_VALUES: _objectSpread$9(_objectSpread$9({}, state.PRESELECTED_VALUES), {}, {
            startDate: props.startDate
          })
        };
      });
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(oldProps, oldState) {
      if (this.context.timezone && this.context.timezone !== this.state.activeTimezone) {
        if (this.props.dateRange && !isEqual(this.props.dateRange, this.state.epochDateRange)) {
          return this.setState(this.getInitialState(this.props));
        }

        return this.state.activeTimezone && this.context.isChangedByTimezonePicker ? this.updateEpochForNewTimezone(this.context.timezone) : this.setState(this.getInitialState(this.props));
      }

      if (this.props.dateRange) {
        if (this.state.epochDateRange) {
          if (!isEqual(this.props.dateRange, oldProps.dateRange) && !isEqual(this.props.dateRange, this.state.epochDateRange)) {
            return this.setState(this.getInitialState(this.props));
          }
        } else {
          return this.setState(this.getInitialState(this.props));
        }
      } else {
        if (!this.state.epochDateRange || oldProps.dateRange) {
          return this.setState(this.getInitialState(this.props));
        }
      }

      if (!this.props.dateRange || !oldState.epochDateRange && this.state.epochDateRange || !isEqual(oldState.epochDateRange, this.state.epochDateRange)) {
        this.props.onDateRangeChange(this.state.epochDateRange);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var datePickerProps = _objectSpread$9({
        maximumDate: this.state.calendarMaximumDate,
        minimumDate: this.state.calendarMinimumDate
      }, this.props.datePickerProps);

      return /*#__PURE__*/React__default.createElement(DatesPicker, _extends({}, this.props, {
        datePickerProps: datePickerProps,
        updateDateRange: this.updateDateRange,
        dateRange: this.state.calendarDateRange || this.props.dateRange,
        insidePreselectors: true,
        preselected: this.getPreselect()
      }));
    }
  }]);

  return EpochDateRangePicker;
}(React__default.Component);

EpochDateRangePicker.contextType = TimezoneContext;
EpochDateRangePicker.PRESELECT_KEYS = PRESELECT_KEYS;
EpochDateRangePicker.propTypes = {
  dateRange: PropTypes.object,
  datePickerProps: PropTypes.object,
  preselected: PropTypes.array,
  onDateRangeChange: PropTypes.func,
  label: PropTypes.string,
  startDate: PropTypes.number
};

var css_248z$6 = ":root {\n  --primary1: #123787;\n  --primary2: #1d58d7;\n  --primary3: #5173fb;\n  --primary4: #7a93ff;\n  --primary5: #c2d0ff;\n  --primary6: #e5ebff;\n  --primary7: #f2f5ff; }\n\n@keyframes index-module_hover-ripples__3Dx_B {\n  0% {\n    top: -0.1875em;\n    left: -0.1875em;\n    right: -0.1875em;\n    bottom: -0.1875em;\n    opacity: 1; }\n  100% {\n    top: -0.8125em;\n    left: -0.8125em;\n    right: -0.8125em;\n    bottom: -0.8125em;\n    opacity: 0; } }\n\n.index-module_datePickerWrapper__2q7sk {\n  display: flex;\n  padding-top: 0.5rem;\n  margin-left: -0.5rem;\n  margin-top: 0.5rem; }\n  .index-module_datePickerWrapper__2q7sk .index-module_label__3e3Q- {\n    position: absolute;\n    z-index: 1;\n    top: 0;\n    left: 1.5rem;\n    padding: 0;\n    max-width: calc(100% - 32rem / 16);\n    background: transparent;\n    overflow: hidden;\n    font-family: 'Avenir Next Regular', sans-serif;\n    font-weight: normal;\n    letter-spacing: .2px;\n    font-size: 0.75rem;\n    line-height: 1rem;\n    z-index: 1;\n    color: #666666; }\n  .index-module_datePickerWrapper__2q7sk .date-confirmBtn.btn-v2 {\n    position: absolute;\n    right: 0;\n    top: 0;\n    background-color: var(--primary2);\n    border-radius: 0 0.25rem 0.25rem 0;\n    height: 2.25rem;\n    width: 2.125rem; }\n  .index-module_datePickerWrapper__2q7sk .date-range-picker .date-picker {\n    width: 100%;\n    padding-left: 0.25rem; }\n    .index-module_datePickerWrapper__2q7sk .date-range-picker .date-picker._withTickbox {\n      width: calc(100% - 34rem / 16); }\n      .index-module_datePickerWrapper__2q7sk .date-range-picker .date-picker._withTickbox._opened {\n        width: 100%; }\n    .index-module_datePickerWrapper__2q7sk .date-range-picker .date-picker:not(._opened) {\n      border-color: transparent; }\n      .index-module_datePickerWrapper__2q7sk .date-range-picker .date-picker:not(._opened) .date-picker__wrapper {\n        position: relative; }\n        .index-module_datePickerWrapper__2q7sk .date-range-picker .date-picker:not(._opened) .date-picker__wrapper .date-picker__item {\n          position: absolute;\n          padding-bottom: 0.25rem;\n          top: -0.5rem;\n          border-bottom: 1px dashed #cbcbcb;\n          left: -1.875rem;\n          padding-left: 1.875rem; }\n    .index-module_datePickerWrapper__2q7sk .date-range-picker .date-picker._disabled {\n      pointer-events: none;\n      user-select: none; }\n      .index-module_datePickerWrapper__2q7sk .date-range-picker .date-picker._disabled .date-picker__wrapper .date-picker__item {\n        border-bottom-color: transparent; }\n    .index-module_datePickerWrapper__2q7sk .date-range-picker .date-picker:hover:not(._disabled) {\n      border-color: #cbcbcb; }\n    .index-module_datePickerWrapper__2q7sk .date-range-picker .date-picker._opened .date-picker__wrapper .date-picker__item,\n    .index-module_datePickerWrapper__2q7sk .date-range-picker .date-picker:hover .date-picker__wrapper .date-picker__item {\n      border-bottom: unset;\n      left: unset;\n      padding-left: unset; }\n    .index-module_datePickerWrapper__2q7sk .date-range-picker .date-picker._error {\n      border-color: #FF6060; }\n";
var styles$5 = {"datePickerWrapper":"index-module_datePickerWrapper__2q7sk","label":"index-module_label__3e3Q-","hover-ripples":"index-module_hover-ripples__3Dx_B"};
styleInject(css_248z$6);

function ownKeys$a(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$a(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$a(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$a(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _createSuper$b(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$b(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct$b() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
var ERROR_MESSAGE = 'End time must be at least 15 min in the future and was corrected.';

var PRESELECTED_VALUES = _defineProperty({}, PRESELECT_KEYS.TODAY, {
  key: PRESELECT_KEYS.TODAY,
  title: 'Today',
  date: function date(tz) {
    return convertTimezoneDayToOSTimezone(getTimezoneCurrentDay(tz));
  }
});

var EpochDatePicker = /*#__PURE__*/function (_React$Component) {
  _inherits(EpochDatePicker, _React$Component);

  var _super = _createSuper$b(EpochDatePicker);

  function EpochDatePicker() {
    var _this;

    _classCallCheck(this, EpochDatePicker);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    _this.state = {};

    _this.getSingleDateState = function (props, activeTimezone) {
      var recievedThruPropsEpochDate = props.singleDate;
      var calendarDate;
      var activeTimezoneDate;

      if (!recievedThruPropsEpochDate) {
        if (props.defaultDate) {
          calendarDate = props.defaultDate(activeTimezone.value);
          activeTimezoneDate = moment$1.tz(calendarDate.clone().format(FULL_DAY_FORMAT), activeTimezone.value);
        }
      } else {
        activeTimezoneDate = moment$1.tz(recievedThruPropsEpochDate, activeTimezone.value);
        calendarDate = moment$1.tz(activeTimezoneDate.format(FULL_DAY_FORMAT), moment$1.tz.guess());
      }

      return _objectSpread$a({
        calendarDate: calendarDate && calendarDate.toDate(),
        epochDate: activeTimezoneDate && activeTimezoneDate.valueOf()
      }, _this.getCalendarMaximaAndMinima(activeTimezone));
    };

    _this.getCalendarMaximaAndMinima = function (timezone, shouldConvertDates) {
      var activeTimezone = timezone || _this.context.timezone;
      var calendarMinimumDate;
      var calendarMaximumDate;

      if (_this.props.calendarMinimumDate) {
        if (_this.props.calendarMinimumDate instanceof Date && !shouldConvertDates) {
          calendarMinimumDate = _this.props.calendarMinimumDate;
        } else {
          var activeTimezoneMinimumDate = moment$1.tz(moment$1(_this.props.calendarMinimumDate), 'UTC').tz(activeTimezone.value);
          calendarMinimumDate = moment$1.tz(activeTimezoneMinimumDate.format(FULL_DAY_FORMAT), moment$1.tz.guess()).toDate();
        }
      }

      if (_this.props.calendarMaximumDate) {
        if (_this.props.calendarMaximumDate instanceof Date && !shouldConvertDates) {
          calendarMaximumDate = _this.props.calendarMaximumDate;
        } else {
          var activeTimezoneMaximumDate = moment$1.tz(moment$1(_this.props.calendarMaximumDate), 'UTC').tz(activeTimezone.value);
          calendarMaximumDate = moment$1.tz(activeTimezoneMaximumDate.format(FULL_DAY_FORMAT), moment$1.tz.guess()).toDate();
        }
      }

      return {
        calendarMinimumDate: calendarMinimumDate,
        calendarMaximumDate: calendarMaximumDate
      };
    };

    _this.getPreselect = function (timezone) {
      var currentTimezone = timezone || _this.context.timezone || _this.state.activeTimezone;
      var preselectedValues = get$2(_this.props, 'preselected', []);
      return currentTimezone && preselectedValues.map(function (preselect) {
        if (!isObject$2(preselect)) {
          preselect = PRESELECTED_VALUES[preselect];
        }

        if (!preselect) {
          throw new Error('Cannot get a preselect object.');
        }

        var calendarDate = preselect.date(currentTimezone.value, convertTimezoneDayToOSTimezone, getTimezoneCurrentDay);
        return _objectSpread$a(_objectSpread$a({}, preselect), {}, {
          date: calendarDate
        });
      });
    };

    _this.sameDay = function (d1, d2) {
      if (!d1 || !d2) return false;
      return d1.getFullYear() === d2.getFullYear() && d1.getMonth() === d2.getMonth() && d1.getDate() === d2.getDate();
    };

    _this.getInitialState = function (props) {
      var activeTimezone = _this.context.timezone;
      return _objectSpread$a({
        activeTimezone: activeTimezone
      }, _this.getSingleDateState(props, activeTimezone));
    };

    _this.updateEpochForNewTimezone = function (activeTimezone) {
      if (!_this.state.calendarDate) {
        return;
      }

      var newState = _this.getCalendarMaximaAndMinima(activeTimezone, true);

      var calendarDate = moment$1.tz(_this.state.calendarDate, moment$1.tz.guess());
      var selectedTimezoneDate = moment$1.tz(calendarDate.clone().format(FULL_DAY_FORMAT), activeTimezone.value);
      var epochDate = selectedTimezoneDate.valueOf(); // old calendarMaximumDate and new calendarMaximumDate is different

      if (!_this.sameDay(_this.state.calendarMaximumDate, newState.calendarMaximumDate) // the calendar date date is the same as calendarMinimumDate or calendarMaximumDate
      && (_this.sameDay(_this.state.calendarMinimumDate, _this.state.calendarDate) || _this.sameDay(_this.state.calendarMaximumDate, _this.state.calendarDate))) {
        if (calendarDate.isAfter(moment$1(newState.calendarMaximumDate))) {
          if (newState.calendarMaximumDate) {
            calendarDate.add(-1, 'day');
            epochDate = selectedTimezoneDate.clone().add(-1, 'day').valueOf();
            _this.props.onError && _this.props.onError(ERROR_MESSAGE);
          }
        } else if (calendarDate.isBefore(moment$1(newState.calendarMinimumDate))) {
          calendarDate.add(1, 'day');
          epochDate = selectedTimezoneDate.clone().add(1, 'day').valueOf();
          _this.props.onError && _this.props.onError(ERROR_MESSAGE);
        }
      }

      newState.activeTimezone = activeTimezone;
      newState.epochDate = epochDate;
      newState.calendarDate = calendarDate.toDate();

      _this.setState(newState);
    };

    _this.getPreselectedDateRanges = function (preselectKey, activeTimezone) {
      var preselected = _this.props.preselected;

      if (!preselected) {
        return;
      }

      var preselect = preselected.find(function (preselect) {
        return isObject$2(preselect) ? preselectKey === preselect.key : preselectKey === preselect;
      });

      if (!isObject$2(preselect)) {
        preselect = PRESELECTED_VALUES[preselect];
      }

      if (!preselect) {
        throw new Error('Cannot get a preselect object.');
      }

      var calendarDate = preselect.date(activeTimezone.value);
      var activeTimezoneDate = moment$1.tz(calendarDate.format(FULL_DAY_FORMAT), activeTimezone.value);
      var epochDate = activeTimezoneDate.valueOf();
      return {
        epochDate: epochDate,
        calendarDate: calendarDate
      };
    };

    _this.updateDateRange = function (updatedDate, _, preselectKey) {
      if (updatedDate === null) {
        _this.setState({
          epochDate: null
        });

        _this.props.onDateChanged(null);

        return;
      }

      if (!moment$1.isMoment(updatedDate)) {
        updatedDate = moment$1(updatedDate);
      }

      var stateUpdater = {
        preselectKey: preselectKey
      };

      if (preselectKey) {
        Object.assign(stateUpdater, _this.getPreselectedDateRanges(preselectKey, _this.state.activeTimezone));
      } else {
        if (_this.state.calendarMaximumDate) {
          if (updatedDate.isAfter(_this.state.calendarMaximumDate)) {
            _this.props.onError && _this.props.onError(ERROR_MESSAGE);
            var _activeTimezone = _this.context.timezone;
            var calendarDate = moment$1(_this.state.calendarMaximumDate);

            var _activeTimezoneDate = moment$1.tz(calendarDate.format(FULL_DAY_FORMAT), _activeTimezone.value);

            var _epochDate = _activeTimezoneDate.valueOf();

            return _this.setState({
              epochDate: _epochDate,
              calendarDate: _this.state.calendarMaximumDate
            });
          }
        }

        if (_this.state.calendarMinimumDate) {
          if (updatedDate.isBefore(_this.state.calendarMinimumDate)) {
            _this.props.onError && _this.props.onError(ERROR_MESSAGE);
            var _activeTimezone2 = _this.context.timezone;

            var _calendarDate = moment$1(_this.state.calendarMinimumDate);

            var _activeTimezoneDate2 = moment$1.tz(_calendarDate.format(FULL_DAY_FORMAT), _activeTimezone2.value);

            var _epochDate2 = _activeTimezoneDate2.valueOf();

            return _this.setState({
              epochDate: _epochDate2,
              calendarDate: _this.state.calendarMinimumDate
            });
          }
        }

        var activeTimezone = _this.context.timezone;
        var activeTimezoneDate = moment$1.tz(updatedDate.format(FULL_DAY_FORMAT), activeTimezone.value);
        var epochDate = activeTimezoneDate.valueOf();

        _this.setState({
          epochDate: epochDate,
          preselectKey: preselectKey,
          calendarDate: updatedDate.toDate()
        });
      }
    };

    return _this;
  }

  _createClass(EpochDatePicker, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (!(this.props.defaultDate && this.props.singleDate)) {
        if (this.props.calendarMaximumDate || this.props.calendarMinimumDate) {
          this.setState(this.getCalendarMaximaAndMinima(this.context.timezone));
        }
      }

      this.setState(this.getInitialState(this.props)); // for click to mount, update activeTimezone on mount
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(oldProps, oldState) {
      if (this.context.timezone && (!this.state.activeTimezone || this.context.timezone.value !== this.state.activeTimezone.value)) {
        if (this.state.activeTimezone && this.context.isChangedByTimezonePicker) {
          return this.updateEpochForNewTimezone(this.context.timezone);
        } else {
          return this.setState(this.getInitialState(this.props));
        }
      }

      if (this.props.singleDate) {
        if (this.state.epochDate) {
          if (this.props.singleDate !== oldProps.singleDate && this.props.singleDate !== this.state.epochDate) {
            return this.setState(this.getInitialState(this.props));
          }
        } else {
          return this.setState(this.getInitialState(this.props));
        }
      } else {
        if (!this.state.epochDate && this.props.defaultDate || oldProps.singleDate) {
          return this.setState(this.getInitialState(this.props));
        }
      }

      if (oldProps.calendarMaximumDate !== this.props.calendarMaximumDate || oldProps.calendarMinimumDate !== this.props.calendarMinimumDate) {
        this.setState(this.getCalendarMaximaAndMinima());
      }

      if (oldState.epochDate !== this.state.epochDate && this.state.epochDate !== this.props.singleDate) {
        this.props.onDateChanged(this.state.epochDate, this.state.calendarDate);
      }
    }
  }, {
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(newProps, newState) {
      if (!newProps.singleDate && this.props.singleDate || newProps.singleDate && !this.props.singleDate) {
        return true;
      }

      return newState.epochDate !== this.state.epochDate || newState.calendarMinimumDate !== this.state.calendarMinimumDate || newState.calendarMaximumDate !== this.state.calendarMaximumDate || newProps.singleDate !== this.props.singleDate || newProps.calendarMinimumDate !== this.props.calendarMinimumDate || newProps.calendarMaximumDate !== this.props.calendarMaximumDate || newProps.preselected !== this.props.preselected && !this.props.preselected;
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          showLabelAlways = _this$props.showLabelAlways,
          label = _this$props.label,
          disabled = _this$props.disabled;

      var datePickerProps = _objectSpread$a({
        maximumDate: this.state.calendarMaximumDate,
        minimumDate: this.state.calendarMinimumDate
      }, this.props.datePickerProps);

      return /*#__PURE__*/React__default.createElement("div", {
        className: styles$5.datePickerWrapper
      }, showLabelAlways ? /*#__PURE__*/React__default.createElement("span", {
        className: styles$5.label
      }, label) : null, /*#__PURE__*/React__default.createElement(DatesPicker, _extends({}, this.props, {
        datePickerProps: datePickerProps,
        updateDateRange: this.updateDateRange,
        singleDate: this.state.calendarDate || this.props.singleDate,
        preselected: this.getPreselect(),
        className: "".concat(this.props.className, " ").concat(disabled ? '_disabled' : ''),
        disabled: disabled
      })));
    }
  }]);

  return EpochDatePicker;
}(React__default.Component);

EpochDatePicker.contextType = TimezoneContext;
EpochDatePicker.PRESELECT_KEYS = PRESELECT_KEYS;
EpochDatePicker.defaultProps = {
  showLabelAlways: false,
  variant: 'withoutTickbox',
  confirmButtonClicked: function confirmButtonClicked() {},
  className: ''
};
EpochDatePicker.propTypes = {
  onError: PropTypes.func,
  singleDate: PropTypes.number,
  defaultDate: PropTypes.func,
  getSingleDateState: PropTypes.func,
  onDateChanged: PropTypes.func,
  datePickerProps: PropTypes.object,
  calendarMinimumDate: PropTypes.oneOfType([PropTypes.number, PropTypes.instanceOf(Date), PropTypes.instanceOf(moment$1)]),
  calendarMaximumDate: PropTypes.oneOfType([PropTypes.number, PropTypes.instanceOf(Date), PropTypes.instanceOf(moment$1)]),
  label: PropTypes.string,
  className: PropTypes.string,
  isClearable: PropTypes.bool,
  disabled: PropTypes.bool,
  showLabelAlways: PropTypes.bool,
  variant: PropTypes.oneOf(['withTickbox', 'withoutTickbox']),
  confirmButtonClicked: PropTypes.func
};

function _createSuper$c(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$c(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct$c() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
var MILLISECONDS_15_MINUTES = 900000;

var getTimezoneCurrentDay$1 = function getTimezoneCurrentDay(timezone) {
  return moment$1.tz(moment$1().utc(), 'UTC').tz(timezone);
};

var EpochSingleDateRangePicker = /*#__PURE__*/function (_React$Component) {
  _inherits(EpochSingleDateRangePicker, _React$Component);

  var _super = _createSuper$c(EpochSingleDateRangePicker);

  function EpochSingleDateRangePicker(props) {
    var _this;

    _classCallCheck(this, EpochSingleDateRangePicker);

    _this = _super.call(this, props);
    _this.datePickerProps = {
      numberOfCalendars: 1
    };

    _this.tryUpdateAbsoluteMaximaAndMinima = function () {
      if (_this.context.timezone) {
        var currentTimezone = get$1(_this.context, 'timezone.value');
        var stateUpdater = {
          currentTimezone: currentTimezone
        };
        var activeTimezoneCurrentDay = getTimezoneCurrentDay$1(currentTimezone);

        if (_this.props.calendarMinimumDate) {
          var calendarMinimumDate = _this.props.calendarMinimumDate(activeTimezoneCurrentDay).set('second', 0);

          var minimumDate = moment$1.tz(calendarMinimumDate.format(FULL_DAY_FORMAT), moment$1.tz.guess()).toDate();
          stateUpdater.absoluteMinimumDate = minimumDate;

          if (!_this.state.relativeMinimumDate) {
            stateUpdater.relativeMinimumDate = minimumDate;
          } else {
            stateUpdater.startDate = calendarMinimumDate.valueOf();

            if (_this.state.endDate) {
              if (stateUpdater.startDate > _this.state.startDate) {
                if (_this.state.endDate < stateUpdater.startDate) {
                  stateUpdater.endDate = stateUpdater.startDate + MILLISECONDS_15_MINUTES;
                  stateUpdater.relativeMaximumDate = moment$1.tz(calendarMinimumDate.format(FULL_DAY_FORMAT), moment$1.tz.guess()).add(15, 'minutes').toDate();
                  stateUpdater.relativeMinimumDate = moment$1.tz(calendarMinimumDate.format(FULL_DAY_FORMAT), moment$1.tz.guess()).toDate();
                }
              } else {
                if (_this.state.endDate > stateUpdater.startDate) {
                  stateUpdater.endDate = stateUpdater.startDate + MILLISECONDS_15_MINUTES;
                  stateUpdater.relativeMaximumDate = moment$1.tz(calendarMinimumDate.format(FULL_DAY_FORMAT), moment$1.tz.guess()).add(15, 'minutes').toDate();
                  stateUpdater.relativeMinimumDate = moment$1.tz(calendarMinimumDate.format(FULL_DAY_FORMAT), moment$1.tz.guess()).toDate();
                }
              }
            }
          }
        }

        if (_this.props.calendarMaximumDate) {
          var calendarMaximumDate = _this.props.calendarMaximumDate(activeTimezoneCurrentDay).set('second', 0);

          var maximumDate = moment$1.tz(calendarMaximumDate.format(FULL_DAY_FORMAT), moment$1.tz.guess()).toDate();
          stateUpdater.absoluteMaximumDate = maximumDate;

          if (!_this.state.relativeMaximumDate) {
            stateUpdater.relativeMaximumDate = maximumDate;
          }
        }

        _this.setState(stateUpdater);
      }
    };

    _this.getContextTimezone = function () {
      return get$1(_this.context, 'timezone.value', null);
    };

    _this.onStartDateChanged = function (startDate, calendarDate) {
      var momentCalendarDate = moment$1(calendarDate);

      if (_this.state.absoluteMinimumDate) {
        if (momentCalendarDate.valueOf() === +_this.state.absoluteMinimumDate) {
          _this.props.onError('Start time can’t be in the past and was corrected.'); // create a new date based on UTC passed as props to refresh the range extremum dates


          var utcCurrentDay = getTimezoneCurrentDay$1(_this.state.currentTimezone);

          var timezoneCurrentDateTime = _this.props.calendarMinimumDate(utcCurrentDay);

          var newAbosuluteMinimumDate = moment$1.tz(timezoneCurrentDateTime.format(FULL_DAY_FORMAT), moment$1.tz.guess());

          var _startDate = timezoneCurrentDateTime.valueOf();

          var shouldUpdateEndDate = _this.state.endDate && _this.state.endDate < _startDate + MILLISECONDS_15_MINUTES;
          return _this.setState({
            startDate: _startDate,
            endDate: shouldUpdateEndDate ? _startDate + MILLISECONDS_15_MINUTES : _this.state.endDate,
            relativeMaximumDate: shouldUpdateEndDate ? newAbosuluteMinimumDate.clone().toDate() : _this.state.relativeMaximumDate,
            absoluteMinimumDate: newAbosuluteMinimumDate.toDate(),
            relativeMinimumDate: newAbosuluteMinimumDate.clone().add(15, 'minutes').toDate()
          });
        }
      }

      if (_this.state.endDate && startDate > _this.state.endDate) {
        _this.props.onError('End time must be at least 15 min in the future and was corrected.');

        return _this.setState({
          startDate: startDate,
          endDate: startDate + MILLISECONDS_15_MINUTES,
          relativeMaximumDate: calendarDate,
          relativeMinimumDate: momentCalendarDate.add(15, 'minutes').toDate()
        });
      }

      _this.setState({
        startDate: startDate,
        relativeMinimumDate: calendarDate
      });
    };

    _this.onEndDateChanged = function (endDate, calendarDate) {
      var momentCalendarDate = moment$1(calendarDate);

      if (_this.state.absoluteMaximumDate) {
        if (momentCalendarDate.valueOf() === +_this.state.absoluteMaximumDate) {
          _this.props.onError('End time must be at least 15 min in the future and was corrected.'); // create a new date based on UTC passed as props to refresh the range extremum dates


          var utcCurrentDay = getTimezoneCurrentDay$1(_this.state.currentTimezone);

          var timezoneCurrentDateTime = _this.props.calendarMinimumDate(utcCurrentDay);

          var newAbsoluteMaximumDate = moment$1.tz(timezoneCurrentDateTime.format(FULL_DAY_FORMAT), moment$1.tz.guess());
          return _this.setState({
            endDate: timezoneCurrentDateTime.valueOf(),
            absoluteMaximumDate: newAbsoluteMaximumDate.toDate(),
            relativeMaximumDate: newAbsoluteMaximumDate.clone().add(-15, 'minutes').toDate()
          });
        }
      }

      if (_this.state.relativeMinimumDate) {
        var newCalendarDate = momentCalendarDate.valueOf();
        var relativeMinimumDate = +_this.state.relativeMinimumDate;

        if (newCalendarDate === relativeMinimumDate) {
          _this.props.onError('End time must be at least 15 min in the future and was corrected.');

          return _this.setState({
            endDate: _this.state.startDate + MILLISECONDS_15_MINUTES,
            relativeMinimumDate: momentCalendarDate.toDate(),
            relativeMaximumDate: momentCalendarDate.add(-15, 'minutes').toDate()
          });
        }
      }

      _this.setState({
        endDate: endDate,
        relativeMaximumDate: momentCalendarDate.add(-15, 'minutes').toDate()
      });
    };

    _this.getDefaultStartDateProps = function () {
      var _this$props = _this.props,
          _this$props$pickerCla = _this$props.pickerClassNames,
          pickerClassNames = _this$props$pickerCla === void 0 ? {} : _this$props$pickerCla,
          disableRelativeMaxDate = _this$props.disableRelativeMaxDate;
      return {
        singleDate: _this.state.startDate,
        onDateChanged: _this.onStartDateChanged,
        defaultDate: _this.props.getDefaultDateStartDate,
        calendarMinimumDate: _this.state.absoluteMinimumDate,
        calendarMaximumDate: disableRelativeMaxDate ? null : _this.state.relativeMaximumDate,
        label: _this.props.startLabel,
        tooltipParams: _this.props.startDateTooltipParams,
        className: pickerClassNames.start || ''
      };
    };

    _this.getDefaultEndDateProps = function () {
      var _this$props$pickerCla2 = _this.props.pickerClassNames,
          pickerClassNames = _this$props$pickerCla2 === void 0 ? {} : _this$props$pickerCla2;
      return {
        singleDate: _this.state.endDate,
        onDateChanged: _this.onEndDateChanged,
        defaultDate: _this.props.getDefaultDateEndDate,
        calendarMinimumDate: _this.state.relativeMinimumDate,
        calendarMaximumDate: _this.state.absoluteMaximumDate,
        label: _this.props.endLabel,
        tooltipParams: _this.props.endDateTooltipParams,
        className: pickerClassNames.end || ''
      };
    };

    _this.baseCalendarProps = {
      dateFormat: AM_PM_DATE_TIME_FORMAT,
      datePickerProps: {
        numberOfCalendars: 1
      },
      withTimePicker: true,
      singleDateMode: true,
      updateByDone: true
    };
    _this.state = {
      currentTimezone: get$1(_this.context, 'timezone.value'),
      startDate: props.startDate,
      endDate: props.endDate,
      absoluteMaximumDate: null,
      absoluteMinimumDate: null,
      relativeMaximumDate: null,
      relativeMinimumDate: null
    };
    return _this;
  }

  _createClass(EpochSingleDateRangePicker, [{
    key: "componentDidMount",
    value: function componentDidMount(newProps) {
      this.tryUpdateAbsoluteMaximaAndMinima();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(newProps, newState) {
      if (newState.startDate !== this.state.startDate || newState.endDate !== this.state.endDate) {
        this.props.onDateRangeChanged({
          startDate: this.state.startDate,
          endDate: this.state.endDate
        });
      }

      var contextTimezone = this.getContextTimezone();

      if (contextTimezone !== this.state.currentTimezone) {
        this.tryUpdateAbsoluteMaximaAndMinima();
      }
    }
  }, {
    key: "render",
    value: function render() {
      var wrapperClassName = "epoch-single-date-range-picker ".concat(get$1(this.props, 'className', ''));
      var startDateProps = this.getDefaultStartDateProps();
      var endDateProps = this.getDefaultEndDateProps();
      var startDateLabel = get$1(this.props.labelOptions, 'startDate');
      var endDateLabel = get$1(this.props.labelOptions, 'endDate');
      return /*#__PURE__*/React__default.createElement("div", {
        className: wrapperClassName
      }, /*#__PURE__*/React__default.createElement("div", {
        className: "epoch-single-date-range-picker__start-date"
      }, startDateLabel && /*#__PURE__*/React__default.createElement("label", null, startDateLabel), /*#__PURE__*/React__default.createElement(EpochDatePicker, _extends({}, this.baseCalendarProps, startDateProps))), /*#__PURE__*/React__default.createElement("div", {
        className: "epoch-single-date-range-picker__end-date"
      }, endDateLabel && /*#__PURE__*/React__default.createElement("label", null, endDateLabel), /*#__PURE__*/React__default.createElement(EpochDatePicker, _extends({}, this.baseCalendarProps, endDateProps))));
    }
  }]);

  return EpochSingleDateRangePicker;
}(React__default.Component);

EpochSingleDateRangePicker.contextType = TimezoneContext;
EpochSingleDateRangePicker.propTypes = {
  startDate: PropTypes.number,
  endDate: PropTypes.number,
  getDefaultDateEndDate: PropTypes.func,
  getDefaultDateStartDate: PropTypes.func,
  onDateRangeChanged: PropTypes.func,
  labelOptions: PropTypes.object,
  className: PropTypes.string,
  calendarMaximumDate: PropTypes.func,
  calendarMinimumDate: PropTypes.func,
  disableRelativeMaxDate: PropTypes.bool,
  onError: PropTypes.func,
  startLabel: PropTypes.string,
  endLabel: PropTypes.string,
  startDateTooltipParams: PropTypes.object,
  endDateTooltipParams: PropTypes.object,
  pickerClassNames: PropTypes.object
};

// browser detect conditions are got from https://stackoverflow.com/a/9851769/6225144
var isEdgeOrIe = !!window.StyleMedia; // eslint-disable-next-line no-undef

var isSafari = /constructor/i.test(window.HTMLElement) || function (p) {
  return p.toString() === '[object SafariRemoteNotification]';
}(!window['safari'] || typeof safari !== 'undefined' && safari.pushNotification);

function _createSuper$d(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$d(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct$d() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var GeneratingFileProgress = /*#__PURE__*/function (_React$Component) {
  _inherits(GeneratingFileProgress, _React$Component);

  var _super = _createSuper$d(GeneratingFileProgress);

  function GeneratingFileProgress() {
    var _this;

    _classCallCheck(this, GeneratingFileProgress);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    _this.state = {
      inProgress: true,
      isError: false
    };
    return _this;
  }

  _createClass(GeneratingFileProgress, [{
    key: "componentDidMount",
    value: function () {
      var _componentDidMount = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee() {
        var base64, params, fileURL;
        return regenerator.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                base64 = window.location.hash.split('?params=')[1];
                if (!base64) window.close();
                params = JSON.parse(atob(base64));
                _context.next = 6;
                return this.props.getFileURL(params.request);

              case 6:
                fileURL = _context.sent;
                this.setState({
                  inProgress: false
                });

                if (params.request.calledApp === 'bidModel') {
                  filesUtils.downloadFile(fileURL, "".concat(params.request.fileName, ".").concat(this.props.fileType));
                } else {
                  window.location.href = fileURL;
                }

                setTimeout(function () {
                  if (!isSafari) {
                    window.close();
                  }
                }, 2500);
                _context.next = 16;
                break;

              case 12:
                _context.prev = 12;
                _context.t0 = _context["catch"](0);
                console.log(_context.t0);
                this.setState({
                  isError: true,
                  inProgress: false
                });

              case 16:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[0, 12]]);
      }));

      function componentDidMount() {
        return _componentDidMount.apply(this, arguments);
      }

      return componentDidMount;
    }()
  }, {
    key: "render",
    value: function render() {
      var _this$state = this.state,
          inProgress = _this$state.inProgress,
          isError = _this$state.isError;
      return /*#__PURE__*/React__default.createElement("div", {
        className: "generate-progress-page"
      }, /*#__PURE__*/React__default.createElement("div", {
        className: "generate-progress"
      }, /*#__PURE__*/React__default.createElement("div", {
        className: "generate-progress__image"
      }, /*#__PURE__*/React__default.createElement(Icon, {
        name: "GenerateProgress"
      })), /*#__PURE__*/React__default.createElement("div", {
        className: "generate-progress__bar ".concat(inProgress ? '_animated' : '')
      }, /*#__PURE__*/React__default.createElement("div", {
        className: "generate-progress__bar-stripped"
      })), !inProgress && isError && /*#__PURE__*/React__default.createElement("div", {
        className: "generate-progress__value _warn"
      }, "File generation failed. Please try again or contact support at", ' ', /*#__PURE__*/React__default.createElement("a", {
        href: "https://help.iqm.com/",
        target: "_blank",
        rel: "noopener noreferrer"
      }, "help.iqm.com"), ' ', "if problem persists."), inProgress && /*#__PURE__*/React__default.createElement("div", {
        className: "generate-progress__value"
      }, this.props.title, /*#__PURE__*/React__default.createElement("span", {
        className: "generate-progress__value-dotted"
      })), !inProgress && !isError && /*#__PURE__*/React__default.createElement("div", {
        className: "generate-progress__value"
      }, "Successfully generated.")));
    }
  }]);

  return GeneratingFileProgress;
}(React__default.Component);

GeneratingFileProgress.propTypes = {
  title: PropTypes.string,
  getFileURL: PropTypes.func,
  fileType: PropTypes.string
};

function ownKeys$b(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$b(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$b(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$b(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function CSVDownloadingProgress() {
  var getFileURL = function getFileURL(params) {
    if (params.activeTable && ['state', 'city', 'zip', 'publisher_category', 'deal_id', 'exchange', 'open_exchange', 'creative', 'device_type', 'traffic_type'].includes(params.activeTable)) {
      return TableApiService.downloadBidmodelTable(_objectSpread$b(_objectSpread$b({}, params), {}, {
        fileType: 'csv'
      }));
    }

    return TableApiService.downloadCSV(params);
  };

  return /*#__PURE__*/React__default.createElement(GeneratingFileProgress, {
    title: "Generating CSV. Please wait",
    getFileURL: getFileURL,
    fileType: 'csv'
  });
}

function ownKeys$c(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$c(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$c(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$c(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function XLSXDownloadingProgress() {
  var getFileURL = function getFileURL(params) {
    if (params.activeTable && ['state', 'city', 'zip', 'publisher_category', 'deal_id', 'exchange', 'open_exchange', 'creative', 'device_type', 'traffic_type'].includes(params.activeTable)) {
      return TableApiService.downloadBidmodelTable(_objectSpread$c(_objectSpread$c({}, params), {}, {
        fileType: 'xlsx'
      }));
    }

    return TableApiService.downloadXLSX(params);
  };

  return /*#__PURE__*/React__default.createElement(GeneratingFileProgress, {
    title: "Generating XLSX. Please wait",
    getFileURL: getFileURL,
    fileType: 'xlsx'
  });
}

var css_248z$7 = ":root {\n  --primary1: #123787;\n  --primary2: #1d58d7;\n  --primary3: #5173fb;\n  --primary4: #7a93ff;\n  --primary5: #c2d0ff;\n  --primary6: #e5ebff;\n  --primary7: #f2f5ff; }\n\n@keyframes styles-module_hover-ripples__2KhAd {\n  0% {\n    top: -0.1875em;\n    left: -0.1875em;\n    right: -0.1875em;\n    bottom: -0.1875em;\n    opacity: 1; }\n  100% {\n    top: -0.8125em;\n    left: -0.8125em;\n    right: -0.8125em;\n    bottom: -0.8125em;\n    opacity: 0; } }\n\n.styles-module_noSearchResultsWrapper__1XQyW {\n  height: 18.75rem;\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  color: #666666; }\n  .styles-module_noSearchResultsWrapper__1XQyW.styles-module_isLoading__XAPFc {\n    height: 6rem; }\n  .styles-module_noSearchResultsWrapper__1XQyW .styles-module_spinner__4_l3A {\n    margin-bottom: 1rem; }\n  .styles-module_noSearchResultsWrapper__1XQyW .styles-module_icon__yQQd_ {\n    height: 2rem;\n    width: 2rem;\n    margin-bottom: 1rem; }\n  .styles-module_noSearchResultsWrapper__1XQyW .styles-module_mainTitle__XmuFg {\n    font-family: 'Avenir Next Bold', sans-serif;\n    font-weight: normal;\n    font-size: 1rem;\n    text-align: center;\n    line-height: 2;\n    margin-bottom: 0.25rem; }\n  .styles-module_noSearchResultsWrapper__1XQyW .styles-module_subtitle__pMZr2 {\n    font-family: 'Avenir Next Regular', sans-serif;\n    font-weight: normal;\n    font-size: 0.875rem;\n    text-align: center;\n    width: 12.5rem; }\n";
var styles$6 = {"noSearchResultsWrapper":"styles-module_noSearchResultsWrapper__1XQyW","isLoading":"styles-module_isLoading__XAPFc","spinner":"styles-module_spinner__4_l3A","icon":"styles-module_icon__yQQd_","mainTitle":"styles-module_mainTitle__XmuFg","subtitle":"styles-module_subtitle__pMZr2","hover-ripples":"styles-module_hover-ripples__2KhAd"};
styleInject(css_248z$7);

var EmptySearchLabel = function EmptySearchLabel(props) {
  var searchTerm = props.searchTerm,
      isLoading = props.isLoading,
      isError = props.isError,
      isEmpty = props.isEmpty;
  return /*#__PURE__*/React__default.createElement("div", {
    className: "".concat(styles$6.noSearchResultsWrapper, " ").concat(isLoading ? styles$6.isLoading : '')
  }, isLoading ? /*#__PURE__*/React__default.createElement(ProgressCircle, {
    className: styles$6.spinner,
    size: 32
  }) : /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(Icon, {
    name: "EmptyClipboard",
    className: styles$6.icon
  }), /*#__PURE__*/React__default.createElement("div", {
    className: styles$6.mainTitle
  }, isError ? 'Oops' : 'No results found'), !isEmpty ? /*#__PURE__*/React__default.createElement("div", {
    className: styles$6.subtitle
  }, isError ? /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("div", {
    className: 'w-100'
  }, "Something went wrong."), /*#__PURE__*/React__default.createElement("div", {
    className: "w-100"
  }, "Please try again")) : searchTerm ? /*#__PURE__*/React__default.createElement(React__default.Fragment, null, "We can\u2019t find any items matching your search", /*#__PURE__*/React__default.createElement(SmartText, {
    label: "\"".concat(searchTerm, "\""),
    tooltipParams: {
      portal: true
    }
  })) : /*#__PURE__*/React__default.createElement(React__default.Fragment, null, "We can\u2019t find any items matching your filter(s).")) : null));
};
EmptySearchLabel.propTypes = {
  searchTerm: PropTypes.string,
  isLoading: PropTypes.bool,
  isError: PropTypes.bool,
  isEmpty: PropTypes.bool
};

function useIsMounted() {
  var isMountedRef = useRef(true);
  useEffect(function () {
    return function () {
      isMountedRef.current = false;
    };
  }, []);
  return function () {
    return isMountedRef.current;
  };
}

var _this = undefined;

function ownKeys$d(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$d(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$d(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$d(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var LazySelect = function LazySelect(props) {
  var value = props.value,
      onChange = props.onChange,
      _props$httpMethod = props.httpMethod,
      httpMethod = _props$httpMethod === void 0 ? 'get' : _props$httpMethod,
      apiPath = props.apiPath,
      _props$numberOfEntrie = props.numberOfEntries,
      noOfEntries = _props$numberOfEntrie === void 0 ? 1000 : _props$numberOfEntrie,
      transformPagingParameters = props.transformPagingParameters,
      selectSpecificProps = props.selectSpecificProps,
      groups = props.groups,
      groupApiPath = props.groupApiPath,
      mapServerResponseData = props.mapServerResponseData,
      mapServerResponseGroupData = props.mapServerResponseGroupData,
      withRefreshOptions = props.withRefreshOptions,
      toggleOpenProp = props.toggleOpenProp,
      _props$maxItems = props.maxItems,
      maxItems = _props$maxItems === void 0 ? 1000 : _props$maxItems,
      refreshObserverValue = props.refreshObserverValue,
      headers = props.headers,
      _props$useParamsAsBod = props.useParamsAsBody,
      useParamsAsBody = _props$useParamsAsBod === void 0 ? false : _props$useParamsAsBod,
      _props$showErrorLabel = props.showErrorLabel,
      showErrorLabel = _props$showErrorLabel === void 0 ? false : _props$showErrorLabel;
  var selectRef = React__default.useRef();
  var isMounted = useIsMounted();

  var _useState = useState$2(true),
      _useState2 = _slicedToArray(_useState, 2),
      isFetching = _useState2[0],
      setIsFetching = _useState2[1];

  var _useState3 = useState$2(1),
      _useState4 = _slicedToArray(_useState3, 2),
      pageNo = _useState4[0],
      setPageNo = _useState4[1];

  var _useState5 = useState$2(value || []),
      _useState6 = _slicedToArray(_useState5, 2),
      options = _useState6[0],
      setOptions = _useState6[1];

  var searchField = useRef('');

  var _useState7 = useState$2(false),
      _useState8 = _slicedToArray(_useState7, 2),
      allSelected = _useState8[0],
      setAllSelected = _useState8[1];

  var _useState9 = useState$2({}),
      _useState10 = _slicedToArray(_useState9, 2),
      groupsMap = _useState10[0],
      setGroupMap = _useState10[1];

  var _useState11 = useState$2(0),
      _useState12 = _slicedToArray(_useState11, 2),
      totalRecords = _useState12[0],
      setTotalRecords = _useState12[1];

  var _useState13 = useState$2(0),
      _useState14 = _slicedToArray(_useState13, 2),
      filteredRecords = _useState14[0],
      setFilteredRecords = _useState14[1];

  var _useState15 = useState$2(noOfEntries),
      _useState16 = _slicedToArray(_useState15, 2),
      numberOfEntries = _useState16[0],
      setNumberOfEntries = _useState16[1];

  var prevSourceRequest = useRef(null); // const selectedValueMap = useRef({});

  var scrollerRef = useRef(null);
  var url = useRef("".concat(ORIGIN_URL, "/").concat(apiPath));
  var isFilteredList = totalRecords > filteredRecords;
  var totalRecordsAvailable = isFilteredList ? filteredRecords : totalRecords;
  var totalPages = Math.ceil(totalRecordsAvailable / numberOfEntries);

  var _useState17 = useState$2(false),
      _useState18 = _slicedToArray(_useState17, 2),
      isLoading = _useState18[0],
      setIsLoading = _useState18[1];

  var handleChange = useCallback(function (newValue, selectedItem, deselectedAll) {
    if (deselectedAll) {
      var isNotMulti = selectSpecificProps && selectSpecificProps.isMulti === false;
      onChange(isNotMulti ? null : []);
      return;
    }

    if (Array.isArray(newValue)) {
      var newSelectedValueMap = newValue.reduce(function (selectedValueMapObj, option) {
        var newSelectedValueMapObj = _objectSpread$d({}, selectedValueMapObj);

        newSelectedValueMapObj[option.value] = true;
        return newSelectedValueMapObj;
      }, {});

      if (newValue && newValue.length && newSelectedValueMap) {
        var isActiveSelectedItem = selectedItem && selectedItem.isActive;
        newValue.forEach(function (option) {
          if (!(isActiveSelectedItem && selectedItem.value === option.value)) {
            if (!newSelectedValueMap[option.value]) {
              newValue.push(option);
            }
          } else if (newValue.isHeader) {
            newValue.push(option);
          }
        });
      }
    }

    onChange(newValue);
  }, [onChange, selectSpecificProps]);
  var dataOrParams = useCallback(function () {
    return useParamsAsBody ? {
      data: transformPagingParameters({
        noOfEntries: numberOfEntries,
        searchField: searchField.current,
        pageNo: pageNo
      })
    } : {
      params: transformPagingParameters({
        noOfEntries: numberOfEntries,
        searchField: searchField.current,
        pageNo: pageNo
      })
    };
  }, [useParamsAsBody, numberOfEntries, pageNo, transformPagingParameters, searchField]);
  var loadData = useCallback( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee() {
    var source, _yield$axios, data, tumbler, groupsMapNew, entities, _yield$axios2, dataLoaded;

    return regenerator.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            setIsLoading(true);
            source = axios.CancelToken.source();
            prevSourceRequest.current = source;
            _context.next = 6;
            return axios(_objectSpread$d({
              cancelToken: source.token,
              url: url.current,
              method: httpMethod,
              headers: headers || getHeaders()
            }, dataOrParams()));

          case 6:
            _yield$axios = _context.sent;
            data = _yield$axios.data;
            tumbler = selectSpecificProps.tumbler;

            if (!tumbler) {
              _context.next = 18;
              break;
            }

            entities = get$1(data, 'responseObject.data', []);

            if (_this.props.isV2Request) {
              entities = data.data;
            }

            if (!entities.length) {
              _context.next = 18;
              break;
            }

            _context.next = 15;
            return axios(_objectSpread$d({
              cancelToken: source.token,
              url: "".concat(ORIGIN_URL, "/api/").concat(groupApiPath),
              method: httpMethod,
              headers: headers || getHeaders()
            }, dataOrParams()));

          case 15:
            _yield$axios2 = _context.sent;
            dataLoaded = _yield$axios2.data;
            groupsMapNew = get$1(dataLoaded, 'responseObject', []);

          case 18:
            prevSourceRequest.current = null;
            setIsLoading(false);
            return _context.abrupt("return", {
              loadedOptions: mapServerResponseData(data, {
                noOfEntries: numberOfEntries,
                searchField: searchField.current,
                pageNo: pageNo
              }),
              groupsMap: _objectSpread$d(_objectSpread$d({}, groupsMap), groupsMapNew)
            });

          case 23:
            _context.prev = 23;
            _context.t0 = _context["catch"](0);
            prevSourceRequest.current = null;
            return _context.abrupt("return", {
              loadedOptions: {
                data: [],
                totalRecords: 0,
                filteredRecords: 0
              },
              groupsMap: {}
            });

          case 27:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[0, 23]]);
  })), [groupApiPath, groupsMap, httpMethod, mapServerResponseData, numberOfEntries, pageNo, headers, selectSpecificProps, dataOrParams]);
  var updateOptions = useCallback( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee2() {
    var source, _yield$axios3, data, tumbler, groupsMapNew, entities, _yield$axios4, dataLoaded;

    return regenerator.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.prev = 0;
            setIsLoading(true);
            source = axios.CancelToken.source();
            prevSourceRequest.current = source;
            _context2.next = 6;
            return axios({
              cancelToken: source.token,
              url: url.current,
              method: httpMethod,
              headers: headers || getHeaders(),
              params: _objectSpread$d(_objectSpread$d({}, transformPagingParameters({
                noOfEntries: numberOfEntries,
                searchField: searchField.current,
                pageNo: 1
              })), {}, {
                creativesGreaterThan: options[0].value
              })
            });

          case 6:
            _yield$axios3 = _context2.sent;
            data = _yield$axios3.data;
            tumbler = selectSpecificProps.tumbler;

            if (!tumbler) {
              _context2.next = 18;
              break;
            }

            entities = get$1(data, 'responseObject.data', []);

            if (_this.props.isV2Request) {
              entities = data.data;
            }

            if (!entities.length) {
              _context2.next = 18;
              break;
            }

            _context2.next = 15;
            return axios({
              cancelToken: source.token,
              url: "".concat(ORIGIN_URL, "/api/").concat(groupApiPath),
              method: httpMethod,
              headers: headers || getHeaders(),
              params: mapServerResponseGroupData(entities)
            });

          case 15:
            _yield$axios4 = _context2.sent;
            dataLoaded = _yield$axios4.data;
            groupsMapNew = get$1(dataLoaded, 'responseObject', []);

          case 18:
            prevSourceRequest.current = null;
            setIsLoading(false);
            return _context2.abrupt("return", {
              loadedOptions: mapServerResponseData(data, {
                noOfEntries: numberOfEntries,
                searchField: searchField.current,
                pageNo: pageNo
              }, true),
              groupsMapNew: groupsMapNew
            });

          case 23:
            _context2.prev = 23;
            _context2.t0 = _context2["catch"](0);
            prevSourceRequest.current = null;
            return _context2.abrupt("return", {
              totalRecords: 0,
              filteredRecords: 0,
              data: []
            });

          case 27:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, null, [[0, 23]]);
  })), [headers, groupApiPath, httpMethod, mapServerResponseData, mapServerResponseGroupData, numberOfEntries, options, pageNo, selectSpecificProps, transformPagingParameters]);
  useEffect(function () {
    setOptions(function (allOptions) {
      return allOptions.filter(function (option) {
        return !option.isHeader;
      });
    });
  }, [selectSpecificProps.tumblerIsActive]);
  var fetchMyAPI = useCallback( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee3() {
    var isScrollTrigger,
        _yield$loadData,
        loadedOptions,
        groupMapLoaded,
        optionsNew,
        _args3 = arguments;

    return regenerator.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            isScrollTrigger = _args3.length > 0 && _args3[0] !== undefined ? _args3[0] : false;
            _context3.next = 3;
            return loadData();

          case 3:
            _yield$loadData = _context3.sent;
            loadedOptions = _yield$loadData.loadedOptions;
            groupMapLoaded = _yield$loadData.groupsMap;
            optionsNew = !isScrollTrigger ? loadedOptions.data : [].concat(_toConsumableArray(options), _toConsumableArray(loadedOptions.data));
            setOptions(optionsNew);
            setGroupMap(function (prevGroupMap) {
              return _objectSpread$d(_objectSpread$d({}, prevGroupMap), groupMapLoaded);
            });
            setTotalRecords(loadedOptions.totalRecords);
            setFilteredRecords(loadedOptions.filteredRecords);
            setIsFetching(false);

          case 12:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  })), [loadData, options]);
  var onScroll = useCallback(function (currentPageNo) {
    if (isFetching) {
      scrollerRef.current.pageLoaded = currentPageNo - 1;
      return;
    }

    setIsFetching(true);
    setPageNo(currentPageNo);
    fetchMyAPI(true);
  }, [fetchMyAPI, isFetching]);
  useEffect(function () {
    if (scrollerRef.current && scrollerRef.current.pageLoaded) {
      scrollerRef.current.pageLoaded = 1;
    }

    return function () {
      if (prevSourceRequest.current) {
        prevSourceRequest.current.cancel();
      }
    };
  }, []);
  var resetScroll = useCallback(function () {
    if (selectRef.current) {
      var listRef = document.querySelector('.opener._opened .select__list');
      if (listRef) listRef.scrollTop = 0;
    }
  }, []);
  var resetAPIdata = useCallback(function () {
    resetScroll();

    if (scrollerRef.current && scrollerRef.current.pageLoaded) {
      scrollerRef.current.pageLoaded = 1;
    }

    setIsFetching(true);
    setPageNo(1);
    searchField.current = '';
    setTotalRecords(0);
    setFilteredRecords(0); // setOptions([]);
  }, [resetScroll]);
  useEffect(function () {
    if (isMounted()) {
      url.current = "".concat(ORIGIN_URL, "/").concat(apiPath);
      resetAPIdata();
      setIsFetching(true);
      fetchMyAPI();
    } // eslint-disable-next-line react-hooks/exhaustive-deps

  }, [apiPath, resetAPIdata, refreshObserverValue]);
  /* useEffect(() => {
    if (isMounted && Array.isArray(value)) {
      selectedValueMap.current
        = value
        && value.reduce((selectedValueAcc, selectedValue) => {
          const newSelectedValueObj = { ...selectedValueAcc };
          newSelectedValueObj[selectedValue.value] = selectedValue;
          return newSelectedValueObj;
        }, {});
    }
  }, [value]); */

  useEffect(function () {
    if (allSelected) {
      var tumbler = selectSpecificProps.tumbler,
          tumblerIsActive = selectSpecificProps.tumblerIsActive;
      var grouppedOptions = [];

      if (tumbler && tumblerIsActive && options.length) {
        var groupMap = keyBy(groups, 'value');
        var hasUnassignedGroup = false;
        var notEmptyGroups = {};
        options.forEach(function (option) {
          var optionGroups = groupsMap[option.value];

          if (optionGroups && optionGroups.length) {
            optionGroups.forEach(function (groupId) {
              if (!notEmptyGroups[groupId]) {
                notEmptyGroups[groupId] = true;
                grouppedOptions.push(_objectSpread$d(_objectSpread$d({}, groupMap[groupId]), {}, {
                  isHeader: true
                }));
              }
            });
          } else if (!hasUnassignedGroup) {
            hasUnassignedGroup = true;
            grouppedOptions.push({
              label: 'No Group Assigned',
              isHeader: true,
              value: -1
            });
          }
        });
      }

      onChange([].concat(grouppedOptions, _toConsumableArray(options)));
      setAllSelected(false);
    }
  }, [allSelected, groups, groupsMap, onChange, options, selectSpecificProps]);
  var loadAll = useCallback(function () {
    if (filteredRecords <= maxItems) {
      setPageNo(1);
      setNumberOfEntries(filteredRecords);
      setAllSelected(true);
    }
  }, [filteredRecords, maxItems]);
  var renderSkeletonLoader = useCallback(function () {
    var style = {
      width: '100%',
      height: '18px'
    };
    var lastPageItemsCount = totalRecordsAvailable % numberOfEntries;
    var isLastPageSmaller = totalPages === pageNo && lastPageItemsCount < numberOfEntries;
    var numberOfLoader = isLastPageSmaller ? lastPageItemsCount || 1 : numberOfEntries - 1;
    return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, Array(numberOfLoader).fill('').map(function (skeletonCount, index) {
      return /*#__PURE__*/React__default.createElement("div", {
        key: "".concat(index, "-select-skeleton"),
        className: "select__option"
      }, /*#__PURE__*/React__default.createElement("div", {
        className: "select__option-label"
      }, /*#__PURE__*/React__default.createElement("div", {
        className: "skeleton-block",
        style: style
      })));
    }));
  }, [numberOfEntries, pageNo, totalRecordsAvailable, totalPages]);
  var updateSearchField = useCallback(function (searchValue) {
    var _selectRef$current;

    var listRef = document.querySelector('.opener._opened');

    if (listRef || searchValue) {
      resetScroll();
      searchField.current = searchValue;
      setPageNo(1);

      if (scrollerRef.current && scrollerRef.current.pageLoaded) {
        scrollerRef.current.pageLoaded = 1;
      }

      setOptions([]);
      setIsFetching(true);
      fetchMyAPI();
    }

    if (!searchValue && (_selectRef$current = selectRef.current) !== null && _selectRef$current !== void 0 && _selectRef$current.searchInput) {
      selectRef.current.searchInput.value = '';
    }
  }, [fetchMyAPI, resetScroll]);
  var toggleOpenHandler = useCallback( /*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee4(isOpen) {
      var _selectRef$current2;

      var _yield$updateOptions, loadedOptions, groupMapLoaded, _newOptions;

      return regenerator.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              if (!searchField.current && (_selectRef$current2 = selectRef.current) !== null && _selectRef$current2 !== void 0 && _selectRef$current2.searchInput) {
                selectRef.current.searchInput.value = '';
              }

              if (!(isOpen && withRefreshOptions)) {
                _context4.next = 11;
                break;
              }

              _context4.next = 4;
              return updateOptions();

            case 4:
              _yield$updateOptions = _context4.sent;
              loadedOptions = _yield$updateOptions.loadedOptions;
              groupMapLoaded = _yield$updateOptions.groupsMap;
              _newOptions = get$1(loadedOptions, 'data', []);
              setOptions([].concat(_toConsumableArray(_newOptions), _toConsumableArray(options)));
              setPageNo(pageNo);
              setGroupMap(function (prevGroupMap) {
                return _objectSpread$d(_objectSpread$d({}, prevGroupMap), groupMapLoaded);
              });

            case 11:
              if (toggleOpenProp) {
                toggleOpenProp();
              }

            case 12:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4);
    }));

    return function (_x) {
      return _ref4.apply(this, arguments);
    };
  }(), [options, pageNo, toggleOpenProp, updateOptions, withRefreshOptions]);
  var groupOptionsIfNeeded = useCallback(function (allOptions) {
    var tumbler = selectSpecificProps.tumbler,
        tumblerIsActive = selectSpecificProps.tumblerIsActive;
    var grouppedOptions = [];

    if (tumbler && tumblerIsActive && allOptions.length) {
      var groupMap = keyBy(groups, 'value');
      var unassignedOptions = [];
      var notEmptyGroups = {};
      allOptions.forEach(function (option) {
        var optionGroups = groupsMap[option.value];

        if (optionGroups && optionGroups.length) {
          optionGroups.forEach(function (groupId) {
            if (!notEmptyGroups[groupId]) {
              notEmptyGroups[groupId] = _objectSpread$d(_objectSpread$d({}, groupMap[groupId]), {}, {
                isHeader: true,
                options: [_objectSpread$d(_objectSpread$d({}, option), {}, {
                  key: "".concat(groupId).concat(option.value)
                })]
              });
            } else if (!notEmptyGroups[groupId].options.find(function (o) {
              return option.value === o.value;
            })) {
              notEmptyGroups[groupId].options.push(_objectSpread$d(_objectSpread$d({}, option), {}, {
                key: "".concat(groupId).concat(option.value)
              }));
            }
          });
        } else {
          unassignedOptions.push(option);
        }
      });
      Object.keys(notEmptyGroups).forEach(function (groupId) {
        grouppedOptions.push(notEmptyGroups[groupId]);
      });

      if (unassignedOptions.length) {
        grouppedOptions.push({
          label: 'No Group Assigned',
          isHeader: true,
          value: -1,
          options: unassignedOptions
        });
      }
    }

    return tumbler && tumblerIsActive ? grouppedOptions : allOptions;
  }, [groups, groupsMap, selectSpecificProps]);
  var renderErrorLabel = useCallback(function () {
    return showErrorLabel ? /*#__PURE__*/React__default.createElement(EmptySearchLabel, {
      searchTerm: searchField.current,
      isLoading: isLoading
    }) : null;
  }, [isLoading, showErrorLabel]);
  var newOptions = uniqBy([].concat(_toConsumableArray(value), _toConsumableArray(options)), 'value');
  var delayedField = useRef(debounce(updateSearchField, 500));
  return /*#__PURE__*/React__default.createElement(Select, _extends({
    ref: selectRef,
    onChange: handleChange,
    value: value,
    options: groupOptionsIfNeeded(newOptions),
    totalRecords: totalRecords,
    lazySelectSearchString: searchField.current,
    changeSearchHandler: function changeSearchHandler(e) {
      return delayedField.current(get$1(e, 'target.value', ''));
    },
    placeholder: "Include All",
    isMulti: true,
    isSearchable: true,
    searchByValue: true,
    isClearable: true,
    allSelectable: true,
    onSelectAll: loadAll,
    toggleOpenProp: toggleOpenHandler,
    lazyLoad: true,
    emptyDropdownLabel: renderErrorLabel(),
    infiniteScrollProps: {
      loadMore: onScroll,
      hasMore: pageNo <= totalPages,
      loader: isFetching && renderSkeletonLoader(),
      pageStart: 2,
      initialLoad: false,
      ref: scrollerRef
    }
  }, selectSpecificProps));
};

LazySelect.propTypes = {
  transformPagingParameters: PropTypes.func,
  useParamsAsBody: PropTypes.bool,
  mapServerResponseData: PropTypes.func,
  onChange: PropTypes.func,
  httpMethod: PropTypes.string,
  apiPath: PropTypes.string,
  refreshObserverValue: string$1,
  numberOfEntries: PropTypes.number,
  selectSpecificProps: PropTypes.object,
  value: PropTypes.oneOfType([PropTypes.array, PropTypes.object, PropTypes.oneOf([null])]),
  maxItems: PropTypes.number,
  withRefreshOptions: PropTypes.bool,
  groups: PropTypes.array,
  groupApiPath: PropTypes.string,
  mapServerResponseGroupData: PropTypes.func,
  toggleOpenProp: PropTypes.func,
  headers: PropTypes.object,
  isV2Request: PropTypes.bool,
  showErrorLabel: PropTypes.bool
};

var css_248z$8 = ":root {\n  --primary1: #123787;\n  --primary2: #1d58d7;\n  --primary3: #5173fb;\n  --primary4: #7a93ff;\n  --primary5: #c2d0ff;\n  --primary6: #e5ebff;\n  --primary7: #f2f5ff; }\n\n@keyframes customerSelect-module_hover-ripples__1sD_4 {\n  0% {\n    top: -0.1875em;\n    left: -0.1875em;\n    right: -0.1875em;\n    bottom: -0.1875em;\n    opacity: 1; }\n  100% {\n    top: -0.8125em;\n    left: -0.8125em;\n    right: -0.8125em;\n    bottom: -0.8125em;\n    opacity: 0; } }\n\n.customerSelect-module_content__X3M2L {\n  position: absolute;\n  z-index: 1;\n  top: 100%;\n  left: 50%;\n  transform: translateX(-50%);\n  width: 17.5rem; }\n  .customerSelect-module_content__X3M2L.customerSelect-module__selected__2lbXT {\n    top: 0; }\n\n.customerSelect-module_select__1fUHA.select .select__option:not(:last-child) {\n  border-bottom: 0.0625rem solid #f4f4f4; }\n\n.customerSelect-module_select__1fUHA.select .select__option-label {\n  padding: 0.25rem 0.75rem; }\n\n.customerSelect-module_option__2rJKK {\n  display: flex;\n  align-items: center;\n  width: 100%; }\n  .customerSelect-module_option__2rJKK.customerSelect-module__selected__2lbXT {\n    padding: 0 0.75rem 0 0.25rem;\n    width: 100%;\n    max-width: 15rem;\n    height: 2.25rem;\n    border: 0.0625rem solid #cbcbcb;\n    border-radius: 0.25rem;\n    cursor: pointer; }\n\n.customerSelect-module_icon__njhV6 {\n  flex: 0 0 1.5rem;\n  margin-right: 0.5rem;\n  padding: 0 0.125rem;\n  line-height: 0; }\n  .customerSelect-module_icon__njhV6 svg {\n    width: 100%;\n    height: auto; }\n\n.customerSelect-module_image__y5-t2 {\n  flex: 0 0 1.5rem;\n  margin-right: 0.75rem;\n  width: 1.5rem;\n  height: 1.5rem;\n  border-radius: 50%;\n  overflow: hidden;\n  line-height: 0; }\n  .customerSelect-module_image__y5-t2:last-child {\n    margin: 0 0 0 0.75rem; }\n  .customerSelect-module_image__y5-t2 img {\n    object-fit: cover;\n    width: 100%;\n    height: 100%; }\n\n.customerSelect-module_info__YI3hK {\n  flex: 1 1 auto;\n  min-width: 0; }\n\n.customerSelect-module_info__YI3hK,\n.customerSelect-module_id__1xZZV,\n.customerSelect-module_balance__2a_uo {\n  font-size: 0.75rem;\n  line-height: 1.16667em;\n  color: #000000; }\n\n.customerSelect-module_label__1Nuic,\n.customerSelect-module_idLabel__3KUNf,\n.customerSelect-module_balanceLabel__3jfbM {\n  font-family: 'Avenir Next Regular', sans-serif;\n  font-weight: normal; }\n\n.customerSelect-module_email__3cWLa,\n.customerSelect-module_idValue__27A5K,\n.customerSelect-module_balanceValue__2YWBr {\n  font-family: 'Avenir Next Regular', sans-serif;\n  font-weight: normal; }\n\n.customerSelect-module_label__1Nuic,\n.customerSelect-module_email__3cWLa,\n.customerSelect-module_balanceValue__2YWBr {\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis; }\n\n.customerSelect-module_id__1xZZV,\n.customerSelect-module_balance__2a_uo {\n  flex: 0 0 auto;\n  margin-left: 0.75rem; }\n";
var styles$7 = {"content":"customerSelect-module_content__X3M2L","_selected":"customerSelect-module__selected__2lbXT","select":"customerSelect-module_select__1fUHA","option":"customerSelect-module_option__2rJKK","icon":"customerSelect-module_icon__njhV6","image":"customerSelect-module_image__y5-t2","info":"customerSelect-module_info__YI3hK","id":"customerSelect-module_id__1xZZV","balance":"customerSelect-module_balance__2a_uo","label":"customerSelect-module_label__1Nuic","idLabel":"customerSelect-module_idLabel__3KUNf","balanceLabel":"customerSelect-module_balanceLabel__3jfbM","email":"customerSelect-module_email__3cWLa","idValue":"customerSelect-module_idValue__27A5K","balanceValue":"customerSelect-module_balanceValue__2YWBr","hover-ripples":"customerSelect-module_hover-ripples__1sD_4"};
styleInject(css_248z$8);

function ownKeys$e(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$e(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$e(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$e(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _createSuper$e(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$e(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct$e() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var CustomerLazySelect = /*#__PURE__*/function (_Component) {
  _inherits(CustomerLazySelect, _Component);

  var _super = _createSuper$e(CustomerLazySelect);

  function CustomerLazySelect() {
    var _this;

    _classCallCheck(this, CustomerLazySelect);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    _this.state = {
      balance: '—'
    };

    _this.getToggleContent = function (func) {
      _this.toggleOpener = func;
    };

    _this.closeOpener = function () {
      return _this.toggleOpener(false);
    };

    _this.renderOption = function (option) {
      var name = option.name,
          id = option.id,
          email = option.email,
          image = option.image;
      return {
        label: name,
        value: id,
        email: email,
        image: image,
        reactLabel: /*#__PURE__*/React__default.createElement("span", {
          className: styles$7.option
        }, /*#__PURE__*/React__default.createElement("div", {
          className: styles$7.image,
          key: "".concat(id, "-image")
        }, /*#__PURE__*/React__default.createElement("img", {
          src: image,
          alt: ""
        })), /*#__PURE__*/React__default.createElement("div", {
          className: styles$7.info,
          key: "".concat(id, "-info")
        }, /*#__PURE__*/React__default.createElement("div", {
          className: styles$7.label,
          key: "".concat(id, "-name")
        }, name), /*#__PURE__*/React__default.createElement("div", {
          className: styles$7.email,
          key: "".concat(id, "-email")
        }, email)), /*#__PURE__*/React__default.createElement("div", {
          className: styles$7.id,
          key: "".concat(id, "-id")
        }, /*#__PURE__*/React__default.createElement("div", {
          className: styles$7.idLabel,
          key: "".concat(id, "-id-title")
        }, "ID"), /*#__PURE__*/React__default.createElement("div", {
          className: styles$7.idValue,
          key: "".concat(id, "-id-value")
        }, id)))
      };
    };

    _this.transformedOptions = function (response, state) {
      var mapServerResponseDataFunc = _this.props.mapServerResponseDataFunc;
      var data = response.data,
          recordsFiltered = response.recordsFiltered,
          recordsTotal = response.recordsTotal;

      if (mapServerResponseDataFunc) {
        mapServerResponseDataFunc(response, state);
      }

      return {
        filteredRecords: recordsFiltered,
        totalRecords: recordsTotal,
        data: data.map(_this.renderOption)
      };
    };

    return _this;
  }

  _createClass(CustomerLazySelect, [{
    key: "componentDidUpdate",
    value: function () {
      var _componentDidUpdate = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee(newProps) {
        var balance;
        return regenerator.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!this.props.showBalance) {
                  _context.next = 11;
                  break;
                }

                if (!this.props.value) {
                  _context.next = 10;
                  break;
                }

                if (!(newProps.value !== this.props.value)) {
                  _context.next = 8;
                  break;
                }

                this.setState({
                  balance: '—'
                });
                _context.next = 6;
                return ApiService.fetchAdvertiserBalance(this.props.value.value);

              case 6:
                balance = _context.sent;
                this.setState({
                  balance: balance === null ? '—' : CurrencyFormat.format(balance)
                });

              case 8:
                _context.next = 11;
                break;

              case 10:
                if (this.state.balance && this.state.balance !== '—') {
                  this.setState({
                    balance: '—'
                  });
                }

              case 11:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function componentDidUpdate(_x) {
        return _componentDidUpdate.apply(this, arguments);
      }

      return componentDidUpdate;
    }()
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          _this$props$className = _this$props.className,
          className = _this$props$className === void 0 ? '' : _this$props$className,
          value = _this$props.value,
          showBalance = _this$props.showBalance;
      console.log(this.state.balance);
      var btn = !value ? /*#__PURE__*/React__default.createElement(ButtonCircle, {
        iconName: "People",
        className: "_size-24"
      }) : /*#__PURE__*/React__default.createElement("div", {
        className: "".concat(styles$7.option, " ").concat(styles$7._selected)
      }, /*#__PURE__*/React__default.createElement("i", {
        className: styles$7.icon
      }, /*#__PURE__*/React__default.createElement(Icon, {
        name: "People"
      })), /*#__PURE__*/React__default.createElement("div", {
        className: styles$7.info
      }, /*#__PURE__*/React__default.createElement("div", {
        className: styles$7.label
      }, value.label), /*#__PURE__*/React__default.createElement("div", {
        className: styles$7.email
      }, value.email)), showBalance ? /*#__PURE__*/React__default.createElement("div", {
        className: styles$7.balance
      }, /*#__PURE__*/React__default.createElement("div", {
        className: styles$7.balanceLabel
      }, "Balance"), /*#__PURE__*/React__default.createElement("div", {
        className: styles$7.balanceValue
      }, this.state.balance)) : null, /*#__PURE__*/React__default.createElement("div", {
        className: styles$7.image
      }, /*#__PURE__*/React__default.createElement("img", {
        src: value.image,
        alt: ""
      })));
      var list = /*#__PURE__*/React__default.createElement(LazySelect, _extends({}, this.props, {
        selectSpecificProps: _objectSpread$e({
          className: styles$7.select,
          placeholder: 'Select Customer',
          isAlwaysOpen: true,
          btnOnClick: this.closeOpener,
          isSearchable: true,
          isMulti: false
        }, this.props.selectSpecificProps),
        mapServerResponseData: this.transformedOptions
      }));
      return /*#__PURE__*/React__default.createElement(Opener, {
        className: "".concat(styles$7.opener, " ").concat(className),
        contentClassName: "".concat(styles$7.content, " ").concat(value ? styles$7._selected : ''),
        getToggleContent: this.getToggleContent,
        btn: btn,
        content: list
      });
    }
  }]);

  return CustomerLazySelect;
}(Component);
CustomerLazySelect.propTypes = {
  className: PropTypes.string,
  options: PropTypes.array,
  showBalance: PropTypes.bool,
  value: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
  onChange: PropTypes.func
};

function Dropdown(props) {
  var dropdownIsOpened = props.dropdownIsOpened,
      toggleOpeningEl = props.toggleOpeningEl,
      toggleDropdownVisilitiy = props.toggleDropdownVisilitiy,
      hasSelectedItems = props.hasSelectedItems,
      allowsToSelectAll = props.allowsToSelectAll,
      handleClearSelection = props.handleClearSelection,
      handleSelectAllItems = props.handleSelectAllItems,
      label = props.label,
      placeholder = props.placeholder,
      selectedLabel = props.selectedLabel,
      style = props.style,
      className = props.className,
      children = props.children;
  var wrapperClassName = "select-with-creating ".concat(className || '');
  var selectClassName = "select js-select ".concat(dropdownIsOpened ? '_opened' : '');
  var upperLabel = hasSelectedItems ? label : placeholder;
  var mainLabel = hasSelectedItems ? selectedLabel : '';
  var onClearSelection = useCallback(function (event) {
    event.stopPropagation();
    handleClearSelection();
  }, []);
  var onSelectAll = useCallback(function (event) {
    event.stopPropagation();
    handleSelectAllItems();
  }, []);
  var clearSelectionElement = hasSelectedItems && /*#__PURE__*/React__default.createElement("div", {
    className: "select__clear",
    onClick: onClearSelection
  }, /*#__PURE__*/React__default.createElement(Icon, {
    name: "Close"
  }));
  var selectAllElement = allowsToSelectAll && /*#__PURE__*/React__default.createElement("div", {
    className: "select__btn-secondary",
    onClick: onSelectAll
  }, "Select All");
  return /*#__PURE__*/React__default.createElement("div", {
    style: style,
    className: wrapperClassName,
    ref: toggleOpeningEl
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "".concat(selectClassName, " opener__container"),
    tabIndex: 0,
    onKeyDown: function onKeyDown(e) {
      if (e.key === 'Enter') {
        toggleDropdownVisilitiy();
        e.stopPropagation();
      }
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "select__outer-wrapper"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "select__wrapper"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "select__btn opener__btn position-relative",
    onClick: function onClick() {
      return toggleDropdownVisilitiy();
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "select__label ".concat(hasSelectedItems ? '_up' : '')
  }, upperLabel), /*#__PURE__*/React__default.createElement("div", {
    className: "select__value ".concat(hasSelectedItems ? '_selected' : '')
  }, mainLabel), selectAllElement, clearSelectionElement, /*#__PURE__*/React__default.createElement("div", {
    className: "select__indicator"
  })), dropdownIsOpened && children))));
}

Dropdown.propTypes = {
  dropdownIsOpened: PropTypes.bool,
  toggleOpeningEl: PropTypes.object,
  toggleDropdownVisilitiy: PropTypes.func,
  hasSelectedItems: PropTypes.bool,
  allowsToSelectAll: PropTypes.bool,
  handleClearSelection: PropTypes.func,
  handleSelectAllItems: PropTypes.func,
  selectedLabel: PropTypes.string,
  label: PropTypes.string,
  placeholder: PropTypes.string,
  style: PropTypes.object,
  className: PropTypes.string
};

function DropdownActionButtons(props) {
  var onApply = props.onApply,
      onCancel = props.onCancel,
      applyButtonIsDisabled = props.applyButtonIsDisabled;

  var handleCancel = function handleCancel() {
    onCancel();
  };

  return /*#__PURE__*/React__default.createElement("div", {
    className: "select__list-wrapper _action-buttons"
  }, /*#__PURE__*/React__default.createElement(Button, {
    className: "btn-square _conflower-blue mr-2",
    onClick: handleCancel
  }, "Cancel"), /*#__PURE__*/React__default.createElement(Button, {
    className: "btn-square _filled _conflower-blue",
    disabled: applyButtonIsDisabled,
    onClick: onApply
  }, "Apply"));
}

DropdownActionButtons.propTypes = {
  applyButtonIsDisabled: PropTypes.bool,
  onCancel: PropTypes.func,
  onApply: PropTypes.func
};

function CreatingForm(props) {
  var createNewItem = props.createNewItem,
      cancelCreating = props.cancelCreating,
      newItemPlaceholder = props.newItemPlaceholder,
      buttonLabel = props.buttonLabel,
      newItemName = props.newItemName,
      changeNewItemName = props.changeNewItemName;
  return /*#__PURE__*/React__default.createElement("div", {
    className: "select__list-wrapper _header"
  }, /*#__PURE__*/React__default.createElement(TextField, {
    name: "newItemNameInput",
    label: newItemPlaceholder,
    onChange: changeNewItemName,
    value: newItemName,
    inputRef: function inputRef(v) {
      return v.select();
    },
    autofocus: true
  }), /*#__PURE__*/React__default.createElement("div", {
    className: "select__buttons d-flex mt-3 mb-3"
  }, /*#__PURE__*/React__default.createElement(Button, {
    className: "create-group-container__button btn-square _conflower-blue _sm mr-2",
    onClick: cancelCreating
  }, "Cancel"), /*#__PURE__*/React__default.createElement(Button, {
    disabled: !newItemName.length,
    className: "create-group-container__button btn-square _filled _conflower-blue _sm",
    onClick: createNewItem
  }, buttonLabel)));
}
CreatingForm.propTypes = {
  buttonLabel: PropTypes.string,
  newItemPlaceholder: PropTypes.string,
  createNewItem: PropTypes.func,
  cancelCreating: PropTypes.func,
  newItemName: PropTypes.string,
  changeNewItemName: PropTypes.func
};

function SelectListHeader(props) {
  var switchToCreateMode = props.switchToCreateMode,
      buttonLabel = props.buttonLabel,
      changeSearchString = props.changeSearchString,
      searchString = props.searchString;
  var handeChangeSearchString = useCallback(function (event) {
    return changeSearchString(event.target.value);
  });
  return /*#__PURE__*/React__default.createElement("div", {
    className: "select__list-wrapper _header"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "select__search btn-select__search"
  }, /*#__PURE__*/React__default.createElement(TextFieldWithIcon, {
    iconName: "Search",
    onChange: handeChangeSearchString,
    value: searchString,
    placeholder: "Search"
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "select__buttons d-flex mt-3 mb-3"
  }, /*#__PURE__*/React__default.createElement(Button, {
    className: "create-group-container__button btn-round _conflower-blue _sm",
    onClick: switchToCreateMode
  }, buttonLabel)));
}
SelectListHeader.propTypes = {
  buttonLabel: PropTypes.string,
  searchString: PropTypes.string,
  switchToCreateMode: PropTypes.func,
  changeSearchString: PropTypes.func
};

function DropdownHeader(props) {
  var allowsToCreateNewItem = props.allowsToCreateNewItem,
      buttonLabel = props.buttonLabel,
      newItemPlaceholder = props.newItemPlaceholder,
      newItemName = props.newItemName,
      searchString = props.searchString,
      createNewItem = props.createNewItem,
      doInvertAllowingToCreateNewItem = props.doInvertAllowingToCreateNewItem,
      doChangeSearchString = props.doChangeSearchString,
      doChangeNewItemName = props.doChangeNewItemName;
  return allowsToCreateNewItem ? /*#__PURE__*/React__default.createElement(CreatingForm, {
    newItemPlaceholder: newItemPlaceholder,
    buttonLabel: buttonLabel,
    cancelCreating: doInvertAllowingToCreateNewItem,
    newItemName: newItemName,
    changeNewItemName: doChangeNewItemName,
    createNewItem: createNewItem
  }) : /*#__PURE__*/React__default.createElement(SelectListHeader, {
    switchToCreateMode: doInvertAllowingToCreateNewItem,
    buttonLabel: buttonLabel,
    searchString: searchString,
    changeSearchString: doChangeSearchString
  });
}

DropdownHeader.propTypes = {
  allowsToCreateNewItem: PropTypes.bool,
  buttonLabel: PropTypes.string,
  newItemPlaceholder: PropTypes.string,
  newItemName: PropTypes.string,
  searchString: PropTypes.string,
  createNewItem: PropTypes.func,
  doInvertAllowingToCreateNewItem: PropTypes.func,
  doChangeSearchString: PropTypes.func,
  doChangeNewItemName: PropTypes.func
};

function DropdownItem(props) {
  var deleteItem = props.deleteItem,
      selectItem = props.selectItem,
      item = props.item,
      isSelected = props.isSelected;
  var className = "select__option ".concat(isSelected ? '_active' : '');
  var onSelectItem = useCallback(function () {
    selectItem(item, !isSelected);
  }, [isSelected]);
  var onDeleteItem = useCallback(function (event) {
    event.stopPropagation();
    deleteItem(item);
  }, []);
  return /*#__PURE__*/React__default.createElement("div", {
    key: item.value,
    className: className,
    onClick: onSelectItem
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "select__option-label"
  }, item.label), deleteItem && /*#__PURE__*/React__default.createElement(Icon, {
    name: "Delete",
    onClick: onDeleteItem
  }));
}

DropdownItem.propTypes = {
  item: PropTypes.object,
  isSelected: PropTypes.any,
  deleteItem: PropTypes.func,
  selectItem: PropTypes.func
};

function DropdownItems(props) {
  var shouldApplyChanges = props.shouldApplyChanges,
      searchString = props.searchString,
      selectListItems = props.selectListItems,
      selectionMap = props.selectionMap,
      deleteItem = props.deleteItem,
      selectItem = props.selectItem;
  var selectListRef = useRef(null);

  var _useState = useState$2(false),
      _useState2 = _slicedToArray(_useState, 2),
      isScrollable = _useState2[0],
      setIsScrollable = _useState2[1];

  var changeScrollability = useCallback(function () {
    var isScrollable = selectListRef.current && selectListRef.current.clientHeight < selectListRef.current.scrollHeight;
    setIsScrollable(isScrollable);
  }, []);
  useEffect(function () {
    changeScrollability();
  }, [selectListItems]);
  useEffect(function () {
    changeScrollability();
  }, []);
  var lowerSearchString = searchString && searchString.toLowerCase();
  var selectListItemsComponents = selectListItems.reduce(function (components, selectListItem) {
    if (searchString) {
      var comparedLabel = selectListItem.label.toLowerCase();

      if (!comparedLabel.includes(lowerSearchString)) {
        return components;
      }
    }

    var item = selectionMap[selectListItem.value];
    components.push( /*#__PURE__*/React__default.createElement(DropdownItem, {
      key: selectListItem.value,
      item: selectListItem,
      isSelected: item && item.itemIsSelected,
      selectItem: selectItem,
      deleteItem: deleteItem
    }));
    return components;
  }, []);
  var classNames = ['select__list-container'];

  if (isScrollable) {
    classNames.push('_scrollable');
  }

  if (!shouldApplyChanges) {
    classNames.push('_border-rounded');
  }

  return /*#__PURE__*/React__default.createElement("div", {
    className: classNames.join(' ')
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "select__list",
    ref: selectListRef
  }, selectListItemsComponents.length ? selectListItemsComponents : /*#__PURE__*/React__default.createElement("div", {
    className: "px-3 py-2 text-muted"
  }, "No items found")));
}
DropdownItems.propTypes = {
  shouldApplyChanges: PropTypes.bool,
  searchString: PropTypes.string,
  selectListItems: PropTypes.array,
  selectionMap: PropTypes.object,
  deleteItem: PropTypes.func,
  selectItem: PropTypes.func
};

function WrappedCustomOpener(props) {
  var setRef = props.setRef,
      handleClick = props.handleClick,
      opener = props.opener,
      wrapperMainStyles = props.wrapperMainStyles;

  var onClick = function onClick(event) {
    event.stopPropagation();
    handleClick();
  };

  if (!wrapperMainStyles.current) {
    useEffect(function () {
      var openingButtonStyle = getComputedStyle(setRef.current);
      wrapperMainStyles.current = {
        width: openingButtonStyle.width,
        height: openingButtonStyle.height,
        left: openingButtonStyle.marginLeft
      };
    }, []);
  }

  return /*#__PURE__*/React__default.createElement("div", {
    ref: setRef,
    onClick: onClick
  }, opener);
}
WrappedCustomOpener.propTypes = {
  setRef: PropTypes.object,
  wrapperMainStyles: PropTypes.object,
  handleClick: PropTypes.func,
  opener: PropTypes.element
};

var TOGGLE_SELECT_VISIBILITY = 'TOGGLE_SELECT_VISIBILITY';
var ALLOWS_TO_CREATE_NEW_ITEM = 'ALLOWS_TO_CREATE_NEW_ITEM';
var CHANGE_SEARCH_STRING = 'CHANGE_SEARCH_STRING';
var CHANGE_NEW_ITEM_NAME = 'CHANGE_NEW_ITEM_NAME';
var HANDLE_SELECT_ITEM = 'HANDLE_SELECT_ITEM';
var HANDLE_DELETE_ITEM = 'HANDLE_DELETE_ITEM';
var HANDLE_SELECT_ALL_ITEMS = 'HANDLE_SELECT_ALL_ITEMS';
var HANDLE_DESELECT_ALL_ITEMS = 'HANDLE_DESELECT_ALL_ITEMS';
var ADD_NEW_ITEM = 'ADD_NEW_ITEM';
var ADD_NEW_ITEMS = 'ADD_NEW_ITEMS';
var CREATE_NEW_ITEM = 'CREATE_NEW_ITEM';
var INIT_VALUES = 'INIT_VALUES';

function getIntialState(props) {
  var shouldApplyChanges = props.shouldApplyChanges,
      isMulti = props.isMulti,
      items = props.items,
      value = props.value;
  var intialState = {
    selectListIsOpened: false,
    allowsToCreateNewItem: false,
    selectionMap: {},
    defaultDataSnapshot: {},
    searchString: '',
    newItemName: '',
    creatingNewItemName: '',
    changesCount: 0,
    selectedItemsCount: value.length,
    shouldApplyChanges: shouldApplyChanges,
    isMulti: isMulti
  };
  var map = value.reduce(function (map, selectedItem) {
    map[selectedItem.value] = selectedItem;
    return map;
  }, {});
  items.forEach(function (item) {
    if (map[item.value]) {
      intialState.selectionMap[item.value] = {
        itemIsSelected: true,
        item: item
      };
    }

    intialState.defaultDataSnapshot[item.value] = !!map[item.value];
  });
  return intialState;
}

function ownKeys$f(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$f(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$f(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$f(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function selectItem(state, action) {
  var item = action.item,
      itemIsSelected = action.itemIsSelected;
  var selectedItemsCount = itemIsSelected ? state.selectedItemsCount + 1 : state.selectedItemsCount - 1;
  var changesCount = state.shouldApplyChanges && state.defaultDataSnapshot[item.value] === itemIsSelected ? state.changesCount - 1 : state.changesCount + 1;

  var selectionMap = _objectSpread$f(_objectSpread$f({}, state.selectionMap), {}, _defineProperty({}, item.value, {
    item: item,
    itemIsSelected: itemIsSelected
  }));

  return _objectSpread$f(_objectSpread$f({}, state), {}, {
    changesCount: changesCount,
    selectedItemsCount: selectedItemsCount,
    selectionMap: selectionMap
  });
}

var _reducer;

function ownKeys$g(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$g(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$g(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$g(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var reducer = (_reducer = {}, _defineProperty(_reducer, TOGGLE_SELECT_VISIBILITY, function (state, action) {
  return state.shouldApplyChanges && state.selectListIsOpened ? getIntialState(action.props) : _objectSpread$g(_objectSpread$g({}, state), {}, {
    searchString: '',
    selectListIsOpened: !state.selectListIsOpened
  });
}), _defineProperty(_reducer, ALLOWS_TO_CREATE_NEW_ITEM, function (state, action) {
  var allowsToCreateNewItem = !state.allowsToCreateNewItem;

  var updatedState = _objectSpread$g(_objectSpread$g({}, state), {}, {
    allowsToCreateNewItem: allowsToCreateNewItem
  });

  if (!state.allowsToCreateNewItem) {
    updatedState.newItemName = state.searchString;
    updatedState.searchString = '';
  }

  return updatedState;
}), _defineProperty(_reducer, CHANGE_SEARCH_STRING, function (state, action) {
  return _objectSpread$g(_objectSpread$g({}, state), {}, {
    searchString: action.searchString
  });
}), _defineProperty(_reducer, CHANGE_NEW_ITEM_NAME, function (state, action) {
  return _objectSpread$g(_objectSpread$g({}, state), {}, {
    newItemName: action.newItemName
  });
}), _defineProperty(_reducer, HANDLE_DELETE_ITEM, function (state, action) {
  var newState = _objectSpread$g({}, state);

  if (newState.selectionMap[action.item.value]) {
    if (newState.selectionMap[action.item.value].itemIsSelected) {
      newState.selectedItemsCount--;
    }

    if (newState.selectionMap[action.item.value].itemIsSelected !== newState.defaultDataSnapshot[action.item.value]) {
      newState.changesCount--;
    }
  }

  if (newState.selectionMap[action.item.value]) {
    newState.selectionMap = _objectSpread$g({}, newState.selectionMap);
    delete newState.selectionMap[action.item.value];
    newState.defaultDataSnapshot = _objectSpread$g({}, newState.defaultDataSnapshot);
    delete newState.defaultDataSnapshot[action.item.value];
  }

  if (!Object.keys(newState.selectionMap).length) {
    newState.hasSelectedItems = false;
  }

  return newState;
}), _defineProperty(_reducer, HANDLE_SELECT_ALL_ITEMS, function (state, action) {
  var changesCount = 0;
  var selectionMap = action.items.reduce(function (selectionMap, item) {
    if (!state.defaultDataSnapshot[item.value]) {
      changesCount++;
    }

    selectionMap[item.value] = {
      itemIsSelected: true,
      item: item
    };
    return selectionMap;
  }, {});
  return _objectSpread$g(_objectSpread$g({}, state), {}, {
    changesCount: changesCount,
    selectedItemsCount: action.items.length,
    selectionMap: selectionMap
  });
}), _defineProperty(_reducer, HANDLE_DESELECT_ALL_ITEMS, function (state, action) {
  var changesCount = 0;
  var selectionMap = action.items.reduce(function (selectionMap, item) {
    if (state.defaultDataSnapshot[item.value]) {
      changesCount++;
    }

    selectionMap[item.value] = {
      itemIsSelected: false,
      item: item
    };
    return selectionMap;
  }, {});
  return _objectSpread$g(_objectSpread$g({}, state), {}, {
    changesCount: changesCount,
    selectedItemsCount: 0,
    selectionMap: selectionMap
  });
}), _defineProperty(_reducer, HANDLE_SELECT_ITEM, selectItem), _defineProperty(_reducer, ADD_NEW_ITEMS, function (state, action) {
  var defaultDataSnapshot = _objectSpread$g({}, state.defaultDataSnapshot);

  action.items.forEach(function (item) {
    defaultDataSnapshot[item.value] = false;
  });
  return _objectSpread$g(_objectSpread$g({}, state), {}, {
    defaultDataSnapshot: defaultDataSnapshot
  });
}), _defineProperty(_reducer, INIT_VALUES, function (state, action) {
  var defaultDataSnapshot = _objectSpread$g({}, state.defaultDataSnapshot);

  var selectionMap = _objectSpread$g({}, state.selectionMap);

  action.values.forEach(function (item) {
    defaultDataSnapshot[item.value] = true;
    selectionMap[item.value] = {
      itemIsSelected: true,
      item: item
    };
  });
  return _objectSpread$g(_objectSpread$g({}, state), {}, {
    defaultDataSnapshot: defaultDataSnapshot,
    selectionMap: selectionMap,
    selectedItemsCount: state.selectedItemsCount + action.values.length
  });
}), _defineProperty(_reducer, ADD_NEW_ITEM, function (state, action) {
  var isCreatingNewItem = action.item.label === state.creatingNewItemName;
  var selectionMap = isCreatingNewItem ? _objectSpread$g(_objectSpread$g({}, state.selectionMap), {}, _defineProperty({}, action.item.value, {
    itemIsSelected: true,
    item: action.item
  })) : state.selectionMap;
  var changesCount = state.changesCount;
  var selectedItemsCount = state.selectedItemsCount;

  if (isCreatingNewItem) {
    if (action.isMulti) {
      changesCount++;
      selectedItemsCount++;
    } else {
      changesCount = 1;
      selectedItemsCount = 1;
    }
  }

  return _objectSpread$g(_objectSpread$g({}, state), {}, {
    selectionMap: selectionMap,
    changesCount: changesCount,
    selectedItemsCount: selectedItemsCount,
    creatingNewItemName: '',
    defaultDataSnapshot: _objectSpread$g(_objectSpread$g({}, state.defaultDataSnapshot), {}, _defineProperty({}, action.item.value, false))
  });
}), _defineProperty(_reducer, CREATE_NEW_ITEM, function (state, action) {
  return _objectSpread$g(_objectSpread$g({}, state), {}, {
    allowsToCreateNewItem: false,
    newItemName: '',
    // creatingNewItemName: action.creatingNewItemName,
    selectionMap: action.isMulti ? state.selectionMap : {}
  });
}), _reducer);
var selectWithCreatingBlockReducer = (function (state, action) {
  return reducer[action.type] && reducer[action.type](state, action);
});

var invertAllowingToCreateNewItem = function invertAllowingToCreateNewItem(allowsToCreateNewItem) {
  return {
    type: ALLOWS_TO_CREATE_NEW_ITEM,
    allowsToCreateNewItem: allowsToCreateNewItem
  };
};
var toggleSelectListVisibility = function toggleSelectListVisibility(props) {
  return {
    type: TOGGLE_SELECT_VISIBILITY,
    props: props
  };
};
var changeSearchString = function changeSearchString(searchString) {
  return {
    type: CHANGE_SEARCH_STRING,
    searchString: searchString
  };
};
var changeNewItemName = function changeNewItemName(newItemName) {
  return {
    type: CHANGE_NEW_ITEM_NAME,
    newItemName: newItemName
  };
};
var handleSelectItem = function handleSelectItem(item, itemIsSelected, isMulti) {
  return {
    type: HANDLE_SELECT_ITEM,
    item: item,
    itemIsSelected: itemIsSelected,
    isMulti: isMulti
  };
};
var handleSelectAllItems = function handleSelectAllItems(items) {
  return {
    type: HANDLE_SELECT_ALL_ITEMS,
    items: items
  };
};
var handleDeselectAllItems = function handleDeselectAllItems(items) {
  return {
    type: HANDLE_DESELECT_ALL_ITEMS,
    items: items
  };
};
var handleDeleteItem = function handleDeleteItem(item) {
  return {
    type: HANDLE_DELETE_ITEM,
    item: item
  };
};
var addNewItem = function addNewItem(item, isMulti) {
  return {
    type: ADD_NEW_ITEM,
    item: item,
    isMulti: isMulti
  };
};
var addNewItems = function addNewItems(items) {
  return {
    type: ADD_NEW_ITEMS,
    items: items
  };
};
var createNewItem = function createNewItem(creatingNewItemName, isMulti) {
  return {
    type: CREATE_NEW_ITEM,
    creatingNewItemName: creatingNewItemName,
    isMulti: isMulti
  };
};
var initValues = function initValues(values) {
  return {
    type: INIT_VALUES,
    values: values
  };
};

function ownKeys$h(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$h(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$h(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$h(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function useState(defaultProps, currentProps) {
  var initialState = useMemo(function () {
    return getIntialState(currentProps);
  }, []);

  var _useReducer = useReducer(selectWithCreatingBlockReducer, initialState),
      _useReducer2 = _slicedToArray(_useReducer, 2),
      state = _useReducer2[0],
      dispatch = _useReducer2[1];

  var doToggleSelectListVisibility = function doToggleSelectListVisibility(props) {
    return dispatch(toggleSelectListVisibility(props || defaultProps.current));
  };

  var doInvertAllowingToCreateNewItem = function doInvertAllowingToCreateNewItem() {
    return dispatch(invertAllowingToCreateNewItem());
  };

  var doChangeNewItemName = function doChangeNewItemName(newItemName) {
    return dispatch(changeNewItemName(newItemName));
  };

  var doChangeSearchString = function doChangeSearchString(searchString) {
    return dispatch(changeSearchString(searchString));
  };

  var doAddNewItem = function doAddNewItem(item) {
    return dispatch(addNewItem(item));
  };

  var doAddNewItems = function doAddNewItems(items) {
    return dispatch(addNewItems(items));
  };

  var doInitValues = function doInitValues(values) {
    return dispatch(initValues(values));
  };

  var doHandleSelectAllItems = function doHandleSelectAllItems() {
    if (!state.shouldApplyChanges) {
      currentProps.onSelect(defaultProps.current.items);
    } else {
      dispatch(handleSelectAllItems(defaultProps.current.items));
    }
  };

  var doHandleDeselectAllItems = function doHandleDeselectAllItems() {
    if (!currentProps.isMulti || !state.shouldApplyChanges) {
      return currentProps.onSelect([]);
    }

    dispatch(handleDeselectAllItems(defaultProps.current.items));
  };

  var doHandleSelectItem = function doHandleSelectItem(item, isSelected) {
    if (!state.shouldApplyChanges) {
      var _defaultProps$current = defaultProps.current,
          value = _defaultProps$current.value,
          items = _defaultProps$current.items;

      if (!isSelected) {
        currentProps.onSelect(value.filter(function (value) {
          return value.value !== item.value;
        }));
      } else {
        var selectedMap = value.reduce(function (items, item) {
          items[item.value] = true;
          return items;
        }, _defineProperty({}, item.value, true));
        currentProps.onSelect(items.filter(function (item) {
          return selectedMap[item.value];
        }));
      }
    } else {
      dispatch(handleSelectItem(item, isSelected, currentProps.isMulti));

      if (!currentProps.isMulti) {
        currentProps.onSelect([item]);
        doToggleSelectListVisibility();
      }
    }
  };

  var doCreateNewItem = function doCreateNewItem() {
    currentProps.onCreate(state.newItemName);
    dispatch(createNewItem(state.newItemName, currentProps.isMulti));

    if (!currentProps.isMulti) {
      doToggleSelectListVisibility();
    }
  };

  var doHandeDeleteItem = function doHandeDeleteItem(item) {
    if (state.shouldApplyChanges) {
      dispatch(handleDeleteItem(item));
    } else {
      currentProps.onDelete(item);
    }
  };

  var doApplyChanges = function doApplyChanges() {
    var allSelectedItems = [];
    var result = defaultProps.current.items.reduce(function (result, item) {
      var itemSelection = state.selectionMap[item.value];

      if (itemSelection) {
        if (itemSelection.itemIsSelected) {
          allSelectedItems.push(itemSelection.item);
        }

        if (itemSelection.itemIsSelected !== state.defaultDataSnapshot[item.value]) {
          if (itemSelection.itemIsSelected) {
            result.selectedItems.push(itemSelection.item);
          } else {
            result.deselectedItems.push(itemSelection.item);
          }
        }
      }

      return result;
    }, {
      selectedItems: [],
      deselectedItems: []
    });
    currentProps.onSelect(allSelectedItems, {
      selectedItems: result.selectedItems,
      deselectedItems: result.deselectedItems
    });
    doToggleSelectListVisibility(_objectSpread$h(_objectSpread$h({}, defaultProps.current), {}, {
      value: allSelectedItems
    }));
  };

  return {
    state: state,
    doToggleSelectListVisibility: doToggleSelectListVisibility,
    doInvertAllowingToCreateNewItem: doInvertAllowingToCreateNewItem,
    doCreateNewItem: doCreateNewItem,
    doChangeNewItemName: doChangeNewItemName,
    doChangeSearchString: doChangeSearchString,
    doAddNewItem: doAddNewItem,
    doAddNewItems: doAddNewItems,
    doHandleSelectAllItems: doHandleSelectAllItems,
    doHandleDeselectAllItems: doHandleDeselectAllItems,
    doHandleSelectItem: doHandleSelectItem,
    doHandeDeleteItem: doHandeDeleteItem,
    doApplyChanges: doApplyChanges,
    doInitValues: doInitValues
  };
}

function useChangedProps(props) {
  var items = props.items,
      value = props.value,
      doInitValues = props.doInitValues,
      doHandleSelectItem = props.doHandleSelectItem,
      doAddNewItems = props.doAddNewItems,
      doHandeDeleteItem = props.doHandeDeleteItem;
  var oldItems = useRef(items);
  var oldValue = useRef(value);
  useEffect(function () {
    if (!oldValue.current.length && value.length) {
      doInitValues(value);
    }

    if (oldItems.current.length !== items.length) {
      if (oldItems.current.length < items.length) {
        if (!oldItems.current.length) {
          doAddNewItems(items);
        } else {
          var oldItemsMap = oldItems.current.reduce(function (t, t2) {
            t[t2.value] = true;
            return t;
          }, {});
          var addNewItems = items.filter(function (i) {
            return !oldItemsMap[i.value];
          });
          addNewItems.forEach(function (item) {
            doHandleSelectItem(item, true);
          });
        }
      } else {
        // UPDATE STATE AFTER REMOVING
        var removedItems = difference(oldItems.current, items);
        removedItems.forEach(function (item) {
          doHandeDeleteItem(item);
        });
      }

      oldItems.current = items;
    } else {
      if (oldValue.current.length !== value.length) {
        if (oldValue.current.length < items.length) ;

        oldValue.current = value;
      }
    }
  }, [items, value]);
}

var css_248z$9 = "@keyframes hover-ripples {\n  0% {\n    top: -0.1875em;\n    left: -0.1875em;\n    right: -0.1875em;\n    bottom: -0.1875em;\n    opacity: 1; }\n  100% {\n    top: -0.8125em;\n    left: -0.8125em;\n    right: -0.8125em;\n    bottom: -0.8125em;\n    opacity: 0; } }\n\n:root {\n  --primary1: #123787;\n  --primary2: #1d58d7;\n  --primary3: #5173fb;\n  --primary4: #7a93ff;\n  --primary5: #c2d0ff;\n  --primary6: #e5ebff;\n  --primary7: #f2f5ff; }\n\n.select-with-creating {\n  box-sizing: border-box;\n  position: relative;\n  width: 200px; }\n  .select-with-creating * {\n    box-sizing: border-box; }\n  .select-with-creating ._action-buttons {\n    display: flex !important;\n    padding: 15px 0;\n    justify-content: center;\n    border-top: none !important; }\n  .select-with-creating ._header {\n    padding: 8px 12px 0 !important; }\n  .select-with-creating .select__clear {\n    margin-left: 0; }\n  .select-with-creating .select__list {\n    margin: 0; }\n    .select-with-creating .select__list-wrapper .btn-select__button {\n      margin-left: auto;\n      margin-right: auto; }\n    .select-with-creating .select__list-container {\n      background-color: white; }\n      .select-with-creating .select__list-container._border-rounded {\n        border-bottom-left-radius: 5px;\n        border-bottom-right-radius: 5px;\n        overflow: hidden; }\n      .select-with-creating .select__list-container._scrollable {\n        position: relative;\n        overflow: hidden; }\n        .select-with-creating .select__list-container._scrollable:before {\n          content: '';\n          display: block;\n          position: absolute;\n          width: 100%;\n          height: 0;\n          top: 0;\n          left: 0;\n          box-shadow: 0 -0.75rem 0.5rem 0.625rem #dddddd;\n          z-index: 1; }\n        .select-with-creating .select__list-container._scrollable:after {\n          content: '';\n          display: block;\n          position: absolute;\n          width: 100%;\n          height: 0;\n          bottom: 0;\n          left: 0;\n          box-shadow: 0 0.75rem 0.5rem 0.625rem #e0e0e0;\n          z-index: 1; }\n  .select-with-creating .select__option {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    cursor: pointer; }\n    .select-with-creating .select__option:hover .svg-icon {\n      visibility: visible; }\n    .select-with-creating .select__option-label {\n      flex-grow: 1; }\n    .select-with-creating .select__option .svg-icon {\n      margin-right: 0.8125rem;\n      flex-shrink: 0;\n      width: 1rem;\n      height: 1rem;\n      cursor: pointer;\n      transition: fill 0.3s;\n      visibility: hidden; }\n      .select-with-creating .select__option .svg-icon:hover {\n        fill: #f44336; }\n  .select-with-creating .select__search {\n    padding: 0; }\n  .select-with-creating .select__input {\n    margin-top: 0.375rem; }\n  .select-with-creating .select._opened {\n    min-width: 18.75rem;\n    position: absolute;\n    top: 0;\n    left: 0;\n    z-index: 4; }\n  .select-with-creating .create-group-container__title {\n    text-align: center; }\n  .select-with-creating .create-group-container__text-field {\n    margin: 0 auto 1rem; }\n  .select-with-creating .create-group-container__button {\n    margin-left: auto;\n    margin-right: auto; }\n  .select-with-creating .create-group-container__divider {\n    margin: 0 -1rem 0.75rem;\n    height: 1px;\n    background-color: #ededed; }\n";
styleInject(css_248z$9);

var SelectWithCreatingBlockComponent = function SelectWithCreatingBlockComponent(props) {
  var isMulti = props.isMulti,
      shouldApplyChanges = props.shouldApplyChanges,
      toggleOpeningElement = props.toggleOpeningElement,
      selectedLabel = props.selectedLabel,
      newItemPlaceholder = props.newItemPlaceholder,
      buttonLabel = props.buttonLabel,
      placeholder = props.placeholder,
      className = props.className,
      items = props.items,
      _props$value = props.value,
      value = _props$value === void 0 ? [] : _props$value,
      _props$onlyList = props.onlyList,
      onlyList = _props$onlyList === void 0 ? false : _props$onlyList,
      _props$loading = props.loading,
      loading = _props$loading === void 0 ? false : _props$loading;
  var wrapperMainStyles = useRef(null);
  var toggleOpeningEl = useRef(null);
  var defaultProps = useRef(props);
  useEffect(function () {
    defaultProps.current = props;
  }, [props]);

  var _useReducer = useState(defaultProps, props),
      state = _useReducer.state,
      doToggleSelectListVisibility = _useReducer.doToggleSelectListVisibility,
      doInvertAllowingToCreateNewItem = _useReducer.doInvertAllowingToCreateNewItem,
      doChangeNewItemName = _useReducer.doChangeNewItemName,
      doChangeSearchString = _useReducer.doChangeSearchString,
      doAddNewItem = _useReducer.doAddNewItem,
      doAddNewItems = _useReducer.doAddNewItems,
      doHandleSelectAllItems = _useReducer.doHandleSelectAllItems,
      doHandleDeselectAllItems = _useReducer.doHandleDeselectAllItems,
      doHandleSelectItem = _useReducer.doHandleSelectItem,
      doCreateNewItem = _useReducer.doCreateNewItem,
      doHandeDeleteItem = _useReducer.doHandeDeleteItem,
      doApplyChanges = _useReducer.doApplyChanges,
      doInitValues = _useReducer.doInitValues;

  var clickOutsideHandler = useCallback(function (event) {
    if (!toggleOpeningEl.current.contains(event.target) && !document.body.querySelector('.modal__overlay')) {
      doToggleSelectListVisibility();
    }
  }, [doToggleSelectListVisibility]);
  useEffect(function () {
    if (!state.selectListIsOpened) {
      document.removeEventListener('mousedown', clickOutsideHandler);
    } else {
      document.addEventListener('mousedown', clickOutsideHandler);
    }
  }, [state.selectListIsOpened, clickOutsideHandler]);

  if (shouldApplyChanges) {
    useChangedProps({
      items: items,
      value: value,
      isMulti: isMulti,
      doInitValues: doInitValues,
      doHandleSelectItem: doHandleSelectItem,
      doAddNewItem: doAddNewItem,
      doAddNewItems: doAddNewItems,
      doHandeDeleteItem: doHandeDeleteItem
    });
  }

  if (!state.selectListIsOpened && toggleOpeningElement) {
    return /*#__PURE__*/React__default.createElement(WrappedCustomOpener, {
      setRef: toggleOpeningEl,
      handleClick: doToggleSelectListVisibility,
      opener: props.toggleOpeningElement,
      wrapperMainStyles: wrapperMainStyles
    });
  }

  var formattedSelectedLabel = selectedLabel;
  var hasSelectedItems = shouldApplyChanges ? state.selectedItemsCount : value.length;

  if (!formattedSelectedLabel) {
    if (!shouldApplyChanges) {
      formattedSelectedLabel = isMulti ? value.length ? "".concat(value.length, " selected") : '' : get$1(value, '[0].label');
    } else {
      if (state.selectedItemsCount) {
        formattedSelectedLabel = "".concat(state.selectedItemsCount, " selected");
      } else {
        formattedSelectedLabel = '';
      }
    }
  }

  var allowsToSelectAll = isMulti && (shouldApplyChanges ? state.selectedItemsCount !== items.length : value.length !== items.length);
  var selectionMap = shouldApplyChanges ? state.selectionMap : value.reduce(function (items, item) {
    items[item.value] = {
      item: item,
      itemIsSelected: true
    };
    return items;
  }, {});
  return /*#__PURE__*/React__default.createElement(Dropdown, {
    style: wrapperMainStyles.current,
    className: className,
    dropdownIsOpened: state.selectListIsOpened,
    toggleDropdownVisilitiy: doToggleSelectListVisibility,
    handleClearSelection: doHandleDeselectAllItems,
    handleSelectAllItems: doHandleSelectAllItems,
    hasSelectedItems: !!hasSelectedItems,
    allowsToSelectAll: state.selectListIsOpened && allowsToSelectAll,
    selectedLabel: formattedSelectedLabel,
    placeholder: placeholder,
    label: props.label,
    toggleOpeningEl: toggleOpeningEl
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "select__list-menu px-0"
  }, !onlyList && /*#__PURE__*/React__default.createElement(DropdownHeader, {
    allowsToCreateNewItem: state.allowsToCreateNewItem,
    buttonLabel: buttonLabel,
    newItemPlaceholder: newItemPlaceholder,
    newItemName: state.newItemName,
    searchString: state.searchString,
    createNewItem: doCreateNewItem,
    doInvertAllowingToCreateNewItem: doInvertAllowingToCreateNewItem,
    doChangeSearchString: doChangeSearchString,
    doChangeNewItemName: doChangeNewItemName
  }), loading ? /*#__PURE__*/React__default.createElement(ProgressCircle, {
    className: "d-block mx-auto my-5",
    size: 20,
    borderWidth: 2
  }) : /*#__PURE__*/React__default.createElement(DropdownItems, {
    shouldApplyChanges: shouldApplyChanges,
    searchString: state.searchString,
    selectionMap: selectionMap,
    selectListItems: items,
    deleteItem: props.onDelete,
    selectItem: doHandleSelectItem
  }), shouldApplyChanges && /*#__PURE__*/React__default.createElement(DropdownActionButtons, {
    onApply: doApplyChanges,
    onCancel: doToggleSelectListVisibility,
    applyButtonIsDisabled: !state.changesCount
  })));
};

SelectWithCreatingBlockComponent.defaultProps = {
  isMulti: false,
  newItemPlaceholder: ''
};
SelectWithCreatingBlockComponent.propTypes = {
  toggleOpeningElement: PropTypes.element,
  items: PropTypes.array,
  value: PropTypes.array,
  selectedLabel: PropTypes.string,
  buttonLabel: PropTypes.string,
  label: PropTypes.string,
  newItemPlaceholder: PropTypes.string,
  placeholder: PropTypes.string,
  isMulti: PropTypes.bool,
  shouldApplyChanges: PropTypes.bool,
  className: PropTypes.string,
  onDelete: PropTypes.func,
  onlyList: PropTypes.bool,
  loading: PropTypes.bool
};
var SelectWithCreatingBlock = SelectWithCreatingBlockComponent;

function Dropdown$1(props) {
  var dropdownIsOpened = props.dropdownIsOpened,
      toggleOpeningEl = props.toggleOpeningEl,
      toggleDropdownVisilitiy = props.toggleDropdownVisilitiy,
      hasSelectedItems = props.hasSelectedItems,
      allowsToSelectAll = props.allowsToSelectAll,
      handleClearSelection = props.handleClearSelection,
      handleSelectAllItems = props.handleSelectAllItems,
      label = props.label,
      placeholder = props.placeholder,
      selectedLabel = props.selectedLabel,
      style = props.style,
      className = props.className,
      children = props.children;
  var wrapperClassName = "select-with-creating ".concat(className || '');
  var selectClassName = "select js-select ".concat(dropdownIsOpened ? '_opened' : '');
  var upperLabel = hasSelectedItems ? label : placeholder;
  var mainLabel = hasSelectedItems ? selectedLabel : '';
  var onClearSelection = useCallback(function (event) {
    event.stopPropagation();
    handleClearSelection();
  }, [handleClearSelection]);
  var onSelectAll = useCallback(function (event) {
    event.stopPropagation();
    handleSelectAllItems();
  }, [handleSelectAllItems]);
  var clearSelectionElement = hasSelectedItems && /*#__PURE__*/React__default.createElement("div", {
    className: "select__clear",
    onClick: onClearSelection
  }, /*#__PURE__*/React__default.createElement(Icon, {
    name: "Close"
  }));
  var selectAllElement = allowsToSelectAll && /*#__PURE__*/React__default.createElement("div", {
    className: "select__btn-secondary",
    onClick: onSelectAll
  }, "Select All");
  return /*#__PURE__*/React__default.createElement("div", {
    style: style,
    className: wrapperClassName,
    ref: toggleOpeningEl
  }, /*#__PURE__*/React__default.createElement("div", {
    className: selectClassName
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "select__outer-wrapper"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "select__wrapper"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "select__btn",
    onClick: function onClick() {
      return toggleDropdownVisilitiy();
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "select__label ".concat(hasSelectedItems ? '_up' : '')
  }, upperLabel), /*#__PURE__*/React__default.createElement("div", {
    className: "select__value ".concat(hasSelectedItems ? '_selected' : '')
  }, mainLabel), selectAllElement, clearSelectionElement, /*#__PURE__*/React__default.createElement("div", {
    className: "select__indicator"
  })), dropdownIsOpened && children))));
}

Dropdown$1.propTypes = {
  dropdownIsOpened: PropTypes.bool,
  toggleOpeningEl: PropTypes.object,
  toggleDropdownVisilitiy: PropTypes.func,
  hasSelectedItems: PropTypes.bool,
  allowsToSelectAll: PropTypes.bool,
  handleClearSelection: PropTypes.func,
  handleSelectAllItems: PropTypes.func,
  selectedLabel: PropTypes.string,
  label: PropTypes.string,
  placeholder: PropTypes.string,
  style: PropTypes.object,
  className: PropTypes.string
};

function ApplyChangesButtons(props) {
  var onApply = props.onApply,
      onCancel = props.onCancel,
      applyButtonIsDisabled = props.applyButtonIsDisabled;

  var handleCancel = function handleCancel() {
    onCancel();
  };

  return /*#__PURE__*/React__default.createElement("div", {
    className: "select__list-wrapper _action-buttons"
  }, /*#__PURE__*/React__default.createElement(Button, {
    className: "btn-square _conflower-blue mr-2",
    onClick: handleCancel
  }, "Cancel"), /*#__PURE__*/React__default.createElement(Button, {
    className: "btn-square _filled _conflower-blue",
    disabled: applyButtonIsDisabled,
    onClick: onApply
  }, "Apply"));
}

ApplyChangesButtons.propTypes = {
  applyButtonIsDisabled: PropTypes.bool,
  onCancel: PropTypes.func,
  onApply: PropTypes.func
};

function CreatingForm$1(props) {
  var createNewItem = props.createNewItem,
      cancelCreating = props.cancelCreating,
      newItemPlaceholder = props.newItemPlaceholder,
      newItemName = props.newItemName,
      changeNewItemName = props.changeNewItemName;
  var disabled = !newItemName || newItemName && !newItemName.trim();
  return /*#__PURE__*/React__default.createElement("div", {
    className: "select__list-wrapper _header"
  }, /*#__PURE__*/React__default.createElement(TextField, {
    name: "newItemNameInput",
    label: newItemPlaceholder,
    onChange: changeNewItemName,
    value: newItemName,
    inputRef: function inputRef(v) {
      return v.select();
    },
    autofocus: true
  }), /*#__PURE__*/React__default.createElement("div", {
    className: "select__buttons d-flex mt-3 mb-3"
  }, /*#__PURE__*/React__default.createElement(Button, {
    className: "create-group-container__button btn-square _conflower-blue _sm mr-2",
    onClick: cancelCreating
  }, "Cancel"), /*#__PURE__*/React__default.createElement(Button, {
    disabled: disabled,
    className: "create-group-container__button btn-square _filled _conflower-blue _sm",
    onClick: createNewItem
  }, "Create New Group")));
}
CreatingForm$1.propTypes = {
  // buttonLabel: PropTypes.string,
  newItemPlaceholder: PropTypes.string,
  createNewItem: PropTypes.func,
  cancelCreating: PropTypes.func,
  newItemName: PropTypes.string,
  changeNewItemName: PropTypes.func
};

function SelectListHeader$1(props) {
  var switchToCreateMode = props.switchToCreateMode,
      changeSearchString = props.changeSearchString,
      searchString = props.searchString;
  var handeChangeSearchString = useCallback(function (event) {
    return changeSearchString(event.target.value);
  }, [changeSearchString]);
  return /*#__PURE__*/React__default.createElement("div", {
    className: "select__list-wrapper _header"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "select__search btn-select__search"
  }, /*#__PURE__*/React__default.createElement(TextFieldWithIcon, {
    iconName: "Search",
    onChange: handeChangeSearchString,
    value: searchString,
    placeholder: "Search"
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "select__buttons d-flex mt-3 mb-3"
  }, /*#__PURE__*/React__default.createElement(Button, {
    className: "create-group-container__button btn-round _filled _conflower-blue _sm",
    onClick: switchToCreateMode
  }, "+ Create New Group")));
}
SelectListHeader$1.propTypes = {
  // buttonLabel: PropTypes.string,
  searchString: PropTypes.string,
  switchToCreateMode: PropTypes.func,
  changeSearchString: PropTypes.func
};

function DropdownHeader$1(props) {
  var allowsToCreateNewItem = props.allowsToCreateNewItem,
      buttonLabel = props.buttonLabel,
      newItemPlaceholder = props.newItemPlaceholder,
      newItemName = props.newItemName,
      searchString = props.searchString,
      createNewItem = props.createNewItem,
      doInvertAllowingToCreateNewItem = props.doInvertAllowingToCreateNewItem,
      doChangeSearchString = props.doChangeSearchString,
      doChangeNewItemName = props.doChangeNewItemName;
  return allowsToCreateNewItem ? /*#__PURE__*/React__default.createElement(CreatingForm$1, {
    newItemPlaceholder: newItemPlaceholder,
    buttonLabel: buttonLabel,
    cancelCreating: doInvertAllowingToCreateNewItem,
    newItemName: newItemName,
    changeNewItemName: doChangeNewItemName,
    createNewItem: createNewItem
  }) : /*#__PURE__*/React__default.createElement(SelectListHeader$1, {
    switchToCreateMode: doInvertAllowingToCreateNewItem,
    buttonLabel: buttonLabel,
    searchString: searchString,
    changeSearchString: doChangeSearchString
  });
}

DropdownHeader$1.propTypes = {
  allowsToCreateNewItem: PropTypes.bool,
  buttonLabel: PropTypes.string,
  newItemPlaceholder: PropTypes.string,
  newItemName: PropTypes.string,
  searchString: PropTypes.string,
  createNewItem: PropTypes.func,
  doInvertAllowingToCreateNewItem: PropTypes.func,
  doChangeSearchString: PropTypes.func,
  doChangeNewItemName: PropTypes.func
};

var css_248z$a = ":root {\n  --primary1: #123787;\n  --primary2: #1d58d7;\n  --primary3: #5173fb;\n  --primary4: #7a93ff;\n  --primary5: #c2d0ff;\n  --primary6: #e5ebff;\n  --primary7: #f2f5ff; }\n\n.GroupListItem-module_deleteItemIcon__2hKfA {\n  visibility: hidden;\n  margin-right: 0.8125rem;\n  flex-shrink: 0;\n  cursor: pointer;\n  transition: fill 0.3s; }\n  .GroupListItem-module_deleteItemIcon__2hKfA svg {\n    width: 1rem;\n    height: 1rem; }\n    .GroupListItem-module_deleteItemIcon__2hKfA svg:hover {\n      fill: #f44336; }\n\n.GroupListItem-module_groupListItem__3f9V2 {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  cursor: pointer;\n  color: #000000; }\n  .GroupListItem-module_groupListItem__3f9V2:hover .GroupListItem-module_deleteItemIcon__2hKfA {\n    visibility: visible; }\n\n.GroupListItem-module_groupItemCheckbox__13hL9 {\n  margin-right: 5px; }\n\n.GroupListItem-module_groupListItem__3f9V2:hover .GroupListItem-module_deleteItemIcon__2hKfA {\n  visibility: visible; }\n\n.GroupListItem-module_groupListItem__3f9V2:hover .GroupListItem-module_groupItemCheckbox__13hL9 {\n  pointer-events: none; }\n  .GroupListItem-module_groupListItem__3f9V2:hover .GroupListItem-module_groupItemCheckbox__13hL9 .checkbox__input:not(:disabled) + svg {\n    fill: #6075ff; }\n";
var styles$8 = {"deleteItemIcon":"GroupListItem-module_deleteItemIcon__2hKfA","groupListItem":"GroupListItem-module_groupListItem__3f9V2","groupItemCheckbox":"GroupListItem-module_groupItemCheckbox__13hL9"};
styleInject(css_248z$a);

function GroupListItem(props) {
  var deleteItem = props.deleteItem,
      selectItem = props.selectItem,
      item = props.item,
      isSelected = props.isSelected,
      isPartiallySelected = props.isPartiallySelected;
  var className = "".concat(styles$8.groupListItem, " ").concat(isSelected ? styles$8.selectedGroupListItem : '');
  var onSelectItem = useCallback(function () {
    if (item.disabled) {
      return;
    }

    selectItem(item, !isSelected);
  }, [isSelected]);
  var onDeleteItem = useCallback(function (event) {
    event.stopPropagation();
    deleteItem(item);
  }, []);
  return /*#__PURE__*/React__default.createElement("div", {
    key: item.value,
    className: className
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "select__option-label ".concat(item.disabled ? '_disabled' : ''),
    onClick: onSelectItem
  }, /*#__PURE__*/React__default.createElement(Checkbox, {
    className: "".concat(styles$8.groupItemCheckbox, " ").concat(isPartiallySelected ? '_dirty' : ''),
    checked: isSelected,
    name: "checkbox-id-".concat(item.value),
    onChange: function onChange() {
      return null;
    },
    disabled: item.disabled || false
  }), item.label), /*#__PURE__*/React__default.createElement("div", {
    className: styles$8.deleteItemIcon,
    onClick: onDeleteItem
  }, /*#__PURE__*/React__default.createElement(Icon, {
    name: "Delete"
  })));
}

GroupListItem.propTypes = {
  item: PropTypes.object,
  isSelected: PropTypes.bool,
  isPartiallySelected: PropTypes.bool,
  deleteItem: PropTypes.func,
  selectItem: PropTypes.func
};
var GroupListItem$1 = /*#__PURE__*/React__default.memo(GroupListItem);

function GroupsList(props) {
  var shouldApplyChanges = props.shouldApplyChanges,
      searchString = props.searchString,
      selectListItems = props.selectListItems,
      selectionMap = props.selectionMap,
      deleteItem = props.deleteItem,
      selectItem = props.selectItem;
  var selectListRef = useRef(null); // const [isScrollable, setIsScrollable] = useState(false);
  // const changeScrollability = useCallback(() => {
  //   const isScrollable = selectListRef.current && (selectListRef.current.clientHeight < selectListRef.current.scrollHeight);
  //   setIsScrollable(isScrollable);
  // }, []);
  // useEffect(() => {
  //   changeScrollability();
  // }, [selectListItems]);
  // useEffect(() => {
  //   changeScrollability();
  // }, []);

  var lowerSearchString = searchString && searchString.toLowerCase();
  var selectListItemsComponents = selectListItems.reduce(function (components, selectListItem) {
    if (searchString) {
      var comparedLabel = selectListItem.label.toLowerCase();

      if (!comparedLabel.includes(lowerSearchString)) {
        return components;
      }
    }

    var item = selectionMap[selectListItem.value];
    components.push( /*#__PURE__*/React__default.createElement(GroupListItem$1, {
      key: selectListItem.value,
      item: selectListItem,
      isSelected: item && item.itemIsSelected,
      isPartiallySelected: item && item.isPartiallySelected,
      selectItem: selectItem,
      deleteItem: deleteItem
    }));
    return components;
  }, []);
  var classNames = ['select__list-container']; // if (isScrollable) {
  //   classNames.push('_scrollable');
  // }

  if (!shouldApplyChanges) {
    classNames.push('_border-rounded');
  }

  return /*#__PURE__*/React__default.createElement("div", {
    className: classNames.join(' ')
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "select__list",
    ref: selectListRef
  }, selectListItemsComponents));
}
GroupsList.propTypes = {
  shouldApplyChanges: PropTypes.bool,
  searchString: PropTypes.string,
  selectListItems: PropTypes.array,
  selectionMap: PropTypes.object,
  deleteItem: PropTypes.func,
  selectItem: PropTypes.func
};
var GroupsList$1 = /*#__PURE__*/React__default.memo(GroupsList);

function WrappedCustomOpener$1(props) {
  var setRef = props.setRef,
      handleClick = props.handleClick,
      opener = props.opener,
      wrapperMainStyles = props.wrapperMainStyles,
      className = props.className;

  var onClick = function onClick(event) {
    event.stopPropagation();
    handleClick();
  };

  if (!wrapperMainStyles.current) {
    useEffect(function () {
      var openingButtonStyle = getComputedStyle(setRef.current);
      wrapperMainStyles.current = {
        width: openingButtonStyle.width,
        height: openingButtonStyle.height,
        left: openingButtonStyle.marginLeft
      };
    }, []);
  }

  return /*#__PURE__*/React__default.createElement("div", {
    className: className,
    ref: setRef,
    onClick: onClick
  }, opener);
}
WrappedCustomOpener$1.propTypes = {
  setRef: PropTypes.object,
  wrapperMainStyles: PropTypes.object,
  handleClick: PropTypes.func,
  opener: PropTypes.element
};

var TOGGLE_SELECT_VISIBILITY$1 = 'TOGGLE_SELECT_VISIBILITY';
var ALLOWS_TO_CREATE_NEW_ITEM$1 = 'ALLOWS_TO_CREATE_NEW_ITEM';
var CHANGE_SEARCH_STRING$1 = 'CHANGE_SEARCH_STRING';
var CHANGE_NEW_ITEM_NAME$1 = 'CHANGE_NEW_ITEM_NAME';
var HANDLE_SELECT_ITEM$1 = 'HANDLE_SELECT_ITEM';
var HANDLE_DELETE_ITEM$1 = 'HANDLE_DELETE_ITEM';
var HANDLE_SELECT_ALL_ITEMS$1 = 'HANDLE_SELECT_ALL_ITEMS';
var HANDLE_DESELECT_ALL_ITEMS$1 = 'HANDLE_DESELECT_ALL_ITEMS';
var ADD_NEW_ITEM$1 = 'ADD_NEW_ITEM';
var ADD_NEW_ITEMS$1 = 'ADD_NEW_ITEMS';
var CREATE_NEW_ITEM$1 = 'CREATE_NEW_ITEM';
var INIT_VALUES$1 = 'INIT_VALUES';

function getIntialState$1(props) {
  var shouldApplyChanges = props.shouldApplyChanges,
      isMulti = props.isMulti,
      items = props.items,
      value = props.value;
  var intialState = {
    selectListIsOpened: false,
    allowsToCreateNewItem: false,
    selectionMap: {},
    defaultDataSnapshot: {},
    defaultPartialSelectionSnapshot: {},
    searchString: '',
    newItemName: '',
    creatingNewItemName: '',
    changesCount: 0,
    shouldApplyChanges: shouldApplyChanges,
    isMulti: isMulti
  };
  var map = value.reduce(function (map, selectedItem) {
    map[selectedItem.value] = selectedItem;
    return map;
  }, {});
  items.forEach(function (item) {
    var selectedItem = map[item.value];

    if (selectedItem) {
      intialState.selectionMap[selectedItem.value] = {
        isPartiallySelected: selectedItem.isPartiallySelected,
        itemIsSelected: !selectedItem.isPartiallySelected,
        item: item
      };
      intialState.defaultPartialSelectionSnapshot[selectedItem.value] = selectedItem.isPartiallySelected;
    }

    intialState.defaultDataSnapshot[item.value] = !!selectedItem;
  });
  return intialState;
}

function ownKeys$i(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$i(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$i(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$i(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function selectItem$1(state, action) {
  var item = action.item,
      itemIsSelected = action.itemIsSelected,
      isNewItem = action.isNewItem;
  var changesCount = state.changesCount;

  if (isNewItem) {
    var test = _objectSpread$i(_objectSpread$i({}, state), {}, {
      defaultDataSnapshot: _objectSpread$i(_objectSpread$i({}, state.defaultDataSnapshot), {}, _defineProperty({}, item.value, false)),
      selectionMap: _objectSpread$i(_objectSpread$i({}, state.selectionMap), {}, _defineProperty({}, item.value, {
        item: item,
        itemIsSelected: itemIsSelected
      })),
      changesCount: changesCount + 1
    });

    return test;
  }

  if (state.shouldApplyChanges) {
    if (state.defaultPartialSelectionSnapshot[item.value]) {
      if (!state.selectionMap[item.value]) {
        changesCount += 1;
      } else {
        changesCount = state.selectionMap[item.value] === itemIsSelected ? state.changesCount - 1 : state.changesCount + 1;
      }
    } else {
      changesCount = state.defaultDataSnapshot[item.value] === itemIsSelected ? state.changesCount - 1 : state.changesCount + 1;
    }
  }

  var selectionMap = _objectSpread$i(_objectSpread$i({}, state.selectionMap), {}, _defineProperty({}, item.value, {
    item: item,
    itemIsSelected: itemIsSelected
  }));

  return _objectSpread$i(_objectSpread$i({}, state), {}, {
    changesCount: changesCount,
    selectionMap: selectionMap
  });
}

var _reducer$1;

function ownKeys$j(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$j(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$j(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$j(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var reducer$1 = (_reducer$1 = {}, _defineProperty(_reducer$1, TOGGLE_SELECT_VISIBILITY$1, function (state, action) {
  return state.shouldApplyChanges && state.selectListIsOpened ? getIntialState$1(action.props) : _objectSpread$j(_objectSpread$j({}, state), {}, {
    searchString: '',
    selectListIsOpened: !state.selectListIsOpened
  });
}), _defineProperty(_reducer$1, ALLOWS_TO_CREATE_NEW_ITEM$1, function (state, action) {
  var allowsToCreateNewItem = !state.allowsToCreateNewItem;

  var updatedState = _objectSpread$j(_objectSpread$j({}, state), {}, {
    allowsToCreateNewItem: allowsToCreateNewItem
  });

  if (!state.allowsToCreateNewItem) {
    updatedState.newItemName = state.searchString;
    updatedState.searchString = '';
  }

  return updatedState;
}), _defineProperty(_reducer$1, CHANGE_SEARCH_STRING$1, function (state, action) {
  return _objectSpread$j(_objectSpread$j({}, state), {}, {
    searchString: action.searchString
  });
}), _defineProperty(_reducer$1, CHANGE_NEW_ITEM_NAME$1, function (state, action) {
  return _objectSpread$j(_objectSpread$j({}, state), {}, {
    newItemName: action.newItemName
  });
}), _defineProperty(_reducer$1, HANDLE_DELETE_ITEM$1, function (state, action) {
  var newState = _objectSpread$j({}, state);

  if (newState.selectionMap[action.item.value]) {
    if (newState.selectionMap[action.item.value].itemIsSelected !== newState.defaultDataSnapshot[action.item.value]) {
      newState.changesCount--;
    }
  }

  if (newState.selectionMap[action.item.value]) {
    newState.selectionMap = _objectSpread$j({}, newState.selectionMap);
    delete newState.selectionMap[action.item.value];
    newState.defaultDataSnapshot = _objectSpread$j({}, newState.defaultDataSnapshot);
    delete newState.defaultDataSnapshot[action.item.value];
  }

  return newState;
}), _defineProperty(_reducer$1, HANDLE_SELECT_ALL_ITEMS$1, function (state, action) {
  var changesCount = 0;
  var selectionMap = action.items.reduce(function (selectionMap, item) {
    if (!state.defaultDataSnapshot[item.value]) {
      changesCount++;
    }

    selectionMap[item.value] = {
      itemIsSelected: true,
      item: item
    };
    return selectionMap;
  }, {});
  return _objectSpread$j(_objectSpread$j({}, state), {}, {
    changesCount: changesCount,
    selectedItemsCount: action.items.length,
    selectionMap: selectionMap
  });
}), _defineProperty(_reducer$1, HANDLE_DESELECT_ALL_ITEMS$1, function (state, action) {
  var changesCount = 0;
  var selectionMap = action.items.reduce(function (selectionMap, item) {
    if (state.defaultDataSnapshot[item.value]) {
      changesCount++;
    }

    selectionMap[item.value] = {
      itemIsSelected: false,
      item: item
    };
    return selectionMap;
  }, {});
  return _objectSpread$j(_objectSpread$j({}, state), {}, {
    changesCount: changesCount,
    selectionMap: selectionMap
  });
}), _defineProperty(_reducer$1, HANDLE_SELECT_ITEM$1, selectItem$1), _defineProperty(_reducer$1, ADD_NEW_ITEMS$1, function (state, action) {
  var defaultDataSnapshot = _objectSpread$j({}, state.defaultDataSnapshot);

  action.items.forEach(function (item) {
    defaultDataSnapshot[item.value] = false;
  });
  return _objectSpread$j(_objectSpread$j({}, state), {}, {
    defaultDataSnapshot: defaultDataSnapshot
  });
}), _defineProperty(_reducer$1, INIT_VALUES$1, function (state, action) {
  var defaultDataSnapshot = _objectSpread$j({}, state.defaultDataSnapshot);

  var defaultPartialSelectionSnapshot = _objectSpread$j({}, state.defaultPartialSelectionSnapshot);

  var selectionMap = _objectSpread$j({}, state.selectionMap);

  action.values.forEach(function (item) {
    if (item.isPartiallySelected) {
      defaultPartialSelectionSnapshot[item.value] = true;
    } else {
      defaultPartialSelectionSnapshot[item.value] = false;
      defaultDataSnapshot[item.value] = true;
    }

    selectionMap[item.value] = {
      isPartiallySelected: item.isPartiallySelected,
      itemIsSelected: !item.isPartiallySelected,
      item: item
    };
  });
  return _objectSpread$j(_objectSpread$j({}, state), {}, {
    defaultDataSnapshot: defaultDataSnapshot,
    defaultPartialSelectionSnapshot: defaultPartialSelectionSnapshot,
    selectionMap: selectionMap
  });
}), _defineProperty(_reducer$1, ADD_NEW_ITEM$1, function (state, action) {
  var isCreatingNewItem = action.item.label === state.creatingNewItemName;
  var selectionMap = isCreatingNewItem ? _objectSpread$j(_objectSpread$j({}, state.selectionMap), {}, _defineProperty({}, action.item.value, {
    itemIsSelected: true,
    item: action.item
  })) : state.selectionMap;
  var changesCount = state.changesCount;

  if (isCreatingNewItem) {
    if (action.isMulti) {
      changesCount++;
    } else {
      changesCount = 1;
    }
  }

  return _objectSpread$j(_objectSpread$j({}, state), {}, {
    selectionMap: selectionMap,
    changesCount: changesCount,
    creatingNewItemName: '',
    defaultDataSnapshot: _objectSpread$j(_objectSpread$j({}, state.defaultDataSnapshot), {}, _defineProperty({}, action.item.value, false))
  });
}), _defineProperty(_reducer$1, CREATE_NEW_ITEM$1, function (state, action) {
  return _objectSpread$j(_objectSpread$j({}, state), {}, {
    allowsToCreateNewItem: false,
    newItemName: '',
    selectionMap: action.isMulti ? state.selectionMap : {}
  });
}), _reducer$1);
var selectWithCreatingBlockReducer$1 = (function (state, action) {
  return reducer$1[action.type] && reducer$1[action.type](state, action);
});

var invertAllowingToCreateNewItem$1 = function invertAllowingToCreateNewItem(allowsToCreateNewItem) {
  return {
    type: ALLOWS_TO_CREATE_NEW_ITEM$1,
    allowsToCreateNewItem: allowsToCreateNewItem
  };
};
var toggleSelectListVisibility$1 = function toggleSelectListVisibility(props) {
  return {
    type: TOGGLE_SELECT_VISIBILITY$1,
    props: props
  };
};
var changeSearchString$1 = function changeSearchString(searchString) {
  return {
    type: CHANGE_SEARCH_STRING$1,
    searchString: searchString
  };
};
var changeNewItemName$1 = function changeNewItemName(newItemName) {
  return {
    type: CHANGE_NEW_ITEM_NAME$1,
    newItemName: newItemName
  };
};
var handleSelectItem$1 = function handleSelectItem(item, itemIsSelected, isNewItem) {
  return {
    type: HANDLE_SELECT_ITEM$1,
    item: item,
    itemIsSelected: itemIsSelected,
    isNewItem: isNewItem
  };
};
var handleSelectAllItems$1 = function handleSelectAllItems(items) {
  return {
    type: HANDLE_SELECT_ALL_ITEMS$1,
    items: items
  };
};
var handleDeselectAllItems$1 = function handleDeselectAllItems(items) {
  return {
    type: HANDLE_DESELECT_ALL_ITEMS$1,
    items: items
  };
};
var handleDeleteItem$1 = function handleDeleteItem(item) {
  return {
    type: HANDLE_DELETE_ITEM$1,
    item: item
  };
};
var addNewItem$1 = function addNewItem(item, isMulti) {
  return {
    type: ADD_NEW_ITEM$1,
    item: item,
    isMulti: isMulti
  };
};
var addNewItems$1 = function addNewItems(items) {
  return {
    type: ADD_NEW_ITEMS$1,
    items: items
  };
};
var createNewItem$1 = function createNewItem(creatingNewItemName, isMulti) {
  return {
    type: CREATE_NEW_ITEM$1,
    creatingNewItemName: creatingNewItemName,
    isMulti: isMulti
  };
};
var initValues$1 = function initValues(values) {
  return {
    type: INIT_VALUES$1,
    values: values
  };
};

function ownKeys$k(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$k(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$k(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$k(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function useState$1(defaultProps, currentProps) {
  var initialState = useMemo(function () {
    return getIntialState$1(currentProps);
  }, []);

  var _useReducer = useReducer(selectWithCreatingBlockReducer$1, initialState),
      _useReducer2 = _slicedToArray(_useReducer, 2),
      state = _useReducer2[0],
      dispatch = _useReducer2[1];

  var doToggleSelectListVisibility = function doToggleSelectListVisibility(props) {
    return dispatch(toggleSelectListVisibility$1(props || defaultProps.current));
  };

  var doInvertAllowingToCreateNewItem = function doInvertAllowingToCreateNewItem() {
    return dispatch(invertAllowingToCreateNewItem$1());
  };

  var doChangeNewItemName = function doChangeNewItemName(newItemName) {
    return dispatch(changeNewItemName$1(newItemName));
  };

  var doChangeSearchString = function doChangeSearchString(searchString) {
    return dispatch(changeSearchString$1(searchString));
  };

  var doAddNewItem = function doAddNewItem(item) {
    return dispatch(addNewItem$1(item));
  };

  var doAddNewItems = function doAddNewItems(items) {
    return dispatch(addNewItems$1(items));
  };

  var doInitValues = function doInitValues(values) {
    return dispatch(initValues$1(values));
  };

  var doHandleSelectAllItems = function doHandleSelectAllItems() {
    if (!state.shouldApplyChanges) {
      currentProps.onSelect(defaultProps.current.items);
    } else {
      dispatch(handleSelectAllItems$1(defaultProps.current.items));
    }
  };

  var doHandleDeselectAllItems = function doHandleDeselectAllItems() {
    if (!currentProps.isMulti || !state.shouldApplyChanges) {
      return currentProps.onSelect([]);
    }

    dispatch(handleDeselectAllItems$1(defaultProps.current.items));
  };

  var doHandleSelectItem = function doHandleSelectItem(item, isSelected, isNewItem) {
    if (!state.shouldApplyChanges) {
      var _defaultProps$current = defaultProps.current,
          value = _defaultProps$current.value,
          items = _defaultProps$current.items;

      if (!isSelected) {
        currentProps.onSelect(value.filter(function (value) {
          return value.value !== item.value;
        }));
      } else {
        var selectedMap = value.reduce(function (items, item) {
          items[item.value] = true;
          return items;
        }, _defineProperty({}, item.value, true));
        currentProps.onSelect(items.filter(function (item) {
          return selectedMap[item.value];
        }));
      }
    } else {
      dispatch(handleSelectItem$1(item, isSelected, isNewItem));

      if (!currentProps.isMulti) {
        currentProps.onSelect([item]);
        doToggleSelectListVisibility();
      }
    }
  };

  var doCreateNewItem = function doCreateNewItem() {
    currentProps.onCreate(state.newItemName);
    dispatch(createNewItem$1(state.newItemName, currentProps.isMulti));

    if (!currentProps.isMulti) {
      doToggleSelectListVisibility();
    }
  };

  var doHandeDeleteItem = function doHandeDeleteItem(item) {
    if (state.shouldApplyChanges) {
      dispatch(handleDeleteItem$1(item));
    } else {
      currentProps.onDelete(item);
    }
  };

  var doApplyChanges = function doApplyChanges() {
    var allSelectedItems = [];
    var result = defaultProps.current.items.reduce(function (result, item) {
      var itemSelection = state.selectionMap[item.value];

      if (itemSelection && !itemSelection.isPartiallySelected) {
        if (itemSelection.itemIsSelected) {
          allSelectedItems.push(itemSelection.item);
        }

        if (itemSelection.itemIsSelected !== state.defaultDataSnapshot[item.value] || state.defaultPartialSelectionSnapshot[item.value]) {
          var detailedItem = _objectSpread$k(_objectSpread$k({}, itemSelection.item), {}, {
            isPartiallySelected: state.defaultPartialSelectionSnapshot[item.value]
          });

          if (itemSelection.itemIsSelected) {
            result.selectedItems.push(detailedItem);
          } else {
            result.deselectedItems.push(detailedItem);
          }
        }
      }

      return result;
    }, {
      selectedItems: [],
      deselectedItems: []
    });
    currentProps.onSelect(allSelectedItems, {
      selectedItems: result.selectedItems,
      deselectedItems: result.deselectedItems
    });
    doToggleSelectListVisibility(_objectSpread$k(_objectSpread$k({}, defaultProps.current), {}, {
      value: allSelectedItems
    }));
  };

  return {
    state: state,
    doToggleSelectListVisibility: doToggleSelectListVisibility,
    doInvertAllowingToCreateNewItem: doInvertAllowingToCreateNewItem,
    doCreateNewItem: doCreateNewItem,
    doChangeNewItemName: doChangeNewItemName,
    doChangeSearchString: doChangeSearchString,
    doAddNewItem: doAddNewItem,
    doAddNewItems: doAddNewItems,
    doHandleSelectAllItems: doHandleSelectAllItems,
    doHandleDeselectAllItems: doHandleDeselectAllItems,
    doHandleSelectItem: doHandleSelectItem,
    doHandeDeleteItem: doHandeDeleteItem,
    doApplyChanges: doApplyChanges,
    doInitValues: doInitValues
  };
}

function useChangedProps$1(props) {
  var items = props.items,
      value = props.value,
      doInitValues = props.doInitValues,
      doHandleSelectItem = props.doHandleSelectItem,
      doAddNewItems = props.doAddNewItems,
      doHandeDeleteItem = props.doHandeDeleteItem;
  var oldItems = useRef(items);
  var oldValue = useRef(value);
  useEffect(function () {
    if (oldValue.current !== value) {
      doInitValues(value);
      oldValue.current = value;
    }

    if (oldItems.current.length !== items.length) {
      if (oldItems.current.length < items.length) {
        if (!oldItems.current.length) {
          doAddNewItems(items);
        } else {
          var oldItemsMap = oldItems.current.reduce(function (t, t2) {
            t[t2.value] = true;
            return t;
          }, {}); // add items diff as new items

          var addNewItems = items.filter(function (i) {
            return !oldItemsMap[i.value];
          });
          addNewItems.forEach(function (item) {
            doHandleSelectItem(item, true, true);
          });
        }
      } else {
        // UPDATE STATE AFTER REMOVING
        var removedItems = difference(oldItems.current, items);
        removedItems.forEach(function (item) {
          doHandeDeleteItem(item);
        });
      }

      oldItems.current = items;
    }
  }, [items, value]);
}

var css_248z$b = "@keyframes hover-ripples {\n  0% {\n    top: -0.1875em;\n    left: -0.1875em;\n    right: -0.1875em;\n    bottom: -0.1875em;\n    opacity: 1; }\n  100% {\n    top: -0.8125em;\n    left: -0.8125em;\n    right: -0.8125em;\n    bottom: -0.8125em;\n    opacity: 0; } }\n\n:root {\n  --primary1: #123787;\n  --primary2: #1d58d7;\n  --primary3: #5173fb;\n  --primary4: #7a93ff;\n  --primary5: #c2d0ff;\n  --primary6: #e5ebff;\n  --primary7: #f2f5ff; }\n\n.select-with-creating {\n  box-sizing: border-box;\n  position: relative;\n  width: 200px; }\n  .select-with-creating * {\n    box-sizing: border-box; }\n  .select-with-creating ._action-buttons {\n    display: flex !important;\n    padding: 15px;\n    justify-content: flex-end;\n    border-top: none !important; }\n  .select-with-creating ._header {\n    padding: 8px 12px 0 !important; }\n  .select-with-creating .select__clear {\n    margin-left: 0; }\n  .select-with-creating .select__list {\n    margin: 0; }\n    .select-with-creating .select__list-wrapper {\n      border-radius: 0; }\n      .select-with-creating .select__list-wrapper .btn-select__button {\n        margin-left: auto;\n        margin-right: auto; }\n    .select-with-creating .select__list-container {\n      background-color: white; }\n      .select-with-creating .select__list-container._border-rounded {\n        border-bottom-left-radius: 5px;\n        border-bottom-right-radius: 5px;\n        overflow: hidden; }\n  .select-with-creating .select__search {\n    padding: 0; }\n  .select-with-creating .select__input {\n    margin-top: 0.375rem; }\n  .select-with-creating .select._opened {\n    min-width: 18.75rem;\n    position: absolute;\n    top: 0;\n    left: 0;\n    z-index: 4; }\n  .select-with-creating .create-group-container__title {\n    text-align: center; }\n  .select-with-creating .create-group-container__text-field {\n    margin: 0 auto 1rem; }\n  .select-with-creating .create-group-container__button {\n    margin-left: auto;\n    margin-right: auto; }\n  .select-with-creating .create-group-container__divider {\n    margin: 0 -1rem 0.75rem;\n    height: 1px;\n    background-color: #ededed; }\n  .select-with-creating ._dirty:after {\n    pointer-events: none;\n    content: '';\n    display: block;\n    position: absolute;\n    width: 0.5rem;\n    height: 0.125rem;\n    top: calc(50% - 1px);\n    left: calc(50% - 0.25rem);\n    background-color: #a2a2a2;\n    border-radius: 2px;\n    transition: background-color 0.25s; }\n";
styleInject(css_248z$b);

var GroupManager = function GroupManager(props) {
  var isMulti = props.isMulti,
      shouldApplyChanges = props.shouldApplyChanges,
      toggleOpeningElement = props.toggleOpeningElement,
      selectedLabel = props.selectedLabel,
      newItemPlaceholder = props.newItemPlaceholder,
      buttonLabel = props.buttonLabel,
      placeholder = props.placeholder,
      className = props.className,
      closedWrapperClassName = props.closedWrapperClassName,
      items = props.items,
      _props$value = props.value,
      value = _props$value === void 0 ? [] : _props$value;
  var wrapperMainStyles = useRef(null);
  var toggleOpeningEl = useRef(null);
  var defaultProps = useRef(props);
  useEffect(function () {
    defaultProps.current = props;
  }, [props]);

  var _useReducer = useState$1(defaultProps, props),
      state = _useReducer.state,
      doToggleSelectListVisibility = _useReducer.doToggleSelectListVisibility,
      doInvertAllowingToCreateNewItem = _useReducer.doInvertAllowingToCreateNewItem,
      doChangeNewItemName = _useReducer.doChangeNewItemName,
      doChangeSearchString = _useReducer.doChangeSearchString,
      doAddNewItem = _useReducer.doAddNewItem,
      doAddNewItems = _useReducer.doAddNewItems,
      doHandleSelectAllItems = _useReducer.doHandleSelectAllItems,
      doHandleDeselectAllItems = _useReducer.doHandleDeselectAllItems,
      doHandleSelectItem = _useReducer.doHandleSelectItem,
      doCreateNewItem = _useReducer.doCreateNewItem,
      doHandeDeleteItem = _useReducer.doHandeDeleteItem,
      doApplyChanges = _useReducer.doApplyChanges,
      doInitValues = _useReducer.doInitValues;

  var clickOutsideHandler = useCallback(function (event) {
    if (!toggleOpeningEl.current.contains(event.target) && !document.body.querySelector('.modal__overlay')) {
      doToggleSelectListVisibility();
    }
  }, []);
  useEffect(function () {
    if (!state.selectListIsOpened) {
      document.removeEventListener('mousedown', clickOutsideHandler);
    } else {
      document.addEventListener('mousedown', clickOutsideHandler);
    }
  }, [state.selectListIsOpened]);

  if (shouldApplyChanges) {
    useChangedProps$1({
      items: items,
      value: value,
      isMulti: isMulti,
      doInitValues: doInitValues,
      doHandleSelectItem: doHandleSelectItem,
      doAddNewItem: doAddNewItem,
      doAddNewItems: doAddNewItems,
      doHandeDeleteItem: doHandeDeleteItem
    });
  }

  if (!state.selectListIsOpened && toggleOpeningElement) {
    return /*#__PURE__*/React__default.createElement(WrappedCustomOpener$1, {
      className: closedWrapperClassName,
      setRef: toggleOpeningEl,
      handleClick: doToggleSelectListVisibility,
      opener: props.toggleOpeningElement,
      wrapperMainStyles: wrapperMainStyles
    });
  }

  var formattedSelectedLabel = selectedLabel;
  var selectedItemsCount = shouldApplyChanges ? Object.keys(state.selectionMap).reduce(function (selectedItemsCount, key) {
    if (state.selectionMap[key].itemIsSelected) {
      selectedItemsCount++;
    }

    return selectedItemsCount;
  }, 0) : value.length;

  if (!formattedSelectedLabel) {
    if (!shouldApplyChanges) {
      formattedSelectedLabel = isMulti ? value.length ? "".concat(value.length, " selected") : '' : get$1(value, '[0].label');
    } else {
      if (selectedItemsCount) {
        formattedSelectedLabel = "".concat(selectedItemsCount, " selected");
      } else {
        formattedSelectedLabel = '';
      }
    }
  }

  var allowsToSelectAll = isMulti && (shouldApplyChanges ? selectedItemsCount !== items.length : value.length !== items.length);
  var selectionMap = shouldApplyChanges ? state.selectionMap : value.reduce(function (items, item) {
    items[item.value] = {
      item: item,
      itemIsSelected: true
    };
    return items;
  }, {});
  return /*#__PURE__*/React__default.createElement(Dropdown$1, {
    style: wrapperMainStyles.current,
    className: className,
    dropdownIsOpened: state.selectListIsOpened,
    toggleDropdownVisilitiy: doToggleSelectListVisibility,
    handleClearSelection: doHandleDeselectAllItems,
    handleSelectAllItems: doHandleSelectAllItems,
    hasSelectedItems: !!selectedItemsCount,
    allowsToSelectAll: state.selectListIsOpened && allowsToSelectAll,
    selectedLabel: formattedSelectedLabel,
    placeholder: placeholder,
    label: props.label,
    toggleOpeningEl: toggleOpeningEl
  }, /*#__PURE__*/React__default.createElement(DropdownHeader$1, {
    allowsToCreateNewItem: state.allowsToCreateNewItem,
    buttonLabel: buttonLabel,
    newItemPlaceholder: newItemPlaceholder,
    newItemName: state.newItemName,
    searchString: state.searchString,
    createNewItem: doCreateNewItem,
    doInvertAllowingToCreateNewItem: doInvertAllowingToCreateNewItem,
    doChangeSearchString: doChangeSearchString,
    doChangeNewItemName: doChangeNewItemName
  }), /*#__PURE__*/React__default.createElement(GroupsList$1, {
    shouldApplyChanges: shouldApplyChanges,
    searchString: state.searchString,
    selectionMap: selectionMap,
    selectListItems: items,
    deleteItem: props.onDelete,
    selectItem: doHandleSelectItem
  }), shouldApplyChanges && /*#__PURE__*/React__default.createElement(ApplyChangesButtons, {
    onApply: doApplyChanges,
    onCancel: doToggleSelectListVisibility,
    applyButtonIsDisabled: !state.changesCount
  }));
};
GroupManager.defaultProps = {
  isMulti: false,
  newItemPlaceholder: ''
};
GroupManager.propTypes = {
  toggleOpeningElement: PropTypes.element,
  items: PropTypes.array,
  value: PropTypes.array,
  selectedLabel: PropTypes.string,
  buttonLabel: PropTypes.string,
  label: PropTypes.string,
  newItemPlaceholder: PropTypes.string,
  placeholder: PropTypes.string,
  isMulti: PropTypes.bool,
  shouldApplyChanges: PropTypes.bool,
  className: PropTypes.string,
  closedWrapperClassName: PropTypes.string,
  // eslint-disable-next-line react/no-unused-prop-types
  onSelect: PropTypes.func,
  // eslint-disable-next-line react/no-unused-prop-types
  onCreate: PropTypes.func,
  onDelete: PropTypes.func
};

/**
 * Expose `arrayFlatten`.
 */
var arrayFlatten = flatten;
var from_1 = flattenFrom;
var depth = flattenDepth;
var fromDepth = flattenFromDepth;

/**
 * Flatten an array.
 *
 * @param  {Array} array
 * @return {Array}
 */
function flatten (array) {
  if (!Array.isArray(array)) {
    throw new TypeError('Expected value to be an array')
  }

  return flattenFrom(array)
}

/**
 * Flatten an array-like structure.
 *
 * @param  {Array} array
 * @return {Array}
 */
function flattenFrom (array) {
  return flattenDown(array, [])
}

/**
 * Flatten an array-like structure with depth.
 *
 * @param  {Array}  array
 * @param  {number} depth
 * @return {Array}
 */
function flattenDepth (array, depth) {
  if (!Array.isArray(array)) {
    throw new TypeError('Expected value to be an array')
  }

  return flattenFromDepth(array, depth)
}

/**
 * Flatten an array-like structure with depth.
 *
 * @param  {Array}  array
 * @param  {number} depth
 * @return {Array}
 */
function flattenFromDepth (array, depth) {
  if (typeof depth !== 'number') {
    throw new TypeError('Expected the depth to be a number')
  }

  return flattenDownDepth(array, [], depth)
}

/**
 * Flatten an array indefinitely.
 *
 * @param  {Array} array
 * @param  {Array} result
 * @return {Array}
 */
function flattenDown (array, result) {
  for (var i = 0; i < array.length; i++) {
    var value = array[i];

    if (Array.isArray(value)) {
      flattenDown(value, result);
    } else {
      result.push(value);
    }
  }

  return result
}

/**
 * Flatten an array with depth.
 *
 * @param  {Array}  array
 * @param  {Array}  result
 * @param  {number} depth
 * @return {Array}
 */
function flattenDownDepth (array, result, depth) {
  depth--;

  for (var i = 0; i < array.length; i++) {
    var value = array[i];

    if (depth > -1 && Array.isArray(value)) {
      flattenDownDepth(value, result, depth);
    } else {
      result.push(value);
    }
  }

  return result
}
arrayFlatten.from = from_1;
arrayFlatten.depth = depth;
arrayFlatten.fromDepth = fromDepth;

var lib = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/* global window self */

var isBrowser = typeof window !== 'undefined' && typeof window.document !== 'undefined';

/* eslint-disable no-restricted-globals */
var isWebWorker = (typeof self === 'undefined' ? 'undefined' : _typeof(self)) === 'object' && self.constructor && self.constructor.name === 'DedicatedWorkerGlobalScope';
/* eslint-enable no-restricted-globals */

var isNode = typeof process !== 'undefined' && process.versions != null && process.versions.node != null;

/**
 * @see https://github.com/jsdom/jsdom/releases/tag/12.0.0
 * @see https://github.com/jsdom/jsdom/issues/1537
 */
/* eslint-disable no-undef */
var isJsDom = function isJsDom() {
  return typeof window !== 'undefined' && window.name === 'nodejs' || navigator.userAgent.includes('Node.js') || navigator.userAgent.includes('jsdom');
};

exports.isBrowser = isBrowser;
exports.isWebWorker = isWebWorker;
exports.isNode = isNode;
exports.isJsDom = isJsDom;
});

unwrapExports(lib);
var lib_1 = lib.isBrowser;
var lib_2 = lib.isWebWorker;
var lib_3 = lib.isNode;
var lib_4 = lib.isJsDom;

var checks = createCommonjsModule(function (module, exports) {
Object.defineProperty(exports, "__esModule", { value: true });
function isNull(something) {
    return typeof something === "undefined" || something === null;
}
exports.isNull = isNull;

});

unwrapExports(checks);
var checks_1 = checks.isNull;

var logs = createCommonjsModule(function (module, exports) {
Object.defineProperty(exports, "__esModule", { value: true });
var yellow = "\x1b[33m";
var red = "\x1b[31m";
var reset = "\x1b[0m";
var introError = yellow + "VAST-LIBRARY " + red + "ERROR" + yellow + ":" + reset;
var introWarning = yellow + "VAST-LIBRARY WARNING:" + reset;
function warnOrThrow(msg, options, isError) {
    if (isError === void 0) { isError = false; }
    if (options.logWarn) {
        if (isError) {
            logError(msg);
        }
        else {
            logWarn(msg);
        }
    }
    if (isError && options.throwOnError) {
        throw new Error(msg);
    }
}
exports.warnOrThrow = warnOrThrow;
// tslint:disable:no-console variable-name
function logError(error) {
    try {
        console.error(introError + " " + error);
    }
    catch (O_o) {
        console.log(introError + " " + error);
    }
}
exports.logError = logError;
function logWarn(warning) {
    try {
        console.warn(introWarning + " " + warning);
    }
    catch (O_o) {
        console.log(introWarning + " " + warning);
    }
}
exports.logWarn = logWarn;

});

unwrapExports(logs);
var logs_1 = logs.warnOrThrow;
var logs_2 = logs.logError;
var logs_3 = logs.logWarn;

var global$1 = (typeof global !== "undefined" ? global :
            typeof self !== "undefined" ? self :
            typeof window !== "undefined" ? window : {});

var lookup = [];
var revLookup = [];
var Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array;
var inited = false;
function init () {
  inited = true;
  var code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
  for (var i = 0, len = code.length; i < len; ++i) {
    lookup[i] = code[i];
    revLookup[code.charCodeAt(i)] = i;
  }

  revLookup['-'.charCodeAt(0)] = 62;
  revLookup['_'.charCodeAt(0)] = 63;
}

function toByteArray (b64) {
  if (!inited) {
    init();
  }
  var i, j, l, tmp, placeHolders, arr;
  var len = b64.length;

  if (len % 4 > 0) {
    throw new Error('Invalid string. Length must be a multiple of 4')
  }

  // the number of equal signs (place holders)
  // if there are two placeholders, than the two characters before it
  // represent one byte
  // if there is only one, then the three characters before it represent 2 bytes
  // this is just a cheap hack to not do indexOf twice
  placeHolders = b64[len - 2] === '=' ? 2 : b64[len - 1] === '=' ? 1 : 0;

  // base64 is 4/3 + up to two characters of the original data
  arr = new Arr(len * 3 / 4 - placeHolders);

  // if there are placeholders, only get up to the last complete 4 chars
  l = placeHolders > 0 ? len - 4 : len;

  var L = 0;

  for (i = 0, j = 0; i < l; i += 4, j += 3) {
    tmp = (revLookup[b64.charCodeAt(i)] << 18) | (revLookup[b64.charCodeAt(i + 1)] << 12) | (revLookup[b64.charCodeAt(i + 2)] << 6) | revLookup[b64.charCodeAt(i + 3)];
    arr[L++] = (tmp >> 16) & 0xFF;
    arr[L++] = (tmp >> 8) & 0xFF;
    arr[L++] = tmp & 0xFF;
  }

  if (placeHolders === 2) {
    tmp = (revLookup[b64.charCodeAt(i)] << 2) | (revLookup[b64.charCodeAt(i + 1)] >> 4);
    arr[L++] = tmp & 0xFF;
  } else if (placeHolders === 1) {
    tmp = (revLookup[b64.charCodeAt(i)] << 10) | (revLookup[b64.charCodeAt(i + 1)] << 4) | (revLookup[b64.charCodeAt(i + 2)] >> 2);
    arr[L++] = (tmp >> 8) & 0xFF;
    arr[L++] = tmp & 0xFF;
  }

  return arr
}

function tripletToBase64 (num) {
  return lookup[num >> 18 & 0x3F] + lookup[num >> 12 & 0x3F] + lookup[num >> 6 & 0x3F] + lookup[num & 0x3F]
}

function encodeChunk (uint8, start, end) {
  var tmp;
  var output = [];
  for (var i = start; i < end; i += 3) {
    tmp = (uint8[i] << 16) + (uint8[i + 1] << 8) + (uint8[i + 2]);
    output.push(tripletToBase64(tmp));
  }
  return output.join('')
}

function fromByteArray (uint8) {
  if (!inited) {
    init();
  }
  var tmp;
  var len = uint8.length;
  var extraBytes = len % 3; // if we have 1 byte left, pad 2 bytes
  var output = '';
  var parts = [];
  var maxChunkLength = 16383; // must be multiple of 3

  // go through the array every three bytes, we'll deal with trailing stuff later
  for (var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength) {
    parts.push(encodeChunk(uint8, i, (i + maxChunkLength) > len2 ? len2 : (i + maxChunkLength)));
  }

  // pad the end with zeros, but make sure to not forget the extra bytes
  if (extraBytes === 1) {
    tmp = uint8[len - 1];
    output += lookup[tmp >> 2];
    output += lookup[(tmp << 4) & 0x3F];
    output += '==';
  } else if (extraBytes === 2) {
    tmp = (uint8[len - 2] << 8) + (uint8[len - 1]);
    output += lookup[tmp >> 10];
    output += lookup[(tmp >> 4) & 0x3F];
    output += lookup[(tmp << 2) & 0x3F];
    output += '=';
  }

  parts.push(output);

  return parts.join('')
}

function read (buffer, offset, isLE, mLen, nBytes) {
  var e, m;
  var eLen = nBytes * 8 - mLen - 1;
  var eMax = (1 << eLen) - 1;
  var eBias = eMax >> 1;
  var nBits = -7;
  var i = isLE ? (nBytes - 1) : 0;
  var d = isLE ? -1 : 1;
  var s = buffer[offset + i];

  i += d;

  e = s & ((1 << (-nBits)) - 1);
  s >>= (-nBits);
  nBits += eLen;
  for (; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8) {}

  m = e & ((1 << (-nBits)) - 1);
  e >>= (-nBits);
  nBits += mLen;
  for (; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8) {}

  if (e === 0) {
    e = 1 - eBias;
  } else if (e === eMax) {
    return m ? NaN : ((s ? -1 : 1) * Infinity)
  } else {
    m = m + Math.pow(2, mLen);
    e = e - eBias;
  }
  return (s ? -1 : 1) * m * Math.pow(2, e - mLen)
}

function write (buffer, value, offset, isLE, mLen, nBytes) {
  var e, m, c;
  var eLen = nBytes * 8 - mLen - 1;
  var eMax = (1 << eLen) - 1;
  var eBias = eMax >> 1;
  var rt = (mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0);
  var i = isLE ? 0 : (nBytes - 1);
  var d = isLE ? 1 : -1;
  var s = value < 0 || (value === 0 && 1 / value < 0) ? 1 : 0;

  value = Math.abs(value);

  if (isNaN(value) || value === Infinity) {
    m = isNaN(value) ? 1 : 0;
    e = eMax;
  } else {
    e = Math.floor(Math.log(value) / Math.LN2);
    if (value * (c = Math.pow(2, -e)) < 1) {
      e--;
      c *= 2;
    }
    if (e + eBias >= 1) {
      value += rt / c;
    } else {
      value += rt * Math.pow(2, 1 - eBias);
    }
    if (value * c >= 2) {
      e++;
      c /= 2;
    }

    if (e + eBias >= eMax) {
      m = 0;
      e = eMax;
    } else if (e + eBias >= 1) {
      m = (value * c - 1) * Math.pow(2, mLen);
      e = e + eBias;
    } else {
      m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
      e = 0;
    }
  }

  for (; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8) {}

  e = (e << mLen) | m;
  eLen += mLen;
  for (; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8) {}

  buffer[offset + i - d] |= s * 128;
}

var toString = {}.toString;

var isArray = Array.isArray || function (arr) {
  return toString.call(arr) == '[object Array]';
};

var INSPECT_MAX_BYTES = 50;

/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Use Object implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * Due to various browser bugs, sometimes the Object implementation will be used even
 * when the browser supports typed arrays.
 *
 * Note:
 *
 *   - Firefox 4-29 lacks support for adding new properties to `Uint8Array` instances,
 *     See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438.
 *
 *   - Chrome 9-10 is missing the `TypedArray.prototype.subarray` function.
 *
 *   - IE10 has a broken `TypedArray.prototype.subarray` function which returns arrays of
 *     incorrect length in some situations.

 * We detect these buggy browsers and set `Buffer.TYPED_ARRAY_SUPPORT` to `false` so they
 * get the Object implementation, which is slower but behaves correctly.
 */
Buffer$1.TYPED_ARRAY_SUPPORT = global$1.TYPED_ARRAY_SUPPORT !== undefined
  ? global$1.TYPED_ARRAY_SUPPORT
  : true;

function kMaxLength () {
  return Buffer$1.TYPED_ARRAY_SUPPORT
    ? 0x7fffffff
    : 0x3fffffff
}

function createBuffer (that, length) {
  if (kMaxLength() < length) {
    throw new RangeError('Invalid typed array length')
  }
  if (Buffer$1.TYPED_ARRAY_SUPPORT) {
    // Return an augmented `Uint8Array` instance, for best performance
    that = new Uint8Array(length);
    that.__proto__ = Buffer$1.prototype;
  } else {
    // Fallback: Return an object instance of the Buffer class
    if (that === null) {
      that = new Buffer$1(length);
    }
    that.length = length;
  }

  return that
}

/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */

function Buffer$1 (arg, encodingOrOffset, length) {
  if (!Buffer$1.TYPED_ARRAY_SUPPORT && !(this instanceof Buffer$1)) {
    return new Buffer$1(arg, encodingOrOffset, length)
  }

  // Common case.
  if (typeof arg === 'number') {
    if (typeof encodingOrOffset === 'string') {
      throw new Error(
        'If encoding is specified then the first argument must be a string'
      )
    }
    return allocUnsafe(this, arg)
  }
  return from(this, arg, encodingOrOffset, length)
}

Buffer$1.poolSize = 8192; // not used by this implementation

// TODO: Legacy, not needed anymore. Remove in next major version.
Buffer$1._augment = function (arr) {
  arr.__proto__ = Buffer$1.prototype;
  return arr
};

function from (that, value, encodingOrOffset, length) {
  if (typeof value === 'number') {
    throw new TypeError('"value" argument must not be a number')
  }

  if (typeof ArrayBuffer !== 'undefined' && value instanceof ArrayBuffer) {
    return fromArrayBuffer(that, value, encodingOrOffset, length)
  }

  if (typeof value === 'string') {
    return fromString(that, value, encodingOrOffset)
  }

  return fromObject(that, value)
}

/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/
Buffer$1.from = function (value, encodingOrOffset, length) {
  return from(null, value, encodingOrOffset, length)
};

if (Buffer$1.TYPED_ARRAY_SUPPORT) {
  Buffer$1.prototype.__proto__ = Uint8Array.prototype;
  Buffer$1.__proto__ = Uint8Array;
}

function assertSize (size) {
  if (typeof size !== 'number') {
    throw new TypeError('"size" argument must be a number')
  } else if (size < 0) {
    throw new RangeError('"size" argument must not be negative')
  }
}

function alloc (that, size, fill, encoding) {
  assertSize(size);
  if (size <= 0) {
    return createBuffer(that, size)
  }
  if (fill !== undefined) {
    // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpretted as a start offset.
    return typeof encoding === 'string'
      ? createBuffer(that, size).fill(fill, encoding)
      : createBuffer(that, size).fill(fill)
  }
  return createBuffer(that, size)
}

/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/
Buffer$1.alloc = function (size, fill, encoding) {
  return alloc(null, size, fill, encoding)
};

function allocUnsafe (that, size) {
  assertSize(size);
  that = createBuffer(that, size < 0 ? 0 : checked(size) | 0);
  if (!Buffer$1.TYPED_ARRAY_SUPPORT) {
    for (var i = 0; i < size; ++i) {
      that[i] = 0;
    }
  }
  return that
}

/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */
Buffer$1.allocUnsafe = function (size) {
  return allocUnsafe(null, size)
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */
Buffer$1.allocUnsafeSlow = function (size) {
  return allocUnsafe(null, size)
};

function fromString (that, string, encoding) {
  if (typeof encoding !== 'string' || encoding === '') {
    encoding = 'utf8';
  }

  if (!Buffer$1.isEncoding(encoding)) {
    throw new TypeError('"encoding" must be a valid string encoding')
  }

  var length = byteLength(string, encoding) | 0;
  that = createBuffer(that, length);

  var actual = that.write(string, encoding);

  if (actual !== length) {
    // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    that = that.slice(0, actual);
  }

  return that
}

function fromArrayLike (that, array) {
  var length = array.length < 0 ? 0 : checked(array.length) | 0;
  that = createBuffer(that, length);
  for (var i = 0; i < length; i += 1) {
    that[i] = array[i] & 255;
  }
  return that
}

function fromArrayBuffer (that, array, byteOffset, length) {
  array.byteLength; // this throws if `array` is not a valid ArrayBuffer

  if (byteOffset < 0 || array.byteLength < byteOffset) {
    throw new RangeError('\'offset\' is out of bounds')
  }

  if (array.byteLength < byteOffset + (length || 0)) {
    throw new RangeError('\'length\' is out of bounds')
  }

  if (byteOffset === undefined && length === undefined) {
    array = new Uint8Array(array);
  } else if (length === undefined) {
    array = new Uint8Array(array, byteOffset);
  } else {
    array = new Uint8Array(array, byteOffset, length);
  }

  if (Buffer$1.TYPED_ARRAY_SUPPORT) {
    // Return an augmented `Uint8Array` instance, for best performance
    that = array;
    that.__proto__ = Buffer$1.prototype;
  } else {
    // Fallback: Return an object instance of the Buffer class
    that = fromArrayLike(that, array);
  }
  return that
}

function fromObject (that, obj) {
  if (internalIsBuffer(obj)) {
    var len = checked(obj.length) | 0;
    that = createBuffer(that, len);

    if (that.length === 0) {
      return that
    }

    obj.copy(that, 0, 0, len);
    return that
  }

  if (obj) {
    if ((typeof ArrayBuffer !== 'undefined' &&
        obj.buffer instanceof ArrayBuffer) || 'length' in obj) {
      if (typeof obj.length !== 'number' || isnan(obj.length)) {
        return createBuffer(that, 0)
      }
      return fromArrayLike(that, obj)
    }

    if (obj.type === 'Buffer' && isArray(obj.data)) {
      return fromArrayLike(that, obj.data)
    }
  }

  throw new TypeError('First argument must be a string, Buffer, ArrayBuffer, Array, or array-like object.')
}

function checked (length) {
  // Note: cannot use `length < kMaxLength()` here because that fails when
  // length is NaN (which is otherwise coerced to zero.)
  if (length >= kMaxLength()) {
    throw new RangeError('Attempt to allocate Buffer larger than maximum ' +
                         'size: 0x' + kMaxLength().toString(16) + ' bytes')
  }
  return length | 0
}
Buffer$1.isBuffer = isBuffer;
function internalIsBuffer (b) {
  return !!(b != null && b._isBuffer)
}

Buffer$1.compare = function compare (a, b) {
  if (!internalIsBuffer(a) || !internalIsBuffer(b)) {
    throw new TypeError('Arguments must be Buffers')
  }

  if (a === b) return 0

  var x = a.length;
  var y = b.length;

  for (var i = 0, len = Math.min(x, y); i < len; ++i) {
    if (a[i] !== b[i]) {
      x = a[i];
      y = b[i];
      break
    }
  }

  if (x < y) return -1
  if (y < x) return 1
  return 0
};

Buffer$1.isEncoding = function isEncoding (encoding) {
  switch (String(encoding).toLowerCase()) {
    case 'hex':
    case 'utf8':
    case 'utf-8':
    case 'ascii':
    case 'latin1':
    case 'binary':
    case 'base64':
    case 'ucs2':
    case 'ucs-2':
    case 'utf16le':
    case 'utf-16le':
      return true
    default:
      return false
  }
};

Buffer$1.concat = function concat (list, length) {
  if (!isArray(list)) {
    throw new TypeError('"list" argument must be an Array of Buffers')
  }

  if (list.length === 0) {
    return Buffer$1.alloc(0)
  }

  var i;
  if (length === undefined) {
    length = 0;
    for (i = 0; i < list.length; ++i) {
      length += list[i].length;
    }
  }

  var buffer = Buffer$1.allocUnsafe(length);
  var pos = 0;
  for (i = 0; i < list.length; ++i) {
    var buf = list[i];
    if (!internalIsBuffer(buf)) {
      throw new TypeError('"list" argument must be an Array of Buffers')
    }
    buf.copy(buffer, pos);
    pos += buf.length;
  }
  return buffer
};

function byteLength (string, encoding) {
  if (internalIsBuffer(string)) {
    return string.length
  }
  if (typeof ArrayBuffer !== 'undefined' && typeof ArrayBuffer.isView === 'function' &&
      (ArrayBuffer.isView(string) || string instanceof ArrayBuffer)) {
    return string.byteLength
  }
  if (typeof string !== 'string') {
    string = '' + string;
  }

  var len = string.length;
  if (len === 0) return 0

  // Use a for loop to avoid recursion
  var loweredCase = false;
  for (;;) {
    switch (encoding) {
      case 'ascii':
      case 'latin1':
      case 'binary':
        return len
      case 'utf8':
      case 'utf-8':
      case undefined:
        return utf8ToBytes(string).length
      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return len * 2
      case 'hex':
        return len >>> 1
      case 'base64':
        return base64ToBytes(string).length
      default:
        if (loweredCase) return utf8ToBytes(string).length // assume utf8
        encoding = ('' + encoding).toLowerCase();
        loweredCase = true;
    }
  }
}
Buffer$1.byteLength = byteLength;

function slowToString (encoding, start, end) {
  var loweredCase = false;

  // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
  // property of a typed array.

  // This behaves neither like String nor Uint8Array in that we set start/end
  // to their upper/lower bounds if the value passed is out of range.
  // undefined is handled specially as per ECMA-262 6th Edition,
  // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
  if (start === undefined || start < 0) {
    start = 0;
  }
  // Return early if start > this.length. Done here to prevent potential uint32
  // coercion fail below.
  if (start > this.length) {
    return ''
  }

  if (end === undefined || end > this.length) {
    end = this.length;
  }

  if (end <= 0) {
    return ''
  }

  // Force coersion to uint32. This will also coerce falsey/NaN values to 0.
  end >>>= 0;
  start >>>= 0;

  if (end <= start) {
    return ''
  }

  if (!encoding) encoding = 'utf8';

  while (true) {
    switch (encoding) {
      case 'hex':
        return hexSlice(this, start, end)

      case 'utf8':
      case 'utf-8':
        return utf8Slice(this, start, end)

      case 'ascii':
        return asciiSlice(this, start, end)

      case 'latin1':
      case 'binary':
        return latin1Slice(this, start, end)

      case 'base64':
        return base64Slice(this, start, end)

      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return utf16leSlice(this, start, end)

      default:
        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
        encoding = (encoding + '').toLowerCase();
        loweredCase = true;
    }
  }
}

// The property is used by `Buffer.isBuffer` and `is-buffer` (in Safari 5-7) to detect
// Buffer instances.
Buffer$1.prototype._isBuffer = true;

function swap (b, n, m) {
  var i = b[n];
  b[n] = b[m];
  b[m] = i;
}

Buffer$1.prototype.swap16 = function swap16 () {
  var len = this.length;
  if (len % 2 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 16-bits')
  }
  for (var i = 0; i < len; i += 2) {
    swap(this, i, i + 1);
  }
  return this
};

Buffer$1.prototype.swap32 = function swap32 () {
  var len = this.length;
  if (len % 4 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 32-bits')
  }
  for (var i = 0; i < len; i += 4) {
    swap(this, i, i + 3);
    swap(this, i + 1, i + 2);
  }
  return this
};

Buffer$1.prototype.swap64 = function swap64 () {
  var len = this.length;
  if (len % 8 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 64-bits')
  }
  for (var i = 0; i < len; i += 8) {
    swap(this, i, i + 7);
    swap(this, i + 1, i + 6);
    swap(this, i + 2, i + 5);
    swap(this, i + 3, i + 4);
  }
  return this
};

Buffer$1.prototype.toString = function toString () {
  var length = this.length | 0;
  if (length === 0) return ''
  if (arguments.length === 0) return utf8Slice(this, 0, length)
  return slowToString.apply(this, arguments)
};

Buffer$1.prototype.equals = function equals (b) {
  if (!internalIsBuffer(b)) throw new TypeError('Argument must be a Buffer')
  if (this === b) return true
  return Buffer$1.compare(this, b) === 0
};

Buffer$1.prototype.inspect = function inspect () {
  var str = '';
  var max = INSPECT_MAX_BYTES;
  if (this.length > 0) {
    str = this.toString('hex', 0, max).match(/.{2}/g).join(' ');
    if (this.length > max) str += ' ... ';
  }
  return '<Buffer ' + str + '>'
};

Buffer$1.prototype.compare = function compare (target, start, end, thisStart, thisEnd) {
  if (!internalIsBuffer(target)) {
    throw new TypeError('Argument must be a Buffer')
  }

  if (start === undefined) {
    start = 0;
  }
  if (end === undefined) {
    end = target ? target.length : 0;
  }
  if (thisStart === undefined) {
    thisStart = 0;
  }
  if (thisEnd === undefined) {
    thisEnd = this.length;
  }

  if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) {
    throw new RangeError('out of range index')
  }

  if (thisStart >= thisEnd && start >= end) {
    return 0
  }
  if (thisStart >= thisEnd) {
    return -1
  }
  if (start >= end) {
    return 1
  }

  start >>>= 0;
  end >>>= 0;
  thisStart >>>= 0;
  thisEnd >>>= 0;

  if (this === target) return 0

  var x = thisEnd - thisStart;
  var y = end - start;
  var len = Math.min(x, y);

  var thisCopy = this.slice(thisStart, thisEnd);
  var targetCopy = target.slice(start, end);

  for (var i = 0; i < len; ++i) {
    if (thisCopy[i] !== targetCopy[i]) {
      x = thisCopy[i];
      y = targetCopy[i];
      break
    }
  }

  if (x < y) return -1
  if (y < x) return 1
  return 0
};

// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function bidirectionalIndexOf (buffer, val, byteOffset, encoding, dir) {
  // Empty buffer means no match
  if (buffer.length === 0) return -1

  // Normalize byteOffset
  if (typeof byteOffset === 'string') {
    encoding = byteOffset;
    byteOffset = 0;
  } else if (byteOffset > 0x7fffffff) {
    byteOffset = 0x7fffffff;
  } else if (byteOffset < -0x80000000) {
    byteOffset = -0x80000000;
  }
  byteOffset = +byteOffset;  // Coerce to Number.
  if (isNaN(byteOffset)) {
    // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : (buffer.length - 1);
  }

  // Normalize byteOffset: negative offsets start from the end of the buffer
  if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
  if (byteOffset >= buffer.length) {
    if (dir) return -1
    else byteOffset = buffer.length - 1;
  } else if (byteOffset < 0) {
    if (dir) byteOffset = 0;
    else return -1
  }

  // Normalize val
  if (typeof val === 'string') {
    val = Buffer$1.from(val, encoding);
  }

  // Finally, search either indexOf (if dir is true) or lastIndexOf
  if (internalIsBuffer(val)) {
    // Special case: looking for empty string/buffer always fails
    if (val.length === 0) {
      return -1
    }
    return arrayIndexOf(buffer, val, byteOffset, encoding, dir)
  } else if (typeof val === 'number') {
    val = val & 0xFF; // Search for a byte value [0-255]
    if (Buffer$1.TYPED_ARRAY_SUPPORT &&
        typeof Uint8Array.prototype.indexOf === 'function') {
      if (dir) {
        return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset)
      } else {
        return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset)
      }
    }
    return arrayIndexOf(buffer, [ val ], byteOffset, encoding, dir)
  }

  throw new TypeError('val must be string, number or Buffer')
}

function arrayIndexOf (arr, val, byteOffset, encoding, dir) {
  var indexSize = 1;
  var arrLength = arr.length;
  var valLength = val.length;

  if (encoding !== undefined) {
    encoding = String(encoding).toLowerCase();
    if (encoding === 'ucs2' || encoding === 'ucs-2' ||
        encoding === 'utf16le' || encoding === 'utf-16le') {
      if (arr.length < 2 || val.length < 2) {
        return -1
      }
      indexSize = 2;
      arrLength /= 2;
      valLength /= 2;
      byteOffset /= 2;
    }
  }

  function read (buf, i) {
    if (indexSize === 1) {
      return buf[i]
    } else {
      return buf.readUInt16BE(i * indexSize)
    }
  }

  var i;
  if (dir) {
    var foundIndex = -1;
    for (i = byteOffset; i < arrLength; i++) {
      if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
        if (foundIndex === -1) foundIndex = i;
        if (i - foundIndex + 1 === valLength) return foundIndex * indexSize
      } else {
        if (foundIndex !== -1) i -= i - foundIndex;
        foundIndex = -1;
      }
    }
  } else {
    if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
    for (i = byteOffset; i >= 0; i--) {
      var found = true;
      for (var j = 0; j < valLength; j++) {
        if (read(arr, i + j) !== read(val, j)) {
          found = false;
          break
        }
      }
      if (found) return i
    }
  }

  return -1
}

Buffer$1.prototype.includes = function includes (val, byteOffset, encoding) {
  return this.indexOf(val, byteOffset, encoding) !== -1
};

Buffer$1.prototype.indexOf = function indexOf (val, byteOffset, encoding) {
  return bidirectionalIndexOf(this, val, byteOffset, encoding, true)
};

Buffer$1.prototype.lastIndexOf = function lastIndexOf (val, byteOffset, encoding) {
  return bidirectionalIndexOf(this, val, byteOffset, encoding, false)
};

function hexWrite (buf, string, offset, length) {
  offset = Number(offset) || 0;
  var remaining = buf.length - offset;
  if (!length) {
    length = remaining;
  } else {
    length = Number(length);
    if (length > remaining) {
      length = remaining;
    }
  }

  // must be an even number of digits
  var strLen = string.length;
  if (strLen % 2 !== 0) throw new TypeError('Invalid hex string')

  if (length > strLen / 2) {
    length = strLen / 2;
  }
  for (var i = 0; i < length; ++i) {
    var parsed = parseInt(string.substr(i * 2, 2), 16);
    if (isNaN(parsed)) return i
    buf[offset + i] = parsed;
  }
  return i
}

function utf8Write (buf, string, offset, length) {
  return blitBuffer(utf8ToBytes(string, buf.length - offset), buf, offset, length)
}

function asciiWrite (buf, string, offset, length) {
  return blitBuffer(asciiToBytes(string), buf, offset, length)
}

function latin1Write (buf, string, offset, length) {
  return asciiWrite(buf, string, offset, length)
}

function base64Write (buf, string, offset, length) {
  return blitBuffer(base64ToBytes(string), buf, offset, length)
}

function ucs2Write (buf, string, offset, length) {
  return blitBuffer(utf16leToBytes(string, buf.length - offset), buf, offset, length)
}

Buffer$1.prototype.write = function write (string, offset, length, encoding) {
  // Buffer#write(string)
  if (offset === undefined) {
    encoding = 'utf8';
    length = this.length;
    offset = 0;
  // Buffer#write(string, encoding)
  } else if (length === undefined && typeof offset === 'string') {
    encoding = offset;
    length = this.length;
    offset = 0;
  // Buffer#write(string, offset[, length][, encoding])
  } else if (isFinite(offset)) {
    offset = offset | 0;
    if (isFinite(length)) {
      length = length | 0;
      if (encoding === undefined) encoding = 'utf8';
    } else {
      encoding = length;
      length = undefined;
    }
  // legacy write(string, encoding, offset, length) - remove in v0.13
  } else {
    throw new Error(
      'Buffer.write(string, encoding, offset[, length]) is no longer supported'
    )
  }

  var remaining = this.length - offset;
  if (length === undefined || length > remaining) length = remaining;

  if ((string.length > 0 && (length < 0 || offset < 0)) || offset > this.length) {
    throw new RangeError('Attempt to write outside buffer bounds')
  }

  if (!encoding) encoding = 'utf8';

  var loweredCase = false;
  for (;;) {
    switch (encoding) {
      case 'hex':
        return hexWrite(this, string, offset, length)

      case 'utf8':
      case 'utf-8':
        return utf8Write(this, string, offset, length)

      case 'ascii':
        return asciiWrite(this, string, offset, length)

      case 'latin1':
      case 'binary':
        return latin1Write(this, string, offset, length)

      case 'base64':
        // Warning: maxLength not taken into account in base64Write
        return base64Write(this, string, offset, length)

      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return ucs2Write(this, string, offset, length)

      default:
        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
        encoding = ('' + encoding).toLowerCase();
        loweredCase = true;
    }
  }
};

Buffer$1.prototype.toJSON = function toJSON () {
  return {
    type: 'Buffer',
    data: Array.prototype.slice.call(this._arr || this, 0)
  }
};

function base64Slice (buf, start, end) {
  if (start === 0 && end === buf.length) {
    return fromByteArray(buf)
  } else {
    return fromByteArray(buf.slice(start, end))
  }
}

function utf8Slice (buf, start, end) {
  end = Math.min(buf.length, end);
  var res = [];

  var i = start;
  while (i < end) {
    var firstByte = buf[i];
    var codePoint = null;
    var bytesPerSequence = (firstByte > 0xEF) ? 4
      : (firstByte > 0xDF) ? 3
      : (firstByte > 0xBF) ? 2
      : 1;

    if (i + bytesPerSequence <= end) {
      var secondByte, thirdByte, fourthByte, tempCodePoint;

      switch (bytesPerSequence) {
        case 1:
          if (firstByte < 0x80) {
            codePoint = firstByte;
          }
          break
        case 2:
          secondByte = buf[i + 1];
          if ((secondByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0x1F) << 0x6 | (secondByte & 0x3F);
            if (tempCodePoint > 0x7F) {
              codePoint = tempCodePoint;
            }
          }
          break
        case 3:
          secondByte = buf[i + 1];
          thirdByte = buf[i + 2];
          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | (thirdByte & 0x3F);
            if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) {
              codePoint = tempCodePoint;
            }
          }
          break
        case 4:
          secondByte = buf[i + 1];
          thirdByte = buf[i + 2];
          fourthByte = buf[i + 3];
          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | (fourthByte & 0x3F);
            if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) {
              codePoint = tempCodePoint;
            }
          }
      }
    }

    if (codePoint === null) {
      // we did not generate a valid codePoint so insert a
      // replacement char (U+FFFD) and advance only 1 byte
      codePoint = 0xFFFD;
      bytesPerSequence = 1;
    } else if (codePoint > 0xFFFF) {
      // encode to utf16 (surrogate pair dance)
      codePoint -= 0x10000;
      res.push(codePoint >>> 10 & 0x3FF | 0xD800);
      codePoint = 0xDC00 | codePoint & 0x3FF;
    }

    res.push(codePoint);
    i += bytesPerSequence;
  }

  return decodeCodePointsArray(res)
}

// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
var MAX_ARGUMENTS_LENGTH = 0x1000;

function decodeCodePointsArray (codePoints) {
  var len = codePoints.length;
  if (len <= MAX_ARGUMENTS_LENGTH) {
    return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
  }

  // Decode in chunks to avoid "call stack size exceeded".
  var res = '';
  var i = 0;
  while (i < len) {
    res += String.fromCharCode.apply(
      String,
      codePoints.slice(i, i += MAX_ARGUMENTS_LENGTH)
    );
  }
  return res
}

function asciiSlice (buf, start, end) {
  var ret = '';
  end = Math.min(buf.length, end);

  for (var i = start; i < end; ++i) {
    ret += String.fromCharCode(buf[i] & 0x7F);
  }
  return ret
}

function latin1Slice (buf, start, end) {
  var ret = '';
  end = Math.min(buf.length, end);

  for (var i = start; i < end; ++i) {
    ret += String.fromCharCode(buf[i]);
  }
  return ret
}

function hexSlice (buf, start, end) {
  var len = buf.length;

  if (!start || start < 0) start = 0;
  if (!end || end < 0 || end > len) end = len;

  var out = '';
  for (var i = start; i < end; ++i) {
    out += toHex(buf[i]);
  }
  return out
}

function utf16leSlice (buf, start, end) {
  var bytes = buf.slice(start, end);
  var res = '';
  for (var i = 0; i < bytes.length; i += 2) {
    res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
  }
  return res
}

Buffer$1.prototype.slice = function slice (start, end) {
  var len = this.length;
  start = ~~start;
  end = end === undefined ? len : ~~end;

  if (start < 0) {
    start += len;
    if (start < 0) start = 0;
  } else if (start > len) {
    start = len;
  }

  if (end < 0) {
    end += len;
    if (end < 0) end = 0;
  } else if (end > len) {
    end = len;
  }

  if (end < start) end = start;

  var newBuf;
  if (Buffer$1.TYPED_ARRAY_SUPPORT) {
    newBuf = this.subarray(start, end);
    newBuf.__proto__ = Buffer$1.prototype;
  } else {
    var sliceLen = end - start;
    newBuf = new Buffer$1(sliceLen, undefined);
    for (var i = 0; i < sliceLen; ++i) {
      newBuf[i] = this[i + start];
    }
  }

  return newBuf
};

/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */
function checkOffset (offset, ext, length) {
  if ((offset % 1) !== 0 || offset < 0) throw new RangeError('offset is not uint')
  if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length')
}

Buffer$1.prototype.readUIntLE = function readUIntLE (offset, byteLength, noAssert) {
  offset = offset | 0;
  byteLength = byteLength | 0;
  if (!noAssert) checkOffset(offset, byteLength, this.length);

  var val = this[offset];
  var mul = 1;
  var i = 0;
  while (++i < byteLength && (mul *= 0x100)) {
    val += this[offset + i] * mul;
  }

  return val
};

Buffer$1.prototype.readUIntBE = function readUIntBE (offset, byteLength, noAssert) {
  offset = offset | 0;
  byteLength = byteLength | 0;
  if (!noAssert) {
    checkOffset(offset, byteLength, this.length);
  }

  var val = this[offset + --byteLength];
  var mul = 1;
  while (byteLength > 0 && (mul *= 0x100)) {
    val += this[offset + --byteLength] * mul;
  }

  return val
};

Buffer$1.prototype.readUInt8 = function readUInt8 (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 1, this.length);
  return this[offset]
};

Buffer$1.prototype.readUInt16LE = function readUInt16LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length);
  return this[offset] | (this[offset + 1] << 8)
};

Buffer$1.prototype.readUInt16BE = function readUInt16BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length);
  return (this[offset] << 8) | this[offset + 1]
};

Buffer$1.prototype.readUInt32LE = function readUInt32LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length);

  return ((this[offset]) |
      (this[offset + 1] << 8) |
      (this[offset + 2] << 16)) +
      (this[offset + 3] * 0x1000000)
};

Buffer$1.prototype.readUInt32BE = function readUInt32BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length);

  return (this[offset] * 0x1000000) +
    ((this[offset + 1] << 16) |
    (this[offset + 2] << 8) |
    this[offset + 3])
};

Buffer$1.prototype.readIntLE = function readIntLE (offset, byteLength, noAssert) {
  offset = offset | 0;
  byteLength = byteLength | 0;
  if (!noAssert) checkOffset(offset, byteLength, this.length);

  var val = this[offset];
  var mul = 1;
  var i = 0;
  while (++i < byteLength && (mul *= 0x100)) {
    val += this[offset + i] * mul;
  }
  mul *= 0x80;

  if (val >= mul) val -= Math.pow(2, 8 * byteLength);

  return val
};

Buffer$1.prototype.readIntBE = function readIntBE (offset, byteLength, noAssert) {
  offset = offset | 0;
  byteLength = byteLength | 0;
  if (!noAssert) checkOffset(offset, byteLength, this.length);

  var i = byteLength;
  var mul = 1;
  var val = this[offset + --i];
  while (i > 0 && (mul *= 0x100)) {
    val += this[offset + --i] * mul;
  }
  mul *= 0x80;

  if (val >= mul) val -= Math.pow(2, 8 * byteLength);

  return val
};

Buffer$1.prototype.readInt8 = function readInt8 (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 1, this.length);
  if (!(this[offset] & 0x80)) return (this[offset])
  return ((0xff - this[offset] + 1) * -1)
};

Buffer$1.prototype.readInt16LE = function readInt16LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length);
  var val = this[offset] | (this[offset + 1] << 8);
  return (val & 0x8000) ? val | 0xFFFF0000 : val
};

Buffer$1.prototype.readInt16BE = function readInt16BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length);
  var val = this[offset + 1] | (this[offset] << 8);
  return (val & 0x8000) ? val | 0xFFFF0000 : val
};

Buffer$1.prototype.readInt32LE = function readInt32LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length);

  return (this[offset]) |
    (this[offset + 1] << 8) |
    (this[offset + 2] << 16) |
    (this[offset + 3] << 24)
};

Buffer$1.prototype.readInt32BE = function readInt32BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length);

  return (this[offset] << 24) |
    (this[offset + 1] << 16) |
    (this[offset + 2] << 8) |
    (this[offset + 3])
};

Buffer$1.prototype.readFloatLE = function readFloatLE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length);
  return read(this, offset, true, 23, 4)
};

Buffer$1.prototype.readFloatBE = function readFloatBE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length);
  return read(this, offset, false, 23, 4)
};

Buffer$1.prototype.readDoubleLE = function readDoubleLE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 8, this.length);
  return read(this, offset, true, 52, 8)
};

Buffer$1.prototype.readDoubleBE = function readDoubleBE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 8, this.length);
  return read(this, offset, false, 52, 8)
};

function checkInt (buf, value, offset, ext, max, min) {
  if (!internalIsBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance')
  if (value > max || value < min) throw new RangeError('"value" argument is out of bounds')
  if (offset + ext > buf.length) throw new RangeError('Index out of range')
}

Buffer$1.prototype.writeUIntLE = function writeUIntLE (value, offset, byteLength, noAssert) {
  value = +value;
  offset = offset | 0;
  byteLength = byteLength | 0;
  if (!noAssert) {
    var maxBytes = Math.pow(2, 8 * byteLength) - 1;
    checkInt(this, value, offset, byteLength, maxBytes, 0);
  }

  var mul = 1;
  var i = 0;
  this[offset] = value & 0xFF;
  while (++i < byteLength && (mul *= 0x100)) {
    this[offset + i] = (value / mul) & 0xFF;
  }

  return offset + byteLength
};

Buffer$1.prototype.writeUIntBE = function writeUIntBE (value, offset, byteLength, noAssert) {
  value = +value;
  offset = offset | 0;
  byteLength = byteLength | 0;
  if (!noAssert) {
    var maxBytes = Math.pow(2, 8 * byteLength) - 1;
    checkInt(this, value, offset, byteLength, maxBytes, 0);
  }

  var i = byteLength - 1;
  var mul = 1;
  this[offset + i] = value & 0xFF;
  while (--i >= 0 && (mul *= 0x100)) {
    this[offset + i] = (value / mul) & 0xFF;
  }

  return offset + byteLength
};

Buffer$1.prototype.writeUInt8 = function writeUInt8 (value, offset, noAssert) {
  value = +value;
  offset = offset | 0;
  if (!noAssert) checkInt(this, value, offset, 1, 0xff, 0);
  if (!Buffer$1.TYPED_ARRAY_SUPPORT) value = Math.floor(value);
  this[offset] = (value & 0xff);
  return offset + 1
};

function objectWriteUInt16 (buf, value, offset, littleEndian) {
  if (value < 0) value = 0xffff + value + 1;
  for (var i = 0, j = Math.min(buf.length - offset, 2); i < j; ++i) {
    buf[offset + i] = (value & (0xff << (8 * (littleEndian ? i : 1 - i)))) >>>
      (littleEndian ? i : 1 - i) * 8;
  }
}

Buffer$1.prototype.writeUInt16LE = function writeUInt16LE (value, offset, noAssert) {
  value = +value;
  offset = offset | 0;
  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0);
  if (Buffer$1.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value & 0xff);
    this[offset + 1] = (value >>> 8);
  } else {
    objectWriteUInt16(this, value, offset, true);
  }
  return offset + 2
};

Buffer$1.prototype.writeUInt16BE = function writeUInt16BE (value, offset, noAssert) {
  value = +value;
  offset = offset | 0;
  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0);
  if (Buffer$1.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 8);
    this[offset + 1] = (value & 0xff);
  } else {
    objectWriteUInt16(this, value, offset, false);
  }
  return offset + 2
};

function objectWriteUInt32 (buf, value, offset, littleEndian) {
  if (value < 0) value = 0xffffffff + value + 1;
  for (var i = 0, j = Math.min(buf.length - offset, 4); i < j; ++i) {
    buf[offset + i] = (value >>> (littleEndian ? i : 3 - i) * 8) & 0xff;
  }
}

Buffer$1.prototype.writeUInt32LE = function writeUInt32LE (value, offset, noAssert) {
  value = +value;
  offset = offset | 0;
  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0);
  if (Buffer$1.TYPED_ARRAY_SUPPORT) {
    this[offset + 3] = (value >>> 24);
    this[offset + 2] = (value >>> 16);
    this[offset + 1] = (value >>> 8);
    this[offset] = (value & 0xff);
  } else {
    objectWriteUInt32(this, value, offset, true);
  }
  return offset + 4
};

Buffer$1.prototype.writeUInt32BE = function writeUInt32BE (value, offset, noAssert) {
  value = +value;
  offset = offset | 0;
  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0);
  if (Buffer$1.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 24);
    this[offset + 1] = (value >>> 16);
    this[offset + 2] = (value >>> 8);
    this[offset + 3] = (value & 0xff);
  } else {
    objectWriteUInt32(this, value, offset, false);
  }
  return offset + 4
};

Buffer$1.prototype.writeIntLE = function writeIntLE (value, offset, byteLength, noAssert) {
  value = +value;
  offset = offset | 0;
  if (!noAssert) {
    var limit = Math.pow(2, 8 * byteLength - 1);

    checkInt(this, value, offset, byteLength, limit - 1, -limit);
  }

  var i = 0;
  var mul = 1;
  var sub = 0;
  this[offset] = value & 0xFF;
  while (++i < byteLength && (mul *= 0x100)) {
    if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) {
      sub = 1;
    }
    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF;
  }

  return offset + byteLength
};

Buffer$1.prototype.writeIntBE = function writeIntBE (value, offset, byteLength, noAssert) {
  value = +value;
  offset = offset | 0;
  if (!noAssert) {
    var limit = Math.pow(2, 8 * byteLength - 1);

    checkInt(this, value, offset, byteLength, limit - 1, -limit);
  }

  var i = byteLength - 1;
  var mul = 1;
  var sub = 0;
  this[offset + i] = value & 0xFF;
  while (--i >= 0 && (mul *= 0x100)) {
    if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) {
      sub = 1;
    }
    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF;
  }

  return offset + byteLength
};

Buffer$1.prototype.writeInt8 = function writeInt8 (value, offset, noAssert) {
  value = +value;
  offset = offset | 0;
  if (!noAssert) checkInt(this, value, offset, 1, 0x7f, -0x80);
  if (!Buffer$1.TYPED_ARRAY_SUPPORT) value = Math.floor(value);
  if (value < 0) value = 0xff + value + 1;
  this[offset] = (value & 0xff);
  return offset + 1
};

Buffer$1.prototype.writeInt16LE = function writeInt16LE (value, offset, noAssert) {
  value = +value;
  offset = offset | 0;
  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000);
  if (Buffer$1.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value & 0xff);
    this[offset + 1] = (value >>> 8);
  } else {
    objectWriteUInt16(this, value, offset, true);
  }
  return offset + 2
};

Buffer$1.prototype.writeInt16BE = function writeInt16BE (value, offset, noAssert) {
  value = +value;
  offset = offset | 0;
  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000);
  if (Buffer$1.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 8);
    this[offset + 1] = (value & 0xff);
  } else {
    objectWriteUInt16(this, value, offset, false);
  }
  return offset + 2
};

Buffer$1.prototype.writeInt32LE = function writeInt32LE (value, offset, noAssert) {
  value = +value;
  offset = offset | 0;
  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000);
  if (Buffer$1.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value & 0xff);
    this[offset + 1] = (value >>> 8);
    this[offset + 2] = (value >>> 16);
    this[offset + 3] = (value >>> 24);
  } else {
    objectWriteUInt32(this, value, offset, true);
  }
  return offset + 4
};

Buffer$1.prototype.writeInt32BE = function writeInt32BE (value, offset, noAssert) {
  value = +value;
  offset = offset | 0;
  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000);
  if (value < 0) value = 0xffffffff + value + 1;
  if (Buffer$1.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 24);
    this[offset + 1] = (value >>> 16);
    this[offset + 2] = (value >>> 8);
    this[offset + 3] = (value & 0xff);
  } else {
    objectWriteUInt32(this, value, offset, false);
  }
  return offset + 4
};

function checkIEEE754 (buf, value, offset, ext, max, min) {
  if (offset + ext > buf.length) throw new RangeError('Index out of range')
  if (offset < 0) throw new RangeError('Index out of range')
}

function writeFloat (buf, value, offset, littleEndian, noAssert) {
  if (!noAssert) {
    checkIEEE754(buf, value, offset, 4);
  }
  write(buf, value, offset, littleEndian, 23, 4);
  return offset + 4
}

Buffer$1.prototype.writeFloatLE = function writeFloatLE (value, offset, noAssert) {
  return writeFloat(this, value, offset, true, noAssert)
};

Buffer$1.prototype.writeFloatBE = function writeFloatBE (value, offset, noAssert) {
  return writeFloat(this, value, offset, false, noAssert)
};

function writeDouble (buf, value, offset, littleEndian, noAssert) {
  if (!noAssert) {
    checkIEEE754(buf, value, offset, 8);
  }
  write(buf, value, offset, littleEndian, 52, 8);
  return offset + 8
}

Buffer$1.prototype.writeDoubleLE = function writeDoubleLE (value, offset, noAssert) {
  return writeDouble(this, value, offset, true, noAssert)
};

Buffer$1.prototype.writeDoubleBE = function writeDoubleBE (value, offset, noAssert) {
  return writeDouble(this, value, offset, false, noAssert)
};

// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
Buffer$1.prototype.copy = function copy (target, targetStart, start, end) {
  if (!start) start = 0;
  if (!end && end !== 0) end = this.length;
  if (targetStart >= target.length) targetStart = target.length;
  if (!targetStart) targetStart = 0;
  if (end > 0 && end < start) end = start;

  // Copy 0 bytes; we're done
  if (end === start) return 0
  if (target.length === 0 || this.length === 0) return 0

  // Fatal error conditions
  if (targetStart < 0) {
    throw new RangeError('targetStart out of bounds')
  }
  if (start < 0 || start >= this.length) throw new RangeError('sourceStart out of bounds')
  if (end < 0) throw new RangeError('sourceEnd out of bounds')

  // Are we oob?
  if (end > this.length) end = this.length;
  if (target.length - targetStart < end - start) {
    end = target.length - targetStart + start;
  }

  var len = end - start;
  var i;

  if (this === target && start < targetStart && targetStart < end) {
    // descending copy from end
    for (i = len - 1; i >= 0; --i) {
      target[i + targetStart] = this[i + start];
    }
  } else if (len < 1000 || !Buffer$1.TYPED_ARRAY_SUPPORT) {
    // ascending copy from start
    for (i = 0; i < len; ++i) {
      target[i + targetStart] = this[i + start];
    }
  } else {
    Uint8Array.prototype.set.call(
      target,
      this.subarray(start, start + len),
      targetStart
    );
  }

  return len
};

// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
Buffer$1.prototype.fill = function fill (val, start, end, encoding) {
  // Handle string cases:
  if (typeof val === 'string') {
    if (typeof start === 'string') {
      encoding = start;
      start = 0;
      end = this.length;
    } else if (typeof end === 'string') {
      encoding = end;
      end = this.length;
    }
    if (val.length === 1) {
      var code = val.charCodeAt(0);
      if (code < 256) {
        val = code;
      }
    }
    if (encoding !== undefined && typeof encoding !== 'string') {
      throw new TypeError('encoding must be a string')
    }
    if (typeof encoding === 'string' && !Buffer$1.isEncoding(encoding)) {
      throw new TypeError('Unknown encoding: ' + encoding)
    }
  } else if (typeof val === 'number') {
    val = val & 255;
  }

  // Invalid ranges are not set to a default, so can range check early.
  if (start < 0 || this.length < start || this.length < end) {
    throw new RangeError('Out of range index')
  }

  if (end <= start) {
    return this
  }

  start = start >>> 0;
  end = end === undefined ? this.length : end >>> 0;

  if (!val) val = 0;

  var i;
  if (typeof val === 'number') {
    for (i = start; i < end; ++i) {
      this[i] = val;
    }
  } else {
    var bytes = internalIsBuffer(val)
      ? val
      : utf8ToBytes(new Buffer$1(val, encoding).toString());
    var len = bytes.length;
    for (i = 0; i < end - start; ++i) {
      this[i + start] = bytes[i % len];
    }
  }

  return this
};

// HELPER FUNCTIONS
// ================

var INVALID_BASE64_RE = /[^+\/0-9A-Za-z-_]/g;

function base64clean (str) {
  // Node strips out invalid characters like \n and \t from the string, base64-js does not
  str = stringtrim(str).replace(INVALID_BASE64_RE, '');
  // Node converts strings with length < 2 to ''
  if (str.length < 2) return ''
  // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
  while (str.length % 4 !== 0) {
    str = str + '=';
  }
  return str
}

function stringtrim (str) {
  if (str.trim) return str.trim()
  return str.replace(/^\s+|\s+$/g, '')
}

function toHex (n) {
  if (n < 16) return '0' + n.toString(16)
  return n.toString(16)
}

function utf8ToBytes (string, units) {
  units = units || Infinity;
  var codePoint;
  var length = string.length;
  var leadSurrogate = null;
  var bytes = [];

  for (var i = 0; i < length; ++i) {
    codePoint = string.charCodeAt(i);

    // is surrogate component
    if (codePoint > 0xD7FF && codePoint < 0xE000) {
      // last char was a lead
      if (!leadSurrogate) {
        // no lead yet
        if (codePoint > 0xDBFF) {
          // unexpected trail
          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
          continue
        } else if (i + 1 === length) {
          // unpaired lead
          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
          continue
        }

        // valid lead
        leadSurrogate = codePoint;

        continue
      }

      // 2 leads in a row
      if (codePoint < 0xDC00) {
        if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        leadSurrogate = codePoint;
        continue
      }

      // valid surrogate pair
      codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
    } else if (leadSurrogate) {
      // valid bmp char, but last char was a lead
      if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
    }

    leadSurrogate = null;

    // encode utf8
    if (codePoint < 0x80) {
      if ((units -= 1) < 0) break
      bytes.push(codePoint);
    } else if (codePoint < 0x800) {
      if ((units -= 2) < 0) break
      bytes.push(
        codePoint >> 0x6 | 0xC0,
        codePoint & 0x3F | 0x80
      );
    } else if (codePoint < 0x10000) {
      if ((units -= 3) < 0) break
      bytes.push(
        codePoint >> 0xC | 0xE0,
        codePoint >> 0x6 & 0x3F | 0x80,
        codePoint & 0x3F | 0x80
      );
    } else if (codePoint < 0x110000) {
      if ((units -= 4) < 0) break
      bytes.push(
        codePoint >> 0x12 | 0xF0,
        codePoint >> 0xC & 0x3F | 0x80,
        codePoint >> 0x6 & 0x3F | 0x80,
        codePoint & 0x3F | 0x80
      );
    } else {
      throw new Error('Invalid code point')
    }
  }

  return bytes
}

function asciiToBytes (str) {
  var byteArray = [];
  for (var i = 0; i < str.length; ++i) {
    // Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
  }
  return byteArray
}

function utf16leToBytes (str, units) {
  var c, hi, lo;
  var byteArray = [];
  for (var i = 0; i < str.length; ++i) {
    if ((units -= 2) < 0) break

    c = str.charCodeAt(i);
    hi = c >> 8;
    lo = c % 256;
    byteArray.push(lo);
    byteArray.push(hi);
  }

  return byteArray
}


function base64ToBytes (str) {
  return toByteArray(base64clean(str))
}

function blitBuffer (src, dst, offset, length) {
  for (var i = 0; i < length; ++i) {
    if ((i + offset >= dst.length) || (i >= src.length)) break
    dst[i + offset] = src[i];
  }
  return i
}

function isnan (val) {
  return val !== val // eslint-disable-line no-self-compare
}


// the following is from is-buffer, also by Feross Aboukhadijeh and with same lisence
// The _isBuffer check is for Safari 5-7 support, because it's missing
// Object.prototype.constructor. Remove this eventually
function isBuffer(obj) {
  return obj != null && (!!obj._isBuffer || isFastBuffer(obj) || isSlowBuffer(obj))
}

function isFastBuffer (obj) {
  return !!obj.constructor && typeof obj.constructor.isBuffer === 'function' && obj.constructor.isBuffer(obj)
}

// For Node v0.10 support. Remove this eventually.
function isSlowBuffer (obj) {
  return typeof obj.readFloatLE === 'function' && typeof obj.slice === 'function' && isFastBuffer(obj.slice(0, 0))
}

var domain;

// This constructor is used to store event handlers. Instantiating this is
// faster than explicitly calling `Object.create(null)` to get a "clean" empty
// object (tested with v8 v4.9).
function EventHandlers() {}
EventHandlers.prototype = Object.create(null);

function EventEmitter() {
  EventEmitter.init.call(this);
}

// nodejs oddity
// require('events') === require('events').EventEmitter
EventEmitter.EventEmitter = EventEmitter;

EventEmitter.usingDomains = false;

EventEmitter.prototype.domain = undefined;
EventEmitter.prototype._events = undefined;
EventEmitter.prototype._maxListeners = undefined;

// By default EventEmitters will print a warning if more than 10 listeners are
// added to it. This is a useful default which helps finding memory leaks.
EventEmitter.defaultMaxListeners = 10;

EventEmitter.init = function() {
  this.domain = null;
  if (EventEmitter.usingDomains) {
    // if there is an active domain, then attach to it.
    if (domain.active ) ;
  }

  if (!this._events || this._events === Object.getPrototypeOf(this)._events) {
    this._events = new EventHandlers();
    this._eventsCount = 0;
  }

  this._maxListeners = this._maxListeners || undefined;
};

// Obviously not all Emitters should be limited to 10. This function allows
// that to be increased. Set to zero for unlimited.
EventEmitter.prototype.setMaxListeners = function setMaxListeners(n) {
  if (typeof n !== 'number' || n < 0 || isNaN(n))
    throw new TypeError('"n" argument must be a positive number');
  this._maxListeners = n;
  return this;
};

function $getMaxListeners(that) {
  if (that._maxListeners === undefined)
    return EventEmitter.defaultMaxListeners;
  return that._maxListeners;
}

EventEmitter.prototype.getMaxListeners = function getMaxListeners() {
  return $getMaxListeners(this);
};

// These standalone emit* functions are used to optimize calling of event
// handlers for fast cases because emit() itself often has a variable number of
// arguments and can be deoptimized because of that. These functions always have
// the same number of arguments and thus do not get deoptimized, so the code
// inside them can execute faster.
function emitNone(handler, isFn, self) {
  if (isFn)
    handler.call(self);
  else {
    var len = handler.length;
    var listeners = arrayClone(handler, len);
    for (var i = 0; i < len; ++i)
      listeners[i].call(self);
  }
}
function emitOne(handler, isFn, self, arg1) {
  if (isFn)
    handler.call(self, arg1);
  else {
    var len = handler.length;
    var listeners = arrayClone(handler, len);
    for (var i = 0; i < len; ++i)
      listeners[i].call(self, arg1);
  }
}
function emitTwo(handler, isFn, self, arg1, arg2) {
  if (isFn)
    handler.call(self, arg1, arg2);
  else {
    var len = handler.length;
    var listeners = arrayClone(handler, len);
    for (var i = 0; i < len; ++i)
      listeners[i].call(self, arg1, arg2);
  }
}
function emitThree(handler, isFn, self, arg1, arg2, arg3) {
  if (isFn)
    handler.call(self, arg1, arg2, arg3);
  else {
    var len = handler.length;
    var listeners = arrayClone(handler, len);
    for (var i = 0; i < len; ++i)
      listeners[i].call(self, arg1, arg2, arg3);
  }
}

function emitMany(handler, isFn, self, args) {
  if (isFn)
    handler.apply(self, args);
  else {
    var len = handler.length;
    var listeners = arrayClone(handler, len);
    for (var i = 0; i < len; ++i)
      listeners[i].apply(self, args);
  }
}

EventEmitter.prototype.emit = function emit(type) {
  var er, handler, len, args, i, events, domain;
  var doError = (type === 'error');

  events = this._events;
  if (events)
    doError = (doError && events.error == null);
  else if (!doError)
    return false;

  domain = this.domain;

  // If there is no 'error' event listener then throw.
  if (doError) {
    er = arguments[1];
    if (domain) {
      if (!er)
        er = new Error('Uncaught, unspecified "error" event');
      er.domainEmitter = this;
      er.domain = domain;
      er.domainThrown = false;
      domain.emit('error', er);
    } else if (er instanceof Error) {
      throw er; // Unhandled 'error' event
    } else {
      // At least give some kind of context to the user
      var err = new Error('Uncaught, unspecified "error" event. (' + er + ')');
      err.context = er;
      throw err;
    }
    return false;
  }

  handler = events[type];

  if (!handler)
    return false;

  var isFn = typeof handler === 'function';
  len = arguments.length;
  switch (len) {
    // fast cases
    case 1:
      emitNone(handler, isFn, this);
      break;
    case 2:
      emitOne(handler, isFn, this, arguments[1]);
      break;
    case 3:
      emitTwo(handler, isFn, this, arguments[1], arguments[2]);
      break;
    case 4:
      emitThree(handler, isFn, this, arguments[1], arguments[2], arguments[3]);
      break;
    // slower
    default:
      args = new Array(len - 1);
      for (i = 1; i < len; i++)
        args[i - 1] = arguments[i];
      emitMany(handler, isFn, this, args);
  }

  return true;
};

function _addListener(target, type, listener, prepend) {
  var m;
  var events;
  var existing;

  if (typeof listener !== 'function')
    throw new TypeError('"listener" argument must be a function');

  events = target._events;
  if (!events) {
    events = target._events = new EventHandlers();
    target._eventsCount = 0;
  } else {
    // To avoid recursion in the case that type === "newListener"! Before
    // adding it to the listeners, first emit "newListener".
    if (events.newListener) {
      target.emit('newListener', type,
                  listener.listener ? listener.listener : listener);

      // Re-assign `events` because a newListener handler could have caused the
      // this._events to be assigned to a new object
      events = target._events;
    }
    existing = events[type];
  }

  if (!existing) {
    // Optimize the case of one listener. Don't need the extra array object.
    existing = events[type] = listener;
    ++target._eventsCount;
  } else {
    if (typeof existing === 'function') {
      // Adding the second element, need to change to array.
      existing = events[type] = prepend ? [listener, existing] :
                                          [existing, listener];
    } else {
      // If we've already got an array, just append.
      if (prepend) {
        existing.unshift(listener);
      } else {
        existing.push(listener);
      }
    }

    // Check for listener leak
    if (!existing.warned) {
      m = $getMaxListeners(target);
      if (m && m > 0 && existing.length > m) {
        existing.warned = true;
        var w = new Error('Possible EventEmitter memory leak detected. ' +
                            existing.length + ' ' + type + ' listeners added. ' +
                            'Use emitter.setMaxListeners() to increase limit');
        w.name = 'MaxListenersExceededWarning';
        w.emitter = target;
        w.type = type;
        w.count = existing.length;
        emitWarning(w);
      }
    }
  }

  return target;
}
function emitWarning(e) {
  typeof console.warn === 'function' ? console.warn(e) : console.log(e);
}
EventEmitter.prototype.addListener = function addListener(type, listener) {
  return _addListener(this, type, listener, false);
};

EventEmitter.prototype.on = EventEmitter.prototype.addListener;

EventEmitter.prototype.prependListener =
    function prependListener(type, listener) {
      return _addListener(this, type, listener, true);
    };

function _onceWrap(target, type, listener) {
  var fired = false;
  function g() {
    target.removeListener(type, g);
    if (!fired) {
      fired = true;
      listener.apply(target, arguments);
    }
  }
  g.listener = listener;
  return g;
}

EventEmitter.prototype.once = function once(type, listener) {
  if (typeof listener !== 'function')
    throw new TypeError('"listener" argument must be a function');
  this.on(type, _onceWrap(this, type, listener));
  return this;
};

EventEmitter.prototype.prependOnceListener =
    function prependOnceListener(type, listener) {
      if (typeof listener !== 'function')
        throw new TypeError('"listener" argument must be a function');
      this.prependListener(type, _onceWrap(this, type, listener));
      return this;
    };

// emits a 'removeListener' event iff the listener was removed
EventEmitter.prototype.removeListener =
    function removeListener(type, listener) {
      var list, events, position, i, originalListener;

      if (typeof listener !== 'function')
        throw new TypeError('"listener" argument must be a function');

      events = this._events;
      if (!events)
        return this;

      list = events[type];
      if (!list)
        return this;

      if (list === listener || (list.listener && list.listener === listener)) {
        if (--this._eventsCount === 0)
          this._events = new EventHandlers();
        else {
          delete events[type];
          if (events.removeListener)
            this.emit('removeListener', type, list.listener || listener);
        }
      } else if (typeof list !== 'function') {
        position = -1;

        for (i = list.length; i-- > 0;) {
          if (list[i] === listener ||
              (list[i].listener && list[i].listener === listener)) {
            originalListener = list[i].listener;
            position = i;
            break;
          }
        }

        if (position < 0)
          return this;

        if (list.length === 1) {
          list[0] = undefined;
          if (--this._eventsCount === 0) {
            this._events = new EventHandlers();
            return this;
          } else {
            delete events[type];
          }
        } else {
          spliceOne(list, position);
        }

        if (events.removeListener)
          this.emit('removeListener', type, originalListener || listener);
      }

      return this;
    };

EventEmitter.prototype.removeAllListeners =
    function removeAllListeners(type) {
      var listeners, events;

      events = this._events;
      if (!events)
        return this;

      // not listening for removeListener, no need to emit
      if (!events.removeListener) {
        if (arguments.length === 0) {
          this._events = new EventHandlers();
          this._eventsCount = 0;
        } else if (events[type]) {
          if (--this._eventsCount === 0)
            this._events = new EventHandlers();
          else
            delete events[type];
        }
        return this;
      }

      // emit removeListener for all listeners on all events
      if (arguments.length === 0) {
        var keys = Object.keys(events);
        for (var i = 0, key; i < keys.length; ++i) {
          key = keys[i];
          if (key === 'removeListener') continue;
          this.removeAllListeners(key);
        }
        this.removeAllListeners('removeListener');
        this._events = new EventHandlers();
        this._eventsCount = 0;
        return this;
      }

      listeners = events[type];

      if (typeof listeners === 'function') {
        this.removeListener(type, listeners);
      } else if (listeners) {
        // LIFO order
        do {
          this.removeListener(type, listeners[listeners.length - 1]);
        } while (listeners[0]);
      }

      return this;
    };

EventEmitter.prototype.listeners = function listeners(type) {
  var evlistener;
  var ret;
  var events = this._events;

  if (!events)
    ret = [];
  else {
    evlistener = events[type];
    if (!evlistener)
      ret = [];
    else if (typeof evlistener === 'function')
      ret = [evlistener.listener || evlistener];
    else
      ret = unwrapListeners(evlistener);
  }

  return ret;
};

EventEmitter.listenerCount = function(emitter, type) {
  if (typeof emitter.listenerCount === 'function') {
    return emitter.listenerCount(type);
  } else {
    return listenerCount.call(emitter, type);
  }
};

EventEmitter.prototype.listenerCount = listenerCount;
function listenerCount(type) {
  var events = this._events;

  if (events) {
    var evlistener = events[type];

    if (typeof evlistener === 'function') {
      return 1;
    } else if (evlistener) {
      return evlistener.length;
    }
  }

  return 0;
}

EventEmitter.prototype.eventNames = function eventNames() {
  return this._eventsCount > 0 ? Reflect.ownKeys(this._events) : [];
};

// About 1.5x faster than the two-arg version of Array#splice().
function spliceOne(list, index) {
  for (var i = index, k = i + 1, n = list.length; k < n; i += 1, k += 1)
    list[i] = list[k];
  list.pop();
}

function arrayClone(arr, i) {
  var copy = new Array(i);
  while (i--)
    copy[i] = arr[i];
  return copy;
}

function unwrapListeners(arr) {
  var ret = new Array(arr.length);
  for (var i = 0; i < ret.length; ++i) {
    ret[i] = arr[i].listener || arr[i];
  }
  return ret;
}

// shim for using process in browser
// based off https://github.com/defunctzombie/node-process/blob/master/browser.js

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
var cachedSetTimeout = defaultSetTimout;
var cachedClearTimeout = defaultClearTimeout;
if (typeof global$1.setTimeout === 'function') {
    cachedSetTimeout = setTimeout;
}
if (typeof global$1.clearTimeout === 'function') {
    cachedClearTimeout = clearTimeout;
}

function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}
function nextTick(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
}
// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};

// from https://github.com/kumavis/browser-process-hrtime/blob/master/index.js
var performance$1 = global$1.performance || {};
var performanceNow =
  performance$1.now        ||
  performance$1.mozNow     ||
  performance$1.msNow      ||
  performance$1.oNow       ||
  performance$1.webkitNow  ||
  function(){ return (new Date()).getTime() };

var inherits$1;
if (typeof Object.create === 'function'){
  inherits$1 = function inherits(ctor, superCtor) {
    // implementation from standard node.js 'util' module
    ctor.super_ = superCtor;
    ctor.prototype = Object.create(superCtor.prototype, {
      constructor: {
        value: ctor,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
  };
} else {
  inherits$1 = function inherits(ctor, superCtor) {
    ctor.super_ = superCtor;
    var TempCtor = function () {};
    TempCtor.prototype = superCtor.prototype;
    ctor.prototype = new TempCtor();
    ctor.prototype.constructor = ctor;
  };
}
var inherits$2 = inherits$1;

var formatRegExp = /%[sdj%]/g;
function format(f) {
  if (!isString(f)) {
    var objects = [];
    for (var i = 0; i < arguments.length; i++) {
      objects.push(inspect(arguments[i]));
    }
    return objects.join(' ');
  }

  var i = 1;
  var args = arguments;
  var len = args.length;
  var str = String(f).replace(formatRegExp, function(x) {
    if (x === '%%') return '%';
    if (i >= len) return x;
    switch (x) {
      case '%s': return String(args[i++]);
      case '%d': return Number(args[i++]);
      case '%j':
        try {
          return JSON.stringify(args[i++]);
        } catch (_) {
          return '[Circular]';
        }
      default:
        return x;
    }
  });
  for (var x = args[i]; i < len; x = args[++i]) {
    if (isNull(x) || !isObject(x)) {
      str += ' ' + x;
    } else {
      str += ' ' + inspect(x);
    }
  }
  return str;
}

// Mark that a method should not be used.
// Returns a modified function which warns once by default.
// If --no-deprecation is set, then it is a no-op.
function deprecate(fn, msg) {
  // Allow for deprecating things in the process of starting up.
  if (isUndefined(global$1.process)) {
    return function() {
      return deprecate(fn, msg).apply(this, arguments);
    };
  }

  var warned = false;
  function deprecated() {
    if (!warned) {
      {
        console.error(msg);
      }
      warned = true;
    }
    return fn.apply(this, arguments);
  }

  return deprecated;
}

var debugs = {};
var debugEnviron;
function debuglog(set) {
  if (isUndefined(debugEnviron))
    debugEnviron =  '';
  set = set.toUpperCase();
  if (!debugs[set]) {
    if (new RegExp('\\b' + set + '\\b', 'i').test(debugEnviron)) {
      var pid = 0;
      debugs[set] = function() {
        var msg = format.apply(null, arguments);
        console.error('%s %d: %s', set, pid, msg);
      };
    } else {
      debugs[set] = function() {};
    }
  }
  return debugs[set];
}

/**
 * Echos the value of a value. Trys to print the value out
 * in the best way possible given the different types.
 *
 * @param {Object} obj The object to print out.
 * @param {Object} opts Optional options object that alters the output.
 */
/* legacy: obj, showHidden, depth, colors*/
function inspect(obj, opts) {
  // default options
  var ctx = {
    seen: [],
    stylize: stylizeNoColor
  };
  // legacy...
  if (arguments.length >= 3) ctx.depth = arguments[2];
  if (arguments.length >= 4) ctx.colors = arguments[3];
  if (isBoolean(opts)) {
    // legacy...
    ctx.showHidden = opts;
  } else if (opts) {
    // got an "options" object
    _extend(ctx, opts);
  }
  // set default options
  if (isUndefined(ctx.showHidden)) ctx.showHidden = false;
  if (isUndefined(ctx.depth)) ctx.depth = 2;
  if (isUndefined(ctx.colors)) ctx.colors = false;
  if (isUndefined(ctx.customInspect)) ctx.customInspect = true;
  if (ctx.colors) ctx.stylize = stylizeWithColor;
  return formatValue(ctx, obj, ctx.depth);
}

// http://en.wikipedia.org/wiki/ANSI_escape_code#graphics
inspect.colors = {
  'bold' : [1, 22],
  'italic' : [3, 23],
  'underline' : [4, 24],
  'inverse' : [7, 27],
  'white' : [37, 39],
  'grey' : [90, 39],
  'black' : [30, 39],
  'blue' : [34, 39],
  'cyan' : [36, 39],
  'green' : [32, 39],
  'magenta' : [35, 39],
  'red' : [31, 39],
  'yellow' : [33, 39]
};

// Don't use 'blue' not visible on cmd.exe
inspect.styles = {
  'special': 'cyan',
  'number': 'yellow',
  'boolean': 'yellow',
  'undefined': 'grey',
  'null': 'bold',
  'string': 'green',
  'date': 'magenta',
  // "name": intentionally not styling
  'regexp': 'red'
};


function stylizeWithColor(str, styleType) {
  var style = inspect.styles[styleType];

  if (style) {
    return '\u001b[' + inspect.colors[style][0] + 'm' + str +
           '\u001b[' + inspect.colors[style][1] + 'm';
  } else {
    return str;
  }
}


function stylizeNoColor(str, styleType) {
  return str;
}


function arrayToHash(array) {
  var hash = {};

  array.forEach(function(val, idx) {
    hash[val] = true;
  });

  return hash;
}


function formatValue(ctx, value, recurseTimes) {
  // Provide a hook for user-specified inspect functions.
  // Check that value is an object with an inspect function on it
  if (ctx.customInspect &&
      value &&
      isFunction(value.inspect) &&
      // Filter out the util module, it's inspect function is special
      value.inspect !== inspect &&
      // Also filter out any prototype objects using the circular check.
      !(value.constructor && value.constructor.prototype === value)) {
    var ret = value.inspect(recurseTimes, ctx);
    if (!isString(ret)) {
      ret = formatValue(ctx, ret, recurseTimes);
    }
    return ret;
  }

  // Primitive types cannot have properties
  var primitive = formatPrimitive(ctx, value);
  if (primitive) {
    return primitive;
  }

  // Look up the keys of the object.
  var keys = Object.keys(value);
  var visibleKeys = arrayToHash(keys);

  if (ctx.showHidden) {
    keys = Object.getOwnPropertyNames(value);
  }

  // IE doesn't make error fields non-enumerable
  // http://msdn.microsoft.com/en-us/library/ie/dww52sbt(v=vs.94).aspx
  if (isError(value)
      && (keys.indexOf('message') >= 0 || keys.indexOf('description') >= 0)) {
    return formatError$1(value);
  }

  // Some type of object without properties can be shortcutted.
  if (keys.length === 0) {
    if (isFunction(value)) {
      var name = value.name ? ': ' + value.name : '';
      return ctx.stylize('[Function' + name + ']', 'special');
    }
    if (isRegExp(value)) {
      return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
    }
    if (isDate(value)) {
      return ctx.stylize(Date.prototype.toString.call(value), 'date');
    }
    if (isError(value)) {
      return formatError$1(value);
    }
  }

  var base = '', array = false, braces = ['{', '}'];

  // Make Array say that they are Array
  if (isArray$1(value)) {
    array = true;
    braces = ['[', ']'];
  }

  // Make functions say that they are functions
  if (isFunction(value)) {
    var n = value.name ? ': ' + value.name : '';
    base = ' [Function' + n + ']';
  }

  // Make RegExps say that they are RegExps
  if (isRegExp(value)) {
    base = ' ' + RegExp.prototype.toString.call(value);
  }

  // Make dates with properties first say the date
  if (isDate(value)) {
    base = ' ' + Date.prototype.toUTCString.call(value);
  }

  // Make error with message first say the error
  if (isError(value)) {
    base = ' ' + formatError$1(value);
  }

  if (keys.length === 0 && (!array || value.length == 0)) {
    return braces[0] + base + braces[1];
  }

  if (recurseTimes < 0) {
    if (isRegExp(value)) {
      return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
    } else {
      return ctx.stylize('[Object]', 'special');
    }
  }

  ctx.seen.push(value);

  var output;
  if (array) {
    output = formatArray(ctx, value, recurseTimes, visibleKeys, keys);
  } else {
    output = keys.map(function(key) {
      return formatProperty(ctx, value, recurseTimes, visibleKeys, key, array);
    });
  }

  ctx.seen.pop();

  return reduceToSingleString(output, base, braces);
}


function formatPrimitive(ctx, value) {
  if (isUndefined(value))
    return ctx.stylize('undefined', 'undefined');
  if (isString(value)) {
    var simple = '\'' + JSON.stringify(value).replace(/^"|"$/g, '')
                                             .replace(/'/g, "\\'")
                                             .replace(/\\"/g, '"') + '\'';
    return ctx.stylize(simple, 'string');
  }
  if (isNumber$1(value))
    return ctx.stylize('' + value, 'number');
  if (isBoolean(value))
    return ctx.stylize('' + value, 'boolean');
  // For some reason typeof null is "object", so special case here.
  if (isNull(value))
    return ctx.stylize('null', 'null');
}


function formatError$1(value) {
  return '[' + Error.prototype.toString.call(value) + ']';
}


function formatArray(ctx, value, recurseTimes, visibleKeys, keys) {
  var output = [];
  for (var i = 0, l = value.length; i < l; ++i) {
    if (hasOwnProperty(value, String(i))) {
      output.push(formatProperty(ctx, value, recurseTimes, visibleKeys,
          String(i), true));
    } else {
      output.push('');
    }
  }
  keys.forEach(function(key) {
    if (!key.match(/^\d+$/)) {
      output.push(formatProperty(ctx, value, recurseTimes, visibleKeys,
          key, true));
    }
  });
  return output;
}


function formatProperty(ctx, value, recurseTimes, visibleKeys, key, array) {
  var name, str, desc;
  desc = Object.getOwnPropertyDescriptor(value, key) || { value: value[key] };
  if (desc.get) {
    if (desc.set) {
      str = ctx.stylize('[Getter/Setter]', 'special');
    } else {
      str = ctx.stylize('[Getter]', 'special');
    }
  } else {
    if (desc.set) {
      str = ctx.stylize('[Setter]', 'special');
    }
  }
  if (!hasOwnProperty(visibleKeys, key)) {
    name = '[' + key + ']';
  }
  if (!str) {
    if (ctx.seen.indexOf(desc.value) < 0) {
      if (isNull(recurseTimes)) {
        str = formatValue(ctx, desc.value, null);
      } else {
        str = formatValue(ctx, desc.value, recurseTimes - 1);
      }
      if (str.indexOf('\n') > -1) {
        if (array) {
          str = str.split('\n').map(function(line) {
            return '  ' + line;
          }).join('\n').substr(2);
        } else {
          str = '\n' + str.split('\n').map(function(line) {
            return '   ' + line;
          }).join('\n');
        }
      }
    } else {
      str = ctx.stylize('[Circular]', 'special');
    }
  }
  if (isUndefined(name)) {
    if (array && key.match(/^\d+$/)) {
      return str;
    }
    name = JSON.stringify('' + key);
    if (name.match(/^"([a-zA-Z_][a-zA-Z_0-9]*)"$/)) {
      name = name.substr(1, name.length - 2);
      name = ctx.stylize(name, 'name');
    } else {
      name = name.replace(/'/g, "\\'")
                 .replace(/\\"/g, '"')
                 .replace(/(^"|"$)/g, "'");
      name = ctx.stylize(name, 'string');
    }
  }

  return name + ': ' + str;
}


function reduceToSingleString(output, base, braces) {
  var length = output.reduce(function(prev, cur) {
    if (cur.indexOf('\n') >= 0) ;
    return prev + cur.replace(/\u001b\[\d\d?m/g, '').length + 1;
  }, 0);

  if (length > 60) {
    return braces[0] +
           (base === '' ? '' : base + '\n ') +
           ' ' +
           output.join(',\n  ') +
           ' ' +
           braces[1];
  }

  return braces[0] + base + ' ' + output.join(', ') + ' ' + braces[1];
}


// NOTE: These type checking functions intentionally don't use `instanceof`
// because it is fragile and can be easily faked with `Object.create()`.
function isArray$1(ar) {
  return Array.isArray(ar);
}

function isBoolean(arg) {
  return typeof arg === 'boolean';
}

function isNull(arg) {
  return arg === null;
}

function isNumber$1(arg) {
  return typeof arg === 'number';
}

function isString(arg) {
  return typeof arg === 'string';
}

function isUndefined(arg) {
  return arg === void 0;
}

function isRegExp(re) {
  return isObject(re) && objectToString(re) === '[object RegExp]';
}

function isObject(arg) {
  return typeof arg === 'object' && arg !== null;
}

function isDate(d) {
  return isObject(d) && objectToString(d) === '[object Date]';
}

function isError(e) {
  return isObject(e) &&
      (objectToString(e) === '[object Error]' || e instanceof Error);
}

function isFunction(arg) {
  return typeof arg === 'function';
}

function objectToString(o) {
  return Object.prototype.toString.call(o);
}

function _extend(origin, add) {
  // Don't do anything if add isn't an object
  if (!add || !isObject(add)) return origin;

  var keys = Object.keys(add);
  var i = keys.length;
  while (i--) {
    origin[keys[i]] = add[keys[i]];
  }
  return origin;
}
function hasOwnProperty(obj, prop) {
  return Object.prototype.hasOwnProperty.call(obj, prop);
}

function BufferList() {
  this.head = null;
  this.tail = null;
  this.length = 0;
}

BufferList.prototype.push = function (v) {
  var entry = { data: v, next: null };
  if (this.length > 0) this.tail.next = entry;else this.head = entry;
  this.tail = entry;
  ++this.length;
};

BufferList.prototype.unshift = function (v) {
  var entry = { data: v, next: this.head };
  if (this.length === 0) this.tail = entry;
  this.head = entry;
  ++this.length;
};

BufferList.prototype.shift = function () {
  if (this.length === 0) return;
  var ret = this.head.data;
  if (this.length === 1) this.head = this.tail = null;else this.head = this.head.next;
  --this.length;
  return ret;
};

BufferList.prototype.clear = function () {
  this.head = this.tail = null;
  this.length = 0;
};

BufferList.prototype.join = function (s) {
  if (this.length === 0) return '';
  var p = this.head;
  var ret = '' + p.data;
  while (p = p.next) {
    ret += s + p.data;
  }return ret;
};

BufferList.prototype.concat = function (n) {
  if (this.length === 0) return Buffer$1.alloc(0);
  if (this.length === 1) return this.head.data;
  var ret = Buffer$1.allocUnsafe(n >>> 0);
  var p = this.head;
  var i = 0;
  while (p) {
    p.data.copy(ret, i);
    i += p.data.length;
    p = p.next;
  }
  return ret;
};

// Copyright Joyent, Inc. and other Node contributors.
var isBufferEncoding = Buffer$1.isEncoding
  || function(encoding) {
       switch (encoding && encoding.toLowerCase()) {
         case 'hex': case 'utf8': case 'utf-8': case 'ascii': case 'binary': case 'base64': case 'ucs2': case 'ucs-2': case 'utf16le': case 'utf-16le': case 'raw': return true;
         default: return false;
       }
     };


function assertEncoding(encoding) {
  if (encoding && !isBufferEncoding(encoding)) {
    throw new Error('Unknown encoding: ' + encoding);
  }
}

// StringDecoder provides an interface for efficiently splitting a series of
// buffers into a series of JS strings without breaking apart multi-byte
// characters. CESU-8 is handled as part of the UTF-8 encoding.
//
// @TODO Handling all encodings inside a single object makes it very difficult
// to reason about this code, so it should be split up in the future.
// @TODO There should be a utf8-strict encoding that rejects invalid UTF-8 code
// points as used by CESU-8.
function StringDecoder(encoding) {
  this.encoding = (encoding || 'utf8').toLowerCase().replace(/[-_]/, '');
  assertEncoding(encoding);
  switch (this.encoding) {
    case 'utf8':
      // CESU-8 represents each of Surrogate Pair by 3-bytes
      this.surrogateSize = 3;
      break;
    case 'ucs2':
    case 'utf16le':
      // UTF-16 represents each of Surrogate Pair by 2-bytes
      this.surrogateSize = 2;
      this.detectIncompleteChar = utf16DetectIncompleteChar;
      break;
    case 'base64':
      // Base-64 stores 3 bytes in 4 chars, and pads the remainder.
      this.surrogateSize = 3;
      this.detectIncompleteChar = base64DetectIncompleteChar;
      break;
    default:
      this.write = passThroughWrite;
      return;
  }

  // Enough space to store all bytes of a single character. UTF-8 needs 4
  // bytes, but CESU-8 may require up to 6 (3 bytes per surrogate).
  this.charBuffer = new Buffer$1(6);
  // Number of bytes received for the current incomplete multi-byte character.
  this.charReceived = 0;
  // Number of bytes expected for the current incomplete multi-byte character.
  this.charLength = 0;
}

// write decodes the given buffer and returns it as JS string that is
// guaranteed to not contain any partial multi-byte characters. Any partial
// character found at the end of the buffer is buffered up, and will be
// returned when calling write again with the remaining bytes.
//
// Note: Converting a Buffer containing an orphan surrogate to a String
// currently works, but converting a String to a Buffer (via `new Buffer`, or
// Buffer#write) will replace incomplete surrogates with the unicode
// replacement character. See https://codereview.chromium.org/121173009/ .
StringDecoder.prototype.write = function(buffer) {
  var charStr = '';
  // if our last write ended with an incomplete multibyte character
  while (this.charLength) {
    // determine how many remaining bytes this buffer has to offer for this char
    var available = (buffer.length >= this.charLength - this.charReceived) ?
        this.charLength - this.charReceived :
        buffer.length;

    // add the new bytes to the char buffer
    buffer.copy(this.charBuffer, this.charReceived, 0, available);
    this.charReceived += available;

    if (this.charReceived < this.charLength) {
      // still not enough chars in this buffer? wait for more ...
      return '';
    }

    // remove bytes belonging to the current character from the buffer
    buffer = buffer.slice(available, buffer.length);

    // get the character that was split
    charStr = this.charBuffer.slice(0, this.charLength).toString(this.encoding);

    // CESU-8: lead surrogate (D800-DBFF) is also the incomplete character
    var charCode = charStr.charCodeAt(charStr.length - 1);
    if (charCode >= 0xD800 && charCode <= 0xDBFF) {
      this.charLength += this.surrogateSize;
      charStr = '';
      continue;
    }
    this.charReceived = this.charLength = 0;

    // if there are no more bytes in this buffer, just emit our char
    if (buffer.length === 0) {
      return charStr;
    }
    break;
  }

  // determine and set charLength / charReceived
  this.detectIncompleteChar(buffer);

  var end = buffer.length;
  if (this.charLength) {
    // buffer the incomplete character bytes we got
    buffer.copy(this.charBuffer, 0, buffer.length - this.charReceived, end);
    end -= this.charReceived;
  }

  charStr += buffer.toString(this.encoding, 0, end);

  var end = charStr.length - 1;
  var charCode = charStr.charCodeAt(end);
  // CESU-8: lead surrogate (D800-DBFF) is also the incomplete character
  if (charCode >= 0xD800 && charCode <= 0xDBFF) {
    var size = this.surrogateSize;
    this.charLength += size;
    this.charReceived += size;
    this.charBuffer.copy(this.charBuffer, size, 0, size);
    buffer.copy(this.charBuffer, 0, 0, size);
    return charStr.substring(0, end);
  }

  // or just emit the charStr
  return charStr;
};

// detectIncompleteChar determines if there is an incomplete UTF-8 character at
// the end of the given buffer. If so, it sets this.charLength to the byte
// length that character, and sets this.charReceived to the number of bytes
// that are available for this character.
StringDecoder.prototype.detectIncompleteChar = function(buffer) {
  // determine how many bytes we have to check at the end of this buffer
  var i = (buffer.length >= 3) ? 3 : buffer.length;

  // Figure out if one of the last i bytes of our buffer announces an
  // incomplete char.
  for (; i > 0; i--) {
    var c = buffer[buffer.length - i];

    // See http://en.wikipedia.org/wiki/UTF-8#Description

    // 110XXXXX
    if (i == 1 && c >> 5 == 0x06) {
      this.charLength = 2;
      break;
    }

    // 1110XXXX
    if (i <= 2 && c >> 4 == 0x0E) {
      this.charLength = 3;
      break;
    }

    // 11110XXX
    if (i <= 3 && c >> 3 == 0x1E) {
      this.charLength = 4;
      break;
    }
  }
  this.charReceived = i;
};

StringDecoder.prototype.end = function(buffer) {
  var res = '';
  if (buffer && buffer.length)
    res = this.write(buffer);

  if (this.charReceived) {
    var cr = this.charReceived;
    var buf = this.charBuffer;
    var enc = this.encoding;
    res += buf.slice(0, cr).toString(enc);
  }

  return res;
};

function passThroughWrite(buffer) {
  return buffer.toString(this.encoding);
}

function utf16DetectIncompleteChar(buffer) {
  this.charReceived = buffer.length % 2;
  this.charLength = this.charReceived ? 2 : 0;
}

function base64DetectIncompleteChar(buffer) {
  this.charReceived = buffer.length % 3;
  this.charLength = this.charReceived ? 3 : 0;
}

var stringDecoder = /*#__PURE__*/Object.freeze({
	__proto__: null,
	StringDecoder: StringDecoder
});

Readable.ReadableState = ReadableState;

var debug = debuglog('stream');
inherits$2(Readable, EventEmitter);

function prependListener(emitter, event, fn) {
  // Sadly this is not cacheable as some libraries bundle their own
  // event emitter implementation with them.
  if (typeof emitter.prependListener === 'function') {
    return emitter.prependListener(event, fn);
  } else {
    // This is a hack to make sure that our error handler is attached before any
    // userland ones.  NEVER DO THIS. This is here only because this code needs
    // to continue to work with older versions of Node.js that do not include
    // the prependListener() method. The goal is to eventually remove this hack.
    if (!emitter._events || !emitter._events[event])
      emitter.on(event, fn);
    else if (Array.isArray(emitter._events[event]))
      emitter._events[event].unshift(fn);
    else
      emitter._events[event] = [fn, emitter._events[event]];
  }
}
function listenerCount$1 (emitter, type) {
  return emitter.listeners(type).length;
}
function ReadableState(options, stream) {

  options = options || {};

  // object stream flag. Used to make read(n) ignore n and to
  // make all the buffer merging and length checks go away
  this.objectMode = !!options.objectMode;

  if (stream instanceof Duplex) this.objectMode = this.objectMode || !!options.readableObjectMode;

  // the point at which it stops calling _read() to fill the buffer
  // Note: 0 is a valid value, means "don't call _read preemptively ever"
  var hwm = options.highWaterMark;
  var defaultHwm = this.objectMode ? 16 : 16 * 1024;
  this.highWaterMark = hwm || hwm === 0 ? hwm : defaultHwm;

  // cast to ints.
  this.highWaterMark = ~ ~this.highWaterMark;

  // A linked list is used to store data chunks instead of an array because the
  // linked list can remove elements from the beginning faster than
  // array.shift()
  this.buffer = new BufferList();
  this.length = 0;
  this.pipes = null;
  this.pipesCount = 0;
  this.flowing = null;
  this.ended = false;
  this.endEmitted = false;
  this.reading = false;

  // a flag to be able to tell if the onwrite cb is called immediately,
  // or on a later tick.  We set this to true at first, because any
  // actions that shouldn't happen until "later" should generally also
  // not happen before the first write call.
  this.sync = true;

  // whenever we return null, then we set a flag to say
  // that we're awaiting a 'readable' event emission.
  this.needReadable = false;
  this.emittedReadable = false;
  this.readableListening = false;
  this.resumeScheduled = false;

  // Crypto is kind of old and crusty.  Historically, its default string
  // encoding is 'binary' so we have to make this configurable.
  // Everything else in the universe uses 'utf8', though.
  this.defaultEncoding = options.defaultEncoding || 'utf8';

  // when piping, we only care about 'readable' events that happen
  // after read()ing all the bytes and not getting any pushback.
  this.ranOut = false;

  // the number of writers that are awaiting a drain event in .pipe()s
  this.awaitDrain = 0;

  // if true, a maybeReadMore has been scheduled
  this.readingMore = false;

  this.decoder = null;
  this.encoding = null;
  if (options.encoding) {
    this.decoder = new StringDecoder(options.encoding);
    this.encoding = options.encoding;
  }
}
function Readable(options) {

  if (!(this instanceof Readable)) return new Readable(options);

  this._readableState = new ReadableState(options, this);

  // legacy
  this.readable = true;

  if (options && typeof options.read === 'function') this._read = options.read;

  EventEmitter.call(this);
}

// Manually shove something into the read() buffer.
// This returns true if the highWaterMark has not been hit yet,
// similar to how Writable.write() returns true if you should
// write() some more.
Readable.prototype.push = function (chunk, encoding) {
  var state = this._readableState;

  if (!state.objectMode && typeof chunk === 'string') {
    encoding = encoding || state.defaultEncoding;
    if (encoding !== state.encoding) {
      chunk = Buffer$1.from(chunk, encoding);
      encoding = '';
    }
  }

  return readableAddChunk(this, state, chunk, encoding, false);
};

// Unshift should *always* be something directly out of read()
Readable.prototype.unshift = function (chunk) {
  var state = this._readableState;
  return readableAddChunk(this, state, chunk, '', true);
};

Readable.prototype.isPaused = function () {
  return this._readableState.flowing === false;
};

function readableAddChunk(stream, state, chunk, encoding, addToFront) {
  var er = chunkInvalid(state, chunk);
  if (er) {
    stream.emit('error', er);
  } else if (chunk === null) {
    state.reading = false;
    onEofChunk(stream, state);
  } else if (state.objectMode || chunk && chunk.length > 0) {
    if (state.ended && !addToFront) {
      var e = new Error('stream.push() after EOF');
      stream.emit('error', e);
    } else if (state.endEmitted && addToFront) {
      var _e = new Error('stream.unshift() after end event');
      stream.emit('error', _e);
    } else {
      var skipAdd;
      if (state.decoder && !addToFront && !encoding) {
        chunk = state.decoder.write(chunk);
        skipAdd = !state.objectMode && chunk.length === 0;
      }

      if (!addToFront) state.reading = false;

      // Don't add to the buffer if we've decoded to an empty string chunk and
      // we're not in object mode
      if (!skipAdd) {
        // if we want the data now, just emit it.
        if (state.flowing && state.length === 0 && !state.sync) {
          stream.emit('data', chunk);
          stream.read(0);
        } else {
          // update the buffer info.
          state.length += state.objectMode ? 1 : chunk.length;
          if (addToFront) state.buffer.unshift(chunk);else state.buffer.push(chunk);

          if (state.needReadable) emitReadable(stream);
        }
      }

      maybeReadMore(stream, state);
    }
  } else if (!addToFront) {
    state.reading = false;
  }

  return needMoreData(state);
}

// if it's past the high water mark, we can push in some more.
// Also, if we have no data yet, we can stand some
// more bytes.  This is to work around cases where hwm=0,
// such as the repl.  Also, if the push() triggered a
// readable event, and the user called read(largeNumber) such that
// needReadable was set, then we ought to push more, so that another
// 'readable' event will be triggered.
function needMoreData(state) {
  return !state.ended && (state.needReadable || state.length < state.highWaterMark || state.length === 0);
}

// backwards compatibility.
Readable.prototype.setEncoding = function (enc) {
  this._readableState.decoder = new StringDecoder(enc);
  this._readableState.encoding = enc;
  return this;
};

// Don't raise the hwm > 8MB
var MAX_HWM = 0x800000;
function computeNewHighWaterMark(n) {
  if (n >= MAX_HWM) {
    n = MAX_HWM;
  } else {
    // Get the next highest power of 2 to prevent increasing hwm excessively in
    // tiny amounts
    n--;
    n |= n >>> 1;
    n |= n >>> 2;
    n |= n >>> 4;
    n |= n >>> 8;
    n |= n >>> 16;
    n++;
  }
  return n;
}

// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function howMuchToRead(n, state) {
  if (n <= 0 || state.length === 0 && state.ended) return 0;
  if (state.objectMode) return 1;
  if (n !== n) {
    // Only flow one buffer at a time
    if (state.flowing && state.length) return state.buffer.head.data.length;else return state.length;
  }
  // If we're asking for more than the current hwm, then raise the hwm.
  if (n > state.highWaterMark) state.highWaterMark = computeNewHighWaterMark(n);
  if (n <= state.length) return n;
  // Don't have enough
  if (!state.ended) {
    state.needReadable = true;
    return 0;
  }
  return state.length;
}

// you can override either this method, or the async _read(n) below.
Readable.prototype.read = function (n) {
  debug('read', n);
  n = parseInt(n, 10);
  var state = this._readableState;
  var nOrig = n;

  if (n !== 0) state.emittedReadable = false;

  // if we're doing read(0) to trigger a readable event, but we
  // already have a bunch of data in the buffer, then just trigger
  // the 'readable' event and move on.
  if (n === 0 && state.needReadable && (state.length >= state.highWaterMark || state.ended)) {
    debug('read: emitReadable', state.length, state.ended);
    if (state.length === 0 && state.ended) endReadable(this);else emitReadable(this);
    return null;
  }

  n = howMuchToRead(n, state);

  // if we've ended, and we're now clear, then finish it up.
  if (n === 0 && state.ended) {
    if (state.length === 0) endReadable(this);
    return null;
  }

  // All the actual chunk generation logic needs to be
  // *below* the call to _read.  The reason is that in certain
  // synthetic stream cases, such as passthrough streams, _read
  // may be a completely synchronous operation which may change
  // the state of the read buffer, providing enough data when
  // before there was *not* enough.
  //
  // So, the steps are:
  // 1. Figure out what the state of things will be after we do
  // a read from the buffer.
  //
  // 2. If that resulting state will trigger a _read, then call _read.
  // Note that this may be asynchronous, or synchronous.  Yes, it is
  // deeply ugly to write APIs this way, but that still doesn't mean
  // that the Readable class should behave improperly, as streams are
  // designed to be sync/async agnostic.
  // Take note if the _read call is sync or async (ie, if the read call
  // has returned yet), so that we know whether or not it's safe to emit
  // 'readable' etc.
  //
  // 3. Actually pull the requested chunks out of the buffer and return.

  // if we need a readable event, then we need to do some reading.
  var doRead = state.needReadable;
  debug('need readable', doRead);

  // if we currently have less than the highWaterMark, then also read some
  if (state.length === 0 || state.length - n < state.highWaterMark) {
    doRead = true;
    debug('length less than watermark', doRead);
  }

  // however, if we've ended, then there's no point, and if we're already
  // reading, then it's unnecessary.
  if (state.ended || state.reading) {
    doRead = false;
    debug('reading or ended', doRead);
  } else if (doRead) {
    debug('do read');
    state.reading = true;
    state.sync = true;
    // if the length is currently zero, then we *need* a readable event.
    if (state.length === 0) state.needReadable = true;
    // call internal read method
    this._read(state.highWaterMark);
    state.sync = false;
    // If _read pushed data synchronously, then `reading` will be false,
    // and we need to re-evaluate how much data we can return to the user.
    if (!state.reading) n = howMuchToRead(nOrig, state);
  }

  var ret;
  if (n > 0) ret = fromList(n, state);else ret = null;

  if (ret === null) {
    state.needReadable = true;
    n = 0;
  } else {
    state.length -= n;
  }

  if (state.length === 0) {
    // If we have nothing in the buffer, then we want to know
    // as soon as we *do* get something into the buffer.
    if (!state.ended) state.needReadable = true;

    // If we tried to read() past the EOF, then emit end on the next tick.
    if (nOrig !== n && state.ended) endReadable(this);
  }

  if (ret !== null) this.emit('data', ret);

  return ret;
};

function chunkInvalid(state, chunk) {
  var er = null;
  if (!isBuffer(chunk) && typeof chunk !== 'string' && chunk !== null && chunk !== undefined && !state.objectMode) {
    er = new TypeError('Invalid non-string/buffer chunk');
  }
  return er;
}

function onEofChunk(stream, state) {
  if (state.ended) return;
  if (state.decoder) {
    var chunk = state.decoder.end();
    if (chunk && chunk.length) {
      state.buffer.push(chunk);
      state.length += state.objectMode ? 1 : chunk.length;
    }
  }
  state.ended = true;

  // emit 'readable' now to make sure it gets picked up.
  emitReadable(stream);
}

// Don't emit readable right away in sync mode, because this can trigger
// another read() call => stack overflow.  This way, it might trigger
// a nextTick recursion warning, but that's not so bad.
function emitReadable(stream) {
  var state = stream._readableState;
  state.needReadable = false;
  if (!state.emittedReadable) {
    debug('emitReadable', state.flowing);
    state.emittedReadable = true;
    if (state.sync) nextTick(emitReadable_, stream);else emitReadable_(stream);
  }
}

function emitReadable_(stream) {
  debug('emit readable');
  stream.emit('readable');
  flow(stream);
}

// at this point, the user has presumably seen the 'readable' event,
// and called read() to consume some data.  that may have triggered
// in turn another _read(n) call, in which case reading = true if
// it's in progress.
// However, if we're not ended, or reading, and the length < hwm,
// then go ahead and try to read some more preemptively.
function maybeReadMore(stream, state) {
  if (!state.readingMore) {
    state.readingMore = true;
    nextTick(maybeReadMore_, stream, state);
  }
}

function maybeReadMore_(stream, state) {
  var len = state.length;
  while (!state.reading && !state.flowing && !state.ended && state.length < state.highWaterMark) {
    debug('maybeReadMore read 0');
    stream.read(0);
    if (len === state.length)
      // didn't get any data, stop spinning.
      break;else len = state.length;
  }
  state.readingMore = false;
}

// abstract method.  to be overridden in specific implementation classes.
// call cb(er, data) where data is <= n in length.
// for virtual (non-string, non-buffer) streams, "length" is somewhat
// arbitrary, and perhaps not very meaningful.
Readable.prototype._read = function (n) {
  this.emit('error', new Error('not implemented'));
};

Readable.prototype.pipe = function (dest, pipeOpts) {
  var src = this;
  var state = this._readableState;

  switch (state.pipesCount) {
    case 0:
      state.pipes = dest;
      break;
    case 1:
      state.pipes = [state.pipes, dest];
      break;
    default:
      state.pipes.push(dest);
      break;
  }
  state.pipesCount += 1;
  debug('pipe count=%d opts=%j', state.pipesCount, pipeOpts);

  var doEnd = (!pipeOpts || pipeOpts.end !== false);

  var endFn = doEnd ? onend : cleanup;
  if (state.endEmitted) nextTick(endFn);else src.once('end', endFn);

  dest.on('unpipe', onunpipe);
  function onunpipe(readable) {
    debug('onunpipe');
    if (readable === src) {
      cleanup();
    }
  }

  function onend() {
    debug('onend');
    dest.end();
  }

  // when the dest drains, it reduces the awaitDrain counter
  // on the source.  This would be more elegant with a .once()
  // handler in flow(), but adding and removing repeatedly is
  // too slow.
  var ondrain = pipeOnDrain(src);
  dest.on('drain', ondrain);

  var cleanedUp = false;
  function cleanup() {
    debug('cleanup');
    // cleanup event handlers once the pipe is broken
    dest.removeListener('close', onclose);
    dest.removeListener('finish', onfinish);
    dest.removeListener('drain', ondrain);
    dest.removeListener('error', onerror);
    dest.removeListener('unpipe', onunpipe);
    src.removeListener('end', onend);
    src.removeListener('end', cleanup);
    src.removeListener('data', ondata);

    cleanedUp = true;

    // if the reader is waiting for a drain event from this
    // specific writer, then it would cause it to never start
    // flowing again.
    // So, if this is awaiting a drain, then we just call it now.
    // If we don't know, then assume that we are waiting for one.
    if (state.awaitDrain && (!dest._writableState || dest._writableState.needDrain)) ondrain();
  }

  // If the user pushes more data while we're writing to dest then we'll end up
  // in ondata again. However, we only want to increase awaitDrain once because
  // dest will only emit one 'drain' event for the multiple writes.
  // => Introduce a guard on increasing awaitDrain.
  var increasedAwaitDrain = false;
  src.on('data', ondata);
  function ondata(chunk) {
    debug('ondata');
    increasedAwaitDrain = false;
    var ret = dest.write(chunk);
    if (false === ret && !increasedAwaitDrain) {
      // If the user unpiped during `dest.write()`, it is possible
      // to get stuck in a permanently paused state if that write
      // also returned false.
      // => Check whether `dest` is still a piping destination.
      if ((state.pipesCount === 1 && state.pipes === dest || state.pipesCount > 1 && indexOf(state.pipes, dest) !== -1) && !cleanedUp) {
        debug('false write response, pause', src._readableState.awaitDrain);
        src._readableState.awaitDrain++;
        increasedAwaitDrain = true;
      }
      src.pause();
    }
  }

  // if the dest has an error, then stop piping into it.
  // however, don't suppress the throwing behavior for this.
  function onerror(er) {
    debug('onerror', er);
    unpipe();
    dest.removeListener('error', onerror);
    if (listenerCount$1(dest, 'error') === 0) dest.emit('error', er);
  }

  // Make sure our error handler is attached before userland ones.
  prependListener(dest, 'error', onerror);

  // Both close and finish should trigger unpipe, but only once.
  function onclose() {
    dest.removeListener('finish', onfinish);
    unpipe();
  }
  dest.once('close', onclose);
  function onfinish() {
    debug('onfinish');
    dest.removeListener('close', onclose);
    unpipe();
  }
  dest.once('finish', onfinish);

  function unpipe() {
    debug('unpipe');
    src.unpipe(dest);
  }

  // tell the dest that it's being piped to
  dest.emit('pipe', src);

  // start the flow if it hasn't been started already.
  if (!state.flowing) {
    debug('pipe resume');
    src.resume();
  }

  return dest;
};

function pipeOnDrain(src) {
  return function () {
    var state = src._readableState;
    debug('pipeOnDrain', state.awaitDrain);
    if (state.awaitDrain) state.awaitDrain--;
    if (state.awaitDrain === 0 && src.listeners('data').length) {
      state.flowing = true;
      flow(src);
    }
  };
}

Readable.prototype.unpipe = function (dest) {
  var state = this._readableState;

  // if we're not piping anywhere, then do nothing.
  if (state.pipesCount === 0) return this;

  // just one destination.  most common case.
  if (state.pipesCount === 1) {
    // passed in one, but it's not the right one.
    if (dest && dest !== state.pipes) return this;

    if (!dest) dest = state.pipes;

    // got a match.
    state.pipes = null;
    state.pipesCount = 0;
    state.flowing = false;
    if (dest) dest.emit('unpipe', this);
    return this;
  }

  // slow case. multiple pipe destinations.

  if (!dest) {
    // remove all.
    var dests = state.pipes;
    var len = state.pipesCount;
    state.pipes = null;
    state.pipesCount = 0;
    state.flowing = false;

    for (var _i = 0; _i < len; _i++) {
      dests[_i].emit('unpipe', this);
    }return this;
  }

  // try to find the right one.
  var i = indexOf(state.pipes, dest);
  if (i === -1) return this;

  state.pipes.splice(i, 1);
  state.pipesCount -= 1;
  if (state.pipesCount === 1) state.pipes = state.pipes[0];

  dest.emit('unpipe', this);

  return this;
};

// set up data events if they are asked for
// Ensure readable listeners eventually get something
Readable.prototype.on = function (ev, fn) {
  var res = EventEmitter.prototype.on.call(this, ev, fn);

  if (ev === 'data') {
    // Start flowing on next tick if stream isn't explicitly paused
    if (this._readableState.flowing !== false) this.resume();
  } else if (ev === 'readable') {
    var state = this._readableState;
    if (!state.endEmitted && !state.readableListening) {
      state.readableListening = state.needReadable = true;
      state.emittedReadable = false;
      if (!state.reading) {
        nextTick(nReadingNextTick, this);
      } else if (state.length) {
        emitReadable(this);
      }
    }
  }

  return res;
};
Readable.prototype.addListener = Readable.prototype.on;

function nReadingNextTick(self) {
  debug('readable nexttick read 0');
  self.read(0);
}

// pause() and resume() are remnants of the legacy readable stream API
// If the user uses them, then switch into old mode.
Readable.prototype.resume = function () {
  var state = this._readableState;
  if (!state.flowing) {
    debug('resume');
    state.flowing = true;
    resume(this, state);
  }
  return this;
};

function resume(stream, state) {
  if (!state.resumeScheduled) {
    state.resumeScheduled = true;
    nextTick(resume_, stream, state);
  }
}

function resume_(stream, state) {
  if (!state.reading) {
    debug('resume read 0');
    stream.read(0);
  }

  state.resumeScheduled = false;
  state.awaitDrain = 0;
  stream.emit('resume');
  flow(stream);
  if (state.flowing && !state.reading) stream.read(0);
}

Readable.prototype.pause = function () {
  debug('call pause flowing=%j', this._readableState.flowing);
  if (false !== this._readableState.flowing) {
    debug('pause');
    this._readableState.flowing = false;
    this.emit('pause');
  }
  return this;
};

function flow(stream) {
  var state = stream._readableState;
  debug('flow', state.flowing);
  while (state.flowing && stream.read() !== null) {}
}

// wrap an old-style stream as the async data source.
// This is *not* part of the readable stream interface.
// It is an ugly unfortunate mess of history.
Readable.prototype.wrap = function (stream) {
  var state = this._readableState;
  var paused = false;

  var self = this;
  stream.on('end', function () {
    debug('wrapped end');
    if (state.decoder && !state.ended) {
      var chunk = state.decoder.end();
      if (chunk && chunk.length) self.push(chunk);
    }

    self.push(null);
  });

  stream.on('data', function (chunk) {
    debug('wrapped data');
    if (state.decoder) chunk = state.decoder.write(chunk);

    // don't skip over falsy values in objectMode
    if (state.objectMode && (chunk === null || chunk === undefined)) return;else if (!state.objectMode && (!chunk || !chunk.length)) return;

    var ret = self.push(chunk);
    if (!ret) {
      paused = true;
      stream.pause();
    }
  });

  // proxy all the other methods.
  // important when wrapping filters and duplexes.
  for (var i in stream) {
    if (this[i] === undefined && typeof stream[i] === 'function') {
      this[i] = function (method) {
        return function () {
          return stream[method].apply(stream, arguments);
        };
      }(i);
    }
  }

  // proxy certain important events.
  var events = ['error', 'close', 'destroy', 'pause', 'resume'];
  forEach$1(events, function (ev) {
    stream.on(ev, self.emit.bind(self, ev));
  });

  // when we try to consume some more bytes, simply unpause the
  // underlying stream.
  self._read = function (n) {
    debug('wrapped _read', n);
    if (paused) {
      paused = false;
      stream.resume();
    }
  };

  return self;
};

// exposed for testing purposes only.
Readable._fromList = fromList;

// Pluck off n bytes from an array of buffers.
// Length is the combined lengths of all the buffers in the list.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function fromList(n, state) {
  // nothing buffered
  if (state.length === 0) return null;

  var ret;
  if (state.objectMode) ret = state.buffer.shift();else if (!n || n >= state.length) {
    // read it all, truncate the list
    if (state.decoder) ret = state.buffer.join('');else if (state.buffer.length === 1) ret = state.buffer.head.data;else ret = state.buffer.concat(state.length);
    state.buffer.clear();
  } else {
    // read part of list
    ret = fromListPartial(n, state.buffer, state.decoder);
  }

  return ret;
}

// Extracts only enough buffered data to satisfy the amount requested.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function fromListPartial(n, list, hasStrings) {
  var ret;
  if (n < list.head.data.length) {
    // slice is the same for buffers and strings
    ret = list.head.data.slice(0, n);
    list.head.data = list.head.data.slice(n);
  } else if (n === list.head.data.length) {
    // first chunk is a perfect match
    ret = list.shift();
  } else {
    // result spans more than one buffer
    ret = hasStrings ? copyFromBufferString(n, list) : copyFromBuffer(n, list);
  }
  return ret;
}

// Copies a specified amount of characters from the list of buffered data
// chunks.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function copyFromBufferString(n, list) {
  var p = list.head;
  var c = 1;
  var ret = p.data;
  n -= ret.length;
  while (p = p.next) {
    var str = p.data;
    var nb = n > str.length ? str.length : n;
    if (nb === str.length) ret += str;else ret += str.slice(0, n);
    n -= nb;
    if (n === 0) {
      if (nb === str.length) {
        ++c;
        if (p.next) list.head = p.next;else list.head = list.tail = null;
      } else {
        list.head = p;
        p.data = str.slice(nb);
      }
      break;
    }
    ++c;
  }
  list.length -= c;
  return ret;
}

// Copies a specified amount of bytes from the list of buffered data chunks.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function copyFromBuffer(n, list) {
  var ret = Buffer$1.allocUnsafe(n);
  var p = list.head;
  var c = 1;
  p.data.copy(ret);
  n -= p.data.length;
  while (p = p.next) {
    var buf = p.data;
    var nb = n > buf.length ? buf.length : n;
    buf.copy(ret, ret.length - n, 0, nb);
    n -= nb;
    if (n === 0) {
      if (nb === buf.length) {
        ++c;
        if (p.next) list.head = p.next;else list.head = list.tail = null;
      } else {
        list.head = p;
        p.data = buf.slice(nb);
      }
      break;
    }
    ++c;
  }
  list.length -= c;
  return ret;
}

function endReadable(stream) {
  var state = stream._readableState;

  // If we get here before consuming all the bytes, then that is a
  // bug in node.  Should never happen.
  if (state.length > 0) throw new Error('"endReadable()" called on non-empty stream');

  if (!state.endEmitted) {
    state.ended = true;
    nextTick(endReadableNT, state, stream);
  }
}

function endReadableNT(state, stream) {
  // Check that we didn't get one last unshift.
  if (!state.endEmitted && state.length === 0) {
    state.endEmitted = true;
    stream.readable = false;
    stream.emit('end');
  }
}

function forEach$1(xs, f) {
  for (var i = 0, l = xs.length; i < l; i++) {
    f(xs[i], i);
  }
}

function indexOf(xs, x) {
  for (var i = 0, l = xs.length; i < l; i++) {
    if (xs[i] === x) return i;
  }
  return -1;
}

// A bit simpler than readable streams.
Writable.WritableState = WritableState;
inherits$2(Writable, EventEmitter);

function nop() {}

function WriteReq(chunk, encoding, cb) {
  this.chunk = chunk;
  this.encoding = encoding;
  this.callback = cb;
  this.next = null;
}

function WritableState(options, stream) {
  Object.defineProperty(this, 'buffer', {
    get: deprecate(function () {
      return this.getBuffer();
    }, '_writableState.buffer is deprecated. Use _writableState.getBuffer ' + 'instead.')
  });
  options = options || {};

  // object stream flag to indicate whether or not this stream
  // contains buffers or objects.
  this.objectMode = !!options.objectMode;

  if (stream instanceof Duplex) this.objectMode = this.objectMode || !!options.writableObjectMode;

  // the point at which write() starts returning false
  // Note: 0 is a valid value, means that we always return false if
  // the entire buffer is not flushed immediately on write()
  var hwm = options.highWaterMark;
  var defaultHwm = this.objectMode ? 16 : 16 * 1024;
  this.highWaterMark = hwm || hwm === 0 ? hwm : defaultHwm;

  // cast to ints.
  this.highWaterMark = ~ ~this.highWaterMark;

  this.needDrain = false;
  // at the start of calling end()
  this.ending = false;
  // when end() has been called, and returned
  this.ended = false;
  // when 'finish' is emitted
  this.finished = false;

  // should we decode strings into buffers before passing to _write?
  // this is here so that some node-core streams can optimize string
  // handling at a lower level.
  var noDecode = options.decodeStrings === false;
  this.decodeStrings = !noDecode;

  // Crypto is kind of old and crusty.  Historically, its default string
  // encoding is 'binary' so we have to make this configurable.
  // Everything else in the universe uses 'utf8', though.
  this.defaultEncoding = options.defaultEncoding || 'utf8';

  // not an actual buffer we keep track of, but a measurement
  // of how much we're waiting to get pushed to some underlying
  // socket or file.
  this.length = 0;

  // a flag to see when we're in the middle of a write.
  this.writing = false;

  // when true all writes will be buffered until .uncork() call
  this.corked = 0;

  // a flag to be able to tell if the onwrite cb is called immediately,
  // or on a later tick.  We set this to true at first, because any
  // actions that shouldn't happen until "later" should generally also
  // not happen before the first write call.
  this.sync = true;

  // a flag to know if we're processing previously buffered items, which
  // may call the _write() callback in the same tick, so that we don't
  // end up in an overlapped onwrite situation.
  this.bufferProcessing = false;

  // the callback that's passed to _write(chunk,cb)
  this.onwrite = function (er) {
    onwrite(stream, er);
  };

  // the callback that the user supplies to write(chunk,encoding,cb)
  this.writecb = null;

  // the amount that is being written when _write is called.
  this.writelen = 0;

  this.bufferedRequest = null;
  this.lastBufferedRequest = null;

  // number of pending user-supplied write callbacks
  // this must be 0 before 'finish' can be emitted
  this.pendingcb = 0;

  // emit prefinish if the only thing we're waiting for is _write cbs
  // This is relevant for synchronous Transform streams
  this.prefinished = false;

  // True if the error was already emitted and should not be thrown again
  this.errorEmitted = false;

  // count buffered requests
  this.bufferedRequestCount = 0;

  // allocate the first CorkedRequest, there is always
  // one allocated and free to use, and we maintain at most two
  this.corkedRequestsFree = new CorkedRequest(this);
}

WritableState.prototype.getBuffer = function writableStateGetBuffer() {
  var current = this.bufferedRequest;
  var out = [];
  while (current) {
    out.push(current);
    current = current.next;
  }
  return out;
};
function Writable(options) {

  // Writable ctor is applied to Duplexes, though they're not
  // instanceof Writable, they're instanceof Readable.
  if (!(this instanceof Writable) && !(this instanceof Duplex)) return new Writable(options);

  this._writableState = new WritableState(options, this);

  // legacy.
  this.writable = true;

  if (options) {
    if (typeof options.write === 'function') this._write = options.write;

    if (typeof options.writev === 'function') this._writev = options.writev;
  }

  EventEmitter.call(this);
}

// Otherwise people can pipe Writable streams, which is just wrong.
Writable.prototype.pipe = function () {
  this.emit('error', new Error('Cannot pipe, not readable'));
};

function writeAfterEnd(stream, cb) {
  var er = new Error('write after end');
  // TODO: defer error events consistently everywhere, not just the cb
  stream.emit('error', er);
  nextTick(cb, er);
}

// If we get something that is not a buffer, string, null, or undefined,
// and we're not in objectMode, then that's an error.
// Otherwise stream chunks are all considered to be of length=1, and the
// watermarks determine how many objects to keep in the buffer, rather than
// how many bytes or characters.
function validChunk(stream, state, chunk, cb) {
  var valid = true;
  var er = false;
  // Always throw error if a null is written
  // if we are not in object mode then throw
  // if it is not a buffer, string, or undefined.
  if (chunk === null) {
    er = new TypeError('May not write null values to stream');
  } else if (!Buffer$1.isBuffer(chunk) && typeof chunk !== 'string' && chunk !== undefined && !state.objectMode) {
    er = new TypeError('Invalid non-string/buffer chunk');
  }
  if (er) {
    stream.emit('error', er);
    nextTick(cb, er);
    valid = false;
  }
  return valid;
}

Writable.prototype.write = function (chunk, encoding, cb) {
  var state = this._writableState;
  var ret = false;

  if (typeof encoding === 'function') {
    cb = encoding;
    encoding = null;
  }

  if (Buffer$1.isBuffer(chunk)) encoding = 'buffer';else if (!encoding) encoding = state.defaultEncoding;

  if (typeof cb !== 'function') cb = nop;

  if (state.ended) writeAfterEnd(this, cb);else if (validChunk(this, state, chunk, cb)) {
    state.pendingcb++;
    ret = writeOrBuffer(this, state, chunk, encoding, cb);
  }

  return ret;
};

Writable.prototype.cork = function () {
  var state = this._writableState;

  state.corked++;
};

Writable.prototype.uncork = function () {
  var state = this._writableState;

  if (state.corked) {
    state.corked--;

    if (!state.writing && !state.corked && !state.finished && !state.bufferProcessing && state.bufferedRequest) clearBuffer(this, state);
  }
};

Writable.prototype.setDefaultEncoding = function setDefaultEncoding(encoding) {
  // node::ParseEncoding() requires lower case.
  if (typeof encoding === 'string') encoding = encoding.toLowerCase();
  if (!(['hex', 'utf8', 'utf-8', 'ascii', 'binary', 'base64', 'ucs2', 'ucs-2', 'utf16le', 'utf-16le', 'raw'].indexOf((encoding + '').toLowerCase()) > -1)) throw new TypeError('Unknown encoding: ' + encoding);
  this._writableState.defaultEncoding = encoding;
  return this;
};

function decodeChunk(state, chunk, encoding) {
  if (!state.objectMode && state.decodeStrings !== false && typeof chunk === 'string') {
    chunk = Buffer$1.from(chunk, encoding);
  }
  return chunk;
}

// if we're already writing something, then just put this
// in the queue, and wait our turn.  Otherwise, call _write
// If we return false, then we need a drain event, so set that flag.
function writeOrBuffer(stream, state, chunk, encoding, cb) {
  chunk = decodeChunk(state, chunk, encoding);

  if (Buffer$1.isBuffer(chunk)) encoding = 'buffer';
  var len = state.objectMode ? 1 : chunk.length;

  state.length += len;

  var ret = state.length < state.highWaterMark;
  // we must ensure that previous needDrain will not be reset to false.
  if (!ret) state.needDrain = true;

  if (state.writing || state.corked) {
    var last = state.lastBufferedRequest;
    state.lastBufferedRequest = new WriteReq(chunk, encoding, cb);
    if (last) {
      last.next = state.lastBufferedRequest;
    } else {
      state.bufferedRequest = state.lastBufferedRequest;
    }
    state.bufferedRequestCount += 1;
  } else {
    doWrite(stream, state, false, len, chunk, encoding, cb);
  }

  return ret;
}

function doWrite(stream, state, writev, len, chunk, encoding, cb) {
  state.writelen = len;
  state.writecb = cb;
  state.writing = true;
  state.sync = true;
  if (writev) stream._writev(chunk, state.onwrite);else stream._write(chunk, encoding, state.onwrite);
  state.sync = false;
}

function onwriteError(stream, state, sync, er, cb) {
  --state.pendingcb;
  if (sync) nextTick(cb, er);else cb(er);

  stream._writableState.errorEmitted = true;
  stream.emit('error', er);
}

function onwriteStateUpdate(state) {
  state.writing = false;
  state.writecb = null;
  state.length -= state.writelen;
  state.writelen = 0;
}

function onwrite(stream, er) {
  var state = stream._writableState;
  var sync = state.sync;
  var cb = state.writecb;

  onwriteStateUpdate(state);

  if (er) onwriteError(stream, state, sync, er, cb);else {
    // Check if we're actually ready to finish, but don't emit yet
    var finished = needFinish(state);

    if (!finished && !state.corked && !state.bufferProcessing && state.bufferedRequest) {
      clearBuffer(stream, state);
    }

    if (sync) {
      /*<replacement>*/
        nextTick(afterWrite, stream, state, finished, cb);
      /*</replacement>*/
    } else {
        afterWrite(stream, state, finished, cb);
      }
  }
}

function afterWrite(stream, state, finished, cb) {
  if (!finished) onwriteDrain(stream, state);
  state.pendingcb--;
  cb();
  finishMaybe(stream, state);
}

// Must force callback to be called on nextTick, so that we don't
// emit 'drain' before the write() consumer gets the 'false' return
// value, and has a chance to attach a 'drain' listener.
function onwriteDrain(stream, state) {
  if (state.length === 0 && state.needDrain) {
    state.needDrain = false;
    stream.emit('drain');
  }
}

// if there's something in the buffer waiting, then process it
function clearBuffer(stream, state) {
  state.bufferProcessing = true;
  var entry = state.bufferedRequest;

  if (stream._writev && entry && entry.next) {
    // Fast case, write everything using _writev()
    var l = state.bufferedRequestCount;
    var buffer = new Array(l);
    var holder = state.corkedRequestsFree;
    holder.entry = entry;

    var count = 0;
    while (entry) {
      buffer[count] = entry;
      entry = entry.next;
      count += 1;
    }

    doWrite(stream, state, true, state.length, buffer, '', holder.finish);

    // doWrite is almost always async, defer these to save a bit of time
    // as the hot path ends with doWrite
    state.pendingcb++;
    state.lastBufferedRequest = null;
    if (holder.next) {
      state.corkedRequestsFree = holder.next;
      holder.next = null;
    } else {
      state.corkedRequestsFree = new CorkedRequest(state);
    }
  } else {
    // Slow case, write chunks one-by-one
    while (entry) {
      var chunk = entry.chunk;
      var encoding = entry.encoding;
      var cb = entry.callback;
      var len = state.objectMode ? 1 : chunk.length;

      doWrite(stream, state, false, len, chunk, encoding, cb);
      entry = entry.next;
      // if we didn't call the onwrite immediately, then
      // it means that we need to wait until it does.
      // also, that means that the chunk and cb are currently
      // being processed, so move the buffer counter past them.
      if (state.writing) {
        break;
      }
    }

    if (entry === null) state.lastBufferedRequest = null;
  }

  state.bufferedRequestCount = 0;
  state.bufferedRequest = entry;
  state.bufferProcessing = false;
}

Writable.prototype._write = function (chunk, encoding, cb) {
  cb(new Error('not implemented'));
};

Writable.prototype._writev = null;

Writable.prototype.end = function (chunk, encoding, cb) {
  var state = this._writableState;

  if (typeof chunk === 'function') {
    cb = chunk;
    chunk = null;
    encoding = null;
  } else if (typeof encoding === 'function') {
    cb = encoding;
    encoding = null;
  }

  if (chunk !== null && chunk !== undefined) this.write(chunk, encoding);

  // .end() fully uncorks
  if (state.corked) {
    state.corked = 1;
    this.uncork();
  }

  // ignore unnecessary end() calls.
  if (!state.ending && !state.finished) endWritable(this, state, cb);
};

function needFinish(state) {
  return state.ending && state.length === 0 && state.bufferedRequest === null && !state.finished && !state.writing;
}

function prefinish(stream, state) {
  if (!state.prefinished) {
    state.prefinished = true;
    stream.emit('prefinish');
  }
}

function finishMaybe(stream, state) {
  var need = needFinish(state);
  if (need) {
    if (state.pendingcb === 0) {
      prefinish(stream, state);
      state.finished = true;
      stream.emit('finish');
    } else {
      prefinish(stream, state);
    }
  }
  return need;
}

function endWritable(stream, state, cb) {
  state.ending = true;
  finishMaybe(stream, state);
  if (cb) {
    if (state.finished) nextTick(cb);else stream.once('finish', cb);
  }
  state.ended = true;
  stream.writable = false;
}

// It seems a linked list but it is not
// there will be only 2 of these for each stream
function CorkedRequest(state) {
  var _this = this;

  this.next = null;
  this.entry = null;

  this.finish = function (err) {
    var entry = _this.entry;
    _this.entry = null;
    while (entry) {
      var cb = entry.callback;
      state.pendingcb--;
      cb(err);
      entry = entry.next;
    }
    if (state.corkedRequestsFree) {
      state.corkedRequestsFree.next = _this;
    } else {
      state.corkedRequestsFree = _this;
    }
  };
}

inherits$2(Duplex, Readable);

var keys = Object.keys(Writable.prototype);
for (var v = 0; v < keys.length; v++) {
  var method = keys[v];
  if (!Duplex.prototype[method]) Duplex.prototype[method] = Writable.prototype[method];
}
function Duplex(options) {
  if (!(this instanceof Duplex)) return new Duplex(options);

  Readable.call(this, options);
  Writable.call(this, options);

  if (options && options.readable === false) this.readable = false;

  if (options && options.writable === false) this.writable = false;

  this.allowHalfOpen = true;
  if (options && options.allowHalfOpen === false) this.allowHalfOpen = false;

  this.once('end', onend);
}

// the no-half-open enforcer
function onend() {
  // if we allow half-open state, or if the writable side ended,
  // then we're ok.
  if (this.allowHalfOpen || this._writableState.ended) return;

  // no more data can be written.
  // But allow more writes to happen in this tick.
  nextTick(onEndNT, this);
}

function onEndNT(self) {
  self.end();
}

// a transform stream is a readable/writable stream where you do
inherits$2(Transform, Duplex);

function TransformState(stream) {
  this.afterTransform = function (er, data) {
    return afterTransform(stream, er, data);
  };

  this.needTransform = false;
  this.transforming = false;
  this.writecb = null;
  this.writechunk = null;
  this.writeencoding = null;
}

function afterTransform(stream, er, data) {
  var ts = stream._transformState;
  ts.transforming = false;

  var cb = ts.writecb;

  if (!cb) return stream.emit('error', new Error('no writecb in Transform class'));

  ts.writechunk = null;
  ts.writecb = null;

  if (data !== null && data !== undefined) stream.push(data);

  cb(er);

  var rs = stream._readableState;
  rs.reading = false;
  if (rs.needReadable || rs.length < rs.highWaterMark) {
    stream._read(rs.highWaterMark);
  }
}
function Transform(options) {
  if (!(this instanceof Transform)) return new Transform(options);

  Duplex.call(this, options);

  this._transformState = new TransformState(this);

  // when the writable side finishes, then flush out anything remaining.
  var stream = this;

  // start out asking for a readable event once data is transformed.
  this._readableState.needReadable = true;

  // we have implemented the _read method, and done the other things
  // that Readable wants before the first _read call, so unset the
  // sync guard flag.
  this._readableState.sync = false;

  if (options) {
    if (typeof options.transform === 'function') this._transform = options.transform;

    if (typeof options.flush === 'function') this._flush = options.flush;
  }

  this.once('prefinish', function () {
    if (typeof this._flush === 'function') this._flush(function (er) {
      done(stream, er);
    });else done(stream);
  });
}

Transform.prototype.push = function (chunk, encoding) {
  this._transformState.needTransform = false;
  return Duplex.prototype.push.call(this, chunk, encoding);
};

// This is the part where you do stuff!
// override this function in implementation classes.
// 'chunk' is an input chunk.
//
// Call `push(newChunk)` to pass along transformed output
// to the readable side.  You may call 'push' zero or more times.
//
// Call `cb(err)` when you are done with this chunk.  If you pass
// an error, then that'll put the hurt on the whole operation.  If you
// never call cb(), then you'll never get another chunk.
Transform.prototype._transform = function (chunk, encoding, cb) {
  throw new Error('Not implemented');
};

Transform.prototype._write = function (chunk, encoding, cb) {
  var ts = this._transformState;
  ts.writecb = cb;
  ts.writechunk = chunk;
  ts.writeencoding = encoding;
  if (!ts.transforming) {
    var rs = this._readableState;
    if (ts.needTransform || rs.needReadable || rs.length < rs.highWaterMark) this._read(rs.highWaterMark);
  }
};

// Doesn't matter what the args are here.
// _transform does all the work.
// That we got here means that the readable side wants more data.
Transform.prototype._read = function (n) {
  var ts = this._transformState;

  if (ts.writechunk !== null && ts.writecb && !ts.transforming) {
    ts.transforming = true;
    this._transform(ts.writechunk, ts.writeencoding, ts.afterTransform);
  } else {
    // mark that we need a transform, so that any data that comes in
    // will get processed, now that we've asked for it.
    ts.needTransform = true;
  }
};

function done(stream, er) {
  if (er) return stream.emit('error', er);

  // if there's nothing in the write buffer, then that means
  // that nothing more will ever be provided
  var ws = stream._writableState;
  var ts = stream._transformState;

  if (ws.length) throw new Error('Calling transform done when ws.length != 0');

  if (ts.transforming) throw new Error('Calling transform done when still transforming');

  return stream.push(null);
}

inherits$2(PassThrough, Transform);
function PassThrough(options) {
  if (!(this instanceof PassThrough)) return new PassThrough(options);

  Transform.call(this, options);
}

PassThrough.prototype._transform = function (chunk, encoding, cb) {
  cb(null, chunk);
};

inherits$2(Stream, EventEmitter);
Stream.Readable = Readable;
Stream.Writable = Writable;
Stream.Duplex = Duplex;
Stream.Transform = Transform;
Stream.PassThrough = PassThrough;

// Backwards-compat with node 0.4.x
Stream.Stream = Stream;

// old-style streams.  Note that the pipe method (the only relevant
// part of this class) is overridden in the Readable class.

function Stream() {
  EventEmitter.call(this);
}

Stream.prototype.pipe = function(dest, options) {
  var source = this;

  function ondata(chunk) {
    if (dest.writable) {
      if (false === dest.write(chunk) && source.pause) {
        source.pause();
      }
    }
  }

  source.on('data', ondata);

  function ondrain() {
    if (source.readable && source.resume) {
      source.resume();
    }
  }

  dest.on('drain', ondrain);

  // If the 'end' option is not supplied, dest.end() will be called when
  // source gets the 'end' or 'close' events.  Only dest.end() once.
  if (!dest._isStdio && (!options || options.end !== false)) {
    source.on('end', onend);
    source.on('close', onclose);
  }

  var didOnEnd = false;
  function onend() {
    if (didOnEnd) return;
    didOnEnd = true;

    dest.end();
  }


  function onclose() {
    if (didOnEnd) return;
    didOnEnd = true;

    if (typeof dest.destroy === 'function') dest.destroy();
  }

  // don't leave dangling pipes when there are errors.
  function onerror(er) {
    cleanup();
    if (EventEmitter.listenerCount(this, 'error') === 0) {
      throw er; // Unhandled stream error in pipe.
    }
  }

  source.on('error', onerror);
  dest.on('error', onerror);

  // remove all the event listeners that were added.
  function cleanup() {
    source.removeListener('data', ondata);
    dest.removeListener('drain', ondrain);

    source.removeListener('end', onend);
    source.removeListener('close', onclose);

    source.removeListener('error', onerror);
    dest.removeListener('error', onerror);

    source.removeListener('end', cleanup);
    source.removeListener('close', cleanup);

    dest.removeListener('close', cleanup);
  }

  source.on('end', cleanup);
  source.on('close', cleanup);

  dest.on('close', cleanup);

  dest.emit('pipe', source);

  // Allow for unix-like usage: A.pipe(B).pipe(C)
  return dest;
};

var sax = createCommonjsModule(function (module, exports) {
(function (sax) { // wrapper for non-node envs
  sax.parser = function (strict, opt) { return new SAXParser(strict, opt) };
  sax.SAXParser = SAXParser;
  sax.SAXStream = SAXStream;
  sax.createStream = createStream;

  // When we pass the MAX_BUFFER_LENGTH position, start checking for buffer overruns.
  // When we check, schedule the next check for MAX_BUFFER_LENGTH - (max(buffer lengths)),
  // since that's the earliest that a buffer overrun could occur.  This way, checks are
  // as rare as required, but as often as necessary to ensure never crossing this bound.
  // Furthermore, buffers are only tested at most once per write(), so passing a very
  // large string into write() might have undesirable effects, but this is manageable by
  // the caller, so it is assumed to be safe.  Thus, a call to write() may, in the extreme
  // edge case, result in creating at most one complete copy of the string passed in.
  // Set to Infinity to have unlimited buffers.
  sax.MAX_BUFFER_LENGTH = 64 * 1024;

  var buffers = [
    'comment', 'sgmlDecl', 'textNode', 'tagName', 'doctype',
    'procInstName', 'procInstBody', 'entity', 'attribName',
    'attribValue', 'cdata', 'script'
  ];

  sax.EVENTS = [
    'text',
    'processinginstruction',
    'sgmldeclaration',
    'doctype',
    'comment',
    'opentagstart',
    'attribute',
    'opentag',
    'closetag',
    'opencdata',
    'cdata',
    'closecdata',
    'error',
    'end',
    'ready',
    'script',
    'opennamespace',
    'closenamespace'
  ];

  function SAXParser (strict, opt) {
    if (!(this instanceof SAXParser)) {
      return new SAXParser(strict, opt)
    }

    var parser = this;
    clearBuffers(parser);
    parser.q = parser.c = '';
    parser.bufferCheckPosition = sax.MAX_BUFFER_LENGTH;
    parser.opt = opt || {};
    parser.opt.lowercase = parser.opt.lowercase || parser.opt.lowercasetags;
    parser.looseCase = parser.opt.lowercase ? 'toLowerCase' : 'toUpperCase';
    parser.tags = [];
    parser.closed = parser.closedRoot = parser.sawRoot = false;
    parser.tag = parser.error = null;
    parser.strict = !!strict;
    parser.noscript = !!(strict || parser.opt.noscript);
    parser.state = S.BEGIN;
    parser.strictEntities = parser.opt.strictEntities;
    parser.ENTITIES = parser.strictEntities ? Object.create(sax.XML_ENTITIES) : Object.create(sax.ENTITIES);
    parser.attribList = [];

    // namespaces form a prototype chain.
    // it always points at the current tag,
    // which protos to its parent tag.
    if (parser.opt.xmlns) {
      parser.ns = Object.create(rootNS);
    }

    // mostly just for error reporting
    parser.trackPosition = parser.opt.position !== false;
    if (parser.trackPosition) {
      parser.position = parser.line = parser.column = 0;
    }
    emit(parser, 'onready');
  }

  if (!Object.create) {
    Object.create = function (o) {
      function F () {}
      F.prototype = o;
      var newf = new F();
      return newf
    };
  }

  if (!Object.keys) {
    Object.keys = function (o) {
      var a = [];
      for (var i in o) if (o.hasOwnProperty(i)) a.push(i);
      return a
    };
  }

  function checkBufferLength (parser) {
    var maxAllowed = Math.max(sax.MAX_BUFFER_LENGTH, 10);
    var maxActual = 0;
    for (var i = 0, l = buffers.length; i < l; i++) {
      var len = parser[buffers[i]].length;
      if (len > maxAllowed) {
        // Text/cdata nodes can get big, and since they're buffered,
        // we can get here under normal conditions.
        // Avoid issues by emitting the text node now,
        // so at least it won't get any bigger.
        switch (buffers[i]) {
          case 'textNode':
            closeText(parser);
            break

          case 'cdata':
            emitNode(parser, 'oncdata', parser.cdata);
            parser.cdata = '';
            break

          case 'script':
            emitNode(parser, 'onscript', parser.script);
            parser.script = '';
            break

          default:
            error(parser, 'Max buffer length exceeded: ' + buffers[i]);
        }
      }
      maxActual = Math.max(maxActual, len);
    }
    // schedule the next check for the earliest possible buffer overrun.
    var m = sax.MAX_BUFFER_LENGTH - maxActual;
    parser.bufferCheckPosition = m + parser.position;
  }

  function clearBuffers (parser) {
    for (var i = 0, l = buffers.length; i < l; i++) {
      parser[buffers[i]] = '';
    }
  }

  function flushBuffers (parser) {
    closeText(parser);
    if (parser.cdata !== '') {
      emitNode(parser, 'oncdata', parser.cdata);
      parser.cdata = '';
    }
    if (parser.script !== '') {
      emitNode(parser, 'onscript', parser.script);
      parser.script = '';
    }
  }

  SAXParser.prototype = {
    end: function () { end(this); },
    write: write,
    resume: function () { this.error = null; return this },
    close: function () { return this.write(null) },
    flush: function () { flushBuffers(this); }
  };

  var Stream$1;
  try {
    Stream$1 = Stream.Stream;
  } catch (ex) {
    Stream$1 = function () {};
  }

  var streamWraps = sax.EVENTS.filter(function (ev) {
    return ev !== 'error' && ev !== 'end'
  });

  function createStream (strict, opt) {
    return new SAXStream(strict, opt)
  }

  function SAXStream (strict, opt) {
    if (!(this instanceof SAXStream)) {
      return new SAXStream(strict, opt)
    }

    Stream$1.apply(this);

    this._parser = new SAXParser(strict, opt);
    this.writable = true;
    this.readable = true;

    var me = this;

    this._parser.onend = function () {
      me.emit('end');
    };

    this._parser.onerror = function (er) {
      me.emit('error', er);

      // if didn't throw, then means error was handled.
      // go ahead and clear error, so we can write again.
      me._parser.error = null;
    };

    this._decoder = null;

    streamWraps.forEach(function (ev) {
      Object.defineProperty(me, 'on' + ev, {
        get: function () {
          return me._parser['on' + ev]
        },
        set: function (h) {
          if (!h) {
            me.removeAllListeners(ev);
            me._parser['on' + ev] = h;
            return h
          }
          me.on(ev, h);
        },
        enumerable: true,
        configurable: false
      });
    });
  }

  SAXStream.prototype = Object.create(Stream$1.prototype, {
    constructor: {
      value: SAXStream
    }
  });

  SAXStream.prototype.write = function (data) {
    if (typeof Buffer$1 === 'function' &&
      typeof isBuffer === 'function' &&
      isBuffer(data)) {
      if (!this._decoder) {
        var SD = stringDecoder.StringDecoder;
        this._decoder = new SD('utf8');
      }
      data = this._decoder.write(data);
    }

    this._parser.write(data.toString());
    this.emit('data', data);
    return true
  };

  SAXStream.prototype.end = function (chunk) {
    if (chunk && chunk.length) {
      this.write(chunk);
    }
    this._parser.end();
    return true
  };

  SAXStream.prototype.on = function (ev, handler) {
    var me = this;
    if (!me._parser['on' + ev] && streamWraps.indexOf(ev) !== -1) {
      me._parser['on' + ev] = function () {
        var args = arguments.length === 1 ? [arguments[0]] : Array.apply(null, arguments);
        args.splice(0, 0, ev);
        me.emit.apply(me, args);
      };
    }

    return Stream$1.prototype.on.call(me, ev, handler)
  };

  // this really needs to be replaced with character classes.
  // XML allows all manner of ridiculous numbers and digits.
  var CDATA = '[CDATA[';
  var DOCTYPE = 'DOCTYPE';
  var XML_NAMESPACE = 'http://www.w3.org/XML/1998/namespace';
  var XMLNS_NAMESPACE = 'http://www.w3.org/2000/xmlns/';
  var rootNS = { xml: XML_NAMESPACE, xmlns: XMLNS_NAMESPACE };

  // http://www.w3.org/TR/REC-xml/#NT-NameStartChar
  // This implementation works on strings, a single character at a time
  // as such, it cannot ever support astral-plane characters (10000-EFFFF)
  // without a significant breaking change to either this  parser, or the
  // JavaScript language.  Implementation of an emoji-capable xml parser
  // is left as an exercise for the reader.
  var nameStart = /[:_A-Za-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD]/;

  var nameBody = /[:_A-Za-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\u00B7\u0300-\u036F\u203F-\u2040.\d-]/;

  var entityStart = /[#:_A-Za-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD]/;
  var entityBody = /[#:_A-Za-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\u00B7\u0300-\u036F\u203F-\u2040.\d-]/;

  function isWhitespace (c) {
    return c === ' ' || c === '\n' || c === '\r' || c === '\t'
  }

  function isQuote (c) {
    return c === '"' || c === '\''
  }

  function isAttribEnd (c) {
    return c === '>' || isWhitespace(c)
  }

  function isMatch (regex, c) {
    return regex.test(c)
  }

  function notMatch (regex, c) {
    return !isMatch(regex, c)
  }

  var S = 0;
  sax.STATE = {
    BEGIN: S++, // leading byte order mark or whitespace
    BEGIN_WHITESPACE: S++, // leading whitespace
    TEXT: S++, // general stuff
    TEXT_ENTITY: S++, // &amp and such.
    OPEN_WAKA: S++, // <
    SGML_DECL: S++, // <!BLARG
    SGML_DECL_QUOTED: S++, // <!BLARG foo "bar
    DOCTYPE: S++, // <!DOCTYPE
    DOCTYPE_QUOTED: S++, // <!DOCTYPE "//blah
    DOCTYPE_DTD: S++, // <!DOCTYPE "//blah" [ ...
    DOCTYPE_DTD_QUOTED: S++, // <!DOCTYPE "//blah" [ "foo
    COMMENT_STARTING: S++, // <!-
    COMMENT: S++, // <!--
    COMMENT_ENDING: S++, // <!-- blah -
    COMMENT_ENDED: S++, // <!-- blah --
    CDATA: S++, // <![CDATA[ something
    CDATA_ENDING: S++, // ]
    CDATA_ENDING_2: S++, // ]]
    PROC_INST: S++, // <?hi
    PROC_INST_BODY: S++, // <?hi there
    PROC_INST_ENDING: S++, // <?hi "there" ?
    OPEN_TAG: S++, // <strong
    OPEN_TAG_SLASH: S++, // <strong /
    ATTRIB: S++, // <a
    ATTRIB_NAME: S++, // <a foo
    ATTRIB_NAME_SAW_WHITE: S++, // <a foo _
    ATTRIB_VALUE: S++, // <a foo=
    ATTRIB_VALUE_QUOTED: S++, // <a foo="bar
    ATTRIB_VALUE_CLOSED: S++, // <a foo="bar"
    ATTRIB_VALUE_UNQUOTED: S++, // <a foo=bar
    ATTRIB_VALUE_ENTITY_Q: S++, // <foo bar="&quot;"
    ATTRIB_VALUE_ENTITY_U: S++, // <foo bar=&quot
    CLOSE_TAG: S++, // </a
    CLOSE_TAG_SAW_WHITE: S++, // </a   >
    SCRIPT: S++, // <script> ...
    SCRIPT_ENDING: S++ // <script> ... <
  };

  sax.XML_ENTITIES = {
    'amp': '&',
    'gt': '>',
    'lt': '<',
    'quot': '"',
    'apos': "'"
  };

  sax.ENTITIES = {
    'amp': '&',
    'gt': '>',
    'lt': '<',
    'quot': '"',
    'apos': "'",
    'AElig': 198,
    'Aacute': 193,
    'Acirc': 194,
    'Agrave': 192,
    'Aring': 197,
    'Atilde': 195,
    'Auml': 196,
    'Ccedil': 199,
    'ETH': 208,
    'Eacute': 201,
    'Ecirc': 202,
    'Egrave': 200,
    'Euml': 203,
    'Iacute': 205,
    'Icirc': 206,
    'Igrave': 204,
    'Iuml': 207,
    'Ntilde': 209,
    'Oacute': 211,
    'Ocirc': 212,
    'Ograve': 210,
    'Oslash': 216,
    'Otilde': 213,
    'Ouml': 214,
    'THORN': 222,
    'Uacute': 218,
    'Ucirc': 219,
    'Ugrave': 217,
    'Uuml': 220,
    'Yacute': 221,
    'aacute': 225,
    'acirc': 226,
    'aelig': 230,
    'agrave': 224,
    'aring': 229,
    'atilde': 227,
    'auml': 228,
    'ccedil': 231,
    'eacute': 233,
    'ecirc': 234,
    'egrave': 232,
    'eth': 240,
    'euml': 235,
    'iacute': 237,
    'icirc': 238,
    'igrave': 236,
    'iuml': 239,
    'ntilde': 241,
    'oacute': 243,
    'ocirc': 244,
    'ograve': 242,
    'oslash': 248,
    'otilde': 245,
    'ouml': 246,
    'szlig': 223,
    'thorn': 254,
    'uacute': 250,
    'ucirc': 251,
    'ugrave': 249,
    'uuml': 252,
    'yacute': 253,
    'yuml': 255,
    'copy': 169,
    'reg': 174,
    'nbsp': 160,
    'iexcl': 161,
    'cent': 162,
    'pound': 163,
    'curren': 164,
    'yen': 165,
    'brvbar': 166,
    'sect': 167,
    'uml': 168,
    'ordf': 170,
    'laquo': 171,
    'not': 172,
    'shy': 173,
    'macr': 175,
    'deg': 176,
    'plusmn': 177,
    'sup1': 185,
    'sup2': 178,
    'sup3': 179,
    'acute': 180,
    'micro': 181,
    'para': 182,
    'middot': 183,
    'cedil': 184,
    'ordm': 186,
    'raquo': 187,
    'frac14': 188,
    'frac12': 189,
    'frac34': 190,
    'iquest': 191,
    'times': 215,
    'divide': 247,
    'OElig': 338,
    'oelig': 339,
    'Scaron': 352,
    'scaron': 353,
    'Yuml': 376,
    'fnof': 402,
    'circ': 710,
    'tilde': 732,
    'Alpha': 913,
    'Beta': 914,
    'Gamma': 915,
    'Delta': 916,
    'Epsilon': 917,
    'Zeta': 918,
    'Eta': 919,
    'Theta': 920,
    'Iota': 921,
    'Kappa': 922,
    'Lambda': 923,
    'Mu': 924,
    'Nu': 925,
    'Xi': 926,
    'Omicron': 927,
    'Pi': 928,
    'Rho': 929,
    'Sigma': 931,
    'Tau': 932,
    'Upsilon': 933,
    'Phi': 934,
    'Chi': 935,
    'Psi': 936,
    'Omega': 937,
    'alpha': 945,
    'beta': 946,
    'gamma': 947,
    'delta': 948,
    'epsilon': 949,
    'zeta': 950,
    'eta': 951,
    'theta': 952,
    'iota': 953,
    'kappa': 954,
    'lambda': 955,
    'mu': 956,
    'nu': 957,
    'xi': 958,
    'omicron': 959,
    'pi': 960,
    'rho': 961,
    'sigmaf': 962,
    'sigma': 963,
    'tau': 964,
    'upsilon': 965,
    'phi': 966,
    'chi': 967,
    'psi': 968,
    'omega': 969,
    'thetasym': 977,
    'upsih': 978,
    'piv': 982,
    'ensp': 8194,
    'emsp': 8195,
    'thinsp': 8201,
    'zwnj': 8204,
    'zwj': 8205,
    'lrm': 8206,
    'rlm': 8207,
    'ndash': 8211,
    'mdash': 8212,
    'lsquo': 8216,
    'rsquo': 8217,
    'sbquo': 8218,
    'ldquo': 8220,
    'rdquo': 8221,
    'bdquo': 8222,
    'dagger': 8224,
    'Dagger': 8225,
    'bull': 8226,
    'hellip': 8230,
    'permil': 8240,
    'prime': 8242,
    'Prime': 8243,
    'lsaquo': 8249,
    'rsaquo': 8250,
    'oline': 8254,
    'frasl': 8260,
    'euro': 8364,
    'image': 8465,
    'weierp': 8472,
    'real': 8476,
    'trade': 8482,
    'alefsym': 8501,
    'larr': 8592,
    'uarr': 8593,
    'rarr': 8594,
    'darr': 8595,
    'harr': 8596,
    'crarr': 8629,
    'lArr': 8656,
    'uArr': 8657,
    'rArr': 8658,
    'dArr': 8659,
    'hArr': 8660,
    'forall': 8704,
    'part': 8706,
    'exist': 8707,
    'empty': 8709,
    'nabla': 8711,
    'isin': 8712,
    'notin': 8713,
    'ni': 8715,
    'prod': 8719,
    'sum': 8721,
    'minus': 8722,
    'lowast': 8727,
    'radic': 8730,
    'prop': 8733,
    'infin': 8734,
    'ang': 8736,
    'and': 8743,
    'or': 8744,
    'cap': 8745,
    'cup': 8746,
    'int': 8747,
    'there4': 8756,
    'sim': 8764,
    'cong': 8773,
    'asymp': 8776,
    'ne': 8800,
    'equiv': 8801,
    'le': 8804,
    'ge': 8805,
    'sub': 8834,
    'sup': 8835,
    'nsub': 8836,
    'sube': 8838,
    'supe': 8839,
    'oplus': 8853,
    'otimes': 8855,
    'perp': 8869,
    'sdot': 8901,
    'lceil': 8968,
    'rceil': 8969,
    'lfloor': 8970,
    'rfloor': 8971,
    'lang': 9001,
    'rang': 9002,
    'loz': 9674,
    'spades': 9824,
    'clubs': 9827,
    'hearts': 9829,
    'diams': 9830
  };

  Object.keys(sax.ENTITIES).forEach(function (key) {
    var e = sax.ENTITIES[key];
    var s = typeof e === 'number' ? String.fromCharCode(e) : e;
    sax.ENTITIES[key] = s;
  });

  for (var s in sax.STATE) {
    sax.STATE[sax.STATE[s]] = s;
  }

  // shorthand
  S = sax.STATE;

  function emit (parser, event, data) {
    parser[event] && parser[event](data);
  }

  function emitNode (parser, nodeType, data) {
    if (parser.textNode) closeText(parser);
    emit(parser, nodeType, data);
  }

  function closeText (parser) {
    parser.textNode = textopts(parser.opt, parser.textNode);
    if (parser.textNode) emit(parser, 'ontext', parser.textNode);
    parser.textNode = '';
  }

  function textopts (opt, text) {
    if (opt.trim) text = text.trim();
    if (opt.normalize) text = text.replace(/\s+/g, ' ');
    return text
  }

  function error (parser, er) {
    closeText(parser);
    if (parser.trackPosition) {
      er += '\nLine: ' + parser.line +
        '\nColumn: ' + parser.column +
        '\nChar: ' + parser.c;
    }
    er = new Error(er);
    parser.error = er;
    emit(parser, 'onerror', er);
    return parser
  }

  function end (parser) {
    if (parser.sawRoot && !parser.closedRoot) strictFail(parser, 'Unclosed root tag');
    if ((parser.state !== S.BEGIN) &&
      (parser.state !== S.BEGIN_WHITESPACE) &&
      (parser.state !== S.TEXT)) {
      error(parser, 'Unexpected end');
    }
    closeText(parser);
    parser.c = '';
    parser.closed = true;
    emit(parser, 'onend');
    SAXParser.call(parser, parser.strict, parser.opt);
    return parser
  }

  function strictFail (parser, message) {
    if (typeof parser !== 'object' || !(parser instanceof SAXParser)) {
      throw new Error('bad call to strictFail')
    }
    if (parser.strict) {
      error(parser, message);
    }
  }

  function newTag (parser) {
    if (!parser.strict) parser.tagName = parser.tagName[parser.looseCase]();
    var parent = parser.tags[parser.tags.length - 1] || parser;
    var tag = parser.tag = { name: parser.tagName, attributes: {} };

    // will be overridden if tag contails an xmlns="foo" or xmlns:foo="bar"
    if (parser.opt.xmlns) {
      tag.ns = parent.ns;
    }
    parser.attribList.length = 0;
    emitNode(parser, 'onopentagstart', tag);
  }

  function qname (name, attribute) {
    var i = name.indexOf(':');
    var qualName = i < 0 ? [ '', name ] : name.split(':');
    var prefix = qualName[0];
    var local = qualName[1];

    // <x "xmlns"="http://foo">
    if (attribute && name === 'xmlns') {
      prefix = 'xmlns';
      local = '';
    }

    return { prefix: prefix, local: local }
  }

  function attrib (parser) {
    if (!parser.strict) {
      parser.attribName = parser.attribName[parser.looseCase]();
    }

    if (parser.attribList.indexOf(parser.attribName) !== -1 ||
      parser.tag.attributes.hasOwnProperty(parser.attribName)) {
      parser.attribName = parser.attribValue = '';
      return
    }

    if (parser.opt.xmlns) {
      var qn = qname(parser.attribName, true);
      var prefix = qn.prefix;
      var local = qn.local;

      if (prefix === 'xmlns') {
        // namespace binding attribute. push the binding into scope
        if (local === 'xml' && parser.attribValue !== XML_NAMESPACE) {
          strictFail(parser,
            'xml: prefix must be bound to ' + XML_NAMESPACE + '\n' +
            'Actual: ' + parser.attribValue);
        } else if (local === 'xmlns' && parser.attribValue !== XMLNS_NAMESPACE) {
          strictFail(parser,
            'xmlns: prefix must be bound to ' + XMLNS_NAMESPACE + '\n' +
            'Actual: ' + parser.attribValue);
        } else {
          var tag = parser.tag;
          var parent = parser.tags[parser.tags.length - 1] || parser;
          if (tag.ns === parent.ns) {
            tag.ns = Object.create(parent.ns);
          }
          tag.ns[local] = parser.attribValue;
        }
      }

      // defer onattribute events until all attributes have been seen
      // so any new bindings can take effect. preserve attribute order
      // so deferred events can be emitted in document order
      parser.attribList.push([parser.attribName, parser.attribValue]);
    } else {
      // in non-xmlns mode, we can emit the event right away
      parser.tag.attributes[parser.attribName] = parser.attribValue;
      emitNode(parser, 'onattribute', {
        name: parser.attribName,
        value: parser.attribValue
      });
    }

    parser.attribName = parser.attribValue = '';
  }

  function openTag (parser, selfClosing) {
    if (parser.opt.xmlns) {
      // emit namespace binding events
      var tag = parser.tag;

      // add namespace info to tag
      var qn = qname(parser.tagName);
      tag.prefix = qn.prefix;
      tag.local = qn.local;
      tag.uri = tag.ns[qn.prefix] || '';

      if (tag.prefix && !tag.uri) {
        strictFail(parser, 'Unbound namespace prefix: ' +
          JSON.stringify(parser.tagName));
        tag.uri = qn.prefix;
      }

      var parent = parser.tags[parser.tags.length - 1] || parser;
      if (tag.ns && parent.ns !== tag.ns) {
        Object.keys(tag.ns).forEach(function (p) {
          emitNode(parser, 'onopennamespace', {
            prefix: p,
            uri: tag.ns[p]
          });
        });
      }

      // handle deferred onattribute events
      // Note: do not apply default ns to attributes:
      //   http://www.w3.org/TR/REC-xml-names/#defaulting
      for (var i = 0, l = parser.attribList.length; i < l; i++) {
        var nv = parser.attribList[i];
        var name = nv[0];
        var value = nv[1];
        var qualName = qname(name, true);
        var prefix = qualName.prefix;
        var local = qualName.local;
        var uri = prefix === '' ? '' : (tag.ns[prefix] || '');
        var a = {
          name: name,
          value: value,
          prefix: prefix,
          local: local,
          uri: uri
        };

        // if there's any attributes with an undefined namespace,
        // then fail on them now.
        if (prefix && prefix !== 'xmlns' && !uri) {
          strictFail(parser, 'Unbound namespace prefix: ' +
            JSON.stringify(prefix));
          a.uri = prefix;
        }
        parser.tag.attributes[name] = a;
        emitNode(parser, 'onattribute', a);
      }
      parser.attribList.length = 0;
    }

    parser.tag.isSelfClosing = !!selfClosing;

    // process the tag
    parser.sawRoot = true;
    parser.tags.push(parser.tag);
    emitNode(parser, 'onopentag', parser.tag);
    if (!selfClosing) {
      // special case for <script> in non-strict mode.
      if (!parser.noscript && parser.tagName.toLowerCase() === 'script') {
        parser.state = S.SCRIPT;
      } else {
        parser.state = S.TEXT;
      }
      parser.tag = null;
      parser.tagName = '';
    }
    parser.attribName = parser.attribValue = '';
    parser.attribList.length = 0;
  }

  function closeTag (parser) {
    if (!parser.tagName) {
      strictFail(parser, 'Weird empty close tag.');
      parser.textNode += '</>';
      parser.state = S.TEXT;
      return
    }

    if (parser.script) {
      if (parser.tagName !== 'script') {
        parser.script += '</' + parser.tagName + '>';
        parser.tagName = '';
        parser.state = S.SCRIPT;
        return
      }
      emitNode(parser, 'onscript', parser.script);
      parser.script = '';
    }

    // first make sure that the closing tag actually exists.
    // <a><b></c></b></a> will close everything, otherwise.
    var t = parser.tags.length;
    var tagName = parser.tagName;
    if (!parser.strict) {
      tagName = tagName[parser.looseCase]();
    }
    var closeTo = tagName;
    while (t--) {
      var close = parser.tags[t];
      if (close.name !== closeTo) {
        // fail the first time in strict mode
        strictFail(parser, 'Unexpected close tag');
      } else {
        break
      }
    }

    // didn't find it.  we already failed for strict, so just abort.
    if (t < 0) {
      strictFail(parser, 'Unmatched closing tag: ' + parser.tagName);
      parser.textNode += '</' + parser.tagName + '>';
      parser.state = S.TEXT;
      return
    }
    parser.tagName = tagName;
    var s = parser.tags.length;
    while (s-- > t) {
      var tag = parser.tag = parser.tags.pop();
      parser.tagName = parser.tag.name;
      emitNode(parser, 'onclosetag', parser.tagName);

      var x = {};
      for (var i in tag.ns) {
        x[i] = tag.ns[i];
      }

      var parent = parser.tags[parser.tags.length - 1] || parser;
      if (parser.opt.xmlns && tag.ns !== parent.ns) {
        // remove namespace bindings introduced by tag
        Object.keys(tag.ns).forEach(function (p) {
          var n = tag.ns[p];
          emitNode(parser, 'onclosenamespace', { prefix: p, uri: n });
        });
      }
    }
    if (t === 0) parser.closedRoot = true;
    parser.tagName = parser.attribValue = parser.attribName = '';
    parser.attribList.length = 0;
    parser.state = S.TEXT;
  }

  function parseEntity (parser) {
    var entity = parser.entity;
    var entityLC = entity.toLowerCase();
    var num;
    var numStr = '';

    if (parser.ENTITIES[entity]) {
      return parser.ENTITIES[entity]
    }
    if (parser.ENTITIES[entityLC]) {
      return parser.ENTITIES[entityLC]
    }
    entity = entityLC;
    if (entity.charAt(0) === '#') {
      if (entity.charAt(1) === 'x') {
        entity = entity.slice(2);
        num = parseInt(entity, 16);
        numStr = num.toString(16);
      } else {
        entity = entity.slice(1);
        num = parseInt(entity, 10);
        numStr = num.toString(10);
      }
    }
    entity = entity.replace(/^0+/, '');
    if (isNaN(num) || numStr.toLowerCase() !== entity) {
      strictFail(parser, 'Invalid character entity');
      return '&' + parser.entity + ';'
    }

    return String.fromCodePoint(num)
  }

  function beginWhiteSpace (parser, c) {
    if (c === '<') {
      parser.state = S.OPEN_WAKA;
      parser.startTagPosition = parser.position;
    } else if (!isWhitespace(c)) {
      // have to process this as a text node.
      // weird, but happens.
      strictFail(parser, 'Non-whitespace before first tag.');
      parser.textNode = c;
      parser.state = S.TEXT;
    }
  }

  function charAt (chunk, i) {
    var result = '';
    if (i < chunk.length) {
      result = chunk.charAt(i);
    }
    return result
  }

  function write (chunk) {
    var parser = this;
    if (this.error) {
      throw this.error
    }
    if (parser.closed) {
      return error(parser,
        'Cannot write after close. Assign an onready handler.')
    }
    if (chunk === null) {
      return end(parser)
    }
    if (typeof chunk === 'object') {
      chunk = chunk.toString();
    }
    var i = 0;
    var c = '';
    while (true) {
      c = charAt(chunk, i++);
      parser.c = c;

      if (!c) {
        break
      }

      if (parser.trackPosition) {
        parser.position++;
        if (c === '\n') {
          parser.line++;
          parser.column = 0;
        } else {
          parser.column++;
        }
      }

      switch (parser.state) {
        case S.BEGIN:
          parser.state = S.BEGIN_WHITESPACE;
          if (c === '\uFEFF') {
            continue
          }
          beginWhiteSpace(parser, c);
          continue

        case S.BEGIN_WHITESPACE:
          beginWhiteSpace(parser, c);
          continue

        case S.TEXT:
          if (parser.sawRoot && !parser.closedRoot) {
            var starti = i - 1;
            while (c && c !== '<' && c !== '&') {
              c = charAt(chunk, i++);
              if (c && parser.trackPosition) {
                parser.position++;
                if (c === '\n') {
                  parser.line++;
                  parser.column = 0;
                } else {
                  parser.column++;
                }
              }
            }
            parser.textNode += chunk.substring(starti, i - 1);
          }
          if (c === '<' && !(parser.sawRoot && parser.closedRoot && !parser.strict)) {
            parser.state = S.OPEN_WAKA;
            parser.startTagPosition = parser.position;
          } else {
            if (!isWhitespace(c) && (!parser.sawRoot || parser.closedRoot)) {
              strictFail(parser, 'Text data outside of root node.');
            }
            if (c === '&') {
              parser.state = S.TEXT_ENTITY;
            } else {
              parser.textNode += c;
            }
          }
          continue

        case S.SCRIPT:
          // only non-strict
          if (c === '<') {
            parser.state = S.SCRIPT_ENDING;
          } else {
            parser.script += c;
          }
          continue

        case S.SCRIPT_ENDING:
          if (c === '/') {
            parser.state = S.CLOSE_TAG;
          } else {
            parser.script += '<' + c;
            parser.state = S.SCRIPT;
          }
          continue

        case S.OPEN_WAKA:
          // either a /, ?, !, or text is coming next.
          if (c === '!') {
            parser.state = S.SGML_DECL;
            parser.sgmlDecl = '';
          } else if (isWhitespace(c)) ; else if (isMatch(nameStart, c)) {
            parser.state = S.OPEN_TAG;
            parser.tagName = c;
          } else if (c === '/') {
            parser.state = S.CLOSE_TAG;
            parser.tagName = '';
          } else if (c === '?') {
            parser.state = S.PROC_INST;
            parser.procInstName = parser.procInstBody = '';
          } else {
            strictFail(parser, 'Unencoded <');
            // if there was some whitespace, then add that in.
            if (parser.startTagPosition + 1 < parser.position) {
              var pad = parser.position - parser.startTagPosition;
              c = new Array(pad).join(' ') + c;
            }
            parser.textNode += '<' + c;
            parser.state = S.TEXT;
          }
          continue

        case S.SGML_DECL:
          if ((parser.sgmlDecl + c).toUpperCase() === CDATA) {
            emitNode(parser, 'onopencdata');
            parser.state = S.CDATA;
            parser.sgmlDecl = '';
            parser.cdata = '';
          } else if (parser.sgmlDecl + c === '--') {
            parser.state = S.COMMENT;
            parser.comment = '';
            parser.sgmlDecl = '';
          } else if ((parser.sgmlDecl + c).toUpperCase() === DOCTYPE) {
            parser.state = S.DOCTYPE;
            if (parser.doctype || parser.sawRoot) {
              strictFail(parser,
                'Inappropriately located doctype declaration');
            }
            parser.doctype = '';
            parser.sgmlDecl = '';
          } else if (c === '>') {
            emitNode(parser, 'onsgmldeclaration', parser.sgmlDecl);
            parser.sgmlDecl = '';
            parser.state = S.TEXT;
          } else if (isQuote(c)) {
            parser.state = S.SGML_DECL_QUOTED;
            parser.sgmlDecl += c;
          } else {
            parser.sgmlDecl += c;
          }
          continue

        case S.SGML_DECL_QUOTED:
          if (c === parser.q) {
            parser.state = S.SGML_DECL;
            parser.q = '';
          }
          parser.sgmlDecl += c;
          continue

        case S.DOCTYPE:
          if (c === '>') {
            parser.state = S.TEXT;
            emitNode(parser, 'ondoctype', parser.doctype);
            parser.doctype = true; // just remember that we saw it.
          } else {
            parser.doctype += c;
            if (c === '[') {
              parser.state = S.DOCTYPE_DTD;
            } else if (isQuote(c)) {
              parser.state = S.DOCTYPE_QUOTED;
              parser.q = c;
            }
          }
          continue

        case S.DOCTYPE_QUOTED:
          parser.doctype += c;
          if (c === parser.q) {
            parser.q = '';
            parser.state = S.DOCTYPE;
          }
          continue

        case S.DOCTYPE_DTD:
          parser.doctype += c;
          if (c === ']') {
            parser.state = S.DOCTYPE;
          } else if (isQuote(c)) {
            parser.state = S.DOCTYPE_DTD_QUOTED;
            parser.q = c;
          }
          continue

        case S.DOCTYPE_DTD_QUOTED:
          parser.doctype += c;
          if (c === parser.q) {
            parser.state = S.DOCTYPE_DTD;
            parser.q = '';
          }
          continue

        case S.COMMENT:
          if (c === '-') {
            parser.state = S.COMMENT_ENDING;
          } else {
            parser.comment += c;
          }
          continue

        case S.COMMENT_ENDING:
          if (c === '-') {
            parser.state = S.COMMENT_ENDED;
            parser.comment = textopts(parser.opt, parser.comment);
            if (parser.comment) {
              emitNode(parser, 'oncomment', parser.comment);
            }
            parser.comment = '';
          } else {
            parser.comment += '-' + c;
            parser.state = S.COMMENT;
          }
          continue

        case S.COMMENT_ENDED:
          if (c !== '>') {
            strictFail(parser, 'Malformed comment');
            // allow <!-- blah -- bloo --> in non-strict mode,
            // which is a comment of " blah -- bloo "
            parser.comment += '--' + c;
            parser.state = S.COMMENT;
          } else {
            parser.state = S.TEXT;
          }
          continue

        case S.CDATA:
          if (c === ']') {
            parser.state = S.CDATA_ENDING;
          } else {
            parser.cdata += c;
          }
          continue

        case S.CDATA_ENDING:
          if (c === ']') {
            parser.state = S.CDATA_ENDING_2;
          } else {
            parser.cdata += ']' + c;
            parser.state = S.CDATA;
          }
          continue

        case S.CDATA_ENDING_2:
          if (c === '>') {
            if (parser.cdata) {
              emitNode(parser, 'oncdata', parser.cdata);
            }
            emitNode(parser, 'onclosecdata');
            parser.cdata = '';
            parser.state = S.TEXT;
          } else if (c === ']') {
            parser.cdata += ']';
          } else {
            parser.cdata += ']]' + c;
            parser.state = S.CDATA;
          }
          continue

        case S.PROC_INST:
          if (c === '?') {
            parser.state = S.PROC_INST_ENDING;
          } else if (isWhitespace(c)) {
            parser.state = S.PROC_INST_BODY;
          } else {
            parser.procInstName += c;
          }
          continue

        case S.PROC_INST_BODY:
          if (!parser.procInstBody && isWhitespace(c)) {
            continue
          } else if (c === '?') {
            parser.state = S.PROC_INST_ENDING;
          } else {
            parser.procInstBody += c;
          }
          continue

        case S.PROC_INST_ENDING:
          if (c === '>') {
            emitNode(parser, 'onprocessinginstruction', {
              name: parser.procInstName,
              body: parser.procInstBody
            });
            parser.procInstName = parser.procInstBody = '';
            parser.state = S.TEXT;
          } else {
            parser.procInstBody += '?' + c;
            parser.state = S.PROC_INST_BODY;
          }
          continue

        case S.OPEN_TAG:
          if (isMatch(nameBody, c)) {
            parser.tagName += c;
          } else {
            newTag(parser);
            if (c === '>') {
              openTag(parser);
            } else if (c === '/') {
              parser.state = S.OPEN_TAG_SLASH;
            } else {
              if (!isWhitespace(c)) {
                strictFail(parser, 'Invalid character in tag name');
              }
              parser.state = S.ATTRIB;
            }
          }
          continue

        case S.OPEN_TAG_SLASH:
          if (c === '>') {
            openTag(parser, true);
            closeTag(parser);
          } else {
            strictFail(parser, 'Forward-slash in opening tag not followed by >');
            parser.state = S.ATTRIB;
          }
          continue

        case S.ATTRIB:
          // haven't read the attribute name yet.
          if (isWhitespace(c)) {
            continue
          } else if (c === '>') {
            openTag(parser);
          } else if (c === '/') {
            parser.state = S.OPEN_TAG_SLASH;
          } else if (isMatch(nameStart, c)) {
            parser.attribName = c;
            parser.attribValue = '';
            parser.state = S.ATTRIB_NAME;
          } else {
            strictFail(parser, 'Invalid attribute name');
          }
          continue

        case S.ATTRIB_NAME:
          if (c === '=') {
            parser.state = S.ATTRIB_VALUE;
          } else if (c === '>') {
            strictFail(parser, 'Attribute without value');
            parser.attribValue = parser.attribName;
            attrib(parser);
            openTag(parser);
          } else if (isWhitespace(c)) {
            parser.state = S.ATTRIB_NAME_SAW_WHITE;
          } else if (isMatch(nameBody, c)) {
            parser.attribName += c;
          } else {
            strictFail(parser, 'Invalid attribute name');
          }
          continue

        case S.ATTRIB_NAME_SAW_WHITE:
          if (c === '=') {
            parser.state = S.ATTRIB_VALUE;
          } else if (isWhitespace(c)) {
            continue
          } else {
            strictFail(parser, 'Attribute without value');
            parser.tag.attributes[parser.attribName] = '';
            parser.attribValue = '';
            emitNode(parser, 'onattribute', {
              name: parser.attribName,
              value: ''
            });
            parser.attribName = '';
            if (c === '>') {
              openTag(parser);
            } else if (isMatch(nameStart, c)) {
              parser.attribName = c;
              parser.state = S.ATTRIB_NAME;
            } else {
              strictFail(parser, 'Invalid attribute name');
              parser.state = S.ATTRIB;
            }
          }
          continue

        case S.ATTRIB_VALUE:
          if (isWhitespace(c)) {
            continue
          } else if (isQuote(c)) {
            parser.q = c;
            parser.state = S.ATTRIB_VALUE_QUOTED;
          } else {
            strictFail(parser, 'Unquoted attribute value');
            parser.state = S.ATTRIB_VALUE_UNQUOTED;
            parser.attribValue = c;
          }
          continue

        case S.ATTRIB_VALUE_QUOTED:
          if (c !== parser.q) {
            if (c === '&') {
              parser.state = S.ATTRIB_VALUE_ENTITY_Q;
            } else {
              parser.attribValue += c;
            }
            continue
          }
          attrib(parser);
          parser.q = '';
          parser.state = S.ATTRIB_VALUE_CLOSED;
          continue

        case S.ATTRIB_VALUE_CLOSED:
          if (isWhitespace(c)) {
            parser.state = S.ATTRIB;
          } else if (c === '>') {
            openTag(parser);
          } else if (c === '/') {
            parser.state = S.OPEN_TAG_SLASH;
          } else if (isMatch(nameStart, c)) {
            strictFail(parser, 'No whitespace between attributes');
            parser.attribName = c;
            parser.attribValue = '';
            parser.state = S.ATTRIB_NAME;
          } else {
            strictFail(parser, 'Invalid attribute name');
          }
          continue

        case S.ATTRIB_VALUE_UNQUOTED:
          if (!isAttribEnd(c)) {
            if (c === '&') {
              parser.state = S.ATTRIB_VALUE_ENTITY_U;
            } else {
              parser.attribValue += c;
            }
            continue
          }
          attrib(parser);
          if (c === '>') {
            openTag(parser);
          } else {
            parser.state = S.ATTRIB;
          }
          continue

        case S.CLOSE_TAG:
          if (!parser.tagName) {
            if (isWhitespace(c)) {
              continue
            } else if (notMatch(nameStart, c)) {
              if (parser.script) {
                parser.script += '</' + c;
                parser.state = S.SCRIPT;
              } else {
                strictFail(parser, 'Invalid tagname in closing tag.');
              }
            } else {
              parser.tagName = c;
            }
          } else if (c === '>') {
            closeTag(parser);
          } else if (isMatch(nameBody, c)) {
            parser.tagName += c;
          } else if (parser.script) {
            parser.script += '</' + parser.tagName;
            parser.tagName = '';
            parser.state = S.SCRIPT;
          } else {
            if (!isWhitespace(c)) {
              strictFail(parser, 'Invalid tagname in closing tag');
            }
            parser.state = S.CLOSE_TAG_SAW_WHITE;
          }
          continue

        case S.CLOSE_TAG_SAW_WHITE:
          if (isWhitespace(c)) {
            continue
          }
          if (c === '>') {
            closeTag(parser);
          } else {
            strictFail(parser, 'Invalid characters in closing tag');
          }
          continue

        case S.TEXT_ENTITY:
        case S.ATTRIB_VALUE_ENTITY_Q:
        case S.ATTRIB_VALUE_ENTITY_U:
          var returnState;
          var buffer;
          switch (parser.state) {
            case S.TEXT_ENTITY:
              returnState = S.TEXT;
              buffer = 'textNode';
              break

            case S.ATTRIB_VALUE_ENTITY_Q:
              returnState = S.ATTRIB_VALUE_QUOTED;
              buffer = 'attribValue';
              break

            case S.ATTRIB_VALUE_ENTITY_U:
              returnState = S.ATTRIB_VALUE_UNQUOTED;
              buffer = 'attribValue';
              break
          }

          if (c === ';') {
            parser[buffer] += parseEntity(parser);
            parser.entity = '';
            parser.state = returnState;
          } else if (isMatch(parser.entity.length ? entityBody : entityStart, c)) {
            parser.entity += c;
          } else {
            strictFail(parser, 'Invalid character in entity name');
            parser[buffer] += '&' + parser.entity + c;
            parser.entity = '';
            parser.state = returnState;
          }

          continue

        default:
          throw new Error(parser, 'Unknown state: ' + parser.state)
      }
    } // while

    if (parser.position >= parser.bufferCheckPosition) {
      checkBufferLength(parser);
    }
    return parser
  }

  /*! http://mths.be/fromcodepoint v0.1.0 by @mathias */
  /* istanbul ignore next */
  if (!String.fromCodePoint) {
    (function () {
      var stringFromCharCode = String.fromCharCode;
      var floor = Math.floor;
      var fromCodePoint = function () {
        var MAX_SIZE = 0x4000;
        var codeUnits = [];
        var highSurrogate;
        var lowSurrogate;
        var index = -1;
        var length = arguments.length;
        if (!length) {
          return ''
        }
        var result = '';
        while (++index < length) {
          var codePoint = Number(arguments[index]);
          if (
            !isFinite(codePoint) || // `NaN`, `+Infinity`, or `-Infinity`
            codePoint < 0 || // not a valid Unicode code point
            codePoint > 0x10FFFF || // not a valid Unicode code point
            floor(codePoint) !== codePoint // not an integer
          ) {
            throw RangeError('Invalid code point: ' + codePoint)
          }
          if (codePoint <= 0xFFFF) { // BMP code point
            codeUnits.push(codePoint);
          } else { // Astral code point; split in surrogate halves
            // http://mathiasbynens.be/notes/javascript-encoding#surrogate-formulae
            codePoint -= 0x10000;
            highSurrogate = (codePoint >> 10) + 0xD800;
            lowSurrogate = (codePoint % 0x400) + 0xDC00;
            codeUnits.push(highSurrogate, lowSurrogate);
          }
          if (index + 1 === length || codeUnits.length > MAX_SIZE) {
            result += stringFromCharCode.apply(null, codeUnits);
            codeUnits.length = 0;
          }
        }
        return result
      };
      /* istanbul ignore next */
      if (Object.defineProperty) {
        Object.defineProperty(String, 'fromCodePoint', {
          value: fromCodePoint,
          configurable: true,
          writable: true
        });
      } else {
        String.fromCodePoint = fromCodePoint;
      }
    }());
  }
})( exports);
});

var arrayHelper = {

  isArray: function(value) {
    if (Array.isArray) {
      return Array.isArray(value);
    }
    // fallback for older browsers like  IE 8
    return Object.prototype.toString.call( value ) === '[object Array]';
  }

};

var isArray$2 = arrayHelper.isArray;

var optionsHelper = {

  copyOptions: function (options) {
    var key, copy = {};
    for (key in options) {
      if (options.hasOwnProperty(key)) {
        copy[key] = options[key];
      }
    }
    return copy;
  },

  ensureFlagExists: function (item, options) {
    if (!(item in options) || typeof options[item] !== 'boolean') {
      options[item] = false;
    }
  },

  ensureSpacesExists: function (options) {
    if (!('spaces' in options) || (typeof options.spaces !== 'number' && typeof options.spaces !== 'string')) {
      options.spaces = 0;
    }
  },

  ensureAlwaysArrayExists: function (options) {
    if (!('alwaysArray' in options) || (typeof options.alwaysArray !== 'boolean' && !isArray$2(options.alwaysArray))) {
      options.alwaysArray = false;
    }
  },

  ensureKeyExists: function (key, options) {
    if (!(key + 'Key' in options) || typeof options[key + 'Key'] !== 'string') {
      options[key + 'Key'] = options.compact ? '_' + key : key;
    }
  },

  checkFnExists: function (key, options) {
    return key + 'Fn' in options;
  }

};

var isArray$3 = arrayHelper.isArray;

var options$1;
var currentElement;

function validateOptions(userOptions) {
  options$1 = optionsHelper.copyOptions(userOptions);
  optionsHelper.ensureFlagExists('ignoreDeclaration', options$1);
  optionsHelper.ensureFlagExists('ignoreInstruction', options$1);
  optionsHelper.ensureFlagExists('ignoreAttributes', options$1);
  optionsHelper.ensureFlagExists('ignoreText', options$1);
  optionsHelper.ensureFlagExists('ignoreComment', options$1);
  optionsHelper.ensureFlagExists('ignoreCdata', options$1);
  optionsHelper.ensureFlagExists('ignoreDoctype', options$1);
  optionsHelper.ensureFlagExists('compact', options$1);
  optionsHelper.ensureFlagExists('alwaysChildren', options$1);
  optionsHelper.ensureFlagExists('addParent', options$1);
  optionsHelper.ensureFlagExists('trim', options$1);
  optionsHelper.ensureFlagExists('nativeType', options$1);
  optionsHelper.ensureFlagExists('nativeTypeAttributes', options$1);
  optionsHelper.ensureFlagExists('sanitize', options$1);
  optionsHelper.ensureFlagExists('instructionHasAttributes', options$1);
  optionsHelper.ensureFlagExists('captureSpacesBetweenElements', options$1);
  optionsHelper.ensureAlwaysArrayExists(options$1);
  optionsHelper.ensureKeyExists('declaration', options$1);
  optionsHelper.ensureKeyExists('instruction', options$1);
  optionsHelper.ensureKeyExists('attributes', options$1);
  optionsHelper.ensureKeyExists('text', options$1);
  optionsHelper.ensureKeyExists('comment', options$1);
  optionsHelper.ensureKeyExists('cdata', options$1);
  optionsHelper.ensureKeyExists('doctype', options$1);
  optionsHelper.ensureKeyExists('type', options$1);
  optionsHelper.ensureKeyExists('name', options$1);
  optionsHelper.ensureKeyExists('elements', options$1);
  optionsHelper.ensureKeyExists('parent', options$1);
  optionsHelper.checkFnExists('doctype', options$1);
  optionsHelper.checkFnExists('instruction', options$1);
  optionsHelper.checkFnExists('cdata', options$1);
  optionsHelper.checkFnExists('comment', options$1);
  optionsHelper.checkFnExists('text', options$1);
  optionsHelper.checkFnExists('instructionName', options$1);
  optionsHelper.checkFnExists('elementName', options$1);
  optionsHelper.checkFnExists('attributeName', options$1);
  optionsHelper.checkFnExists('attributeValue', options$1);
  optionsHelper.checkFnExists('attributes', options$1);
  return options$1;
}

function nativeType(value) {
  var nValue = Number(value);
  if (!isNaN(nValue)) {
    return nValue;
  }
  var bValue = value.toLowerCase();
  if (bValue === 'true') {
    return true;
  } else if (bValue === 'false') {
    return false;
  }
  return value;
}

function addField(type, value) {
  var key;
  if (options$1.compact) {
    if (
      !currentElement[options$1[type + 'Key']] &&
      (isArray$3(options$1.alwaysArray) ? options$1.alwaysArray.indexOf(options$1[type + 'Key']) !== -1 : options$1.alwaysArray)
    ) {
      currentElement[options$1[type + 'Key']] = [];
    }
    if (currentElement[options$1[type + 'Key']] && !isArray$3(currentElement[options$1[type + 'Key']])) {
      currentElement[options$1[type + 'Key']] = [currentElement[options$1[type + 'Key']]];
    }
    if (type + 'Fn' in options$1 && typeof value === 'string') {
      value = options$1[type + 'Fn'](value, currentElement);
    }
    if (type === 'instruction' && ('instructionFn' in options$1 || 'instructionNameFn' in options$1)) {
      for (key in value) {
        if (value.hasOwnProperty(key)) {
          if ('instructionFn' in options$1) {
            value[key] = options$1.instructionFn(value[key], key, currentElement);
          } else {
            var temp = value[key];
            delete value[key];
            value[options$1.instructionNameFn(key, temp, currentElement)] = temp;
          }
        }
      }
    }
    if (isArray$3(currentElement[options$1[type + 'Key']])) {
      currentElement[options$1[type + 'Key']].push(value);
    } else {
      currentElement[options$1[type + 'Key']] = value;
    }
  } else {
    if (!currentElement[options$1.elementsKey]) {
      currentElement[options$1.elementsKey] = [];
    }
    var element = {};
    element[options$1.typeKey] = type;
    if (type === 'instruction') {
      for (key in value) {
        if (value.hasOwnProperty(key)) {
          break;
        }
      }
      element[options$1.nameKey] = 'instructionNameFn' in options$1 ? options$1.instructionNameFn(key, value, currentElement) : key;
      if (options$1.instructionHasAttributes) {
        element[options$1.attributesKey] = value[key][options$1.attributesKey];
        if ('instructionFn' in options$1) {
          element[options$1.attributesKey] = options$1.instructionFn(element[options$1.attributesKey], key, currentElement);
        }
      } else {
        if ('instructionFn' in options$1) {
          value[key] = options$1.instructionFn(value[key], key, currentElement);
        }
        element[options$1.instructionKey] = value[key];
      }
    } else {
      if (type + 'Fn' in options$1) {
        value = options$1[type + 'Fn'](value, currentElement);
      }
      element[options$1[type + 'Key']] = value;
    }
    if (options$1.addParent) {
      element[options$1.parentKey] = currentElement;
    }
    currentElement[options$1.elementsKey].push(element);
  }
}

function manipulateAttributes(attributes) {
  if ('attributesFn' in options$1 && attributes) {
    attributes = options$1.attributesFn(attributes, currentElement);
  }
  if ((options$1.trim || 'attributeValueFn' in options$1 || 'attributeNameFn' in options$1 || options$1.nativeTypeAttributes) && attributes) {
    var key;
    for (key in attributes) {
      if (attributes.hasOwnProperty(key)) {
        if (options$1.trim) attributes[key] = attributes[key].trim();
        if (options$1.nativeTypeAttributes) {
          attributes[key] = nativeType(attributes[key]);
        }
        if ('attributeValueFn' in options$1) attributes[key] = options$1.attributeValueFn(attributes[key], key, currentElement);
        if ('attributeNameFn' in options$1) {
          var temp = attributes[key];
          delete attributes[key];
          attributes[options$1.attributeNameFn(key, attributes[key], currentElement)] = temp;
        }
      }
    }
  }
  return attributes;
}

function onInstruction(instruction) {
  var attributes = {};
  if (instruction.body && (instruction.name.toLowerCase() === 'xml' || options$1.instructionHasAttributes)) {
    var attrsRegExp = /([\w:-]+)\s*=\s*(?:"([^"]*)"|'([^']*)'|(\w+))\s*/g;
    var match;
    while ((match = attrsRegExp.exec(instruction.body)) !== null) {
      attributes[match[1]] = match[2] || match[3] || match[4];
    }
    attributes = manipulateAttributes(attributes);
  }
  if (instruction.name.toLowerCase() === 'xml') {
    if (options$1.ignoreDeclaration) {
      return;
    }
    currentElement[options$1.declarationKey] = {};
    if (Object.keys(attributes).length) {
      currentElement[options$1.declarationKey][options$1.attributesKey] = attributes;
    }
    if (options$1.addParent) {
      currentElement[options$1.declarationKey][options$1.parentKey] = currentElement;
    }
  } else {
    if (options$1.ignoreInstruction) {
      return;
    }
    if (options$1.trim) {
      instruction.body = instruction.body.trim();
    }
    var value = {};
    if (options$1.instructionHasAttributes && Object.keys(attributes).length) {
      value[instruction.name] = {};
      value[instruction.name][options$1.attributesKey] = attributes;
    } else {
      value[instruction.name] = instruction.body;
    }
    addField('instruction', value);
  }
}

function onStartElement(name, attributes) {
  var element;
  if (typeof name === 'object') {
    attributes = name.attributes;
    name = name.name;
  }
  attributes = manipulateAttributes(attributes);
  if ('elementNameFn' in options$1) {
    name = options$1.elementNameFn(name, currentElement);
  }
  if (options$1.compact) {
    element = {};
    if (!options$1.ignoreAttributes && attributes && Object.keys(attributes).length) {
      element[options$1.attributesKey] = {};
      var key;
      for (key in attributes) {
        if (attributes.hasOwnProperty(key)) {
          element[options$1.attributesKey][key] = attributes[key];
        }
      }
    }
    if (
      !(name in currentElement) &&
      (isArray$3(options$1.alwaysArray) ? options$1.alwaysArray.indexOf(name) !== -1 : options$1.alwaysArray)
    ) {
      currentElement[name] = [];
    }
    if (currentElement[name] && !isArray$3(currentElement[name])) {
      currentElement[name] = [currentElement[name]];
    }
    if (isArray$3(currentElement[name])) {
      currentElement[name].push(element);
    } else {
      currentElement[name] = element;
    }
  } else {
    if (!currentElement[options$1.elementsKey]) {
      currentElement[options$1.elementsKey] = [];
    }
    element = {};
    element[options$1.typeKey] = 'element';
    element[options$1.nameKey] = name;
    if (!options$1.ignoreAttributes && attributes && Object.keys(attributes).length) {
      element[options$1.attributesKey] = attributes;
    }
    if (options$1.alwaysChildren) {
      element[options$1.elementsKey] = [];
    }
    currentElement[options$1.elementsKey].push(element);
  }
  element[options$1.parentKey] = currentElement; // will be deleted in onEndElement() if !options.addParent
  currentElement = element;
}

function onText(text) {
  if (options$1.ignoreText) {
    return;
  }
  if (!text.trim() && !options$1.captureSpacesBetweenElements) {
    return;
  }
  if (options$1.trim) {
    text = text.trim();
  }
  if (options$1.nativeType) {
    text = nativeType(text);
  }
  if (options$1.sanitize) {
    text = text.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
  }
  addField('text', text);
}

function onComment(comment) {
  if (options$1.ignoreComment) {
    return;
  }
  if (options$1.trim) {
    comment = comment.trim();
  }
  addField('comment', comment);
}

function onEndElement(name) {
  var parentElement = currentElement[options$1.parentKey];
  if (!options$1.addParent) {
    delete currentElement[options$1.parentKey];
  }
  currentElement = parentElement;
}

function onCdata(cdata) {
  if (options$1.ignoreCdata) {
    return;
  }
  if (options$1.trim) {
    cdata = cdata.trim();
  }
  addField('cdata', cdata);
}

function onDoctype(doctype) {
  if (options$1.ignoreDoctype) {
    return;
  }
  doctype = doctype.replace(/^ /, '');
  if (options$1.trim) {
    doctype = doctype.trim();
  }
  addField('doctype', doctype);
}

function onError$1(error) {
  error.note = error; //console.error(error);
}

var xml2js = function (xml, userOptions) {

  var parser =  sax.parser(true, {}) ;
  var result = {};
  currentElement = result;

  options$1 = validateOptions(userOptions);

  {
    parser.opt = {strictEntities: true};
    parser.onopentag = onStartElement;
    parser.ontext = onText;
    parser.oncomment = onComment;
    parser.onclosetag = onEndElement;
    parser.onerror = onError$1;
    parser.oncdata = onCdata;
    parser.ondoctype = onDoctype;
    parser.onprocessinginstruction = onInstruction;
  }

  {
    parser.write(xml).close();
  }

  if (result[options$1.elementsKey]) {
    var temp = result[options$1.elementsKey];
    delete result[options$1.elementsKey];
    result[options$1.elementsKey] = temp;
    delete result.text;
  }

  return result;

};

function validateOptions$1 (userOptions) {
  var options = optionsHelper.copyOptions(userOptions);
  optionsHelper.ensureSpacesExists(options);
  return options;
}

var xml2json = function(xml, userOptions) {
  var options, js, json, parentKey;
  options = validateOptions$1(userOptions);
  js = xml2js(xml, options);
  parentKey = 'compact' in options && options.compact ? '_parent' : 'parent';
  // parentKey = ptions.compact ? '_parent' : 'parent'; // consider this
  if ('addParent' in options && options.addParent) {
    json = JSON.stringify(js, function (k, v) { return k === parentKey? '_' : v; }, options.spaces);
  } else {
    json = JSON.stringify(js, null, options.spaces);
  }
  return json.replace(/\u2028/g, '\\u2028').replace(/\u2029/g, '\\u2029');
};

var isArray$4 = arrayHelper.isArray;

var currentElement$1, currentElementName;

function validateOptions$2(userOptions) {
  var options = optionsHelper.copyOptions(userOptions);
  optionsHelper.ensureFlagExists('ignoreDeclaration', options);
  optionsHelper.ensureFlagExists('ignoreInstruction', options);
  optionsHelper.ensureFlagExists('ignoreAttributes', options);
  optionsHelper.ensureFlagExists('ignoreText', options);
  optionsHelper.ensureFlagExists('ignoreComment', options);
  optionsHelper.ensureFlagExists('ignoreCdata', options);
  optionsHelper.ensureFlagExists('ignoreDoctype', options);
  optionsHelper.ensureFlagExists('compact', options);
  optionsHelper.ensureFlagExists('indentText', options);
  optionsHelper.ensureFlagExists('indentCdata', options);
  optionsHelper.ensureFlagExists('indentAttributes', options);
  optionsHelper.ensureFlagExists('indentInstruction', options);
  optionsHelper.ensureFlagExists('fullTagEmptyElement', options);
  optionsHelper.ensureFlagExists('noQuotesForNativeAttributes', options);
  optionsHelper.ensureSpacesExists(options);
  if (typeof options.spaces === 'number') {
    options.spaces = Array(options.spaces + 1).join(' ');
  }
  optionsHelper.ensureKeyExists('declaration', options);
  optionsHelper.ensureKeyExists('instruction', options);
  optionsHelper.ensureKeyExists('attributes', options);
  optionsHelper.ensureKeyExists('text', options);
  optionsHelper.ensureKeyExists('comment', options);
  optionsHelper.ensureKeyExists('cdata', options);
  optionsHelper.ensureKeyExists('doctype', options);
  optionsHelper.ensureKeyExists('type', options);
  optionsHelper.ensureKeyExists('name', options);
  optionsHelper.ensureKeyExists('elements', options);
  optionsHelper.checkFnExists('doctype', options);
  optionsHelper.checkFnExists('instruction', options);
  optionsHelper.checkFnExists('cdata', options);
  optionsHelper.checkFnExists('comment', options);
  optionsHelper.checkFnExists('text', options);
  optionsHelper.checkFnExists('instructionName', options);
  optionsHelper.checkFnExists('elementName', options);
  optionsHelper.checkFnExists('attributeName', options);
  optionsHelper.checkFnExists('attributeValue', options);
  optionsHelper.checkFnExists('attributes', options);
  optionsHelper.checkFnExists('fullTagEmptyElement', options);
  return options;
}

function writeIndentation(options, depth, firstLine) {
  return (!firstLine && options.spaces ? '\n' : '') + Array(depth + 1).join(options.spaces);
}

function writeAttributes(attributes, options, depth) {
  if (options.ignoreAttributes) {
    return '';
  }
  if ('attributesFn' in options) {
    attributes = options.attributesFn(attributes, currentElementName, currentElement$1);
  }
  var key, attr, attrName, quote, result = [];
  for (key in attributes) {
    if (attributes.hasOwnProperty(key) && attributes[key] !== null && attributes[key] !== undefined) {
      quote = options.noQuotesForNativeAttributes && typeof attributes[key] !== 'string' ? '' : '"';
      attr = '' + attributes[key]; // ensure number and boolean are converted to String
      attr = attr.replace(/"/g, '&quot;');
      attrName = 'attributeNameFn' in options ? options.attributeNameFn(key, attr, currentElementName, currentElement$1) : key;
      result.push((options.spaces && options.indentAttributes? writeIndentation(options, depth+1, false) : ' '));
      result.push(attrName + '=' + quote + ('attributeValueFn' in options ? options.attributeValueFn(attr, key, currentElementName, currentElement$1) : attr) + quote);
    }
  }
  if (attributes && Object.keys(attributes).length && options.spaces && options.indentAttributes) {
    result.push(writeIndentation(options, depth, false));
  }
  return result.join('');
}

function writeDeclaration(declaration, options, depth) {
  currentElement$1 = declaration;
  currentElementName = 'xml';
  return options.ignoreDeclaration ? '' :  '<?' + 'xml' + writeAttributes(declaration[options.attributesKey], options, depth) + '?>';
}

function writeInstruction(instruction, options, depth) {
  if (options.ignoreInstruction) {
    return '';
  }
  var key;
  for (key in instruction) {
    if (instruction.hasOwnProperty(key)) {
      break;
    }
  }
  var instructionName = 'instructionNameFn' in options ? options.instructionNameFn(key, instruction[key], currentElementName, currentElement$1) : key;
  if (typeof instruction[key] === 'object') {
    currentElement$1 = instruction;
    currentElementName = instructionName;
    return '<?' + instructionName + writeAttributes(instruction[key][options.attributesKey], options, depth) + '?>';
  } else {
    var instructionValue = instruction[key] ? instruction[key] : '';
    if ('instructionFn' in options) instructionValue = options.instructionFn(instructionValue, key, currentElementName, currentElement$1);
    return '<?' + instructionName + (instructionValue ? ' ' + instructionValue : '') + '?>';
  }
}

function writeComment(comment, options) {
  return options.ignoreComment ? '' : '<!--' + ('commentFn' in options ? options.commentFn(comment, currentElementName, currentElement$1) : comment) + '-->';
}

function writeCdata(cdata, options) {
  return options.ignoreCdata ? '' : '<![CDATA[' + ('cdataFn' in options ? options.cdataFn(cdata, currentElementName, currentElement$1) : cdata.replace(']]>', ']]]]><![CDATA[>')) + ']]>';
}

function writeDoctype(doctype, options) {
  return options.ignoreDoctype ? '' : '<!DOCTYPE ' + ('doctypeFn' in options ? options.doctypeFn(doctype, currentElementName, currentElement$1) : doctype) + '>';
}

function writeText(text, options) {
  if (options.ignoreText) return '';
  text = '' + text; // ensure Number and Boolean are converted to String
  text = text.replace(/&amp;/g, '&'); // desanitize to avoid double sanitization
  text = text.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
  return 'textFn' in options ? options.textFn(text, currentElementName, currentElement$1) : text;
}

function hasContent(element, options) {
  var i;
  if (element.elements && element.elements.length) {
    for (i = 0; i < element.elements.length; ++i) {
      switch (element.elements[i][options.typeKey]) {
      case 'text':
        if (options.indentText) {
          return true;
        }
        break; // skip to next key
      case 'cdata':
        if (options.indentCdata) {
          return true;
        }
        break; // skip to next key
      case 'instruction':
        if (options.indentInstruction) {
          return true;
        }
        break; // skip to next key
      case 'doctype':
      case 'comment':
      case 'element':
        return true;
      default:
        return true;
      }
    }
  }
  return false;
}

function writeElement(element, options, depth) {
  currentElement$1 = element;
  currentElementName = element.name;
  var xml = [], elementName = 'elementNameFn' in options ? options.elementNameFn(element.name, element) : element.name;
  xml.push('<' + elementName);
  if (element[options.attributesKey]) {
    xml.push(writeAttributes(element[options.attributesKey], options, depth));
  }
  var withClosingTag = element[options.elementsKey] && element[options.elementsKey].length || element[options.attributesKey] && element[options.attributesKey]['xml:space'] === 'preserve';
  if (!withClosingTag) {
    if ('fullTagEmptyElementFn' in options) {
      withClosingTag = options.fullTagEmptyElementFn(element.name, element);
    } else {
      withClosingTag = options.fullTagEmptyElement;
    }
  }
  if (withClosingTag) {
    xml.push('>');
    if (element[options.elementsKey] && element[options.elementsKey].length) {
      xml.push(writeElements(element[options.elementsKey], options, depth + 1));
      currentElement$1 = element;
      currentElementName = element.name;
    }
    xml.push(options.spaces && hasContent(element, options) ? '\n' + Array(depth + 1).join(options.spaces) : '');
    xml.push('</' + elementName + '>');
  } else {
    xml.push('/>');
  }
  return xml.join('');
}

function writeElements(elements, options, depth, firstLine) {
  return elements.reduce(function (xml, element) {
    var indent = writeIndentation(options, depth, firstLine && !xml);
    switch (element.type) {
    case 'element': return xml + indent + writeElement(element, options, depth);
    case 'comment': return xml + indent + writeComment(element[options.commentKey], options);
    case 'doctype': return xml + indent + writeDoctype(element[options.doctypeKey], options);
    case 'cdata': return xml + (options.indentCdata ? indent : '') + writeCdata(element[options.cdataKey], options);
    case 'text': return xml + (options.indentText ? indent : '') + writeText(element[options.textKey], options);
    case 'instruction':
      var instruction = {};
      instruction[element[options.nameKey]] = element[options.attributesKey] ? element : element[options.instructionKey];
      return xml + (options.indentInstruction ? indent : '') + writeInstruction(instruction, options, depth);
    }
  }, '');
}

function hasContentCompact(element, options, anyContent) {
  var key;
  for (key in element) {
    if (element.hasOwnProperty(key)) {
      switch (key) {
      case options.parentKey:
      case options.attributesKey:
        break; // skip to next key
      case options.textKey:
        if (options.indentText || anyContent) {
          return true;
        }
        break; // skip to next key
      case options.cdataKey:
        if (options.indentCdata || anyContent) {
          return true;
        }
        break; // skip to next key
      case options.instructionKey:
        if (options.indentInstruction || anyContent) {
          return true;
        }
        break; // skip to next key
      case options.doctypeKey:
      case options.commentKey:
        return true;
      default:
        return true;
      }
    }
  }
  return false;
}

function writeElementCompact(element, name, options, depth, indent) {
  currentElement$1 = element;
  currentElementName = name;
  var elementName = 'elementNameFn' in options ? options.elementNameFn(name, element) : name;
  if (typeof element === 'undefined' || element === null || element === '') {
    return 'fullTagEmptyElementFn' in options && options.fullTagEmptyElementFn(name, element) || options.fullTagEmptyElement ? '<' + elementName + '></' + elementName + '>' : '<' + elementName + '/>';
  }
  var xml = [];
  if (name) {
    xml.push('<' + elementName);
    if (typeof element !== 'object') {
      xml.push('>' + writeText(element,options) + '</' + elementName + '>');
      return xml.join('');
    }
    if (element[options.attributesKey]) {
      xml.push(writeAttributes(element[options.attributesKey], options, depth));
    }
    var withClosingTag = hasContentCompact(element, options, true) || element[options.attributesKey] && element[options.attributesKey]['xml:space'] === 'preserve';
    if (!withClosingTag) {
      if ('fullTagEmptyElementFn' in options) {
        withClosingTag = options.fullTagEmptyElementFn(name, element);
      } else {
        withClosingTag = options.fullTagEmptyElement;
      }
    }
    if (withClosingTag) {
      xml.push('>');
    } else {
      xml.push('/>');
      return xml.join('');
    }
  }
  xml.push(writeElementsCompact(element, options, depth + 1, false));
  currentElement$1 = element;
  currentElementName = name;
  if (name) {
    xml.push((indent ? writeIndentation(options, depth, false) : '') + '</' + elementName + '>');
  }
  return xml.join('');
}

function writeElementsCompact(element, options, depth, firstLine) {
  var i, key, nodes, xml = [];
  for (key in element) {
    if (element.hasOwnProperty(key)) {
      nodes = isArray$4(element[key]) ? element[key] : [element[key]];
      for (i = 0; i < nodes.length; ++i) {
        switch (key) {
        case options.declarationKey: xml.push(writeDeclaration(nodes[i], options, depth)); break;
        case options.instructionKey: xml.push((options.indentInstruction ? writeIndentation(options, depth, firstLine) : '') + writeInstruction(nodes[i], options, depth)); break;
        case options.attributesKey: case options.parentKey: break; // skip
        case options.textKey: xml.push((options.indentText ? writeIndentation(options, depth, firstLine) : '') + writeText(nodes[i], options)); break;
        case options.cdataKey: xml.push((options.indentCdata ? writeIndentation(options, depth, firstLine) : '') + writeCdata(nodes[i], options)); break;
        case options.doctypeKey: xml.push(writeIndentation(options, depth, firstLine) + writeDoctype(nodes[i], options)); break;
        case options.commentKey: xml.push(writeIndentation(options, depth, firstLine) + writeComment(nodes[i], options)); break;
        default: xml.push(writeIndentation(options, depth, firstLine) + writeElementCompact(nodes[i], key, options, depth, hasContentCompact(nodes[i], options)));
        }
        firstLine = firstLine && !xml.length;
      }
    }
  }
  return xml.join('');
}

var js2xml = function (js, options) {
  options = validateOptions$2(options);
  var xml = [];
  currentElement$1 = js;
  currentElementName = '_root_';
  if (options.compact) {
    xml.push(writeElementsCompact(js, options, 0, true));
  } else {
    if (js[options.declarationKey]) {
      xml.push(writeDeclaration(js[options.declarationKey], options, 0));
    }
    if (js[options.elementsKey] && js[options.elementsKey].length) {
      xml.push(writeElements(js[options.elementsKey], options, 0, !xml.length));
    }
  }
  return xml.join('');
};

var json2xml = function (json, options) {
  if (json instanceof Buffer$1) {
    json = json.toString();
  }
  var js = null;
  if (typeof (json) === 'string') {
    try {
      js = JSON.parse(json);
    } catch (e) {
      throw new Error('The JSON structure is invalid');
    }
  } else {
    js = json;
  }
  return js2xml(js, options);
};

/*jslint node:true */






var lib$1 = {
  xml2js: xml2js,
  xml2json: xml2json,
  js2xml: js2xml,
  json2xml: json2xml
};

var string = createCommonjsModule(function (module, exports) {
Object.defineProperty(exports, "__esModule", { value: true });
function stripCDATA(str) {
    return str
        .replace("<![CDATA[", "")
        .replace("]]>", "")
        .trim();
}
exports.stripCDATA = stripCDATA;
function hasCDATA(str) {
    return str && str.indexOf("<![CDATA[") !== -1;
}
exports.hasCDATA = hasCDATA;

});

unwrapExports(string);
var string_1 = string.stripCDATA;
var string_2 = string.hasCDATA;

var vastElement = createCommonjsModule(function (module, exports) {
var __extends = (commonjsGlobal && commonjsGlobal.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (commonjsGlobal && commonjsGlobal.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });




var xmlDeclaration = {
    _declaration: {
        _attributes: {
            encoding: "utf-8",
            version: "1.0"
        }
    }
};
var VastElement = /** @class */ (function () {
    function VastElement(name, parent, baseInfos, contentOrAttributes, attributesIfContent) {
        if (name === void 0) { name = "root"; }
        if (parent === void 0) { parent = null; }
        if (baseInfos === void 0) { baseInfos = { attrs: [] }; }
        this.parent = parent;
        this.name = name;
        if (typeof contentOrAttributes === "string") {
            if (string.hasCDATA(contentOrAttributes)) {
                this.cdataThisOne = true;
            }
            this.content = string.stripCDATA(contentOrAttributes);
            this.attrs = attributesIfContent || {};
        }
        else {
            this.content = null;
            this.attrs = contentOrAttributes || {};
        }
        this.childs = [];
        this.infos = {
            attrs: baseInfos.attrs || []
        };
        this.parseOptions((parent && parent.options) || {});
    }
    // > Get the node name
    // * getName(): string
    VastElement.prototype.getName = function () {
        return this.name;
    };
    // > alias for and()
    // * getParent(): Object
    VastElement.prototype.getParent = function () {
        return this.and();
    };
    // > Get filtered attributes (only specs valids one will be returned)
    // * getContent(): string
    VastElement.prototype.getContent = function () {
        return this.content;
    };
    VastElement.prototype.getInfos = function () {
        return this.infos;
    };
    // > Get a specific attr, it's case insensitive (only specs valids one will be returned)
    // * getAttr(attributeName: string): string
    VastElement.prototype.getAttr = function (attributeName) {
        var baseAttrs = this.getValidAttrs();
        var lowerCasedAttrs = Object.keys(this.getValidAttrs()).reduce(function (prev, next) {
            prev[next.toLowerCase()] = baseAttrs[next];
            return prev;
        }, {});
        return lowerCasedAttrs[attributeName.toLowerCase()];
    };
    // > Get filtered attributes (only specs valids one will be returned)
    // * getValidAttrs(): Object
    VastElement.prototype.getValidAttrs = function () {
        var _this = this;
        if (this.infos.attrs === "all") {
            return this.attrs;
        }
        else {
            return Object.keys(this.attrs).reduce(function (prev, next) {
                var _a;
                if (_this.infos.attrs.indexOf(next) !== -1) {
                    return __assign({}, prev, (_a = {}, _a[next] = _this.attrs[next], _a));
                }
                else {
                    logs.warnOrThrow("WARNING: the attribute \"" + next + "\" does not exists in \"" + _this.name + "\" Tag. It was ignored.\n            Here is the allowed list: " + _this.infos.attrs, _this.options);
                    return prev;
                }
            }, {});
        }
    };
    /** @deprecated “getAttrs()“ method is deprecated, use getValidAttrs() instead. */
    VastElement.prototype.getAttrs = function () {
        logs.logWarn("“getAttrs()“ method is deprecated, use getValidAttrs() instead.");
        return this.getValidAttrs();
    };
    // > return the parent element
    // * and(): VastElement
    VastElement.prototype.and = function () {
        return this.parent;
    };
    // > alias for .and().and()
    // * back(): VastElement
    VastElement.prototype.back = function () {
        return this.and().and();
    };
    // > force element content into cdata. return the current element
    // * cdata(): VastElement
    VastElement.prototype.cdata = function () {
        this.cdataThisOne = true;
        return this;
    };
    // > force element content into text. return the current element
    // * text(): VastElement
    VastElement.prototype.text = function () {
        this.cdataThisOne = false;
        return this;
    };
    VastElement.prototype.attachCustomTag = function (tagName, contentOrAttributes, attributesIfContent) {
        var newElem = new VastElement(tagName, this, { attrs: "all" }, contentOrAttributes, attributesIfContent);
        this.childs.push(newElem);
        return newElem;
    };
    VastElement.prototype.addCustomTag = function (tagName, contentOrAttributes, attributesIfContent) {
        return this.attachCustomTag(tagName, 
        // allow fallback on attachCustomTag overload
        contentOrAttributes, attributesIfContent).and();
    };
    // undocumented
    VastElement.prototype.hasAttrs = function () {
        return Object.keys(this.attrs).length > 0;
    };
    // undocumented
    // return a JS object
    VastElement.prototype.getJson = function () {
        var childCode = {};
        this.childs.forEach(function (child) {
            childCode[child.name] = childCode[child.name] || [];
            var childJson = child.getJson();
            if (Object.keys(childJson).length > 0) {
                childCode[child.name].push(childJson);
            }
        });
        var jsonVast = {};
        if (this.hasAttrs()) {
            jsonVast._attributes = this.getValidAttrs();
        }
        if (this.content) {
            if (this.cdataThisOne === true ||
                (this.cdataThisOne !== false && this.options.cdata)) {
                jsonVast._cdata = this.content;
            }
            else {
                jsonVast._text = this.content;
            }
        }
        return __assign({}, jsonVast, childCode);
    };
    // > Return the root VastElement
    // * getRoot(): VastElement
    VastElement.prototype.getRoot = function () {
        var parent = this.parent || this;
        while (parent.parent) {
            parent = parent.parent;
        }
        return parent;
    };
    // > Return the generated Vast string
    // * toXml(): string
    VastElement.prototype.toXml = function () {
        // todo, manage this
        // if (this.options.validateOnBuild) {
        //   this.validate();
        // }
        return lib$1.js2xml(__assign({}, xmlDeclaration, this.getRoot().getJson()), __assign({ compact: true }, this.options));
    };
    // > return the current VAST api version
    // * getVastVersion(): number
    VastElement.prototype.getVastVersion = function () {
        return parseInt(this.getVersionRaw());
    };
    // > return the current VAST api version in snake case
    // * getVastSnakeVersion(): string
    VastElement.prototype.getVastSnakeVersion = function () {
        return this.getVersionRaw().replace(".", "_");
    };
    // > return an array all direct childs with "name"
    // * getChilds(name: string): Array<VastElement>
    VastElement.prototype.getChilds = function (name) {
        return this.childs.filter(function (c) { return c.name === name; });
    };
    // > return an array of all childs find recursively at "arrayOfNames" path in the hierarchy
    // * getChilds(arrayOfNames: Array<string>, fromRoot: boolean = true): Array<VastElement>
    VastElement.prototype.get = function (arrayOfTagNames, fromRoot) {
        if (arrayOfTagNames === void 0) { arrayOfTagNames = []; }
        if (fromRoot === void 0) { fromRoot = true; }
        if (arrayOfTagNames.length === 0) {
            return [this];
        }
        var findedNodes = [];
        var node = fromRoot ? this.getRoot() : this;
        Object.keys(node.childs).forEach(function (key) {
            var child = node.childs[key];
            if (child.name === arrayOfTagNames[0]) {
                if (arrayOfTagNames.length === 1) {
                    findedNodes.push(child);
                }
                else {
                    findedNodes.push(child.get(arrayOfTagNames.slice(1), false));
                }
            }
            else {
                findedNodes.push(child.get(arrayOfTagNames, false));
            }
        });
        return arrayFlatten(findedNodes);
    };
    VastElement.prototype.getCustom = function (arrayOfTagNames, fromRoot) {
        if (arrayOfTagNames === void 0) { arrayOfTagNames = []; }
        if (fromRoot === void 0) { fromRoot = true; }
        return this.get(arrayOfTagNames, fromRoot);
    };
    // > Return if current VastElement hierarchie is a Wrapper
    // * isWrapper(): boolean
    VastElement.prototype.isWrapper = function () {
        return this.get(["Wrapper"]).length > 0;
    };
    // undocumented
    VastElement.prototype.parseOptions = function (options) {
        this.options = __assign({ cdata: true, logWarn: true, spaces: 2, throwOnError: false }, options);
    };
    // undocumented
    VastElement.prototype.getVersionRaw = function () {
        return this.getRoot()
            .getChilds("VAST")[0]
            .getAttr("version");
    };
    return VastElement;
}());
exports.default = VastElement;
// mainly used in tests to simulate VastElement root from build/api
var VastElementRoot = /** @class */ (function (_super) {
    __extends(VastElementRoot, _super);
    function VastElementRoot() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    VastElementRoot.prototype.and = function () {
        return this;
    };
    return VastElementRoot;
}(VastElement));
exports.VastElementRoot = VastElementRoot;

});

unwrapExports(vastElement);
var vastElement_1 = vastElement.VastElementRoot;

var fetch_browser = createCommonjsModule(function (module, exports) {
Object.defineProperty(exports, "__esModule", { value: true });
function fetchUrl(_a) {
    var url = _a.url, _b = _a.loadCallback, loadCallback = _b === void 0 ? function () { } : _b, _c = _a.syncInBrowser, syncInBrowser = _c === void 0 ? false : _c;
    if (!url) {
        throw new Error("'url' is undefined");
    }
    var fail = function () {
        throw new Error(url + " fetch failed");
    };
    var fetchReq = new XMLHttpRequest();
    if (syncInBrowser) {
        fetchReq.open("GET", url, false);
        fetchReq.send();
        if (fetchReq.status >= 200 && fetchReq.status < 400) {
            loadCallback(fetchReq.responseText);
            return fetchReq.responseText;
        }
        else {
            fail();
        }
    }
    else {
        fetchReq.open("GET", url, true);
        fetchReq.onerror = fail;
        fetchReq.onload = function (res) {
            loadCallback(res.responseText);
        };
        fetchReq.send();
    }
}
exports.fetchUrl = fetchUrl;

});

unwrapExports(fetch_browser);
var fetch_browser_1 = fetch_browser.fetchUrl;

var vast = createCommonjsModule(function (module, exports) {
var __assign = (commonjsGlobal && commonjsGlobal.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });




function buildVast(current, currentTag) {
    /* istanbul ignore next */
    if (current && current.elements) {
        if (current.elements.length === 1 &&
            (current.elements[0].text || current.elements[0].cdata)) {
            var currentTmp = current.elements[0];
            var currentText = String(currentTmp.text || currentTmp.cdata);
            currentTag.content = currentText;
        }
        else {
            var currentChild = void 0;
            for (var i = 0; i < current.elements.length; i++) {
                var currentTmp = current.elements[i];
                // TODO refacto attachCustomTag from real tag for better integration
                // and fallback on dangerous
                currentChild = currentTag.attachCustomTag(currentTmp.name, currentTmp.attributes);
                buildVast(currentTmp, currentChild);
            }
        }
    }
}
exports.buildVast = buildVast;
// TODO this is only exported for test, it should not be
function createVastWithBuilder(vastRawCode, options) {
    if (options === void 0) { options = {}; }
    options = __assign({ logWarn: false }, options);
    var parsedXml;
    try {
        parsedXml = lib$1.xml2js(vastRawCode);
    }
    catch (e) {
        logs.warnOrThrow("Error during the vast parsing, it seems not valid XML", options);
    }
    return createVastFromJson(parsedXml);
}
exports.createVastWithBuilder = createVastWithBuilder;
function createVastFromJson(vastJsonCode, options) {
    if (options === void 0) { options = {}; }
    options = __assign({ logWarn: false }, options);
    var root = new vastElement.default();
    root.parseOptions(options);
    buildVast(vastJsonCode, root);
    return root;
}
function downloadVastAndWrappersSync(vastUrl, options) {
    var vastAndWrappers = [];
    var currentVast;
    do {
        var vastRawContent = fetch_browser.fetchUrl({ url: replaceMacros(vastUrl, options.macrosToReplace), syncInBrowser: true });
        currentVast = createVastWithBuilder(vastRawContent);
        vastAndWrappers.push(currentVast);
        if (currentVast.isWrapper()) {
            var VASTAdTagURI = currentVast.get(["VASTAdTagURI"])[0];
            if (VASTAdTagURI) {
                vastUrl = VASTAdTagURI.getContent();
            }
        }
    } while (currentVast.isWrapper());
    return vastAndWrappers;
}
exports.downloadVastAndWrappersSync = downloadVastAndWrappersSync;
function replaceMacros(vastUrl, macrosToReplace) {
    if (macrosToReplace === void 0) { macrosToReplace = []; }
    return macrosToReplace.reduce(function (acc, _a) {
        var key = _a.key, value = _a.value;
        return acc.replace(new RegExp("(#{|\\[)" + key + "(}|\\])"), value);
    }, vastUrl);
}
exports.replaceMacros = replaceMacros;
function downloadVastAndWrappersAsync(vastUrl, options, callback, actualDownloadedVasts) {
    var vastAndWrappers = actualDownloadedVasts || [];
    var currentVast;
    fetch_browser.fetchUrl({
        loadCallback: function (vastRawContent) {
            currentVast = createVastWithBuilder(vastRawContent);
            vastAndWrappers.push(currentVast);
            if (currentVast.isWrapper()) {
                var VASTAdTagURI = currentVast.get(["VASTAdTagURI"])[0];
                if (VASTAdTagURI) {
                    vastUrl = VASTAdTagURI.getContent();
                }
                downloadVastAndWrappersAsync(vastUrl, options, callback, vastAndWrappers);
            }
            else {
                callback(vastAndWrappers);
            }
        },
        syncInBrowser: true,
        url: replaceMacros(vastUrl, options.macrosToReplace)
    });
}
exports.downloadVastAndWrappersAsync = downloadVastAndWrappersAsync;

});

unwrapExports(vast);
var vast_1 = vast.buildVast;
var vast_2 = vast.createVastWithBuilder;
var vast_3 = vast.downloadVastAndWrappersSync;
var vast_4 = vast.replaceMacros;
var vast_5 = vast.downloadVastAndWrappersAsync;

var parser = createCommonjsModule(function (module, exports) {
Object.defineProperty(exports, "__esModule", { value: true });





var VastParser = /** @class */ (function () {
    function VastParser(options) {
        if (options === void 0) { options = {}; }
        this.options = options;
        this.vasts = [];
    }
    /**
     * Usefull for tests, this method does not fetch anything. You can add wrappers and inlines manually.
     */
    VastParser.prototype.addVastWithoutFetching = function (vastXML) {
        this.vasts.push(vast.createVastWithBuilder(vastXML));
    };
    VastParser.prototype.parseAsync = function (vastUrl, callback) {
        var _this = this;
        this.cleanVasts();
        vast.downloadVastAndWrappersAsync(vastUrl, this.options, function (vasts) {
            _this.vasts = vasts;
            callback(_this);
        });
    };
    VastParser.prototype.parseSync = function (vastUrl) {
        this.cleanVasts();
        if (lib.isNode) {
            throw new Error("parseSync is only available in a browser context");
        }
        this.vasts = vast.downloadVastAndWrappersSync(vastUrl, this.options);
        return this;
    };
    VastParser.prototype.getVasts = function () {
        return this.vasts;
    };
    VastParser.prototype.getVastElements = function (arrayOfTagNames) {
        var vastElements = arrayFlatten(this.vasts.map(function (v) { return v.get(arrayOfTagNames, true); }));
        return vastElements;
    };
    VastParser.prototype.getCustomVastElements = function (arrayOfTagNames) {
        return this.getVastElements(arrayOfTagNames);
    };
    VastParser.prototype.getContents = function (arrayOfTagNames) {
        var _this = this;
        return this.getVastElements(arrayOfTagNames)
            .map(function (vastElement) {
            if (checks.isNull(vastElement.content)) {
                logs.warnOrThrow(vastElement.name + " does not have content", _this.options);
            }
            return vastElement.content;
        })
            .filter(function (x) { return x; });
    };
    VastParser.prototype.getCustomContents = function (arrayOfTagNames) {
        return this.getContents(arrayOfTagNames);
    };
    VastParser.prototype.getAttributes = function (arrayOfTagNames, attribute) {
        var _this = this;
        return this.getVastElements(arrayOfTagNames)
            .map(function (vastElement) {
            var attributeLowerCased = {};
            Object.keys(vastElement.attrs).forEach(function (attr) {
                attributeLowerCased[attr.toLowerCase()] = vastElement.attrs[attr];
            });
            if (checks.isNull(attributeLowerCased[attribute.toLowerCase()])) {
                logs.warnOrThrow(vastElement.name + " does not have attribute " + attribute, _this.options);
            }
            return attributeLowerCased[attribute.toLowerCase()];
        })
            .filter(function (x) { return x; });
    };
    VastParser.prototype.getCustomAttributes = function (arrayOfTagNames, attribute) {
        return this.getAttributes(arrayOfTagNames, attribute);
    };
    VastParser.prototype.cleanVasts = function () {
        this.vasts = [];
    };
    return VastParser;
}());
exports.default = VastParser;

});

var VastParser = unwrapExports(parser);

var decodeHTMLEntities = function decodeHTMLEntities(text) {
  var textArea = document.createElement('textarea');
  textArea.innerHTML = text;
  return textArea.value;
};

var createURLBlob = function createURLBlob(value, typeOfBlob) {
  var blob = new Blob([value], {
    type: typeOfBlob
  });
  return URL.createObjectURL(blob);
};
var createURLBlobXML = function createURLBlobXML(value) {
  return createURLBlob(decodeHTMLEntities(value), 'text/xml');
};

var TAG_MEDIA_FILE = 'MediaFile';
var TAG_WRAPPER = 'Wrapper';
var TAG_VAST_AD_URI = 'VASTAdTagURI';
var TAG_DAAST_AD_URI = 'DAASTAdTagURI';

var parseRecursive = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee(vastParser, allowedRecurses) {
    var VASTAdTagURIContents, DAASTAdTagURIContents, newURI, vastAdTagURI, isWrapper;
    return regenerator.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (allowedRecurses) {
              _context.next = 2;
              break;
            }

            return _context.abrupt("return");

          case 2:
            _context.prev = 2;
            VASTAdTagURIContents = vastParser.getContents([TAG_VAST_AD_URI])[0];
            DAASTAdTagURIContents = vastParser.getContents([TAG_DAAST_AD_URI])[0];
            newURI = new URL(VASTAdTagURIContents || DAASTAdTagURIContents);
            newURI.searchParams.set('correlator', Math.floor(Math.random() * Date.now()));
            vastAdTagURI = newURI.toString();
            vastParser.cleanVasts();
            _context.next = 11;
            return new Promise(function (resolve) {
              vastParser.parseAsync(vastAdTagURI, resolve);
            });

          case 11:
            isWrapper = vastParser.getVastElements([TAG_WRAPPER]).length && !vastParser.getVastElements([TAG_MEDIA_FILE]).length;

            if (!isWrapper) {
              _context.next = 15;
              break;
            }

            _context.next = 15;
            return parseRecursive(vastParser, allowedRecurses - 1);

          case 15:
            _context.next = 20;
            break;

          case 17:
            _context.prev = 17;
            _context.t0 = _context["catch"](2);
            vastParser.cleanVasts();

          case 20:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[2, 17]]);
  }));

  return function parseRecursive(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();

var parseVASTDAAST = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee2(value) {
    var vastParser, URLBlobXML, isWrapper, contents, mediaUrl;
    return regenerator.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            vastParser = new VastParser();
            URLBlobXML = createURLBlobXML(value);
            _context2.next = 4;
            return new Promise(function (resolve) {
              vastParser.parseAsync(URLBlobXML, resolve);
            });

          case 4:
            URL.revokeObjectURL(URLBlobXML);
            isWrapper = vastParser.getVastElements([TAG_WRAPPER]).length && !vastParser.getVastElements([TAG_MEDIA_FILE]).length;

            if (!isWrapper) {
              _context2.next = 9;
              break;
            }

            _context2.next = 9;
            return parseRecursive(vastParser, 10);

          case 9:
            contents = vastParser.getContents([TAG_MEDIA_FILE]);
            mediaUrl = contents === null || contents === void 0 ? void 0 : contents.find(function (file) {
              return typeof file === 'string' && file.split('?')[0].split('.').pop() !== 'js';
            });
            return _context2.abrupt("return", mediaUrl || '');

          case 12:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));

  return function parseVASTDAAST(_x3) {
    return _ref2.apply(this, arguments);
  };
}();
var parseVASTDAASTSync = function parseVASTDAASTSync(value) {
  var vastParser = new VastParser();
  var URLBlobXML = createURLBlobXML(value);
  vastParser.parseSync(URLBlobXML);
  URL.revokeObjectURL(URLBlobXML);
  return vastParser.getContents([TAG_MEDIA_FILE])[0] || '';
};

var IMAGE_CREATIVE_ID = 11;
var HTML_CREATIVE_ID = 13;
var VIDEO_CREATIVE_ID = 14;
var TICKER_CREATIVE_ID = 16;
var AUDIO_CREATIVE_ID = 17;
var GOTV_CREATIVE_ID = 18;

var css_248z$c = ":root {\n  --primary1: #123787;\n  --primary2: #1d58d7;\n  --primary3: #5173fb;\n  --primary4: #7a93ff;\n  --primary5: #c2d0ff;\n  --primary6: #e5ebff;\n  --primary7: #f2f5ff; }\n\n.DevicePreview-module_section__hIDZx {\n  flex: 1 1 auto;\n  max-height: calc(100% - 81rem / 16);\n  height: 100%;\n  width: 100%;\n  font-size: 0;\n  line-height: 0;\n  text-align: center; }\n\n.DevicePreview-module_component__3uWre {\n  position: relative;\n  display: inline-block;\n  vertical-align: middle;\n  height: 100%;\n  overflow: hidden; }\n  .DevicePreview-module_component__3uWre:before {\n    content: '';\n    display: inline-block;\n    vertical-align: middle;\n    height: 100%; }\n  .DevicePreview-module_component__3uWre._desktop .DevicePreview-module__desktop__1ospn.DevicePreview-module_site__1dyqk {\n    position: static;\n    transform: none;\n    left: 0;\n    top: 0; }\n\n.DevicePreview-module_image__2JSG1 {\n  display: inline-block;\n  vertical-align: middle;\n  max-width: 100%;\n  max-height: 100%; }\n\n.DevicePreview-module_site__1dyqk {\n  position: absolute;\n  top: 50%;\n  bottom: 0;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  width: 100%;\n  height: 0;\n  overflow: hidden; }\n  .DevicePreview-module_site__1dyqk.DevicePreview-module__desktop__1ospn {\n    padding-bottom: 83.0703%;\n    font-size: 0.40486em; }\n    .DevicePreview-module_site__1dyqk.DevicePreview-module__desktop__1ospn .DevicePreview-module_wrapper__UQ55P {\n      visibility: visible;\n      top: 5.2677%;\n      left: 4.08895%;\n      right: 4.08895%;\n      height: 62.17617%; }\n  .DevicePreview-module_site__1dyqk.DevicePreview-module__tv__2FkQa {\n    padding-bottom: 62.43305%;\n    font-size: 0.34843em; }\n    .DevicePreview-module_site__1dyqk.DevicePreview-module__tv__2FkQa .DevicePreview-module_wrapper__UQ55P {\n      visibility: visible;\n      top: 1.71569%;\n      left: 0.91813%;\n      right: 1.07116%;\n      height: 88.35784%; }\n  .DevicePreview-module_site__1dyqk.DevicePreview-module__tablet__s_bTL {\n    padding-bottom: 77.48184%;\n    font-size: 0.62112em; }\n    .DevicePreview-module_site__1dyqk.DevicePreview-module__tablet__s_bTL .DevicePreview-module_wrapper__UQ55P {\n      visibility: visible;\n      top: 5.20833%;\n      left: 4.09605%;\n      right: 3.63196%;\n      height: 89.32292%;\n      border-radius: 0.5rem; }\n  .DevicePreview-module_site__1dyqk.DevicePreview-module__mobile__3srhj {\n    padding-bottom: 199.37695%;\n    font-size: 1.35135em; }\n    .DevicePreview-module_site__1dyqk.DevicePreview-module__mobile__3srhj .DevicePreview-module_wrapper__UQ55P {\n      visibility: visible;\n      top: 5.9375%;\n      left: 7.37279%;\n      right: 7.26895%;\n      height: 89.53125%;\n      border-radius: 0 0 0.07em 0.07em; }\n\n.DevicePreview-module_wrapper__UQ55P {\n  visibility: hidden;\n  position: absolute;\n  overflow: hidden; }\n  .DevicePreview-module_wrapperScroller__N8mea {\n    position: absolute;\n    top: 0;\n    left: 0;\n    bottom: 0;\n    width: 100%;\n    overflow: auto; }\n\n.DevicePreview-module_container__25wCR {\n  margin: 0 auto;\n  width: 69.23077%; }\n\n.DevicePreview-module_site__1dyqk.DevicePreview-module__tablet__s_bTL .__device-header {\n  width: 93.78882% !important; }\n\n.DevicePreview-module_site__1dyqk.DevicePreview-module__tablet__s_bTL .DevicePreview-module_container__25wCR {\n  width: 93.78882% !important; }\n\n.DevicePreview-module_site__1dyqk.DevicePreview-module__mobile__3srhj .DevicePreview-module_container__25wCR {\n  width: 91.89189%; }\n\n.DevicePreview-module_main__2IoOy {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  padding-top: 0.07em; }\n\n.DevicePreview-module_site__1dyqk.DevicePreview-module__tablet__s_bTL .__left-sidebar {\n  visibility: hidden; }\n";
var styles$9 = {"section":"DevicePreview-module_section__hIDZx","component":"DevicePreview-module_component__3uWre","_desktop":"DevicePreview-module__desktop__1ospn","site":"DevicePreview-module_site__1dyqk","image":"DevicePreview-module_image__2JSG1","wrapper":"DevicePreview-module_wrapper__UQ55P","_tv":"DevicePreview-module__tv__2FkQa","_tablet":"DevicePreview-module__tablet__s_bTL","_mobile":"DevicePreview-module__mobile__3srhj","wrapperScroller":"DevicePreview-module_wrapperScroller__N8mea","container":"DevicePreview-module_container__25wCR","main":"DevicePreview-module_main__2IoOy"};
styleInject(css_248z$c);

var css_248z$d = ":root {\n  --primary1: #123787;\n  --primary2: #1d58d7;\n  --primary3: #5173fb;\n  --primary4: #7a93ff;\n  --primary5: #c2d0ff;\n  --primary6: #e5ebff;\n  --primary7: #f2f5ff; }\n\n.index-module_container__rVzDl {\n  margin: 0 auto;\n  width: 69.23077%; }\n\n.index-module_content__1L8nH {\n  flex: 1 1 auto;\n  max-width: 100%; }\n\n._tv {\n  height: 100%; }\n  ._tv .index-module_content__1L8nH,\n  ._tv .index-module_preview__3cYIw,\n  ._tv .index-module_video__BlhWB {\n    height: 100%; }\n  ._tv .index-module_mainHeader__3bKIC,\n  ._tv .index-module_block__25BIK {\n    display: none; }\n\n.index-module_mainHeader__3bKIC {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  margin-bottom: 0.05em;\n  padding: 0.06em;\n  background: #d8d8d8; }\n  .index-module_mainHeaderItem__q0z7u {\n    width: 100%;\n    background: #ffffff; }\n    .index-module_mainHeaderItem__q0z7u:not(:last-child) {\n      margin-bottom: 0.04em;\n      height: 0.04em;\n      border-radius: 0.02em; }\n    .index-module_mainHeaderItem__q0z7u:first-child {\n      max-width: 0.3em; }\n    .index-module_mainHeaderItem__q0z7u:nth-child(2) {\n      max-width: 0.55em; }\n    .index-module_mainHeaderItem__q0z7u:nth-child(3) {\n      max-width: 0.3em;\n      height: 0.06em;\n      border-radius: 0.03em; }\n\n.index-module_block__25BIK {\n  padding: 0.02em;\n  background: #d8d8d8; }\n  .index-module_block__25BIK:not(:last-child) {\n    margin-bottom: 0.05em; }\n\n.index-module_row__Fvorb {\n  display: flex;\n  align-items: center; }\n  .index-module_row__Fvorb:not(:last-child) {\n    margin-bottom: 0.02em; }\n\n.index-module_item__3CqAV {\n  height: 0.04em;\n  border-radius: 0.02em;\n  background: #ffffff; }\n  .index-module_item__3CqAV:not(:last-child) {\n    margin-right: 0.02em; }\n\n.index-module_image__25wbH {\n  width: 100%;\n  background: #ffffff; }\n\n.index-module_preview__3cYIw {\n  pointer-events: none; }\n  .index-module_preview__3cYIw:not(:last-child) {\n    margin-bottom: 0.05em; }\n  .index-module_previewWrapper__1_Wlc {\n    position: relative;\n    width: 100%;\n    font-size: 0; }\n  .index-module_previewTitle__218Np {\n    font-size: 0.01rem;\n    line-height: 1.15; }\n  .index-module_preview__3cYIw img {\n    display: inline-block;\n    vertical-align: middle;\n    max-width: 100%;\n    max-height: 100%; }\n\n.index-module_video__BlhWB {\n  max-width: 100%; }\n\n.index-module_iframe__3ybaa {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  transform-origin: 0 0; }\n\n.index-module_process__27dQU {\n  position: relative;\n  background: rgba(0, 0, 0, 0.5);\n  cursor: default;\n  z-index: 1;\n  height: 100px;\n  line-height: normal; }\n  .index-module_processText__26I-U {\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n    font-size: 1rem;\n    color: #ffffff; }\n";
var styles$a = {"container":"index-module_container__rVzDl","content":"index-module_content__1L8nH","preview":"index-module_preview__3cYIw","video":"index-module_video__BlhWB","mainHeader":"index-module_mainHeader__3bKIC","block":"index-module_block__25BIK","mainHeaderItem":"index-module_mainHeaderItem__q0z7u","row":"index-module_row__Fvorb","item":"index-module_item__3CqAV","image":"index-module_image__25wbH","previewWrapper":"index-module_previewWrapper__1_Wlc","previewTitle":"index-module_previewTitle__218Np","iframe":"index-module_iframe__3ybaa","process":"index-module_process__27dQU","processText":"index-module_processText__26I-U"};
styleInject(css_248z$d);

function _createSuper$f(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$f(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct$f() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var DevicePreviewContent = /*#__PURE__*/function (_React$Component) {
  _inherits(DevicePreviewContent, _React$Component);

  var _super = _createSuper$f(DevicePreviewContent);

  function DevicePreviewContent(props) {
    var _this;

    _classCallCheck(this, DevicePreviewContent);

    _this = _super.call(this, props);

    _this.updatePreviewWidth = function (isPreviousDeviceImageLoaded) {
      var isDeviceImageLoaded = _this.props.isDeviceImageLoaded;

      if (isDeviceImageLoaded && !isPreviousDeviceImageLoaded) {
        _this.setState({
          previewWidth: _this.preview.offsetWidth
        });
      }
    };

    _this.getXMLContainerRef = function (div) {
      _this.divTag = div;
    };

    _this.onVideoError = function () {
      _this.setState({
        isVideoError: true
      });
    };

    _this.onVideoEnd = function () {
      _this.setState({
        isVideoEnded: true
      });

      _this.IQMVideoRef.current.play();
    };

    _this.onIQMVideoEnd = function () {
      _this.setState({
        isIQMVideoEnded: true
      });
    };

    _this.renderPreview = function () {
      var _this$props = _this.props,
          _this$props$creative = _this$props.creative,
          width = _this$props$creative.width,
          height = _this$props$creative.height,
          creativeTypeId = _this$props$creative.creativeTypeId,
          creativeSource = _this$props$creative.creativeSource,
          isLoading = _this$props.isLoading;
      var _this$state = _this.state,
          previewWidth = _this$state.previewWidth,
          isVideoError = _this$state.isVideoError,
          isVideoEnded = _this$state.isVideoEnded;
      var scale; // 285 is a 'magic number'. It is sidebar preview container width.
      // It is used when no preview dimensions are set.

      var setWidth = width || 285;

      if (previewWidth) {
        scale = previewWidth / +setWidth;
      } // if height is not set, a 'square' used in modal preview


      var paddingBottom = 100;

      if (height) {
        paddingBottom = +height / +setWidth * 100;
      }

      if (isLoading) {
        return /*#__PURE__*/React__default.createElement("div", {
          className: styles$a.previewWrapper,
          style: {
            paddingBottom: "".concat(paddingBottom, "%")
          }
        });
      }

      switch (creativeTypeId) {
        case IMAGE_CREATIVE_ID: // return <img src={creativeCardSource} />;
        // eslint-disable-next-line no-fallthrough

        case HTML_CREATIVE_ID:
          return /*#__PURE__*/React__default.createElement("div", {
            className: styles$a.previewWrapper,
            style: {
              paddingBottom: "".concat(paddingBottom, "%")
            }
          }, /*#__PURE__*/React__default.createElement("iframe", {
            ref: function ref(el) {
              _this.iframe = el;
            },
            frameBorder: "0",
            className: styles$a.iframe,
            style: {
              transform: scale ? "scale(".concat(scale, ")") : '',
              width: scale ? "".concat(1 / scale * 100, "%") : '',
              height: scale ? "".concat(1 / scale * 100, "%") : ''
            }
          }));

        case VIDEO_CREATIVE_ID:
          if (isVideoError || !creativeSource) {
            return /*#__PURE__*/React__default.createElement("div", {
              className: styles$a.process
            }, /*#__PURE__*/React__default.createElement("span", {
              className: styles$a.processText
            }, "Video loading failed"));
          }

          return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("video", {
            style: {
              display: isVideoEnded ? 'none' : 'inline-block'
            },
            autoPlay: true,
            className: styles$a.video,
            src: creativeSource,
            onError: _this.onVideoError,
            onEnded: _this.onVideoEnd,
            ref: _this.videoRef
          }), /*#__PURE__*/React__default.createElement("video", {
            style: {
              display: isVideoEnded ? 'inline-block' : 'none'
            },
            className: styles$a.video,
            src: IQM_VIDEO_URL,
            onError: _this.onVideoError,
            onEnded: _this.onIQMVideoEnd,
            ref: _this.IQMVideoRef
          }));

        default:
          return null;
      }
    };

    _this.updateIframe = function () {
      var creativeSource = _this.props.creative.creativeSource;

      if (!_this.iframe || !creativeSource) {
        return;
      }

      var iframeDoc = _this.iframe.contentWindow.document;
      iframeDoc.open();
      iframeDoc.write(decodeHTMLEntities(creativeSource));
      iframeDoc.close();
      var head = iframeDoc.querySelector('head');
      var style = document.createElement('style');
      head.appendChild(style);
      style.appendChild(document.createTextNode('body { margin: 0 !important; }'));
    };

    _this.state = {
      previewWidth: null,
      isVideoError: false,
      isVideoEnded: false,
      isIQMVideoEnded: false,
      videoCreativeSource: _this.props.creative.creativeCardSource
    };
    _this.IQMVideoRef = /*#__PURE__*/React__default.createRef();
    _this.videoRef = /*#__PURE__*/React__default.createRef();
    return _this;
  }

  _createClass(DevicePreviewContent, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var creativeTypeId = this.props.creative.creativeTypeId;

      if (creativeTypeId === HTML_CREATIVE_ID || creativeTypeId === IMAGE_CREATIVE_ID) {
        this.updatePreviewWidth();
        this.updateIframe();
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _this$props2 = this.props,
          currentTab = _this$props2.currentTab,
          _this$props2$creative = _this$props2.creative,
          creativeTypeId = _this$props2$creative.creativeTypeId,
          creativeSource = _this$props2$creative.creativeSource;
      var isIQMVideoEnded = this.state.isIQMVideoEnded;
      this.updatePreviewWidth(prevProps.isDeviceImageLoaded); // update html creative preview after creativeSource (html code) response has come

      if ((creativeTypeId === HTML_CREATIVE_ID || creativeTypeId === IMAGE_CREATIVE_ID) && prevProps.creative.creativeSource !== creativeSource) {
        this.updateIframe();
      }

      if (prevProps.currentTab !== currentTab && isIQMVideoEnded) {
        this.videoRef.current.pause();
        this.videoRef.current.currentTime = 0;
        this.IQMVideoRef.current.pause();
        this.IQMVideoRef.current.currentTime = 0;
        this.setState({
          isIQMVideoEnded: false,
          isVideoEnded: false
        });
        this.videoRef.current.play();
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      return /*#__PURE__*/React__default.createElement("div", {
        className: styles$a.content
      }, /*#__PURE__*/React__default.createElement("div", {
        className: styles$a.mainHeader
      }, _toConsumableArray(new Array(3)).map(function (i, k) {
        return /*#__PURE__*/React__default.createElement("div", {
          className: styles$a.mainHeaderItem,
          key: k
        });
      })), /*#__PURE__*/React__default.createElement("div", {
        className: styles$a.block
      }, /*#__PURE__*/React__default.createElement("div", {
        className: styles$a.row
      }, /*#__PURE__*/React__default.createElement("div", {
        className: styles$a.item,
        style: {
          width: ".04em"
        }
      }), /*#__PURE__*/React__default.createElement("div", {
        className: styles$a.item,
        style: {
          width: ".3em"
        }
      })), /*#__PURE__*/React__default.createElement("div", {
        className: styles$a.row
      }, /*#__PURE__*/React__default.createElement("div", {
        className: styles$a.item,
        style: {
          width: ".55em"
        }
      }))), /*#__PURE__*/React__default.createElement("div", {
        ref: function ref(el) {
          _this2.preview = el;
        },
        className: "".concat(styles$a.preview, " _preview")
      }, this.renderPreview()), /*#__PURE__*/React__default.createElement("div", {
        className: styles$a.block
      }, /*#__PURE__*/React__default.createElement("div", {
        className: styles$a.row
      }, /*#__PURE__*/React__default.createElement("div", {
        className: styles$a.item,
        style: {
          width: ".55em"
        }
      })), /*#__PURE__*/React__default.createElement("div", {
        className: styles$a.row
      }, /*#__PURE__*/React__default.createElement("div", {
        className: styles$a.item,
        style: {
          width: ".65em"
        }
      })), /*#__PURE__*/React__default.createElement("div", {
        className: styles$a.row
      }, /*#__PURE__*/React__default.createElement("div", {
        className: styles$a.item,
        style: {
          width: ".04em"
        }
      }), /*#__PURE__*/React__default.createElement("div", {
        className: styles$a.item,
        style: {
          width: ".3em"
        }
      })), /*#__PURE__*/React__default.createElement("div", {
        className: styles$a.row
      }, /*#__PURE__*/React__default.createElement("div", {
        className: styles$a.image,
        style: {
          height: ".36em"
        }
      })), /*#__PURE__*/React__default.createElement("div", {
        className: styles$a.row
      }, /*#__PURE__*/React__default.createElement("div", {
        className: styles$a.item,
        style: {
          width: "66%"
        }
      })), /*#__PURE__*/React__default.createElement("div", {
        className: styles$a.row
      }, /*#__PURE__*/React__default.createElement("div", {
        className: styles$a.item,
        style: {
          width: "80%"
        }
      })), /*#__PURE__*/React__default.createElement("div", {
        className: styles$a.row
      }, /*#__PURE__*/React__default.createElement("div", {
        className: styles$a.item,
        style: {
          width: ".04em"
        }
      }), /*#__PURE__*/React__default.createElement("div", {
        className: styles$a.item,
        style: {
          width: ".04em"
        }
      }), /*#__PURE__*/React__default.createElement("div", {
        className: styles$a.item,
        style: {
          width: ".04em"
        }
      }))), /*#__PURE__*/React__default.createElement("div", {
        className: styles$a.block
      }, /*#__PURE__*/React__default.createElement("div", {
        className: styles$a.row
      }, /*#__PURE__*/React__default.createElement("div", {
        className: styles$a.item,
        style: {
          width: ".55em"
        }
      })), /*#__PURE__*/React__default.createElement("div", {
        className: styles$a.row
      }, /*#__PURE__*/React__default.createElement("div", {
        className: styles$a.item,
        style: {
          width: ".65em"
        }
      })), /*#__PURE__*/React__default.createElement("div", {
        className: styles$a.row
      }, /*#__PURE__*/React__default.createElement("div", {
        className: styles$a.item,
        style: {
          width: ".04em"
        }
      }), /*#__PURE__*/React__default.createElement("div", {
        className: styles$a.item,
        style: {
          width: ".3em"
        }
      })), /*#__PURE__*/React__default.createElement("div", {
        className: styles$a.row
      }, /*#__PURE__*/React__default.createElement("div", {
        className: styles$a.image,
        style: {
          height: ".36em"
        }
      }))));
    }
  }]);

  return DevicePreviewContent;
}(React__default.Component);
DevicePreviewContent.propTypes = {
  creative: PropTypes.object,
  currentTab: PropTypes.string,
  isDeviceImageLoaded: PropTypes["boolean"],
  isLoading: PropTypes["boolean"]
};

var css_248z$e = ".index-module_leftSidebar__ePByV {\n  padding-right: 0.09em;\n  width: 0.33em; }\n  .index-module_leftSidebarItem__2BeTU {\n    width: 0.24em;\n    height: 0.04em;\n    border-radius: 0.02em;\n    background: #d8d8d8; }\n    .index-module_leftSidebarItem__2BeTU:not(:last-child) {\n      margin-bottom: 0.04em; }\n";
var styles$b = {"leftSidebar":"index-module_leftSidebar__ePByV","leftSidebarItem":"index-module_leftSidebarItem__2BeTU"};
styleInject(css_248z$e);

var DevicePreviewLeftSidebar = /*#__PURE__*/React__default.memo(function DevicePreviewLeftSidebar() {
  return /*#__PURE__*/React__default.createElement("div", {
    className: "".concat(styles$b.leftSidebar, " __left-sidebar")
  }, [0, 1, 2, 3, 4].map(function (i) {
    return /*#__PURE__*/React__default.createElement("div", {
      className: styles$b.leftSidebarItem,
      key: i
    });
  }));
});

var css_248z$f = ":root {\n  --primary1: #123787;\n  --primary2: #1d58d7;\n  --primary3: #5173fb;\n  --primary4: #7a93ff;\n  --primary5: #c2d0ff;\n  --primary6: #e5ebff;\n  --primary7: #f2f5ff; }\n\n.index-module_rightSidebar__3NSaL {\n  margin-left: 0.08em;\n  padding: 0.03em 0.03em 0.06em;\n  min-width: 0.28em;\n  background: #d8d8d8; }\n  .index-module_rightSidebarItem__2G_2m {\n    height: 0.04em;\n    border-radius: 0.02em;\n    background: #ffffff; }\n    .index-module_rightSidebarItem__2G_2m:first-child {\n      height: 0.06em;\n      border-radius: 0.03em; }\n    .index-module_rightSidebarItem__2G_2m:not(:last-child) {\n      margin-bottom: 0.04em; }\n";
var styles$c = {"rightSidebar":"index-module_rightSidebar__3NSaL","rightSidebarItem":"index-module_rightSidebarItem__2G_2m"};
styleInject(css_248z$f);

var DevicePreviewRightSidebar = /*#__PURE__*/React__default.memo(function DevicePreviewRightSidebar() {
  return /*#__PURE__*/React__default.createElement("div", {
    className: styles$c.rightSidebar
  }, [0, 1, 2, 3, 4, 5, 6, 7, 8].map(function (i) {
    return /*#__PURE__*/React__default.createElement("div", {
      className: styles$c.rightSidebarItem,
      key: i
    });
  }));
});

var css_248z$g = ":root {\n  --primary1: #123787;\n  --primary2: #1d58d7;\n  --primary3: #5173fb;\n  --primary4: #7a93ff;\n  --primary5: #c2d0ff;\n  --primary6: #e5ebff;\n  --primary7: #f2f5ff; }\n\n.index-module_container__33lYO {\n  width: 91.89189%;\n  display: flex;\n  align-items: center;\n  height: 100%;\n  margin: 0 auto; }\n\n.index-module_header__1tTHi {\n  height: 0.1em;\n  justify-content: space-between;\n  border: none;\n  background: #b92b27; }\n\n.index-module_logo__gAI-W {\n  margin: 0;\n  min-width: 0.05em;\n  height: 0.05em;\n  background: #ffffff;\n  border-radius: 50%; }\n\n.index-module_title__2mGFN {\n  margin: 0 auto;\n  width: 0.16em;\n  height: 0.06em;\n  border-radius: 0.03em;\n  background: #ffffff; }\n\n.index-module_profileName__1zAl0 {\n  margin-left: 0.02em;\n  width: 0.05em;\n  height: 0.04em;\n  background: #ffffff;\n  border-radius: 0.02em; }\n";
var styles$d = {"container":"index-module_container__33lYO","header":"index-module_header__1tTHi","logo":"index-module_logo__gAI-W","title":"index-module_title__2mGFN","profileName":"index-module_profileName__1zAl0"};
styleInject(css_248z$g);

var DevicePreviewMobileHeader = /*#__PURE__*/React__default.memo(function devicePreviewMobileHeader() {
  return /*#__PURE__*/React__default.createElement("header", {
    className: styles$d.header
  }, /*#__PURE__*/React__default.createElement("div", {
    className: styles$d.container
  }, /*#__PURE__*/React__default.createElement("div", {
    className: styles$d.logo
  }), /*#__PURE__*/React__default.createElement("div", {
    className: styles$d.title
  }), /*#__PURE__*/React__default.createElement("div", {
    className: styles$d.logo
  }), /*#__PURE__*/React__default.createElement("div", {
    className: styles$d.profileName
  })));
});

var css_248z$h = ".index-module_container__14Lat {\n  display: flex;\n  align-items: center;\n  height: 100%;\n  margin: 0 auto;\n  width: 69.23077%; }\n\n.index-module_header__2M1-1 {\n  height: 0.1em;\n  border-bottom: 0.01em solid #979797; }\n  .index-module_headerItem__1J08S {\n    margin-right: 0.04em;\n    width: 0.15em;\n    height: 0.04em;\n    border-radius: 0.02em;\n    background: #d8d8d8; }\n\n.index-module_search__2FaDw {\n  margin-left: 0.08em;\n  margin-right: 0.02em;\n  width: 0.32em;\n  height: 0.04em;\n  border: 0.01em solid #d8d8d8; }\n\n.index-module_profileImage__35GM4 {\n  margin-left: auto;\n  margin-right: 0.02em;\n  min-width: 0.04em;\n  height: 0.04em;\n  border-radius: 50%;\n  background: #d8d8d8; }\n\n.index-module_profileName__1Mm9m {\n  width: 0.22em;\n  height: 0.04em;\n  background: #b92b27; }\n\n.index-module_logo__1tF3n {\n  margin-right: 0.12em;\n  min-width: 0.08em;\n  height: 0.08em;\n  border-radius: 50%;\n  background: #b92b27; }\n";
var styles$e = {"container":"index-module_container__14Lat","header":"index-module_header__2M1-1","headerItem":"index-module_headerItem__1J08S","search":"index-module_search__2FaDw","profileImage":"index-module_profileImage__35GM4","profileName":"index-module_profileName__1Mm9m","logo":"index-module_logo__1tF3n"};
styleInject(css_248z$h);

var DevicePreviewHeader = /*#__PURE__*/React__default.memo(function devicePreviewHeader() {
  return /*#__PURE__*/React__default.createElement("header", {
    className: styles$e.header
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "".concat(styles$e.container, " __device-header")
  }, /*#__PURE__*/React__default.createElement("div", {
    className: styles$e.logo
  }), [0, 1, 2, 3, 4].map(function (i) {
    return /*#__PURE__*/React__default.createElement("div", {
      className: "".concat(styles$e.headerItem, " ").concat(i === 0 ? '_active' : ''),
      key: i
    });
  }), /*#__PURE__*/React__default.createElement("div", {
    className: styles$e.search
  }), /*#__PURE__*/React__default.createElement("div", {
    className: styles$e.profileImage
  }), /*#__PURE__*/React__default.createElement("div", {
    className: styles$e.profileName
  })));
});

var _creativeIconMapping;
var MOBILE = 'Mobile';
var DESKTOP = 'Desktop';
var TV = 'TV';
var TABLET = 'Tablet';
var deviceTabs = [{
  title: MOBILE,
  value: MOBILE
}, {
  title: DESKTOP,
  value: DESKTOP
}, {
  title: TV,
  value: TV
}, {
  title: TABLET,
  value: TABLET
}];
var creativeIconMapping = (_creativeIconMapping = {}, _defineProperty(_creativeIconMapping, HTML_CREATIVE_ID, 'CreativeHtml'), _defineProperty(_creativeIconMapping, IMAGE_CREATIVE_ID, 'CreativeImage'), _defineProperty(_creativeIconMapping, VIDEO_CREATIVE_ID, 'CreativeVideo'), _defineProperty(_creativeIconMapping, AUDIO_CREATIVE_ID, 'CreativeAudio'), _defineProperty(_creativeIconMapping, GOTV_CREATIVE_ID, 'CreativeGotv'), _defineProperty(_creativeIconMapping, TICKER_CREATIVE_ID, 'CreativeTicker'), _creativeIconMapping);

function _createSuper$g(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$g(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct$g() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var DevicePreview = /*#__PURE__*/function (_React$Component) {
  _inherits(DevicePreview, _React$Component);

  var _super = _createSuper$g(DevicePreview);

  function DevicePreview(props) {
    var _this$devices;

    var _this;

    _classCallCheck(this, DevicePreview);

    _this = _super.call(this, props);

    _this.getFontSize = function () {
      if (!_this.siteWrapper.current) {
        return;
      }

      var wrapperWidth = _this.siteWrapper.current.offsetWidth;
      var windowWidth = window.innerWidth;
      return wrapperWidth / windowWidth * 100;
    };

    _this.setFontSize = function () {
      var newFontSize = _this.getFontSize();

      newFontSize !== _this.state.fontSize && _this.setState({
        fontSize: newFontSize
      });
    };

    _this.handleImageLoad = function () {
      return _this.setState({
        stateType: _this.props.type
      }, function () {
        _this.calculateStyles();

        _this.scrollAdIntoView();
      });
    };

    _this.scrollAdIntoView = function () {
      setTimeout(function () {
        var el = document.querySelector('._preview');

        if (el) {
          el.scrollIntoView({
            block: 'center',
            behavior: 'smooth'
          });
        }
      }, 100);
    };

    _this.calculateStyles = function () {
      if (isEdgeOrIe || isSafari) {
        _this.setWidth(_this.setFontSize);
      } else {
        _this.setFontSize();
      }
    };

    _this.setWidth = function (callback) {
      var sectionRatio = _this.section.offsetWidth / _this.section.offsetHeight;
      var imageRatio = _this.image.offsetWidth / _this.image.offsetHeight;
      var width = '100%';

      if (sectionRatio > imageRatio) {
        width = _this.section.offsetHeight * imageRatio + 'px';
      }

      if (_this.state.componentWidth !== width) {
        _this.setState({
          componentWidth: width
        }, callback);
      } else {
        callback();
      }
    };

    _this.siteWrapper = /*#__PURE__*/React__default.createRef();
    _this.state = {
      fontSize: 0,
      stateType: undefined
    };
    _this.devices = (_this$devices = {}, _defineProperty(_this$devices, MOBILE, "".concat(SVG_HOST_URL, "/device/mobile.png")), _defineProperty(_this$devices, DESKTOP, "".concat(SVG_HOST_URL, "/device/desktop.png")), _defineProperty(_this$devices, TV, "".concat(SVG_HOST_URL, "/device/tv.png")), _defineProperty(_this$devices, TABLET, "".concat(SVG_HOST_URL, "/device/tablet.png")), _this$devices);
    return _this;
  }

  _createClass(DevicePreview, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var stateType = this.state.stateType;
      return /*#__PURE__*/React__default.createElement("div", {
        className: styles$9.section,
        ref: function ref(el) {
          _this2.section = el;
        }
      }, /*#__PURE__*/React__default.createElement("div", {
        className: "".concat(styles$9.component, " _").concat(stateType),
        style: {
          fontSize: "".concat(this.state.fontSize, "vw"),
          width: this.state.componentWidth
        }
      }, /*#__PURE__*/React__default.createElement("img", {
        className: styles$9.image,
        alt: this.props.type,
        src: this.devices[this.props.deviceId],
        ref: function ref(el) {
          _this2.image = el;
        },
        onLoad: this.handleImageLoad
      }), /*#__PURE__*/React__default.createElement("div", {
        className: "".concat(styles$9.site, " ").concat(styles$9["_".concat(stateType)])
      }, /*#__PURE__*/React__default.createElement("div", {
        className: "".concat(styles$9.wrapper),
        ref: this.siteWrapper
      }, stateType === 'tv' ? /*#__PURE__*/React__default.createElement(DevicePreviewContent, {
        currentTab: stateType,
        creative: this.props.creative,
        isDeviceImageLoaded: !!stateType
      }) : /*#__PURE__*/React__default.createElement("div", {
        className: "".concat(styles$9.wrapperScroller)
      }, stateType === 'mobile' ? /*#__PURE__*/React__default.createElement(DevicePreviewMobileHeader, null) : /*#__PURE__*/React__default.createElement(DevicePreviewHeader, null), /*#__PURE__*/React__default.createElement("div", {
        className: styles$9.container
      }, /*#__PURE__*/React__default.createElement("div", {
        className: styles$9.main
      }, stateType !== 'mobile' && /*#__PURE__*/React__default.createElement(DevicePreviewLeftSidebar, null), /*#__PURE__*/React__default.createElement(DevicePreviewContent, {
        currentTab: stateType,
        creative: this.props.creative,
        isDeviceImageLoaded: !!stateType,
        isLoading: this.props.isLoading
      }), stateType !== 'mobile' && /*#__PURE__*/React__default.createElement(DevicePreviewRightSidebar, null))))))));
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      window.addEventListener('resize', this.calculateStyles);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      window.removeEventListener('resize', this.calculateStyles);
    }
  }]);

  return DevicePreview;
}(React__default.Component);

var css_248z$i = ":root {\n  --primary1: #123787;\n  --primary2: #1d58d7;\n  --primary3: #5173fb;\n  --primary4: #7a93ff;\n  --primary5: #c2d0ff;\n  --primary6: #e5ebff;\n  --primary7: #f2f5ff; }\n\n@keyframes EnabledAdBlockPlaceholder-module_hover-ripples__3zv_u {\n  0% {\n    top: -0.1875em;\n    left: -0.1875em;\n    right: -0.1875em;\n    bottom: -0.1875em;\n    opacity: 1; }\n  100% {\n    top: -0.8125em;\n    left: -0.8125em;\n    right: -0.8125em;\n    bottom: -0.8125em;\n    opacity: 0; } }\n\n.EnabledAdBlockPlaceholder-module_enabledAdBlockPlaceholder__HeJ2e {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center; }\n  .EnabledAdBlockPlaceholder-module_enabledAdBlockPlaceholderIcon__rteRO.svg-icon {\n    width: 18.75rem;\n    height: unset; }\n  .EnabledAdBlockPlaceholder-module_enabledAdBlockPlaceholderTitle__3yAdo {\n    font-family: 'Avenir Next Regular', sans-serif;\n    font-weight: normal;\n    font-size: 1.125rem;\n    color: #a2a2a2;\n    text-align: center;\n    margin-bottom: 1.5rem; }\n";
var styles$f = {"enabledAdBlockPlaceholder":"EnabledAdBlockPlaceholder-module_enabledAdBlockPlaceholder__HeJ2e","enabledAdBlockPlaceholderIcon":"EnabledAdBlockPlaceholder-module_enabledAdBlockPlaceholderIcon__rteRO","enabledAdBlockPlaceholderTitle":"EnabledAdBlockPlaceholder-module_enabledAdBlockPlaceholderTitle__3yAdo","hover-ripples":"EnabledAdBlockPlaceholder-module_hover-ripples__3zv_u"};
styleInject(css_248z$i);

function EnabledAdBlockPlaceholder() {
  return /*#__PURE__*/React__default.createElement("div", {
    className: styles$f.enabledAdBlockPlaceholder
  }, /*#__PURE__*/React__default.createElement("h3", {
    className: styles$f.enabledAdBlockPlaceholderTitle
  }, "Please disable AdBlock to preview Ads"), /*#__PURE__*/React__default.createElement(Icon, {
    className: styles$f.enabledAdBlockPlaceholderIcon,
    name: "EnabledAdBlockImage"
  }));
}

var css_248z$j = ":root {\n  --primary1: #123787;\n  --primary2: #1d58d7;\n  --primary3: #5173fb;\n  --primary4: #7a93ff;\n  --primary5: #c2d0ff;\n  --primary6: #e5ebff;\n  --primary7: #f2f5ff; }\n\n@keyframes index-module_hover-ripples__31bVj {\n  0% {\n    top: -0.1875em;\n    left: -0.1875em;\n    right: -0.1875em;\n    bottom: -0.1875em;\n    opacity: 1; }\n  100% {\n    top: -0.8125em;\n    left: -0.8125em;\n    right: -0.8125em;\n    bottom: -0.8125em;\n    opacity: 0; } }\n\n.index-module_dialog__1Nekp {\n  display: flex;\n  align-items: stretch;\n  height: 85vh;\n  width: 90vw;\n  max-width: none;\n  border: 0;\n  border-radius: 0.25rem;\n  flex-direction: column;\n  background: #ffffff;\n  padding: 1rem;\n  position: relative; }\n  .index-module_dialog__1Nekp .dialog__content {\n    width: 100%; }\n\n.index-module_container__2N-gj {\n  flex: 1 1 auto;\n  display: flex;\n  flex-direction: column;\n  align-items: stretch;\n  min-height: 0; }\n\n.index-module_header__3-S9j {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-right: 2rem; }\n\n.index-module_icon__1aQUs {\n  margin-right: 0.875rem;\n  transform: scale(1.2); }\n\n.index-module_hidden__HaJW0.tooltipV2 .tooltipV2__label {\n  visibility: hidden; }\n\n.index-module_nameTooltip__1DE0J {\n  width: 100%;\n  height: 2rem;\n  display: flex;\n  align-items: center;\n  justify-content: flex-start; }\n\n.index-module_title__3x1Mg {\n  font-family: 'Avenir Next Demi', sans-serif;\n  font-weight: normal;\n  word-break: break-all;\n  line-height: 1.2rem;\n  max-height: 2rem;\n  max-width: 29.375rem;\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  position: relative;\n  top: 0.1875rem; }\n  .index-module_title__3x1Mg::after {\n    content: '';\n    display: block; }\n\n.index-module_size__1JyIo {\n  font-family: 'Avenir Next Regular', sans-serif;\n  font-weight: normal;\n  margin-left: 0.5rem;\n  font-size: 0.75rem;\n  line-height: 1.25em;\n  color: #a2a2a2;\n  float: left; }\n\n.index-module_creativeName__1-yWY {\n  display: flex;\n  align-self: flex-start;\n  align-items: center;\n  width: 30%;\n  position: relative; }\n\n.index-module_infoActions__2VlYL {\n  display: flex;\n  justify-content: flex-end;\n  align-self: flex-start;\n  width: 30%; }\n\n.index-module_close__3ObL4.btn-circle {\n  position: absolute;\n  top: 0.75rem;\n  right: 0.75rem; }\n";
var styles$g = {"dialog":"index-module_dialog__1Nekp","container":"index-module_container__2N-gj","header":"index-module_header__3-S9j","icon":"index-module_icon__1aQUs","hidden":"index-module_hidden__HaJW0","nameTooltip":"index-module_nameTooltip__1DE0J","title":"index-module_title__3x1Mg","size":"index-module_size__1JyIo","creativeName":"index-module_creativeName__1-yWY","infoActions":"index-module_infoActions__2VlYL","close":"index-module_close__3ObL4","hover-ripples":"index-module_hover-ripples__31bVj"};
styleInject(css_248z$j);

function ownKeys$l(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$l(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$l(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$l(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _createSuper$h(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$h(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct$h() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var ModalCreativePreview = /*#__PURE__*/function (_React$Component) {
  _inherits(ModalCreativePreview, _React$Component);

  var _super = _createSuper$h(ModalCreativePreview);

  function ModalCreativePreview(props) {
    var _this;

    _classCallCheck(this, ModalCreativePreview);

    _this = _super.call(this, props);

    _this.onTabChange = function (activeTab) {
      _this.setState({
        activeTab: activeTab
      });
    };

    _this.getTabsForCreative = function () {
      var creative = _this.props.creative;
      var creativeTypeId = creative.creativeTypeId;

      if (creativeTypeId !== VIDEO_CREATIVE_ID) {
        return deviceTabs.filter(function (tab) {
          return tab.value !== TV;
        });
      }

      return deviceTabs;
    };

    _this.renderSize = function () {
      var creative = _this.props.creative;
      var height = creative.height,
          width = creative.width,
          duration = creative.duration,
          creativeTypeId = creative.creativeTypeId;

      switch (creativeTypeId) {
        case IMAGE_CREATIVE_ID:
        case HTML_CREATIVE_ID:
          return "".concat(width, "x").concat(height);

        case VIDEO_CREATIVE_ID:
          return duration ? "".concat(duration, "s") : 'unknown';

        default:
          return 'unknown';
      }
    };

    _this.onMouseOver = function (event) {
      if (event.target.clientWidth < event.target.scrollWidth) {
        _this.setState(_objectSpread$l(_objectSpread$l({}, _this.state), {}, {
          isNameTooltipVisible: true
        }));
      }
    };

    _this.onMouseOut = function () {
      _this.setState(_objectSpread$l(_objectSpread$l({}, _this.state), {}, {
        isNameTooltipVisible: false
      }));
    };

    _this.renderDialog = function () {
      var _this$props = _this.props,
          creative = _this$props.creative,
          onClose = _this$props.onClose,
          videoSource = _this$props.videoSource,
          isLoading = _this$props.isLoading;
      var activeTab = _this.state.activeTab;
      var creativeIconName = creativeIconMapping[creative.creativeTypeId] || 'CreativeHtml';
      return /*#__PURE__*/React__default.createElement(Modal, {
        open: true
      }, /*#__PURE__*/React__default.createElement("div", {
        className: styles$g.dialog
      }, /*#__PURE__*/React__default.createElement("div", {
        className: styles$g.container
      }, /*#__PURE__*/React__default.createElement("header", {
        className: styles$g.header
      }, /*#__PURE__*/React__default.createElement("div", {
        className: styles$g.creativeName
      }, /*#__PURE__*/React__default.createElement("i", {
        className: styles$g.icon
      }, /*#__PURE__*/React__default.createElement(Icon, {
        name: creativeIconName
      })), /*#__PURE__*/React__default.createElement(Tooltip, {
        label: creative.name || creative.creativeName,
        auto: false,
        labelMaxWidth: 600,
        position: "bottom",
        className: "".concat(_this.state.isNameTooltipVisible ? '' : styles$g.hidden, " ").concat(styles$g.nameTooltip)
      }, /*#__PURE__*/React__default.createElement("h4", {
        onMouseEnter: _this.onMouseOver,
        onMouseLeave: _this.onMouseOut,
        className: styles$g.title
      }, creative.name || creative.creativeName))), /*#__PURE__*/React__default.createElement("div", {
        className: styles$g.tabs
      }, /*#__PURE__*/React__default.createElement(Tabs, {
        items: _this.getTabsForCreative(),
        onChange: _this.onTabChange,
        value: activeTab.value
      })), /*#__PURE__*/React__default.createElement("div", {
        className: styles$g.infoActions
      }, /*#__PURE__*/React__default.createElement("div", {
        className: styles$g.size
      }, "Size: ", _this.renderSize()))), /*#__PURE__*/React__default.createElement(ButtonCircle, {
        iconName: "Close",
        className: styles$g.close,
        onClick: onClose
      })), _this.state.hasCheckedAdblock && _this.state.hasAdblock && /*#__PURE__*/React__default.createElement(EnabledAdBlockPlaceholder, null), _this.state.hasCheckedAdblock && !_this.state.hasAdblock && /*#__PURE__*/React__default.createElement(DevicePreview, {
        creative: _objectSpread$l(_objectSpread$l({}, creative), videoSource ? {
          creativeSource: videoSource
        } : {}),
        deviceId: activeTab.value,
        type: activeTab.value.toLowerCase(),
        isLoading: isLoading
      })));
    };

    _this.state = {
      // eslint-disable-next-line standard/computed-property-even-spacing
      activeTab: deviceTabs[typeof props.defaultPreviewDeviceIndex === 'number' && props.defaultPreviewDeviceIndex < deviceTabs.length ? props.defaultPreviewDeviceIndex : 0],
      hasAdblock: false,
      hasCheckedAdblock: false,
      isNameTooltipVisible: false
    };
    return _this;
  }

  _createClass(ModalCreativePreview, [{
    key: "componentDidMount",
    value: function () {
      var _componentDidMount = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee() {
        var hasAdblock;
        return regenerator.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                hasAdblock = false;
                _context.prev = 1;
                _context.next = 4;
                return fetch(AD_URL, {
                  method: 'HEAD',
                  mode: 'no-cors',
                  cache: 'no-store'
                });

              case 4:
                _context.next = 9;
                break;

              case 6:
                _context.prev = 6;
                _context.t0 = _context["catch"](1);
                hasAdblock = true;

              case 9:
                this.setState({
                  hasAdblock: hasAdblock,
                  hasCheckedAdblock: true
                });

              case 10:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[1, 6]]);
      }));

      function componentDidMount() {
        return _componentDidMount.apply(this, arguments);
      }

      return componentDidMount;
    }()
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/createPortal(this.renderDialog(), document.body);
    }
  }]);

  return ModalCreativePreview;
}(React__default.Component);

ModalCreativePreview.propTypes = {
  creative: PropTypes.object,
  onClose: PropTypes.func,
  videoSource: PropTypes.string,
  defaultPreviewDeviceIndex: PropTypes.number,
  isLoading: PropTypes["boolean"]
};

var css_248z$k = ".index-module_audioContainer__1qBW3 {\n  width: 100%;\n  height: 100%;\n  padding: 0.5rem;\n  display: flex;\n  align-items: center;\n  justify-content: center; }\n\n.index-module_audioPlayer__1g0Di {\n  width: 100%;\n  align-self: center;\n  outline: none; }\n";
var styles$h = {"audioContainer":"index-module_audioContainer__1qBW3","audioPlayer":"index-module_audioPlayer__1g0Di"};
styleInject(css_248z$k);

function ownKeys$m(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$m(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$m(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$m(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var DATE_FORMAT = 'MM/DD/YYYY hh:mm A';

var CreativeCard = function CreativeCard(props) {
  var creative = props.creative,
      cardOptions = props.cardOptions,
      additionalParams = props.additionalParams,
      customURLParams = props.customURLParams,
      _props$onClick = props.onClick,
      onClick = _props$onClick === void 0 ? function () {} : _props$onClick,
      _props$className = props.className,
      className = _props$className === void 0 ? '' : _props$className,
      getOpenPreviewHandler = props.getOpenPreviewHandler,
      defaultPreviewDeviceIndex = props.defaultPreviewDeviceIndex,
      onModalCloseFromProps = props.onModalCloseFromProps;

  var _useState = useState$2(null),
      _useState2 = _slicedToArray(_useState, 2),
      audioSource = _useState2[0],
      setAudioSource = _useState2[1];

  var _useState3 = useState$2(null),
      _useState4 = _slicedToArray(_useState3, 2),
      videoSource = _useState4[0],
      setVideoSource = _useState4[1];

  var _useState5 = useState$2(null),
      _useState6 = _slicedToArray(_useState5, 2),
      htmlSource = _useState6[0],
      setHtmlSource = _useState6[1];

  var _useState7 = useState$2(false),
      _useState8 = _slicedToArray(_useState7, 2),
      isPreviewOpen = _useState8[0],
      setIsPreviewOpen = _useState8[1];

  var _useState9 = useState$2(false),
      _useState10 = _slicedToArray(_useState9, 2),
      isLoading = _useState10[0],
      setIsLoading = _useState10[1];

  var getIconName = function getIconName() {
    return creativeIconMapping[creative.creativeTypeId] || 'CreativeHtml';
  };

  var getTypeName = function getTypeName() {
    var typeName = 'Html';

    switch (creative.creativeTypeId) {
      case 11:
        typeName = 'Image';
        break;

      case 14:
        typeName = 'Video';
        break;

      case 17:
        typeName = 'Audio';
        break;
    }

    return typeName;
  };

  var audioPlayerRef = useRef(null);

  var stopPlayingOtherAudio = function stopPlayingOtherAudio() {
    document.querySelectorAll('audio').forEach(function (playerEl) {
      var _audioPlayerRef$curre;

      return playerEl.getAttribute('src') !== ((_audioPlayerRef$curre = audioPlayerRef.current) === null || _audioPlayerRef$curre === void 0 ? void 0 : _audioPlayerRef$curre.getAttribute('src')) && playerEl.pause();
    });
  };

  var getMediaURL = useCallback( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee() {
    var sourceResponse, parsed, dastSource, link;
    return regenerator.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            setIsLoading(true);
            creative.creativeTypeId === 14 ? setVideoSource('') : setAudioSource('');
            _context.next = 4;
            return ApiService.GetCreativeMediaSource(creative.id);

          case 4:
            sourceResponse = _context.sent;

            if (!sourceResponse) {
              _context.next = 12;
              break;
            }

            parsed = JSON.parse(sourceResponse);
            dastSource = parsed[Object.keys(parsed)[0]];
            _context.next = 10;
            return parseVASTDAAST(dastSource);

          case 10:
            link = _context.sent;
            creative.creativeTypeId === 14 ? setVideoSource(link) : setAudioSource(link);

          case 12:
            setIsLoading(false);

          case 13:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  })), [creative.id, creative.creativeTypeId]);
  var getHtml = useCallback( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee2() {
    var creativeSource;
    return regenerator.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return ApiService.GetCreativeMediaSource(creative.id);

          case 2:
            creativeSource = _context2.sent;

            if (creativeSource) {
              setHtmlSource(creativeSource);
            }

          case 4:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  })), [creative.id]);

  var playAudioHandler = function playAudioHandler() {
    stopPlayingOtherAudio();

    if (audioPlayerRef.current) {
      audioPlayerRef.current.play();
    }
  };

  var createParamsArray = function createParamsArray() {
    var params = [{
      label: 'ID:',
      value: creative.id,
      order: 10
    }, {
      label: 'Uploaded on:',
      value: moment(creative.createdOn).format(DATE_FORMAT),
      order: 20
    }, {
      label: 'Status:',
      value: creative.status,
      order: 30
    }];

    if ([14, 17].includes(creative.creativeTypeId)) {
      params.push({
        label: 'Duration:',
        value: creative.duration || 0,
        order: 40
      });
    } else {
      params.push({
        label: 'Size:',
        value: "".concat(creative.width, "x").concat(creative.height),
        order: 50
      });
    }

    if (!customURLParams) {
      params.push({
        order: 60,
        label: 'Click URL:',
        value: creative.clickUrl ? /*#__PURE__*/React__default.createElement("a", {
          target: "_blank",
          rel: "noopener noreferrer",
          href: creative.clickUrl
        }, creative.clickUrl) : '—'
      });
      params.push({
        order: 70,
        label: 'Pixel URL:',
        value: creative.pixelUrls ? creative.pixelUrls.map(function (link, index) {
          return /*#__PURE__*/React__default.createElement(Fragment, {
            key: link
          }, index ? ', ' : '', /*#__PURE__*/React__default.createElement("a", {
            href: link,
            target: "_blank",
            rel: "noopener noreferrer",
            className: "text-link"
          }, link));
        }) : '—'
      });
    }

    if (additionalParams) {
      params = sortBy([].concat(_toConsumableArray(params), _toConsumableArray(additionalParams)), 'order');
    }

    return params;
  };

  var openPreviewModal = useCallback(function () {
    // if video creative
    if (creative.creativeTypeId === 14) {
      getMediaURL();
    } // if html creative


    if (creative.creativeTypeId === 13 || creative.creativeTypeId === 11) {
      getHtml();
    }

    setIsPreviewOpen(true);
  }, [creative.creativeTypeId, getHtml, getMediaURL]);
  var onImageClick = useCallback(function () {
    creative.creativeTypeId === 17 ? getMediaURL() : openPreviewModal();
  }, [creative.creativeTypeId, openPreviewModal, getMediaURL]);
  useEffect(function () {
    if (getOpenPreviewHandler) {
      getOpenPreviewHandler(onImageClick);
    }
  }, [getOpenPreviewHandler, onImageClick]);

  var onModalClose = function onModalClose() {
    setIsPreviewOpen(false);

    if (onModalCloseFromProps) {
      onModalCloseFromProps();
    }
  };

  return /*#__PURE__*/React__default.createElement("div", {
    className: "_tile ".concat(className)
  }, /*#__PURE__*/React__default.createElement(ImageCard, _extends({
    title: creative.name,
    imageSrc: audioSource ? null : creative.creativeCardSource,
    noImageElement: audioSource ? /*#__PURE__*/React__default.createElement("div", {
      className: styles$h.audioContainer
    }, /*#__PURE__*/React__default.createElement("audio", {
      ref: audioPlayerRef,
      controls: true,
      src: audioSource,
      className: styles$h.audioPlayer,
      autoPlay: true,
      onPlay: playAudioHandler
    })) : /*#__PURE__*/React__default.createElement("i", null, /*#__PURE__*/React__default.createElement(Icon, {
      name: creative.creativeTypeId === 17 ? 'VoiceXS' : 'NoData'
    })),
    params: createParamsArray(),
    isSelected: false,
    clickedOnImage: onImageClick,
    onClick: onClick,
    iconName: getIconName(),
    loadingMessage: creative.isTransformed === 0 ? "".concat(getTypeName(), " is processing...") : ''
  }, cardOptions)), isPreviewOpen ? /*#__PURE__*/React__default.createElement(ModalCreativePreview, _extends({
    creative: _objectSpread$m(_objectSpread$m({}, creative), creative.creativeTypeId === 13 || creative.creativeTypeId === 11 ? {
      creativeSource: htmlSource
    } : {}),
    onClose: onModalClose,
    videoSource: videoSource
  }, defaultPreviewDeviceIndex !== undefined ? {
    defaultPreviewDeviceIndex: defaultPreviewDeviceIndex
  } : {}, {
    isLoading: isLoading
  })) : null);
};

CreativeCard.propTypes = {
  cardOptions: PropTypes.object,
  creative: PropTypes.object,
  onClick: PropTypes.func,
  additionalParams: PropTypes.array,
  customURLParams: PropTypes.bool,
  getOpenPreviewHandler: PropTypes.func,
  defaultPreviewDeviceIndex: PropTypes.number,
  onModalCloseFromProps: PropTypes.func,
  className: PropTypes.string
};

var css_248z$l = ":root {\n  --primary1: #123787;\n  --primary2: #1d58d7;\n  --primary3: #5173fb;\n  --primary4: #7a93ff;\n  --primary5: #c2d0ff;\n  --primary6: #e5ebff;\n  --primary7: #f2f5ff; }\n\n@keyframes styles-module_hover-ripples__3-Z8K {\n  0% {\n    top: -0.1875em;\n    left: -0.1875em;\n    right: -0.1875em;\n    bottom: -0.1875em;\n    opacity: 1; }\n  100% {\n    top: -0.8125em;\n    left: -0.8125em;\n    right: -0.8125em;\n    bottom: -0.8125em;\n    opacity: 0; } }\n\n.styles-module_advancedVideoTargetingContainer__1HZaV {\n  font-size: 0.875rem;\n  line-height: 1.125rem; }\n  .styles-module_advancedVideoTargetingContainer__1HZaV .styles-module_checkboxGroupDisabled__3dOhh {\n    color: #a2a2a2; }\n    .styles-module_advancedVideoTargetingContainer__1HZaV .styles-module_checkboxGroupDisabled__3dOhh .svg-icon {\n      fill: #a2a2a2; }\n\n.styles-module_dialogUpdate__1xald {\n  width: 3.25rem; }\n\n.styles-module_dialogInfo__3iqeP {\n  font-size: 0.875rem; }\n\n.styles-module_progressCircleContainer__1eo6x {\n  width: 100%;\n  padding: 1.5rem 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  height: 11.25rem; }\n\n.styles-module_advaContainer__6Y4sm {\n  font-size: 0.875rem; }\n\n.styles-module_tooltipInfoContainer__4j3SV {\n  padding: 0.5rem 0.25rem;\n  font-size: 0.75rem;\n  line-height: 1.125rem; }\n  .styles-module_tooltipInfoContainer__4j3SV h3 {\n    font-size: 0.875rem;\n    margin-bottom: 0.25rem; }\n  .styles-module_tooltipInfoContainer__4j3SV h3 {\n    font-weight: bold; }\n  .styles-module_tooltipInfoContainer__4j3SV ul {\n    margin-top: 0.25rem;\n    list-style: disc;\n    padding-left: 0.75rem; }\n    .styles-module_tooltipInfoContainer__4j3SV ul li {\n      margin-bottom: 0.125rem; }\n";
var styles$i = {"advancedVideoTargetingContainer":"styles-module_advancedVideoTargetingContainer__1HZaV","checkboxGroupDisabled":"styles-module_checkboxGroupDisabled__3dOhh","dialogUpdate":"styles-module_dialogUpdate__1xald","dialogInfo":"styles-module_dialogInfo__3iqeP","progressCircleContainer":"styles-module_progressCircleContainer__1eo6x","advaContainer":"styles-module_advaContainer__6Y4sm","tooltipInfoContainer":"styles-module_tooltipInfoContainer__4j3SV","hover-ripples":"styles-module_hover-ripples__3-Z8K"};
styleInject(css_248z$l);

function ownKeys$n(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$n(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$n(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$n(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var creativesIDMap = {
  CreativeImage: 11,
  CreativeHtml: 13,
  CreativeVideo: 14,
  CreativeAudio: 17
};
var AdvancedVideoTargeting = function AdvancedVideoTargeting(props) {
  var advancedOptions = props.advancedOptions,
      setAdvancedOptions = props.setAdvancedOptions,
      isLoading = props.isLoading,
      _props$creativeTypeId = props.creativeTypeId,
      creativeTypeId = _props$creativeTypeId === void 0 ? creativesIDMap.CreativeVideo : _props$creativeTypeId;
  useEffect(function () {
    var isCheckboxChange = null;

    var _advancedOptions$map = advancedOptions === null || advancedOptions === void 0 ? void 0 : advancedOptions.map(function (options) {
      var _options$options;

      return (_options$options = options.options) === null || _options$options === void 0 ? void 0 : _options$options.map(function (option) {
        if (option.checked) {
          return option.id;
        }

        isCheckboxChange = true;
        return null;
      }).filter(function (val) {
        return val;
      });
    }),
        _advancedOptions$map2 = _slicedToArray(_advancedOptions$map, 5),
        placementType = _advancedOptions$map2[0],
        rollPosition = _advancedOptions$map2[1],
        playerSize = _advancedOptions$map2[2],
        skippability = _advancedOptions$map2[3],
        playbackMethod = _advancedOptions$map2[4];

    if (isCheckboxChange) {
      setAdvancedOptions({
        placementType: placementType !== null && placementType !== void 0 && placementType.length ? placementType : undefined,
        playbackMethod: playbackMethod !== null && playbackMethod !== void 0 && playbackMethod.length ? playbackMethod : undefined,
        playerSize: playerSize !== null && playerSize !== void 0 && playerSize.length ? playerSize : undefined,
        rollPosition: rollPosition !== null && rollPosition !== void 0 && rollPosition.length ? rollPosition : undefined,
        skippability: skippability !== null && skippability !== void 0 && skippability.length ? skippability : undefined
      });
    } else {
      setAdvancedOptions(undefined);
    }
  }, [advancedOptions, setAdvancedOptions]);
  var isVideCreative = useMemo(function () {
    return creativesIDMap.CreativeVideo === creativeTypeId;
  }, [creativeTypeId]);
  var isAudioCreative = useMemo(function () {
    return creativesIDMap.CreativeAudio === creativeTypeId;
  }, [creativeTypeId]);
  var checkboxHandler = useCallback(function (id) {
    return function (vals) {
      setAdvancedOptions(function (prevVal) {
        return prevVal === null || prevVal === void 0 ? void 0 : prevVal.map(function (val) {
          var _val$options;

          return _objectSpread$n(_objectSpread$n({}, val), {}, {
            options: (_val$options = val.options) === null || _val$options === void 0 ? void 0 : _val$options.map(function (nestVals) {
              return +nestVals.id === +id ? _objectSpread$n(_objectSpread$n({}, nestVals), {}, {
                checked: vals
              }) : nestVals;
            })
          });
        });
      });
    };
  }, [setAdvancedOptions]);
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("div", {
    className: styles$i.dialogInfo
  }, isVideCreative && /*#__PURE__*/React__default.createElement(React__default.Fragment, null, "Select at least 1 paramenter from each catergory apart from ", /*#__PURE__*/React__default.createElement("b", null, "Unknown")), isAudioCreative && /*#__PURE__*/React__default.createElement(React__default.Fragment, null, "Select at least 1 paramenter apart from ", /*#__PURE__*/React__default.createElement("b", null, "Unknown"))), /*#__PURE__*/React__default.createElement("div", {
    className: styles$i.advaContainer
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "d-flex align-items-start justify-content-between mt-3 mb-2"
  }, isLoading && advancedOptions !== null && advancedOptions !== void 0 && advancedOptions.every(function (val) {
    return val.options.every(function (opt) {
      return opt.id;
    });
  }) ? /*#__PURE__*/React__default.createElement("div", {
    className: styles$i.progressCircleContainer
  }, /*#__PURE__*/React__default.createElement(ProgressCircle, {
    size: 60
  })) : advancedOptions === null || advancedOptions === void 0 ? void 0 : advancedOptions.map(function (opts) {
    var _opts$options;

    return /*#__PURE__*/React__default.createElement("div", {
      className: "".concat(opts.disabled ? styles$i.checkboxGroupDisabled : '', " ").concat(isAudioCreative ? 'd-flex align-items-center ' : ''),
      key: opts === null || opts === void 0 ? void 0 : opts.option
    }, /*#__PURE__*/React__default.createElement("div", {
      className: "d-flex align-items-center ".concat(isAudioCreative ? 'mr-2' : '')
    }, opts.label, ' ', /*#__PURE__*/React__default.createElement(Tooltip, {
      label: opts.info,
      auto: false,
      portal: true
    }, /*#__PURE__*/React__default.createElement(Icon, {
      className: "ml-1",
      name: "Info"
    }))), /*#__PURE__*/React__default.createElement("div", {
      className: isAudioCreative ? 'd-flex align-items-center ml-2' : ''
    }, (_opts$options = opts.options) === null || _opts$options === void 0 ? void 0 : _opts$options.map(function (opt) {
      return /*#__PURE__*/React__default.createElement("div", {
        className: "d-flex align-items-center  pointer ".concat(isAudioCreative ? 'ml-2' : '', " ").concat(isVideCreative ? 'my-2' : ''),
        key: opt === null || opt === void 0 ? void 0 : opt.id.toString()
      }, /*#__PURE__*/React__default.createElement(Checkbox, {
        onChange: function onChange(val) {
          checkboxHandler(opt.id)(val);
        },
        className: opt.disabled || opts.disabled ? styles$i.checkboxDisabled : '',
        checked: opt.checked,
        name: opt.id.toString(),
        disabled: !!(opt.disabled || opts.disabled)
      }), ' ', /*#__PURE__*/React__default.createElement("label", {
        className: "ml-1",
        htmlFor: opt.id.toString()
      }, opt.name));
    })));
  }))));
};
AdvancedVideoTargeting.propTypes = {
  advancedOptions: PropTypes.array,
  setAdvancedOptions: PropTypes.func,
  isLoading: PropTypes.bool,
  creativeTypeId: PropTypes.number
};

var ALLOWED_VAST_VERSIONS = '2.0, 3.0, 4.0';
var SWF = 'swf';
var FLV = 'flv';

var isValid = function isValid(name, value) {
  switch (name) {
    case 'email':
      return validateEmail(value);

    default:
      return true;
  }
};

var validateEmail = function validateEmail(value) {
  var reg = EMAIL_REGEX;
  return !!(value && reg.test(value));
};

var isValidRequired = function isValidRequired(value) {
  return !!value.trim();
};

var isValidURL = function isValidURL(url) {
  return !url || /^(?:(?:https?):\/\/)?(?:\S+(?::\S*)?@)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)(?:\.(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)*(?:\.(?:[a-z\u00a1-\uffff]{2,}))\.?)(?::\d{2,5})?(?:[/?#]\S*)?$/i.test(url);
};

var isValidXML = function isValidXML(text) {
  var parser = new DOMParser();
  var xmlDoc = parser.parseFromString(text, 'text/xml');
  return !xmlDoc.getElementsByTagName('parsererror').length;
};

var isValidFlash = function isValidFlash(value) {
  return value.indexOf(SWF) !== -1 || value.indexOf(FLV) !== -1;
};

var isValidVASTDAAST = function isValidVASTDAAST(value) {
  var result = parseVASTDAASTSync(value);
  var hasResult = !!result;
  return hasResult && !isValidFlash(result);
};

var isValidHTML = function isValidHTML(htmlCode) {
  var a = document.createElement('div');
  a.innerHTML = htmlCode;

  for (var c = a.childNodes, i = c.length; i--;) {
    if (c[i].nodeType === 1) return true;
  }

  return false;
};

var validateHTML = function validateHTML() {
  return {
    func: isValidHTML,
    error: function error(name, rule) {
      return "Please enter a valid html code!";
    }
  };
};

var validateRequired = function validateRequired(title) {
  return {
    func: isValidRequired,
    error: function error(name, rule) {
      return "".concat(rule.title, " is required!");
    },
    title: title
  };
};

var validateURL = function validateURL(title, providedFullMessage) {
  return {
    func: isValidURL,
    error: function error(name, rule) {
      return providedFullMessage ? title : "".concat(rule.title, " must be a valid url address!");
    },
    title: title
  };
};

var validateXML = function validateXML(title) {
  return {
    func: isValidXML,
    error: function error(name, rule) {
      return "".concat(rule.title, " must be a valid XML");
    },
    title: title
  };
};

var validateVASTDAASTXML = function validateVASTDAASTXML(title) {
  return {
    func: isValidVASTDAAST,
    error: function error(name, rule) {
      return "Only allow to upload ".concat(ALLOWED_VAST_VERSIONS, " ").concat(title, " versions");
    },
    title: title
  };
};

var validateVASTDAASTXMLorURL = function validateVASTDAASTXMLorURL(title) {
  return {
    func: function func(value) {
      if (isValidURL(value)) {
        return true;
      }

      if (isValidXML(value)) {
        return isValidVASTDAAST(value);
      }

      return false;
    },
    error: function error(name, rule) {
      return "Only allow to upload ".concat(ALLOWED_VAST_VERSIONS, " versions or ").concat(title);
    },
    title: title
  };
};

var validate = {
  validateRequired: validateRequired,
  validateEmail: validateEmail,
  validateHTML: validateHTML,
  validateURL: validateURL,
  validateVASTDAASTXML: validateVASTDAASTXML,
  validateXML: validateXML,
  validateVASTDAASTXMLorURL: validateVASTDAASTXMLorURL,
  isValidHTML: isValidHTML,
  isValidURL: isValidURL,
  isValidFlash: isValidFlash,
  isValidRequired: isValidRequired,
  isValidVASTDAAST: isValidVASTDAAST,
  isValidXML: isValidXML,
  isValid: isValid
};

var EXCEL_FORMATS = ['application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', 'application/vnd.ms-excel'];
var CSV_FORMAT = 'text/csv';

var papaparse_min = createCommonjsModule(function (module, exports) {
/* @license
Papa Parse
v5.3.1
https://github.com/mholt/PapaParse
License: MIT
*/
!function(e,t){module.exports=t();}(commonjsGlobal,function s(){var f="undefined"!=typeof self?self:"undefined"!=typeof window?window:void 0!==f?f:{};var n=!f.document&&!!f.postMessage,o=n&&/blob:/i.test((f.location||{}).protocol),a={},h=0,b={parse:function(e,t){var i=(t=t||{}).dynamicTyping||!1;M(i)&&(t.dynamicTypingFunction=i,i={});if(t.dynamicTyping=i,t.transform=!!M(t.transform)&&t.transform,t.worker&&b.WORKERS_SUPPORTED){var r=function(){if(!b.WORKERS_SUPPORTED)return !1;var e=(i=f.URL||f.webkitURL||null,r=s.toString(),b.BLOB_URL||(b.BLOB_URL=i.createObjectURL(new Blob(["(",r,")();"],{type:"text/javascript"})))),t=new f.Worker(e);var i,r;return t.onmessage=_,t.id=h++,a[t.id]=t}();return r.userStep=t.step,r.userChunk=t.chunk,r.userComplete=t.complete,r.userError=t.error,t.step=M(t.step),t.chunk=M(t.chunk),t.complete=M(t.complete),t.error=M(t.error),delete t.worker,void r.postMessage({input:e,config:t,workerId:r.id})}var n=null;"string"==typeof e?n=t.download?new l(t):new p(t):!0===e.readable&&M(e.read)&&M(e.on)?n=new g(t):(f.File&&e instanceof File||e instanceof Object)&&(n=new c(t));return n.stream(e)},unparse:function(e,t){var n=!1,_=!0,m=",",y="\r\n",s='"',a=s+s,i=!1,r=null,o=!1;!function(){if("object"!=typeof t)return;"string"!=typeof t.delimiter||b.BAD_DELIMITERS.filter(function(e){return -1!==t.delimiter.indexOf(e)}).length||(m=t.delimiter);("boolean"==typeof t.quotes||"function"==typeof t.quotes||Array.isArray(t.quotes))&&(n=t.quotes);"boolean"!=typeof t.skipEmptyLines&&"string"!=typeof t.skipEmptyLines||(i=t.skipEmptyLines);"string"==typeof t.newline&&(y=t.newline);"string"==typeof t.quoteChar&&(s=t.quoteChar);"boolean"==typeof t.header&&(_=t.header);if(Array.isArray(t.columns)){if(0===t.columns.length)throw new Error("Option columns is empty");r=t.columns;}void 0!==t.escapeChar&&(a=t.escapeChar+s);"boolean"==typeof t.escapeFormulae&&(o=t.escapeFormulae);}();var h=new RegExp(j(s),"g");"string"==typeof e&&(e=JSON.parse(e));if(Array.isArray(e)){if(!e.length||Array.isArray(e[0]))return u(null,e,i);if("object"==typeof e[0])return u(r||Object.keys(e[0]),e,i)}else if("object"==typeof e)return "string"==typeof e.data&&(e.data=JSON.parse(e.data)),Array.isArray(e.data)&&(e.fields||(e.fields=e.meta&&e.meta.fields),e.fields||(e.fields=Array.isArray(e.data[0])?e.fields:"object"==typeof e.data[0]?Object.keys(e.data[0]):[]),Array.isArray(e.data[0])||"object"==typeof e.data[0]||(e.data=[e.data])),u(e.fields||[],e.data||[],i);throw new Error("Unable to serialize unrecognized input");function u(e,t,i){var r="";"string"==typeof e&&(e=JSON.parse(e)),"string"==typeof t&&(t=JSON.parse(t));var n=Array.isArray(e)&&0<e.length,s=!Array.isArray(t[0]);if(n&&_){for(var a=0;a<e.length;a++)0<a&&(r+=m),r+=v(e[a],a);0<t.length&&(r+=y);}for(var o=0;o<t.length;o++){var h=n?e.length:t[o].length,u=!1,f=n?0===Object.keys(t[o]).length:0===t[o].length;if(i&&!n&&(u="greedy"===i?""===t[o].join("").trim():1===t[o].length&&0===t[o][0].length),"greedy"===i&&n){for(var d=[],l=0;l<h;l++){var c=s?e[l]:l;d.push(t[o][c]);}u=""===d.join("").trim();}if(!u){for(var p=0;p<h;p++){0<p&&!f&&(r+=m);var g=n&&s?e[p]:p;r+=v(t[o][g],p);}o<t.length-1&&(!i||0<h&&!f)&&(r+=y);}}return r}function v(e,t){if(null==e)return "";if(e.constructor===Date)return JSON.stringify(e).slice(1,25);!0===o&&"string"==typeof e&&null!==e.match(/^[=+\-@].*$/)&&(e="'"+e);var i=e.toString().replace(h,a),r="boolean"==typeof n&&n||"function"==typeof n&&n(e,t)||Array.isArray(n)&&n[t]||function(e,t){for(var i=0;i<t.length;i++)if(-1<e.indexOf(t[i]))return !0;return !1}(i,b.BAD_DELIMITERS)||-1<i.indexOf(m)||" "===i.charAt(0)||" "===i.charAt(i.length-1);return r?s+i+s:i}}};if(b.RECORD_SEP=String.fromCharCode(30),b.UNIT_SEP=String.fromCharCode(31),b.BYTE_ORDER_MARK="\ufeff",b.BAD_DELIMITERS=["\r","\n",'"',b.BYTE_ORDER_MARK],b.WORKERS_SUPPORTED=!n&&!!f.Worker,b.NODE_STREAM_INPUT=1,b.LocalChunkSize=10485760,b.RemoteChunkSize=5242880,b.DefaultDelimiter=",",b.Parser=E,b.ParserHandle=i,b.NetworkStreamer=l,b.FileStreamer=c,b.StringStreamer=p,b.ReadableStreamStreamer=g,f.jQuery){var d=f.jQuery;d.fn.parse=function(o){var i=o.config||{},h=[];return this.each(function(e){if(!("INPUT"===d(this).prop("tagName").toUpperCase()&&"file"===d(this).attr("type").toLowerCase()&&f.FileReader)||!this.files||0===this.files.length)return !0;for(var t=0;t<this.files.length;t++)h.push({file:this.files[t],inputElem:this,instanceConfig:d.extend({},i)});}),e(),this;function e(){if(0!==h.length){var e,t,i,r,n=h[0];if(M(o.before)){var s=o.before(n.file,n.inputElem);if("object"==typeof s){if("abort"===s.action)return e="AbortError",t=n.file,i=n.inputElem,r=s.reason,void(M(o.error)&&o.error({name:e},t,i,r));if("skip"===s.action)return void u();"object"==typeof s.config&&(n.instanceConfig=d.extend(n.instanceConfig,s.config));}else if("skip"===s)return void u()}var a=n.instanceConfig.complete;n.instanceConfig.complete=function(e){M(a)&&a(e,n.file,n.inputElem),u();},b.parse(n.file,n.instanceConfig);}else M(o.complete)&&o.complete();}function u(){h.splice(0,1),e();}};}function u(e){this._handle=null,this._finished=!1,this._completed=!1,this._halted=!1,this._input=null,this._baseIndex=0,this._partialLine="",this._rowCount=0,this._start=0,this._nextChunk=null,this.isFirstChunk=!0,this._completeResults={data:[],errors:[],meta:{}},function(e){var t=w(e);t.chunkSize=parseInt(t.chunkSize),e.step||e.chunk||(t.chunkSize=null);this._handle=new i(t),(this._handle.streamer=this)._config=t;}.call(this,e),this.parseChunk=function(e,t){if(this.isFirstChunk&&M(this._config.beforeFirstChunk)){var i=this._config.beforeFirstChunk(e);void 0!==i&&(e=i);}this.isFirstChunk=!1,this._halted=!1;var r=this._partialLine+e;this._partialLine="";var n=this._handle.parse(r,this._baseIndex,!this._finished);if(!this._handle.paused()&&!this._handle.aborted()){var s=n.meta.cursor;this._finished||(this._partialLine=r.substring(s-this._baseIndex),this._baseIndex=s),n&&n.data&&(this._rowCount+=n.data.length);var a=this._finished||this._config.preview&&this._rowCount>=this._config.preview;if(o)f.postMessage({results:n,workerId:b.WORKER_ID,finished:a});else if(M(this._config.chunk)&&!t){if(this._config.chunk(n,this._handle),this._handle.paused()||this._handle.aborted())return void(this._halted=!0);n=void 0,this._completeResults=void 0;}return this._config.step||this._config.chunk||(this._completeResults.data=this._completeResults.data.concat(n.data),this._completeResults.errors=this._completeResults.errors.concat(n.errors),this._completeResults.meta=n.meta),this._completed||!a||!M(this._config.complete)||n&&n.meta.aborted||(this._config.complete(this._completeResults,this._input),this._completed=!0),a||n&&n.meta.paused||this._nextChunk(),n}this._halted=!0;},this._sendError=function(e){M(this._config.error)?this._config.error(e):o&&this._config.error&&f.postMessage({workerId:b.WORKER_ID,error:e,finished:!1});};}function l(e){var r;(e=e||{}).chunkSize||(e.chunkSize=b.RemoteChunkSize),u.call(this,e),this._nextChunk=n?function(){this._readChunk(),this._chunkLoaded();}:function(){this._readChunk();},this.stream=function(e){this._input=e,this._nextChunk();},this._readChunk=function(){if(this._finished)this._chunkLoaded();else {if(r=new XMLHttpRequest,this._config.withCredentials&&(r.withCredentials=this._config.withCredentials),n||(r.onload=v(this._chunkLoaded,this),r.onerror=v(this._chunkError,this)),r.open(this._config.downloadRequestBody?"POST":"GET",this._input,!n),this._config.downloadRequestHeaders){var e=this._config.downloadRequestHeaders;for(var t in e)r.setRequestHeader(t,e[t]);}if(this._config.chunkSize){var i=this._start+this._config.chunkSize-1;r.setRequestHeader("Range","bytes="+this._start+"-"+i);}try{r.send(this._config.downloadRequestBody);}catch(e){this._chunkError(e.message);}n&&0===r.status&&this._chunkError();}},this._chunkLoaded=function(){4===r.readyState&&(r.status<200||400<=r.status?this._chunkError():(this._start+=this._config.chunkSize?this._config.chunkSize:r.responseText.length,this._finished=!this._config.chunkSize||this._start>=function(e){var t=e.getResponseHeader("Content-Range");if(null===t)return -1;return parseInt(t.substring(t.lastIndexOf("/")+1))}(r),this.parseChunk(r.responseText)));},this._chunkError=function(e){var t=r.statusText||e;this._sendError(new Error(t));};}function c(e){var r,n;(e=e||{}).chunkSize||(e.chunkSize=b.LocalChunkSize),u.call(this,e);var s="undefined"!=typeof FileReader;this.stream=function(e){this._input=e,n=e.slice||e.webkitSlice||e.mozSlice,s?((r=new FileReader).onload=v(this._chunkLoaded,this),r.onerror=v(this._chunkError,this)):r=new FileReaderSync,this._nextChunk();},this._nextChunk=function(){this._finished||this._config.preview&&!(this._rowCount<this._config.preview)||this._readChunk();},this._readChunk=function(){var e=this._input;if(this._config.chunkSize){var t=Math.min(this._start+this._config.chunkSize,this._input.size);e=n.call(e,this._start,t);}var i=r.readAsText(e,this._config.encoding);s||this._chunkLoaded({target:{result:i}});},this._chunkLoaded=function(e){this._start+=this._config.chunkSize,this._finished=!this._config.chunkSize||this._start>=this._input.size,this.parseChunk(e.target.result);},this._chunkError=function(){this._sendError(r.error);};}function p(e){var i;u.call(this,e=e||{}),this.stream=function(e){return i=e,this._nextChunk()},this._nextChunk=function(){if(!this._finished){var e,t=this._config.chunkSize;return t?(e=i.substring(0,t),i=i.substring(t)):(e=i,i=""),this._finished=!i,this.parseChunk(e)}};}function g(e){u.call(this,e=e||{});var t=[],i=!0,r=!1;this.pause=function(){u.prototype.pause.apply(this,arguments),this._input.pause();},this.resume=function(){u.prototype.resume.apply(this,arguments),this._input.resume();},this.stream=function(e){this._input=e,this._input.on("data",this._streamData),this._input.on("end",this._streamEnd),this._input.on("error",this._streamError);},this._checkIsFinished=function(){r&&1===t.length&&(this._finished=!0);},this._nextChunk=function(){this._checkIsFinished(),t.length?this.parseChunk(t.shift()):i=!0;},this._streamData=v(function(e){try{t.push("string"==typeof e?e:e.toString(this._config.encoding)),i&&(i=!1,this._checkIsFinished(),this.parseChunk(t.shift()));}catch(e){this._streamError(e);}},this),this._streamError=v(function(e){this._streamCleanUp(),this._sendError(e);},this),this._streamEnd=v(function(){this._streamCleanUp(),r=!0,this._streamData("");},this),this._streamCleanUp=v(function(){this._input.removeListener("data",this._streamData),this._input.removeListener("end",this._streamEnd),this._input.removeListener("error",this._streamError);},this);}function i(m){var a,o,h,r=Math.pow(2,53),n=-r,s=/^\s*-?(\d+\.?|\.\d+|\d+\.\d+)([eE][-+]?\d+)?\s*$/,u=/^(\d{4}-[01]\d-[0-3]\dT[0-2]\d:[0-5]\d:[0-5]\d\.\d+([+-][0-2]\d:[0-5]\d|Z))|(\d{4}-[01]\d-[0-3]\dT[0-2]\d:[0-5]\d:[0-5]\d([+-][0-2]\d:[0-5]\d|Z))|(\d{4}-[01]\d-[0-3]\dT[0-2]\d:[0-5]\d([+-][0-2]\d:[0-5]\d|Z))$/,t=this,i=0,f=0,d=!1,e=!1,l=[],c={data:[],errors:[],meta:{}};if(M(m.step)){var p=m.step;m.step=function(e){if(c=e,_())g();else {if(g(),0===c.data.length)return;i+=e.data.length,m.preview&&i>m.preview?o.abort():(c.data=c.data[0],p(c,t));}};}function y(e){return "greedy"===m.skipEmptyLines?""===e.join("").trim():1===e.length&&0===e[0].length}function g(){if(c&&h&&(k("Delimiter","UndetectableDelimiter","Unable to auto-detect delimiting character; defaulted to '"+b.DefaultDelimiter+"'"),h=!1),m.skipEmptyLines)for(var e=0;e<c.data.length;e++)y(c.data[e])&&c.data.splice(e--,1);return _()&&function(){if(!c)return;function e(e,t){M(m.transformHeader)&&(e=m.transformHeader(e,t)),l.push(e);}if(Array.isArray(c.data[0])){for(var t=0;_()&&t<c.data.length;t++)c.data[t].forEach(e);c.data.splice(0,1);}else c.data.forEach(e);}(),function(){if(!c||!m.header&&!m.dynamicTyping&&!m.transform)return c;function e(e,t){var i,r=m.header?{}:[];for(i=0;i<e.length;i++){var n=i,s=e[i];m.header&&(n=i>=l.length?"__parsed_extra":l[i]),m.transform&&(s=m.transform(s,n)),s=v(n,s),"__parsed_extra"===n?(r[n]=r[n]||[],r[n].push(s)):r[n]=s;}return m.header&&(i>l.length?k("FieldMismatch","TooManyFields","Too many fields: expected "+l.length+" fields but parsed "+i,f+t):i<l.length&&k("FieldMismatch","TooFewFields","Too few fields: expected "+l.length+" fields but parsed "+i,f+t)),r}var t=1;!c.data.length||Array.isArray(c.data[0])?(c.data=c.data.map(e),t=c.data.length):c.data=e(c.data,0);m.header&&c.meta&&(c.meta.fields=l);return f+=t,c}()}function _(){return m.header&&0===l.length}function v(e,t){return i=e,m.dynamicTypingFunction&&void 0===m.dynamicTyping[i]&&(m.dynamicTyping[i]=m.dynamicTypingFunction(i)),!0===(m.dynamicTyping[i]||m.dynamicTyping)?"true"===t||"TRUE"===t||"false"!==t&&"FALSE"!==t&&(function(e){if(s.test(e)){var t=parseFloat(e);if(n<t&&t<r)return !0}return !1}(t)?parseFloat(t):u.test(t)?new Date(t):""===t?null:t):t;var i;}function k(e,t,i,r){var n={type:e,code:t,message:i};void 0!==r&&(n.row=r),c.errors.push(n);}this.parse=function(e,t,i){var r=m.quoteChar||'"';if(m.newline||(m.newline=function(e,t){e=e.substring(0,1048576);var i=new RegExp(j(t)+"([^]*?)"+j(t),"gm"),r=(e=e.replace(i,"")).split("\r"),n=e.split("\n"),s=1<n.length&&n[0].length<r[0].length;if(1===r.length||s)return "\n";for(var a=0,o=0;o<r.length;o++)"\n"===r[o][0]&&a++;return a>=r.length/2?"\r\n":"\r"}(e,r)),h=!1,m.delimiter)M(m.delimiter)&&(m.delimiter=m.delimiter(e),c.meta.delimiter=m.delimiter);else {var n=function(e,t,i,r,n){var s,a,o,h;n=n||[",","\t","|",";",b.RECORD_SEP,b.UNIT_SEP];for(var u=0;u<n.length;u++){var f=n[u],d=0,l=0,c=0;o=void 0;for(var p=new E({comments:r,delimiter:f,newline:t,preview:10}).parse(e),g=0;g<p.data.length;g++)if(i&&y(p.data[g]))c++;else {var _=p.data[g].length;l+=_,void 0!==o?0<_&&(d+=Math.abs(_-o),o=_):o=_;}0<p.data.length&&(l/=p.data.length-c),(void 0===a||d<=a)&&(void 0===h||h<l)&&1.99<l&&(a=d,s=f,h=l);}return {successful:!!(m.delimiter=s),bestDelimiter:s}}(e,m.newline,m.skipEmptyLines,m.comments,m.delimitersToGuess);n.successful?m.delimiter=n.bestDelimiter:(h=!0,m.delimiter=b.DefaultDelimiter),c.meta.delimiter=m.delimiter;}var s=w(m);return m.preview&&m.header&&s.preview++,a=e,o=new E(s),c=o.parse(a,t,i),g(),d?{meta:{paused:!0}}:c||{meta:{paused:!1}}},this.paused=function(){return d},this.pause=function(){d=!0,o.abort(),a=M(m.chunk)?"":a.substring(o.getCharIndex());},this.resume=function(){t.streamer._halted?(d=!1,t.streamer.parseChunk(a,!0)):setTimeout(t.resume,3);},this.aborted=function(){return e},this.abort=function(){e=!0,o.abort(),c.meta.aborted=!0,M(m.complete)&&m.complete(c),a="";};}function j(e){return e.replace(/[.*+?^${}()|[\]\\]/g,"\\$&")}function E(e){var S,O=(e=e||{}).delimiter,x=e.newline,I=e.comments,T=e.step,D=e.preview,A=e.fastMode,L=S=void 0===e.quoteChar?'"':e.quoteChar;if(void 0!==e.escapeChar&&(L=e.escapeChar),("string"!=typeof O||-1<b.BAD_DELIMITERS.indexOf(O))&&(O=","),I===O)throw new Error("Comment character same as delimiter");!0===I?I="#":("string"!=typeof I||-1<b.BAD_DELIMITERS.indexOf(I))&&(I=!1),"\n"!==x&&"\r"!==x&&"\r\n"!==x&&(x="\n");var F=0,z=!1;this.parse=function(r,t,i){if("string"!=typeof r)throw new Error("Input must be a string");var n=r.length,e=O.length,s=x.length,a=I.length,o=M(T),h=[],u=[],f=[],d=F=0;if(!r)return C();if(A||!1!==A&&-1===r.indexOf(S)){for(var l=r.split(x),c=0;c<l.length;c++){if(f=l[c],F+=f.length,c!==l.length-1)F+=x.length;else if(i)return C();if(!I||f.substring(0,a)!==I){if(o){if(h=[],k(f.split(O)),R(),z)return C()}else k(f.split(O));if(D&&D<=c)return h=h.slice(0,D),C(!0)}}return C()}for(var p=r.indexOf(O,F),g=r.indexOf(x,F),_=new RegExp(j(L)+j(S),"g"),m=r.indexOf(S,F);;)if(r[F]!==S)if(I&&0===f.length&&r.substring(F,F+a)===I){if(-1===g)return C();F=g+s,g=r.indexOf(x,F),p=r.indexOf(O,F);}else if(-1!==p&&(p<g||-1===g))f.push(r.substring(F,p)),F=p+e,p=r.indexOf(O,F);else {if(-1===g)break;if(f.push(r.substring(F,g)),w(g+s),o&&(R(),z))return C();if(D&&h.length>=D)return C(!0)}else for(m=F,F++;;){if(-1===(m=r.indexOf(S,m+1)))return i||u.push({type:"Quotes",code:"MissingQuotes",message:"Quoted field unterminated",row:h.length,index:F}),E();if(m===n-1)return E(r.substring(F,m).replace(_,S));if(S!==L||r[m+1]!==L){if(S===L||0===m||r[m-1]!==L){-1!==p&&p<m+1&&(p=r.indexOf(O,m+1)),-1!==g&&g<m+1&&(g=r.indexOf(x,m+1));var y=b(-1===g?p:Math.min(p,g));if(r[m+1+y]===O){f.push(r.substring(F,m).replace(_,S)),r[F=m+1+y+e]!==S&&(m=r.indexOf(S,F)),p=r.indexOf(O,F),g=r.indexOf(x,F);break}var v=b(g);if(r.substring(m+1+v,m+1+v+s)===x){if(f.push(r.substring(F,m).replace(_,S)),w(m+1+v+s),p=r.indexOf(O,F),m=r.indexOf(S,F),o&&(R(),z))return C();if(D&&h.length>=D)return C(!0);break}u.push({type:"Quotes",code:"InvalidQuotes",message:"Trailing quote on quoted field is malformed",row:h.length,index:F}),m++;}}else m++;}return E();function k(e){h.push(e),d=F;}function b(e){var t=0;if(-1!==e){var i=r.substring(m+1,e);i&&""===i.trim()&&(t=i.length);}return t}function E(e){return i||(void 0===e&&(e=r.substring(F)),f.push(e),F=n,k(f),o&&R()),C()}function w(e){F=e,k(f),f=[],g=r.indexOf(x,F);}function C(e){return {data:h,errors:u,meta:{delimiter:O,linebreak:x,aborted:z,truncated:!!e,cursor:d+(t||0)}}}function R(){T(C()),h=[],u=[];}},this.abort=function(){z=!0;},this.getCharIndex=function(){return F};}function _(e){var t=e.data,i=a[t.workerId],r=!1;if(t.error)i.userError(t.error,t.file);else if(t.results&&t.results.data){var n={abort:function(){r=!0,m(t.workerId,{data:[],errors:[],meta:{aborted:!0}});},pause:y,resume:y};if(M(i.userStep)){for(var s=0;s<t.results.data.length&&(i.userStep({data:t.results.data[s],errors:t.results.errors,meta:t.results.meta},n),!r);s++);delete t.results;}else M(i.userChunk)&&(i.userChunk(t.results,n,t.file),delete t.results);}t.finished&&!r&&m(t.workerId,t.results);}function m(e,t){var i=a[e];M(i.userComplete)&&i.userComplete(t),i.terminate(),delete a[e];}function y(){throw new Error("Not implemented.")}function w(e){if("object"!=typeof e||null===e)return e;var t=Array.isArray(e)?[]:{};for(var i in e)t[i]=w(e[i]);return t}function v(e,t){return function(){e.apply(t,arguments);}}function M(e){return "function"==typeof e}return o&&(f.onmessage=function(e){var t=e.data;void 0===b.WORKER_ID&&t&&(b.WORKER_ID=t.workerId);if("string"==typeof t.input)f.postMessage({workerId:b.WORKER_ID,results:b.parse(t.input,t.config),finished:!0});else if(f.File&&t.input instanceof File||t.input instanceof Object){var i=b.parse(t.input,t.config);i&&f.postMessage({workerId:b.WORKER_ID,results:i,finished:!0});}}),(l.prototype=Object.create(u.prototype)).constructor=l,(c.prototype=Object.create(u.prototype)).constructor=c,(p.prototype=Object.create(p.prototype)).constructor=p,(g.prototype=Object.create(u.prototype)).constructor=g,b});
});

var getCsvData = function getCsvData(csv, callback) {
  papaparse_min.parse(csv, {
    preview: 1000,
    skipEmptyLines: true,
    complete: function complete(results) {
      callback(results.data);
    }
  });
};

var getFileData = function getFileData(file, callback, errorCallback) {
  if (![].concat(_toConsumableArray(EXCEL_FORMATS), [CSV_FORMAT]).includes(file.type)) {
    errorCallback && errorCallback();
  } else {
    if (EXCEL_FORMATS.includes(file.type)) {
      Promise.resolve().then(function () { return xlsx; }).then(function (xlsxImport) {
        var xlsx = xlsxImport !== null && xlsxImport !== void 0 && xlsxImport["default"] ? xlsxImport["default"] : xlsxImport;
        var reader = new FileReader();

        reader.onload = function (evt) {
          var _evt$target;

          var bstr = evt === null || evt === void 0 ? void 0 : (_evt$target = evt.target) === null || _evt$target === void 0 ? void 0 : _evt$target.result;
          var wb = xlsx.read(bstr, {
            type: 'binary',
            sheetRows: 1000
          });
          var wsname = wb.SheetNames[0];
          var ws = wb.Sheets[wsname];
          var data = xlsx.utils.sheet_to_csv(ws);
          getCsvData(data, callback);
        };

        reader.readAsBinaryString(file);
      })["catch"](function () {
        errorCallback && errorCallback();
      });
    } else if (file.type === CSV_FORMAT) {
      getCsvData(file, callback);
    }
  }
};

var downloadBlob = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee(blob, fileName) {
    var link;
    return regenerator.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            link = window.document.createElement('a');
            link.href = window.URL.createObjectURL(blob);
            link.download = fileName;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            _context.next = 12;
            break;

          case 9:
            _context.prev = 9;
            _context.t0 = _context["catch"](0);
            throw _context.t0;

          case 12:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[0, 9]]);
  }));

  return function downloadBlob(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();

var downloadFile = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee2(fileUrl, fileName) {
    var file, blob;
    return regenerator.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.prev = 0;
            _context2.next = 3;
            return fetch(fileUrl);

          case 3:
            file = _context2.sent;
            _context2.next = 6;
            return file.blob();

          case 6:
            blob = _context2.sent;
            downloadBlob(blob, fileName);
            _context2.next = 13;
            break;

          case 10:
            _context2.prev = 10;
            _context2.t0 = _context2["catch"](0);
            console.error('error :', _context2.t0);

          case 13:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, null, [[0, 10]]);
  }));

  return function downloadFile(_x3, _x4) {
    return _ref2.apply(this, arguments);
  };
}();

var filesUtils = {
  getFileData: getFileData,
  downloadFile: downloadFile,
  downloadBlob: downloadBlob
};

function copyText(text) {
  var input = document.createElement('textarea');
  input.innerHTML = text;
  document.body.appendChild(input);
  input.select();
  var result = document.execCommand('copy');
  document.body.removeChild(input);
  return result;
}
function selectText(nodeId) {
  var node = document.getElementById(nodeId);

  if (window.getSelection && node) {
    var selection = window.getSelection();
    var range = document.createRange();
    range.selectNodeContents(node);

    if (selection) {
      selection.removeAllRanges();
      selection.addRange(range);
    }
  } else {
    // eslint-disable-next-line no-console
    console.warn('Could not select text.');
  }
}

var getApiErrorMsg = function getApiErrorMsg(response, withDefaultError) {
  return get$1(response, 'data.errorObjects[0].error') || get$1(response, 'data.responseObject.errorMsg') || (withDefaultError ? "API Error: ".concat((response === null || response === void 0 ? void 0 : response.status) || 'No Status Code Found') : null);
};

var getEndpoint = function getEndpoint(url) {
  var _url$split, _url$split$call;

  var endpoint = url === null || url === void 0 ? void 0 : (_url$split = url.split) === null || _url$split === void 0 ? void 0 : (_url$split$call = _url$split.call(url, '/api/')) === null || _url$split$call === void 0 ? void 0 : _url$split$call[1];
  return endpoint ? "/api/".concat(endpoint) : null;
};

var getApiErrorContext = function getApiErrorContext(response) {
  var _response$config, _response$config2, _response$config3;

  return {
    errorMsg: getApiErrorMsg(response, true),
    statusCode: response === null || response === void 0 ? void 0 : response.status,
    url: getEndpoint(response === null || response === void 0 ? void 0 : (_response$config = response.config) === null || _response$config === void 0 ? void 0 : _response$config.url) || getEndpoint("".concat((response === null || response === void 0 ? void 0 : (_response$config2 = response.config) === null || _response$config2 === void 0 ? void 0 : _response$config2.baseURL) || '').concat((response === null || response === void 0 ? void 0 : (_response$config3 = response.config) === null || _response$config3 === void 0 ? void 0 : _response$config3.url) || ''))
  };
};

function ownKeys$o(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$o(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$o(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$o(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var CacheableActionQueue = /*#__PURE__*/function () {
  function CacheableActionQueue(handleLogAction) {
    _classCallCheck(this, CacheableActionQueue);

    this.actionQueue = [];
    this.handleLogCallback = handleLogAction;
  }

  _createClass(CacheableActionQueue, [{
    key: "startAction",
    value: function startAction(params) {
      this.actionQueue.push({
        params: params,
        isCancelled: false,
        isCached: false,
        hasApiCall: false
      });
    }
  }, {
    key: "completeAction",
    value: function completeAction(completionInfo) {
      var action = this.actionQueue.shift();

      if (action) {
        var params = action.params,
            isCached = action.isCached,
            isCancelled = action.isCancelled,
            hasApiCall = action.hasApiCall;
        this.handleLogCallback(_objectSpread$o(_objectSpread$o({}, completionInfo), {}, {
          isCancelled: isCancelled,
          isCached: isCached || !hasApiCall,
          hasApiCall: hasApiCall,
          params: params
        }));
      }
    }
  }, {
    key: "onApiCancel",
    value: function onApiCancel() {
      if (this.actionQueue.length) {
        this.actionQueue[0].isCancelled = true;
      }
    }
  }, {
    key: "onCacheHit",
    value: function onCacheHit() {
      if (this.actionQueue.length) {
        this.actionQueue[this.actionQueue.length - 1].isCached = true;
      }
    }
  }, {
    key: "onApiCall",
    value: function onApiCall() {
      if (this.actionQueue.length) {
        this.actionQueue[this.actionQueue.length - 1].hasApiCall = true;
      }
    }
  }, {
    key: "clearActions",
    value: function clearActions() {
      this.actionQueue = [];
    }
  }, {
    key: "logAction",
    value: function logAction(info) {
      this.handleLogCallback(info);
    }
  }]);

  return CacheableActionQueue;
}();

var ADBLOCK_MESSAGE = 'Please turn off your AdBlocker if it was installed';
var useAdblockCheck = function useAdblockCheck() {
  var _useState = useState$2(false),
      _useState2 = _slicedToArray(_useState, 2),
      adblockEnabled = _useState2[0],
      setAdblockEnabled = _useState2[1];

  useEffect(function () {
    var testAd = document.createElement('div');
    testAd.innerHTML = '&nbsp;';
    testAd.className = 'ads ad adsbox doubleclick ad-placement';
    document.body.appendChild(testAd);
    setTimeout(function () {
      setAdblockEnabled(testAd.offsetHeight === 0);
      testAd.remove();
    }, 100);
  }, []);
  return [adblockEnabled, setAdblockEnabled];
};

var CAPSLOCK_MESSAGE = 'Caps lock is ON';
var useCapslockCheck = function useCapslockCheck() {
  var _useState = useState$2(false),
      _useState2 = _slicedToArray(_useState, 2),
      isCapsLock = _useState2[0],
      setIsCapsLock = _useState2[1];

  var checkCapsLock = useCallback(function (e) {
    var isCapsLockNew = e.getModifierState && e.getModifierState('CapsLock');

    if (isCapsLock !== isCapsLockNew) {
      setIsCapsLock(isCapsLockNew);
    }
  }, [isCapsLock]);
  useEffect(function () {
    window.addEventListener('keydown', checkCapsLock);
    window.addEventListener('keyup', checkCapsLock);
    return function () {
      window.removeEventListener('keydown', checkCapsLock);
      window.removeEventListener('keyup', checkCapsLock);
    };
  }, [checkCapsLock]);
  return [isCapsLock];
};

var css_248z$m = ":root {\n  --primary1: #123787;\n  --primary2: #1d58d7;\n  --primary3: #5173fb;\n  --primary4: #7a93ff;\n  --primary5: #c2d0ff;\n  --primary6: #e5ebff;\n  --primary7: #f2f5ff; }\n\n@keyframes TwoPartScreen-module_hover-ripples__3cbBt {\n  0% {\n    top: -0.1875em;\n    left: -0.1875em;\n    right: -0.1875em;\n    bottom: -0.1875em;\n    opacity: 1; }\n  100% {\n    top: -0.8125em;\n    left: -0.8125em;\n    right: -0.8125em;\n    bottom: -0.8125em;\n    opacity: 0; } }\n\n.TwoPartScreen-module_wrapper__3C0nd {\n  display: flex;\n  position: fixed;\n  left: 0;\n  top: 0;\n  width: 100vw;\n  height: 100vh;\n  padding-top: 3.75rem; }\n  .TwoPartScreen-module_wrapper__3C0nd .TwoPartScreen-module_leftWrapper__1Hlx2 {\n    position: relative;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: flex-start;\n    width: 47%; }\n  .TwoPartScreen-module_wrapper__3C0nd .TwoPartScreen-module_rightWrapper__1KMCq {\n    width: 53%;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    background-color: var(--primary7); }\n    .TwoPartScreen-module_wrapper__3C0nd .TwoPartScreen-module_rightWrapper__1KMCq .TwoPartScreen-module_illustration__29_2_ {\n      max-width: 90%;\n      max-height: 31.25rem;\n      pointer-events: none;\n      user-select: none; }\n  .TwoPartScreen-module_wrapper__3C0nd .TwoPartScreen-module_footerLinks__1chmL {\n    margin-top: auto;\n    margin-bottom: 2rem;\n    display: flex;\n    width: 100%;\n    justify-content: center; }\n    .TwoPartScreen-module_wrapper__3C0nd .TwoPartScreen-module_footerLinks__1chmL .TwoPartScreen-module_footerLink__3MWFO {\n      font-family: 'Avenir Next Regular', sans-serif;\n      font-weight: normal;\n      letter-spacing: .2px;\n      font-size: 0.75rem;\n      line-height: 0.875rem;\n      text-decoration: none;\n      color: #000000; }\n      .TwoPartScreen-module_wrapper__3C0nd .TwoPartScreen-module_footerLinks__1chmL .TwoPartScreen-module_footerLink__3MWFO:hover {\n        text-decoration: underline; }\n    .TwoPartScreen-module_wrapper__3C0nd .TwoPartScreen-module_footerLinks__1chmL .TwoPartScreen-module_footerLink__3MWFO + .TwoPartScreen-module_footerLink__3MWFO {\n      margin-left: 1.75rem; }\n\n.TwoPartScreen-module_title__1pxN2 {\n  font-family: 'Avenir Next Demi', sans-serif;\n  font-weight: normal;\n  letter-spacing: .2px;\n  font-size: 1.625rem;\n  line-height: 2rem;\n  color: #000000; }\n\n.TwoPartScreen-module_headerOrgName__2IgFn {\n  font-family: 'Avenir Next Demi', sans-serif;\n  font-weight: normal;\n  letter-spacing: .2px;\n  font-size: 1.25rem;\n  line-height: 2rem;\n  color: #000000;\n  margin-left: 1rem; }\n\n.TwoPartScreen-module_card__3g89i {\n  margin-top: 5.9375rem;\n  padding: 4.5rem;\n  box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.05), 0px 0px 8px rgba(0, 0, 0, 0.04);\n  min-height: 26rem;\n  position: absolute;\n  left: 7vw;\n  right: 7vw;\n  background-color: #ffffff; }\n  @media (max-width: 1400px) {\n    .TwoPartScreen-module_card__3g89i {\n      padding: 4.5rem 2.75rem;\n      margin-top: 4rem; } }\n  .TwoPartScreen-module_card__3g89i .TwoPartScreen-module_button__-h1by {\n    margin-top: 2rem; }\n  .TwoPartScreen-module_card__3g89i .TwoPartScreen-module_subtitle__1W4ew {\n    font-family: 'Avenir Next Regular', sans-serif;\n    font-weight: normal;\n    font-size: 1rem;\n    line-height: 1.5rem;\n    color: #000000;\n    margin: 0.5rem 0 1rem; }\n  .TwoPartScreen-module_card__3g89i .TwoPartScreen-module_subtitle__1W4ew + .TwoPartScreen-module_subtitle__1W4ew {\n    margin-top: -0.75rem; }\n  .TwoPartScreen-module_card__3g89i .TwoPartScreen-module_readonlyEmail__2ZZge {\n    cursor: pointer;\n    display: inline-block; }\n    .TwoPartScreen-module_card__3g89i .TwoPartScreen-module_readonlyEmail__2ZZge .svg-icon path {\n      fill: var(--primary2); }\n  .TwoPartScreen-module_card__3g89i .TwoPartScreen-module_passwordField__bbDQp {\n    margin-top: 1.5rem; }\n  .TwoPartScreen-module_card__3g89i .TwoPartScreen-module_warningMessage__1nt0k,\n  .TwoPartScreen-module_card__3g89i .TwoPartScreen-module_errorMessage__16uus,\n  .TwoPartScreen-module_card__3g89i .TwoPartScreen-module_successMessage__2K6a8 {\n    display: block;\n    color: #f7ad2a;\n    font-size: 0.875rem;\n    line-height: 1rem;\n    font-family: 'Avenir Next Regular', sans-serif;\n    font-weight: normal;\n    padding: 0.75rem 0 0; }\n  .TwoPartScreen-module_card__3g89i .TwoPartScreen-module_errorMessage__16uus {\n    color: #f1494a; }\n  .TwoPartScreen-module_card__3g89i .TwoPartScreen-module_successMessage__2K6a8 {\n    color: #289679; }\n  .TwoPartScreen-module_card__3g89i .TwoPartScreen-module_link__sWxts {\n    color: var(--primary4);\n    font-family: 'Avenir Next Demi', sans-serif;\n    font-weight: normal;\n    letter-spacing: .2px;\n    font-size: 0.75rem;\n    line-height: 0.9rem;\n    margin-top: 2.25rem;\n    text-decoration: none;\n    display: inline-block; }\n\n.TwoPartScreen-module_hide__2q7ao {\n  pointer-events: none;\n  animation-name: TwoPartScreen-module_hideme__19QJB;\n  animation-duration: 750ms;\n  opacity: 0;\n  z-index: 0; }\n\n.TwoPartScreen-module_show__nIww9 {\n  animation-name: TwoPartScreen-module_showme__3uIMS;\n  animation-duration: 750ms;\n  opacity: 1;\n  z-index: 2; }\n\n@keyframes TwoPartScreen-module_hideme__19QJB {\n  0% {\n    left: 7vw;\n    opacity: 1; }\n  50% {\n    opacity: 0.2; }\n  100% {\n    left: -14vw;\n    opacity: 0; } }\n\n@keyframes TwoPartScreen-module_showme__3uIMS {\n  0% {\n    left: -14vw;\n    opacity: 0; }\n  50% {\n    opacity: 0.8; }\n  100% {\n    left: 7vw;\n    opacity: 1; } }\n\n@media (max-width: 1200px) {\n  .TwoPartScreen-module_wrapper__3C0nd {\n    flex-direction: column;\n    position: static;\n    min-height: 100vh;\n    height: 100%;\n    padding-top: 3rem; }\n    .TwoPartScreen-module_wrapper__3C0nd .TwoPartScreen-module_leftWrapper__1Hlx2 {\n      position: static;\n      width: 100%;\n      height: 100%; }\n    .TwoPartScreen-module_wrapper__3C0nd .TwoPartScreen-module_card__3g89i {\n      position: static;\n      z-index: 0;\n      width: 90%;\n      padding: 3rem;\n      margin-top: 3rem;\n      min-height: auto; }\n    .TwoPartScreen-module_wrapper__3C0nd .TwoPartScreen-module_footerLinks__1chmL {\n      margin-top: -15rem;\n      margin-bottom: 0;\n      padding-top: 20rem;\n      background-color: var(--primary7); }\n    .TwoPartScreen-module_wrapper__3C0nd .TwoPartScreen-module_rightWrapper__1KMCq {\n      width: 100%;\n      min-height: 50vh; }\n      .TwoPartScreen-module_wrapper__3C0nd .TwoPartScreen-module_rightWrapper__1KMCq .TwoPartScreen-module_illustration__29_2_ {\n        padding: 3rem 0; } }\n\n@media (max-width: 380px) {\n  .TwoPartScreen-module_wrapper__3C0nd .TwoPartScreen-module_card__3g89i {\n    padding: 3rem 2rem; } }\n";
var styles$j = {"wrapper":"TwoPartScreen-module_wrapper__3C0nd","leftWrapper":"TwoPartScreen-module_leftWrapper__1Hlx2","rightWrapper":"TwoPartScreen-module_rightWrapper__1KMCq","illustration":"TwoPartScreen-module_illustration__29_2_","footerLinks":"TwoPartScreen-module_footerLinks__1chmL","footerLink":"TwoPartScreen-module_footerLink__3MWFO","title":"TwoPartScreen-module_title__1pxN2","headerOrgName":"TwoPartScreen-module_headerOrgName__2IgFn","card":"TwoPartScreen-module_card__3g89i","button":"TwoPartScreen-module_button__-h1by","subtitle":"TwoPartScreen-module_subtitle__1W4ew","readonlyEmail":"TwoPartScreen-module_readonlyEmail__2ZZge","passwordField":"TwoPartScreen-module_passwordField__bbDQp","warningMessage":"TwoPartScreen-module_warningMessage__1nt0k","errorMessage":"TwoPartScreen-module_errorMessage__16uus","successMessage":"TwoPartScreen-module_successMessage__2K6a8","link":"TwoPartScreen-module_link__sWxts","hide":"TwoPartScreen-module_hide__2q7ao","hideme":"TwoPartScreen-module_hideme__19QJB","show":"TwoPartScreen-module_show__nIww9","showme":"TwoPartScreen-module_showme__3uIMS","hover-ripples":"TwoPartScreen-module_hover-ripples__3cbBt"};
styleInject(css_248z$m);

var TwoPartScreen = function TwoPartScreen(props) {
  var _initData$pages;

  var rightPartImage = props.rightPartImage,
      leftChildren = props.leftChildren,
      docTitle = props.docTitle,
      for404Page = props.for404Page;

  var _useState = useState$2({}),
      _useState2 = _slicedToArray(_useState, 2),
      initData = _useState2[0],
      setInitData = _useState2[1];

  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(SimpleHeader, {
    docTitle: docTitle,
    setParentInitData: setInitData,
    for404Page: for404Page
  }), /*#__PURE__*/React__default.createElement("div", {
    className: styles$j.wrapper
  }, /*#__PURE__*/React__default.createElement("div", {
    className: styles$j.leftWrapper
  }, leftChildren, /*#__PURE__*/React__default.createElement("div", {
    className: styles$j.footerLinks
  }, (((_initData$pages = initData.pages) === null || _initData$pages === void 0 ? void 0 : _initData$pages.footer) || []).map(function (item) {
    return /*#__PURE__*/React__default.createElement("a", {
      key: item.url,
      className: styles$j.footerLink,
      href: item.url,
      target: "_blank",
      rel: "noopener noreferrer"
    }, item.label);
  }))), /*#__PURE__*/React__default.createElement("div", {
    className: styles$j.rightWrapper
  }, /*#__PURE__*/React__default.createElement("img", {
    src: rightPartImage,
    className: styles$j.illustration,
    alt: "illustration"
  }))));
};
TwoPartScreen.propTypes = {
  rightPartImage: PropTypes.string.isRequired,
  leftChildren: PropTypes.node.isRequired,
  docTitle: PropTypes.string.isRequired
};

var css_248z$n = ":root {\n  --primary1: #123787;\n  --primary2: #1d58d7;\n  --primary3: #5173fb;\n  --primary4: #7a93ff;\n  --primary5: #c2d0ff;\n  --primary6: #e5ebff;\n  --primary7: #f2f5ff; }\n\n@keyframes index-module_hover-ripples__2dS6- {\n  0% {\n    top: -0.1875em;\n    left: -0.1875em;\n    right: -0.1875em;\n    bottom: -0.1875em;\n    opacity: 1; }\n  100% {\n    top: -0.8125em;\n    left: -0.8125em;\n    right: -0.8125em;\n    bottom: -0.8125em;\n    opacity: 0; } }\n\n.index-module_hidden__2xpzw .tooltip__label {\n  display: none; }\n\n.index-module_container__1gJwX {\n  height: 2.5rem;\n  width: 13.1875rem;\n  z-index: 4;\n  margin-right: 0.5rem; }\n  .index-module_container__1gJwX .index-module_openerBtn__1NLRO {\n    border-radius: 0.125rem;\n    height: 2.5rem;\n    max-width: 13.1875rem;\n    width: 100%;\n    border: 1px solid #cbcbcb;\n    padding: 0.375rem 0.625rem;\n    cursor: pointer;\n    position: relative;\n    display: flex;\n    z-index: 8;\n    transition: width 0.3s ease-in-out; }\n    .index-module_container__1gJwX .index-module_openerBtnIndicator__kTyze {\n      position: absolute;\n      top: 50%;\n      right: 0.75rem;\n      transform: translateY(-50%);\n      border-style: solid;\n      border-width: 0.25rem 0.25rem 0;\n      border-color: #787878 transparent transparent transparent;\n      cursor: pointer;\n      width: 0;\n      height: 0;\n      transition: border 0.25s; }\n    .index-module_container__1gJwX .index-module_openerBtnText__2u_g0 {\n      font-size: 0.875rem;\n      line-height: 1.125rem;\n      display: flex;\n      align-items: center;\n      user-select: none;\n      font-family: 'Avenir Next Regular', sans-serif;\n      font-weight: normal; }\n  .index-module_container__1gJwX ._opened .index-module_openerBtn__1NLRO {\n    border-color: var(--primary2);\n    border-bottom-color: transparent;\n    border-bottom-left-radius: 0;\n    border-bottom-right-radius: 0;\n    position: relative; }\n    .index-module_container__1gJwX ._opened .index-module_openerBtn__1NLRO::after {\n      content: '';\n      position: absolute;\n      bottom: -0.125rem;\n      left: 0;\n      height: 3px;\n      width: 13.0625rem;\n      background-color: #ffffff;\n      z-index: 5; }\n  .index-module_container__1gJwX .index-module_openerContent__1C9HP {\n    border-radius: 0.125rem;\n    border-top-left-radius: 0;\n    border: 1px solid var(--primary2);\n    position: relative;\n    margin-top: -0.0625rem;\n    width: 100%;\n    height: 50vh;\n    max-height: 28.375rem;\n    overflow-y: auto;\n    overflow-x: hidden;\n    background-color: #ffffff;\n    z-index: 7; }\n    .index-module_container__1gJwX .index-module_openerContent__1C9HP .index-module_workspaceWrapper__1-iFp {\n      min-height: 2.375rem; }\n    .index-module_container__1gJwX .index-module_openerContent__1C9HP .index-module_row__1F5Iw {\n      height: 3.5rem;\n      padding: 0.5rem 0.25rem 0.5rem 1rem;\n      display: flex;\n      justify-content: flex-start;\n      align-items: center;\n      position: relative; }\n      .index-module_container__1gJwX .index-module_openerContent__1C9HP .index-module_row__1F5Iw:hover {\n        background-color: #f9f9f9; }\n        .index-module_container__1gJwX .index-module_openerContent__1C9HP .index-module_row__1F5Iw:hover .index-module_checkbox__1qa1b,\n        .index-module_container__1gJwX .index-module_openerContent__1C9HP .index-module_row__1F5Iw:hover .index-module_expand__zm-02 {\n          background-color: #f9f9f9; }\n      .index-module_container__1gJwX .index-module_openerContent__1C9HP .index-module_rowSelected__1R7rF {\n        background-color: var(--primary7); }\n        .index-module_container__1gJwX .index-module_openerContent__1C9HP .index-module_rowSelected__1R7rF .index-module_expand__zm-02 {\n          background-color: var(--primary7); }\n        .index-module_container__1gJwX .index-module_openerContent__1C9HP .index-module_rowSelected__1R7rF::before {\n          content: '';\n          position: absolute;\n          top: 0;\n          left: 0;\n          height: 100%;\n          width: 0.1875rem;\n          background-color: var(--primary2); }\n      .index-module_container__1gJwX .index-module_openerContent__1C9HP .index-module_rowName__2eK9_ {\n        font-size: 0.875rem;\n        line-height: 1.125rem;\n        display: flex;\n        align-items: center;\n        user-select: none;\n        flex-grow: 1; }\n      .index-module_container__1gJwX .index-module_openerContent__1C9HP .index-module_row__1F5Iw .index-module_checkbox__1qa1b {\n        width: 1.5rem;\n        height: 1.5rem;\n        display: flex;\n        align-items: center;\n        margin-right: 0.5rem; }\n        .index-module_container__1gJwX .index-module_openerContent__1C9HP .index-module_row__1F5Iw .index-module_checkboxChecked__3l8qW {\n          background-color: var(--primary7); }\n          .index-module_container__1gJwX .index-module_openerContent__1C9HP .index-module_row__1F5Iw .index-module_checkboxChecked__3l8qW .svg-icon path {\n            fill: var(--primary2) !important; }\n      .index-module_container__1gJwX .index-module_openerContent__1C9HP .index-module_row__1F5Iw .index-module_expand__zm-02 {\n        display: flex;\n        align-items: center;\n        height: 1.5rem;\n        margin-left: auto; }\n        .index-module_container__1gJwX .index-module_openerContent__1C9HP .index-module_row__1F5Iw .index-module_expand__zm-02 svg {\n          width: 1.25rem;\n          height: 1.25rem; }\n    .index-module_container__1gJwX .index-module_openerContent__1C9HP .index-module_innerRow__1nCZR {\n      padding-left: 3rem; }\n    .index-module_container__1gJwX .index-module_openerContent__1C9HP .index-module_selectDeselectAll__NpIzd {\n      font-size: 0.75rem;\n      line-height: 1rem;\n      padding: 0.5rem 0.25rem 0.5rem 1rem;\n      display: flex;\n      flex-direction: row;\n      cursor: pointer;\n      white-space: nowrap;\n      font-family: 'Avenir Next Regular', sans-serif;\n      font-weight: normal;\n      justify-content: space-between;\n      align-items: center;\n      color: var(--primary2); }\n      .index-module_container__1gJwX .index-module_openerContent__1C9HP .index-module_selectDeselectAll__NpIzd .index-module_disabled__2thYp {\n        color: #a2a2a2;\n        cursor: default; }\n    .index-module_container__1gJwX .index-module_openerContent__1C9HP .index-module_globalSelectAll__3fVyk {\n      cursor: pointer; }\n    .index-module_container__1gJwX .index-module_openerContent__1C9HP .index-module_header__3r6u- {\n      position: sticky;\n      top: 0;\n      background-color: #ffffff;\n      z-index: 6; }\n      .index-module_container__1gJwX .index-module_openerContent__1C9HP .index-module_header__3r6u- .index-module_searchBox__-T10p {\n        margin-top: 0; }\n        .index-module_container__1gJwX .index-module_openerContent__1C9HP .index-module_header__3r6u- .index-module_searchBox__-T10p {\n          /*.text-field__icon {\n            margin-top: -2/16+rem;\n          }*/ }\n          .index-module_container__1gJwX .index-module_openerContent__1C9HP .index-module_header__3r6u- .index-module_searchBox__-T10p .text-field__base {\n            border: 0; }\n          .index-module_container__1gJwX .index-module_openerContent__1C9HP .index-module_header__3r6u- .index-module_searchBox__-T10p .text-field__base:hover {\n            box-shadow: none; }\n          .index-module_container__1gJwX .index-module_openerContent__1C9HP .index-module_header__3r6u- .index-module_searchBox__-T10p .text-field__input {\n            font-family: 'Avenir Next Regular', sans-serif;\n            font-weight: normal;\n            font-size: 0.875rem; }\n          .index-module_container__1gJwX .index-module_openerContent__1C9HP .index-module_header__3r6u- .index-module_searchBox__-T10p .text-field__reset {\n            margin-right: 1.125rem;\n            height: 1.375rem;\n            width: 1.375rem;\n            top: 0.5rem; }\n  .index-module_container__1gJwX .index-module_noResults__3fgfL {\n    display: flex;\n    width: 100%;\n    align-items: center;\n    justify-content: center;\n    flex-direction: column;\n    color: #666666;\n    padding: 4.75rem 0 9.875rem; }\n    .index-module_container__1gJwX .index-module_noResultsIcon__Nnp9l {\n      height: 2rem;\n      width: 2rem;\n      margin-bottom: 1rem; }\n    .index-module_container__1gJwX .index-module_noResultsTitle__2uRMm {\n      font-family: 'Avenir Next Bold', sans-serif;\n      font-weight: normal;\n      font-size: 1rem;\n      line-height: 1.2rem;\n      margin-bottom: 0.25rem;\n      text-align: center; }\n    .index-module_container__1gJwX .index-module_noResultsMessage__3azJt {\n      font-family: 'Avenir Next Regular', sans-serif;\n      font-weight: normal;\n      font-size: 0.875rem;\n      line-height: 1.05rem;\n      width: 15.625rem;\n      text-align: center; }\n  .index-module_container__1gJwX .index-module_optionContent__r5cYm {\n    display: flex;\n    flex-direction: row;\n    justify-content: flex-start;\n    align-items: center;\n    width: 100%;\n    max-width: 100%;\n    min-width: 0; }\n    .index-module_container__1gJwX .index-module_optionContent__r5cYm .tooltip__label-inner {\n      word-break: break-word;\n      hyphens: auto; }\n    .index-module_container__1gJwX .index-module_optionContent__r5cYm .index-module_highlight__186yj {\n      color: var(--primary2); }\n    .index-module_container__1gJwX .index-module_optionContent__r5cYm .index-module_optionIconGroup__2V5HN {\n      width: 2.5rem;\n      height: 2.5rem;\n      margin-right: 0.75rem;\n      position: relative; }\n      .index-module_container__1gJwX .index-module_optionContent__r5cYm .index-module_optionIconGroup__2V5HN .index-module_optionIconCrownWrapper__MHgiy {\n        height: 0.9375rem;\n        width: 0.9375rem;\n        padding: 0.125rem;\n        border-radius: 50%;\n        overflow: hidden;\n        display: flex;\n        justify-content: center;\n        align-items: center;\n        position: absolute;\n        left: 25px;\n        top: 0px;\n        z-index: 5;\n        background-color: var(--primary2);\n        box-shadow: 0 0 0 0.0625rem #ffffff; }\n        .index-module_container__1gJwX .index-module_optionContent__r5cYm .index-module_optionIconGroup__2V5HN .index-module_optionIconCrownWrapper__MHgiy .svg-icon {\n          height: 100%;\n          width: 100%;\n          fill: #ffffff; }\n          .index-module_container__1gJwX .index-module_optionContent__r5cYm .index-module_optionIconGroup__2V5HN .index-module_optionIconCrownWrapper__MHgiy .svg-icon.stroke-icon path {\n            stroke: #ffffff; }\n      .index-module_container__1gJwX .index-module_optionContent__r5cYm .index-module_optionIconGroup__2V5HN .index-module_optionIconWrapper__2GNLe {\n        border-radius: 50%;\n        min-width: 2.375rem;\n        width: 2.375rem;\n        height: 2.375rem;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        margin-right: 1rem;\n        position: relative;\n        box-shadow: 0 0 0 0.0625rem #ffffff, 0 0 0 0.125rem #cbcbcb;\n        overflow: hidden; }\n        .index-module_container__1gJwX .index-module_optionContent__r5cYm .index-module_optionIconGroup__2V5HN .index-module_optionIconWrapper__2GNLe.index-module_workspaceIconWrapper__1Cr5W {\n          box-shadow: 0 0 0 0.0625rem #ffffff, 0 0 0 0.125rem var(--primary2); }\n        .index-module_container__1gJwX .index-module_optionContent__r5cYm .index-module_optionIconGroup__2V5HN .index-module_optionIconWrapper__2GNLe .index-module_optionIcon__1xVhn {\n          border-radius: 50%;\n          width: 100%;\n          height: 100%;\n          object-fit: contain; }\n    .index-module_container__1gJwX .index-module_optionContent__r5cYm .index-module_optionText__3nzYZ {\n      display: flex;\n      flex-direction: column;\n      align-items: flex-start;\n      justify-content: center;\n      font-size: 0.875rem;\n      line-height: 1.05rem;\n      color: #000000;\n      min-width: 0; }\n      .index-module_container__1gJwX .index-module_optionContent__r5cYm .index-module_optionText__3nzYZ .index-module_tooltip__qqhZz {\n        width: 100%;\n        max-width: 25rem; }\n      .index-module_container__1gJwX .index-module_optionContent__r5cYm .index-module_optionText__3nzYZ .index-module_tooltipWrapper__vFSlC {\n        display: flex;\n        flex-direction: row;\n        align-items: center;\n        justify-content: flex-start;\n        width: 100%; }\n      .index-module_container__1gJwX .index-module_optionContent__r5cYm .index-module_optionText__3nzYZ .index-module_optionTextTop__2ypur {\n        font-family: 'Avenir Next Bold', sans-serif;\n        font-weight: normal;\n        white-space: nowrap;\n        overflow: hidden;\n        text-overflow: ellipsis;\n        margin-bottom: 0.1875rem;\n        width: 100%;\n        min-width: 0; }\n        .index-module_container__1gJwX .index-module_optionContent__r5cYm .index-module_optionText__3nzYZ .index-module_optionTextTop__2ypur::after {\n          content: '';\n          display: block; }\n      .index-module_container__1gJwX .index-module_optionContent__r5cYm .index-module_optionText__3nzYZ .index-module_optionTextBottom__U7U-p {\n        font-family: 'Avenir Next Regular', sans-serif;\n        font-weight: normal;\n        display: flex;\n        flex-direction: row;\n        align-items: center;\n        justify-content: center; }\n        .index-module_container__1gJwX .index-module_optionContent__r5cYm .index-module_optionText__3nzYZ .index-module_optionTextBottom__U7U-p .index-module_optionTextId__3ev1K .index-module_idText__1-axl {\n          color: #666666;\n          margin-right: 0.25rem; }\n        .index-module_container__1gJwX .index-module_optionContent__r5cYm .index-module_optionText__3nzYZ .index-module_optionTextBottom__U7U-p .index-module_optionTextSeparator__30NNR {\n          height: 0.1875rem;\n          width: 0.1875rem;\n          border-radius: 50%;\n          background: #666666;\n          margin-left: 0.25rem;\n          margin-right: 0.25rem; }\n        .index-module_container__1gJwX .index-module_optionContent__r5cYm .index-module_optionText__3nzYZ .index-module_optionTextBottom__U7U-p .index-module_optionTextStatus__1g55_ {\n          display: flex;\n          flex-direction: row;\n          align-items: center;\n          justify-content: center; }\n          .index-module_container__1gJwX .index-module_optionContent__r5cYm .index-module_optionText__3nzYZ .index-module_optionTextBottom__U7U-p .index-module_optionTextStatus__1g55_ .index-module_statusIcon__1o7Tn {\n            height: 1.125rem;\n            width: 1.125rem;\n            margin-right: 0.125rem; }\n  .index-module_container__1gJwX .opener {\n    display: none; }\n    .index-module_container__1gJwX .opener._opened {\n      display: block;\n      width: 32.875rem; }\n";
var styles$k = {"hidden":"index-module_hidden__2xpzw","container":"index-module_container__1gJwX","openerBtn":"index-module_openerBtn__1NLRO","openerBtnIndicator":"index-module_openerBtnIndicator__kTyze","openerBtnText":"index-module_openerBtnText__2u_g0","openerContent":"index-module_openerContent__1C9HP","workspaceWrapper":"index-module_workspaceWrapper__1-iFp","row":"index-module_row__1F5Iw","checkbox":"index-module_checkbox__1qa1b","expand":"index-module_expand__zm-02","rowSelected":"index-module_rowSelected__1R7rF","rowName":"index-module_rowName__2eK9_","checkboxChecked":"index-module_checkboxChecked__3l8qW","innerRow":"index-module_innerRow__1nCZR","selectDeselectAll":"index-module_selectDeselectAll__NpIzd","disabled":"index-module_disabled__2thYp","globalSelectAll":"index-module_globalSelectAll__3fVyk","header":"index-module_header__3r6u-","searchBox":"index-module_searchBox__-T10p","noResults":"index-module_noResults__3fgfL","noResultsIcon":"index-module_noResultsIcon__Nnp9l","noResultsTitle":"index-module_noResultsTitle__2uRMm","noResultsMessage":"index-module_noResultsMessage__3azJt","optionContent":"index-module_optionContent__r5cYm","highlight":"index-module_highlight__186yj","optionIconGroup":"index-module_optionIconGroup__2V5HN","optionIconCrownWrapper":"index-module_optionIconCrownWrapper__MHgiy","optionIconWrapper":"index-module_optionIconWrapper__2GNLe","workspaceIconWrapper":"index-module_workspaceIconWrapper__1Cr5W","optionIcon":"index-module_optionIcon__1xVhn","optionText":"index-module_optionText__3nzYZ","tooltip":"index-module_tooltip__qqhZz","tooltipWrapper":"index-module_tooltipWrapper__vFSlC","optionTextTop":"index-module_optionTextTop__2ypur","optionTextBottom":"index-module_optionTextBottom__U7U-p","optionTextId":"index-module_optionTextId__3ev1K","idText":"index-module_idText__1-axl","optionTextSeparator":"index-module_optionTextSeparator__30NNR","optionTextStatus":"index-module_optionTextStatus__1g55_","statusIcon":"index-module_statusIcon__1o7Tn","hover-ripples":"index-module_hover-ripples__2dS6-"};
styleInject(css_248z$n);

var CheckedButton = function CheckedButton(props) {
  var onClick = props.onClick,
      _props$disabled = props.disabled,
      disabled = _props$disabled === void 0 ? false : _props$disabled;
  return /*#__PURE__*/React__default.createElement(ButtonCircle, {
    onClick: onClick,
    iconName: 'Checkbox',
    className: "".concat(styles$k.checkbox, " ").concat(styles$k.checkboxChecked),
    disabled: disabled
  });
};
CheckedButton.propTypes = {
  onClick: PropTypes.func,
  disabled: PropTypes.bool
};

var UncheckedButton = function UncheckedButton(props) {
  var onClick = props.onClick,
      _props$disabled = props.disabled,
      disabled = _props$disabled === void 0 ? false : _props$disabled;
  return /*#__PURE__*/React__default.createElement(ButtonCircle, {
    onClick: onClick,
    iconName: 'CheckboxBlank',
    className: styles$k.checkbox,
    disabled: disabled
  });
};
UncheckedButton.propTypes = {
  onClick: PropTypes.func,
  disabled: PropTypes.bool
};

function ownKeys$p(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$p(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$p(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$p(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var StatusIconMapper = {
  Active: 'StatusApprovedColor',
  Invited: 'StatusInvitedColor',
  Pending: 'StatusPendingColor',
  Suspended: 'StatusPausedColor',
  Rejected: 'StatusRejectedColor'
};
var NestedCustomerSelect = function NestedCustomerSelect(props) {
  var _selectedOwIds$split;

  var _props$workspaceOwIds = props.workspaceOwIds,
      workspaceOwIds = _props$workspaceOwIds === void 0 ? '' : _props$workspaceOwIds,
      _props$selectedOwIds = props.selectedOwIds,
      selectedOwIds = _props$selectedOwIds === void 0 ? '' : _props$selectedOwIds,
      onChangeSelection = props.onChangeSelection,
      onChangeAdvertiserSelection = props.onChangeAdvertiserSelection,
      onChangeWorkspaceSelection = props.onChangeWorkspaceSelection,
      _props$stopClickPropa = props.stopClickPropagation,
      stopClickPropagation = _props$stopClickPropa === void 0 ? true : _props$stopClickPropa,
      _props$selectAllOnLoa = props.selectAllOnLoad,
      selectAllOnLoad = _props$selectAllOnLoa === void 0 ? false : _props$selectAllOnLoa,
      _props$hideCurrentUse = props.hideCurrentUser,
      hideCurrentUser = _props$hideCurrentUse === void 0 ? false : _props$hideCurrentUse,
      _props$selectAdvertis = props.selectAdvertisersOnWorkspaceSelect,
      selectAdvertisersOnWorkspaceSelect = _props$selectAdvertis === void 0 ? false : _props$selectAdvertis,
      onLoad = props.onLoad,
      onLoadError = props.onLoadError,
      onSelectAll = props.onSelectAll,
      _props$openerProps = props.openerProps,
      openerProps = _props$openerProps === void 0 ? {} : _props$openerProps,
      _props$disableSafariA = props.disableSafariAutoCorrect,
      disableSafariAutoCorrect = _props$disableSafariA === void 0 ? false : _props$disableSafariA,
      _props$isWorkspacesOn = props.isWorkspacesOnly,
      isWorkspacesOnly = _props$isWorkspacesOn === void 0 ? false : _props$isWorkspacesOn,
      _props$expectedStatus = props.expectedStatusId,
      expectedStatusId = _props$expectedStatus === void 0 ? [1, 2, 3, 4, 5] : _props$expectedStatus,
      _props$className = props.className,
      className = _props$className === void 0 ? '' : _props$className,
      _props$width = props.width,
      width = _props$width === void 0 ? 0 : _props$width,
      _props$undeletableOwI = props.undeletableOwIds,
      undeletableOwIds = _props$undeletableOwI === void 0 ? [] : _props$undeletableOwI,
      _props$preserveSelect = props.preserveSelection,
      preserveSelection = _props$preserveSelect === void 0 ? true : _props$preserveSelect,
      _props$sortOptionByNa = props.sortOptionByName,
      sortOptionByName = _props$sortOptionByNa === void 0 ? false : _props$sortOptionByNa,
      _props$hideWorkspaceW = props.hideWorkspaceWithNoAdvertiser,
      hideWorkspaceWithNoAdvertiser = _props$hideWorkspaceW === void 0 ? false : _props$hideWorkspaceW;

  var _useState = useState$2([]),
      _useState2 = _slicedToArray(_useState, 2),
      rows = _useState2[0],
      setRows = _useState2[1];

  var _useState3 = useState$2(selectedOwIds ? selectedOwIds.split(',').map(Number) : []),
      _useState4 = _slicedToArray(_useState3, 2),
      selected = _useState4[0],
      setSelected = _useState4[1];

  var _useState5 = useState$2([]),
      _useState6 = _slicedToArray(_useState5, 2),
      selectedWorkspaces = _useState6[0],
      setSelectedWorkspaces = _useState6[1];

  var _useState7 = useState$2([]),
      _useState8 = _slicedToArray(_useState7, 2),
      selectedAdvertisers = _useState8[0],
      setSelectedAdvertisers = _useState8[1];

  var _useState9 = useState$2([]),
      _useState10 = _slicedToArray(_useState9, 2),
      selectedAdvertisersItems = _useState10[0],
      setSelectedAdvertisersItems = _useState10[1];

  var _useState11 = useState$2([]),
      _useState12 = _slicedToArray(_useState11, 2),
      expanded = _useState12[0],
      setExpanded = _useState12[1];

  var _useState13 = useState$2(''),
      _useState14 = _slicedToArray(_useState13, 2),
      searchField = _useState14[0],
      setSearchField = _useState14[1];

  var _useState15 = useState$2(false),
      _useState16 = _slicedToArray(_useState15, 2),
      isOpen = _useState16[0],
      setIsOpen = _useState16[1];

  var _useState17 = useState$2(1),
      _useState18 = _slicedToArray(_useState17, 2),
      pageNo = _useState18[0],
      setPageNo = _useState18[1];

  var _useState19 = useState$2(false),
      _useState20 = _slicedToArray(_useState19, 2),
      loading = _useState20[0],
      setLoading = _useState20[1];

  var _useState21 = useState$2(false),
      _useState22 = _slicedToArray(_useState21, 2),
      hasMore = _useState22[0],
      setHasMore = _useState22[1];

  var _useState23 = useState$2(true),
      _useState24 = _slicedToArray(_useState23, 2),
      noDropdown = _useState24[0],
      setNoDropdown = _useState24[1];

  var _useState25 = useState$2(false),
      _useState26 = _slicedToArray(_useState25, 2),
      showDeselectAll = _useState26[0],
      setShowDeselectAll = _useState26[1];

  var _useState27 = useState$2(!selectAllOnLoad),
      _useState28 = _slicedToArray(_useState27, 2),
      showSelectAll = _useState28[0],
      setShowSelectAll = _useState28[1];

  var io = useRef();
  var cancelTokenSource = useRef(null);
  var isSearchChanged = useRef(false);
  var isFirstLoad = useRef(true);
  var authorizedUser = useRef(null);
  var prevSelectedLength = useRef(selectedOwIds ? (_selectedOwIds$split = selectedOwIds.split(',')) === null || _selectedOwIds$split === void 0 ? void 0 : _selectedOwIds$split.length : 0);
  var maxSelectedLength = useRef(0);

  var _useState29 = useState$2(false),
      _useState30 = _slicedToArray(_useState29, 2),
      isWorkspaceOwnerOrg = _useState30[0],
      setIsWorkspaceOwnerOrg = _useState30[1];

  var _useState31 = useState$2(true),
      _useState32 = _slicedToArray(_useState31, 2),
      showPlaceholderCount = _useState32[0],
      setShowPlaceholderCount = _useState32[1];

  var didComponentRender = useRef(false);
  var selectExternalStyling = width ? {
    width: "".concat(width / 16, "rem")
  } : null;
  useEffect(function () {
    var updateCondition = preserveSelection ? selectedOwIds : typeof selectedOwIds === 'string';

    if (rows[0] && updateCondition) {
      var owIds = selectedOwIds ? selectedOwIds.split(',').map(Number) : [];
      setSelected(owIds);

      if (!isEqual$1(owIds, selectedAdvertisers)) {
        setSelectedAdvertisers(owIds);
        setSelectedAdvertisersItems(owIds.map(function (owId) {
          return rows[0].customers.find(function (cust) {
            return (cust === null || cust === void 0 ? void 0 : cust.owId) === owId;
          });
        }));
      }
    } else if (selectedOwIds === '') {
      setSelected([]);
    }
  }, [selectedOwIds, rows]);
  var getData = useCallback( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee() {
    var _ref2,
        _ref2$searchField,
        searchField,
        _ref2$pageNo,
        pageNo,
        _ref2$all,
        all,
        _ref2$searchChanged,
        searchChanged,
        res,
        customers,
        currentUser,
        _args = arguments;

    return regenerator.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _ref2 = _args.length > 0 && _args[0] !== undefined ? _args[0] : {}, _ref2$searchField = _ref2.searchField, searchField = _ref2$searchField === void 0 ? '' : _ref2$searchField, _ref2$pageNo = _ref2.pageNo, pageNo = _ref2$pageNo === void 0 ? 1 : _ref2$pageNo, _ref2$all = _ref2.all, all = _ref2$all === void 0 ? false : _ref2$all, _ref2$searchChanged = _ref2.searchChanged, searchChanged = _ref2$searchChanged === void 0 ? false : _ref2$searchChanged;

            if (cancelTokenSource.current) {
              cancelTokenSource.current.cancel();
            }

            cancelTokenSource.current = axios.CancelToken.source();

            if (pageNo === 1 && !searchChanged) {
              maxSelectedLength.current = 0;
            }

            if (searchChanged) {
              setRows([]);
            }

            setLoading(true);

            if (!isWorkspacesOnly) {
              _context.next = 12;
              break;
            }

            _context.next = 9;
            return ApiService.getWorkspacesData({
              searchField: searchField,
              owIds: workspaceOwIds,
              pageNo: all ? -1 : pageNo,
              status: expectedStatusId.filter(function (id) {
                return Number(id);
              }).join(',')
            }, cancelTokenSource.current.token);

          case 9:
            _context.t0 = _context.sent;
            _context.next = 15;
            break;

          case 12:
            _context.next = 14;
            return ApiService.getMultiLevelCustomersData(_objectSpread$p({
              searchField: searchField,
              owIds: workspaceOwIds,
              pageNo: all ? -1 : pageNo,
              status: expectedStatusId.filter(function (id) {
                return Number(id);
              }).join(',')
            }, sortOptionByName ? {
              sortBy: '+organizationName'
            } : {}), cancelTokenSource.current.token);

          case 14:
            _context.t0 = _context.sent;

          case 15:
            res = _context.t0;

            if (!axios.isCancel(res)) {
              _context.next = 20;
              break;
            }

            return _context.abrupt("return");

          case 20:
            if (res && onLoad) {
              onLoad(res);
            } else if (onLoadError && !res) {
              onLoadError();
            }

          case 21:
            customers = (res === null || res === void 0 ? void 0 : res.data) || res || [];
            currentUser = AuthService.getUser();

            if (hideCurrentUser && currentUser && currentUser.isPlatformOwnerOrg) {
              customers = customers.filter(function (customer) {
                return customer.owId !== currentUser.owId;
              });
            }

            if (customers.length && expectedStatusId) {
              customers = customers.filter(function (customer) {
                return expectedStatusId.includes(customer.statusId);
              });
            }

            if (hideWorkspaceWithNoAdvertiser) {
              customers = customers.filter(function (cust) {
                var _cust$customers;

                return cust === null || cust === void 0 ? void 0 : (_cust$customers = cust.customers) === null || _cust$customers === void 0 ? void 0 : _cust$customers.length;
              });
            }

            if (all) {
              maxSelectedLength.current = customers.reduce(function (acc, current) {
                var _current$customers;

                return acc + 1 + (((_current$customers = current.customers) === null || _current$customers === void 0 ? void 0 : _current$customers.length) || 0);
              }, 0);
            } else if (!searchChanged) {
              maxSelectedLength.current = maxSelectedLength.current + customers.reduce(function (acc, current) {
                var _current$customers2;

                return acc + 1 + (((_current$customers2 = current.customers) === null || _current$customers2 === void 0 ? void 0 : _current$customers2.length) || 0);
              }, 0);
            }

            authorizedUser.current = currentUser;

            if (all || searchChanged) {
              setRows(customers);
            } else {
              setRows(function (existing) {
                return [].concat(_toConsumableArray(existing), _toConsumableArray(customers));
              });
            }

            setLoading(false);

            if (res !== null && res !== void 0 && res.filteredRecords) {
              setHasMore(res.filteredRecords > 20 * pageNo);
            }

            return _context.abrupt("return", all ? customers : [].concat(_toConsumableArray(rows), [customers]));

          case 32:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  })), [workspaceOwIds, hideCurrentUser, rows, onLoad, onLoadError, expectedStatusId, isWorkspacesOnly]);
  var debouncedGetData = useRef(debounce$1(function (requestData) {
    return getData(requestData);
  }, 500));
  useEffect(function () {
    var getUpdatedUser = /*#__PURE__*/function () {
      var _ref3 = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee2() {
        var user, authorizedUser;
        return regenerator.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                user = AuthService.getUser();
                _context2.next = 3;
                return AuthService.authorize(user, true);

              case 3:
                authorizedUser = _context2.sent;

                if (authorizedUser !== null && authorizedUser !== void 0 && authorizedUser.isWorkspaceOwnerOrg) {
                  setIsWorkspaceOwnerOrg(true);
                }

              case 5:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      return function getUpdatedUser() {
        return _ref3.apply(this, arguments);
      };
    }();

    getUpdatedUser();
  }, [setIsWorkspaceOwnerOrg]);
  useEffect(function () {
    if (isWorkspaceOwnerOrg) {
      setNoDropdown(false);
      var searchChanged = isSearchChanged.current;
      isSearchChanged.current = false;
      setLoading(true);

      if (selectAllOnLoad && isFirstLoad.current) {
        isFirstLoad.current = false;
        handleSelectAll(true);
      } else {
        debouncedGetData.current({
          searchField: searchField,
          pageNo: pageNo,
          searchChanged: searchChanged
        });
      }
    }
  }, [searchField, pageNo, setNoDropdown, isWorkspaceOwnerOrg]);

  var unobserveAndRemove = function unobserveAndRemove() {
    var node = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
    io.current.unobserve(node || document.getElementById('last-row-item'));
    io.current = null;
  };

  useLayoutEffect(function () {
    if (loading || !hasMore) {
      return;
    }

    var lastRowItem = document.getElementById('last-row-item');

    if (!lastRowItem) {
      return;
    }

    if (isOpen && !io.current) {
      var onIntersection = function onIntersection(_ref4) {
        var _ref5 = _slicedToArray(_ref4, 1),
            isIntersecting = _ref5[0].isIntersecting;

        if (isIntersecting) {
          unobserveAndRemove(lastRowItem);
          setPageNo(function (pgno) {
            return pgno + 1;
          });
        }
      };

      io.current = new IntersectionObserver(onIntersection, {
        threshold: 1
      });
      io.current.observe(lastRowItem);
    } else if (io.current) {
      unobserveAndRemove(lastRowItem);
    }
  }, [isOpen, loading, hasMore]);
  useEffect(function () {
    if (!(selected !== null && selected !== void 0 && selected.length)) {
      setShowDeselectAll(false);
    } else {
      setShowDeselectAll(true);
    }

    var selectedLength = (selected === null || selected === void 0 ? void 0 : selected.length) || 0;

    if (prevSelectedLength.current > selectedLength) {
      setShowSelectAll(true);
    }

    if (maxSelectedLength.current && selectedLength >= maxSelectedLength.current) {
      maxSelectedLength.current = selectedLength;
      setShowSelectAll(false);
    }

    prevSelectedLength.current = selectedLength;

    if (onChangeSelection) {
      onChangeSelection(selected.join(','));
    }
  }, [selected]);
  useEffect(function () {
    if (onChangeWorkspaceSelection && didComponentRender.current) {
      onChangeWorkspaceSelection(selectedWorkspaces.join(','));
    }
  }, [selectedWorkspaces]);
  useEffect(function () {
    if (didComponentRender.current) {
      onChangeAdvertiserSelection === null || onChangeAdvertiserSelection === void 0 ? void 0 : onChangeAdvertiserSelection(selectedAdvertisers.join(','), selectedAdvertisersItems.filter(Boolean));
    }
  }, [selectedAdvertisers, selectedAdvertisersItems]);
  useEffect(function () {
    didComponentRender.current = true;
  }, []);
  var toggleSelection = useCallback(function (id, isAdd, isWorkspace) {
    var parentWorkspace = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
    var item = arguments.length > 4 ? arguments[4] : undefined;
    return function () {
      if (isAdd) {
        if (isWorkspace) {
          setSelected(function (selected) {
            return [].concat(_toConsumableArray(selected), [id]);
          });
          setSelectedWorkspaces(function (selectedWorkspaces) {
            return [].concat(_toConsumableArray(selectedWorkspaces), [id]);
          });
        } else {
          var _parentWorkspace$cust;

          setSelectedAdvertisers(function (selectedAdvertisers) {
            return [].concat(_toConsumableArray(selectedAdvertisers), [id]);
          });
          setSelectedAdvertisersItems(function (selectedAdvertisersItems) {
            return [].concat(_toConsumableArray(selectedAdvertisersItems), [item]);
          });

          if (parentWorkspace && parentWorkspace.isAccess && parentWorkspace.owId && selectAdvertisersOnWorkspaceSelect && parentWorkspace !== null && parentWorkspace !== void 0 && (_parentWorkspace$cust = parentWorkspace.customers) !== null && _parentWorkspace$cust !== void 0 && _parentWorkspace$cust.every(function (customer) {
            return selected.includes(customer.owId) || customer.owId === id;
          })) {
            setSelectedWorkspaces(function (selectedWorkspaces) {
              return [].concat(_toConsumableArray(selectedWorkspaces), [parentWorkspace.owId]);
            });
            setSelected(function (selected) {
              return [].concat(_toConsumableArray(selected), [id, parentWorkspace.owId]);
            });
          } else {
            setSelected(function (selected) {
              return [].concat(_toConsumableArray(selected), [id]);
            });
          }
        }
      } else {
        if (isWorkspace) {
          setSelected(function (selected) {
            return selected.filter(function (i) {
              return i !== id;
            });
          });
          setSelectedWorkspaces(function (selectedWorkspaces) {
            return selectedWorkspaces.filter(function (i) {
              return i !== id;
            });
          });
        } else {
          setSelectedAdvertisers(function (selectedAdvertisers) {
            return selectedAdvertisers.filter(function (i) {
              return i !== id;
            });
          });
          setSelectedAdvertisersItems(function (selectedAdvertisersItems) {
            return selectedAdvertisersItems.filter(function (item) {
              if (!!item && !!item.owId) {
                return item.owId !== id;
              }
            });
          });

          if (parentWorkspace && parentWorkspace.isAccess && parentWorkspace.owId && selectAdvertisersOnWorkspaceSelect) {
            setSelectedWorkspaces(function (selectedWorkspaces) {
              return selectedWorkspaces.filter(function (i) {
                return i !== parentWorkspace.owId;
              });
            });
            setSelected(function (selectedItems) {
              return selectedItems.filter(function (i) {
                return i !== id && i !== parentWorkspace.owId;
              });
            });
          } else {
            setSelected(function (selected) {
              return selected.filter(function (i) {
                return i !== id;
              });
            });
          }
        }
      }
    };
  }, [selectAdvertisersOnWorkspaceSelect, selected]);

  var toggleExpansion = function toggleExpansion(id, isExpand) {
    return function () {
      if (isExpand) {
        setExpanded(function (expanded) {
          return [].concat(_toConsumableArray(expanded), [id]);
        });
      } else {
        setExpanded(function (expanded) {
          return expanded.filter(function (i) {
            return i !== id;
          });
        });
      }
    };
  };

  var areAllCustomersSelected = useCallback(function () {
    var customers = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    var workspace = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var allowedWorkspace = workspace.isAccess ? workspace : {};
    return [].concat(_toConsumableArray(customers), [allowedWorkspace]).filter(function (_ref6) {
      var owId = _ref6.owId;
      return owId;
    }).every(function (_ref7) {
      var owId = _ref7.owId;
      return selected.includes(owId);
    });
  }, [selected]);
  var deselectAllCustomers = useCallback(function () {
    var customers = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    var workspace = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    return function () {
      var customersIds = customers.filter(function (_ref8) {
        var owId = _ref8.owId;
        return owId;
      }).map(function (_ref9) {
        var owId = _ref9.owId;
        return owId;
      });
      var ids = workspace && workspace.owId ? [].concat(_toConsumableArray(customersIds), [workspace.owId]) : _toConsumableArray(customersIds);
      var workspaceId = workspace && workspace.owId ? workspace.owId : null;
      setSelected(function (selected) {
        return selected.filter(function (item) {
          return !ids.includes(item);
        });
      });
      setSelectedAdvertisers(function (selectedAdvertisers) {
        return selectedAdvertisers.filter(function (item) {
          return !customersIds.includes(item);
        });
      });
      setSelectedAdvertisersItems(function (selectedAdvertisersItems) {
        return selectedAdvertisersItems.filter(function (item) {
          return !customersIds.includes(item === null || item === void 0 ? void 0 : item.owId);
        });
      });
      setSelectedWorkspaces(function (selectedWorkspaces) {
        return selectedWorkspaces.filter(function (item) {
          return item !== workspaceId;
        });
      });
    };
  }, []);
  var selectAllCustomers = useCallback(function () {
    var customers = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    var workspace = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    return function () {
      var allowedWorkspace = workspace.isAccess ? workspace : {};
      var nonSelectedItems = customers.filter(function (_ref10) {
        var owId = _ref10.owId;
        return owId && !selected.includes(owId);
      });
      var nonSelectedIds = nonSelectedItems.map(function (_ref11) {
        var owId = _ref11.owId;
        return owId;
      });
      var nonSelectedIdsWorkspace = [allowedWorkspace].filter(function (_ref12) {
        var owId = _ref12.owId;
        return owId && !selected.includes(owId);
      }).map(function (_ref13) {
        var owId = _ref13.owId;
        return owId;
      });
      setSelected(function (selected) {
        return [].concat(_toConsumableArray(selected), _toConsumableArray(nonSelectedIds), _toConsumableArray(nonSelectedIdsWorkspace));
      });
      setSelectedWorkspaces(function (selectedWorkspaces) {
        return [].concat(_toConsumableArray(nonSelectedIdsWorkspace), _toConsumableArray(selectedWorkspaces));
      });
      setSelectedAdvertisers(function (selectedAdvertisers) {
        return [].concat(_toConsumableArray(selectedAdvertisers), _toConsumableArray(nonSelectedIds));
      });
      setSelectedAdvertisersItems(function (selectedAdvertisersItems) {
        return [].concat(_toConsumableArray(selectedAdvertisersItems), _toConsumableArray(nonSelectedItems));
      });
    };
  }, [selected]);
  var handleSelectAll = useCallback( /*#__PURE__*/function () {
    var _ref14 = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee3(isFirstLoad) {
      var allRows, selectedAll, allSelectedItems, _selectedAll$advertis, _allSelectedItems;

      return regenerator.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              setShowPlaceholderCount(!isFirstLoad);
              setRows([]);
              _context3.next = 4;
              return getData({
                all: true
              });

            case 4:
              allRows = _context3.sent;
              selectedAll = allRows.reduce(function (acc, item) {
                var _item$customers;

                if (item.isAccess !== false) {
                  acc.workspaces.push(item.owId);
                }

                if ((_item$customers = item.customers) !== null && _item$customers !== void 0 && _item$customers.length) {
                  item.customers.forEach(function (cust) {
                    acc.advertisers.push(cust.owId);
                    acc.advertisersItems.push(cust);
                  });
                }

                return acc;
              }, {
                workspaces: [],
                advertisers: [],
                advertisersItems: []
              });
              allSelectedItems = [];

              if (authorizedUser.current && authorizedUser.current.isWorkspaceOwnerOrg && !authorizedUser.current.isPlatformOwnerOrg && hideCurrentUser) {
                maxSelectedLength.current = (_selectedAll$advertis = selectedAll.advertisers) === null || _selectedAll$advertis === void 0 ? void 0 : _selectedAll$advertis.length;
                allSelectedItems = _toConsumableArray(selectedAll.advertisers);
                setSelected(allSelectedItems);
                setSelectedWorkspaces([]);
              } else {
                allSelectedItems = [].concat(_toConsumableArray(selectedAll.workspaces), _toConsumableArray(selectedAll.advertisers));
                maxSelectedLength.current = (_allSelectedItems = allSelectedItems) === null || _allSelectedItems === void 0 ? void 0 : _allSelectedItems.length;
                setSelected(allSelectedItems);
                setSelectedWorkspaces(selectedAll.workspaces);
              }

              setSelectedAdvertisers(selectedAll.advertisers);
              setSelectedAdvertisersItems(selectedAll.advertisersItems);
              setShowDeselectAll(true);
              setShowSelectAll(false);

              if (onSelectAll) {
                onSelectAll(allSelectedItems);
              }

              setShowPlaceholderCount(true);

            case 14:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }));

    return function (_x) {
      return _ref14.apply(this, arguments);
    };
  }(), [rows, hideCurrentUser, getData, onSelectAll]);

  var handleDeselectAll = function handleDeselectAll() {
    if (!!undeletableOwIds.length) {
      var FilteredSelected = selected.filter(function (value) {
        return undeletableOwIds.includes(value);
      });
      var FileteredSelectedAdv = selectedAdvertisers.filter(function (adv) {
        return undeletableOwIds.includes(adv);
      });
      var FilteredSelectedAdvItem = selectedAdvertisersItems.filter(function (advI) {
        return undeletableOwIds.includes(advI.owId);
      });
      var FilteredWorkspace = selectedWorkspaces.filter(function (workspace) {
        return undeletableOwIds.includes(workspace.owId);
      });
      setSelected(FilteredSelected);
      setSelectedAdvertisers(FileteredSelectedAdv);
      setSelectedAdvertisersItems(FilteredSelectedAdvItem);
      setSelectedWorkspaces(FilteredWorkspace);
    } else {
      setSelected([]);
      setSelectedAdvertisers([]);
      setSelectedAdvertisersItems([]);
      setSelectedWorkspaces([]);
    }

    setShowDeselectAll(false);
    setShowSelectAll(true);
  };

  var handleSearchChange = function handleSearchChange(str) {
    isSearchChanged.current = true;
    setSearchField(str || '');
    setPageNo(1);
    setRows([]);
  };

  var renderOpener = useCallback(function () {
    var placeholder = isWorkspacesOnly ? 'Workspaces' : 'Customers';
    var placeholderString = showPlaceholderCount ? "".concat(placeholder, " (").concat(selected === null || selected === void 0 ? void 0 : selected.length, ")") : placeholder;
    return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("div", {
      className: styles$k.openerBtnText
    }, placeholderString), /*#__PURE__*/React__default.createElement("div", {
      className: styles$k.openerBtnIndicator
    }));
  }, [selected, showPlaceholderCount]);

  var getHighlights = function getHighlights(str, searchField, sliceTo) {
    if (!searchField || typeof str !== 'string' || searchField.length < 3) {
      return str;
    }

    var withLimit = sliceTo ? "".concat(searchField.slice(0, sliceTo)) : searchField;
    var escaped = withLimit.replaceAll(/[-[\]{}()*+?.,\\^$|#]/g, function (str) {
      return "\\".concat(str);
    });
    var parts = str.split(new RegExp(escaped, 'ig'));

    var matches = _toConsumableArray(str.matchAll(new RegExp(escaped, 'ig')));

    parts.forEach(function (part, index) {
      if (index !== (parts === null || parts === void 0 ? void 0 : parts.length) - 1) {
        parts[index] = /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("span", {
          className: styles$k.highlightedPart
        }, part), /*#__PURE__*/React__default.createElement("span", {
          className: "".concat(styles$k.highlight, " ").concat(styles$k.highlightedPart)
        }, matches[index][0]));
      }
    });
    return parts;
  };

  var renderOptionContent = useCallback(function (customer, isWorkspace) {
    var _ref15;

    var owId = customer.owId,
        status = customer.status,
        organizationName = customer.organizationName,
        logoUrl = customer.logoUrl,
        workspaceName = customer.workspaceName;
    var organizationNameHighlighted = getHighlights(organizationName || workspaceName, searchField, 60);
    var owIdHighlighted = getHighlights("".concat(owId), searchField);
    return /*#__PURE__*/React__default.createElement("div", {
      className: styles$k.optionContent
    }, /*#__PURE__*/React__default.createElement("div", {
      className: styles$k.optionIconGroup
    }, isWorkspace ? /*#__PURE__*/React__default.createElement("div", {
      className: styles$k.optionIconCrownWrapper
    }, /*#__PURE__*/React__default.createElement(Icon, {
      name: "Crown"
    })) : null, /*#__PURE__*/React__default.createElement("div", {
      className: "".concat(styles$k.optionIconWrapper, " ").concat(isWorkspace ? styles$k.workspaceIconWrapper : '')
    }, /*#__PURE__*/React__default.createElement("img", {
      src: logoUrl,
      className: styles$k.optionIcon
    }))), /*#__PURE__*/React__default.createElement("div", {
      className: styles$k.optionText
    }, ((_ref15 = organizationName || workspaceName) === null || _ref15 === void 0 ? void 0 : _ref15.length) >= 60 ? /*#__PURE__*/React__default.createElement(Tooltip, {
      label: organizationName || workspaceName,
      className: styles$k.tooltip,
      labelMaxWidth: 300,
      portal: true
    }, /*#__PURE__*/React__default.createElement("div", {
      className: styles$k.optionTextTop
    }, organizationNameHighlighted, "...")) : /*#__PURE__*/React__default.createElement("div", {
      className: styles$k.optionTextTop
    }, organizationNameHighlighted), /*#__PURE__*/React__default.createElement("div", {
      className: styles$k.optionTextBottom
    }, /*#__PURE__*/React__default.createElement("div", {
      className: styles$k.optionTextId
    }, /*#__PURE__*/React__default.createElement("span", {
      className: styles$k.idText
    }, "ID"), /*#__PURE__*/React__default.createElement("span", {
      className: styles$k.idValue
    }, owIdHighlighted)), /*#__PURE__*/React__default.createElement("div", {
      className: styles$k.optionTextSeparator
    }), /*#__PURE__*/React__default.createElement("div", {
      className: styles$k.optionTextStatus
    }, /*#__PURE__*/React__default.createElement(Icon, {
      className: styles$k.statusIcon,
      name: StatusIconMapper[status] || ''
    }), /*#__PURE__*/React__default.createElement("span", {
      className: styles$k.statusValue
    }, status)))));
  }, [searchField]);
  var handleWorkspaceSelection = useCallback(function (workspace, wsIncluded, allCustomersSelected) {
    var owId = workspace.owId,
        customers = workspace.customers;

    if (selectAdvertisersOnWorkspaceSelect && customers.length) {
      if (!allCustomersSelected) {
        selectAllCustomers(customers, workspace)();
      } else {
        deselectAllCustomers(customers, workspace)();
      }
    } else {
      toggleSelection(owId, !wsIncluded, true)();
    }
  }, [toggleSelection, selectAdvertisersOnWorkspaceSelect, selectAllCustomers, deselectAllCustomers]);
  var renderAdvertiserList = useCallback(function (customers, workspace) {
    var customersAdvertisers = rows && rows[0] && rows[0].customers ? rows[0].customers : [];
    return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, (customers || customersAdvertisers).map(function (customer) {
      if (!expectedStatusId.includes(customer.statusId)) return;
      var owId = customer.owId;
      var custSelected = selected.includes(owId);
      return /*#__PURE__*/React__default.createElement("div", {
        className: "".concat(styles$k.row, " ").concat(customers ? styles$k.innerRow : '', " ").concat(custSelected ? styles$k.rowSelected : ''),
        key: owId
      }, custSelected ? /*#__PURE__*/React__default.createElement(CheckedButton, {
        onClick: toggleSelection(owId, !custSelected, false, workspace, customer),
        disabled: undeletableOwIds.includes(owId)
      }) : /*#__PURE__*/React__default.createElement(UncheckedButton, {
        onClick: toggleSelection(owId, !custSelected, false, workspace, customer)
      }), renderOptionContent(customer));
    }));
  }, [rows, selected, selectAdvertisersOnWorkspaceSelect, toggleSelection, renderOptionContent, undeletableOwIds]);
  var renderWorkspaceList = useCallback(function () {
    if (isWorkspacesOnly) {
      return rows.map(function (workspace, index) {
        var owId = workspace.owId,
            statusId = workspace.statusId;
        var wsIncluded = selected.includes(owId);
        if (!expectedStatusId.includes(statusId)) return;
        return /*#__PURE__*/React__default.createElement("div", {
          key: owId,
          className: styles$k.workspaceWrapper,
          id: "".concat(index + 1 === (rows === null || rows === void 0 ? void 0 : rows.length) ? 'last-row-item' : '')
        }, /*#__PURE__*/React__default.createElement("div", {
          className: "".concat(styles$k.row, " ").concat(wsIncluded ? styles$k.rowSelected : '')
        }, wsIncluded ? /*#__PURE__*/React__default.createElement(CheckedButton, {
          onClick: function onClick() {
            return handleWorkspaceSelection(workspace, wsIncluded);
          }
        }) : /*#__PURE__*/React__default.createElement(UncheckedButton, {
          onClick: function onClick() {
            return handleWorkspaceSelection(workspace, wsIncluded);
          }
        }), renderOptionContent(workspace, true)));
      });
    }

    return rows.map(function (workspace, index) {
      var owId = workspace.owId,
          customers = workspace.customers,
          isAccess = workspace.isAccess,
          statusId = workspace.statusId;
      if (!expectedStatusId.includes(statusId)) return;
      var wsIncluded = selected.includes(owId);
      var wsExpanded = expanded.includes(owId);
      var allCustomersSelected = areAllCustomersSelected(customers, workspace);
      return /*#__PURE__*/React__default.createElement("div", {
        key: owId,
        className: styles$k.workspaceWrapper,
        id: "".concat(index + 1 === (rows === null || rows === void 0 ? void 0 : rows.length) ? 'last-row-item' : '')
      }, /*#__PURE__*/React__default.createElement("div", {
        className: "".concat(styles$k.row, " ").concat(wsIncluded ? styles$k.rowSelected : '')
      }, wsIncluded ? /*#__PURE__*/React__default.createElement(CheckedButton, {
        onClick: function onClick() {
          return handleWorkspaceSelection(workspace, wsIncluded, allCustomersSelected);
        },
        disabled: !isAccess
      }) : /*#__PURE__*/React__default.createElement(UncheckedButton, {
        onClick: function onClick() {
          return handleWorkspaceSelection(workspace, wsIncluded, allCustomersSelected);
        },
        disabled: !isAccess
      }), renderOptionContent(workspace, true), wsExpanded && !selectAdvertisersOnWorkspaceSelect && !allCustomersSelected ? /*#__PURE__*/React__default.createElement("div", {
        className: styles$k.selectDeselectAll,
        onClick: selectAllCustomers(customers, workspace)
      }, "Select All") : null, wsExpanded && !selectAdvertisersOnWorkspaceSelect && allCustomersSelected ? /*#__PURE__*/React__default.createElement("div", {
        className: styles$k.selectDeselectAll,
        onClick: deselectAllCustomers(customers, workspace)
      }, "Deselect All") : null, customers !== null && customers !== void 0 && customers.length ? /*#__PURE__*/React__default.createElement(ButtonCircle, {
        onClick: toggleExpansion(owId, !wsExpanded),
        iconName: wsExpanded ? 'Expand' : 'Right',
        className: styles$k.expand,
        size: "small"
      }) : null), wsExpanded && customers !== null && customers !== void 0 && customers.length ? renderAdvertiserList(customers, workspace) : null);
    });
  }, [rows, selected, expanded, areAllCustomersSelected, selectAllCustomers, selectAdvertisersOnWorkspaceSelect, handleWorkspaceSelection, renderAdvertiserList, renderOptionContent, isWorkspacesOnly, expectedStatusId, hideWorkspaceWithNoAdvertiser]);
  var renderContent = useCallback(function () {
    var _authorizedUser$curre, _rows$, _rows$$customers;

    var useAdvertiserList = hideCurrentUser && authorizedUser.current && authorizedUser.current.isWorkspaceOwnerOrg && !authorizedUser.current.isPlatformOwnerOrg;
    var selectAllEnabled = !loading && showSelectAll;
    var deselectAllEnabled = !loading && showDeselectAll;
    var searchPlaceholder = (_authorizedUser$curre = authorizedUser.current) !== null && _authorizedUser$curre !== void 0 && _authorizedUser$curre.isPlatformOwnerOrg ? 'Search by Workspace, Customer ID, Status, Email' : 'Search by Organization, Customer ID, Status or Email';

    var inputAttributes = _objectSpread$p({}, disableSafariAutoCorrect ? {
      spellcheck: 'false'
    } : {});

    return /*#__PURE__*/React__default.createElement("div", {
      className: styles$k.openerContent
    }, /*#__PURE__*/React__default.createElement("div", {
      className: styles$k.header
    }, /*#__PURE__*/React__default.createElement(TextField, {
      variant: "withoutTickbox",
      underline: false,
      className: styles$k.searchBox,
      placeholder: searchPlaceholder,
      value: searchField,
      onChange: handleSearchChange,
      iconName: "Search",
      inputAttributes: inputAttributes
    }), /*#__PURE__*/React__default.createElement("div", {
      className: styles$k.selectDeselectAll
    }, /*#__PURE__*/React__default.createElement("div", {
      className: "".concat(styles$k.globalSelectAll, " ").concat(selectAllEnabled ? '' : styles$k.disabled),
      onClick: selectAllEnabled ? handleSelectAll : undefined
    }, "Select all"), /*#__PURE__*/React__default.createElement("div", {
      className: "".concat(styles$k.globalSelectAll, " ").concat(deselectAllEnabled ? '' : styles$k.disabled, " mr-3"),
      onClick: deselectAllEnabled ? handleDeselectAll : undefined
    }, "Clear all"))), useAdvertiserList ? renderAdvertiserList() : renderWorkspaceList(), loading ? /*#__PURE__*/React__default.createElement("div", {
      className: "row w-100 align-items-center justify-content-center mt-3"
    }, /*#__PURE__*/React__default.createElement(ProgressCircle, {
      className: "mb-3",
      size: 32
    })) : null, !loading && (useAdvertiserList ? !(rows !== null && rows !== void 0 && (_rows$ = rows[0]) !== null && _rows$ !== void 0 && (_rows$$customers = _rows$.customers) !== null && _rows$$customers !== void 0 && _rows$$customers.length) : !(rows !== null && rows !== void 0 && rows.length)) ? /*#__PURE__*/React__default.createElement("div", {
      className: styles$k.noResults
    }, /*#__PURE__*/React__default.createElement(Icon, {
      name: "EmptyClipboard",
      className: styles$k.noResultsIcon
    }), /*#__PURE__*/React__default.createElement("div", {
      className: styles$k.noResultsTitle
    }, "No results found"), /*#__PURE__*/React__default.createElement("div", {
      className: styles$k.noResultsMessage
    }, "We can\u2019t find any items matching your search \"".concat(searchField, "\"."))) : null);
  }, [rows, selected, expanded, areAllCustomersSelected, selectAllCustomers, searchField, handleSelectAll, loading, showDeselectAll, showSelectAll, renderWorkspaceList, renderAdvertiserList, hideCurrentUser, disableSafariAutoCorrect, undeletableOwIds]);

  if (noDropdown) {
    return /*#__PURE__*/React__default.createElement(React__default.Fragment, null);
  }

  return /*#__PURE__*/React__default.createElement("div", {
    style: isOpen ? null : selectExternalStyling,
    className: [styles$k.container, className].join(' ')
  }, /*#__PURE__*/React__default.createElement(Opener, _extends({
    btnClassName: styles$k.openerBtn,
    btn: renderOpener(),
    content: renderContent(),
    onToggle: setIsOpen,
    stopClickPropagation: stopClickPropagation
  }, openerProps)));
};
NestedCustomerSelect.propTypes = {
  selectedOwIds: PropTypes.string,
  workspaceOwIds: PropTypes.string,
  onChangeSelection: PropTypes.func,
  onChangeAdvertiserSelection: PropTypes.func,
  onChangeWorkspaceSelection: PropTypes.func,
  stopClickPropagation: PropTypes.bool,
  hideCurrentUser: PropTypes.bool,
  selectAllOnLoad: PropTypes.bool,
  selectAdvertisersOnWorkspaceSelect: PropTypes.bool,
  customerStatusIds: PropTypes.string,
  onLoad: PropTypes.func,
  onLoadError: PropTypes.func,
  onSelectAll: PropTypes.func,
  openerProps: PropTypes.obj,
  disableSafariAutoCorrect: PropTypes.bool,
  isWorkspacesOnly: PropTypes.bool,
  expectedStatusId: PropTypes.array,
  className: PropTypes.string,
  width: PropTypes.number,
  undeletableOwIds: PropTypes.array,
  preserveSelection: PropTypes.bool,
  sortOptionByName: PropTypes.bool,
  hideWorkspaceWithNoAdvertiser: PropTypes.bool
};

var css_248z$o = ":root {\n  --primary1: #123787;\n  --primary2: #1d58d7;\n  --primary3: #5173fb;\n  --primary4: #7a93ff;\n  --primary5: #c2d0ff;\n  --primary6: #e5ebff;\n  --primary7: #f2f5ff; }\n\n@keyframes waitIndicator-module_hover-ripples__2jMz0 {\n  0% {\n    top: -0.1875em;\n    left: -0.1875em;\n    right: -0.1875em;\n    bottom: -0.1875em;\n    opacity: 1; }\n  100% {\n    top: -0.8125em;\n    left: -0.8125em;\n    right: -0.8125em;\n    bottom: -0.8125em;\n    opacity: 0; } }\n\n.waitIndicator-module_waitingLoaderContainer__QPj2H {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  margin: auto; }\n  .waitIndicator-module_waitingLoaderContainer__QPj2H img {\n    margin-bottom: 2rem;\n    width: 16.6875rem;\n    height: 12.4375rem; }\n  .waitIndicator-module_waitingLoaderContainer__QPj2H .waitIndicator-module_messageTitle__2Va8I {\n    font-family: 'Avenir Next Demi', sans-serif;\n    font-weight: normal;\n    font-style: normal;\n    font-weight: 600;\n    font-size: 1rem;\n    line-height: 1;\n    color: #000000;\n    letter-spacing: 0.00625rem;\n    margin-bottom: 0.25rem; }\n    .waitIndicator-module_waitingLoaderContainer__QPj2H .waitIndicator-module_messageTitle__2Va8I .waitIndicator-module_subMessage__1Hobp {\n      font-family: 'Avenir Next Demi', sans-serif;\n      font-weight: normal;\n      font-style: normal;\n      font-weight: 400;\n      font-size: 0.875rem;\n      line-height: 1;\n      color: #000000;\n      letter-spacing: 0.00625rem; }\n";
var styles$l = {"waitingLoaderContainer":"waitIndicator-module_waitingLoaderContainer__QPj2H","messageTitle":"waitIndicator-module_messageTitle__2Va8I","subMessage":"waitIndicator-module_subMessage__1Hobp","hover-ripples":"waitIndicator-module_hover-ripples__2jMz0"};
styleInject(css_248z$o);

var WaitIndicator = function WaitIndicator(_ref) {
  var message = _ref.message,
      subMessage = _ref.subMessage,
      theme = _ref.theme;
  return /*#__PURE__*/React__default.createElement("div", {
    className: styles$l.waitingLoaderContainer
  }, /*#__PURE__*/React__default.createElement("img", {
    src: "".concat(SVG_HOST_URL, "/misc/loader-wait-").concat(theme === 'blue' ? 'blue' : 'teal', ".svg"),
    alt: ""
  }), /*#__PURE__*/React__default.createElement(LoadingBar, null), /*#__PURE__*/React__default.createElement("div", {
    className: styles$l.messageTitle
  }, message), /*#__PURE__*/React__default.createElement("div", {
    className: styles$l.subMessage
  }, subMessage));
};
WaitIndicator.defaultProps = {
  message: '',
  subMessage: '',
  theme: 'blue'
};
WaitIndicator.propTypes = {
  message: PropTypes.string,
  subMessage: PropTypes.string,
  theme: PropTypes.string
};

var InfiniteScroll_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, '__esModule', {
  value: true
});

var _createClass = (function() {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ('value' in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }
  return function(Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
})();



var _react2 = _interopRequireDefault(React__default);



var _propTypes2 = _interopRequireDefault(PropTypes);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function _objectWithoutProperties(obj, keys) {
  var target = {};
  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }
  return target;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError('Cannot call a class as a function');
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError(
      "this hasn't been initialised - super() hasn't been called"
    );
  }
  return call && (typeof call === 'object' || typeof call === 'function')
    ? call
    : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== 'function' && superClass !== null) {
    throw new TypeError(
      'Super expression must either be null or a function, not ' +
        typeof superClass
    );
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass)
    Object.setPrototypeOf
      ? Object.setPrototypeOf(subClass, superClass)
      : (subClass.__proto__ = superClass);
}

var InfiniteScroll = (function(_Component) {
  _inherits(InfiniteScroll, _Component);

  function InfiniteScroll(props) {
    _classCallCheck(this, InfiniteScroll);

    var _this = _possibleConstructorReturn(
      this,
      (InfiniteScroll.__proto__ || Object.getPrototypeOf(InfiniteScroll)).call(
        this,
        props
      )
    );

    _this.scrollListener = _this.scrollListener.bind(_this);
    _this.eventListenerOptions = _this.eventListenerOptions.bind(_this);
    _this.mousewheelListener = _this.mousewheelListener.bind(_this);
    return _this;
  }

  _createClass(InfiniteScroll, [
    {
      key: 'componentDidMount',
      value: function componentDidMount() {
        this.pageLoaded = this.props.pageStart;
        this.options = this.eventListenerOptions();
        this.attachScrollListener();
      }
    },
    {
      key: 'componentDidUpdate',
      value: function componentDidUpdate() {
        if (this.props.isReverse && this.loadMore) {
          var parentElement = this.getParentElement(this.scrollComponent);
          parentElement.scrollTop =
            parentElement.scrollHeight -
            this.beforeScrollHeight +
            this.beforeScrollTop;
          this.loadMore = false;
        }
        this.attachScrollListener();
      }
    },
    {
      key: 'componentWillUnmount',
      value: function componentWillUnmount() {
        this.detachScrollListener();
        this.detachMousewheelListener();
      }
    },
    {
      key: 'isPassiveSupported',
      value: function isPassiveSupported() {
        var passive = false;

        var testOptions = {
          get passive() {
            passive = true;
          }
        };

        try {
          document.addEventListener('test', null, testOptions);
          document.removeEventListener('test', null, testOptions);
        } catch (e) {
          // ignore
        }
        return passive;
      }
    },
    {
      key: 'eventListenerOptions',
      value: function eventListenerOptions() {
        var options = this.props.useCapture;

        if (this.isPassiveSupported()) {
          options = {
            useCapture: this.props.useCapture,
            passive: true
          };
        }
        return options;
      }

      // Set a defaut loader for all your `InfiniteScroll` components
    },
    {
      key: 'setDefaultLoader',
      value: function setDefaultLoader(loader) {
        this.defaultLoader = loader;
      }
    },
    {
      key: 'detachMousewheelListener',
      value: function detachMousewheelListener() {
        var scrollEl = window;
        if (this.props.useWindow === false) {
          scrollEl = this.scrollComponent.parentNode;
        }

        scrollEl.removeEventListener(
          'mousewheel',
          this.mousewheelListener,
          this.options ? this.options : this.props.useCapture
        );
      }
    },
    {
      key: 'detachScrollListener',
      value: function detachScrollListener() {
        var scrollEl = window;
        if (this.props.useWindow === false) {
          scrollEl = this.getParentElement(this.scrollComponent);
        }

        scrollEl.removeEventListener(
          'scroll',
          this.scrollListener,
          this.options ? this.options : this.props.useCapture
        );
        scrollEl.removeEventListener(
          'resize',
          this.scrollListener,
          this.options ? this.options : this.props.useCapture
        );
      }
    },
    {
      key: 'getParentElement',
      value: function getParentElement(el) {
        var scrollParent =
          this.props.getScrollParent && this.props.getScrollParent(el);
        if (scrollParent != null) {
          return scrollParent;
        }
        return el && el.parentNode;
      }
    },
    {
      key: 'filterProps',
      value: function filterProps(props) {
        return props;
      }
    },
    {
      key: 'attachScrollListener',
      value: function attachScrollListener() {
        var parentElement = this.getParentElement(this.scrollComponent);

        if (!this.props.hasMore || !parentElement) {
          return;
        }

        var scrollEl = window;
        if (this.props.useWindow === false) {
          scrollEl = parentElement;
        }

        scrollEl.addEventListener(
          'mousewheel',
          this.mousewheelListener,
          this.options ? this.options : this.props.useCapture
        );
        scrollEl.addEventListener(
          'scroll',
          this.scrollListener,
          this.options ? this.options : this.props.useCapture
        );
        scrollEl.addEventListener(
          'resize',
          this.scrollListener,
          this.options ? this.options : this.props.useCapture
        );

        if (this.props.initialLoad) {
          this.scrollListener();
        }
      }
    },
    {
      key: 'mousewheelListener',
      value: function mousewheelListener(e) {
        // Prevents Chrome hangups
        // See: https://stackoverflow.com/questions/47524205/random-high-content-download-time-in-chrome/47684257#47684257
        if (e.deltaY === 1 && !this.isPassiveSupported()) {
          e.preventDefault();
        }
      }
    },
    {
      key: 'scrollListener',
      value: function scrollListener() {
        var el = this.scrollComponent;
        var scrollEl = window;
        var parentNode = this.getParentElement(el);

        var offset = void 0;
        if (this.props.useWindow) {
          var doc =
            document.documentElement ||
            document.body.parentNode ||
            document.body;
          var scrollTop =
            scrollEl.pageYOffset !== undefined
              ? scrollEl.pageYOffset
              : doc.scrollTop;
          if (this.props.isReverse) {
            offset = scrollTop;
          } else {
            offset = this.calculateOffset(el, scrollTop);
          }
        } else if (this.props.isReverse) {
          offset = parentNode.scrollTop;
        } else {
          offset =
            el.scrollHeight - parentNode.scrollTop - parentNode.clientHeight;
        }

        // Here we make sure the element is visible as well as checking the offset
        if (
          offset < Number(this.props.threshold) &&
          el &&
          el.offsetParent !== null
        ) {
          this.detachScrollListener();
          this.beforeScrollHeight = parentNode.scrollHeight;
          this.beforeScrollTop = parentNode.scrollTop;
          // Call loadMore after detachScrollListener to allow for non-async loadMore functions
          if (typeof this.props.loadMore === 'function') {
            this.props.loadMore((this.pageLoaded += 1));
            this.loadMore = true;
          }
        }
      }
    },
    {
      key: 'calculateOffset',
      value: function calculateOffset(el, scrollTop) {
        if (!el) {
          return 0;
        }

        return (
          this.calculateTopPosition(el) +
          (el.offsetHeight - scrollTop - window.innerHeight)
        );
      }
    },
    {
      key: 'calculateTopPosition',
      value: function calculateTopPosition(el) {
        if (!el) {
          return 0;
        }
        return el.offsetTop + this.calculateTopPosition(el.offsetParent);
      }
    },
    {
      key: 'render',
      value: function render() {
        var _this2 = this;

        var renderProps = this.filterProps(this.props);

        var children = renderProps.children,
          element = renderProps.element,
          hasMore = renderProps.hasMore,
          initialLoad = renderProps.initialLoad,
          isReverse = renderProps.isReverse,
          loader = renderProps.loader,
          loadMore = renderProps.loadMore,
          pageStart = renderProps.pageStart,
          ref = renderProps.ref,
          threshold = renderProps.threshold,
          useCapture = renderProps.useCapture,
          useWindow = renderProps.useWindow,
          getScrollParent = renderProps.getScrollParent,
          props = _objectWithoutProperties(renderProps, [
            'children',
            'element',
            'hasMore',
            'initialLoad',
            'isReverse',
            'loader',
            'loadMore',
            'pageStart',
            'ref',
            'threshold',
            'useCapture',
            'useWindow',
            'getScrollParent'
          ]);

        props.ref = function(node) {
          _this2.scrollComponent = node;
          if (ref) {
            ref(node);
          }
        };

        var childrenArray = [children];
        if (hasMore) {
          if (loader) {
            isReverse
              ? childrenArray.unshift(loader)
              : childrenArray.push(loader);
          } else if (this.defaultLoader) {
            isReverse
              ? childrenArray.unshift(this.defaultLoader)
              : childrenArray.push(this.defaultLoader);
          }
        }
        return _react2.default.createElement(element, props, childrenArray);
      }
    }
  ]);

  return InfiniteScroll;
})(React__default.Component);

InfiniteScroll.propTypes = {
  children: _propTypes2.default.node.isRequired,
  element: _propTypes2.default.node,
  hasMore: _propTypes2.default.bool,
  initialLoad: _propTypes2.default.bool,
  isReverse: _propTypes2.default.bool,
  loader: _propTypes2.default.node,
  loadMore: _propTypes2.default.func.isRequired,
  pageStart: _propTypes2.default.number,
  ref: _propTypes2.default.func,
  getScrollParent: _propTypes2.default.func,
  threshold: _propTypes2.default.number,
  useCapture: _propTypes2.default.bool,
  useWindow: _propTypes2.default.bool
};
InfiniteScroll.defaultProps = {
  element: 'div',
  hasMore: false,
  initialLoad: true,
  pageStart: 0,
  ref: null,
  threshold: 250,
  useWindow: true,
  isReverse: false,
  useCapture: false,
  loader: null,
  getScrollParent: null
};
exports.default = InfiniteScroll;
module.exports = exports['default'];
});

unwrapExports(InfiniteScroll_1);

var reactInfiniteScroller = InfiniteScroll_1;

var css_248z$p = ":root {\n  --primary1: #123787;\n  --primary2: #1d58d7;\n  --primary3: #5173fb;\n  --primary4: #7a93ff;\n  --primary5: #c2d0ff;\n  --primary6: #e5ebff;\n  --primary7: #f2f5ff; }\n\n@keyframes styles-module_hover-ripples__2UszM {\n  0% {\n    top: -0.1875em;\n    left: -0.1875em;\n    right: -0.1875em;\n    bottom: -0.1875em;\n    opacity: 1; }\n  100% {\n    top: -0.8125em;\n    left: -0.8125em;\n    right: -0.8125em;\n    bottom: -0.8125em;\n    opacity: 0; } }\n\n.styles-module_groupedLazyLoad__zgAbU {\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  align-items: stretch;\n  box-sizing: border-box; }\n  .styles-module_groupedLazyLoad__zgAbU * {\n    box-sizing: border-box; }\n  .styles-module_groupedLazyLoad__zgAbU .styles-module_hidden__uwyrM {\n    display: none; }\n  .styles-module_groupedLazyLoad__zgAbU .styles-module_noData__gZm0h {\n    width: 100%;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center; }\n    .styles-module_groupedLazyLoad__zgAbU .styles-module_noDataIcon__QUJL5 {\n      width: 12.5rem;\n      height: 12.5rem;\n      fill: #dddddd; }\n    .styles-module_groupedLazyLoad__zgAbU .styles-module_noDataText__2rDBr {\n      font-family: 'Avenir Next Regular', sans-serif;\n      font-weight: normal;\n      font-size: 1.3125rem;\n      color: #a2a2a2; }\n  .styles-module_groupedLazyLoad__zgAbU .styles-module_zoomDetector__2m4Dr {\n    width: 100%;\n    height: 0;\n    margin: 0;\n    padding: 0;\n    display: block;\n    border: none; }\n  .styles-module_groupedLazyLoad__zgAbU .styles-module_infiniteScrollSkeleton__5XGJb td:first-child .td-content {\n    border-left: none; }\n  .styles-module_groupedLazyLoad__zgAbU .styles-module_infiniteScrollSkeleton__5XGJb td:last-child .td-content {\n    border-right: none; }\n  .styles-module_groupedLazyLoad__zgAbU .styles-module_infiniteScrollSkeleton__5XGJb thead,\n  .styles-module_groupedLazyLoad__zgAbU .styles-module_infiniteScrollSkeleton__5XGJb .table__header {\n    display: none; }\n  .styles-module_groupedLazyLoad__zgAbU .styles-module_withSkeleton__Sopus table td,\n  .styles-module_groupedLazyLoad__zgAbU .styles-module_withSkeleton__Sopus table th {\n    padding: 0; }\n  .styles-module_groupedLazyLoad__zgAbU .styles-module_tooltip__1SCT0 {\n    width: 100%; }\n    .styles-module_groupedLazyLoad__zgAbU .styles-module_tooltipHidden__2jbWi .tooltipV2__label {\n      visibility: hidden; }\n  .styles-module_groupedLazyLoad__zgAbU .styles-module_fixed__3TuOX {\n    z-index: 2;\n    position: sticky;\n    background-color: #ffffff;\n    width: 100%;\n    min-width: 100%;\n    order: 1; }\n  .styles-module_groupedLazyLoad__zgAbU .styles-module_scrollContainer__32Y2Z {\n    width: 100%;\n    min-width: 100%;\n    position: relative;\n    overflow: hidden scroll;\n    height: 100%;\n    max-height: 100vh;\n    order: 2; }\n    .styles-module_groupedLazyLoad__zgAbU .styles-module_scrollContainer__32Y2Z .svg-icon {\n      fill: #a2a2a2; }\n    .styles-module_groupedLazyLoad__zgAbU .styles-module_scrollContainer__32Y2Z > div {\n      display: flex;\n      flex-direction: column;\n      align-items: stretch; }\n  .styles-module_groupedLazyLoad__zgAbU table {\n    table-layout: fixed;\n    border-collapse: collapse;\n    padding: 0;\n    border: none;\n    width: 100%;\n    min-width: 100%; }\n    .styles-module_groupedLazyLoad__zgAbU table.styles-module_scrollContents__2N6dj {\n      width: 100%;\n      min-width: 100%;\n      max-width: 100%;\n      overflow: hidden auto; }\n    .styles-module_groupedLazyLoad__zgAbU table thead,\n    .styles-module_groupedLazyLoad__zgAbU table tbody {\n      width: 100%;\n      min-width: 100%; }\n    .styles-module_groupedLazyLoad__zgAbU table tr {\n      height: 2.5rem;\n      max-height: 2.5rem;\n      width: 100%; }\n    .styles-module_groupedLazyLoad__zgAbU table td,\n    .styles-module_groupedLazyLoad__zgAbU table th {\n      padding: 0.375rem 1rem;\n      position: relative;\n      background: transparent;\n      height: 2.5rem;\n      vertical-align: middle; }\n    .styles-module_groupedLazyLoad__zgAbU table .styles-module_dataRow__12fYG {\n      border-bottom: 0.0625rem solid rgba(203, 203, 203, 0.5); }\n      .styles-module_groupedLazyLoad__zgAbU table .styles-module_dataRow__12fYG td {\n        border: none;\n        border-left: 0.0625rem solid rgba(203, 203, 203, 0.5);\n        font-family: 'Avenir Next Regular', sans-serif;\n        font-weight: normal;\n        font-size: 0.75rem; }\n        .styles-module_groupedLazyLoad__zgAbU table .styles-module_dataRow__12fYG td:first-child {\n          border-left: none; }\n    .styles-module_groupedLazyLoad__zgAbU table .styles-module_cellContents__3rFBV {\n      width: 100%;\n      overflow: hidden;\n      white-space: nowrap;\n      word-wrap: break-all;\n      overflow-wrap: anywhere;\n      text-overflow: ellipsis; }\n  .styles-module_groupedLazyLoad__zgAbU .styles-module_groupHeader__2vi6U {\n    background: #f9f9f9;\n    border-bottom: 0.0625rem solid #cbcbcb;\n    width: 100%;\n    min-width: 100%;\n    border-left: none;\n    background: #f4f4f4; }\n    .styles-module_groupedLazyLoad__zgAbU .styles-module_groupHeader__2vi6U:first-child, .styles-module_groupedLazyLoad__zgAbU .styles-module_groupHeaderFirst__1Or9g {\n      border-top: none; }\n    .styles-module_groupedLazyLoad__zgAbU .styles-module_groupHeaderFirst__1Or9g {\n      background: #f4f4f4; }\n      .styles-module_groupedLazyLoad__zgAbU .styles-module_groupHeaderFirst__1Or9g th:first-child {\n        background: #f9f9f9; }\n    .styles-module_groupedLazyLoad__zgAbU .styles-module_groupHeader__2vi6U .styles-module_toggle__3Fyeh {\n      background-color: transparent;\n      max-height: 0.75rem;\n      border: none;\n      outline: none;\n      display: flex;\n      flex-direction: row;\n      align-items: center;\n      cursor: pointer;\n      padding-left: 0; }\n    .styles-module_groupedLazyLoad__zgAbU .styles-module_groupHeaderContent__278gF {\n      display: flex;\n      flex-direction: row;\n      align-items: center;\n      justify-content: flex-start;\n      overflow: hidden;\n      white-space: nowrap;\n      word-wrap: break-all;\n      overflow-wrap: anywhere;\n      text-overflow: ellipsis; }\n    .styles-module_groupedLazyLoad__zgAbU .styles-module_groupHeader__2vi6U th {\n      border-right: 0.0625rem solid rgba(203, 203, 203, 0.5);\n      font-family: 'Avenir Next Demi', sans-serif;\n      font-weight: normal;\n      letter-spacing: .2px;\n      font-size: 0.75rem;\n      text-align: left; }\n    .styles-module_groupedLazyLoad__zgAbU .styles-module_groupHeader__2vi6U th:last-child {\n      border-right: none; }\n";
var styles$m = {"groupedLazyLoad":"styles-module_groupedLazyLoad__zgAbU","hidden":"styles-module_hidden__uwyrM","noData":"styles-module_noData__gZm0h","noDataIcon":"styles-module_noDataIcon__QUJL5","noDataText":"styles-module_noDataText__2rDBr","zoomDetector":"styles-module_zoomDetector__2m4Dr","infiniteScrollSkeleton":"styles-module_infiniteScrollSkeleton__5XGJb","withSkeleton":"styles-module_withSkeleton__Sopus","tooltip":"styles-module_tooltip__1SCT0","tooltipHidden":"styles-module_tooltipHidden__2jbWi","fixed":"styles-module_fixed__3TuOX","scrollContainer":"styles-module_scrollContainer__32Y2Z","scrollContents":"styles-module_scrollContents__2N6dj","dataRow":"styles-module_dataRow__12fYG","cellContents":"styles-module_cellContents__3rFBV","groupHeader":"styles-module_groupHeader__2vi6U","groupHeaderFirst":"styles-module_groupHeaderFirst__1Or9g","toggle":"styles-module_toggle__3Fyeh","groupHeaderContent":"styles-module_groupHeaderContent__278gF","hover-ripples":"styles-module_hover-ripples__2UszM"};
styleInject(css_248z$p);

function ownKeys$q(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$q(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$q(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$q(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var DEFAULT_PAGE_SIZE = 20; // Requires that API data is returned sorted.

var GroupedLazyLoad = function GroupedLazyLoad(props) {
  var _useState = useState$2(1),
      _useState2 = _slicedToArray(_useState, 2),
      currentPage = _useState2[0],
      setCurrentPage = _useState2[1];

  var _useState3 = useState$2(true),
      _useState4 = _slicedToArray(_useState3, 2),
      hasMore = _useState4[0],
      setHasMore = _useState4[1];

  var _useState5 = useState$2([]),
      _useState6 = _slicedToArray(_useState5, 2),
      data = _useState6[0],
      setData = _useState6[1];

  var _useState7 = useState$2(false),
      _useState8 = _slicedToArray(_useState7, 2),
      isLoading = _useState8[0],
      setIsLoading = _useState8[1];

  var _useState9 = useState$2(new Set()),
      _useState10 = _slicedToArray(_useState9, 2),
      hiddenRows = _useState10[0],
      setHiddenRows = _useState10[1];

  var _useState11 = useState$2(false),
      _useState12 = _slicedToArray(_useState11, 2),
      noData = _useState12[0],
      setNoData = _useState12[1];

  var _useState13 = useState$2(false),
      _useState14 = _slicedToArray(_useState13, 2),
      setForFullReload = _useState14[0],
      doSetForFullReload = _useState14[1];

  var _useState15 = useState$2(false),
      _useState16 = _slicedToArray(_useState15, 2),
      showLoader = _useState16[0],
      setShowLoader = _useState16[1];

  var prevSourceRequestRef = useRef(null);
  var scrollContainerRef = useRef(null);
  var stickyHeaderRef = useRef(null);
  var zoomDetectorRef = useRef(null);
  var prevSetForFullReloadRef = useRef(false);
  var isFetchingRef = useRef(false);
  var currentGetDataPromiseRef = useRef(null);
  var dataUrl = props.dataUrl,
      dataPath = props.dataPath,
      requestQueryParameters = props.requestQueryParameters,
      requestHttpMethod = props.requestHttpMethod,
      requestQueryPageString = props.requestQueryPageString,
      requestQueryCountString = props.requestQueryCountString,
      requestBodyParameters = props.requestBodyParameters,
      groupingKey = props.groupingKey,
      groupingFunction = props.groupingFunction,
      pageSize = props.pageSize,
      onDataFetchError = props.onDataFetchError,
      emptyTableLabel = props.emptyTableLabel,
      _props$rowKeyExtracto = props.rowKeyExtractor,
      rowKeyExtractor = _props$rowKeyExtracto === void 0 ? function () {} : _props$rowKeyExtracto,
      colWidthClasses = props.colWidthClasses,
      header = props.header,
      body = props.body,
      disableCollapseForGroups = props.disableCollapseForGroups,
      threshold = props.threshold,
      groupHeaderClassName = props.groupHeaderClassName;
  var getData = useCallback( /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee(isFirstLoad) {
      var source, params, response, results, groupedData, initialGroup, groupOfFirstResult, group, newData, rowData;
      return regenerator.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (!isFetchingRef.current) {
                _context.next = 4;
                break;
              }

              return _context.abrupt("return");

            case 4:
              isFetchingRef.current = true;

            case 5:
              _context.prev = 5;

              if (isFirstLoad) {
                setIsLoading(true);
              } else {
                setShowLoader(true);
              }

              source = axios.CancelToken.source();
              prevSourceRequestRef.current = source;
              params = requestQueryParameters ? _objectSpread$q({}, requestQueryParameters) : {};

              if (requestQueryPageString) {
                params[requestQueryPageString] = currentPage;
              } else {
                params.page = currentPage;
              }

              if (requestQueryCountString) {
                params[requestQueryCountString] = pageSize || DEFAULT_PAGE_SIZE;
              } else {
                params.size = pageSize || DEFAULT_PAGE_SIZE;
              }

              _context.next = 14;
              return axios({
                cancelToken: source.token,
                url: "".concat(ORIGIN_URL).concat(dataUrl),
                method: requestHttpMethod || 'get',
                headers: getHeaders(),
                params: params,
                data: requestBodyParameters
              });

            case 14:
              response = _context.sent;
              // Data returned from the API must be sorted!
              results = get$1(response.data, dataPath || 'responseObject.data', []);
              setHasMore(!!results.length);

              if (!results.length && isFirstLoad) {
                setNoData(true);
              }

              if (results.length) {
                groupedData = [];
                initialGroup = data.length ? data[data.length - 1].group : null;
                groupOfFirstResult = groupingFunction ? groupingFunction(results[0]) : results[0][groupingKey];

                if (!initialGroup) {
                  initialGroup = groupOfFirstResult;
                }

                group = initialGroup;
                results.forEach(function (item) {
                  var currentGroup = groupingFunction ? groupingFunction(item) : item[groupingKey];

                  if (group === currentGroup) {
                    if (!groupedData.length) {
                      groupedData.push({
                        group: currentGroup,
                        rowData: [item]
                      });
                    } else {
                      groupedData[groupedData.length - 1].rowData.push(item);
                    }
                  } else {
                    group = currentGroup;
                    groupedData.push({
                      group: currentGroup,
                      rowData: [item]
                    });
                  }
                });
                newData = data ? data.slice() : [];

                if (newData.length && newData[newData.length - 1].group === groupOfFirstResult) {
                  rowData = newData[newData.length - 1].rowData;
                  newData[newData.length - 1] = _objectSpread$q(_objectSpread$q({}, newData[newData.length - 1]), {}, {
                    rowData: rowData.concat(groupedData[0].rowData)
                  });
                  groupedData.shift();
                }

                newData = newData.concat(groupedData);
                setCurrentPage(currentPage + 1);
                setData(newData);
              }

              _context.next = 24;
              break;

            case 21:
              _context.prev = 21;
              _context.t0 = _context["catch"](5);

              if (!axios.isCancel(_context.t0)) {
                if (isFirstLoad) {
                  setNoData(true);
                }

                if (onDataFetchError) {
                  onDataFetchError(_context.t0);
                }
              }

            case 24:
              _context.prev = 24;
              isFetchingRef.current = false;
              setIsLoading(false);
              setShowLoader(false);
              return _context.finish(24);

            case 29:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[5, 21, 24, 29]]);
    }));

    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }(), [data, currentPage, dataUrl, groupingKey, requestQueryParameters, requestQueryPageString, requestQueryCountString, pageSize, requestHttpMethod, requestBodyParameters, dataPath, groupingFunction, onDataFetchError]);
  var onResize = useCallback(debounce(function () {
    var scrollContainer = document.querySelector(".".concat(styles$m.scrollContainer));

    if (scrollContainer) {
      scrollContainer.style.width = scrollContainerRef.current ? "calc(100% + ".concat(scrollContainerRef.current.offsetWidth - scrollContainerRef.current.clientWidth, "px") : '100%';
    }

    var stickyHeader = document.querySelector(".".concat(styles$m.fixed));

    if (stickyHeader) {
      stickyHeader.style.width = scrollContainerRef.current ? "calc(100% - ".concat(scrollContainerRef.current.offsetWidth - scrollContainerRef.current.clientWidth, "px") : '100%';
    } // eslint-disable-next-line react-hooks/exhaustive-deps

  }, 200), []);

  var onLoadFinish = function onLoadFinish() {
    var scrollContainer = document.querySelector(".".concat(styles$m.scrollContainer));

    if (scrollContainer) {
      scrollContainer.style.top = stickyHeaderRef.current ? "-".concat(stickyHeaderRef.current.offsetHeight, "px") : '0';
    }
  };

  useEffect(function () {
    try {
      prevSourceRequestRef.current.cancel();
    } catch (err) {}

    if (currentGetDataPromiseRef.current) {
      currentGetDataPromiseRef.current["finally"](function (res) {
        isFetchingRef.current = false;
        setIsLoading(true);
        setData([]);
        setCurrentPage(1);
        setHasMore(true);
        setNoData(false);
        setHiddenRows(new Set());
        doSetForFullReload(function (set) {
          return !set;
        });
      });
    } else {
      isFetchingRef.current = false;
      setIsLoading(true);
      setData([]);
      setCurrentPage(1);
      setHasMore(true);
      setNoData(false);
      setHiddenRows(new Set());
      doSetForFullReload(function (set) {
        return !set;
      });
    }
  }, [dataUrl, dataPath, requestQueryParameters, requestHttpMethod, requestBodyParameters]);
  useEffect(function () {
    if (prevSetForFullReloadRef.current !== setForFullReload) {
      currentGetDataPromiseRef.current = getData(true);
      prevSetForFullReloadRef.current = setForFullReload;
    }
  }, [setForFullReload, getData]);
  useLayoutEffect(function () {
    onLoadFinish();
  }, [isLoading]);
  useLayoutEffect(function () {
    onResize();
  }, [isLoading, getData, onResize]);
  useLayoutEffect(function () {
    var scrollContainer = document.querySelector(".".concat(styles$m.scrollContainer));
    var scrollContents = document.querySelector(".".concat(styles$m.scrollContents));

    if (hiddenRows.size && hasMore && scrollContainer && scrollContents && scrollContents.scrollHeight <= scrollContainer.clientHeight && data && data.length && !showLoader) {
      currentGetDataPromiseRef.current = getData(false);
    }
  }, [hiddenRows, hasMore, data, getData, showLoader]);
  useEffect(function () {
    currentGetDataPromiseRef.current = getData(true);
    window.addEventListener('resize', onResize);

    if (zoomDetectorRef.current) {
      zoomDetectorRef.current.contentWindow.addEventListener('resize', onResize);
    }

    var zoomDetectorCleanup = zoomDetectorRef.current;
    return function () {
      if (prevSourceRequestRef.current) {
        prevSourceRequestRef.current.cancel();
      }

      window.removeEventListener('resize', onResize);

      if (zoomDetectorCleanup) {
        zoomDetectorCleanup.contentWindow.removeEventListener('resize', onResize);
      }
    }; // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  var renderRow = function renderRow(dataRow) {
    return /*#__PURE__*/React__default.createElement("tr", {
      key: "".concat(rowKeyExtractor(dataRow)),
      className: "".concat(styles$m.dataRow)
    }, body.map(function (bodyItem, index) {
      var dataItem = '';

      if (bodyItem.key && dataRow[bodyItem.key]) {
        dataItem = dataRow[bodyItem.key];
      }

      if (bodyItem.transform) {
        dataItem = bodyItem.transform(dataRow);
      }

      return /*#__PURE__*/React__default.createElement("td", {
        key: "".concat(rowKeyExtractor(dataRow), "_").concat(bodyItem.key, "_td"),
        className: colWidthClasses ? colWidthClasses[index] : ''
      }, dataItem);
    }));
  };

  var getListBody = function getListBody() {
    return /*#__PURE__*/React__default.createElement("table", {
      className: styles$m.scrollContents
    }, /*#__PURE__*/React__default.createElement("thead", null, /*#__PURE__*/React__default.createElement("tr", {
      className: "".concat(styles$m.groupHeader, " ").concat(styles$m.groupHeaderFirst)
    }, header.map(function (headerItem, index) {
      return /*#__PURE__*/React__default.createElement("th", {
        key: "h_i_".concat(headerItem.key),
        className: "".concat(colWidthClasses ? colWidthClasses[index] : '', " ").concat(headerItem.className || '')
      }, headerItem.label);
    }))), data.map(function (groupedItem, index) {
      return /*#__PURE__*/React__default.createElement(React__default.Fragment, {
        key: "".concat(groupedItem.group, "_fragment")
      }, /*#__PURE__*/React__default.createElement("tbody", null, /*#__PURE__*/React__default.createElement("tr", {
        key: "".concat(groupedItem.group, "_tr_h"),
        className: styles$m.groupHeader
      }, /*#__PURE__*/React__default.createElement("th", {
        className: groupHeaderClassName || '',
        colSpan: header.length
      }, /*#__PURE__*/React__default.createElement("div", {
        className: styles$m.groupHeaderContent
      }, !(disableCollapseForGroups && disableCollapseForGroups.includes(groupedItem.group)) && /*#__PURE__*/React__default.createElement("button", {
        type: "button",
        className: styles$m.toggle,
        onClick: function onClick(event) {
          var identifier = "".concat(groupedItem.group, "_index");
          var s = new Set(hiddenRows);

          if (s.has(identifier)) {
            s["delete"](identifier);
          } else {
            s.add(identifier);
          }

          setHiddenRows(s);
        }
      }, /*#__PURE__*/React__default.createElement(Icon, {
        name: hiddenRows.has("".concat(groupedItem.group, "_index")) ? 'Expand' : 'Collapse'
      })), groupedItem.group)))), /*#__PURE__*/React__default.createElement("tbody", {
        className: hiddenRows.has("".concat(groupedItem.group, "_index")) ? styles$m.hidden : ''
      }, groupedItem.rowData.map(function (item) {
        return renderRow(item);
      })));
    }));
  };

  var getLoadingSkeleton = function getLoadingSkeleton(className, numRows) {
    return /*#__PURE__*/React__default.createElement("div", {
      className: "".concat(styles$m.withSkeleton, " ").concat(className, " table-wrapper _show-skeleton")
    }, /*#__PURE__*/React__default.createElement(Skeleton, {
      colN: header.length,
      rowN: numRows || 5,
      classes: colWidthClasses || []
    }));
  };

  return /*#__PURE__*/React__default.createElement("div", {
    className: "".concat(styles$m.groupedLazyLoad)
  }, isLoading && getLoadingSkeleton(''), /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("div", {
    className: "".concat(!isLoading && noData ? styles$m.noData : styles$m.hidden)
  }, /*#__PURE__*/React__default.createElement(Icon, {
    name: "NoData",
    className: styles$m.noDataIcon
  }), /*#__PURE__*/React__default.createElement("h3", {
    className: styles$m.noDataText
  }, emptyTableLabel || 'No Data Available')), /*#__PURE__*/React__default.createElement("table", {
    ref: stickyHeaderRef,
    className: "".concat(styles$m.fixed, " ").concat(isLoading || noData ? styles$m.hidden : '')
  }, /*#__PURE__*/React__default.createElement("thead", null, /*#__PURE__*/React__default.createElement("tr", {
    className: "".concat(styles$m.groupHeader, " ").concat(styles$m.groupHeaderFirst)
  }, header.map(function (headerItem, index) {
    return /*#__PURE__*/React__default.createElement("th", {
      key: "h_".concat(headerItem.key),
      className: "".concat(colWidthClasses ? colWidthClasses[index] : '', " ").concat(headerItem.className || '')
    }, headerItem.tooltipText ? /*#__PURE__*/React__default.createElement(Tooltip, {
      label: headerItem.tooltipText,
      auto: true,
      className: styles$m.tooltip
    }, /*#__PURE__*/React__default.createElement("div", {
      className: styles$m.cellContents
    }, headerItem.label)) : /*#__PURE__*/React__default.createElement("div", {
      className: styles$m.cellContents
    }, headerItem.label));
  })))), /*#__PURE__*/React__default.createElement("div", {
    ref: scrollContainerRef,
    className: "".concat(styles$m.scrollContainer, " ").concat(isLoading || noData ? styles$m.hidden : ''),
    style: {
      top: stickyHeaderRef.current ? "-".concat(stickyHeaderRef.current.offsetHeight, "px") : '0'
    }
  }, /*#__PURE__*/React__default.createElement(reactInfiniteScroller, {
    loadMore: function loadMore() {
      if (!isFetchingRef.current) {
        currentGetDataPromiseRef.current = getData(false);
      }
    },
    hasMore: hasMore,
    element: "div",
    useWindow: false,
    loader: showLoader && getLoadingSkeleton(styles$m.infiniteScrollSkeleton, 10),
    threshold: threshold || 300,
    initialLoad: false,
    getScrollParent: function getScrollParent(el) {
      return el && el.closest(".".concat(styles$m.scrollContainer));
    }
  }, getListBody()))), /*#__PURE__*/React__default.createElement("iframe", {
    ref: zoomDetectorRef,
    className: styles$m.zoomDetector
  }));
};
GroupedLazyLoad.propTypes = {
  // API endpoint. example: /api/v2/rb/reports
  dataUrl: PropTypes.string.isRequired,
  // Path in response body of data array.
  dataPath: PropTypes.string.isRequired,
  // ontains query string parameters. Do not include paging-related parameters here.
  requestQueryParameters: PropTypes.object,
  // Contains request body.
  requestBodyParameters: PropTypes.object,
  // Defaults to GET
  requestHttpMethod: PropTypes.string,
  // Name of paging parameter to indicate page number. 'pgno', 'pageNumber', etc
  requestQueryPageString: PropTypes.string,
  // Name of paging parameter to indicate number of items per page. 'size' etc
  requestQueryCountString: PropTypes.string,
  // Indicates which value in the response body data array to group rows by.
  // Used to group rows when groupingFunction is not passed.
  groupingKey: PropTypes.string.isRequired,
  // Data rows that map to the same value when passed to this function will be grouped together.
  // Defaults to ===.
  // When dividing items into groups, items must be in the same order as returned from API.
  // OK : [1, 2, 3, 4, 5, 6] => [[1,2], [3], [4,5,6]]
  // Not OK: [1, 2, 3, 4, 5, 6] => [[2,1], [3], [5,6,4]];
  groupingFunction: PropTypes.func,
  // Number of items to load in each request.
  pageSize: PropTypes.number,
  // Function to call when there is an error fetching data.
  onDataFetchError: PropTypes.func,
  // Text to show if no data is available
  emptyTableLabel: PropTypes.string,
  // Passed a data row from the response body data array. Must return a value that uniquely identifies that row.
  rowKeyExtractor: PropTypes.func.isRequired,
  // Class name to apply to td and th elements in each row.
  colWidthClasses: PropTypes.arrayOf(PropTypes.string),
  // Describes the header at the top of the 'lazy load' table.
  //  label is the user-friendly label to display
  //  key is the key of the data item in the response body data array
  //  tooltipText is the text to show when the user hovers over the header cell
  //  className is applied to <th> elements in the 'sticky' table header
  header: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string.isRequired,
    key: PropTypes.string.isRequired,
    tooltipText: PropTypes.string,
    className: PropTypes.string
  })).isRequired,
  // Describes the body (data rows) in the 'lazy load' table.
  //  key should match the corresponding key in the header array.
  //  transform accepts a data row from the response body data array and should return a string or React element
  body: PropTypes.arrayOf(PropTypes.shape({
    key: PropTypes.string.isRequired,
    transform: PropTypes.func
  })).isRequired,
  // Array of group titles to disable collapsing for
  disableCollapseForGroups: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.string, PropTypes.number])),
  // 'threshold' prop to InfiniteScroll component
  threshold: PropTypes.number,
  // className to apply to group header th's
  groupHeaderClassName: PropTypes.string
};

var css_248z$q = ":root {\n  --primary1: #123787;\n  --primary2: #1d58d7;\n  --primary3: #5173fb;\n  --primary4: #7a93ff;\n  --primary5: #c2d0ff;\n  --primary6: #e5ebff;\n  --primary7: #f2f5ff; }\n\n@keyframes styles-module_hover-ripples__1DNF5 {\n  0% {\n    top: -0.1875em;\n    left: -0.1875em;\n    right: -0.1875em;\n    bottom: -0.1875em;\n    opacity: 1; }\n  100% {\n    top: -0.8125em;\n    left: -0.8125em;\n    right: -0.8125em;\n    bottom: -0.8125em;\n    opacity: 0; } }\n\n.styles-module_blockTitleText__2ocDT {\n  font-family: 'Avenir Next Demi', sans-serif;\n  font-weight: normal;\n  font-size: 1rem;\n  line-height: 1.5em;\n  min-width: 7.75rem;\n  margin-right: 1rem;\n  display: flex; }\n\n.styles-module_panelHeaderCollapse__2mXEk {\n  padding: 0;\n  cursor: pointer; }\n\n.styles-module_panelHeaderExpand__Wamq_ {\n  padding: 0;\n  cursor: pointer;\n  margin-bottom: 1rem; }\n\n.styles-module_summaryContainer__EQJ6f {\n  margin-right: 1rem;\n  display: inline; }\n\n.styles-module_summaryLabel__ivTUx {\n  font-family: 'Avenir Next Regular', sans-serif;\n  font-weight: normal;\n  letter-spacing: .2px;\n  color: #a2a2a2;\n  font-size: 0.75rem;\n  line-height: 1;\n  letter-spacing: 0.0125rem; }\n\n.styles-module_summaryValue__1feOQ {\n  font-family: 'Avenir Next Regular', sans-serif;\n  font-weight: normal;\n  letter-spacing: .2px;\n  font-size: 0.75rem;\n  line-height: 1;\n  letter-spacing: 0.0125rem; }\n\n.styles-module_grid__KEKYb {\n  width: 100%;\n  margin-left: 0.5rem;\n  margin-top: 0.5rem; }\n\n.styles-module_section__2SFPa {\n  display: flex;\n  flex-direction: column;\n  padding-top: 1rem;\n  padding-left: 1.5rem;\n  margin-bottom: 0.9375rem;\n  width: 57.4375rem;\n  padding-right: 1.5rem;\n  padding-bottom: 1rem;\n  border-radius: 0.25rem !important;\n  box-shadow: 0 0.25rem 0.375rem rgba(0, 0, 0, 0.05), 0 0 0.5rem rgba(0, 0, 0, 0.04); }\n  .styles-module_section__2SFPa .styles-module_title__ghKXz {\n    font-family: 'Avenir Next Demi', sans-serif;\n    font-weight: normal;\n    font-weight: 600;\n    font-size: 0.875rem;\n    line-height: 1.125rem;\n    margin: auto 0 auto 0;\n    display: flex;\n    align-items: center; }\n    .styles-module_section__2SFPa .styles-module_title__ghKXz .svg-icon {\n      margin-right: 0.25rem;\n      width: 1.25rem; }\n      .styles-module_section__2SFPa .styles-module_title__ghKXz .svg-icon path {\n        fill: var(--primary2); }\n\n.styles-module_info__29R60 {\n  display: flex;\n  flex-direction: row;\n  flex-wrap: wrap; }\n  .styles-module_infoItem__ls2Qm {\n    display: flex;\n    flex-direction: column;\n    width: 100%;\n    margin-bottom: 1rem;\n    gap: 0.25rem; }\n    .styles-module_infoItemTitle__SEsZD {\n      font-family: 'Avenir Next Regular', sans-serif;\n      font-weight: normal;\n      letter-spacing: .2px;\n      color: #666666;\n      font-size: 0.75rem;\n      line-height: 1;\n      letter-spacing: 0.0125rem;\n      margin-bottom: 0.4375rem; }\n    .styles-module_infoItemValue__lUQV3 {\n      font-family: 'Avenir Next Regular', sans-serif;\n      font-weight: normal;\n      letter-spacing: .2px;\n      color: #000000;\n      font-size: 0.75rem;\n      line-height: 1rem;\n      display: flex; }\n      .styles-module_infoItemValue__lUQV3 .svg-icon {\n        margin-right: 0.3125rem;\n        width: 1rem;\n        height: 1rem; }\n        .styles-module_infoItemValue__lUQV3 .svg-icon path {\n          fill: var(--primary2); }\n      .styles-module_infoItemValue__lUQV3 .styles-module_clickableIcon__24tL0 {\n        cursor: pointer; }\n        .styles-module_infoItemValue__lUQV3 .styles-module_clickableIcon__24tL0 .svg-icon path {\n          fill: #787878; }\n\n.styles-module_toolTipText__-Tfjp {\n  max-width: 15.625rem;\n  margin-right: 0.5rem;\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis; }\n  .styles-module_toolTipText__-Tfjp::after {\n    content: '';\n    display: block; }\n";
var styles$n = {"blockTitleText":"styles-module_blockTitleText__2ocDT","panelHeaderCollapse":"styles-module_panelHeaderCollapse__2mXEk","panelHeaderExpand":"styles-module_panelHeaderExpand__Wamq_","summaryContainer":"styles-module_summaryContainer__EQJ6f","summaryLabel":"styles-module_summaryLabel__ivTUx","summaryValue":"styles-module_summaryValue__1feOQ","grid":"styles-module_grid__KEKYb","section":"styles-module_section__2SFPa","title":"styles-module_title__ghKXz","info":"styles-module_info__29R60","infoItem":"styles-module_infoItem__ls2Qm","infoItemTitle":"styles-module_infoItemTitle__SEsZD","infoItemValue":"styles-module_infoItemValue__lUQV3","clickableIcon":"styles-module_clickableIcon__24tL0","toolTipText":"styles-module_toolTipText__-Tfjp","hover-ripples":"styles-module_hover-ripples__1DNF5"};
styleInject(css_248z$q);

function ownKeys$r(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$r(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$r(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$r(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var fetchCountries = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee(params, onError) {
    var _response$data, _response$data$data, response, countries;

    return regenerator.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            _context.next = 3;
            return axios({
              url: "".concat(ORIGIN_URL, "/api/v3/master/segment/country"),
              headers: getHeaders(),
              method: 'post',
              data: params || {}
            });

          case 3:
            response = _context.sent;
            countries = ((_response$data = response.data) === null || _response$data === void 0 ? void 0 : (_response$data$data = _response$data.data) === null || _response$data$data === void 0 ? void 0 : _response$data$data.data) || [];
            return _context.abrupt("return", countries.map(function (country) {
              return {
                label: country.name,
                value: country.id,
                shortName: country.abbreviation
              };
            }));

          case 8:
            _context.prev = 8;
            _context.t0 = _context["catch"](0);
            console.error('Error while getting countries', _context.t0);

            if (onError) {
              onError(_context.t0);
            }

            return _context.abrupt("return", []);

          case 13:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[0, 8]]);
  }));

  return function fetchCountries(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();
var fetchStates = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee2(params, onError) {
    var _response$data2, _response$data2$data, response, data;

    return regenerator.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.prev = 0;
            _context2.next = 3;
            return axios({
              url: "".concat(ORIGIN_URL, "/api/v3/master/segment/state"),
              headers: getHeaders(),
              method: 'post',
              data: params || {}
            });

          case 3:
            response = _context2.sent;
            data = (response === null || response === void 0 ? void 0 : (_response$data2 = response.data) === null || _response$data2 === void 0 ? void 0 : (_response$data2$data = _response$data2.data) === null || _response$data2$data === void 0 ? void 0 : _response$data2$data.data) || [];
            return _context2.abrupt("return", data.map(function (state) {
              return {
                label: state.name,
                value: state.id,
                abbreviation: state.abbreviation,
                geojsonUrl: state.geojsonUrl,
                v2Id: state.id
              };
            }));

          case 8:
            _context2.prev = 8;
            _context2.t0 = _context2["catch"](0);
            console.error('Error while getting states', _context2.t0);

            if (onError) {
              onError(_context2.t0);
            }

            return _context2.abrupt("return", []);

          case 13:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, null, [[0, 8]]);
  }));

  return function fetchStates(_x3, _x4) {
    return _ref2.apply(this, arguments);
  };
}();
var fetchDeviceTypes = /*#__PURE__*/function () {
  var _ref3 = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee3(onError) {
    var response;
    return regenerator.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            _context3.prev = 0;
            _context3.next = 3;
            return axios({
              url: "".concat(ORIGIN_URL, "/api/device_types"),
              headers: getHeaders(),
              method: 'get'
            });

          case 3:
            response = _context3.sent;
            return _context3.abrupt("return", response.data.map(function (item) {
              return {
                id: item.id,
                label: item.name,
                value: item.id
              };
            }));

          case 7:
            _context3.prev = 7;
            _context3.t0 = _context3["catch"](0);
            console.error('Error while getting device types', _context3.t0);

            if (onError) {
              onError(_context3.t0);
            }

            return _context3.abrupt("return", []);

          case 12:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3, null, [[0, 7]]);
  }));

  return function fetchDeviceTypes(_x5) {
    return _ref3.apply(this, arguments);
  };
}();
var fetchManufacturers = /*#__PURE__*/function () {
  var _ref4 = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee4(onError) {
    var response;
    return regenerator.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            _context4.prev = 0;
            _context4.next = 3;
            return axios({
              url: "".concat(ORIGIN_URL, "/api/manufacturers"),
              headers: getHeaders(),
              method: 'get'
            });

          case 3:
            response = _context4.sent;
            return _context4.abrupt("return", response.data.map(function (item) {
              return {
                id: item.id,
                label: item.name,
                value: item.id
              };
            }));

          case 7:
            _context4.prev = 7;
            _context4.t0 = _context4["catch"](0);
            console.error('Error while getting manufacturers list', _context4.t0);

            if (onError) {
              onError(_context4.t0);
            }

            return _context4.abrupt("return", []);

          case 12:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4, null, [[0, 7]]);
  }));

  return function fetchManufacturers(_x6) {
    return _ref4.apply(this, arguments);
  };
}();
var fetchOs = /*#__PURE__*/function () {
  var _ref5 = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee5(onError) {
    var response;
    return regenerator.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            _context5.prev = 0;
            _context5.next = 3;
            return axios({
              url: "".concat(ORIGIN_URL, "/api/device_os"),
              headers: getHeaders(),
              method: 'get'
            });

          case 3:
            response = _context5.sent;
            return _context5.abrupt("return", response.data.map(function (item) {
              return {
                id: item.id,
                label: item.name,
                value: item.id
              };
            }));

          case 7:
            _context5.prev = 7;
            _context5.t0 = _context5["catch"](0);
            console.error('Error while getting device os list', _context5.t0);

            if (onError) {
              onError(_context5.t0);
            }

            return _context5.abrupt("return", []);

          case 12:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5, null, [[0, 7]]);
  }));

  return function fetchOs(_x7) {
    return _ref5.apply(this, arguments);
  };
}();
var fetchNetworkTypes = /*#__PURE__*/function () {
  var _ref6 = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee6(onError) {
    var response;
    return regenerator.wrap(function _callee6$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            _context6.prev = 0;
            _context6.next = 3;
            return axios({
              url: "".concat(ORIGIN_URL, "/api/network_types"),
              headers: getHeaders(),
              method: 'get'
            });

          case 3:
            response = _context6.sent;
            return _context6.abrupt("return", response.data.map(function (item) {
              return {
                id: item.id,
                label: item.name,
                value: item.id
              };
            }));

          case 7:
            _context6.prev = 7;
            _context6.t0 = _context6["catch"](0);
            console.error('Error while getting network types list', _context6.t0);

            if (onError) {
              onError(_context6.t0);
            }

            return _context6.abrupt("return", []);

          case 12:
          case "end":
            return _context6.stop();
        }
      }
    }, _callee6, null, [[0, 7]]);
  }));

  return function fetchNetworkTypes(_x8) {
    return _ref6.apply(this, arguments);
  };
}();
var fetchTrafficTypes = /*#__PURE__*/function () {
  var _ref7 = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee7(onError) {
    var response;
    return regenerator.wrap(function _callee7$(_context7) {
      while (1) {
        switch (_context7.prev = _context7.next) {
          case 0:
            _context7.prev = 0;
            _context7.next = 3;
            return axios({
              url: "".concat(ORIGIN_URL, "/api/source_traffic_types"),
              headers: getHeaders(),
              method: 'get'
            });

          case 3:
            response = _context7.sent;
            return _context7.abrupt("return", response.data.map(function (item) {
              return {
                id: item.id,
                label: item.name,
                value: item.id
              };
            }));

          case 7:
            _context7.prev = 7;
            _context7.t0 = _context7["catch"](0);
            console.error('Error while getting traffic types list', _context7.t0);

            if (onError) {
              onError(_context7.t0);
            }

            return _context7.abrupt("return", []);

          case 12:
          case "end":
            return _context7.stop();
        }
      }
    }, _callee7, null, [[0, 7]]);
  }));

  return function fetchTrafficTypes(_x9) {
    return _ref7.apply(this, arguments);
  };
}();
var fetchCarriers = /*#__PURE__*/function () {
  var _ref8 = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee8(onError, carrierIds) {
    var response;
    return regenerator.wrap(function _callee8$(_context8) {
      while (1) {
        switch (_context8.prev = _context8.next) {
          case 0:
            _context8.prev = 0;
            _context8.next = 3;
            return axios({
              url: "".concat(ORIGIN_URL, "/api/v2/master/segment/device-carrier?segmentIds=").concat(carrierIds),
              headers: getHeaders(),
              method: 'get'
            });

          case 3:
            response = _context8.sent;
            return _context8.abrupt("return", response.data.responseObject.data.map(function (item) {
              return {
                id: item.id,
                label: item.name,
                value: item.id
              };
            }));

          case 7:
            _context8.prev = 7;
            _context8.t0 = _context8["catch"](0);
            console.error('Error while getting carriers list', _context8.t0);

            if (onError) {
              onError(_context8.t0);
            }

            return _context8.abrupt("return", []);

          case 12:
          case "end":
            return _context8.stop();
        }
      }
    }, _callee8, null, [[0, 7]]);
  }));

  return function fetchCarriers(_x10, _x11) {
    return _ref8.apply(this, arguments);
  };
}();
var fetchExchanges = /*#__PURE__*/function () {
  var _ref9 = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee9(onError) {
    var response;
    return regenerator.wrap(function _callee9$(_context9) {
      while (1) {
        switch (_context9.prev = _context9.next) {
          case 0:
            _context9.prev = 0;
            _context9.next = 3;
            return axios({
              url: "".concat(ORIGIN_URL, "/api/exchanges"),
              headers: getHeaders(),
              method: 'get'
            });

          case 3:
            response = _context9.sent;
            return _context9.abrupt("return", response.data.map(function (_ref10) {
              var name = _ref10.name,
                  id = _ref10.id;
              return {
                label: name,
                value: id
              };
            }));

          case 7:
            _context9.prev = 7;
            _context9.t0 = _context9["catch"](0);
            console.error('Error while getting exchanges codes', _context9.t0);

            if (onError) {
              onError(_context9.t0);
            }

            return _context9.abrupt("return", []);

          case 12:
          case "end":
            return _context9.stop();
        }
      }
    }, _callee9, null, [[0, 7]]);
  }));

  return function fetchExchanges(_x12) {
    return _ref9.apply(this, arguments);
  };
}();
var fetchAges = /*#__PURE__*/function () {
  var _ref11 = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee10(onError) {
    var response;
    return regenerator.wrap(function _callee10$(_context10) {
      while (1) {
        switch (_context10.prev = _context10.next) {
          case 0:
            _context10.prev = 0;
            _context10.next = 3;
            return axios({
              url: "".concat(ORIGIN_URL, "/api/v2/master/segment/age"),
              headers: getHeaders(),
              method: 'get'
            });

          case 3:
            response = _context10.sent;
            return _context10.abrupt("return", response.data.responseObject.data.map(function (item) {
              return {
                id: item.id,
                label: item.name,
                value: item.id
              };
            }));

          case 7:
            _context10.prev = 7;
            _context10.t0 = _context10["catch"](0);
            console.error('Error while getting age range list', _context10.t0);

            if (onError) {
              onError(_context10.t0);
            }

            return _context10.abrupt("return", []);

          case 12:
          case "end":
            return _context10.stop();
        }
      }
    }, _callee10, null, [[0, 7]]);
  }));

  return function fetchAges(_x13) {
    return _ref11.apply(this, arguments);
  };
}();
var fetchGenders = /*#__PURE__*/function () {
  var _ref12 = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee11(onError) {
    var _response$data$respon, response;

    return regenerator.wrap(function _callee11$(_context11) {
      while (1) {
        switch (_context11.prev = _context11.next) {
          case 0:
            _context11.prev = 0;
            _context11.next = 3;
            return axios({
              url: "".concat(ORIGIN_URL, "/api/v2/master/segment/gender"),
              headers: getHeaders(),
              method: 'get'
            });

          case 3:
            response = _context11.sent;
            return _context11.abrupt("return", (_response$data$respon = response.data.responseObject) === null || _response$data$respon === void 0 ? void 0 : _response$data$respon.data.map(function (item) {
              return {
                id: item.id,
                label: item.name,
                value: item.id
              };
            }));

          case 7:
            _context11.prev = 7;
            _context11.t0 = _context11["catch"](0);
            console.error('Error while getting gender list', _context11.t0);

            if (onError) {
              onError(_context11.t0);
            }

            return _context11.abrupt("return", []);

          case 12:
          case "end":
            return _context11.stop();
        }
      }
    }, _callee11, null, [[0, 7]]);
  }));

  return function fetchGenders(_x14) {
    return _ref12.apply(this, arguments);
  };
}();
var fetchLanguages = /*#__PURE__*/function () {
  var _ref13 = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee12(onError) {
    var response;
    return regenerator.wrap(function _callee12$(_context12) {
      while (1) {
        switch (_context12.prev = _context12.next) {
          case 0:
            _context12.prev = 0;
            _context12.next = 3;
            return axios({
              url: "".concat(ORIGIN_URL, "/api/v2/master/segment/language"),
              headers: getHeaders(),
              method: 'get'
            });

          case 3:
            response = _context12.sent;
            return _context12.abrupt("return", response.data.responseObject.data.map(function (item) {
              return {
                id: item.id,
                label: item.name,
                value: item.id
              };
            }));

          case 7:
            _context12.prev = 7;
            _context12.t0 = _context12["catch"](0);
            console.error('Error while getting language list', _context12.t0);

            if (onError) {
              onError(_context12.t0);
            }

            return _context12.abrupt("return", []);

          case 12:
          case "end":
            return _context12.stop();
        }
      }
    }, _callee12, null, [[0, 7]]);
  }));

  return function fetchLanguages(_x15) {
    return _ref13.apply(this, arguments);
  };
}();
var fetchInterests = /*#__PURE__*/function () {
  var _ref14 = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee13(onError) {
    var response;
    return regenerator.wrap(function _callee13$(_context13) {
      while (1) {
        switch (_context13.prev = _context13.next) {
          case 0:
            _context13.prev = 0;
            _context13.next = 3;
            return axios({
              url: "".concat(ORIGIN_URL, "/api/v2/master/segment/interest"),
              headers: getHeaders(),
              method: 'get'
            });

          case 3:
            response = _context13.sent;
            return _context13.abrupt("return", response.data.responseObject.data.map(function (item) {
              return {
                id: item.id,
                label: item.name,
                value: item.id
              };
            }));

          case 7:
            _context13.prev = 7;
            _context13.t0 = _context13["catch"](0);
            console.error('Error while getting interest list', _context13.t0);

            if (onError) {
              onError(_context13.t0);
            }

            return _context13.abrupt("return", []);

          case 12:
          case "end":
            return _context13.stop();
        }
      }
    }, _callee13, null, [[0, 7]]);
  }));

  return function fetchInterests(_x16) {
    return _ref14.apply(this, arguments);
  };
}();
var fetchIncomeRange = /*#__PURE__*/function () {
  var _ref15 = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee14(onError) {
    var response;
    return regenerator.wrap(function _callee14$(_context14) {
      while (1) {
        switch (_context14.prev = _context14.next) {
          case 0:
            _context14.prev = 0;
            _context14.next = 3;
            return axios({
              url: "".concat(ORIGIN_URL, "/api/v2/master/segment/income"),
              headers: getHeaders(),
              method: 'get'
            });

          case 3:
            response = _context14.sent;
            return _context14.abrupt("return", response.data.responseObject.data.map(function (item) {
              return {
                id: item.id,
                label: item.name,
                value: item.id
              };
            }));

          case 7:
            _context14.prev = 7;
            _context14.t0 = _context14["catch"](0);
            console.error('Error while getting income range list', _context14.t0);

            if (onError) {
              onError(_context14.t0);
            }

            return _context14.abrupt("return", []);

          case 12:
          case "end":
            return _context14.stop();
        }
      }
    }, _callee14, null, [[0, 7]]);
  }));

  return function fetchIncomeRange(_x17) {
    return _ref15.apply(this, arguments);
  };
}();
var fetchEthnicityGroups = /*#__PURE__*/function () {
  var _ref16 = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee15(onError) {
    var response;
    return regenerator.wrap(function _callee15$(_context15) {
      while (1) {
        switch (_context15.prev = _context15.next) {
          case 0:
            _context15.prev = 0;
            _context15.next = 3;
            return axios({
              url: "".concat(ORIGIN_URL, "/api/v2/master/segment/ethnicity-group"),
              headers: getHeaders(),
              method: 'get'
            });

          case 3:
            response = _context15.sent;
            return _context15.abrupt("return", response.data.responseObject.data.map(function (item) {
              return {
                id: item.id,
                label: item.name,
                value: item.id
              };
            }));

          case 7:
            _context15.prev = 7;
            _context15.t0 = _context15["catch"](0);
            console.error('Error while getting ethnicity list', _context15.t0);

            if (onError) {
              onError(_context15.t0);
            }

            return _context15.abrupt("return", []);

          case 12:
          case "end":
            return _context15.stop();
        }
      }
    }, _callee15, null, [[0, 7]]);
  }));

  return function fetchEthnicityGroups(_x18) {
    return _ref16.apply(this, arguments);
  };
}();
var fetchAudiences = /*#__PURE__*/function () {
  var _ref17 = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee16(audienceTypeIds, owIds, onError) {
    var response;
    return regenerator.wrap(function _callee16$(_context16) {
      while (1) {
        switch (_context16.prev = _context16.next) {
          case 0:
            _context16.prev = 0;
            _context16.next = 3;
            return axios({
              url: "".concat(ORIGIN_URL, "/api/v2/audience/list"),
              headers: getHeaders(),
              method: 'get',
              params: {
                owIds: owIds,
                audienceTypeIds: audienceTypeIds
              }
            });

          case 3:
            response = _context16.sent;
            return _context16.abrupt("return", response.data.responseObject.map(function (item) {
              return _objectSpread$r(_objectSpread$r({}, item), {}, {
                label: item.audienceName,
                value: item.id
              });
            }));

          case 7:
            _context16.prev = 7;
            _context16.t0 = _context16["catch"](0);
            console.error('Error while getting audiences list', _context16.t0);

            if (onError) {
              onError(_context16.t0);
            }

            return _context16.abrupt("return", []);

          case 12:
          case "end":
            return _context16.stop();
        }
      }
    }, _callee16, null, [[0, 7]]);
  }));

  return function fetchAudiences(_x19, _x20, _x21) {
    return _ref17.apply(this, arguments);
  };
}();
var fetchAdvertiserList = /*#__PURE__*/function () {
  var _ref18 = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee17(politicalAdvertiserId, onError) {
    var _response$data3, response;

    return regenerator.wrap(function _callee17$(_context17) {
      while (1) {
        switch (_context17.prev = _context17.next) {
          case 0:
            _context17.prev = 0;
            _context17.next = 3;
            return axios({
              url: "".concat(ORIGIN_URL, "/api/v3/ua/organization/advertisers/list?searchField=&pageNo=1&limit=&advertiserIds=").concat(politicalAdvertiserId),
              headers: getHeaders(),
              method: 'get'
            });

          case 3:
            response = _context17.sent;

            if (!(response !== null && response !== void 0 && (_response$data3 = response.data) !== null && _response$data3 !== void 0 && _response$data3.success)) {
              _context17.next = 6;
              break;
            }

            return _context17.abrupt("return", response.data.data);

          case 6:
            _context17.next = 13;
            break;

          case 8:
            _context17.prev = 8;
            _context17.t0 = _context17["catch"](0);
            console.error('Error while getting advertisers list', _context17.t0);

            if (onError) {
              onError(_context17.t0);
            }

            return _context17.abrupt("return", []);

          case 13:
          case "end":
            return _context17.stop();
        }
      }
    }, _callee17, null, [[0, 8]]);
  }));

  return function fetchAdvertiserList(_x22, _x23) {
    return _ref18.apply(this, arguments);
  };
}();
var fetchCreativesDetails = /*#__PURE__*/function () {
  var _ref19 = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee18(params, onError) {
    var response;
    return regenerator.wrap(function _callee18$(_context18) {
      while (1) {
        switch (_context18.prev = _context18.next) {
          case 0:
            _context18.prev = 0;
            _context18.next = 3;
            return axios({
              url: "".concat(ORIGIN_URL, "/api/v2/crt/creatives/details"),
              headers: getHeaders(),
              method: 'get',
              params: params
            });

          case 3:
            response = _context18.sent;
            return _context18.abrupt("return", response.data.responseObject);

          case 7:
            _context18.prev = 7;
            _context18.t0 = _context18["catch"](0);
            console.error('Error while getting creatives details', _context18.t0);

            if (onError) {
              onError(_context18.t0);
            }

            return _context18.abrupt("return", []);

          case 12:
          case "end":
            return _context18.stop();
        }
      }
    }, _callee18, null, [[0, 7]]);
  }));

  return function fetchCreativesDetails(_x24, _x25) {
    return _ref19.apply(this, arguments);
  };
}();
var fetchInventoryGroupDetails = /*#__PURE__*/function () {
  var _ref20 = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee19(params, onError) {
    var response;
    return regenerator.wrap(function _callee19$(_context19) {
      while (1) {
        switch (_context19.prev = _context19.next) {
          case 0:
            _context19.prev = 0;
            _context19.next = 3;
            return axios({
              url: "".concat(ORIGIN_URL, "/api/v2/inv/group/list"),
              headers: getHeaders(),
              method: 'get',
              params: params
            });

          case 3:
            response = _context19.sent;
            return _context19.abrupt("return", get$1(response, 'data.responseObject.data', []));

          case 7:
            _context19.prev = 7;
            _context19.t0 = _context19["catch"](0);
            console.error('Error while getting political advertiser list:', _context19.t0);

            if (onError) {
              onError(_context19.t0);
            }

            return _context19.abrupt("return", []);

          case 12:
          case "end":
            return _context19.stop();
        }
      }
    }, _callee19, null, [[0, 7]]);
  }));

  return function fetchInventoryGroupDetails(_x26, _x27) {
    return _ref20.apply(this, arguments);
  };
}();
var fetchCampaignGroupDetailsByStatus = /*#__PURE__*/function () {
  var _ref21 = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee20(params, onError) {
    var response;
    return regenerator.wrap(function _callee20$(_context20) {
      while (1) {
        switch (_context20.prev = _context20.next) {
          case 0:
            _context20.prev = 0;
            _context20.next = 3;
            return axios({
              url: "".concat(ORIGIN_URL, "/api/v3/cmp/campaigngroup/list"),
              headers: getHeaders(),
              method: 'post',
              data: _objectSpread$r({}, params)
            });

          case 3:
            response = _context20.sent;
            return _context20.abrupt("return", get$1(response, 'data', []));

          case 7:
            _context20.prev = 7;
            _context20.t0 = _context20["catch"](0);
            console.error('Error while getting campain group details:', _context20.t0);

            if (onError) {
              onError(_context20.t0);
            }

            return _context20.abrupt("return", []);

          case 12:
          case "end":
            return _context20.stop();
        }
      }
    }, _callee20, null, [[0, 7]]);
  }));

  return function fetchCampaignGroupDetailsByStatus(_x28, _x29) {
    return _ref21.apply(this, arguments);
  };
}();

var CampaignDetails = function CampaignDetails(_ref) {
  var _timezonesList$find;

  var campaign = _ref.campaign,
      selectedTimezone = _ref.selectedTimezone,
      timezonesList = _ref.timezonesList,
      onLinkCopy = _ref.onLinkCopy,
      isBlockOpen = _ref.isBlockOpen,
      onToggle = _ref.onToggle,
      onFetchCampaignGroupDetailsError = _ref.onFetchCampaignGroupDetailsError;

  var _useState = useState$2([]),
      _useState2 = _slicedToArray(_useState, 2),
      campaignGroupsInfo = _useState2[0],
      setCampaignGroupsInfo = _useState2[1];

  var campaignGroupIds = campaign.campaignGroupIds ? campaign.campaignGroupIds.split(',') : '';
  useEffect(function () {
    if (campaign.campaignGroupIds) {
      _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee() {
        var _res$data, _res$data$data;

        var res;
        return regenerator.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return fetchCampaignGroupDetailsByStatus({
                  campaignGroupIds: campaign.campaignGroupIds.split(',').map(function (id) {
                    return +id;
                  }),
                  pageNo: -1
                }, onFetchCampaignGroupDetailsError);

              case 2:
                res = _context.sent;

                if (res.success && (_res$data = res.data) !== null && _res$data !== void 0 && (_res$data$data = _res$data.data) !== null && _res$data$data !== void 0 && _res$data$data.length) {
                  setCampaignGroupsInfo(res.data.data);
                }

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    } // eslint-disable-next-line react-hooks/exhaustive-deps

  }, [campaign]);
  var campaignDetailsWithFields = {
    title: 'Campaign Details',
    icon: 'CampaignsInfo',
    info: [{
      title: 'Campaign Name',
      value: campaign.campaignName,
      displayTooltip: true
    }, {
      title: 'Campaign Group',
      value: campaignGroupsInfo.length ? campaignGroupsInfo.map(function (group) {
        return group.groupName;
      }).join(', ') : '-',
      displayTooltip: true
    }, {
      title: 'Advertiser Domain URL',
      value: campaign.advertiserDomain,
      icon: ['Copy', 'OpenLink'],
      displayTooltip: true,
      iconPosition: 'right'
    }, {
      title: 'Timezone',
      value: timezonesList === null || timezonesList === void 0 ? void 0 : (_timezonesList$find = timezonesList.find(function (tz) {
        return tz.id === campaign.timezone;
      })) === null || _timezonesList$find === void 0 ? void 0 : _timezonesList$find.label,
      icon: ['Timezone'],
      iconPosition: 'left'
    }, {
      title: 'Start Time',
      value: moment(campaign.startTime * 1000).tz((selectedTimezone === null || selectedTimezone === void 0 ? void 0 : selectedTimezone.value) || 'UTC').format('MM/DD/YYYY  hh:mm A'),
      icon: ['DateRange'],
      iconPosition: 'left'
    }, {
      title: 'End Time',
      value: campaign.endTime ? moment(campaign.endTime * 1000).tz((selectedTimezone === null || selectedTimezone === void 0 ? void 0 : selectedTimezone.value) || 'UTC').format('MM/DD/YYYY  hh:mm A') : '',
      icon: ['DateRange'],
      iconPosition: 'left'
    }]
  };

  var onIconClick = function onIconClick(iconName, code) {
    if (iconName === 'Copy') {
      var input = document.createElement('textarea');
      input.value = code;
      document.body.appendChild(input);
      input.select();
      document.execCommand('copy');
      document.body.removeChild(input);
      onLinkCopy === null || onLinkCopy === void 0 ? void 0 : onLinkCopy();
    } else {
      window.open(campaign === null || campaign === void 0 ? void 0 : campaign.advertiserDomain, '_blank');
    }
  };

  var getClippedText = function getClippedText(text) {
    return text.length > 30 ? "".concat(text.substring(0, 29), "...") : text;
  };

  return /*#__PURE__*/React__default.createElement(CollapsibleBlock, {
    customStyle: {
      block: styles$n.section,
      blockTitleText: styles$n.blockTitleText,
      summaryContainer: styles$n.summaryContainer,
      summaryLabel: styles$n.summaryLabel,
      summaryValue: styles$n.summaryValue,
      panelHeaderExpand: styles$n.panelHeaderExpand,
      panelHeaderCollapse: styles$n.panelHeaderCollapse
    },
    id: "details",
    header: {
      title: /*#__PURE__*/React__default.createElement("div", {
        className: styles$n.title
      }, /*#__PURE__*/React__default.createElement(Icon, {
        name: "CampaignsInfo"
      }), "Campaign Details"),
      summary: {
        'Campaign Name': truncate$1(campaign.campaignName)
      }
    },
    isCollapseOpen: isBlockOpen,
    onToggle: onToggle,
    collapsible: true
  }, /*#__PURE__*/React__default.createElement("div", {
    className: styles$n.info
  }, /*#__PURE__*/React__default.createElement(DisplayItems, {
    type: "grid",
    gridColumnCount: 3,
    gridClassName: styles$n.grid,
    items: campaignDetailsWithFields.info.map(function (infoItem, idx) {
      return {
        id: idx,
        element: /*#__PURE__*/React__default.createElement("div", {
          className: styles$n.infoItem
        }, /*#__PURE__*/React__default.createElement("div", {
          className: styles$n.infoItemTitle
        }, infoItem.title), /*#__PURE__*/React__default.createElement("div", {
          className: styles$n.infoItemValue
        }, infoItem.icon && infoItem.iconPosition === 'left' ? infoItem.icon.map(function (icon) {
          return /*#__PURE__*/React__default.createElement(Icon, {
            name: icon
          });
        }) : null, /*#__PURE__*/React__default.createElement("div", null, infoItem.displayTooltip && infoItem.value ? /*#__PURE__*/React__default.createElement(Tooltip, {
          label: infoItem.value,
          portal: true
        }, /*#__PURE__*/React__default.createElement("div", {
          className: styles$n.toolTipText
        }, getClippedText(infoItem.value.toString()))) : /*#__PURE__*/React__default.createElement(React__default.Fragment, null, infoItem.value ? getClippedText(infoItem.value.toString()) : '-')), infoItem.icon && infoItem.iconPosition === 'right' && infoItem.value ? infoItem.icon.map(function (icon) {
          return /*#__PURE__*/React__default.createElement("div", {
            className: styles$n.clickableIcon,
            onClick: function onClick() {
              return onIconClick(icon, infoItem.value);
            }
          }, /*#__PURE__*/React__default.createElement(Tooltip, {
            label: icon === 'Copy' ? 'Copy Link' : 'Open Link',
            portal: true
          }, /*#__PURE__*/React__default.createElement(Icon, {
            name: icon
          })));
        }) : null))
      };
    })
  })));
};

var css_248z$r = ":root {\n  --primary1: #123787;\n  --primary2: #1d58d7;\n  --primary3: #5173fb;\n  --primary4: #7a93ff;\n  --primary5: #c2d0ff;\n  --primary6: #e5ebff;\n  --primary7: #f2f5ff; }\n\n@keyframes index-module_hover-ripples__BUcKE {\n  0% {\n    top: -0.1875em;\n    left: -0.1875em;\n    right: -0.1875em;\n    bottom: -0.1875em;\n    opacity: 1; }\n  100% {\n    top: -0.8125em;\n    left: -0.8125em;\n    right: -0.8125em;\n    bottom: -0.8125em;\n    opacity: 0; } }\n\n.index-module_blockTitleText__Q2cDE {\n  font-family: 'Avenir Next Demi', sans-serif;\n  font-weight: normal;\n  font-size: 1rem;\n  line-height: 1.5em;\n  min-width: 4.75rem;\n  margin-right: 1rem;\n  display: flex; }\n\n.index-module_panelHeaderCollapse__29buQ {\n  padding: 0;\n  cursor: pointer; }\n\n.index-module_panelHeaderExpand__22iKa {\n  padding: 0;\n  cursor: pointer;\n  margin-bottom: 1rem; }\n\n.index-module_summaryContainer__2r74j {\n  margin-right: 1rem;\n  display: inline; }\n\n.index-module_summaryLabel__3nyMm {\n  font-family: 'Avenir Next Regular', sans-serif;\n  font-weight: normal;\n  letter-spacing: .2px;\n  color: #a2a2a2;\n  font-size: 0.75rem;\n  line-height: 1;\n  letter-spacing: 0.0125rem; }\n\n.index-module_summaryValue__36FtA {\n  font-family: 'Avenir Next Regular', sans-serif;\n  font-weight: normal;\n  letter-spacing: .2px;\n  font-size: 0.75rem;\n  line-height: 1;\n  letter-spacing: 0.0125rem; }\n\n.index-module_grid__2xc9T {\n  width: 100%;\n  margin-left: 0.5rem;\n  margin-top: 0.5rem; }\n\n.index-module_section__2vqvJ {\n  display: flex;\n  flex-direction: column;\n  padding-top: 1rem;\n  padding-left: 1.5rem;\n  margin-bottom: 0.9375rem;\n  width: 57.4375rem;\n  padding-right: 1.5rem;\n  padding-bottom: 1rem;\n  border-radius: 0.25rem !important;\n  box-shadow: 0 0.25rem 0.375rem rgba(0, 0, 0, 0.05), 0 0 0.5rem rgba(0, 0, 0, 0.04); }\n  .index-module_section__2vqvJ .index-module_title__1sWMv {\n    font-family: 'Avenir Next Demi', sans-serif;\n    font-weight: normal;\n    font-weight: 600;\n    font-size: 0.875rem;\n    line-height: 1.125rem;\n    margin: auto 0 auto 0;\n    display: flex;\n    align-items: center; }\n    .index-module_section__2vqvJ .index-module_title__1sWMv .svg-icon {\n      margin-right: 0.25rem; }\n      .index-module_section__2vqvJ .index-module_title__1sWMv .svg-icon path {\n        stroke: var(--primary2);\n        fill: none; }\n\n.index-module_info__3uzfb {\n  display: flex;\n  flex-direction: row;\n  flex-wrap: wrap; }\n  .index-module_infoItem__1qTdN {\n    display: flex;\n    flex-direction: column;\n    width: 100%;\n    margin-bottom: 1rem;\n    gap: 0.25rem; }\n    .index-module_infoItemTitle__BzdQf {\n      font-family: 'Avenir Next Regular', sans-serif;\n      font-weight: normal;\n      letter-spacing: .2px;\n      color: #666666;\n      font-size: 0.75rem;\n      line-height: 1;\n      letter-spacing: 0.0125rem;\n      margin-bottom: 0.4375rem; }\n    .index-module_infoItemValue__3QLHK {\n      font-family: 'Avenir Next Regular', sans-serif;\n      font-weight: normal;\n      letter-spacing: .2px;\n      color: #000000;\n      font-size: 0.75rem;\n      line-height: 1rem;\n      display: flex; }\n      .index-module_infoItemValue__3QLHK .index-module_successPill__29LdC {\n        font-family: 'Avenir Next Demi', sans-serif;\n        font-weight: normal;\n        letter-spacing: .2px;\n        margin-top: -0.3125rem;\n        height: 1.5625rem;\n        color: #289679; }\n      .index-module_infoItemValue__3QLHK .index-module_dangerPill__3oYfI {\n        font-family: 'Avenir Next Demi', sans-serif;\n        font-weight: normal;\n        letter-spacing: .2px;\n        margin-top: -0.3125rem;\n        height: 1.5625rem;\n        color: #f1494a; }\n";
var styles$o = {"blockTitleText":"index-module_blockTitleText__Q2cDE","panelHeaderCollapse":"index-module_panelHeaderCollapse__29buQ","panelHeaderExpand":"index-module_panelHeaderExpand__22iKa","summaryContainer":"index-module_summaryContainer__2r74j","summaryLabel":"index-module_summaryLabel__3nyMm","summaryValue":"index-module_summaryValue__36FtA","grid":"index-module_grid__2xc9T","section":"index-module_section__2vqvJ","title":"index-module_title__1sWMv","info":"index-module_info__3uzfb","infoItem":"index-module_infoItem__1qTdN","infoItemTitle":"index-module_infoItemTitle__BzdQf","infoItemValue":"index-module_infoItemValue__3QLHK","successPill":"index-module_successPill__29LdC","dangerPill":"index-module_dangerPill__3oYfI","hover-ripples":"index-module_hover-ripples__BUcKE"};
styleInject(css_248z$r);

var CampaignBudget = function CampaignBudget(_ref) {
  var campaign = _ref.campaign,
      isBlockOpen = _ref.isBlockOpen,
      onToggle = _ref.onToggle;
  var campaignBudgetWithFields = {
    title: 'Budget',
    icon: 'Dollar',
    info: [{
      title: 'Total Budget',
      value: "".concat(CurrencyFormat.format(campaign.budgetTotal))
    }, {
      title: 'Max Bid',
      value: "".concat(CurrencyFormat.format(campaign.maxBid))
    }, {
      title: 'Daily Budget',
      value: "".concat(!!campaign.budgetDay && CurrencyFormat.format(campaign.budgetDay))
    }, {
      title: 'Budget Pacing',
      value: /*#__PURE__*/React__default.createElement(Pill, {
        label: campaign.totalBudgetPacing ? 'On' : 'Off',
        className: campaign.totalBudgetPacing ? styles$o.successPill : styles$o.dangerPill
      })
    }]
  };
  return /*#__PURE__*/React__default.createElement(CollapsibleBlock, {
    customStyle: {
      block: styles$o.section,
      blockTitleText: styles$o.blockTitleText,
      summaryContainer: styles$o.summaryContainer,
      summaryLabel: styles$o.summaryLabel,
      summaryValue: styles$o.summaryValue,
      panelHeaderExpand: styles$o.panelHeaderExpand,
      panelHeaderCollapse: styles$o.panelHeaderCollapse
    },
    id: "budget",
    header: {
      title: /*#__PURE__*/React__default.createElement("div", {
        className: styles$o.title
      }, /*#__PURE__*/React__default.createElement(Icon, {
        name: "CurrencyDollar"
      }), "Budget"),
      summary: {
        'Total Budget': "".concat(CurrencyFormat.format(campaign.budgetTotal)),
        'Max Bid': "".concat(CurrencyFormat.format(campaign.maxBid)),
        'Daily Budget': "".concat(!!campaign.budgetDay && CurrencyFormat.format(campaign.budgetDay)),
        'Budget Pacing': campaign.totalBudgetPacing ? 'ON' : 'OFF'
      }
    },
    isCollapseOpen: isBlockOpen,
    onToggle: onToggle,
    collapsible: true
  }, /*#__PURE__*/React__default.createElement("div", {
    className: styles$o.info
  }, /*#__PURE__*/React__default.createElement(DisplayItems, {
    type: "grid",
    gridColumnCount: 4,
    gridClassName: styles$o.grid,
    items: campaignBudgetWithFields.info.map(function (infoItem, idx) {
      return {
        id: idx,
        element: /*#__PURE__*/React__default.createElement("div", {
          className: styles$o.infoItem
        }, /*#__PURE__*/React__default.createElement("div", {
          className: styles$o.infoItemTitle
        }, infoItem.title), /*#__PURE__*/React__default.createElement("div", {
          className: styles$o.infoItemValue
        }, infoItem.value || '-'))
      };
    })
  })));
};

/**
  postmate - A powerful, simple, promise-based postMessage library
  @version v1.5.2
  @link https://github.com/dollarshaveclub/postmate
  @author Jacob Kelley <jakie8@gmail.com>
  @license MIT
**/
/**
 * The type of messages our frames our sending
 * @type {String}
 */
var messageType = 'application/x-postmate-v1+json';
/**
 * The maximum number of attempts to send a handshake request to the parent
 * @type {Number}
 */

var maxHandshakeRequests = 5;
/**
 * A unique message ID that is used to ensure responses are sent to the correct requests
 * @type {Number}
 */

var _messageId = 0;
/**
 * Increments and returns a message ID
 * @return {Number} A unique ID for a message
 */

var generateNewMessageId = function generateNewMessageId() {
  return ++_messageId;
};
/**
 * Postmate logging function that enables/disables via config
 * @param  {Object} ...args Rest Arguments
 */

var log = function log() {
  var _console;

  return Postmate.debug ? (_console = console).log.apply(_console, arguments) : null;
}; // eslint-disable-line no-console

/**
 * Takes a URL and returns the origin
 * @param  {String} url The full URL being requested
 * @return {String}     The URLs origin
 */

var resolveOrigin = function resolveOrigin(url) {
  var a = document.createElement('a');
  a.href = url;
  var protocol = a.protocol.length > 4 ? a.protocol : window.location.protocol;
  var host = a.host.length ? a.port === '80' || a.port === '443' ? a.hostname : a.host : window.location.host;
  return a.origin || protocol + "//" + host;
};
var messageTypes = {
  handshake: 1,
  'handshake-reply': 1,
  call: 1,
  emit: 1,
  reply: 1,
  request: 1
  /**
   * Ensures that a message is safe to interpret
   * @param  {Object} message The postmate message being sent
   * @param  {String|Boolean} allowedOrigin The whitelisted origin or false to skip origin check
   * @return {Boolean}
   */

};
var sanitize = function sanitize(message, allowedOrigin) {
  if (typeof allowedOrigin === 'string' && message.origin !== allowedOrigin) return false;
  if (!message.data) return false;
  if (typeof message.data === 'object' && !('postmate' in message.data)) return false;
  if (message.data.type !== messageType) return false;
  if (!messageTypes[message.data.postmate]) return false;
  return true;
};
/**
 * Takes a model, and searches for a value by the property
 * @param  {Object} model     The dictionary to search against
 * @param  {String} property  A path within a dictionary (i.e. 'window.location.href')
 * @param  {Object} data      Additional information from the get request that is
 *                            passed to functions in the child model
 * @return {Promise}
 */

var resolveValue = function resolveValue(model, property) {
  var unwrappedContext = typeof model[property] === 'function' ? model[property]() : model[property];
  return Postmate.Promise.resolve(unwrappedContext);
};
/**
 * Composes an API to be used by the parent
 * @param {Object} info Information on the consumer
 */

var ParentAPI =
/*#__PURE__*/
function () {
  function ParentAPI(info) {
    var _this = this;

    this.parent = info.parent;
    this.frame = info.frame;
    this.child = info.child;
    this.childOrigin = info.childOrigin;
    this.events = {};

    if (process.env.NODE_ENV !== 'production') {
      log('Parent: Registering API');
      log('Parent: Awaiting messages...');
    }

    this.listener = function (e) {
      if (!sanitize(e, _this.childOrigin)) return false;
      /**
       * the assignments below ensures that e, data, and value are all defined
       */

      var _ref = ((e || {}).data || {}).value || {},
          data = _ref.data,
          name = _ref.name;

      if (e.data.postmate === 'emit') {
        if (process.env.NODE_ENV !== 'production') {
          log("Parent: Received event emission: " + name);
        }

        if (name in _this.events) {
          _this.events[name].call(_this, data);
        }
      }
    };

    this.parent.addEventListener('message', this.listener, false);

    if (process.env.NODE_ENV !== 'production') {
      log('Parent: Awaiting event emissions from Child');
    }
  }

  var _proto = ParentAPI.prototype;

  _proto.get = function get(property) {
    var _this2 = this;

    return new Postmate.Promise(function (resolve) {
      // Extract data from response and kill listeners
      var uid = generateNewMessageId();

      var transact = function transact(e) {
        if (e.data.uid === uid && e.data.postmate === 'reply') {
          _this2.parent.removeEventListener('message', transact, false);

          resolve(e.data.value);
        }
      }; // Prepare for response from Child...


      _this2.parent.addEventListener('message', transact, false); // Then ask child for information


      _this2.child.postMessage({
        postmate: 'request',
        type: messageType,
        property: property,
        uid: uid
      }, _this2.childOrigin);
    });
  };

  _proto.call = function call(property, data) {
    // Send information to the child
    this.child.postMessage({
      postmate: 'call',
      type: messageType,
      property: property,
      data: data
    }, this.childOrigin);
  };

  _proto.on = function on(eventName, callback) {
    this.events[eventName] = callback;
  };

  _proto.destroy = function destroy() {
    if (process.env.NODE_ENV !== 'production') {
      log('Parent: Destroying Postmate instance');
    }

    window.removeEventListener('message', this.listener, false);
    this.frame.parentNode.removeChild(this.frame);
  };

  return ParentAPI;
}();
/**
 * Composes an API to be used by the child
 * @param {Object} info Information on the consumer
 */

var ChildAPI =
/*#__PURE__*/
function () {
  function ChildAPI(info) {
    var _this3 = this;

    this.model = info.model;
    this.parent = info.parent;
    this.parentOrigin = info.parentOrigin;
    this.child = info.child;

    if (process.env.NODE_ENV !== 'production') {
      log('Child: Registering API');
      log('Child: Awaiting messages...');
    }

    this.child.addEventListener('message', function (e) {
      if (!sanitize(e, _this3.parentOrigin)) return;

      if (process.env.NODE_ENV !== 'production') {
        log('Child: Received request', e.data);
      }

      var _e$data = e.data,
          property = _e$data.property,
          uid = _e$data.uid,
          data = _e$data.data;

      if (e.data.postmate === 'call') {
        if (property in _this3.model && typeof _this3.model[property] === 'function') {
          _this3.model[property](data);
        }

        return;
      } // Reply to Parent


      resolveValue(_this3.model, property).then(function (value) {
        return e.source.postMessage({
          property: property,
          postmate: 'reply',
          type: messageType,
          uid: uid,
          value: value
        }, e.origin);
      });
    });
  }

  var _proto2 = ChildAPI.prototype;

  _proto2.emit = function emit(name, data) {
    if (process.env.NODE_ENV !== 'production') {
      log("Child: Emitting Event \"" + name + "\"", data);
    }

    this.parent.postMessage({
      postmate: 'emit',
      type: messageType,
      value: {
        name: name,
        data: data
      }
    }, this.parentOrigin);
  };

  return ChildAPI;
}();
/**
  * The entry point of the Parent.
 * @type {Class}
 */

var Postmate =
/*#__PURE__*/
function () {
  // eslint-disable-line no-undef
  // Internet Explorer craps itself

  /**
   * Sets options related to the Parent
   * @param {Object} object The element to inject the frame into, and the url
   * @return {Promise}
   */
  function Postmate(_ref2) {
    var _ref2$container = _ref2.container,
        container = _ref2$container === void 0 ? typeof container !== 'undefined' ? container : document.body : _ref2$container,
        model = _ref2.model,
        url = _ref2.url,
        name = _ref2.name,
        _ref2$classListArray = _ref2.classListArray,
        classListArray = _ref2$classListArray === void 0 ? [] : _ref2$classListArray;
    // eslint-disable-line no-undef
    this.parent = window;
    this.frame = document.createElement('iframe');
    this.frame.name = name || '';
    this.frame.classList.add.apply(this.frame.classList, classListArray);
    container.appendChild(this.frame);
    this.child = this.frame.contentWindow || this.frame.contentDocument.parentWindow;
    this.model = model || {};
    return this.sendHandshake(url);
  }
  /**
   * Begins the handshake strategy
   * @param  {String} url The URL to send a handshake request to
   * @return {Promise}     Promise that resolves when the handshake is complete
   */


  var _proto3 = Postmate.prototype;

  _proto3.sendHandshake = function sendHandshake(url) {
    var _this4 = this;

    var childOrigin = resolveOrigin(url);
    var attempt = 0;
    var responseInterval;
    return new Postmate.Promise(function (resolve, reject) {
      var reply = function reply(e) {
        if (!sanitize(e, childOrigin)) return false;

        if (e.data.postmate === 'handshake-reply') {
          clearInterval(responseInterval);

          if (process.env.NODE_ENV !== 'production') {
            log('Parent: Received handshake reply from Child');
          }

          _this4.parent.removeEventListener('message', reply, false);

          _this4.childOrigin = e.origin;

          if (process.env.NODE_ENV !== 'production') {
            log('Parent: Saving Child origin', _this4.childOrigin);
          }

          return resolve(new ParentAPI(_this4));
        } // Might need to remove since parent might be receiving different messages
        // from different hosts


        if (process.env.NODE_ENV !== 'production') {
          log('Parent: Invalid handshake reply');
        }

        return reject('Failed handshake');
      };

      _this4.parent.addEventListener('message', reply, false);

      var doSend = function doSend() {
        attempt++;

        if (process.env.NODE_ENV !== 'production') {
          log("Parent: Sending handshake attempt " + attempt, {
            childOrigin: childOrigin
          });
        }

        _this4.child.postMessage({
          postmate: 'handshake',
          type: messageType,
          model: _this4.model
        }, childOrigin);

        if (attempt === maxHandshakeRequests) {
          clearInterval(responseInterval);
        }
      };

      var loaded = function loaded() {
        doSend();
        responseInterval = setInterval(doSend, 500);
      };

      if (_this4.frame.attachEvent) {
        _this4.frame.attachEvent('onload', loaded);
      } else {
        _this4.frame.onload = loaded;
      }

      if (process.env.NODE_ENV !== 'production') {
        log('Parent: Loading frame', {
          url: url
        });
      }

      _this4.frame.src = url;
    });
  };

  return Postmate;
}();
/**
 * The entry point of the Child
 * @type {Class}
 */


Postmate.debug = false;

Postmate.Promise = function () {
  try {
    return window ? window.Promise : Promise;
  } catch (e) {
    return null;
  }
}();

Postmate.Model =
/*#__PURE__*/
function () {
  /**
   * Initializes the child, model, parent, and responds to the Parents handshake
   * @param {Object} model Hash of values, functions, or promises
   * @return {Promise}       The Promise that resolves when the handshake has been received
   */
  function Model(model) {
    this.child = window;
    this.model = model;
    this.parent = this.child.parent;
    return this.sendHandshakeReply();
  }
  /**
   * Responds to a handshake initiated by the Parent
   * @return {Promise} Resolves an object that exposes an API for the Child
   */


  var _proto4 = Model.prototype;

  _proto4.sendHandshakeReply = function sendHandshakeReply() {
    var _this5 = this;

    return new Postmate.Promise(function (resolve, reject) {
      var shake = function shake(e) {
        if (!e.data.postmate) {
          return;
        }

        if (e.data.postmate === 'handshake') {
          if (process.env.NODE_ENV !== 'production') {
            log('Child: Received handshake from Parent');
          }

          _this5.child.removeEventListener('message', shake, false);

          if (process.env.NODE_ENV !== 'production') {
            log('Child: Sending handshake reply to Parent');
          }

          e.source.postMessage({
            postmate: 'handshake-reply',
            type: messageType
          }, e.origin);
          _this5.parentOrigin = e.origin; // Extend model with the one provided by the parent

          var defaults = e.data.model;

          if (defaults) {
            Object.keys(defaults).forEach(function (key) {
              _this5.model[key] = defaults[key];
            });

            if (process.env.NODE_ENV !== 'production') {
              log('Child: Inherited and extended model from Parent');
            }
          }

          if (process.env.NODE_ENV !== 'production') {
            log('Child: Saving Parent origin', _this5.parentOrigin);
          }

          return resolve(new ChildAPI(_this5));
        }

        return reject('Handshake Reply Failed');
      };

      _this5.child.addEventListener('message', shake, false);
    });
  };

  return Model;
}();

var useScrollbarWidth = function useScrollbarWidth() {
  var alreadyCalculated = useRef(false);
  var widthRef = useRef(0);
  if (alreadyCalculated.current) return widthRef.current;
  var scrollDiv = document.createElement('div');
  scrollDiv.style.width = '99px';
  scrollDiv.style.height = '99px';
  scrollDiv.style.position = 'absolute';
  scrollDiv.style.overflow = 'scroll';
  scrollDiv.className = 'scrollDiv';
  document.body.appendChild(scrollDiv);
  var width = scrollDiv.offsetWidth - scrollDiv.clientWidth;
  widthRef.current = width;
  document.body.removeChild(scrollDiv);
  alreadyCalculated.current = true;
  widthRef.current = width;
  return width;
};

var css_248z$s = ":root {\n  --primary1: #123787;\n  --primary2: #1d58d7;\n  --primary3: #5173fb;\n  --primary4: #7a93ff;\n  --primary5: #c2d0ff;\n  --primary6: #e5ebff;\n  --primary7: #f2f5ff; }\n\n@keyframes index-module_hover-ripples__3W3Rl {\n  0% {\n    top: -0.1875em;\n    left: -0.1875em;\n    right: -0.1875em;\n    bottom: -0.1875em;\n    opacity: 1; }\n  100% {\n    top: -0.8125em;\n    left: -0.8125em;\n    right: -0.8125em;\n    bottom: -0.8125em;\n    opacity: 0; } }\n\n.index-module_section__3t1zp {\n  display: flex;\n  flex-direction: column;\n  padding-top: 1rem;\n  padding-left: 1.5rem;\n  width: 57.4375rem;\n  padding-right: 1.5rem;\n  padding-bottom: 0.5rem;\n  margin-bottom: 0.9375rem;\n  border-radius: 0.25rem !important;\n  box-shadow: 0rem 0.25rem 0.375rem rgba(0, 0, 0, 0.05), 0rem 0rem 0.5rem rgba(0, 0, 0, 0.04); }\n  .index-module_section__3t1zp .index-module_title__3XyfZ {\n    font-family: 'Avenir Next Demi', sans-serif;\n    font-weight: normal;\n    font-weight: 600;\n    font-size: 0.875rem;\n    line-height: 1.125rem; }\n    .index-module_section__3t1zp .index-module_title__3XyfZ .svg-icon {\n      margin-right: 0.25rem; }\n      .index-module_section__3t1zp .index-module_title__3XyfZ .svg-icon path {\n        fill: var(--primary2); }\n\n.index-module_mapBoxContainer__zweKl {\n  width: 100%;\n  height: 28.125rem; }\n\n.index-module_iframeSize__2NhFb {\n  width: 100%;\n  height: 100%;\n  border-style: none; }\n\n.index-module_blockTitleText__2mTHf {\n  font-family: 'Avenir Next Demi', sans-serif;\n  font-weight: normal;\n  font-size: 1rem;\n  line-height: 1.5em;\n  min-width: 6.5rem; }\n\n.index-module_panelHeaderCollapse__2xTPH {\n  padding: 0;\n  cursor: pointer; }\n\n.index-module_panelHeaderExpand__1EAyq {\n  padding: 0;\n  cursor: pointer;\n  margin-bottom: 1rem; }\n\n.index-module_summaryContainer__k3kht {\n  margin-right: 1rem;\n  display: inline; }\n\n.index-module_summaryLabel__2zjoo {\n  font-family: 'Avenir Next Regular', sans-serif;\n  font-weight: normal;\n  letter-spacing: .2px;\n  color: #a2a2a2;\n  font-size: 0.75rem;\n  line-height: 1;\n  letter-spacing: 0.0125rem; }\n\n.index-module_summaryValue__1SFlA {\n  font-family: 'Avenir Next Regular', sans-serif;\n  font-weight: normal;\n  letter-spacing: .2px;\n  font-size: 0.75rem;\n  line-height: 1;\n  letter-spacing: 0.0125rem; }\n\n.index-module_emptySection__HJhyk {\n  display: flex;\n  align-items: center;\n  flex-direction: column; }\n  .index-module_emptySection__HJhyk img {\n    margin-bottom: 0.5rem;\n    width: 15.625rem;\n    height: 12.3125rem; }\n  .index-module_emptySection__HJhyk .index-module_text__21O3y {\n    font-family: 'Avenir Next Demi', sans-serif;\n    font-weight: normal;\n    font-style: normal;\n    font-weight: 600;\n    font-size: 0.875rem;\n    line-height: 1;\n    color: #000000;\n    letter-spacing: 0.00625rem;\n    margin-bottom: 0.25rem; }\n  .index-module_emptySection__HJhyk .index-module_subText__2ar-y {\n    font-family: 'Avenir Next Regular', sans-serif;\n    font-weight: normal;\n    font-style: normal;\n    font-weight: 400;\n    font-size: 0.8125rem;\n    line-height: 1;\n    color: #000000;\n    letter-spacing: 0.00625rem; }\n";
var styles$p = {"section":"index-module_section__3t1zp","title":"index-module_title__3XyfZ","mapBoxContainer":"index-module_mapBoxContainer__zweKl","iframeSize":"index-module_iframeSize__2NhFb","blockTitleText":"index-module_blockTitleText__2mTHf","panelHeaderCollapse":"index-module_panelHeaderCollapse__2xTPH","panelHeaderExpand":"index-module_panelHeaderExpand__1EAyq","summaryContainer":"index-module_summaryContainer__k3kht","summaryLabel":"index-module_summaryLabel__2zjoo","summaryValue":"index-module_summaryValue__1SFlA","emptySection":"index-module_emptySection__HJhyk","text":"index-module_text__21O3y","subText":"index-module_subText__2ar-y","hover-ripples":"index-module_hover-ripples__3W3Rl"};
styleInject(css_248z$s);

function ownKeys$s(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$s(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$s(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$s(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var CampaignLocation = function CampaignLocation(props) {
  var campaign = props.campaign,
      isBlockOpen = props.isBlockOpen,
      onToggle = props.onToggle,
      parentApp = props.parentApp,
      onFetchCountriesError = props.onFetchCountriesError,
      onFetchStatesError = props.onFetchStatesError;
  var scrollBarWidth = useScrollbarWidth();

  var _useState = useState$2([]),
      _useState2 = _slicedToArray(_useState, 2),
      countriesList = _useState2[0],
      setCountriesList = _useState2[1];

  var _useState3 = useState$2([]),
      _useState4 = _slicedToArray(_useState3, 2),
      statesList = _useState4[0],
      setStatesList = _useState4[1]; // using statefulRef for re-render to establish iFrame


  var _useState5 = useState$2(),
      _useState6 = _slicedToArray(_useState5, 2),
      mapNode = _useState6[0],
      setMapNode = _useState6[1];

  var mapRef = useRef(null);
  var iFrameEstablished = useRef(false);
  var getCommaSeparatedIds = useCallback(function (ids) {
    return ids ? ids.split(',') : [];
  }, []);
  var joinByComma = useCallback(function (blackList, whiteList) {
    if (blackList && whiteList) {
      return "".concat(blackList, ",").concat(whiteList);
    }

    return blackList || whiteList;
  }, []);

  var getIncludeExcludeLocationIds = function getIncludeExcludeLocationIds(locationDetail, includedLocation) {
    var locationIds = [];
    var locations = Object.values(locationDetail);

    for (var i = 0; i < locations.length; i += 1) {
      var _locations$i$validLoc;

      if ((_locations$i$validLoc = locations[i].validLocations) !== null && _locations$i$validLoc !== void 0 && _locations$i$validLoc.length) {
        var validLocations = locations[i].validLocations;

        for (var j = 0; j < validLocations.length; j += 1) {
          if (validLocations[j].isIncluded && includedLocation || !validLocations[j].isIncluded && !includedLocation) {
            locationIds.push(validLocations[j].locationId);
          }
        }
      }
    }

    return locationIds;
  };

  var convertToNumberArray = useCallback(function (str) {
    return getCommaSeparatedIds(str).map(function (idVal) {
      return Number(idVal);
    });
  }, [getCommaSeparatedIds]);
  var location = useMemo(function () {
    return _objectSpread$s(_objectSpread$s({
      countryId: campaign !== null && campaign !== void 0 && campaign.countryId ? Number(campaign === null || campaign === void 0 ? void 0 : campaign.countryId) : undefined,
      scrollBarWidth: scrollBarWidth,
      locationFileIds: campaign !== null && campaign !== void 0 && campaign.locationDetails ? Object.keys(campaign === null || campaign === void 0 ? void 0 : campaign.locationDetails).map(function (idVal) {
        return Number(idVal);
      }) : []
    }, parentApp ? {
      parentApp: parentApp
    } : {}), {}, {
      stateIds: campaign === null || campaign === void 0 ? void 0 : campaign.stateIds,
      excluded: {
        zipCodes: campaign !== null && campaign !== void 0 && campaign.blackListedZipcodes ? getCommaSeparatedIds(campaign === null || campaign === void 0 ? void 0 : campaign.blackListedZipcodes) : [],
        customAreas: campaign === null || campaign === void 0 ? void 0 : campaign.blackListedGeoRadiusDetails,
        locationIds: campaign !== null && campaign !== void 0 && campaign.locationDetails ? getIncludeExcludeLocationIds(campaign === null || campaign === void 0 ? void 0 : campaign.locationDetails, false) : [],
        stateHouses: campaign !== null && campaign !== void 0 && campaign.blackListedHouseDistrictIds ? convertToNumberArray(campaign === null || campaign === void 0 ? void 0 : campaign.blackListedHouseDistrictIds) : [],
        congressionalDistricts: campaign !== null && campaign !== void 0 && campaign.blackListedCongressionalDistrictIds ? convertToNumberArray(campaign === null || campaign === void 0 ? void 0 : campaign.blackListedCongressionalDistrictIds) : [],
        cities: campaign !== null && campaign !== void 0 && campaign.blackListedCityIds ? convertToNumberArray(campaign === null || campaign === void 0 ? void 0 : campaign.blackListedCityIds) : [],
        stateSenates: campaign !== null && campaign !== void 0 && campaign.blackListedSenateDistrictIds ? convertToNumberArray(campaign === null || campaign === void 0 ? void 0 : campaign.blackListedSenateDistrictIds) : [],
        counties: campaign !== null && campaign !== void 0 && campaign.blackListedCountyIds ? convertToNumberArray(campaign === null || campaign === void 0 ? void 0 : campaign.blackListedCountyIds) : [],
        dmaIds: campaign !== null && campaign !== void 0 && campaign.blackListedDmaIds ? convertToNumberArray(campaign === null || campaign === void 0 ? void 0 : campaign.blackListedDmaIds) : []
      },
      included: {
        zipCodes: campaign !== null && campaign !== void 0 && campaign.whiteListedZipcodes ? getCommaSeparatedIds(campaign === null || campaign === void 0 ? void 0 : campaign.whiteListedZipcodes) : [],
        customAreas: campaign === null || campaign === void 0 ? void 0 : campaign.whiteListedGeoRadiusDetails,
        locationIds: campaign !== null && campaign !== void 0 && campaign.locationDetails ? getIncludeExcludeLocationIds(campaign === null || campaign === void 0 ? void 0 : campaign.locationDetails, true) : [],
        stateHouses: campaign !== null && campaign !== void 0 && campaign.whiteListedHouseDistrictIds ? convertToNumberArray(campaign === null || campaign === void 0 ? void 0 : campaign.whiteListedHouseDistrictIds) : [],
        congressionalDistricts: campaign !== null && campaign !== void 0 && campaign.whiteListedCongressionalDistrictIds ? convertToNumberArray(campaign === null || campaign === void 0 ? void 0 : campaign.whiteListedCongressionalDistrictIds) : [],
        cities: campaign !== null && campaign !== void 0 && campaign.whiteListedCityIds ? convertToNumberArray(campaign === null || campaign === void 0 ? void 0 : campaign.whiteListedCityIds) : [],
        stateSenates: campaign !== null && campaign !== void 0 && campaign.whiteListedSenateDistrictIds ? convertToNumberArray(campaign === null || campaign === void 0 ? void 0 : campaign.whiteListedSenateDistrictIds) : [],
        counties: campaign !== null && campaign !== void 0 && campaign.whiteListedCountyIds ? convertToNumberArray(campaign === null || campaign === void 0 ? void 0 : campaign.whiteListedCountyIds) : [],
        dmaIds: campaign !== null && campaign !== void 0 && campaign.whiteListedDmaIds ? convertToNumberArray(campaign === null || campaign === void 0 ? void 0 : campaign.whiteListedDmaIds) : []
      },
      filterStore: {
        country: countriesList === null || countriesList === void 0 ? void 0 : countriesList.filter(function (country) {
          return country.value === Number(campaign === null || campaign === void 0 ? void 0 : campaign.countryId);
        })[0],
        locationDetails: campaign === null || campaign === void 0 ? void 0 : campaign.locationDetails
      }
    });
  }, [campaign, getCommaSeparatedIds, statesList, countriesList, joinByComma, convertToNumberArray]);

  var getCampaignUrl = function getCampaignUrl(mapType) {
    var CAMPAIGN_URL = '/campaigns';
    var origin = isLocalhost() ? "http://localhost:".concat(process.env.REACT_APP_CAMPAIGN_APP_LOCAL_PORT) : "".concat(CAMPAIGN_URL, "/u/").concat(getPathNumber());
    return "".concat(origin, "/#/apps/").concat(mapType);
  };

  var isAllLocationInfoAvailable = function isAllLocationInfoAvailable() {
    var isAllDetailsAvailable = true;

    if (campaign !== null && campaign !== void 0 && campaign.countryId && !countriesList.length) {
      isAllDetailsAvailable = false;
    }

    return isAllDetailsAvailable;
  };

  useEffect(function () {
    if (mapNode && location && isAllLocationInfoAvailable() && !iFrameEstablished.current) {
      iFrameEstablished.current = true;

      var initHandShake = /*#__PURE__*/function () {
        var _ref = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee() {
          return regenerator.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  _context.next = 2;
                  return new Postmate({
                    container: mapNode,
                    url: getCampaignUrl('maps-with-tabs'),
                    name: 'location-block',
                    classListArray: [styles$p.iframeSize]
                  });

                case 2:
                  mapRef.current = _context.sent;

                case 3:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee);
        }));

        return function initHandShake() {
          return _ref.apply(this, arguments);
        };
      }();

      initHandShake().then(function () {
        var _mapRef$current;

        return mapRef === null || mapRef === void 0 ? void 0 : (_mapRef$current = mapRef.current) === null || _mapRef$current === void 0 ? void 0 : _mapRef$current.call('initStore', JSON.stringify(location));
      });
      return function () {
        var _mapRef$current2, _mapRef$current2$dest;

        return mapRef === null || mapRef === void 0 ? void 0 : (_mapRef$current2 = mapRef.current) === null || _mapRef$current2 === void 0 ? void 0 : (_mapRef$current2$dest = _mapRef$current2.destroy) === null || _mapRef$current2$dest === void 0 ? void 0 : _mapRef$current2$dest.call(_mapRef$current2);
      };
    }

    return function () {};
  }, [location, mapNode]);
  var fetchStateOptions = useCallback( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee2() {
    var res;
    return regenerator.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return fetchStates({
              segmentIds: campaign.stateIds.split(',').map(function (stateId) {
                return Number(stateId);
              })
            }, onFetchStatesError);

          case 2:
            res = _context2.sent;

            if (res) {
              setStatesList(res);
            }

          case 4:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  })), [onFetchStatesError]);
  var fetchCountryOptions = useCallback( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee3() {
    var res;
    return regenerator.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            _context3.next = 2;
            return fetchCountries({
              segmentIds: [Number(campaign.countryId)]
            }, onFetchCountriesError);

          case 2:
            res = _context3.sent;

            if (res) {
              setCountriesList(res);
            }

          case 4:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  })), [onFetchCountriesError]);
  useEffect(function () {
    if (campaign !== null && campaign !== void 0 && campaign.stateIds && campaign !== null && campaign !== void 0 && campaign.countryId) {
      fetchStateOptions();
    } // eslint-disable-next-line react-hooks/exhaustive-deps

  }, [campaign]);
  useEffect(function () {
    if (campaign !== null && campaign !== void 0 && campaign.countryId) {
      fetchCountryOptions();
    } // eslint-disable-next-line react-hooks/exhaustive-deps

  }, [campaign]);

  var getStrLabelFromValue = function getStrLabelFromValue(list, value) {
    return intersectionWith(list, value.split(','), function (a, b) {
      return "".concat(a.value) === b;
    }).map(function (item) {
      return item.label;
    }).join(', ');
  };

  var countriesLabel = useMemo(function () {
    return campaign !== null && campaign !== void 0 && campaign.countryId ? getStrLabelFromValue(countriesList, campaign === null || campaign === void 0 ? void 0 : campaign.countryId) : '';
  }, [campaign, countriesList]);
  var statesLabel = useMemo(function () {
    return statesList.length && campaign.stateIds ? getStrLabelFromValue(statesList, (campaign === null || campaign === void 0 ? void 0 : campaign.stateIds).split(',').slice(0, 2).join()) : '';
  }, [statesList, campaign]);

  var getOtherHeaderLabel = function getOtherHeaderLabel() {
    var result = '';

    var addCommaIfNeeded = function addCommaIfNeeded() {
      if (result.length) {
        result += ', ';
      }
    };

    if (campaign !== null && campaign !== void 0 && campaign.blackListedZipcodes || campaign !== null && campaign !== void 0 && campaign.whiteListedZipcodes) {
      result += "ZipCode (".concat(getCommaSeparatedIds(joinByComma(campaign === null || campaign === void 0 ? void 0 : campaign.blackListedZipcodes, campaign === null || campaign === void 0 ? void 0 : campaign.whiteListedZipcodes)).length, ")");
    }

    if (campaign !== null && campaign !== void 0 && campaign.whiteListedDmaIds || campaign !== null && campaign !== void 0 && campaign.blackListedDmaIds) {
      addCommaIfNeeded();
      result += "DMA (".concat(getCommaSeparatedIds(joinByComma(campaign === null || campaign === void 0 ? void 0 : campaign.whiteListedDmaIds, campaign === null || campaign === void 0 ? void 0 : campaign.blackListedDmaIds)).length, ")");
    }

    if (campaign !== null && campaign !== void 0 && campaign.blackListedHouseDistrictIds || campaign !== null && campaign !== void 0 && campaign.whiteListedHouseDistrictIds) {
      addCommaIfNeeded();
      result += "State House (".concat(getCommaSeparatedIds(joinByComma(campaign === null || campaign === void 0 ? void 0 : campaign.blackListedHouseDistrictIds, campaign === null || campaign === void 0 ? void 0 : campaign.whiteListedHouseDistrictIds)).length, ")");
    }

    if (campaign !== null && campaign !== void 0 && campaign.blackListedGeoRadiusDetails || campaign !== null && campaign !== void 0 && campaign.whiteListedGeoRadiusDetails) {
      addCommaIfNeeded();
      result += "Custom Area (".concat(((campaign === null || campaign === void 0 ? void 0 : campaign.blackListedGeoRadiusDetails) || []).concat((campaign === null || campaign === void 0 ? void 0 : campaign.whiteListedGeoRadiusDetails) || []).length, ")");
    }

    if (campaign !== null && campaign !== void 0 && campaign.blackListedCongressionalDistrictIds || campaign !== null && campaign !== void 0 && campaign.whiteListedCongressionalDistrictIds) {
      addCommaIfNeeded();
      result += "Congressional District (".concat(getCommaSeparatedIds(joinByComma(campaign === null || campaign === void 0 ? void 0 : campaign.blackListedCongressionalDistrictIds, campaign === null || campaign === void 0 ? void 0 : campaign.whiteListedCongressionalDistrictIds)).length, ")");
    }

    if (campaign !== null && campaign !== void 0 && campaign.blackListedSenateDistrictIds || campaign !== null && campaign !== void 0 && campaign.whiteListedSenateDistrictIds) {
      addCommaIfNeeded();
      result += "State Senate (".concat(getCommaSeparatedIds(joinByComma(campaign === null || campaign === void 0 ? void 0 : campaign.blackListedSenateDistrictIds, campaign === null || campaign === void 0 ? void 0 : campaign.whiteListedSenateDistrictIds)).length, ")");
    }

    if (campaign !== null && campaign !== void 0 && campaign.locationDetails && Object.values(campaign.locationDetails).length) {
      addCommaIfNeeded();
      var addressCount = 0;
      Object.values(campaign === null || campaign === void 0 ? void 0 : campaign.locationDetails).forEach(function (file) {
        var _file$validLocations;

        addressCount += ((_file$validLocations = file.validLocations) === null || _file$validLocations === void 0 ? void 0 : _file$validLocations.length) || 0;
      });
      result += "Address (".concat(addressCount, ")");
    }

    return result;
  };

  return /*#__PURE__*/React__default.createElement(CollapsibleBlock, {
    customStyle: {
      block: styles$p.section,
      blockTitleText: styles$p.blockTitleText,
      summaryContainer: styles$p.summaryContainer,
      summaryLabel: styles$p.summaryLabel,
      summaryValue: styles$p.summaryValue,
      panelHeaderExpand: styles$p.panelHeaderExpand,
      panelHeaderCollapse: styles$p.panelHeaderCollapse
    },
    header: {
      title: /*#__PURE__*/React__default.createElement("div", {
        className: styles$p.title
      }, /*#__PURE__*/React__default.createElement(Icon, {
        name: "CampaignsLocation"
      }), /*#__PURE__*/React__default.createElement(React__default.Fragment, null, "Location")),
      summary: {
        Country: countriesLabel || '',
        States: campaign !== null && campaign !== void 0 && campaign.stateIds && campaign.stateIds.split(',').length > 2 ? "".concat(statesLabel, ", ...") : statesLabel,
        Other: getOtherHeaderLabel()
      }
    },
    id: "location",
    isCollapseOpen: isBlockOpen,
    onToggle: onToggle,
    collapsible: true
  }, campaign.stateIds || getOtherHeaderLabel() ? /*#__PURE__*/React__default.createElement("div", {
    ref: function ref(divRef) {
      return setMapNode(divRef);
    },
    className: styles$p.mapBoxContainer
  }) : /*#__PURE__*/React__default.createElement("div", {
    className: styles$p.emptySection
  }, /*#__PURE__*/React__default.createElement("img", {
    className: styles$p.image,
    alt: "",
    src: "".concat(SVG_HOST_URL, "/misc/empty-section-teal.svg")
  }), /*#__PURE__*/React__default.createElement("div", {
    className: styles$p.text
  }, "No Locations assigned yet"), /*#__PURE__*/React__default.createElement("div", {
    className: styles$p.subText
  }, "Click on edit to assign location targeting for the campaign")));
};

var css_248z$t = ":root {\n  --primary1: #123787;\n  --primary2: #1d58d7;\n  --primary3: #5173fb;\n  --primary4: #7a93ff;\n  --primary5: #c2d0ff;\n  --primary6: #e5ebff;\n  --primary7: #f2f5ff; }\n\n@keyframes index-module_hover-ripples__PRkUt {\n  0% {\n    top: -0.1875em;\n    left: -0.1875em;\n    right: -0.1875em;\n    bottom: -0.1875em;\n    opacity: 1; }\n  100% {\n    top: -0.8125em;\n    left: -0.8125em;\n    right: -0.8125em;\n    bottom: -0.8125em;\n    opacity: 0; } }\n\n.index-module_listItem__1_23W {\n  display: flex;\n  margin-bottom: 0.4375rem;\n  align-items: center; }\n\n.index-module_listTitle__1UiWT {\n  font-family: 'Avenir Next Regular', sans-serif;\n  font-weight: normal;\n  letter-spacing: .2px;\n  color: #666666;\n  font-size: 0.75rem;\n  line-height: 1;\n  letter-spacing: 0.0125rem;\n  margin-right: 0.25rem; }\n\n.index-module_listValue__1xo_Q {\n  font-family: 'Avenir Next Regular', sans-serif;\n  font-weight: normal;\n  letter-spacing: .2px;\n  color: #000000;\n  font-size: 0.75rem;\n  line-height: 1rem; }\n\n.index-module_blockTitleText__EpoXM {\n  font-family: 'Avenir Next Demi', sans-serif;\n  font-weight: normal;\n  font-size: 1rem;\n  line-height: 1.5em;\n  min-width: 6.25rem;\n  margin-right: 1rem;\n  display: flex; }\n\n.index-module_panelHeaderCollapse__1FSsJ {\n  padding: 0;\n  cursor: pointer; }\n\n.index-module_panelHeaderExpand__4mTwm {\n  padding: 0;\n  cursor: pointer;\n  margin-bottom: 1rem; }\n\n.index-module_summaryContainer__2uTNy {\n  margin-right: 1rem;\n  display: inline; }\n\n.index-module_summaryLabel__1Qd1e {\n  font-family: 'Avenir Next Regular', sans-serif;\n  font-weight: normal;\n  letter-spacing: .2px;\n  color: #a2a2a2;\n  font-size: 0.75rem;\n  line-height: 1;\n  letter-spacing: 0.0125rem; }\n\n.index-module_summaryValue__1jUSv {\n  font-family: 'Avenir Next Regular', sans-serif;\n  font-weight: normal;\n  letter-spacing: .2px;\n  font-size: 0.75rem;\n  line-height: 1;\n  letter-spacing: 0.0125rem; }\n\n.index-module_section__1uIEV {\n  display: flex;\n  flex-direction: column;\n  padding-top: 1rem;\n  padding-left: 1.5rem;\n  width: 57.4375rem;\n  padding-right: 1.5rem;\n  margin-bottom: 0.9375rem;\n  padding-bottom: 1rem;\n  border-radius: 0.25rem !important;\n  box-shadow: 0 0.25rem 0.375rem rgba(0, 0, 0, 0.05), 0 0 0.5rem rgba(0, 0, 0, 0.04); }\n  .index-module_section__1uIEV .index-module_title__1FIqR {\n    font-family: 'Avenir Next Demi', sans-serif;\n    font-weight: normal;\n    font-weight: 600;\n    font-size: 0.875rem;\n    line-height: 1.125rem;\n    margin: auto 0 auto 0;\n    display: flex;\n    align-items: center; }\n    .index-module_section__1uIEV .index-module_title__1FIqR .svg-icon {\n      margin-right: 0.25rem; }\n      .index-module_section__1uIEV .index-module_title__1FIqR .svg-icon path {\n        fill: var(--primary2); }\n\n.index-module_emptySection__O9qBj {\n  display: flex;\n  align-items: center;\n  flex-direction: column; }\n  .index-module_emptySection__O9qBj img {\n    margin-bottom: 0.5rem;\n    width: 15.625rem;\n    height: 12.3125rem; }\n  .index-module_emptySection__O9qBj .index-module_text__AC-Df {\n    font-family: 'Avenir Next Demi', sans-serif;\n    font-weight: normal;\n    font-style: normal;\n    font-weight: 600;\n    font-size: 0.875rem;\n    line-height: 1;\n    color: #000000;\n    letter-spacing: 0.00625rem;\n    margin-bottom: 0.25rem; }\n  .index-module_emptySection__O9qBj .index-module_subText__aGdCO {\n    font-family: 'Avenir Next Regular', sans-serif;\n    font-weight: normal;\n    font-style: normal;\n    font-weight: 400;\n    font-size: 0.8125rem;\n    line-height: 1;\n    color: #000000;\n    letter-spacing: 0.00625rem; }\n";
var styles$q = {"listItem":"index-module_listItem__1_23W","listTitle":"index-module_listTitle__1UiWT","listValue":"index-module_listValue__1xo_Q","blockTitleText":"index-module_blockTitleText__EpoXM","panelHeaderCollapse":"index-module_panelHeaderCollapse__1FSsJ","panelHeaderExpand":"index-module_panelHeaderExpand__4mTwm","summaryContainer":"index-module_summaryContainer__2uTNy","summaryLabel":"index-module_summaryLabel__1Qd1e","summaryValue":"index-module_summaryValue__1jUSv","section":"index-module_section__1uIEV","title":"index-module_title__1FIqR","emptySection":"index-module_emptySection__O9qBj","text":"index-module_text__AC-Df","subText":"index-module_subText__aGdCO","hover-ripples":"index-module_hover-ripples__PRkUt"};
styleInject(css_248z$t);

var CampaignTechnology = function CampaignTechnology(_ref) {
  var campaign = _ref.campaign,
      isBlockOpen = _ref.isBlockOpen,
      onToggle = _ref.onToggle,
      onFetchDeviceTypesError = _ref.onFetchDeviceTypesError,
      onFetchManufacturersError = _ref.onFetchManufacturersError,
      onFetchCarriersError = _ref.onFetchCarriersError,
      onFetchNetworkTypesError = _ref.onFetchNetworkTypesError,
      onFetchTrafficTypesError = _ref.onFetchTrafficTypesError,
      onFetchOSsErrors = _ref.onFetchOSsErrors;

  var _useState = useState$2([]),
      _useState2 = _slicedToArray(_useState, 2),
      getSelectedValuesDeviceTypes = _useState2[0],
      setSelectedDeviceTypes = _useState2[1];

  var _useState3 = useState$2([]),
      _useState4 = _slicedToArray(_useState3, 2),
      getSelectedValuesManufacturers = _useState4[0],
      setSelectedManufacturers = _useState4[1];

  var _useState5 = useState$2([]),
      _useState6 = _slicedToArray(_useState5, 2),
      getSelectedValuesOS = _useState6[0],
      setSelectedOS = _useState6[1];

  var _useState7 = useState$2([]),
      _useState8 = _slicedToArray(_useState7, 2),
      getSelectedValuesTrafficTypes = _useState8[0],
      setSelectedTrafficTpes = _useState8[1];

  var _useState9 = useState$2([]),
      _useState10 = _slicedToArray(_useState9, 2),
      getSelectedValuesCarriersList = _useState10[0],
      setSelectedCarriersList = _useState10[1];

  var _useState11 = useState$2([]),
      _useState12 = _slicedToArray(_useState11, 2),
      getSelectedValuesNetworkTypes = _useState12[0],
      setSelectedNetworkTypes = _useState12[1];

  var getSelectedValues = function getSelectedValues(values, arr) {
    return values.reduce(function (acc, value) {
      var option = arr.find(function (item) {
        return item.value === value;
      });

      if (option) {
        acc.push(option);
      }

      return acc;
    }, []);
  };

  useEffect(function () {
    var _campaign$deviceType2;

    var fetchDeviceTypeList = /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee() {
        var _campaign$deviceType;

        var deviceTypesList;
        return regenerator.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return fetchDeviceTypes(onFetchDeviceTypesError);

              case 2:
                deviceTypesList = _context.sent;
                setSelectedDeviceTypes(getSelectedValues((_campaign$deviceType = campaign.deviceType) === null || _campaign$deviceType === void 0 ? void 0 : _campaign$deviceType.split(',').map(function (item) {
                  return +item;
                }), deviceTypesList));

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function fetchDeviceTypeList() {
        return _ref2.apply(this, arguments);
      };
    }();

    if ((_campaign$deviceType2 = campaign.deviceType) !== null && _campaign$deviceType2 !== void 0 && _campaign$deviceType2.length) {
      fetchDeviceTypeList();
    } // eslint-disable-next-line react-hooks/exhaustive-deps

  }, [campaign]);
  useEffect(function () {
    var _campaign$manufacture2;

    var fetchManufacturersList = /*#__PURE__*/function () {
      var _ref3 = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee2() {
        var _campaign$manufacture;

        var manufacturersList;
        return regenerator.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return fetchManufacturers(onFetchManufacturersError);

              case 2:
                manufacturersList = _context2.sent;
                setSelectedManufacturers(getSelectedValues((_campaign$manufacture = campaign.manufacturer) === null || _campaign$manufacture === void 0 ? void 0 : _campaign$manufacture.split(',').map(function (item) {
                  return +item;
                }), manufacturersList));

              case 4:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      return function fetchManufacturersList() {
        return _ref3.apply(this, arguments);
      };
    }();

    if ((_campaign$manufacture2 = campaign.manufacturer) !== null && _campaign$manufacture2 !== void 0 && _campaign$manufacture2.length) {
      fetchManufacturersList();
    } // eslint-disable-next-line react-hooks/exhaustive-deps

  }, [campaign]);
  useEffect(function () {
    var _campaign$carriers2;

    var fetchCarrierList = /*#__PURE__*/function () {
      var _ref4 = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee3() {
        var _campaign$carriers;

        var carriersList;
        return regenerator.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return fetchCarriers(onFetchCarriersError, campaign.carriers);

              case 2:
                carriersList = _context3.sent;
                setSelectedCarriersList(getSelectedValues((_campaign$carriers = campaign.carriers) === null || _campaign$carriers === void 0 ? void 0 : _campaign$carriers.split(',').map(function (item) {
                  return +item;
                }), carriersList));

              case 4:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));

      return function fetchCarrierList() {
        return _ref4.apply(this, arguments);
      };
    }();

    if ((_campaign$carriers2 = campaign.carriers) !== null && _campaign$carriers2 !== void 0 && _campaign$carriers2.length) {
      fetchCarrierList();
    } // eslint-disable-next-line react-hooks/exhaustive-deps

  }, [campaign]);
  useEffect(function () {
    var _campaign$networkType2;

    var fetchNetworkTypeList = /*#__PURE__*/function () {
      var _ref5 = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee4() {
        var _campaign$networkType;

        var networkTypesList;
        return regenerator.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return fetchNetworkTypes(onFetchNetworkTypesError);

              case 2:
                networkTypesList = _context4.sent;
                setSelectedNetworkTypes(getSelectedValues((_campaign$networkType = campaign.networkType) === null || _campaign$networkType === void 0 ? void 0 : _campaign$networkType.split(',').map(function (item) {
                  return +item;
                }), networkTypesList));

              case 4:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }));

      return function fetchNetworkTypeList() {
        return _ref5.apply(this, arguments);
      };
    }();

    if ((_campaign$networkType2 = campaign.networkType) !== null && _campaign$networkType2 !== void 0 && _campaign$networkType2.length) {
      fetchNetworkTypeList();
    } // eslint-disable-next-line react-hooks/exhaustive-deps

  }, [campaign]);
  useEffect(function () {
    var _campaign$trafficType2;

    var fetchTrafficTypeList = /*#__PURE__*/function () {
      var _ref6 = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee5() {
        var _campaign$trafficType;

        var trafficTypesList;
        return regenerator.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.next = 2;
                return fetchTrafficTypes(onFetchTrafficTypesError);

              case 2:
                trafficTypesList = _context5.sent;
                setSelectedTrafficTpes(getSelectedValues((_campaign$trafficType = campaign.trafficType) === null || _campaign$trafficType === void 0 ? void 0 : _campaign$trafficType.split(',').map(function (item) {
                  return +item;
                }), trafficTypesList));

              case 4:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5);
      }));

      return function fetchTrafficTypeList() {
        return _ref6.apply(this, arguments);
      };
    }();

    if ((_campaign$trafficType2 = campaign.trafficType) !== null && _campaign$trafficType2 !== void 0 && _campaign$trafficType2.length) {
      fetchTrafficTypeList();
    } // eslint-disable-next-line react-hooks/exhaustive-deps

  }, [campaign]);
  useEffect(function () {
    var _campaign$os2;

    var fetchSelectedOSList = /*#__PURE__*/function () {
      var _ref7 = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee6() {
        var _campaign$os;

        var oSList;
        return regenerator.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.next = 2;
                return fetchOs(onFetchOSsErrors);

              case 2:
                oSList = _context6.sent;
                setSelectedOS(getSelectedValues((_campaign$os = campaign.os) === null || _campaign$os === void 0 ? void 0 : _campaign$os.split(',').map(function (item) {
                  return +item;
                }), oSList));

              case 4:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6);
      }));

      return function fetchSelectedOSList() {
        return _ref7.apply(this, arguments);
      };
    }();

    if ((_campaign$os2 = campaign.os) !== null && _campaign$os2 !== void 0 && _campaign$os2.length) {
      fetchSelectedOSList();
    } // eslint-disable-next-line react-hooks/exhaustive-deps

  }, [campaign]);

  var joinByComma = function joinByComma(values) {
    return values.map(function (value) {
      return value.label;
    }).join(', ');
  };

  var deviceTypeStr = joinByComma(getSelectedValuesDeviceTypes);
  var manufacturerStr = joinByComma(getSelectedValuesManufacturers);
  var osStr = joinByComma(getSelectedValuesOS);
  var networkTypeStr = joinByComma(getSelectedValuesNetworkTypes);
  var carrierStr = joinByComma(getSelectedValuesCarriersList);
  var trafficTypeStr = joinByComma(getSelectedValuesTrafficTypes);

  var getClippedValues = function getClippedValues(getSelectedValuesValues) {
    return getSelectedValuesValues.length > 5 ? getSelectedValuesValues.slice(0, 5).map(function (i) {
      return i.label;
    }).join(', ').concat(" and ".concat(getSelectedValuesValues.length - 5, " more")) : getSelectedValuesValues.map(function (i) {
      return i.label;
    }).join(', ');
  };

  var getListItem = function getListItem(title, value, toolTipValue) {
    return /*#__PURE__*/React__default.createElement("div", {
      className: styles$q.listItem
    }, /*#__PURE__*/React__default.createElement("div", {
      className: styles$q.listTitle
    }, title, ":"), /*#__PURE__*/React__default.createElement("div", {
      className: styles$q.listValue
    }, /*#__PURE__*/React__default.createElement(Tooltip, {
      portal: true,
      label: toolTipValue
    }, value)));
  };

  var listItems = [].concat(_toConsumableArray(deviceTypeStr ? [{
    element: getListItem('Device Type', getClippedValues(getSelectedValuesDeviceTypes), deviceTypeStr),
    key: 'deviceType'
  }] : []), _toConsumableArray(manufacturerStr ? [{
    element: getListItem('Manufacturer', getClippedValues(getSelectedValuesManufacturers), manufacturerStr),
    key: 'manufacturer'
  }] : []), _toConsumableArray(osStr ? [{
    element: getListItem('Operating System', getClippedValues(getSelectedValuesOS), osStr),
    key: 'os'
  }] : []), _toConsumableArray(carrierStr ? [{
    element: getListItem('Carrier', getClippedValues(getSelectedValuesCarriersList), carrierStr),
    key: 'carrier'
  }] : []), _toConsumableArray(networkTypeStr ? [{
    element: getListItem('Network Type', getClippedValues(getSelectedValuesNetworkTypes), networkTypeStr),
    key: 'networkType'
  }] : []), _toConsumableArray(trafficTypeStr ? [{
    element: getListItem('Traffic Type', getClippedValues(getSelectedValuesTrafficTypes), trafficTypeStr),
    key: 'trafficType'
  }] : []));
  var isSectionEmpty = !campaign.deviceType && !campaign.manufacturer && !campaign.carriers && !campaign.networkType && !campaign.trafficType && !campaign.os;
  return /*#__PURE__*/React__default.createElement(CollapsibleBlock, {
    customStyle: {
      block: styles$q.section,
      blockTitleText: styles$q.blockTitleText,
      summaryContainer: styles$q.summaryContainer,
      summaryLabel: styles$q.summaryLabel,
      summaryValue: styles$q.summaryValue,
      panelHeaderExpand: styles$q.panelHeaderExpand,
      panelHeaderCollapse: styles$q.panelHeaderCollapse
    },
    id: "technology",
    header: {
      title: /*#__PURE__*/React__default.createElement("div", {
        className: styles$q.title
      }, /*#__PURE__*/React__default.createElement(Icon, {
        name: 'CampaignsTechnology'
      }), /*#__PURE__*/React__default.createElement("div", null, "Technology")),
      summary: {
        'Device Type': truncate$1$1(deviceTypeStr),
        Manufacturer: truncate$1$1(manufacturerStr),
        OS: truncate$1$1(osStr),
        'Network Type': truncate$1$1(networkTypeStr),
        Carrier: truncate$1$1(carrierStr),
        Channel: truncate$1$1(trafficTypeStr)
      }
    },
    isCollapseOpen: isBlockOpen,
    onToggle: onToggle,
    collapsible: true
  }, !isSectionEmpty ? /*#__PURE__*/React__default.createElement(DisplayItems, {
    type: "list",
    items: listItems,
    listClassName: styles$q.list
  }) : /*#__PURE__*/React__default.createElement("div", {
    className: styles$q.emptySection
  }, /*#__PURE__*/React__default.createElement("img", {
    className: styles$q.image,
    alt: "",
    src: "".concat(SVG_HOST_URL, "/misc/empty-section-teal.svg")
  }), /*#__PURE__*/React__default.createElement("div", {
    className: styles$q.text
  }, "No Technology assigned yet"), /*#__PURE__*/React__default.createElement("div", {
    className: styles$q.subText
  }, "Click on edit to assign technology targeting for the campaign")));
};

var css_248z$u = ":root {\n  --primary1: #123787;\n  --primary2: #1d58d7;\n  --primary3: #5173fb;\n  --primary4: #7a93ff;\n  --primary5: #c2d0ff;\n  --primary6: #e5ebff;\n  --primary7: #f2f5ff; }\n\n@keyframes index-module_hover-ripples__1hu67 {\n  0% {\n    top: -0.1875em;\n    left: -0.1875em;\n    right: -0.1875em;\n    bottom: -0.1875em;\n    opacity: 1; }\n  100% {\n    top: -0.8125em;\n    left: -0.8125em;\n    right: -0.8125em;\n    bottom: -0.8125em;\n    opacity: 0; } }\n\n.index-module_blockTitleText__3QQFi {\n  font-family: 'Avenir Next Demi', sans-serif;\n  font-weight: normal;\n  font-size: 1rem;\n  line-height: 1.5em;\n  min-width: 7rem;\n  display: flex; }\n\n.index-module_panelHeaderCollapse__3z-Y7 {\n  padding: 0;\n  cursor: pointer; }\n\n.index-module_panelHeaderExpand__1Sk6W {\n  padding: 0;\n  cursor: pointer;\n  margin-bottom: 1rem; }\n\n.index-module_summaryContainer__2jFPi {\n  margin-right: 1rem;\n  display: inline; }\n\n.index-module_summaryLabel__3I5Jt {\n  font-family: 'Avenir Next Regular', sans-serif;\n  font-weight: normal;\n  letter-spacing: .2px;\n  color: #a2a2a2;\n  font-size: 0.75rem;\n  line-height: 1;\n  letter-spacing: 0.0125rem; }\n\n.index-module_summaryValue__1cpQd {\n  font-family: 'Avenir Next Regular', sans-serif;\n  font-weight: normal;\n  letter-spacing: .2px;\n  font-size: 0.75rem;\n  line-height: 1;\n  letter-spacing: 0.0125rem; }\n\n.index-module_grid__1WrtY {\n  width: 100%;\n  margin-bottom: 1.25rem; }\n\n.index-module_gridItem__2G63J:last-of-type [class*='scheduleContainer'] {\n  border: 0; }\n\n.index-module_scheduleContainer__1OQeI {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  border-right: 0.03125rem solid;\n  border-color: #cbcbcb;\n  height: 100%; }\n\n.index-module_scheduleDay__32YSO {\n  font-family: 'Avenir Next Regular', sans-serif;\n  font-weight: normal;\n  letter-spacing: .2px;\n  color: #000000;\n  font-size: 0.75rem;\n  line-height: 1rem; }\n\n.index-module_scheduleItem__2cmYy {\n  margin-bottom: 0.125rem; }\n\n.index-module_section__2Bvir {\n  display: flex;\n  flex-direction: column;\n  padding-top: 1rem;\n  padding-left: 1.5rem;\n  margin-bottom: 0.9375rem;\n  width: 57.4375rem;\n  padding-right: 1.5rem;\n  padding-bottom: 1rem;\n  border-radius: 0.25rem !important;\n  box-shadow: 0 0.25rem 0.375rem rgba(0, 0, 0, 0.05), 0 0 0.5rem rgba(0, 0, 0, 0.04); }\n  .index-module_section__2Bvir .index-module_title__G0167 {\n    font-family: 'Avenir Next Demi', sans-serif;\n    font-weight: normal;\n    font-weight: 600;\n    font-size: 0.875rem;\n    line-height: 1.125rem;\n    margin: auto 0 auto 0;\n    display: flex;\n    align-items: center; }\n    .index-module_section__2Bvir .index-module_title__G0167 .svg-icon {\n      margin-right: 0.25rem; }\n      .index-module_section__2Bvir .index-module_title__G0167 .svg-icon path {\n        fill: var(--primary2); }\n\n.index-module_emptySection__3URr3 {\n  display: flex;\n  align-items: center;\n  flex-direction: column; }\n  .index-module_emptySection__3URr3 img {\n    margin-bottom: 0.5rem;\n    width: 15.625rem;\n    height: 12.3125rem; }\n  .index-module_emptySection__3URr3 .index-module_text__7c0jy {\n    font-family: 'Avenir Next Demi', sans-serif;\n    font-weight: normal;\n    font-style: normal;\n    font-weight: 600;\n    font-size: 0.875rem;\n    line-height: 1;\n    color: #000000;\n    letter-spacing: 0.00625rem;\n    margin-bottom: 0.25rem; }\n  .index-module_emptySection__3URr3 .index-module_subText__60XW7 {\n    font-family: 'Avenir Next Regular', sans-serif;\n    font-weight: normal;\n    font-style: normal;\n    font-weight: 400;\n    font-size: 0.8125rem;\n    line-height: 1;\n    color: #000000;\n    letter-spacing: 0.00625rem; }\n";
var styles$r = {"blockTitleText":"index-module_blockTitleText__3QQFi","panelHeaderCollapse":"index-module_panelHeaderCollapse__3z-Y7","panelHeaderExpand":"index-module_panelHeaderExpand__1Sk6W","summaryContainer":"index-module_summaryContainer__2jFPi","summaryLabel":"index-module_summaryLabel__3I5Jt","summaryValue":"index-module_summaryValue__1cpQd","grid":"index-module_grid__1WrtY","gridItem":"index-module_gridItem__2G63J","scheduleContainer":"index-module_scheduleContainer__1OQeI","scheduleDay":"index-module_scheduleDay__32YSO","scheduleItem":"index-module_scheduleItem__2cmYy","section":"index-module_section__2Bvir","title":"index-module_title__G0167","emptySection":"index-module_emptySection__3URr3","text":"index-module_text__7c0jy","subText":"index-module_subText__60XW7","hover-ripples":"index-module_hover-ripples__1hu67"};
styleInject(css_248z$u);

function ownKeys$t(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$t(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$t(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$t(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var CampaignScheduling = function CampaignScheduling(_ref) {
  var _campaign$scheduling, _campaign$scheduling2, _campaign$scheduling3, _campaign$scheduling4, _campaign$scheduling5, _campaign$scheduling6, _campaign$scheduling7;

  var campaign = _ref.campaign,
      isBlockOpen = _ref.isBlockOpen,
      onToggle = _ref.onToggle;

  var getFormattedTime = function getFormattedTime(schedule) {
    var startTime = moment$1(schedule[0].substring(0, 2), ['HH']).format('hh a');
    var endTime = schedule[1] === '23:59:59' ? '12am' : moment$1(schedule[1].substring(0, 2), ['HH']).format('hh a');
    return "".concat(startTime, "-").concat(endTime).replace(/\s/g, '');
  };

  var fetchTimeSchedules = function fetchTimeSchedules(schedules) {
    return /*#__PURE__*/React__default.createElement("ul", null, schedules.map(function (schedule, idx) {
      return /*#__PURE__*/React__default.createElement("li", {
        key: idx
      }, /*#__PURE__*/React__default.createElement("div", {
        className: styles$r.scheduleItem
      }, /*#__PURE__*/React__default.createElement(Pill, {
        label: getFormattedTime(schedule)
      })));
    }));
  };

  var isTimeSchedulingPresent = campaign.scheduling && Object.keys(campaign.scheduling).length;
  var gridItems = [].concat(_toConsumableArray((_campaign$scheduling = campaign.scheduling) !== null && _campaign$scheduling !== void 0 && _campaign$scheduling[6] ? [{
    element: /*#__PURE__*/React__default.createElement("div", {
      className: styles$r.scheduleContainer
    }, /*#__PURE__*/React__default.createElement("div", {
      className: styles$r.scheduleDay
    }, "Sunday"), fetchTimeSchedules(campaign.scheduling[6])),
    key: 'sunday'
  }] : []), _toConsumableArray((_campaign$scheduling2 = campaign.scheduling) !== null && _campaign$scheduling2 !== void 0 && _campaign$scheduling2[0] ? [{
    element: /*#__PURE__*/React__default.createElement("div", {
      className: styles$r.scheduleContainer
    }, /*#__PURE__*/React__default.createElement("div", {
      className: styles$r.scheduleDay
    }, "Monday"), fetchTimeSchedules(campaign.scheduling[0])),
    key: 'monday'
  }] : []), _toConsumableArray((_campaign$scheduling3 = campaign.scheduling) !== null && _campaign$scheduling3 !== void 0 && _campaign$scheduling3[1] ? [{
    element: /*#__PURE__*/React__default.createElement("div", {
      className: styles$r.scheduleContainer
    }, /*#__PURE__*/React__default.createElement("div", {
      className: styles$r.scheduleDay
    }, "Tuesday"), fetchTimeSchedules(campaign.scheduling[1])),
    key: 'tuesday'
  }] : []), _toConsumableArray((_campaign$scheduling4 = campaign.scheduling) !== null && _campaign$scheduling4 !== void 0 && _campaign$scheduling4[2] ? [{
    element: /*#__PURE__*/React__default.createElement("div", {
      className: styles$r.scheduleContainer
    }, /*#__PURE__*/React__default.createElement("div", {
      className: styles$r.scheduleDay
    }, "Wednesday"), fetchTimeSchedules(campaign.scheduling[2])),
    key: 'wednesday'
  }] : []), _toConsumableArray((_campaign$scheduling5 = campaign.scheduling) !== null && _campaign$scheduling5 !== void 0 && _campaign$scheduling5[3] ? [{
    element: /*#__PURE__*/React__default.createElement("div", {
      className: styles$r.scheduleContainer
    }, /*#__PURE__*/React__default.createElement("div", {
      className: styles$r.scheduleDay
    }, "Thursday"), fetchTimeSchedules(campaign.scheduling[3])),
    key: 'thursday'
  }] : []), _toConsumableArray((_campaign$scheduling6 = campaign.scheduling) !== null && _campaign$scheduling6 !== void 0 && _campaign$scheduling6[4] ? [{
    element: /*#__PURE__*/React__default.createElement("div", {
      className: styles$r.scheduleContainer
    }, /*#__PURE__*/React__default.createElement("div", {
      className: styles$r.scheduleDay
    }, "Friday"), fetchTimeSchedules(campaign.scheduling[4])),
    key: 'friday'
  }] : []), _toConsumableArray((_campaign$scheduling7 = campaign.scheduling) !== null && _campaign$scheduling7 !== void 0 && _campaign$scheduling7[5] ? [{
    element: /*#__PURE__*/React__default.createElement("div", {
      className: styles$r.scheduleContainer
    }, /*#__PURE__*/React__default.createElement("div", {
      className: styles$r.scheduleDay
    }, "Saturday"), fetchTimeSchedules(campaign.scheduling[5])),
    key: 'saturday'
  }] : []));

  var getNumberOfIntervals = function getNumberOfIntervals() {
    var intervals = 0;
    Object.values(campaign.scheduling).forEach(function (intervalArr) {
      intervals += intervalArr.length;
    });
    return intervals;
  };

  return /*#__PURE__*/React__default.createElement(CollapsibleBlock, {
    customStyle: {
      block: styles$r.section,
      blockTitleText: styles$r.blockTitleText,
      summaryContainer: styles$r.summaryContainer,
      summaryLabel: styles$r.summaryLabel,
      summaryValue: styles$r.summaryValue,
      panelHeaderExpand: styles$r.panelHeaderExpand,
      panelHeaderCollapse: styles$r.panelHeaderCollapse
    },
    id: "scheduling",
    header: {
      title: /*#__PURE__*/React__default.createElement("div", {
        className: styles$r.title
      }, /*#__PURE__*/React__default.createElement(Icon, {
        name: "CampaignsTime"
      }), /*#__PURE__*/React__default.createElement(React__default.Fragment, null, "Scheduling")),
      summary: _objectSpread$t({}, campaign.scheduling ? {
        Scheduling: "".concat(getNumberOfIntervals(), " intervals selected")
      } : {})
    },
    isCollapseOpen: isBlockOpen,
    onToggle: onToggle,
    collapsible: true
  }, isTimeSchedulingPresent ? /*#__PURE__*/React__default.createElement(DisplayItems, {
    type: "grid",
    gridColumnCount: gridItems.length,
    gridClassName: styles$r.grid,
    items: gridItems,
    itemClassName: styles$r.gridItem
  }) : /*#__PURE__*/React__default.createElement("div", {
    className: styles$r.emptySection
  }, /*#__PURE__*/React__default.createElement("img", {
    className: styles$r.image,
    alt: "",
    src: "".concat(SVG_HOST_URL, "/misc/empty-section-teal.svg")
  }), /*#__PURE__*/React__default.createElement("div", {
    className: styles$r.text
  }, "No Scheduling assigned yet"), /*#__PURE__*/React__default.createElement("div", {
    className: styles$r.subText
  }, "Click on edit to assign scheduling targeting for the campaign")));
};

var css_248z$v = ":root {\n  --primary1: #123787;\n  --primary2: #1d58d7;\n  --primary3: #5173fb;\n  --primary4: #7a93ff;\n  --primary5: #c2d0ff;\n  --primary6: #e5ebff;\n  --primary7: #f2f5ff; }\n\n@keyframes index-module_hover-ripples__1GdsV {\n  0% {\n    top: -0.1875em;\n    left: -0.1875em;\n    right: -0.1875em;\n    bottom: -0.1875em;\n    opacity: 1; }\n  100% {\n    top: -0.8125em;\n    left: -0.8125em;\n    right: -0.8125em;\n    bottom: -0.8125em;\n    opacity: 0; } }\n\n.index-module_listItem__2TdeI {\n  display: flex;\n  margin-bottom: 0.4375rem;\n  align-items: center; }\n\n.index-module_listTitle__1Lwlv {\n  font-family: 'Avenir Next Regular', sans-serif;\n  font-weight: normal;\n  letter-spacing: .2px;\n  color: #666666;\n  font-size: 0.75rem;\n  line-height: 1;\n  letter-spacing: 0.0125rem;\n  margin-right: 0.25rem; }\n\n.index-module_listValue__3X8ZN {\n  font-family: 'Avenir Next Regular', sans-serif;\n  font-weight: normal;\n  letter-spacing: .2px;\n  color: #000000;\n  font-size: 0.75rem;\n  line-height: 1rem; }\n\n.index-module_blockTitleText__GQhG7 {\n  font-family: 'Avenir Next Demi', sans-serif;\n  font-weight: normal;\n  font-size: 1rem;\n  line-height: 1.5em;\n  min-width: 7.75rem;\n  margin-right: 1rem;\n  display: flex; }\n\n.index-module_panelHeaderCollapse__1gEpn {\n  padding: 0;\n  cursor: pointer; }\n\n.index-module_panelHeaderExpand___mLVm {\n  padding: 0;\n  cursor: pointer;\n  margin-bottom: 1rem; }\n\n.index-module_summaryContainer__24g-u {\n  margin-right: 1rem;\n  display: inline; }\n\n.index-module_summaryLabel__1IEke {\n  font-family: 'Avenir Next Regular', sans-serif;\n  font-weight: normal;\n  letter-spacing: .2px;\n  color: #a2a2a2;\n  font-size: 0.75rem;\n  line-height: 1;\n  letter-spacing: 0.0125rem; }\n\n.index-module_summaryValue__2F0Uf {\n  font-family: 'Avenir Next Regular', sans-serif;\n  font-weight: normal;\n  letter-spacing: .2px;\n  font-size: 0.75rem;\n  line-height: 1;\n  letter-spacing: 0.0125rem; }\n\n.index-module_section__N7Wot {\n  display: flex;\n  flex-direction: column;\n  padding-top: 1rem;\n  padding-left: 1.5rem;\n  margin-bottom: 0.9375rem;\n  width: 57.4375rem;\n  padding-right: 1.5rem;\n  padding-bottom: 1rem;\n  border-radius: 0.25rem !important;\n  box-shadow: 0 0.25rem 0.375rem rgba(0, 0, 0, 0.05), 0 0 0.5rem rgba(0, 0, 0, 0.04); }\n  .index-module_section__N7Wot .index-module_title__RSI98 {\n    font-family: 'Avenir Next Demi', sans-serif;\n    font-weight: normal;\n    font-weight: 600;\n    font-size: 0.875rem;\n    line-height: 1.125rem;\n    margin: auto 0 auto 0;\n    display: flex;\n    align-items: center; }\n    .index-module_section__N7Wot .index-module_title__RSI98 .svg-icon {\n      margin-right: 0.25rem; }\n      .index-module_section__N7Wot .index-module_title__RSI98 .svg-icon path {\n        fill: var(--primary2); }\n\n.index-module_emptySection__1VyDb {\n  display: flex;\n  align-items: center;\n  flex-direction: column; }\n  .index-module_emptySection__1VyDb img {\n    margin-bottom: 0.5rem;\n    width: 15.625rem;\n    height: 12.3125rem; }\n  .index-module_emptySection__1VyDb .index-module_text__KQmAE {\n    font-family: 'Avenir Next Demi', sans-serif;\n    font-weight: normal;\n    font-style: normal;\n    font-weight: 600;\n    font-size: 0.875rem;\n    line-height: 1;\n    color: #000000;\n    letter-spacing: 0.00625rem;\n    margin-bottom: 0.25rem; }\n  .index-module_emptySection__1VyDb .index-module_subText__2xXlH {\n    font-family: 'Avenir Next Regular', sans-serif;\n    font-weight: normal;\n    font-style: normal;\n    font-weight: 400;\n    font-size: 0.8125rem;\n    line-height: 1;\n    color: #000000;\n    letter-spacing: 0.00625rem; }\n";
var styles$s = {"listItem":"index-module_listItem__2TdeI","listTitle":"index-module_listTitle__1Lwlv","listValue":"index-module_listValue__3X8ZN","blockTitleText":"index-module_blockTitleText__GQhG7","panelHeaderCollapse":"index-module_panelHeaderCollapse__1gEpn","panelHeaderExpand":"index-module_panelHeaderExpand___mLVm","summaryContainer":"index-module_summaryContainer__24g-u","summaryLabel":"index-module_summaryLabel__1IEke","summaryValue":"index-module_summaryValue__2F0Uf","section":"index-module_section__N7Wot","title":"index-module_title__RSI98","emptySection":"index-module_emptySection__1VyDb","text":"index-module_text__KQmAE","subText":"index-module_subText__2xXlH","hover-ripples":"index-module_hover-ripples__1GdsV"};
styleInject(css_248z$v);

function ownKeys$u(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$u(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$u(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$u(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var CampaignDemographic = function CampaignDemographic(_ref) {
  var campaign = _ref.campaign,
      isBlockOpen = _ref.isBlockOpen,
      onToggle = _ref.onToggle,
      onFetchAgesError = _ref.onFetchAgesError,
      onFetchEthnicityGroupsError = _ref.onFetchEthnicityGroupsError,
      onFetchGendersError = _ref.onFetchGendersError,
      onFetchIncomeRangesError = _ref.onFetchIncomeRangesError,
      onFetchInterestsError = _ref.onFetchInterestsError,
      onFetchLanguagesError = _ref.onFetchLanguagesError;

  var _useState = useState$2([]),
      _useState2 = _slicedToArray(_useState, 2),
      ages = _useState2[0],
      setAges = _useState2[1];

  var _useState3 = useState$2([]),
      _useState4 = _slicedToArray(_useState3, 2),
      genders = _useState4[0],
      setGenders = _useState4[1];

  var _useState5 = useState$2([]),
      _useState6 = _slicedToArray(_useState5, 2),
      languages = _useState6[0],
      setLanguages = _useState6[1];

  var _useState7 = useState$2([]),
      _useState8 = _slicedToArray(_useState7, 2),
      interests = _useState8[0],
      setInterests = _useState8[1];

  var _useState9 = useState$2([]),
      _useState10 = _slicedToArray(_useState9, 2),
      incomeRanges = _useState10[0],
      setIncomeRanges = _useState10[1];

  var _useState11 = useState$2([]),
      _useState12 = _slicedToArray(_useState11, 2),
      ethnicities = _useState12[0],
      setEthnicities = _useState12[1];

  var getSelectedValues = function getSelectedValues(values, arr) {
    return values.reduce(function (acc, value) {
      var option = arr.find(function (item) {
        return item.value === value;
      });

      if (option) {
        acc.push(option);
      }

      return acc;
    }, []);
  };

  var selectedAges = campaign.ageRangeIds ? getSelectedValues(campaign.ageRangeIds.split(',').map(function (item) {
    return +item;
  }), ages) : [];
  var selectedGenders = campaign.genderIds ? getSelectedValues(campaign.genderIds.split(',').map(function (item) {
    return +item;
  }), genders) : [];
  var selectedLanguages = campaign.languageIds ? getSelectedValues(campaign.languageIds.split(',').map(function (item) {
    return +item;
  }), languages) : [];
  var selectedInterests = campaign.interestIds ? getSelectedValues(campaign.interestIds.split(',').map(function (item) {
    return +item;
  }), interests) : [];
  var selectedIncomeRanges = campaign.incomeRangeIds ? getSelectedValues(campaign.incomeRangeIds.split(',').map(function (item) {
    return +item;
  }), incomeRanges) : [];
  var selectedEthnicities = campaign.ethnicityIds ? getSelectedValues(campaign.ethnicityIds.split(',').map(function (item) {
    return +item;
  }), ethnicities) : [];

  var joinByComma = function joinByComma(values) {
    return values.map(function (value) {
      return value.label;
    }).join(', ');
  };

  var agesStr = joinByComma(selectedAges);
  var genderStr = joinByComma(selectedGenders);
  var languagesStr = joinByComma(selectedLanguages);
  var interestStr = joinByComma(selectedInterests);
  var incomeStr = joinByComma(selectedIncomeRanges);
  var nationalityStr = joinByComma(selectedEthnicities);
  useEffect(function () {
    var fetchAgesList = /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee() {
        var _campaign$ageRangeIds;

        var agesList;
        return regenerator.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return fetchAges(onFetchAgesError);

              case 2:
                agesList = _context.sent;
                setAges(getSelectedValues((_campaign$ageRangeIds = campaign.ageRangeIds) === null || _campaign$ageRangeIds === void 0 ? void 0 : _campaign$ageRangeIds.split(',').map(function (item) {
                  return +item;
                }), agesList));

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function fetchAgesList() {
        return _ref2.apply(this, arguments);
      };
    }();

    if (campaign.ageRangeIds) {
      fetchAgesList();
    } // eslint-disable-next-line react-hooks/exhaustive-deps

  }, [campaign]);
  useEffect(function () {
    var fetchGenderList = /*#__PURE__*/function () {
      var _ref3 = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee2() {
        var _campaign$genderIds;

        var gendersList;
        return regenerator.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return fetchGenders(onFetchGendersError);

              case 2:
                gendersList = _context2.sent;
                setGenders(getSelectedValues((_campaign$genderIds = campaign.genderIds) === null || _campaign$genderIds === void 0 ? void 0 : _campaign$genderIds.split(',').map(function (item) {
                  return +item;
                }), gendersList));

              case 4:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      return function fetchGenderList() {
        return _ref3.apply(this, arguments);
      };
    }();

    if (campaign.genderIds) {
      fetchGenderList();
    } // eslint-disable-next-line react-hooks/exhaustive-deps

  }, [campaign]);
  useEffect(function () {
    var fetchLanguagesList = /*#__PURE__*/function () {
      var _ref4 = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee3() {
        var _campaign$languageIds;

        var languagesList;
        return regenerator.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return fetchLanguages(onFetchLanguagesError);

              case 2:
                languagesList = _context3.sent;
                setLanguages(getSelectedValues((_campaign$languageIds = campaign.languageIds) === null || _campaign$languageIds === void 0 ? void 0 : _campaign$languageIds.split(',').map(function (item) {
                  return +item;
                }), languagesList));

              case 4:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));

      return function fetchLanguagesList() {
        return _ref4.apply(this, arguments);
      };
    }();

    if (campaign.languageIds) {
      fetchLanguagesList();
    } // eslint-disable-next-line react-hooks/exhaustive-deps

  }, [campaign]);
  useEffect(function () {
    var fetchInterestsList = /*#__PURE__*/function () {
      var _ref5 = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee4() {
        var _campaign$interestIds;

        var interestsList;
        return regenerator.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return fetchInterests(onFetchInterestsError);

              case 2:
                interestsList = _context4.sent;
                setInterests(getSelectedValues((_campaign$interestIds = campaign.interestIds) === null || _campaign$interestIds === void 0 ? void 0 : _campaign$interestIds.split(',').map(function (item) {
                  return +item;
                }), interestsList));

              case 4:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }));

      return function fetchInterestsList() {
        return _ref5.apply(this, arguments);
      };
    }();

    if (campaign.interestIds) {
      fetchInterestsList();
    } // eslint-disable-next-line react-hooks/exhaustive-deps

  }, [campaign]);
  useEffect(function () {
    var fetchIncomeRangeList = /*#__PURE__*/function () {
      var _ref6 = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee5() {
        var _campaign$incomeRange;

        var incomeRangeList;
        return regenerator.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.next = 2;
                return fetchIncomeRange(onFetchIncomeRangesError);

              case 2:
                incomeRangeList = _context5.sent;
                setIncomeRanges(getSelectedValues((_campaign$incomeRange = campaign.incomeRangeIds) === null || _campaign$incomeRange === void 0 ? void 0 : _campaign$incomeRange.split(',').map(function (item) {
                  return +item;
                }), incomeRangeList));

              case 4:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5);
      }));

      return function fetchIncomeRangeList() {
        return _ref6.apply(this, arguments);
      };
    }();

    if (campaign.incomeRangeIds) {
      fetchIncomeRangeList();
    } // eslint-disable-next-line react-hooks/exhaustive-deps

  }, [campaign]);
  useEffect(function () {
    var fetchEthnicitiesList = /*#__PURE__*/function () {
      var _ref7 = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee6() {
        var _campaign$ethnicityId;

        var ethnicitiesList;
        return regenerator.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.next = 2;
                return fetchEthnicityGroups(onFetchEthnicityGroupsError);

              case 2:
                ethnicitiesList = _context6.sent;
                setEthnicities(getSelectedValues((_campaign$ethnicityId = campaign.ethnicityIds) === null || _campaign$ethnicityId === void 0 ? void 0 : _campaign$ethnicityId.split(',').map(function (item) {
                  return +item;
                }), ethnicitiesList));

              case 4:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6);
      }));

      return function fetchEthnicitiesList() {
        return _ref7.apply(this, arguments);
      };
    }();

    if (campaign.ethnicityIds) {
      fetchEthnicitiesList();
    } // eslint-disable-next-line react-hooks/exhaustive-deps

  }, [campaign]);

  var getClippedValues = function getClippedValues(selectedValues) {
    return selectedValues.length > 5 ? selectedValues.slice(0, 5).map(function (i) {
      return i.label;
    }).join(', ').concat(" and ".concat(selectedValues.length - 5, " more")) : selectedValues.map(function (i) {
      return i.label;
    }).join(', ');
  };

  var getListItem = function getListItem(title, value) {
    var toolTipValue = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
    return /*#__PURE__*/React__default.createElement("div", {
      className: styles$s.listItem
    }, /*#__PURE__*/React__default.createElement("div", {
      className: styles$s.listTitle
    }, title, ":"), /*#__PURE__*/React__default.createElement("div", {
      className: styles$s.listValue
    }, toolTipValue ? /*#__PURE__*/React__default.createElement(Tooltip, {
      portal: true,
      label: toolTipValue
    }, value) : value));
  };

  var listItems = [].concat(_toConsumableArray(selectedAges.length ? [{
    element: getListItem('Age Group', getClippedValues(selectedAges), agesStr),
    key: 'ageGroup'
  }] : []), _toConsumableArray(selectedGenders.length ? [{
    element: getListItem('Gender', getClippedValues(selectedGenders), genderStr),
    key: 'gender'
  }] : []), _toConsumableArray(selectedLanguages.length ? [{
    element: getListItem('Language', getClippedValues(selectedLanguages), languagesStr),
    key: 'languages'
  }] : []), _toConsumableArray(selectedInterests.length ? [{
    element: getListItem('Interest', getClippedValues(selectedInterests), interestStr),
    key: 'interest'
  }] : []), _toConsumableArray(selectedIncomeRanges.length ? [{
    element: getListItem('Income Range', getClippedValues(selectedIncomeRanges), incomeStr),
    key: 'incomeRange'
  }] : []), _toConsumableArray(selectedEthnicities.length ? [{
    element: getListItem('Nationality', getClippedValues(selectedEthnicities), nationalityStr),
    key: 'nationality'
  }] : []));
  var isSectionEmpty = !campaign.ageRangeIds && !campaign.genderIds && !campaign.languageIds && !campaign.interestIds && !campaign.incomeRangeIds && !campaign.ethnicityIds;
  return /*#__PURE__*/React__default.createElement(CollapsibleBlock, {
    customStyle: {
      block: styles$s.section,
      blockTitleText: styles$s.blockTitleText,
      summaryContainer: styles$s.summaryContainer,
      summaryLabel: styles$s.summaryLabel,
      summaryValue: styles$s.summaryValue,
      panelHeaderExpand: styles$s.panelHeaderExpand,
      panelHeaderCollapse: styles$s.panelHeaderCollapse
    },
    id: "demographic",
    header: {
      title: /*#__PURE__*/React__default.createElement("div", {
        className: styles$s.title
      }, /*#__PURE__*/React__default.createElement(Icon, {
        name: "CampaignsDemographic"
      }), /*#__PURE__*/React__default.createElement(React__default.Fragment, null, "Demographic")),
      summary: _objectSpread$u(_objectSpread$u(_objectSpread$u(_objectSpread$u(_objectSpread$u(_objectSpread$u({}, agesStr ? {
        'Age Group': truncate$1$1(agesStr)
      } : {}), genderStr ? {
        Gender: truncate$1$1(genderStr)
      } : {}), languagesStr ? {
        Language: truncate$1$1(languagesStr)
      } : {}), interestStr ? {
        Interest: truncate$1$1(interestStr)
      } : {}), incomeStr ? {
        'Income Group': truncate$1$1(incomeStr)
      } : {}), nationalityStr ? {
        Nationality: truncate$1$1(nationalityStr)
      } : {})
    },
    isCollapseOpen: isBlockOpen,
    onToggle: onToggle,
    collapsible: true
  }, !isSectionEmpty ? /*#__PURE__*/React__default.createElement(DisplayItems, {
    type: "list",
    items: listItems,
    listClassName: styles$s.list
  }) : /*#__PURE__*/React__default.createElement("div", {
    className: styles$s.emptySection
  }, /*#__PURE__*/React__default.createElement("img", {
    className: styles$s.image,
    alt: "",
    src: "".concat(SVG_HOST_URL, "/misc/empty-section-teal.svg")
  }), /*#__PURE__*/React__default.createElement("div", {
    className: styles$s.text
  }, "No Demography assigned yet"), /*#__PURE__*/React__default.createElement("div", {
    className: styles$s.subText
  }, "Click on edit to assign demography targeting for the campaign")));
};

var css_248z$w = ":root {\n  --primary1: #123787;\n  --primary2: #1d58d7;\n  --primary3: #5173fb;\n  --primary4: #7a93ff;\n  --primary5: #c2d0ff;\n  --primary6: #e5ebff;\n  --primary7: #f2f5ff; }\n\n@keyframes index-module_hover-ripples__13PYu {\n  0% {\n    top: -0.1875em;\n    left: -0.1875em;\n    right: -0.1875em;\n    bottom: -0.1875em;\n    opacity: 1; }\n  100% {\n    top: -0.8125em;\n    left: -0.8125em;\n    right: -0.8125em;\n    bottom: -0.8125em;\n    opacity: 0; } }\n\n.index-module_listItem__lOrhJ {\n  display: flex;\n  margin-bottom: 0.4375rem;\n  align-items: center; }\n\n.index-module_listTitle__xn6K8 {\n  font-family: 'Avenir Next Regular', sans-serif;\n  font-weight: normal;\n  letter-spacing: .2px;\n  color: #666666;\n  font-size: 0.75rem;\n  line-height: 1;\n  letter-spacing: 0.0125rem;\n  margin-right: 0.25rem; }\n\n.index-module_listValue__1Ke7N {\n  font-family: 'Avenir Next Regular', sans-serif;\n  font-weight: normal;\n  letter-spacing: .2px;\n  color: #000000;\n  font-size: 0.75rem;\n  line-height: 1rem; }\n\n.index-module_blockTitleText__2FVlJ {\n  font-family: 'Avenir Next Demi', sans-serif;\n  font-weight: normal;\n  font-size: 1rem;\n  line-height: 1.5em;\n  min-width: 6.5rem;\n  display: flex; }\n\n.index-module_panelHeaderCollapse__27jCZ {\n  padding: 0;\n  cursor: pointer; }\n\n.index-module_panelHeaderExpand__3Xg1f {\n  padding: 0;\n  cursor: pointer;\n  margin-bottom: 1rem; }\n\n.index-module_summaryContainer__3TmTo {\n  margin-right: 1rem;\n  display: inline; }\n\n.index-module_summaryLabel__3pZ1q {\n  font-family: 'Avenir Next Regular', sans-serif;\n  font-weight: normal;\n  letter-spacing: .2px;\n  color: #a2a2a2;\n  font-size: 0.75rem;\n  line-height: 1;\n  letter-spacing: 0.0125rem; }\n\n.index-module_summaryValue__pSLQJ {\n  font-family: 'Avenir Next Regular', sans-serif;\n  font-weight: normal;\n  letter-spacing: .2px;\n  font-size: 0.75rem;\n  line-height: 1;\n  letter-spacing: 0.0125rem; }\n\n.index-module_section__1m-FE {\n  display: flex;\n  flex-direction: column;\n  padding-top: 1rem;\n  padding-left: 1.5rem;\n  width: 57.4375rem;\n  padding-right: 1.5rem;\n  padding-bottom: 1rem;\n  margin-bottom: 0.9375rem;\n  border-radius: 0.25rem !important;\n  box-shadow: 0 0.25rem 0.375rem rgba(0, 0, 0, 0.05), 0 0 0.5rem rgba(0, 0, 0, 0.04); }\n  .index-module_section__1m-FE .index-module_title__1rOg1 {\n    font-family: 'Avenir Next Demi', sans-serif;\n    font-weight: normal;\n    font-weight: 600;\n    font-size: 0.875rem;\n    line-height: 1.125rem;\n    margin: auto 0 auto 0;\n    display: flex;\n    align-items: center; }\n    .index-module_section__1m-FE .index-module_title__1rOg1 .svg-icon {\n      margin-right: 0.25rem; }\n      .index-module_section__1m-FE .index-module_title__1rOg1 .svg-icon path {\n        fill: var(--primary2); }\n\n.index-module_emptySection__3U_oH {\n  display: flex;\n  align-items: center;\n  flex-direction: column; }\n  .index-module_emptySection__3U_oH img {\n    margin-bottom: 0.5rem;\n    width: 15.625rem;\n    height: 12.3125rem; }\n  .index-module_emptySection__3U_oH .index-module_text__4ugTX {\n    font-family: 'Avenir Next Demi', sans-serif;\n    font-weight: normal;\n    font-style: normal;\n    font-weight: 600;\n    font-size: 0.875rem;\n    line-height: 1;\n    color: #000000;\n    letter-spacing: 0.00625rem;\n    margin-bottom: 0.25rem; }\n  .index-module_emptySection__3U_oH .index-module_subText__2jtqw {\n    font-family: 'Avenir Next Regular', sans-serif;\n    font-weight: normal;\n    font-style: normal;\n    font-weight: 400;\n    font-size: 0.8125rem;\n    line-height: 1;\n    color: #000000;\n    letter-spacing: 0.00625rem; }\n";
var styles$t = {"listItem":"index-module_listItem__lOrhJ","listTitle":"index-module_listTitle__xn6K8","listValue":"index-module_listValue__1Ke7N","blockTitleText":"index-module_blockTitleText__2FVlJ","panelHeaderCollapse":"index-module_panelHeaderCollapse__27jCZ","panelHeaderExpand":"index-module_panelHeaderExpand__3Xg1f","summaryContainer":"index-module_summaryContainer__3TmTo","summaryLabel":"index-module_summaryLabel__3pZ1q","summaryValue":"index-module_summaryValue__pSLQJ","section":"index-module_section__1m-FE","title":"index-module_title__1rOg1","emptySection":"index-module_emptySection__3U_oH","text":"index-module_text__4ugTX","subText":"index-module_subText__2jtqw","hover-ripples":"index-module_hover-ripples__13PYu"};
styleInject(css_248z$w);

var CampaignAdvanced = function CampaignAdvanced(props) {
  var _campaign$exchanges2;

  var campaign = props.campaign,
      isBlockOpen = props.isBlockOpen,
      onToggle = props.onToggle,
      onFetchExchangesError = props.onFetchExchangesError;

  var _useState = useState$2([]),
      _useState2 = _slicedToArray(_useState, 2),
      selectedExchanges = _useState2[0],
      setSelectedExchanges = _useState2[1];

  var getSelectedValues = function getSelectedValues(values, arr) {
    return values.reduce(function (acc, value) {
      var option = arr.find(function (item) {
        return item.value === value;
      });

      if (option) {
        acc.push(option);
      }

      return acc;
    }, []);
  };

  useEffect(function () {
    var fetchExchangesList = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee() {
        var _campaign$exchanges;

        var exchangesList;
        return regenerator.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return fetchExchanges(onFetchExchangesError);

              case 2:
                exchangesList = _context.sent;
                setSelectedExchanges(getSelectedValues((_campaign$exchanges = campaign.exchanges) === null || _campaign$exchanges === void 0 ? void 0 : _campaign$exchanges.split(',').map(function (item) {
                  return +item;
                }), exchangesList));

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function fetchExchangesList() {
        return _ref.apply(this, arguments);
      };
    }();

    if (campaign.exchanges) {
      fetchExchangesList();
    } // eslint-disable-next-line react-hooks/exhaustive-deps

  }, [campaign]);
  var exchanges = selectedExchanges.map(function (i) {
    return i.label;
  }).join(', ');

  var getClippedValues = function getClippedValues(selectedValues) {
    return selectedValues.length > 5 ? selectedValues.slice(0, 5).map(function (i) {
      return i.label;
    }).join(', ').concat(" and ".concat(selectedValues.length - 5, " more")) : selectedValues.map(function (i) {
      return i.label;
    }).join(', ');
  };

  var getListItem = function getListItem(title, value) {
    var toolTipValue = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
    return /*#__PURE__*/React__default.createElement("div", {
      className: styles$t.listItem
    }, /*#__PURE__*/React__default.createElement("div", {
      className: styles$t.listTitle
    }, title, ":"), /*#__PURE__*/React__default.createElement("div", {
      className: styles$t.listValue
    }, toolTipValue ? /*#__PURE__*/React__default.createElement(Tooltip, {
      portal: true,
      label: toolTipValue
    }, value) : value));
  }; // @ts-ignore


  var countFormatter = Intl.NumberFormat('en', {
    notation: 'compact'
  });

  var getTotalCount = function getTotalCount(blackList, whiteList) {
    var _blackList$split$leng, _whiteList$split$leng;

    return countFormatter.format(((_blackList$split$leng = blackList === null || blackList === void 0 ? void 0 : blackList.split(',').length) !== null && _blackList$split$leng !== void 0 ? _blackList$split$leng : 0) + ((_whiteList$split$leng = whiteList === null || whiteList === void 0 ? void 0 : whiteList.split(',').length) !== null && _whiteList$split$leng !== void 0 ? _whiteList$split$leng : 0));
  };

  var getTextWithCount = function getTextWithCount(blackList, whiteList) {
    if (blackList && whiteList) {
      return "Allowed (".concat(countFormatter.format(whiteList.split(',').length), "), Blocked (").concat(countFormatter.format(blackList.split(',').length), ")");
    }

    return blackList ? "Blocked (".concat(countFormatter.format(blackList.split(',').length), ")") : "Allowed (".concat(countFormatter.format(whiteList.split(',').length), ")");
  };

  var listItems = [].concat(_toConsumableArray(selectedExchanges.length ? [{
    element: getListItem("Exchanges (".concat(countFormatter.format((_campaign$exchanges2 = campaign.exchanges) === null || _campaign$exchanges2 === void 0 ? void 0 : _campaign$exchanges2.split(',').length), ")"), getClippedValues(selectedExchanges), exchanges),
    key: 'exchanges'
  }] : []), _toConsumableArray(campaign.blackListedDeviceId || campaign.whiteListedDeviceId ? [{
    element: getListItem("Device ID (".concat(getTotalCount(campaign.blackListedDeviceId, campaign.whiteListedDeviceId), ")"), getTextWithCount(campaign.blackListedDeviceId, campaign.whiteListedDeviceId)),
    key: 'deviceId'
  }] : []), _toConsumableArray(campaign.blackListedIp || campaign.whiteListedIp ? [{
    element: getListItem("IP (".concat(getTotalCount(campaign.blackListedIp, campaign.whiteListedIp), ")"), getTextWithCount(campaign.blackListedIp, campaign.whiteListedIp)),
    key: 'ip'
  }] : []), _toConsumableArray(campaign.blackListedPackageName || campaign.whiteListedPackageName ? [{
    element: getListItem("Android Package Name (".concat(getTotalCount(campaign.blackListedPackageName, campaign.whiteListedPackageName), ")"), getTextWithCount(campaign.blackListedPackageName, campaign.whiteListedPackageName)),
    key: 'package'
  }] : []), _toConsumableArray(campaign.blackListedAppId || campaign.whiteListedAppId ? [{
    element: getListItem("iOS App IDs (".concat(getTotalCount(campaign.blackListedAppId, campaign.whiteListedAppId), ")"), getTextWithCount(campaign.blackListedAppId, campaign.whiteListedAppId)),
    key: 'iOS'
  }] : []), _toConsumableArray(campaign.blackListedSiteDomain || campaign.whiteListedSiteDomain ? [{
    element: getListItem("Site Domains (".concat(getTotalCount(campaign.blackListedSiteDomain, campaign.whiteListedSiteDomain), ")"), getTextWithCount(campaign.blackListedSiteDomain, campaign.whiteListedSiteDomain)),
    key: 'siteDomain'
  }] : []));
  var isSectionEmpty = !campaign.exchanges && !campaign.blackListedDeviceId && !campaign.whiteListedDeviceId && !campaign.blackListedIp && !campaign.whiteListedIp && !campaign.blackListedPackageName && !campaign.whiteListedPackageName && !campaign.blackListedAppId && !campaign.whiteListedAppId && !campaign.blackListedSiteDomain && !campaign.whiteListedSiteDomain;
  return /*#__PURE__*/React__default.createElement(CollapsibleBlock, {
    customStyle: {
      block: styles$t.section,
      blockTitleText: styles$t.blockTitleText,
      summaryContainer: styles$t.summaryContainer,
      summaryLabel: styles$t.summaryLabel,
      summaryValue: styles$t.summaryValue,
      panelHeaderExpand: styles$t.panelHeaderExpand,
      panelHeaderCollapse: styles$t.panelHeaderCollapse
    },
    id: "advanced",
    header: {
      title: /*#__PURE__*/React__default.createElement("div", {
        className: styles$t.title
      }, /*#__PURE__*/React__default.createElement(Icon, {
        name: "Advanced"
      }), /*#__PURE__*/React__default.createElement(React__default.Fragment, null, "Advanced")),
      summary: {
        Exchanges: truncate$1$1(exchanges)
      }
    },
    isCollapseOpen: isBlockOpen,
    onToggle: onToggle,
    collapsible: true
  }, !isSectionEmpty ? /*#__PURE__*/React__default.createElement(DisplayItems, {
    type: "list",
    items: listItems,
    listClassName: styles$t.list
  }) : /*#__PURE__*/React__default.createElement("div", {
    className: styles$t.emptySection
  }, /*#__PURE__*/React__default.createElement("img", {
    className: styles$t.image,
    alt: "",
    src: "".concat(SVG_HOST_URL, "/misc/empty-section-teal.svg")
  }), /*#__PURE__*/React__default.createElement("div", {
    className: styles$t.text
  }, "No Advanced targeting assigned yet"), /*#__PURE__*/React__default.createElement("div", {
    className: styles$t.subText
  }, "Click on edit to assign advanced targeting for the campaign")));
};

var css_248z$x = ":root {\n  --primary1: #123787;\n  --primary2: #1d58d7;\n  --primary3: #5173fb;\n  --primary4: #7a93ff;\n  --primary5: #c2d0ff;\n  --primary6: #e5ebff;\n  --primary7: #f2f5ff; }\n\n@keyframes index-module_hover-ripples__3fd_0 {\n  0% {\n    top: -0.1875em;\n    left: -0.1875em;\n    right: -0.1875em;\n    bottom: -0.1875em;\n    opacity: 1; }\n  100% {\n    top: -0.8125em;\n    left: -0.8125em;\n    right: -0.8125em;\n    bottom: -0.8125em;\n    opacity: 0; } }\n\n.index-module_blockTitleText__3KIa0 {\n  font-family: 'Avenir Next Demi', sans-serif;\n  font-weight: normal;\n  font-size: 1rem;\n  line-height: 1.5em;\n  min-width: 7.5rem;\n  display: flex; }\n\n.index-module_panelHeaderCollapse__3B70D {\n  padding: 0;\n  cursor: pointer; }\n\n.index-module_panelHeaderExpand__3HsZ3 {\n  padding: 0;\n  cursor: pointer;\n  margin-bottom: 1rem; }\n\n.index-module_summaryContainer__GVjri {\n  margin-right: 1rem;\n  display: inline; }\n\n.index-module_summaryLabel__2D0SD {\n  font-family: 'Avenir Next Regular', sans-serif;\n  font-weight: normal;\n  letter-spacing: .2px;\n  color: #a2a2a2;\n  font-size: 0.75rem;\n  line-height: 1;\n  letter-spacing: 0.0125rem; }\n\n.index-module_summaryValue__24YlO {\n  font-family: 'Avenir Next Regular', sans-serif;\n  font-weight: normal;\n  letter-spacing: .2px;\n  font-size: 0.75rem;\n  line-height: 1;\n  letter-spacing: 0.0125rem; }\n\n.index-module_grid__rGgC- {\n  width: 100%;\n  margin-bottom: 1.25rem; }\n\n.index-module_section__2_nfC {\n  display: flex;\n  flex-direction: column;\n  padding-top: 1rem;\n  padding-left: 1.5rem;\n  width: 57.4375rem;\n  margin-bottom: 0.9375rem;\n  padding-right: 1.5rem;\n  padding-bottom: 1rem;\n  border-radius: 0.25rem !important;\n  box-shadow: 0 0.25rem 0.375rem rgba(0, 0, 0, 0.05), 0 0 0.5rem rgba(0, 0, 0, 0.04); }\n  .index-module_section__2_nfC .index-module_title__2weC6 {\n    font-family: 'Avenir Next Demi', sans-serif;\n    font-weight: normal;\n    font-weight: 600;\n    font-size: 0.875rem;\n    line-height: 1.125rem;\n    margin: auto 0 auto 0;\n    display: flex;\n    align-items: center; }\n    .index-module_section__2_nfC .index-module_title__2weC6 .svg-icon {\n      margin-right: 0.25rem; }\n      .index-module_section__2_nfC .index-module_title__2weC6 .svg-icon path {\n        fill: var(--primary2); }\n\n.index-module_bidStrategy__1UnWV {\n  display: flex;\n  align-items: center; }\n  .index-module_bidStrategy__1UnWV .svg-icon {\n    width: 1.125rem;\n    height: 1.125rem; }\n  .index-module_bidStrategy__1UnWV .index-module_onPill__3NmQH {\n    font-family: 'Avenir Next Demi', sans-serif;\n    font-weight: normal;\n    letter-spacing: .2px;\n    margin-left: 0.5rem;\n    height: 1.5625rem;\n    color: #289679; }\n  .index-module_bidStrategy__1UnWV .index-module_offPill__PYJ8Y {\n    font-family: 'Avenir Next Demi', sans-serif;\n    font-weight: normal;\n    letter-spacing: .2px;\n    margin-left: 0.5rem;\n    height: 1.5625rem;\n    color: #f1494a; }\n  .index-module_bidStrategy__1UnWV .index-module_bidtext__6ngCX {\n    font-family: 'Avenir Next Regular', sans-serif;\n    font-weight: normal;\n    letter-spacing: .2px;\n    color: #666666;\n    font-size: 0.75rem;\n    line-height: 1;\n    letter-spacing: 0.0125rem;\n    margin-right: 0.5rem; }\n";
var styles$u = {"blockTitleText":"index-module_blockTitleText__3KIa0","panelHeaderCollapse":"index-module_panelHeaderCollapse__3B70D","panelHeaderExpand":"index-module_panelHeaderExpand__3HsZ3","summaryContainer":"index-module_summaryContainer__GVjri","summaryLabel":"index-module_summaryLabel__2D0SD","summaryValue":"index-module_summaryValue__24YlO","grid":"index-module_grid__rGgC-","section":"index-module_section__2_nfC","title":"index-module_title__2weC6","bidStrategy":"index-module_bidStrategy__1UnWV","onPill":"index-module_onPill__3NmQH","offPill":"index-module_offPill__PYJ8Y","bidtext":"index-module_bidtext__6ngCX","hover-ripples":"index-module_hover-ripples__3fd_0"};
styleInject(css_248z$x);

var CampaignBidStrategy = function CampaignBidStrategy(_ref) {
  var campaign = _ref.campaign,
      isBlockOpen = _ref.isBlockOpen,
      onToggle = _ref.onToggle;
  var budgetCapping = !!(campaign !== null && campaign !== void 0 && campaign.maxDayImpressions || campaign !== null && campaign !== void 0 && campaign.maxDayClicks || campaign !== null && campaign !== void 0 && campaign.maxDayConversions || campaign !== null && campaign !== void 0 && campaign.totalImpressions || campaign !== null && campaign !== void 0 && campaign.totalClicks || campaign !== null && campaign !== void 0 && campaign.totalConversions);
  var gridItems = [{
    element: /*#__PURE__*/React__default.createElement("div", {
      className: styles$u.bidStrategy
    }, /*#__PURE__*/React__default.createElement("div", {
      className: styles$u.bidtext
    }, "Budget Capping"), /*#__PURE__*/React__default.createElement(Tooltip, {
      label: "Need inputs",
      portal: true
    }, /*#__PURE__*/React__default.createElement(Icon, {
      name: "Info"
    })), /*#__PURE__*/React__default.createElement(Pill, {
      className: budgetCapping ? styles$u.onPill : styles$u.offPill,
      label: budgetCapping ? 'On' : 'Off'
    })),
    key: 'budgetCapping'
  }, {
    element: /*#__PURE__*/React__default.createElement("div", {
      className: styles$u.bidStrategy
    }, /*#__PURE__*/React__default.createElement("div", {
      className: styles$u.bidtext
    }, "Impression Capping"), /*#__PURE__*/React__default.createElement(Tooltip, {
      label: "Need inputs",
      portal: true
    }, /*#__PURE__*/React__default.createElement(Icon, {
      name: "Info"
    })), /*#__PURE__*/React__default.createElement(Pill, {
      className: campaign !== null && campaign !== void 0 && campaign.impressionCapping ? styles$u.onPill : styles$u.offPill,
      label: campaign !== null && campaign !== void 0 && campaign.impressionCapping ? 'On' : 'Off'
    })),
    key: 'impressionCapping'
  }, {
    element: /*#__PURE__*/React__default.createElement("div", {
      className: styles$u.bidStrategy
    }, /*#__PURE__*/React__default.createElement("div", {
      className: styles$u.bidtext
    }, "Bid Pacing"), /*#__PURE__*/React__default.createElement(Tooltip, {
      label: "Need inputs",
      portal: true
    }, /*#__PURE__*/React__default.createElement(Icon, {
      name: "Info"
    })), /*#__PURE__*/React__default.createElement(Pill, {
      className: campaign !== null && campaign !== void 0 && campaign.bidPacing ? styles$u.onPill : styles$u.offPill,
      label: campaign !== null && campaign !== void 0 && campaign.bidPacing ? 'On' : 'Off'
    })),
    key: 'bidPacing'
  }];

  var getSwitchStatus = function getSwitchStatus(value) {
    return value ? 'ON' : 'OFF';
  };

  return /*#__PURE__*/React__default.createElement(CollapsibleBlock, {
    customStyle: {
      block: styles$u.section,
      blockTitleText: styles$u.blockTitleText,
      summaryContainer: styles$u.summaryContainer,
      summaryLabel: styles$u.summaryLabel,
      summaryValue: styles$u.summaryValue,
      panelHeaderExpand: styles$u.panelHeaderExpand,
      panelHeaderCollapse: styles$u.panelHeaderCollapse
    },
    id: "bidStrategy",
    header: {
      title: /*#__PURE__*/React__default.createElement("div", {
        className: styles$u.title
      }, /*#__PURE__*/React__default.createElement(Icon, {
        name: "CampaignsBid"
      }), "Bid Strategy"),
      summary: {
        'Budget Capping': getSwitchStatus(budgetCapping),
        'Impressions Capping': getSwitchStatus(campaign === null || campaign === void 0 ? void 0 : campaign.impressionCapping),
        'Bid Pacing': getSwitchStatus(campaign === null || campaign === void 0 ? void 0 : campaign.bidPacing)
      }
    },
    isCollapseOpen: isBlockOpen,
    onToggle: onToggle,
    collapsible: true
  }, /*#__PURE__*/React__default.createElement(DisplayItems, {
    type: "grid",
    gridColumnCount: gridItems.length,
    gridClassName: styles$u.grid,
    items: gridItems
  }));
};

var css_248z$y = ":root {\n  --primary1: #123787;\n  --primary2: #1d58d7;\n  --primary3: #5173fb;\n  --primary4: #7a93ff;\n  --primary5: #c2d0ff;\n  --primary6: #e5ebff;\n  --primary7: #f2f5ff; }\n\n@keyframes index-module_hover-ripples__1tHAp {\n  0% {\n    top: -0.1875em;\n    left: -0.1875em;\n    right: -0.1875em;\n    bottom: -0.1875em;\n    opacity: 1; }\n  100% {\n    top: -0.8125em;\n    left: -0.8125em;\n    right: -0.8125em;\n    bottom: -0.8125em;\n    opacity: 0; } }\n\n.index-module_section__3CUHO {\n  display: flex;\n  flex-direction: column;\n  padding-top: 1rem;\n  padding-left: 1.5rem;\n  width: 57.4375rem;\n  padding-right: 1.5rem;\n  margin-bottom: 0.9375rem;\n  padding-bottom: 1rem;\n  border-radius: 0.25rem !important;\n  box-shadow: 0rem 0.25rem 0.375rem rgba(0, 0, 0, 0.05), 0rem 0rem 0.5rem rgba(0, 0, 0, 0.04); }\n  .index-module_section__3CUHO .index-module_title__3kQYV {\n    font-family: 'Avenir Next Demi', sans-serif;\n    font-weight: normal;\n    font-weight: 600;\n    font-size: 0.875rem;\n    line-height: 1.125rem;\n    margin: auto 0 auto 0;\n    display: flex;\n    align-items: center; }\n    .index-module_section__3CUHO .index-module_title__3kQYV .svg-icon {\n      margin-right: 0.25rem; }\n      .index-module_section__3CUHO .index-module_title__3kQYV .svg-icon path {\n        fill: var(--primary2); }\n\n.index-module_blockTitleText__3lWlV {\n  font-family: 'Avenir Next Demi', sans-serif;\n  font-weight: normal;\n  font-size: 1rem;\n  line-height: 1.5em;\n  min-width: 3.5rem;\n  margin-right: 1rem;\n  display: flex; }\n\n.index-module_panelHeaderCollapse__2MGMp {\n  padding: 0;\n  cursor: pointer; }\n\n.index-module_panelHeaderExpand__3Ra-S {\n  padding: 0;\n  cursor: pointer;\n  margin-bottom: 1rem; }\n\n.index-module_summaryContainer__h7rlj {\n  margin-right: 1rem;\n  display: inline; }\n\n.index-module_summaryLabel__2hi5C {\n  font-family: 'Avenir Next Regular', sans-serif;\n  font-weight: normal;\n  letter-spacing: .2px;\n  color: #a2a2a2;\n  font-size: 0.75rem;\n  line-height: 1;\n  letter-spacing: 0.0125rem; }\n\n.index-module_summaryValue__zMj3h {\n  font-family: 'Avenir Next Regular', sans-serif;\n  font-weight: normal;\n  letter-spacing: .2px;\n  font-size: 0.75rem;\n  line-height: 1;\n  letter-spacing: 0.0125rem; }\n\n.index-module_blackListTextColor__3EgNC {\n  color: #f1494a; }\n\n.index-module_table__HBgHJ [class*='containerRightScroller'] {\n  max-height: 21.875rem;\n  overflow-y: auto;\n  overflow-x: hidden; }\n  .index-module_table__HBgHJ [class*='containerRightScroller'] thead {\n    position: sticky;\n    top: 0;\n    z-index: 1; }\n\n.index-module_table__HBgHJ .table__top {\n  min-height: 1.125rem; }\n\n.index-module_table__HBgHJ [class*='_id'] {\n  min-width: 5rem;\n  width: 5rem; }\n\n.index-module_table__HBgHJ [class*='_audienceName'] {\n  min-width: 21.875rem;\n  width: 21.875rem; }\n  .index-module_table__HBgHJ [class*='_audienceName'] [class*='svg'] {\n    fill: none; }\n\n.index-module_table__HBgHJ [class*='_createdOn'] {\n  min-width: 7.8125rem;\n  width: 7.8125rem; }\n  .index-module_table__HBgHJ [class*='_createdOn'] .td-content-inner {\n    margin-left: auto; }\n\n.index-module_table__HBgHJ [class*='_status'] {\n  min-width: 7.8125rem;\n  width: 7.8125rem; }\n  .index-module_table__HBgHJ [class*='_status'] .td-content-inner {\n    margin-right: auto; }\n\n.index-module_table__HBgHJ [class*='_incExc'] {\n  min-width: 5rem;\n  width: 5rem; }\n  .index-module_table__HBgHJ [class*='_incExc'] .td-content-inner {\n    margin-right: auto; }\n  .index-module_table__HBgHJ [class*='_incExc'] .td-content-inner {\n    margin-left: auto; }\n\n.index-module_audienceName__1KeA0 {\n  display: flex;\n  align-items: center;\n  cursor: pointer; }\n  .index-module_audienceName__1KeA0 .index-module_toolTipContent__GLpWw {\n    display: flex;\n    align-items: center;\n    margin-top: 0rem; }\n  .index-module_audienceName__1KeA0 .index-module_toolTip__2bbzE {\n    position: absolute; }\n  .index-module_audienceName__1KeA0 .index-module_nameComplete__3Uzlh {\n    display: inline-block;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    width: 18.75rem; }\n    .index-module_audienceName__1KeA0 .index-module_nameComplete__3Uzlh::after {\n      content: '';\n      display: block; }\n\n.index-module_successPill__3VZg2 {\n  font-family: 'Avenir Next Demi', sans-serif;\n  font-weight: normal;\n  letter-spacing: .2px;\n  margin-left: 0.5rem;\n  height: 1.5625rem;\n  color: #289679; }\n\n.index-module_dangerPill__31rkT {\n  font-family: 'Avenir Next Demi', sans-serif;\n  font-weight: normal;\n  letter-spacing: .2px;\n  margin-left: 0.5rem;\n  height: 1.5625rem;\n  color: #f1494a; }\n\n.index-module_emptySection__LgJDS {\n  display: flex;\n  align-items: center;\n  flex-direction: column; }\n  .index-module_emptySection__LgJDS img {\n    margin-bottom: 0.5rem;\n    width: 15.625rem;\n    height: 12.3125rem; }\n  .index-module_emptySection__LgJDS .index-module_text__3R7oG {\n    font-family: 'Avenir Next Demi', sans-serif;\n    font-weight: normal;\n    font-style: normal;\n    font-weight: 600;\n    font-size: 0.875rem;\n    line-height: 1;\n    color: #000000;\n    letter-spacing: 0.00625rem;\n    margin-bottom: 0.25rem; }\n  .index-module_emptySection__LgJDS .index-module_subText__3a56n {\n    font-family: 'Avenir Next Regular', sans-serif;\n    font-weight: normal;\n    font-style: normal;\n    font-weight: 400;\n    font-size: 0.8125rem;\n    line-height: 1;\n    color: #000000;\n    letter-spacing: 0.00625rem; }\n";
var styles$v = {"section":"index-module_section__3CUHO","title":"index-module_title__3kQYV","blockTitleText":"index-module_blockTitleText__3lWlV","panelHeaderCollapse":"index-module_panelHeaderCollapse__2MGMp","panelHeaderExpand":"index-module_panelHeaderExpand__3Ra-S","summaryContainer":"index-module_summaryContainer__h7rlj","summaryLabel":"index-module_summaryLabel__2hi5C","summaryValue":"index-module_summaryValue__zMj3h","blackListTextColor":"index-module_blackListTextColor__3EgNC","table":"index-module_table__HBgHJ","audienceName":"index-module_audienceName__1KeA0","toolTipContent":"index-module_toolTipContent__GLpWw","toolTip":"index-module_toolTip__2bbzE","nameComplete":"index-module_nameComplete__3Uzlh","successPill":"index-module_successPill__3VZg2","dangerPill":"index-module_dangerPill__31rkT","emptySection":"index-module_emptySection__LgJDS","text":"index-module_text__3R7oG","subText":"index-module_subText__3a56n","hover-ripples":"index-module_hover-ripples__1tHAp"};
styleInject(css_248z$y);

function ownKeys$v(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$v(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$v(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$v(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var AUDIENCES_ICONS = [{
  audienceTypeId: 1,
  iconName: 'AudienceMatched'
}, {
  audienceTypeId: 2,
  iconName: 'AudienceSegmented'
}, {
  audienceTypeId: 3,
  iconName: 'AudienceRetargeted'
}, {
  audienceTypeId: 4,
  iconName: 'AudienceGeo'
}, {
  audienceTypeId: 5,
  iconName: 'AudienceContextual'
}, {
  audienceTypeId: 6,
  iconName: 'AudienceLookalike'
}, {
  audienceTypeId: 7,
  iconName: 'AudienceCampaign'
}];
var AUDIENCE_IDS_TO_FETCH = '1,2,3,4,5,6,7';

var CampaignAudience = function CampaignAudience(props) {
  var _campaign$blackListed2, _campaign$blackListed3, _campaign$whiteListed3, _campaign$whiteListed4;

  var campaign = props.campaign,
      isBlockOpen = props.isBlockOpen,
      onToggle = props.onToggle,
      onFetchAudiencesError = props.onFetchAudiencesError;

  var _useState = useState$2([]),
      _useState2 = _slicedToArray(_useState, 2),
      audiencesFilteredByOwId = _useState2[0],
      setAudiencesFilteredByOwId = _useState2[1];

  var _useState3 = useState$2({
    header: [],
    body: [],
    data: []
  }),
      _useState4 = _slicedToArray(_useState3, 2),
      tableConfig = _useState4[0],
      setTableConfig = _useState4[1];

  var fetchAudiencesFilteredByOwId = useCallback(function () {
    if (campaign !== null && campaign !== void 0 && campaign.owId) {
      _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee() {
        var response;
        return regenerator.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return fetchAudiences(AUDIENCE_IDS_TO_FETCH, String(campaign.owId), onFetchAudiencesError);

              case 2:
                response = _context.sent;
                setAudiencesFilteredByOwId(response);

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    } // eslint-disable-next-line react-hooks/exhaustive-deps

  }, [campaign]);
  useEffect(function () {
    fetchAudiencesFilteredByOwId();
  }, [fetchAudiencesFilteredByOwId]);
  var getAudienceItemsList = useCallback(function (type) {
    var _campaign$whiteListed, _campaign$blackListed;

    var whiteListedAudienceIds = (campaign === null || campaign === void 0 ? void 0 : (_campaign$whiteListed = campaign.whiteListedAudienceIds) === null || _campaign$whiteListed === void 0 ? void 0 : _campaign$whiteListed.split(',')) || [];
    var blackListedAudienceIds = (campaign === null || campaign === void 0 ? void 0 : (_campaign$blackListed = campaign.blackListedAudienceIds) === null || _campaign$blackListed === void 0 ? void 0 : _campaign$blackListed.split(',')) || [];
    var audienceIds = [];

    if (type === 'White') {
      audienceIds = whiteListedAudienceIds;
    } else if (type === 'Black') {
      audienceIds = blackListedAudienceIds;
    } else {
      audienceIds = whiteListedAudienceIds.concat(blackListedAudienceIds);
    }

    var audiencesInfo = [];
    audienceIds.forEach(function (audienceId) {
      var audienceDetails = audiencesFilteredByOwId.find(function (audience) {
        return audience.id === Number(audienceId);
      });

      if (audienceDetails) {
        var _AUDIENCES_ICONS$find, _campaign$whiteListed2;

        audiencesInfo.push({
          label: audienceDetails.audienceName || '',
          iconName: ((_AUDIENCES_ICONS$find = AUDIENCES_ICONS.find(function (icon) {
            return icon.audienceTypeId === audienceDetails.audienceTypeId;
          })) === null || _AUDIENCES_ICONS$find === void 0 ? void 0 : _AUDIENCES_ICONS$find.iconName) || '',
          id: audienceDetails.id,
          createdDate: audienceDetails.createdOn,
          status: audienceDetails.status,
          listingType: campaign !== null && campaign !== void 0 && (_campaign$whiteListed2 = campaign.whiteListedAudienceIds) !== null && _campaign$whiteListed2 !== void 0 && _campaign$whiteListed2.includes(audienceDetails.id.toString()) ? 'White' : 'Black',
          audienceTypeId: audienceDetails.audienceTypeId
        });
      }
    });
    return audiencesInfo;
  }, [audiencesFilteredByOwId, campaign]);

  var getTextStyle = function getTextStyle(listingType) {
    return listingType === 'Black' ? styles$v.blackListTextColor : '';
  };

  var selectedAudiences = useMemo(function () {
    var whiteListed = getAudienceItemsList('White');
    var blackListed = getAudienceItemsList('Black');
    var audienceType = Array.from(new Set([].concat(_toConsumableArray(whiteListed), _toConsumableArray(blackListed)).map(function (item) {
      return item.iconName === 'AudienceGeo' ? 'Geofarmed' : item.iconName.replace('Audience', '');
    })));
    return {
      audienceType: audienceType,
      whiteListed: whiteListed,
      blackListed: blackListed
    };
  }, [getAudienceItemsList]);
  var APPROVED = 'approved';
  var STATUS_MAP = {
    running: 'StatusRunningColor',
    pending: 'StatusPendingColor',
    'pending for approval': 'StatusPendingColor',
    paused: 'StatusPausedColor',
    draft: 'StatusDraftColor',
    budget_paused: 'StatusBudgetPausedColor',
    deleted: 'StatusDeletedColor',
    expired: 'StatusExpiredColor',
    rejected: 'StatusRejectedColor',
    'in-use': 'StatusRunningColor',
    unused: 'StatusUnusedColor',
    ready: 'StatusReadyColor',
    approved: 'StatusReadyColor',
    processing: 'StatusProcessingColor',
    updated: 'StatusExpiredColor',
    failed: 'StatusFailedColor',
    audiencematched: 'AudienceMatched',
    audiencelookalike: 'AudienceLookalike'
  };
  var loadTableData = useCallback(function () {
    setTableConfig({
      header: [{
        label: 'ID',
        sortingKey: 'id',
        className: '_id'
      }, {
        label: 'Audience Name',
        sortingKey: 'label',
        className: '_audienceName'
      }, {
        label: 'Created',
        sortingKey: 'createdDate',
        className: '_createdOn'
      }, {
        label: 'Status',
        className: '_status'
      }, {
        label: /*#__PURE__*/React__default.createElement(AllowlistBlocklistTooltip, {
          dimension: "audiences",
          tooltipProps: {
            disableAnimation: true,
            delayTime: 0
          }
        }),
        className: '_incExc'
      }],
      body: [{
        key: function key(audience) {
          return /*#__PURE__*/React__default.createElement("span", {
            className: getTextStyle(audience.listingType)
          }, audience.id);
        },
        className: '_id'
      }, {
        key: function key(audience) {
          var _AUDIENCES_ICONS$find2;

          return /*#__PURE__*/React__default.createElement("div", {
            className: styles$v.audienceName
          }, /*#__PURE__*/React__default.createElement(Tooltip, {
            label: audience.label,
            portal: true,
            className: styles$v.toolTip,
            labelMaxWidth: 300
          }, /*#__PURE__*/React__default.createElement("span", {
            className: styles$v.toolTipContent
          }, /*#__PURE__*/React__default.createElement("span", {
            className: "mr-2"
          }, /*#__PURE__*/React__default.createElement(Icon, {
            name: (_AUDIENCES_ICONS$find2 = AUDIENCES_ICONS.find(function (icon) {
              return icon.audienceTypeId === audience.audienceTypeId;
            })) === null || _AUDIENCES_ICONS$find2 === void 0 ? void 0 : _AUDIENCES_ICONS$find2.iconName,
            className: "_size-20"
          })), /*#__PURE__*/React__default.createElement("span", {
            className: "".concat(styles$v.nameComplete, " ").concat(getTextStyle(audience.listingType))
          }, audience.label))));
        },
        className: '_audienceName'
      }, {
        key: function key(audience) {
          return /*#__PURE__*/React__default.createElement("span", {
            className: getTextStyle(audience.listingType)
          }, moment$1.unix(audience.createdDate).tz('UTC').format('MM/DD/yyyy'));
        },
        className: '_createdOn'
      }, {
        key: function key(audience) {
          var _audience$status;

          return /*#__PURE__*/React__default.createElement("div", {
            className: "d-flex align-items-center "
          }, /*#__PURE__*/React__default.createElement("span", {
            className: "mr-1"
          }, /*#__PURE__*/React__default.createElement(Icon, {
            name: STATUS_MAP[audience.status.toLowerCase()],
            className: "_size-16"
          })), /*#__PURE__*/React__default.createElement("span", {
            className: getTextStyle(audience.listingType)
          }, ((_audience$status = audience.status) === null || _audience$status === void 0 ? void 0 : _audience$status.toLowerCase()) === APPROVED ? 'Ready' : capitalize(audience.status)));
        },
        className: '_status'
      }, {
        key: function key(audience) {
          return /*#__PURE__*/React__default.createElement("div", {
            className: "d-flex align-items-center"
          }, /*#__PURE__*/React__default.createElement(Pill, {
            label: audience.listingType === 'White' ? 'Allowed' : 'Blocked',
            className: audience.listingType === 'White' ? styles$v.successPill : styles$v.dangerPill
          }));
        },
        className: '_incExc'
      }],
      data: getAudienceItemsList('all').map(function (audience) {
        return {
          label: audience.label,
          id: audience.id,
          createdDate: audience.createdDate,
          status: audience.status,
          listingType: audience.listingType,
          audienceTypeId: audience.audienceTypeId
        };
      })
    });
  }, [campaign, getAudienceItemsList]);
  useEffect(function () {
    if (campaign !== null && campaign !== void 0 && campaign.blackListedAudienceIds || campaign !== null && campaign !== void 0 && campaign.whiteListedAudienceIds) {
      loadTableData();
    }
  }, [loadTableData, campaign]);
  var blackListedAudiencesCount = (_campaign$blackListed2 = campaign === null || campaign === void 0 ? void 0 : (_campaign$blackListed3 = campaign.blackListedAudienceIds) === null || _campaign$blackListed3 === void 0 ? void 0 : _campaign$blackListed3.split(',').length) !== null && _campaign$blackListed2 !== void 0 ? _campaign$blackListed2 : 0;
  var whiteListedAudiencesCount = (_campaign$whiteListed3 = campaign === null || campaign === void 0 ? void 0 : (_campaign$whiteListed4 = campaign.whiteListedAudienceIds) === null || _campaign$whiteListed4 === void 0 ? void 0 : _campaign$whiteListed4.split(',').length) !== null && _campaign$whiteListed3 !== void 0 ? _campaign$whiteListed3 : 0;
  var audienceType = selectedAudiences.audienceType,
      blackListed = selectedAudiences.blackListed,
      whiteListed = selectedAudiences.whiteListed;
  return /*#__PURE__*/React__default.createElement(CollapsibleBlock, {
    customStyle: {
      block: styles$v.section,
      blockTitleText: styles$v.blockTitleText,
      summaryContainer: styles$v.summaryContainer,
      summaryLabel: styles$v.summaryLabel,
      summaryValue: styles$v.summaryValue,
      panelHeaderExpand: styles$v.panelHeaderExpand,
      panelHeaderCollapse: styles$v.panelHeaderCollapse
    },
    id: "audience",
    header: {
      title: /*#__PURE__*/React__default.createElement("div", {
        className: styles$v.title
      }, /*#__PURE__*/React__default.createElement(Icon, {
        name: "CampaignsAudience"
      }), /*#__PURE__*/React__default.createElement(React__default.Fragment, null, "Audience ".concat(blackListedAudiencesCount + whiteListedAudiencesCount ? '(' + (blackListedAudiencesCount + whiteListedAudiencesCount).toString().padStart(2, '0') + ')' : ''))),
      summary: _objectSpread$v({
        Allowed: whiteListed.length ? whiteListed.length.toString().padStart(2, '0') : '0',
        Blocked: blackListed.length ? blackListed.length.toString().padStart(2, '0') : '0'
      }, getAudienceItemsList('all') ? {
        'Audience Type': audienceType.join(',')
      } : {})
    },
    isCollapseOpen: isBlockOpen,
    onToggle: onToggle,
    collapsible: true
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "col-12"
  }, campaign !== null && campaign !== void 0 && campaign.blackListedAudienceIds || campaign !== null && campaign !== void 0 && campaign.whiteListedAudienceIds ? /*#__PURE__*/React__default.createElement(Table, {
    className: styles$v.table,
    data: tableConfig.data,
    header: tableConfig.header,
    sorting: {
      field: 'createdDate',
      direction: 'desc'
    },
    body: tableConfig.body,
    rowKeyExtractor: function rowKeyExtractor(data) {
      return data.id;
    }
  }) : /*#__PURE__*/React__default.createElement("div", {
    className: styles$v.emptySection
  }, /*#__PURE__*/React__default.createElement("img", {
    className: styles$v.image,
    alt: "",
    src: "".concat(SVG_HOST_URL, "/misc/empty-section-teal.svg")
  }), /*#__PURE__*/React__default.createElement("div", {
    className: styles$v.text
  }, "No Audiences assigned yet"), /*#__PURE__*/React__default.createElement("div", {
    className: styles$v.subText
  }, "Click on edit to assign audience targeting for the campaign")))));
};

var css_248z$z = ":root {\n  --primary1: #123787;\n  --primary2: #1d58d7;\n  --primary3: #5173fb;\n  --primary4: #7a93ff;\n  --primary5: #c2d0ff;\n  --primary6: #e5ebff;\n  --primary7: #f2f5ff; }\n\n@keyframes index-module_hover-ripples__2vVPU {\n  0% {\n    top: -0.1875em;\n    left: -0.1875em;\n    right: -0.1875em;\n    bottom: -0.1875em;\n    opacity: 1; }\n  100% {\n    top: -0.8125em;\n    left: -0.8125em;\n    right: -0.8125em;\n    bottom: -0.8125em;\n    opacity: 0; } }\n\n.index-module_listItem__2z5uF {\n  display: flex;\n  margin-bottom: 0.4375rem;\n  align-items: center; }\n\n.index-module_listTitle__3NNkd {\n  font-family: 'Avenir Next Regular', sans-serif;\n  font-weight: normal;\n  letter-spacing: .2px;\n  color: #666666;\n  font-size: 0.75rem;\n  line-height: 1;\n  letter-spacing: 0.0125rem;\n  margin-right: 0.25rem; }\n\n.index-module_listValue__roFuB {\n  font-family: 'Avenir Next Regular', sans-serif;\n  font-weight: normal;\n  letter-spacing: .2px;\n  color: #000000;\n  font-size: 0.75rem;\n  line-height: 1rem; }\n\n.index-module_blockTitleText__kDhv9 {\n  font-family: 'Avenir Next Demi', sans-serif;\n  font-weight: normal;\n  font-size: 1rem;\n  line-height: 1.5em;\n  min-width: 7.75rem;\n  margin-right: 1rem;\n  display: flex; }\n\n.index-module_panelHeaderCollapse__3esE1 {\n  padding: 0;\n  cursor: pointer; }\n\n.index-module_panelHeaderExpand__3WWiq {\n  padding: 0;\n  cursor: pointer;\n  margin-bottom: 1rem; }\n\n.index-module_summaryContainer__1MEAv {\n  margin-right: 1rem;\n  display: inline; }\n\n.index-module_summaryLabel__3LOAK {\n  font-family: 'Avenir Next Regular', sans-serif;\n  font-weight: normal;\n  letter-spacing: .2px;\n  color: #a2a2a2;\n  font-size: 0.75rem;\n  line-height: 1;\n  letter-spacing: 0.0125rem; }\n\n.index-module_summaryValue__1rSnq {\n  font-family: 'Avenir Next Regular', sans-serif;\n  font-weight: normal;\n  letter-spacing: .2px;\n  font-size: 0.75rem;\n  line-height: 1;\n  letter-spacing: 0.0125rem; }\n\n.index-module_section__26Bga {\n  display: flex;\n  flex-direction: column;\n  padding-top: 1rem;\n  padding-left: 1.5rem;\n  margin-bottom: 0.9375rem;\n  width: 57.4375rem;\n  padding-right: 1.5rem;\n  padding-bottom: 1rem;\n  border-radius: 0.25rem !important;\n  box-shadow: 0 0.25rem 0.375rem rgba(0, 0, 0, 0.05), 0 0 0.5rem rgba(0, 0, 0, 0.04); }\n  .index-module_section__26Bga .index-module_title__1Y5cx {\n    font-family: 'Avenir Next Demi', sans-serif;\n    font-weight: normal;\n    font-weight: 600;\n    font-size: 0.875rem;\n    line-height: 1.125rem;\n    margin: auto 0 auto 0;\n    display: flex;\n    align-items: center; }\n    .index-module_section__26Bga .index-module_title__1Y5cx .svg-icon {\n      margin-right: 0.25rem; }\n      .index-module_section__26Bga .index-module_title__1Y5cx .svg-icon path {\n        fill: var(--primary2); }\n\n.index-module_toolTipText__3fFQg {\n  max-width: 25rem;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap; }\n\n.index-module_emptySection__1Zu20 {\n  display: flex;\n  align-items: center;\n  flex-direction: column; }\n  .index-module_emptySection__1Zu20 img {\n    margin-bottom: 0.5rem;\n    width: 15.625rem;\n    height: 12.3125rem; }\n  .index-module_emptySection__1Zu20 .index-module_text__2Jbs0 {\n    font-family: 'Avenir Next Demi', sans-serif;\n    font-weight: normal;\n    font-style: normal;\n    font-weight: 600;\n    font-size: 0.875rem;\n    line-height: 1;\n    color: #000000;\n    letter-spacing: 0.00625rem;\n    margin-bottom: 0.25rem; }\n    .index-module_emptySection__1Zu20 .index-module_text__2Jbs0 .index-module_subText__nZJeD {\n      font-family: 'Avenir Next Demi', sans-serif;\n      font-weight: normal;\n      font-style: normal;\n      font-weight: 400;\n      font-size: 0.8125rem;\n      line-height: 1;\n      color: #000000;\n      letter-spacing: 0.00625rem; }\n";
var styles$w = {"listItem":"index-module_listItem__2z5uF","listTitle":"index-module_listTitle__3NNkd","listValue":"index-module_listValue__roFuB","blockTitleText":"index-module_blockTitleText__kDhv9","panelHeaderCollapse":"index-module_panelHeaderCollapse__3esE1","panelHeaderExpand":"index-module_panelHeaderExpand__3WWiq","summaryContainer":"index-module_summaryContainer__1MEAv","summaryLabel":"index-module_summaryLabel__3LOAK","summaryValue":"index-module_summaryValue__1rSnq","section":"index-module_section__26Bga","title":"index-module_title__1Y5cx","toolTipText":"index-module_toolTipText__3fFQg","emptySection":"index-module_emptySection__1Zu20","text":"index-module_text__2Jbs0","subText":"index-module_subText__nZJeD","hover-ripples":"index-module_hover-ripples__2vVPU"};
styleInject(css_248z$z);

function ownKeys$w(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$w(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$w(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$w(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var CampaignPoliticalAdvertiser = function CampaignPoliticalAdvertiser(_ref) {
  var _advertiserInfo$0$lin, _advertiserInfo$;

  var campaign = _ref.campaign,
      isBlockOpen = _ref.isBlockOpen,
      onToggle = _ref.onToggle,
      onFetchAdvertisersError = _ref.onFetchAdvertisersError;

  var _useState = useState$2([]),
      _useState2 = _slicedToArray(_useState, 2),
      advertiserInfo = _useState2[0],
      setAdvertiserInfo = _useState2[1];

  useEffect(function () {
    if (campaign !== null && campaign !== void 0 && campaign.politicalAdvertiserClientId) {
      (function () {
        var _fetchAdvDetails = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee() {
          var response;
          return regenerator.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  _context.next = 2;
                  return fetchAdvertiserList(campaign === null || campaign === void 0 ? void 0 : campaign.politicalAdvertiserClientId, onFetchAdvertisersError);

                case 2:
                  response = _context.sent;

                  if (response.data) {
                    setAdvertiserInfo(response.data);
                  }

                case 4:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee);
        }));

        function fetchAdvDetails() {
          return _fetchAdvDetails.apply(this, arguments);
        }

        return fetchAdvDetails;
      })()();
    } // eslint-disable-next-line react-hooks/exhaustive-deps

  }, [campaign]);

  var getClippedValues = function getClippedValues(selectedValues) {
    return selectedValues.length > 2 ? selectedValues.slice(0, 2).join(', ').concat(" and ".concat(selectedValues.length - 2, " more")) : selectedValues.join(', ');
  };

  var getListItem = function getListItem(title, value) {
    var toolTipValue = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
    return /*#__PURE__*/React__default.createElement("div", {
      className: styles$w.listItem
    }, /*#__PURE__*/React__default.createElement("div", {
      className: styles$w.listTitle
    }, title, ":"), /*#__PURE__*/React__default.createElement("div", {
      className: styles$w.listValue
    }, toolTipValue ? /*#__PURE__*/React__default.createElement(Tooltip, {
      portal: true,
      label: toolTipValue
    }, /*#__PURE__*/React__default.createElement("div", {
      className: styles$w.toolTipText
    }, value)) : value));
  };

  var listItems = [].concat(_toConsumableArray(advertiserInfo !== null && advertiserInfo !== void 0 && advertiserInfo.length && advertiserInfo[0].advertiserName ? [{
    element: getListItem('Political Advertisers', advertiserInfo[0].advertiserName, advertiserInfo[0].advertiserName),
    key: 'politicalAdvertisers'
  }] : []), _toConsumableArray(advertiserInfo !== null && advertiserInfo !== void 0 && advertiserInfo.length && advertiserInfo[0].chiefName ? [{
    element: getListItem('Chief Name', advertiserInfo[0].chiefName, advertiserInfo[0].chiefName),
    key: 'chief'
  }] : []), _toConsumableArray(advertiserInfo !== null && advertiserInfo !== void 0 && advertiserInfo.length && advertiserInfo[0].address ? [{
    element: getListItem('Address', advertiserInfo[0].address, advertiserInfo[0].address),
    key: 'address'
  }] : []), _toConsumableArray(advertiserInfo !== null && advertiserInfo !== void 0 && advertiserInfo.length && advertiserInfo[0].contactNumber ? [{
    element: getListItem('Phone', advertiserInfo[0].contactNumber, advertiserInfo[0].contactNumber),
    key: 'contactNumber'
  }] : []), _toConsumableArray(advertiserInfo !== null && advertiserInfo !== void 0 && advertiserInfo.length && advertiserInfo[0].legalInfo ? [{
    element: getListItem('Other information as per federal or state law', advertiserInfo[0].legalInfo, advertiserInfo[0].legalInfo),
    key: 'legalInfo'
  }] : []), _toConsumableArray(advertiserInfo !== null && advertiserInfo !== void 0 && advertiserInfo.length && (_advertiserInfo$0$lin = advertiserInfo[0].links) !== null && _advertiserInfo$0$lin !== void 0 && _advertiserInfo$0$lin.length ? [{
    element: getListItem('Additional link', getClippedValues(advertiserInfo[0].links), advertiserInfo[0].links.join(',')),
    key: 'politicalAdvertisers'
  }] : []));
  return /*#__PURE__*/React__default.createElement(CollapsibleBlock, {
    customStyle: {
      block: styles$w.section,
      blockTitleText: styles$w.blockTitleText,
      summaryContainer: styles$w.summaryContainer,
      summaryLabel: styles$w.summaryLabel,
      summaryValue: styles$w.summaryValue,
      panelHeaderExpand: styles$w.panelHeaderExpand,
      panelHeaderCollapse: styles$w.panelHeaderCollapse
    },
    id: "advertiser",
    header: {
      title: /*#__PURE__*/React__default.createElement("div", {
        className: styles$w.title
      }, /*#__PURE__*/React__default.createElement(Icon, {
        name: "CampaignsStateLaw"
      }), "Political Advertiser Details"),
      summary: _objectSpread$w({}, advertiserInfo.length && (_advertiserInfo$ = advertiserInfo[0]) !== null && _advertiserInfo$ !== void 0 && _advertiserInfo$.advertiserName ? {
        'Full Name': advertiserInfo[0].advertiserName
      } : {})
    },
    isCollapseOpen: isBlockOpen,
    onToggle: onToggle,
    collapsible: true
  }, campaign !== null && campaign !== void 0 && campaign.politicalAdvertiserClientId ? /*#__PURE__*/React__default.createElement(DisplayItems, {
    type: "list",
    items: listItems
  }) : /*#__PURE__*/React__default.createElement("div", {
    className: styles$w.emptySection
  }, /*#__PURE__*/React__default.createElement("img", {
    className: styles$w.image,
    alt: "",
    src: "".concat(SVG_HOST_URL, "/misc/empty-section-teal.svg")
  }), /*#__PURE__*/React__default.createElement("div", {
    className: styles$w.text
  }, "No Political Advertiser assigned yet"), /*#__PURE__*/React__default.createElement("div", {
    className: styles$w.subText
  }, "Click on edit to assign political advertiser targeting for the campaign")));
};

var css_248z$A = ":root {\n  --primary1: #123787;\n  --primary2: #1d58d7;\n  --primary3: #5173fb;\n  --primary4: #7a93ff;\n  --primary5: #c2d0ff;\n  --primary6: #e5ebff;\n  --primary7: #f2f5ff; }\n\n@keyframes index-module_hover-ripples__4P-EO {\n  0% {\n    top: -0.1875em;\n    left: -0.1875em;\n    right: -0.1875em;\n    bottom: -0.1875em;\n    opacity: 1; }\n  100% {\n    top: -0.8125em;\n    left: -0.8125em;\n    right: -0.8125em;\n    bottom: -0.8125em;\n    opacity: 0; } }\n\n.index-module_blockTitleText__2unHt {\n  font-family: 'Avenir Next Demi', sans-serif;\n  font-weight: normal;\n  font-size: 1rem;\n  line-height: 1.5em;\n  min-width: 6.5rem;\n  display: flex; }\n\n.index-module_panelHeaderCollapse__34UHa {\n  padding: 0;\n  cursor: pointer; }\n\n.index-module_panelHeaderExpand__1NqfO {\n  padding: 0;\n  cursor: pointer;\n  margin-bottom: 1rem; }\n\n.index-module_summaryContainer__oBy0U {\n  margin-right: 1rem;\n  display: inline; }\n\n.index-module_summaryLabel__Fn-mf {\n  font-family: 'Avenir Next Regular', sans-serif;\n  font-weight: normal;\n  letter-spacing: .2px;\n  color: #a2a2a2;\n  font-size: 0.75rem;\n  line-height: 1;\n  letter-spacing: 0.0125rem; }\n\n.index-module_summaryValue__3xwqo {\n  font-family: 'Avenir Next Regular', sans-serif;\n  font-weight: normal;\n  letter-spacing: .2px;\n  font-size: 0.75rem;\n  line-height: 1;\n  letter-spacing: 0.0125rem; }\n\n.index-module_section__36ARY {\n  display: flex;\n  flex-direction: column;\n  padding-top: 1rem;\n  padding-left: 1.5rem;\n  width: 57.4375rem;\n  padding-right: 1.5rem;\n  padding-bottom: 1rem;\n  margin-bottom: 0.9375rem;\n  border-radius: 0.25rem !important;\n  box-shadow: 0 0.25rem 0.375rem rgba(0, 0, 0, 0.05), 0 0 0.5rem rgba(0, 0, 0, 0.04); }\n  .index-module_section__36ARY .index-module_title__1oqJW {\n    font-family: 'Avenir Next Demi', sans-serif;\n    font-weight: normal;\n    font-weight: 600;\n    font-size: 0.875rem;\n    line-height: 1.125rem;\n    margin: auto 0 auto 0;\n    display: flex;\n    align-items: center; }\n    .index-module_section__36ARY .index-module_title__1oqJW .svg-icon {\n      margin-right: 0.25rem; }\n      .index-module_section__36ARY .index-module_title__1oqJW .svg-icon path {\n        fill: var(--primary2); }\n\n.index-module_creativeHeader__3bAEJ {\n  margin-top: 0.3125rem;\n  display: flex;\n  align-items: center; }\n  .index-module_creativeHeader__3bAEJ .svg-icon {\n    margin-right: 0.25rem; }\n    .index-module_creativeHeader__3bAEJ .svg-icon path {\n      fill: var(--primary2); }\n  .index-module_creativeHeader__3bAEJ .index-module_creativeId__3WSA7 {\n    font-family: 'Avenir Next Demi', sans-serif;\n    font-weight: normal;\n    font-weight: 600;\n    font-size: 0.875rem;\n    line-height: 1;\n    margin-left: 0.25rem; }\n  .index-module_creativeHeader__3bAEJ .index-module_creativeName__2ogL0 {\n    font-family: 'Avenir Next Regular', sans-serif;\n    font-weight: normal;\n    letter-spacing: .2px;\n    color: #000000;\n    font-size: 0.875rem;\n    line-height: 1;\n    letter-spacing: 0.00625rem;\n    margin-left: 0.4375rem;\n    font-weight: 400;\n    max-width: 18.75rem;\n    overflow: hidden;\n    white-space: nowrap;\n    text-overflow: ellipsis; }\n    .index-module_creativeHeader__3bAEJ .index-module_creativeName__2ogL0::after {\n      content: '';\n      display: block; }\n\n.index-module_creativeSubHeader__3nFF8 {\n  display: flex;\n  align-items: center;\n  margin-bottom: 0.625rem; }\n  .index-module_creativeSubHeader__3nFF8 .svg-icon {\n    margin-right: 0.25rem;\n    width: 1.125rem; }\n  .index-module_creativeSubHeader__3nFF8 .index-module_infoItem__1XhZG {\n    display: flex;\n    align-items: center;\n    position: relative; }\n    .index-module_creativeSubHeader__3nFF8 .index-module_infoItem__1XhZG:not(:last-child) {\n      margin-right: 1.625rem; }\n      .index-module_creativeSubHeader__3nFF8 .index-module_infoItem__1XhZG:not(:last-child):after {\n        content: '';\n        position: absolute;\n        top: 50%;\n        left: calc(100% + 0.75rem);\n        margin-top: -0.1875rem;\n        margin-left: -0.1875rem;\n        width: 0.375rem;\n        height: 0.375rem;\n        border-radius: 50%;\n        background-color: #cbcbcb; }\n    .index-module_creativeSubHeader__3nFF8 .index-module_infoItemLabel__3NaYa {\n      font-family: 'Avenir Next Regular', sans-serif;\n      font-weight: normal;\n      letter-spacing: .2px;\n      color: #666666;\n      font-size: 0.75rem;\n      line-height: 1;\n      letter-spacing: 0.00625rem;\n      margin-right: 0.25rem; }\n    .index-module_creativeSubHeader__3nFF8 .index-module_infoItemValue__1p_cI {\n      font-family: 'Avenir Next Regular', sans-serif;\n      font-weight: normal;\n      letter-spacing: .2px;\n      color: #000000;\n      font-size: 0.75rem;\n      line-height: 1;\n      letter-spacing: 0.00625rem;\n      margin-right: 0.25rem; }\n\n.index-module_thumbNail__3pqnp {\n  object-fit: contain;\n  width: 12.5rem;\n  height: 6.25rem; }\n\n.index-module_creativeURL__3WJfv {\n  font-family: 'Avenir Next Regular', sans-serif;\n  font-weight: normal;\n  letter-spacing: .2px;\n  color: #666666;\n  font-size: 0.75rem;\n  line-height: 1;\n  letter-spacing: 0.00625rem;\n  margin-right: 0.25rem;\n  margin-top: 1.5rem; }\n\n.index-module_creativeURLValue__1Avrj {\n  font-family: 'Avenir Next Regular', sans-serif;\n  font-weight: normal;\n  letter-spacing: .2px;\n  display: flex;\n  align-items: center;\n  margin-top: 0.5rem;\n  color: #000000;\n  font-size: 0.75rem;\n  line-height: 1;\n  letter-spacing: 0.00625rem;\n  margin-right: 0.25rem; }\n  .index-module_creativeURLValue__1Avrj .svg-icon {\n    width: 1rem; }\n  .index-module_creativeURLValue__1Avrj .index-module_clickableIcon__1OZnY {\n    cursor: pointer; }\n  .index-module_creativeURLValue__1Avrj .index-module_text__1GyUx {\n    max-width: 6.25rem;\n    overflow: hidden;\n    white-space: nowrap;\n    text-overflow: ellipsis; }\n    .index-module_creativeURLValue__1Avrj .index-module_text__1GyUx::after {\n      content: '';\n      display: block; }\n\n.index-module_endLine__SH4R_ {\n  width: 100%;\n  height: 0;\n  border: 0.2px solid #e7e7e7;\n  display: inline-block; }\n";
var styles$x = {"blockTitleText":"index-module_blockTitleText__2unHt","panelHeaderCollapse":"index-module_panelHeaderCollapse__34UHa","panelHeaderExpand":"index-module_panelHeaderExpand__1NqfO","summaryContainer":"index-module_summaryContainer__oBy0U","summaryLabel":"index-module_summaryLabel__Fn-mf","summaryValue":"index-module_summaryValue__3xwqo","section":"index-module_section__36ARY","title":"index-module_title__1oqJW","creativeHeader":"index-module_creativeHeader__3bAEJ","creativeId":"index-module_creativeId__3WSA7","creativeName":"index-module_creativeName__2ogL0","creativeSubHeader":"index-module_creativeSubHeader__3nFF8","infoItem":"index-module_infoItem__1XhZG","infoItemLabel":"index-module_infoItemLabel__3NaYa","infoItemValue":"index-module_infoItemValue__1p_cI","thumbNail":"index-module_thumbNail__3pqnp","creativeURL":"index-module_creativeURL__3WJfv","creativeURLValue":"index-module_creativeURLValue__1Avrj","clickableIcon":"index-module_clickableIcon__1OZnY","text":"index-module_text__1GyUx","endLine":"index-module_endLine__SH4R_","hover-ripples":"index-module_hover-ripples__4P-EO"};
styleInject(css_248z$A);

var CampaignCreatives = function CampaignCreatives(_ref) {
  var campaign = _ref.campaign,
      isBlockOpen = _ref.isBlockOpen,
      onToggle = _ref.onToggle,
      onLinkCopy = _ref.onLinkCopy,
      onFetchCreativesDetailsError = _ref.onFetchCreativesDetailsError;

  var _useState = useState$2([]),
      _useState2 = _slicedToArray(_useState, 2),
      creativesInfo = _useState2[0],
      setCreativesInfo = _useState2[1];

  var _useState3 = useState$2([]),
      _useState4 = _slicedToArray(_useState3, 2),
      creativePreviewURL = _useState4[0],
      setCreativePreviewURL = _useState4[1];

  useEffect(function () {
    if (campaign !== null && campaign !== void 0 && campaign.creativeIds) {
      (function () {
        var _fetchAdvDetails = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee() {
          var response, urls;
          return regenerator.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  _context.next = 2;
                  return fetchCreativesDetails({
                    campaignIds: campaign.id.toString()
                  }, onFetchCreativesDetailsError);

                case 2:
                  response = _context.sent;

                  if (response !== null && response !== void 0 && response.length) {
                    urls = response.map(function (creative) {
                      return {
                        id: creative.creativeId,
                        url: creative.creativeCardSource || creative.creativeThumbnailSource
                      };
                    });
                    setCreativePreviewURL(urls);
                    setCreativesInfo(response);
                  }

                case 4:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee);
        }));

        function fetchAdvDetails() {
          return _fetchAdvDetails.apply(this, arguments);
        }

        return fetchAdvDetails;
      })()();
    } // eslint-disable-next-line react-hooks/exhaustive-deps

  }, [campaign]);
  var creativeIconMap = {
    11: 'CreativeImage',
    13: 'CreativeHtml',
    14: 'CreativeVideo',
    16: 'CreativeTicker',
    17: 'CreativeAudio',
    18: 'CreativeGotv'
  };
  var adPlacementOptions = [{
    value: 0,
    label: 'Any'
  }, {
    value: 11,
    label: 'Pre-Roll'
  }, {
    value: 13,
    label: 'Post-Roll'
  }, {
    value: 12,
    label: 'Mid-Roll'
  }];

  var onCopyIconClick = function onCopyIconClick(code) {
    var input = document.createElement('textarea');
    input.value = code;
    document.body.appendChild(input);
    input.select();
    document.execCommand('copy');
    document.body.removeChild(input);
    onLinkCopy === null || onLinkCopy === void 0 ? void 0 : onLinkCopy();
  };

  var STATUS_MAP = {
    running: 'StatusRunningColor',
    pending: 'StatusPendingColor',
    'pending for approval': 'StatusPendingColor',
    paused: 'StatusPausedColor',
    draft: 'StatusDraftColor',
    budget_paused: 'StatusBudgetPausedColor',
    deleted: 'StatusDeletedColor',
    expired: 'StatusExpiredColor',
    rejected: 'StatusRejectedColor',
    ready: 'StatusReadyColor',
    approved: 'StatusReadyColor',
    processing: 'StatusProcessingColor',
    updated: 'StatusExpiredColor',
    failed: 'StatusFailedColor'
  };
  return /*#__PURE__*/React__default.createElement(CollapsibleBlock, {
    customStyle: {
      block: styles$x.section,
      blockTitleText: styles$x.blockTitleText,
      summaryContainer: styles$x.summaryContainer,
      summaryLabel: styles$x.summaryLabel,
      summaryValue: styles$x.summaryValue,
      panelHeaderExpand: styles$x.panelHeaderExpand,
      panelHeaderCollapse: styles$x.panelHeaderCollapse
    },
    id: "creatives",
    header: {
      title: /*#__PURE__*/React__default.createElement("div", {
        className: styles$x.title
      }, /*#__PURE__*/React__default.createElement(Icon, {
        name: "CampaignsCreative"
      }), "Creatives (".concat(campaign === null || campaign === void 0 ? void 0 : campaign.creativeIds.split(',').length.toString().padStart(2, '0'), ")"))
    },
    isCollapseOpen: isBlockOpen,
    onToggle: onToggle,
    collapsible: true
  }, creativesInfo.length ? /*#__PURE__*/React__default.createElement(React__default.Fragment, null, creativesInfo.map(function (creative) {
    var _creative$pixelUrls;

    return /*#__PURE__*/React__default.createElement("div", {
      key: creative.creativeId
    }, /*#__PURE__*/React__default.createElement("div", {
      className: styles$x.creativeHeader
    }, /*#__PURE__*/React__default.createElement(Icon, {
      name: creativeIconMap[creative.creativeTypeId.toString()]
    }), /*#__PURE__*/React__default.createElement("div", {
      className: styles$x.creativeId
    }, creative.creativeId), /*#__PURE__*/React__default.createElement(Tooltip, {
      label: creative.creativeName,
      portal: true
    }, /*#__PURE__*/React__default.createElement("div", {
      className: styles$x.creativeName
    }, creative.creativeName))), /*#__PURE__*/React__default.createElement("div", {
      className: styles$x.creativeSubHeader
    }, /*#__PURE__*/React__default.createElement("div", {
      className: styles$x.infoItem
    }, /*#__PURE__*/React__default.createElement("div", {
      className: styles$x.infoItemLabel
    }, "Type:"), /*#__PURE__*/React__default.createElement("div", {
      className: styles$x.infoItemValue
    }, capitalize(creative.creativeType))), /*#__PURE__*/React__default.createElement("div", {
      className: styles$x.infoItem
    }, /*#__PURE__*/React__default.createElement("div", {
      className: styles$x.infoItemLabel
    }, "Created on:"), /*#__PURE__*/React__default.createElement("div", {
      className: styles$x.infoItemValue
    }, moment(creative.createdOn * 1000).format('MM/DD/YYYY'))), creative.width && creative.height && /*#__PURE__*/React__default.createElement("div", {
      className: styles$x.infoItem
    }, /*#__PURE__*/React__default.createElement("div", {
      className: styles$x.infoItemLabel
    }, "Size:"), /*#__PURE__*/React__default.createElement("div", {
      className: styles$x.infoItemValue
    }, creative.width.toString() + ' X ' + creative.height.toString())), /*#__PURE__*/React__default.createElement("div", {
      className: styles$x.infoItem
    }, /*#__PURE__*/React__default.createElement("div", {
      className: styles$x.infoItemLabel
    }, "Status:"), /*#__PURE__*/React__default.createElement("div", {
      className: styles$x.infoItemValue
    }, /*#__PURE__*/React__default.createElement(Icon, {
      name: STATUS_MAP[creative.status]
    }), creative.status === 'approved' ? 'Ready' : capitalize(creative.status)))), /*#__PURE__*/React__default.createElement(DisplayItems, {
      type: "grid",
      gridColumnCount: 3,
      gridClassName: styles$x.grid,
      items: [{
        key: "".concat(creative.creativeId, "_thumbnail"),
        element: /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("img", {
          className: styles$x.thumbNail,
          src: creativePreviewURL.find(function (item) {
            return item.id === creative.creativeId;
          }).url,
          alt: creative.creativeName,
          onError: function onError() {
            var _creative$creativeTyp;

            var urls = creativePreviewURL.filter(function (item) {
              return item.id !== creative.creativeId;
            });
            urls.push({
              id: creative.creativeId,
              url: "".concat(SVG_HOST_URL, "/creatives/default-thumbnails/").concat((_creative$creativeTyp = creative.creativeType) === null || _creative$creativeTyp === void 0 ? void 0 : _creative$creativeTyp.toLowerCase(), "-tableview.svg")
            });
            setCreativePreviewURL(urls);
          }
        }))
      }, {
        key: "".concat(creative.creativeId, "_clickURL"),
        element: /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("div", {
          className: styles$x.creativeURL
        }, "Click URL"), /*#__PURE__*/React__default.createElement("div", {
          className: styles$x.creativeURLValue
        }, creative.clickUrl ? /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(Tooltip, {
          label: creative.clickUrl,
          portal: true
        }, /*#__PURE__*/React__default.createElement("div", {
          className: styles$x.text
        }, creative.clickUrl)), /*#__PURE__*/React__default.createElement("div", {
          className: styles$x.clickableIcon,
          onClick: function onClick() {
            return onCopyIconClick(creative.clickUrl);
          }
        }, /*#__PURE__*/React__default.createElement(Tooltip, {
          label: "Copy Link",
          portal: true
        }, /*#__PURE__*/React__default.createElement(Icon, {
          name: "Copy"
        }))), /*#__PURE__*/React__default.createElement("div", {
          className: styles$x.clickableIcon,
          onClick: function onClick() {
            return window.open(creative.clickUrl, '_blank');
          }
        }, /*#__PURE__*/React__default.createElement(Tooltip, {
          label: "Open Link",
          portal: true
        }, /*#__PURE__*/React__default.createElement(Icon, {
          name: "OpenLink"
        })))) : /*#__PURE__*/React__default.createElement("div", {
          className: styles$x.text
        }, "-")))
      }].concat(_toConsumableArray(campaign.creativeType === 11 ? [{
        key: "".concat(creative.creativeId, "_pixelURL"),
        element: /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("div", {
          className: styles$x.creativeURL
        }, "Pixel URL"), /*#__PURE__*/React__default.createElement("div", {
          className: styles$x.creativeURLValue
        }, (_creative$pixelUrls = creative.pixelUrls) !== null && _creative$pixelUrls !== void 0 && _creative$pixelUrls.length ? /*#__PURE__*/React__default.createElement(Tooltip, {
          label: creative.pixelUrls.join(','),
          portal: true
        }, /*#__PURE__*/React__default.createElement("div", {
          className: styles$x.text
        }, creative.pixelUrls.join(','))) : null, !creative.pixelUrls ? /*#__PURE__*/React__default.createElement("div", {
          className: styles$x.text
        }, "-") : null, creative.pixelUrls && /*#__PURE__*/React__default.createElement("div", {
          className: styles$x.clickableIcon,
          onClick: function onClick() {
            return onCopyIconClick(creative.pixelUrls.join(','));
          }
        }, /*#__PURE__*/React__default.createElement(Tooltip, {
          label: "Copy Link",
          portal: true
        }, /*#__PURE__*/React__default.createElement(Icon, {
          name: "Copy"
        }))), creative.pixelUrls && /*#__PURE__*/React__default.createElement("div", {
          className: styles$x.clickableIcon,
          onClick: function onClick() {
            return window.open(creative.pixelUrls[0], '_blank');
          }
        }, /*#__PURE__*/React__default.createElement(Tooltip, {
          label: "Open Link",
          portal: true
        }, /*#__PURE__*/React__default.createElement(Icon, {
          name: "OpenLink"
        })))))
      }] : []), _toConsumableArray(campaign.creativeType === 14 || campaign.creativeType === 17 ? [{
        key: "".concat(creative.creativeId, "_adPlacement"),
        element: /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("div", {
          className: styles$x.creativeURL
        }, "Ad Placement"), /*#__PURE__*/React__default.createElement("div", {
          className: styles$x.creativeURLValue
        }, campaign.creativesPlacementMapping ? adPlacementOptions.find(function (option) {
          return option.value === campaign.creativesPlacementMapping[creative.creativeId];
        }).label : '-'))
      }] : []))
    }), /*#__PURE__*/React__default.createElement("div", {
      className: styles$x.endLine
    }));
  })) : null);
};

var css_248z$B = ":root {\n  --primary1: #123787;\n  --primary2: #1d58d7;\n  --primary3: #5173fb;\n  --primary4: #7a93ff;\n  --primary5: #c2d0ff;\n  --primary6: #e5ebff;\n  --primary7: #f2f5ff; }\n\n@keyframes index-module_hover-ripples__1qksF {\n  0% {\n    top: -0.1875em;\n    left: -0.1875em;\n    right: -0.1875em;\n    bottom: -0.1875em;\n    opacity: 1; }\n  100% {\n    top: -0.8125em;\n    left: -0.8125em;\n    right: -0.8125em;\n    bottom: -0.8125em;\n    opacity: 0; } }\n\n.index-module_section__xmN_o {\n  display: flex;\n  flex-direction: column;\n  padding: 1rem;\n  width: 57.4375rem;\n  margin-bottom: 0.9375rem;\n  border-radius: 0.25rem !important;\n  box-shadow: 0rem 0.25rem 0.375rem rgba(0, 0, 0, 0.05), 0rem 0rem 0.5rem rgba(0, 0, 0, 0.04); }\n  .index-module_section__xmN_o .index-module_title__1Jsf1 {\n    font-family: 'Avenir Next Demi', sans-serif;\n    font-weight: normal;\n    font-weight: 600;\n    font-size: 0.875rem;\n    line-height: 1.125rem;\n    margin: auto 0 auto 0;\n    display: flex;\n    align-items: center; }\n    .index-module_section__xmN_o .index-module_title__1Jsf1 .svg-icon {\n      margin-right: 0.25rem; }\n      .index-module_section__xmN_o .index-module_title__1Jsf1 .svg-icon path {\n        fill: var(--primary2); }\n\n.index-module_blockTitleText__aLf-F {\n  font-family: 'Avenir Next Demi', sans-serif;\n  font-weight: normal;\n  font-size: 1rem;\n  line-height: 1.5em;\n  min-width: 3.5rem;\n  margin-right: 1rem;\n  display: flex; }\n\n.index-module_panelHeaderCollapse__2HR5d {\n  padding: 0;\n  cursor: pointer; }\n\n.index-module_panelHeaderExpand__gTYix {\n  padding: 0;\n  cursor: pointer;\n  margin-bottom: 1rem; }\n\n.index-module_summaryContainer__3J7Uo {\n  margin-right: 1rem;\n  display: inline; }\n\n.index-module_summaryLabel__1yA4s {\n  font-family: 'Avenir Next Regular', sans-serif;\n  font-weight: normal;\n  letter-spacing: .2px;\n  color: #a2a2a2;\n  font-size: 0.75rem;\n  line-height: 1;\n  letter-spacing: 0.0125rem; }\n\n.index-module_summaryValue__1WyJS {\n  font-family: 'Avenir Next Regular', sans-serif;\n  font-weight: normal;\n  letter-spacing: .2px;\n  font-size: 0.75rem;\n  line-height: 1;\n  letter-spacing: 0.0125rem; }\n\n.index-module_blackListTextColor__1Y61W {\n  color: #f1494a; }\n\n.index-module_table__1glTi [class*='containerRightScroller'] {\n  max-height: 21.875rem;\n  overflow-y: auto;\n  overflow-x: hidden; }\n  .index-module_table__1glTi [class*='containerRightScroller'] thead {\n    position: sticky;\n    top: 0;\n    z-index: 1; }\n\n.index-module_table__1glTi .table__top {\n  min-height: 1.125rem; }\n\n.index-module_table__1glTi [class*='_grpName'] {\n  min-width: 12.5rem;\n  width: 12.5rem; }\n\n.index-module_table__1glTi [class*='_keywords'] {\n  min-width: 8.4375rem;\n  width: 8.4375rem; }\n  .index-module_table__1glTi [class*='_keywords'] .td-content-inner {\n    margin-left: auto; }\n\n.index-module_table__1glTi [class*='_urls'] {\n  min-width: 8.4375rem;\n  width: 8.4375rem; }\n  .index-module_table__1glTi [class*='_urls'] .td-content-inner {\n    margin-left: auto; }\n\n.index-module_table__1glTi [class*='_deals'] {\n  min-width: 8.4375rem;\n  width: 8.4375rem; }\n  .index-module_table__1glTi [class*='_deals'] .td-content-inner {\n    margin-left: auto; }\n\n.index-module_table__1glTi [class*='_openExchange'] {\n  min-width: 8.4375rem;\n  width: 8.4375rem; }\n  .index-module_table__1glTi [class*='_openExchange'] .td-content-inner {\n    margin-left: auto; }\n\n.index-module_table__1glTi [class*='_incExc'] {\n  min-width: 5rem;\n  width: 5rem; }\n  .index-module_table__1glTi [class*='_incExc'] .td-content-inner {\n    margin-right: auto; }\n  .index-module_table__1glTi [class*='_incExc'] .td-content-inner {\n    margin-left: auto; }\n\n.index-module_inventoryGroupName__bSsV8 {\n  display: flex;\n  align-items: center;\n  cursor: pointer; }\n  .index-module_inventoryGroupName__bSsV8 .index-module_toolTipContent__2cWWF {\n    display: flex;\n    align-items: center;\n    margin-top: 0rem; }\n  .index-module_inventoryGroupName__bSsV8 .index-module_toolTip__2k8T6 {\n    position: absolute; }\n  .index-module_inventoryGroupName__bSsV8 .index-module_nameComplete__18XQN {\n    display: inline-block;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    width: 11.25rem; }\n    .index-module_inventoryGroupName__bSsV8 .index-module_nameComplete__18XQN::after {\n      content: '';\n      display: block; }\n\n.index-module_successPill__8Ed6B {\n  font-family: 'Avenir Next Demi', sans-serif;\n  font-weight: normal;\n  letter-spacing: .2px;\n  margin-left: 0.5rem;\n  height: 1.5625rem;\n  color: #289679; }\n\n.index-module_dangerPill__EHxOs {\n  font-family: 'Avenir Next Demi', sans-serif;\n  font-weight: normal;\n  letter-spacing: .2px;\n  margin-left: 0.5rem;\n  height: 1.5625rem;\n  color: #f1494a; }\n\n.index-module_excluded__k8kZ5 {\n  color: #f1494a; }\n\n.index-module_emptySection__34crQ {\n  display: flex;\n  align-items: center;\n  flex-direction: column; }\n  .index-module_emptySection__34crQ img {\n    margin-bottom: 0.5rem;\n    width: 15.625rem;\n    height: 12.3125rem; }\n  .index-module_emptySection__34crQ .index-module_text__1m3bz {\n    font-family: 'Avenir Next Demi', sans-serif;\n    font-weight: normal;\n    font-style: normal;\n    font-weight: 600;\n    font-size: 0.875rem;\n    line-height: 1;\n    color: #000000;\n    letter-spacing: 0.00625rem;\n    margin-bottom: 0.25rem; }\n  .index-module_emptySection__34crQ .index-module_subText__2qCFP {\n    font-family: 'Avenir Next Regular', sans-serif;\n    font-weight: normal;\n    font-style: normal;\n    font-weight: 400;\n    font-size: 0.8125rem;\n    line-height: 1;\n    color: #000000;\n    letter-spacing: 0.00625rem; }\n";
var styles$y = {"section":"index-module_section__xmN_o","title":"index-module_title__1Jsf1","blockTitleText":"index-module_blockTitleText__aLf-F","panelHeaderCollapse":"index-module_panelHeaderCollapse__2HR5d","panelHeaderExpand":"index-module_panelHeaderExpand__gTYix","summaryContainer":"index-module_summaryContainer__3J7Uo","summaryLabel":"index-module_summaryLabel__1yA4s","summaryValue":"index-module_summaryValue__1WyJS","blackListTextColor":"index-module_blackListTextColor__1Y61W","table":"index-module_table__1glTi","inventoryGroupName":"index-module_inventoryGroupName__bSsV8","toolTipContent":"index-module_toolTipContent__2cWWF","toolTip":"index-module_toolTip__2k8T6","nameComplete":"index-module_nameComplete__18XQN","successPill":"index-module_successPill__8Ed6B","dangerPill":"index-module_dangerPill__EHxOs","excluded":"index-module_excluded__k8kZ5","emptySection":"index-module_emptySection__34crQ","text":"index-module_text__1m3bz","subText":"index-module_subText__2qCFP","hover-ripples":"index-module_hover-ripples__1qksF"};
styleInject(css_248z$B);

var CampaignInventory = function CampaignInventory(props) {
  var campaign = props.campaign,
      isBlockOpen = props.isBlockOpen,
      onToggle = props.onToggle,
      onFetchInventoryGroupDetailsError = props.onFetchInventoryGroupDetailsError;

  var _useState = useState$2([]),
      _useState2 = _slicedToArray(_useState, 2),
      inventoryGroupsInfo = _useState2[0],
      setInventoryGroupsInfo = _useState2[1];

  var _useState3 = useState$2({
    header: [],
    body: [],
    data: []
  }),
      _useState4 = _slicedToArray(_useState3, 2),
      tableConfig = _useState4[0],
      setTableConfig = _useState4[1];

  var fetchInventoryGroupsInfo = useCallback(function () {
    if (campaign !== null && campaign !== void 0 && campaign.blackListedInventoryGroupIds || campaign !== null && campaign !== void 0 && campaign.whiteListedInventoryGroupIds) {
      _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee() {
        var queryStringId, response;
        return regenerator.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                queryStringId = '';

                if (campaign !== null && campaign !== void 0 && campaign.whiteListedInventoryGroupIds) {
                  queryStringId = campaign === null || campaign === void 0 ? void 0 : campaign.whiteListedInventoryGroupIds;
                }

                if (campaign !== null && campaign !== void 0 && campaign.blackListedInventoryGroupIds) {
                  queryStringId = campaign !== null && campaign !== void 0 && campaign.whiteListedInventoryGroupIds ? queryStringId.concat(',').concat(campaign === null || campaign === void 0 ? void 0 : campaign.blackListedInventoryGroupIds) : campaign === null || campaign === void 0 ? void 0 : campaign.blackListedInventoryGroupIds;
                }

                _context.next = 5;
                return fetchInventoryGroupDetails({
                  groupIds: queryStringId,
                  pageNo: -1,
                  includeContextualCount: true
                }, onFetchInventoryGroupDetailsError);

              case 5:
                response = _context.sent;
                setInventoryGroupsInfo(response);

              case 7:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    } // eslint-disable-next-line react-hooks/exhaustive-deps

  }, [campaign]);
  useEffect(function () {
    fetchInventoryGroupsInfo();
  }, [fetchInventoryGroupsInfo]);
  var loadTableData = useCallback(function () {
    setTableConfig({
      header: [{
        label: 'Inventory Group Name',
        sortingKey: 'name',
        className: '_grpName'
      }, {
        label: 'Open Exchange',
        sortingKey: 'exchanges',
        className: '_openExchange'
      }, {
        label: 'Private Deals',
        sortingKey: 'deals',
        className: '_deals'
      }, {
        label: 'Keywords',
        sortingKey: 'keywords',
        className: '_keywords'
      }, {
        label: 'URLs',
        sortingKey: 'urls',
        className: '_urls'
      }, {
        label: /*#__PURE__*/React__default.createElement(AllowlistBlocklistTooltip, {
          dimension: "inventories",
          tooltipProps: {
            disableAnimation: true,
            delayTime: 0
          }
        }),
        className: '_incExc'
      }],
      body: [{
        key: function key(invGrp) {
          return /*#__PURE__*/React__default.createElement("div", {
            className: "".concat(styles$y.inventoryGroupName)
          }, /*#__PURE__*/React__default.createElement(Tooltip, {
            label: invGrp.name,
            className: styles$y.toolTip,
            labelMaxWidth: 300,
            portal: true
          }, /*#__PURE__*/React__default.createElement("span", {
            className: styles$y.toolTipContent
          }, /*#__PURE__*/React__default.createElement("span", {
            className: "".concat(styles$y.nameComplete, " ").concat(invGrp.isExcluded ? styles$y.excluded : styles$y.included)
          }, invGrp.name))));
        },
        className: '_grpName'
      }, {
        key: function key(invGrp) {
          return /*#__PURE__*/React__default.createElement("span", {
            className: invGrp.isExcluded ? styles$y.excluded : styles$y.included
          }, invGrp.exchanges);
        },
        className: '_openExchange'
      }, {
        key: function key(invGrp) {
          return /*#__PURE__*/React__default.createElement("span", {
            className: invGrp.isExcluded ? styles$y.excluded : styles$y.included
          }, invGrp.deals);
        },
        className: '_deals'
      }, {
        key: function key(invGrp) {
          return /*#__PURE__*/React__default.createElement("span", {
            className: invGrp.isExcluded ? styles$y.excluded : styles$y.included
          }, invGrp.keywords);
        },
        className: '_keywords'
      }, {
        key: function key(invGrp) {
          return /*#__PURE__*/React__default.createElement("span", {
            className: invGrp.isExcluded ? styles$y.excluded : styles$y.included
          }, invGrp.urls);
        },
        className: '_urls'
      }, {
        key: function key(invGrp) {
          return /*#__PURE__*/React__default.createElement("div", {
            className: "d-flex align-items-center"
          }, /*#__PURE__*/React__default.createElement(Pill, {
            label: !invGrp.isExcluded ? 'Allowed' : 'Blocked',
            className: !invGrp.isExcluded ? styles$y.successPill : styles$y.dangerPill
          }));
        },
        className: '_incExc'
      }],
      data: inventoryGroupsInfo.map(function (invGrp) {
        var _campaign$blackListed;

        return {
          id: invGrp.id,
          name: invGrp.name,
          exchanges: invGrp.inventories,
          keywords: invGrp.keywords,
          urls: invGrp.urls,
          deals: invGrp.deals,
          isExcluded: campaign === null || campaign === void 0 ? void 0 : (_campaign$blackListed = campaign.blackListedInventoryGroupIds) === null || _campaign$blackListed === void 0 ? void 0 : _campaign$blackListed.split(',').includes(invGrp.id.toString())
        };
      })
    });
  }, [campaign, inventoryGroupsInfo]);
  useEffect(function () {
    if ((campaign !== null && campaign !== void 0 && campaign.blackListedInventoryGroupIds || campaign !== null && campaign !== void 0 && campaign.whiteListedInventoryGroupIds) && inventoryGroupsInfo !== null && inventoryGroupsInfo !== void 0 && inventoryGroupsInfo.length) {
      loadTableData();
    }
  }, [loadTableData, campaign, inventoryGroupsInfo]);
  return /*#__PURE__*/React__default.createElement(CollapsibleBlock, {
    customStyle: {
      block: styles$y.section,
      blockTitleText: styles$y.blockTitleText,
      summaryContainer: styles$y.summaryContainer,
      summaryLabel: styles$y.summaryLabel,
      summaryValue: styles$y.summaryValue,
      panelHeaderExpand: styles$y.panelHeaderExpand,
      panelHeaderCollapse: styles$y.panelHeaderCollapse
    },
    id: "inventory",
    header: {
      title: /*#__PURE__*/React__default.createElement("div", {
        className: styles$y.title
      }, /*#__PURE__*/React__default.createElement(Icon, {
        name: "CampaignsInventory"
      }), /*#__PURE__*/React__default.createElement(React__default.Fragment, null, "Inventory"))
    },
    isCollapseOpen: isBlockOpen,
    onToggle: onToggle,
    collapsible: true
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "col-12"
  }, campaign !== null && campaign !== void 0 && campaign.blackListedInventoryGroupIds || campaign !== null && campaign !== void 0 && campaign.whiteListedInventoryGroupIds ? /*#__PURE__*/React__default.createElement(Table, {
    className: styles$y.table,
    data: tableConfig.data,
    header: tableConfig.header,
    body: tableConfig.body,
    rowKeyExtractor: function rowKeyExtractor(data) {
      return data.id;
    }
  }) : /*#__PURE__*/React__default.createElement("div", {
    className: styles$y.emptySection
  }, /*#__PURE__*/React__default.createElement("img", {
    className: styles$y.image,
    alt: "",
    src: "".concat(SVG_HOST_URL, "/misc/empty-section-teal.svg")
  }), /*#__PURE__*/React__default.createElement("div", {
    className: styles$y.text
  }, "No Inventory assigned yet"), /*#__PURE__*/React__default.createElement("div", {
    className: styles$y.subText
  }, "Click on edit to assign inventory targeting for the campaign")))));
};

var objectWithoutPropertiesLoose = createCommonjsModule(function (module) {
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

module.exports = _objectWithoutPropertiesLoose, module.exports.__esModule = true, module.exports["default"] = module.exports;
});

unwrapExports(objectWithoutPropertiesLoose);

var objectWithoutProperties = createCommonjsModule(function (module) {
function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = objectWithoutPropertiesLoose(source, excluded);
  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

module.exports = _objectWithoutProperties, module.exports.__esModule = true, module.exports["default"] = module.exports;
});

var _objectWithoutProperties = unwrapExports(objectWithoutProperties);

var _excluded = ["forwardedRef"];

function _createSuper$i(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$i(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct$i() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
var withDataDogCallbackLogging = function withDataDogCallbackLogging(actionName, interceptedHandlerName, debounceTime) {
  return function (WrappedComponent) {
    var WithDataDogCallbackLogging = /*#__PURE__*/function (_React$Component) {
      _inherits(WithDataDogCallbackLogging, _React$Component);

      var _super = _createSuper$i(WithDataDogCallbackLogging);

      function WithDataDogCallbackLogging(props) {
        var _this;

        _classCallCheck(this, WithDataDogCallbackLogging);

        _this = _super.call(this, props);

        _this.handleClickToStartAction = function (e) {
          e.stopPropagation();
        };

        _this.newEventHandler = function () {
          var _this$props;

          _this.doLoggingClick();

          (_this$props = _this.props)[interceptedHandlerName].apply(_this$props, arguments);
        };

        _this.loggingButtonRef = /*#__PURE__*/React__default.createRef();
        _this.doLoggingClick = debounceTime ? debounce(function () {
          if (_this.loggingButtonRef.current) {
            _this.loggingButtonRef.current.click();
          }
        }, debounceTime, {
          leading: true,
          trailing: false
        }) : function () {
          if (_this.loggingButtonRef.current) {
            _this.loggingButtonRef.current.click();
          }
        };
        return _this;
      }

      _createClass(WithDataDogCallbackLogging, [{
        key: "render",
        value: function render() {
          var _this$props2 = this.props,
              forwardedRef = _this$props2.forwardedRef,
              newProps = _objectWithoutProperties(_this$props2, _excluded);

          newProps[interceptedHandlerName] = this.newEventHandler;
          return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("button", {
            style: {
              display: 'none'
            },
            onClick: this.handleClickToStartAction,
            ref: this.loggingButtonRef,
            'data-dd-action-name': actionName
          }), /*#__PURE__*/React__default.createElement(WrappedComponent, _extends({
            ref: forwardedRef
          }, newProps)));
        }
      }]);

      return WithDataDogCallbackLogging;
    }(React__default.Component);

    WithDataDogCallbackLogging.displayName = "WithDataDogCallbackLogging(".concat(WrappedComponent.displayName, ")");
    return /*#__PURE__*/React__default.forwardRef(function (props, ref) {
      return /*#__PURE__*/React__default.createElement(WithDataDogCallbackLogging, _extends({}, props, {
        forwardedRef: ref
      }));
    });
  };
};

var GENERAL_API_ERROR = 'Something went wrong. Please try again later.';

/*! xlsx.js (C) 2013-present SheetJS -- http://sheetjs.com */
/* vim: set ts=2: */
/*exported XLSX */
/*global global, exports, module, require:false, process:false, Buffer:false, ArrayBuffer:false */
var XLSX = {};
XLSX.version = '0.18.2';
var current_codepage = 1200, current_ansi = 1252;

var VALID_ANSI = [ 874, 932, 936, 949, 950, 10000 ];
for(var i = 0; i <= 8; ++i) VALID_ANSI.push(1250 + i);
/* ECMA-376 Part I 18.4.1 charset to codepage mapping */
var CS2CP = ({
	/*::[*/0/*::]*/:    1252, /* ANSI */
	/*::[*/1/*::]*/:   65001, /* DEFAULT */
	/*::[*/2/*::]*/:   65001, /* SYMBOL */
	/*::[*/77/*::]*/:  10000, /* MAC */
	/*::[*/128/*::]*/:   932, /* SHIFTJIS */
	/*::[*/129/*::]*/:   949, /* HANGUL */
	/*::[*/130/*::]*/:  1361, /* JOHAB */
	/*::[*/134/*::]*/:   936, /* GB2312 */
	/*::[*/136/*::]*/:   950, /* CHINESEBIG5 */
	/*::[*/161/*::]*/:  1253, /* GREEK */
	/*::[*/162/*::]*/:  1254, /* TURKISH */
	/*::[*/163/*::]*/:  1258, /* VIETNAMESE */
	/*::[*/177/*::]*/:  1255, /* HEBREW */
	/*::[*/178/*::]*/:  1256, /* ARABIC */
	/*::[*/186/*::]*/:  1257, /* BALTIC */
	/*::[*/204/*::]*/:  1251, /* RUSSIAN */
	/*::[*/222/*::]*/:   874, /* THAI */
	/*::[*/238/*::]*/:  1250, /* EASTEUROPE */
	/*::[*/255/*::]*/:  1252, /* OEM */
	/*::[*/69/*::]*/:   6969  /* MISC */
}/*:any*/);

var set_ansi = function(cp/*:number*/) { if(VALID_ANSI.indexOf(cp) == -1) return; current_ansi = CS2CP[0] = cp; };
function reset_ansi() { set_ansi(1252); }

var set_cp = function(cp/*:number*/) { current_codepage = cp; set_ansi(cp); };
function reset_cp() { set_cp(1200); reset_ansi(); }

function char_codes(data/*:string*/)/*:Array<number>*/ { var o/*:Array<number>*/ = []; for(var i = 0, len = data.length; i < len; ++i) o[i] = data.charCodeAt(i); return o; }

function utf16leread(data/*:string*/)/*:string*/ {
	var o/*:Array<string>*/ = [];
	for(var i = 0; i < (data.length>>1); ++i) o[i] = String.fromCharCode(data.charCodeAt(2*i) + (data.charCodeAt(2*i+1)<<8));
	return o.join("");
}
function utf16beread(data/*:string*/)/*:string*/ {
	var o/*:Array<string>*/ = [];
	for(var i = 0; i < (data.length>>1); ++i) o[i] = String.fromCharCode(data.charCodeAt(2*i+1) + (data.charCodeAt(2*i)<<8));
	return o.join("");
}

var debom = function(data/*:string*/)/*:string*/ {
	var c1 = data.charCodeAt(0), c2 = data.charCodeAt(1);
	if(c1 == 0xFF && c2 == 0xFE) return utf16leread(data.slice(2));
	if(c1 == 0xFE && c2 == 0xFF) return utf16beread(data.slice(2));
	if(c1 == 0xFEFF) return data.slice(1);
	return data;
};

var _getchar = function _gc1(x/*:number*/)/*:string*/ { return String.fromCharCode(x); };
var _getansi = function _ga1(x/*:number*/)/*:string*/ { return String.fromCharCode(x); };

var cptable;
function set_cptable(_cptable) {
	cptable = _cptable;
	set_cp = function(cp/*:number*/) { current_codepage = cp; set_ansi(cp); };
	debom = function(data/*:string*/) {
		if(data.charCodeAt(0) === 0xFF && data.charCodeAt(1) === 0xFE) { return cptable.utils.decode(1200, char_codes(data.slice(2))); }
		return data;
	};
	_getchar = function _gc2(x/*:number*/)/*:string*/ {
		if(current_codepage === 1200) return String.fromCharCode(x);
		return cptable.utils.decode(current_codepage, [x&255,x>>8])[0];
	};
	_getansi = function _ga2(x/*:number*/)/*:string*/ {
		return cptable.utils.decode(current_ansi, [x])[0];
	};
	cpdoit();
}
var Base64 = function() {
  var map = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";
  return {
    encode: function(input) {
      var o = "";
      var c1 = 0, c2 = 0, c3 = 0, e1 = 0, e2 = 0, e3 = 0, e4 = 0;
      for (var i = 0; i < input.length; ) {
        c1 = input.charCodeAt(i++);
        e1 = c1 >> 2;
        c2 = input.charCodeAt(i++);
        e2 = (c1 & 3) << 4 | c2 >> 4;
        c3 = input.charCodeAt(i++);
        e3 = (c2 & 15) << 2 | c3 >> 6;
        e4 = c3 & 63;
        if (isNaN(c2)) {
          e3 = e4 = 64;
        } else if (isNaN(c3)) {
          e4 = 64;
        }
        o += map.charAt(e1) + map.charAt(e2) + map.charAt(e3) + map.charAt(e4);
      }
      return o;
    },
    decode: function(input) {
      var o = "";
      var c1 = 0, c2 = 0, c3 = 0, e1 = 0, e2 = 0, e3 = 0, e4 = 0;
      input = input.replace(/[^\w\+\/\=]/g, "");
      for (var i = 0; i < input.length; ) {
        e1 = map.indexOf(input.charAt(i++));
        e2 = map.indexOf(input.charAt(i++));
        c1 = e1 << 2 | e2 >> 4;
        o += String.fromCharCode(c1);
        e3 = map.indexOf(input.charAt(i++));
        c2 = (e2 & 15) << 4 | e3 >> 2;
        if (e3 !== 64) {
          o += String.fromCharCode(c2);
        }
        e4 = map.indexOf(input.charAt(i++));
        c3 = (e3 & 3) << 6 | e4;
        if (e4 !== 64) {
          o += String.fromCharCode(c3);
        }
      }
      return o;
    }
  };
}();
var has_buf = (typeof Buffer !== 'undefined' && typeof process !== 'undefined' && typeof process.versions !== 'undefined' && !!process.versions.node);

var Buffer_from = /*::(*/function(){}/*:: :any)*/;

if(typeof Buffer !== 'undefined') {
	var nbfs = !Buffer.from;
	if(!nbfs) try { Buffer.from("foo", "utf8"); } catch(e) { nbfs = true; }
	Buffer_from = nbfs ? function(buf, enc) { return (enc) ? new Buffer(buf, enc) : new Buffer(buf); } : Buffer.from.bind(Buffer);
	// $FlowIgnore
	if(!Buffer.alloc) Buffer.alloc = function(n) { return new Buffer(n); };
	// $FlowIgnore
	if(!Buffer.allocUnsafe) Buffer.allocUnsafe = function(n) { return new Buffer(n); };
}

function new_raw_buf(len/*:number*/) {
	/* jshint -W056 */
	return has_buf ? Buffer.alloc(len) : typeof Uint8Array != "undefined" ? new Uint8Array(len) : new Array(len);
	/* jshint +W056 */
}

function new_unsafe_buf(len/*:number*/) {
	/* jshint -W056 */
	return has_buf ? Buffer.allocUnsafe(len) : typeof Uint8Array != "undefined" ? new Uint8Array(len) : new Array(len);
	/* jshint +W056 */
}

var s2a = function s2a(s/*:string*/)/*:any*/ {
	if(has_buf) return Buffer_from(s, "binary");
	return s.split("").map(function(x/*:string*/)/*:number*/{ return x.charCodeAt(0) & 0xff; });
};

function s2ab(s/*:string*/)/*:any*/ {
	if(typeof ArrayBuffer === 'undefined') return s2a(s);
	var buf = new ArrayBuffer(s.length), view = new Uint8Array(buf);
	for (var i=0; i!=s.length; ++i) view[i] = s.charCodeAt(i) & 0xFF;
	return buf;
}

function a2s(data/*:any*/)/*:string*/ {
	if(Array.isArray(data)) return data.map(function(c) { return String.fromCharCode(c); }).join("");
	var o/*:Array<string>*/ = []; for(var i = 0; i < data.length; ++i) o[i] = String.fromCharCode(data[i]); return o.join("");
}

function a2u(data/*:Array<number>*/)/*:Uint8Array*/ {
	if(typeof Uint8Array === 'undefined') throw new Error("Unsupported");
	return new Uint8Array(data);
}

function ab2a(data/*:ArrayBuffer|Uint8Array*/)/*:Array<number>*/ {
	if(typeof ArrayBuffer == 'undefined') throw new Error("Unsupported");
	if(data instanceof ArrayBuffer) return ab2a(new Uint8Array(data));
	/*:: if(data instanceof ArrayBuffer) throw new Error("unreachable"); */
	var o = new Array(data.length);
	for(var i = 0; i < data.length; ++i) o[i] = data[i];
	return o;
}

function utf8decode(content/*:string*/) {
	var out = [], widx = 0, L = content.length + 250;
	var o = new_raw_buf(content.length + 255);
	for(var ridx = 0; ridx < content.length; ++ridx) {
		var c = content.charCodeAt(ridx);
		if(c < 0x80) o[widx++] = c;
		else if(c < 0x800) {
			o[widx++] = (192|((c>>6)&31));
			o[widx++] = (128|(c&63));
		} else if(c >= 0xD800 && c < 0xE000) {
			c = (c&1023)+64;
			var d = content.charCodeAt(++ridx)&1023;
			o[widx++] = (240|((c>>8)&7));
			o[widx++] = (128|((c>>2)&63));
			o[widx++] = (128|((d>>6)&15)|((c&3)<<4));
			o[widx++] = (128|(d&63));
		} else {
			o[widx++] = (224|((c>>12)&15));
			o[widx++] = (128|((c>>6)&63));
			o[widx++] = (128|(c&63));
		}
		if(widx > L) {
			out.push(o.slice(0, widx));
			widx = 0;
			o = new_raw_buf(65535);
			L = 65530;
		}
	}
	out.push(o.slice(0, widx));
	return bconcat(out);
}

var bconcat = function(bufs) {
	if(typeof Uint8Array !== "undefined") {
		var i = 0, maxlen = 0;
		for(i = 0; i < bufs.length; ++i) maxlen += bufs[i].length;
		var o = new Uint8Array(maxlen);
		var len = 0;
		for(i = 0, maxlen = 0; i < bufs.length; maxlen += len, ++i) {
			len = bufs[i].length;
			if(bufs[i] instanceof Uint8Array) o.set(bufs[i], maxlen);
			else if(typeof bufs[i] == "string") { throw "wtf"; }
			else o.set(new Uint8Array(bufs[i]), maxlen);
		}
		return o;
	}
	return [].concat.apply([], bufs.map(function(buf) { return Array.isArray(buf) ? buf : [].slice.call(buf); }));
};

var chr0 = /\u0000/g, chr1 = /[\u0001-\u0006]/g;
/*::
declare type Block = any;
declare type BufArray = {
	newblk(sz:number):Block;
	next(sz:number):Block;
	end():any;
	push(buf:Block):void;
};

type RecordHopperCB = {(d:any, Rn:string, RT:number):?boolean;};

type EvertType = {[string]:string};
type EvertNumType = {[string]:number};
type EvertArrType = {[string]:Array<string>};

type StringConv = {(string):string};

type WriteObjStrFactory = {from_sheet(ws:Worksheet, o:any, wb:?Workbook):string};
*/
/* ssf.js (C) 2013-present SheetJS -- http://sheetjs.com */
/*jshint -W041 */
var SSF/*:SSFModule*/ = ({}/*:any*/);
var make_ssf = function make_ssf(SSF/*:SSFModule*/){
SSF.version = '0.11.2';
function _strrev(x/*:string*/)/*:string*/ { var o = "", i = x.length-1; while(i>=0) o += x.charAt(i--); return o; }
function fill(c/*:string*/,l/*:number*/)/*:string*/ { var o = ""; while(o.length < l) o+=c; return o; }
function pad0(v/*:any*/,d/*:number*/)/*:string*/{var t=""+v; return t.length>=d?t:fill('0',d-t.length)+t;}
function pad_(v/*:any*/,d/*:number*/)/*:string*/{var t=""+v;return t.length>=d?t:fill(' ',d-t.length)+t;}
function rpad_(v/*:any*/,d/*:number*/)/*:string*/{var t=""+v; return t.length>=d?t:t+fill(' ',d-t.length);}
function pad0r1(v/*:any*/,d/*:number*/)/*:string*/{var t=""+Math.round(v); return t.length>=d?t:fill('0',d-t.length)+t;}
function pad0r2(v/*:any*/,d/*:number*/)/*:string*/{var t=""+v; return t.length>=d?t:fill('0',d-t.length)+t;}
var p2_32 = Math.pow(2,32);
function pad0r(v/*:any*/,d/*:number*/)/*:string*/{if(v>p2_32||v<-p2_32) return pad0r1(v,d); var i = Math.round(v); return pad0r2(i,d); }
function isgeneral(s/*:string*/, i/*:?number*/)/*:boolean*/ { i = i || 0; return s.length >= 7 + i && (s.charCodeAt(i)|32) === 103 && (s.charCodeAt(i+1)|32) === 101 && (s.charCodeAt(i+2)|32) === 110 && (s.charCodeAt(i+3)|32) === 101 && (s.charCodeAt(i+4)|32) === 114 && (s.charCodeAt(i+5)|32) === 97 && (s.charCodeAt(i+6)|32) === 108; }
/*::
type SSF_write_num = {(type:string, fmt:string, val:number):string};
*/
var days/*:Array<Array<string> >*/ = [
	['Sun', 'Sunday'],
	['Mon', 'Monday'],
	['Tue', 'Tuesday'],
	['Wed', 'Wednesday'],
	['Thu', 'Thursday'],
	['Fri', 'Friday'],
	['Sat', 'Saturday']
];
var months/*:Array<Array<string> >*/ = [
	['J', 'Jan', 'January'],
	['F', 'Feb', 'February'],
	['M', 'Mar', 'March'],
	['A', 'Apr', 'April'],
	['M', 'May', 'May'],
	['J', 'Jun', 'June'],
	['J', 'Jul', 'July'],
	['A', 'Aug', 'August'],
	['S', 'Sep', 'September'],
	['O', 'Oct', 'October'],
	['N', 'Nov', 'November'],
	['D', 'Dec', 'December']
];
function init_table(t/*:any*/) {
	t[0]=  'General';
	t[1]=  '0';
	t[2]=  '0.00';
	t[3]=  '#,##0';
	t[4]=  '#,##0.00';
	t[9]=  '0%';
	t[10]= '0.00%';
	t[11]= '0.00E+00';
	t[12]= '# ?/?';
	t[13]= '# ??/??';
	t[14]= 'm/d/yy';
	t[15]= 'd-mmm-yy';
	t[16]= 'd-mmm';
	t[17]= 'mmm-yy';
	t[18]= 'h:mm AM/PM';
	t[19]= 'h:mm:ss AM/PM';
	t[20]= 'h:mm';
	t[21]= 'h:mm:ss';
	t[22]= 'm/d/yy h:mm';
	t[37]= '#,##0 ;(#,##0)';
	t[38]= '#,##0 ;[Red](#,##0)';
	t[39]= '#,##0.00;(#,##0.00)';
	t[40]= '#,##0.00;[Red](#,##0.00)';
	t[45]= 'mm:ss';
	t[46]= '[h]:mm:ss';
	t[47]= 'mmss.0';
	t[48]= '##0.0E+0';
	t[49]= '@';
	t[56]= '"上午/下午 "hh"時"mm"分"ss"秒 "';
}

var table_fmt = {};
init_table(table_fmt);
/* Defaults determined by systematically testing in Excel 2019 */

/* These formats appear to default to other formats in the table */
var default_map/*:Array<number>*/ = [];
var defi = 0;

//  5 -> 37 ...  8 -> 40
for(defi = 5; defi <= 8; ++defi) default_map[defi] = 32 + defi;

// 23 ->  0 ... 26 ->  0
for(defi = 23; defi <= 26; ++defi) default_map[defi] = 0;

// 27 -> 14 ... 31 -> 14
for(defi = 27; defi <= 31; ++defi) default_map[defi] = 14;
// 50 -> 14 ... 58 -> 14
for(defi = 50; defi <= 58; ++defi) default_map[defi] = 14;

// 59 ->  1 ... 62 ->  4
for(defi = 59; defi <= 62; ++defi) default_map[defi] = defi - 58;
// 67 ->  9 ... 68 -> 10
for(defi = 67; defi <= 68; ++defi) default_map[defi] = defi - 58;
// 72 -> 14 ... 75 -> 17
for(defi = 72; defi <= 75; ++defi) default_map[defi] = defi - 58;

// 69 -> 12 ... 71 -> 14
for(defi = 67; defi <= 68; ++defi) default_map[defi] = defi - 57;

// 76 -> 20 ... 78 -> 22
for(defi = 76; defi <= 78; ++defi) default_map[defi] = defi - 56;

// 79 -> 45 ... 81 -> 47
for(defi = 79; defi <= 81; ++defi) default_map[defi] = defi - 34;

// 82 ->  0 ... 65536 -> 0 (omitted)

/* These formats technically refer to Accounting formats with no equivalent */
var default_str/*:Array<string>*/ = [];

//  5 -- Currency,   0 decimal, black negative
default_str[5] = default_str[63] = '"$"#,##0_);\\("$"#,##0\\)';
//  6 -- Currency,   0 decimal, red   negative
default_str[6] = default_str[64] = '"$"#,##0_);[Red]\\("$"#,##0\\)';
//  7 -- Currency,   2 decimal, black negative
default_str[7] = default_str[65] = '"$"#,##0.00_);\\("$"#,##0.00\\)';
//  8 -- Currency,   2 decimal, red   negative
default_str[8] = default_str[66] = '"$"#,##0.00_);[Red]\\("$"#,##0.00\\)';

// 41 -- Accounting, 0 decimal, No Symbol
default_str[41] = '_(* #,##0_);_(* \\(#,##0\\);_(* "-"_);_(@_)';
// 42 -- Accounting, 0 decimal, $  Symbol
default_str[42] = '_("$"* #,##0_);_("$"* \\(#,##0\\);_("$"* "-"_);_(@_)';
// 43 -- Accounting, 2 decimal, No Symbol
default_str[43] = '_(* #,##0.00_);_(* \\(#,##0.00\\);_(* "-"??_);_(@_)';
// 44 -- Accounting, 2 decimal, $  Symbol
default_str[44] = '_("$"* #,##0.00_);_("$"* \\(#,##0.00\\);_("$"* "-"??_);_(@_)';
function frac(x/*:number*/, D/*:number*/, mixed/*:?boolean*/)/*:Array<number>*/ {
	var sgn = x < 0 ? -1 : 1;
	var B = x * sgn;
	var P_2 = 0, P_1 = 1, P = 0;
	var Q_2 = 1, Q_1 = 0, Q = 0;
	var A = Math.floor(B);
	while(Q_1 < D) {
		A = Math.floor(B);
		P = A * P_1 + P_2;
		Q = A * Q_1 + Q_2;
		if((B - A) < 0.00000005) break;
		B = 1 / (B - A);
		P_2 = P_1; P_1 = P;
		Q_2 = Q_1; Q_1 = Q;
	}
	if(Q > D) { if(Q_1 > D) { Q = Q_2; P = P_2; } else { Q = Q_1; P = P_1; } }
	if(!mixed) return [0, sgn * P, Q];
	var q = Math.floor(sgn * P/Q);
	return [q, sgn*P - q*Q, Q];
}
function parse_date_code(v/*:number*/,opts/*:?any*/,b2/*:?boolean*/) {
	if(v > 2958465 || v < 0) return null;
	var date = (v|0), time = Math.floor(86400 * (v - date)), dow=0;
	var dout=[];
	var out={D:date, T:time, u:86400*(v-date)-time,y:0,m:0,d:0,H:0,M:0,S:0,q:0};
	if(Math.abs(out.u) < 1e-6) out.u = 0;
	if(opts && opts.date1904) date += 1462;
	if(out.u > 0.9999) {
		out.u = 0;
		if(++time == 86400) { out.T = time = 0; ++date; ++out.D; }
	}
	if(date === 60) {dout = b2 ? [1317,10,29] : [1900,2,29]; dow=3;}
	else if(date === 0) {dout = b2 ? [1317,8,29] : [1900,1,0]; dow=6;}
	else {
		if(date > 60) --date;
		/* 1 = Jan 1 1900 in Gregorian */
		var d = new Date(1900, 0, 1);
		d.setDate(d.getDate() + date - 1);
		dout = [d.getFullYear(), d.getMonth()+1,d.getDate()];
		dow = d.getDay();
		if(date < 60) dow = (dow + 6) % 7;
		if(b2) dow = fix_hijri(d, dout);
	}
	out.y = dout[0]; out.m = dout[1]; out.d = dout[2];
	out.S = time % 60; time = Math.floor(time / 60);
	out.M = time % 60; time = Math.floor(time / 60);
	out.H = time;
	out.q = dow;
	return out;
}
SSF.parse_date_code = parse_date_code;
var basedate = new Date(1899, 11, 31, 0, 0, 0);
var dnthresh = basedate.getTime();
var base1904 = new Date(1900, 2, 1, 0, 0, 0);
function datenum_local(v/*:Date*/, date1904/*:?boolean*/)/*:number*/ {
	var epoch = v.getTime();
	if(date1904) epoch -= 1461*24*60*60*1000;
	else if(v >= base1904) epoch += 24*60*60*1000;
	return (epoch - (dnthresh + (v.getTimezoneOffset() - basedate.getTimezoneOffset()) * 60000)) / (24 * 60 * 60 * 1000);
}
/* The longest 32-bit integer text is "-4294967296", exactly 11 chars */
function general_fmt_int(v/*:number*/)/*:string*/ { return v.toString(10); }
SSF._general_int = general_fmt_int;

/* ECMA-376 18.8.30 numFmt*/
/* Note: `toPrecision` uses standard form when prec > E and E >= -6 */
var general_fmt_num = (function make_general_fmt_num() {
	var trailing_zeroes_and_decimal = /(?:\.0*|(\.\d*[1-9])0+)$/;
	function strip_decimal(o/*:string*/)/*:string*/ {
		return (o.indexOf(".") == -1) ? o : o.replace(trailing_zeroes_and_decimal, "$1");
	}

	/* General Exponential always shows 2 digits exp and trims the mantissa */
	var mantissa_zeroes_and_decimal = /(?:\.0*|(\.\d*[1-9])0+)[Ee]/;
	var exp_with_single_digit = /(E[+-])(\d)$/;
	function normalize_exp(o/*:string*/)/*:string*/ {
		if(o.indexOf("E") == -1) return o;
		return o.replace(mantissa_zeroes_and_decimal,"$1E").replace(exp_with_single_digit,"$10$2");
	}

	/* exponent >= -9 and <= 9 */
	function small_exp(v/*:number*/)/*:string*/ {
		var w = (v<0?12:11);
		var o = strip_decimal(v.toFixed(12)); if(o.length <= w) return o;
		o = v.toPrecision(10); if(o.length <= w) return o;
		return v.toExponential(5);
	}

	/* exponent >= 11 or <= -10 likely exponential */
	function large_exp(v/*:number*/)/*:string*/ {
		var o = strip_decimal(v.toFixed(11));
		return (o.length > (v<0?12:11) || o === "0" || o === "-0") ? v.toPrecision(6) : o;
	}

	function general_fmt_num_base(v/*:number*/)/*:string*/ {
		var V = Math.floor(Math.log(Math.abs(v))*Math.LOG10E), o;

		if(V >= -4 && V <= -1) o = v.toPrecision(10+V);
		else if(Math.abs(V) <= 9) o = small_exp(v);
		else if(V === 10) o = v.toFixed(10).substr(0,12);
		else o = large_exp(v);

		return strip_decimal(normalize_exp(o.toUpperCase()));
	}

	return general_fmt_num_base;
})();
SSF._general_num = general_fmt_num;

/*
	"General" rules:
	- text is passed through ("@")
	- booleans are rendered as TRUE/FALSE
	- "up to 11 characters" displayed for numbers
	- Default date format (code 14) used for Dates

	TODO: technically the display depends on the width of the cell
*/
function general_fmt(v/*:any*/, opts/*:any*/) {
	switch(typeof v) {
		case 'string': return v;
		case 'boolean': return v ? "TRUE" : "FALSE";
		case 'number': return (v|0) === v ? v.toString(10) : general_fmt_num(v);
		case 'undefined': return "";
		case 'object':
			if(v == null) return "";
			if(v instanceof Date) return format(14, datenum_local(v, opts && opts.date1904), opts);
	}
	throw new Error("unsupported value in General format: " + v);
}
SSF._general = general_fmt;
function fix_hijri(date/*:Date*/, o/*:[number, number, number]*/) {
  /* TODO: properly adjust y/m/d and  */
  o[0] -= 581;
  var dow = date.getDay();
  if(date < 60) dow = (dow + 6) % 7;
  return dow;
}
//var THAI_DIGITS = "\u0E50\u0E51\u0E52\u0E53\u0E54\u0E55\u0E56\u0E57\u0E58\u0E59".split("");
/*jshint -W086 */
function write_date(type/*:number*/, fmt/*:string*/, val, ss0/*:?number*/)/*:string*/ {
	var o="", ss=0, tt=0, y = val.y, out, outl = 0;
	switch(type) {
		case 98: /* 'b' buddhist year */
			y = val.y + 543;
			/* falls through */
		case 121: /* 'y' year */
		switch(fmt.length) {
			case 1: case 2: out = y % 100; outl = 2; break;
			default: out = y % 10000; outl = 4; break;
		} break;
		case 109: /* 'm' month */
		switch(fmt.length) {
			case 1: case 2: out = val.m; outl = fmt.length; break;
			case 3: return months[val.m-1][1];
			case 5: return months[val.m-1][0];
			default: return months[val.m-1][2];
		} break;
		case 100: /* 'd' day */
		switch(fmt.length) {
			case 1: case 2: out = val.d; outl = fmt.length; break;
			case 3: return days[val.q][0];
			default: return days[val.q][1];
		} break;
		case 104: /* 'h' 12-hour */
		switch(fmt.length) {
			case 1: case 2: out = 1+(val.H+11)%12; outl = fmt.length; break;
			default: throw 'bad hour format: ' + fmt;
		} break;
		case 72: /* 'H' 24-hour */
		switch(fmt.length) {
			case 1: case 2: out = val.H; outl = fmt.length; break;
			default: throw 'bad hour format: ' + fmt;
		} break;
		case 77: /* 'M' minutes */
		switch(fmt.length) {
			case 1: case 2: out = val.M; outl = fmt.length; break;
			default: throw 'bad minute format: ' + fmt;
		} break;
		case 115: /* 's' seconds */
			if(fmt != 's' && fmt != 'ss' && fmt != '.0' && fmt != '.00' && fmt != '.000') throw 'bad second format: ' + fmt;
			if(val.u === 0 && (fmt == "s" || fmt == "ss")) return pad0(val.S, fmt.length);
			/*::if(!ss0) ss0 = 0; */
			if(ss0 >= 2) tt = ss0 === 3 ? 1000 : 100;
			else tt = ss0 === 1 ? 10 : 1;
			ss = Math.round((tt)*(val.S + val.u));
			if(ss >= 60*tt) ss = 0;
			if(fmt === 's') return ss === 0 ? "0" : ""+ss/tt;
			o = pad0(ss,2 + ss0);
			if(fmt === 'ss') return o.substr(0,2);
			return "." + o.substr(2,fmt.length-1);
		case 90: /* 'Z' absolute time */
		switch(fmt) {
			case '[h]': case '[hh]': out = val.D*24+val.H; break;
			case '[m]': case '[mm]': out = (val.D*24+val.H)*60+val.M; break;
			case '[s]': case '[ss]': out = ((val.D*24+val.H)*60+val.M)*60+Math.round(val.S+val.u); break;
			default: throw 'bad abstime format: ' + fmt;
		} outl = fmt.length === 3 ? 1 : 2; break;
		case 101: /* 'e' era */
			out = y; outl = 1; break;
	}
	var outstr = outl > 0 ? pad0(out, outl) : "";
	return outstr;
}
/*jshint +W086 */
function commaify(s/*:string*/)/*:string*/ {
	var w = 3;
	if(s.length <= w) return s;
	var j = (s.length % w), o = s.substr(0,j);
	for(; j!=s.length; j+=w) o+=(o.length > 0 ? "," : "") + s.substr(j,w);
	return o;
}
var write_num/*:SSF_write_num*/ = (function make_write_num(){
var pct1 = /%/g;
function write_num_pct(type/*:string*/, fmt/*:string*/, val/*:number*/)/*:string*/{
	var sfmt = fmt.replace(pct1,""), mul = fmt.length - sfmt.length;
	return write_num(type, sfmt, val * Math.pow(10,2*mul)) + fill("%",mul);
}
function write_num_cm(type/*:string*/, fmt/*:string*/, val/*:number*/)/*:string*/{
	var idx = fmt.length - 1;
	while(fmt.charCodeAt(idx-1) === 44) --idx;
	return write_num(type, fmt.substr(0,idx), val / Math.pow(10,3*(fmt.length-idx)));
}
function write_num_exp(fmt/*:string*/, val/*:number*/)/*:string*/{
	var o/*:string*/;
	var idx = fmt.indexOf("E") - fmt.indexOf(".") - 1;
	if(fmt.match(/^#+0.0E\+0$/)) {
		if(val == 0) return "0.0E+0";
		else if(val < 0) return "-" + write_num_exp(fmt, -val);
		var period = fmt.indexOf("."); if(period === -1) period=fmt.indexOf('E');
		var ee = Math.floor(Math.log(val)*Math.LOG10E)%period;
		if(ee < 0) ee += period;
		o = (val/Math.pow(10,ee)).toPrecision(idx+1+(period+ee)%period);
		if(o.indexOf("e") === -1) {
			var fakee = Math.floor(Math.log(val)*Math.LOG10E);
			if(o.indexOf(".") === -1) o = o.charAt(0) + "." + o.substr(1) + "E+" + (fakee - o.length+ee);
			else o += "E+" + (fakee - ee);
			while(o.substr(0,2) === "0.") {
				o = o.charAt(0) + o.substr(2,period) + "." + o.substr(2+period);
				o = o.replace(/^0+([1-9])/,"$1").replace(/^0+\./,"0.");
			}
			o = o.replace(/\+-/,"-");
		}
		o = o.replace(/^([+-]?)(\d*)\.(\d*)[Ee]/,function($$,$1,$2,$3) { return $1 + $2 + $3.substr(0,(period+ee)%period) + "." + $3.substr(ee) + "E"; });
	} else o = val.toExponential(idx);
	if(fmt.match(/E\+00$/) && o.match(/e[+-]\d$/)) o = o.substr(0,o.length-1) + "0" + o.charAt(o.length-1);
	if(fmt.match(/E\-/) && o.match(/e\+/)) o = o.replace(/e\+/,"e");
	return o.replace("e","E");
}
var frac1 = /# (\?+)( ?)\/( ?)(\d+)/;
function write_num_f1(r/*:Array<string>*/, aval/*:number*/, sign/*:string*/)/*:string*/ {
	var den = parseInt(r[4],10), rr = Math.round(aval * den), base = Math.floor(rr/den);
	var myn = (rr - base*den), myd = den;
	return sign + (base === 0 ? "" : ""+base) + " " + (myn === 0 ? fill(" ", r[1].length + 1 + r[4].length) : pad_(myn,r[1].length) + r[2] + "/" + r[3] + pad0(myd,r[4].length));
}
function write_num_f2(r/*:Array<string>*/, aval/*:number*/, sign/*:string*/)/*:string*/ {
	return sign + (aval === 0 ? "" : ""+aval) + fill(" ", r[1].length + 2 + r[4].length);
}
var dec1 = /^#*0*\.([0#]+)/;
var closeparen = /\).*[0#]/;
var phone = /\(###\) ###\\?-####/;
function hashq(str/*:string*/)/*:string*/ {
	var o = "", cc;
	for(var i = 0; i != str.length; ++i) switch((cc=str.charCodeAt(i))) {
		case 35: break;
		case 63: o+= " "; break;
		case 48: o+= "0"; break;
		default: o+= String.fromCharCode(cc);
	}
	return o;
}
function rnd(val/*:number*/, d/*:number*/)/*:string*/ { var dd = Math.pow(10,d); return ""+(Math.round(val * dd)/dd); }
function dec(val/*:number*/, d/*:number*/)/*:number*/ {
	var _frac = val - Math.floor(val), dd = Math.pow(10,d);
	if (d < ('' + Math.round(_frac * dd)).length) return 0;
	return Math.round(_frac * dd);
}
function carry(val/*:number*/, d/*:number*/)/*:number*/ {
	if (d < ('' + Math.round((val-Math.floor(val))*Math.pow(10,d))).length) {
		return 1;
	}
	return 0;
}
function flr(val/*:number*/)/*:string*/ {
	if(val < 2147483647 && val > -2147483648) return ""+(val >= 0 ? (val|0) : (val-1|0));
	return ""+Math.floor(val);
}
function write_num_flt(type/*:string*/, fmt/*:string*/, val/*:number*/)/*:string*/ {
	if(type.charCodeAt(0) === 40 && !fmt.match(closeparen)) {
		var ffmt = fmt.replace(/\( */,"").replace(/ \)/,"").replace(/\)/,"");
		if(val >= 0) return write_num_flt('n', ffmt, val);
		return '(' + write_num_flt('n', ffmt, -val) + ')';
	}
	if(fmt.charCodeAt(fmt.length - 1) === 44) return write_num_cm(type, fmt, val);
	if(fmt.indexOf('%') !== -1) return write_num_pct(type, fmt, val);
	if(fmt.indexOf('E') !== -1) return write_num_exp(fmt, val);
	if(fmt.charCodeAt(0) === 36) return "$"+write_num_flt(type,fmt.substr(fmt.charAt(1)==' '?2:1),val);
	var o;
	var r/*:?Array<string>*/, ri, ff, aval = Math.abs(val), sign = val < 0 ? "-" : "";
	if(fmt.match(/^00+$/)) return sign + pad0r(aval,fmt.length);
	if(fmt.match(/^[#?]+$/)) {
		o = pad0r(val,0); if(o === "0") o = "";
		return o.length > fmt.length ? o : hashq(fmt.substr(0,fmt.length-o.length)) + o;
	}
	if((r = fmt.match(frac1))) return write_num_f1(r, aval, sign);
	if(fmt.match(/^#+0+$/)) return sign + pad0r(aval,fmt.length - fmt.indexOf("0"));
	if((r = fmt.match(dec1))) {
		o = rnd(val, r[1].length).replace(/^([^\.]+)$/,"$1."+hashq(r[1])).replace(/\.$/,"."+hashq(r[1])).replace(/\.(\d*)$/,function($$, $1) { return "." + $1 + fill("0", hashq(/*::(*/r/*::||[""])*/[1]).length-$1.length); });
		return fmt.indexOf("0.") !== -1 ? o : o.replace(/^0\./,".");
	}
	fmt = fmt.replace(/^#+([0.])/, "$1");
	if((r = fmt.match(/^(0*)\.(#*)$/))) {
		return sign + rnd(aval, r[2].length).replace(/\.(\d*[1-9])0*$/,".$1").replace(/^(-?\d*)$/,"$1.").replace(/^0\./,r[1].length?"0.":".");
	}
	if((r = fmt.match(/^#{1,3},##0(\.?)$/))) return sign + commaify(pad0r(aval,0));
	if((r = fmt.match(/^#,##0\.([#0]*0)$/))) {
		return val < 0 ? "-" + write_num_flt(type, fmt, -val) : commaify(""+(Math.floor(val) + carry(val, r[1].length))) + "." + pad0(dec(val, r[1].length),r[1].length);
	}
	if((r = fmt.match(/^#,#*,#0/))) return write_num_flt(type,fmt.replace(/^#,#*,/,""),val);
	if((r = fmt.match(/^([0#]+)(\\?-([0#]+))+$/))) {
		o = _strrev(write_num_flt(type, fmt.replace(/[\\-]/g,""), val));
		ri = 0;
		return _strrev(_strrev(fmt.replace(/\\/g,"")).replace(/[0#]/g,function(x){return ri<o.length?o.charAt(ri++):x==='0'?'0':"";}));
	}
	if(fmt.match(phone)) {
		o = write_num_flt(type, "##########", val);
		return "(" + o.substr(0,3) + ") " + o.substr(3, 3) + "-" + o.substr(6);
	}
	var oa = "";
	if((r = fmt.match(/^([#0?]+)( ?)\/( ?)([#0?]+)/))) {
		ri = Math.min(/*::String(*/r[4]/*::)*/.length,7);
		ff = frac(aval, Math.pow(10,ri)-1, false);
		o = "" + sign;
		oa = write_num("n", /*::String(*/r[1]/*::)*/, ff[1]);
		if(oa.charAt(oa.length-1) == " ") oa = oa.substr(0,oa.length-1) + "0";
		o += oa + /*::String(*/r[2]/*::)*/ + "/" + /*::String(*/r[3]/*::)*/;
		oa = rpad_(ff[2],ri);
		if(oa.length < r[4].length) oa = hashq(r[4].substr(r[4].length-oa.length)) + oa;
		o += oa;
		return o;
	}
	if((r = fmt.match(/^# ([#0?]+)( ?)\/( ?)([#0?]+)/))) {
		ri = Math.min(Math.max(r[1].length, r[4].length),7);
		ff = frac(aval, Math.pow(10,ri)-1, true);
		return sign + (ff[0]||(ff[1] ? "" : "0")) + " " + (ff[1] ? pad_(ff[1],ri) + r[2] + "/" + r[3] + rpad_(ff[2],ri): fill(" ", 2*ri+1 + r[2].length + r[3].length));
	}
	if((r = fmt.match(/^[#0?]+$/))) {
		o = pad0r(val, 0);
		if(fmt.length <= o.length) return o;
		return hashq(fmt.substr(0,fmt.length-o.length)) + o;
	}
	if((r = fmt.match(/^([#0?]+)\.([#0]+)$/))) {
		o = "" + val.toFixed(Math.min(r[2].length,10)).replace(/([^0])0+$/,"$1");
		ri = o.indexOf(".");
		var lres = fmt.indexOf(".") - ri, rres = fmt.length - o.length - lres;
		return hashq(fmt.substr(0,lres) + o + fmt.substr(fmt.length-rres));
	}
	if((r = fmt.match(/^00,000\.([#0]*0)$/))) {
		ri = dec(val, r[1].length);
		return val < 0 ? "-" + write_num_flt(type, fmt, -val) : commaify(flr(val)).replace(/^\d,\d{3}$/,"0$&").replace(/^\d*$/,function($$) { return "00," + ($$.length < 3 ? pad0(0,3-$$.length) : "") + $$; }) + "." + pad0(ri,r[1].length);
	}
	switch(fmt) {
		case "###,##0.00": return write_num_flt(type, "#,##0.00", val);
		case "###,###":
		case "##,###":
		case "#,###": var x = commaify(pad0r(aval,0)); return x !== "0" ? sign + x : "";
		case "###,###.00": return write_num_flt(type, "###,##0.00",val).replace(/^0\./,".");
		case "#,###.00": return write_num_flt(type, "#,##0.00",val).replace(/^0\./,".");
	}
	throw new Error("unsupported format |" + fmt + "|");
}
function write_num_cm2(type/*:string*/, fmt/*:string*/, val/*:number*/)/*:string*/{
	var idx = fmt.length - 1;
	while(fmt.charCodeAt(idx-1) === 44) --idx;
	return write_num(type, fmt.substr(0,idx), val / Math.pow(10,3*(fmt.length-idx)));
}
function write_num_pct2(type/*:string*/, fmt/*:string*/, val/*:number*/)/*:string*/{
	var sfmt = fmt.replace(pct1,""), mul = fmt.length - sfmt.length;
	return write_num(type, sfmt, val * Math.pow(10,2*mul)) + fill("%",mul);
}
function write_num_exp2(fmt/*:string*/, val/*:number*/)/*:string*/{
	var o/*:string*/;
	var idx = fmt.indexOf("E") - fmt.indexOf(".") - 1;
	if(fmt.match(/^#+0.0E\+0$/)) {
		if(val == 0) return "0.0E+0";
		else if(val < 0) return "-" + write_num_exp2(fmt, -val);
		var period = fmt.indexOf("."); if(period === -1) period=fmt.indexOf('E');
		var ee = Math.floor(Math.log(val)*Math.LOG10E)%period;
		if(ee < 0) ee += period;
		o = (val/Math.pow(10,ee)).toPrecision(idx+1+(period+ee)%period);
		if(!o.match(/[Ee]/)) {
			var fakee = Math.floor(Math.log(val)*Math.LOG10E);
			if(o.indexOf(".") === -1) o = o.charAt(0) + "." + o.substr(1) + "E+" + (fakee - o.length+ee);
			else o += "E+" + (fakee - ee);
			o = o.replace(/\+-/,"-");
		}
		o = o.replace(/^([+-]?)(\d*)\.(\d*)[Ee]/,function($$,$1,$2,$3) { return $1 + $2 + $3.substr(0,(period+ee)%period) + "." + $3.substr(ee) + "E"; });
	} else o = val.toExponential(idx);
	if(fmt.match(/E\+00$/) && o.match(/e[+-]\d$/)) o = o.substr(0,o.length-1) + "0" + o.charAt(o.length-1);
	if(fmt.match(/E\-/) && o.match(/e\+/)) o = o.replace(/e\+/,"e");
	return o.replace("e","E");
}
function write_num_int(type/*:string*/, fmt/*:string*/, val/*:number*/)/*:string*/ {
	if(type.charCodeAt(0) === 40 && !fmt.match(closeparen)) {
		var ffmt = fmt.replace(/\( */,"").replace(/ \)/,"").replace(/\)/,"");
		if(val >= 0) return write_num_int('n', ffmt, val);
		return '(' + write_num_int('n', ffmt, -val) + ')';
	}
	if(fmt.charCodeAt(fmt.length - 1) === 44) return write_num_cm2(type, fmt, val);
	if(fmt.indexOf('%') !== -1) return write_num_pct2(type, fmt, val);
	if(fmt.indexOf('E') !== -1) return write_num_exp2(fmt, val);
	if(fmt.charCodeAt(0) === 36) return "$"+write_num_int(type,fmt.substr(fmt.charAt(1)==' '?2:1),val);
	var o;
	var r/*:?Array<string>*/, ri, ff, aval = Math.abs(val), sign = val < 0 ? "-" : "";
	if(fmt.match(/^00+$/)) return sign + pad0(aval,fmt.length);
	if(fmt.match(/^[#?]+$/)) {
		o = (""+val); if(val === 0) o = "";
		return o.length > fmt.length ? o : hashq(fmt.substr(0,fmt.length-o.length)) + o;
	}
	if((r = fmt.match(frac1))) return write_num_f2(r, aval, sign);
	if(fmt.match(/^#+0+$/)) return sign + pad0(aval,fmt.length - fmt.indexOf("0"));
	if((r = fmt.match(dec1))) {
		/*:: if(!Array.isArray(r)) throw new Error("unreachable"); */
		o = (""+val).replace(/^([^\.]+)$/,"$1."+hashq(r[1])).replace(/\.$/,"."+hashq(r[1]));
		o = o.replace(/\.(\d*)$/,function($$, $1) {
		/*:: if(!Array.isArray(r)) throw new Error("unreachable"); */
			return "." + $1 + fill("0", hashq(r[1]).length-$1.length); });
		return fmt.indexOf("0.") !== -1 ? o : o.replace(/^0\./,".");
	}
	fmt = fmt.replace(/^#+([0.])/, "$1");
	if((r = fmt.match(/^(0*)\.(#*)$/))) {
		return sign + (""+aval).replace(/\.(\d*[1-9])0*$/,".$1").replace(/^(-?\d*)$/,"$1.").replace(/^0\./,r[1].length?"0.":".");
	}
	if((r = fmt.match(/^#{1,3},##0(\.?)$/))) return sign + commaify((""+aval));
	if((r = fmt.match(/^#,##0\.([#0]*0)$/))) {
		return val < 0 ? "-" + write_num_int(type, fmt, -val) : commaify((""+val)) + "." + fill('0',r[1].length);
	}
	if((r = fmt.match(/^#,#*,#0/))) return write_num_int(type,fmt.replace(/^#,#*,/,""),val);
	if((r = fmt.match(/^([0#]+)(\\?-([0#]+))+$/))) {
		o = _strrev(write_num_int(type, fmt.replace(/[\\-]/g,""), val));
		ri = 0;
		return _strrev(_strrev(fmt.replace(/\\/g,"")).replace(/[0#]/g,function(x){return ri<o.length?o.charAt(ri++):x==='0'?'0':"";}));
	}
	if(fmt.match(phone)) {
		o = write_num_int(type, "##########", val);
		return "(" + o.substr(0,3) + ") " + o.substr(3, 3) + "-" + o.substr(6);
	}
	var oa = "";
	if((r = fmt.match(/^([#0?]+)( ?)\/( ?)([#0?]+)/))) {
		ri = Math.min(/*::String(*/r[4]/*::)*/.length,7);
		ff = frac(aval, Math.pow(10,ri)-1, false);
		o = "" + sign;
		oa = write_num("n", /*::String(*/r[1]/*::)*/, ff[1]);
		if(oa.charAt(oa.length-1) == " ") oa = oa.substr(0,oa.length-1) + "0";
		o += oa + /*::String(*/r[2]/*::)*/ + "/" + /*::String(*/r[3]/*::)*/;
		oa = rpad_(ff[2],ri);
		if(oa.length < r[4].length) oa = hashq(r[4].substr(r[4].length-oa.length)) + oa;
		o += oa;
		return o;
	}
	if((r = fmt.match(/^# ([#0?]+)( ?)\/( ?)([#0?]+)/))) {
		ri = Math.min(Math.max(r[1].length, r[4].length),7);
		ff = frac(aval, Math.pow(10,ri)-1, true);
		return sign + (ff[0]||(ff[1] ? "" : "0")) + " " + (ff[1] ? pad_(ff[1],ri) + r[2] + "/" + r[3] + rpad_(ff[2],ri): fill(" ", 2*ri+1 + r[2].length + r[3].length));
	}
	if((r = fmt.match(/^[#0?]+$/))) {
		o = "" + val;
		if(fmt.length <= o.length) return o;
		return hashq(fmt.substr(0,fmt.length-o.length)) + o;
	}
	if((r = fmt.match(/^([#0]+)\.([#0]+)$/))) {
		o = "" + val.toFixed(Math.min(r[2].length,10)).replace(/([^0])0+$/,"$1");
		ri = o.indexOf(".");
		var lres = fmt.indexOf(".") - ri, rres = fmt.length - o.length - lres;
		return hashq(fmt.substr(0,lres) + o + fmt.substr(fmt.length-rres));
	}
	if((r = fmt.match(/^00,000\.([#0]*0)$/))) {
		return val < 0 ? "-" + write_num_int(type, fmt, -val) : commaify(""+val).replace(/^\d,\d{3}$/,"0$&").replace(/^\d*$/,function($$) { return "00," + ($$.length < 3 ? pad0(0,3-$$.length) : "") + $$; }) + "." + pad0(0,r[1].length);
	}
	switch(fmt) {
		case "###,###":
		case "##,###":
		case "#,###": var x = commaify(""+aval); return x !== "0" ? sign + x : "";
		default:
			if(fmt.match(/\.[0#?]*$/)) return write_num_int(type, fmt.slice(0,fmt.lastIndexOf(".")), val) + hashq(fmt.slice(fmt.lastIndexOf(".")));
	}
	throw new Error("unsupported format |" + fmt + "|");
}
return function write_num(type/*:string*/, fmt/*:string*/, val/*:number*/)/*:string*/ {
	return (val|0) === val ? write_num_int(type, fmt, val) : write_num_flt(type, fmt, val);
};})();
function split_fmt(fmt/*:string*/)/*:Array<string>*/ {
	var out/*:Array<string>*/ = [];
	var in_str = false/*, cc*/;
	for(var i = 0, j = 0; i < fmt.length; ++i) switch((/*cc=*/fmt.charCodeAt(i))) {
		case 34: /* '"' */
			in_str = !in_str; break;
		case 95: case 42: case 92: /* '_' '*' '\\' */
			++i; break;
		case 59: /* ';' */
			out[out.length] = fmt.substr(j,i-j);
			j = i+1;
	}
	out[out.length] = fmt.substr(j);
	if(in_str === true) throw new Error("Format |" + fmt + "| unterminated string ");
	return out;
}
SSF._split = split_fmt;
var abstime = /\[[HhMmSs\u0E0A\u0E19\u0E17]*\]/;
function fmt_is_date(fmt/*:string*/)/*:boolean*/ {
	var i = 0, /*cc = 0,*/ c = "", o = "";
	while(i < fmt.length) {
		switch((c = fmt.charAt(i))) {
			case 'G': if(isgeneral(fmt, i)) i+= 6; i++; break;
			case '"': for(;(/*cc=*/fmt.charCodeAt(++i)) !== 34 && i < fmt.length;){/*empty*/} ++i; break;
			case '\\': i+=2; break;
			case '_': i+=2; break;
			case '@': ++i; break;
			case 'B': case 'b':
				if(fmt.charAt(i+1) === "1" || fmt.charAt(i+1) === "2") return true;
				/* falls through */
			case 'M': case 'D': case 'Y': case 'H': case 'S': case 'E':
				/* falls through */
			case 'm': case 'd': case 'y': case 'h': case 's': case 'e': case 'g': return true;
			case 'A': case 'a': case '上':
				if(fmt.substr(i, 3).toUpperCase() === "A/P") return true;
				if(fmt.substr(i, 5).toUpperCase() === "AM/PM") return true;
				if(fmt.substr(i, 5).toUpperCase() === "上午/下午") return true;
				++i; break;
			case '[':
				o = c;
				while(fmt.charAt(i++) !== ']' && i < fmt.length) o += fmt.charAt(i);
				if(o.match(abstime)) return true;
				break;
			case '.':
				/* falls through */
			case '0': case '#':
				while(i < fmt.length && ("0#?.,E+-%".indexOf(c=fmt.charAt(++i)) > -1 || (c=='\\' && fmt.charAt(i+1) == "-" && "0#".indexOf(fmt.charAt(i+2))>-1))){/* empty */}
				break;
			case '?': while(fmt.charAt(++i) === c){/* empty */} break;
			case '*': ++i; if(fmt.charAt(i) == ' ' || fmt.charAt(i) == '*') ++i; break;
			case '(': case ')': ++i; break;
			case '1': case '2': case '3': case '4': case '5': case '6': case '7': case '8': case '9':
				while(i < fmt.length && "0123456789".indexOf(fmt.charAt(++i)) > -1){/* empty */} break;
			case ' ': ++i; break;
			default: ++i; break;
		}
	}
	return false;
}
SSF.is_date = fmt_is_date;
function eval_fmt(fmt/*:string*/, v/*:any*/, opts/*:any*/, flen/*:number*/) {
	var out = [], o = "", i = 0, c = "", lst='t', dt, j, cc;
	var hr='H';
	/* Tokenize */
	while(i < fmt.length) {
		switch((c = fmt.charAt(i))) {
			case 'G': /* General */
				if(!isgeneral(fmt, i)) throw new Error('unrecognized character ' + c + ' in ' +fmt);
				out[out.length] = {t:'G', v:'General'}; i+=7; break;
			case '"': /* Literal text */
				for(o="";(cc=fmt.charCodeAt(++i)) !== 34 && i < fmt.length;) o += String.fromCharCode(cc);
				out[out.length] = {t:'t', v:o}; ++i; break;
			case '\\': var w = fmt.charAt(++i), t = (w === "(" || w === ")") ? w : 't';
				out[out.length] = {t:t, v:w}; ++i; break;
			case '_': out[out.length] = {t:'t', v:" "}; i+=2; break;
			case '@': /* Text Placeholder */
				out[out.length] = {t:'T', v:v}; ++i; break;
			case 'B': case 'b':
				if(fmt.charAt(i+1) === "1" || fmt.charAt(i+1) === "2") {
					if(dt==null) { dt=parse_date_code(v, opts, fmt.charAt(i+1) === "2"); if(dt==null) return ""; }
					out[out.length] = {t:'X', v:fmt.substr(i,2)}; lst = c; i+=2; break;
				}
				/* falls through */
			case 'M': case 'D': case 'Y': case 'H': case 'S': case 'E':
				c = c.toLowerCase();
				/* falls through */
			case 'm': case 'd': case 'y': case 'h': case 's': case 'e': case 'g':
				if(v < 0) return "";
				if(dt==null) { dt=parse_date_code(v, opts); if(dt==null) return ""; }
				o = c; while(++i < fmt.length && fmt.charAt(i).toLowerCase() === c) o+=c;
				if(c === 'm' && lst.toLowerCase() === 'h') c = 'M';
				if(c === 'h') c = hr;
				out[out.length] = {t:c, v:o}; lst = c; break;
			case 'A': case 'a': case '上':
				var q={t:c, v:c};
				if(dt==null) dt=parse_date_code(v, opts);
				if(fmt.substr(i, 3).toUpperCase() === "A/P") { if(dt!=null) q.v = dt.H >= 12 ? "P" : "A"; q.t = 'T'; hr='h';i+=3;}
				else if(fmt.substr(i,5).toUpperCase() === "AM/PM") { if(dt!=null) q.v = dt.H >= 12 ? "PM" : "AM"; q.t = 'T'; i+=5; hr='h'; }
				else if(fmt.substr(i,5).toUpperCase() === "上午/下午") { if(dt!=null) q.v = dt.H >= 12 ? "下午" : "上午"; q.t = 'T'; i+=5; hr='h'; }
				else { q.t = "t"; ++i; }
				if(dt==null && q.t === 'T') return "";
				out[out.length] = q; lst = c; break;
			case '[':
				o = c;
				while(fmt.charAt(i++) !== ']' && i < fmt.length) o += fmt.charAt(i);
				if(o.slice(-1) !== ']') throw 'unterminated "[" block: |' + o + '|';
				if(o.match(abstime)) {
					if(dt==null) { dt=parse_date_code(v, opts); if(dt==null) return ""; }
					out[out.length] = {t:'Z', v:o.toLowerCase()};
					lst = o.charAt(1);
				} else if(o.indexOf("$") > -1) {
					o = (o.match(/\$([^-\[\]]*)/)||[])[1]||"$";
					if(!fmt_is_date(fmt)) out[out.length] = {t:'t',v:o};
				}
				break;
			/* Numbers */
			case '.':
				if(dt != null) {
					o = c; while(++i < fmt.length && (c=fmt.charAt(i)) === "0") o += c;
					out[out.length] = {t:'s', v:o}; break;
				}
				/* falls through */
			case '0': case '#':
				o = c; while(++i < fmt.length && "0#?.,E+-%".indexOf(c=fmt.charAt(i)) > -1) o += c;
				out[out.length] = {t:'n', v:o}; break;
			case '?':
				o = c; while(fmt.charAt(++i) === c) o+=c;
				out[out.length] = {t:c, v:o}; lst = c; break;
			case '*': ++i; if(fmt.charAt(i) == ' ' || fmt.charAt(i) == '*') ++i; break; // **
			case '(': case ')': out[out.length] = {t:(flen===1?'t':c), v:c}; ++i; break;
			case '1': case '2': case '3': case '4': case '5': case '6': case '7': case '8': case '9':
				o = c; while(i < fmt.length && "0123456789".indexOf(fmt.charAt(++i)) > -1) o+=fmt.charAt(i);
				out[out.length] = {t:'D', v:o}; break;
			case ' ': out[out.length] = {t:c, v:c}; ++i; break;
			case '$': out[out.length] = {t:'t', v:'$'}; ++i; break;
			default:
				if(",$-+/():!^&'~{}<>=€acfijklopqrtuvwxzP".indexOf(c) === -1) throw new Error('unrecognized character ' + c + ' in ' + fmt);
				out[out.length] = {t:'t', v:c}; ++i; break;
		}
	}

	/* Scan for date/time parts */
	var bt = 0, ss0 = 0, ssm;
	for(i=out.length-1, lst='t'; i >= 0; --i) {
		switch(out[i].t) {
			case 'h': case 'H': out[i].t = hr; lst='h'; if(bt < 1) bt = 1; break;
			case 's':
				if((ssm=out[i].v.match(/\.0+$/))) ss0=Math.max(ss0,ssm[0].length-1);
				if(bt < 3) bt = 3;
			/* falls through */
			case 'd': case 'y': case 'M': case 'e': lst=out[i].t; break;
			case 'm': if(lst === 's') { out[i].t = 'M'; if(bt < 2) bt = 2; } break;
			case 'X': /*if(out[i].v === "B2");*/
				break;
			case 'Z':
				if(bt < 1 && out[i].v.match(/[Hh]/)) bt = 1;
				if(bt < 2 && out[i].v.match(/[Mm]/)) bt = 2;
				if(bt < 3 && out[i].v.match(/[Ss]/)) bt = 3;
		}
	}
	/* time rounding depends on presence of minute / second / usec fields */
	switch(bt) {
		case 0: break;
		case 1:
			/*::if(!dt) break;*/
			if(dt.u >= 0.5) { dt.u = 0; ++dt.S; }
			if(dt.S >=  60) { dt.S = 0; ++dt.M; }
			if(dt.M >=  60) { dt.M = 0; ++dt.H; }
			break;
		case 2:
			/*::if(!dt) break;*/
			if(dt.u >= 0.5) { dt.u = 0; ++dt.S; }
			if(dt.S >=  60) { dt.S = 0; ++dt.M; }
			break;
	}

	/* replace fields */
	var nstr = "", jj;
	for(i=0; i < out.length; ++i) {
		switch(out[i].t) {
			case 't': case 'T': case ' ': case 'D': break;
			case 'X': out[i].v = ""; out[i].t = ";"; break;
			case 'd': case 'm': case 'y': case 'h': case 'H': case 'M': case 's': case 'e': case 'b': case 'Z':
				/*::if(!dt) throw "unreachable"; */
				out[i].v = write_date(out[i].t.charCodeAt(0), out[i].v, dt, ss0);
				out[i].t = 't'; break;
			case 'n': case '?':
				jj = i+1;
				while(out[jj] != null && (
					(c=out[jj].t) === "?" || c === "D" ||
					((c === " " || c === "t") && out[jj+1] != null && (out[jj+1].t === '?' || out[jj+1].t === "t" && out[jj+1].v === '/')) ||
					(out[i].t === '(' && (c === ' ' || c === 'n' || c === ')')) ||
					(c === 't' && (out[jj].v === '/' || out[jj].v === ' ' && out[jj+1] != null && out[jj+1].t == '?'))
				)) {
					out[i].v += out[jj].v;
					out[jj] = {v:"", t:";"}; ++jj;
				}
				nstr += out[i].v;
				i = jj-1; break;
			case 'G': out[i].t = 't'; out[i].v = general_fmt(v,opts); break;
		}
	}
	var vv = "", myv, ostr;
	if(nstr.length > 0) {
		if(nstr.charCodeAt(0) == 40) /* '(' */ {
			myv = (v<0&&nstr.charCodeAt(0) === 45 ? -v : v);
			ostr = write_num('n', nstr, myv);
		} else {
			myv = (v<0 && flen > 1 ? -v : v);
			ostr = write_num('n', nstr, myv);
			if(myv < 0 && out[0] && out[0].t == 't') {
				ostr = ostr.substr(1);
				out[0].v = "-" + out[0].v;
			}
		}
		jj=ostr.length-1;
		var decpt = out.length;
		for(i=0; i < out.length; ++i) if(out[i] != null && out[i].t != 't' && out[i].v.indexOf(".") > -1) { decpt = i; break; }
		var lasti=out.length;
		if(decpt === out.length && ostr.indexOf("E") === -1) {
			for(i=out.length-1; i>= 0;--i) {
				if(out[i] == null || 'n?'.indexOf(out[i].t) === -1) continue;
				if(jj>=out[i].v.length-1) { jj -= out[i].v.length; out[i].v = ostr.substr(jj+1, out[i].v.length); }
				else if(jj < 0) out[i].v = "";
				else { out[i].v = ostr.substr(0, jj+1); jj = -1; }
				out[i].t = 't';
				lasti = i;
			}
			if(jj>=0 && lasti<out.length) out[lasti].v = ostr.substr(0,jj+1) + out[lasti].v;
		}
		else if(decpt !== out.length && ostr.indexOf("E") === -1) {
			jj = ostr.indexOf(".")-1;
			for(i=decpt; i>= 0; --i) {
				if(out[i] == null || 'n?'.indexOf(out[i].t) === -1) continue;
				j=out[i].v.indexOf(".")>-1&&i===decpt?out[i].v.indexOf(".")-1:out[i].v.length-1;
				vv = out[i].v.substr(j+1);
				for(; j>=0; --j) {
					if(jj>=0 && (out[i].v.charAt(j) === "0" || out[i].v.charAt(j) === "#")) vv = ostr.charAt(jj--) + vv;
				}
				out[i].v = vv;
				out[i].t = 't';
				lasti = i;
			}
			if(jj>=0 && lasti<out.length) out[lasti].v = ostr.substr(0,jj+1) + out[lasti].v;
			jj = ostr.indexOf(".")+1;
			for(i=decpt; i<out.length; ++i) {
				if(out[i] == null || ('n?('.indexOf(out[i].t) === -1 && i !== decpt)) continue;
				j=out[i].v.indexOf(".")>-1&&i===decpt?out[i].v.indexOf(".")+1:0;
				vv = out[i].v.substr(0,j);
				for(; j<out[i].v.length; ++j) {
					if(jj<ostr.length) vv += ostr.charAt(jj++);
				}
				out[i].v = vv;
				out[i].t = 't';
				lasti = i;
			}
		}
	}
	for(i=0; i<out.length; ++i) if(out[i] != null && 'n?'.indexOf(out[i].t)>-1) {
		myv = (flen >1 && v < 0 && i>0 && out[i-1].v === "-" ? -v:v);
		out[i].v = write_num(out[i].t, out[i].v, myv);
		out[i].t = 't';
	}
	var retval = "";
	for(i=0; i !== out.length; ++i) if(out[i] != null) retval += out[i].v;
	return retval;
}
SSF._eval = eval_fmt;
var cfregex = /\[[=<>]/;
var cfregex2 = /\[(=|>[=]?|<[>=]?)(-?\d+(?:\.\d*)?)\]/;
function chkcond(v, rr) {
	if(rr == null) return false;
	var thresh = parseFloat(rr[2]);
	switch(rr[1]) {
		case "=":  if(v == thresh) return true; break;
		case ">":  if(v >  thresh) return true; break;
		case "<":  if(v <  thresh) return true; break;
		case "<>": if(v != thresh) return true; break;
		case ">=": if(v >= thresh) return true; break;
		case "<=": if(v <= thresh) return true; break;
	}
	return false;
}
function choose_fmt(f/*:string*/, v/*:any*/) {
	var fmt = split_fmt(f);
	var l = fmt.length, lat = fmt[l-1].indexOf("@");
	if(l<4 && lat>-1) --l;
	if(fmt.length > 4) throw new Error("cannot find right format for |" + fmt.join("|") + "|");
	if(typeof v !== "number") return [4, fmt.length === 4 || lat>-1?fmt[fmt.length-1]:"@"];
	switch(fmt.length) {
		case 1: fmt = lat>-1 ? ["General", "General", "General", fmt[0]] : [fmt[0], fmt[0], fmt[0], "@"]; break;
		case 2: fmt = lat>-1 ? [fmt[0], fmt[0], fmt[0], fmt[1]] : [fmt[0], fmt[1], fmt[0], "@"]; break;
		case 3: fmt = lat>-1 ? [fmt[0], fmt[1], fmt[0], fmt[2]] : [fmt[0], fmt[1], fmt[2], "@"]; break;
	}
	var ff = v > 0 ? fmt[0] : v < 0 ? fmt[1] : fmt[2];
	if(fmt[0].indexOf("[") === -1 && fmt[1].indexOf("[") === -1) return [l, ff];
	if(fmt[0].match(cfregex) != null || fmt[1].match(cfregex) != null) {
		var m1 = fmt[0].match(cfregex2);
		var m2 = fmt[1].match(cfregex2);
		return chkcond(v, m1) ? [l, fmt[0]] : chkcond(v, m2) ? [l, fmt[1]] : [l, fmt[m1 != null && m2 != null ? 2 : 1]];
	}
	return [l, ff];
}
function format(fmt/*:string|number*/,v/*:any*/,o/*:?any*/) {
	if(o == null) o = {};
	var sfmt = "";
	switch(typeof fmt) {
		case "string":
			if(fmt == "m/d/yy" && o.dateNF) sfmt = o.dateNF;
			else sfmt = fmt;
			break;
		case "number":
			if(fmt == 14 && o.dateNF) sfmt = o.dateNF;
			else sfmt = (o.table != null ? (o.table/*:any*/) : table_fmt)[fmt];
			if(sfmt == null) sfmt = (o.table && o.table[default_map[fmt]]) || table_fmt[default_map[fmt]];
			if(sfmt == null) sfmt = default_str[fmt] || "General";
			break;
	}
	if(isgeneral(sfmt,0)) return general_fmt(v, o);
	if(v instanceof Date) v = datenum_local(v, o.date1904);
	var f = choose_fmt(sfmt, v);
	if(isgeneral(f[1])) return general_fmt(v, o);
	if(v === true) v = "TRUE"; else if(v === false) v = "FALSE";
	else if(v === "" || v == null) return "";
	return eval_fmt(f[1], v, o, f[0]);
}
function load_entry(fmt/*:string*/, idx/*:?number*/)/*:number*/ {
	if(typeof idx != 'number') {
		idx = +idx || -1;
/*::if(typeof idx != 'number') return 0x188; */
		for(var i = 0; i < 0x0188; ++i) {
/*::if(typeof idx != 'number') return 0x188; */
			if(table_fmt[i] == undefined) { if(idx < 0) idx = i; continue; }
			if(table_fmt[i] == fmt) { idx = i; break; }
		}
/*::if(typeof idx != 'number') return 0x188; */
		if(idx < 0) idx = 0x187;
	}
/*::if(typeof idx != 'number') return 0x188; */
	table_fmt[idx] = fmt;
	return idx;
}
SSF.load = load_entry;
SSF._table = table_fmt;
SSF.get_table = function get_table()/*:SSFTable*/ { return table_fmt; };
SSF.load_table = function load_table(tbl/*:SSFTable*/)/*:void*/ {
	for(var i=0; i!=0x0188; ++i)
		if(tbl[i] !== undefined) load_entry(tbl[i], i);
};
SSF.init_table = init_table;
SSF.format = format;
};
make_ssf(SSF);
/* map from xlml named formats to SSF TODO: localize */
var XLMLFormatMap/*{[string]:string}*/ = ({
	"General Number": "General",
	"General Date": SSF._table[22],
	"Long Date": "dddd, mmmm dd, yyyy",
	"Medium Date": SSF._table[15],
	"Short Date": SSF._table[14],
	"Long Time": SSF._table[19],
	"Medium Time": SSF._table[18],
	"Short Time": SSF._table[20],
	"Currency": '"$"#,##0.00_);[Red]\\("$"#,##0.00\\)',
	"Fixed": SSF._table[2],
	"Standard": SSF._table[4],
	"Percent": SSF._table[10],
	"Scientific": SSF._table[11],
	"Yes/No": '"Yes";"Yes";"No";@',
	"True/False": '"True";"True";"False";@',
	"On/Off": '"Yes";"Yes";"No";@'
}/*:any*/);

var SSFImplicit/*{[number]:string}*/ = ({
	"5": '"$"#,##0_);\\("$"#,##0\\)',
	"6": '"$"#,##0_);[Red]\\("$"#,##0\\)',
	"7": '"$"#,##0.00_);\\("$"#,##0.00\\)',
	"8": '"$"#,##0.00_);[Red]\\("$"#,##0.00\\)',
	"23": 'General', "24": 'General', "25": 'General', "26": 'General',
	"27": 'm/d/yy', "28": 'm/d/yy', "29": 'm/d/yy', "30": 'm/d/yy', "31": 'm/d/yy',
	"32": 'h:mm:ss', "33": 'h:mm:ss', "34": 'h:mm:ss', "35": 'h:mm:ss',
	"36": 'm/d/yy',
	"41": '_(* #,##0_);_(* \(#,##0\);_(* "-"_);_(@_)',
	"42": '_("$"* #,##0_);_("$"* \(#,##0\);_("$"* "-"_);_(@_)',
	"43": '_(* #,##0.00_);_(* \(#,##0.00\);_(* "-"??_);_(@_)',
	"44": '_("$"* #,##0.00_);_("$"* \(#,##0.00\);_("$"* "-"??_);_(@_)',
	"50": 'm/d/yy', "51": 'm/d/yy', "52": 'm/d/yy', "53": 'm/d/yy', "54": 'm/d/yy',
	"55": 'm/d/yy', "56": 'm/d/yy', "57": 'm/d/yy', "58": 'm/d/yy',
	"59": '0',
	"60": '0.00',
	"61": '#,##0',
	"62": '#,##0.00',
	"63": '"$"#,##0_);\\("$"#,##0\\)',
	"64": '"$"#,##0_);[Red]\\("$"#,##0\\)',
	"65": '"$"#,##0.00_);\\("$"#,##0.00\\)',
	"66": '"$"#,##0.00_);[Red]\\("$"#,##0.00\\)',
	"67": '0%',
	"68": '0.00%',
	"69": '# ?/?',
	"70": '# ??/??',
	"71": 'm/d/yy',
	"72": 'm/d/yy',
	"73": 'd-mmm-yy',
	"74": 'd-mmm',
	"75": 'mmm-yy',
	"76": 'h:mm',
	"77": 'h:mm:ss',
	"78": 'm/d/yy h:mm',
	"79": 'mm:ss',
	"80": '[h]:mm:ss',
	"81": 'mmss.0'
}/*:any*/);

/* dateNF parse TODO: move to SSF */
var dateNFregex = /[dD]+|[mM]+|[yYeE]+|[Hh]+|[Ss]+/g;
function dateNF_regex(dateNF/*:string|number*/)/*:RegExp*/ {
	var fmt = typeof dateNF == "number" ? SSF._table[dateNF] : dateNF;
	fmt = fmt.replace(dateNFregex, "(\\d+)");
	return new RegExp("^" + fmt + "$");
}
function dateNF_fix(str/*:string*/, dateNF/*:string*/, match/*:Array<string>*/)/*:string*/ {
	var Y = -1, m = -1, d = -1, H = -1, M = -1, S = -1;
	(dateNF.match(dateNFregex)||[]).forEach(function(n, i) {
		var v = parseInt(match[i+1], 10);
		switch(n.toLowerCase().charAt(0)) {
			case 'y': Y = v; break; case 'd': d = v; break;
			case 'h': H = v; break; case 's': S = v; break;
			case 'm': if(H >= 0) M = v; else m = v; break;
		}
	});
	if(S >= 0 && M == -1 && m >= 0) { M = m; m = -1; }
	var datestr = (("" + (Y>=0?Y: new Date().getFullYear())).slice(-4) + "-" + ("00" + (m>=1?m:1)).slice(-2) + "-" + ("00" + (d>=1?d:1)).slice(-2));
	if(datestr.length == 7) datestr = "0" + datestr;
	if(datestr.length == 8) datestr = "20" + datestr;
	var timestr = (("00" + (H>=0?H:0)).slice(-2) + ":" + ("00" + (M>=0?M:0)).slice(-2) + ":" + ("00" + (S>=0?S:0)).slice(-2));
	if(H == -1 && M == -1 && S == -1) return datestr;
	if(Y == -1 && m == -1 && d == -1) return timestr;
	return datestr + "T" + timestr;
}

var DO_NOT_EXPORT_CFB = true;
/*::
declare var Base64:any;
declare var ReadShift:any;
declare var CheckField:any;
declare var prep_blob:any;
declare var __readUInt32LE:any;
declare var __readInt32LE:any;
declare var __toBuffer:any;
declare var __utf16le:any;
declare var bconcat:any;
declare var s2a:any;
declare var chr0:any;
declare var chr1:any;
declare var has_buf:boolean;
declare var new_buf:any;
declare var new_raw_buf:any;
declare var new_unsafe_buf:any;
declare var Buffer_from:any;
*/
/* cfb.js (C) 2013-present SheetJS -- http://sheetjs.com */
/* vim: set ts=2: */
/*jshint eqnull:true */
/*exported CFB */
/*global module, require:false, process:false, Buffer:false, Uint8Array:false, Uint16Array:false */

/*::
declare var DO_NOT_EXPORT_CFB:?boolean;
type SectorEntry = {
	name?:string;
	nodes?:Array<number>;
	data:RawBytes;
};
type SectorList = {
	[k:string|number]:SectorEntry;
	name:?string;
	fat_addrs:Array<number>;
	ssz:number;
}
type CFBFiles = {[n:string]:CFBEntry};
*/
/* crc32.js (C) 2014-present SheetJS -- http://sheetjs.com */
/* vim: set ts=2: */
/*exported CRC32 */
var CRC32;
(function (factory) {
	/*jshint ignore:start */
	/*eslint-disable */
	factory(CRC32 = {});
	/*eslint-enable */
	/*jshint ignore:end */
}(function(CRC32) {
CRC32.version = '1.2.0';
/* see perf/crc32table.js */
/*global Int32Array */
function signed_crc_table()/*:any*/ {
	var c = 0, table/*:Array<number>*/ = new Array(256);

	for(var n =0; n != 256; ++n){
		c = n;
		c = ((c&1) ? (-306674912 ^ (c >>> 1)) : (c >>> 1));
		c = ((c&1) ? (-306674912 ^ (c >>> 1)) : (c >>> 1));
		c = ((c&1) ? (-306674912 ^ (c >>> 1)) : (c >>> 1));
		c = ((c&1) ? (-306674912 ^ (c >>> 1)) : (c >>> 1));
		c = ((c&1) ? (-306674912 ^ (c >>> 1)) : (c >>> 1));
		c = ((c&1) ? (-306674912 ^ (c >>> 1)) : (c >>> 1));
		c = ((c&1) ? (-306674912 ^ (c >>> 1)) : (c >>> 1));
		c = ((c&1) ? (-306674912 ^ (c >>> 1)) : (c >>> 1));
		table[n] = c;
	}

	return typeof Int32Array !== 'undefined' ? new Int32Array(table) : table;
}

var T0 = signed_crc_table();
function slice_by_16_tables(T) {
	var c = 0, v = 0, n = 0, table/*:Array<number>*/ = typeof Int32Array !== 'undefined' ? new Int32Array(4096) : new Array(4096) ;

	for(n = 0; n != 256; ++n) table[n] = T[n];
	for(n = 0; n != 256; ++n) {
		v = T[n];
		for(c = 256 + n; c < 4096; c += 256) v = table[c] = (v >>> 8) ^ T[v & 0xFF];
	}
	var out = [];
	for(n = 1; n != 16; ++n) out[n - 1] = typeof Int32Array !== 'undefined' ? table.subarray(n * 256, n * 256 + 256) : table.slice(n * 256, n * 256 + 256);
	return out;
}
var TT = slice_by_16_tables(T0);
var T1 = TT[0],  T2 = TT[1],  T3 = TT[2],  T4 = TT[3],  T5 = TT[4];
var T6 = TT[5],  T7 = TT[6],  T8 = TT[7],  T9 = TT[8],  Ta = TT[9];
var Tb = TT[10], Tc = TT[11], Td = TT[12], Te = TT[13], Tf = TT[14];
function crc32_bstr(bstr/*:string*/, seed/*:number*/)/*:number*/ {
	var C = seed/*:: ? 0 : 0 */ ^ -1;
	for(var i = 0, L = bstr.length; i < L;) C = (C>>>8) ^ T0[(C^bstr.charCodeAt(i++))&0xFF];
	return ~C;
}

function crc32_buf(B/*:Uint8Array|Array<number>*/, seed/*:number*/)/*:number*/ {
	var C = seed/*:: ? 0 : 0 */ ^ -1, L = B.length - 15, i = 0;
	for(; i < L;) C =
		Tf[B[i++] ^ (C & 255)] ^
		Te[B[i++] ^ ((C >> 8) & 255)] ^
		Td[B[i++] ^ ((C >> 16) & 255)] ^
		Tc[B[i++] ^ (C >>> 24)] ^
		Tb[B[i++]] ^ Ta[B[i++]] ^ T9[B[i++]] ^ T8[B[i++]] ^
		T7[B[i++]] ^ T6[B[i++]] ^ T5[B[i++]] ^ T4[B[i++]] ^
		T3[B[i++]] ^ T2[B[i++]] ^ T1[B[i++]] ^ T0[B[i++]];
	L += 15;
	while(i < L) C = (C>>>8) ^ T0[(C^B[i++])&0xFF];
	return ~C;
}

function crc32_str(str/*:string*/, seed/*:number*/)/*:number*/ {
	var C = seed ^ -1;
	for(var i = 0, L = str.length, c = 0, d = 0; i < L;) {
		c = str.charCodeAt(i++);
		if(c < 0x80) {
			C = (C>>>8) ^ T0[(C^c)&0xFF];
		} else if(c < 0x800) {
			C = (C>>>8) ^ T0[(C ^ (192|((c>>6)&31)))&0xFF];
			C = (C>>>8) ^ T0[(C ^ (128|(c&63)))&0xFF];
		} else if(c >= 0xD800 && c < 0xE000) {
			c = (c&1023)+64; d = str.charCodeAt(i++)&1023;
			C = (C>>>8) ^ T0[(C ^ (240|((c>>8)&7)))&0xFF];
			C = (C>>>8) ^ T0[(C ^ (128|((c>>2)&63)))&0xFF];
			C = (C>>>8) ^ T0[(C ^ (128|((d>>6)&15)|((c&3)<<4)))&0xFF];
			C = (C>>>8) ^ T0[(C ^ (128|(d&63)))&0xFF];
		} else {
			C = (C>>>8) ^ T0[(C ^ (224|((c>>12)&15)))&0xFF];
			C = (C>>>8) ^ T0[(C ^ (128|((c>>6)&63)))&0xFF];
			C = (C>>>8) ^ T0[(C ^ (128|(c&63)))&0xFF];
		}
	}
	return ~C;
}
CRC32.table = T0;
CRC32.bstr = crc32_bstr;
CRC32.buf = crc32_buf;
CRC32.str = crc32_str;
}));
/* [MS-CFB] v20171201 */
var CFB = (function _CFB(){
var exports/*:CFBModule*/ = /*::(*/{}/*:: :any)*/;
exports.version = '1.2.1';
/* [MS-CFB] 2.6.4 */
function namecmp(l/*:string*/, r/*:string*/)/*:number*/ {
	var L = l.split("/"), R = r.split("/");
	for(var i = 0, c = 0, Z = Math.min(L.length, R.length); i < Z; ++i) {
		if((c = L[i].length - R[i].length)) return c;
		if(L[i] != R[i]) return L[i] < R[i] ? -1 : 1;
	}
	return L.length - R.length;
}
function dirname(p/*:string*/)/*:string*/ {
	if(p.charAt(p.length - 1) == "/") return (p.slice(0,-1).indexOf("/") === -1) ? p : dirname(p.slice(0, -1));
	var c = p.lastIndexOf("/");
	return (c === -1) ? p : p.slice(0, c+1);
}

function filename(p/*:string*/)/*:string*/ {
	if(p.charAt(p.length - 1) == "/") return filename(p.slice(0, -1));
	var c = p.lastIndexOf("/");
	return (c === -1) ? p : p.slice(c+1);
}
/* -------------------------------------------------------------------------- */
/* DOS Date format:
   high|YYYYYYYm.mmmddddd.HHHHHMMM.MMMSSSSS|low
   add 1980 to stored year
   stored second should be doubled
*/

/* write JS date to buf as a DOS date */
function write_dos_date(buf/*:CFBlob*/, date/*:Date|string*/) {
	if(typeof date === "string") date = new Date(date);
	var hms/*:number*/ = date.getHours();
	hms = hms << 6 | date.getMinutes();
	hms = hms << 5 | (date.getSeconds()>>>1);
	buf.write_shift(2, hms);
	var ymd/*:number*/ = (date.getFullYear() - 1980);
	ymd = ymd << 4 | (date.getMonth()+1);
	ymd = ymd << 5 | date.getDate();
	buf.write_shift(2, ymd);
}

/* read four bytes from buf and interpret as a DOS date */
function parse_dos_date(buf/*:CFBlob*/)/*:Date*/ {
	var hms = buf.read_shift(2) & 0xFFFF;
	var ymd = buf.read_shift(2) & 0xFFFF;
	var val = new Date();
	var d = ymd & 0x1F; ymd >>>= 5;
	var m = ymd & 0x0F; ymd >>>= 4;
	val.setMilliseconds(0);
	val.setFullYear(ymd + 1980);
	val.setMonth(m-1);
	val.setDate(d);
	var S = hms & 0x1F; hms >>>= 5;
	var M = hms & 0x3F; hms >>>= 6;
	val.setHours(hms);
	val.setMinutes(M);
	val.setSeconds(S<<1);
	return val;
}
function parse_extra_field(blob/*:CFBlob*/)/*:any*/ {
	prep_blob(blob, 0);
	var o = /*::(*/{}/*:: :any)*/;
	var flags = 0;
	while(blob.l <= blob.length - 4) {
		var type = blob.read_shift(2);
		var sz = blob.read_shift(2), tgt = blob.l + sz;
		var p = {};
		switch(type) {
			/* UNIX-style Timestamps */
			case 0x5455: {
				flags = blob.read_shift(1);
				if(flags & 1) p.mtime = blob.read_shift(4);
				/* for some reason, CD flag corresponds to LFH */
				if(sz > 5) {
					if(flags & 2) p.atime = blob.read_shift(4);
					if(flags & 4) p.ctime = blob.read_shift(4);
				}
				if(p.mtime) p.mt = new Date(p.mtime*1000);
			}
			break;
		}
		blob.l = tgt;
		o[type] = p;
	}
	return o;
}
var fs/*:: = require('fs'); */;
function get_fs() { return fs || (fs = {}); }
function parse(file/*:RawBytes*/, options/*:CFBReadOpts*/)/*:CFBContainer*/ {
if(file[0] == 0x50 && file[1] == 0x4b) return parse_zip(file, options);
if((file[0] | 0x20) == 0x6d && (file[1]|0x20) == 0x69) return parse_mad(file, options);
if(file.length < 512) throw new Error("CFB file size " + file.length + " < 512");
var mver = 3;
var ssz = 512;
var nmfs = 0; // number of mini FAT sectors
var difat_sec_cnt = 0;
var dir_start = 0;
var minifat_start = 0;
var difat_start = 0;

var fat_addrs/*:Array<number>*/ = []; // locations of FAT sectors

/* [MS-CFB] 2.2 Compound File Header */
var blob/*:CFBlob*/ = /*::(*/file.slice(0,512)/*:: :any)*/;
prep_blob(blob, 0);

/* major version */
var mv = check_get_mver(blob);
mver = mv[0];
switch(mver) {
	case 3: ssz = 512; break; case 4: ssz = 4096; break;
	case 0: if(mv[1] == 0) return parse_zip(file, options);
	/* falls through */
	default: throw new Error("Major Version: Expected 3 or 4 saw " + mver);
}

/* reprocess header */
if(ssz !== 512) { blob = /*::(*/file.slice(0,ssz)/*:: :any)*/; prep_blob(blob, 28 /* blob.l */); }
/* Save header for final object */
var header/*:RawBytes*/ = file.slice(0,ssz);

check_shifts(blob, mver);

// Number of Directory Sectors
var dir_cnt/*:number*/ = blob.read_shift(4, 'i');
if(mver === 3 && dir_cnt !== 0) throw new Error('# Directory Sectors: Expected 0 saw ' + dir_cnt);

// Number of FAT Sectors
blob.l += 4;

// First Directory Sector Location
dir_start = blob.read_shift(4, 'i');

// Transaction Signature
blob.l += 4;

// Mini Stream Cutoff Size
blob.chk('00100000', 'Mini Stream Cutoff Size: ');

// First Mini FAT Sector Location
minifat_start = blob.read_shift(4, 'i');

// Number of Mini FAT Sectors
nmfs = blob.read_shift(4, 'i');

// First DIFAT sector location
difat_start = blob.read_shift(4, 'i');

// Number of DIFAT Sectors
difat_sec_cnt = blob.read_shift(4, 'i');

// Grab FAT Sector Locations
for(var q = -1, j = 0; j < 109; ++j) { /* 109 = (512 - blob.l)>>>2; */
	q = blob.read_shift(4, 'i');
	if(q<0) break;
	fat_addrs[j] = q;
}

/** Break the file up into sectors */
var sectors/*:Array<RawBytes>*/ = sectorify(file, ssz);

sleuth_fat(difat_start, difat_sec_cnt, sectors, ssz, fat_addrs);

/** Chains */
var sector_list/*:SectorList*/ = make_sector_list(sectors, dir_start, fat_addrs, ssz);

sector_list[dir_start].name = "!Directory";
if(nmfs > 0 && minifat_start !== ENDOFCHAIN) sector_list[minifat_start].name = "!MiniFAT";
sector_list[fat_addrs[0]].name = "!FAT";
sector_list.fat_addrs = fat_addrs;
sector_list.ssz = ssz;

/* [MS-CFB] 2.6.1 Compound File Directory Entry */
var files/*:CFBFiles*/ = {}, Paths/*:Array<string>*/ = [], FileIndex/*:CFBFileIndex*/ = [], FullPaths/*:Array<string>*/ = [];
read_directory(dir_start, sector_list, sectors, Paths, nmfs, files, FileIndex, minifat_start);

build_full_paths(FileIndex, FullPaths, Paths);
Paths.shift();

var o = {
	FileIndex: FileIndex,
	FullPaths: FullPaths
};

// $FlowIgnore
if(options && options.raw) o.raw = {header: header, sectors: sectors};
return o;
} // parse

/* [MS-CFB] 2.2 Compound File Header -- read up to major version */
function check_get_mver(blob/*:CFBlob*/)/*:[number, number]*/ {
	if(blob[blob.l] == 0x50 && blob[blob.l + 1] == 0x4b) return [0, 0];
	// header signature 8
	blob.chk(HEADER_SIGNATURE, 'Header Signature: ');

	// clsid 16
	//blob.chk(HEADER_CLSID, 'CLSID: ');
	blob.l += 16;

	// minor version 2
	var mver/*:number*/ = blob.read_shift(2, 'u');

	return [blob.read_shift(2,'u'), mver];
}
function check_shifts(blob/*:CFBlob*/, mver/*:number*/)/*:void*/ {
	var shift = 0x09;

	// Byte Order
	//blob.chk('feff', 'Byte Order: '); // note: some writers put 0xffff
	blob.l += 2;

	// Sector Shift
	switch((shift = blob.read_shift(2))) {
		case 0x09: if(mver != 3) throw new Error('Sector Shift: Expected 9 saw ' + shift); break;
		case 0x0c: if(mver != 4) throw new Error('Sector Shift: Expected 12 saw ' + shift); break;
		default: throw new Error('Sector Shift: Expected 9 or 12 saw ' + shift);
	}

	// Mini Sector Shift
	blob.chk('0600', 'Mini Sector Shift: ');

	// Reserved
	blob.chk('000000000000', 'Reserved: ');
}

/** Break the file up into sectors */
function sectorify(file/*:RawBytes*/, ssz/*:number*/)/*:Array<RawBytes>*/ {
	var nsectors = Math.ceil(file.length/ssz)-1;
	var sectors/*:Array<RawBytes>*/ = [];
	for(var i=1; i < nsectors; ++i) sectors[i-1] = file.slice(i*ssz,(i+1)*ssz);
	sectors[nsectors-1] = file.slice(nsectors*ssz);
	return sectors;
}

/* [MS-CFB] 2.6.4 Red-Black Tree */
function build_full_paths(FI/*:CFBFileIndex*/, FP/*:Array<string>*/, Paths/*:Array<string>*/)/*:void*/ {
	var i = 0, L = 0, R = 0, C = 0, j = 0, pl = Paths.length;
	var dad/*:Array<number>*/ = [], q/*:Array<number>*/ = [];

	for(; i < pl; ++i) { dad[i]=q[i]=i; FP[i]=Paths[i]; }

	for(; j < q.length; ++j) {
		i = q[j];
		L = FI[i].L; R = FI[i].R; C = FI[i].C;
		if(dad[i] === i) {
			if(L !== -1 /*NOSTREAM*/ && dad[L] !== L) dad[i] = dad[L];
			if(R !== -1 && dad[R] !== R) dad[i] = dad[R];
		}
		if(C !== -1 /*NOSTREAM*/) dad[C] = i;
		if(L !== -1 && i != dad[i]) { dad[L] = dad[i]; if(q.lastIndexOf(L) < j) q.push(L); }
		if(R !== -1 && i != dad[i]) { dad[R] = dad[i]; if(q.lastIndexOf(R) < j) q.push(R); }
	}
	for(i=1; i < pl; ++i) if(dad[i] === i) {
		if(R !== -1 /*NOSTREAM*/ && dad[R] !== R) dad[i] = dad[R];
		else if(L !== -1 && dad[L] !== L) dad[i] = dad[L];
	}

	for(i=1; i < pl; ++i) {
		if(FI[i].type === 0 /* unknown */) continue;
		j = i;
		if(j != dad[j]) do {
			j = dad[j];
			FP[i] = FP[j] + "/" + FP[i];
		} while (j !== 0 && -1 !== dad[j] && j != dad[j]);
		dad[i] = -1;
	}

	FP[0] += "/";
	for(i=1; i < pl; ++i) {
		if(FI[i].type !== 2 /* stream */) FP[i] += "/";
	}
}

function get_mfat_entry(entry/*:CFBEntry*/, payload/*:RawBytes*/, mini/*:?RawBytes*/)/*:CFBlob*/ {
	var start = entry.start, size = entry.size;
	//return (payload.slice(start*MSSZ, start*MSSZ + size)/*:any*/);
	var o = [];
	var idx = start;
	while(mini && size > 0 && idx >= 0) {
		o.push(payload.slice(idx * MSSZ, idx * MSSZ + MSSZ));
		size -= MSSZ;
		idx = __readInt32LE(mini, idx * 4);
	}
	if(o.length === 0) return (new_buf(0)/*:any*/);
	return (bconcat(o).slice(0, entry.size)/*:any*/);
}

/** Chase down the rest of the DIFAT chain to build a comprehensive list
    DIFAT chains by storing the next sector number as the last 32 bits */
function sleuth_fat(idx/*:number*/, cnt/*:number*/, sectors/*:Array<RawBytes>*/, ssz/*:number*/, fat_addrs)/*:void*/ {
	var q/*:number*/ = ENDOFCHAIN;
	if(idx === ENDOFCHAIN) {
		if(cnt !== 0) throw new Error("DIFAT chain shorter than expected");
	} else if(idx !== -1 /*FREESECT*/) {
		var sector = sectors[idx], m = (ssz>>>2)-1;
		if(!sector) return;
		for(var i = 0; i < m; ++i) {
			if((q = __readInt32LE(sector,i*4)) === ENDOFCHAIN) break;
			fat_addrs.push(q);
		}
		sleuth_fat(__readInt32LE(sector,ssz-4),cnt - 1, sectors, ssz, fat_addrs);
	}
}

/** Follow the linked list of sectors for a given starting point */
function get_sector_list(sectors/*:Array<RawBytes>*/, start/*:number*/, fat_addrs/*:Array<number>*/, ssz/*:number*/, chkd/*:?Array<boolean>*/)/*:SectorEntry*/ {
	var buf/*:Array<number>*/ = [], buf_chain/*:Array<any>*/ = [];
	if(!chkd) chkd = [];
	var modulus = ssz - 1, j = 0, jj = 0;
	for(j=start; j>=0;) {
		chkd[j] = true;
		buf[buf.length] = j;
		buf_chain.push(sectors[j]);
		var addr = fat_addrs[Math.floor(j*4/ssz)];
		jj = ((j*4) & modulus);
		if(ssz < 4 + jj) throw new Error("FAT boundary crossed: " + j + " 4 "+ssz);
		if(!sectors[addr]) break;
		j = __readInt32LE(sectors[addr], jj);
	}
	return {nodes: buf, data:__toBuffer([buf_chain])};
}

/** Chase down the sector linked lists */
function make_sector_list(sectors/*:Array<RawBytes>*/, dir_start/*:number*/, fat_addrs/*:Array<number>*/, ssz/*:number*/)/*:SectorList*/ {
	var sl = sectors.length, sector_list/*:SectorList*/ = ([]/*:any*/);
	var chkd/*:Array<boolean>*/ = [], buf/*:Array<number>*/ = [], buf_chain/*:Array<RawBytes>*/ = [];
	var modulus = ssz - 1, i=0, j=0, k=0, jj=0;
	for(i=0; i < sl; ++i) {
		buf = ([]/*:Array<number>*/);
		k = (i + dir_start); if(k >= sl) k-=sl;
		if(chkd[k]) continue;
		buf_chain = [];
		var seen = [];
		for(j=k; j>=0;) {
			seen[j] = true;
			chkd[j] = true;
			buf[buf.length] = j;
			buf_chain.push(sectors[j]);
			var addr/*:number*/ = fat_addrs[Math.floor(j*4/ssz)];
			jj = ((j*4) & modulus);
			if(ssz < 4 + jj) throw new Error("FAT boundary crossed: " + j + " 4 "+ssz);
			if(!sectors[addr]) break;
			j = __readInt32LE(sectors[addr], jj);
			if(seen[j]) break;
		}
		sector_list[k] = ({nodes: buf, data:__toBuffer([buf_chain])}/*:SectorEntry*/);
	}
	return sector_list;
}

/* [MS-CFB] 2.6.1 Compound File Directory Entry */
function read_directory(dir_start/*:number*/, sector_list/*:SectorList*/, sectors/*:Array<RawBytes>*/, Paths/*:Array<string>*/, nmfs, files, FileIndex, mini) {
	var minifat_store = 0, pl = (Paths.length?2:0);
	var sector = sector_list[dir_start].data;
	var i = 0, namelen = 0, name;
	for(; i < sector.length; i+= 128) {
		var blob/*:CFBlob*/ = /*::(*/sector.slice(i, i+128)/*:: :any)*/;
		prep_blob(blob, 64);
		namelen = blob.read_shift(2);
		name = __utf16le(blob,0,namelen-pl);
		Paths.push(name);
		var o/*:CFBEntry*/ = ({
			name:  name,
			type:  blob.read_shift(1),
			color: blob.read_shift(1),
			L:     blob.read_shift(4, 'i'),
			R:     blob.read_shift(4, 'i'),
			C:     blob.read_shift(4, 'i'),
			clsid: blob.read_shift(16),
			state: blob.read_shift(4, 'i'),
			start: 0,
			size: 0
		});
		var ctime/*:number*/ = blob.read_shift(2) + blob.read_shift(2) + blob.read_shift(2) + blob.read_shift(2);
		if(ctime !== 0) o.ct = read_date(blob, blob.l-8);
		var mtime/*:number*/ = blob.read_shift(2) + blob.read_shift(2) + blob.read_shift(2) + blob.read_shift(2);
		if(mtime !== 0) o.mt = read_date(blob, blob.l-8);
		o.start = blob.read_shift(4, 'i');
		o.size = blob.read_shift(4, 'i');
		if(o.size < 0 && o.start < 0) { o.size = o.type = 0; o.start = ENDOFCHAIN; o.name = ""; }
		if(o.type === 5) { /* root */
			minifat_store = o.start;
			if(nmfs > 0 && minifat_store !== ENDOFCHAIN) sector_list[minifat_store].name = "!StreamData";
			/*minifat_size = o.size;*/
		} else if(o.size >= 4096 /* MSCSZ */) {
			o.storage = 'fat';
			if(sector_list[o.start] === undefined) sector_list[o.start] = get_sector_list(sectors, o.start, sector_list.fat_addrs, sector_list.ssz);
			sector_list[o.start].name = o.name;
			o.content = (sector_list[o.start].data.slice(0,o.size)/*:any*/);
		} else {
			o.storage = 'minifat';
			if(o.size < 0) o.size = 0;
			else if(minifat_store !== ENDOFCHAIN && o.start !== ENDOFCHAIN && sector_list[minifat_store]) {
				o.content = get_mfat_entry(o, sector_list[minifat_store].data, (sector_list[mini]||{}).data);
			}
		}
		if(o.content) prep_blob(o.content, 0);
		files[name] = o;
		FileIndex.push(o);
	}
}

function read_date(blob/*:RawBytes|CFBlob*/, offset/*:number*/)/*:Date*/ {
	return new Date(( ( (__readUInt32LE(blob,offset+4)/1e7)*Math.pow(2,32)+__readUInt32LE(blob,offset)/1e7 ) - 11644473600)*1000);
}

function read_file(filename/*:string*/, options/*:CFBReadOpts*/) {
	get_fs();
	return parse(fs.readFileSync(filename), options);
}

function read(blob/*:RawBytes|string*/, options/*:CFBReadOpts*/) {
	var type = options && options.type;
	if(!type) {
		if(has_buf && Buffer.isBuffer(blob)) type = "buffer";
	}
	switch(type || "base64") {
		case "file": /*:: if(typeof blob !== 'string') throw "Must pass a filename when type='file'"; */return read_file(blob, options);
		case "base64": /*:: if(typeof blob !== 'string') throw "Must pass a base64-encoded binary string when type='file'"; */return parse(s2a(Base64.decode(blob)), options);
		case "binary": /*:: if(typeof blob !== 'string') throw "Must pass a binary string when type='file'"; */return parse(s2a(blob), options);
	}
	return parse(/*::typeof blob == 'string' ? new Buffer(blob, 'utf-8') : */blob, options);
}

function init_cfb(cfb/*:CFBContainer*/, opts/*:?any*/)/*:void*/ {
	var o = opts || {}, root = o.root || "Root Entry";
	if(!cfb.FullPaths) cfb.FullPaths = [];
	if(!cfb.FileIndex) cfb.FileIndex = [];
	if(cfb.FullPaths.length !== cfb.FileIndex.length) throw new Error("inconsistent CFB structure");
	if(cfb.FullPaths.length === 0) {
		cfb.FullPaths[0] = root + "/";
		cfb.FileIndex[0] = ({ name: root, type: 5 }/*:any*/);
	}
	if(o.CLSID) cfb.FileIndex[0].clsid = o.CLSID;
	seed_cfb(cfb);
}
function seed_cfb(cfb/*:CFBContainer*/)/*:void*/ {
	var nm = "\u0001Sh33tJ5";
	if(CFB.find(cfb, "/" + nm)) return;
	var p = new_buf(4); p[0] = 55; p[1] = p[3] = 50; p[2] = 54;
	cfb.FileIndex.push(({ name: nm, type: 2, content:p, size:4, L:69, R:69, C:69 }/*:any*/));
	cfb.FullPaths.push(cfb.FullPaths[0] + nm);
	rebuild_cfb(cfb);
}
function rebuild_cfb(cfb/*:CFBContainer*/, f/*:?boolean*/)/*:void*/ {
	init_cfb(cfb);
	var gc = false, s = false;
	for(var i = cfb.FullPaths.length - 1; i >= 0; --i) {
		var _file = cfb.FileIndex[i];
		switch(_file.type) {
			case 0:
				if(s) gc = true;
				else { cfb.FileIndex.pop(); cfb.FullPaths.pop(); }
				break;
			case 1: case 2: case 5:
				s = true;
				if(isNaN(_file.R * _file.L * _file.C)) gc = true;
				if(_file.R > -1 && _file.L > -1 && _file.R == _file.L) gc = true;
				break;
			default: gc = true; break;
		}
	}
	if(!gc && !f) return;

	var now = new Date(1987, 1, 19), j = 0;
	// Track which names exist
	var fullPaths = Object.create ? Object.create(null) : {};
	var data/*:Array<[string, CFBEntry]>*/ = [];
	for(i = 0; i < cfb.FullPaths.length; ++i) {
		fullPaths[cfb.FullPaths[i]] = true;
		if(cfb.FileIndex[i].type === 0) continue;
		data.push([cfb.FullPaths[i], cfb.FileIndex[i]]);
	}
	for(i = 0; i < data.length; ++i) {
		var dad = dirname(data[i][0]);
		s = fullPaths[dad];
		if(!s) {
			data.push([dad, ({
				name: filename(dad).replace("/",""),
				type: 1,
				clsid: HEADER_CLSID,
				ct: now, mt: now,
				content: null
			}/*:any*/)]);
			// Add name to set
			fullPaths[dad] = true;
		}
	}

	data.sort(function(x,y) { return namecmp(x[0], y[0]); });
	cfb.FullPaths = []; cfb.FileIndex = [];
	for(i = 0; i < data.length; ++i) { cfb.FullPaths[i] = data[i][0]; cfb.FileIndex[i] = data[i][1]; }
	for(i = 0; i < data.length; ++i) {
		var elt = cfb.FileIndex[i];
		var nm = cfb.FullPaths[i];

		elt.name =  filename(nm).replace("/","");
		elt.L = elt.R = elt.C = -(elt.color = 1);
		elt.size = elt.content ? elt.content.length : 0;
		elt.start = 0;
		elt.clsid = (elt.clsid || HEADER_CLSID);
		if(i === 0) {
			elt.C = data.length > 1 ? 1 : -1;
			elt.size = 0;
			elt.type = 5;
		} else if(nm.slice(-1) == "/") {
			for(j=i+1;j < data.length; ++j) if(dirname(cfb.FullPaths[j])==nm) break;
			elt.C = j >= data.length ? -1 : j;
			for(j=i+1;j < data.length; ++j) if(dirname(cfb.FullPaths[j])==dirname(nm)) break;
			elt.R = j >= data.length ? -1 : j;
			elt.type = 1;
		} else {
			if(dirname(cfb.FullPaths[i+1]||"") == dirname(nm)) elt.R = i + 1;
			elt.type = 2;
		}
	}

}

function _write(cfb/*:CFBContainer*/, options/*:CFBWriteOpts*/)/*:RawBytes|string*/ {
	var _opts = options || {};
	/* MAD is order-sensitive, skip rebuild and sort */
	if(_opts.fileType == 'mad') return write_mad(cfb, _opts);
	rebuild_cfb(cfb);
	switch(_opts.fileType) {
		case 'zip': return write_zip(cfb, _opts);
		//case 'mad': return write_mad(cfb, _opts);
	}
	var L = (function(cfb/*:CFBContainer*/)/*:Array<number>*/{
		var mini_size = 0, fat_size = 0;
		for(var i = 0; i < cfb.FileIndex.length; ++i) {
			var file = cfb.FileIndex[i];
			if(!file.content) continue;
			/*:: if(file.content == null) throw new Error("unreachable"); */
			var flen = file.content.length;
			if(flen > 0){
				if(flen < 0x1000) mini_size += (flen + 0x3F) >> 6;
				else fat_size += (flen + 0x01FF) >> 9;
			}
		}
		var dir_cnt = (cfb.FullPaths.length +3) >> 2;
		var mini_cnt = (mini_size + 7) >> 3;
		var mfat_cnt = (mini_size + 0x7F) >> 7;
		var fat_base = mini_cnt + fat_size + dir_cnt + mfat_cnt;
		var fat_cnt = (fat_base + 0x7F) >> 7;
		var difat_cnt = fat_cnt <= 109 ? 0 : Math.ceil((fat_cnt-109)/0x7F);
		while(((fat_base + fat_cnt + difat_cnt + 0x7F) >> 7) > fat_cnt) difat_cnt = ++fat_cnt <= 109 ? 0 : Math.ceil((fat_cnt-109)/0x7F);
		var L =  [1, difat_cnt, fat_cnt, mfat_cnt, dir_cnt, fat_size, mini_size, 0];
		cfb.FileIndex[0].size = mini_size << 6;
		L[7] = (cfb.FileIndex[0].start=L[0]+L[1]+L[2]+L[3]+L[4]+L[5])+((L[6]+7) >> 3);
		return L;
	})(cfb);
	var o = new_buf(L[7] << 9);
	var i = 0, T = 0;
	{
		for(i = 0; i < 8; ++i) o.write_shift(1, HEADER_SIG[i]);
		for(i = 0; i < 8; ++i) o.write_shift(2, 0);
		o.write_shift(2, 0x003E);
		o.write_shift(2, 0x0003);
		o.write_shift(2, 0xFFFE);
		o.write_shift(2, 0x0009);
		o.write_shift(2, 0x0006);
		for(i = 0; i < 3; ++i) o.write_shift(2, 0);
		o.write_shift(4, 0);
		o.write_shift(4, L[2]);
		o.write_shift(4, L[0] + L[1] + L[2] + L[3] - 1);
		o.write_shift(4, 0);
		o.write_shift(4, 1<<12);
		o.write_shift(4, L[3] ? L[0] + L[1] + L[2] - 1: ENDOFCHAIN);
		o.write_shift(4, L[3]);
		o.write_shift(-4, L[1] ? L[0] - 1: ENDOFCHAIN);
		o.write_shift(4, L[1]);
		for(i = 0; i < 109; ++i) o.write_shift(-4, i < L[2] ? L[1] + i : -1);
	}
	if(L[1]) {
		for(T = 0; T < L[1]; ++T) {
			for(; i < 236 + T * 127; ++i) o.write_shift(-4, i < L[2] ? L[1] + i : -1);
			o.write_shift(-4, T === L[1] - 1 ? ENDOFCHAIN : T + 1);
		}
	}
	var chainit = function(w/*:number*/)/*:void*/ {
		for(T += w; i<T-1; ++i) o.write_shift(-4, i+1);
		if(w) { ++i; o.write_shift(-4, ENDOFCHAIN); }
	};
	T = i = 0;
	for(T+=L[1]; i<T; ++i) o.write_shift(-4, consts.DIFSECT);
	for(T+=L[2]; i<T; ++i) o.write_shift(-4, consts.FATSECT);
	chainit(L[3]);
	chainit(L[4]);
	var j/*:number*/ = 0, flen/*:number*/ = 0;
	var file/*:CFBEntry*/ = cfb.FileIndex[0];
	for(; j < cfb.FileIndex.length; ++j) {
		file = cfb.FileIndex[j];
		if(!file.content) continue;
		/*:: if(file.content == null) throw new Error("unreachable"); */
		flen = file.content.length;
		if(flen < 0x1000) continue;
		file.start = T;
		chainit((flen + 0x01FF) >> 9);
	}
	chainit((L[6] + 7) >> 3);
	while(o.l & 0x1FF) o.write_shift(-4, consts.ENDOFCHAIN);
	T = i = 0;
	for(j = 0; j < cfb.FileIndex.length; ++j) {
		file = cfb.FileIndex[j];
		if(!file.content) continue;
		/*:: if(file.content == null) throw new Error("unreachable"); */
		flen = file.content.length;
		if(!flen || flen >= 0x1000) continue;
		file.start = T;
		chainit((flen + 0x3F) >> 6);
	}
	while(o.l & 0x1FF) o.write_shift(-4, consts.ENDOFCHAIN);
	for(i = 0; i < L[4]<<2; ++i) {
		var nm = cfb.FullPaths[i];
		if(!nm || nm.length === 0) {
			for(j = 0; j < 17; ++j) o.write_shift(4, 0);
			for(j = 0; j < 3; ++j) o.write_shift(4, -1);
			for(j = 0; j < 12; ++j) o.write_shift(4, 0);
			continue;
		}
		file = cfb.FileIndex[i];
		if(i === 0) file.start = file.size ? file.start - 1 : ENDOFCHAIN;
		var _nm/*:string*/ = (i === 0 && _opts.root) || file.name;
		flen = 2*(_nm.length+1);
		o.write_shift(64, _nm, "utf16le");
		o.write_shift(2, flen);
		o.write_shift(1, file.type);
		o.write_shift(1, file.color);
		o.write_shift(-4, file.L);
		o.write_shift(-4, file.R);
		o.write_shift(-4, file.C);
		if(!file.clsid) for(j = 0; j < 4; ++j) o.write_shift(4, 0);
		else o.write_shift(16, file.clsid, "hex");
		o.write_shift(4, file.state || 0);
		o.write_shift(4, 0); o.write_shift(4, 0);
		o.write_shift(4, 0); o.write_shift(4, 0);
		o.write_shift(4, file.start);
		o.write_shift(4, file.size); o.write_shift(4, 0);
	}
	for(i = 1; i < cfb.FileIndex.length; ++i) {
		file = cfb.FileIndex[i];
		/*:: if(!file.content) throw new Error("unreachable"); */
		if(file.size >= 0x1000) {
			o.l = (file.start+1) << 9;
			if (has_buf && Buffer.isBuffer(file.content)) {
				file.content.copy(o, o.l, 0, file.size);
				// o is a 0-filled Buffer so just set next offset
				o.l += (file.size + 511) & -512;
			} else {
				for(j = 0; j < file.size; ++j) o.write_shift(1, file.content[j]);
				for(; j & 0x1FF; ++j) o.write_shift(1, 0);
			}
		}
	}
	for(i = 1; i < cfb.FileIndex.length; ++i) {
		file = cfb.FileIndex[i];
		/*:: if(!file.content) throw new Error("unreachable"); */
		if(file.size > 0 && file.size < 0x1000) {
			if (has_buf && Buffer.isBuffer(file.content)) {
				file.content.copy(o, o.l, 0, file.size);
				// o is a 0-filled Buffer so just set next offset
				o.l += (file.size + 63) & -64;
			} else {
				for(j = 0; j < file.size; ++j) o.write_shift(1, file.content[j]);
				for(; j & 0x3F; ++j) o.write_shift(1, 0);
			}
		}
	}
	if (has_buf) {
		o.l = o.length;
	} else {
		// When using Buffer, already 0-filled
		while(o.l < o.length) o.write_shift(1, 0);
	}
	return o;
}
/* [MS-CFB] 2.6.4 (Unicode 3.0.1 case conversion) */
function find(cfb/*:CFBContainer*/, path/*:string*/)/*:?CFBEntry*/ {
	var UCFullPaths/*:Array<string>*/ = cfb.FullPaths.map(function(x) { return x.toUpperCase(); });
	var UCPaths/*:Array<string>*/ = UCFullPaths.map(function(x) { var y = x.split("/"); return y[y.length - (x.slice(-1) == "/" ? 2 : 1)]; });
	var k/*:boolean*/ = false;
	if(path.charCodeAt(0) === 47 /* "/" */) { k = true; path = UCFullPaths[0].slice(0, -1) + path; }
	else k = path.indexOf("/") !== -1;
	var UCPath/*:string*/ = path.toUpperCase();
	var w/*:number*/ = k === true ? UCFullPaths.indexOf(UCPath) : UCPaths.indexOf(UCPath);
	if(w !== -1) return cfb.FileIndex[w];

	var m = !UCPath.match(chr1);
	UCPath = UCPath.replace(chr0,'');
	if(m) UCPath = UCPath.replace(chr1,'!');
	for(w = 0; w < UCFullPaths.length; ++w) {
		if((m ? UCFullPaths[w].replace(chr1,'!') : UCFullPaths[w]).replace(chr0,'') == UCPath) return cfb.FileIndex[w];
		if((m ? UCPaths[w].replace(chr1,'!') : UCPaths[w]).replace(chr0,'') == UCPath) return cfb.FileIndex[w];
	}
	return null;
}
/** CFB Constants */
var MSSZ = 64; /* Mini Sector Size = 1<<6 */
//var MSCSZ = 4096; /* Mini Stream Cutoff Size */
/* 2.1 Compound File Sector Numbers and Types */
var ENDOFCHAIN = -2;
/* 2.2 Compound File Header */
var HEADER_SIGNATURE = 'd0cf11e0a1b11ae1';
var HEADER_SIG = [0xD0, 0xCF, 0x11, 0xE0, 0xA1, 0xB1, 0x1A, 0xE1];
var HEADER_CLSID = '00000000000000000000000000000000';
var consts = {
	/* 2.1 Compund File Sector Numbers and Types */
	MAXREGSECT: -6,
	DIFSECT: -4,
	FATSECT: -3,
	ENDOFCHAIN: ENDOFCHAIN,
	FREESECT: -1,
	/* 2.2 Compound File Header */
	HEADER_SIGNATURE: HEADER_SIGNATURE,
	HEADER_MINOR_VERSION: '3e00',
	MAXREGSID: -6,
	NOSTREAM: -1,
	HEADER_CLSID: HEADER_CLSID,
	/* 2.6.1 Compound File Directory Entry */
	EntryTypes: ['unknown','storage','stream','lockbytes','property','root']
};

function write_file(cfb/*:CFBContainer*/, filename/*:string*/, options/*:CFBWriteOpts*/)/*:void*/ {
	get_fs();
	var o = _write(cfb, options);
	/*:: if(typeof Buffer == 'undefined' || !Buffer.isBuffer(o) || !(o instanceof Buffer)) throw new Error("unreachable"); */
	fs.writeFileSync(filename, o);
}

function a2s(o/*:RawBytes*/)/*:string*/ {
	var out = new Array(o.length);
	for(var i = 0; i < o.length; ++i) out[i] = String.fromCharCode(o[i]);
	return out.join("");
}

function write(cfb/*:CFBContainer*/, options/*:CFBWriteOpts*/)/*:RawBytes|string*/ {
	var o = _write(cfb, options);
	switch(options && options.type || "buffer") {
		case "file": get_fs(); fs.writeFileSync(options.filename, (o/*:any*/)); return o;
		case "binary": return typeof o == "string" ? o : a2s(o);
		case "base64": return Base64.encode(typeof o == "string" ? o : a2s(o));
		case "buffer": if(has_buf) return Buffer.isBuffer(o) ? o : Buffer_from(o);
			/* falls through */
		case "array": return typeof o == "string" ? s2a(o) : o;
	}
	return o;
}
/* node < 8.1 zlib does not expose bytesRead, so default to pure JS */
var _zlib;
function use_zlib(zlib) { try {
	var InflateRaw = zlib.InflateRaw;
	var InflRaw = new InflateRaw();
	InflRaw._processChunk(new Uint8Array([3, 0]), InflRaw._finishFlushFlag);
	if(InflRaw.bytesRead) _zlib = zlib;
	else throw new Error("zlib does not expose bytesRead");
} catch(e) {console.error("cannot use native zlib: " + (e.message || e)); } }

function _inflateRawSync(payload, usz) {
	if(!_zlib) return _inflate(payload, usz);
	var InflateRaw = _zlib.InflateRaw;
	var InflRaw = new InflateRaw();
	var out = InflRaw._processChunk(payload.slice(payload.l), InflRaw._finishFlushFlag);
	payload.l += InflRaw.bytesRead;
	return out;
}

function _deflateRawSync(payload) {
	return _zlib ? _zlib.deflateRawSync(payload) : _deflate(payload);
}
var CLEN_ORDER = [ 16, 17, 18, 0, 8, 7, 9, 6, 10, 5, 11, 4, 12, 3, 13, 2, 14, 1, 15 ];

/*  LEN_ID = [ 257, 258, 259, 260, 261, 262, 263, 264, 265, 266, 267, 268, 269, 270, 271, 272, 273, 274, 275, 276, 277, 278, 279, 280, 281, 282, 283, 284, 285 ]; */
var LEN_LN = [   3,   4,   5,   6,   7,   8,   9,  10,  11,  13 , 15,  17,  19,  23,  27,  31,  35,  43,  51,  59,  67,  83,  99, 115, 131, 163, 195, 227, 258 ];

/*  DST_ID = [  0,  1,  2,  3,  4,  5,  6,  7,  8,  9, 10, 11, 12, 13,  14,  15,  16,  17,  18,  19,   20,   21,   22,   23,   24,   25,   26,    27,    28,    29 ]; */
var DST_LN = [  1,  2,  3,  4,  5,  7,  9, 13, 17, 25, 33, 49, 65, 97, 129, 193, 257, 385, 513, 769, 1025, 1537, 2049, 3073, 4097, 6145, 8193, 12289, 16385, 24577 ];

function bit_swap_8(n) { var t = (((((n<<1)|(n<<11)) & 0x22110) | (((n<<5)|(n<<15)) & 0x88440))); return ((t>>16) | (t>>8) |t)&0xFF; }

var use_typed_arrays = typeof Uint8Array !== 'undefined';

var bitswap8 = use_typed_arrays ? new Uint8Array(1<<8) : [];
for(var q = 0; q < (1<<8); ++q) bitswap8[q] = bit_swap_8(q);

function bit_swap_n(n, b) {
	var rev = bitswap8[n & 0xFF];
	if(b <= 8) return rev >>> (8-b);
	rev = (rev << 8) | bitswap8[(n>>8)&0xFF];
	if(b <= 16) return rev >>> (16-b);
	rev = (rev << 8) | bitswap8[(n>>16)&0xFF];
	return rev >>> (24-b);
}

/* helpers for unaligned bit reads */
function read_bits_2(buf, bl) { var w = (bl&7), h = (bl>>>3); return ((buf[h]|(w <= 6 ? 0 : buf[h+1]<<8))>>>w)& 0x03; }
function read_bits_3(buf, bl) { var w = (bl&7), h = (bl>>>3); return ((buf[h]|(w <= 5 ? 0 : buf[h+1]<<8))>>>w)& 0x07; }
function read_bits_4(buf, bl) { var w = (bl&7), h = (bl>>>3); return ((buf[h]|(w <= 4 ? 0 : buf[h+1]<<8))>>>w)& 0x0F; }
function read_bits_5(buf, bl) { var w = (bl&7), h = (bl>>>3); return ((buf[h]|(w <= 3 ? 0 : buf[h+1]<<8))>>>w)& 0x1F; }
function read_bits_7(buf, bl) { var w = (bl&7), h = (bl>>>3); return ((buf[h]|(w <= 1 ? 0 : buf[h+1]<<8))>>>w)& 0x7F; }

/* works up to n = 3 * 8 + 1 = 25 */
function read_bits_n(buf, bl, n) {
	var w = (bl&7), h = (bl>>>3), f = ((1<<n)-1);
	var v = buf[h] >>> w;
	if(n < 8 - w) return v & f;
	v |= buf[h+1]<<(8-w);
	if(n < 16 - w) return v & f;
	v |= buf[h+2]<<(16-w);
	if(n < 24 - w) return v & f;
	v |= buf[h+3]<<(24-w);
	return v & f;
}

/* helpers for unaligned bit writes */
function write_bits_3(buf, bl, v) { var w = bl & 7, h = bl >>> 3;
	if(w <= 5) buf[h] |= (v & 7) << w;
	else {
		buf[h] |= (v << w) & 0xFF;
		buf[h+1] = (v&7) >> (8-w);
	}
	return bl + 3;
}

function write_bits_1(buf, bl, v) {
	var w = bl & 7, h = bl >>> 3;
	v = (v&1) << w;
	buf[h] |= v;
	return bl + 1;
}
function write_bits_8(buf, bl, v) {
	var w = bl & 7, h = bl >>> 3;
	v <<= w;
	buf[h] |=  v & 0xFF; v >>>= 8;
	buf[h+1] = v;
	return bl + 8;
}
function write_bits_16(buf, bl, v) {
	var w = bl & 7, h = bl >>> 3;
	v <<= w;
	buf[h] |=  v & 0xFF; v >>>= 8;
	buf[h+1] = v & 0xFF;
	buf[h+2] = v >>> 8;
	return bl + 16;
}

/* until ArrayBuffer#realloc is a thing, fake a realloc */
function realloc(b, sz/*:number*/) {
	var L = b.length, M = 2*L > sz ? 2*L : sz + 5, i = 0;
	if(L >= sz) return b;
	if(has_buf) {
		var o = new_unsafe_buf(M);
		// $FlowIgnore
		if(b.copy) b.copy(o);
		else for(; i < b.length; ++i) o[i] = b[i];
		return o;
	} else if(use_typed_arrays) {
		var a = new Uint8Array(M);
		if(a.set) a.set(b);
		else for(; i < L; ++i) a[i] = b[i];
		return a;
	}
	b.length = M;
	return b;
}

/* zero-filled arrays for older browsers */
function zero_fill_array(n) {
	var o = new Array(n);
	for(var i = 0; i < n; ++i) o[i] = 0;
	return o;
}

/* build tree (used for literals and lengths) */
function build_tree(clens, cmap, MAX/*:number*/)/*:number*/ {
	var maxlen = 1, w = 0, i = 0, j = 0, ccode = 0, L = clens.length;

	var bl_count  = use_typed_arrays ? new Uint16Array(32) : zero_fill_array(32);
	for(i = 0; i < 32; ++i) bl_count[i] = 0;

	for(i = L; i < MAX; ++i) clens[i] = 0;
	L = clens.length;

	var ctree = use_typed_arrays ? new Uint16Array(L) : zero_fill_array(L); // []

	/* build code tree */
	for(i = 0; i < L; ++i) {
		bl_count[(w = clens[i])]++;
		if(maxlen < w) maxlen = w;
		ctree[i] = 0;
	}
	bl_count[0] = 0;
	for(i = 1; i <= maxlen; ++i) bl_count[i+16] = (ccode = (ccode + bl_count[i-1])<<1);
	for(i = 0; i < L; ++i) {
		ccode = clens[i];
		if(ccode != 0) ctree[i] = bl_count[ccode+16]++;
	}

	/* cmap[maxlen + 4 bits] = (off&15) + (lit<<4) reverse mapping */
	var cleni = 0;
	for(i = 0; i < L; ++i) {
		cleni = clens[i];
		if(cleni != 0) {
			ccode = bit_swap_n(ctree[i], maxlen)>>(maxlen-cleni);
			for(j = (1<<(maxlen + 4 - cleni)) - 1; j>=0; --j)
				cmap[ccode|(j<<cleni)] = (cleni&15) | (i<<4);
		}
	}
	return maxlen;
}

/* Fixed Huffman */
var fix_lmap = use_typed_arrays ? new Uint16Array(512) : zero_fill_array(512);
var fix_dmap = use_typed_arrays ? new Uint16Array(32)  : zero_fill_array(32);
if(!use_typed_arrays) {
	for(var i = 0; i < 512; ++i) fix_lmap[i] = 0;
	for(i = 0; i < 32; ++i) fix_dmap[i] = 0;
}
(function() {
	var dlens/*:Array<number>*/ = [];
	var i = 0;
	for(;i<32; i++) dlens.push(5);
	build_tree(dlens, fix_dmap, 32);

	var clens/*:Array<number>*/ = [];
	i = 0;
	for(; i<=143; i++) clens.push(8);
	for(; i<=255; i++) clens.push(9);
	for(; i<=279; i++) clens.push(7);
	for(; i<=287; i++) clens.push(8);
	build_tree(clens, fix_lmap, 288);
})();var _deflateRaw = (function _deflateRawIIFE() {
	var DST_LN_RE = use_typed_arrays ? new Uint8Array(0x8000) : [];
	var j = 0, k = 0;
	for(; j < DST_LN.length - 1; ++j) {
		for(; k < DST_LN[j+1]; ++k) DST_LN_RE[k] = j;
	}
	for(;k < 32768; ++k) DST_LN_RE[k] = 29;

	var LEN_LN_RE = use_typed_arrays ? new Uint8Array(0x103) : [];
	for(j = 0, k = 0; j < LEN_LN.length - 1; ++j) {
		for(; k < LEN_LN[j+1]; ++k) LEN_LN_RE[k] = j;
	}

	function write_stored(data, out) {
		var boff = 0;
		while(boff < data.length) {
			var L = Math.min(0xFFFF, data.length - boff);
			var h = boff + L == data.length;
			out.write_shift(1, +h);
			out.write_shift(2, L);
			out.write_shift(2, (~L) & 0xFFFF);
			while(L-- > 0) out[out.l++] = data[boff++];
		}
		return out.l;
	}

	/* Fixed Huffman */
	function write_huff_fixed(data, out) {
		var bl = 0;
		var boff = 0;
		var addrs = use_typed_arrays ? new Uint16Array(0x8000) : [];
		while(boff < data.length) {
			var L = /* data.length - boff; */ Math.min(0xFFFF, data.length - boff);

			/* write a stored block for short data */
			if(L < 10) {
				bl = write_bits_3(out, bl, +!!(boff + L == data.length)); // jshint ignore:line
				if(bl & 7) bl += 8 - (bl & 7);
				out.l = (bl / 8) | 0;
				out.write_shift(2, L);
				out.write_shift(2, (~L) & 0xFFFF);
				while(L-- > 0) out[out.l++] = data[boff++];
				bl = out.l * 8;
				continue;
			}

			bl = write_bits_3(out, bl, +!!(boff + L == data.length) + 2); // jshint ignore:line
			var hash = 0;
			while(L-- > 0) {
				var d = data[boff];
				hash = ((hash << 5) ^ d) & 0x7FFF;

				var match = -1, mlen = 0;

				if((match = addrs[hash])) {
					match |= boff & ~0x7FFF;
					if(match > boff) match -= 0x8000;
					if(match < boff) while(data[match + mlen] == data[boff + mlen] && mlen < 250) ++mlen;
				}

				if(mlen > 2) {
					/* Copy Token  */
					d = LEN_LN_RE[mlen];
					if(d <= 22) bl = write_bits_8(out, bl, bitswap8[d+1]>>1) - 1;
					else {
						write_bits_8(out, bl, 3);
						bl += 5;
						write_bits_8(out, bl, bitswap8[d-23]>>5);
						bl += 3;
					}
					var len_eb = (d < 8) ? 0 : ((d - 4)>>2);
					if(len_eb > 0) {
						write_bits_16(out, bl, mlen - LEN_LN[d]);
						bl += len_eb;
					}

					d = DST_LN_RE[boff - match];
					bl = write_bits_8(out, bl, bitswap8[d]>>3);
					bl -= 3;

					var dst_eb = d < 4 ? 0 : (d-2)>>1;
					if(dst_eb > 0) {
						write_bits_16(out, bl, boff - match - DST_LN[d]);
						bl += dst_eb;
					}
					for(var q = 0; q < mlen; ++q) {
						addrs[hash] = boff & 0x7FFF;
						hash = ((hash << 5) ^ data[boff]) & 0x7FFF;
						++boff;
					}
					L-= mlen - 1;
				} else {
					/* Literal Token */
					if(d <= 143) d = d + 48;
					else bl = write_bits_1(out, bl, 1);
					bl = write_bits_8(out, bl, bitswap8[d]);
					addrs[hash] = boff & 0x7FFF;
					++boff;
				}
			}

			bl = write_bits_8(out, bl, 0) - 1;
		}
		out.l = ((bl + 7)/8)|0;
		return out.l;
	}
	return function _deflateRaw(data, out) {
		if(data.length < 8) return write_stored(data, out);
		return write_huff_fixed(data, out);
	};
})();

function _deflate(data) {
	var buf = new_buf(50+Math.floor(data.length*1.1));
	var off = _deflateRaw(data, buf);
	return buf.slice(0, off);
}
/* modified inflate function also moves original read head */

var dyn_lmap = use_typed_arrays ? new Uint16Array(32768) : zero_fill_array(32768);
var dyn_dmap = use_typed_arrays ? new Uint16Array(32768) : zero_fill_array(32768);
var dyn_cmap = use_typed_arrays ? new Uint16Array(128)   : zero_fill_array(128);
var dyn_len_1 = 1, dyn_len_2 = 1;

/* 5.5.3 Expanding Huffman Codes */
function dyn(data, boff/*:number*/) {
	/* nomenclature from RFC1951 refers to bit values; these are offset by the implicit constant */
	var _HLIT = read_bits_5(data, boff) + 257; boff += 5;
	var _HDIST = read_bits_5(data, boff) + 1; boff += 5;
	var _HCLEN = read_bits_4(data, boff) + 4; boff += 4;
	var w = 0;

	/* grab and store code lengths */
	var clens = use_typed_arrays ? new Uint8Array(19) : zero_fill_array(19);
	var ctree = [ 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0 ];
	var maxlen = 1;
	var bl_count =  use_typed_arrays ? new Uint8Array(8) : zero_fill_array(8);
	var next_code = use_typed_arrays ? new Uint8Array(8) : zero_fill_array(8);
	var L = clens.length; /* 19 */
	for(var i = 0; i < _HCLEN; ++i) {
		clens[CLEN_ORDER[i]] = w = read_bits_3(data, boff);
		if(maxlen < w) maxlen = w;
		bl_count[w]++;
		boff += 3;
	}

	/* build code tree */
	var ccode = 0;
	bl_count[0] = 0;
	for(i = 1; i <= maxlen; ++i) next_code[i] = ccode = (ccode + bl_count[i-1])<<1;
	for(i = 0; i < L; ++i) if((ccode = clens[i]) != 0) ctree[i] = next_code[ccode]++;
	/* cmap[7 bits from stream] = (off&7) + (lit<<3) */
	var cleni = 0;
	for(i = 0; i < L; ++i) {
		cleni = clens[i];
		if(cleni != 0) {
			ccode = bitswap8[ctree[i]]>>(8-cleni);
			for(var j = (1<<(7-cleni))-1; j>=0; --j) dyn_cmap[ccode|(j<<cleni)] = (cleni&7) | (i<<3);
		}
	}

	/* read literal and dist codes at once */
	var hcodes/*:Array<number>*/ = [];
	maxlen = 1;
	for(; hcodes.length < _HLIT + _HDIST;) {
		ccode = dyn_cmap[read_bits_7(data, boff)];
		boff += ccode & 7;
		switch((ccode >>>= 3)) {
			case 16:
				w = 3 + read_bits_2(data, boff); boff += 2;
				ccode = hcodes[hcodes.length - 1];
				while(w-- > 0) hcodes.push(ccode);
				break;
			case 17:
				w = 3 + read_bits_3(data, boff); boff += 3;
				while(w-- > 0) hcodes.push(0);
				break;
			case 18:
				w = 11 + read_bits_7(data, boff); boff += 7;
				while(w -- > 0) hcodes.push(0);
				break;
			default:
				hcodes.push(ccode);
				if(maxlen < ccode) maxlen = ccode;
				break;
		}
	}

	/* build literal / length trees */
	var h1 = hcodes.slice(0, _HLIT), h2 = hcodes.slice(_HLIT);
	for(i = _HLIT; i < 286; ++i) h1[i] = 0;
	for(i = _HDIST; i < 30; ++i) h2[i] = 0;
	dyn_len_1 = build_tree(h1, dyn_lmap, 286);
	dyn_len_2 = build_tree(h2, dyn_dmap, 30);
	return boff;
}

/* return [ data, bytesRead ] */
function inflate(data, usz/*:number*/) {
	/* shortcircuit for empty buffer [0x03, 0x00] */
	if(data[0] == 3 && !(data[1] & 0x3)) { return [new_raw_buf(usz), 2]; }

	/* bit offset */
	var boff = 0;

	/* header includes final bit and type bits */
	var header = 0;

	var outbuf = new_unsafe_buf(usz ? usz : (1<<18));
	var woff = 0;
	var OL = outbuf.length>>>0;
	var max_len_1 = 0, max_len_2 = 0;

	while((header&1) == 0) {
		header = read_bits_3(data, boff); boff += 3;
		if((header >>> 1) == 0) {
			/* Stored block */
			if(boff & 7) boff += 8 - (boff&7);
			/* 2 bytes sz, 2 bytes bit inverse */
			var sz = data[boff>>>3] | data[(boff>>>3)+1]<<8;
			boff += 32;
			/* push sz bytes */
			if(sz > 0) {
				if(!usz && OL < woff + sz) { outbuf = realloc(outbuf, woff + sz); OL = outbuf.length; }
				while(sz-- > 0) { outbuf[woff++] = data[boff>>>3]; boff += 8; }
			}
			continue;
		} else if((header >> 1) == 1) {
			/* Fixed Huffman */
			max_len_1 = 9; max_len_2 = 5;
		} else {
			/* Dynamic Huffman */
			boff = dyn(data, boff);
			max_len_1 = dyn_len_1; max_len_2 = dyn_len_2;
		}
		for(;;) { // while(true) is apparently out of vogue in modern JS circles
			if(!usz && (OL < woff + 32767)) { outbuf = realloc(outbuf, woff + 32767); OL = outbuf.length; }
			/* ingest code and move read head */
			var bits = read_bits_n(data, boff, max_len_1);
			var code = (header>>>1) == 1 ? fix_lmap[bits] : dyn_lmap[bits];
			boff += code & 15; code >>>= 4;
			/* 0-255 are literals, 256 is end of block token, 257+ are copy tokens */
			if(((code>>>8)&0xFF) === 0) outbuf[woff++] = code;
			else if(code == 256) break;
			else {
				code -= 257;
				var len_eb = (code < 8) ? 0 : ((code-4)>>2); if(len_eb > 5) len_eb = 0;
				var tgt = woff + LEN_LN[code];
				/* length extra bits */
				if(len_eb > 0) {
					tgt += read_bits_n(data, boff, len_eb);
					boff += len_eb;
				}

				/* dist code */
				bits = read_bits_n(data, boff, max_len_2);
				code = (header>>>1) == 1 ? fix_dmap[bits] : dyn_dmap[bits];
				boff += code & 15; code >>>= 4;
				var dst_eb = (code < 4 ? 0 : (code-2)>>1);
				var dst = DST_LN[code];
				/* dist extra bits */
				if(dst_eb > 0) {
					dst += read_bits_n(data, boff, dst_eb);
					boff += dst_eb;
				}

				/* in the common case, manual byte copy is faster than TA set / Buffer copy */
				if(!usz && OL < tgt) { outbuf = realloc(outbuf, tgt + 100); OL = outbuf.length; }
				while(woff < tgt) { outbuf[woff] = outbuf[woff - dst]; ++woff; }
			}
		}
	}
	if(usz) return [outbuf, (boff+7)>>>3];
	return [outbuf.slice(0, woff), (boff+7)>>>3];
}

function _inflate(payload, usz) {
	var data = payload.slice(payload.l||0);
	var out = inflate(data, usz);
	payload.l += out[1];
	return out[0];
}

function warn_or_throw(wrn, msg) {
	if(wrn) { if(typeof console !== 'undefined') console.error(msg); }
	else throw new Error(msg);
}

function parse_zip(file/*:RawBytes*/, options/*:CFBReadOpts*/)/*:CFBContainer*/ {
	var blob/*:CFBlob*/ = /*::(*/file/*:: :any)*/;
	prep_blob(blob, 0);

	var FileIndex/*:CFBFileIndex*/ = [], FullPaths/*:Array<string>*/ = [];
	var o = {
		FileIndex: FileIndex,
		FullPaths: FullPaths
	};
	init_cfb(o, { root: options.root });

	/* find end of central directory, start just after signature */
	var i = blob.length - 4;
	while((blob[i] != 0x50 || blob[i+1] != 0x4b || blob[i+2] != 0x05 || blob[i+3] != 0x06) && i >= 0) --i;
	blob.l = i + 4;

	/* parse end of central directory */
	blob.l += 4;
	var fcnt = blob.read_shift(2);
	blob.l += 6;
	var start_cd = blob.read_shift(4);

	/* parse central directory */
	blob.l = start_cd;

	for(i = 0; i < fcnt; ++i) {
		/* trust local file header instead of CD entry */
		blob.l += 20;
		var csz = blob.read_shift(4);
		var usz = blob.read_shift(4);
		var namelen = blob.read_shift(2);
		var efsz = blob.read_shift(2);
		var fcsz = blob.read_shift(2);
		blob.l += 8;
		var offset = blob.read_shift(4);
		var EF = parse_extra_field(/*::(*/blob.slice(blob.l+namelen, blob.l+namelen+efsz)/*:: :any)*/);
		blob.l += namelen + efsz + fcsz;

		var L = blob.l;
		blob.l = offset + 4;
		parse_local_file(blob, csz, usz, o, EF);
		blob.l = L;
	}
	return o;
}


/* head starts just after local file header signature */
function parse_local_file(blob/*:CFBlob*/, csz/*:number*/, usz/*:number*/, o/*:CFBContainer*/, EF) {
	/* [local file header] */
	blob.l += 2;
	var flags = blob.read_shift(2);
	var meth = blob.read_shift(2);
	var date = parse_dos_date(blob);

	if(flags & 0x2041) throw new Error("Unsupported ZIP encryption");
	var crc32 = blob.read_shift(4);
	var _csz = blob.read_shift(4);
	var _usz = blob.read_shift(4);

	var namelen = blob.read_shift(2);
	var efsz = blob.read_shift(2);

	// TODO: flags & (1<<11) // UTF8
	var name = ""; for(var i = 0; i < namelen; ++i) name += String.fromCharCode(blob[blob.l++]);
	if(efsz) {
		var ef = parse_extra_field(/*::(*/blob.slice(blob.l, blob.l + efsz)/*:: :any)*/);
		if((ef[0x5455]||{}).mt) date = ef[0x5455].mt;
		if(((EF||{})[0x5455]||{}).mt) date = EF[0x5455].mt;
	}
	blob.l += efsz;

	/* [encryption header] */

	/* [file data] */
	var data = blob.slice(blob.l, blob.l + _csz);
	switch(meth) {
		case 8: data = _inflateRawSync(blob, _usz); break;
		case 0: break; // TODO: scan for magic number
		default: throw new Error("Unsupported ZIP Compression method " + meth);
	}

	/* [data descriptor] */
	var wrn = false;
	if(flags & 8) {
		crc32 = blob.read_shift(4);
		if(crc32 == 0x08074b50) { crc32 = blob.read_shift(4); wrn = true; }
		_csz = blob.read_shift(4);
		_usz = blob.read_shift(4);
	}

	if(_csz != csz) warn_or_throw(wrn, "Bad compressed size: " + csz + " != " + _csz);
	if(_usz != usz) warn_or_throw(wrn, "Bad uncompressed size: " + usz + " != " + _usz);
	//var _crc32 = CRC32.buf(data, 0);
	//if((crc32>>0) != (_crc32>>0)) warn_or_throw(wrn, "Bad CRC32 checksum: " + crc32 + " != " + _crc32);
	cfb_add(o, name, data, {unsafe: true, mt: date});
}
function write_zip(cfb/*:CFBContainer*/, options/*:CFBWriteOpts*/)/*:RawBytes*/ {
	var _opts = options || {};
	var out = [], cdirs = [];
	var o/*:CFBlob*/ = new_buf(1);
	var method = (_opts.compression ? 8 : 0), flags = 0;
	var i = 0, j = 0;

	var start_cd = 0, fcnt = 0;
	var root = cfb.FullPaths[0], fp = root, fi = cfb.FileIndex[0];
	var crcs = [];
	var sz_cd = 0;

	for(i = 1; i < cfb.FullPaths.length; ++i) {
		fp = cfb.FullPaths[i].slice(root.length); fi = cfb.FileIndex[i];
		if(!fi.size || !fi.content || fp == "\u0001Sh33tJ5") continue;
		var start = start_cd;

		/* TODO: CP437 filename */
		var namebuf = new_buf(fp.length);
		for(j = 0; j < fp.length; ++j) namebuf.write_shift(1, fp.charCodeAt(j) & 0x7F);
		namebuf = namebuf.slice(0, namebuf.l);
		crcs[fcnt] = CRC32.buf(/*::((*/fi.content/*::||[]):any)*/, 0);

		var outbuf = fi.content/*::||[]*/;
		if(method == 8) outbuf = _deflateRawSync(outbuf);

		/* local file header */
		o = new_buf(30);
		o.write_shift(4, 0x04034b50);
		o.write_shift(2, 20);
		o.write_shift(2, flags);
		o.write_shift(2, method);
		/* TODO: last mod file time/date */
		if(fi.mt) write_dos_date(o, fi.mt);
		else o.write_shift(4, 0);
		o.write_shift(-4,  crcs[fcnt]);
		o.write_shift(4,   outbuf.length);
		o.write_shift(4,   /*::(*/fi.content/*::||[])*/.length);
		o.write_shift(2, namebuf.length);
		o.write_shift(2, 0);

		start_cd += o.length;
		out.push(o);
		start_cd += namebuf.length;
		out.push(namebuf);

		/* TODO: extra fields? */

		/* TODO: encryption header ? */

		start_cd += outbuf.length;
		out.push(outbuf);

		/* central directory */
		o = new_buf(46);
		o.write_shift(4, 0x02014b50);
		o.write_shift(2, 0);
		o.write_shift(2, 20);
		o.write_shift(2, flags);
		o.write_shift(2, method);
		o.write_shift(4, 0); /* TODO: last mod file time/date */
		o.write_shift(-4, crcs[fcnt]);

		o.write_shift(4, outbuf.length);
		o.write_shift(4, /*::(*/fi.content/*::||[])*/.length);
		o.write_shift(2, namebuf.length);
		o.write_shift(2, 0);
		o.write_shift(2, 0);
		o.write_shift(2, 0);
		o.write_shift(2, 0);
		o.write_shift(4, 0);
		o.write_shift(4, start);

		sz_cd += o.l;
		cdirs.push(o);
		sz_cd += namebuf.length;
		cdirs.push(namebuf);
		++fcnt;
	}

	/* end of central directory */
	o = new_buf(22);
	o.write_shift(4, 0x06054b50);
	o.write_shift(2, 0);
	o.write_shift(2, 0);
	o.write_shift(2, fcnt);
	o.write_shift(2, fcnt);
	o.write_shift(4, sz_cd);
	o.write_shift(4, start_cd);
	o.write_shift(2, 0);

	return bconcat(([bconcat((out/*:any*/)), bconcat(cdirs), o]/*:any*/));
}
var ContentTypeMap = ({
	"htm": "text/html",
	"xml": "text/xml",

	"gif": "image/gif",
	"jpg": "image/jpeg",
	"png": "image/png",

	"mso": "application/x-mso",
	"thmx": "application/vnd.ms-officetheme",
	"sh33tj5": "application/octet-stream"
}/*:any*/);

function get_content_type(fi/*:CFBEntry*/, fp/*:string*/)/*:string*/ {
	if(fi.ctype) return fi.ctype;

	var ext = fi.name || "", m = ext.match(/\.([^\.]+)$/);
	if(m && ContentTypeMap[m[1]]) return ContentTypeMap[m[1]];

	if(fp) {
		m = (ext = fp).match(/[\.\\]([^\.\\])+$/);
		if(m && ContentTypeMap[m[1]]) return ContentTypeMap[m[1]];
	}

	return "application/octet-stream";
}

/* 76 character chunks TODO: intertwine encoding */
function write_base64_76(bstr/*:string*/)/*:string*/ {
	var data = Base64.encode(bstr);
	var o = [];
	for(var i = 0; i < data.length; i+= 76) o.push(data.slice(i, i+76));
	return o.join("\r\n") + "\r\n";
}

/*
Rules for QP:
	- escape =## applies for all non-display characters and literal "="
	- space or tab at end of line must be encoded
	- \r\n newlines can be preserved, but bare \r and \n must be escaped
	- lines must not exceed 76 characters, use soft breaks =\r\n

TODO: Some files from word appear to write line extensions with bare equals:

```
<table class=3DMsoTableGrid border=3D1 cellspacing=3D0 cellpadding=3D0 width=
="70%"
```
*/
function write_quoted_printable(text/*:string*/)/*:string*/ {
	var encoded = text.replace(/[\x00-\x08\x0B\x0C\x0E-\x1F\x7E-\xFF=]/g, function(c) {
		var w = c.charCodeAt(0).toString(16).toUpperCase();
		return "=" + (w.length == 1 ? "0" + w : w);
	});

	encoded = encoded.replace(/ $/mg, "=20").replace(/\t$/mg, "=09");

	if(encoded.charAt(0) == "\n") encoded = "=0D" + encoded.slice(1);
	encoded = encoded.replace(/\r(?!\n)/mg, "=0D").replace(/\n\n/mg, "\n=0A").replace(/([^\r\n])\n/mg, "$1=0A");

	var o/*:Array<string>*/ = [], split = encoded.split("\r\n");
	for(var si = 0; si < split.length; ++si) {
		var str = split[si];
		if(str.length == 0) { o.push(""); continue; }
		for(var i = 0; i < str.length;) {
			var end = 76;
			var tmp = str.slice(i, i + end);
			if(tmp.charAt(end - 1) == "=") end --;
			else if(tmp.charAt(end - 2) == "=") end -= 2;
			else if(tmp.charAt(end - 3) == "=") end -= 3;
			tmp = str.slice(i, i + end);
			i += end;
			if(i < str.length) tmp += "=";
			o.push(tmp);
		}
	}

	return o.join("\r\n");
}
function parse_quoted_printable(data/*:Array<string>*/)/*:RawBytes*/ {
	var o = [];

	/* unify long lines */
	for(var di = 0; di < data.length; ++di) {
		var line = data[di];
		while(di <= data.length && line.charAt(line.length - 1) == "=") line = line.slice(0, line.length - 1) + data[++di];
		o.push(line);
	}

	/* decode */
	for(var oi = 0; oi < o.length; ++oi) o[oi] = o[oi].replace(/[=][0-9A-Fa-f]{2}/g, function($$) { return String.fromCharCode(parseInt($$.slice(1), 16)); });
	return s2a(o.join("\r\n"));
}


function parse_mime(cfb/*:CFBContainer*/, data/*:Array<string>*/, root/*:string*/)/*:void*/ {
	var fname = "", cte = "", ctype = "", fdata;
	var di = 0;
	for(;di < 10; ++di) {
		var line = data[di];
		if(!line || line.match(/^\s*$/)) break;
		var m = line.match(/^(.*?):\s*([^\s].*)$/);
		if(m) switch(m[1].toLowerCase()) {
			case "content-location": fname = m[2].trim(); break;
			case "content-type": ctype = m[2].trim(); break;
			case "content-transfer-encoding": cte = m[2].trim(); break;
		}
	}
	++di;
	switch(cte.toLowerCase()) {
		case 'base64': fdata = s2a(Base64.decode(data.slice(di).join(""))); break;
		case 'quoted-printable': fdata = parse_quoted_printable(data.slice(di)); break;
		default: throw new Error("Unsupported Content-Transfer-Encoding " + cte);
	}
	var file = cfb_add(cfb, fname.slice(root.length), fdata, {unsafe: true});
	if(ctype) file.ctype = ctype;
}

function parse_mad(file/*:RawBytes*/, options/*:CFBReadOpts*/)/*:CFBContainer*/ {
	if(a2s(file.slice(0,13)).toLowerCase() != "mime-version:") throw new Error("Unsupported MAD header");
	var root = (options && options.root || "");
	// $FlowIgnore
	var data = (has_buf && Buffer.isBuffer(file) ? file.toString("binary") : a2s(file)).split("\r\n");
	var di = 0, row = "";

	/* if root is not specified, scan for the common prefix */
	for(di = 0; di < data.length; ++di) {
		row = data[di];
		if(!/^Content-Location:/i.test(row)) continue;
		row = row.slice(row.indexOf("file"));
		if(!root) root = row.slice(0, row.lastIndexOf("/") + 1);
		if(row.slice(0, root.length) == root) continue;
		while(root.length > 0) {
			root = root.slice(0, root.length - 1);
			root = root.slice(0, root.lastIndexOf("/") + 1);
			if(row.slice(0,root.length) == root) break;
		}
	}

	var mboundary = (data[1] || "").match(/boundary="(.*?)"/);
	if(!mboundary) throw new Error("MAD cannot find boundary");
	var boundary = "--" + (mboundary[1] || "");

	var FileIndex/*:CFBFileIndex*/ = [], FullPaths/*:Array<string>*/ = [];
	var o = {
		FileIndex: FileIndex,
		FullPaths: FullPaths
	};
	init_cfb(o);
	var start_di, fcnt = 0;
	for(di = 0; di < data.length; ++di) {
		var line = data[di];
		if(line !== boundary && line !== boundary + "--") continue;
		if(fcnt++) parse_mime(o, data.slice(start_di, di), root);
		start_di = di;
	}
	return o;
}

function write_mad(cfb/*:CFBContainer*/, options/*:CFBWriteOpts*/)/*:string*/ {
	var opts = options || {};
	var boundary = opts.boundary || "SheetJS";
	boundary = '------=' + boundary;

	var out = [
		'MIME-Version: 1.0',
		'Content-Type: multipart/related; boundary="' + boundary.slice(2) + '"',
		'',
		'',
		''
	];

	var root = cfb.FullPaths[0], fp = root, fi = cfb.FileIndex[0];
	for(var i = 1; i < cfb.FullPaths.length; ++i) {
		fp = cfb.FullPaths[i].slice(root.length);
		fi = cfb.FileIndex[i];
		if(!fi.size || !fi.content || fp == "\u0001Sh33tJ5") continue;

		/* Normalize filename */
		fp = fp.replace(/[\x00-\x08\x0B\x0C\x0E-\x1F\x7E-\xFF]/g, function(c) {
			return "_x" + c.charCodeAt(0).toString(16) + "_";
		}).replace(/[\u0080-\uFFFF]/g, function(u) {
			return "_u" + u.charCodeAt(0).toString(16) + "_";
		});

		/* Extract content as binary string */
		var ca = fi.content;
		// $FlowIgnore
		var cstr = has_buf && Buffer.isBuffer(ca) ? ca.toString("binary") : a2s(ca);

		/* 4/5 of first 1024 chars ascii -> quoted printable, else base64 */
		var dispcnt = 0, L = Math.min(1024, cstr.length), cc = 0;
		for(var csl = 0; csl <= L; ++csl) if((cc=cstr.charCodeAt(csl)) >= 0x20 && cc < 0x80) ++dispcnt;
		var qp = dispcnt >= L * 4 / 5;

		out.push(boundary);
		out.push('Content-Location: ' + (opts.root || 'file:///C:/SheetJS/') + fp);
		out.push('Content-Transfer-Encoding: ' + (qp ? 'quoted-printable' : 'base64'));
		out.push('Content-Type: ' + get_content_type(fi, fp));
		out.push('');

		out.push(qp ? write_quoted_printable(cstr) : write_base64_76(cstr));
	}
	out.push(boundary + '--\r\n');
	return out.join("\r\n");
}
function cfb_new(opts/*:?any*/)/*:CFBContainer*/ {
	var o/*:CFBContainer*/ = ({}/*:any*/);
	init_cfb(o, opts);
	return o;
}

function cfb_add(cfb/*:CFBContainer*/, name/*:string*/, content/*:?RawBytes*/, opts/*:?any*/)/*:CFBEntry*/ {
	var unsafe = opts && opts.unsafe;
	if(!unsafe) init_cfb(cfb);
	var file = !unsafe && CFB.find(cfb, name);
	if(!file) {
		var fpath/*:string*/ = cfb.FullPaths[0];
		if(name.slice(0, fpath.length) == fpath) fpath = name;
		else {
			if(fpath.slice(-1) != "/") fpath += "/";
			fpath = (fpath + name).replace("//","/");
		}
		file = ({name: filename(name), type: 2}/*:any*/);
		cfb.FileIndex.push(file);
		cfb.FullPaths.push(fpath);
		if(!unsafe) CFB.utils.cfb_gc(cfb);
	}
	/*:: if(!file) throw new Error("unreachable"); */
	file.content = (content/*:any*/);
	file.size = content ? content.length : 0;
	if(opts) {
		if(opts.CLSID) file.clsid = opts.CLSID;
		if(opts.mt) file.mt = opts.mt;
		if(opts.ct) file.ct = opts.ct;
	}
	return file;
}

function cfb_del(cfb/*:CFBContainer*/, name/*:string*/)/*:boolean*/ {
	init_cfb(cfb);
	var file = CFB.find(cfb, name);
	if(file) for(var j = 0; j < cfb.FileIndex.length; ++j) if(cfb.FileIndex[j] == file) {
		cfb.FileIndex.splice(j, 1);
		cfb.FullPaths.splice(j, 1);
		return true;
	}
	return false;
}

function cfb_mov(cfb/*:CFBContainer*/, old_name/*:string*/, new_name/*:string*/)/*:boolean*/ {
	init_cfb(cfb);
	var file = CFB.find(cfb, old_name);
	if(file) for(var j = 0; j < cfb.FileIndex.length; ++j) if(cfb.FileIndex[j] == file) {
		cfb.FileIndex[j].name = filename(new_name);
		cfb.FullPaths[j] = new_name;
		return true;
	}
	return false;
}

function cfb_gc(cfb/*:CFBContainer*/)/*:void*/ { rebuild_cfb(cfb, true); }

exports.find = find;
exports.read = read;
exports.parse = parse;
exports.write = write;
exports.writeFile = write_file;
exports.utils = {
	cfb_new: cfb_new,
	cfb_add: cfb_add,
	cfb_del: cfb_del,
	cfb_mov: cfb_mov,
	cfb_gc: cfb_gc,
	ReadShift: ReadShift,
	CheckField: CheckField,
	prep_blob: prep_blob,
	bconcat: bconcat,
	use_zlib: use_zlib,
	_deflateRaw: _deflate,
	_inflateRaw: _inflate,
	consts: consts
};

return exports;
})();

if(typeof require !== 'undefined' && typeof module !== 'undefined' && typeof DO_NOT_EXPORT_CFB === 'undefined') { module.exports = CFB; }
let _fs = void 0;
function set_fs(fs) { _fs = fs; }

/* normalize data for blob ctor */
function blobify(data) {
	if(typeof data === "string") return s2ab(data);
	if(Array.isArray(data)) return a2u(data);
	return data;
}
/* write or download file */
function write_dl(fname/*:string*/, payload/*:any*/, enc/*:?string*/) {
	/*global IE_SaveFile, Blob, navigator, saveAs, document, File, chrome */
	if(typeof _fs !== 'undefined' && _fs.writeFileSync) return enc ? _fs.writeFileSync(fname, payload, enc) : _fs.writeFileSync(fname, payload);
	if(typeof Deno !== 'undefined') {
		/* in this spot, it's safe to assume typed arrays and TextEncoder/TextDecoder exist */
		if(enc) switch(enc) {
			case "utf8": payload = new TextEncoder(enc).encode(payload); break;
			case "binary": payload = s2ab(payload); break;
			/* TODO: binary equivalent */
			default: throw new Error("Unsupported encoding " + enc);
		}
		return Deno.writeFileSync(fname, payload);
	}
	var data = (enc == "utf8") ? utf8write(payload) : payload;
	/*:: declare var IE_SaveFile: any; */
	if(typeof IE_SaveFile !== 'undefined') return IE_SaveFile(data, fname);
	if(typeof Blob !== 'undefined') {
		var blob = new Blob([blobify(data)], {type:"application/octet-stream"});
		/*:: declare var navigator: any; */
		if(typeof navigator !== 'undefined' && navigator.msSaveBlob) return navigator.msSaveBlob(blob, fname);
		/*:: declare var saveAs: any; */
		if(typeof saveAs !== 'undefined') return saveAs(blob, fname);
		if(typeof URL !== 'undefined' && typeof document !== 'undefined' && document.createElement && URL.createObjectURL) {
			var url = URL.createObjectURL(blob);
			/*:: declare var chrome: any; */
			if(typeof chrome === 'object' && typeof (chrome.downloads||{}).download == "function") {
				if(URL.revokeObjectURL && typeof setTimeout !== 'undefined') setTimeout(function() { URL.revokeObjectURL(url); }, 60000);
				return chrome.downloads.download({ url: url, filename: fname, saveAs: true});
			}
			var a = document.createElement("a");
			if(a.download != null) {
				/*:: if(document.body == null) throw new Error("unreachable"); */
				a.download = fname; a.href = url; document.body.appendChild(a); a.click();
				/*:: if(document.body == null) throw new Error("unreachable"); */ document.body.removeChild(a);
				if(URL.revokeObjectURL && typeof setTimeout !== 'undefined') setTimeout(function() { URL.revokeObjectURL(url); }, 60000);
				return url;
			}
		}
	}
	// $FlowIgnore
	if(typeof $ !== 'undefined' && typeof File !== 'undefined' && typeof Folder !== 'undefined') try { // extendscript
		// $FlowIgnore
		var out = File(fname); out.open("w"); out.encoding = "binary";
		if(Array.isArray(payload)) payload = a2s(payload);
		out.write(payload); out.close(); return payload;
	} catch(e) { if(!e.message || !e.message.match(/onstruct/)) throw e; }
	throw new Error("cannot save file " + fname);
}

/* read binary data from file */
function read_binary(path/*:string*/) {
	if(typeof _fs !== 'undefined') return _fs.readFileSync(path);
	if(typeof Deno !== 'undefined') return Deno.readFileSync(path);
	// $FlowIgnore
	if(typeof $ !== 'undefined' && typeof File !== 'undefined' && typeof Folder !== 'undefined') try { // extendscript
		// $FlowIgnore
		var infile = File(path); infile.open("r"); infile.encoding = "binary";
		var data = infile.read(); infile.close();
		return data;
	} catch(e) { if(!e.message || !e.message.match(/onstruct/)) throw e; }
	throw new Error("Cannot access file " + path);
}
function keys$1(o/*:any*/)/*:Array<any>*/ {
	var ks = Object.keys(o), o2 = [];
	for(var i = 0; i < ks.length; ++i) if(Object.prototype.hasOwnProperty.call(o, ks[i])) o2.push(ks[i]);
	return o2;
}

function evert_key(obj/*:any*/, key/*:string*/)/*:EvertType*/ {
	var o = ([]/*:any*/), K = keys$1(obj);
	for(var i = 0; i !== K.length; ++i) if(o[obj[K[i]][key]] == null) o[obj[K[i]][key]] = K[i];
	return o;
}

function evert(obj/*:any*/)/*:EvertType*/ {
	var o = ([]/*:any*/), K = keys$1(obj);
	for(var i = 0; i !== K.length; ++i) o[obj[K[i]]] = K[i];
	return o;
}

function evert_num(obj/*:any*/)/*:EvertNumType*/ {
	var o = ([]/*:any*/), K = keys$1(obj);
	for(var i = 0; i !== K.length; ++i) o[obj[K[i]]] = parseInt(K[i],10);
	return o;
}

function evert_arr(obj/*:any*/)/*:EvertArrType*/ {
	var o/*:EvertArrType*/ = ([]/*:any*/), K = keys$1(obj);
	for(var i = 0; i !== K.length; ++i) {
		if(o[obj[K[i]]] == null) o[obj[K[i]]] = [];
		o[obj[K[i]]].push(K[i]);
	}
	return o;
}

var basedate = new Date(1899, 11, 30, 0, 0, 0); // 2209161600000
function datenum(v/*:Date*/, date1904/*:?boolean*/)/*:number*/ {
	var epoch = v.getTime();
	if(date1904) epoch -= 1462*24*60*60*1000;
	var dnthresh = basedate.getTime() + (v.getTimezoneOffset() - basedate.getTimezoneOffset()) * 60000;
	return (epoch - dnthresh) / (24 * 60 * 60 * 1000);
}
var refdate = new Date();
var dnthresh = basedate.getTime() + (refdate.getTimezoneOffset() - basedate.getTimezoneOffset()) * 60000;
var refoffset = refdate.getTimezoneOffset();
function numdate(v/*:number*/)/*:Date*/ {
	var out = new Date();
	out.setTime(v * 24 * 60 * 60 * 1000 + dnthresh);
	if (out.getTimezoneOffset() !== refoffset) {
		out.setTime(out.getTime() + (out.getTimezoneOffset() - refoffset) * 60000);
	}
	return out;
}

/* ISO 8601 Duration */
function parse_isodur(s) {
	var sec = 0, mt = 0, time = false;
	var m = s.match(/P([0-9\.]+Y)?([0-9\.]+M)?([0-9\.]+D)?T([0-9\.]+H)?([0-9\.]+M)?([0-9\.]+S)?/);
	if(!m) throw new Error("|" + s + "| is not an ISO8601 Duration");
	for(var i = 1; i != m.length; ++i) {
		if(!m[i]) continue;
		mt = 1;
		if(i > 3) time = true;
		switch(m[i].slice(m[i].length-1)) {
			case 'Y':
				throw new Error("Unsupported ISO Duration Field: " + m[i].slice(m[i].length-1));
			case 'D': mt *= 24;
				/* falls through */
			case 'H': mt *= 60;
				/* falls through */
			case 'M':
				if(!time) throw new Error("Unsupported ISO Duration Field: M");
				else mt *= 60;
		}
		sec += mt * parseInt(m[i], 10);
	}
	return sec;
}

var good_pd_date = new Date('2017-02-19T19:06:09.000Z');
if(isNaN(good_pd_date.getFullYear())) good_pd_date = new Date('2/19/17');
var good_pd = good_pd_date.getFullYear() == 2017;
/* parses a date as a local date */
function parseDate(str/*:string|Date*/, fixdate/*:?number*/)/*:Date*/ {
	var d = new Date(str);
	if(good_pd) {
		/*:: if(fixdate == null) fixdate = 0; */
		if(fixdate > 0) d.setTime(d.getTime() + d.getTimezoneOffset() * 60 * 1000);
		else if(fixdate < 0) d.setTime(d.getTime() - d.getTimezoneOffset() * 60 * 1000);
		return d;
	}
	if(str instanceof Date) return str;
	if(good_pd_date.getFullYear() == 1917 && !isNaN(d.getFullYear())) {
		var s = d.getFullYear();
		if(str.indexOf("" + s) > -1) return d;
		d.setFullYear(d.getFullYear() + 100); return d;
	}
	var n = str.match(/\d+/g)||["2017","2","19","0","0","0"];
	var out = new Date(+n[0], +n[1] - 1, +n[2], (+n[3]||0), (+n[4]||0), (+n[5]||0));
	if(str.indexOf("Z") > -1) out = new Date(out.getTime() - out.getTimezoneOffset() * 60 * 1000);
	return out;
}

function cc2str(arr/*:Array<number>*/, debomit)/*:string*/ {
	if(has_buf && Buffer.isBuffer(arr)) {
		if(debomit) {
			if(arr[0] == 0xFF && arr[1] == 0xFE) return arr.slice(2).toString("utf16le");
			if(arr[1] == 0xFE && arr[2] == 0xFF) return utf16beread(arr.slice(2).toString("binary"));
		}
		return arr.toString("binary");
	}
	/* TODO: investigate performance degradation of TextEncoder in Edge 13 */
	var o = [];
	for(var i = 0; i != arr.length; ++i) o.push(String.fromCharCode(arr[i]));
	return o.join("");
}

function dup(o/*:any*/)/*:any*/ {
	if(typeof JSON != 'undefined' && !Array.isArray(o)) return JSON.parse(JSON.stringify(o));
	if(typeof o != 'object' || o == null) return o;
	if(o instanceof Date) return new Date(o.getTime());
	var out = {};
	for(var k in o) if(Object.prototype.hasOwnProperty.call(o, k)) out[k] = dup(o[k]);
	return out;
}

function fill(c/*:string*/,l/*:number*/)/*:string*/ { var o = ""; while(o.length < l) o+=c; return o; }

/* TODO: stress test */
function fuzzynum(s/*:string*/)/*:number*/ {
	var v/*:number*/ = Number(s);
	if(isFinite(v)) return v;
	if(!isNaN(v)) return NaN;
	if(!/\d/.test(s)) return v;
	var wt = 1;
	var ss = s.replace(/([\d]),([\d])/g,"$1$2").replace(/[$]/g,"").replace(/[%]/g, function() { wt *= 100; return "";});
	if(!isNaN(v = Number(ss))) return v / wt;
	ss = ss.replace(/[(](.*)[)]/,function($$, $1) { wt = -wt; return $1;});
	if(!isNaN(v = Number(ss))) return v / wt;
	return v;
}
var lower_months = ['january', 'february', 'march', 'april', 'may', 'june', 'july', 'august', 'september', 'october', 'november', 'december'];
function fuzzydate(s/*:string*/)/*:Date*/ {
	var o = new Date(s), n = new Date(NaN);
	var y = o.getYear(), m = o.getMonth(), d = o.getDate();
	if(isNaN(d)) return n;
	var lower = s.toLowerCase();
	if(lower.match(/jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec/)) {
		lower = lower.replace(/[^a-z]/g,"").replace(/([^a-z]|^)[ap]m?([^a-z]|$)/,"");
		if(lower.length > 3 && lower_months.indexOf(lower) == -1) return n;
	} else if(lower.match(/[a-z]/)) return n;
	if(y < 0 || y > 8099) return n;
	if((m > 0 || d > 1) && y != 101) return o;
	if(s.match(/[^-0-9:,\/\\]/)) return n;
	return o;
}

var safe_split_regex = "abacaba".split(/(:?b)/i).length == 5;
function split_regex(str/*:string*/, re, def/*:string*/)/*:Array<string>*/ {
	if(safe_split_regex || typeof re == "string") return str.split(re);
	var p = str.split(re), o = [p[0]];
	for(var i = 1; i < p.length; ++i) { o.push(def); o.push(p[i]); }
	return o;
}
function getdatastr(data)/*:?string*/ {
	if(!data) return null;
	if(data.content && data.type) return cc2str(data.content, true);
	if(data.data) return debom(data.data);
	if(data.asNodeBuffer && has_buf) return debom(data.asNodeBuffer().toString('binary'));
	if(data.asBinary) return debom(data.asBinary());
	if(data._data && data._data.getContent) return debom(cc2str(Array.prototype.slice.call(data._data.getContent(),0)));
	return null;
}

function getdatabin(data) {
	if(!data) return null;
	if(data.data) return char_codes(data.data);
	if(data.asNodeBuffer && has_buf) return data.asNodeBuffer();
	if(data._data && data._data.getContent) {
		var o = data._data.getContent();
		if(typeof o == "string") return char_codes(o);
		return Array.prototype.slice.call(o);
	}
	if(data.content && data.type) return data.content;
	return null;
}

function getdata(data) { return (data && data.name.slice(-4) === ".bin") ? getdatabin(data) : getdatastr(data); }

/* Part 2 Section 10.1.2 "Mapping Content Types" Names are case-insensitive */
/* OASIS does not comment on filename case sensitivity */
function safegetzipfile(zip, file/*:string*/) {
	var k = zip.FullPaths || keys$1(zip.files);
	var f = file.toLowerCase().replace(/[\/]/g, '\\'), g = f.replace(/\\/g,'\/');
	for(var i=0; i<k.length; ++i) {
		var n = k[i].replace(/^Root Entry[\/]/,"").toLowerCase();
		if(f == n || g == n) return zip.files ? zip.files[k[i]] : zip.FileIndex[i];
	}
	return null;
}

function getzipfile(zip, file/*:string*/) {
	var o = safegetzipfile(zip, file);
	if(o == null) throw new Error("Cannot find file " + file + " in zip");
	return o;
}

function getzipdata(zip, file/*:string*/, safe/*:?boolean*/)/*:any*/ {
	if(!safe) return getdata(getzipfile(zip, file));
	if(!file) return null;
	try { return getzipdata(zip, file); } catch(e) { return null; }
}

function getzipstr(zip, file/*:string*/, safe/*:?boolean*/)/*:?string*/ {
	if(!safe) return getdatastr(getzipfile(zip, file));
	if(!file) return null;
	try { return getzipstr(zip, file); } catch(e) { return null; }
}

function getzipbin(zip, file/*:string*/, safe/*:?boolean*/)/*:any*/ {
	if(!safe) return getdatabin(getzipfile(zip, file));
	if(!file) return null;
	try { return getzipbin(zip, file); } catch(e) { return null; }
}

function zipentries(zip) {
	var k = zip.FullPaths || keys$1(zip.files), o = [];
	for(var i = 0; i < k.length; ++i) if(k[i].slice(-1) != '/') o.push(k[i].replace(/^Root Entry[\/]/, ""));
	return o.sort();
}

function zip_add_file(zip, path, content) {
	if(zip.FullPaths) {
		if(typeof content == "string") {
			var res;
			if(has_buf) res = Buffer_from(content);
			/* TODO: investigate performance in Edge 13 */
			//else if(typeof TextEncoder !== "undefined") res = new TextEncoder().encode(content);
			else res = utf8decode(content);
			return CFB.utils.cfb_add(zip, path, res);
		}
		CFB.utils.cfb_add(zip, path, content);
	}
	else zip.file(path, content);
}

function zip_new() { return CFB.utils.cfb_new(); }

function zip_read(d, o) {
	switch(o.type) {
		case "base64": return CFB.read(d, { type: "base64" });
		case "binary": return CFB.read(d, { type: "binary" });
		case "buffer": case "array": return CFB.read(d, { type: "buffer" });
	}
	throw new Error("Unrecognized type " + o.type);
}

function resolve_path(path/*:string*/, base/*:string*/)/*:string*/ {
	if(path.charAt(0) == "/") return path.slice(1);
	var result = base.split('/');
	if(base.slice(-1) != "/") result.pop(); // folder path
	var target = path.split('/');
	while (target.length !== 0) {
		var step = target.shift();
		if (step === '..') result.pop();
		else if (step !== '.') result.push(step);
	}
	return result.join('/');
}
var XML_HEADER = '<?xml version="1.0" encoding="UTF-8" standalone="yes"?>\r\n';
var attregexg=/([^"\s?>\/]+)\s*=\s*((?:")([^"]*)(?:")|(?:')([^']*)(?:')|([^'">\s]+))/g;
var tagregex=/<[\/\?]?[a-zA-Z0-9:_-]+(?:\s+[^"\s?>\/]+\s*=\s*(?:"[^"]*"|'[^']*'|[^'">\s=]+))*\s*[\/\?]?>/mg;

if(!(XML_HEADER.match(tagregex))) tagregex = /<[^>]*>/g;
var nsregex=/<\w*:/, nsregex2 = /<(\/?)\w+:/;
function parsexmltag(tag/*:string*/, skip_root/*:?boolean*/, skip_LC/*:?boolean*/)/*:any*/ {
	var z = ({}/*:any*/);
	var eq = 0, c = 0;
	for(; eq !== tag.length; ++eq) if((c = tag.charCodeAt(eq)) === 32 || c === 10 || c === 13) break;
	if(!skip_root) z[0] = tag.slice(0, eq);
	if(eq === tag.length) return z;
	var m = tag.match(attregexg), j=0, v="", i=0, q="", cc="", quot = 1;
	if(m) for(i = 0; i != m.length; ++i) {
		cc = m[i];
		for(c=0; c != cc.length; ++c) if(cc.charCodeAt(c) === 61) break;
		q = cc.slice(0,c).trim();
		while(cc.charCodeAt(c+1) == 32) ++c;
		quot = ((eq=cc.charCodeAt(c+1)) == 34 || eq == 39) ? 1 : 0;
		v = cc.slice(c+1+quot, cc.length-quot);
		for(j=0;j!=q.length;++j) if(q.charCodeAt(j) === 58) break;
		if(j===q.length) {
			if(q.indexOf("_") > 0) q = q.slice(0, q.indexOf("_")); // from ods
			z[q] = v;
			if(!skip_LC) z[q.toLowerCase()] = v;
		}
		else {
			var k = (j===5 && q.slice(0,5)==="xmlns"?"xmlns":"")+q.slice(j+1);
			if(z[k] && q.slice(j-3,j) == "ext") continue; // from ods
			z[k] = v;
			if(!skip_LC) z[k.toLowerCase()] = v;
		}
	}
	return z;
}
function strip_ns(x/*:string*/)/*:string*/ { return x.replace(nsregex2, "<$1"); }

var encodings = {
	'&quot;': '"',
	'&apos;': "'",
	'&gt;': '>',
	'&lt;': '<',
	'&amp;': '&'
};
var rencoding = evert(encodings);
//var rencstr = "&<>'\"".split("");

// TODO: CP remap (need to read file version to determine OS)
var unescapexml/*:StringConv*/ = (function() {
	/* 22.4.2.4 bstr (Basic String) */
	var encregex = /&(?:quot|apos|gt|lt|amp|#x?([\da-fA-F]+));/ig, coderegex = /_x([\da-fA-F]{4})_/ig;
	return function unescapexml(text/*:string*/)/*:string*/ {
		var s = text + '', i = s.indexOf("<![CDATA[");
		if(i == -1) return s.replace(encregex, function($$, $1) { return encodings[$$]||String.fromCharCode(parseInt($1,$$.indexOf("x")>-1?16:10))||$$; }).replace(coderegex,function(m,c) {return String.fromCharCode(parseInt(c,16));});
		var j = s.indexOf("]]>");
		return unescapexml(s.slice(0, i)) + s.slice(i+9,j) + unescapexml(s.slice(j+3));
	};
})();

var decregex=/[&<>'"]/g, charegex = /[\u0000-\u0008\u000b-\u001f]/g;
function escapexml(text/*:string*/)/*:string*/{
	var s = text + '';
	return s.replace(decregex, function(y) { return rencoding[y]; }).replace(charegex,function(s) { return "_x" + ("000"+s.charCodeAt(0).toString(16)).slice(-4) + "_";});
}
function escapexmltag(text/*:string*/)/*:string*/{ return escapexml(text).replace(/ /g,"_x0020_"); }

var htmlcharegex = /[\u0000-\u001f]/g;
function escapehtml(text/*:string*/)/*:string*/{
	var s = text + '';
	return s.replace(decregex, function(y) { return rencoding[y]; }).replace(/\n/g, "<br/>").replace(htmlcharegex,function(s) { return "&#x" + ("000"+s.charCodeAt(0).toString(16)).slice(-4) + ";"; });
}

function escapexlml(text/*:string*/)/*:string*/{
	var s = text + '';
	return s.replace(decregex, function(y) { return rencoding[y]; }).replace(htmlcharegex,function(s) { return "&#x" + (s.charCodeAt(0).toString(16)).toUpperCase() + ";"; });
}

/* TODO: handle codepages */
var xlml_fixstr/*:StringConv*/ = (function() {
	var entregex = /&#(\d+);/g;
	function entrepl($$/*:string*/,$1/*:string*/)/*:string*/ { return String.fromCharCode(parseInt($1,10)); }
	return function xlml_fixstr(str/*:string*/)/*:string*/ { return str.replace(entregex,entrepl); };
})();
var xlml_unfixstr/*:StringConv*/ = (function() {
	return function xlml_unfixstr(str/*:string*/)/*:string*/ { return str.replace(/(\r\n|[\r\n])/g,"\&#10;"); };
})();

function parsexmlbool(value/*:any*/)/*:boolean*/ {
	switch(value) {
		case 1: case true: case '1': case 'true': case 'TRUE': return true;
		/* case '0': case 'false': case 'FALSE':*/
		default: return false;
	}
}

var utf8read/*:StringConv*/ = function utf8reada(orig/*:string*/)/*:string*/ {
	var out = "", i = 0, c = 0, d = 0, e = 0, f = 0, w = 0;
	while (i < orig.length) {
		c = orig.charCodeAt(i++);
		if (c < 128) { out += String.fromCharCode(c); continue; }
		d = orig.charCodeAt(i++);
		if (c>191 && c<224) { f = ((c & 31) << 6); f |= (d & 63); out += String.fromCharCode(f); continue; }
		e = orig.charCodeAt(i++);
		if (c < 240) { out += String.fromCharCode(((c & 15) << 12) | ((d & 63) << 6) | (e & 63)); continue; }
		f = orig.charCodeAt(i++);
		w = (((c & 7) << 18) | ((d & 63) << 12) | ((e & 63) << 6) | (f & 63))-65536;
		out += String.fromCharCode(0xD800 + ((w>>>10)&1023));
		out += String.fromCharCode(0xDC00 + (w&1023));
	}
	return out;
};

var utf8write/*:StringConv*/ = function(orig/*:string*/)/*:string*/ {
	var out/*:Array<string>*/ = [], i = 0, c = 0, d = 0;
	while(i < orig.length) {
		c = orig.charCodeAt(i++);
		switch(true) {
			case c < 128: out.push(String.fromCharCode(c)); break;
			case c < 2048:
				out.push(String.fromCharCode(192 + (c >> 6)));
				out.push(String.fromCharCode(128 + (c & 63)));
				break;
			case c >= 55296 && c < 57344:
				c -= 55296; d = orig.charCodeAt(i++) - 56320 + (c<<10);
				out.push(String.fromCharCode(240 + ((d >>18) & 7)));
				out.push(String.fromCharCode(144 + ((d >>12) & 63)));
				out.push(String.fromCharCode(128 + ((d >> 6) & 63)));
				out.push(String.fromCharCode(128 + (d & 63)));
				break;
			default:
				out.push(String.fromCharCode(224 + (c >> 12)));
				out.push(String.fromCharCode(128 + ((c >> 6) & 63)));
				out.push(String.fromCharCode(128 + (c & 63)));
		}
	}
	return out.join("");
};

if(has_buf) {
	var utf8readb = function utf8readb(data) {
		var out = Buffer.alloc(2*data.length), w, i, j = 1, k = 0, ww=0, c;
		for(i = 0; i < data.length; i+=j) {
			j = 1;
			if((c=data.charCodeAt(i)) < 128) w = c;
			else if(c < 224) { w = (c&31)*64+(data.charCodeAt(i+1)&63); j=2; }
			else if(c < 240) { w=(c&15)*4096+(data.charCodeAt(i+1)&63)*64+(data.charCodeAt(i+2)&63); j=3; }
			else { j = 4;
				w = (c & 7)*262144+(data.charCodeAt(i+1)&63)*4096+(data.charCodeAt(i+2)&63)*64+(data.charCodeAt(i+3)&63);
				w -= 65536; ww = 0xD800 + ((w>>>10)&1023); w = 0xDC00 + (w&1023);
			}
			if(ww !== 0) { out[k++] = ww&255; out[k++] = ww>>>8; ww = 0; }
			out[k++] = w%256; out[k++] = w>>>8;
		}
		return out.slice(0,k).toString('ucs2');
	};
	var corpus = "foo bar baz\u00e2\u0098\u0083\u00f0\u009f\u008d\u00a3";
	if(utf8read(corpus) == utf8readb(corpus)) utf8read = utf8readb;
	var utf8readc = function utf8readc(data) { return Buffer_from(data, 'binary').toString('utf8'); };
	if(utf8read(corpus) == utf8readc(corpus)) utf8read = utf8readc;

	utf8write = function(data) { return Buffer_from(data, 'utf8').toString("binary"); };
}

// matches <foo>...</foo> extracts content
var matchtag = (function() {
	var mtcache/*:{[k:string]:RegExp}*/ = ({}/*:any*/);
	return function matchtag(f/*:string*/,g/*:?string*/)/*:RegExp*/ {
		var t = f+"|"+(g||"");
		if(mtcache[t]) return mtcache[t];
		return (mtcache[t] = new RegExp('<(?:\\w+:)?'+f+'(?: xml:space="preserve")?(?:[^>]*)>([\\s\\S]*?)</(?:\\w+:)?'+f+'>',((g||"")/*:any*/)));
	};
})();

var htmldecode/*:{(s:string):string}*/ = (function() {
	var entities/*:Array<[RegExp, string]>*/ = [
		['nbsp', ' '], ['middot', '·'],
		['quot', '"'], ['apos', "'"], ['gt',   '>'], ['lt',   '<'], ['amp',  '&']
	].map(function(x/*:[string, string]*/) { return [new RegExp('&' + x[0] + ';', "ig"), x[1]]; });
	return function htmldecode(str/*:string*/)/*:string*/ {
		var o = str
				// Remove new lines and spaces from start of content
				.replace(/^[\t\n\r ]+/, "")
				// Remove new lines and spaces from end of content
				.replace(/[\t\n\r ]+$/,"")
				// Added line which removes any white space characters after and before html tags
				.replace(/>\s+/g,">").replace(/\s+</g,"<")
				// Replace remaining new lines and spaces with space
				.replace(/[\t\n\r ]+/g, " ")
				// Replace <br> tags with new lines
				.replace(/<\s*[bB][rR]\s*\/?>/g,"\n")
				// Strip HTML elements
				.replace(/<[^>]*>/g,"");
		for(var i = 0; i < entities.length; ++i) o = o.replace(entities[i][0], entities[i][1]);
		return o;
	};
})();

var vtregex = (function(){ var vt_cache = {};
	return function vt_regex(bt) {
		if(vt_cache[bt] !== undefined) return vt_cache[bt];
		return (vt_cache[bt] = new RegExp("<(?:vt:)?" + bt + ">([\\s\\S]*?)</(?:vt:)?" + bt + ">", 'g') );
};})();
var vtvregex = /<\/?(?:vt:)?variant>/g, vtmregex = /<(?:vt:)([^>]*)>([\s\S]*)</;
function parseVector(data/*:string*/, opts)/*:Array<{v:string,t:string}>*/ {
	var h = parsexmltag(data);

	var matches/*:Array<string>*/ = data.match(vtregex(h.baseType))||[];
	var res/*:Array<any>*/ = [];
	if(matches.length != h.size) {
		if(opts.WTF) throw new Error("unexpected vector length " + matches.length + " != " + h.size);
		return res;
	}
	matches.forEach(function(x/*:string*/) {
		var v = x.replace(vtvregex,"").match(vtmregex);
		if(v) res.push({v:utf8read(v[2]), t:v[1]});
	});
	return res;
}

var wtregex = /(^\s|\s$|\n)/;
function writetag(f/*:string*/,g/*:string*/)/*:string*/ { return '<' + f + (g.match(wtregex)?' xml:space="preserve"' : "") + '>' + g + '</' + f + '>'; }

function wxt_helper(h)/*:string*/ { return keys$1(h).map(function(k) { return " " + k + '="' + h[k] + '"';}).join(""); }
function writextag(f/*:string*/,g/*:?string*/,h) { return '<' + f + ((h != null) ? wxt_helper(h) : "") + ((g != null) ? (g.match(wtregex)?' xml:space="preserve"' : "") + '>' + g + '</' + f : "/") + '>';}

function write_w3cdtf(d/*:Date*/, t/*:?boolean*/)/*:string*/ { try { return d.toISOString().replace(/\.\d*/,""); } catch(e) { if(t) throw e; } return ""; }

function write_vt(s, xlsx/*:?boolean*/)/*:string*/ {
	switch(typeof s) {
		case 'string':
			var o = writextag('vt:lpwstr', escapexml(s));
			if(xlsx) o = o.replace(/&quot;/g, "_x0022_");
			return o;
		case 'number': return writextag((s|0)==s?'vt:i4':'vt:r8', escapexml(String(s)));
		case 'boolean': return writextag('vt:bool',s?'true':'false');
	}
	if(s instanceof Date) return writextag('vt:filetime', write_w3cdtf(s));
	throw new Error("Unable to serialize " + s);
}

var XMLNS = ({
	'dc': 'http://purl.org/dc/elements/1.1/',
	'dcterms': 'http://purl.org/dc/terms/',
	'dcmitype': 'http://purl.org/dc/dcmitype/',
	'mx': 'http://schemas.microsoft.com/office/mac/excel/2008/main',
	'r': 'http://schemas.openxmlformats.org/officeDocument/2006/relationships',
	'sjs': 'http://schemas.openxmlformats.org/package/2006/sheetjs/core-properties',
	'vt': 'http://schemas.openxmlformats.org/officeDocument/2006/docPropsVTypes',
	'xsi': 'http://www.w3.org/2001/XMLSchema-instance',
	'xsd': 'http://www.w3.org/2001/XMLSchema'
}/*:any*/);

XMLNS.main = [
	'http://schemas.openxmlformats.org/spreadsheetml/2006/main',
	'http://purl.oclc.org/ooxml/spreadsheetml/main',
	'http://schemas.microsoft.com/office/excel/2006/main',
	'http://schemas.microsoft.com/office/excel/2006/2'
];

var XLMLNS = ({
	'o':    'urn:schemas-microsoft-com:office:office',
	'x':    'urn:schemas-microsoft-com:office:excel',
	'ss':   'urn:schemas-microsoft-com:office:spreadsheet',
	'dt':   'uuid:C2F41010-65B3-11d1-A29F-00AA00C14882',
	'mv':   'http://macVmlSchemaUri',
	'v':    'urn:schemas-microsoft-com:vml',
	'html': 'http://www.w3.org/TR/REC-html40'
}/*:any*/);
function read_double_le(b/*:RawBytes|CFBlob*/, idx/*:number*/)/*:number*/ {
	var s = 1 - 2 * (b[idx + 7] >>> 7);
	var e = ((b[idx + 7] & 0x7f) << 4) + ((b[idx + 6] >>> 4) & 0x0f);
	var m = (b[idx+6]&0x0f);
	for(var i = 5; i >= 0; --i) m = m * 256 + b[idx + i];
	if(e == 0x7ff) return m == 0 ? (s * Infinity) : NaN;
	if(e == 0) e = -1022;
	else { e -= 1023; m += Math.pow(2,52); }
	return s * Math.pow(2, e - 52) * m;
}

function write_double_le(b/*:RawBytes|CFBlob*/, v/*:number*/, idx/*:number*/) {
	var bs = ((((v < 0) || (1/v == -Infinity)) ? 1 : 0) << 7), e = 0, m = 0;
	var av = bs ? (-v) : v;
	if(!isFinite(av)) { e = 0x7ff; m = isNaN(v) ? 0x6969 : 0; }
	else if(av == 0) e = m = 0;
	else {
		e = Math.floor(Math.log(av) / Math.LN2);
		m = av * Math.pow(2, 52 - e);
		if((e <= -1023) && (!isFinite(m) || (m < Math.pow(2,52)))) { e = -1022; }
		else { m -= Math.pow(2,52); e+=1023; }
	}
	for(var i = 0; i <= 5; ++i, m/=256) b[idx + i] = m & 0xff;
	b[idx + 6] = ((e & 0x0f) << 4) | (m & 0xf);
	b[idx + 7] = (e >> 4) | bs;
}

var __toBuffer = function(bufs/*:Array<Array<RawBytes> >*/)/*:RawBytes*/ { var x=[],w=10240; for(var i=0;i<bufs[0].length;++i) if(bufs[0][i]) for(var j=0,L=bufs[0][i].length;j<L;j+=w) x.push.apply(x, bufs[0][i].slice(j,j+w)); return x; };
var ___toBuffer = __toBuffer;
var __utf16le = function(b/*:RawBytes|CFBlob*/,s/*:number*/,e/*:number*/)/*:string*/ { var ss/*:Array<string>*/=[]; for(var i=s; i<e; i+=2) ss.push(String.fromCharCode(__readUInt16LE(b,i))); return ss.join("").replace(chr0,''); };
var ___utf16le = __utf16le;
var __hexlify = function(b/*:RawBytes|CFBlob*/,s/*:number*/,l/*:number*/)/*:string*/ { var ss/*:Array<string>*/=[]; for(var i=s; i<s+l; ++i) ss.push(("0" + b[i].toString(16)).slice(-2)); return ss.join(""); };
var ___hexlify = __hexlify;
var __utf8 = function(b/*:RawBytes|CFBlob*/,s/*:number*/,e/*:number*/) { var ss=[]; for(var i=s; i<e; i++) ss.push(String.fromCharCode(__readUInt8(b,i))); return ss.join(""); };
var ___utf8 = __utf8;
var __lpstr = function(b/*:RawBytes|CFBlob*/,i/*:number*/) { var len = __readUInt32LE(b,i); return len > 0 ? __utf8(b, i+4,i+4+len-1) : "";};
var ___lpstr = __lpstr;
var __cpstr = function(b/*:RawBytes|CFBlob*/,i/*:number*/) { var len = __readUInt32LE(b,i); return len > 0 ? __utf8(b, i+4,i+4+len-1) : "";};
var ___cpstr = __cpstr;
var __lpwstr = function(b/*:RawBytes|CFBlob*/,i/*:number*/) { var len = 2*__readUInt32LE(b,i); return len > 0 ? __utf8(b, i+4,i+4+len-1) : "";};
var ___lpwstr = __lpwstr;
var __lpp4, ___lpp4;
__lpp4 = ___lpp4 = function lpp4_(b/*:RawBytes|CFBlob*/,i/*:number*/) { var len = __readUInt32LE(b,i); return len > 0 ? __utf16le(b, i+4,i+4+len) : "";};
var __8lpp4 = function(b/*:RawBytes|CFBlob*/,i/*:number*/) { var len = __readUInt32LE(b,i); return len > 0 ? __utf8(b, i+4,i+4+len) : "";};
var ___8lpp4 = __8lpp4;
var __double, ___double;
__double = ___double = function(b/*:RawBytes|CFBlob*/, idx/*:number*/) { return read_double_le(b, idx);};
var is_buf = function is_buf_a(a) { return Array.isArray(a) || (typeof Uint8Array !== "undefined" && a instanceof Uint8Array); };

if(has_buf/*:: && typeof Buffer !== 'undefined'*/) {
	__utf16le = function(b/*:RawBytes|CFBlob*/,s/*:number*/,e/*:number*/)/*:string*/ { if(!Buffer.isBuffer(b)/*:: || !(b instanceof Buffer)*/) return ___utf16le(b,s,e); return b.toString('utf16le',s,e).replace(chr0,'')/*.replace(chr1,'!')*/; };
	__hexlify = function(b/*:RawBytes|CFBlob*/,s/*:number*/,l/*:number*/)/*:string*/ { return Buffer.isBuffer(b)/*:: && b instanceof Buffer*/ ? b.toString('hex',s,s+l) : ___hexlify(b,s,l); };
	__lpstr = function lpstr_b(b/*:RawBytes|CFBlob*/, i/*:number*/) { if(!Buffer.isBuffer(b)/*:: || !(b instanceof Buffer)*/) return ___lpstr(b, i); var len = b.readUInt32LE(i); return len > 0 ? b.toString('utf8',i+4,i+4+len-1) : "";};
	__cpstr = function cpstr_b(b/*:RawBytes|CFBlob*/, i/*:number*/) { if(!Buffer.isBuffer(b)/*:: || !(b instanceof Buffer)*/) return ___cpstr(b, i); var len = b.readUInt32LE(i); return len > 0 ? b.toString('utf8',i+4,i+4+len-1) : "";};
	__lpwstr = function lpwstr_b(b/*:RawBytes|CFBlob*/, i/*:number*/) { if(!Buffer.isBuffer(b)/*:: || !(b instanceof Buffer)*/) return ___lpwstr(b, i); var len = 2*b.readUInt32LE(i); return b.toString('utf16le',i+4,i+4+len-1);};
	__lpp4 = function lpp4_b(b/*:RawBytes|CFBlob*/, i/*:number*/) { if(!Buffer.isBuffer(b)/*:: || !(b instanceof Buffer)*/) return ___lpp4(b, i); var len = b.readUInt32LE(i); return b.toString('utf16le',i+4,i+4+len);};
	__8lpp4 = function lpp4_8b(b/*:RawBytes|CFBlob*/, i/*:number*/) { if(!Buffer.isBuffer(b)/*:: || !(b instanceof Buffer)*/) return ___8lpp4(b, i); var len = b.readUInt32LE(i); return b.toString('utf8',i+4,i+4+len);};
	__utf8 = function utf8_b(b/*:RawBytes|CFBlob*/, s/*:number*/, e/*:number*/) { return (Buffer.isBuffer(b)/*:: && (b instanceof Buffer)*/) ? b.toString('utf8',s,e) : ___utf8(b,s,e); };
	__toBuffer = function(bufs) { return (bufs[0].length > 0 && Buffer.isBuffer(bufs[0][0])) ? Buffer.concat(bufs[0].map(function(x) { return Buffer.isBuffer(x) ? x : Buffer_from(x); })) : ___toBuffer(bufs);};
	bconcat = function(bufs) { return Buffer.concat(bufs.map(function(buf) { return Buffer.isBuffer(buf) ? buf : Buffer_from(buf); })); };
	__double = function double_(b/*:RawBytes|CFBlob*/, i/*:number*/) { if(Buffer.isBuffer(b)/*::&& b instanceof Buffer*/) return b.readDoubleLE(i); return ___double(b,i); };
	is_buf = function is_buf_b(a) { return Buffer.isBuffer(a) || Array.isArray(a) || (typeof Uint8Array !== "undefined" && a instanceof Uint8Array); };
}

/* from js-xls */
function cpdoit() {
	__utf16le = function(b/*:RawBytes|CFBlob*/,s/*:number*/,e/*:number*/) { return cptable.utils.decode(1200, b.slice(s,e)).replace(chr0, ''); };
	__utf8 = function(b/*:RawBytes|CFBlob*/,s/*:number*/,e/*:number*/) { return cptable.utils.decode(65001, b.slice(s,e)); };
	__lpstr = function(b/*:RawBytes|CFBlob*/,i/*:number*/) { var len = __readUInt32LE(b,i); return len > 0 ? cptable.utils.decode(current_ansi, b.slice(i+4, i+4+len-1)) : "";};
	__cpstr = function(b/*:RawBytes|CFBlob*/,i/*:number*/) { var len = __readUInt32LE(b,i); return len > 0 ? cptable.utils.decode(current_codepage, b.slice(i+4, i+4+len-1)) : "";};
	__lpwstr = function(b/*:RawBytes|CFBlob*/,i/*:number*/) { var len = 2*__readUInt32LE(b,i); return len > 0 ? cptable.utils.decode(1200, b.slice(i+4,i+4+len-1)) : "";};
	__lpp4 = function(b/*:RawBytes|CFBlob*/,i/*:number*/) { var len = __readUInt32LE(b,i); return len > 0 ? cptable.utils.decode(1200, b.slice(i+4,i+4+len)) : "";};
	__8lpp4 = function(b/*:RawBytes|CFBlob*/,i/*:number*/) { var len = __readUInt32LE(b,i); return len > 0 ? cptable.utils.decode(65001, b.slice(i+4,i+4+len)) : "";};
}
if(typeof cptable !== 'undefined') cpdoit();

var __readUInt8 = function(b/*:RawBytes|CFBlob*/, idx/*:number*/)/*:number*/ { return b[idx]; };
var __readUInt16LE = function(b/*:RawBytes|CFBlob*/, idx/*:number*/)/*:number*/ { return (b[idx+1]*(1<<8))+b[idx]; };
var __readInt16LE = function(b/*:RawBytes|CFBlob*/, idx/*:number*/)/*:number*/ { var u = (b[idx+1]*(1<<8))+b[idx]; return (u < 0x8000) ? u : ((0xffff - u + 1) * -1); };
var __readUInt32LE = function(b/*:RawBytes|CFBlob*/, idx/*:number*/)/*:number*/ { return b[idx+3]*(1<<24)+(b[idx+2]<<16)+(b[idx+1]<<8)+b[idx]; };
var __readInt32LE = function(b/*:RawBytes|CFBlob*/, idx/*:number*/)/*:number*/ { return (b[idx+3]<<24)|(b[idx+2]<<16)|(b[idx+1]<<8)|b[idx]; };
var __readInt32BE = function(b/*:RawBytes|CFBlob*/, idx/*:number*/)/*:number*/ { return (b[idx]<<24)|(b[idx+1]<<16)|(b[idx+2]<<8)|b[idx+3]; };

function ReadShift(size/*:number*/, t/*:?string*/)/*:number|string*/ {
	var o="", oI/*:: :number = 0*/, oR, oo=[], w, vv, i, loc;
	switch(t) {
		case 'dbcs':
			loc = this.l;
			if(has_buf && Buffer.isBuffer(this)) o = this.slice(this.l, this.l+2*size).toString("utf16le");
			else for(i = 0; i < size; ++i) { o+=String.fromCharCode(__readUInt16LE(this, loc)); loc+=2; }
			size *= 2;
			break;

		case 'utf8': o = __utf8(this, this.l, this.l + size); break;
		case 'utf16le': size *= 2; o = __utf16le(this, this.l, this.l + size); break;

		case 'wstr':
			if(typeof cptable !== 'undefined') o = cptable.utils.decode(current_codepage, this.slice(this.l, this.l+2*size));
			else return ReadShift.call(this, size, 'dbcs');
			size = 2 * size; break;

		/* [MS-OLEDS] 2.1.4 LengthPrefixedAnsiString */
		case 'lpstr-ansi': o = __lpstr(this, this.l); size = 4 + __readUInt32LE(this, this.l); break;
		case 'lpstr-cp': o = __cpstr(this, this.l); size = 4 + __readUInt32LE(this, this.l); break;
		/* [MS-OLEDS] 2.1.5 LengthPrefixedUnicodeString */
		case 'lpwstr': o = __lpwstr(this, this.l); size = 4 + 2 * __readUInt32LE(this, this.l); break;
		/* [MS-OFFCRYPTO] 2.1.2 Length-Prefixed Padded Unicode String (UNICODE-LP-P4) */
		case 'lpp4': size = 4 +  __readUInt32LE(this, this.l); o = __lpp4(this, this.l); if(size & 0x02) size += 2; break;
		/* [MS-OFFCRYPTO] 2.1.3 Length-Prefixed UTF-8 String (UTF-8-LP-P4) */
		case '8lpp4': size = 4 +  __readUInt32LE(this, this.l); o = __8lpp4(this, this.l); if(size & 0x03) size += 4 - (size & 0x03); break;

		case 'cstr': size = 0; o = "";
			while((w=__readUInt8(this, this.l + size++))!==0) oo.push(_getchar(w));
			o = oo.join(""); break;
		case '_wstr': size = 0; o = "";
			while((w=__readUInt16LE(this,this.l +size))!==0){oo.push(_getchar(w));size+=2;}
			size+=2; o = oo.join(""); break;

		/* sbcs and dbcs support continue records in the SST way TODO codepages */
		case 'dbcs-cont': o = ""; loc = this.l;
			for(i = 0; i < size; ++i) {
				if(this.lens && this.lens.indexOf(loc) !== -1) {
					w = __readUInt8(this, loc);
					this.l = loc + 1;
					vv = ReadShift.call(this, size-i, w ? 'dbcs-cont' : 'sbcs-cont');
					return oo.join("") + vv;
				}
				oo.push(_getchar(__readUInt16LE(this, loc)));
				loc+=2;
			} o = oo.join(""); size *= 2; break;

		case 'cpstr':
			if(typeof cptable !== 'undefined') {
				o = cptable.utils.decode(current_codepage, this.slice(this.l, this.l + size));
				break;
			}
		/* falls through */
		case 'sbcs-cont': o = ""; loc = this.l;
			for(i = 0; i != size; ++i) {
				if(this.lens && this.lens.indexOf(loc) !== -1) {
					w = __readUInt8(this, loc);
					this.l = loc + 1;
					vv = ReadShift.call(this, size-i, w ? 'dbcs-cont' : 'sbcs-cont');
					return oo.join("") + vv;
				}
				oo.push(_getchar(__readUInt8(this, loc)));
				loc+=1;
			} o = oo.join(""); break;

		default:
	switch(size) {
		case 1: oI = __readUInt8(this, this.l); this.l++; return oI;
		case 2: oI = (t === 'i' ? __readInt16LE : __readUInt16LE)(this, this.l); this.l += 2; return oI;
		case 4: case -4:
			if(t === 'i' || ((this[this.l+3] & 0x80)===0)) { oI = ((size > 0) ? __readInt32LE : __readInt32BE)(this, this.l); this.l += 4; return oI; }
			else { oR = __readUInt32LE(this, this.l); this.l += 4; } return oR;
		case 8: case -8:
			if(t === 'f') {
				if(size == 8) oR = __double(this, this.l);
				else oR = __double([this[this.l+7],this[this.l+6],this[this.l+5],this[this.l+4],this[this.l+3],this[this.l+2],this[this.l+1],this[this.l+0]], 0);
				this.l += 8; return oR;
			} else size = 8;
		/* falls through */
		case 16: o = __hexlify(this, this.l, size); break;
	}}
	this.l+=size; return o;
}

var __writeUInt32LE = function(b/*:RawBytes|CFBlob*/, val/*:number*/, idx/*:number*/)/*:void*/ { b[idx] = (val & 0xFF); b[idx+1] = ((val >>> 8) & 0xFF); b[idx+2] = ((val >>> 16) & 0xFF); b[idx+3] = ((val >>> 24) & 0xFF); };
var __writeInt32LE  = function(b/*:RawBytes|CFBlob*/, val/*:number*/, idx/*:number*/)/*:void*/ { b[idx] = (val & 0xFF); b[idx+1] = ((val >> 8) & 0xFF); b[idx+2] = ((val >> 16) & 0xFF); b[idx+3] = ((val >> 24) & 0xFF); };
var __writeUInt16LE = function(b/*:RawBytes|CFBlob*/, val/*:number*/, idx/*:number*/)/*:void*/ { b[idx] = (val & 0xFF); b[idx+1] = ((val >>> 8) & 0xFF); };

function WriteShift(t/*:number*/, val/*:string|number*/, f/*:?string*/)/*:any*/ {
	var size = 0, i = 0;
	if(f === 'dbcs') {
		/*:: if(typeof val !== 'string') throw new Error("unreachable"); */
		for(i = 0; i != val.length; ++i) __writeUInt16LE(this, val.charCodeAt(i), this.l + 2 * i);
		size = 2 * val.length;
	} else if(f === 'sbcs') {
		if(typeof cptable !== 'undefined' && current_ansi == 874) {
			/* TODO: use tables directly, don't encode */
			/*:: if(typeof val !== "string") throw new Error("unreachable"); */
			for(i = 0; i != val.length; ++i) {
				var cppayload = cptable.utils.encode(current_ansi, val.charAt(i));
				this[this.l + i] = cppayload[0];
			}
		} else {
			/*:: if(typeof val !== 'string') throw new Error("unreachable"); */
			val = val.replace(/[^\x00-\x7F]/g, "_");
			/*:: if(typeof val !== 'string') throw new Error("unreachable"); */
			for(i = 0; i != val.length; ++i) this[this.l + i] = (val.charCodeAt(i) & 0xFF);
		}
		size = val.length;
	} else if(f === 'hex') {
		for(; i < t; ++i) {
			/*:: if(typeof val !== "string") throw new Error("unreachable"); */
			this[this.l++] = (parseInt(val.slice(2*i, 2*i+2), 16)||0);
		} return this;
	} else if(f === 'utf16le') {
			/*:: if(typeof val !== "string") throw new Error("unreachable"); */
			var end/*:number*/ = Math.min(this.l + t, this.length);
			for(i = 0; i < Math.min(val.length, t); ++i) {
				var cc = val.charCodeAt(i);
				this[this.l++] = (cc & 0xff);
				this[this.l++] = (cc >> 8);
			}
			while(this.l < end) this[this.l++] = 0;
			return this;
	} else /*:: if(typeof val === 'number') */ switch(t) {
		case  1: size = 1; this[this.l] = val&0xFF; break;
		case  2: size = 2; this[this.l] = val&0xFF; val >>>= 8; this[this.l+1] = val&0xFF; break;
		case  3: size = 3; this[this.l] = val&0xFF; val >>>= 8; this[this.l+1] = val&0xFF; val >>>= 8; this[this.l+2] = val&0xFF; break;
		case  4: size = 4; __writeUInt32LE(this, val, this.l); break;
		case  8: size = 8; if(f === 'f') { write_double_le(this, val, this.l); break; }
		/* falls through */
		case 16: break;
		case -4: size = 4; __writeInt32LE(this, val, this.l); break;
	}
	this.l += size; return this;
}

function CheckField(hexstr/*:string*/, fld/*:string*/)/*:void*/ {
	var m = __hexlify(this,this.l,hexstr.length>>1);
	if(m !== hexstr) throw new Error(fld + 'Expected ' + hexstr + ' saw ' + m);
	this.l += hexstr.length>>1;
}

function prep_blob(blob, pos/*:number*/)/*:void*/ {
	blob.l = pos;
	blob.read_shift = /*::(*/ReadShift/*:: :any)*/;
	blob.chk = CheckField;
	blob.write_shift = WriteShift;
}

function parsenoop(blob, length/*:: :number, opts?:any */) { blob.l += length; }

function new_buf(sz/*:number*/)/*:Block*/ {
	var o = new_raw_buf(sz);
	prep_blob(o, 0);
	return o;
}

/* [MS-XLSB] 2.1.4 Record */
function recordhopper(data, cb/*:RecordHopperCB*/, opts/*:?any*/) {
	if(!data) return;
	var tmpbyte, cntbyte, length;
	prep_blob(data, data.l || 0);
	var L = data.length, RT = 0, tgt = 0;
	while(data.l < L) {
		RT = data.read_shift(1);
		if(RT & 0x80) RT = (RT & 0x7F) + ((data.read_shift(1) & 0x7F)<<7);
		var R = XLSBRecordEnum[RT] || XLSBRecordEnum[0xFFFF];
		tmpbyte = data.read_shift(1);
		length = tmpbyte & 0x7F;
		for(cntbyte = 1; cntbyte <4 && (tmpbyte & 0x80); ++cntbyte) length += ((tmpbyte = data.read_shift(1)) & 0x7F)<<(7*cntbyte);
		tgt = data.l + length;
		var d = R.f && R.f(data, length, opts);
		data.l = tgt;
		if(cb(d, R.n, RT)) return;
	}
}

/* control buffer usage for fixed-length buffers */
function buf_array()/*:BufArray*/ {
	var bufs/*:Array<Block>*/ = [], blksz = has_buf ? 256 : 2048;
	var newblk = function ba_newblk(sz/*:number*/)/*:Block*/ {
		var o/*:Block*/ = (new_buf(sz)/*:any*/);
		prep_blob(o, 0);
		return o;
	};

	var curbuf/*:Block*/ = newblk(blksz);

	var endbuf = function ba_endbuf() {
		if(!curbuf) return;
		if(curbuf.length > curbuf.l) { curbuf = curbuf.slice(0, curbuf.l); curbuf.l = curbuf.length; }
		if(curbuf.length > 0) bufs.push(curbuf);
		curbuf = null;
	};

	var next = function ba_next(sz/*:number*/)/*:Block*/ {
		if(curbuf && (sz < (curbuf.length - curbuf.l))) return curbuf;
		endbuf();
		return (curbuf = newblk(Math.max(sz+1, blksz)));
	};

	var end = function ba_end() {
		endbuf();
		return bconcat(bufs);
	};

	var push = function ba_push(buf) { endbuf(); curbuf = buf; if(curbuf.l == null) curbuf.l = curbuf.length; next(blksz); };

	return ({ next:next, push:push, end:end, _bufs:bufs }/*:any*/);
}

function write_record(ba/*:BufArray*/, type/*:string*/, payload, length/*:?number*/) {
	if(!XLSBRE) make_XLSBRE();
	var t/*:number*/ = +XLSBRE[type], l;
	if(isNaN(t)) return; // TODO: throw something here?
	if(!length) length = XLSBRecordEnum[t].p || (payload||[]).length || 0;
	l = 1 + (t >= 0x80 ? 1 : 0) + 1/* + length*/;
	if(length >= 0x80) ++l; if(length >= 0x4000) ++l; if(length >= 0x200000) ++l;
	var o = ba.next(l);
	if(t <= 0x7F) o.write_shift(1, t);
	else {
		o.write_shift(1, (t & 0x7F) + 0x80);
		o.write_shift(1, (t >> 7));
	}
	for(var i = 0; i != 4; ++i) {
		if(length >= 0x80) { o.write_shift(1, (length & 0x7F)+0x80); length >>= 7; }
		else { o.write_shift(1, length); break; }
	}
	if(/*:: length != null &&*/length > 0 && is_buf(payload)) ba.push(payload);
}
/* XLS ranges enforced */
function shift_cell_xls(cell/*:CellAddress*/, tgt/*:any*/, opts/*:?any*/)/*:CellAddress*/ {
	var out = dup(cell);
	if(tgt.s) {
		if(out.cRel) out.c += tgt.s.c;
		if(out.rRel) out.r += tgt.s.r;
	} else {
		if(out.cRel) out.c += tgt.c;
		if(out.rRel) out.r += tgt.r;
	}
	if(!opts || opts.biff < 12) {
		while(out.c >= 0x100) out.c -= 0x100;
		while(out.r >= 0x10000) out.r -= 0x10000;
	}
	return out;
}

function shift_range_xls(cell, range, opts) {
	var out = dup(cell);
	out.s = shift_cell_xls(out.s, range.s, opts);
	out.e = shift_cell_xls(out.e, range.s, opts);
	return out;
}

function encode_cell_xls(c/*:CellAddress*/, biff/*:number*/)/*:string*/ {
	if(c.cRel && c.c < 0) { c = dup(c); while(c.c < 0) c.c += (biff > 8) ? 0x4000 : 0x100; }
	if(c.rRel && c.r < 0) { c = dup(c); while(c.r < 0) c.r += (biff > 8) ? 0x100000 : ((biff > 5) ? 0x10000 : 0x4000); }
	var s = encode_cell(c);
	if(!c.cRel && c.cRel != null) s = fix_col(s);
	if(!c.rRel && c.rRel != null) s = fix_row(s);
	return s;
}

function encode_range_xls(r, opts)/*:string*/ {
	if(r.s.r == 0 && !r.s.rRel) {
		if(r.e.r == (opts.biff >= 12 ? 0xFFFFF : (opts.biff >= 8 ? 0x10000 : 0x4000)) && !r.e.rRel) {
			return (r.s.cRel ? "" : "$") + encode_col(r.s.c) + ":" + (r.e.cRel ? "" : "$") + encode_col(r.e.c);
		}
	}
	if(r.s.c == 0 && !r.s.cRel) {
		if(r.e.c == (opts.biff >= 12 ? 0x3FFF : 0xFF) && !r.e.cRel) {
			return (r.s.rRel ? "" : "$") + encode_row(r.s.r) + ":" + (r.e.rRel ? "" : "$") + encode_row(r.e.r);
		}
	}
	return encode_cell_xls(r.s, opts.biff) + ":" + encode_cell_xls(r.e, opts.biff);
}
function decode_row(rowstr/*:string*/)/*:number*/ { return parseInt(unfix_row(rowstr),10) - 1; }
function encode_row(row/*:number*/)/*:string*/ { return "" + (row + 1); }
function fix_row(cstr/*:string*/)/*:string*/ { return cstr.replace(/([A-Z]|^)(\d+)$/,"$1$$$2"); }
function unfix_row(cstr/*:string*/)/*:string*/ { return cstr.replace(/\$(\d+)$/,"$1"); }

function decode_col(colstr/*:string*/)/*:number*/ { var c = unfix_col(colstr), d = 0, i = 0; for(; i !== c.length; ++i) d = 26*d + c.charCodeAt(i) - 64; return d - 1; }
function encode_col(col/*:number*/)/*:string*/ { if(col < 0) throw new Error("invalid column " + col); var s=""; for(++col; col; col=Math.floor((col-1)/26)) s = String.fromCharCode(((col-1)%26) + 65) + s; return s; }
function fix_col(cstr/*:string*/)/*:string*/ { return cstr.replace(/^([A-Z])/,"$$$1"); }
function unfix_col(cstr/*:string*/)/*:string*/ { return cstr.replace(/^\$([A-Z])/,"$1"); }

function split_cell(cstr/*:string*/)/*:Array<string>*/ { return cstr.replace(/(\$?[A-Z]*)(\$?\d*)/,"$1,$2").split(","); }
//function decode_cell(cstr/*:string*/)/*:CellAddress*/ { var splt = split_cell(cstr); return { c:decode_col(splt[0]), r:decode_row(splt[1]) }; }
function decode_cell(cstr/*:string*/)/*:CellAddress*/ {
	var R = 0, C = 0;
	for(var i = 0; i < cstr.length; ++i) {
		var cc = cstr.charCodeAt(i);
		if(cc >= 48 && cc <= 57) R = 10 * R + (cc - 48);
		else if(cc >= 65 && cc <= 90) C = 26 * C + (cc - 64);
	}
	return { c: C - 1, r:R - 1 };
}
//function encode_cell(cell/*:CellAddress*/)/*:string*/ { return encode_col(cell.c) + encode_row(cell.r); }
function encode_cell(cell/*:CellAddress*/)/*:string*/ {
	var col = cell.c + 1;
	var s="";
	for(; col; col=((col-1)/26)|0) s = String.fromCharCode(((col-1)%26) + 65) + s;
	return s + (cell.r + 1);
}
function decode_range(range/*:string*/)/*:Range*/ {
	var idx = range.indexOf(":");
	if(idx == -1) return { s: decode_cell(range), e: decode_cell(range) };
	return { s: decode_cell(range.slice(0, idx)), e: decode_cell(range.slice(idx + 1)) };
}
/*# if only one arg, it is assumed to be a Range.  If 2 args, both are cell addresses */
function encode_range(cs/*:CellAddrSpec|Range*/,ce/*:?CellAddrSpec*/)/*:string*/ {
	if(typeof ce === 'undefined' || typeof ce === 'number') {
/*:: if(!(cs instanceof Range)) throw "unreachable"; */
		return encode_range(cs.s, cs.e);
	}
/*:: if((cs instanceof Range)) throw "unreachable"; */
	if(typeof cs !== 'string') cs = encode_cell((cs/*:any*/));
	if(typeof ce !== 'string') ce = encode_cell((ce/*:any*/));
/*:: if(typeof cs !== 'string') throw "unreachable"; */
/*:: if(typeof ce !== 'string') throw "unreachable"; */
	return cs == ce ? cs : cs + ":" + ce;
}

function safe_decode_range(range/*:string*/)/*:Range*/ {
	var o = {s:{c:0,r:0},e:{c:0,r:0}};
	var idx = 0, i = 0, cc = 0;
	var len = range.length;
	for(idx = 0; i < len; ++i) {
		if((cc=range.charCodeAt(i)-64) < 1 || cc > 26) break;
		idx = 26*idx + cc;
	}
	o.s.c = --idx;

	for(idx = 0; i < len; ++i) {
		if((cc=range.charCodeAt(i)-48) < 0 || cc > 9) break;
		idx = 10*idx + cc;
	}
	o.s.r = --idx;

	if(i === len || cc != 10) { o.e.c=o.s.c; o.e.r=o.s.r; return o; }
	++i;

	for(idx = 0; i != len; ++i) {
		if((cc=range.charCodeAt(i)-64) < 1 || cc > 26) break;
		idx = 26*idx + cc;
	}
	o.e.c = --idx;

	for(idx = 0; i != len; ++i) {
		if((cc=range.charCodeAt(i)-48) < 0 || cc > 9) break;
		idx = 10*idx + cc;
	}
	o.e.r = --idx;
	return o;
}

function safe_format_cell(cell/*:Cell*/, v/*:any*/) {
	var q = (cell.t == 'd' && v instanceof Date);
	if(cell.z != null) try { return (cell.w = SSF.format(cell.z, q ? datenum(v) : v)); } catch(e) { }
	try { return (cell.w = SSF.format((cell.XF||{}).numFmtId||(q ? 14 : 0),  q ? datenum(v) : v)); } catch(e) { return ''+v; }
}

function format_cell(cell/*:Cell*/, v/*:any*/, o/*:any*/) {
	if(cell == null || cell.t == null || cell.t == 'z') return "";
	if(cell.w !== undefined) return cell.w;
	if(cell.t == 'd' && !cell.z && o && o.dateNF) cell.z = o.dateNF;
	if(cell.t == "e") return BErr[cell.v] || cell.v;
	if(v == undefined) return safe_format_cell(cell, cell.v);
	return safe_format_cell(cell, v);
}

function sheet_to_workbook(sheet/*:Worksheet*/, opts)/*:Workbook*/ {
	var n = opts && opts.sheet ? opts.sheet : "Sheet1";
	var sheets = {}; sheets[n] = sheet;
	return { SheetNames: [n], Sheets: sheets };
}

function sheet_add_aoa(_ws/*:?Worksheet*/, data/*:AOA*/, opts/*:?any*/)/*:Worksheet*/ {
	var o = opts || {};
	var dense = _ws ? Array.isArray(_ws) : o.dense;
	var ws/*:Worksheet*/ = _ws || (dense ? ([]/*:any*/) : ({}/*:any*/));
	var _R = 0, _C = 0;
	if(ws && o.origin != null) {
		if(typeof o.origin == 'number') _R = o.origin;
		else {
			var _origin/*:CellAddress*/ = typeof o.origin == "string" ? decode_cell(o.origin) : o.origin;
			_R = _origin.r; _C = _origin.c;
		}
		if(!ws["!ref"]) ws["!ref"] = "A1:A1";
	}
	var range/*:Range*/ = ({s: {c:10000000, r:10000000}, e: {c:0, r:0}}/*:any*/);
	if(ws['!ref']) {
		var _range = safe_decode_range(ws['!ref']);
		range.s.c = _range.s.c;
		range.s.r = _range.s.r;
		range.e.c = Math.max(range.e.c, _range.e.c);
		range.e.r = Math.max(range.e.r, _range.e.r);
		if(_R == -1) range.e.r = _R = _range.e.r + 1;
	}
	for(var R = 0; R != data.length; ++R) {
		if(!data[R]) continue;
		if(!Array.isArray(data[R])) throw new Error("aoa_to_sheet expects an array of arrays");
		for(var C = 0; C != data[R].length; ++C) {
			if(typeof data[R][C] === 'undefined') continue;
			var cell/*:Cell*/ = ({v: data[R][C] }/*:any*/);
			var __R = _R + R, __C = _C + C;
			if(range.s.r > __R) range.s.r = __R;
			if(range.s.c > __C) range.s.c = __C;
			if(range.e.r < __R) range.e.r = __R;
			if(range.e.c < __C) range.e.c = __C;
			if(data[R][C] && typeof data[R][C] === 'object' && !Array.isArray(data[R][C]) && !(data[R][C] instanceof Date)) cell = data[R][C];
			else {
				if(Array.isArray(cell.v)) { cell.f = data[R][C][1]; cell.v = cell.v[0]; }
				if(cell.v === null) {
					if(cell.f) cell.t = 'n';
					else if(o.nullError) { cell.t = 'e'; cell.v = 0; }
					else if(!o.sheetStubs) continue;
					else cell.t = 'z';
				}
				else if(typeof cell.v === 'number') cell.t = 'n';
				else if(typeof cell.v === 'boolean') cell.t = 'b';
				else if(cell.v instanceof Date) {
					cell.z = o.dateNF || SSF._table[14];
					if(o.cellDates) { cell.t = 'd'; cell.w = SSF.format(cell.z, datenum(cell.v)); }
					else { cell.t = 'n'; cell.v = datenum(cell.v); cell.w = SSF.format(cell.z, cell.v); }
				}
				else cell.t = 's';
			}
			if(dense) {
				if(!ws[__R]) ws[__R] = [];
				if(ws[__R][__C] && ws[__R][__C].z) cell.z = ws[__R][__C].z;
				ws[__R][__C] = cell;
			} else {
				var cell_ref = encode_cell(({c:__C,r:__R}/*:any*/));
				if(ws[cell_ref] && ws[cell_ref].z) cell.z = ws[cell_ref].z;
				ws[cell_ref] = cell;
			}
		}
	}
	if(range.s.c < 10000000) ws['!ref'] = encode_range(range);
	return ws;
}
function aoa_to_sheet(data/*:AOA*/, opts/*:?any*/)/*:Worksheet*/ { return sheet_add_aoa(null, data, opts); }

function write_UInt32LE(x/*:number*/, o) {
	if (!o) o = new_buf(4);
	o.write_shift(4, x);
	return o;
}

/* [MS-XLSB] 2.5.168 */
function parse_XLWideString(data/*::, length*/)/*:string*/ {
	var cchCharacters = data.read_shift(4);
	return cchCharacters === 0 ? "" : data.read_shift(cchCharacters, 'dbcs');
}
function write_XLWideString(data/*:string*/, o) {
	var _null = false; if (o == null) { _null = true; o = new_buf(4 + 2 * data.length); }
	o.write_shift(4, data.length);
	if (data.length > 0) o.write_shift(0, data, 'dbcs');
	return _null ? o.slice(0, o.l) : o;
}

/* [MS-XLSB] 2.5.91 */
//function parse_LPWideString(data/*::, length*/)/*:string*/ {
//	var cchCharacters = data.read_shift(2);
//	return cchCharacters === 0 ? "" : data.read_shift(cchCharacters, "utf16le");
//}

/* [MS-XLSB] 2.5.143 */
function parse_StrRun(data) {
	return { ich: data.read_shift(2), ifnt: data.read_shift(2) };
}
function write_StrRun(run, o) {
	if (!o) o = new_buf(4);
	o.write_shift(2, run.ich || 0);
	o.write_shift(2, run.ifnt || 0);
	return o;
}

/* [MS-XLSB] 2.5.121 */
function parse_RichStr(data, length/*:number*/)/*:XLString*/ {
	var start = data.l;
	var flags = data.read_shift(1);
	var str = parse_XLWideString(data);
	var rgsStrRun = [];
	var z = ({ t: str, h: str }/*:any*/);
	if ((flags & 1) !== 0) { /* fRichStr */
		/* TODO: formatted string */
		var dwSizeStrRun = data.read_shift(4);
		for (var i = 0; i != dwSizeStrRun; ++i) rgsStrRun.push(parse_StrRun(data));
		z.r = rgsStrRun;
	}
	else z.r = [{ ich: 0, ifnt: 0 }];
	//if((flags & 2) !== 0) { /* fExtStr */
	//	/* TODO: phonetic string */
	//}
	data.l = start + length;
	return z;
}
function write_RichStr(str/*:XLString*/, o/*:?Block*/)/*:Block*/ {
	/* TODO: formatted string */
	var _null = false; if (o == null) { _null = true; o = new_buf(15 + 4 * str.t.length); }
	o.write_shift(1, 0);
	write_XLWideString(str.t, o);
	return _null ? o.slice(0, o.l) : o;
}
/* [MS-XLSB] 2.4.328 BrtCommentText (RichStr w/1 run) */
var parse_BrtCommentText = parse_RichStr;
function write_BrtCommentText(str/*:XLString*/, o/*:?Block*/)/*:Block*/ {
	/* TODO: formatted string */
	var _null = false; if (o == null) { _null = true; o = new_buf(23 + 4 * str.t.length); }
	o.write_shift(1, 1);
	write_XLWideString(str.t, o);
	o.write_shift(4, 1);
	write_StrRun({ ich: 0, ifnt: 0 }, o);
	return _null ? o.slice(0, o.l) : o;
}

/* [MS-XLSB] 2.5.9 */
function parse_XLSBCell(data)/*:any*/ {
	var col = data.read_shift(4);
	var iStyleRef = data.read_shift(2);
	iStyleRef += data.read_shift(1) << 16;
	data.l++; //var fPhShow = data.read_shift(1);
	return { c: col, iStyleRef: iStyleRef };
}
function write_XLSBCell(cell/*:any*/, o/*:?Block*/) {
	if (o == null) o = new_buf(8);
	o.write_shift(-4, cell.c);
	o.write_shift(3, cell.iStyleRef || cell.s);
	o.write_shift(1, 0); /* fPhShow */
	return o;
}

/* Short XLSB Cell does not include column */
function parse_XLSBShortCell(data)/*:any*/ {
	var iStyleRef = data.read_shift(2);
	iStyleRef += data.read_shift(1) <<16;
	data.l++; //var fPhShow = data.read_shift(1);
	return { c:-1, iStyleRef: iStyleRef };
}
function write_XLSBShortCell(cell/*:any*/, o/*:?Block*/) {
	if(o == null) o = new_buf(4);
	o.write_shift(3, cell.iStyleRef || cell.s);
	o.write_shift(1, 0); /* fPhShow */
	return o;
}

/* [MS-XLSB] 2.5.21 */
var parse_XLSBCodeName = parse_XLWideString;
var write_XLSBCodeName = write_XLWideString;

/* [MS-XLSB] 2.5.166 */
function parse_XLNullableWideString(data/*::, length*/)/*:string*/ {
	var cchCharacters = data.read_shift(4);
	return cchCharacters === 0 || cchCharacters === 0xFFFFFFFF ? "" : data.read_shift(cchCharacters, 'dbcs');
}
function write_XLNullableWideString(data/*:string*/, o) {
	var _null = false; if (o == null) { _null = true; o = new_buf(127); }
	o.write_shift(4, data.length > 0 ? data.length : 0xFFFFFFFF);
	if (data.length > 0) o.write_shift(0, data, 'dbcs');
	return _null ? o.slice(0, o.l) : o;
}

/* [MS-XLSB] 2.5.165 */
var parse_XLNameWideString = parse_XLWideString;
//var write_XLNameWideString = write_XLWideString;

/* [MS-XLSB] 2.5.114 */
var parse_RelID = parse_XLNullableWideString;
var write_RelID = write_XLNullableWideString;


/* [MS-XLS] 2.5.217 ; [MS-XLSB] 2.5.122 */
function parse_RkNumber(data)/*:number*/ {
	var b = data.slice(data.l, data.l + 4);
	var fX100 = (b[0] & 1), fInt = (b[0] & 2);
	data.l += 4;
	var RK = fInt === 0 ? __double([0, 0, 0, 0, (b[0] & 0xFC), b[1], b[2], b[3]], 0) : __readInt32LE(b, 0) >> 2;
	return fX100 ? (RK / 100) : RK;
}
function write_RkNumber(data/*:number*/, o) {
	if (o == null) o = new_buf(4);
	var fX100 = 0, fInt = 0, d100 = data * 100;
	if ((data == (data | 0)) && (data >= -(1 << 29)) && (data < (1 << 29))) { fInt = 1; }
	else if ((d100 == (d100 | 0)) && (d100 >= -(1 << 29)) && (d100 < (1 << 29))) { fInt = 1; fX100 = 1; }
	if (fInt) o.write_shift(-4, ((fX100 ? d100 : data) << 2) + (fX100 + 2));
	else throw new Error("unsupported RkNumber " + data); // TODO
}


/* [MS-XLSB] 2.5.117 RfX */
function parse_RfX(data /*::, length*/)/*:Range*/ {
	var cell/*:Range*/ = ({ s: {}, e: {} }/*:any*/);
	cell.s.r = data.read_shift(4);
	cell.e.r = data.read_shift(4);
	cell.s.c = data.read_shift(4);
	cell.e.c = data.read_shift(4);
	return cell;
}
function write_RfX(r/*:Range*/, o) {
	if (!o) o = new_buf(16);
	o.write_shift(4, r.s.r);
	o.write_shift(4, r.e.r);
	o.write_shift(4, r.s.c);
	o.write_shift(4, r.e.c);
	return o;
}

/* [MS-XLSB] 2.5.153 UncheckedRfX */
var parse_UncheckedRfX = parse_RfX;
var write_UncheckedRfX = write_RfX;

/* [MS-XLSB] 2.5.155 UncheckedSqRfX */
//function parse_UncheckedSqRfX(data) {
//	var cnt = data.read_shift(4);
//	var out = [];
//	for(var i = 0; i < cnt; ++i) {
//		var rng = parse_UncheckedRfX(data);
//		out.push(encode_range(rng));
//	}
//	return out.join(",");
//}
//function write_UncheckedSqRfX(sqrfx/*:string*/) {
//	var parts = sqrfx.split(/\s*,\s*/);
//	var o = new_buf(4); o.write_shift(4, parts.length);
//	var out = [o];
//	parts.forEach(function(rng) {
//		out.push(write_UncheckedRfX(safe_decode_range(rng)));
//	});
//	return bconcat(out);
//}

/* [MS-XLS] 2.5.342 ; [MS-XLSB] 2.5.171 */
/* TODO: error checking, NaN and Infinity values are not valid Xnum */
function parse_Xnum(data/*::, length*/) {
	if(data.length - data.l < 8) throw "XLS Xnum Buffer underflow";
	return data.read_shift(8, 'f');
}
function write_Xnum(data, o) { return (o || new_buf(8)).write_shift(8, data, 'f'); }

/* [MS-XLSB] 2.4.324 BrtColor */
function parse_BrtColor(data/*::, length*/) {
	var out = {};
	var d = data.read_shift(1);

	//var fValidRGB = d & 1;
	var xColorType = d >>> 1;

	var index = data.read_shift(1);
	var nTS = data.read_shift(2, 'i');
	var bR = data.read_shift(1);
	var bG = data.read_shift(1);
	var bB = data.read_shift(1);
	data.l++; //var bAlpha = data.read_shift(1);

	switch (xColorType) {
		case 0: out.auto = 1; break;
		case 1:
			out.index = index;
			var icv = XLSIcv[index];
			/* automatic pseudo index 81 */
			if (icv) out.rgb = rgb2Hex(icv);
			break;
		case 2:
			/* if(!fValidRGB) throw new Error("invalid"); */
			out.rgb = rgb2Hex([bR, bG, bB]);
			break;
		case 3: out.theme = index; break;
	}
	if (nTS != 0) out.tint = nTS > 0 ? nTS / 32767 : nTS / 32768;

	return out;
}
function write_BrtColor(color, o) {
	if (!o) o = new_buf(8);
	if (!color || color.auto) { o.write_shift(4, 0); o.write_shift(4, 0); return o; }
	if (color.index != null) {
		o.write_shift(1, 0x02);
		o.write_shift(1, color.index);
	} else if (color.theme != null) {
		o.write_shift(1, 0x06);
		o.write_shift(1, color.theme);
	} else {
		o.write_shift(1, 0x05);
		o.write_shift(1, 0);
	}
	var nTS = color.tint || 0;
	if (nTS > 0) nTS *= 32767;
	else if (nTS < 0) nTS *= 32768;
	o.write_shift(2, nTS);
	if (!color.rgb || color.theme != null) {
		o.write_shift(2, 0);
		o.write_shift(1, 0);
		o.write_shift(1, 0);
	} else {
		var rgb = (color.rgb || 'FFFFFF');
		if (typeof rgb == 'number') rgb = ("000000" + rgb.toString(16)).slice(-6);
		o.write_shift(1, parseInt(rgb.slice(0, 2), 16));
		o.write_shift(1, parseInt(rgb.slice(2, 4), 16));
		o.write_shift(1, parseInt(rgb.slice(4, 6), 16));
		o.write_shift(1, 0xFF);
	}
	return o;
}

/* [MS-XLSB] 2.5.52 */
function parse_FontFlags(data/*::, length, opts*/) {
	var d = data.read_shift(1);
	data.l++;
	var out = {
		fBold: d & 0x01,
		fItalic: d & 0x02,
		fUnderline: d & 0x04,
		fStrikeout: d & 0x08,
		fOutline: d & 0x10,
		fShadow: d & 0x20,
		fCondense: d & 0x40,
		fExtend: d & 0x80
	};
	return out;
}
function write_FontFlags(font, o) {
	if (!o) o = new_buf(2);
	var grbit =
		(font.italic ? 0x02 : 0) |
		(font.strike ? 0x08 : 0) |
		(font.outline ? 0x10 : 0) |
		(font.shadow ? 0x20 : 0) |
		(font.condense ? 0x40 : 0) |
		(font.extend ? 0x80 : 0);
	o.write_shift(1, grbit);
	o.write_shift(1, 0);
	return o;
}

/* [MS-OLEDS] 2.3.1 and 2.3.2 */
function parse_ClipboardFormatOrString(o, w/*:number*/)/*:string*/ {
	// $FlowIgnore
	var ClipFmt = { 2: "BITMAP", 3: "METAFILEPICT", 8: "DIB", 14: "ENHMETAFILE" };
	var m/*:number*/ = o.read_shift(4);
	switch (m) {
		case 0x00000000: return "";
		case 0xffffffff: case 0xfffffffe: return ClipFmt[o.read_shift(4)] || "";
	}
	if (m > 0x190) throw new Error("Unsupported Clipboard: " + m.toString(16));
	o.l -= 4;
	return o.read_shift(0, w == 1 ? "lpstr" : "lpwstr");
}
function parse_ClipboardFormatOrAnsiString(o) { return parse_ClipboardFormatOrString(o, 1); }
function parse_ClipboardFormatOrUnicodeString(o) { return parse_ClipboardFormatOrString(o, 2); }

/* [MS-OLEPS] 2.2 PropertyType */
//var VT_EMPTY    = 0x0000;
//var VT_NULL     = 0x0001;
var VT_I2       = 0x0002;
var VT_I4       = 0x0003;
//var VT_R4       = 0x0004;
//var VT_R8       = 0x0005;
//var VT_CY       = 0x0006;
//var VT_DATE     = 0x0007;
//var VT_BSTR     = 0x0008;
//var VT_ERROR    = 0x000A;
var VT_BOOL     = 0x000B;
var VT_VARIANT  = 0x000C;
//var VT_DECIMAL  = 0x000E;
//var VT_I1       = 0x0010;
//var VT_UI1      = 0x0011;
//var VT_UI2      = 0x0012;
var VT_UI4      = 0x0013;
//var VT_I8       = 0x0014;
//var VT_UI8      = 0x0015;
//var VT_INT      = 0x0016;
//var VT_UINT     = 0x0017;
var VT_LPSTR    = 0x001E;
//var VT_LPWSTR   = 0x001F;
var VT_FILETIME = 0x0040;
var VT_BLOB     = 0x0041;
//var VT_STREAM   = 0x0042;
//var VT_STORAGE  = 0x0043;
//var VT_STREAMED_Object  = 0x0044;
//var VT_STORED_Object    = 0x0045;
//var VT_BLOB_Object      = 0x0046;
var VT_CF       = 0x0047;
//var VT_CLSID    = 0x0048;
//var VT_VERSIONED_STREAM = 0x0049;
var VT_VECTOR   = 0x1000;
//var VT_ARRAY    = 0x2000;

var VT_STRING   = 0x0050; // 2.3.3.1.11 VtString
var VT_USTR     = 0x0051; // 2.3.3.1.12 VtUnalignedString
var VT_CUSTOM   = [VT_STRING, VT_USTR];

/* [MS-OSHARED] 2.3.3.2.2.1 Document Summary Information PIDDSI */
var DocSummaryPIDDSI = {
	/*::[*/0x01/*::]*/: { n: 'CodePage', t: VT_I2 },
	/*::[*/0x02/*::]*/: { n: 'Category', t: VT_STRING },
	/*::[*/0x03/*::]*/: { n: 'PresentationFormat', t: VT_STRING },
	/*::[*/0x04/*::]*/: { n: 'ByteCount', t: VT_I4 },
	/*::[*/0x05/*::]*/: { n: 'LineCount', t: VT_I4 },
	/*::[*/0x06/*::]*/: { n: 'ParagraphCount', t: VT_I4 },
	/*::[*/0x07/*::]*/: { n: 'SlideCount', t: VT_I4 },
	/*::[*/0x08/*::]*/: { n: 'NoteCount', t: VT_I4 },
	/*::[*/0x09/*::]*/: { n: 'HiddenCount', t: VT_I4 },
	/*::[*/0x0a/*::]*/: { n: 'MultimediaClipCount', t: VT_I4 },
	/*::[*/0x0b/*::]*/: { n: 'ScaleCrop', t: VT_BOOL },
	/*::[*/0x0c/*::]*/: { n: 'HeadingPairs', t: VT_VECTOR | VT_VARIANT },
	/*::[*/0x0d/*::]*/: { n: 'TitlesOfParts', t: VT_VECTOR | VT_LPSTR },
	/*::[*/0x0e/*::]*/: { n: 'Manager', t: VT_STRING },
	/*::[*/0x0f/*::]*/: { n: 'Company', t: VT_STRING },
	/*::[*/0x10/*::]*/: { n: 'LinksUpToDate', t: VT_BOOL },
	/*::[*/0x11/*::]*/: { n: 'CharacterCount', t: VT_I4 },
	/*::[*/0x13/*::]*/: { n: 'SharedDoc', t: VT_BOOL },
	/*::[*/0x16/*::]*/: { n: 'HyperlinksChanged', t: VT_BOOL },
	/*::[*/0x17/*::]*/: { n: 'AppVersion', t: VT_I4, p: 'version' },
	/*::[*/0x18/*::]*/: { n: 'DigSig', t: VT_BLOB },
	/*::[*/0x1A/*::]*/: { n: 'ContentType', t: VT_STRING },
	/*::[*/0x1B/*::]*/: { n: 'ContentStatus', t: VT_STRING },
	/*::[*/0x1C/*::]*/: { n: 'Language', t: VT_STRING },
	/*::[*/0x1D/*::]*/: { n: 'Version', t: VT_STRING },
	/*::[*/0xFF/*::]*/: {},
	/* [MS-OLEPS] 2.18 */
	/*::[*/0x80000000/*::]*/: { n: 'Locale', t: VT_UI4 },
	/*::[*/0x80000003/*::]*/: { n: 'Behavior', t: VT_UI4 },
	/*::[*/0x72627262/*::]*/: {}
};

/* [MS-OSHARED] 2.3.3.2.1.1 Summary Information Property Set PIDSI */
var SummaryPIDSI = {
	/*::[*/0x01/*::]*/: { n: 'CodePage', t: VT_I2 },
	/*::[*/0x02/*::]*/: { n: 'Title', t: VT_STRING },
	/*::[*/0x03/*::]*/: { n: 'Subject', t: VT_STRING },
	/*::[*/0x04/*::]*/: { n: 'Author', t: VT_STRING },
	/*::[*/0x05/*::]*/: { n: 'Keywords', t: VT_STRING },
	/*::[*/0x06/*::]*/: { n: 'Comments', t: VT_STRING },
	/*::[*/0x07/*::]*/: { n: 'Template', t: VT_STRING },
	/*::[*/0x08/*::]*/: { n: 'LastAuthor', t: VT_STRING },
	/*::[*/0x09/*::]*/: { n: 'RevNumber', t: VT_STRING },
	/*::[*/0x0A/*::]*/: { n: 'EditTime', t: VT_FILETIME },
	/*::[*/0x0B/*::]*/: { n: 'LastPrinted', t: VT_FILETIME },
	/*::[*/0x0C/*::]*/: { n: 'CreatedDate', t: VT_FILETIME },
	/*::[*/0x0D/*::]*/: { n: 'ModifiedDate', t: VT_FILETIME },
	/*::[*/0x0E/*::]*/: { n: 'PageCount', t: VT_I4 },
	/*::[*/0x0F/*::]*/: { n: 'WordCount', t: VT_I4 },
	/*::[*/0x10/*::]*/: { n: 'CharCount', t: VT_I4 },
	/*::[*/0x11/*::]*/: { n: 'Thumbnail', t: VT_CF },
	/*::[*/0x12/*::]*/: { n: 'Application', t: VT_STRING },
	/*::[*/0x13/*::]*/: { n: 'DocSecurity', t: VT_I4 },
	/*::[*/0xFF/*::]*/: {},
	/* [MS-OLEPS] 2.18 */
	/*::[*/0x80000000/*::]*/: { n: 'Locale', t: VT_UI4 },
	/*::[*/0x80000003/*::]*/: { n: 'Behavior', t: VT_UI4 },
	/*::[*/0x72627262/*::]*/: {}
};

var DocSummaryRE/*:{[key:string]:string}*/ = evert_key(DocSummaryPIDDSI, "n");
var SummaryRE/*:{[key:string]:string}*/ = evert_key(SummaryPIDSI, "n");

/* [MS-XLS] 2.4.63 Country/Region codes */
var CountryEnum = {
	/*::[*/0x0001/*::]*/: "US", // United States
	/*::[*/0x0002/*::]*/: "CA", // Canada
	/*::[*/0x0003/*::]*/: "", // Latin America (except Brazil)
	/*::[*/0x0007/*::]*/: "RU", // Russia
	/*::[*/0x0014/*::]*/: "EG", // Egypt
	/*::[*/0x001E/*::]*/: "GR", // Greece
	/*::[*/0x001F/*::]*/: "NL", // Netherlands
	/*::[*/0x0020/*::]*/: "BE", // Belgium
	/*::[*/0x0021/*::]*/: "FR", // France
	/*::[*/0x0022/*::]*/: "ES", // Spain
	/*::[*/0x0024/*::]*/: "HU", // Hungary
	/*::[*/0x0027/*::]*/: "IT", // Italy
	/*::[*/0x0029/*::]*/: "CH", // Switzerland
	/*::[*/0x002B/*::]*/: "AT", // Austria
	/*::[*/0x002C/*::]*/: "GB", // United Kingdom
	/*::[*/0x002D/*::]*/: "DK", // Denmark
	/*::[*/0x002E/*::]*/: "SE", // Sweden
	/*::[*/0x002F/*::]*/: "NO", // Norway
	/*::[*/0x0030/*::]*/: "PL", // Poland
	/*::[*/0x0031/*::]*/: "DE", // Germany
	/*::[*/0x0034/*::]*/: "MX", // Mexico
	/*::[*/0x0037/*::]*/: "BR", // Brazil
	/*::[*/0x003d/*::]*/: "AU", // Australia
	/*::[*/0x0040/*::]*/: "NZ", // New Zealand
	/*::[*/0x0042/*::]*/: "TH", // Thailand
	/*::[*/0x0051/*::]*/: "JP", // Japan
	/*::[*/0x0052/*::]*/: "KR", // Korea
	/*::[*/0x0054/*::]*/: "VN", // Viet Nam
	/*::[*/0x0056/*::]*/: "CN", // China
	/*::[*/0x005A/*::]*/: "TR", // Turkey
	/*::[*/0x0069/*::]*/: "JS", // Ramastan
	/*::[*/0x00D5/*::]*/: "DZ", // Algeria
	/*::[*/0x00D8/*::]*/: "MA", // Morocco
	/*::[*/0x00DA/*::]*/: "LY", // Libya
	/*::[*/0x015F/*::]*/: "PT", // Portugal
	/*::[*/0x0162/*::]*/: "IS", // Iceland
	/*::[*/0x0166/*::]*/: "FI", // Finland
	/*::[*/0x01A4/*::]*/: "CZ", // Czech Republic
	/*::[*/0x0376/*::]*/: "TW", // Taiwan
	/*::[*/0x03C1/*::]*/: "LB", // Lebanon
	/*::[*/0x03C2/*::]*/: "JO", // Jordan
	/*::[*/0x03C3/*::]*/: "SY", // Syria
	/*::[*/0x03C4/*::]*/: "IQ", // Iraq
	/*::[*/0x03C5/*::]*/: "KW", // Kuwait
	/*::[*/0x03C6/*::]*/: "SA", // Saudi Arabia
	/*::[*/0x03CB/*::]*/: "AE", // United Arab Emirates
	/*::[*/0x03CC/*::]*/: "IL", // Israel
	/*::[*/0x03CE/*::]*/: "QA", // Qatar
	/*::[*/0x03D5/*::]*/: "IR", // Iran
	/*::[*/0xFFFF/*::]*/: "US"  // United States
};

/* [MS-XLS] 2.5.127 */
var XLSFillPattern = [
	null,
	'solid',
	'mediumGray',
	'darkGray',
	'lightGray',
	'darkHorizontal',
	'darkVertical',
	'darkDown',
	'darkUp',
	'darkGrid',
	'darkTrellis',
	'lightHorizontal',
	'lightVertical',
	'lightDown',
	'lightUp',
	'lightGrid',
	'lightTrellis',
	'gray125',
	'gray0625'
];

function rgbify(arr/*:Array<number>*/)/*:Array<[number, number, number]>*/ { return arr.map(function(x) { return [(x>>16)&255,(x>>8)&255,x&255]; }); }

/* [MS-XLS] 2.5.161 */
/* [MS-XLSB] 2.5.75 Icv */
var _XLSIcv = rgbify([
	/* Color Constants */
	0x000000,
	0xFFFFFF,
	0xFF0000,
	0x00FF00,
	0x0000FF,
	0xFFFF00,
	0xFF00FF,
	0x00FFFF,

	/* Overridable Defaults */
	0x000000,
	0xFFFFFF,
	0xFF0000,
	0x00FF00,
	0x0000FF,
	0xFFFF00,
	0xFF00FF,
	0x00FFFF,

	0x800000,
	0x008000,
	0x000080,
	0x808000,
	0x800080,
	0x008080,
	0xC0C0C0,
	0x808080,
	0x9999FF,
	0x993366,
	0xFFFFCC,
	0xCCFFFF,
	0x660066,
	0xFF8080,
	0x0066CC,
	0xCCCCFF,

	0x000080,
	0xFF00FF,
	0xFFFF00,
	0x00FFFF,
	0x800080,
	0x800000,
	0x008080,
	0x0000FF,
	0x00CCFF,
	0xCCFFFF,
	0xCCFFCC,
	0xFFFF99,
	0x99CCFF,
	0xFF99CC,
	0xCC99FF,
	0xFFCC99,

	0x3366FF,
	0x33CCCC,
	0x99CC00,
	0xFFCC00,
	0xFF9900,
	0xFF6600,
	0x666699,
	0x969696,
	0x003366,
	0x339966,
	0x003300,
	0x333300,
	0x993300,
	0x993366,
	0x333399,
	0x333333,

	/* Other entries to appease BIFF8/12 */
	0xFFFFFF, /* 0x40 icvForeground ?? */
	0x000000, /* 0x41 icvBackground ?? */
	0x000000, /* 0x42 icvFrame ?? */
	0x000000, /* 0x43 icv3D ?? */
	0x000000, /* 0x44 icv3DText ?? */
	0x000000, /* 0x45 icv3DHilite ?? */
	0x000000, /* 0x46 icv3DShadow ?? */
	0x000000, /* 0x47 icvHilite ?? */
	0x000000, /* 0x48 icvCtlText ?? */
	0x000000, /* 0x49 icvCtlScrl ?? */
	0x000000, /* 0x4A icvCtlInv ?? */
	0x000000, /* 0x4B icvCtlBody ?? */
	0x000000, /* 0x4C icvCtlFrame ?? */
	0x000000, /* 0x4D icvCtlFore ?? */
	0x000000, /* 0x4E icvCtlBack ?? */
	0x000000, /* 0x4F icvCtlNeutral */
	0x000000, /* 0x50 icvInfoBk ?? */
	0x000000 /* 0x51 icvInfoText ?? */
]);
var XLSIcv = dup(_XLSIcv);

/* [MS-XLSB] 2.5.97.2 */
var BErr = {
	/*::[*/0x00/*::]*/: "#NULL!",
	/*::[*/0x07/*::]*/: "#DIV/0!",
	/*::[*/0x0F/*::]*/: "#VALUE!",
	/*::[*/0x17/*::]*/: "#REF!",
	/*::[*/0x1D/*::]*/: "#NAME?",
	/*::[*/0x24/*::]*/: "#NUM!",
	/*::[*/0x2A/*::]*/: "#N/A",
	/*::[*/0x2B/*::]*/: "#GETTING_DATA",
	/*::[*/0xFF/*::]*/: "#WTF?"
};
var RBErr = evert_num(BErr);
/* Parts enumerated in OPC spec, MS-XLSB and MS-XLSX */
/* 12.3 Part Summary <SpreadsheetML> */
/* 14.2 Part Summary <DrawingML> */
/* [MS-XLSX] 2.1 Part Enumerations ; [MS-XLSB] 2.1.7 Part Enumeration */
var ct2type/*{[string]:string}*/ = ({
	/* Workbook */
	"application/vnd.openxmlformats-officedocument.spreadsheetml.sheet.main+xml": "workbooks",

	/* Worksheet */
	"application/vnd.ms-excel.binIndexWs": "TODO", /* Binary Index */

	/* Macrosheet */
	"application/vnd.ms-excel.intlmacrosheet": "TODO",
	"application/vnd.ms-excel.binIndexMs": "TODO", /* Binary Index */

	/* File Properties */
	"application/vnd.openxmlformats-package.core-properties+xml": "coreprops",
	"application/vnd.openxmlformats-officedocument.custom-properties+xml": "custprops",
	"application/vnd.openxmlformats-officedocument.extended-properties+xml": "extprops",

	/* Custom Data Properties */
	"application/vnd.openxmlformats-officedocument.customXmlProperties+xml": "TODO",
	"application/vnd.openxmlformats-officedocument.spreadsheetml.customProperty": "TODO",

	/* PivotTable */
	"application/vnd.ms-excel.pivotTable": "TODO",
	"application/vnd.openxmlformats-officedocument.spreadsheetml.pivotTable+xml": "TODO",

	/* Chart Objects */
	"application/vnd.openxmlformats-officedocument.drawingml.chart+xml": "TODO",

	/* Chart Colors */
	"application/vnd.ms-office.chartcolorstyle+xml": "TODO",

	/* Chart Style */
	"application/vnd.ms-office.chartstyle+xml": "TODO",

	/* Chart Advanced */
	"application/vnd.ms-office.chartex+xml": "TODO",

	/* Calculation Chain */
	"application/vnd.ms-excel.calcChain": "calcchains",
	"application/vnd.openxmlformats-officedocument.spreadsheetml.calcChain+xml": "calcchains",

	/* Printer Settings */
	"application/vnd.openxmlformats-officedocument.spreadsheetml.printerSettings": "TODO",

	/* ActiveX */
	"application/vnd.ms-office.activeX": "TODO",
	"application/vnd.ms-office.activeX+xml": "TODO",

	/* Custom Toolbars */
	"application/vnd.ms-excel.attachedToolbars": "TODO",

	/* External Data Connections */
	"application/vnd.ms-excel.connections": "TODO",
	"application/vnd.openxmlformats-officedocument.spreadsheetml.connections+xml": "TODO",

	/* External Links */
	"application/vnd.ms-excel.externalLink": "links",
	"application/vnd.openxmlformats-officedocument.spreadsheetml.externalLink+xml": "links",

	/* Metadata */
	"application/vnd.ms-excel.sheetMetadata": "TODO",
	"application/vnd.openxmlformats-officedocument.spreadsheetml.sheetMetadata+xml": "TODO",

	/* PivotCache */
	"application/vnd.ms-excel.pivotCacheDefinition": "TODO",
	"application/vnd.ms-excel.pivotCacheRecords": "TODO",
	"application/vnd.openxmlformats-officedocument.spreadsheetml.pivotCacheDefinition+xml": "TODO",
	"application/vnd.openxmlformats-officedocument.spreadsheetml.pivotCacheRecords+xml": "TODO",

	/* Query Table */
	"application/vnd.ms-excel.queryTable": "TODO",
	"application/vnd.openxmlformats-officedocument.spreadsheetml.queryTable+xml": "TODO",

	/* Shared Workbook */
	"application/vnd.ms-excel.userNames": "TODO",
	"application/vnd.ms-excel.revisionHeaders": "TODO",
	"application/vnd.ms-excel.revisionLog": "TODO",
	"application/vnd.openxmlformats-officedocument.spreadsheetml.revisionHeaders+xml": "TODO",
	"application/vnd.openxmlformats-officedocument.spreadsheetml.revisionLog+xml": "TODO",
	"application/vnd.openxmlformats-officedocument.spreadsheetml.userNames+xml": "TODO",

	/* Single Cell Table */
	"application/vnd.ms-excel.tableSingleCells": "TODO",
	"application/vnd.openxmlformats-officedocument.spreadsheetml.tableSingleCells+xml": "TODO",

	/* Slicer */
	"application/vnd.ms-excel.slicer": "TODO",
	"application/vnd.ms-excel.slicerCache": "TODO",
	"application/vnd.ms-excel.slicer+xml": "TODO",
	"application/vnd.ms-excel.slicerCache+xml": "TODO",

	/* Sort Map */
	"application/vnd.ms-excel.wsSortMap": "TODO",

	/* Table */
	"application/vnd.ms-excel.table": "TODO",
	"application/vnd.openxmlformats-officedocument.spreadsheetml.table+xml": "TODO",

	/* Themes */
	"application/vnd.openxmlformats-officedocument.theme+xml": "themes",

	/* Theme Override */
	"application/vnd.openxmlformats-officedocument.themeOverride+xml": "TODO",

	/* Timeline */
	"application/vnd.ms-excel.Timeline+xml": "TODO", /* verify */
	"application/vnd.ms-excel.TimelineCache+xml": "TODO", /* verify */

	/* VBA */
	"application/vnd.ms-office.vbaProject": "vba",
	"application/vnd.ms-office.vbaProjectSignature": "TODO",

	/* Volatile Dependencies */
	"application/vnd.ms-office.volatileDependencies": "TODO",
	"application/vnd.openxmlformats-officedocument.spreadsheetml.volatileDependencies+xml": "TODO",

	/* Control Properties */
	"application/vnd.ms-excel.controlproperties+xml": "TODO",

	/* Data Model */
	"application/vnd.openxmlformats-officedocument.model+data": "TODO",

	/* Survey */
	"application/vnd.ms-excel.Survey+xml": "TODO",

	/* Drawing */
	"application/vnd.openxmlformats-officedocument.drawing+xml": "drawings",
	"application/vnd.openxmlformats-officedocument.drawingml.chartshapes+xml": "TODO",
	"application/vnd.openxmlformats-officedocument.drawingml.diagramColors+xml": "TODO",
	"application/vnd.openxmlformats-officedocument.drawingml.diagramData+xml": "TODO",
	"application/vnd.openxmlformats-officedocument.drawingml.diagramLayout+xml": "TODO",
	"application/vnd.openxmlformats-officedocument.drawingml.diagramStyle+xml": "TODO",

	/* VML */
	"application/vnd.openxmlformats-officedocument.vmlDrawing": "TODO",

	"application/vnd.openxmlformats-package.relationships+xml": "rels",
	"application/vnd.openxmlformats-officedocument.oleObject": "TODO",

	/* Image */
	"image/png": "TODO",

	"sheet": "js"
}/*:any*/);

var CT_LIST = (function(){
	var o = {
		workbooks: {
			xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet.main+xml",
			xlsm: "application/vnd.ms-excel.sheet.macroEnabled.main+xml",
			xlsb: "application/vnd.ms-excel.sheet.binary.macroEnabled.main",
			xlam: "application/vnd.ms-excel.addin.macroEnabled.main+xml",
			xltx: "application/vnd.openxmlformats-officedocument.spreadsheetml.template.main+xml"
		},
		strs: { /* Shared Strings */
			xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.sharedStrings+xml",
			xlsb: "application/vnd.ms-excel.sharedStrings"
		},
		comments: { /* Comments */
			xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.comments+xml",
			xlsb: "application/vnd.ms-excel.comments"
		},
		sheets: { /* Worksheet */
			xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.worksheet+xml",
			xlsb: "application/vnd.ms-excel.worksheet"
		},
		charts: { /* Chartsheet */
			xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.chartsheet+xml",
			xlsb: "application/vnd.ms-excel.chartsheet"
		},
		dialogs: { /* Dialogsheet */
			xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.dialogsheet+xml",
			xlsb: "application/vnd.ms-excel.dialogsheet"
		},
		macros: { /* Macrosheet (Excel 4.0 Macros) */
			xlsx: "application/vnd.ms-excel.macrosheet+xml",
			xlsb: "application/vnd.ms-excel.macrosheet"
		},
		styles: { /* Styles */
			xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.styles+xml",
			xlsb: "application/vnd.ms-excel.styles"
		}
	};
	keys$1(o).forEach(function(k) { ["xlsm", "xlam"].forEach(function(v) { if(!o[k][v]) o[k][v] = o[k].xlsx; }); });
	keys$1(o).forEach(function(k){ keys$1(o[k]).forEach(function(v) { ct2type[o[k][v]] = k; }); });
	return o;
})();

var type2ct/*{[string]:Array<string>}*/ = evert_arr(ct2type);

XMLNS.CT = 'http://schemas.openxmlformats.org/package/2006/content-types';

function new_ct()/*:any*/ {
	return ({
		workbooks:[], sheets:[], charts:[], dialogs:[], macros:[],
		rels:[], strs:[], comments:[], links:[],
		coreprops:[], extprops:[], custprops:[], themes:[], styles:[],
		calcchains:[], vba: [], drawings: [],
		TODO:[], xmlns: "" }/*:any*/);
}

function parse_ct(data/*:?string*/) {
	var ct = new_ct();
	if(!data || !data.match) return ct;
	var ctext = {};
	(data.match(tagregex)||[]).forEach(function(x) {
		var y = parsexmltag(x);
		switch(y[0].replace(nsregex,"<")) {
			case '<?xml': break;
			case '<Types': ct.xmlns = y['xmlns' + (y[0].match(/<(\w+):/)||["",""])[1] ]; break;
			case '<Default': ctext[y.Extension] = y.ContentType; break;
			case '<Override':
				if(ct[ct2type[y.ContentType]] !== undefined) ct[ct2type[y.ContentType]].push(y.PartName);
				break;
		}
	});
	if(ct.xmlns !== XMLNS.CT) throw new Error("Unknown Namespace: " + ct.xmlns);
	ct.calcchain = ct.calcchains.length > 0 ? ct.calcchains[0] : "";
	ct.sst = ct.strs.length > 0 ? ct.strs[0] : "";
	ct.style = ct.styles.length > 0 ? ct.styles[0] : "";
	ct.defaults = ctext;
	delete ct.calcchains;
	return ct;
}

var CTYPE_XML_ROOT = writextag('Types', null, {
	'xmlns': XMLNS.CT,
	'xmlns:xsd': XMLNS.xsd,
	'xmlns:xsi': XMLNS.xsi
});

var CTYPE_DEFAULTS = [
	['xml', 'application/xml'],
	['bin', 'application/vnd.ms-excel.sheet.binary.macroEnabled.main'],
	['vml', 'application/vnd.openxmlformats-officedocument.vmlDrawing'],
	['data', 'application/vnd.openxmlformats-officedocument.model+data'],
	/* from test files */
	['bmp', 'image/bmp'],
	['png', 'image/png'],
	['gif', 'image/gif'],
	['emf', 'image/x-emf'],
	['wmf', 'image/x-wmf'],
	['jpg', 'image/jpeg'], ['jpeg', 'image/jpeg'],
	['tif', 'image/tiff'], ['tiff', 'image/tiff'],
	['pdf', 'application/pdf'],
	['rels', type2ct.rels[0]]
].map(function(x) {
	return writextag('Default', null, {'Extension':x[0], 'ContentType': x[1]});
});

function write_ct(ct, opts)/*:string*/ {
	var o/*:Array<string>*/ = [], v;
	o[o.length] = (XML_HEADER);
	o[o.length] = (CTYPE_XML_ROOT);
	o = o.concat(CTYPE_DEFAULTS);

	/* only write first instance */
	var f1 = function(w) {
		if(ct[w] && ct[w].length > 0) {
			v = ct[w][0];
			o[o.length] = (writextag('Override', null, {
				'PartName': (v[0] == '/' ? "":"/") + v,
				'ContentType': CT_LIST[w][opts.bookType || 'xlsx']
			}));
		}
	};

	/* book type-specific */
	var f2 = function(w) {
		(ct[w]||[]).forEach(function(v) {
			o[o.length] = (writextag('Override', null, {
				'PartName': (v[0] == '/' ? "":"/") + v,
				'ContentType': CT_LIST[w][opts.bookType || 'xlsx']
			}));
		});
	};

	/* standard type */
	var f3 = function(t) {
		(ct[t]||[]).forEach(function(v) {
			o[o.length] = (writextag('Override', null, {
				'PartName': (v[0] == '/' ? "":"/") + v,
				'ContentType': type2ct[t][0]
			}));
		});
	};

	f1('workbooks');
	f2('sheets');
	f2('charts');
	f3('themes');
	['strs', 'styles'].forEach(f1);
	['coreprops', 'extprops', 'custprops'].forEach(f3);
	f3('vba');
	f3('comments');
	f3('drawings');
	if(o.length>2){ o[o.length] = ('</Types>'); o[1]=o[1].replace("/>",">"); }
	return o.join("");
}
/* 9.3 Relationships */
var RELS = ({
	WB: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/officeDocument",
	SHEET: "http://sheetjs.openxmlformats.org/officeDocument/2006/relationships/officeDocument",
	HLINK: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/hyperlink",
	VML: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/vmlDrawing",
	XPATH: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/externalLinkPath",
	XMISS: "http://schemas.microsoft.com/office/2006/relationships/xlExternalLinkPath/xlPathMissing",
	XLINK: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/externalLink",
	CXML: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/customXml",
	CXMLP: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/customXmlProps",
	VBA: "http://schemas.microsoft.com/office/2006/relationships/vbaProject"
}/*:any*/);

/* 9.3.3 Representing Relationships */
function get_rels_path(file/*:string*/)/*:string*/ {
	var n = file.lastIndexOf("/");
	return file.slice(0,n+1) + '_rels/' + file.slice(n+1) + ".rels";
}

function parse_rels(data/*:?string*/, currentFilePath/*:string*/) {
	var rels = {"!id":{}};
	if (!data) return rels;
	if (currentFilePath.charAt(0) !== '/') {
		currentFilePath = '/'+currentFilePath;
	}
	var hash = {};

	(data.match(tagregex)||[]).forEach(function(x) {
		var y = parsexmltag(x);
		/* 9.3.2.2 OPC_Relationships */
		if (y[0] === '<Relationship') {
			var rel = {}; rel.Type = y.Type; rel.Target = y.Target; rel.Id = y.Id; if(y.TargetMode) rel.TargetMode = y.TargetMode;
			var canonictarget = y.TargetMode === 'External' ? y.Target : resolve_path(y.Target, currentFilePath);
			rels[canonictarget] = rel;
			hash[y.Id] = rel;
		}
	});
	rels["!id"] = hash;
	return rels;
}

XMLNS.RELS = 'http://schemas.openxmlformats.org/package/2006/relationships';

var RELS_ROOT = writextag('Relationships', null, {
	//'xmlns:ns0': XMLNS.RELS,
	'xmlns': XMLNS.RELS
});

/* TODO */
function write_rels(rels)/*:string*/ {
	var o = [XML_HEADER, RELS_ROOT];
	keys$1(rels['!id']).forEach(function(rid) {
		o[o.length] = (writextag('Relationship', null, rels['!id'][rid]));
	});
	if(o.length>2){ o[o.length] = ('</Relationships>'); o[1]=o[1].replace("/>",">"); }
	return o.join("");
}

var RELS_EXTERN = [RELS.HLINK, RELS.XPATH, RELS.XMISS];
function add_rels(rels, rId/*:number*/, f, type, relobj, targetmode/*:?string*/)/*:number*/ {
	if(!relobj) relobj = {};
	if(!rels['!id']) rels['!id'] = {};
	if(rId < 0) for(rId = 1; rels['!id']['rId' + rId]; ++rId){/* empty */}
	relobj.Id = 'rId' + rId;
	relobj.Type = type;
	relobj.Target = f;
	if(targetmode) relobj.TargetMode = targetmode;
	else if(RELS_EXTERN.indexOf(relobj.Type) > -1) relobj.TargetMode = "External";
	if(rels['!id'][relobj.Id]) throw new Error("Cannot rewrite rId " + rId);
	rels['!id'][relobj.Id] = relobj;
	rels[('/' + relobj.Target).replace("//","/")] = relobj;
	return rId;
}
/* Open Document Format for Office Applications (OpenDocument) Version 1.2 */
/* Part 3 Section 4 Manifest File */
var CT_ODS = "application/vnd.oasis.opendocument.spreadsheet";
function parse_manifest(d, opts) {
	var str = xlml_normalize(d);
	var Rn;
	var FEtag;
	while((Rn = xlmlregex.exec(str))) switch(Rn[3]) {
		case 'manifest': break; // 4.2 <manifest:manifest>
		case 'file-entry': // 4.3 <manifest:file-entry>
			FEtag = parsexmltag(Rn[0], false);
			if(FEtag.path == '/' && FEtag.type !== CT_ODS) throw new Error("This OpenDocument is not a spreadsheet");
			break;
		case 'encryption-data': // 4.4 <manifest:encryption-data>
		case 'algorithm': // 4.5 <manifest:algorithm>
		case 'start-key-generation': // 4.6 <manifest:start-key-generation>
		case 'key-derivation': // 4.7 <manifest:key-derivation>
			throw new Error("Unsupported ODS Encryption");
		default: if(opts && opts.WTF) throw Rn;
	}
}

function write_manifest(manifest/*:Array<Array<string> >*/)/*:string*/ {
	var o = [XML_HEADER];
	o.push('<manifest:manifest xmlns:manifest="urn:oasis:names:tc:opendocument:xmlns:manifest:1.0" manifest:version="1.2">\n');
	o.push('  <manifest:file-entry manifest:full-path="/" manifest:version="1.2" manifest:media-type="application/vnd.oasis.opendocument.spreadsheet"/>\n');
	for(var i = 0; i < manifest.length; ++i) o.push('  <manifest:file-entry manifest:full-path="' + manifest[i][0] + '" manifest:media-type="' + manifest[i][1] + '"/>\n');
	o.push('</manifest:manifest>');
	return o.join("");
}

/* Part 3 Section 6 Metadata Manifest File */
function write_rdf_type(file/*:string*/, res/*:string*/, tag/*:?string*/) {
	return [
		'  <rdf:Description rdf:about="' + file + '">\n',
		'    <rdf:type rdf:resource="http://docs.oasis-open.org/ns/office/1.2/meta/' + (tag || "odf") + '#' + res + '"/>\n',
		'  </rdf:Description>\n'
	].join("");
}
function write_rdf_has(base/*:string*/, file/*:string*/) {
	return [
		'  <rdf:Description rdf:about="' + base + '">\n',
		'    <ns0:hasPart xmlns:ns0="http://docs.oasis-open.org/ns/office/1.2/meta/pkg#" rdf:resource="' + file + '"/>\n',
		'  </rdf:Description>\n'
	].join("");
}
function write_rdf(rdf) {
	var o = [XML_HEADER];
	o.push('<rdf:RDF xmlns:rdf="http://www.w3.org/1999/02/22-rdf-syntax-ns#">\n');
	for(var i = 0; i != rdf.length; ++i) {
		o.push(write_rdf_type(rdf[i][0], rdf[i][1]));
		o.push(write_rdf_has("",rdf[i][0]));
	}
	o.push(write_rdf_type("","Document", "pkg"));
	o.push('</rdf:RDF>');
	return o.join("");
}
/* TODO: pull properties */
var write_meta_ods/*:{(wb:Workbook, opts:any):string}*/ = (function() {
	var payload = '<office:document-meta xmlns:office="urn:oasis:names:tc:opendocument:xmlns:office:1.0" xmlns:meta="urn:oasis:names:tc:opendocument:xmlns:meta:1.0" xmlns:dc="http://purl.org/dc/elements/1.1/" xmlns:xlink="http://www.w3.org/1999/xlink" office:version="1.2"><office:meta><meta:generator>Sheet' + 'JS ' + XLSX.version + '</meta:generator></office:meta></office:document-meta>';
	return function wmo(/*:: wb: Workbook, opts: any*/)/*:string*/ {
		return payload;
	};
})();

/* ECMA-376 Part II 11.1 Core Properties Part */
/* [MS-OSHARED] 2.3.3.2.[1-2].1 (PIDSI/PIDDSI) */
var CORE_PROPS/*:Array<Array<string> >*/ = [
	["cp:category", "Category"],
	["cp:contentStatus", "ContentStatus"],
	["cp:keywords", "Keywords"],
	["cp:lastModifiedBy", "LastAuthor"],
	["cp:lastPrinted", "LastPrinted"],
	["cp:revision", "RevNumber"],
	["cp:version", "Version"],
	["dc:creator", "Author"],
	["dc:description", "Comments"],
	["dc:identifier", "Identifier"],
	["dc:language", "Language"],
	["dc:subject", "Subject"],
	["dc:title", "Title"],
	["dcterms:created", "CreatedDate", 'date'],
	["dcterms:modified", "ModifiedDate", 'date']
];

XMLNS.CORE_PROPS = "http://schemas.openxmlformats.org/package/2006/metadata/core-properties";
RELS.CORE_PROPS  = 'http://schemas.openxmlformats.org/package/2006/relationships/metadata/core-properties';

var CORE_PROPS_REGEX/*:Array<RegExp>*/ = (function() {
	var r = new Array(CORE_PROPS.length);
	for(var i = 0; i < CORE_PROPS.length; ++i) {
		var f = CORE_PROPS[i];
		var g = "(?:"+ f[0].slice(0,f[0].indexOf(":")) +":)"+ f[0].slice(f[0].indexOf(":")+1);
		r[i] = new RegExp("<" + g + "[^>]*>([\\s\\S]*?)<\/" + g + ">");
	}
	return r;
})();

function parse_core_props(data) {
	var p = {};
	data = utf8read(data);

	for(var i = 0; i < CORE_PROPS.length; ++i) {
		var f = CORE_PROPS[i], cur = data.match(CORE_PROPS_REGEX[i]);
		if(cur != null && cur.length > 0) p[f[1]] = unescapexml(cur[1]);
		if(f[2] === 'date' && p[f[1]]) p[f[1]] = parseDate(p[f[1]]);
	}

	return p;
}

var CORE_PROPS_XML_ROOT = writextag('cp:coreProperties', null, {
	//'xmlns': XMLNS.CORE_PROPS,
	'xmlns:cp': XMLNS.CORE_PROPS,
	'xmlns:dc': XMLNS.dc,
	'xmlns:dcterms': XMLNS.dcterms,
	'xmlns:dcmitype': XMLNS.dcmitype,
	'xmlns:xsi': XMLNS.xsi
});

function cp_doit(f, g, h, o, p) {
	if(p[f] != null || g == null || g === "") return;
	p[f] = g;
	g = escapexml(g);
	o[o.length] = (h ? writextag(f,g,h) : writetag(f,g));
}

function write_core_props(cp, _opts) {
	var opts = _opts || {};
	var o = [XML_HEADER, CORE_PROPS_XML_ROOT], p = {};
	if(!cp && !opts.Props) return o.join("");

	if(cp) {
		if(cp.CreatedDate != null) cp_doit("dcterms:created", typeof cp.CreatedDate === "string" ? cp.CreatedDate : write_w3cdtf(cp.CreatedDate, opts.WTF), {"xsi:type":"dcterms:W3CDTF"}, o, p);
		if(cp.ModifiedDate != null) cp_doit("dcterms:modified", typeof cp.ModifiedDate === "string" ? cp.ModifiedDate : write_w3cdtf(cp.ModifiedDate, opts.WTF), {"xsi:type":"dcterms:W3CDTF"}, o, p);
	}

	for(var i = 0; i != CORE_PROPS.length; ++i) {
		var f = CORE_PROPS[i];
		var v = opts.Props && opts.Props[f[1]] != null ? opts.Props[f[1]] : cp ? cp[f[1]] : null;
		if(v === true) v = "1";
		else if(v === false) v = "0";
		else if(typeof v == "number") v = String(v);
		if(v != null) cp_doit(f[0], v, null, o, p);
	}
	if(o.length>2){ o[o.length] = ('</cp:coreProperties>'); o[1]=o[1].replace("/>",">"); }
	return o.join("");
}
/* 15.2.12.3 Extended File Properties Part */
/* [MS-OSHARED] 2.3.3.2.[1-2].1 (PIDSI/PIDDSI) */
var EXT_PROPS/*:Array<Array<string> >*/ = [
	["Application", "Application", "string"],
	["AppVersion", "AppVersion", "string"],
	["Company", "Company", "string"],
	["DocSecurity", "DocSecurity", "string"],
	["Manager", "Manager", "string"],
	["HyperlinksChanged", "HyperlinksChanged", "bool"],
	["SharedDoc", "SharedDoc", "bool"],
	["LinksUpToDate", "LinksUpToDate", "bool"],
	["ScaleCrop", "ScaleCrop", "bool"],
	["HeadingPairs", "HeadingPairs", "raw"],
	["TitlesOfParts", "TitlesOfParts", "raw"]
];

XMLNS.EXT_PROPS = "http://schemas.openxmlformats.org/officeDocument/2006/extended-properties";
RELS.EXT_PROPS  = 'http://schemas.openxmlformats.org/officeDocument/2006/relationships/extended-properties';

var PseudoPropsPairs = [
	"Worksheets",  "SheetNames",
	"NamedRanges", "DefinedNames",
	"Chartsheets", "ChartNames"
];
function load_props_pairs(HP/*:string|Array<Array<any>>*/, TOP, props, opts) {
	var v = [];
	if(typeof HP == "string") v = parseVector(HP, opts);
	else for(var j = 0; j < HP.length; ++j) v = v.concat(HP[j].map(function(hp) { return {v:hp}; }));
	var parts = (typeof TOP == "string") ? parseVector(TOP, opts).map(function (x) { return x.v; }) : TOP;
	var idx = 0, len = 0;
	if(parts.length > 0) for(var i = 0; i !== v.length; i += 2) {
		len = +(v[i+1].v);
		switch(v[i].v) {
			case "Worksheets":
			case "工作表":
			case "Листы":
			case "أوراق العمل":
			case "ワークシート":
			case "גליונות עבודה":
			case "Arbeitsblätter":
			case "Çalışma Sayfaları":
			case "Feuilles de calcul":
			case "Fogli di lavoro":
			case "Folhas de cálculo":
			case "Planilhas":
			case "Regneark":
			case "Hojas de cálculo":
			case "Werkbladen":
				props.Worksheets = len;
				props.SheetNames = parts.slice(idx, idx + len);
				break;

			case "Named Ranges":
			case "Rangos con nombre":
			case "名前付き一覧":
			case "Benannte Bereiche":
			case "Navngivne områder":
				props.NamedRanges = len;
				props.DefinedNames = parts.slice(idx, idx + len);
				break;

			case "Charts":
			case "Diagramme":
				props.Chartsheets = len;
				props.ChartNames = parts.slice(idx, idx + len);
				break;
		}
		idx += len;
	}
}

function parse_ext_props(data, p, opts) {
	var q = {}; if(!p) p = {};
	data = utf8read(data);

	EXT_PROPS.forEach(function(f) {
		var xml = (data.match(matchtag(f[0]))||[])[1];
		switch(f[2]) {
			case "string": if(xml) p[f[1]] = unescapexml(xml); break;
			case "bool": p[f[1]] = xml === "true"; break;
			case "raw":
				var cur = data.match(new RegExp("<" + f[0] + "[^>]*>([\\s\\S]*?)<\/" + f[0] + ">"));
				if(cur && cur.length > 0) q[f[1]] = cur[1];
				break;
		}
	});

	if(q.HeadingPairs && q.TitlesOfParts) load_props_pairs(q.HeadingPairs, q.TitlesOfParts, p, opts);

	return p;
}

var EXT_PROPS_XML_ROOT = writextag('Properties', null, {
	'xmlns': XMLNS.EXT_PROPS,
	'xmlns:vt': XMLNS.vt
});

function write_ext_props(cp/*::, opts*/)/*:string*/ {
	var o/*:Array<string>*/ = [], W = writextag;
	if(!cp) cp = {};
	cp.Application = "SheetJS";
	o[o.length] = (XML_HEADER);
	o[o.length] = (EXT_PROPS_XML_ROOT);

	EXT_PROPS.forEach(function(f) {
		if(cp[f[1]] === undefined) return;
		var v;
		switch(f[2]) {
			case 'string': v = escapexml(String(cp[f[1]])); break;
			case 'bool': v = cp[f[1]] ? 'true' : 'false'; break;
		}
		if(v !== undefined) o[o.length] = (W(f[0], v));
	});

	/* TODO: HeadingPairs, TitlesOfParts */
	o[o.length] = (W('HeadingPairs', W('vt:vector', W('vt:variant', '<vt:lpstr>Worksheets</vt:lpstr>')+W('vt:variant', W('vt:i4', String(cp.Worksheets))), {size:2, baseType:"variant"})));
	o[o.length] = (W('TitlesOfParts', W('vt:vector', cp.SheetNames.map(function(s) { return "<vt:lpstr>" + escapexml(s) + "</vt:lpstr>"; }).join(""), {size: cp.Worksheets, baseType:"lpstr"})));
	if(o.length>2){ o[o.length] = ('</Properties>'); o[1]=o[1].replace("/>",">"); }
	return o.join("");
}
/* 15.2.12.2 Custom File Properties Part */
XMLNS.CUST_PROPS = "http://schemas.openxmlformats.org/officeDocument/2006/custom-properties";
RELS.CUST_PROPS  = 'http://schemas.openxmlformats.org/officeDocument/2006/relationships/custom-properties';

var custregex = /<[^>]+>[^<]*/g;
function parse_cust_props(data/*:string*/, opts) {
	var p = {}, name = "";
	var m = data.match(custregex);
	if(m) for(var i = 0; i != m.length; ++i) {
		var x = m[i], y = parsexmltag(x);
		switch(y[0]) {
			case '<?xml': break;
			case '<Properties': break;
			case '<property': name = unescapexml(y.name); break;
			case '</property>': name = null; break;
			default: if (x.indexOf('<vt:') === 0) {
				var toks = x.split('>');
				var type = toks[0].slice(4), text = toks[1];
				/* 22.4.2.32 (CT_Variant). Omit the binary types from 22.4 (Variant Types) */
				switch(type) {
					case 'lpstr': case 'bstr': case 'lpwstr':
						p[name] = unescapexml(text);
						break;
					case 'bool':
						p[name] = parsexmlbool(text);
						break;
					case 'i1': case 'i2': case 'i4': case 'i8': case 'int': case 'uint':
						p[name] = parseInt(text, 10);
						break;
					case 'r4': case 'r8': case 'decimal':
						p[name] = parseFloat(text);
						break;
					case 'filetime': case 'date':
						p[name] = parseDate(text);
						break;
					case 'cy': case 'error':
						p[name] = unescapexml(text);
						break;
					default:
						if(type.slice(-1) == '/') break;
						if(opts.WTF && typeof console !== 'undefined') console.warn('Unexpected', x, type, toks);
				}
			} else if(x.slice(0,2) === "</") ; else if(opts.WTF) throw new Error(x);
		}
	}
	return p;
}

var CUST_PROPS_XML_ROOT = writextag('Properties', null, {
	'xmlns': XMLNS.CUST_PROPS,
	'xmlns:vt': XMLNS.vt
});

function write_cust_props(cp/*::, opts*/)/*:string*/ {
	var o = [XML_HEADER, CUST_PROPS_XML_ROOT];
	if(!cp) return o.join("");
	var pid = 1;
	keys$1(cp).forEach(function custprop(k) { ++pid;
		o[o.length] = (writextag('property', write_vt(cp[k], true), {
			'fmtid': '{D5CDD505-2E9C-101B-9397-08002B2CF9AE}',
			'pid': pid,
			'name': escapexml(k)
		}));
	});
	if(o.length>2){ o[o.length] = '</Properties>'; o[1]=o[1].replace("/>",">"); }
	return o.join("");
}
/* Common Name -> XLML Name */
var XLMLDocPropsMap = {
	Title: 'Title',
	Subject: 'Subject',
	Author: 'Author',
	Keywords: 'Keywords',
	Comments: 'Description',
	LastAuthor: 'LastAuthor',
	RevNumber: 'Revision',
	Application: 'AppName',
	/* TotalTime: 'TotalTime', */
	LastPrinted: 'LastPrinted',
	CreatedDate: 'Created',
	ModifiedDate: 'LastSaved',
	/* Pages */
	/* Words */
	/* Characters */
	Category: 'Category',
	/* PresentationFormat */
	Manager: 'Manager',
	Company: 'Company',
	/* Guid */
	/* HyperlinkBase */
	/* Bytes */
	/* Lines */
	/* Paragraphs */
	/* CharactersWithSpaces */
	AppVersion: 'Version',

	ContentStatus: 'ContentStatus', /* NOTE: missing from schema */
	Identifier: 'Identifier', /* NOTE: missing from schema */
	Language: 'Language' /* NOTE: missing from schema */
};
var evert_XLMLDPM = evert(XLMLDocPropsMap);

function xlml_set_prop(Props, tag/*:string*/, val) {
	tag = evert_XLMLDPM[tag] || tag;
	Props[tag] = val;
}

function xlml_write_docprops(Props, opts) {
	var o/*:Array<string>*/ = [];
	keys$1(XLMLDocPropsMap).map(function(m) {
		for(var i = 0; i < CORE_PROPS.length; ++i) if(CORE_PROPS[i][1] == m) return CORE_PROPS[i];
		for(i = 0; i < EXT_PROPS.length; ++i) if(EXT_PROPS[i][1] == m) return EXT_PROPS[i];
		throw m;
	}).forEach(function(p) {
		if(Props[p[1]] == null) return;
		var m = opts && opts.Props && opts.Props[p[1]] != null ? opts.Props[p[1]] : Props[p[1]];
		switch(p[2]) {
			case 'date': m = new Date(m).toISOString().replace(/\.\d*Z/,"Z"); break;
		}
		if(typeof m == 'number') m = String(m);
		else if(m === true || m === false) { m = m ? "1" : "0"; }
		else if(m instanceof Date) m = new Date(m).toISOString().replace(/\.\d*Z/,"");
		o.push(writetag(XLMLDocPropsMap[p[1]] || p[1], m));
	});
	return writextag('DocumentProperties', o.join(""), {xmlns:XLMLNS.o });
}
function xlml_write_custprops(Props, Custprops/*::, opts*/) {
	var BLACKLIST = ["Worksheets","SheetNames"];
	var T = 'CustomDocumentProperties';
	var o/*:Array<string>*/ = [];
	if(Props) keys$1(Props).forEach(function(k) {
		/*:: if(!Props) return; */
		if(!Object.prototype.hasOwnProperty.call(Props, k)) return;
		for(var i = 0; i < CORE_PROPS.length; ++i) if(k == CORE_PROPS[i][1]) return;
		for(i = 0; i < EXT_PROPS.length; ++i) if(k == EXT_PROPS[i][1]) return;
		for(i = 0; i < BLACKLIST.length; ++i) if(k == BLACKLIST[i]) return;

		var m = Props[k];
		var t = "string";
		if(typeof m == 'number') { t = "float"; m = String(m); }
		else if(m === true || m === false) { t = "boolean"; m = m ? "1" : "0"; }
		else m = String(m);
		o.push(writextag(escapexmltag(k), m, {"dt:dt":t}));
	});
	if(Custprops) keys$1(Custprops).forEach(function(k) {
		/*:: if(!Custprops) return; */
		if(!Object.prototype.hasOwnProperty.call(Custprops, k)) return;
		if(Props && Object.prototype.hasOwnProperty.call(Props, k)) return;
		var m = Custprops[k];
		var t = "string";
		if(typeof m == 'number') { t = "float"; m = String(m); }
		else if(m === true || m === false) { t = "boolean"; m = m ? "1" : "0"; }
		else if(m instanceof Date) { t = "dateTime.tz"; m = m.toISOString(); }
		else m = String(m);
		o.push(writextag(escapexmltag(k), m, {"dt:dt":t}));
	});
	return '<' + T + ' xmlns="' + XLMLNS.o + '">' + o.join("") + '</' + T + '>';
}
/* [MS-DTYP] 2.3.3 FILETIME */
/* [MS-OLEDS] 2.1.3 FILETIME (Packet Version) */
/* [MS-OLEPS] 2.8 FILETIME (Packet Version) */
function parse_FILETIME(blob) {
	var dwLowDateTime = blob.read_shift(4), dwHighDateTime = blob.read_shift(4);
	return new Date(((dwHighDateTime/1e7*Math.pow(2,32) + dwLowDateTime/1e7) - 11644473600)*1000).toISOString().replace(/\.000/,"");
}
function write_FILETIME(time/*:string|Date*/) {
	var date = (typeof time == "string") ? new Date(Date.parse(time)) : time;
	var t = date.getTime() / 1000 + 11644473600;
	var l = t % Math.pow(2,32), h = (t - l) / Math.pow(2,32);
	l *= 1e7; h *= 1e7;
	var w = (l / Math.pow(2,32)) | 0;
	if(w > 0) { l = l % Math.pow(2,32); h += w; }
	var o = new_buf(8); o.write_shift(4, l); o.write_shift(4, h); return o;
}

/* [MS-OSHARED] 2.3.3.1.4 Lpstr */
function parse_lpstr(blob, type, pad/*:?number*/) {
	var start = blob.l;
	var str = blob.read_shift(0, 'lpstr-cp');
	if(pad) while((blob.l - start) & 3) ++blob.l;
	return str;
}

/* [MS-OSHARED] 2.3.3.1.6 Lpwstr */
function parse_lpwstr(blob, type, pad) {
	var str = blob.read_shift(0, 'lpwstr');
	if(pad) blob.l += (4 - ((str.length+1) & 3)) & 3;
	return str;
}


/* [MS-OSHARED] 2.3.3.1.11 VtString */
/* [MS-OSHARED] 2.3.3.1.12 VtUnalignedString */
function parse_VtStringBase(blob, stringType, pad) {
	if(stringType === 0x1F /*VT_LPWSTR*/) return parse_lpwstr(blob);
	return parse_lpstr(blob, stringType, pad);
}

function parse_VtString(blob, t/*:number*/, pad/*:?boolean*/) { return parse_VtStringBase(blob, t, pad === false ? 0: 4); }
function parse_VtUnalignedString(blob, t/*:number*/) { if(!t) throw new Error("VtUnalignedString must have positive length"); return parse_VtStringBase(blob, t, 0); }

/* [MS-OSHARED] 2.3.3.1.7 VtVecLpwstrValue */
function parse_VtVecLpwstrValue(blob)/*:Array<string>*/ {
	var length = blob.read_shift(4);
	var ret/*:Array<string>*/ = [];
	for(var i = 0; i != length; ++i) {
		var start = blob.l;
		ret[i] = blob.read_shift(0, 'lpwstr').replace(chr0,'');
		if((blob.l - start) & 0x02) blob.l += 2;
	}
	return ret;
}

/* [MS-OSHARED] 2.3.3.1.9 VtVecUnalignedLpstrValue */
function parse_VtVecUnalignedLpstrValue(blob)/*:Array<string>*/ {
	var length = blob.read_shift(4);
	var ret/*:Array<string>*/ = [];
	for(var i = 0; i != length; ++i) ret[i] = blob.read_shift(0, 'lpstr-cp').replace(chr0,'');
	return ret;
}


/* [MS-OSHARED] 2.3.3.1.13 VtHeadingPair */
function parse_VtHeadingPair(blob) {
	var start = blob.l;
	var headingString = parse_TypedPropertyValue(blob, VT_USTR);
	if(blob[blob.l] == 0x00 && blob[blob.l+1] == 0x00 && ((blob.l - start) & 0x02)) blob.l += 2;
	var headerParts = parse_TypedPropertyValue(blob, VT_I4);
	return [headingString, headerParts];
}

/* [MS-OSHARED] 2.3.3.1.14 VtVecHeadingPairValue */
function parse_VtVecHeadingPairValue(blob) {
	var cElements = blob.read_shift(4);
	var out = [];
	for(var i = 0; i < cElements / 2; ++i) out.push(parse_VtHeadingPair(blob));
	return out;
}

/* [MS-OLEPS] 2.18.1 Dictionary (uses 2.17, 2.16) */
function parse_dictionary(blob,CodePage) {
	var cnt = blob.read_shift(4);
	var dict/*:{[number]:string}*/ = ({}/*:any*/);
	for(var j = 0; j != cnt; ++j) {
		var pid = blob.read_shift(4);
		var len = blob.read_shift(4);
		dict[pid] = blob.read_shift(len, (CodePage === 0x4B0 ?'utf16le':'utf8')).replace(chr0,'').replace(chr1,'!');
		if(CodePage === 0x4B0 && (len % 2)) blob.l += 2;
	}
	if(blob.l & 3) blob.l = (blob.l>>2+1)<<2;
	return dict;
}

/* [MS-OLEPS] 2.9 BLOB */
function parse_BLOB(blob) {
	var size = blob.read_shift(4);
	var bytes = blob.slice(blob.l,blob.l+size);
	blob.l += size;
	if((size & 3) > 0) blob.l += (4 - (size & 3)) & 3;
	return bytes;
}

/* [MS-OLEPS] 2.11 ClipboardData */
function parse_ClipboardData(blob) {
	// TODO
	var o = {};
	o.Size = blob.read_shift(4);
	//o.Format = blob.read_shift(4);
	blob.l += o.Size + 3 - (o.Size - 1) % 4;
	return o;
}

/* [MS-OLEPS] 2.15 TypedPropertyValue */
function parse_TypedPropertyValue(blob, type/*:number*/, _opts)/*:any*/ {
	var t = blob.read_shift(2), ret, opts = _opts||{};
	blob.l += 2;
	if(type !== VT_VARIANT)
	if(t !== type && VT_CUSTOM.indexOf(type)===-1 && !((type & 0xFFFE) == 0x101E && (t & 0xFFFE) == 0x101E)) throw new Error('Expected type ' + type + ' saw ' + t);
	switch(type === VT_VARIANT ? t : type) {
		case 0x02 /*VT_I2*/: ret = blob.read_shift(2, 'i'); if(!opts.raw) blob.l += 2; return ret;
		case 0x03 /*VT_I4*/: ret = blob.read_shift(4, 'i'); return ret;
		case 0x0B /*VT_BOOL*/: return blob.read_shift(4) !== 0x0;
		case 0x13 /*VT_UI4*/: ret = blob.read_shift(4); return ret;
		case 0x1E /*VT_LPSTR*/: return parse_lpstr(blob, t, 4).replace(chr0,'');
		case 0x1F /*VT_LPWSTR*/: return parse_lpwstr(blob);
		case 0x40 /*VT_FILETIME*/: return parse_FILETIME(blob);
		case 0x41 /*VT_BLOB*/: return parse_BLOB(blob);
		case 0x47 /*VT_CF*/: return parse_ClipboardData(blob);
		case 0x50 /*VT_STRING*/: return parse_VtString(blob, t, !opts.raw).replace(chr0,'');
		case 0x51 /*VT_USTR*/: return parse_VtUnalignedString(blob, t/*, 4*/).replace(chr0,'');
		case 0x100C /*VT_VECTOR|VT_VARIANT*/: return parse_VtVecHeadingPairValue(blob);
		case 0x101E /*VT_VECTOR|VT_LPSTR*/:
		case 0x101F /*VT_VECTOR|VT_LPWSTR*/:
			return t == 0x101F ? parse_VtVecLpwstrValue(blob) : parse_VtVecUnalignedLpstrValue(blob);
		default: throw new Error("TypedPropertyValue unrecognized type " + type + " " + t);
	}
}
function write_TypedPropertyValue(type/*:number*/, value) {
	var o = new_buf(4), p = new_buf(4);
	o.write_shift(4, type == 0x50 ? 0x1F : type);
	switch(type) {
		case 0x03 /*VT_I4*/: p.write_shift(-4, value); break;
		case 0x05 /*VT_I4*/: p = new_buf(8); p.write_shift(8, value, 'f'); break;
		case 0x0B /*VT_BOOL*/: p.write_shift(4, value ? 0x01 : 0x00); break;
		case 0x40 /*VT_FILETIME*/: /*:: if(typeof value !== "string" && !(value instanceof Date)) throw "unreachable"; */ p = write_FILETIME(value); break;
		case 0x1F /*VT_LPWSTR*/:
		case 0x50 /*VT_STRING*/:
			/*:: if(typeof value !== "string") throw "unreachable"; */
			p = new_buf(4 + 2 * (value.length + 1) + (value.length % 2 ? 0 : 2));
			p.write_shift(4, value.length + 1);
			p.write_shift(0, value, "dbcs");
			while(p.l != p.length) p.write_shift(1, 0);
			break;
		default: throw new Error("TypedPropertyValue unrecognized type " + type + " " + value);
	}
	return bconcat([o, p]);
}

/* [MS-OLEPS] 2.20 PropertySet */
function parse_PropertySet(blob, PIDSI) {
	var start_addr = blob.l;
	var size = blob.read_shift(4);
	var NumProps = blob.read_shift(4);
	var Props = [], i = 0;
	var CodePage = 0;
	var Dictionary = -1, DictObj/*:{[number]:string}*/ = ({}/*:any*/);
	for(i = 0; i != NumProps; ++i) {
		var PropID = blob.read_shift(4);
		var Offset = blob.read_shift(4);
		Props[i] = [PropID, Offset + start_addr];
	}
	Props.sort(function(x,y) { return x[1] - y[1]; });
	var PropH = {};
	for(i = 0; i != NumProps; ++i) {
		if(blob.l !== Props[i][1]) {
			var fail = true;
			if(i>0 && PIDSI) switch(PIDSI[Props[i-1][0]].t) {
				case 0x02 /*VT_I2*/: if(blob.l+2 === Props[i][1]) { blob.l+=2; fail = false; } break;
				case 0x50 /*VT_STRING*/: if(blob.l <= Props[i][1]) { blob.l=Props[i][1]; fail = false; } break;
				case 0x100C /*VT_VECTOR|VT_VARIANT*/: if(blob.l <= Props[i][1]) { blob.l=Props[i][1]; fail = false; } break;
			}
			if((!PIDSI||i==0) && blob.l <= Props[i][1]) { fail=false; blob.l = Props[i][1]; }
			if(fail) throw new Error("Read Error: Expected address " + Props[i][1] + ' at ' + blob.l + ' :' + i);
		}
		if(PIDSI) {
			var piddsi = PIDSI[Props[i][0]];
			PropH[piddsi.n] = parse_TypedPropertyValue(blob, piddsi.t, {raw:true});
			if(piddsi.p === 'version') PropH[piddsi.n] = String(PropH[piddsi.n] >> 16) + "." + ("0000" + String(PropH[piddsi.n] & 0xFFFF)).slice(-4);
			if(piddsi.n == "CodePage") switch(PropH[piddsi.n]) {
				case 0: PropH[piddsi.n] = 1252;
					/* falls through */
				case 874:
				case 932:
				case 936:
				case 949:
				case 950:
				case 1250:
				case 1251:
				case 1253:
				case 1254:
				case 1255:
				case 1256:
				case 1257:
				case 1258:
				case 10000:
				case 1200:
				case 1201:
				case 1252:
				case 65000: case -536:
				case 65001: case -535:
					set_cp(CodePage = (PropH[piddsi.n]>>>0) & 0xFFFF); break;
				default: throw new Error("Unsupported CodePage: " + PropH[piddsi.n]);
			}
		} else {
			if(Props[i][0] === 0x1) {
				CodePage = PropH.CodePage = (parse_TypedPropertyValue(blob, VT_I2)/*:number*/);
				set_cp(CodePage);
				if(Dictionary !== -1) {
					var oldpos = blob.l;
					blob.l = Props[Dictionary][1];
					DictObj = parse_dictionary(blob,CodePage);
					blob.l = oldpos;
				}
			} else if(Props[i][0] === 0) {
				if(CodePage === 0) { Dictionary = i; blob.l = Props[i+1][1]; continue; }
				DictObj = parse_dictionary(blob,CodePage);
			} else {
				var name = DictObj[Props[i][0]];
				var val;
				/* [MS-OSHARED] 2.3.3.2.3.1.2 + PROPVARIANT */
				switch(blob[blob.l]) {
					case 0x41 /*VT_BLOB*/: blob.l += 4; val = parse_BLOB(blob); break;
					case 0x1E /*VT_LPSTR*/: blob.l += 4; val = parse_VtString(blob, blob[blob.l-4]).replace(/\u0000+$/,""); break;
					case 0x1F /*VT_LPWSTR*/: blob.l += 4; val = parse_VtString(blob, blob[blob.l-4]).replace(/\u0000+$/,""); break;
					case 0x03 /*VT_I4*/: blob.l += 4; val = blob.read_shift(4, 'i'); break;
					case 0x13 /*VT_UI4*/: blob.l += 4; val = blob.read_shift(4); break;
					case 0x05 /*VT_R8*/: blob.l += 4; val = blob.read_shift(8, 'f'); break;
					case 0x0B /*VT_BOOL*/: blob.l += 4; val = parsebool(blob, 4); break;
					case 0x40 /*VT_FILETIME*/: blob.l += 4; val = parseDate(parse_FILETIME(blob)); break;
					default: throw new Error("unparsed value: " + blob[blob.l]);
				}
				PropH[name] = val;
			}
		}
	}
	blob.l = start_addr + size; /* step ahead to skip padding */
	return PropH;
}
var XLSPSSkip = [ "CodePage", "Thumbnail", "_PID_LINKBASE", "_PID_HLINKS", "SystemIdentifier", "FMTID" ].concat(PseudoPropsPairs);
function guess_property_type(val/*:any*/)/*:number*/ {
	switch(typeof val) {
		case "boolean": return 0x0B;
		case "number": return ((val|0)==val) ? 0x03 : 0x05;
		case "string": return 0x1F;
		case "object": if(val instanceof Date) return 0x40; break;
	}
	return -1;
}
function write_PropertySet(entries, RE, PIDSI) {
	var hdr = new_buf(8), piao = [], prop = [];
	var sz = 8, i = 0;

	var pr = new_buf(8), pio = new_buf(8);
	pr.write_shift(4, 0x0002);
	pr.write_shift(4, 0x04B0);
	pio.write_shift(4, 0x0001);
	prop.push(pr); piao.push(pio);
	sz += 8 + pr.length;

	if(!RE) {
		pio = new_buf(8);
		pio.write_shift(4, 0);
		piao.unshift(pio);

		var bufs = [new_buf(4)];
		bufs[0].write_shift(4, entries.length);
		for(i = 0; i < entries.length; ++i) {
			var value = entries[i][0];
			pr = new_buf(4 + 4 + 2 * (value.length + 1) + (value.length % 2 ? 0 : 2));
			pr.write_shift(4, i+2);
			pr.write_shift(4, value.length + 1);
			pr.write_shift(0, value, "dbcs");
			while(pr.l != pr.length) pr.write_shift(1, 0);
			bufs.push(pr);
		}
		pr = bconcat(bufs);
		prop.unshift(pr);
		sz += 8 + pr.length;
	}

	for(i = 0; i < entries.length; ++i) {
		if(RE && !RE[entries[i][0]]) continue;
		if(XLSPSSkip.indexOf(entries[i][0]) > -1) continue;
		if(entries[i][1] == null) continue;

		var val = entries[i][1], idx = 0;
		if(RE) {
			idx = +RE[entries[i][0]];
			var pinfo = (PIDSI/*:: || {}*/)[idx]/*:: || {} */;
			if(pinfo.p == "version" && typeof val == "string") {
				/*:: if(typeof val !== "string") throw "unreachable"; */
				var arr = val.split(".");
				val = ((+arr[0])<<16) + ((+arr[1])||0);
			}
			pr = write_TypedPropertyValue(pinfo.t, val);
		} else {
			var T = guess_property_type(val);
			if(T == -1) { T = 0x1F; val = String(val); }
			pr = write_TypedPropertyValue(T, val);
		}
		prop.push(pr);

		pio = new_buf(8);
		pio.write_shift(4, !RE ? 2+i : idx);
		piao.push(pio);

		sz += 8 + pr.length;
	}

	var w = 8 * (prop.length + 1);
	for(i = 0; i < prop.length; ++i) { piao[i].write_shift(4, w); w += prop[i].length; }
	hdr.write_shift(4, sz);
	hdr.write_shift(4, prop.length);
	return bconcat([hdr].concat(piao).concat(prop));
}

/* [MS-OLEPS] 2.21 PropertySetStream */
function parse_PropertySetStream(file, PIDSI, clsid) {
	var blob = file.content;
	if(!blob) return ({}/*:any*/);
	prep_blob(blob, 0);

	var NumSets, FMTID0, FMTID1, Offset0, Offset1 = 0;
	blob.chk('feff', 'Byte Order: ');

	/*var vers = */blob.read_shift(2); // TODO: check version
	var SystemIdentifier = blob.read_shift(4);
	var CLSID = blob.read_shift(16);
	if(CLSID !== CFB.utils.consts.HEADER_CLSID && CLSID !== clsid) throw new Error("Bad PropertySet CLSID " + CLSID);
	NumSets = blob.read_shift(4);
	if(NumSets !== 1 && NumSets !== 2) throw new Error("Unrecognized #Sets: " + NumSets);
	FMTID0 = blob.read_shift(16); Offset0 = blob.read_shift(4);

	if(NumSets === 1 && Offset0 !== blob.l) throw new Error("Length mismatch: " + Offset0 + " !== " + blob.l);
	else if(NumSets === 2) { FMTID1 = blob.read_shift(16); Offset1 = blob.read_shift(4); }
	var PSet0 = parse_PropertySet(blob, PIDSI);

	var rval = ({ SystemIdentifier: SystemIdentifier }/*:any*/);
	for(var y in PSet0) rval[y] = PSet0[y];
	//rval.blob = blob;
	rval.FMTID = FMTID0;
	//rval.PSet0 = PSet0;
	if(NumSets === 1) return rval;
	if(Offset1 - blob.l == 2) blob.l += 2;
	if(blob.l !== Offset1) throw new Error("Length mismatch 2: " + blob.l + " !== " + Offset1);
	var PSet1;
	try { PSet1 = parse_PropertySet(blob, null); } catch(e) {/* empty */}
	for(y in PSet1) rval[y] = PSet1[y];
	rval.FMTID = [FMTID0, FMTID1]; // TODO: verify FMTID0/1
	return rval;
}
function write_PropertySetStream(entries, clsid, RE, PIDSI/*:{[key:string|number]:any}*/, entries2/*:?any*/, clsid2/*:?any*/) {
	var hdr = new_buf(entries2 ? 68 : 48);
	var bufs = [hdr];
	hdr.write_shift(2, 0xFFFE);
	hdr.write_shift(2, 0x0000); /* TODO: type 1 props */
	hdr.write_shift(4, 0x32363237);
	hdr.write_shift(16, CFB.utils.consts.HEADER_CLSID, "hex");
	hdr.write_shift(4, (entries2 ? 2 : 1));
	hdr.write_shift(16, clsid, "hex");
	hdr.write_shift(4, (entries2 ? 68 : 48));
	var ps0 = write_PropertySet(entries, RE, PIDSI);
	bufs.push(ps0);

	if(entries2) {
		var ps1 = write_PropertySet(entries2, null, null);
		hdr.write_shift(16, clsid2, "hex");
		hdr.write_shift(4, 68 + ps0.length);
		bufs.push(ps1);
	}
	return bconcat(bufs);
}

function parsenoop2(blob, length) { blob.read_shift(length); return null; }
function writezeroes(n, o) { if(!o) o=new_buf(n); for(var j=0; j<n; ++j) o.write_shift(1, 0); return o; }

function parslurp(blob, length, cb) {
	var arr = [], target = blob.l + length;
	while(blob.l < target) arr.push(cb(blob, target - blob.l));
	if(target !== blob.l) throw new Error("Slurp error");
	return arr;
}

function parsebool(blob, length/*:number*/) { return blob.read_shift(length) === 0x1; }
function writebool(v/*:any*/, o) { if(!o) o=new_buf(2); o.write_shift(2, +!!v); return o; }

function parseuint16(blob/*::, length:?number, opts:?any*/) { return blob.read_shift(2, 'u'); }
function writeuint16(v/*:number*/, o) { if(!o) o=new_buf(2); o.write_shift(2, v); return o; }
function parseuint16a(blob, length/*:: :?number, opts:?any*/) { return parslurp(blob,length,parseuint16);}

/* --- 2.5 Structures --- */

/* [MS-XLS] 2.5.10 Bes (boolean or error) */
function parse_Bes(blob/*::, length*/) {
	var v = blob.read_shift(1), t = blob.read_shift(1);
	return t === 0x01 ? v : v === 0x01;
}
function write_Bes(v, t/*:string*/, o) {
	if(!o) o = new_buf(2);
	o.write_shift(1, ((t == 'e') ? +v : +!!v));
	o.write_shift(1, ((t == 'e') ? 1 : 0));
	return o;
}

/* [MS-XLS] 2.5.240 ShortXLUnicodeString */
function parse_ShortXLUnicodeString(blob, length, opts) {
	var cch = blob.read_shift(opts && opts.biff >= 12 ? 2 : 1);
	var encoding = 'sbcs-cont';
	var cp = current_codepage;
	if(opts && opts.biff >= 8) current_codepage = 1200;
	if(!opts || opts.biff == 8 ) {
		var fHighByte = blob.read_shift(1);
		if(fHighByte) { encoding = 'dbcs-cont'; }
	} else if(opts.biff == 12) {
		encoding = 'wstr';
	}
	if(opts.biff >= 2 && opts.biff <= 5) encoding = 'cpstr';
	var o = cch ? blob.read_shift(cch, encoding) : "";
	current_codepage = cp;
	return o;
}

/* 2.5.293 XLUnicodeRichExtendedString */
function parse_XLUnicodeRichExtendedString(blob) {
	var cp = current_codepage;
	current_codepage = 1200;
	var cch = blob.read_shift(2), flags = blob.read_shift(1);
	var /*fHighByte = flags & 0x1,*/ fExtSt = flags & 0x4, fRichSt = flags & 0x8;
	var width = 1 + (flags & 0x1); // 0x0 -> utf8, 0x1 -> dbcs
	var cRun = 0, cbExtRst;
	var z = {};
	if(fRichSt) cRun = blob.read_shift(2);
	if(fExtSt) cbExtRst = blob.read_shift(4);
	var encoding = width == 2 ? 'dbcs-cont' : 'sbcs-cont';
	var msg = cch === 0 ? "" : blob.read_shift(cch, encoding);
	if(fRichSt) blob.l += 4 * cRun; //TODO: parse this
	if(fExtSt) blob.l += cbExtRst; //TODO: parse this
	z.t = msg;
	if(!fRichSt) { z.raw = "<t>" + z.t + "</t>"; z.r = z.t; }
	current_codepage = cp;
	return z;
}
function write_XLUnicodeRichExtendedString(xlstr/*:: :XLString, opts*/) {
	var str = (xlstr.t||"");

	var hdr = new_buf(3 + ( 0));
	hdr.write_shift(2, str.length);
	hdr.write_shift(1, ( 0x00) | 0x01);

	var otext = new_buf(2 * str.length);
	otext.write_shift(2 * str.length, str, 'utf16le');

	var out = [hdr, otext];

	return bconcat(out);
}

/* 2.5.296 XLUnicodeStringNoCch */
function parse_XLUnicodeStringNoCch(blob, cch, opts) {
	var retval;
	if(opts) {
		if(opts.biff >= 2 && opts.biff <= 5) return blob.read_shift(cch, 'cpstr');
		if(opts.biff >= 12) return blob.read_shift(cch, 'dbcs-cont');
	}
	var fHighByte = blob.read_shift(1);
	if(fHighByte===0) { retval = blob.read_shift(cch, 'sbcs-cont'); }
	else { retval = blob.read_shift(cch, 'dbcs-cont'); }
	return retval;
}

/* 2.5.294 XLUnicodeString */
function parse_XLUnicodeString(blob, length, opts) {
	var cch = blob.read_shift(opts && opts.biff == 2 ? 1 : 2);
	if(cch === 0) { blob.l++; return ""; }
	return parse_XLUnicodeStringNoCch(blob, cch, opts);
}
/* BIFF5 override */
function parse_XLUnicodeString2(blob, length, opts) {
	if(opts.biff > 5) return parse_XLUnicodeString(blob, length, opts);
	var cch = blob.read_shift(1);
	if(cch === 0) { blob.l++; return ""; }
	return blob.read_shift(cch, (opts.biff <= 4 || !blob.lens ) ? 'cpstr' : 'sbcs-cont');
}
/* TODO: BIFF5 and lower, codepage awareness */
function write_XLUnicodeString(str, opts, o) {
	if(!o) o = new_buf(3 + 2 * str.length);
	o.write_shift(2, str.length);
	o.write_shift(1, 1);
	o.write_shift(31, str, 'utf16le');
	return o;
}

/* [MS-XLS] 2.5.61 ControlInfo */
function parse_ControlInfo(blob/*::, length, opts*/) {
	var flags = blob.read_shift(1);
	blob.l++;
	var accel = blob.read_shift(2);
	blob.l += 2;
	return [flags, accel];
}

/* [MS-OSHARED] 2.3.7.6 URLMoniker TODO: flags */
function parse_URLMoniker(blob/*::, length, opts*/) {
	var len = blob.read_shift(4), start = blob.l;
	var extra = false;
	if(len > 24) {
		/* look ahead */
		blob.l += len - 24;
		if(blob.read_shift(16) === "795881f43b1d7f48af2c825dc4852763") extra = true;
		blob.l = start;
	}
	var url = blob.read_shift((extra?len-24:len)>>1, 'utf16le').replace(chr0,"");
	if(extra) blob.l += 24;
	return url;
}

/* [MS-OSHARED] 2.3.7.8 FileMoniker TODO: all fields */
function parse_FileMoniker(blob/*::, length*/) {
	var cAnti = blob.read_shift(2);
	var preamble = ""; while(cAnti-- > 0) preamble += "../";
	var ansiPath = blob.read_shift(0, 'lpstr-ansi');
	blob.l += 2; //var endServer = blob.read_shift(2);
	if(blob.read_shift(2) != 0xDEAD) throw new Error("Bad FileMoniker");
	var sz = blob.read_shift(4);
	if(sz === 0) return preamble + ansiPath.replace(/\\/g,"/");
	var bytes = blob.read_shift(4);
	if(blob.read_shift(2) != 3) throw new Error("Bad FileMoniker");
	var unicodePath = blob.read_shift(bytes>>1, 'utf16le').replace(chr0,"");
	return preamble + unicodePath;
}

/* [MS-OSHARED] 2.3.7.2 HyperlinkMoniker TODO: all the monikers */
function parse_HyperlinkMoniker(blob, length) {
	var clsid = blob.read_shift(16);	switch(clsid) {
		case "e0c9ea79f9bace118c8200aa004ba90b": return parse_URLMoniker(blob);
		case "0303000000000000c000000000000046": return parse_FileMoniker(blob);
		default: throw new Error("Unsupported Moniker " + clsid);
	}
}

/* [MS-OSHARED] 2.3.7.9 HyperlinkString */
function parse_HyperlinkString(blob/*::, length*/) {
	var len = blob.read_shift(4);
	var o = len > 0 ? blob.read_shift(len, 'utf16le').replace(chr0, "") : "";
	return o;
}
function write_HyperlinkString(str/*:string*/, o) {
	if(!o) o = new_buf(6 + str.length * 2);
	o.write_shift(4, 1 + str.length);
	for(var i = 0; i < str.length; ++i) o.write_shift(2, str.charCodeAt(i));
	o.write_shift(2, 0);
	return o;
}

/* [MS-OSHARED] 2.3.7.1 Hyperlink Object */
function parse_Hyperlink(blob, length)/*:Hyperlink*/ {
	var end = blob.l + length;
	var sVer = blob.read_shift(4);
	if(sVer !== 2) throw new Error("Unrecognized streamVersion: " + sVer);
	var flags = blob.read_shift(2);
	blob.l += 2;
	var displayName, targetFrameName, moniker, oleMoniker, Loc="", guid, fileTime;
	if(flags & 0x0010) displayName = parse_HyperlinkString(blob, end - blob.l);
	if(flags & 0x0080) targetFrameName = parse_HyperlinkString(blob, end - blob.l);
	if((flags & 0x0101) === 0x0101) moniker = parse_HyperlinkString(blob, end - blob.l);
	if((flags & 0x0101) === 0x0001) oleMoniker = parse_HyperlinkMoniker(blob, end - blob.l);
	if(flags & 0x0008) Loc = parse_HyperlinkString(blob, end - blob.l);
	if(flags & 0x0020) guid = blob.read_shift(16);
	if(flags & 0x0040) fileTime = parse_FILETIME(blob/*, 8*/);
	blob.l = end;
	var target = targetFrameName||moniker||oleMoniker||"";
	if(target && Loc) target+="#"+Loc;
	if(!target) target = "#" + Loc;
	if((flags & 0x0002) && target.charAt(0) == "/" && target.charAt(1) != "/") target = "file://" + target;
	var out = ({Target:target}/*:any*/);
	if(guid) out.guid = guid;
	if(fileTime) out.time = fileTime;
	if(displayName) out.Tooltip = displayName;
	return out;
}
function write_Hyperlink(hl) {
	var out = new_buf(512), i = 0;
	var Target = hl.Target;
	if(Target.slice(0,7) == "file://") Target = Target.slice(7);
	var hashidx = Target.indexOf("#");
	var F = hashidx > -1 ? 0x1f : 0x17;
	switch(Target.charAt(0)) { case "#": F=0x1c; break; case ".": F&=~2; break; }
	out.write_shift(4,2); out.write_shift(4, F);
	var data = [8,6815827,6619237,4849780,83]; for(i = 0; i < data.length; ++i) out.write_shift(4, data[i]);
	if(F == 0x1C) {
		Target = Target.slice(1);
		write_HyperlinkString(Target, out);
	} else if(F & 0x02) {
		data = "e0 c9 ea 79 f9 ba ce 11 8c 82 00 aa 00 4b a9 0b".split(" ");
		for(i = 0; i < data.length; ++i) out.write_shift(1, parseInt(data[i], 16));
		var Pretarget = hashidx > -1 ? Target.slice(0, hashidx) : Target;
		out.write_shift(4, 2*(Pretarget.length + 1));
		for(i = 0; i < Pretarget.length; ++i) out.write_shift(2, Pretarget.charCodeAt(i));
		out.write_shift(2, 0);
		if(F & 0x08) write_HyperlinkString(hashidx > -1 ? Target.slice(hashidx+1): "", out);
	} else {
		data = "03 03 00 00 00 00 00 00 c0 00 00 00 00 00 00 46".split(" ");
		for(i = 0; i < data.length; ++i) out.write_shift(1, parseInt(data[i], 16));
		var P = 0;
		while(Target.slice(P*3,P*3+3)=="../"||Target.slice(P*3,P*3+3)=="..\\") ++P;
		out.write_shift(2, P);
		out.write_shift(4, Target.length - 3 * P + 1);
		for(i = 0; i < Target.length - 3 * P; ++i) out.write_shift(1, Target.charCodeAt(i + 3 * P) & 0xFF);
		out.write_shift(1, 0);
		out.write_shift(2, 0xFFFF);
		out.write_shift(2, 0xDEAD);
		for(i = 0; i < 6; ++i) out.write_shift(4, 0);
	}
	return out.slice(0, out.l);
}

/* 2.5.178 LongRGBA */
function parse_LongRGBA(blob/*::, length*/) { var r = blob.read_shift(1), g = blob.read_shift(1), b = blob.read_shift(1), a = blob.read_shift(1); return [r,g,b,a]; }

/* 2.5.177 LongRGB */
function parse_LongRGB(blob, length) { var x = parse_LongRGBA(blob); x[3] = 0; return x; }


/* [MS-XLS] 2.5.19 */
function parse_XLSCell(blob/*::, length*/)/*:Cell*/ {
	var rw = blob.read_shift(2); // 0-indexed
	var col = blob.read_shift(2);
	var ixfe = blob.read_shift(2);
	return ({r:rw, c:col, ixfe:ixfe}/*:any*/);
}
function write_XLSCell(R/*:number*/, C/*:number*/, ixfe/*:?number*/, o) {
	if(!o) o = new_buf(6);
	o.write_shift(2, R);
	o.write_shift(2, C);
	o.write_shift(2, ixfe||0);
	return o;
}

/* [MS-XLS] 2.5.134 */
function parse_frtHeader(blob) {
	var rt = blob.read_shift(2);
	var flags = blob.read_shift(2); // TODO: parse these flags
	blob.l += 8;
	return {type: rt, flags: flags};
}



function parse_OptXLUnicodeString(blob, length, opts) { return length === 0 ? "" : parse_XLUnicodeString2(blob, length, opts); }

/* [MS-XLS] 2.5.344 */
function parse_XTI(blob, length, opts) {
	var w = opts.biff > 8 ? 4 : 2;
	var iSupBook = blob.read_shift(w), itabFirst = blob.read_shift(w,'i'), itabLast = blob.read_shift(w,'i');
	return [iSupBook, itabFirst, itabLast];
}

/* [MS-XLS] 2.5.218 */
function parse_RkRec(blob) {
	var ixfe = blob.read_shift(2);
	var RK = parse_RkNumber(blob);
	return [ixfe, RK];
}

/* [MS-XLS] 2.5.1 */
function parse_AddinUdf(blob, length, opts) {
	blob.l += 4; length -= 4;
	var l = blob.l + length;
	var udfName = parse_ShortXLUnicodeString(blob, length, opts);
	var cb = blob.read_shift(2);
	l -= blob.l;
	if(cb !== l) throw new Error("Malformed AddinUdf: padding = " + l + " != " + cb);
	blob.l += cb;
	return udfName;
}

/* [MS-XLS] 2.5.209 TODO: Check sizes */
function parse_Ref8U(blob/*::, length*/) {
	var rwFirst = blob.read_shift(2);
	var rwLast = blob.read_shift(2);
	var colFirst = blob.read_shift(2);
	var colLast = blob.read_shift(2);
	return {s:{c:colFirst, r:rwFirst}, e:{c:colLast,r:rwLast}};
}
function write_Ref8U(r/*:Range*/, o) {
	if(!o) o = new_buf(8);
	o.write_shift(2, r.s.r);
	o.write_shift(2, r.e.r);
	o.write_shift(2, r.s.c);
	o.write_shift(2, r.e.c);
	return o;
}

/* [MS-XLS] 2.5.211 */
function parse_RefU(blob/*::, length*/) {
	var rwFirst = blob.read_shift(2);
	var rwLast = blob.read_shift(2);
	var colFirst = blob.read_shift(1);
	var colLast = blob.read_shift(1);
	return {s:{c:colFirst, r:rwFirst}, e:{c:colLast,r:rwLast}};
}

/* [MS-XLS] 2.5.207 */
var parse_Ref = parse_RefU;

/* [MS-XLS] 2.5.143 */
function parse_FtCmo(blob/*::, length*/) {
	blob.l += 4;
	var ot = blob.read_shift(2);
	var id = blob.read_shift(2);
	var flags = blob.read_shift(2);
	blob.l+=12;
	return [id, ot, flags];
}

/* [MS-XLS] 2.5.149 */
function parse_FtNts(blob) {
	var out = {};
	blob.l += 4;
	blob.l += 16; // GUID TODO
	out.fSharedNote = blob.read_shift(2);
	blob.l += 4;
	return out;
}

/* [MS-XLS] 2.5.142 */
function parse_FtCf(blob) {
	var out = {};
	blob.l += 4;
	blob.cf = blob.read_shift(2);
	return out;
}

/* [MS-XLS] 2.5.140 - 2.5.154 and friends */
function parse_FtSkip(blob) { blob.l += 2; blob.l += blob.read_shift(2); }
var FtTab = {
	/*::[*/0x00/*::]*/: parse_FtSkip,      /* FtEnd */
	/*::[*/0x04/*::]*/: parse_FtSkip,      /* FtMacro */
	/*::[*/0x05/*::]*/: parse_FtSkip,      /* FtButton */
	/*::[*/0x06/*::]*/: parse_FtSkip,      /* FtGmo */
	/*::[*/0x07/*::]*/: parse_FtCf,        /* FtCf */
	/*::[*/0x08/*::]*/: parse_FtSkip,      /* FtPioGrbit */
	/*::[*/0x09/*::]*/: parse_FtSkip,      /* FtPictFmla */
	/*::[*/0x0A/*::]*/: parse_FtSkip,      /* FtCbls */
	/*::[*/0x0B/*::]*/: parse_FtSkip,      /* FtRbo */
	/*::[*/0x0C/*::]*/: parse_FtSkip,      /* FtSbs */
	/*::[*/0x0D/*::]*/: parse_FtNts,       /* FtNts */
	/*::[*/0x0E/*::]*/: parse_FtSkip,      /* FtSbsFmla */
	/*::[*/0x0F/*::]*/: parse_FtSkip,      /* FtGboData */
	/*::[*/0x10/*::]*/: parse_FtSkip,      /* FtEdoData */
	/*::[*/0x11/*::]*/: parse_FtSkip,      /* FtRboData */
	/*::[*/0x12/*::]*/: parse_FtSkip,      /* FtCblsData */
	/*::[*/0x13/*::]*/: parse_FtSkip,      /* FtLbsData */
	/*::[*/0x14/*::]*/: parse_FtSkip,      /* FtCblsFmla */
	/*::[*/0x15/*::]*/: parse_FtCmo
};
function parse_FtArray(blob, length/*::, ot*/) {
	var tgt = blob.l + length;
	var fts = [];
	while(blob.l < tgt) {
		var ft = blob.read_shift(2);
		blob.l-=2;
		try {
			fts.push(FtTab[ft](blob, tgt - blob.l));
		} catch(e) { blob.l = tgt; return fts; }
	}
	if(blob.l != tgt) blob.l = tgt; //throw new Error("bad Object Ft-sequence");
	return fts;
}

/* --- 2.4 Records --- */

/* [MS-XLS] 2.4.21 */
function parse_BOF(blob, length) {
	var o = {BIFFVer:0, dt:0};
	o.BIFFVer = blob.read_shift(2); length -= 2;
	if(length >= 2) { o.dt = blob.read_shift(2); blob.l -= 2; }
	switch(o.BIFFVer) {
		case 0x0600: /* BIFF8 */
		case 0x0500: /* BIFF5 */
		case 0x0400: /* BIFF4 */
		case 0x0300: /* BIFF3 */
		case 0x0200: /* BIFF2 */
		case 0x0002: case 0x0007: /* BIFF2 */
			break;
		default: if(length > 6) throw new Error("Unexpected BIFF Ver " + o.BIFFVer);
	}

	blob.read_shift(length);
	return o;
}
function write_BOF(wb/*:Workbook*/, t/*:number*/, o) {
	var h = 0x0600, w = 16;
	switch(o.bookType) {
		case 'biff8': break;
		case 'biff5': h = 0x0500; w = 8; break;
		case 'biff4': h = 0x0004; w = 6; break;
		case 'biff3': h = 0x0003; w = 6; break;
		case 'biff2': h = 0x0002; w = 4; break;
		case 'xla': break;
		default: throw new Error("unsupported BIFF version");
	}
	var out = new_buf(w);
	out.write_shift(2, h);
	out.write_shift(2, t);
	if(w > 4) out.write_shift(2, 0x7262);
	if(w > 6) out.write_shift(2, 0x07CD);
	if(w > 8) {
		out.write_shift(2, 0xC009);
		out.write_shift(2, 0x0001);
		out.write_shift(2, 0x0706);
		out.write_shift(2, 0x0000);
	}
	return out;
}


/* [MS-XLS] 2.4.146 */
function parse_InterfaceHdr(blob, length) {
	if(length === 0) return 0x04b0;
	if((blob.read_shift(2))!==0x04b0);
	return 0x04b0;
}


/* [MS-XLS] 2.4.349 */
function parse_WriteAccess(blob, length, opts) {
	if(opts.enc) { blob.l += length; return ""; }
	var l = blob.l;
	// TODO: make sure XLUnicodeString doesnt overrun
	var UserName = parse_XLUnicodeString2(blob, 0, opts);
	blob.read_shift(length + l - blob.l);
	return UserName;
}
function write_WriteAccess(s/*:string*/, opts) {
	var b8 = !opts || opts.biff == 8;
	var o = new_buf(b8 ? 112 : 54);
	o.write_shift(opts.biff == 8 ? 2 : 1, 7);
	if(b8) o.write_shift(1, 0);
	o.write_shift(4, 0x33336853);
	o.write_shift(4, (0x00534A74 | (b8 ? 0 : 0x20000000)));
	while(o.l < o.length) o.write_shift(1, (b8 ? 0 : 32));
	return o;
}

/* [MS-XLS] 2.4.351 */
function parse_WsBool(blob, length, opts) {
	var flags = opts && opts.biff == 8 || length == 2 ? blob.read_shift(2) : (blob.l += length, 0);
	return { fDialog: flags & 0x10, fBelow: flags & 0x40, fRight: flags & 0x80 };
}

/* [MS-XLS] 2.4.28 */
function parse_BoundSheet8(blob, length, opts) {
	var pos = blob.read_shift(4);
	var hidden = blob.read_shift(1) & 0x03;
	var dt = blob.read_shift(1);
	switch(dt) {
		case 0: dt = 'Worksheet'; break;
		case 1: dt = 'Macrosheet'; break;
		case 2: dt = 'Chartsheet'; break;
		case 6: dt = 'VBAModule'; break;
	}
	var name = parse_ShortXLUnicodeString(blob, 0, opts);
	if(name.length === 0) name = "Sheet1";
	return { pos:pos, hs:hidden, dt:dt, name:name };
}
function write_BoundSheet8(data, opts) {
	var w = (!opts || opts.biff >= 8 ? 2 : 1);
	var o = new_buf(8 + w * data.name.length);
	o.write_shift(4, data.pos);
	o.write_shift(1, data.hs || 0);
	o.write_shift(1, data.dt);
	o.write_shift(1, data.name.length);
	if(opts.biff >= 8) o.write_shift(1, 1);
	o.write_shift(w * data.name.length, data.name, opts.biff < 8 ? 'sbcs' : 'utf16le');
	var out = o.slice(0, o.l);
	out.l = o.l; return out;
}

/* [MS-XLS] 2.4.265 TODO */
function parse_SST(blob, length)/*:SST*/ {
	var end = blob.l + length;
	var cnt = blob.read_shift(4);
	var ucnt = blob.read_shift(4);
	var strs/*:SST*/ = ([]/*:any*/);
	for(var i = 0; i != ucnt && blob.l < end; ++i) {
		strs.push(parse_XLUnicodeRichExtendedString(blob));
	}
	strs.Count = cnt; strs.Unique = ucnt;
	return strs;
}
function write_SST(sst, opts) {
	var header = new_buf(8);
	header.write_shift(4, sst.Count);
	header.write_shift(4, sst.Unique);
	var strs = [];
	for(var j = 0; j < sst.length; ++j) strs[j] = write_XLUnicodeRichExtendedString(sst[j]);
	var o = bconcat([header].concat(strs));
	/*::(*/o/*:: :any)*/.parts = [header.length].concat(strs.map(function(str) { return str.length; }));
	return o;
}

/* [MS-XLS] 2.4.107 */
function parse_ExtSST(blob, length) {
	var extsst = {};
	extsst.dsst = blob.read_shift(2);
	blob.l += length-2;
	return extsst;
}


/* [MS-XLS] 2.4.221 TODO: check BIFF2-4 */
function parse_Row(blob) {
	var z = ({}/*:any*/);
	z.r = blob.read_shift(2);
	z.c = blob.read_shift(2);
	z.cnt = blob.read_shift(2) - z.c;
	var miyRw = blob.read_shift(2);
	blob.l += 4; // reserved(2), unused(2)
	var flags = blob.read_shift(1); // various flags
	blob.l += 3; // reserved(8), ixfe(12), flags(4)
	if(flags & 0x07) z.level = flags & 0x07;
	// collapsed: flags & 0x10
	if(flags & 0x20) z.hidden = true;
	if(flags & 0x40) z.hpt = miyRw / 20;
	return z;
}


/* [MS-XLS] 2.4.125 */
function parse_ForceFullCalculation(blob) {
	var header = parse_frtHeader(blob);
	if(header.type != 0x08A3) throw new Error("Invalid Future Record " + header.type);
	var fullcalc = blob.read_shift(4);
	return fullcalc !== 0x0;
}





/* [MS-XLS] 2.4.215 rt */
function parse_RecalcId(blob) {
	blob.read_shift(2);
	return blob.read_shift(4);
}

/* [MS-XLS] 2.4.87 */
function parse_DefaultRowHeight(blob, length, opts) {
	var f = 0;
	if(!(opts && opts.biff == 2)) {
		f = blob.read_shift(2);
	}
	var miyRw = blob.read_shift(2);
	if((opts && opts.biff == 2)) {
		f = 1 - (miyRw >> 15); miyRw &= 0x7fff;
	}
	var fl = {Unsynced:f&1,DyZero:(f&2)>>1,ExAsc:(f&4)>>2,ExDsc:(f&8)>>3};
	return [fl, miyRw];
}

/* [MS-XLS] 2.4.345 TODO */
function parse_Window1(blob) {
	var xWn = blob.read_shift(2), yWn = blob.read_shift(2), dxWn = blob.read_shift(2), dyWn = blob.read_shift(2);
	var flags = blob.read_shift(2), iTabCur = blob.read_shift(2), iTabFirst = blob.read_shift(2);
	var ctabSel = blob.read_shift(2), wTabRatio = blob.read_shift(2);
	return { Pos: [xWn, yWn], Dim: [dxWn, dyWn], Flags: flags, CurTab: iTabCur,
		FirstTab: iTabFirst, Selected: ctabSel, TabRatio: wTabRatio };
}
function write_Window1(/*::opts*/) {
	var o = new_buf(18);
	o.write_shift(2, 0);
	o.write_shift(2, 0);
	o.write_shift(2, 0x7260);
	o.write_shift(2, 0x44c0);
	o.write_shift(2, 0x38);
	o.write_shift(2, 0);
	o.write_shift(2, 0);
	o.write_shift(2, 1);
	o.write_shift(2, 0x01f4);
	return o;
}
/* [MS-XLS] 2.4.346 TODO */
function parse_Window2(blob, length, opts) {
	if(opts && opts.biff >= 2 && opts.biff < 5) return {};
	var f = blob.read_shift(2);
	return { RTL: f & 0x40 };
}
function write_Window2(view) {
	var o = new_buf(18), f = 0x6b6;
	if(view && view.RTL) f |= 0x40;
	o.write_shift(2, f);
	o.write_shift(4, 0);
	o.write_shift(4, 64);
	o.write_shift(4, 0);
	o.write_shift(4, 0);
	return o;
}

/* [MS-XLS] 2.4.189 TODO */
function parse_Pane(/*blob, length, opts*/) {
}

/* [MS-XLS] 2.4.122 TODO */
function parse_Font(blob, length, opts) {
	var o/*:any*/ = {
		dyHeight: blob.read_shift(2),
		fl: blob.read_shift(2)
	};
	switch((opts && opts.biff) || 8) {
		case 2: break;
		case 3: case 4: blob.l += 2; break;
		default: blob.l += 10; break;
	}
	o.name = parse_ShortXLUnicodeString(blob, 0, opts);
	return o;
}
function write_Font(data, opts) {
	var name = data.name || "Arial";
	var b5 = (opts && (opts.biff == 5)), w = (b5 ? (15 + name.length) : (16 + 2 * name.length));
	var o = new_buf(w);
	o.write_shift(2, (data.sz || 12) * 20);
	o.write_shift(4, 0);
	o.write_shift(2, 400);
	o.write_shift(4, 0);
	o.write_shift(2, 0);
	o.write_shift(1, name.length);
	if(!b5) o.write_shift(1, 1);
	o.write_shift((b5 ? 1 : 2) * name.length, name, (b5 ? "sbcs" : "utf16le"));
	return o;
}

/* [MS-XLS] 2.4.149 */
function parse_LabelSst(blob) {
	var cell = parse_XLSCell(blob);
	cell.isst = blob.read_shift(4);
	return cell;
}
function write_LabelSst(R/*:number*/, C/*:number*/, v/*:number*/, os/*:number*/ /*::, opts*/) {
	var o = new_buf(10);
	write_XLSCell(R, C, os, o);
	o.write_shift(4, v);
	return o;
}

/* [MS-XLS] 2.4.148 */
function parse_Label(blob, length, opts) {
	if(opts.biffguess && opts.biff == 2) opts.biff = 5;
	var target = blob.l + length;
	var cell = parse_XLSCell(blob);
	if(opts.biff == 2) blob.l++;
	var str = parse_XLUnicodeString(blob, target - blob.l, opts);
	cell.val = str;
	return cell;
}
function write_Label(R/*:number*/, C/*:number*/, v/*:string*/, os/*:number*/, opts) {
	var b8 = !opts || opts.biff == 8;
	var o = new_buf(6 + 2 + (+b8) + (1 + b8) * v.length);
	write_XLSCell(R, C, os, o);
	o.write_shift(2, v.length);
	if(b8) o.write_shift(1, 1);
	o.write_shift((1 + b8) * v.length, v, b8 ? 'utf16le' : 'sbcs');
	return o;
}


/* [MS-XLS] 2.4.126 Number Formats */
function parse_Format(blob, length, opts) {
	var numFmtId = blob.read_shift(2);
	var fmtstr = parse_XLUnicodeString2(blob, 0, opts);
	return [numFmtId, fmtstr];
}
function write_Format(i/*:number*/, f/*:string*/, opts, o) {
	var b5 = (opts && (opts.biff == 5));
	if(!o) o = new_buf(b5 ? (3 + f.length) : (5 + 2 * f.length));
	o.write_shift(2, i);
	o.write_shift((b5 ? 1 : 2), f.length);
	if(!b5) o.write_shift(1, 1);
	o.write_shift((b5 ? 1 : 2) * f.length, f, (b5 ? 'sbcs' : 'utf16le'));
	var out = (o.length > o.l) ? o.slice(0, o.l) : o;
	if(out.l == null) out.l = out.length;
	return out;
}
var parse_BIFF2Format = parse_XLUnicodeString2;

/* [MS-XLS] 2.4.90 */
function parse_Dimensions(blob, length, opts) {
	var end = blob.l + length;
	var w = opts.biff == 8 || !opts.biff ? 4 : 2;
	var r = blob.read_shift(w), R = blob.read_shift(w);
	var c = blob.read_shift(2), C = blob.read_shift(2);
	blob.l = end;
	return {s: {r:r, c:c}, e: {r:R, c:C}};
}
function write_Dimensions(range, opts) {
	var w = opts.biff == 8 || !opts.biff ? 4 : 2;
	var o = new_buf(2*w + 6);
	o.write_shift(w, range.s.r);
	o.write_shift(w, range.e.r + 1);
	o.write_shift(2, range.s.c);
	o.write_shift(2, range.e.c + 1);
	o.write_shift(2, 0);
	return o;
}

/* [MS-XLS] 2.4.220 */
function parse_RK(blob) {
	var rw = blob.read_shift(2), col = blob.read_shift(2);
	var rkrec = parse_RkRec(blob);
	return {r:rw, c:col, ixfe:rkrec[0], rknum:rkrec[1]};
}

/* [MS-XLS] 2.4.175 */
function parse_MulRk(blob, length) {
	var target = blob.l + length - 2;
	var rw = blob.read_shift(2), col = blob.read_shift(2);
	var rkrecs = [];
	while(blob.l < target) rkrecs.push(parse_RkRec(blob));
	if(blob.l !== target) throw new Error("MulRK read error");
	var lastcol = blob.read_shift(2);
	if(rkrecs.length != lastcol - col + 1) throw new Error("MulRK length mismatch");
	return {r:rw, c:col, C:lastcol, rkrec:rkrecs};
}
/* [MS-XLS] 2.4.174 */
function parse_MulBlank(blob, length) {
	var target = blob.l + length - 2;
	var rw = blob.read_shift(2), col = blob.read_shift(2);
	var ixfes = [];
	while(blob.l < target) ixfes.push(blob.read_shift(2));
	if(blob.l !== target) throw new Error("MulBlank read error");
	var lastcol = blob.read_shift(2);
	if(ixfes.length != lastcol - col + 1) throw new Error("MulBlank length mismatch");
	return {r:rw, c:col, C:lastcol, ixfe:ixfes};
}

/* [MS-XLS] 2.5.20 2.5.249 TODO: interpret values here */
function parse_CellStyleXF(blob, length, style, opts) {
	var o = {};
	var a = blob.read_shift(4), b = blob.read_shift(4);
	var c = blob.read_shift(4), d = blob.read_shift(2);
	o.patternType = XLSFillPattern[c >> 26];

	if(!opts.cellStyles) return o;
	o.alc = a & 0x07;
	o.fWrap = (a >> 3) & 0x01;
	o.alcV = (a >> 4) & 0x07;
	o.fJustLast = (a >> 7) & 0x01;
	o.trot = (a >> 8) & 0xFF;
	o.cIndent = (a >> 16) & 0x0F;
	o.fShrinkToFit = (a >> 20) & 0x01;
	o.iReadOrder = (a >> 22) & 0x02;
	o.fAtrNum = (a >> 26) & 0x01;
	o.fAtrFnt = (a >> 27) & 0x01;
	o.fAtrAlc = (a >> 28) & 0x01;
	o.fAtrBdr = (a >> 29) & 0x01;
	o.fAtrPat = (a >> 30) & 0x01;
	o.fAtrProt = (a >> 31) & 0x01;

	o.dgLeft = b & 0x0F;
	o.dgRight = (b >> 4) & 0x0F;
	o.dgTop = (b >> 8) & 0x0F;
	o.dgBottom = (b >> 12) & 0x0F;
	o.icvLeft = (b >> 16) & 0x7F;
	o.icvRight = (b >> 23) & 0x7F;
	o.grbitDiag = (b >> 30) & 0x03;

	o.icvTop = c & 0x7F;
	o.icvBottom = (c >> 7) & 0x7F;
	o.icvDiag = (c >> 14) & 0x7F;
	o.dgDiag = (c >> 21) & 0x0F;

	o.icvFore = d & 0x7F;
	o.icvBack = (d >> 7) & 0x7F;
	o.fsxButton = (d >> 14) & 0x01;
	return o;
}
//function parse_CellXF(blob, length, opts) {return parse_CellStyleXF(blob,length,0, opts);}
//function parse_StyleXF(blob, length, opts) {return parse_CellStyleXF(blob,length,1, opts);}

/* [MS-XLS] 2.4.353 TODO: actually do this right */
function parse_XF(blob, length, opts) {
	var o = {};
	o.ifnt = blob.read_shift(2); o.numFmtId = blob.read_shift(2); o.flags = blob.read_shift(2);
	o.fStyle = (o.flags >> 2) & 0x01;
	length -= 6;
	o.data = parse_CellStyleXF(blob, length, o.fStyle, opts);
	return o;
}
function write_XF(data, ixfeP, opts, o) {
	var b5 = (opts && (opts.biff == 5));
	if(!o) o = new_buf(b5 ? 16 : 20);
	o.write_shift(2, 0);
	if(data.style) {
		o.write_shift(2, (data.numFmtId||0));
		o.write_shift(2, 0xFFF4);
	} else {
		o.write_shift(2, (data.numFmtId||0));
		o.write_shift(2, (ixfeP<<4));
	}
	var f = 0;
	if(data.numFmtId > 0 && b5) f |= 0x0400;
	o.write_shift(4, f);
	o.write_shift(4, 0);
	if(!b5) o.write_shift(4, 0);
	o.write_shift(2, 0);
	return o;
}

/* [MS-XLS] 2.4.134 */
function parse_Guts(blob) {
	blob.l += 4;
	var out = [blob.read_shift(2), blob.read_shift(2)];
	if(out[0] !== 0) out[0]--;
	if(out[1] !== 0) out[1]--;
	if(out[0] > 7 || out[1] > 7) throw new Error("Bad Gutters: " + out.join("|"));
	return out;
}
function write_Guts(guts/*:Array<number>*/) {
	var o = new_buf(8);
	o.write_shift(4, 0);
	o.write_shift(2, guts[0] ? guts[0] + 1 : 0);
	o.write_shift(2, guts[1] ? guts[1] + 1 : 0);
	return o;
}

/* [MS-XLS] 2.4.24 */
function parse_BoolErr(blob, length, opts) {
	var cell = parse_XLSCell(blob);
	if(opts.biff == 2 || length == 9) ++blob.l;
	var val = parse_Bes(blob);
	cell.val = val;
	cell.t = (val === true || val === false) ? 'b' : 'e';
	return cell;
}
function write_BoolErr(R/*:number*/, C/*:number*/, v, os/*:number*/, opts, t/*:string*/) {
	var o = new_buf(8);
	write_XLSCell(R, C, os, o);
	write_Bes(v, t, o);
	return o;
}

/* [MS-XLS] 2.4.180 Number */
function parse_Number(blob, length, opts) {
	if(opts.biffguess && opts.biff == 2) opts.biff = 5;
	var cell = parse_XLSCell(blob);
	var xnum = parse_Xnum(blob);
	cell.val = xnum;
	return cell;
}
function write_Number(R/*:number*/, C/*:number*/, v, os/*:: :number, opts*/) {
	var o = new_buf(14);
	write_XLSCell(R, C, os, o);
	write_Xnum(v, o);
	return o;
}

var parse_XLHeaderFooter = parse_OptXLUnicodeString; // TODO: parse 2.4.136

/* [MS-XLS] 2.4.271 */
function parse_SupBook(blob, length, opts) {
	var end = blob.l + length;
	var ctab = blob.read_shift(2);
	var cch = blob.read_shift(2);
	opts.sbcch = cch;
	if(cch == 0x0401 || cch == 0x3A01) return [cch, ctab];
	if(cch < 0x01 || cch >0xff) throw new Error("Unexpected SupBook type: "+cch);
	var virtPath = parse_XLUnicodeStringNoCch(blob, cch);
	/* TODO: 2.5.277 Virtual Path */
	var rgst = [];
	while(end > blob.l) rgst.push(parse_XLUnicodeString(blob));
	return [cch, ctab, virtPath, rgst];
}

/* [MS-XLS] 2.4.105 TODO */
function parse_ExternName(blob, length, opts) {
	var flags = blob.read_shift(2);
	var body;
	var o = ({
		fBuiltIn: flags & 0x01,
		fWantAdvise: (flags >>> 1) & 0x01,
		fWantPict: (flags >>> 2) & 0x01,
		fOle: (flags >>> 3) & 0x01,
		fOleLink: (flags >>> 4) & 0x01,
		cf: (flags >>> 5) & 0x3FF,
		fIcon: flags >>> 15 & 0x01
	}/*:any*/);
	if(opts.sbcch === 0x3A01) body = parse_AddinUdf(blob, length-2, opts);
	//else throw new Error("unsupported SupBook cch: " + opts.sbcch);
	o.body = body || blob.read_shift(length-2);
	if(typeof body === "string") o.Name = body;
	return o;
}

/* [MS-XLS] 2.4.150 TODO */
var XLSLblBuiltIn = [
	"_xlnm.Consolidate_Area",
	"_xlnm.Auto_Open",
	"_xlnm.Auto_Close",
	"_xlnm.Extract",
	"_xlnm.Database",
	"_xlnm.Criteria",
	"_xlnm.Print_Area",
	"_xlnm.Print_Titles",
	"_xlnm.Recorder",
	"_xlnm.Data_Form",
	"_xlnm.Auto_Activate",
	"_xlnm.Auto_Deactivate",
	"_xlnm.Sheet_Title",
	"_xlnm._FilterDatabase"
];
function parse_Lbl(blob, length, opts) {
	var target = blob.l + length;
	var flags = blob.read_shift(2);
	var chKey = blob.read_shift(1);
	var cch = blob.read_shift(1);
	var cce = blob.read_shift(opts && opts.biff == 2 ? 1 : 2);
	var itab = 0;
	if(!opts || opts.biff >= 5) {
		if(opts.biff != 5) blob.l += 2;
		itab = blob.read_shift(2);
		if(opts.biff == 5) blob.l += 2;
		blob.l += 4;
	}
	var name = parse_XLUnicodeStringNoCch(blob, cch, opts);
	if(flags & 0x20) name = XLSLblBuiltIn[name.charCodeAt(0)];
	var npflen = target - blob.l; if(opts && opts.biff == 2) --npflen;
	/*jshint -W018 */
	var rgce = (target == blob.l || cce === 0 || !(npflen > 0)) ? [] : parse_NameParsedFormula(blob, npflen, opts, cce);
	/*jshint +W018 */
	return {
		chKey: chKey,
		Name: name,
		itab: itab,
		rgce: rgce
	};
}

/* [MS-XLS] 2.4.106 TODO: verify filename encoding */
function parse_ExternSheet(blob, length, opts) {
	if(opts.biff < 8) return parse_BIFF5ExternSheet(blob, length, opts);
	var o = [], target = blob.l + length, len = blob.read_shift(opts.biff > 8 ? 4 : 2);
	while(len-- !== 0) o.push(parse_XTI(blob, opts.biff > 8 ? 12 : 6, opts));
		// [iSupBook, itabFirst, itabLast];
	if(blob.l != target) throw new Error("Bad ExternSheet: " + blob.l + " != " + target);
	return o;
}
function parse_BIFF5ExternSheet(blob, length, opts) {
	if(blob[blob.l + 1] == 0x03) blob[blob.l]++;
	var o = parse_ShortXLUnicodeString(blob, length, opts);
	return o.charCodeAt(0) == 0x03 ? o.slice(1) : o;
}

/* [MS-XLS] 2.4.176 TODO: check older biff */
function parse_NameCmt(blob, length, opts) {
	if(opts.biff < 8) { blob.l += length; return; }
	var cchName = blob.read_shift(2);
	var cchComment = blob.read_shift(2);
	var name = parse_XLUnicodeStringNoCch(blob, cchName, opts);
	var comment = parse_XLUnicodeStringNoCch(blob, cchComment, opts);
	return [name, comment];
}

/* [MS-XLS] 2.4.260 */
function parse_ShrFmla(blob, length, opts) {
	var ref = parse_RefU(blob);
	blob.l++;
	var cUse = blob.read_shift(1);
	length -= 8;
	return [parse_SharedParsedFormula(blob, length, opts), cUse, ref];
}

/* [MS-XLS] 2.4.4 TODO */
function parse_Array(blob, length, opts) {
	var ref = parse_Ref(blob);
	/* TODO: fAlwaysCalc */
	switch(opts.biff) {
		case 2: blob.l ++; length -= 7; break;
		case 3: case 4: blob.l += 2; length -= 8; break;
		default: blob.l += 6; length -= 12;
	}
	return [ref, parse_ArrayParsedFormula(blob, length, opts)];
}

/* [MS-XLS] 2.4.173 */
function parse_MTRSettings(blob) {
	var fMTREnabled = blob.read_shift(4) !== 0x00;
	var fUserSetThreadCount = blob.read_shift(4) !== 0x00;
	var cUserThreadCount = blob.read_shift(4);
	return [fMTREnabled, fUserSetThreadCount, cUserThreadCount];
}

/* [MS-XLS] 2.5.186 TODO: BIFF5 */
function parse_NoteSh(blob, length, opts) {
	if(opts.biff < 8) return;
	var row = blob.read_shift(2), col = blob.read_shift(2);
	var flags = blob.read_shift(2), idObj = blob.read_shift(2);
	var stAuthor = parse_XLUnicodeString2(blob, 0, opts);
	if(opts.biff < 8) blob.read_shift(1);
	return [{r:row,c:col}, stAuthor, idObj, flags];
}

/* [MS-XLS] 2.4.179 */
function parse_Note(blob, length, opts) {
	/* TODO: Support revisions */
	return parse_NoteSh(blob, length, opts);
}

/* [MS-XLS] 2.4.168 */
function parse_MergeCells(blob, length)/*:Array<Range>*/ {
	var merges/*:Array<Range>*/ = [];
	var cmcs = blob.read_shift(2);
	while (cmcs--) merges.push(parse_Ref8U(blob));
	return merges;
}
function write_MergeCells(merges/*:Array<Range>*/) {
	var o = new_buf(2 + merges.length * 8);
	o.write_shift(2, merges.length);
	for(var i = 0; i < merges.length; ++i) write_Ref8U(merges[i], o);
	return o;
}

/* [MS-XLS] 2.4.181 TODO: parse all the things! */
function parse_Obj(blob, length, opts) {
	if(opts && opts.biff < 8) return parse_BIFF5Obj(blob, length, opts);
	var cmo = parse_FtCmo(blob); // id, ot, flags
	var fts = parse_FtArray(blob, length-22);
	return { cmo: cmo, ft:fts };
}
/* from older spec */
var parse_BIFF5OT = [];
parse_BIFF5OT[0x08] = function(blob, length) {
	var tgt = blob.l + length;
	blob.l += 10; // todo
	var cf = blob.read_shift(2);
	blob.l += 4;
	blob.l += 2; //var cbPictFmla = blob.read_shift(2);
	blob.l += 2;
	blob.l += 2; //var grbit = blob.read_shift(2);
	blob.l += 4;
	var cchName = blob.read_shift(1);
	blob.l += cchName; // TODO: stName
	blob.l = tgt; // TODO: fmla
	return { fmt:cf };
};

function parse_BIFF5Obj(blob, length, opts) {
	blob.l += 4; //var cnt = blob.read_shift(4);
	var ot = blob.read_shift(2);
	var id = blob.read_shift(2);
	var grbit = blob.read_shift(2);
	blob.l += 2; //var colL = blob.read_shift(2);
	blob.l += 2; //var dxL = blob.read_shift(2);
	blob.l += 2; //var rwT = blob.read_shift(2);
	blob.l += 2; //var dyT = blob.read_shift(2);
	blob.l += 2; //var colR = blob.read_shift(2);
	blob.l += 2; //var dxR = blob.read_shift(2);
	blob.l += 2; //var rwB = blob.read_shift(2);
	blob.l += 2; //var dyB = blob.read_shift(2);
	blob.l += 2; //var cbMacro = blob.read_shift(2);
	blob.l += 6;
	length -= 36;
	var fts = [];
	fts.push((parse_BIFF5OT[ot]||parsenoop)(blob, length, opts));
	return { cmo: [id, ot, grbit], ft:fts };
}

/* [MS-XLS] 2.4.329 TODO: parse properly */
function parse_TxO(blob, length, opts) {
	var s = blob.l;
	var texts = "";
try {
	blob.l += 4;
	var ot = (opts.lastobj||{cmo:[0,0]}).cmo[1];
	var controlInfo; // eslint-disable-line no-unused-vars
	if([0,5,7,11,12,14].indexOf(ot) == -1) blob.l += 6;
	else controlInfo = parse_ControlInfo(blob, 6, opts);
	var cchText = blob.read_shift(2);
	/*var cbRuns = */blob.read_shift(2);
	/*var ifntEmpty = */parseuint16(blob, 2);
	var len = blob.read_shift(2);
	blob.l += len;
	//var fmla = parse_ObjFmla(blob, s + length - blob.l);

	for(var i = 1; i < blob.lens.length-1; ++i) {
		if(blob.l-s != blob.lens[i]) throw new Error("TxO: bad continue record");
		var hdr = blob[blob.l];
		var t = parse_XLUnicodeStringNoCch(blob, blob.lens[i+1]-blob.lens[i]-1);
		texts += t;
		if(texts.length >= (hdr ? cchText : 2*cchText)) break;
	}
	if(texts.length !== cchText && texts.length !== cchText*2) {
		throw new Error("cchText: " + cchText + " != " + texts.length);
	}

	blob.l = s + length;
	/* [MS-XLS] 2.5.272 TxORuns */
//	var rgTxoRuns = [];
//	for(var j = 0; j != cbRuns/8-1; ++j) blob.l += 8;
//	var cchText2 = blob.read_shift(2);
//	if(cchText2 !== cchText) throw new Error("TxOLastRun mismatch: " + cchText2 + " " + cchText);
//	blob.l += 6;
//	if(s + length != blob.l) throw new Error("TxO " + (s + length) + ", at " + blob.l);
	return { t: texts };
} catch(e) { blob.l = s + length; return { t: texts }; }
}

/* [MS-XLS] 2.4.140 */
function parse_HLink(blob, length) {
	var ref = parse_Ref8U(blob);
	blob.l += 16; /* CLSID */
	var hlink = parse_Hyperlink(blob, length-24);
	return [ref, hlink];
}
function write_HLink(hl) {
	var O = new_buf(24);
	var ref = decode_cell(hl[0]);
	O.write_shift(2, ref.r); O.write_shift(2, ref.r);
	O.write_shift(2, ref.c); O.write_shift(2, ref.c);
	var clsid = "d0 c9 ea 79 f9 ba ce 11 8c 82 00 aa 00 4b a9 0b".split(" ");
	for(var i = 0; i < 16; ++i) O.write_shift(1, parseInt(clsid[i], 16));
	return bconcat([O, write_Hyperlink(hl[1])]);
}


/* [MS-XLS] 2.4.141 */
function parse_HLinkTooltip(blob, length) {
	blob.read_shift(2);
	var ref = parse_Ref8U(blob);
	var wzTooltip = blob.read_shift((length-10)/2, 'dbcs-cont');
	wzTooltip = wzTooltip.replace(chr0,"");
	return [ref, wzTooltip];
}
function write_HLinkTooltip(hl) {
	var TT = hl[1].Tooltip;
	var O = new_buf(10 + 2 * (TT.length + 1));
	O.write_shift(2, 0x0800);
	var ref = decode_cell(hl[0]);
	O.write_shift(2, ref.r); O.write_shift(2, ref.r);
	O.write_shift(2, ref.c); O.write_shift(2, ref.c);
	for(var i = 0; i < TT.length; ++i) O.write_shift(2, TT.charCodeAt(i));
	O.write_shift(2, 0);
	return O;
}

/* [MS-XLS] 2.4.63 */
function parse_Country(blob)/*:[string|number, string|number]*/ {
	var o = [0,0], d;
	d = blob.read_shift(2); o[0] = CountryEnum[d] || d;
	d = blob.read_shift(2); o[1] = CountryEnum[d] || d;
	return o;
}
function write_Country(o) {
	if(!o) o = new_buf(4);
	o.write_shift(2, 0x01);
	o.write_shift(2, 0x01);
	return o;
}

/* [MS-XLS] 2.4.50 ClrtClient */
function parse_ClrtClient(blob) {
	var ccv = blob.read_shift(2);
	var o = [];
	while(ccv-->0) o.push(parse_LongRGB(blob));
	return o;
}

/* [MS-XLS] 2.4.188 */
function parse_Palette(blob) {
	var ccv = blob.read_shift(2);
	var o = [];
	while(ccv-->0) o.push(parse_LongRGB(blob));
	return o;
}

/* [MS-XLS] 2.4.354 */
function parse_XFCRC(blob) {
	blob.l += 2;
	var o = {cxfs:0, crc:0};
	o.cxfs = blob.read_shift(2);
	o.crc = blob.read_shift(4);
	return o;
}

/* [MS-XLS] 2.4.53 TODO: parse flags */
/* [MS-XLSB] 2.4.323 TODO: parse flags */
function parse_ColInfo(blob, length, opts) {
	if(!opts.cellStyles) return parsenoop(blob, length);
	var w = opts && opts.biff >= 12 ? 4 : 2;
	var colFirst = blob.read_shift(w);
	var colLast = blob.read_shift(w);
	var coldx = blob.read_shift(w);
	var ixfe = blob.read_shift(w);
	var flags = blob.read_shift(2);
	if(w == 2) blob.l += 2;
	var o = ({s:colFirst, e:colLast, w:coldx, ixfe:ixfe, flags:flags}/*:any*/);
	if(opts.biff >= 5 || !opts.biff) o.level = (flags >> 8) & 0x7;
	return o;
}
function write_ColInfo(col, idx) {
	var o = new_buf(12);
	o.write_shift(2, idx);
	o.write_shift(2, idx);
	o.write_shift(2, col.width * 256);
	o.write_shift(2, 0);
	var f = 0;
	if(col.hidden) f |= 1;
	o.write_shift(1, f);
	f = col.level || 0;
	o.write_shift(1, f);
	o.write_shift(2, 0);
	return o;
}

/* [MS-XLS] 2.4.257 */
function parse_Setup(blob, length) {
	var o = {};
	if(length < 32) return o;
	blob.l += 16;
	o.header = parse_Xnum(blob);
	o.footer = parse_Xnum(blob);
	blob.l += 2;
	return o;
}

/* [MS-XLS] 2.4.261 */
function parse_ShtProps(blob, length, opts) {
	var def = {area:false};
	if(opts.biff != 5) { blob.l += length; return def; }
	var d = blob.read_shift(1); blob.l += 3;
	if((d & 0x10)) def.area = true;
	return def;
}

/* [MS-XLS] 2.4.241 */
function write_RRTabId(n/*:number*/) {
	var out = new_buf(2 * n);
	for(var i = 0; i < n; ++i) out.write_shift(2, i+1);
	return out;
}

var parse_Blank = parse_XLSCell; /* [MS-XLS] 2.4.20 Just the cell */
var parse_Scl = parseuint16a; /* [MS-XLS] 2.4.247 num, den */
var parse_String = parse_XLUnicodeString; /* [MS-XLS] 2.4.268 */

/* --- Specific to versions before BIFF8 --- */
function parse_ImData(blob) {
	var cf = blob.read_shift(2);
	var env = blob.read_shift(2);
	var lcb = blob.read_shift(4);
	var o = {fmt:cf, env:env, len:lcb, data:blob.slice(blob.l,blob.l+lcb)};
	blob.l += lcb;
	return o;
}

/* BIFF2_??? where ??? is the name from [XLS] */
function parse_BIFF2STR(blob, length, opts) {
	if(opts.biffguess && opts.biff == 5) opts.biff = 2;
	var cell = parse_XLSCell(blob);
	++blob.l;
	var str = parse_XLUnicodeString2(blob, length-7, opts);
	cell.t = 'str';
	cell.val = str;
	return cell;
}

function parse_BIFF2NUM(blob/*::, length*/) {
	var cell = parse_XLSCell(blob);
	++blob.l;
	var num = parse_Xnum(blob);
	cell.t = 'n';
	cell.val = num;
	return cell;
}
function write_BIFF2NUM(r/*:number*/, c/*:number*/, val/*:number*/) {
	var out = new_buf(15);
	write_BIFF2Cell(out, r, c);
	out.write_shift(8, val, 'f');
	return out;
}

function parse_BIFF2INT(blob) {
	var cell = parse_XLSCell(blob);
	++blob.l;
	var num = blob.read_shift(2);
	cell.t = 'n';
	cell.val = num;
	return cell;
}
function write_BIFF2INT(r/*:number*/, c/*:number*/, val/*:number*/) {
	var out = new_buf(9);
	write_BIFF2Cell(out, r, c);
	out.write_shift(2, val);
	return out;
}

function parse_BIFF2STRING(blob) {
	var cch = blob.read_shift(1);
	if(cch === 0) { blob.l++; return ""; }
	return blob.read_shift(cch, 'sbcs-cont');
}

/* TODO: convert to BIFF8 font struct */
function parse_BIFF2FONTXTRA(blob, length) {
	blob.l += 6; // unknown
	blob.l += 2; // font weight "bls"
	blob.l += 1; // charset
	blob.l += 3; // unknown
	blob.l += 1; // font family
	blob.l += length - 13;
}

/* TODO: parse rich text runs */
function parse_RString(blob, length, opts) {
	var end = blob.l + length;
	var cell = parse_XLSCell(blob);
	var cch = blob.read_shift(2);
	var str = parse_XLUnicodeStringNoCch(blob, cch, opts);
	blob.l = end;
	cell.t = 'str';
	cell.val = str;
	return cell;
}
/* from js-harb (C) 2014-present  SheetJS */
var DBF = (function() {
var dbf_codepage_map = {
	/* Code Pages Supported by Visual FoxPro */
	/*::[*/0x01/*::]*/:   437,           /*::[*/0x02/*::]*/:   850,
	/*::[*/0x03/*::]*/:  1252,           /*::[*/0x04/*::]*/: 10000,
	/*::[*/0x64/*::]*/:   852,           /*::[*/0x65/*::]*/:   866,
	/*::[*/0x66/*::]*/:   865,           /*::[*/0x67/*::]*/:   861,
	/*::[*/0x68/*::]*/:   895,           /*::[*/0x69/*::]*/:   620,
	/*::[*/0x6A/*::]*/:   737,           /*::[*/0x6B/*::]*/:   857,
	/*::[*/0x78/*::]*/:   950,           /*::[*/0x79/*::]*/:   949,
	/*::[*/0x7A/*::]*/:   936,           /*::[*/0x7B/*::]*/:   932,
	/*::[*/0x7C/*::]*/:   874,           /*::[*/0x7D/*::]*/:  1255,
	/*::[*/0x7E/*::]*/:  1256,           /*::[*/0x96/*::]*/: 10007,
	/*::[*/0x97/*::]*/: 10029,           /*::[*/0x98/*::]*/: 10006,
	/*::[*/0xC8/*::]*/:  1250,           /*::[*/0xC9/*::]*/:  1251,
	/*::[*/0xCA/*::]*/:  1254,           /*::[*/0xCB/*::]*/:  1253,

	/* shapefile DBF extension */
	/*::[*/0x00/*::]*/: 20127,           /*::[*/0x08/*::]*/:   865,
	/*::[*/0x09/*::]*/:   437,           /*::[*/0x0A/*::]*/:   850,
	/*::[*/0x0B/*::]*/:   437,           /*::[*/0x0D/*::]*/:   437,
	/*::[*/0x0E/*::]*/:   850,           /*::[*/0x0F/*::]*/:   437,
	/*::[*/0x10/*::]*/:   850,           /*::[*/0x11/*::]*/:   437,
	/*::[*/0x12/*::]*/:   850,           /*::[*/0x13/*::]*/:   932,
	/*::[*/0x14/*::]*/:   850,           /*::[*/0x15/*::]*/:   437,
	/*::[*/0x16/*::]*/:   850,           /*::[*/0x17/*::]*/:   865,
	/*::[*/0x18/*::]*/:   437,           /*::[*/0x19/*::]*/:   437,
	/*::[*/0x1A/*::]*/:   850,           /*::[*/0x1B/*::]*/:   437,
	/*::[*/0x1C/*::]*/:   863,           /*::[*/0x1D/*::]*/:   850,
	/*::[*/0x1F/*::]*/:   852,           /*::[*/0x22/*::]*/:   852,
	/*::[*/0x23/*::]*/:   852,           /*::[*/0x24/*::]*/:   860,
	/*::[*/0x25/*::]*/:   850,           /*::[*/0x26/*::]*/:   866,
	/*::[*/0x37/*::]*/:   850,           /*::[*/0x40/*::]*/:   852,
	/*::[*/0x4D/*::]*/:   936,           /*::[*/0x4E/*::]*/:   949,
	/*::[*/0x4F/*::]*/:   950,           /*::[*/0x50/*::]*/:   874,
	/*::[*/0x57/*::]*/:  1252,           /*::[*/0x58/*::]*/:  1252,
	/*::[*/0x59/*::]*/:  1252,           /*::[*/0x6C/*::]*/:   863,
	/*::[*/0x86/*::]*/:   737,           /*::[*/0x87/*::]*/:   852,
	/*::[*/0x88/*::]*/:   857,           /*::[*/0xCC/*::]*/:  1257,

	/*::[*/0xFF/*::]*/: 16969
};
var dbf_reverse_map = evert({
	/*::[*/0x01/*::]*/:   437,           /*::[*/0x02/*::]*/:   850,
	/*::[*/0x03/*::]*/:  1252,           /*::[*/0x04/*::]*/: 10000,
	/*::[*/0x64/*::]*/:   852,           /*::[*/0x65/*::]*/:   866,
	/*::[*/0x66/*::]*/:   865,           /*::[*/0x67/*::]*/:   861,
	/*::[*/0x68/*::]*/:   895,           /*::[*/0x69/*::]*/:   620,
	/*::[*/0x6A/*::]*/:   737,           /*::[*/0x6B/*::]*/:   857,
	/*::[*/0x78/*::]*/:   950,           /*::[*/0x79/*::]*/:   949,
	/*::[*/0x7A/*::]*/:   936,           /*::[*/0x7B/*::]*/:   932,
	/*::[*/0x7C/*::]*/:   874,           /*::[*/0x7D/*::]*/:  1255,
	/*::[*/0x7E/*::]*/:  1256,           /*::[*/0x96/*::]*/: 10007,
	/*::[*/0x97/*::]*/: 10029,           /*::[*/0x98/*::]*/: 10006,
	/*::[*/0xC8/*::]*/:  1250,           /*::[*/0xC9/*::]*/:  1251,
	/*::[*/0xCA/*::]*/:  1254,           /*::[*/0xCB/*::]*/:  1253,
	/*::[*/0x00/*::]*/: 20127
});
var DBF_SUPPORTED_VERSIONS = [0x02, 0x03, 0x30, 0x31, 0x83, 0x8B, 0x8C, 0xF5];
/* TODO: find an actual specification */
function dbf_to_aoa(buf, opts)/*:AOA*/ {
	var out/*:AOA*/ = [];
	var d/*:Block*/ = (new_raw_buf(1)/*:any*/);
	switch(opts.type) {
		case 'base64': d = s2a(Base64.decode(buf)); break;
		case 'binary': d = s2a(buf); break;
		case 'buffer':
		case 'array': d = buf; break;
	}
	prep_blob(d, 0);

	/* header */
	var ft = d.read_shift(1);
	var memo = !!(ft & 0x88);
	var vfp = false, l7 = false;
	switch(ft) {
		case 0x02: break; // dBASE II
		case 0x03: break; // dBASE III
		case 0x30: vfp = true; memo = true; break; // VFP
		case 0x31: vfp = true; memo = true; break; // VFP with autoincrement
		// 0x43 dBASE IV SQL table files
		// 0x63 dBASE IV SQL system files
		case 0x83: break; // dBASE III with memo
		case 0x8B: break; // dBASE IV with memo
		case 0x8C: l7 = true; break; // dBASE Level 7 with memo
		// case 0xCB dBASE IV SQL table files with memo
		case 0xF5: break; // FoxPro 2.x with memo
		// case 0xFB FoxBASE
		default: throw new Error("DBF Unsupported Version: " + ft.toString(16));
	}

	var nrow = 0, fpos = 0x0209;
	if(ft == 0x02) nrow = d.read_shift(2);
	d.l += 3; // dBASE II stores DDMMYY date, others use YYMMDD
	if(ft != 0x02) nrow = d.read_shift(4);
	if(nrow > 1048576) nrow = 1e6;

	if(ft != 0x02) fpos = d.read_shift(2); // header length
	var rlen = d.read_shift(2); // record length

	var /*flags = 0,*/ current_cp = opts.codepage || 1252;
	if(ft != 0x02) { // 20 reserved bytes
		d.l+=16;
		/*flags = */d.read_shift(1);
		//if(memo && ((flags & 0x02) === 0)) throw new Error("DBF Flags " + flags.toString(16) + " ft " + ft.toString(16));

		/* codepage present in FoxPro and dBASE Level 7 */
		if(d[d.l] !== 0) current_cp = dbf_codepage_map[d[d.l]];
		d.l+=1;

		d.l+=2;
	}
	if(l7) d.l += 36; // Level 7: 32 byte "Language driver name", 4 byte reserved

/*:: type DBFField = { name:string; len:number; type:string; } */
	var fields/*:Array<DBFField>*/ = [], field/*:DBFField*/ = ({}/*:any*/);
	var hend = Math.min(d.length, (ft == 0x02 ? 0x209 : (fpos - 10 - (vfp ? 264 : 0))));
	var ww = l7 ? 32 : 11;
	while(d.l < hend && d[d.l] != 0x0d) {
		field = ({}/*:any*/);
		field.name = cptable.utils.decode(current_cp, d.slice(d.l, d.l+ww)).replace(/[\u0000\r\n].*$/g,"");
		d.l += ww;
		field.type = String.fromCharCode(d.read_shift(1));
		if(ft != 0x02 && !l7) field.offset = d.read_shift(4);
		field.len = d.read_shift(1);
		if(ft == 0x02) field.offset = d.read_shift(2);
		field.dec = d.read_shift(1);
		if(field.name.length) fields.push(field);
		if(ft != 0x02) d.l += l7 ? 13 : 14;
		switch(field.type) {
			case 'B': // Double (VFP) / Binary (dBASE L7)
				if((!vfp || field.len != 8) && opts.WTF) console.log('Skipping ' + field.name + ':' + field.type);
				break;
			case 'G': // General (FoxPro and dBASE L7)
			case 'P': // Picture (FoxPro and dBASE L7)
				if(opts.WTF) console.log('Skipping ' + field.name + ':' + field.type);
				break;
			case '+': // Autoincrement (dBASE L7 only)
			case '0': // _NullFlags (VFP only)
			case '@': // Timestamp (dBASE L7 only)
			case 'C': // Character (dBASE II)
			case 'D': // Date (dBASE III)
			case 'F': // Float (dBASE IV)
			case 'I': // Long (VFP and dBASE L7)
			case 'L': // Logical (dBASE II)
			case 'M': // Memo (dBASE III)
			case 'N': // Number (dBASE II)
			case 'O': // Double (dBASE L7 only)
			case 'T': // Datetime (VFP only)
			case 'Y': // Currency (VFP only)
				break;
			default: throw new Error('Unknown Field Type: ' + field.type);
		}
	}

	if(d[d.l] !== 0x0D) d.l = fpos-1;
	if(d.read_shift(1) !== 0x0D) throw new Error("DBF Terminator not found " + d.l + " " + d[d.l]);
	d.l = fpos;

	/* data */
	var R = 0, C = 0;
	out[0] = [];
	for(C = 0; C != fields.length; ++C) out[0][C] = fields[C].name;
	while(nrow-- > 0) {
		if(d[d.l] === 0x2A) {
			// TODO: record marked as deleted -- create a hidden row?
			d.l+=rlen;
			continue;
		}
		++d.l;
		out[++R] = []; C = 0;
		for(C = 0; C != fields.length; ++C) {
			var dd = d.slice(d.l, d.l+fields[C].len); d.l+=fields[C].len;
			prep_blob(dd, 0);
			var s = cptable.utils.decode(current_cp, dd);
			switch(fields[C].type) {
				case 'C':
					// NOTE: it is conventional to write '  /  /  ' for empty dates
					if(s.trim().length) out[R][C] = s.replace(/\s+$/,"");
					break;
				case 'D':
					if(s.length === 8) out[R][C] = new Date(+s.slice(0,4), +s.slice(4,6)-1, +s.slice(6,8));
					else out[R][C] = s;
					break;
				case 'F': out[R][C] = parseFloat(s.trim()); break;
				case '+': case 'I': out[R][C] = l7 ? dd.read_shift(-4, 'i') ^ 0x80000000 : dd.read_shift(4, 'i'); break;
				case 'L': switch(s.trim().toUpperCase()) {
					case 'Y': case 'T': out[R][C] = true; break;
					case 'N': case 'F': out[R][C] = false; break;
					case '': case '?': break;
					default: throw new Error("DBF Unrecognized L:|" + s + "|");
					} break;
				case 'M': /* TODO: handle memo files */
					if(!memo) throw new Error("DBF Unexpected MEMO for type " + ft.toString(16));
					out[R][C] = "##MEMO##" + (l7 ? parseInt(s.trim(), 10): dd.read_shift(4));
					break;
				case 'N':
					s = s.replace(/\u0000/g,"").trim();
					// NOTE: dBASE II interprets "  .  " as 0
					if(s && s != ".") out[R][C] = +s || 0; break;
				case '@':
					// NOTE: dBASE specs appear to be incorrect
					out[R][C] = new Date(dd.read_shift(-8, 'f') - 0x388317533400);
					break;
				case 'T': out[R][C] = new Date((dd.read_shift(4) - 0x253D8C) * 0x5265C00 + dd.read_shift(4)); break;
				case 'Y': out[R][C] = dd.read_shift(4,'i')/1e4; break;
				case 'O': out[R][C] = -dd.read_shift(-8, 'f'); break;
				case 'B': if(vfp && fields[C].len == 8) { out[R][C] = dd.read_shift(8,'f'); break; }
					/* falls through */
				case 'G': case 'P': dd.l += fields[C].len; break;
				case '0':
					if(fields[C].name === '_NullFlags') break;
					/* falls through */
				default: throw new Error("DBF Unsupported data type " + fields[C].type);
			}
		}
	}
	if(ft != 0x02) if(d.l < d.length && d[d.l++] != 0x1A) throw new Error("DBF EOF Marker missing " + (d.l-1) + " of " + d.length + " " + d[d.l-1].toString(16));
	if(opts && opts.sheetRows) out = out.slice(0, opts.sheetRows);
	return out;
}

function dbf_to_sheet(buf, opts)/*:Worksheet*/ {
	var o = opts || {};
	if(!o.dateNF) o.dateNF = "yyyymmdd";
	return aoa_to_sheet(dbf_to_aoa(buf, o), o);
}

function dbf_to_workbook(buf, opts)/*:Workbook*/ {
	try { return sheet_to_workbook(dbf_to_sheet(buf, opts), opts); }
	catch(e) { if(opts && opts.WTF) throw e; }
	return ({SheetNames:[],Sheets:{}});
}

var _RLEN = { 'B': 8, 'C': 250, 'L': 1, 'D': 8, '?': 0, '': 0 };
function sheet_to_dbf(ws/*:Worksheet*/, opts/*:WriteOpts*/) {
	var o = opts || {};
	if(+o.codepage >= 0) set_cp(+o.codepage);
	if(o.type == "string") throw new Error("Cannot write DBF to JS string");
	var ba = buf_array();
	var aoa/*:AOA*/ = sheet_to_json(ws, {header:1, raw:true, cellDates:true});
	var headers = aoa[0], data = aoa.slice(1);
	var i = 0, j = 0, hcnt = 0, rlen = 1;
	for(i = 0; i < headers.length; ++i) {
		if(i == null) continue;
		++hcnt;
		if(typeof headers[i] === 'number') headers[i] = headers[i].toString(10);
		if(typeof headers[i] !== 'string') throw new Error("DBF Invalid column name " + headers[i] + " |" + (typeof headers[i]) + "|");
		if(headers.indexOf(headers[i]) !== i) for(j=0; j<1024;++j)
			if(headers.indexOf(headers[i] + "_" + j) == -1) { headers[i] += "_" + j; break; }
	}
	var range = safe_decode_range(ws['!ref']);
	var coltypes/*:Array<string>*/ = [];
	for(i = 0; i <= range.e.c - range.s.c; ++i) {
		var col/*:Array<any>*/ = [];
		for(j=0; j < data.length; ++j) {
			if(data[j][i] != null) col.push(data[j][i]);
		}
		if(col.length == 0 || headers[i] == null) { coltypes[i] = '?'; continue; }
		var guess = '', _guess = '';
		for(j = 0; j < col.length; ++j) {
			switch(typeof col[j]) {
				/* TODO: check if L2 compat is desired */
				case 'number': _guess = 'B'; break;
				case 'string': _guess = 'C'; break;
				case 'boolean': _guess = 'L'; break;
				case 'object': _guess = col[j] instanceof Date ? 'D' : 'C'; break;
				default: _guess = 'C';
			}
			guess = guess && guess != _guess ? 'C' : _guess;
			if(guess == 'C') break;
		}
		rlen += _RLEN[guess] || 0;
		coltypes[i] = guess;
	}

	var h = ba.next(32);
	h.write_shift(4, 0x13021130);
	h.write_shift(4, data.length);
	h.write_shift(2, 296 + 32 * hcnt);
	h.write_shift(2, rlen);
	for(i=0; i < 4; ++i) h.write_shift(4, 0);
	h.write_shift(4, 0x00000000 | ((+dbf_reverse_map[/*::String(*/current_ansi/*::)*/] || 0x03)<<8));

	for(i = 0, j = 0; i < headers.length; ++i) {
		if(headers[i] == null) continue;
		var hf = ba.next(32);
		var _f = (headers[i].slice(-10) + "\x00\x00\x00\x00\x00\x00\x00\x00\x00\x00\x00").slice(0, 11);
		hf.write_shift(1, _f, "sbcs");
		hf.write_shift(1, coltypes[i] == '?' ? 'C' : coltypes[i], "sbcs");
		hf.write_shift(4, j);
		hf.write_shift(1, _RLEN[coltypes[i]] || 0);
		hf.write_shift(1, 0);
		hf.write_shift(1, 0x02);
		hf.write_shift(4, 0);
		hf.write_shift(1, 0);
		hf.write_shift(4, 0);
		hf.write_shift(4, 0);
		j += _RLEN[coltypes[i]] || 0;
	}

	var hb = ba.next(264);
	hb.write_shift(4, 0x0000000D);
	for(i=0; i < 65;++i) hb.write_shift(4, 0x00000000);
	for(i=0; i < data.length; ++i) {
		var rout = ba.next(rlen);
		rout.write_shift(1, 0);
		for(j=0; j<headers.length; ++j) {
			if(headers[j] == null) continue;
			switch(coltypes[j]) {
				case 'L': rout.write_shift(1, data[i][j] == null ? 0x3F : data[i][j] ? 0x54 : 0x46); break;
				case 'B': rout.write_shift(8, data[i][j]||0, 'f'); break;
				case 'D':
					if(!data[i][j]) rout.write_shift(8, "00000000", "sbcs");
					else {
						rout.write_shift(4, ("0000"+data[i][j].getFullYear()).slice(-4), "sbcs");
						rout.write_shift(2, ("00"+(data[i][j].getMonth()+1)).slice(-2), "sbcs");
						rout.write_shift(2, ("00"+data[i][j].getDate()).slice(-2), "sbcs");
					} break;
				case 'C':
					var _s = String(data[i][j]||"");
					rout.write_shift(1, _s, "sbcs");
					for(hcnt=0; hcnt < 250-_s.length; ++hcnt) rout.write_shift(1, 0x20); break;
			}
		}
		// data
	}
	ba.next(1).write_shift(1, 0x1A);
	return ba.end();
}
	return {
		versions: DBF_SUPPORTED_VERSIONS,
		to_workbook: dbf_to_workbook,
		to_sheet: dbf_to_sheet,
		from_sheet: sheet_to_dbf
	};
})();

var SYLK = (function() {
	/* TODO: stress test sequences */
	var sylk_escapes = ({
		AA:'À', BA:'Á', CA:'Â', DA:195, HA:'Ä', JA:197,
		AE:'È', BE:'É', CE:'Ê',         HE:'Ë',
		AI:'Ì', BI:'Í', CI:'Î',         HI:'Ï',
		AO:'Ò', BO:'Ó', CO:'Ô', DO:213, HO:'Ö',
		AU:'Ù', BU:'Ú', CU:'Û',         HU:'Ü',
		Aa:'à', Ba:'á', Ca:'â', Da:227, Ha:'ä', Ja:229,
		Ae:'è', Be:'é', Ce:'ê',         He:'ë',
		Ai:'ì', Bi:'í', Ci:'î',         Hi:'ï',
		Ao:'ò', Bo:'ó', Co:'ô', Do:245, Ho:'ö',
		Au:'ù', Bu:'ú', Cu:'û',         Hu:'ü',
		KC:'Ç', Kc:'ç', q:'æ',  z:'œ',  a:'Æ',  j:'Œ',
		DN:209, Dn:241, Hy:255,
		S:169,  c:170,  R:174,  "B ":180,
		/*::[*/0/*::]*/:176,    /*::[*/1/*::]*/:177,  /*::[*/2/*::]*/:178,
		/*::[*/3/*::]*/:179,    /*::[*/5/*::]*/:181,  /*::[*/6/*::]*/:182,
		/*::[*/7/*::]*/:183,    Q:185,  k:186,  b:208,  i:216,  l:222,  s:240,  y:248,
		"!":161, '"':162, "#":163, "(":164, "%":165, "'":167, "H ":168,
		"+":171, ";":187, "<":188, "=":189, ">":190, "?":191, "{":223
	}/*:any*/);
	var sylk_char_regex = new RegExp("\u001BN(" + keys$1(sylk_escapes).join("|").replace(/\|\|\|/, "|\\||").replace(/([?()+])/g,"\\$1") + "|\\|)", "gm");
	var sylk_char_fn = function(_, $1){ var o = sylk_escapes[$1]; return typeof o == "number" ? _getansi(o) : o; };
	var decode_sylk_char = function($$, $1, $2) { var newcc = (($1.charCodeAt(0) - 0x20)<<4) | ($2.charCodeAt(0) - 0x30); return newcc == 59 ? $$ : _getansi(newcc); };
	sylk_escapes["|"] = 254;
	/* TODO: find an actual specification */
	function sylk_to_aoa(d/*:RawData*/, opts)/*:[AOA, Worksheet]*/ {
		switch(opts.type) {
			case 'base64': return sylk_to_aoa_str(Base64.decode(d), opts);
			case 'binary': return sylk_to_aoa_str(d, opts);
			case 'buffer': return sylk_to_aoa_str(has_buf && Buffer.isBuffer(d) ? d.toString('binary') : a2s(d), opts);
			case 'array': return sylk_to_aoa_str(cc2str(d), opts);
		}
		throw new Error("Unrecognized type " + opts.type);
	}
	function sylk_to_aoa_str(str/*:string*/, opts)/*:[AOA, Worksheet]*/ {
		var records = str.split(/[\n\r]+/), R = -1, C = -1, ri = 0, rj = 0, arr/*:AOA*/ = [];
		var formats/*:Array<string>*/ = [];
		var next_cell_format/*:string|null*/ = null;
		var sht = {}, rowinfo/*:Array<RowInfo>*/ = [], colinfo/*:Array<ColInfo>*/ = [], cw/*:Array<string>*/ = [];
		var Mval = 0, j;
		if(+opts.codepage >= 0) set_cp(+opts.codepage);
		for (; ri !== records.length; ++ri) {
			Mval = 0;
			var rstr=records[ri].trim().replace(/\x1B([\x20-\x2F])([\x30-\x3F])/g, decode_sylk_char).replace(sylk_char_regex, sylk_char_fn);
			var record=rstr.replace(/;;/g, "\u0000").split(";").map(function(x) { return x.replace(/\u0000/g, ";"); });
			var RT=record[0], val;
			if(rstr.length > 0) switch(RT) {
			case 'ID': break; /* header */
			case 'E': break; /* EOF */
			case 'B': break; /* dimensions */
			case 'O': break; /* options? */
			case 'W': break; /* window? */
			case 'P':
				if(record[1].charAt(0) == 'P')
					formats.push(rstr.slice(3).replace(/;;/g, ";"));
				break;
			case 'C':
			var C_seen_K = false, C_seen_X = false, C_seen_S = false, C_seen_E = false, _R = -1, _C = -1;
			for(rj=1; rj<record.length; ++rj) switch(record[rj].charAt(0)) {
				case 'A': break; // TODO: comment
				case 'X': C = parseInt(record[rj].slice(1))-1; C_seen_X = true; break;
				case 'Y':
					R = parseInt(record[rj].slice(1))-1; if(!C_seen_X) C = 0;
					for(j = arr.length; j <= R; ++j) arr[j] = [];
					break;
				case 'K':
					val = record[rj].slice(1);
					if(val.charAt(0) === '"') val = val.slice(1,val.length - 1);
					else if(val === 'TRUE') val = true;
					else if(val === 'FALSE') val = false;
					else if(!isNaN(fuzzynum(val))) {
						val = fuzzynum(val);
						if(next_cell_format !== null && SSF.is_date(next_cell_format)) val = numdate(val);
					} else if(!isNaN(fuzzydate(val).getDate())) {
						val = parseDate(val);
					}
					if(typeof cptable !== 'undefined' && typeof val == "string" && ((opts||{}).type != "string") && (opts||{}).codepage) val = cptable.utils.decode(opts.codepage, val);
					C_seen_K = true;
					break;
				case 'E':
					C_seen_E = true;
					var formula = rc_to_a1(record[rj].slice(1), {r:R,c:C});
					arr[R][C] = [arr[R][C], formula];
					break;
				case 'S':
					C_seen_S = true;
					arr[R][C] = [arr[R][C], "S5S"];
					break;
				case 'G': break; // unknown
				case 'R': _R = parseInt(record[rj].slice(1))-1; break;
				case 'C': _C = parseInt(record[rj].slice(1))-1; break;
				default: if(opts && opts.WTF) throw new Error("SYLK bad record " + rstr);
			}
			if(C_seen_K) {
				if(arr[R][C] && arr[R][C].length == 2) arr[R][C][0] = val;
				else arr[R][C] = val;
				next_cell_format = null;
			}
			if(C_seen_S) {
				if(C_seen_E) throw new Error("SYLK shared formula cannot have own formula");
				var shrbase = _R > -1 && arr[_R][_C];
				if(!shrbase || !shrbase[1]) throw new Error("SYLK shared formula cannot find base");
				arr[R][C][1] = shift_formula_str(shrbase[1], {r: R - _R, c: C - _C});
			}
			break;
			case 'F':
			var F_seen = 0;
			for(rj=1; rj<record.length; ++rj) switch(record[rj].charAt(0)) {
				case 'X': C = parseInt(record[rj].slice(1))-1; ++F_seen; break;
				case 'Y':
					R = parseInt(record[rj].slice(1))-1; /*C = 0;*/
					for(j = arr.length; j <= R; ++j) arr[j] = [];
					break;
				case 'M': Mval = parseInt(record[rj].slice(1)) / 20; break;
				case 'F': break; /* ??? */
				case 'G': break; /* hide grid */
				case 'P':
					next_cell_format = formats[parseInt(record[rj].slice(1))];
					break;
				case 'S': break; /* cell style */
				case 'D': break; /* column */
				case 'N': break; /* font */
				case 'W':
					cw = record[rj].slice(1).split(" ");
					for(j = parseInt(cw[0], 10); j <= parseInt(cw[1], 10); ++j) {
						Mval = parseInt(cw[2], 10);
						colinfo[j-1] = Mval === 0 ? {hidden:true}: {wch:Mval}; process_col(colinfo[j-1]);
					} break;
				case 'C': /* default column format */
					C = parseInt(record[rj].slice(1))-1;
					if(!colinfo[C]) colinfo[C] = {};
					break;
				case 'R': /* row properties */
					R = parseInt(record[rj].slice(1))-1;
					if(!rowinfo[R]) rowinfo[R] = {};
					if(Mval > 0) { rowinfo[R].hpt = Mval; rowinfo[R].hpx = pt2px(Mval); }
					else if(Mval === 0) rowinfo[R].hidden = true;
					break;
				default: if(opts && opts.WTF) throw new Error("SYLK bad record " + rstr);
			}
			if(F_seen < 1) next_cell_format = null; break;
			default: if(opts && opts.WTF) throw new Error("SYLK bad record " + rstr);
			}
		}
		if(rowinfo.length > 0) sht['!rows'] = rowinfo;
		if(colinfo.length > 0) sht['!cols'] = colinfo;
		if(opts && opts.sheetRows) arr = arr.slice(0, opts.sheetRows);
		return [arr, sht];
	}

	function sylk_to_sheet(d/*:RawData*/, opts)/*:Worksheet*/ {
		var aoasht = sylk_to_aoa(d, opts);
		var aoa = aoasht[0], ws = aoasht[1];
		var o = aoa_to_sheet(aoa, opts);
		keys$1(ws).forEach(function(k) { o[k] = ws[k]; });
		return o;
	}

	function sylk_to_workbook(d/*:RawData*/, opts)/*:Workbook*/ { return sheet_to_workbook(sylk_to_sheet(d, opts), opts); }

	function write_ws_cell_sylk(cell/*:Cell*/, ws/*:Worksheet*/, R/*:number*/, C/*:number*//*::, opts*/)/*:string*/ {
		var o = "C;Y" + (R+1) + ";X" + (C+1) + ";K";
		switch(cell.t) {
			case 'n':
				o += (cell.v||0);
				if(cell.f && !cell.F) o += ";E" + a1_to_rc(cell.f, {r:R, c:C}); break;
			case 'b': o += cell.v ? "TRUE" : "FALSE"; break;
			case 'e': o += cell.w || cell.v; break;
			case 'd': o += '"' + (cell.w || cell.v) + '"'; break;
			case 's': o += '"' + cell.v.replace(/"/g,"").replace(/;/g, ";;") + '"'; break;
		}
		return o;
	}

	function write_ws_cols_sylk(out, cols) {
		cols.forEach(function(col, i) {
			var rec = "F;W" + (i+1) + " " + (i+1) + " ";
			if(col.hidden) rec += "0";
			else {
				if(typeof col.width == 'number' && !col.wpx) col.wpx = width2px(col.width);
				if(typeof col.wpx == 'number' && !col.wch) col.wch = px2char(col.wpx);
				if(typeof col.wch == 'number') rec += Math.round(col.wch);
			}
			if(rec.charAt(rec.length - 1) != " ") out.push(rec);
		});
	}

	function write_ws_rows_sylk(out/*:Array<string>*/, rows/*:Array<RowInfo>*/) {
		rows.forEach(function(row, i) {
			var rec = "F;";
			if(row.hidden) rec += "M0;";
			else if(row.hpt) rec += "M" + 20 * row.hpt + ";";
			else if(row.hpx) rec += "M" + 20 * px2pt(row.hpx) + ";";
			if(rec.length > 2) out.push(rec + "R" + (i+1));
		});
	}

	function sheet_to_sylk(ws/*:Worksheet*/, opts/*:?any*/)/*:string*/ {
		var preamble/*:Array<string>*/ = ["ID;PWXL;N;E"], o/*:Array<string>*/ = [];
		var r = safe_decode_range(ws['!ref']), cell/*:Cell*/;
		var dense = Array.isArray(ws);
		var RS = "\r\n";

		preamble.push("P;PGeneral");
		preamble.push("F;P0;DG0G8;M255");
		if(ws['!cols']) write_ws_cols_sylk(preamble, ws['!cols']);
		if(ws['!rows']) write_ws_rows_sylk(preamble, ws['!rows']);

		preamble.push("B;Y" + (r.e.r - r.s.r + 1) + ";X" + (r.e.c - r.s.c + 1) + ";D" + [r.s.c,r.s.r,r.e.c,r.e.r].join(" "));
		for(var R = r.s.r; R <= r.e.r; ++R) {
			for(var C = r.s.c; C <= r.e.c; ++C) {
				var coord = encode_cell({r:R,c:C});
				cell = dense ? (ws[R]||[])[C]: ws[coord];
				if(!cell || (cell.v == null && (!cell.f || cell.F))) continue;
				o.push(write_ws_cell_sylk(cell, ws, R, C));
			}
		}
		return preamble.join(RS) + RS + o.join(RS) + RS + "E" + RS;
	}

	return {
		to_workbook: sylk_to_workbook,
		to_sheet: sylk_to_sheet,
		from_sheet: sheet_to_sylk
	};
})();

var DIF = (function() {
	function dif_to_aoa(d/*:RawData*/, opts)/*:AOA*/ {
		switch(opts.type) {
			case 'base64': return dif_to_aoa_str(Base64.decode(d), opts);
			case 'binary': return dif_to_aoa_str(d, opts);
			case 'buffer': return dif_to_aoa_str(has_buf && Buffer.isBuffer(d) ? d.toString('binary') : a2s(d), opts);
			case 'array': return dif_to_aoa_str(cc2str(d), opts);
		}
		throw new Error("Unrecognized type " + opts.type);
	}
	function dif_to_aoa_str(str/*:string*/, opts)/*:AOA*/ {
		var records = str.split('\n'), R = -1, C = -1, ri = 0, arr/*:AOA*/ = [];
		for (; ri !== records.length; ++ri) {
			if (records[ri].trim() === 'BOT') { arr[++R] = []; C = 0; continue; }
			if (R < 0) continue;
			var metadata = records[ri].trim().split(",");
			var type = metadata[0], value = metadata[1];
			++ri;
			var data = records[ri] || "";
			while(((data.match(/["]/g)||[]).length & 1) && ri < records.length - 1) data += "\n" + records[++ri];
			data = data.trim();
			switch (+type) {
				case -1:
					if (data === 'BOT') { arr[++R] = []; C = 0; continue; }
					else if (data !== 'EOD') throw new Error("Unrecognized DIF special command " + data);
					break;
				case 0:
					if(data === 'TRUE') arr[R][C] = true;
					else if(data === 'FALSE') arr[R][C] = false;
					else if(!isNaN(fuzzynum(value))) arr[R][C] = fuzzynum(value);
					else if(!isNaN(fuzzydate(value).getDate())) arr[R][C] = parseDate(value);
					else arr[R][C] = value;
					++C; break;
				case 1:
					data = data.slice(1,data.length-1);
					data = data.replace(/""/g, '"');
					if( data && data.match(/^=".*"$/)) data = data.slice(2, -1);
					arr[R][C++] = data !== '' ? data : null;
					break;
			}
			if (data === 'EOD') break;
		}
		if(opts && opts.sheetRows) arr = arr.slice(0, opts.sheetRows);
		return arr;
	}

	function dif_to_sheet(str/*:string*/, opts)/*:Worksheet*/ { return aoa_to_sheet(dif_to_aoa(str, opts), opts); }
	function dif_to_workbook(str/*:string*/, opts)/*:Workbook*/ { return sheet_to_workbook(dif_to_sheet(str, opts), opts); }

	var sheet_to_dif = (function() {
		var push_field = function pf(o/*:Array<string>*/, topic/*:string*/, v/*:number*/, n/*:number*/, s/*:string*/) {
			o.push(topic);
			o.push(v + "," + n);
			o.push('"' + s.replace(/"/g,'""') + '"');
		};
		var push_value = function po(o/*:Array<string>*/, type/*:number*/, v/*:any*/, s/*:string*/) {
			o.push(type + "," + v);
			o.push(type == 1 ? '"' + s.replace(/"/g,'""') + '"' : s);
		};
		return function sheet_to_dif(ws/*:Worksheet*//*::, opts:?any*/)/*:string*/ {
			var o/*:Array<string>*/ = [];
			var r = safe_decode_range(ws['!ref']), cell/*:Cell*/;
			var dense = Array.isArray(ws);
			push_field(o, "TABLE", 0, 1, "sheetjs");
			push_field(o, "VECTORS", 0, r.e.r - r.s.r + 1,"");
			push_field(o, "TUPLES", 0, r.e.c - r.s.c + 1,"");
			push_field(o, "DATA", 0, 0,"");
			for(var R = r.s.r; R <= r.e.r; ++R) {
				push_value(o, -1, 0, "BOT");
				for(var C = r.s.c; C <= r.e.c; ++C) {
					var coord = encode_cell({r:R,c:C});
					cell = dense ? (ws[R]||[])[C] : ws[coord];
					if(!cell) { push_value(o, 1, 0, ""); continue;}
					switch(cell.t) {
						case 'n':
							var val =  cell.w ;
							if(!val && cell.v != null) val = cell.v;
							if(val == null) {
								if( cell.f && !cell.F) push_value(o, 1, 0, "=" + cell.f);
								else push_value(o, 1, 0, "");
							}
							else push_value(o, 0, val, "V");
							break;
						case 'b':
							push_value(o, 0, cell.v ? 1 : 0, cell.v ? "TRUE" : "FALSE");
							break;
						case 's':
							push_value(o, 1, 0, ( isNaN(cell.v)) ? cell.v : '="' + cell.v + '"');
							break;
						case 'd':
							if(!cell.w) cell.w = SSF.format(cell.z || SSF._table[14], datenum(parseDate(cell.v)));
							push_value(o, 0, cell.w, "V");
							break;
						default: push_value(o, 1, 0, "");
					}
				}
			}
			push_value(o, -1, 0, "EOD");
			var RS = "\r\n";
			var oo = o.join(RS);
			//while((oo.length & 0x7F) != 0) oo += "\0";
			return oo;
		};
	})();
	return {
		to_workbook: dif_to_workbook,
		to_sheet: dif_to_sheet,
		from_sheet: sheet_to_dif
	};
})();

var ETH = (function() {
	function decode(s/*:string*/)/*:string*/ { return s.replace(/\\b/g,"\\").replace(/\\c/g,":").replace(/\\n/g,"\n"); }
	function encode(s/*:string*/)/*:string*/ { return s.replace(/\\/g, "\\b").replace(/:/g, "\\c").replace(/\n/g,"\\n"); }

	function eth_to_aoa(str/*:string*/, opts)/*:AOA*/ {
		var records = str.split('\n'), R = -1, C = -1, ri = 0, arr/*:AOA*/ = [];
		for (; ri !== records.length; ++ri) {
			var record = records[ri].trim().split(":");
			if(record[0] !== 'cell') continue;
			var addr = decode_cell(record[1]);
			if(arr.length <= addr.r) for(R = arr.length; R <= addr.r; ++R) if(!arr[R]) arr[R] = [];
			R = addr.r; C = addr.c;
			switch(record[2]) {
				case 't': arr[R][C] = decode(record[3]); break;
				case 'v': arr[R][C] = +record[3]; break;
				case 'vtf': var _f = record[record.length - 1];
					/* falls through */
				case 'vtc':
					switch(record[3]) {
						case 'nl': arr[R][C] = +record[4] ? true : false; break;
						default: arr[R][C] = +record[4]; break;
					}
					if(record[2] == 'vtf') arr[R][C] = [arr[R][C], _f];
			}
		}
		if(opts && opts.sheetRows) arr = arr.slice(0, opts.sheetRows);
		return arr;
	}

	function eth_to_sheet(d/*:string*/, opts)/*:Worksheet*/ { return aoa_to_sheet(eth_to_aoa(d, opts), opts); }
	function eth_to_workbook(d/*:string*/, opts)/*:Workbook*/ { return sheet_to_workbook(eth_to_sheet(d, opts), opts); }

	var header = [
		"socialcalc:version:1.5",
		"MIME-Version: 1.0",
		"Content-Type: multipart/mixed; boundary=SocialCalcSpreadsheetControlSave"
	].join("\n");

	var sep = [
		"--SocialCalcSpreadsheetControlSave",
		"Content-type: text/plain; charset=UTF-8"
	].join("\n") + "\n";

	/* TODO: the other parts */
	var meta = [
		"# SocialCalc Spreadsheet Control Save",
		"part:sheet"
	].join("\n");

	var end = "--SocialCalcSpreadsheetControlSave--";

	function sheet_to_eth_data(ws/*:Worksheet*/)/*:string*/ {
		if(!ws || !ws['!ref']) return "";
		var o/*:Array<string>*/ = [], oo/*:Array<string>*/ = [], cell, coord = "";
		var r = decode_range(ws['!ref']);
		var dense = Array.isArray(ws);
		for(var R = r.s.r; R <= r.e.r; ++R) {
			for(var C = r.s.c; C <= r.e.c; ++C) {
				coord = encode_cell({r:R,c:C});
				cell = dense ? (ws[R]||[])[C] : ws[coord];
				if(!cell || cell.v == null || cell.t === 'z') continue;
				oo = ["cell", coord, 't'];
				switch(cell.t) {
					case 's': case 'str': oo.push(encode(cell.v)); break;
					case 'n':
						if(!cell.f) { oo[2]='v'; oo[3]=cell.v; }
						else { oo[2]='vtf'; oo[3]='n'; oo[4]=cell.v; oo[5]=encode(cell.f); }
						break;
					case 'b':
						oo[2] = 'vt'+(cell.f?'f':'c'); oo[3]='nl'; oo[4]=cell.v?"1":"0";
						oo[5] = encode(cell.f||(cell.v?'TRUE':'FALSE'));
						break;
					case 'd':
						var t = datenum(parseDate(cell.v));
						oo[2] = 'vtc'; oo[3] = 'nd'; oo[4] = ""+t;
						oo[5] = cell.w || SSF.format(cell.z || SSF._table[14], t);
						break;
					case 'e': continue;
				}
				o.push(oo.join(":"));
			}
		}
		o.push("sheet:c:" + (r.e.c-r.s.c+1) + ":r:" + (r.e.r-r.s.r+1) + ":tvf:1");
		o.push("valueformat:1:text-wiki");
		//o.push("copiedfrom:" + ws['!ref']); // clipboard only
		return o.join("\n");
	}

	function sheet_to_eth(ws/*:Worksheet*//*::, opts:?any*/)/*:string*/ {
		return [header, sep, meta, sep, sheet_to_eth_data(ws), end].join("\n");
		// return ["version:1.5", sheet_to_eth_data(ws)].join("\n"); // clipboard form
	}

	return {
		to_workbook: eth_to_workbook,
		to_sheet: eth_to_sheet,
		from_sheet: sheet_to_eth
	};
})();

var PRN = (function() {
	function set_text_arr(data/*:string*/, arr/*:AOA*/, R/*:number*/, C/*:number*/, o/*:any*/) {
		if(o.raw) arr[R][C] = data;
		else if(data === "");
		else if(data === 'TRUE') arr[R][C] = true;
		else if(data === 'FALSE') arr[R][C] = false;
		else if(!isNaN(fuzzynum(data))) arr[R][C] = fuzzynum(data);
		else if(!isNaN(fuzzydate(data).getDate())) arr[R][C] = parseDate(data);
		else arr[R][C] = data;
	}

	function prn_to_aoa_str(f/*:string*/, opts)/*:AOA*/ {
		var o = opts || {};
		var arr/*:AOA*/ = ([]/*:any*/);
		if(!f || f.length === 0) return arr;
		var lines = f.split(/[\r\n]/);
		var L = lines.length - 1;
		while(L >= 0 && lines[L].length === 0) --L;
		var start = 10, idx = 0;
		var R = 0;
		for(; R <= L; ++R) {
			idx = lines[R].indexOf(" ");
			if(idx == -1) idx = lines[R].length; else idx++;
			start = Math.max(start, idx);
		}
		for(R = 0; R <= L; ++R) {
			arr[R] = [];
			/* TODO: confirm that widths are always 10 */
			var C = 0;
			set_text_arr(lines[R].slice(0, start).trim(), arr, R, C, o);
			for(C = 1; C <= (lines[R].length - start)/10 + 1; ++C)
				set_text_arr(lines[R].slice(start+(C-1)*10,start+C*10).trim(),arr,R,C,o);
		}
		if(o.sheetRows) arr = arr.slice(0, o.sheetRows);
		return arr;
	}

	// List of accepted CSV separators
	var guess_seps = {
		/*::[*/0x2C/*::]*/: ',',
		/*::[*/0x09/*::]*/: "\t",
		/*::[*/0x3B/*::]*/: ';',
		/*::[*/0x7C/*::]*/: '|'
	};

	// CSV separator weights to be used in case of equal numbers
	var guess_sep_weights = {
		/*::[*/0x2C/*::]*/: 3,
		/*::[*/0x09/*::]*/: 2,
		/*::[*/0x3B/*::]*/: 1,
		/*::[*/0x7C/*::]*/: 0
	};

	function guess_sep(str) {
		var cnt = {}, instr = false, end = 0, cc = 0;
		for(;end < str.length;++end) {
			if((cc=str.charCodeAt(end)) == 0x22) instr = !instr;
			else if(!instr && cc in guess_seps) cnt[cc] = (cnt[cc]||0)+1;
		}

		cc = [];
		for(end in cnt) if ( Object.prototype.hasOwnProperty.call(cnt, end) ) {
			cc.push([ cnt[end], end ]);
		}

		if ( !cc.length ) {
			cnt = guess_sep_weights;
			for(end in cnt) if ( Object.prototype.hasOwnProperty.call(cnt, end) ) {
				cc.push([ cnt[end], end ]);
			}
		}

		cc.sort(function(a, b) { return a[0] - b[0] || guess_sep_weights[a[1]] - guess_sep_weights[b[1]]; });

		return guess_seps[cc.pop()[1]] || 0x2C;
	}

	function dsv_to_sheet_str(str/*:string*/, opts)/*:Worksheet*/ {
		var o = opts || {};
		var sep = "";
		var ws/*:Worksheet*/ = o.dense ? ([]/*:any*/) : ({}/*:any*/);
		var range/*:Range*/ = ({s: {c:0, r:0}, e: {c:0, r:0}}/*:any*/);

		if(str.slice(0,4) == "sep=") {
			// If the line ends in \r\n
			if(str.charCodeAt(5) == 13 && str.charCodeAt(6) == 10 ) {
				sep = str.charAt(4); str = str.slice(7);
			}
			// If line ends in \r OR \n
			else if(str.charCodeAt(5) == 13 || str.charCodeAt(5) == 10 ) {
				sep = str.charAt(4); str = str.slice(6);
			}
			else sep = guess_sep(str.slice(0,1024));
		}
		else if(o && o.FS) sep = o.FS;
		else sep = guess_sep(str.slice(0,1024));
		var R = 0, C = 0, v = 0;
		var start = 0, end = 0, sepcc = sep.charCodeAt(0), instr = false, cc=0, startcc=str.charCodeAt(0);
		str = str.replace(/\r\n/mg, "\n");
		var _re/*:?RegExp*/ = o.dateNF != null ? dateNF_regex(o.dateNF) : null;
		function finish_cell() {
			var s = str.slice(start, end);
			var cell = ({}/*:any*/);
			if(s.charAt(0) == '"' && s.charAt(s.length - 1) == '"') s = s.slice(1,-1).replace(/""/g,'"');
			if(s.length === 0) cell.t = 'z';
			else if(o.raw) { cell.t = 's'; cell.v = s; }
			else if(s.trim().length === 0) { cell.t = 's'; cell.v = s; }
			else if(s.charCodeAt(0) == 0x3D) {
				if(s.charCodeAt(1) == 0x22 && s.charCodeAt(s.length - 1) == 0x22) { cell.t = 's'; cell.v = s.slice(2,-1).replace(/""/g,'"'); }
				else if(fuzzyfmla(s)) { cell.t = 'n'; cell.f = s.slice(1); }
				else { cell.t = 's'; cell.v = s; } }
			else if(s == "TRUE") { cell.t = 'b'; cell.v = true; }
			else if(s == "FALSE") { cell.t = 'b'; cell.v = false; }
			else if(!isNaN(v = fuzzynum(s))) { cell.t = 'n'; if(o.cellText !== false) cell.w = s; cell.v = v; }
			else if(!isNaN(fuzzydate(s).getDate()) || _re && s.match(_re)) {
				cell.z = o.dateNF || SSF._table[14];
				var k = 0;
				if(_re && s.match(_re)){ s=dateNF_fix(s, o.dateNF, (s.match(_re)||[])); k=1; }
				if(o.cellDates) { cell.t = 'd'; cell.v = parseDate(s, k); }
				else { cell.t = 'n'; cell.v = datenum(parseDate(s, k)); }
				if(o.cellText !== false) cell.w = SSF.format(cell.z, cell.v instanceof Date ? datenum(cell.v):cell.v);
				if(!o.cellNF) delete cell.z;
			} else {
				cell.t = 's';
				cell.v = s;
			}
			if(cell.t == 'z');
			else if(o.dense) { if(!ws[R]) ws[R] = []; ws[R][C] = cell; }
			else ws[encode_cell({c:C,r:R})] = cell;
			start = end+1; startcc = str.charCodeAt(start);
			if(range.e.c < C) range.e.c = C;
			if(range.e.r < R) range.e.r = R;
			if(cc == sepcc) ++C; else { C = 0; ++R; if(o.sheetRows && o.sheetRows <= R) return true; }
		}
		outer: for(;end < str.length;++end) switch((cc=str.charCodeAt(end))) {
			case 0x22: if(startcc === 0x22) instr = !instr; break;
			case sepcc: case 0x0a: case 0x0d: if(!instr && finish_cell()) break outer; break;
		}
		if(end - start > 0) finish_cell();

		ws['!ref'] = encode_range(range);
		return ws;
	}

	function prn_to_sheet_str(str/*:string*/, opts)/*:Worksheet*/ {
		if(!(opts && opts.PRN)) return dsv_to_sheet_str(str, opts);
		if(opts.FS) return dsv_to_sheet_str(str, opts);
		if(str.slice(0,4) == "sep=") return dsv_to_sheet_str(str, opts);
		if(str.indexOf("\t") >= 0 || str.indexOf(",") >= 0 || str.indexOf(";") >= 0) return dsv_to_sheet_str(str, opts);
		return aoa_to_sheet(prn_to_aoa_str(str, opts), opts);
	}

	function prn_to_sheet(d/*:RawData*/, opts)/*:Worksheet*/ {
		var str = "", bytes = opts.type == 'string' ? [0,0,0,0] : firstbyte(d, opts);
		switch(opts.type) {
			case 'base64': str = Base64.decode(d); break;
			case 'binary': str = d; break;
			case 'buffer':
				if(opts.codepage == 65001) str = d.toString('utf8'); // TODO: test if buf
				else if(opts.codepage && typeof cptable !== 'undefined') str = cptable.utils.decode(opts.codepage, d);
				else str = has_buf && Buffer.isBuffer(d) ? d.toString('binary') : a2s(d);
				break;
			case 'array': str = cc2str(d); break;
			case 'string': str = d; break;
			default: throw new Error("Unrecognized type " + opts.type);
		}
		if(bytes[0] == 0xEF && bytes[1] == 0xBB && bytes[2] == 0xBF) str = utf8read(str.slice(3));
		else if(opts.type != 'string' && opts.type != 'buffer' && opts.codepage == 65001) str = utf8read(str);
		else if((opts.type == 'binary') && typeof cptable !== 'undefined' && opts.codepage)  str = cptable.utils.decode(opts.codepage, cptable.utils.encode(28591,str));
		if(str.slice(0,19) == "socialcalc:version:") return ETH.to_sheet(opts.type == 'string' ? str : utf8read(str), opts);
		return prn_to_sheet_str(str, opts);
	}

	function prn_to_workbook(d/*:RawData*/, opts)/*:Workbook*/ { return sheet_to_workbook(prn_to_sheet(d, opts), opts); }

	function sheet_to_prn(ws/*:Worksheet*//*::, opts:?any*/)/*:string*/ {
		var o/*:Array<string>*/ = [];
		var r = safe_decode_range(ws['!ref']), cell/*:Cell*/;
		var dense = Array.isArray(ws);
		for(var R = r.s.r; R <= r.e.r; ++R) {
			var oo/*:Array<string>*/ = [];
			for(var C = r.s.c; C <= r.e.c; ++C) {
				var coord = encode_cell({r:R,c:C});
				cell = dense ? (ws[R]||[])[C] : ws[coord];
				if(!cell || cell.v == null) { oo.push("          "); continue; }
				var w = (cell.w || (format_cell(cell), cell.w) || "").slice(0,10);
				while(w.length < 10) w += " ";
				oo.push(w + (C === 0 ? " " : ""));
			}
			o.push(oo.join(""));
		}
		return o.join("\n");
	}

	return {
		to_workbook: prn_to_workbook,
		to_sheet: prn_to_sheet,
		from_sheet: sheet_to_prn
	};
})();

/* Excel defaults to SYLK but warns if data is not valid */
function read_wb_ID(d, opts) {
	var o = opts || {}, OLD_WTF = !!o.WTF; o.WTF = true;
	try {
		var out = SYLK.to_workbook(d, o);
		o.WTF = OLD_WTF;
		return out;
	} catch(e) {
		o.WTF = OLD_WTF;
		if(!e.message.match(/SYLK bad record ID/) && OLD_WTF) throw e;
		return PRN.to_workbook(d, opts);
	}
}

var WK_ = /*#__PURE__*/ (function() {
	function lotushopper(data, cb/*:RecordHopperCB*/, opts/*:any*/) {
		if(!data) return;
		prep_blob(data, data.l || 0);
		var Enum = opts.Enum || WK1Enum;
		while(data.l < data.length) {
			var RT = data.read_shift(2);
			var R = Enum[RT] || Enum[0xFFFF];
			var length = data.read_shift(2);
			var tgt = data.l + length;
			var d = R.f && R.f(data, length, opts);
			data.l = tgt;
			if(cb(d, R, RT)) return;
		}
	}

	function lotus_to_workbook(d/*:RawData*/, opts) {
		switch(opts.type) {
			case 'base64': return lotus_to_workbook_buf(s2a(Base64.decode(d)), opts);
			case 'binary': return lotus_to_workbook_buf(s2a(d), opts);
			case 'buffer':
			case 'array': return lotus_to_workbook_buf(d, opts);
		}
		throw "Unsupported type " + opts.type;
	}

	function lotus_to_workbook_buf(d, opts)/*:Workbook*/ {
		if(!d) return d;
		var o = opts || {};
		var s/*:Worksheet*/ = ((o.dense ? [] : {})/*:any*/), n = "Sheet1", next_n = "", sidx = 0;
		var sheets = {}, snames = [], realnames = [];

		var refguess = {s: {r:0, c:0}, e: {r:0, c:0} };
		var sheetRows = o.sheetRows || 0;

		if(d[2] == 0x00) {
			if(d[3] == 0x08 || d[3] == 0x09) {
				if(d.length >= 16 && d[14] == 0x05 && d[15] === 0x6c) throw new Error("Unsupported Works 3 for Mac file");
			}
		}

		if(d[2] == 0x02) {
			o.Enum = WK1Enum;
			lotushopper(d, function(val, R, RT) { switch(RT) {
				case 0x00: /* BOF */
					o.vers = val;
					if(val >= 0x1000) o.qpro = true;
					break;
				case 0x06: refguess = val; break; /* RANGE */
				case 0xCC: if(val) next_n = val; break; /* SHEETNAMECS */
				case 0xDE: next_n = val; break; /* SHEETNAMELP */
				case 0x0F: /* LABEL */
				case 0x33: /* STRING */
					if(!o.qpro) val[1].v = val[1].v.slice(1);
					/* falls through */
				case 0x0D: /* INTEGER */
				case 0x0E: /* NUMBER */
				case 0x10: /* FORMULA */
					/* TODO: actual translation of the format code */
					if(RT == 0x0E && (val[2] & 0x70) == 0x70 && (val[2] & 0x0F) > 1 && (val[2] & 0x0F) < 15) {
						val[1].z = o.dateNF || SSF._table[14];
						if(o.cellDates) { val[1].t = 'd'; val[1].v = numdate(val[1].v); }
					}

					if(o.qpro) {
						if(val[3] > sidx) {
							s["!ref"] = encode_range(refguess);
							sheets[n] = s;
							snames.push(n);
							s = (o.dense ? [] : {});
							refguess = {s: {r:0, c:0}, e: {r:0, c:0} };
							sidx = val[3]; n = next_n || "Sheet" + (sidx + 1); next_n = "";
						}
					}

					var tmpcell = o.dense ? (s[val[0].r]||[])[val[0].c] : s[encode_cell(val[0])];
					if(tmpcell) {
						tmpcell.t = val[1].t; tmpcell.v = val[1].v;
						if(val[1].z != null) tmpcell.z = val[1].z;
						if(val[1].f != null) tmpcell.f = val[1].f;
						break;
					}
					if(o.dense) {
						if(!s[val[0].r]) s[val[0].r] = [];
						s[val[0].r][val[0].c] = val[1];
					} else s[encode_cell(val[0])] = val[1];
					break;
			}}, o);
		} else if(d[2] == 0x1A || d[2] == 0x0E) {
			o.Enum = WK3Enum;
			if(d[2] == 0x0E) { o.qpro = true; d.l = 0; }
			lotushopper(d, function(val, R, RT) { switch(RT) {
				case 0xCC: n = val; break; /* SHEETNAMECS */
				case 0x16: /* LABEL16 */
					val[1].v = val[1].v.slice(1);
					/* falls through */
				case 0x17: /* NUMBER17 */
				case 0x18: /* NUMBER18 */
				case 0x19: /* FORMULA19 */
				case 0x25: /* NUMBER25 */
				case 0x27: /* NUMBER27 */
				case 0x28: /* FORMULA28 */
					if(val[3] > sidx) {
						s["!ref"] = encode_range(refguess);
						sheets[n] = s;
						snames.push(n);
						s = (o.dense ? [] : {});
						refguess = {s: {r:0, c:0}, e: {r:0, c:0} };
						sidx = val[3]; n = "Sheet" + (sidx + 1);
					}
					if(sheetRows > 0 && val[0].r >= sheetRows) break;
					if(o.dense) {
						if(!s[val[0].r]) s[val[0].r] = [];
						s[val[0].r][val[0].c] = val[1];
					} else s[encode_cell(val[0])] = val[1];
					if(refguess.e.c < val[0].c) refguess.e.c = val[0].c;
					if(refguess.e.r < val[0].r) refguess.e.r = val[0].r;
					break;
				case 0x1B: /* XFORMAT */
					if(val[0x36b0]) realnames[val[0x36b0][0]] = val[0x36b0][1];
					break;
				case 0x0601: /* SHEETINFOQP */
					realnames[val[0]] = val[1]; if(val[0] == sidx) n = val[1]; break;
			}}, o);
		} else throw new Error("Unrecognized LOTUS BOF " + d[2]);
		s["!ref"] = encode_range(refguess);
		sheets[next_n || n] = s;
		snames.push(next_n || n);
		if(!realnames.length) return { SheetNames: snames, Sheets: sheets };
		var osheets = {}, rnames = [];
		/* TODO: verify no collisions */
		for(var i = 0; i < realnames.length; ++i) if(sheets[snames[i]]) {
			rnames.push(realnames[i] || snames[i]);
			osheets[realnames[i]] = sheets[realnames[i]] || sheets[snames[i]];
		} else {
			rnames.push(realnames[i]);
			osheets[realnames[i]] = ({ "!ref": "A1" });
		}
		return { SheetNames: rnames, Sheets: osheets };
	}

	function sheet_to_wk1(ws/*:Worksheet*/, opts/*:WriteOpts*/) {
		var o = opts || {};
		if(+o.codepage >= 0) set_cp(+o.codepage);
		if(o.type == "string") throw new Error("Cannot write WK1 to JS string");
		var ba = buf_array();
		var range = safe_decode_range(ws["!ref"]);
		var dense = Array.isArray(ws);
		var cols = [];

		write_biff_rec(ba, 0x00, write_BOF_WK1(0x0406));
		write_biff_rec(ba, 0x06, write_RANGE(range));
		var max_R = Math.min(range.e.r, 8191);
		for(var R = range.s.r; R <= max_R; ++R) {
			var rr = encode_row(R);
			for(var C = range.s.c; C <= range.e.c; ++C) {
				if(R === range.s.r) cols[C] = encode_col(C);
				var ref = cols[C] + rr;
				var cell = dense ? (ws[R]||[])[C] : ws[ref];
				if(!cell || cell.t == "z") continue;
				/* TODO: formula records */
				if(cell.t == "n") {
					if((cell.v|0)==cell.v && cell.v >= -32768 && cell.v <= 32767) write_biff_rec(ba, 0x0d, write_INTEGER(R, C, cell.v));
					else write_biff_rec(ba, 0x0e, write_NUMBER(R, C, cell.v));
				} else {
					var str = format_cell(cell);
					write_biff_rec(ba, 0x0F, write_LABEL(R, C, str.slice(0, 239)));
				}
			}
		}

		write_biff_rec(ba, 0x01);
		return ba.end();
	}

	function book_to_wk3(wb/*:Workbook*/, opts/*:WriteOpts*/) {
		var o = opts || {};
		if(+o.codepage >= 0) set_cp(+o.codepage);
		if(o.type == "string") throw new Error("Cannot write WK3 to JS string");
		var ba = buf_array();

		write_biff_rec(ba, 0x00, write_BOF_WK3(wb));

		for(var i = 0, cnt = 0; i < wb.SheetNames.length; ++i) if((wb.Sheets[wb.SheetNames[i]] || {})["!ref"]) write_biff_rec(ba, 0x1b, write_XFORMAT_SHEETNAME(wb.SheetNames[i], cnt++));

		var wsidx = 0;
		for(i = 0; i < wb.SheetNames.length; ++i) {
			var ws = wb.Sheets[wb.SheetNames[i]];
			if(!ws || !ws["!ref"]) continue;
			var range = safe_decode_range(ws["!ref"]);
			var dense = Array.isArray(ws);
			var cols = [];
			var max_R = Math.min(range.e.r, 8191);
			for(var R = range.s.r; R <= max_R; ++R) {
				var rr = encode_row(R);
				for(var C = range.s.c; C <= range.e.c; ++C) {
					if(R === range.s.r) cols[C] = encode_col(C);
					var ref = cols[C] + rr;
					var cell = dense ? (ws[R]||[])[C] : ws[ref];
					if(!cell || cell.t == "z") continue;
					/* TODO: FORMULA19 NUMBER18 records */
					if(cell.t == "n") {
						write_biff_rec(ba, 0x17, write_NUMBER_17(R, C, wsidx, cell.v));
					} else {
						var str = format_cell(cell);
						/* TODO: max len? */
						write_biff_rec(ba, 0x16, write_LABEL_16(R, C, wsidx, str.slice(0, 239)));
					}
				}
			}
			++wsidx;
		}

		write_biff_rec(ba, 0x01);
		return ba.end();
	}


	function write_BOF_WK1(v/*:number*/) {
		var out = new_buf(2);
		out.write_shift(2, v);
		return out;
	}

	function write_BOF_WK3(wb/*:Workbook*/) {
		var out = new_buf(26);
		out.write_shift(2, 0x1000);
		out.write_shift(2, 0x0004);
		out.write_shift(4, 0x0000);
		var rows = 0, cols = 0, wscnt = 0;
		for(var i = 0; i < wb.SheetNames.length; ++i) {
			var name = wb.SheetNames[i];
			var ws = wb.Sheets[name];
			if(!ws || !ws["!ref"]) continue;
			++wscnt;
			var range = decode_range(ws["!ref"]);
			if(rows < range.e.r) rows = range.e.r;
			if(cols < range.e.c) cols = range.e.c;
		}
		if(rows > 8191) rows = 8191;
		out.write_shift(2, rows);
		out.write_shift(1, wscnt);
		out.write_shift(1, cols);
		out.write_shift(2, 0x00);
		out.write_shift(2, 0x00);
		out.write_shift(1, 0x01);
		out.write_shift(1, 0x02);
		out.write_shift(4, 0);
		out.write_shift(4, 0);
		return out;
	}

	function parse_RANGE(blob, length, opts) {
		var o = {s:{c:0,r:0},e:{c:0,r:0}};
		if(length == 8 && opts.qpro) {
			o.s.c = blob.read_shift(1);
			blob.l++;
			o.s.r = blob.read_shift(2);
			o.e.c = blob.read_shift(1);
			blob.l++;
			o.e.r = blob.read_shift(2);
			return o;
		}
		o.s.c = blob.read_shift(2);
		o.s.r = blob.read_shift(2);
		if(length == 12 && opts.qpro) blob.l += 2;
		o.e.c = blob.read_shift(2);
		o.e.r = blob.read_shift(2);
		if(length == 12 && opts.qpro) blob.l += 2;
		if(o.s.c == 0xFFFF) o.s.c = o.e.c = o.s.r = o.e.r = 0;
		return o;
	}
	function write_RANGE(range) {
		var out = new_buf(8);
		out.write_shift(2, range.s.c);
		out.write_shift(2, range.s.r);
		out.write_shift(2, range.e.c);
		out.write_shift(2, range.e.r);
		return out;
	}

	function parse_cell(blob, length, opts) {
		var o = [{c:0,r:0}, {t:'n',v:0}, 0, 0];
		if(opts.qpro && opts.vers != 0x5120) {
			o[0].c = blob.read_shift(1);
			o[3] = blob.read_shift(1);
			o[0].r = blob.read_shift(2);
			blob.l+=2;
		} else {
			o[2] = blob.read_shift(1);
			o[0].c = blob.read_shift(2); o[0].r = blob.read_shift(2);
		}
		return o;
	}

	function parse_LABEL(blob, length, opts) {
		var tgt = blob.l + length;
		var o = parse_cell(blob, length, opts);
		o[1].t = 's';
		if(opts.vers == 0x5120) {
			blob.l++;
			var len = blob.read_shift(1);
			o[1].v = blob.read_shift(len, 'utf8');
			return o;
		}
		if(opts.qpro) blob.l++;
		o[1].v = blob.read_shift(tgt - blob.l, 'cstr');
		return o;
	}
	function write_LABEL(R, C, s) {
		/* TODO: encoding */
		var o = new_buf(7 + s.length);
		o.write_shift(1, 0xFF);
		o.write_shift(2, C);
		o.write_shift(2, R);
		o.write_shift(1, 0x27); // ??
		for(var i = 0; i < o.length; ++i) {
			var cc = s.charCodeAt(i);
			o.write_shift(1, cc >= 0x80 ? 0x5F : cc);
		}
		o.write_shift(1, 0);
		return o;
	}

	function parse_INTEGER(blob, length, opts) {
		var o = parse_cell(blob, length, opts);
		o[1].v = blob.read_shift(2, 'i');
		return o;
	}
	function write_INTEGER(R, C, v) {
		var o = new_buf(7);
		o.write_shift(1, 0xFF);
		o.write_shift(2, C);
		o.write_shift(2, R);
		o.write_shift(2, v, 'i');
		return o;
	}

	function parse_NUMBER(blob, length, opts) {
		var o = parse_cell(blob, length, opts);
		o[1].v = blob.read_shift(8, 'f');
		return o;
	}
	function write_NUMBER(R, C, v) {
		var o = new_buf(13);
		o.write_shift(1, 0xFF);
		o.write_shift(2, C);
		o.write_shift(2, R);
		o.write_shift(8, v, 'f');
		return o;
	}

	function parse_FORMULA(blob, length, opts) {
		var tgt = blob.l + length;
		var o = parse_cell(blob, length, opts);
		/* TODO: formula */
		o[1].v = blob.read_shift(8, 'f');
		if(opts.qpro) blob.l = tgt;
		else {
			var flen = blob.read_shift(2);
			wk1_fmla_to_csf(blob.slice(blob.l, blob.l + flen), o);
			blob.l += flen;
		}
		return o;
	}

	function wk1_parse_rc(B, V, col) {
		var rel = V & 0x8000;
		V &= ~0x8000;
		V = (rel ? B : 0) + ((V >= 0x2000) ? V - 0x4000 : V);
		return (rel ? "" : "$") + (col ? encode_col(V) : encode_row(V));
	}
	/* TODO: flesh out */
	var FuncTab = {
		0x33: ["FALSE", 0],
		0x34: ["TRUE", 0],
		0x46: ["LEN", 1],
		0x50: ["SUM", 69],
		0x51: ["AVERAGEA", 69],
		0x52: ["COUNTA", 69],
		0x53: ["MINA", 69],
		0x54: ["MAXA", 69],
		0x6F: ["T", 1]
	};
	var BinOpTab = [
		  "",   "",   "",   "",   "",   "",   "",   "",
		  "",  "+",  "-",  "*",  "/",  "^",  "=", "<>",
		"<=", ">=",  "<",  ">",   "",   "",   "",   "",
		 "&",   "",   "",   "",   "",   "",   "",   ""
	];

	function wk1_fmla_to_csf(blob, o) {
		prep_blob(blob, 0);
		var out = [], argc = 0, R = "", C = "", argL = "", argR = "";
		while(blob.l < blob.length) {
			var cc = blob[blob.l++];
			switch(cc) {
				case 0x00: out.push(blob.read_shift(8, 'f')); break;
				case 0x01: {
					C = wk1_parse_rc(o[0].c, blob.read_shift(2), true);
					R = wk1_parse_rc(o[0].r, blob.read_shift(2), false);
					out.push(C + R);
				} break;
				case 0x02: {
					var c = wk1_parse_rc(o[0].c, blob.read_shift(2), true);
					var r = wk1_parse_rc(o[0].r, blob.read_shift(2), false);
					C = wk1_parse_rc(o[0].c, blob.read_shift(2), true);
					R = wk1_parse_rc(o[0].r, blob.read_shift(2), false);
					out.push(c + r + ":" + C + R);
				} break;
				case 0x03:
					if(blob.l < blob.length) { console.error("WK1 premature formula end"); return; }
					break;
				case 0x04: out.push("(" + out.pop() + ")"); break;
				case 0x05: out.push(blob.read_shift(2)); break;
				case 0x06: {
					/* TODO: text encoding */
					var Z = ""; while((cc = blob[blob.l++])) Z += String.fromCharCode(cc);
					out.push('"' + Z.replace(/"/g, '""') + '"'); break;
				}
				case 0x08: out.push("-" + out.pop()); break;
				case 0x17: out.push("+" + out.pop()); break;
				case 0x16: out.push("NOT(" + out.pop() + ")"); break;

				case 0x14: case 0x15: {
					argR = out.pop(); argL = out.pop();
					out.push(["AND", "OR"][cc - 0x14] + "(" + argL + "," + argR + ")");
				} break;

				default:
					if(cc < 0x20 && BinOpTab[cc]) {
						argR = out.pop(); argL = out.pop();
						out.push(argL + BinOpTab[cc] + argR);
					} else if(FuncTab[cc]) {
						argc = FuncTab[cc][1];
						if(argc == 69) argc = blob[blob.l++];
						if(argc > out.length) { console.error("WK1 bad formula parse 0x" + cc.toString(16) + ":|" + out.join("|") + "|"); return; }
						var args = out.slice(-argc);
						out.length -= argc;
						out.push(FuncTab[cc][0] + "(" + args.join(",") + ")");
					}
					else if(cc <= 0x07) return console.error("WK1 invalid opcode " + cc.toString(16));
					else if(cc <= 0x18) return console.error("WK1 unsupported op " + cc.toString(16));
					else if(cc <= 0x1E) return console.error("WK1 invalid opcode " + cc.toString(16));
					else if(cc <= 0x73) return console.error("WK1 unsupported function opcode " + cc.toString(16));
					// possible future functions ??
					else return console.error("WK1 unrecognized opcode " + cc.toString(16));
			}
		}
		if(out.length == 1) o[1].f = "" + out[0];
		else console.error("WK1 bad formula parse |" + out.join("|") + "|");
	}


	function parse_cell_3(blob/*::, length*/) {
		var o = [{c:0,r:0}, {t:'n',v:0}, 0];
		o[0].r = blob.read_shift(2); o[3] = blob[blob.l++]; o[0].c = blob[blob.l++];
		return o;
	}

	function parse_LABEL_16(blob, length) {
		var o = parse_cell_3(blob);
		o[1].t = 's';
		o[1].v = blob.read_shift(length - 4, 'cstr');
		return o;
	}
	function write_LABEL_16(R, C, wsidx, s) {
		/* TODO: encoding */
		var o = new_buf(6 + s.length);
		o.write_shift(2, R);
		o.write_shift(1, wsidx);
		o.write_shift(1, C);
		o.write_shift(1, 0x27);
		for(var i = 0; i < s.length; ++i) {
			var cc = s.charCodeAt(i);
			o.write_shift(1, cc >= 0x80 ? 0x5F : cc);
		}
		o.write_shift(1, 0);
		return o;
	}

	function parse_NUMBER_18(blob, length) {
		var o = parse_cell_3(blob);
		o[1].v = blob.read_shift(2);
		var v = o[1].v >> 1;
		if(o[1].v & 0x1) {
			switch(v & 0x07) {
				case 0: v = (v >> 3) * 5000; break;
				case 1: v = (v >> 3) * 500; break;
				case 2: v = (v >> 3) / 20; break;
				case 3: v = (v >> 3) / 200; break;
				case 4: v = (v >> 3) / 2000; break;
				case 5: v = (v >> 3) / 20000; break;
				case 6: v = (v >> 3) / 16; break;
				case 7: v = (v >> 3) / 64; break;
			}
		}
		o[1].v = v;
		return o;
	}

	function parse_NUMBER_17(blob, length) {
		var o = parse_cell_3(blob);
		var v1 = blob.read_shift(4);
		var v2 = blob.read_shift(4);
		var e = blob.read_shift(2);
		if(e == 0xFFFF) {
			if(v1 === 0 && v2 === 0xC0000000) { o[1].t = "e"; o[1].v = 0x0F; } // ERR -> #VALUE!
			else if(v1 === 0 && v2 === 0xD0000000) { o[1].t = "e"; o[1].v = 0x2A; } // NA -> #N/A
			else o[1].v = 0;
			return o;
		}
		var s = e & 0x8000; e = (e&0x7FFF) - 16446;
		o[1].v = (1 - s*2) * (v2 * Math.pow(2, e+32) + v1 * Math.pow(2, e));
		return o;
	}
	function write_NUMBER_17(R, C, wsidx, v) {
		var o = new_buf(14);
		o.write_shift(2, R);
		o.write_shift(1, wsidx);
		o.write_shift(1, C);
		if(v == 0) {
			o.write_shift(4, 0);
			o.write_shift(4, 0);
			o.write_shift(2, 0xFFFF);
			return o;
		}
		var s = 0, e = 0, v1 = 0, v2 = 0;
		if(v < 0) { s = 1; v = -v; }
		e = Math.log2(v) | 0;
		v /= Math.pow(2, e-31);
		v2 = (v)>>>0;
		if((v2&0x80000000) == 0) { v/=2; ++e; v2 = v >>> 0; }
		v -= v2;
		v2 |= 0x80000000;
		v2 >>>= 0;
		v *= Math.pow(2, 32);
		v1 = v>>>0;
		o.write_shift(4, v1);
		o.write_shift(4, v2);
		e += 0x3FFF + (s ? 0x8000 : 0);
		o.write_shift(2, e);
		return o;
	}

	function parse_FORMULA_19(blob, length) {
		var o = parse_NUMBER_17(blob);
		blob.l += length - 14; /* TODO: WK3 formula */
		return o;
	}

	function parse_NUMBER_25(blob, length) {
		var o = parse_cell_3(blob);
		var v1 = blob.read_shift(4);
		o[1].v = v1 >> 6;
		return o;
	}

	function parse_NUMBER_27(blob, length) {
		var o = parse_cell_3(blob);
		var v1 = blob.read_shift(8,'f');
		o[1].v = v1;
		return o;
	}

	function parse_FORMULA_28(blob, length) {
		var o = parse_NUMBER_27(blob);
		blob.l += length - 10; /* TODO: formula */
		return o;
	}

	function parse_SHEETNAMECS(blob, length) {
		return blob[blob.l + length - 1] == 0 ? blob.read_shift(length, 'cstr') : "";
	}

	function parse_SHEETNAMELP(blob, length) {
		var len = blob[blob.l++];
		if(len > length - 1) len = length - 1;
		var o = ""; while(o.length < len) o += String.fromCharCode(blob[blob.l++]);
		return o;
	}

	function parse_SHEETINFOQP(blob, length, opts) {
		if(!opts.qpro || length < 21) return;
		var id = blob.read_shift(1);
		blob.l += 17;
		var len = blob.read_shift(1);
		blob.l += 2;
		var nm = blob.read_shift(length - 21, 'cstr');
		return [id, nm];
	}

	function parse_XFORMAT(blob, length) {
		var o = {}, tgt = blob.l + length;
		while(blob.l < tgt) {
			var dt = blob.read_shift(2);
			if(dt == 0x36b0) {
				o[dt] = [0, ""];
				o[dt][0] = blob.read_shift(2);
				while(blob[blob.l]) { o[dt][1] += String.fromCharCode(blob[blob.l]); blob.l++; } blob.l++;
			}
			// TODO: 0x3a99 ??
		}
		return o;
	}
	function write_XFORMAT_SHEETNAME(name, wsidx) {
		var out = new_buf(5 + name.length);
		out.write_shift(2, 0x36b0);
		out.write_shift(2, wsidx);
		for(var i = 0; i < name.length; ++i) {
			var cc = name.charCodeAt(i);
			out[out.l++] = cc > 0x7F ? 0x5F : cc;
		}
		out[out.l++] = 0;
		return out;
	}

	var WK1Enum = {
		/*::[*/0x0000/*::]*/: { n:"BOF", f:parseuint16 },
		/*::[*/0x0001/*::]*/: { n:"EOF" },
		/*::[*/0x0002/*::]*/: { n:"CALCMODE" },
		/*::[*/0x0003/*::]*/: { n:"CALCORDER" },
		/*::[*/0x0004/*::]*/: { n:"SPLIT" },
		/*::[*/0x0005/*::]*/: { n:"SYNC" },
		/*::[*/0x0006/*::]*/: { n:"RANGE", f:parse_RANGE },
		/*::[*/0x0007/*::]*/: { n:"WINDOW1" },
		/*::[*/0x0008/*::]*/: { n:"COLW1" },
		/*::[*/0x0009/*::]*/: { n:"WINTWO" },
		/*::[*/0x000A/*::]*/: { n:"COLW2" },
		/*::[*/0x000B/*::]*/: { n:"NAME" },
		/*::[*/0x000C/*::]*/: { n:"BLANK" },
		/*::[*/0x000D/*::]*/: { n:"INTEGER", f:parse_INTEGER },
		/*::[*/0x000E/*::]*/: { n:"NUMBER", f:parse_NUMBER },
		/*::[*/0x000F/*::]*/: { n:"LABEL", f:parse_LABEL },
		/*::[*/0x0010/*::]*/: { n:"FORMULA", f:parse_FORMULA },
		/*::[*/0x0018/*::]*/: { n:"TABLE" },
		/*::[*/0x0019/*::]*/: { n:"ORANGE" },
		/*::[*/0x001A/*::]*/: { n:"PRANGE" },
		/*::[*/0x001B/*::]*/: { n:"SRANGE" },
		/*::[*/0x001C/*::]*/: { n:"FRANGE" },
		/*::[*/0x001D/*::]*/: { n:"KRANGE1" },
		/*::[*/0x0020/*::]*/: { n:"HRANGE" },
		/*::[*/0x0023/*::]*/: { n:"KRANGE2" },
		/*::[*/0x0024/*::]*/: { n:"PROTEC" },
		/*::[*/0x0025/*::]*/: { n:"FOOTER" },
		/*::[*/0x0026/*::]*/: { n:"HEADER" },
		/*::[*/0x0027/*::]*/: { n:"SETUP" },
		/*::[*/0x0028/*::]*/: { n:"MARGINS" },
		/*::[*/0x0029/*::]*/: { n:"LABELFMT" },
		/*::[*/0x002A/*::]*/: { n:"TITLES" },
		/*::[*/0x002B/*::]*/: { n:"SHEETJS" },
		/*::[*/0x002D/*::]*/: { n:"GRAPH" },
		/*::[*/0x002E/*::]*/: { n:"NGRAPH" },
		/*::[*/0x002F/*::]*/: { n:"CALCCOUNT" },
		/*::[*/0x0030/*::]*/: { n:"UNFORMATTED" },
		/*::[*/0x0031/*::]*/: { n:"CURSORW12" },
		/*::[*/0x0032/*::]*/: { n:"WINDOW" },
		/*::[*/0x0033/*::]*/: { n:"STRING", f:parse_LABEL },
		/*::[*/0x0037/*::]*/: { n:"PASSWORD" },
		/*::[*/0x0038/*::]*/: { n:"LOCKED" },
		/*::[*/0x003C/*::]*/: { n:"QUERY" },
		/*::[*/0x003D/*::]*/: { n:"QUERYNAME" },
		/*::[*/0x003E/*::]*/: { n:"PRINT" },
		/*::[*/0x003F/*::]*/: { n:"PRINTNAME" },
		/*::[*/0x0040/*::]*/: { n:"GRAPH2" },
		/*::[*/0x0041/*::]*/: { n:"GRAPHNAME" },
		/*::[*/0x0042/*::]*/: { n:"ZOOM" },
		/*::[*/0x0043/*::]*/: { n:"SYMSPLIT" },
		/*::[*/0x0044/*::]*/: { n:"NSROWS" },
		/*::[*/0x0045/*::]*/: { n:"NSCOLS" },
		/*::[*/0x0046/*::]*/: { n:"RULER" },
		/*::[*/0x0047/*::]*/: { n:"NNAME" },
		/*::[*/0x0048/*::]*/: { n:"ACOMM" },
		/*::[*/0x0049/*::]*/: { n:"AMACRO" },
		/*::[*/0x004A/*::]*/: { n:"PARSE" },
		/*::[*/0x0066/*::]*/: { n:"PRANGES??" },
		/*::[*/0x0067/*::]*/: { n:"RRANGES??" },
		/*::[*/0x0068/*::]*/: { n:"FNAME??" },
		/*::[*/0x0069/*::]*/: { n:"MRANGES??" },
		/*::[*/0x00CC/*::]*/: { n:"SHEETNAMECS", f:parse_SHEETNAMECS },
		/*::[*/0x00DE/*::]*/: { n:"SHEETNAMELP", f:parse_SHEETNAMELP },
		/*::[*/0xFFFF/*::]*/: { n:"" }
	};

	var WK3Enum = {
		/*::[*/0x0000/*::]*/: { n:"BOF" },
		/*::[*/0x0001/*::]*/: { n:"EOF" },
		/*::[*/0x0002/*::]*/: { n:"PASSWORD" },
		/*::[*/0x0003/*::]*/: { n:"CALCSET" },
		/*::[*/0x0004/*::]*/: { n:"WINDOWSET" },
		/*::[*/0x0005/*::]*/: { n:"SHEETCELLPTR" },
		/*::[*/0x0006/*::]*/: { n:"SHEETLAYOUT" },
		/*::[*/0x0007/*::]*/: { n:"COLUMNWIDTH" },
		/*::[*/0x0008/*::]*/: { n:"HIDDENCOLUMN" },
		/*::[*/0x0009/*::]*/: { n:"USERRANGE" },
		/*::[*/0x000A/*::]*/: { n:"SYSTEMRANGE" },
		/*::[*/0x000B/*::]*/: { n:"ZEROFORCE" },
		/*::[*/0x000C/*::]*/: { n:"SORTKEYDIR" },
		/*::[*/0x000D/*::]*/: { n:"FILESEAL" },
		/*::[*/0x000E/*::]*/: { n:"DATAFILLNUMS" },
		/*::[*/0x000F/*::]*/: { n:"PRINTMAIN" },
		/*::[*/0x0010/*::]*/: { n:"PRINTSTRING" },
		/*::[*/0x0011/*::]*/: { n:"GRAPHMAIN" },
		/*::[*/0x0012/*::]*/: { n:"GRAPHSTRING" },
		/*::[*/0x0013/*::]*/: { n:"??" },
		/*::[*/0x0014/*::]*/: { n:"ERRCELL" },
		/*::[*/0x0015/*::]*/: { n:"NACELL" },
		/*::[*/0x0016/*::]*/: { n:"LABEL16", f:parse_LABEL_16},
		/*::[*/0x0017/*::]*/: { n:"NUMBER17", f:parse_NUMBER_17 },
		/*::[*/0x0018/*::]*/: { n:"NUMBER18", f:parse_NUMBER_18 },
		/*::[*/0x0019/*::]*/: { n:"FORMULA19", f:parse_FORMULA_19},
		/*::[*/0x001A/*::]*/: { n:"FORMULA1A" },
		/*::[*/0x001B/*::]*/: { n:"XFORMAT", f:parse_XFORMAT },
		/*::[*/0x001C/*::]*/: { n:"DTLABELMISC" },
		/*::[*/0x001D/*::]*/: { n:"DTLABELCELL" },
		/*::[*/0x001E/*::]*/: { n:"GRAPHWINDOW" },
		/*::[*/0x001F/*::]*/: { n:"CPA" },
		/*::[*/0x0020/*::]*/: { n:"LPLAUTO" },
		/*::[*/0x0021/*::]*/: { n:"QUERY" },
		/*::[*/0x0022/*::]*/: { n:"HIDDENSHEET" },
		/*::[*/0x0023/*::]*/: { n:"??" },
		/*::[*/0x0025/*::]*/: { n:"NUMBER25", f:parse_NUMBER_25 },
		/*::[*/0x0026/*::]*/: { n:"??" },
		/*::[*/0x0027/*::]*/: { n:"NUMBER27", f:parse_NUMBER_27 },
		/*::[*/0x0028/*::]*/: { n:"FORMULA28", f:parse_FORMULA_28 },
		/*::[*/0x008E/*::]*/: { n:"??" },
		/*::[*/0x0093/*::]*/: { n:"??" },
		/*::[*/0x0096/*::]*/: { n:"??" },
		/*::[*/0x0097/*::]*/: { n:"??" },
		/*::[*/0x0098/*::]*/: { n:"??" },
		/*::[*/0x0099/*::]*/: { n:"??" },
		/*::[*/0x009A/*::]*/: { n:"??" },
		/*::[*/0x009B/*::]*/: { n:"??" },
		/*::[*/0x009C/*::]*/: { n:"??" },
		/*::[*/0x00A3/*::]*/: { n:"??" },
		/*::[*/0x00AE/*::]*/: { n:"??" },
		/*::[*/0x00AF/*::]*/: { n:"??" },
		/*::[*/0x00B0/*::]*/: { n:"??" },
		/*::[*/0x00B1/*::]*/: { n:"??" },
		/*::[*/0x00B8/*::]*/: { n:"??" },
		/*::[*/0x00B9/*::]*/: { n:"??" },
		/*::[*/0x00BA/*::]*/: { n:"??" },
		/*::[*/0x00BB/*::]*/: { n:"??" },
		/*::[*/0x00BC/*::]*/: { n:"??" },
		/*::[*/0x00C3/*::]*/: { n:"??" },
		/*::[*/0x00C9/*::]*/: { n:"??" },
		/*::[*/0x00CC/*::]*/: { n:"SHEETNAMECS", f:parse_SHEETNAMECS },
		/*::[*/0x00CD/*::]*/: { n:"??" },
		/*::[*/0x00CE/*::]*/: { n:"??" },
		/*::[*/0x00CF/*::]*/: { n:"??" },
		/*::[*/0x00D0/*::]*/: { n:"??" },
		/*::[*/0x0100/*::]*/: { n:"??" },
		/*::[*/0x0103/*::]*/: { n:"??" },
		/*::[*/0x0104/*::]*/: { n:"??" },
		/*::[*/0x0105/*::]*/: { n:"??" },
		/*::[*/0x0106/*::]*/: { n:"??" },
		/*::[*/0x0107/*::]*/: { n:"??" },
		/*::[*/0x0109/*::]*/: { n:"??" },
		/*::[*/0x010A/*::]*/: { n:"??" },
		/*::[*/0x010B/*::]*/: { n:"??" },
		/*::[*/0x010C/*::]*/: { n:"??" },
		/*::[*/0x010E/*::]*/: { n:"??" },
		/*::[*/0x010F/*::]*/: { n:"??" },
		/*::[*/0x0180/*::]*/: { n:"??" },
		/*::[*/0x0185/*::]*/: { n:"??" },
		/*::[*/0x0186/*::]*/: { n:"??" },
		/*::[*/0x0189/*::]*/: { n:"??" },
		/*::[*/0x018C/*::]*/: { n:"??" },
		/*::[*/0x0200/*::]*/: { n:"??" },
		/*::[*/0x0202/*::]*/: { n:"??" },
		/*::[*/0x0201/*::]*/: { n:"??" },
		/*::[*/0x0204/*::]*/: { n:"??" },
		/*::[*/0x0205/*::]*/: { n:"??" },
		/*::[*/0x0280/*::]*/: { n:"??" },
		/*::[*/0x0281/*::]*/: { n:"??" },
		/*::[*/0x0282/*::]*/: { n:"??" },
		/*::[*/0x0283/*::]*/: { n:"??" },
		/*::[*/0x0284/*::]*/: { n:"??" },
		/*::[*/0x0285/*::]*/: { n:"??" },
		/*::[*/0x0286/*::]*/: { n:"??" },
		/*::[*/0x0287/*::]*/: { n:"??" },
		/*::[*/0x0288/*::]*/: { n:"??" },
		/*::[*/0x0292/*::]*/: { n:"??" },
		/*::[*/0x0293/*::]*/: { n:"??" },
		/*::[*/0x0294/*::]*/: { n:"??" },
		/*::[*/0x0295/*::]*/: { n:"??" },
		/*::[*/0x0296/*::]*/: { n:"??" },
		/*::[*/0x0299/*::]*/: { n:"??" },
		/*::[*/0x029A/*::]*/: { n:"??" },
		/*::[*/0x0300/*::]*/: { n:"??" },
		/*::[*/0x0304/*::]*/: { n:"??" },
		/*::[*/0x0601/*::]*/: { n:"SHEETINFOQP", f:parse_SHEETINFOQP },
		/*::[*/0x0640/*::]*/: { n:"??" },
		/*::[*/0x0642/*::]*/: { n:"??" },
		/*::[*/0x0701/*::]*/: { n:"??" },
		/*::[*/0x0702/*::]*/: { n:"??" },
		/*::[*/0x0703/*::]*/: { n:"??" },
		/*::[*/0x0704/*::]*/: { n:"??" },
		/*::[*/0x0780/*::]*/: { n:"??" },
		/*::[*/0x0800/*::]*/: { n:"??" },
		/*::[*/0x0801/*::]*/: { n:"??" },
		/*::[*/0x0804/*::]*/: { n:"??" },
		/*::[*/0x0A80/*::]*/: { n:"??" },
		/*::[*/0x2AF6/*::]*/: { n:"??" },
		/*::[*/0x3231/*::]*/: { n:"??" },
		/*::[*/0x6E49/*::]*/: { n:"??" },
		/*::[*/0x6F44/*::]*/: { n:"??" },
		/*::[*/0xFFFF/*::]*/: { n:"" }
	};
	return {
		sheet_to_wk1: sheet_to_wk1,
		book_to_wk3: book_to_wk3,
		to_workbook: lotus_to_workbook
	};
})();
/* 18.4.7 rPr CT_RPrElt */
function parse_rpr(rpr) {
	var font = {}, m = rpr.match(tagregex), i = 0;
	var pass = false;
	if(m) for(;i!=m.length; ++i) {
		var y = parsexmltag(m[i]);
		switch(y[0].replace(/\w*:/g,"")) {
			/* 18.8.12 condense CT_BooleanProperty */
			/* ** not required . */
			case '<condense': break;
			/* 18.8.17 extend CT_BooleanProperty */
			/* ** not required . */
			case '<extend': break;
			/* 18.8.36 shadow CT_BooleanProperty */
			/* ** not required . */
			case '<shadow':
				if(!y.val) break;
				/* falls through */
			case '<shadow>':
			case '<shadow/>': font.shadow = 1; break;
			case '</shadow>': break;

			/* 18.4.1 charset CT_IntProperty TODO */
			case '<charset':
				if(y.val == '1') break;
				font.cp = CS2CP[parseInt(y.val, 10)];
				break;

			/* 18.4.2 outline CT_BooleanProperty TODO */
			case '<outline':
				if(!y.val) break;
				/* falls through */
			case '<outline>':
			case '<outline/>': font.outline = 1; break;
			case '</outline>': break;

			/* 18.4.5 rFont CT_FontName */
			case '<rFont': font.name = y.val; break;

			/* 18.4.11 sz CT_FontSize */
			case '<sz': font.sz = y.val; break;

			/* 18.4.10 strike CT_BooleanProperty */
			case '<strike':
				if(!y.val) break;
				/* falls through */
			case '<strike>':
			case '<strike/>': font.strike = 1; break;
			case '</strike>': break;

			/* 18.4.13 u CT_UnderlineProperty */
			case '<u':
				if(!y.val) break;
				switch(y.val) {
					case 'double': font.uval = "double"; break;
					case 'singleAccounting': font.uval = "single-accounting"; break;
					case 'doubleAccounting': font.uval = "double-accounting"; break;
				}
				/* falls through */
			case '<u>':
			case '<u/>': font.u = 1; break;
			case '</u>': break;

			/* 18.8.2 b */
			case '<b':
				if(y.val == '0') break;
				/* falls through */
			case '<b>':
			case '<b/>': font.b = 1; break;
			case '</b>': break;

			/* 18.8.26 i */
			case '<i':
				if(y.val == '0') break;
				/* falls through */
			case '<i>':
			case '<i/>': font.i = 1; break;
			case '</i>': break;

			/* 18.3.1.15 color CT_Color TODO: tint, theme, auto, indexed */
			case '<color':
				if(y.rgb) font.color = y.rgb.slice(2,8);
				break;
			case '<color>': case '<color/>': case '</color>': break;

			/* 18.8.18 family ST_FontFamily */
			case '<family': font.family = y.val; break;
			case '<family>': case '<family/>': case '</family>': break;

			/* 18.4.14 vertAlign CT_VerticalAlignFontProperty TODO */
			case '<vertAlign': font.valign = y.val; break;
			case '<vertAlign>': case '<vertAlign/>': case '</vertAlign>': break;

			/* 18.8.35 scheme CT_FontScheme TODO */
			case '<scheme': break;
			case '<scheme>': case '<scheme/>': case '</scheme>': break;

			/* 18.2.10 extLst CT_ExtensionList ? */
			case '<extLst': case '<extLst>': case '</extLst>': break;
			case '<ext': pass = true; break;
			case '</ext>': pass = false; break;
			default:
				if(y[0].charCodeAt(1) !== 47 && !pass) throw new Error('Unrecognized rich format ' + y[0]);
		}
	}
	return font;
}

var parse_rs = (function() {
	var tregex = matchtag("t"), rpregex = matchtag("rPr");
	/* 18.4.4 r CT_RElt */
	function parse_r(r) {
		/* 18.4.12 t ST_Xstring */
		var t = r.match(tregex)/*, cp = 65001*/;
		if(!t) return {t:"s", v:""};

		var o/*:Cell*/ = ({t:'s', v:unescapexml(t[1])}/*:any*/);
		var rpr = r.match(rpregex);
		if(rpr) o.s = parse_rpr(rpr[1]);
		return o;
	}
	var rregex = /<(?:\w+:)?r>/g, rend = /<\/(?:\w+:)?r>/;
	return function parse_rs(rs) {
		return rs.replace(rregex,"").split(rend).map(parse_r).filter(function(r) { return r.v; });
	};
})();


/* Parse a list of <r> tags */
var rs_to_html = (function parse_rs_factory() {
	var nlregex = /(\r\n|\n)/g;
	function parse_rpr2(font, intro, outro) {
		var style/*:Array<string>*/ = [];

		if(font.u) style.push("text-decoration: underline;");
		if(font.uval) style.push("text-underline-style:" + font.uval + ";");
		if(font.sz) style.push("font-size:" + font.sz + "pt;");
		if(font.outline) style.push("text-effect: outline;");
		if(font.shadow) style.push("text-shadow: auto;");
		intro.push('<span style="' + style.join("") + '">');

		if(font.b) { intro.push("<b>"); outro.push("</b>"); }
		if(font.i) { intro.push("<i>"); outro.push("</i>"); }
		if(font.strike) { intro.push("<s>"); outro.push("</s>"); }

		var align = font.valign || "";
		if(align == "superscript" || align == "super") align = "sup";
		else if(align == "subscript") align = "sub";
		if(align != "") { intro.push("<" + align + ">"); outro.push("</" + align + ">"); }

		outro.push("</span>");
		return font;
	}

	/* 18.4.4 r CT_RElt */
	function r_to_html(r) {
		var terms/*:[Array<string>, string, Array<string>]*/ = [[],r.v,[]];
		if(!r.v) return "";

		if(r.s) parse_rpr2(r.s, terms[0], terms[2]);

		return terms[0].join("") + terms[1].replace(nlregex,'<br/>') + terms[2].join("");
	}

	return function parse_rs(rs) {
		return rs.map(r_to_html).join("");
	};
})();

/* 18.4.8 si CT_Rst */
var sitregex = /<(?:\w+:)?t[^>]*>([^<]*)<\/(?:\w+:)?t>/g, sirregex = /<(?:\w+:)?r>/;
var sirphregex = /<(?:\w+:)?rPh.*?>([\s\S]*?)<\/(?:\w+:)?rPh>/g;
function parse_si(x, opts) {
	var html = opts ? opts.cellHTML : true;
	var z = {};
	if(!x) return { t: "" };
	//var y;
	/* 18.4.12 t ST_Xstring (Plaintext String) */
	// TODO: is whitespace actually valid here?
	if(x.match(/^\s*<(?:\w+:)?t[^>]*>/)) {
		z.t = unescapexml(utf8read(x.slice(x.indexOf(">")+1).split(/<\/(?:\w+:)?t>/)[0]||""));
		z.r = utf8read(x);
		if(html) z.h = escapehtml(z.t);
	}
	/* 18.4.4 r CT_RElt (Rich Text Run) */
	else if((/*y = */x.match(sirregex))) {
		z.r = utf8read(x);
		z.t = unescapexml(utf8read((x.replace(sirphregex, '').match(sitregex)||[]).join("").replace(tagregex,"")));
		if(html) z.h = rs_to_html(parse_rs(z.r));
	}
	/* 18.4.3 phoneticPr CT_PhoneticPr (TODO: needed for Asian support) */
	/* 18.4.6 rPh CT_PhoneticRun (TODO: needed for Asian support) */
	return z;
}

/* 18.4 Shared String Table */
var sstr0 = /<(?:\w+:)?sst([^>]*)>([\s\S]*)<\/(?:\w+:)?sst>/;
var sstr1 = /<(?:\w+:)?(?:si|sstItem)>/g;
var sstr2 = /<\/(?:\w+:)?(?:si|sstItem)>/;
function parse_sst_xml(data/*:string*/, opts)/*:SST*/ {
	var s/*:SST*/ = ([]/*:any*/), ss = "";
	if(!data) return s;
	/* 18.4.9 sst CT_Sst */
	var sst = data.match(sstr0);
	if(sst) {
		ss = sst[2].replace(sstr1,"").split(sstr2);
		for(var i = 0; i != ss.length; ++i) {
			var o = parse_si(ss[i].trim(), opts);
			if(o != null) s[s.length] = o;
		}
		sst = parsexmltag(sst[1]); s.Count = sst.count; s.Unique = sst.uniqueCount;
	}
	return s;
}

RELS.SST = "http://schemas.openxmlformats.org/officeDocument/2006/relationships/sharedStrings";
var straywsregex = /^\s|\s$|[\t\n\r]/;
function write_sst_xml(sst/*:SST*/, opts)/*:string*/ {
	if(!opts.bookSST) return "";
	var o = [XML_HEADER];
	o[o.length] = (writextag('sst', null, {
		xmlns: XMLNS.main[0],
		count: sst.Count,
		uniqueCount: sst.Unique
	}));
	for(var i = 0; i != sst.length; ++i) { if(sst[i] == null) continue;
		var s/*:XLString*/ = sst[i];
		var sitag = "<si>";
		if(s.r) sitag += s.r;
		else {
			sitag += "<t";
			if(!s.t) s.t = "";
			if(s.t.match(straywsregex)) sitag += ' xml:space="preserve"';
			sitag += ">" + escapexml(s.t) + "</t>";
		}
		sitag += "</si>";
		o[o.length] = (sitag);
	}
	if(o.length>2){ o[o.length] = ('</sst>'); o[1]=o[1].replace("/>",">"); }
	return o.join("");
}
/* [MS-XLSB] 2.4.221 BrtBeginSst */
function parse_BrtBeginSst(data) {
	return [data.read_shift(4), data.read_shift(4)];
}

/* [MS-XLSB] 2.1.7.45 Shared Strings */
function parse_sst_bin(data, opts)/*:SST*/ {
	var s/*:SST*/ = ([]/*:any*/);
	var pass = false;
	recordhopper(data, function hopper_sst(val, R_n, RT) {
		switch(RT) {
			case 0x009F: /* 'BrtBeginSst' */
				s.Count = val[0]; s.Unique = val[1]; break;
			case 0x0013: /* 'BrtSSTItem' */
				s.push(val); break;
			case 0x00A0: /* 'BrtEndSst' */
				return true;

			case 0x0023: /* 'BrtFRTBegin' */
				pass = true; break;
			case 0x0024: /* 'BrtFRTEnd' */
				pass = false; break;

			default:
				if(R_n.indexOf("Begin") > 0);
				else if(R_n.indexOf("End") > 0);
				if(!pass || opts.WTF) throw new Error("Unexpected record " + RT + " " + R_n);
		}
	});
	return s;
}

function write_BrtBeginSst(sst, o) {
	if(!o) o = new_buf(8);
	o.write_shift(4, sst.Count);
	o.write_shift(4, sst.Unique);
	return o;
}

var write_BrtSSTItem = write_RichStr;

function write_sst_bin(sst/*::, opts*/) {
	var ba = buf_array();
	write_record(ba, "BrtBeginSst", write_BrtBeginSst(sst));
	for(var i = 0; i < sst.length; ++i) write_record(ba, "BrtSSTItem", write_BrtSSTItem(sst[i]));
	/* FRTSST */
	write_record(ba, "BrtEndSst");
	return ba.end();
}
function _JS2ANSI(str/*:string*/)/*:Array<number>*/ {
	if(typeof cptable !== 'undefined') return cptable.utils.encode(current_ansi, str);
	var o/*:Array<number>*/ = [], oo = str.split("");
	for(var i = 0; i < oo.length; ++i) o[i] = oo[i].charCodeAt(0);
	return o;
}

/* [MS-OFFCRYPTO] 2.1.4 Version */
function parse_CRYPTOVersion(blob, length/*:?number*/) {
	var o/*:any*/ = {};
	o.Major = blob.read_shift(2);
	o.Minor = blob.read_shift(2);
	/*:: if(length == null) return o; */
	if(length >= 4) blob.l += length - 4;
	return o;
}

/* [MS-OFFCRYPTO] 2.1.5 DataSpaceVersionInfo */
function parse_DataSpaceVersionInfo(blob) {
	var o = {};
	o.id = blob.read_shift(0, 'lpp4');
	o.R = parse_CRYPTOVersion(blob, 4);
	o.U = parse_CRYPTOVersion(blob, 4);
	o.W = parse_CRYPTOVersion(blob, 4);
	return o;
}

/* [MS-OFFCRYPTO] 2.1.6.1 DataSpaceMapEntry Structure */
function parse_DataSpaceMapEntry(blob) {
	var len = blob.read_shift(4);
	var end = blob.l + len - 4;
	var o = {};
	var cnt = blob.read_shift(4);
	var comps/*:Array<{t:number, v:string}>*/ = [];
	/* [MS-OFFCRYPTO] 2.1.6.2 DataSpaceReferenceComponent Structure */
	while(cnt-- > 0) comps.push({ t: blob.read_shift(4), v: blob.read_shift(0, 'lpp4') });
	o.name = blob.read_shift(0, 'lpp4');
	o.comps = comps;
	if(blob.l != end) throw new Error("Bad DataSpaceMapEntry: " + blob.l + " != " + end);
	return o;
}

/* [MS-OFFCRYPTO] 2.1.6 DataSpaceMap */
function parse_DataSpaceMap(blob) {
	var o = [];
	blob.l += 4; // must be 0x8
	var cnt = blob.read_shift(4);
	while(cnt-- > 0) o.push(parse_DataSpaceMapEntry(blob));
	return o;
}

/* [MS-OFFCRYPTO] 2.1.7 DataSpaceDefinition */
function parse_DataSpaceDefinition(blob)/*:Array<string>*/ {
	var o/*:Array<string>*/ = [];
	blob.l += 4; // must be 0x8
	var cnt = blob.read_shift(4);
	while(cnt-- > 0) o.push(blob.read_shift(0, 'lpp4'));
	return o;
}

/* [MS-OFFCRYPTO] 2.1.8 DataSpaceDefinition */
function parse_TransformInfoHeader(blob) {
	var o = {};
	/*var len = */blob.read_shift(4);
	blob.l += 4; // must be 0x1
	o.id = blob.read_shift(0, 'lpp4');
	o.name = blob.read_shift(0, 'lpp4');
	o.R = parse_CRYPTOVersion(blob, 4);
	o.U = parse_CRYPTOVersion(blob, 4);
	o.W = parse_CRYPTOVersion(blob, 4);
	return o;
}

function parse_Primary(blob) {
	/* [MS-OFFCRYPTO] 2.2.6 IRMDSTransformInfo */
	var hdr = parse_TransformInfoHeader(blob);
	/* [MS-OFFCRYPTO] 2.1.9 EncryptionTransformInfo */
	hdr.ename = blob.read_shift(0, '8lpp4');
	hdr.blksz = blob.read_shift(4);
	hdr.cmode = blob.read_shift(4);
	if(blob.read_shift(4) != 0x04) throw new Error("Bad !Primary record");
	return hdr;
}

/* [MS-OFFCRYPTO] 2.3.2 Encryption Header */
function parse_EncryptionHeader(blob, length/*:number*/) {
	var tgt = blob.l + length;
	var o = {};
	o.Flags = (blob.read_shift(4) & 0x3F);
	blob.l += 4;
	o.AlgID = blob.read_shift(4);
	var valid = false;
	switch(o.AlgID) {
		case 0x660E: case 0x660F: case 0x6610: valid = (o.Flags == 0x24); break;
		case 0x6801: valid = (o.Flags == 0x04); break;
		case 0: valid = (o.Flags == 0x10 || o.Flags == 0x04 || o.Flags == 0x24); break;
		default: throw 'Unrecognized encryption algorithm: ' + o.AlgID;
	}
	if(!valid) throw new Error("Encryption Flags/AlgID mismatch");
	o.AlgIDHash = blob.read_shift(4);
	o.KeySize = blob.read_shift(4);
	o.ProviderType = blob.read_shift(4);
	blob.l += 8;
	o.CSPName = blob.read_shift((tgt-blob.l)>>1, 'utf16le');
	blob.l = tgt;
	return o;
}

/* [MS-OFFCRYPTO] 2.3.3 Encryption Verifier */
function parse_EncryptionVerifier(blob, length/*:number*/) {
	var o = {}, tgt = blob.l + length;
	blob.l += 4; // SaltSize must be 0x10
	o.Salt = blob.slice(blob.l, blob.l+16); blob.l += 16;
	o.Verifier = blob.slice(blob.l, blob.l+16); blob.l += 16;
	/*var sz = */blob.read_shift(4);
	o.VerifierHash = blob.slice(blob.l, tgt); blob.l = tgt;
	return o;
}

/* [MS-OFFCRYPTO] 2.3.4.* EncryptionInfo Stream */
function parse_EncryptionInfo(blob) {
	var vers = parse_CRYPTOVersion(blob);
	switch(vers.Minor) {
		case 0x02: return [vers.Minor, parse_EncInfoStd(blob)];
		case 0x03: return [vers.Minor, parse_EncInfoExt()];
		case 0x04: return [vers.Minor, parse_EncInfoAgl(blob)];
	}
	throw new Error("ECMA-376 Encrypted file unrecognized Version: " + vers.Minor);
}

/* [MS-OFFCRYPTO] 2.3.4.5  EncryptionInfo Stream (Standard Encryption) */
function parse_EncInfoStd(blob/*::, vers*/) {
	var flags = blob.read_shift(4);
	if((flags & 0x3F) != 0x24) throw new Error("EncryptionInfo mismatch");
	var sz = blob.read_shift(4);
	//var tgt = blob.l + sz;
	var hdr = parse_EncryptionHeader(blob, sz);
	var verifier = parse_EncryptionVerifier(blob, blob.length - blob.l);
	return { t:"Std", h:hdr, v:verifier };
}
/* [MS-OFFCRYPTO] 2.3.4.6  EncryptionInfo Stream (Extensible Encryption) */
function parse_EncInfoExt(/*::blob, vers*/) { throw new Error("File is password-protected: ECMA-376 Extensible"); }
/* [MS-OFFCRYPTO] 2.3.4.10 EncryptionInfo Stream (Agile Encryption) */
function parse_EncInfoAgl(blob/*::, vers*/) {
	var KeyData = ["saltSize","blockSize","keyBits","hashSize","cipherAlgorithm","cipherChaining","hashAlgorithm","saltValue"];
	blob.l+=4;
	var xml = blob.read_shift(blob.length - blob.l, 'utf8');
	var o = {};
	xml.replace(tagregex, function xml_agile(x) {
		var y/*:any*/ = parsexmltag(x);
		switch(strip_ns(y[0])) {
			case '<?xml': break;
			case '<encryption': case '</encryption>': break;
			case '<keyData': KeyData.forEach(function(k) { o[k] = y[k]; }); break;
			case '<dataIntegrity': o.encryptedHmacKey = y.encryptedHmacKey; o.encryptedHmacValue = y.encryptedHmacValue; break;
			case '<keyEncryptors>': case '<keyEncryptors': o.encs = []; break;
			case '</keyEncryptors>': break;

			case '<keyEncryptor': o.uri = y.uri; break;
			case '</keyEncryptor>': break;
			case '<encryptedKey': o.encs.push(y); break;
			default: throw y[0];
		}
	});
	return o;
}

/* [MS-OFFCRYPTO] 2.3.5.1 RC4 CryptoAPI Encryption Header */
function parse_RC4CryptoHeader(blob, length/*:number*/) {
	var o = {};
	var vers = o.EncryptionVersionInfo = parse_CRYPTOVersion(blob, 4); length -= 4;
	if(vers.Minor != 2) throw new Error('unrecognized minor version code: ' + vers.Minor);
	if(vers.Major > 4 || vers.Major < 2) throw new Error('unrecognized major version code: ' + vers.Major);
	o.Flags = blob.read_shift(4); length -= 4;
	var sz = blob.read_shift(4); length -= 4;
	o.EncryptionHeader = parse_EncryptionHeader(blob, sz); length -= sz;
	o.EncryptionVerifier = parse_EncryptionVerifier(blob, length);
	return o;
}
/* [MS-OFFCRYPTO] 2.3.6.1 RC4 Encryption Header */
function parse_RC4Header(blob/*::, length*/) {
	var o = {};
	var vers = o.EncryptionVersionInfo = parse_CRYPTOVersion(blob, 4);
	if(vers.Major != 1 || vers.Minor != 1) throw 'unrecognized version code ' + vers.Major + ' : ' + vers.Minor;
	o.Salt = blob.read_shift(16);
	o.EncryptedVerifier = blob.read_shift(16);
	o.EncryptedVerifierHash = blob.read_shift(16);
	return o;
}

/* [MS-OFFCRYPTO] 2.3.7.1 Binary Document Password Verifier Derivation */
function crypto_CreatePasswordVerifier_Method1(Password/*:string*/) {
	var Verifier = 0x0000, PasswordArray;
	var PasswordDecoded = _JS2ANSI(Password);
	var len = PasswordDecoded.length + 1, i, PasswordByte;
	var Intermediate1, Intermediate2, Intermediate3;
	PasswordArray = new_raw_buf(len);
	PasswordArray[0] = PasswordDecoded.length;
	for(i = 1; i != len; ++i) PasswordArray[i] = PasswordDecoded[i-1];
	for(i = len-1; i >= 0; --i) {
		PasswordByte = PasswordArray[i];
		Intermediate1 = ((Verifier & 0x4000) === 0x0000) ? 0 : 1;
		Intermediate2 = (Verifier << 1) & 0x7FFF;
		Intermediate3 = Intermediate1 | Intermediate2;
		Verifier = Intermediate3 ^ PasswordByte;
	}
	return Verifier ^ 0xCE4B;
}

/* [MS-OFFCRYPTO] 2.3.7.2 Binary Document XOR Array Initialization */
var crypto_CreateXorArray_Method1 = (function() {
	var PadArray = [0xBB, 0xFF, 0xFF, 0xBA, 0xFF, 0xFF, 0xB9, 0x80, 0x00, 0xBE, 0x0F, 0x00, 0xBF, 0x0F, 0x00];
	var InitialCode = [0xE1F0, 0x1D0F, 0xCC9C, 0x84C0, 0x110C, 0x0E10, 0xF1CE, 0x313E, 0x1872, 0xE139, 0xD40F, 0x84F9, 0x280C, 0xA96A, 0x4EC3];
	var XorMatrix = [0xAEFC, 0x4DD9, 0x9BB2, 0x2745, 0x4E8A, 0x9D14, 0x2A09, 0x7B61, 0xF6C2, 0xFDA5, 0xEB6B, 0xC6F7, 0x9DCF, 0x2BBF, 0x4563, 0x8AC6, 0x05AD, 0x0B5A, 0x16B4, 0x2D68, 0x5AD0, 0x0375, 0x06EA, 0x0DD4, 0x1BA8, 0x3750, 0x6EA0, 0xDD40, 0xD849, 0xA0B3, 0x5147, 0xA28E, 0x553D, 0xAA7A, 0x44D5, 0x6F45, 0xDE8A, 0xAD35, 0x4A4B, 0x9496, 0x390D, 0x721A, 0xEB23, 0xC667, 0x9CEF, 0x29FF, 0x53FE, 0xA7FC, 0x5FD9, 0x47D3, 0x8FA6, 0x0F6D, 0x1EDA, 0x3DB4, 0x7B68, 0xF6D0, 0xB861, 0x60E3, 0xC1C6, 0x93AD, 0x377B, 0x6EF6, 0xDDEC, 0x45A0, 0x8B40, 0x06A1, 0x0D42, 0x1A84, 0x3508, 0x6A10, 0xAA51, 0x4483, 0x8906, 0x022D, 0x045A, 0x08B4, 0x1168, 0x76B4, 0xED68, 0xCAF1, 0x85C3, 0x1BA7, 0x374E, 0x6E9C, 0x3730, 0x6E60, 0xDCC0, 0xA9A1, 0x4363, 0x86C6, 0x1DAD, 0x3331, 0x6662, 0xCCC4, 0x89A9, 0x0373, 0x06E6, 0x0DCC, 0x1021, 0x2042, 0x4084, 0x8108, 0x1231, 0x2462, 0x48C4];
	var Ror = function(Byte) { return ((Byte/2) | (Byte*128)) & 0xFF; };
	var XorRor = function(byte1, byte2) { return Ror(byte1 ^ byte2); };
	var CreateXorKey_Method1 = function(Password) {
		var XorKey = InitialCode[Password.length - 1];
		var CurrentElement = 0x68;
		for(var i = Password.length-1; i >= 0; --i) {
			var Char = Password[i];
			for(var j = 0; j != 7; ++j) {
				if(Char & 0x40) XorKey ^= XorMatrix[CurrentElement];
				Char *= 2; --CurrentElement;
			}
		}
		return XorKey;
	};
	return function(password/*:string*/) {
		var Password = _JS2ANSI(password);
		var XorKey = CreateXorKey_Method1(Password);
		var Index = Password.length;
		var ObfuscationArray = new_raw_buf(16);
		for(var i = 0; i != 16; ++i) ObfuscationArray[i] = 0x00;
		var Temp, PasswordLastChar, PadIndex;
		if((Index & 1) === 1) {
			Temp = XorKey >> 8;
			ObfuscationArray[Index] = XorRor(PadArray[0], Temp);
			--Index;
			Temp = XorKey & 0xFF;
			PasswordLastChar = Password[Password.length - 1];
			ObfuscationArray[Index] = XorRor(PasswordLastChar, Temp);
		}
		while(Index > 0) {
			--Index;
			Temp = XorKey >> 8;
			ObfuscationArray[Index] = XorRor(Password[Index], Temp);
			--Index;
			Temp = XorKey & 0xFF;
			ObfuscationArray[Index] = XorRor(Password[Index], Temp);
		}
		Index = 15;
		PadIndex = 15 - Password.length;
		while(PadIndex > 0) {
			Temp = XorKey >> 8;
			ObfuscationArray[Index] = XorRor(PadArray[PadIndex], Temp);
			--Index;
			--PadIndex;
			Temp = XorKey & 0xFF;
			ObfuscationArray[Index] = XorRor(Password[Index], Temp);
			--Index;
			--PadIndex;
		}
		return ObfuscationArray;
	};
})();

/* [MS-OFFCRYPTO] 2.3.7.3 Binary Document XOR Data Transformation Method 1 */
var crypto_DecryptData_Method1 = function(password/*:string*/, Data, XorArrayIndex, XorArray, O) {
	/* If XorArray is set, use it; if O is not set, make changes in-place */
	if(!O) O = Data;
	if(!XorArray) XorArray = crypto_CreateXorArray_Method1(password);
	var Index, Value;
	for(Index = 0; Index != Data.length; ++Index) {
		Value = Data[Index];
		Value ^= XorArray[XorArrayIndex];
		Value = ((Value>>5) | (Value<<3)) & 0xFF;
		O[Index] = Value;
		++XorArrayIndex;
	}
	return [O, XorArrayIndex, XorArray];
};

var crypto_MakeXorDecryptor = function(password/*:string*/) {
	var XorArrayIndex = 0, XorArray = crypto_CreateXorArray_Method1(password);
	return function(Data) {
		var O = crypto_DecryptData_Method1("", Data, XorArrayIndex, XorArray);
		XorArrayIndex = O[1];
		return O[0];
	};
};

/* 2.5.343 */
function parse_XORObfuscation(blob, length, opts, out) {
	var o = ({ key: parseuint16(blob), verificationBytes: parseuint16(blob) }/*:any*/);
	if(opts.password) o.verifier = crypto_CreatePasswordVerifier_Method1(opts.password);
	out.valid = o.verificationBytes === o.verifier;
	if(out.valid) out.insitu = crypto_MakeXorDecryptor(opts.password);
	return o;
}

/* 2.4.117 */
function parse_FilePassHeader(blob, length/*:number*/, oo) {
	var o = oo || {}; o.Info = blob.read_shift(2); blob.l -= 2;
	if(o.Info === 1) o.Data = parse_RC4Header(blob);
	else o.Data = parse_RC4CryptoHeader(blob, length);
	return o;
}
function parse_FilePass(blob, length/*:number*/, opts) {
	var o = ({ Type: opts.biff >= 8 ? blob.read_shift(2) : 0 }/*:any*/); /* wEncryptionType */
	if(o.Type) parse_FilePassHeader(blob, length-2, o);
	else parse_XORObfuscation(blob, opts.biff >= 8 ? length : length - 2, opts, o);
	return o;
}


var RTF = (function() {
	function rtf_to_sheet(d/*:RawData*/, opts)/*:Worksheet*/ {
		switch(opts.type) {
			case 'base64': return rtf_to_sheet_str(Base64.decode(d), opts);
			case 'binary': return rtf_to_sheet_str(d, opts);
			case 'buffer': return rtf_to_sheet_str(has_buf && Buffer.isBuffer(d) ? d.toString('binary') : a2s(d), opts);
			case 'array':  return rtf_to_sheet_str(cc2str(d), opts);
		}
		throw new Error("Unrecognized type " + opts.type);
	}

	/* TODO: this is a stub */
	function rtf_to_sheet_str(str/*:string*/, opts)/*:Worksheet*/ {
		var o = opts || {};
		var ws/*:Worksheet*/ = o.dense ? ([]/*:any*/) : ({}/*:any*/);

		var rows = str.match(/\\trowd.*?\\row\b/g);
		if(!rows.length) throw new Error("RTF missing table");
		var range/*:Range*/ = ({s: {c:0, r:0}, e: {c:0, r:rows.length - 1}}/*:any*/);
		rows.forEach(function(rowtf, R) {
			if(Array.isArray(ws)) ws[R] = [];
			var rtfre = /\\\w+\b/g;
			var last_index = 0;
			var res;
			var C = -1;
			while((res = rtfre.exec(rowtf))) {
				switch(res[0]) {
					case "\\cell":
						var data = rowtf.slice(last_index, rtfre.lastIndex - res[0].length);
						if(data[0] == " ") data = data.slice(1);
						++C;
						if(data.length) {
							// TODO: value parsing, including codepage adjustments
							var cell = {v: data, t:"s"};
							if(Array.isArray(ws)) ws[R][C] = cell;
							else ws[encode_cell({r:R, c:C})] = cell;
						}
						break;
				}
				last_index = rtfre.lastIndex;
			}
			if(C > range.e.c) range.e.c = C;
		});
		ws['!ref'] = encode_range(range);
		return ws;
	}

	function rtf_to_workbook(d/*:RawData*/, opts)/*:Workbook*/ { return sheet_to_workbook(rtf_to_sheet(d, opts), opts); }

	/* TODO: this is a stub */
	function sheet_to_rtf(ws/*:Worksheet*//*::, opts*/)/*:string*/ {
		var o = ["{\\rtf1\\ansi"];
		var r = safe_decode_range(ws['!ref']), cell/*:Cell*/;
		var dense = Array.isArray(ws);
		for(var R = r.s.r; R <= r.e.r; ++R) {
			o.push("\\trowd\\trautofit1");
			for(var C = r.s.c; C <= r.e.c; ++C) o.push("\\cellx" + (C+1));
			o.push("\\pard\\intbl");
			for(C = r.s.c; C <= r.e.c; ++C) {
				var coord = encode_cell({r:R,c:C});
				cell = dense ? (ws[R]||[])[C]: ws[coord];
				if(!cell || cell.v == null && (!cell.f || cell.F)) continue;
				o.push(" " + (cell.w || (format_cell(cell), cell.w)));
				o.push("\\cell");
			}
			o.push("\\pard\\intbl\\row");
		}
		return o.join("") + "}";
	}

	return {
		to_workbook: rtf_to_workbook,
		to_sheet: rtf_to_sheet,
		from_sheet: sheet_to_rtf
	};
})();
function hex2RGB(h) {
	var o = h.slice(h[0]==="#"?1:0).slice(0,6);
	return [parseInt(o.slice(0,2),16),parseInt(o.slice(2,4),16),parseInt(o.slice(4,6),16)];
}
function rgb2Hex(rgb) {
	for(var i=0,o=1; i!=3; ++i) o = o*256 + (rgb[i]>255?255:rgb[i]<0?0:rgb[i]);
	return o.toString(16).toUpperCase().slice(1);
}

function rgb2HSL(rgb) {
	var R = rgb[0]/255, G = rgb[1]/255, B=rgb[2]/255;
	var M = Math.max(R, G, B), m = Math.min(R, G, B), C = M - m;
	if(C === 0) return [0, 0, R];

	var H6 = 0, S = 0, L2 = (M + m);
	S = C / (L2 > 1 ? 2 - L2 : L2);
	switch(M){
		case R: H6 = ((G - B) / C + 6)%6; break;
		case G: H6 = ((B - R) / C + 2); break;
		case B: H6 = ((R - G) / C + 4); break;
	}
	return [H6 / 6, S, L2 / 2];
}

function hsl2RGB(hsl){
	var H = hsl[0], S = hsl[1], L = hsl[2];
	var C = S * 2 * (L < 0.5 ? L : 1 - L), m = L - C/2;
	var rgb = [m,m,m], h6 = 6*H;

	var X;
	if(S !== 0) switch(h6|0) {
		case 0: case 6: X = C * h6; rgb[0] += C; rgb[1] += X; break;
		case 1: X = C * (2 - h6);   rgb[0] += X; rgb[1] += C; break;
		case 2: X = C * (h6 - 2);   rgb[1] += C; rgb[2] += X; break;
		case 3: X = C * (4 - h6);   rgb[1] += X; rgb[2] += C; break;
		case 4: X = C * (h6 - 4);   rgb[2] += C; rgb[0] += X; break;
		case 5: X = C * (6 - h6);   rgb[2] += X; rgb[0] += C; break;
	}
	for(var i = 0; i != 3; ++i) rgb[i] = Math.round(rgb[i]*255);
	return rgb;
}

/* 18.8.3 bgColor tint algorithm */
function rgb_tint(hex, tint) {
	if(tint === 0) return hex;
	var hsl = rgb2HSL(hex2RGB(hex));
	if (tint < 0) hsl[2] = hsl[2] * (1 + tint);
	else hsl[2] = 1 - (1 - hsl[2]) * (1 - tint);
	return rgb2Hex(hsl2RGB(hsl));
}

/* 18.3.1.13 width calculations */
/* [MS-OI29500] 2.1.595 Column Width & Formatting */
var DEF_MDW = 6, MAX_MDW = 15, MIN_MDW = 1, MDW = DEF_MDW;
function width2px(width) { return Math.floor(( width + (Math.round(128/MDW))/256 )* MDW ); }
function px2char(px) { return (Math.floor((px - 5)/MDW * 100 + 0.5))/100; }
function char2width(chr) { return (Math.round((chr * MDW + 5)/MDW*256))/256; }
//function px2char_(px) { return (((px - 5)/MDW * 100 + 0.5))/100; }
//function char2width_(chr) { return (((chr * MDW + 5)/MDW*256))/256; }
function cycle_width(collw) { return char2width(px2char(width2px(collw))); }
/* XLSX/XLSB/XLS specify width in units of MDW */
function find_mdw_colw(collw) {
	var delta = Math.abs(collw - cycle_width(collw)), _MDW = MDW;
	if(delta > 0.005) for(MDW=MIN_MDW; MDW<MAX_MDW; ++MDW) if(Math.abs(collw - cycle_width(collw)) <= delta) { delta = Math.abs(collw - cycle_width(collw)); _MDW = MDW; }
	MDW = _MDW;
}
/* XLML specifies width in terms of pixels */
/*function find_mdw_wpx(wpx) {
	var delta = Infinity, guess = 0, _MDW = MIN_MDW;
	for(MDW=MIN_MDW; MDW<MAX_MDW; ++MDW) {
		guess = char2width_(px2char_(wpx))*256;
		guess = (guess) % 1;
		if(guess > 0.5) guess--;
		if(Math.abs(guess) < delta) { delta = Math.abs(guess); _MDW = MDW; }
	}
	MDW = _MDW;
}*/

function process_col(coll/*:ColInfo*/) {
	if(coll.width) {
		coll.wpx = width2px(coll.width);
		coll.wch = px2char(coll.wpx);
		coll.MDW = MDW;
	} else if(coll.wpx) {
		coll.wch = px2char(coll.wpx);
		coll.width = char2width(coll.wch);
		coll.MDW = MDW;
	} else if(typeof coll.wch == 'number') {
		coll.width = char2width(coll.wch);
		coll.wpx = width2px(coll.width);
		coll.MDW = MDW;
	}
	if(coll.customWidth) delete coll.customWidth;
}

var DEF_PPI = 96, PPI = DEF_PPI;
function px2pt(px) { return px * 96 / PPI; }
function pt2px(pt) { return pt * PPI / 96; }

/* [MS-EXSPXML3] 2.4.54 ST_enmPattern */
var XLMLPatternTypeMap = {
	"None": "none",
	"Solid": "solid",
	"Gray50": "mediumGray",
	"Gray75": "darkGray",
	"Gray25": "lightGray",
	"HorzStripe": "darkHorizontal",
	"VertStripe": "darkVertical",
	"ReverseDiagStripe": "darkDown",
	"DiagStripe": "darkUp",
	"DiagCross": "darkGrid",
	"ThickDiagCross": "darkTrellis",
	"ThinHorzStripe": "lightHorizontal",
	"ThinVertStripe": "lightVertical",
	"ThinReverseDiagStripe": "lightDown",
	"ThinHorzCross": "lightGrid"
};

/* 18.8.5 borders CT_Borders */
function parse_borders(t, styles, themes, opts) {
	styles.Borders = [];
	var border = {};
	var pass = false;
	(t[0].match(tagregex)||[]).forEach(function(x) {
		var y = parsexmltag(x);
		switch(strip_ns(y[0])) {
			case '<borders': case '<borders>': case '</borders>': break;

			/* 18.8.4 border CT_Border */
			case '<border': case '<border>': case '<border/>':
				border = /*::(*/{}/*:: :any)*/;
				if(y.diagonalUp) border.diagonalUp = parsexmlbool(y.diagonalUp);
				if(y.diagonalDown) border.diagonalDown = parsexmlbool(y.diagonalDown);
				styles.Borders.push(border);
				break;
			case '</border>': break;

			/* note: not in spec, appears to be CT_BorderPr */
			case '<left/>': break;
			case '<left': case '<left>': break;
			case '</left>': break;

			/* note: not in spec, appears to be CT_BorderPr */
			case '<right/>': break;
			case '<right': case '<right>': break;
			case '</right>': break;

			/* 18.8.43 top CT_BorderPr */
			case '<top/>': break;
			case '<top': case '<top>': break;
			case '</top>': break;

			/* 18.8.6 bottom CT_BorderPr */
			case '<bottom/>': break;
			case '<bottom': case '<bottom>': break;
			case '</bottom>': break;

			/* 18.8.13 diagonal CT_BorderPr */
			case '<diagonal': case '<diagonal>': case '<diagonal/>': break;
			case '</diagonal>': break;

			/* 18.8.25 horizontal CT_BorderPr */
			case '<horizontal': case '<horizontal>': case '<horizontal/>': break;
			case '</horizontal>': break;

			/* 18.8.44 vertical CT_BorderPr */
			case '<vertical': case '<vertical>': case '<vertical/>': break;
			case '</vertical>': break;

			/* 18.8.37 start CT_BorderPr */
			case '<start': case '<start>': case '<start/>': break;
			case '</start>': break;

			/* 18.8.16 end CT_BorderPr */
			case '<end': case '<end>': case '<end/>': break;
			case '</end>': break;

			/* 18.8.? color CT_Color */
			case '<color': case '<color>':
				break;
			case '<color/>': case '</color>': break;

			/* 18.2.10 extLst CT_ExtensionList ? */
			case '<extLst': case '<extLst>': case '</extLst>': break;
			case '<ext': pass = true; break;
			case '</ext>': pass = false; break;
			default: if(opts && opts.WTF) {
				if(!pass) throw new Error('unrecognized ' + y[0] + ' in borders');
			}
		}
	});
}

/* 18.8.21 fills CT_Fills */
function parse_fills(t, styles, themes, opts) {
	styles.Fills = [];
	var fill = {};
	var pass = false;
	(t[0].match(tagregex)||[]).forEach(function(x) {
		var y = parsexmltag(x);
		switch(strip_ns(y[0])) {
			case '<fills': case '<fills>': case '</fills>': break;

			/* 18.8.20 fill CT_Fill */
			case '<fill>': case '<fill': case '<fill/>':
				fill = {}; styles.Fills.push(fill); break;
			case '</fill>': break;

			/* 18.8.24 gradientFill CT_GradientFill */
			case '<gradientFill>': break;
			case '<gradientFill':
			case '</gradientFill>': styles.Fills.push(fill); fill = {}; break;

			/* 18.8.32 patternFill CT_PatternFill */
			case '<patternFill': case '<patternFill>':
				if(y.patternType) fill.patternType = y.patternType;
				break;
			case '<patternFill/>': case '</patternFill>': break;

			/* 18.8.3 bgColor CT_Color */
			case '<bgColor':
				if(!fill.bgColor) fill.bgColor = {};
				if(y.indexed) fill.bgColor.indexed = parseInt(y.indexed, 10);
				if(y.theme) fill.bgColor.theme = parseInt(y.theme, 10);
				if(y.tint) fill.bgColor.tint = parseFloat(y.tint);
				/* Excel uses ARGB strings */
				if(y.rgb) fill.bgColor.rgb = y.rgb.slice(-6);
				break;
			case '<bgColor/>': case '</bgColor>': break;

			/* 18.8.19 fgColor CT_Color */
			case '<fgColor':
				if(!fill.fgColor) fill.fgColor = {};
				if(y.theme) fill.fgColor.theme = parseInt(y.theme, 10);
				if(y.tint) fill.fgColor.tint = parseFloat(y.tint);
				/* Excel uses ARGB strings */
				if(y.rgb != null) fill.fgColor.rgb = y.rgb.slice(-6);
				break;
			case '<fgColor/>': case '</fgColor>': break;

			/* 18.8.38 stop CT_GradientStop */
			case '<stop': case '<stop/>': break;
			case '</stop>': break;

			/* 18.8.? color CT_Color */
			case '<color': case '<color/>': break;
			case '</color>': break;

			/* 18.2.10 extLst CT_ExtensionList ? */
			case '<extLst': case '<extLst>': case '</extLst>': break;
			case '<ext': pass = true; break;
			case '</ext>': pass = false; break;
			default: if(opts && opts.WTF) {
				if(!pass) throw new Error('unrecognized ' + y[0] + ' in fills');
			}
		}
	});
}

/* 18.8.23 fonts CT_Fonts */
function parse_fonts(t, styles, themes, opts) {
	styles.Fonts = [];
	var font = {};
	var pass = false;
	(t[0].match(tagregex)||[]).forEach(function(x) {
		var y = parsexmltag(x);
		switch(strip_ns(y[0])) {
			case '<fonts': case '<fonts>': case '</fonts>': break;

			/* 18.8.22 font CT_Font */
			case '<font': case '<font>': break;
			case '</font>': case '<font/>':
				styles.Fonts.push(font);
				font = {};
				break;

			/* 18.8.29 name CT_FontName */
			case '<name': if(y.val) font.name = utf8read(y.val); break;
			case '<name/>': case '</name>': break;

			/* 18.8.2  b CT_BooleanProperty */
			case '<b': font.bold = y.val ? parsexmlbool(y.val) : 1; break;
			case '<b/>': font.bold = 1; break;

			/* 18.8.26 i CT_BooleanProperty */
			case '<i': font.italic = y.val ? parsexmlbool(y.val) : 1; break;
			case '<i/>': font.italic = 1; break;

			/* 18.4.13 u CT_UnderlineProperty */
			case '<u':
				switch(y.val) {
					case "none": font.underline = 0x00; break;
					case "single": font.underline = 0x01; break;
					case "double": font.underline = 0x02; break;
					case "singleAccounting": font.underline = 0x21; break;
					case "doubleAccounting": font.underline = 0x22; break;
				} break;
			case '<u/>': font.underline = 1; break;

			/* 18.4.10 strike CT_BooleanProperty */
			case '<strike': font.strike = y.val ? parsexmlbool(y.val) : 1; break;
			case '<strike/>': font.strike = 1; break;

			/* 18.4.2  outline CT_BooleanProperty */
			case '<outline': font.outline = y.val ? parsexmlbool(y.val) : 1; break;
			case '<outline/>': font.outline = 1; break;

			/* 18.8.36 shadow CT_BooleanProperty */
			case '<shadow': font.shadow = y.val ? parsexmlbool(y.val) : 1; break;
			case '<shadow/>': font.shadow = 1; break;

			/* 18.8.12 condense CT_BooleanProperty */
			case '<condense': font.condense = y.val ? parsexmlbool(y.val) : 1; break;
			case '<condense/>': font.condense = 1; break;

			/* 18.8.17 extend CT_BooleanProperty */
			case '<extend': font.extend = y.val ? parsexmlbool(y.val) : 1; break;
			case '<extend/>': font.extend = 1; break;

			/* 18.4.11 sz CT_FontSize */
			case '<sz': if(y.val) font.sz = +y.val; break;
			case '<sz/>': case '</sz>': break;

			/* 18.4.14 vertAlign CT_VerticalAlignFontProperty */
			case '<vertAlign': if(y.val) font.vertAlign = y.val; break;
			case '<vertAlign/>': case '</vertAlign>': break;

			/* 18.8.18 family CT_FontFamily */
			case '<family': if(y.val) font.family = parseInt(y.val,10); break;
			case '<family/>': case '</family>': break;

			/* 18.8.35 scheme CT_FontScheme */
			case '<scheme': if(y.val) font.scheme = y.val; break;
			case '<scheme/>': case '</scheme>': break;

			/* 18.4.1 charset CT_IntProperty */
			case '<charset':
				if(y.val == '1') break;
				y.codepage = CS2CP[parseInt(y.val, 10)];
				break;

			/* 18.?.? color CT_Color */
			case '<color':
				if(!font.color) font.color = {};
				if(y.auto) font.color.auto = parsexmlbool(y.auto);

				if(y.rgb) font.color.rgb = y.rgb.slice(-6);
				else if(y.indexed) {
					font.color.index = parseInt(y.indexed, 10);
					var icv = XLSIcv[font.color.index];
					if(font.color.index == 81) icv = XLSIcv[1];
					if(!icv) icv = XLSIcv[1]; //throw new Error(x); // note: 206 is valid
					font.color.rgb = icv[0].toString(16) + icv[1].toString(16) + icv[2].toString(16);
				} else if(y.theme) {
					font.color.theme = parseInt(y.theme, 10);
					if(y.tint) font.color.tint = parseFloat(y.tint);
					if(y.theme && themes.themeElements && themes.themeElements.clrScheme) {
						font.color.rgb = rgb_tint(themes.themeElements.clrScheme[font.color.theme].rgb, font.color.tint || 0);
					}
				}

				break;
			case '<color/>': case '</color>': break;

			/* note: sometimes mc:AlternateContent appears bare */
			case '<AlternateContent': pass = true; break;
			case '</AlternateContent>': pass = false; break;

			/* 18.2.10 extLst CT_ExtensionList ? */
			case '<extLst': case '<extLst>': case '</extLst>': break;
			case '<ext': pass = true; break;
			case '</ext>': pass = false; break;
			default: if(opts && opts.WTF) {
				if(!pass) throw new Error('unrecognized ' + y[0] + ' in fonts');
			}
		}
	});
}

/* 18.8.31 numFmts CT_NumFmts */
function parse_numFmts(t, styles, opts) {
	styles.NumberFmt = [];
	var k/*Array<number>*/ = (keys$1(SSF._table)/*:any*/);
	for(var i=0; i < k.length; ++i) styles.NumberFmt[k[i]] = SSF._table[k[i]];
	var m = t[0].match(tagregex);
	if(!m) return;
	for(i=0; i < m.length; ++i) {
		var y = parsexmltag(m[i]);
		switch(strip_ns(y[0])) {
			case '<numFmts': case '</numFmts>': case '<numFmts/>': case '<numFmts>': break;
			case '<numFmt': {
				var f=unescapexml(utf8read(y.formatCode)), j=parseInt(y.numFmtId,10);
				styles.NumberFmt[j] = f;
				if(j>0) {
					if(j > 0x188) {
						for(j = 0x188; j > 0x3c; --j) if(styles.NumberFmt[j] == null) break;
						styles.NumberFmt[j] = f;
					}
					SSF.load(f,j);
				}
			} break;
			case '</numFmt>': break;
			default: if(opts.WTF) throw new Error('unrecognized ' + y[0] + ' in numFmts');
		}
	}
}

function write_numFmts(NF/*:{[n:number|string]:string}*//*::, opts*/) {
	var o = ["<numFmts>"];
	[[5,8],[23,26],[41,44],[/*63*/50,/*66],[164,*/392]].forEach(function(r) {
		for(var i = r[0]; i <= r[1]; ++i) if(NF[i] != null) o[o.length] = (writextag('numFmt',null,{numFmtId:i,formatCode:escapexml(NF[i])}));
	});
	if(o.length === 1) return "";
	o[o.length] = ("</numFmts>");
	o[0] = writextag('numFmts', null, { count:o.length-2 }).replace("/>", ">");
	return o.join("");
}

/* 18.8.10 cellXfs CT_CellXfs */
var cellXF_uint = [ "numFmtId", "fillId", "fontId", "borderId", "xfId" ];
var cellXF_bool = [ "applyAlignment", "applyBorder", "applyFill", "applyFont", "applyNumberFormat", "applyProtection", "pivotButton", "quotePrefix" ];
function parse_cellXfs(t, styles, opts) {
	styles.CellXf = [];
	var xf;
	var pass = false;
	(t[0].match(tagregex)||[]).forEach(function(x) {
		var y = parsexmltag(x), i = 0;
		switch(strip_ns(y[0])) {
			case '<cellXfs': case '<cellXfs>': case '<cellXfs/>': case '</cellXfs>': break;

			/* 18.8.45 xf CT_Xf */
			case '<xf': case '<xf/>':
				xf = y;
				delete xf[0];
				for(i = 0; i < cellXF_uint.length; ++i) if(xf[cellXF_uint[i]])
					xf[cellXF_uint[i]] = parseInt(xf[cellXF_uint[i]], 10);
				for(i = 0; i < cellXF_bool.length; ++i) if(xf[cellXF_bool[i]])
					xf[cellXF_bool[i]] = parsexmlbool(xf[cellXF_bool[i]]);
				if(styles.NumberFmt && xf.numFmtId > 0x188) {
					for(i = 0x188; i > 0x3c; --i) if(styles.NumberFmt[xf.numFmtId] == styles.NumberFmt[i]) { xf.numFmtId = i; break; }
				}
				styles.CellXf.push(xf); break;
			case '</xf>': break;

			/* 18.8.1 alignment CT_CellAlignment */
			case '<alignment': case '<alignment/>':
				var alignment = {};
				if(y.vertical) alignment.vertical = y.vertical;
				if(y.horizontal) alignment.horizontal = y.horizontal;
				if(y.textRotation != null) alignment.textRotation = y.textRotation;
				if(y.indent) alignment.indent = y.indent;
				if(y.wrapText) alignment.wrapText = parsexmlbool(y.wrapText);
				xf.alignment = alignment;
				break;
			case '</alignment>': break;

			/* 18.8.33 protection CT_CellProtection */
			case '<protection':
				break;
			case '</protection>': case '<protection/>': break;

			/* note: sometimes mc:AlternateContent appears bare */
			case '<AlternateContent': pass = true; break;
			case '</AlternateContent>': pass = false; break;

			/* 18.2.10 extLst CT_ExtensionList ? */
			case '<extLst': case '<extLst>': case '</extLst>': break;
			case '<ext': pass = true; break;
			case '</ext>': pass = false; break;
			default: if(opts && opts.WTF) {
				if(!pass) throw new Error('unrecognized ' + y[0] + ' in cellXfs');
			}
		}
	});
}

function write_cellXfs(cellXfs)/*:string*/ {
	var o/*:Array<string>*/ = [];
	o[o.length] = (writextag('cellXfs',null));
	cellXfs.forEach(function(c) {
		o[o.length] = (writextag('xf', null, c));
	});
	o[o.length] = ("</cellXfs>");
	if(o.length === 2) return "";
	o[0] = writextag('cellXfs',null, {count:o.length-2}).replace("/>",">");
	return o.join("");
}

/* 18.8 Styles CT_Stylesheet*/
var parse_sty_xml= (function make_pstyx() {
var numFmtRegex = /<(?:\w+:)?numFmts([^>]*)>[\S\s]*?<\/(?:\w+:)?numFmts>/;
var cellXfRegex = /<(?:\w+:)?cellXfs([^>]*)>[\S\s]*?<\/(?:\w+:)?cellXfs>/;
var fillsRegex = /<(?:\w+:)?fills([^>]*)>[\S\s]*?<\/(?:\w+:)?fills>/;
var fontsRegex = /<(?:\w+:)?fonts([^>]*)>[\S\s]*?<\/(?:\w+:)?fonts>/;
var bordersRegex = /<(?:\w+:)?borders([^>]*)>[\S\s]*?<\/(?:\w+:)?borders>/;

return function parse_sty_xml(data, themes, opts) {
	var styles = {};
	if(!data) return styles;
	data = data.replace(/<!--([\s\S]*?)-->/mg,"").replace(/<!DOCTYPE[^\[]*\[[^\]]*\]>/gm,"");
	/* 18.8.39 styleSheet CT_Stylesheet */
	var t;

	/* 18.8.31 numFmts CT_NumFmts ? */
	if((t=data.match(numFmtRegex))) parse_numFmts(t, styles, opts);

	/* 18.8.23 fonts CT_Fonts ? */
	if((t=data.match(fontsRegex))) parse_fonts(t, styles, themes, opts);

	/* 18.8.21 fills CT_Fills ? */
	if((t=data.match(fillsRegex))) parse_fills(t, styles, themes, opts);

	/* 18.8.5  borders CT_Borders ? */
	if((t=data.match(bordersRegex))) parse_borders(t, styles, themes, opts);

	/* 18.8.9  cellStyleXfs CT_CellStyleXfs ? */
	/* 18.8.8  cellStyles CT_CellStyles ? */

	/* 18.8.10 cellXfs CT_CellXfs ? */
	if((t=data.match(cellXfRegex))) parse_cellXfs(t, styles, opts);

	/* 18.8.15 dxfs CT_Dxfs ? */
	/* 18.8.42 tableStyles CT_TableStyles ? */
	/* 18.8.11 colors CT_Colors ? */
	/* 18.2.10 extLst CT_ExtensionList ? */

	return styles;
};
})();

var STYLES_XML_ROOT = writextag('styleSheet', null, {
	'xmlns': XMLNS.main[0],
	'xmlns:vt': XMLNS.vt
});

RELS.STY = "http://schemas.openxmlformats.org/officeDocument/2006/relationships/styles";

function write_sty_xml(wb/*:Workbook*/, opts)/*:string*/ {
	var o = [XML_HEADER, STYLES_XML_ROOT], w;
	if(wb.SSF && (w = write_numFmts(wb.SSF)) != null) o[o.length] = w;
	o[o.length] = ('<fonts count="1"><font><sz val="12"/><color theme="1"/><name val="Calibri"/><family val="2"/><scheme val="minor"/></font></fonts>');
	o[o.length] = ('<fills count="2"><fill><patternFill patternType="none"/></fill><fill><patternFill patternType="gray125"/></fill></fills>');
	o[o.length] = ('<borders count="1"><border><left/><right/><top/><bottom/><diagonal/></border></borders>');
	o[o.length] = ('<cellStyleXfs count="1"><xf numFmtId="0" fontId="0" fillId="0" borderId="0"/></cellStyleXfs>');
	if((w = write_cellXfs(opts.cellXfs))) o[o.length] = (w);
	o[o.length] = ('<cellStyles count="1"><cellStyle name="Normal" xfId="0" builtinId="0"/></cellStyles>');
	o[o.length] = ('<dxfs count="0"/>');
	o[o.length] = ('<tableStyles count="0" defaultTableStyle="TableStyleMedium9" defaultPivotStyle="PivotStyleMedium4"/>');

	if(o.length>2){ o[o.length] = ('</styleSheet>'); o[1]=o[1].replace("/>",">"); }
	return o.join("");
}
/* [MS-XLSB] 2.4.657 BrtFmt */
function parse_BrtFmt(data, length/*:number*/) {
	var numFmtId = data.read_shift(2);
	var stFmtCode = parse_XLWideString(data);
	return [numFmtId, stFmtCode];
}
function write_BrtFmt(i/*:number*/, f/*:string*/, o) {
	if(!o) o = new_buf(6 + 4 * f.length);
	o.write_shift(2, i);
	write_XLWideString(f, o);
	var out = (o.length > o.l) ? o.slice(0, o.l) : o;
	if(o.l == null) o.l = o.length;
	return out;
}

/* [MS-XLSB] 2.4.659 BrtFont TODO */
function parse_BrtFont(data, length/*:number*/, opts) {
	var out = ({}/*:any*/);

	out.sz = data.read_shift(2) / 20;

	var grbit = parse_FontFlags(data);
	if(grbit.fItalic) out.italic = 1;
	if(grbit.fCondense) out.condense = 1;
	if(grbit.fExtend) out.extend = 1;
	if(grbit.fShadow) out.shadow = 1;
	if(grbit.fOutline) out.outline = 1;
	if(grbit.fStrikeout) out.strike = 1;

	var bls = data.read_shift(2);
	if(bls === 0x02BC) out.bold = 1;

	switch(data.read_shift(2)) {
		/* case 0: out.vertAlign = "baseline"; break; */
		case 1: out.vertAlign = "superscript"; break;
		case 2: out.vertAlign = "subscript"; break;
	}

	var underline = data.read_shift(1);
	if(underline != 0) out.underline = underline;

	var family = data.read_shift(1);
	if(family > 0) out.family = family;

	var bCharSet = data.read_shift(1);
	if(bCharSet > 0) out.charset = bCharSet;

	data.l++;
	out.color = parse_BrtColor(data);

	switch(data.read_shift(1)) {
		/* case 0: out.scheme = "none": break; */
		case 1: out.scheme = "major"; break;
		case 2: out.scheme = "minor"; break;
	}

	out.name = parse_XLWideString(data);

	return out;
}
function write_BrtFont(font/*:any*/, o) {
	if(!o) o = new_buf(25+4*32);
	o.write_shift(2, font.sz * 20);
	write_FontFlags(font, o);
	o.write_shift(2, font.bold ? 0x02BC : 0x0190);
	var sss = 0;
	if(font.vertAlign == "superscript") sss = 1;
	else if(font.vertAlign == "subscript") sss = 2;
	o.write_shift(2, sss);
	o.write_shift(1, font.underline || 0);
	o.write_shift(1, font.family || 0);
	o.write_shift(1, font.charset || 0);
	o.write_shift(1, 0);
	write_BrtColor(font.color, o);
	var scheme = 0;
	if(font.scheme == "major") scheme = 1;
	if(font.scheme == "minor") scheme = 2;
	o.write_shift(1, scheme);
	write_XLWideString(font.name, o);
	return o.length > o.l ? o.slice(0, o.l) : o;
}

/* [MS-XLSB] 2.4.650 BrtFill */
var XLSBFillPTNames = [
	"none",
	"solid",
	"mediumGray",
	"darkGray",
	"lightGray",
	"darkHorizontal",
	"darkVertical",
	"darkDown",
	"darkUp",
	"darkGrid",
	"darkTrellis",
	"lightHorizontal",
	"lightVertical",
	"lightDown",
	"lightUp",
	"lightGrid",
	"lightTrellis",
	"gray125",
	"gray0625"
];
var rev_XLSBFillPTNames/*:EvertNumType*/ = (evert(XLSBFillPTNames)/*:any*/);
/* TODO: gradient fill representation */
var parse_BrtFill = parsenoop;
function write_BrtFill(fill, o) {
	if(!o) o = new_buf(4*3 + 8*7 + 16*1);
	var fls/*:number*/ = rev_XLSBFillPTNames[fill.patternType];
	if(fls == null) fls = 0x28;
	o.write_shift(4, fls);
	var j = 0;
	if(fls != 0x28) {
		/* TODO: custom FG Color */
		write_BrtColor({auto:1}, o);
		/* TODO: custom BG Color */
		write_BrtColor({auto:1}, o);

		for(; j < 12; ++j) o.write_shift(4, 0);
	} else {
		for(; j < 4; ++j) o.write_shift(4, 0);

		for(; j < 12; ++j) o.write_shift(4, 0); /* TODO */
		/* iGradientType */
		/* xnumDegree */
		/* xnumFillToLeft */
		/* xnumFillToRight */
		/* xnumFillToTop */
		/* xnumFillToBottom */
		/* cNumStop */
		/* xfillGradientStop */
	}
	return o.length > o.l ? o.slice(0, o.l) : o;
}

/* [MS-XLSB] 2.4.824 BrtXF */
function parse_BrtXF(data, length/*:number*/) {
	var tgt = data.l + length;
	var ixfeParent = data.read_shift(2);
	var ifmt = data.read_shift(2);
	data.l = tgt;
	return {ixfe:ixfeParent, numFmtId:ifmt };
}
function write_BrtXF(data, ixfeP, o) {
	if(!o) o = new_buf(16);
	o.write_shift(2, ixfeP||0);
	o.write_shift(2, data.numFmtId||0);
	o.write_shift(2, 0); /* iFont */
	o.write_shift(2, 0); /* iFill */
	o.write_shift(2, 0); /* ixBorder */
	o.write_shift(1, 0); /* trot */
	o.write_shift(1, 0); /* indent */
	var flow = 0;
	o.write_shift(1, flow); /* flags */
	o.write_shift(1, 0); /* flags */
	o.write_shift(1, 0); /* xfGrbitAtr */
	o.write_shift(1, 0);
	return o;
}

/* [MS-XLSB] 2.5.4 Blxf TODO */
function write_Blxf(data, o) {
	if(!o) o = new_buf(10);
	o.write_shift(1, 0); /* dg */
	o.write_shift(1, 0);
	o.write_shift(4, 0); /* color */
	o.write_shift(4, 0); /* color */
	return o;
}
/* [MS-XLSB] 2.4.302 BrtBorder TODO */
var parse_BrtBorder = parsenoop;
function write_BrtBorder(border, o) {
	if(!o) o = new_buf(51);
	o.write_shift(1, 0); /* diagonal */
	write_Blxf(null, o); /* top */
	write_Blxf(null, o); /* bottom */
	write_Blxf(null, o); /* left */
	write_Blxf(null, o); /* right */
	write_Blxf(null, o); /* diag */
	return o.length > o.l ? o.slice(0, o.l) : o;
}

/* [MS-XLSB] 2.4.763 BrtStyle TODO */
function write_BrtStyle(style, o) {
	if(!o) o = new_buf(12+4*10);
	o.write_shift(4, style.xfId);
	o.write_shift(2, 1);
	o.write_shift(1, +style.builtinId);
	o.write_shift(1, 0); /* iLevel */
	write_XLNullableWideString(style.name || "", o);
	return o.length > o.l ? o.slice(0, o.l) : o;
}

/* [MS-XLSB] 2.4.272 BrtBeginTableStyles */
function write_BrtBeginTableStyles(cnt, defTableStyle, defPivotStyle) {
	var o = new_buf(4+256*2*4);
	o.write_shift(4, cnt);
	write_XLNullableWideString(defTableStyle, o);
	write_XLNullableWideString(defPivotStyle, o);
	return o.length > o.l ? o.slice(0, o.l) : o;
}

/* [MS-XLSB] 2.1.7.50 Styles */
function parse_sty_bin(data, themes, opts) {
	var styles = {};
	styles.NumberFmt = ([]/*:any*/);
	for(var y in SSF._table) styles.NumberFmt[y] = SSF._table[y];

	styles.CellXf = [];
	styles.Fonts = [];
	var state/*:Array<string>*/ = [];
	var pass = false;
	recordhopper(data, function hopper_sty(val, R_n, RT) {
		switch(RT) {
			case 0x002C: /* 'BrtFmt' */
				styles.NumberFmt[val[0]] = val[1]; SSF.load(val[1], val[0]);
				break;
			case 0x002B: /* 'BrtFont' */
				styles.Fonts.push(val);
				if(val.color.theme != null && themes && themes.themeElements && themes.themeElements.clrScheme) {
					val.color.rgb = rgb_tint(themes.themeElements.clrScheme[val.color.theme].rgb, val.color.tint || 0);
				}
				break;
			case 0x0401: /* 'BrtKnownFonts' */ break;
			case 0x002D: /* 'BrtFill' */
				break;
			case 0x002E: /* 'BrtBorder' */
				break;
			case 0x002F: /* 'BrtXF' */
				if(state[state.length - 1] == "BrtBeginCellXFs") {
					styles.CellXf.push(val);
				}
				break;
			case 0x0030: /* 'BrtStyle' */
			case 0x01FB: /* 'BrtDXF' */
			case 0x023C: /* 'BrtMRUColor' */
			case 0x01DB: /* 'BrtIndexedColor': */
				break;

			case 0x0493: /* 'BrtDXF14' */
			case 0x0836: /* 'BrtDXF15' */
			case 0x046A: /* 'BrtSlicerStyleElement' */
			case 0x0200: /* 'BrtTableStyleElement' */
			case 0x082F: /* 'BrtTimelineStyleElement' */
			case 0x0C00: /* 'BrtUid' */
				break;

			case 0x0023: /* 'BrtFRTBegin' */
				pass = true; break;
			case 0x0024: /* 'BrtFRTEnd' */
				pass = false; break;
			case 0x0025: /* 'BrtACBegin' */
				state.push(R_n); pass = true; break;
			case 0x0026: /* 'BrtACEnd' */
				state.pop(); pass = false; break;

			default:
				if((R_n||"").indexOf("Begin") > 0) state.push(R_n);
				else if((R_n||"").indexOf("End") > 0) state.pop();
				else if(!pass || (opts.WTF && state[state.length-1] != "BrtACBegin")) throw new Error("Unexpected record " + RT + " " + R_n);
		}
	});
	return styles;
}

function write_FMTS_bin(ba, NF/*:?SSFTable*/) {
	if(!NF) return;
	var cnt = 0;
	[[5,8],[23,26],[41,44],[/*63*/50,/*66],[164,*/392]].forEach(function(r) {
		/*:: if(!NF) return; */
		for(var i = r[0]; i <= r[1]; ++i) if(NF[i] != null) ++cnt;
	});

	if(cnt == 0) return;
	write_record(ba, "BrtBeginFmts", write_UInt32LE(cnt));
	[[5,8],[23,26],[41,44],[/*63*/50,/*66],[164,*/392]].forEach(function(r) {
		/*:: if(!NF) return; */
		for(var i = r[0]; i <= r[1]; ++i) if(NF[i] != null) write_record(ba, "BrtFmt", write_BrtFmt(i, NF[i]));
	});
	write_record(ba, "BrtEndFmts");
}

function write_FONTS_bin(ba/*::, data*/) {
	var cnt = 1;
	write_record(ba, "BrtBeginFonts", write_UInt32LE(cnt));
	write_record(ba, "BrtFont", write_BrtFont({
		sz:12,
		color: {theme:1},
		name: "Calibri",
		family: 2,
		scheme: "minor"
	}));
	/* 1*65491BrtFont [ACFONTS] */
	write_record(ba, "BrtEndFonts");
}

function write_FILLS_bin(ba/*::, data*/) {
	var cnt = 2;
	write_record(ba, "BrtBeginFills", write_UInt32LE(cnt));
	write_record(ba, "BrtFill", write_BrtFill({patternType:"none"}));
	write_record(ba, "BrtFill", write_BrtFill({patternType:"gray125"}));
	/* 1*65431BrtFill */
	write_record(ba, "BrtEndFills");
}

function write_BORDERS_bin(ba/*::, data*/) {
	var cnt = 1;
	write_record(ba, "BrtBeginBorders", write_UInt32LE(cnt));
	write_record(ba, "BrtBorder", write_BrtBorder());
	/* 1*65430BrtBorder */
	write_record(ba, "BrtEndBorders");
}

function write_CELLSTYLEXFS_bin(ba/*::, data*/) {
	var cnt = 1;
	write_record(ba, "BrtBeginCellStyleXFs", write_UInt32LE(cnt));
	write_record(ba, "BrtXF", write_BrtXF({
		numFmtId: 0,
		fontId:   0,
		fillId:   0,
		borderId: 0
	}, 0xFFFF));
	/* 1*65430(BrtXF *FRT) */
	write_record(ba, "BrtEndCellStyleXFs");
}

function write_CELLXFS_bin(ba, data) {
	write_record(ba, "BrtBeginCellXFs", write_UInt32LE(data.length));
	data.forEach(function(c) { write_record(ba, "BrtXF", write_BrtXF(c,0)); });
	/* 1*65430(BrtXF *FRT) */
	write_record(ba, "BrtEndCellXFs");
}

function write_STYLES_bin(ba/*::, data*/) {
	var cnt = 1;

	write_record(ba, "BrtBeginStyles", write_UInt32LE(cnt));
	write_record(ba, "BrtStyle", write_BrtStyle({
		xfId:0,
		builtinId:0,
		name:"Normal"
	}));
	/* 1*65430(BrtStyle *FRT) */
	write_record(ba, "BrtEndStyles");
}

function write_DXFS_bin(ba/*::, data*/) {
	var cnt = 0;

	write_record(ba, "BrtBeginDXFs", write_UInt32LE(cnt));
	/* *2147483647(BrtDXF *FRT) */
	write_record(ba, "BrtEndDXFs");
}

function write_TABLESTYLES_bin(ba/*::, data*/) {
	var cnt = 0;

	write_record(ba, "BrtBeginTableStyles", write_BrtBeginTableStyles(cnt, "TableStyleMedium9", "PivotStyleMedium4"));
	/* *TABLESTYLE */
	write_record(ba, "BrtEndTableStyles");
}

/* [MS-XLSB] 2.1.7.50 Styles */
function write_sty_bin(wb, opts) {
	var ba = buf_array();
	write_record(ba, "BrtBeginStyleSheet");
	write_FMTS_bin(ba, wb.SSF);
	write_FONTS_bin(ba);
	write_FILLS_bin(ba);
	write_BORDERS_bin(ba);
	write_CELLSTYLEXFS_bin(ba);
	write_CELLXFS_bin(ba, opts.cellXfs);
	write_STYLES_bin(ba);
	write_DXFS_bin(ba);
	write_TABLESTYLES_bin(ba);
	/* FRTSTYLESHEET*/
	write_record(ba, "BrtEndStyleSheet");
	return ba.end();
}
RELS.THEME = "http://schemas.openxmlformats.org/officeDocument/2006/relationships/theme";

/* Even though theme layout is dk1 lt1 dk2 lt2, true order is lt1 dk1 lt2 dk2 */
var XLSXThemeClrScheme = [
	'</a:lt1>', '</a:dk1>', '</a:lt2>', '</a:dk2>',
	'</a:accent1>', '</a:accent2>', '</a:accent3>',
	'</a:accent4>', '</a:accent5>', '</a:accent6>',
	'</a:hlink>', '</a:folHlink>'
];
/* 20.1.6.2 clrScheme CT_ColorScheme */
function parse_clrScheme(t, themes, opts) {
	themes.themeElements.clrScheme = [];
	var color = {};
	(t[0].match(tagregex)||[]).forEach(function(x) {
		var y = parsexmltag(x);
		switch(y[0]) {
			/* 20.1.6.2 clrScheme (Color Scheme) CT_ColorScheme */
			case '<a:clrScheme': case '</a:clrScheme>': break;

			/* 20.1.2.3.32 srgbClr CT_SRgbColor */
			case '<a:srgbClr':
				color.rgb = y.val; break;

			/* 20.1.2.3.33 sysClr CT_SystemColor */
			case '<a:sysClr':
				color.rgb = y.lastClr; break;

			/* 20.1.4.1.1 accent1 (Accent 1) */
			/* 20.1.4.1.2 accent2 (Accent 2) */
			/* 20.1.4.1.3 accent3 (Accent 3) */
			/* 20.1.4.1.4 accent4 (Accent 4) */
			/* 20.1.4.1.5 accent5 (Accent 5) */
			/* 20.1.4.1.6 accent6 (Accent 6) */
			/* 20.1.4.1.9 dk1 (Dark 1) */
			/* 20.1.4.1.10 dk2 (Dark 2) */
			/* 20.1.4.1.15 folHlink (Followed Hyperlink) */
			/* 20.1.4.1.19 hlink (Hyperlink) */
			/* 20.1.4.1.22 lt1 (Light 1) */
			/* 20.1.4.1.23 lt2 (Light 2) */
			case '<a:dk1>': case '</a:dk1>':
			case '<a:lt1>': case '</a:lt1>':
			case '<a:dk2>': case '</a:dk2>':
			case '<a:lt2>': case '</a:lt2>':
			case '<a:accent1>': case '</a:accent1>':
			case '<a:accent2>': case '</a:accent2>':
			case '<a:accent3>': case '</a:accent3>':
			case '<a:accent4>': case '</a:accent4>':
			case '<a:accent5>': case '</a:accent5>':
			case '<a:accent6>': case '</a:accent6>':
			case '<a:hlink>': case '</a:hlink>':
			case '<a:folHlink>': case '</a:folHlink>':
				if (y[0].charAt(1) === '/') {
					themes.themeElements.clrScheme[XLSXThemeClrScheme.indexOf(y[0])] = color;
					color = {};
				} else {
					color.name = y[0].slice(3, y[0].length - 1);
				}
				break;

			default: if(opts && opts.WTF) throw new Error('Unrecognized ' + y[0] + ' in clrScheme');
		}
	});
}

/* 20.1.4.1.18 fontScheme CT_FontScheme */
function parse_fontScheme(/*::t, themes, opts*/) { }

/* 20.1.4.1.15 fmtScheme CT_StyleMatrix */
function parse_fmtScheme(/*::t, themes, opts*/) { }

var clrsregex = /<a:clrScheme([^>]*)>[\s\S]*<\/a:clrScheme>/;
var fntsregex = /<a:fontScheme([^>]*)>[\s\S]*<\/a:fontScheme>/;
var fmtsregex = /<a:fmtScheme([^>]*)>[\s\S]*<\/a:fmtScheme>/;

/* 20.1.6.10 themeElements CT_BaseStyles */
function parse_themeElements(data, themes, opts) {
	themes.themeElements = {};

	var t;

	[
		/* clrScheme CT_ColorScheme */
		['clrScheme', clrsregex, parse_clrScheme],
		/* fontScheme CT_FontScheme */
		['fontScheme', fntsregex, parse_fontScheme],
		/* fmtScheme CT_StyleMatrix */
		['fmtScheme', fmtsregex, parse_fmtScheme]
	].forEach(function(m) {
		if(!(t=data.match(m[1]))) throw new Error(m[0] + ' not found in themeElements');
		m[2](t, themes, opts);
	});
}

var themeltregex = /<a:themeElements([^>]*)>[\s\S]*<\/a:themeElements>/;

/* 14.2.7 Theme Part */
function parse_theme_xml(data/*:string*/, opts) {
	/* 20.1.6.9 theme CT_OfficeStyleSheet */
	if(!data || data.length === 0) return parse_theme_xml(write_theme());

	var t;
	var themes = {};

	/* themeElements CT_BaseStyles */
	if(!(t=data.match(themeltregex))) throw new Error('themeElements not found in theme');
	parse_themeElements(t[0], themes, opts);
	themes.raw = data;
	return themes;
}

function write_theme(Themes, opts)/*:string*/ {
	if(opts && opts.themeXLSX) return opts.themeXLSX;
	if(Themes && typeof Themes.raw == "string") return Themes.raw;
	var o = [XML_HEADER];
	o[o.length] = '<a:theme xmlns:a="http://schemas.openxmlformats.org/drawingml/2006/main" name="Office Theme">';
	o[o.length] =  '<a:themeElements>';

	o[o.length] =   '<a:clrScheme name="Office">';
	o[o.length] =    '<a:dk1><a:sysClr val="windowText" lastClr="000000"/></a:dk1>';
	o[o.length] =    '<a:lt1><a:sysClr val="window" lastClr="FFFFFF"/></a:lt1>';
	o[o.length] =    '<a:dk2><a:srgbClr val="1F497D"/></a:dk2>';
	o[o.length] =    '<a:lt2><a:srgbClr val="EEECE1"/></a:lt2>';
	o[o.length] =    '<a:accent1><a:srgbClr val="4F81BD"/></a:accent1>';
	o[o.length] =    '<a:accent2><a:srgbClr val="C0504D"/></a:accent2>';
	o[o.length] =    '<a:accent3><a:srgbClr val="9BBB59"/></a:accent3>';
	o[o.length] =    '<a:accent4><a:srgbClr val="8064A2"/></a:accent4>';
	o[o.length] =    '<a:accent5><a:srgbClr val="4BACC6"/></a:accent5>';
	o[o.length] =    '<a:accent6><a:srgbClr val="F79646"/></a:accent6>';
	o[o.length] =    '<a:hlink><a:srgbClr val="0000FF"/></a:hlink>';
	o[o.length] =    '<a:folHlink><a:srgbClr val="800080"/></a:folHlink>';
	o[o.length] =   '</a:clrScheme>';

	o[o.length] =   '<a:fontScheme name="Office">';
	o[o.length] =    '<a:majorFont>';
	o[o.length] =     '<a:latin typeface="Cambria"/>';
	o[o.length] =     '<a:ea typeface=""/>';
	o[o.length] =     '<a:cs typeface=""/>';
	o[o.length] =     '<a:font script="Jpan" typeface="ＭＳ Ｐゴシック"/>';
	o[o.length] =     '<a:font script="Hang" typeface="맑은 고딕"/>';
	o[o.length] =     '<a:font script="Hans" typeface="宋体"/>';
	o[o.length] =     '<a:font script="Hant" typeface="新細明體"/>';
	o[o.length] =     '<a:font script="Arab" typeface="Times New Roman"/>';
	o[o.length] =     '<a:font script="Hebr" typeface="Times New Roman"/>';
	o[o.length] =     '<a:font script="Thai" typeface="Tahoma"/>';
	o[o.length] =     '<a:font script="Ethi" typeface="Nyala"/>';
	o[o.length] =     '<a:font script="Beng" typeface="Vrinda"/>';
	o[o.length] =     '<a:font script="Gujr" typeface="Shruti"/>';
	o[o.length] =     '<a:font script="Khmr" typeface="MoolBoran"/>';
	o[o.length] =     '<a:font script="Knda" typeface="Tunga"/>';
	o[o.length] =     '<a:font script="Guru" typeface="Raavi"/>';
	o[o.length] =     '<a:font script="Cans" typeface="Euphemia"/>';
	o[o.length] =     '<a:font script="Cher" typeface="Plantagenet Cherokee"/>';
	o[o.length] =     '<a:font script="Yiii" typeface="Microsoft Yi Baiti"/>';
	o[o.length] =     '<a:font script="Tibt" typeface="Microsoft Himalaya"/>';
	o[o.length] =     '<a:font script="Thaa" typeface="MV Boli"/>';
	o[o.length] =     '<a:font script="Deva" typeface="Mangal"/>';
	o[o.length] =     '<a:font script="Telu" typeface="Gautami"/>';
	o[o.length] =     '<a:font script="Taml" typeface="Latha"/>';
	o[o.length] =     '<a:font script="Syrc" typeface="Estrangelo Edessa"/>';
	o[o.length] =     '<a:font script="Orya" typeface="Kalinga"/>';
	o[o.length] =     '<a:font script="Mlym" typeface="Kartika"/>';
	o[o.length] =     '<a:font script="Laoo" typeface="DokChampa"/>';
	o[o.length] =     '<a:font script="Sinh" typeface="Iskoola Pota"/>';
	o[o.length] =     '<a:font script="Mong" typeface="Mongolian Baiti"/>';
	o[o.length] =     '<a:font script="Viet" typeface="Times New Roman"/>';
	o[o.length] =     '<a:font script="Uigh" typeface="Microsoft Uighur"/>';
	o[o.length] =     '<a:font script="Geor" typeface="Sylfaen"/>';
	o[o.length] =    '</a:majorFont>';
	o[o.length] =    '<a:minorFont>';
	o[o.length] =     '<a:latin typeface="Calibri"/>';
	o[o.length] =     '<a:ea typeface=""/>';
	o[o.length] =     '<a:cs typeface=""/>';
	o[o.length] =     '<a:font script="Jpan" typeface="ＭＳ Ｐゴシック"/>';
	o[o.length] =     '<a:font script="Hang" typeface="맑은 고딕"/>';
	o[o.length] =     '<a:font script="Hans" typeface="宋体"/>';
	o[o.length] =     '<a:font script="Hant" typeface="新細明體"/>';
	o[o.length] =     '<a:font script="Arab" typeface="Arial"/>';
	o[o.length] =     '<a:font script="Hebr" typeface="Arial"/>';
	o[o.length] =     '<a:font script="Thai" typeface="Tahoma"/>';
	o[o.length] =     '<a:font script="Ethi" typeface="Nyala"/>';
	o[o.length] =     '<a:font script="Beng" typeface="Vrinda"/>';
	o[o.length] =     '<a:font script="Gujr" typeface="Shruti"/>';
	o[o.length] =     '<a:font script="Khmr" typeface="DaunPenh"/>';
	o[o.length] =     '<a:font script="Knda" typeface="Tunga"/>';
	o[o.length] =     '<a:font script="Guru" typeface="Raavi"/>';
	o[o.length] =     '<a:font script="Cans" typeface="Euphemia"/>';
	o[o.length] =     '<a:font script="Cher" typeface="Plantagenet Cherokee"/>';
	o[o.length] =     '<a:font script="Yiii" typeface="Microsoft Yi Baiti"/>';
	o[o.length] =     '<a:font script="Tibt" typeface="Microsoft Himalaya"/>';
	o[o.length] =     '<a:font script="Thaa" typeface="MV Boli"/>';
	o[o.length] =     '<a:font script="Deva" typeface="Mangal"/>';
	o[o.length] =     '<a:font script="Telu" typeface="Gautami"/>';
	o[o.length] =     '<a:font script="Taml" typeface="Latha"/>';
	o[o.length] =     '<a:font script="Syrc" typeface="Estrangelo Edessa"/>';
	o[o.length] =     '<a:font script="Orya" typeface="Kalinga"/>';
	o[o.length] =     '<a:font script="Mlym" typeface="Kartika"/>';
	o[o.length] =     '<a:font script="Laoo" typeface="DokChampa"/>';
	o[o.length] =     '<a:font script="Sinh" typeface="Iskoola Pota"/>';
	o[o.length] =     '<a:font script="Mong" typeface="Mongolian Baiti"/>';
	o[o.length] =     '<a:font script="Viet" typeface="Arial"/>';
	o[o.length] =     '<a:font script="Uigh" typeface="Microsoft Uighur"/>';
	o[o.length] =     '<a:font script="Geor" typeface="Sylfaen"/>';
	o[o.length] =    '</a:minorFont>';
	o[o.length] =   '</a:fontScheme>';

	o[o.length] =   '<a:fmtScheme name="Office">';
	o[o.length] =    '<a:fillStyleLst>';
	o[o.length] =     '<a:solidFill><a:schemeClr val="phClr"/></a:solidFill>';
	o[o.length] =     '<a:gradFill rotWithShape="1">';
	o[o.length] =      '<a:gsLst>';
	o[o.length] =       '<a:gs pos="0"><a:schemeClr val="phClr"><a:tint val="50000"/><a:satMod val="300000"/></a:schemeClr></a:gs>';
	o[o.length] =       '<a:gs pos="35000"><a:schemeClr val="phClr"><a:tint val="37000"/><a:satMod val="300000"/></a:schemeClr></a:gs>';
	o[o.length] =       '<a:gs pos="100000"><a:schemeClr val="phClr"><a:tint val="15000"/><a:satMod val="350000"/></a:schemeClr></a:gs>';
	o[o.length] =      '</a:gsLst>';
	o[o.length] =      '<a:lin ang="16200000" scaled="1"/>';
	o[o.length] =     '</a:gradFill>';
	o[o.length] =     '<a:gradFill rotWithShape="1">';
	o[o.length] =      '<a:gsLst>';
	o[o.length] =       '<a:gs pos="0"><a:schemeClr val="phClr"><a:tint val="100000"/><a:shade val="100000"/><a:satMod val="130000"/></a:schemeClr></a:gs>';
	o[o.length] =       '<a:gs pos="100000"><a:schemeClr val="phClr"><a:tint val="50000"/><a:shade val="100000"/><a:satMod val="350000"/></a:schemeClr></a:gs>';
	o[o.length] =      '</a:gsLst>';
	o[o.length] =      '<a:lin ang="16200000" scaled="0"/>';
	o[o.length] =     '</a:gradFill>';
	o[o.length] =    '</a:fillStyleLst>';
	o[o.length] =    '<a:lnStyleLst>';
	o[o.length] =     '<a:ln w="9525" cap="flat" cmpd="sng" algn="ctr"><a:solidFill><a:schemeClr val="phClr"><a:shade val="95000"/><a:satMod val="105000"/></a:schemeClr></a:solidFill><a:prstDash val="solid"/></a:ln>';
	o[o.length] =     '<a:ln w="25400" cap="flat" cmpd="sng" algn="ctr"><a:solidFill><a:schemeClr val="phClr"/></a:solidFill><a:prstDash val="solid"/></a:ln>';
	o[o.length] =     '<a:ln w="38100" cap="flat" cmpd="sng" algn="ctr"><a:solidFill><a:schemeClr val="phClr"/></a:solidFill><a:prstDash val="solid"/></a:ln>';
	o[o.length] =    '</a:lnStyleLst>';
	o[o.length] =    '<a:effectStyleLst>';
	o[o.length] =     '<a:effectStyle>';
	o[o.length] =      '<a:effectLst>';
	o[o.length] =       '<a:outerShdw blurRad="40000" dist="20000" dir="5400000" rotWithShape="0"><a:srgbClr val="000000"><a:alpha val="38000"/></a:srgbClr></a:outerShdw>';
	o[o.length] =      '</a:effectLst>';
	o[o.length] =     '</a:effectStyle>';
	o[o.length] =     '<a:effectStyle>';
	o[o.length] =      '<a:effectLst>';
	o[o.length] =       '<a:outerShdw blurRad="40000" dist="23000" dir="5400000" rotWithShape="0"><a:srgbClr val="000000"><a:alpha val="35000"/></a:srgbClr></a:outerShdw>';
	o[o.length] =      '</a:effectLst>';
	o[o.length] =     '</a:effectStyle>';
	o[o.length] =     '<a:effectStyle>';
	o[o.length] =      '<a:effectLst>';
	o[o.length] =       '<a:outerShdw blurRad="40000" dist="23000" dir="5400000" rotWithShape="0"><a:srgbClr val="000000"><a:alpha val="35000"/></a:srgbClr></a:outerShdw>';
	o[o.length] =      '</a:effectLst>';
	o[o.length] =      '<a:scene3d><a:camera prst="orthographicFront"><a:rot lat="0" lon="0" rev="0"/></a:camera><a:lightRig rig="threePt" dir="t"><a:rot lat="0" lon="0" rev="1200000"/></a:lightRig></a:scene3d>';
	o[o.length] =      '<a:sp3d><a:bevelT w="63500" h="25400"/></a:sp3d>';
	o[o.length] =     '</a:effectStyle>';
	o[o.length] =    '</a:effectStyleLst>';
	o[o.length] =    '<a:bgFillStyleLst>';
	o[o.length] =     '<a:solidFill><a:schemeClr val="phClr"/></a:solidFill>';
	o[o.length] =     '<a:gradFill rotWithShape="1">';
	o[o.length] =      '<a:gsLst>';
	o[o.length] =       '<a:gs pos="0"><a:schemeClr val="phClr"><a:tint val="40000"/><a:satMod val="350000"/></a:schemeClr></a:gs>';
	o[o.length] =       '<a:gs pos="40000"><a:schemeClr val="phClr"><a:tint val="45000"/><a:shade val="99000"/><a:satMod val="350000"/></a:schemeClr></a:gs>';
	o[o.length] =       '<a:gs pos="100000"><a:schemeClr val="phClr"><a:shade val="20000"/><a:satMod val="255000"/></a:schemeClr></a:gs>';
	o[o.length] =      '</a:gsLst>';
	o[o.length] =      '<a:path path="circle"><a:fillToRect l="50000" t="-80000" r="50000" b="180000"/></a:path>';
	o[o.length] =     '</a:gradFill>';
	o[o.length] =     '<a:gradFill rotWithShape="1">';
	o[o.length] =      '<a:gsLst>';
	o[o.length] =       '<a:gs pos="0"><a:schemeClr val="phClr"><a:tint val="80000"/><a:satMod val="300000"/></a:schemeClr></a:gs>';
	o[o.length] =       '<a:gs pos="100000"><a:schemeClr val="phClr"><a:shade val="30000"/><a:satMod val="200000"/></a:schemeClr></a:gs>';
	o[o.length] =      '</a:gsLst>';
	o[o.length] =      '<a:path path="circle"><a:fillToRect l="50000" t="50000" r="50000" b="50000"/></a:path>';
	o[o.length] =     '</a:gradFill>';
	o[o.length] =    '</a:bgFillStyleLst>';
	o[o.length] =   '</a:fmtScheme>';
	o[o.length] =  '</a:themeElements>';

	o[o.length] =  '<a:objectDefaults>';
	o[o.length] =   '<a:spDef>';
	o[o.length] =    '<a:spPr/><a:bodyPr/><a:lstStyle/><a:style><a:lnRef idx="1"><a:schemeClr val="accent1"/></a:lnRef><a:fillRef idx="3"><a:schemeClr val="accent1"/></a:fillRef><a:effectRef idx="2"><a:schemeClr val="accent1"/></a:effectRef><a:fontRef idx="minor"><a:schemeClr val="lt1"/></a:fontRef></a:style>';
	o[o.length] =   '</a:spDef>';
	o[o.length] =   '<a:lnDef>';
	o[o.length] =    '<a:spPr/><a:bodyPr/><a:lstStyle/><a:style><a:lnRef idx="2"><a:schemeClr val="accent1"/></a:lnRef><a:fillRef idx="0"><a:schemeClr val="accent1"/></a:fillRef><a:effectRef idx="1"><a:schemeClr val="accent1"/></a:effectRef><a:fontRef idx="minor"><a:schemeClr val="tx1"/></a:fontRef></a:style>';
	o[o.length] =   '</a:lnDef>';
	o[o.length] =  '</a:objectDefaults>';
	o[o.length] =  '<a:extraClrSchemeLst/>';
	o[o.length] = '</a:theme>';
	return o.join("");
}
/* [MS-XLS] 2.4.326 TODO: payload is a zip file */
function parse_Theme(blob, length, opts) {
	var end = blob.l + length;
	var dwThemeVersion = blob.read_shift(4);
	if(dwThemeVersion === 124226) return;
	if(!opts.cellStyles) { blob.l = end; return; }
	var data = blob.slice(blob.l);
	blob.l = end;
	var zip; try { zip = zip_read(data, {type: "array"}); } catch(e) { return; }
	var themeXML = getzipstr(zip, "theme/theme/theme1.xml", true);
	if(!themeXML) return;
	return parse_theme_xml(themeXML, opts);
}

/* 2.5.49 */
function parse_ColorTheme(blob/*::, length*/) { return blob.read_shift(4); }

/* 2.5.155 */
function parse_FullColorExt(blob/*::, length*/) {
	var o = {};
	o.xclrType = blob.read_shift(2);
	o.nTintShade = blob.read_shift(2);
	switch(o.xclrType) {
		case 0: blob.l += 4; break;
		case 1: o.xclrValue = parse_IcvXF(blob, 4); break;
		case 2: o.xclrValue = parse_LongRGBA(blob); break;
		case 3: o.xclrValue = parse_ColorTheme(blob); break;
		case 4: blob.l += 4; break;
	}
	blob.l += 8;
	return o;
}

/* 2.5.164 TODO: read 7 bits*/
function parse_IcvXF(blob, length) {
	return parsenoop(blob, length);
}

/* 2.5.280 */
function parse_XFExtGradient(blob, length) {
	return parsenoop(blob, length);
}

/* [MS-XLS] 2.5.108 */
function parse_ExtProp(blob/*::, length*/)/*:Array<any>*/ {
	var extType = blob.read_shift(2);
	var cb = blob.read_shift(2) - 4;
	var o = [extType];
	switch(extType) {
		case 0x04: case 0x05: case 0x07: case 0x08:
		case 0x09: case 0x0A: case 0x0B: case 0x0D:
			o[1] = parse_FullColorExt(blob); break;
		case 0x06: o[1] = parse_XFExtGradient(blob, cb); break;
		case 0x0E: case 0x0F: o[1] = blob.read_shift(cb === 1 ? 1 : 2); break;
		default: throw new Error("Unrecognized ExtProp type: " + extType + " " + cb);
	}
	return o;
}

/* 2.4.355 */
function parse_XFExt(blob, length) {
	var end = blob.l + length;
	blob.l += 2;
	var ixfe = blob.read_shift(2);
	blob.l += 2;
	var cexts = blob.read_shift(2);
	var ext/*:AOA*/ = [];
	while(cexts-- > 0) ext.push(parse_ExtProp(blob, end-blob.l));
	return {ixfe:ixfe, ext:ext};
}

/* xf is an XF, see parse_XFExt for xfext */
function update_xfext(xf, xfext) {
	xfext.forEach(function(xfe) {
		switch(xfe[0]) { /* 2.5.108 extPropData */
					}
	});
}

/* 18.6 Calculation Chain */
function parse_cc_xml(data/*::, name, opts*/)/*:Array<any>*/ {
	var d = [];
	if(!data) return d;
	var i = 1;
	(data.match(tagregex)||[]).forEach(function(x) {
		var y = parsexmltag(x);
		switch(y[0]) {
			case '<?xml': break;
			/* 18.6.2  calcChain CT_CalcChain 1 */
			case '<calcChain': case '<calcChain>': case '</calcChain>': break;
			/* 18.6.1  c CT_CalcCell 1 */
			case '<c': delete y[0]; if(y.i) i = y.i; else y.i = i; d.push(y); break;
		}
	});
	return d;
}

//function write_cc_xml(data, opts) { }

/* [MS-XLSB] 2.6.4.1 */
function parse_BrtCalcChainItem$(data) {
	var out = {};
	out.i = data.read_shift(4);
	var cell = {};
	cell.r = data.read_shift(4);
	cell.c = data.read_shift(4);
	out.r = encode_cell(cell);
	var flags = data.read_shift(1);
	if(flags & 0x2) out.l = '1';
	if(flags & 0x8) out.a = '1';
	return out;
}

/* 18.6 Calculation Chain */
function parse_cc_bin(data, name, opts) {
	var out = [];
	recordhopper(data, function hopper_cc(val, R_n, RT) {
		switch(RT) {
			case 0x003F: /* 'BrtCalcChainItem$' */
				out.push(val); break;

			default:
				if((R_n||"").indexOf("Begin") > 0);
				else if((R_n||"").indexOf("End") > 0);
				else throw new Error("Unexpected record " + RT + " " + R_n);
		}
	});
	return out;
}

//function write_cc_bin(data, opts) { }
/* 18.14 Supplementary Workbook Data */
function parse_xlink_xml(/*::data, rel, name:string, _opts*/) {
	//var opts = _opts || {};
	//if(opts.WTF) throw "XLSX External Link";
}

/* [MS-XLSB] 2.1.7.25 External Link */
function parse_xlink_bin(data, rel, name/*:string*/, _opts) {
	if(!data) return data;
	var opts = _opts || {};

	var pass = false;

	recordhopper(data, function xlink_parse(val, R_n, RT) {
		switch(RT) {
			case 0x0167: /* 'BrtSupTabs' */
			case 0x016B: /* 'BrtExternTableStart' */
			case 0x016C: /* 'BrtExternTableEnd' */
			case 0x016E: /* 'BrtExternRowHdr' */
			case 0x016F: /* 'BrtExternCellBlank' */
			case 0x0170: /* 'BrtExternCellReal' */
			case 0x0171: /* 'BrtExternCellBool' */
			case 0x0172: /* 'BrtExternCellError' */
			case 0x0173: /* 'BrtExternCellString' */
			case 0x01D8: /* 'BrtExternValueMeta' */
			case 0x0241: /* 'BrtSupNameStart' */
			case 0x0242: /* 'BrtSupNameValueStart' */
			case 0x0243: /* 'BrtSupNameValueEnd' */
			case 0x0244: /* 'BrtSupNameNum' */
			case 0x0245: /* 'BrtSupNameErr' */
			case 0x0246: /* 'BrtSupNameSt' */
			case 0x0247: /* 'BrtSupNameNil' */
			case 0x0248: /* 'BrtSupNameBool' */
			case 0x0249: /* 'BrtSupNameFmla' */
			case 0x024A: /* 'BrtSupNameBits' */
			case 0x024B: /* 'BrtSupNameEnd' */
				break;

			case 0x0023: /* 'BrtFRTBegin' */
				pass = true; break;
			case 0x0024: /* 'BrtFRTEnd' */
				pass = false; break;

			default:
				if((R_n||"").indexOf("Begin") > 0);
				else if((R_n||"").indexOf("End") > 0);
				else if(!pass || opts.WTF) throw new Error("Unexpected record " + RT.toString(16) + " " + R_n);
		}
	}, opts);
}
/* 20.5 DrawingML - SpreadsheetML Drawing */
RELS.IMG = "http://schemas.openxmlformats.org/officeDocument/2006/relationships/image";
RELS.DRAW = "http://schemas.openxmlformats.org/officeDocument/2006/relationships/drawing";

/* 20.5.2.35 wsDr CT_Drawing */
function parse_drawing(data, rels/*:any*/) {
	if(!data) return "??";
	/*
	  Chartsheet Drawing:
	   - 20.5.2.35 wsDr CT_Drawing
	    - 20.5.2.1  absoluteAnchor CT_AbsoluteAnchor
	     - 20.5.2.16 graphicFrame CT_GraphicalObjectFrame
	      - 20.1.2.2.16 graphic CT_GraphicalObject
	       - 20.1.2.2.17 graphicData CT_GraphicalObjectData
          - chart reference
	   the actual type is based on the URI of the graphicData
		TODO: handle embedded charts and other types of graphics
	*/
	var id = (data.match(/<c:chart [^>]*r:id="([^"]*)"/)||["",""])[1];

	return rels['!id'][id].Target;
}

/* L.5.5.2 SpreadsheetML Comments + VML Schema */
var _shapeid = 1024;
function write_comments_vml(rId/*:number*/, comments) {
	var csize = [21600, 21600];
	/* L.5.2.1.2 Path Attribute */
	var bbox = ["m0,0l0",csize[1],csize[0],csize[1],csize[0],"0xe"].join(",");
	var o = [
		writextag("xml", null, { 'xmlns:v': XLMLNS.v, 'xmlns:o': XLMLNS.o, 'xmlns:x': XLMLNS.x, 'xmlns:mv': XLMLNS.mv }).replace(/\/>/,">"),
		writextag("o:shapelayout", writextag("o:idmap", null, {'v:ext':"edit", 'data':rId}), {'v:ext':"edit"}),
		writextag("v:shapetype", [
			writextag("v:stroke", null, {joinstyle:"miter"}),
			writextag("v:path", null, {gradientshapeok:"t", 'o:connecttype':"rect"})
		].join(""), {id:"_x0000_t202", 'o:spt':202, coordsize:csize.join(","),path:bbox})
	];
	while(_shapeid < rId * 1000) _shapeid += 1000;

	comments.forEach(function(x) {
	var c = decode_cell(x[0]);
	var fillopts = /*::(*/{'color2':"#BEFF82", 'type':"gradient"}/*:: :any)*/;
	if(fillopts.type == "gradient") fillopts.angle = "-180";
	var fillparm = fillopts.type == "gradient" ? writextag("o:fill", null, {type:"gradientUnscaled", 'v:ext':"view"}) : null;
	var fillxml = writextag('v:fill', fillparm, fillopts);

	var shadata = ({on:"t", 'obscured':"t"}/*:any*/);
	++_shapeid;

	o = o.concat([
	'<v:shape' + wxt_helper({
		id:'_x0000_s' + _shapeid,
		type:"#_x0000_t202",
		style:"position:absolute; margin-left:80pt;margin-top:5pt;width:104pt;height:64pt;z-index:10" + (x[1].hidden ? ";visibility:hidden" : "") ,
		fillcolor:"#ECFAD4",
		strokecolor:"#edeaa1"
	}) + '>',
		fillxml,
		writextag("v:shadow", null, shadata),
		writextag("v:path", null, {'o:connecttype':"none"}),
		'<v:textbox><div style="text-align:left"></div></v:textbox>',
		'<x:ClientData ObjectType="Note">',
			'<x:MoveWithCells/>',
			'<x:SizeWithCells/>',
			/* Part 4 19.4.2.3 Anchor (Anchor) */
			writetag('x:Anchor', [c.c+1, 0, c.r+1, 0, c.c+3, 20, c.r+5, 20].join(",")),
			writetag('x:AutoFill', "False"),
			writetag('x:Row', String(c.r)),
			writetag('x:Column', String(c.c)),
			x[1].hidden ? '' : '<x:Visible/>',
		'</x:ClientData>',
	'</v:shape>'
	]); });
	o.push('</xml>');
	return o.join("");
}
RELS.CMNT = "http://schemas.openxmlformats.org/officeDocument/2006/relationships/comments";

function sheet_insert_comments(sheet, comments/*:Array<RawComment>*/) {
	var dense = Array.isArray(sheet);
	var cell/*:Cell*/;
	comments.forEach(function(comment) {
		var r = decode_cell(comment.ref);
		if(dense) {
			if(!sheet[r.r]) sheet[r.r] = [];
			cell = sheet[r.r][r.c];
		} else cell = sheet[comment.ref];
		if (!cell) {
			cell = ({t:"z"}/*:any*/);
			if(dense) sheet[r.r][r.c] = cell;
			else sheet[comment.ref] = cell;
			var range = safe_decode_range(sheet["!ref"]||"BDWGO1000001:A1");
			if(range.s.r > r.r) range.s.r = r.r;
			if(range.e.r < r.r) range.e.r = r.r;
			if(range.s.c > r.c) range.s.c = r.c;
			if(range.e.c < r.c) range.e.c = r.c;
			var encoded = encode_range(range);
			if (encoded !== sheet["!ref"]) sheet["!ref"] = encoded;
		}

		if (!cell.c) cell.c = [];
		var o/*:Comment*/ = ({a: comment.author, t: comment.t, r: comment.r});
		if(comment.h) o.h = comment.h;
		cell.c.push(o);
	});
}

/* 18.7 Comments */
function parse_comments_xml(data/*:string*/, opts)/*:Array<RawComment>*/ {
	/* 18.7.6 CT_Comments */
	if(data.match(/<(?:\w+:)?comments *\/>/)) return [];
	var authors/*:Array<string>*/ = [];
	var commentList/*:Array<RawComment>*/ = [];
	var authtag = data.match(/<(?:\w+:)?authors>([\s\S]*)<\/(?:\w+:)?authors>/);
	if(authtag && authtag[1]) authtag[1].split(/<\/\w*:?author>/).forEach(function(x) {
		if(x === "" || x.trim() === "") return;
		var a = x.match(/<(?:\w+:)?author[^>]*>(.*)/);
		if(a) authors.push(a[1]);
	});
	var cmnttag = data.match(/<(?:\w+:)?commentList>([\s\S]*)<\/(?:\w+:)?commentList>/);
	if(cmnttag && cmnttag[1]) cmnttag[1].split(/<\/\w*:?comment>/).forEach(function(x) {
		if(x === "" || x.trim() === "") return;
		var cm = x.match(/<(?:\w+:)?comment[^>]*>/);
		if(!cm) return;
		var y = parsexmltag(cm[0]);
		var comment/*:RawComment*/ = ({ author: y.authorId && authors[y.authorId] || "sheetjsghost", ref: y.ref, guid: y.guid }/*:any*/);
		var cell = decode_cell(y.ref);
		if(opts.sheetRows && opts.sheetRows <= cell.r) return;
		var textMatch = x.match(/<(?:\w+:)?text>([\s\S]*)<\/(?:\w+:)?text>/);
		var rt = !!textMatch && !!textMatch[1] && parse_si(textMatch[1]) || {r:"",t:"",h:""};
		comment.r = rt.r;
		if(rt.r == "<t></t>") rt.t = rt.h = "";
		comment.t = (rt.t||"").replace(/\r\n/g,"\n").replace(/\r/g,"\n");
		if(opts.cellHTML) comment.h = rt.h;
		commentList.push(comment);
	});
	return commentList;
}

var CMNT_XML_ROOT = writextag('comments', null, { 'xmlns': XMLNS.main[0] });
function write_comments_xml(data/*::, opts*/) {
	var o = [XML_HEADER, CMNT_XML_ROOT];

	var iauthor/*:Array<string>*/ = [];
	o.push("<authors>");
	data.forEach(function(x) { x[1].forEach(function(w) { var a = escapexml(w.a);
		if(iauthor.indexOf(a) > -1) return;
		iauthor.push(a);
		o.push("<author>" + a + "</author>");
	}); });
	o.push("</authors>");
	o.push("<commentList>");
	data.forEach(function(d) {
		d[1].forEach(function(c) {
			/* 18.7.3 CT_Comment */
			o.push('<comment ref="' + d[0] + '" authorId="' + iauthor.indexOf(escapexml(c.a)) + '"><text>');
			o.push(writetag("t", c.t == null ? "" : escapexml(c.t)));
			o.push('</text></comment>');
		});
	});
	o.push("</commentList>");
	if(o.length>2) { o[o.length] = ('</comments>'); o[1]=o[1].replace("/>",">"); }
	return o.join("");
}
/* [MS-XLSB] 2.4.28 BrtBeginComment */
function parse_BrtBeginComment(data) {
	var out = {};
	out.iauthor = data.read_shift(4);
	var rfx = parse_UncheckedRfX(data);
	out.rfx = rfx.s;
	out.ref = encode_cell(rfx.s);
	data.l += 16; /*var guid = parse_GUID(data); */
	return out;
}
function write_BrtBeginComment(data, o) {
	if(o == null) o = new_buf(36);
	o.write_shift(4, data[1].iauthor);
	write_UncheckedRfX((data[0]/*:any*/), o);
	o.write_shift(4, 0);
	o.write_shift(4, 0);
	o.write_shift(4, 0);
	o.write_shift(4, 0);
	return o;
}

/* [MS-XLSB] 2.4.327 BrtCommentAuthor */
var parse_BrtCommentAuthor = parse_XLWideString;
function write_BrtCommentAuthor(data) { return write_XLWideString(data.slice(0, 54)); }

/* [MS-XLSB] 2.1.7.8 Comments */
function parse_comments_bin(data, opts)/*:Array<RawComment>*/ {
	var out/*:Array<RawComment>*/ = [];
	var authors/*:Array<string>*/ = [];
	var c = {};
	var pass = false;
	recordhopper(data, function hopper_cmnt(val, R_n, RT) {
		switch(RT) {
			case 0x0278: /* 'BrtCommentAuthor' */
				authors.push(val); break;
			case 0x027B: /* 'BrtBeginComment' */
				c = val; break;
			case 0x027D: /* 'BrtCommentText' */
				c.t = val.t; c.h = val.h; c.r = val.r; break;
			case 0x027C: /* 'BrtEndComment' */
				c.author = authors[c.iauthor];
				delete (c/*:any*/).iauthor;
				if(opts.sheetRows && c.rfx && opts.sheetRows <= c.rfx.r) break;
				if(!c.t) c.t = "";
				delete c.rfx; out.push(c); break;

			case 0x0C00: /* 'BrtUid' */
				break;

			case 0x0023: /* 'BrtFRTBegin' */
				pass = true; break;
			case 0x0024: /* 'BrtFRTEnd' */
				pass = false; break;
			case 0x0025: /* 'BrtACBegin' */ break;
			case 0x0026: /* 'BrtACEnd' */ break;


			default:
				if((R_n||"").indexOf("Begin") > 0);
				else if((R_n||"").indexOf("End") > 0);
				else if(!pass || opts.WTF) throw new Error("Unexpected record " + RT + " " + R_n);
		}
	});
	return out;
}

function write_comments_bin(data/*::, opts*/) {
	var ba = buf_array();
	var iauthor/*:Array<string>*/ = [];
	write_record(ba, "BrtBeginComments");

	write_record(ba, "BrtBeginCommentAuthors");
	data.forEach(function(comment) {
		comment[1].forEach(function(c) {
			if(iauthor.indexOf(c.a) > -1) return;
			iauthor.push(c.a.slice(0,54));
			write_record(ba, "BrtCommentAuthor", write_BrtCommentAuthor(c.a));
		});
	});
	write_record(ba, "BrtEndCommentAuthors");

	write_record(ba, "BrtBeginCommentList");
	data.forEach(function(comment) {
		comment[1].forEach(function(c) {
			c.iauthor = iauthor.indexOf(c.a);
			var range = {s:decode_cell(comment[0]),e:decode_cell(comment[0])};
			write_record(ba, "BrtBeginComment", write_BrtBeginComment([range, c]));
			if(c.t && c.t.length > 0) write_record(ba, "BrtCommentText", write_BrtCommentText(c));
			write_record(ba, "BrtEndComment");
			delete c.iauthor;
		});
	});
	write_record(ba, "BrtEndCommentList");

	write_record(ba, "BrtEndComments");
	return ba.end();
}
var CT_VBA = "application/vnd.ms-office.vbaProject";
function make_vba_xls(cfb) {
  var newcfb = CFB.utils.cfb_new({ root: "R" });
  cfb.FullPaths.forEach(function(p, i) {
    if (p.slice(-1) === "/" || !p.match(/_VBA_PROJECT_CUR/))
      return;
    var newpath = p.replace(/^[^\/]*/, "R").replace(/\/_VBA_PROJECT_CUR\u0000*/, "");
    CFB.utils.cfb_add(newcfb, newpath, cfb.FileIndex[i].content);
  });
  return CFB.write(newcfb);
}
function fill_vba_xls(cfb, vba) {
  vba.FullPaths.forEach(function(p, i) {
    if (i == 0)
      return;
    var newpath = p.replace(/[^\/]*[\/]/, "/_VBA_PROJECT_CUR/");
    if (newpath.slice(-1) !== "/")
      CFB.utils.cfb_add(cfb, newpath, vba.FileIndex[i].content);
  });
}
var VBAFMTS = ["xlsb", "xlsm", "xlam", "biff8", "xla"];
RELS.DS = "http://schemas.openxmlformats.org/officeDocument/2006/relationships/dialogsheet";
RELS.MS = "http://schemas.microsoft.com/office/2006/relationships/xlMacrosheet";

/* macro and dialog sheet stubs */
function parse_ds_bin(/*::data:any, opts, idx:number, rels, wb, themes, styles*/)/*:Worksheet*/ { return {'!type':'dialog'}; }
function parse_ds_xml(/*::data:any, opts, idx:number, rels, wb, themes, styles*/)/*:Worksheet*/ { return {'!type':'dialog'}; }
function parse_ms_bin(/*::data:any, opts, idx:number, rels, wb, themes, styles*/)/*:Worksheet*/ { return {'!type':'macro'}; }
function parse_ms_xml(/*::data:any, opts, idx:number, rels, wb, themes, styles*/)/*:Worksheet*/ { return {'!type':'macro'}; }
/* TODO: it will be useful to parse the function str */
var rc_to_a1 = (function(){
	var rcregex = /(^|[^A-Za-z_])R(\[?-?\d+\]|[1-9]\d*|)C(\[?-?\d+\]|[1-9]\d*|)(?![A-Za-z0-9_])/g;
	var rcbase/*:Cell*/ = ({r:0,c:0}/*:any*/);
	function rcfunc($$,$1,$2,$3) {
		var cRel = false, rRel = false;

		if($2.length == 0) rRel = true;
		else if($2.charAt(0) == "[") { rRel = true; $2 = $2.slice(1, -1); }

		if($3.length == 0) cRel = true;
		else if($3.charAt(0) == "[") { cRel = true; $3 = $3.slice(1, -1); }

		var R = $2.length>0?parseInt($2,10)|0:0, C = $3.length>0?parseInt($3,10)|0:0;

		if(cRel) C += rcbase.c; else --C;
		if(rRel) R += rcbase.r; else --R;
		return $1 + (cRel ? "" : "$") + encode_col(C) + (rRel ? "" : "$") + encode_row(R);
	}
	return function rc_to_a1(fstr/*:string*/, base/*:Cell*/)/*:string*/ {
		rcbase = base;
		return fstr.replace(rcregex, rcfunc);
	};
})();

var crefregex = /(^|[^._A-Z0-9])([$]?)([A-Z]{1,2}|[A-W][A-Z]{2}|X[A-E][A-Z]|XF[A-D])([$]?)(10[0-3]\d{4}|104[0-7]\d{3}|1048[0-4]\d{2}|10485[0-6]\d|104857[0-6]|[1-9]\d{0,5})(?![_.\(A-Za-z0-9])/g;
var a1_to_rc =(function(){
	return function a1_to_rc(fstr/*:string*/, base/*:CellAddress*/) {
		return fstr.replace(crefregex, function($0, $1, $2, $3, $4, $5) {
			var c = decode_col($3) - ($2 ? 0 : base.c);
			var r = decode_row($5) - ($4 ? 0 : base.r);
			var R = (r == 0 ? "" : !$4 ? "[" + r + "]" : (r+1));
			var C = (c == 0 ? "" : !$2 ? "[" + c + "]" : (c+1));
			return $1 + "R" + R + "C" + C;
		});
	};
})();

/* no defined name can collide with a valid cell address A1:XFD1048576 ... except LOG10! */
function shift_formula_str(f/*:string*/, delta/*:Cell*/)/*:string*/ {
	return f.replace(crefregex, function($0, $1, $2, $3, $4, $5) {
		return $1+($2=="$" ? $2+$3 : encode_col(decode_col($3)+delta.c))+($4=="$" ? $4+$5 : encode_row(decode_row($5) + delta.r));
	});
}

function shift_formula_xlsx(f/*:string*/, range/*:string*/, cell/*:string*/)/*:string*/ {
	var r = decode_range(range), s = r.s, c = decode_cell(cell);
	var delta = {r:c.r - s.r, c:c.c - s.c};
	return shift_formula_str(f, delta);
}

/* TODO: parse formula */
function fuzzyfmla(f/*:string*/)/*:boolean*/ {
	if(f.length == 1) return false;
	return true;
}

function _xlfn(f/*:string*/)/*:string*/ {
	return f.replace(/_xlfn\./g,"");
}
function parseread1(blob) { blob.l+=1; return; }

/* [MS-XLS] 2.5.51 */
function parse_ColRelU(blob, length) {
	var c = blob.read_shift(length == 1 ? 1 : 2);
	return [c & 0x3FFF, (c >> 14) & 1, (c >> 15) & 1];
}

/* [MS-XLS] 2.5.198.105 ; [MS-XLSB] 2.5.97.89 */
function parse_RgceArea(blob, length, opts) {
	var w = 2;
	if(opts) {
		if(opts.biff >= 2 && opts.biff <= 5) return parse_RgceArea_BIFF2(blob);
		else if(opts.biff == 12) w = 4;
	}
	var r=blob.read_shift(w), R=blob.read_shift(w);
	var c=parse_ColRelU(blob, 2);
	var C=parse_ColRelU(blob, 2);
	return { s:{r:r, c:c[0], cRel:c[1], rRel:c[2]}, e:{r:R, c:C[0], cRel:C[1], rRel:C[2]} };
}
/* BIFF 2-5 encodes flags in the row field */
function parse_RgceArea_BIFF2(blob/*::, length, opts*/) {
	var r=parse_ColRelU(blob, 2), R=parse_ColRelU(blob, 2);
	var c=blob.read_shift(1);
	var C=blob.read_shift(1);
	return { s:{r:r[0], c:c, cRel:r[1], rRel:r[2]}, e:{r:R[0], c:C, cRel:R[1], rRel:R[2]} };
}

/* [MS-XLS] 2.5.198.105 ; [MS-XLSB] 2.5.97.90 */
function parse_RgceAreaRel(blob, length, opts) {
	if(opts.biff < 8) return parse_RgceArea_BIFF2(blob);
	var r=blob.read_shift(opts.biff == 12 ? 4 : 2), R=blob.read_shift(opts.biff == 12 ? 4 : 2);
	var c=parse_ColRelU(blob, 2);
	var C=parse_ColRelU(blob, 2);
	return { s:{r:r, c:c[0], cRel:c[1], rRel:c[2]}, e:{r:R, c:C[0], cRel:C[1], rRel:C[2]} };
}

/* [MS-XLS] 2.5.198.109 ; [MS-XLSB] 2.5.97.91 */
function parse_RgceLoc(blob, length, opts) {
	if(opts && opts.biff >= 2 && opts.biff <= 5) return parse_RgceLoc_BIFF2(blob);
	var r = blob.read_shift(opts && opts.biff == 12 ? 4 : 2);
	var c = parse_ColRelU(blob, 2);
	return {r:r, c:c[0], cRel:c[1], rRel:c[2]};
}
function parse_RgceLoc_BIFF2(blob/*::, length, opts*/) {
	var r = parse_ColRelU(blob, 2);
	var c = blob.read_shift(1);
	return {r:r[0], c:c, cRel:r[1], rRel:r[2]};
}

/* [MS-XLS] 2.5.198.107, 2.5.47 */
function parse_RgceElfLoc(blob/*::, length, opts*/) {
	var r = blob.read_shift(2);
	var c = blob.read_shift(2);
	return {r:r, c:c & 0xFF, fQuoted:!!(c & 0x4000), cRel:c>>15, rRel:c>>15 };
}

/* [MS-XLS] 2.5.198.111 ; [MS-XLSB] 2.5.97.92 TODO */
function parse_RgceLocRel(blob, length, opts) {
	var biff = opts && opts.biff ? opts.biff : 8;
	if(biff >= 2 && biff <= 5) return parse_RgceLocRel_BIFF2(blob);
	var r = blob.read_shift(biff >= 12 ? 4 : 2);
	var cl = blob.read_shift(2);
	var cRel = (cl & 0x4000) >> 14, rRel = (cl & 0x8000) >> 15;
	cl &= 0x3FFF;
	if(rRel == 1) while(r > 0x7FFFF) r -= 0x100000;
	if(cRel == 1) while(cl > 0x1FFF) cl = cl - 0x4000;
	return {r:r,c:cl,cRel:cRel,rRel:rRel};
}
function parse_RgceLocRel_BIFF2(blob/*::, length:number, opts*/) {
	var rl = blob.read_shift(2);
	var c = blob.read_shift(1);
	var rRel = (rl & 0x8000) >> 15, cRel = (rl & 0x4000) >> 14;
	rl &= 0x3FFF;
	if(rRel == 1 && rl >= 0x2000) rl = rl - 0x4000;
	if(cRel == 1 && c >= 0x80) c = c - 0x100;
	return {r:rl,c:c,cRel:cRel,rRel:rRel};
}

/* [MS-XLS] 2.5.198.27 ; [MS-XLSB] 2.5.97.18 */
function parse_PtgArea(blob, length, opts) {
	var type = (blob[blob.l++] & 0x60) >> 5;
	var area = parse_RgceArea(blob, opts.biff >= 2 && opts.biff <= 5 ? 6 : 8, opts);
	return [type, area];
}

/* [MS-XLS] 2.5.198.28 ; [MS-XLSB] 2.5.97.19 */
function parse_PtgArea3d(blob, length, opts) {
	var type = (blob[blob.l++] & 0x60) >> 5;
	var ixti = blob.read_shift(2, 'i');
	var w = 8;
	if(opts) switch(opts.biff) {
		case 5: blob.l += 12; w = 6; break;
		case 12: w = 12; break;
	}
	var area = parse_RgceArea(blob, w, opts);
	return [type, ixti, area];
}

/* [MS-XLS] 2.5.198.29 ; [MS-XLSB] 2.5.97.20 */
function parse_PtgAreaErr(blob, length, opts) {
	var type = (blob[blob.l++] & 0x60) >> 5;
	blob.l += opts && (opts.biff > 8) ? 12 : (opts.biff < 8 ? 6 : 8);
	return [type];
}
/* [MS-XLS] 2.5.198.30 ; [MS-XLSB] 2.5.97.21 */
function parse_PtgAreaErr3d(blob, length, opts) {
	var type = (blob[blob.l++] & 0x60) >> 5;
	var ixti = blob.read_shift(2);
	var w = 8;
	if(opts) switch(opts.biff) {
		case 5: blob.l += 12; w = 6; break;
		case 12: w = 12; break;
	}
	blob.l += w;
	return [type, ixti];
}

/* [MS-XLS] 2.5.198.31 ; [MS-XLSB] 2.5.97.22 */
function parse_PtgAreaN(blob, length, opts) {
	var type = (blob[blob.l++] & 0x60) >> 5;
	var area = parse_RgceAreaRel(blob, length - 1, opts);
	return [type, area];
}

/* [MS-XLS] 2.5.198.32 ; [MS-XLSB] 2.5.97.23 */
function parse_PtgArray(blob, length, opts) {
	var type = (blob[blob.l++] & 0x60) >> 5;
	blob.l += opts.biff == 2 ? 6 : opts.biff == 12 ? 14 : 7;
	return [type];
}

/* [MS-XLS] 2.5.198.33 ; [MS-XLSB] 2.5.97.24 */
function parse_PtgAttrBaxcel(blob) {
	var bitSemi = blob[blob.l+1] & 0x01; /* 1 = volatile */
	var bitBaxcel = 1;
	blob.l += 4;
	return [bitSemi, bitBaxcel];
}

/* [MS-XLS] 2.5.198.34 ; [MS-XLSB] 2.5.97.25 */
function parse_PtgAttrChoose(blob, length, opts)/*:Array<number>*/ {
	blob.l +=2;
	var offset = blob.read_shift(opts && opts.biff == 2 ? 1 : 2);
	var o/*:Array<number>*/ = [];
	/* offset is 1 less than the number of elements */
	for(var i = 0; i <= offset; ++i) o.push(blob.read_shift(opts && opts.biff == 2 ? 1 : 2));
	return o;
}

/* [MS-XLS] 2.5.198.35 ; [MS-XLSB] 2.5.97.26 */
function parse_PtgAttrGoto(blob, length, opts) {
	var bitGoto = (blob[blob.l+1] & 0xFF) ? 1 : 0;
	blob.l += 2;
	return [bitGoto, blob.read_shift(opts && opts.biff == 2 ? 1 : 2)];
}

/* [MS-XLS] 2.5.198.36 ; [MS-XLSB] 2.5.97.27 */
function parse_PtgAttrIf(blob, length, opts) {
	var bitIf = (blob[blob.l+1] & 0xFF) ? 1 : 0;
	blob.l += 2;
	return [bitIf, blob.read_shift(opts && opts.biff == 2 ? 1 : 2)];
}

/* [MS-XLSB] 2.5.97.28 */
function parse_PtgAttrIfError(blob) {
	var bitIf = (blob[blob.l+1] & 0xFF) ? 1 : 0;
	blob.l += 2;
	return [bitIf, blob.read_shift(2)];
}

/* [MS-XLS] 2.5.198.37 ; [MS-XLSB] 2.5.97.29 */
function parse_PtgAttrSemi(blob, length, opts) {
	var bitSemi = (blob[blob.l+1] & 0xFF) ? 1 : 0;
	blob.l += opts && opts.biff == 2 ? 3 : 4;
	return [bitSemi];
}

/* [MS-XLS] 2.5.198.40 ; [MS-XLSB] 2.5.97.32 */
function parse_PtgAttrSpaceType(blob/*::, length*/) {
	var type = blob.read_shift(1), cch = blob.read_shift(1);
	return [type, cch];
}

/* [MS-XLS] 2.5.198.38 ; [MS-XLSB] 2.5.97.30 */
function parse_PtgAttrSpace(blob) {
	blob.read_shift(2);
	return parse_PtgAttrSpaceType(blob);
}

/* [MS-XLS] 2.5.198.39 ; [MS-XLSB] 2.5.97.31 */
function parse_PtgAttrSpaceSemi(blob) {
	blob.read_shift(2);
	return parse_PtgAttrSpaceType(blob);
}

/* [MS-XLS] 2.5.198.84 ; [MS-XLSB] 2.5.97.68 TODO */
function parse_PtgRef(blob, length, opts) {
	//var ptg = blob[blob.l] & 0x1F;
	var type = (blob[blob.l] & 0x60)>>5;
	blob.l += 1;
	var loc = parse_RgceLoc(blob, 0, opts);
	return [type, loc];
}

/* [MS-XLS] 2.5.198.88 ; [MS-XLSB] 2.5.97.72 TODO */
function parse_PtgRefN(blob, length, opts) {
	var type = (blob[blob.l] & 0x60)>>5;
	blob.l += 1;
	var loc = parse_RgceLocRel(blob, 0, opts);
	return [type, loc];
}

/* [MS-XLS] 2.5.198.85 ; [MS-XLSB] 2.5.97.69 TODO */
function parse_PtgRef3d(blob, length, opts) {
	var type = (blob[blob.l] & 0x60)>>5;
	blob.l += 1;
	var ixti = blob.read_shift(2); // XtiIndex
	if(opts && opts.biff == 5) blob.l += 12;
	var loc = parse_RgceLoc(blob, 0, opts); // TODO: or RgceLocRel
	return [type, ixti, loc];
}


/* [MS-XLS] 2.5.198.62 ; [MS-XLSB] 2.5.97.45 TODO */
function parse_PtgFunc(blob, length, opts) {
	//var ptg = blob[blob.l] & 0x1F;
	var type = (blob[blob.l] & 0x60)>>5;
	blob.l += 1;
	var iftab = blob.read_shift(opts && opts.biff <= 3 ? 1 : 2);
	return [FtabArgc[iftab], Ftab[iftab], type];
}
/* [MS-XLS] 2.5.198.63 ; [MS-XLSB] 2.5.97.46 TODO */
function parse_PtgFuncVar(blob, length, opts) {
	var type = blob[blob.l++];
	var cparams = blob.read_shift(1), tab = opts && opts.biff <= 3 ? [(type == 0x58 ? -1 : 0), blob.read_shift(1)]: parsetab(blob);
	return [cparams, (tab[0] === 0 ? Ftab : Cetab)[tab[1]]];
}

function parsetab(blob) {
	return [blob[blob.l+1]>>7, blob.read_shift(2) & 0x7FFF];
}

/* [MS-XLS] 2.5.198.41 ; [MS-XLSB] 2.5.97.33 */
function parse_PtgAttrSum(blob, length, opts) {
	blob.l += opts && opts.biff == 2 ? 3 : 4; return;
}

/* [MS-XLS] 2.5.198.58 ; [MS-XLSB] 2.5.97.40 */
function parse_PtgExp(blob, length, opts) {
	blob.l++;
	if(opts && opts.biff == 12) return [blob.read_shift(4, 'i'), 0];
	var row = blob.read_shift(2);
	var col = blob.read_shift(opts && opts.biff == 2 ? 1 : 2);
	return [row, col];
}

/* [MS-XLS] 2.5.198.57 ; [MS-XLSB] 2.5.97.39 */
function parse_PtgErr(blob) { blob.l++; return BErr[blob.read_shift(1)]; }

/* [MS-XLS] 2.5.198.66 ; [MS-XLSB] 2.5.97.49 */
function parse_PtgInt(blob) { blob.l++; return blob.read_shift(2); }

/* [MS-XLS] 2.5.198.42 ; [MS-XLSB] 2.5.97.34 */
function parse_PtgBool(blob) { blob.l++; return blob.read_shift(1)!==0;}

/* [MS-XLS] 2.5.198.79 ; [MS-XLSB] 2.5.97.63 */
function parse_PtgNum(blob) { blob.l++; return parse_Xnum(blob); }

/* [MS-XLS] 2.5.198.89 ; [MS-XLSB] 2.5.97.74 */
function parse_PtgStr(blob, length, opts) { blob.l++; return parse_ShortXLUnicodeString(blob, length-1, opts); }

/* [MS-XLS] 2.5.192.112 + 2.5.192.11{3,4,5,6,7} */
/* [MS-XLSB] 2.5.97.93 + 2.5.97.9{4,5,6,7} */
function parse_SerAr(blob, biff/*:number*/) {
	var val = [blob.read_shift(1)];
	if(biff == 12) switch(val[0]) {
		case 0x02: val[0] = 0x04; break; /* SerBool */
		case 0x04: val[0] = 0x10; break; /* SerErr */
		case 0x00: val[0] = 0x01; break; /* SerNum */
		case 0x01: val[0] = 0x02; break; /* SerStr */
	}
	switch(val[0]) {
		case 0x04: /* SerBool -- boolean */
			val[1] = parsebool(blob, 1) ? 'TRUE' : 'FALSE';
			if(biff != 12) blob.l += 7; break;
		case 0x25: /* appears to be an alias */
		case 0x10: /* SerErr -- error */
			val[1] = BErr[blob[blob.l]];
			blob.l += ((biff == 12) ? 4 : 8); break;
		case 0x00: /* SerNil -- honestly, I'm not sure how to reproduce this */
			blob.l += 8; break;
		case 0x01: /* SerNum -- Xnum */
			val[1] = parse_Xnum(blob); break;
		case 0x02: /* SerStr -- XLUnicodeString (<256 chars) */
			val[1] = parse_XLUnicodeString2(blob, 0, {biff:biff > 0 && biff < 8 ? 2 : biff}); break;
		default: throw new Error("Bad SerAr: " + val[0]); /* Unreachable */
	}
	return val;
}

/* [MS-XLS] 2.5.198.61 ; [MS-XLSB] 2.5.97.44 */
function parse_PtgExtraMem(blob, cce, opts) {
	var count = blob.read_shift((opts.biff == 12) ? 4 : 2);
	var out/*:Array<Range>*/ = [];
	for(var i = 0; i != count; ++i) out.push(((opts.biff == 12) ? parse_UncheckedRfX : parse_Ref8U)(blob, 8));
	return out;
}

/* [MS-XLS] 2.5.198.59 ; [MS-XLSB] 2.5.97.41 */
function parse_PtgExtraArray(blob, length, opts) {
	var rows = 0, cols = 0;
	if(opts.biff == 12) {
		rows = blob.read_shift(4); // DRw
		cols = blob.read_shift(4); // DCol
	} else {
		cols = 1 + blob.read_shift(1); //DColByteU
		rows = 1 + blob.read_shift(2); //DRw
	}
	if(opts.biff >= 2 && opts.biff < 8) { --rows; if(--cols == 0) cols = 0x100; }
	// $FlowIgnore
	for(var i = 0, o/*:Array<Array<any>>*/ = []; i != rows && (o[i] = []); ++i)
		for(var j = 0; j != cols; ++j) o[i][j] = parse_SerAr(blob, opts.biff);
	return o;
}

/* [MS-XLS] 2.5.198.76 ; [MS-XLSB] 2.5.97.60 */
function parse_PtgName(blob, length, opts) {
	var type = (blob.read_shift(1) >>> 5) & 0x03;
	var w = (!opts || (opts.biff >= 8)) ? 4 : 2;
	var nameindex = blob.read_shift(w);
	switch(opts.biff) {
		case 2: blob.l += 5; break;
		case 3: case 4: blob.l += 8; break;
		case 5: blob.l += 12; break;
	}
	return [type, 0, nameindex];
}

/* [MS-XLS] 2.5.198.77 ; [MS-XLSB] 2.5.97.61 */
function parse_PtgNameX(blob, length, opts) {
	if(opts.biff == 5) return parse_PtgNameX_BIFF5(blob);
	var type = (blob.read_shift(1) >>> 5) & 0x03;
	var ixti = blob.read_shift(2); // XtiIndex
	var nameindex = blob.read_shift(4);
	return [type, ixti, nameindex];
}
function parse_PtgNameX_BIFF5(blob/*::, length, opts*/) {
	var type = (blob.read_shift(1) >>> 5) & 0x03;
	var ixti = blob.read_shift(2, 'i'); // XtiIndex
	blob.l += 8;
	var nameindex = blob.read_shift(2);
	blob.l += 12;
	return [type, ixti, nameindex];
}

/* [MS-XLS] 2.5.198.70 ; [MS-XLSB] 2.5.97.54 */
function parse_PtgMemArea(blob, length, opts) {
	var type = (blob.read_shift(1) >>> 5) & 0x03;
	blob.l += (opts && opts.biff == 2 ? 3 : 4);
	var cce = blob.read_shift(opts && opts.biff == 2 ? 1 : 2);
	return [type, cce];
}

/* [MS-XLS] 2.5.198.72 ; [MS-XLSB] 2.5.97.56 */
function parse_PtgMemFunc(blob, length, opts) {
	var type = (blob.read_shift(1) >>> 5) & 0x03;
	var cce = blob.read_shift(opts && opts.biff == 2 ? 1 : 2);
	return [type, cce];
}


/* [MS-XLS] 2.5.198.86 ; [MS-XLSB] 2.5.97.69 */
function parse_PtgRefErr(blob, length, opts) {
	var type = (blob.read_shift(1) >>> 5) & 0x03;
	blob.l += 4;
	if(opts.biff < 8) blob.l--;
	if(opts.biff == 12) blob.l += 2;
	return [type];
}

/* [MS-XLS] 2.5.198.87 ; [MS-XLSB] 2.5.97.71 */
function parse_PtgRefErr3d(blob, length, opts) {
	var type = (blob[blob.l++] & 0x60) >> 5;
	var ixti = blob.read_shift(2);
	var w = 4;
	if(opts) switch(opts.biff) {
		case 5: w = 15; break;
		case 12: w = 6; break;
	}
	blob.l += w;
	return [type, ixti];
}

/* [MS-XLS] 2.5.198.71 ; [MS-XLSB] 2.5.97.55 */
var parse_PtgMemErr = parsenoop;
/* [MS-XLS] 2.5.198.73  ; [MS-XLSB] 2.5.97.57 */
var parse_PtgMemNoMem = parsenoop;
/* [MS-XLS] 2.5.198.92 */
var parse_PtgTbl = parsenoop;

function parse_PtgElfLoc(blob, length, opts) {
	blob.l += 2;
	return [parse_RgceElfLoc(blob)];
}
function parse_PtgElfNoop(blob/*::, length, opts*/) {
	blob.l += 6;
	return [];
}
/* [MS-XLS] 2.5.198.46 */
var parse_PtgElfCol = parse_PtgElfLoc;
/* [MS-XLS] 2.5.198.47 */
var parse_PtgElfColS = parse_PtgElfNoop;
/* [MS-XLS] 2.5.198.48 */
var parse_PtgElfColSV = parse_PtgElfNoop;
/* [MS-XLS] 2.5.198.49 */
var parse_PtgElfColV = parse_PtgElfLoc;
/* [MS-XLS] 2.5.198.50 */
function parse_PtgElfLel(blob/*::, length, opts*/) {
	blob.l += 2;
	return [parseuint16(blob), blob.read_shift(2) & 0x01];
}
/* [MS-XLS] 2.5.198.51 */
var parse_PtgElfRadical = parse_PtgElfLoc;
/* [MS-XLS] 2.5.198.52 */
var parse_PtgElfRadicalLel = parse_PtgElfLel;
/* [MS-XLS] 2.5.198.53 */
var parse_PtgElfRadicalS = parse_PtgElfNoop;
/* [MS-XLS] 2.5.198.54 */
var parse_PtgElfRw = parse_PtgElfLoc;
/* [MS-XLS] 2.5.198.55 */
var parse_PtgElfRwV = parse_PtgElfLoc;

/* [MS-XLSB] 2.5.97.52 TODO */
var PtgListRT = [
	"Data",
	"All",
	"Headers",
	"??",
	"?Data2",
	"??",
	"?DataHeaders",
	"??",
	"Totals",
	"??",
	"??",
	"??",
	"?DataTotals",
	"??",
	"??",
	"??",
	"?Current"
];
function parse_PtgList(blob/*::, length, opts*/) {
	blob.l += 2;
	var ixti = blob.read_shift(2);
	var flags = blob.read_shift(2);
	var idx = blob.read_shift(4);
	var c = blob.read_shift(2);
	var C = blob.read_shift(2);
	var rt = PtgListRT[(flags >> 2) & 0x1F];
	return {ixti: ixti, coltype:(flags&0x3), rt:rt, idx:idx, c:c, C:C};
}
/* [MS-XLS] 2.5.198.91 ; [MS-XLSB] 2.5.97.76 */
function parse_PtgSxName(blob/*::, length, opts*/) {
	blob.l += 2;
	return [blob.read_shift(4)];
}

/* [XLS] old spec */
function parse_PtgSheet(blob, length, opts) {
	blob.l += 5;
	blob.l += 2;
	blob.l += (opts.biff == 2 ? 1 : 4);
	return ["PTGSHEET"];
}
function parse_PtgEndSheet(blob, length, opts) {
	blob.l += (opts.biff == 2 ? 4 : 5);
	return ["PTGENDSHEET"];
}
function parse_PtgMemAreaN(blob/*::, length, opts*/) {
	var type = (blob.read_shift(1) >>> 5) & 0x03;
	var cce = blob.read_shift(2);
	return [type, cce];
}
function parse_PtgMemNoMemN(blob/*::, length, opts*/) {
	var type = (blob.read_shift(1) >>> 5) & 0x03;
	var cce = blob.read_shift(2);
	return [type, cce];
}
function parse_PtgAttrNoop(blob/*::, length, opts*/) {
	blob.l += 4;
	return [0, 0];
}

/* [MS-XLS] 2.5.198.25 ; [MS-XLSB] 2.5.97.16 */
var PtgTypes = {
	/*::[*/0x01/*::]*/: { n:'PtgExp', f:parse_PtgExp },
	/*::[*/0x02/*::]*/: { n:'PtgTbl', f:parse_PtgTbl },
	/*::[*/0x03/*::]*/: { n:'PtgAdd', f:parseread1 },
	/*::[*/0x04/*::]*/: { n:'PtgSub', f:parseread1 },
	/*::[*/0x05/*::]*/: { n:'PtgMul', f:parseread1 },
	/*::[*/0x06/*::]*/: { n:'PtgDiv', f:parseread1 },
	/*::[*/0x07/*::]*/: { n:'PtgPower', f:parseread1 },
	/*::[*/0x08/*::]*/: { n:'PtgConcat', f:parseread1 },
	/*::[*/0x09/*::]*/: { n:'PtgLt', f:parseread1 },
	/*::[*/0x0A/*::]*/: { n:'PtgLe', f:parseread1 },
	/*::[*/0x0B/*::]*/: { n:'PtgEq', f:parseread1 },
	/*::[*/0x0C/*::]*/: { n:'PtgGe', f:parseread1 },
	/*::[*/0x0D/*::]*/: { n:'PtgGt', f:parseread1 },
	/*::[*/0x0E/*::]*/: { n:'PtgNe', f:parseread1 },
	/*::[*/0x0F/*::]*/: { n:'PtgIsect', f:parseread1 },
	/*::[*/0x10/*::]*/: { n:'PtgUnion', f:parseread1 },
	/*::[*/0x11/*::]*/: { n:'PtgRange', f:parseread1 },
	/*::[*/0x12/*::]*/: { n:'PtgUplus', f:parseread1 },
	/*::[*/0x13/*::]*/: { n:'PtgUminus', f:parseread1 },
	/*::[*/0x14/*::]*/: { n:'PtgPercent', f:parseread1 },
	/*::[*/0x15/*::]*/: { n:'PtgParen', f:parseread1 },
	/*::[*/0x16/*::]*/: { n:'PtgMissArg', f:parseread1 },
	/*::[*/0x17/*::]*/: { n:'PtgStr', f:parse_PtgStr },
	/*::[*/0x1A/*::]*/: { n:'PtgSheet', f:parse_PtgSheet },
	/*::[*/0x1B/*::]*/: { n:'PtgEndSheet', f:parse_PtgEndSheet },
	/*::[*/0x1C/*::]*/: { n:'PtgErr', f:parse_PtgErr },
	/*::[*/0x1D/*::]*/: { n:'PtgBool', f:parse_PtgBool },
	/*::[*/0x1E/*::]*/: { n:'PtgInt', f:parse_PtgInt },
	/*::[*/0x1F/*::]*/: { n:'PtgNum', f:parse_PtgNum },
	/*::[*/0x20/*::]*/: { n:'PtgArray', f:parse_PtgArray },
	/*::[*/0x21/*::]*/: { n:'PtgFunc', f:parse_PtgFunc },
	/*::[*/0x22/*::]*/: { n:'PtgFuncVar', f:parse_PtgFuncVar },
	/*::[*/0x23/*::]*/: { n:'PtgName', f:parse_PtgName },
	/*::[*/0x24/*::]*/: { n:'PtgRef', f:parse_PtgRef },
	/*::[*/0x25/*::]*/: { n:'PtgArea', f:parse_PtgArea },
	/*::[*/0x26/*::]*/: { n:'PtgMemArea', f:parse_PtgMemArea },
	/*::[*/0x27/*::]*/: { n:'PtgMemErr', f:parse_PtgMemErr },
	/*::[*/0x28/*::]*/: { n:'PtgMemNoMem', f:parse_PtgMemNoMem },
	/*::[*/0x29/*::]*/: { n:'PtgMemFunc', f:parse_PtgMemFunc },
	/*::[*/0x2A/*::]*/: { n:'PtgRefErr', f:parse_PtgRefErr },
	/*::[*/0x2B/*::]*/: { n:'PtgAreaErr', f:parse_PtgAreaErr },
	/*::[*/0x2C/*::]*/: { n:'PtgRefN', f:parse_PtgRefN },
	/*::[*/0x2D/*::]*/: { n:'PtgAreaN', f:parse_PtgAreaN },
	/*::[*/0x2E/*::]*/: { n:'PtgMemAreaN', f:parse_PtgMemAreaN },
	/*::[*/0x2F/*::]*/: { n:'PtgMemNoMemN', f:parse_PtgMemNoMemN },
	/*::[*/0x39/*::]*/: { n:'PtgNameX', f:parse_PtgNameX },
	/*::[*/0x3A/*::]*/: { n:'PtgRef3d', f:parse_PtgRef3d },
	/*::[*/0x3B/*::]*/: { n:'PtgArea3d', f:parse_PtgArea3d },
	/*::[*/0x3C/*::]*/: { n:'PtgRefErr3d', f:parse_PtgRefErr3d },
	/*::[*/0x3D/*::]*/: { n:'PtgAreaErr3d', f:parse_PtgAreaErr3d },
	/*::[*/0xFF/*::]*/: {}
};
/* These are duplicated in the PtgTypes table */
var PtgDupes = {
	/*::[*/0x40/*::]*/: 0x20, /*::[*/0x60/*::]*/: 0x20,
	/*::[*/0x41/*::]*/: 0x21, /*::[*/0x61/*::]*/: 0x21,
	/*::[*/0x42/*::]*/: 0x22, /*::[*/0x62/*::]*/: 0x22,
	/*::[*/0x43/*::]*/: 0x23, /*::[*/0x63/*::]*/: 0x23,
	/*::[*/0x44/*::]*/: 0x24, /*::[*/0x64/*::]*/: 0x24,
	/*::[*/0x45/*::]*/: 0x25, /*::[*/0x65/*::]*/: 0x25,
	/*::[*/0x46/*::]*/: 0x26, /*::[*/0x66/*::]*/: 0x26,
	/*::[*/0x47/*::]*/: 0x27, /*::[*/0x67/*::]*/: 0x27,
	/*::[*/0x48/*::]*/: 0x28, /*::[*/0x68/*::]*/: 0x28,
	/*::[*/0x49/*::]*/: 0x29, /*::[*/0x69/*::]*/: 0x29,
	/*::[*/0x4A/*::]*/: 0x2A, /*::[*/0x6A/*::]*/: 0x2A,
	/*::[*/0x4B/*::]*/: 0x2B, /*::[*/0x6B/*::]*/: 0x2B,
	/*::[*/0x4C/*::]*/: 0x2C, /*::[*/0x6C/*::]*/: 0x2C,
	/*::[*/0x4D/*::]*/: 0x2D, /*::[*/0x6D/*::]*/: 0x2D,
	/*::[*/0x4E/*::]*/: 0x2E, /*::[*/0x6E/*::]*/: 0x2E,
	/*::[*/0x4F/*::]*/: 0x2F, /*::[*/0x6F/*::]*/: 0x2F,
	/*::[*/0x58/*::]*/: 0x22, /*::[*/0x78/*::]*/: 0x22,
	/*::[*/0x59/*::]*/: 0x39, /*::[*/0x79/*::]*/: 0x39,
	/*::[*/0x5A/*::]*/: 0x3A, /*::[*/0x7A/*::]*/: 0x3A,
	/*::[*/0x5B/*::]*/: 0x3B, /*::[*/0x7B/*::]*/: 0x3B,
	/*::[*/0x5C/*::]*/: 0x3C, /*::[*/0x7C/*::]*/: 0x3C,
	/*::[*/0x5D/*::]*/: 0x3D, /*::[*/0x7D/*::]*/: 0x3D
};
(function(){for(var y in PtgDupes) PtgTypes[y] = PtgTypes[PtgDupes[y]];})();

var Ptg18 = {
	/*::[*/0x01/*::]*/: { n:'PtgElfLel', f:parse_PtgElfLel },
	/*::[*/0x02/*::]*/: { n:'PtgElfRw', f:parse_PtgElfRw },
	/*::[*/0x03/*::]*/: { n:'PtgElfCol', f:parse_PtgElfCol },
	/*::[*/0x06/*::]*/: { n:'PtgElfRwV', f:parse_PtgElfRwV },
	/*::[*/0x07/*::]*/: { n:'PtgElfColV', f:parse_PtgElfColV },
	/*::[*/0x0A/*::]*/: { n:'PtgElfRadical', f:parse_PtgElfRadical },
	/*::[*/0x0B/*::]*/: { n:'PtgElfRadicalS', f:parse_PtgElfRadicalS },
	/*::[*/0x0D/*::]*/: { n:'PtgElfColS', f:parse_PtgElfColS },
	/*::[*/0x0F/*::]*/: { n:'PtgElfColSV', f:parse_PtgElfColSV },
	/*::[*/0x10/*::]*/: { n:'PtgElfRadicalLel', f:parse_PtgElfRadicalLel },
	/*::[*/0x19/*::]*/: { n:'PtgList', f:parse_PtgList },
	/*::[*/0x1D/*::]*/: { n:'PtgSxName', f:parse_PtgSxName },
	/*::[*/0xFF/*::]*/: {}
};
var Ptg19 = {
	/*::[*/0x00/*::]*/: { n:'PtgAttrNoop', f:parse_PtgAttrNoop },
	/*::[*/0x01/*::]*/: { n:'PtgAttrSemi', f:parse_PtgAttrSemi },
	/*::[*/0x02/*::]*/: { n:'PtgAttrIf', f:parse_PtgAttrIf },
	/*::[*/0x04/*::]*/: { n:'PtgAttrChoose', f:parse_PtgAttrChoose },
	/*::[*/0x08/*::]*/: { n:'PtgAttrGoto', f:parse_PtgAttrGoto },
	/*::[*/0x10/*::]*/: { n:'PtgAttrSum', f:parse_PtgAttrSum },
	/*::[*/0x20/*::]*/: { n:'PtgAttrBaxcel', f:parse_PtgAttrBaxcel },
	/*::[*/0x40/*::]*/: { n:'PtgAttrSpace', f:parse_PtgAttrSpace },
	/*::[*/0x41/*::]*/: { n:'PtgAttrSpaceSemi', f:parse_PtgAttrSpaceSemi },
	/*::[*/0x80/*::]*/: { n:'PtgAttrIfError', f:parse_PtgAttrIfError },
	/*::[*/0xFF/*::]*/: {}
};
Ptg19[0x21] = Ptg19[0x20];

/* [MS-XLS] 2.5.198.103 ; [MS-XLSB] 2.5.97.87 */
function parse_RgbExtra(blob, length, rgce, opts) {
	if(opts.biff < 8) return parsenoop(blob, length);
	var target = blob.l + length;
	var o = [];
	for(var i = 0; i !== rgce.length; ++i) {
		switch(rgce[i][0]) {
			case 'PtgArray': /* PtgArray -> PtgExtraArray */
				rgce[i][1] = parse_PtgExtraArray(blob, 0, opts);
				o.push(rgce[i][1]);
				break;
			case 'PtgMemArea': /* PtgMemArea -> PtgExtraMem */
				rgce[i][2] = parse_PtgExtraMem(blob, rgce[i][1], opts);
				o.push(rgce[i][2]);
				break;
			case 'PtgExp': /* PtgExp -> PtgExtraCol */
				if(opts && opts.biff == 12) {
					rgce[i][1][1] = blob.read_shift(4);
					o.push(rgce[i][1]);
				} break;
			case 'PtgList': /* TODO: PtgList -> PtgExtraList */
			case 'PtgElfRadicalS': /* TODO: PtgElfRadicalS -> PtgExtraElf */
			case 'PtgElfColS': /* TODO: PtgElfColS -> PtgExtraElf */
			case 'PtgElfColSV': /* TODO: PtgElfColSV -> PtgExtraElf */
				throw "Unsupported " + rgce[i][0];
		}
	}
	length = target - blob.l;
	/* note: this is technically an error but Excel disregards */
	//if(target !== blob.l && blob.l !== target - length) throw new Error(target + " != " + blob.l);
	if(length !== 0) o.push(parsenoop(blob, length));
	return o;
}

/* [MS-XLS] 2.5.198.104 ; [MS-XLSB] 2.5.97.88 */
function parse_Rgce(blob, length, opts) {
	var target = blob.l + length;
	var R, id, ptgs = [];
	while(target != blob.l) {
		length = target - blob.l;
		id = blob[blob.l];
		R = PtgTypes[id];
		if(id === 0x18 || id === 0x19) R = (id === 0x18 ? Ptg18 : Ptg19)[blob[blob.l + 1]];
		if(!R || !R.f) { /*ptgs.push*/(parsenoop(blob, length)); }
		else { ptgs.push([R.n, R.f(blob, length, opts)]); }
	}
	return ptgs;
}

function stringify_array(f/*:Array<Array<string>>*/)/*:string*/ {
	var o/*:Array<string>*/ = [];
	for(var i = 0; i < f.length; ++i) {
		var x = f[i], r/*:Array<string>*/ = [];
		for(var j = 0; j < x.length; ++j) {
			var y = x[j];
			if(y) switch(y[0]) {
				// TODO: handle embedded quotes
				case 0x02:
					/*:: if(typeof y[1] != 'string') throw "unreachable"; */
					r.push('"' + y[1].replace(/"/g,'""') + '"'); break;
				default: r.push(y[1]);
			} else r.push("");
		}
		o.push(r.join(","));
	}
	return o.join(";");
}

/* [MS-XLS] 2.2.2 ; [MS-XLSB] 2.2.2 TODO */
var PtgBinOp = {
	PtgAdd: "+",
	PtgConcat: "&",
	PtgDiv: "/",
	PtgEq: "=",
	PtgGe: ">=",
	PtgGt: ">",
	PtgLe: "<=",
	PtgLt: "<",
	PtgMul: "*",
	PtgNe: "<>",
	PtgPower: "^",
	PtgSub: "-"
};

// List of invalid characters needs to be tested further
var quoteCharacters /*:RegExp */ = new RegExp(/[^\w\u4E00-\u9FFF\u3040-\u30FF]/);
function formula_quote_sheet_name(sname/*:string*/, opts)/*:string*/ {
	if(!sname && !(opts && opts.biff <= 5 && opts.biff >= 2)) throw new Error("empty sheet name");
	if (quoteCharacters.test(sname)) return "'" + sname + "'";
	return sname;
}
function get_ixti_raw(supbooks, ixti/*:number*/, opts)/*:string*/ {
	if(!supbooks) return "SH33TJSERR0";
	if(opts.biff > 8 && (!supbooks.XTI || !supbooks.XTI[ixti])) return supbooks.SheetNames[ixti];
	if(!supbooks.XTI) return "SH33TJSERR6";
	var XTI = supbooks.XTI[ixti];
	if(opts.biff < 8) {
		if(ixti > 10000) ixti-= 65536;
		if(ixti < 0) ixti = -ixti;
		return ixti == 0 ? "" : supbooks.XTI[ixti - 1];
	}
	if(!XTI) return "SH33TJSERR1";
	var o = "";
	if(opts.biff > 8) switch(supbooks[XTI[0]][0]) {
		case 0x0165: /* 'BrtSupSelf' */
			o = XTI[1] == -1 ? "#REF" : supbooks.SheetNames[XTI[1]];
			return XTI[1] == XTI[2] ? o : o + ":" + supbooks.SheetNames[XTI[2]];
		case 0x0166: /* 'BrtSupSame' */
			if(opts.SID != null) return supbooks.SheetNames[opts.SID];
			return "SH33TJSSAME" + supbooks[XTI[0]][0];
		case 0x0163: /* 'BrtSupBookSrc' */
			/* falls through */
		default: return "SH33TJSSRC" + supbooks[XTI[0]][0];
	}
	switch(supbooks[XTI[0]][0][0]) {
		case 0x0401:
			o = XTI[1] == -1 ? "#REF" : (supbooks.SheetNames[XTI[1]] || "SH33TJSERR3");
			return XTI[1] == XTI[2] ? o : o + ":" + supbooks.SheetNames[XTI[2]];
		case 0x3A01: return supbooks[XTI[0]].slice(1).map(function(name) { return name.Name; }).join(";;"); //return "SH33TJSERR8";
		default:
			if(!supbooks[XTI[0]][0][3]) return "SH33TJSERR2";
			o = XTI[1] == -1 ? "#REF" : (supbooks[XTI[0]][0][3][XTI[1]] || "SH33TJSERR4");
			return XTI[1] == XTI[2] ? o : o + ":" + supbooks[XTI[0]][0][3][XTI[2]];
	}
}
function get_ixti(supbooks, ixti/*:number*/, opts)/*:string*/ {
	var ixtiraw = get_ixti_raw(supbooks, ixti, opts);
	return ixtiraw == "#REF" ? ixtiraw : formula_quote_sheet_name(ixtiraw, opts);
}
function stringify_formula(formula/*Array<any>*/, range, cell/*:any*/, supbooks, opts)/*:string*/ {
	var biff = (opts && opts.biff) || 8;
	var _range = /*range != null ? range :*/ {s:{c:0, r:0},e:{c:0, r:0}};
	var stack/*:Array<string>*/ = [], e1, e2, /*::type,*/ c/*:CellAddress*/, ixti=0, nameidx=0, r, sname="";
	if(!formula[0] || !formula[0][0]) return "";
	var last_sp = -1, sp = "";
	for(var ff = 0, fflen = formula[0].length; ff < fflen; ++ff) {
		var f = formula[0][ff];
		switch(f[0]) {
			case 'PtgUminus': /* [MS-XLS] 2.5.198.93 */
				stack.push("-" + stack.pop()); break;
			case 'PtgUplus': /* [MS-XLS] 2.5.198.95 */
				stack.push("+" + stack.pop()); break;
			case 'PtgPercent': /* [MS-XLS] 2.5.198.81 */
				stack.push(stack.pop() + "%"); break;

			case 'PtgAdd':    /* [MS-XLS] 2.5.198.26 */
			case 'PtgConcat': /* [MS-XLS] 2.5.198.43 */
			case 'PtgDiv':    /* [MS-XLS] 2.5.198.45 */
			case 'PtgEq':     /* [MS-XLS] 2.5.198.56 */
			case 'PtgGe':     /* [MS-XLS] 2.5.198.64 */
			case 'PtgGt':     /* [MS-XLS] 2.5.198.65 */
			case 'PtgLe':     /* [MS-XLS] 2.5.198.68 */
			case 'PtgLt':     /* [MS-XLS] 2.5.198.69 */
			case 'PtgMul':    /* [MS-XLS] 2.5.198.75 */
			case 'PtgNe':     /* [MS-XLS] 2.5.198.78 */
			case 'PtgPower':  /* [MS-XLS] 2.5.198.82 */
			case 'PtgSub':    /* [MS-XLS] 2.5.198.90 */
				e1 = stack.pop(); e2 = stack.pop();
				if(last_sp >= 0) {
					switch(formula[0][last_sp][1][0]) {
						case 0:
							// $FlowIgnore
							sp = fill(" ", formula[0][last_sp][1][1]); break;
						case 1:
							// $FlowIgnore
							sp = fill("\r", formula[0][last_sp][1][1]); break;
						default:
							sp = "";
							// $FlowIgnore
							if(opts.WTF) throw new Error("Unexpected PtgAttrSpaceType " + formula[0][last_sp][1][0]);
					}
					e2 = e2 + sp;
					last_sp = -1;
				}
				stack.push(e2+PtgBinOp[f[0]]+e1);
				break;

			case 'PtgIsect': /* [MS-XLS] 2.5.198.67 */
				e1 = stack.pop(); e2 = stack.pop();
				stack.push(e2+" "+e1);
				break;
			case 'PtgUnion': /* [MS-XLS] 2.5.198.94 */
				e1 = stack.pop(); e2 = stack.pop();
				stack.push(e2+","+e1);
				break;
			case 'PtgRange': /* [MS-XLS] 2.5.198.83 */
				e1 = stack.pop(); e2 = stack.pop();
				stack.push(e2+":"+e1);
				break;

			case 'PtgAttrChoose': /* [MS-XLS] 2.5.198.34 */
				break;
			case 'PtgAttrGoto': /* [MS-XLS] 2.5.198.35 */
				break;
			case 'PtgAttrIf': /* [MS-XLS] 2.5.198.36 */
				break;
			case 'PtgAttrIfError': /* [MS-XLSB] 2.5.97.28 */
				break;


			case 'PtgRef': /* [MS-XLS] 2.5.198.84 */
				/*::type = f[1][0]; */c = shift_cell_xls((f[1][1]/*:any*/), _range, opts);
				stack.push(encode_cell_xls(c, biff));
				break;
			case 'PtgRefN': /* [MS-XLS] 2.5.198.88 */
				/*::type = f[1][0]; */c = cell ? shift_cell_xls((f[1][1]/*:any*/), cell, opts) : (f[1][1]/*:any*/);
				stack.push(encode_cell_xls(c, biff));
				break;
			case 'PtgRef3d': /* [MS-XLS] 2.5.198.85 */
				/*::type = f[1][0]; */ixti = /*::Number(*/f[1][1]/*::)*/; c = shift_cell_xls((f[1][2]/*:any*/), _range, opts);
				sname = get_ixti(supbooks, ixti, opts);
				stack.push(sname + "!" + encode_cell_xls(c, biff));
				break;

			case 'PtgFunc': /* [MS-XLS] 2.5.198.62 */
			case 'PtgFuncVar': /* [MS-XLS] 2.5.198.63 */
				/* f[1] = [argc, func, type] */
				var argc/*:number*/ = (f[1][0]/*:any*/), func/*:string*/ = (f[1][1]/*:any*/);
				if(!argc) argc = 0;
				argc &= 0x7F;
				var args = argc == 0 ? [] : stack.slice(-argc);
				stack.length -= argc;
				if(func === 'User') func = args.shift();
				stack.push(func + "(" + args.join(",") + ")");
				break;

			case 'PtgBool': /* [MS-XLS] 2.5.198.42 */
				stack.push(f[1] ? "TRUE" : "FALSE"); break;
			case 'PtgInt': /* [MS-XLS] 2.5.198.66 */
				stack.push(/*::String(*/f[1]/*::)*/); break;
			case 'PtgNum': /* [MS-XLS] 2.5.198.79 TODO: precision? */
				stack.push(String(f[1])); break;
			case 'PtgStr': /* [MS-XLS] 2.5.198.89 */
				// $FlowIgnore
				stack.push('"' + f[1].replace(/"/g, '""') + '"'); break;
			case 'PtgErr': /* [MS-XLS] 2.5.198.57 */
				stack.push(/*::String(*/f[1]/*::)*/); break;
			case 'PtgAreaN': /* [MS-XLS] 2.5.198.31 TODO */
				/*::type = f[1][0]; */r = shift_range_xls(f[1][1], cell ? {s:cell} : _range, opts);
				stack.push(encode_range_xls((r/*:any*/), opts));
				break;
			case 'PtgArea': /* [MS-XLS] 2.5.198.27 TODO: fixed points */
				/*::type = f[1][0]; */r = shift_range_xls(f[1][1], _range, opts);
				stack.push(encode_range_xls((r/*:any*/), opts));
				break;
			case 'PtgArea3d': /* [MS-XLS] 2.5.198.28 TODO */
				/*::type = f[1][0]; */ixti = /*::Number(*/f[1][1]/*::)*/; r = f[1][2];
				sname = get_ixti(supbooks, ixti, opts);
				stack.push(sname + "!" + encode_range_xls((r/*:any*/), opts));
				break;
			case 'PtgAttrSum': /* [MS-XLS] 2.5.198.41 */
				stack.push("SUM(" + stack.pop() + ")");
				break;

			case 'PtgAttrBaxcel': /* [MS-XLS] 2.5.198.33 */
			case 'PtgAttrSemi': /* [MS-XLS] 2.5.198.37 */
				break;

			case 'PtgName': /* [MS-XLS] 2.5.198.76 ; [MS-XLSB] 2.5.97.60 TODO: revisions */
				/* f[1] = type, 0, nameindex */
				nameidx = (f[1][2]/*:any*/);
				var lbl = (supbooks.names||[])[nameidx-1] || (supbooks[0]||[])[nameidx];
				var name = lbl ? lbl.Name : "SH33TJSNAME" + String(nameidx);
				/* [MS-XLSB] 2.5.97.10 Ftab -- last verified 20220204 */
				if(name && name.slice(0,6) == "_xlfn.") name = name.slice(6);
				stack.push(name);
				break;

			case 'PtgNameX': /* [MS-XLS] 2.5.198.77 ; [MS-XLSB] 2.5.97.61 TODO: revisions */
				/* f[1] = type, ixti, nameindex */
				var bookidx/*:number*/ = (f[1][1]/*:any*/); nameidx = (f[1][2]/*:any*/); var externbook;
				/* TODO: Properly handle missing values -- this should be using get_ixti_raw primarily */
				if(opts.biff <= 5) {
					if(bookidx < 0) bookidx = -bookidx;
					if(supbooks[bookidx]) externbook = supbooks[bookidx][nameidx];
				} else {
					var o = "";
					if(((supbooks[bookidx]||[])[0]||[])[0] == 0x3A01);
					else if(((supbooks[bookidx]||[])[0]||[])[0] == 0x0401){
						if(supbooks[bookidx][nameidx] && supbooks[bookidx][nameidx].itab > 0) {
							o = supbooks.SheetNames[supbooks[bookidx][nameidx].itab-1] + "!";
						}
					}
					else o = supbooks.SheetNames[nameidx-1]+ "!";
					if(supbooks[bookidx] && supbooks[bookidx][nameidx]) o += supbooks[bookidx][nameidx].Name;
					else if(supbooks[0] && supbooks[0][nameidx]) o += supbooks[0][nameidx].Name;
					else {
						var ixtidata = (get_ixti_raw(supbooks, bookidx, opts)||"").split(";;");
						if(ixtidata[nameidx - 1]) o = ixtidata[nameidx - 1]; // TODO: confirm this is correct
						else o += "SH33TJSERRX";
					}
					stack.push(o);
					break;
				}
				if(!externbook) externbook = {Name: "SH33TJSERRY"};
				stack.push(externbook.Name);
				break;

			case 'PtgParen': /* [MS-XLS] 2.5.198.80 */
				var lp = '(', rp = ')';
				if(last_sp >= 0) {
					sp = "";
					switch(formula[0][last_sp][1][0]) {
						// $FlowIgnore
						case 2: lp = fill(" ", formula[0][last_sp][1][1]) + lp; break;
						// $FlowIgnore
						case 3: lp = fill("\r", formula[0][last_sp][1][1]) + lp; break;
						// $FlowIgnore
						case 4: rp = fill(" ", formula[0][last_sp][1][1]) + rp; break;
						// $FlowIgnore
						case 5: rp = fill("\r", formula[0][last_sp][1][1]) + rp; break;
						default:
							// $FlowIgnore
							if(opts.WTF) throw new Error("Unexpected PtgAttrSpaceType " + formula[0][last_sp][1][0]);
					}
					last_sp = -1;
				}
				stack.push(lp + stack.pop() + rp); break;

			case 'PtgRefErr': /* [MS-XLS] 2.5.198.86 */
				stack.push('#REF!'); break;

			case 'PtgRefErr3d': /* [MS-XLS] 2.5.198.87 */
				stack.push('#REF!'); break;

			case 'PtgExp': /* [MS-XLS] 2.5.198.58 TODO */
				c = {c:(f[1][1]/*:any*/),r:(f[1][0]/*:any*/)};
				var q = ({c: cell.c, r:cell.r}/*:any*/);
				if(supbooks.sharedf[encode_cell(c)]) {
					var parsedf = (supbooks.sharedf[encode_cell(c)]);
					stack.push(stringify_formula(parsedf, _range, q, supbooks, opts));
				} else {
					var fnd = false;
					for(e1=0;e1!=supbooks.arrayf.length; ++e1) {
						/* TODO: should be something like range_has */
						e2 = supbooks.arrayf[e1];
						if(c.c < e2[0].s.c || c.c > e2[0].e.c) continue;
						if(c.r < e2[0].s.r || c.r > e2[0].e.r) continue;
						stack.push(stringify_formula(e2[1], _range, q, supbooks, opts));
						fnd = true;
						break;
					}
					if(!fnd) stack.push(/*::String(*/f[1]/*::)*/);
				}
				break;

			case 'PtgArray': /* [MS-XLS] 2.5.198.32 TODO */
				stack.push("{" + stringify_array(/*::(*/f[1]/*:: :any)*/) + "}");
				break;

			case 'PtgMemArea': /* [MS-XLS] 2.5.198.70 TODO: confirm this is a non-display */
				//stack.push("(" + f[2].map(encode_range).join(",") + ")");
				break;

			case 'PtgAttrSpace': /* [MS-XLS] 2.5.198.38 */
			case 'PtgAttrSpaceSemi': /* [MS-XLS] 2.5.198.39 */
				last_sp = ff;
				break;

			case 'PtgTbl': /* [MS-XLS] 2.5.198.92 TODO */
				break;

			case 'PtgMemErr': /* [MS-XLS] 2.5.198.71 */
				break;

			case 'PtgMissArg': /* [MS-XLS] 2.5.198.74 */
				stack.push("");
				break;

			case 'PtgAreaErr': /* [MS-XLS] 2.5.198.29 */
				stack.push("#REF!"); break;

			case 'PtgAreaErr3d': /* [MS-XLS] 2.5.198.30 */
				stack.push("#REF!"); break;

			case 'PtgList': /* [MS-XLSB] 2.5.97.52 */
				// $FlowIgnore
				stack.push("Table" + f[1].idx + "[#" + f[1].rt + "]");
				break;

			case 'PtgMemAreaN':
			case 'PtgMemNoMemN':
			case 'PtgAttrNoop':
			case 'PtgSheet':
			case 'PtgEndSheet':
				break;

			case 'PtgMemFunc': /* [MS-XLS] 2.5.198.72 TODO */
				break;
			case 'PtgMemNoMem': /* [MS-XLS] 2.5.198.73 TODO */
				break;

			case 'PtgElfCol': /* [MS-XLS] 2.5.198.46 */
			case 'PtgElfColS': /* [MS-XLS] 2.5.198.47 */
			case 'PtgElfColSV': /* [MS-XLS] 2.5.198.48 */
			case 'PtgElfColV': /* [MS-XLS] 2.5.198.49 */
			case 'PtgElfLel': /* [MS-XLS] 2.5.198.50 */
			case 'PtgElfRadical': /* [MS-XLS] 2.5.198.51 */
			case 'PtgElfRadicalLel': /* [MS-XLS] 2.5.198.52 */
			case 'PtgElfRadicalS': /* [MS-XLS] 2.5.198.53 */
			case 'PtgElfRw': /* [MS-XLS] 2.5.198.54 */
			case 'PtgElfRwV': /* [MS-XLS] 2.5.198.55 */
				throw new Error("Unsupported ELFs");

			case 'PtgSxName': /* [MS-XLS] 2.5.198.91 TODO -- find a test case */
				throw new Error('Unrecognized Formula Token: ' + String(f));
			default: throw new Error('Unrecognized Formula Token: ' + String(f));
		}
		var PtgNonDisp = ['PtgAttrSpace', 'PtgAttrSpaceSemi', 'PtgAttrGoto'];
		if(opts.biff != 3) if(last_sp >= 0 && PtgNonDisp.indexOf(formula[0][ff][0]) == -1) {
			f = formula[0][last_sp];
			var _left = true;
			switch(f[1][0]) {
				/* note: some bad XLSB files omit the PtgParen */
				case 4: _left = false;
				/* falls through */
				case 0:
					// $FlowIgnore
					sp = fill(" ", f[1][1]); break;
				case 5: _left = false;
				/* falls through */
				case 1:
					// $FlowIgnore
					sp = fill("\r", f[1][1]); break;
				default:
					sp = "";
					// $FlowIgnore
					if(opts.WTF) throw new Error("Unexpected PtgAttrSpaceType " + f[1][0]);
			}
			stack.push((_left ? sp : "") + stack.pop() + (_left ? "" : sp));
			last_sp = -1;
		}
	}
	if(stack.length > 1 && opts.WTF) throw new Error("bad formula stack");
	return stack[0];
}

/* [MS-XLS] 2.5.198.1 TODO */
function parse_ArrayParsedFormula(blob, length, opts/*::, ref*/) {
	var target = blob.l + length, len = opts.biff == 2 ? 1 : 2;
	var rgcb, cce = blob.read_shift(len); // length of rgce
	if(cce == 0xFFFF) return [[],parsenoop(blob, length-2)];
	var rgce = parse_Rgce(blob, cce, opts);
	if(length !== cce + len) rgcb = parse_RgbExtra(blob, length - cce - len, rgce, opts);
	blob.l = target;
	return [rgce, rgcb];
}

/* [MS-XLS] 2.5.198.3 TODO */
function parse_XLSCellParsedFormula(blob, length, opts) {
	var target = blob.l + length, len = opts.biff == 2 ? 1 : 2;
	var rgcb, cce = blob.read_shift(len); // length of rgce
	if(cce == 0xFFFF) return [[],parsenoop(blob, length-2)];
	var rgce = parse_Rgce(blob, cce, opts);
	if(length !== cce + len) rgcb = parse_RgbExtra(blob, length - cce - len, rgce, opts);
	blob.l = target;
	return [rgce, rgcb];
}

/* [MS-XLS] 2.5.198.21 */
function parse_NameParsedFormula(blob, length, opts, cce) {
	var target = blob.l + length;
	var rgce = parse_Rgce(blob, cce, opts);
	var rgcb;
	if(target !== blob.l) rgcb = parse_RgbExtra(blob, target - blob.l, rgce, opts);
	return [rgce, rgcb];
}

/* [MS-XLS] 2.5.198.118 TODO */
function parse_SharedParsedFormula(blob, length, opts) {
	var target = blob.l + length;
	var rgcb, cce = blob.read_shift(2); // length of rgce
	var rgce = parse_Rgce(blob, cce, opts);
	if(cce == 0xFFFF) return [[],parsenoop(blob, length-2)];
	if(length !== cce + 2) rgcb = parse_RgbExtra(blob, target - cce - 2, rgce, opts);
	return [rgce, rgcb];
}

/* [MS-XLS] 2.5.133 TODO: how to emit empty strings? */
function parse_FormulaValue(blob/*::, length*/) {
	var b;
	if(__readUInt16LE(blob,blob.l + 6) !== 0xFFFF) return [parse_Xnum(blob),'n'];
	switch(blob[blob.l]) {
		case 0x00: blob.l += 8; return ["String", 's'];
		case 0x01: b = blob[blob.l+2] === 0x1; blob.l += 8; return [b,'b'];
		case 0x02: b = blob[blob.l+2]; blob.l += 8; return [b,'e'];
		case 0x03: blob.l += 8; return ["",'s'];
	}
	return [];
}
function write_FormulaValue(value) {
	if(value == null) {
		// Blank String Value
		var o = new_buf(8);
		o.write_shift(1, 0x03);
		o.write_shift(1, 0);
		o.write_shift(2, 0);
		o.write_shift(2, 0);
		o.write_shift(2, 0xFFFF);
		return o;
	} else if(typeof value == "number") return write_Xnum(value);
	return write_Xnum(0);
}

/* [MS-XLS] 2.4.127 TODO */
function parse_Formula(blob, length, opts) {
	var end = blob.l + length;
	var cell = parse_XLSCell(blob);
	if(opts.biff == 2) ++blob.l;
	var val = parse_FormulaValue(blob);
	var flags = blob.read_shift(1);
	if(opts.biff != 2) {
		blob.read_shift(1);
		if(opts.biff >= 5) {
			/*var chn = */blob.read_shift(4);
		}
	}
	var cbf = parse_XLSCellParsedFormula(blob, end - blob.l, opts);
	return {cell:cell, val:val[0], formula:cbf, shared: (flags >> 3) & 1, tt:val[1]};
}
function write_Formula(cell/*:Cell*/, R/*:number*/, C/*:number*/, opts, os/*:number*/) {
	// Cell
	var o1 = write_XLSCell(R, C, os);

	// FormulaValue
	var o2 = write_FormulaValue(cell.v);

	// flags + cache
	var o3 = new_buf(6);
	var flags = 0x01 | 0x20;
	o3.write_shift(2, flags);
	o3.write_shift(4, 0);

	// CellParsedFormula
	var bf = new_buf(cell.bf.length);
	for(var i = 0; i < cell.bf.length; ++i) bf[i] = cell.bf[i];

	var out = bconcat([o1, o2, o3, bf]);
	return out;
}


/* XLSB Parsed Formula records have the same shape */
function parse_XLSBParsedFormula(data, length, opts) {
	var cce = data.read_shift(4);
	var rgce = parse_Rgce(data, cce, opts);
	var cb = data.read_shift(4);
	var rgcb = cb > 0 ? parse_RgbExtra(data, cb, rgce, opts) : null;
	return [rgce, rgcb];
}

/* [MS-XLSB] 2.5.97.1 ArrayParsedFormula */
var parse_XLSBArrayParsedFormula = parse_XLSBParsedFormula;
/* [MS-XLSB] 2.5.97.4 CellParsedFormula */
var parse_XLSBCellParsedFormula = parse_XLSBParsedFormula;
/* [MS-XLSB] 2.5.97.8 DVParsedFormula */
//var parse_XLSBDVParsedFormula = parse_XLSBParsedFormula;
/* [MS-XLSB] 2.5.97.9 FRTParsedFormula */
//var parse_XLSBFRTParsedFormula = parse_XLSBParsedFormula2;
/* [MS-XLSB] 2.5.97.12 NameParsedFormula */
var parse_XLSBNameParsedFormula = parse_XLSBParsedFormula;
/* [MS-XLSB] 2.5.97.98 SharedParsedFormula */
var parse_XLSBSharedParsedFormula = parse_XLSBParsedFormula;
var Cetab = {
  0: "BEEP",
  1: "OPEN",
  2: "OPEN.LINKS",
  3: "CLOSE.ALL",
  4: "SAVE",
  5: "SAVE.AS",
  6: "FILE.DELETE",
  7: "PAGE.SETUP",
  8: "PRINT",
  9: "PRINTER.SETUP",
  10: "QUIT",
  11: "NEW.WINDOW",
  12: "ARRANGE.ALL",
  13: "WINDOW.SIZE",
  14: "WINDOW.MOVE",
  15: "FULL",
  16: "CLOSE",
  17: "RUN",
  22: "SET.PRINT.AREA",
  23: "SET.PRINT.TITLES",
  24: "SET.PAGE.BREAK",
  25: "REMOVE.PAGE.BREAK",
  26: "FONT",
  27: "DISPLAY",
  28: "PROTECT.DOCUMENT",
  29: "PRECISION",
  30: "A1.R1C1",
  31: "CALCULATE.NOW",
  32: "CALCULATION",
  34: "DATA.FIND",
  35: "EXTRACT",
  36: "DATA.DELETE",
  37: "SET.DATABASE",
  38: "SET.CRITERIA",
  39: "SORT",
  40: "DATA.SERIES",
  41: "TABLE",
  42: "FORMAT.NUMBER",
  43: "ALIGNMENT",
  44: "STYLE",
  45: "BORDER",
  46: "CELL.PROTECTION",
  47: "COLUMN.WIDTH",
  48: "UNDO",
  49: "CUT",
  50: "COPY",
  51: "PASTE",
  52: "CLEAR",
  53: "PASTE.SPECIAL",
  54: "EDIT.DELETE",
  55: "INSERT",
  56: "FILL.RIGHT",
  57: "FILL.DOWN",
  61: "DEFINE.NAME",
  62: "CREATE.NAMES",
  63: "FORMULA.GOTO",
  64: "FORMULA.FIND",
  65: "SELECT.LAST.CELL",
  66: "SHOW.ACTIVE.CELL",
  67: "GALLERY.AREA",
  68: "GALLERY.BAR",
  69: "GALLERY.COLUMN",
  70: "GALLERY.LINE",
  71: "GALLERY.PIE",
  72: "GALLERY.SCATTER",
  73: "COMBINATION",
  74: "PREFERRED",
  75: "ADD.OVERLAY",
  76: "GRIDLINES",
  77: "SET.PREFERRED",
  78: "AXES",
  79: "LEGEND",
  80: "ATTACH.TEXT",
  81: "ADD.ARROW",
  82: "SELECT.CHART",
  83: "SELECT.PLOT.AREA",
  84: "PATTERNS",
  85: "MAIN.CHART",
  86: "OVERLAY",
  87: "SCALE",
  88: "FORMAT.LEGEND",
  89: "FORMAT.TEXT",
  90: "EDIT.REPEAT",
  91: "PARSE",
  92: "JUSTIFY",
  93: "HIDE",
  94: "UNHIDE",
  95: "WORKSPACE",
  96: "FORMULA",
  97: "FORMULA.FILL",
  98: "FORMULA.ARRAY",
  99: "DATA.FIND.NEXT",
  100: "DATA.FIND.PREV",
  101: "FORMULA.FIND.NEXT",
  102: "FORMULA.FIND.PREV",
  103: "ACTIVATE",
  104: "ACTIVATE.NEXT",
  105: "ACTIVATE.PREV",
  106: "UNLOCKED.NEXT",
  107: "UNLOCKED.PREV",
  108: "COPY.PICTURE",
  109: "SELECT",
  110: "DELETE.NAME",
  111: "DELETE.FORMAT",
  112: "VLINE",
  113: "HLINE",
  114: "VPAGE",
  115: "HPAGE",
  116: "VSCROLL",
  117: "HSCROLL",
  118: "ALERT",
  119: "NEW",
  120: "CANCEL.COPY",
  121: "SHOW.CLIPBOARD",
  122: "MESSAGE",
  124: "PASTE.LINK",
  125: "APP.ACTIVATE",
  126: "DELETE.ARROW",
  127: "ROW.HEIGHT",
  128: "FORMAT.MOVE",
  129: "FORMAT.SIZE",
  130: "FORMULA.REPLACE",
  131: "SEND.KEYS",
  132: "SELECT.SPECIAL",
  133: "APPLY.NAMES",
  134: "REPLACE.FONT",
  135: "FREEZE.PANES",
  136: "SHOW.INFO",
  137: "SPLIT",
  138: "ON.WINDOW",
  139: "ON.DATA",
  140: "DISABLE.INPUT",
  142: "OUTLINE",
  143: "LIST.NAMES",
  144: "FILE.CLOSE",
  145: "SAVE.WORKBOOK",
  146: "DATA.FORM",
  147: "COPY.CHART",
  148: "ON.TIME",
  149: "WAIT",
  150: "FORMAT.FONT",
  151: "FILL.UP",
  152: "FILL.LEFT",
  153: "DELETE.OVERLAY",
  155: "SHORT.MENUS",
  159: "SET.UPDATE.STATUS",
  161: "COLOR.PALETTE",
  162: "DELETE.STYLE",
  163: "WINDOW.RESTORE",
  164: "WINDOW.MAXIMIZE",
  166: "CHANGE.LINK",
  167: "CALCULATE.DOCUMENT",
  168: "ON.KEY",
  169: "APP.RESTORE",
  170: "APP.MOVE",
  171: "APP.SIZE",
  172: "APP.MINIMIZE",
  173: "APP.MAXIMIZE",
  174: "BRING.TO.FRONT",
  175: "SEND.TO.BACK",
  185: "MAIN.CHART.TYPE",
  186: "OVERLAY.CHART.TYPE",
  187: "SELECT.END",
  188: "OPEN.MAIL",
  189: "SEND.MAIL",
  190: "STANDARD.FONT",
  191: "CONSOLIDATE",
  192: "SORT.SPECIAL",
  193: "GALLERY.3D.AREA",
  194: "GALLERY.3D.COLUMN",
  195: "GALLERY.3D.LINE",
  196: "GALLERY.3D.PIE",
  197: "VIEW.3D",
  198: "GOAL.SEEK",
  199: "WORKGROUP",
  200: "FILL.GROUP",
  201: "UPDATE.LINK",
  202: "PROMOTE",
  203: "DEMOTE",
  204: "SHOW.DETAIL",
  206: "UNGROUP",
  207: "OBJECT.PROPERTIES",
  208: "SAVE.NEW.OBJECT",
  209: "SHARE",
  210: "SHARE.NAME",
  211: "DUPLICATE",
  212: "APPLY.STYLE",
  213: "ASSIGN.TO.OBJECT",
  214: "OBJECT.PROTECTION",
  215: "HIDE.OBJECT",
  216: "SET.EXTRACT",
  217: "CREATE.PUBLISHER",
  218: "SUBSCRIBE.TO",
  219: "ATTRIBUTES",
  220: "SHOW.TOOLBAR",
  222: "PRINT.PREVIEW",
  223: "EDIT.COLOR",
  224: "SHOW.LEVELS",
  225: "FORMAT.MAIN",
  226: "FORMAT.OVERLAY",
  227: "ON.RECALC",
  228: "EDIT.SERIES",
  229: "DEFINE.STYLE",
  240: "LINE.PRINT",
  243: "ENTER.DATA",
  249: "GALLERY.RADAR",
  250: "MERGE.STYLES",
  251: "EDITION.OPTIONS",
  252: "PASTE.PICTURE",
  253: "PASTE.PICTURE.LINK",
  254: "SPELLING",
  256: "ZOOM",
  259: "INSERT.OBJECT",
  260: "WINDOW.MINIMIZE",
  265: "SOUND.NOTE",
  266: "SOUND.PLAY",
  267: "FORMAT.SHAPE",
  268: "EXTEND.POLYGON",
  269: "FORMAT.AUTO",
  272: "GALLERY.3D.BAR",
  273: "GALLERY.3D.SURFACE",
  274: "FILL.AUTO",
  276: "CUSTOMIZE.TOOLBAR",
  277: "ADD.TOOL",
  278: "EDIT.OBJECT",
  279: "ON.DOUBLECLICK",
  280: "ON.ENTRY",
  281: "WORKBOOK.ADD",
  282: "WORKBOOK.MOVE",
  283: "WORKBOOK.COPY",
  284: "WORKBOOK.OPTIONS",
  285: "SAVE.WORKSPACE",
  288: "CHART.WIZARD",
  289: "DELETE.TOOL",
  290: "MOVE.TOOL",
  291: "WORKBOOK.SELECT",
  292: "WORKBOOK.ACTIVATE",
  293: "ASSIGN.TO.TOOL",
  295: "COPY.TOOL",
  296: "RESET.TOOL",
  297: "CONSTRAIN.NUMERIC",
  298: "PASTE.TOOL",
  302: "WORKBOOK.NEW",
  305: "SCENARIO.CELLS",
  306: "SCENARIO.DELETE",
  307: "SCENARIO.ADD",
  308: "SCENARIO.EDIT",
  309: "SCENARIO.SHOW",
  310: "SCENARIO.SHOW.NEXT",
  311: "SCENARIO.SUMMARY",
  312: "PIVOT.TABLE.WIZARD",
  313: "PIVOT.FIELD.PROPERTIES",
  314: "PIVOT.FIELD",
  315: "PIVOT.ITEM",
  316: "PIVOT.ADD.FIELDS",
  318: "OPTIONS.CALCULATION",
  319: "OPTIONS.EDIT",
  320: "OPTIONS.VIEW",
  321: "ADDIN.MANAGER",
  322: "MENU.EDITOR",
  323: "ATTACH.TOOLBARS",
  324: "VBAActivate",
  325: "OPTIONS.CHART",
  328: "VBA.INSERT.FILE",
  330: "VBA.PROCEDURE.DEFINITION",
  336: "ROUTING.SLIP",
  338: "ROUTE.DOCUMENT",
  339: "MAIL.LOGON",
  342: "INSERT.PICTURE",
  343: "EDIT.TOOL",
  344: "GALLERY.DOUGHNUT",
  350: "CHART.TREND",
  352: "PIVOT.ITEM.PROPERTIES",
  354: "WORKBOOK.INSERT",
  355: "OPTIONS.TRANSITION",
  356: "OPTIONS.GENERAL",
  370: "FILTER.ADVANCED",
  373: "MAIL.ADD.MAILER",
  374: "MAIL.DELETE.MAILER",
  375: "MAIL.REPLY",
  376: "MAIL.REPLY.ALL",
  377: "MAIL.FORWARD",
  378: "MAIL.NEXT.LETTER",
  379: "DATA.LABEL",
  380: "INSERT.TITLE",
  381: "FONT.PROPERTIES",
  382: "MACRO.OPTIONS",
  383: "WORKBOOK.HIDE",
  384: "WORKBOOK.UNHIDE",
  385: "WORKBOOK.DELETE",
  386: "WORKBOOK.NAME",
  388: "GALLERY.CUSTOM",
  390: "ADD.CHART.AUTOFORMAT",
  391: "DELETE.CHART.AUTOFORMAT",
  392: "CHART.ADD.DATA",
  393: "AUTO.OUTLINE",
  394: "TAB.ORDER",
  395: "SHOW.DIALOG",
  396: "SELECT.ALL",
  397: "UNGROUP.SHEETS",
  398: "SUBTOTAL.CREATE",
  399: "SUBTOTAL.REMOVE",
  400: "RENAME.OBJECT",
  412: "WORKBOOK.SCROLL",
  413: "WORKBOOK.NEXT",
  414: "WORKBOOK.PREV",
  415: "WORKBOOK.TAB.SPLIT",
  416: "FULL.SCREEN",
  417: "WORKBOOK.PROTECT",
  420: "SCROLLBAR.PROPERTIES",
  421: "PIVOT.SHOW.PAGES",
  422: "TEXT.TO.COLUMNS",
  423: "FORMAT.CHARTTYPE",
  424: "LINK.FORMAT",
  425: "TRACER.DISPLAY",
  430: "TRACER.NAVIGATE",
  431: "TRACER.CLEAR",
  432: "TRACER.ERROR",
  433: "PIVOT.FIELD.GROUP",
  434: "PIVOT.FIELD.UNGROUP",
  435: "CHECKBOX.PROPERTIES",
  436: "LABEL.PROPERTIES",
  437: "LISTBOX.PROPERTIES",
  438: "EDITBOX.PROPERTIES",
  439: "PIVOT.REFRESH",
  440: "LINK.COMBO",
  441: "OPEN.TEXT",
  442: "HIDE.DIALOG",
  443: "SET.DIALOG.FOCUS",
  444: "ENABLE.OBJECT",
  445: "PUSHBUTTON.PROPERTIES",
  446: "SET.DIALOG.DEFAULT",
  447: "FILTER",
  448: "FILTER.SHOW.ALL",
  449: "CLEAR.OUTLINE",
  450: "FUNCTION.WIZARD",
  451: "ADD.LIST.ITEM",
  452: "SET.LIST.ITEM",
  453: "REMOVE.LIST.ITEM",
  454: "SELECT.LIST.ITEM",
  455: "SET.CONTROL.VALUE",
  456: "SAVE.COPY.AS",
  458: "OPTIONS.LISTS.ADD",
  459: "OPTIONS.LISTS.DELETE",
  460: "SERIES.AXES",
  461: "SERIES.X",
  462: "SERIES.Y",
  463: "ERRORBAR.X",
  464: "ERRORBAR.Y",
  465: "FORMAT.CHART",
  466: "SERIES.ORDER",
  467: "MAIL.LOGOFF",
  468: "CLEAR.ROUTING.SLIP",
  469: "APP.ACTIVATE.MICROSOFT",
  470: "MAIL.EDIT.MAILER",
  471: "ON.SHEET",
  472: "STANDARD.WIDTH",
  473: "SCENARIO.MERGE",
  474: "SUMMARY.INFO",
  475: "FIND.FILE",
  476: "ACTIVE.CELL.FONT",
  477: "ENABLE.TIPWIZARD",
  478: "VBA.MAKE.ADDIN",
  480: "INSERTDATATABLE",
  481: "WORKGROUP.OPTIONS",
  482: "MAIL.SEND.MAILER",
  485: "AUTOCORRECT",
  489: "POST.DOCUMENT",
  491: "PICKLIST",
  493: "VIEW.SHOW",
  494: "VIEW.DEFINE",
  495: "VIEW.DELETE",
  509: "SHEET.BACKGROUND",
  510: "INSERT.MAP.OBJECT",
  511: "OPTIONS.MENONO",
  517: "MSOCHECKS",
  518: "NORMAL",
  519: "LAYOUT",
  520: "RM.PRINT.AREA",
  521: "CLEAR.PRINT.AREA",
  522: "ADD.PRINT.AREA",
  523: "MOVE.BRK",
  545: "HIDECURR.NOTE",
  546: "HIDEALL.NOTES",
  547: "DELETE.NOTE",
  548: "TRAVERSE.NOTES",
  549: "ACTIVATE.NOTES",
  620: "PROTECT.REVISIONS",
  621: "UNPROTECT.REVISIONS",
  647: "OPTIONS.ME",
  653: "WEB.PUBLISH",
  667: "NEWWEBQUERY",
  673: "PIVOT.TABLE.CHART",
  753: "OPTIONS.SAVE",
  755: "OPTIONS.SPELL",
  808: "HIDEALL.INKANNOTS"
};
var Ftab = {
  0: "COUNT",
  1: "IF",
  2: "ISNA",
  3: "ISERROR",
  4: "SUM",
  5: "AVERAGE",
  6: "MIN",
  7: "MAX",
  8: "ROW",
  9: "COLUMN",
  10: "NA",
  11: "NPV",
  12: "STDEV",
  13: "DOLLAR",
  14: "FIXED",
  15: "SIN",
  16: "COS",
  17: "TAN",
  18: "ATAN",
  19: "PI",
  20: "SQRT",
  21: "EXP",
  22: "LN",
  23: "LOG10",
  24: "ABS",
  25: "INT",
  26: "SIGN",
  27: "ROUND",
  28: "LOOKUP",
  29: "INDEX",
  30: "REPT",
  31: "MID",
  32: "LEN",
  33: "VALUE",
  34: "TRUE",
  35: "FALSE",
  36: "AND",
  37: "OR",
  38: "NOT",
  39: "MOD",
  40: "DCOUNT",
  41: "DSUM",
  42: "DAVERAGE",
  43: "DMIN",
  44: "DMAX",
  45: "DSTDEV",
  46: "VAR",
  47: "DVAR",
  48: "TEXT",
  49: "LINEST",
  50: "TREND",
  51: "LOGEST",
  52: "GROWTH",
  53: "GOTO",
  54: "HALT",
  55: "RETURN",
  56: "PV",
  57: "FV",
  58: "NPER",
  59: "PMT",
  60: "RATE",
  61: "MIRR",
  62: "IRR",
  63: "RAND",
  64: "MATCH",
  65: "DATE",
  66: "TIME",
  67: "DAY",
  68: "MONTH",
  69: "YEAR",
  70: "WEEKDAY",
  71: "HOUR",
  72: "MINUTE",
  73: "SECOND",
  74: "NOW",
  75: "AREAS",
  76: "ROWS",
  77: "COLUMNS",
  78: "OFFSET",
  79: "ABSREF",
  80: "RELREF",
  81: "ARGUMENT",
  82: "SEARCH",
  83: "TRANSPOSE",
  84: "ERROR",
  85: "STEP",
  86: "TYPE",
  87: "ECHO",
  88: "SET.NAME",
  89: "CALLER",
  90: "DEREF",
  91: "WINDOWS",
  92: "SERIES",
  93: "DOCUMENTS",
  94: "ACTIVE.CELL",
  95: "SELECTION",
  96: "RESULT",
  97: "ATAN2",
  98: "ASIN",
  99: "ACOS",
  100: "CHOOSE",
  101: "HLOOKUP",
  102: "VLOOKUP",
  103: "LINKS",
  104: "INPUT",
  105: "ISREF",
  106: "GET.FORMULA",
  107: "GET.NAME",
  108: "SET.VALUE",
  109: "LOG",
  110: "EXEC",
  111: "CHAR",
  112: "LOWER",
  113: "UPPER",
  114: "PROPER",
  115: "LEFT",
  116: "RIGHT",
  117: "EXACT",
  118: "TRIM",
  119: "REPLACE",
  120: "SUBSTITUTE",
  121: "CODE",
  122: "NAMES",
  123: "DIRECTORY",
  124: "FIND",
  125: "CELL",
  126: "ISERR",
  127: "ISTEXT",
  128: "ISNUMBER",
  129: "ISBLANK",
  130: "T",
  131: "N",
  132: "FOPEN",
  133: "FCLOSE",
  134: "FSIZE",
  135: "FREADLN",
  136: "FREAD",
  137: "FWRITELN",
  138: "FWRITE",
  139: "FPOS",
  140: "DATEVALUE",
  141: "TIMEVALUE",
  142: "SLN",
  143: "SYD",
  144: "DDB",
  145: "GET.DEF",
  146: "REFTEXT",
  147: "TEXTREF",
  148: "INDIRECT",
  149: "REGISTER",
  150: "CALL",
  151: "ADD.BAR",
  152: "ADD.MENU",
  153: "ADD.COMMAND",
  154: "ENABLE.COMMAND",
  155: "CHECK.COMMAND",
  156: "RENAME.COMMAND",
  157: "SHOW.BAR",
  158: "DELETE.MENU",
  159: "DELETE.COMMAND",
  160: "GET.CHART.ITEM",
  161: "DIALOG.BOX",
  162: "CLEAN",
  163: "MDETERM",
  164: "MINVERSE",
  165: "MMULT",
  166: "FILES",
  167: "IPMT",
  168: "PPMT",
  169: "COUNTA",
  170: "CANCEL.KEY",
  171: "FOR",
  172: "WHILE",
  173: "BREAK",
  174: "NEXT",
  175: "INITIATE",
  176: "REQUEST",
  177: "POKE",
  178: "EXECUTE",
  179: "TERMINATE",
  180: "RESTART",
  181: "HELP",
  182: "GET.BAR",
  183: "PRODUCT",
  184: "FACT",
  185: "GET.CELL",
  186: "GET.WORKSPACE",
  187: "GET.WINDOW",
  188: "GET.DOCUMENT",
  189: "DPRODUCT",
  190: "ISNONTEXT",
  191: "GET.NOTE",
  192: "NOTE",
  193: "STDEVP",
  194: "VARP",
  195: "DSTDEVP",
  196: "DVARP",
  197: "TRUNC",
  198: "ISLOGICAL",
  199: "DCOUNTA",
  200: "DELETE.BAR",
  201: "UNREGISTER",
  204: "USDOLLAR",
  205: "FINDB",
  206: "SEARCHB",
  207: "REPLACEB",
  208: "LEFTB",
  209: "RIGHTB",
  210: "MIDB",
  211: "LENB",
  212: "ROUNDUP",
  213: "ROUNDDOWN",
  214: "ASC",
  215: "DBCS",
  216: "RANK",
  219: "ADDRESS",
  220: "DAYS360",
  221: "TODAY",
  222: "VDB",
  223: "ELSE",
  224: "ELSE.IF",
  225: "END.IF",
  226: "FOR.CELL",
  227: "MEDIAN",
  228: "SUMPRODUCT",
  229: "SINH",
  230: "COSH",
  231: "TANH",
  232: "ASINH",
  233: "ACOSH",
  234: "ATANH",
  235: "DGET",
  236: "CREATE.OBJECT",
  237: "VOLATILE",
  238: "LAST.ERROR",
  239: "CUSTOM.UNDO",
  240: "CUSTOM.REPEAT",
  241: "FORMULA.CONVERT",
  242: "GET.LINK.INFO",
  243: "TEXT.BOX",
  244: "INFO",
  245: "GROUP",
  246: "GET.OBJECT",
  247: "DB",
  248: "PAUSE",
  251: "RESUME",
  252: "FREQUENCY",
  253: "ADD.TOOLBAR",
  254: "DELETE.TOOLBAR",
  255: "User",
  256: "RESET.TOOLBAR",
  257: "EVALUATE",
  258: "GET.TOOLBAR",
  259: "GET.TOOL",
  260: "SPELLING.CHECK",
  261: "ERROR.TYPE",
  262: "APP.TITLE",
  263: "WINDOW.TITLE",
  264: "SAVE.TOOLBAR",
  265: "ENABLE.TOOL",
  266: "PRESS.TOOL",
  267: "REGISTER.ID",
  268: "GET.WORKBOOK",
  269: "AVEDEV",
  270: "BETADIST",
  271: "GAMMALN",
  272: "BETAINV",
  273: "BINOMDIST",
  274: "CHIDIST",
  275: "CHIINV",
  276: "COMBIN",
  277: "CONFIDENCE",
  278: "CRITBINOM",
  279: "EVEN",
  280: "EXPONDIST",
  281: "FDIST",
  282: "FINV",
  283: "FISHER",
  284: "FISHERINV",
  285: "FLOOR",
  286: "GAMMADIST",
  287: "GAMMAINV",
  288: "CEILING",
  289: "HYPGEOMDIST",
  290: "LOGNORMDIST",
  291: "LOGINV",
  292: "NEGBINOMDIST",
  293: "NORMDIST",
  294: "NORMSDIST",
  295: "NORMINV",
  296: "NORMSINV",
  297: "STANDARDIZE",
  298: "ODD",
  299: "PERMUT",
  300: "POISSON",
  301: "TDIST",
  302: "WEIBULL",
  303: "SUMXMY2",
  304: "SUMX2MY2",
  305: "SUMX2PY2",
  306: "CHITEST",
  307: "CORREL",
  308: "COVAR",
  309: "FORECAST",
  310: "FTEST",
  311: "INTERCEPT",
  312: "PEARSON",
  313: "RSQ",
  314: "STEYX",
  315: "SLOPE",
  316: "TTEST",
  317: "PROB",
  318: "DEVSQ",
  319: "GEOMEAN",
  320: "HARMEAN",
  321: "SUMSQ",
  322: "KURT",
  323: "SKEW",
  324: "ZTEST",
  325: "LARGE",
  326: "SMALL",
  327: "QUARTILE",
  328: "PERCENTILE",
  329: "PERCENTRANK",
  330: "MODE",
  331: "TRIMMEAN",
  332: "TINV",
  334: "MOVIE.COMMAND",
  335: "GET.MOVIE",
  336: "CONCATENATE",
  337: "POWER",
  338: "PIVOT.ADD.DATA",
  339: "GET.PIVOT.TABLE",
  340: "GET.PIVOT.FIELD",
  341: "GET.PIVOT.ITEM",
  342: "RADIANS",
  343: "DEGREES",
  344: "SUBTOTAL",
  345: "SUMIF",
  346: "COUNTIF",
  347: "COUNTBLANK",
  348: "SCENARIO.GET",
  349: "OPTIONS.LISTS.GET",
  350: "ISPMT",
  351: "DATEDIF",
  352: "DATESTRING",
  353: "NUMBERSTRING",
  354: "ROMAN",
  355: "OPEN.DIALOG",
  356: "SAVE.DIALOG",
  357: "VIEW.GET",
  358: "GETPIVOTDATA",
  359: "HYPERLINK",
  360: "PHONETIC",
  361: "AVERAGEA",
  362: "MAXA",
  363: "MINA",
  364: "STDEVPA",
  365: "VARPA",
  366: "STDEVA",
  367: "VARA",
  368: "BAHTTEXT",
  369: "THAIDAYOFWEEK",
  370: "THAIDIGIT",
  371: "THAIMONTHOFYEAR",
  372: "THAINUMSOUND",
  373: "THAINUMSTRING",
  374: "THAISTRINGLENGTH",
  375: "ISTHAIDIGIT",
  376: "ROUNDBAHTDOWN",
  377: "ROUNDBAHTUP",
  378: "THAIYEAR",
  379: "RTD",
  380: "CUBEVALUE",
  381: "CUBEMEMBER",
  382: "CUBEMEMBERPROPERTY",
  383: "CUBERANKEDMEMBER",
  384: "HEX2BIN",
  385: "HEX2DEC",
  386: "HEX2OCT",
  387: "DEC2BIN",
  388: "DEC2HEX",
  389: "DEC2OCT",
  390: "OCT2BIN",
  391: "OCT2HEX",
  392: "OCT2DEC",
  393: "BIN2DEC",
  394: "BIN2OCT",
  395: "BIN2HEX",
  396: "IMSUB",
  397: "IMDIV",
  398: "IMPOWER",
  399: "IMABS",
  400: "IMSQRT",
  401: "IMLN",
  402: "IMLOG2",
  403: "IMLOG10",
  404: "IMSIN",
  405: "IMCOS",
  406: "IMEXP",
  407: "IMARGUMENT",
  408: "IMCONJUGATE",
  409: "IMAGINARY",
  410: "IMREAL",
  411: "COMPLEX",
  412: "IMSUM",
  413: "IMPRODUCT",
  414: "SERIESSUM",
  415: "FACTDOUBLE",
  416: "SQRTPI",
  417: "QUOTIENT",
  418: "DELTA",
  419: "GESTEP",
  420: "ISEVEN",
  421: "ISODD",
  422: "MROUND",
  423: "ERF",
  424: "ERFC",
  425: "BESSELJ",
  426: "BESSELK",
  427: "BESSELY",
  428: "BESSELI",
  429: "XIRR",
  430: "XNPV",
  431: "PRICEMAT",
  432: "YIELDMAT",
  433: "INTRATE",
  434: "RECEIVED",
  435: "DISC",
  436: "PRICEDISC",
  437: "YIELDDISC",
  438: "TBILLEQ",
  439: "TBILLPRICE",
  440: "TBILLYIELD",
  441: "PRICE",
  442: "YIELD",
  443: "DOLLARDE",
  444: "DOLLARFR",
  445: "NOMINAL",
  446: "EFFECT",
  447: "CUMPRINC",
  448: "CUMIPMT",
  449: "EDATE",
  450: "EOMONTH",
  451: "YEARFRAC",
  452: "COUPDAYBS",
  453: "COUPDAYS",
  454: "COUPDAYSNC",
  455: "COUPNCD",
  456: "COUPNUM",
  457: "COUPPCD",
  458: "DURATION",
  459: "MDURATION",
  460: "ODDLPRICE",
  461: "ODDLYIELD",
  462: "ODDFPRICE",
  463: "ODDFYIELD",
  464: "RANDBETWEEN",
  465: "WEEKNUM",
  466: "AMORDEGRC",
  467: "AMORLINC",
  468: "CONVERT",
  724: "SHEETJS",
  469: "ACCRINT",
  470: "ACCRINTM",
  471: "WORKDAY",
  472: "NETWORKDAYS",
  473: "GCD",
  474: "MULTINOMIAL",
  475: "LCM",
  476: "FVSCHEDULE",
  477: "CUBEKPIMEMBER",
  478: "CUBESET",
  479: "CUBESETCOUNT",
  480: "IFERROR",
  481: "COUNTIFS",
  482: "SUMIFS",
  483: "AVERAGEIF",
  484: "AVERAGEIFS"
};
var FtabArgc = {
  2: 1,
  3: 1,
  10: 0,
  15: 1,
  16: 1,
  17: 1,
  18: 1,
  19: 0,
  20: 1,
  21: 1,
  22: 1,
  23: 1,
  24: 1,
  25: 1,
  26: 1,
  27: 2,
  30: 2,
  31: 3,
  32: 1,
  33: 1,
  34: 0,
  35: 0,
  38: 1,
  39: 2,
  40: 3,
  41: 3,
  42: 3,
  43: 3,
  44: 3,
  45: 3,
  47: 3,
  48: 2,
  53: 1,
  61: 3,
  63: 0,
  65: 3,
  66: 3,
  67: 1,
  68: 1,
  69: 1,
  70: 1,
  71: 1,
  72: 1,
  73: 1,
  74: 0,
  75: 1,
  76: 1,
  77: 1,
  79: 2,
  80: 2,
  83: 1,
  85: 0,
  86: 1,
  89: 0,
  90: 1,
  94: 0,
  95: 0,
  97: 2,
  98: 1,
  99: 1,
  101: 3,
  102: 3,
  105: 1,
  106: 1,
  108: 2,
  111: 1,
  112: 1,
  113: 1,
  114: 1,
  117: 2,
  118: 1,
  119: 4,
  121: 1,
  126: 1,
  127: 1,
  128: 1,
  129: 1,
  130: 1,
  131: 1,
  133: 1,
  134: 1,
  135: 1,
  136: 2,
  137: 2,
  138: 2,
  140: 1,
  141: 1,
  142: 3,
  143: 4,
  144: 4,
  161: 1,
  162: 1,
  163: 1,
  164: 1,
  165: 2,
  172: 1,
  175: 2,
  176: 2,
  177: 3,
  178: 2,
  179: 1,
  184: 1,
  186: 1,
  189: 3,
  190: 1,
  195: 3,
  196: 3,
  197: 1,
  198: 1,
  199: 3,
  201: 1,
  207: 4,
  210: 3,
  211: 1,
  212: 2,
  213: 2,
  214: 1,
  215: 1,
  225: 0,
  229: 1,
  230: 1,
  231: 1,
  232: 1,
  233: 1,
  234: 1,
  235: 3,
  244: 1,
  247: 4,
  252: 2,
  257: 1,
  261: 1,
  271: 1,
  273: 4,
  274: 2,
  275: 2,
  276: 2,
  277: 3,
  278: 3,
  279: 1,
  280: 3,
  281: 3,
  282: 3,
  283: 1,
  284: 1,
  285: 2,
  286: 4,
  287: 3,
  288: 2,
  289: 4,
  290: 3,
  291: 3,
  292: 3,
  293: 4,
  294: 1,
  295: 3,
  296: 1,
  297: 3,
  298: 1,
  299: 2,
  300: 3,
  301: 3,
  302: 4,
  303: 2,
  304: 2,
  305: 2,
  306: 2,
  307: 2,
  308: 2,
  309: 3,
  310: 2,
  311: 2,
  312: 2,
  313: 2,
  314: 2,
  315: 2,
  316: 4,
  325: 2,
  326: 2,
  327: 2,
  328: 2,
  331: 2,
  332: 2,
  337: 2,
  342: 1,
  343: 1,
  346: 2,
  347: 1,
  350: 4,
  351: 3,
  352: 1,
  353: 2,
  360: 1,
  368: 1,
  369: 1,
  370: 1,
  371: 1,
  372: 1,
  373: 1,
  374: 1,
  375: 1,
  376: 1,
  377: 1,
  378: 1,
  382: 3,
  385: 1,
  392: 1,
  393: 1,
  396: 2,
  397: 2,
  398: 2,
  399: 1,
  400: 1,
  401: 1,
  402: 1,
  403: 1,
  404: 1,
  405: 1,
  406: 1,
  407: 1,
  408: 1,
  409: 1,
  410: 1,
  414: 4,
  415: 1,
  416: 1,
  417: 2,
  420: 1,
  421: 1,
  422: 2,
  424: 1,
  425: 2,
  426: 2,
  427: 2,
  428: 2,
  430: 3,
  438: 3,
  439: 3,
  440: 3,
  443: 2,
  444: 2,
  445: 2,
  446: 2,
  447: 6,
  448: 6,
  449: 2,
  450: 2,
  464: 2,
  468: 3,
  476: 2,
  479: 1,
  480: 2,
  65535: 0
};
/* Part 3 TODO: actually parse formulae */
function ods_to_csf_formula(f/*:string*/)/*:string*/ {
	if(f.slice(0,3) == "of:") f = f.slice(3);
	/* 5.2 Basic Expressions */
	if(f.charCodeAt(0) == 61) {
		f = f.slice(1);
		if(f.charCodeAt(0) == 61) f = f.slice(1);
	}
	f = f.replace(/COM\.MICROSOFT\./g, "");
	/* Part 3 Section 5.8 References */
	f = f.replace(/\[((?:\.[A-Z]+[0-9]+)(?::\.[A-Z]+[0-9]+)?)\]/g, function($$, $1) { return $1.replace(/\./g,""); });
	/* TODO: something other than this */
	f = f.replace(/\[.(#[A-Z]*[?!])\]/g, "$1");
	return f.replace(/[;~]/g,",").replace(/\|/g,";");
}

function csf_to_ods_formula(f/*:string*/)/*:string*/ {
	var o = "of:=" + f.replace(crefregex, "$1[.$2$3$4$5]").replace(/\]:\[/g,":");
	/* TODO: something other than this */
	return o.replace(/;/g, "|").replace(/,/g,";");
}

function ods_to_csf_3D(r/*:string*/)/*:[string, string]*/ {
	var a = r.split(":");
	var s = a[0].split(".")[0];
	return [s, a[0].split(".")[1] + (a.length > 1 ? (":" + (a[1].split(".")[1] || a[1].split(".")[0])) : "")];
}

function csf_to_ods_3D(r/*:string*/)/*:string*/ {
	return r.replace(/\./,"!");
}

var strs = {}; // shared strings
var _ssfopts = {}; // spreadsheet formatting options

RELS.WS = [
	"http://schemas.openxmlformats.org/officeDocument/2006/relationships/worksheet",
	"http://purl.oclc.org/ooxml/officeDocument/relationships/worksheet"
];

/*global Map */
var browser_has_Map = typeof Map !== 'undefined';

function get_sst_id(sst/*:SST*/, str/*:string*/, rev)/*:number*/ {
	var i = 0, len = sst.length;
	if(rev) {
		if(browser_has_Map ? rev.has(str) : Object.prototype.hasOwnProperty.call(rev, str)) {
			var revarr = browser_has_Map ? rev.get(str) : rev[str];
			for(; i < revarr.length; ++i) {
				if(sst[revarr[i]].t === str) { sst.Count ++; return revarr[i]; }
			}
		}
	} else for(; i < len; ++i) {
		if(sst[i].t === str) { sst.Count ++; return i; }
	}
	sst[len] = ({t:str}/*:any*/); sst.Count ++; sst.Unique ++;
	if(rev) {
		if(browser_has_Map) {
			if(!rev.has(str)) rev.set(str, []);
			rev.get(str).push(len);
		} else {
			if(!Object.prototype.hasOwnProperty.call(rev, str)) rev[str] = [];
			rev[str].push(len);
		}
	}
	return len;
}

function col_obj_w(C/*:number*/, col) {
	var p = ({min:C+1,max:C+1}/*:any*/);
	/* wch (chars), wpx (pixels) */
	var wch = -1;
	if(col.MDW) MDW = col.MDW;
	if(col.width != null) p.customWidth = 1;
	else if(col.wpx != null) wch = px2char(col.wpx);
	else if(col.wch != null) wch = col.wch;
	if(wch > -1) { p.width = char2width(wch); p.customWidth = 1; }
	else if(col.width != null) p.width = col.width;
	if(col.hidden) p.hidden = true;
	if(col.level != null) { p.outlineLevel = p.level = col.level; }
	return p;
}

function default_margins(margins/*:Margins*/, mode/*:?string*/) {
	if(!margins) return;
	var defs = [0.7, 0.7, 0.75, 0.75, 0.3, 0.3];
	if(mode == 'xlml') defs = [1, 1, 1, 1, 0.5, 0.5];
	if(margins.left   == null) margins.left   = defs[0];
	if(margins.right  == null) margins.right  = defs[1];
	if(margins.top    == null) margins.top    = defs[2];
	if(margins.bottom == null) margins.bottom = defs[3];
	if(margins.header == null) margins.header = defs[4];
	if(margins.footer == null) margins.footer = defs[5];
}

function get_cell_style(styles/*:Array<any>*/, cell/*:Cell*/, opts) {
	var z = opts.revssf[cell.z != null ? cell.z : "General"];
	var i = 0x3c, len = styles.length;
	if(z == null && opts.ssf) {
		for(; i < 0x188; ++i) if(opts.ssf[i] == null) {
			SSF.load(cell.z, i);
			// $FlowIgnore
			opts.ssf[i] = cell.z;
			opts.revssf[cell.z] = z = i;
			break;
		}
	}
	for(i = 0; i != len; ++i) if(styles[i].numFmtId === z) return i;
	styles[len] = {
		numFmtId:z,
		fontId:0,
		fillId:0,
		borderId:0,
		xfId:0,
		applyNumberFormat:1
	};
	return len;
}

function safe_format(p/*:Cell*/, fmtid/*:number*/, fillid/*:?number*/, opts, themes, styles) {
	try {
		if(opts.cellNF) p.z = SSF._table[fmtid];
	} catch(e) { if(opts.WTF) throw e; }
	if(p.t === 'z' && !opts.cellStyles) return;
	if(p.t === 'd' && typeof p.v === 'string') p.v = parseDate(p.v);
	if((!opts || opts.cellText !== false) && p.t !== 'z') try {
		if(SSF._table[fmtid] == null) SSF.load(SSFImplicit[fmtid] || "General", fmtid);
		if(p.t === 'e') p.w = p.w || BErr[p.v];
		else if(fmtid === 0) {
			if(p.t === 'n') {
				if((p.v|0) === p.v) p.w = SSF._general_int(p.v);
				else p.w = SSF._general_num(p.v);
			}
			else if(p.t === 'd') {
				var dd = datenum(p.v);
				if((dd|0) === dd) p.w = SSF._general_int(dd);
				else p.w = SSF._general_num(dd);
			}
			else if(p.v === undefined) return "";
			else p.w = SSF._general(p.v,_ssfopts);
		}
		else if(p.t === 'd') p.w = SSF.format(fmtid,datenum(p.v),_ssfopts);
		else p.w = SSF.format(fmtid,p.v,_ssfopts);
	} catch(e) { if(opts.WTF) throw e; }
	if(!opts.cellStyles) return;
	if(fillid != null) try {
		p.s = styles.Fills[fillid];
		if (p.s.fgColor && p.s.fgColor.theme && !p.s.fgColor.rgb) {
			p.s.fgColor.rgb = rgb_tint(themes.themeElements.clrScheme[p.s.fgColor.theme].rgb, p.s.fgColor.tint || 0);
			if(opts.WTF) p.s.fgColor.raw_rgb = themes.themeElements.clrScheme[p.s.fgColor.theme].rgb;
		}
		if (p.s.bgColor && p.s.bgColor.theme) {
			p.s.bgColor.rgb = rgb_tint(themes.themeElements.clrScheme[p.s.bgColor.theme].rgb, p.s.bgColor.tint || 0);
			if(opts.WTF) p.s.bgColor.raw_rgb = themes.themeElements.clrScheme[p.s.bgColor.theme].rgb;
		}
	} catch(e) { if(opts.WTF && styles.Fills) throw e; }
}

function check_ws(ws/*:Worksheet*/, sname/*:string*/, i/*:number*/) {
	if(ws && ws['!ref']) {
		var range = safe_decode_range(ws['!ref']);
		if(range.e.c < range.s.c || range.e.r < range.s.r) throw new Error("Bad range (" + i + "): " + ws['!ref']);
	}
}
function parse_ws_xml_dim(ws/*:Worksheet*/, s/*:string*/) {
	var d = safe_decode_range(s);
	if(d.s.r<=d.e.r && d.s.c<=d.e.c && d.s.r>=0 && d.s.c>=0) ws["!ref"] = encode_range(d);
}
var mergecregex = /<(?:\w:)?mergeCell ref="[A-Z0-9:]+"\s*[\/]?>/g;
var sheetdataregex = /<(?:\w+:)?sheetData[^>]*>([\s\S]*)<\/(?:\w+:)?sheetData>/;
var hlinkregex = /<(?:\w:)?hyperlink [^>]*>/mg;
var dimregex = /"(\w*:\w*)"/;
var colregex = /<(?:\w:)?col\b[^>]*[\/]?>/g;
var afregex = /<(?:\w:)?autoFilter[^>]*([\/]|>([\s\S]*)<\/(?:\w:)?autoFilter)>/g;
var marginregex= /<(?:\w:)?pageMargins[^>]*\/>/g;
var sheetprregex = /<(?:\w:)?sheetPr\b(?:[^>a-z][^>]*)?\/>/;
var sheetprregex2= /<(?:\w:)?sheetPr[^>]*(?:[\/]|>([\s\S]*)<\/(?:\w:)?sheetPr)>/;
var svsregex = /<(?:\w:)?sheetViews[^>]*(?:[\/]|>([\s\S]*)<\/(?:\w:)?sheetViews)>/;

/* 18.3 Worksheets */
function parse_ws_xml(data/*:?string*/, opts, idx/*:number*/, rels, wb/*:WBWBProps*/, themes, styles)/*:Worksheet*/ {
	if(!data) return data;
	if(!rels) rels = {'!id':{}};

	/* 18.3.1.99 worksheet CT_Worksheet */
	var s = opts.dense ? ([]/*:any*/) : ({}/*:any*/);
	var refguess/*:Range*/ = ({s: {r:2000000, c:2000000}, e: {r:0, c:0} }/*:any*/);

	var data1 = "", data2 = "";
	var mtch/*:?any*/ = data.match(sheetdataregex);
	if(mtch) {
		data1 = data.slice(0, mtch.index);
		data2 = data.slice(mtch.index + mtch[0].length);
	} else data1 = data2 = data;

	/* 18.3.1.82 sheetPr CT_SheetPr */
	var sheetPr = data1.match(sheetprregex);
	if(sheetPr) parse_ws_xml_sheetpr(sheetPr[0], s, wb, idx);
	else if((sheetPr = data1.match(sheetprregex2))) parse_ws_xml_sheetpr2(sheetPr[0], sheetPr[1]||"", s, wb, idx);

	/* 18.3.1.35 dimension CT_SheetDimension */
	var ridx = (data1.match(/<(?:\w*:)?dimension/)||{index:-1}).index;
	if(ridx > 0) {
		var ref = data1.slice(ridx,ridx+50).match(dimregex);
		if(ref) parse_ws_xml_dim(s, ref[1]);
	}

	/* 18.3.1.88 sheetViews CT_SheetViews */
	var svs = data1.match(svsregex);
	if(svs && svs[1]) parse_ws_xml_sheetviews(svs[1], wb);

	/* 18.3.1.17 cols CT_Cols */
	var columns/*:Array<ColInfo>*/ = [];
	if(opts.cellStyles) {
		/* 18.3.1.13 col CT_Col */
		var cols = data1.match(colregex);
		if(cols) parse_ws_xml_cols(columns, cols);
	}

	/* 18.3.1.80 sheetData CT_SheetData ? */
	if(mtch) parse_ws_xml_data(mtch[1], s, opts, refguess, themes, styles);

	/* 18.3.1.2  autoFilter CT_AutoFilter */
	var afilter = data2.match(afregex);
	if(afilter) s['!autofilter'] = parse_ws_xml_autofilter(afilter[0]);

	/* 18.3.1.55 mergeCells CT_MergeCells */
	var merges/*:Array<Range>*/ = [];
	var _merge = data2.match(mergecregex);
	if(_merge) for(ridx = 0; ridx != _merge.length; ++ridx)
		merges[ridx] = safe_decode_range(_merge[ridx].slice(_merge[ridx].indexOf("\"")+1));

	/* 18.3.1.48 hyperlinks CT_Hyperlinks */
	var hlink = data2.match(hlinkregex);
	if(hlink) parse_ws_xml_hlinks(s, hlink, rels);

	/* 18.3.1.62 pageMargins CT_PageMargins */
	var margins = data2.match(marginregex);
	if(margins) s['!margins'] = parse_ws_xml_margins(parsexmltag(margins[0]));

	if(!s["!ref"] && refguess.e.c >= refguess.s.c && refguess.e.r >= refguess.s.r) s["!ref"] = encode_range(refguess);
	if(opts.sheetRows > 0 && s["!ref"]) {
		var tmpref = safe_decode_range(s["!ref"]);
		if(opts.sheetRows <= +tmpref.e.r) {
			tmpref.e.r = opts.sheetRows - 1;
			if(tmpref.e.r > refguess.e.r) tmpref.e.r = refguess.e.r;
			if(tmpref.e.r < tmpref.s.r) tmpref.s.r = tmpref.e.r;
			if(tmpref.e.c > refguess.e.c) tmpref.e.c = refguess.e.c;
			if(tmpref.e.c < tmpref.s.c) tmpref.s.c = tmpref.e.c;
			s["!fullref"] = s["!ref"];
			s["!ref"] = encode_range(tmpref);
		}
	}
	if(columns.length > 0) s["!cols"] = columns;
	if(merges.length > 0) s["!merges"] = merges;
	return s;
}

function write_ws_xml_merges(merges/*:Array<Range>*/)/*:string*/ {
	if(merges.length === 0) return "";
	var o = '<mergeCells count="' + merges.length + '">';
	for(var i = 0; i != merges.length; ++i) o += '<mergeCell ref="' + encode_range(merges[i]) + '"/>';
	return o + '</mergeCells>';
}

/* 18.3.1.82-3 sheetPr CT_ChartsheetPr / CT_SheetPr */
function parse_ws_xml_sheetpr(sheetPr/*:string*/, s, wb/*:WBWBProps*/, idx/*:number*/) {
	var data = parsexmltag(sheetPr);
	if(!wb.Sheets[idx]) wb.Sheets[idx] = {};
	if(data.codeName) wb.Sheets[idx].CodeName = unescapexml(utf8read(data.codeName));
}
function parse_ws_xml_sheetpr2(sheetPr/*:string*/, body/*:string*/, s, wb/*:WBWBProps*/, idx/*:number*/, styles, themes) {
	parse_ws_xml_sheetpr(sheetPr.slice(0, sheetPr.indexOf(">")), s, wb, idx);
}
function write_ws_xml_sheetpr(ws, wb, idx, opts, o) {
	var needed = false;
	var props = {}, payload = null;
	if(opts.bookType !== 'xlsx' && wb.vbaraw) {
		var cname = wb.SheetNames[idx];
		try { if(wb.Workbook) cname = wb.Workbook.Sheets[idx].CodeName || cname; } catch(e) {}
		needed = true;
		props.codeName = utf8write(escapexml(cname));
	}

	if(ws && ws["!outline"]) {
		var outlineprops = {summaryBelow:1, summaryRight:1};
		if(ws["!outline"].above) outlineprops.summaryBelow = 0;
		if(ws["!outline"].left) outlineprops.summaryRight = 0;
		payload = (payload||"") + writextag('outlinePr', null, outlineprops);
	}

	if(!needed && !payload) return;
	o[o.length] = (writextag('sheetPr', payload, props));
}

/* 18.3.1.85 sheetProtection CT_SheetProtection */
var sheetprot_deffalse = ["objects", "scenarios", "selectLockedCells", "selectUnlockedCells"];
var sheetprot_deftrue = [
	"formatColumns", "formatRows", "formatCells",
	"insertColumns", "insertRows", "insertHyperlinks",
	"deleteColumns", "deleteRows",
	"sort", "autoFilter", "pivotTables"
];
function write_ws_xml_protection(sp)/*:string*/ {
	// algorithmName, hashValue, saltValue, spinCount
	var o = ({sheet:1}/*:any*/);
	sheetprot_deffalse.forEach(function(n) { if(sp[n] != null && sp[n]) o[n] = "1"; });
	sheetprot_deftrue.forEach(function(n) { if(sp[n] != null && !sp[n]) o[n] = "0"; });
	/* TODO: algorithm */
	if(sp.password) o.password = crypto_CreatePasswordVerifier_Method1(sp.password).toString(16).toUpperCase();
	return writextag('sheetProtection', null, o);
}

function parse_ws_xml_hlinks(s, data/*:Array<string>*/, rels) {
	var dense = Array.isArray(s);
	for(var i = 0; i != data.length; ++i) {
		var val = parsexmltag(utf8read(data[i]), true);
		if(!val.ref) return;
		var rel = ((rels || {})['!id']||[])[val.id];
		if(rel) {
			val.Target = rel.Target;
			if(val.location) val.Target += "#"+unescapexml(val.location);
		} else {
			val.Target = "#" + unescapexml(val.location);
			rel = {Target: val.Target, TargetMode: 'Internal'};
		}
		val.Rel = rel;
		if(val.tooltip) { val.Tooltip = val.tooltip; delete val.tooltip; }
		var rng = safe_decode_range(val.ref);
		for(var R=rng.s.r;R<=rng.e.r;++R) for(var C=rng.s.c;C<=rng.e.c;++C) {
			var addr = encode_cell({c:C,r:R});
			if(dense) {
				if(!s[R]) s[R] = [];
				if(!s[R][C]) s[R][C] = {t:"z",v:undefined};
				s[R][C].l = val;
			} else {
				if(!s[addr]) s[addr] = {t:"z",v:undefined};
				s[addr].l = val;
			}
		}
	}
}

function parse_ws_xml_margins(margin) {
	var o = {};
	["left", "right", "top", "bottom", "header", "footer"].forEach(function(k) {
		if(margin[k]) o[k] = parseFloat(margin[k]);
	});
	return o;
}
function write_ws_xml_margins(margin)/*:string*/ {
	default_margins(margin);
	return writextag('pageMargins', null, margin);
}

function parse_ws_xml_cols(columns, cols) {
	var seencol = false;
	for(var coli = 0; coli != cols.length; ++coli) {
		var coll = parsexmltag(cols[coli], true);
		if(coll.hidden) coll.hidden = parsexmlbool(coll.hidden);
		var colm=parseInt(coll.min, 10)-1, colM=parseInt(coll.max,10)-1;
		if(coll.outlineLevel) coll.level = (+coll.outlineLevel || 0);
		delete coll.min; delete coll.max; coll.width = +coll.width;
		if(!seencol && coll.width) { seencol = true; find_mdw_colw(coll.width); }
		process_col(coll);
		while(colm <= colM) columns[colm++] = dup(coll);
	}
}
function write_ws_xml_cols(ws, cols)/*:string*/ {
	var o = ["<cols>"], col;
	for(var i = 0; i != cols.length; ++i) {
		if(!(col = cols[i])) continue;
		o[o.length] = (writextag('col', null, col_obj_w(i, col)));
	}
	o[o.length] = "</cols>";
	return o.join("");
}

function parse_ws_xml_autofilter(data/*:string*/) {
	var o = { ref: (data.match(/ref="([^"]*)"/)||[])[1]};
	return o;
}
function write_ws_xml_autofilter(data, ws, wb, idx)/*:string*/ {
	var ref = typeof data.ref == "string" ? data.ref : encode_range(data.ref);
	if(!wb.Workbook) wb.Workbook = ({Sheets:[]}/*:any*/);
	if(!wb.Workbook.Names) wb.Workbook.Names = [];
	var names/*: Array<any> */ = wb.Workbook.Names;
	var range = decode_range(ref);
	if(range.s.r == range.e.r) { range.e.r = decode_range(ws["!ref"]).e.r; ref = encode_range(range); }
	for(var i = 0; i < names.length; ++i) {
		var name = names[i];
		if(name.Name != '_xlnm._FilterDatabase') continue;
		if(name.Sheet != idx) continue;
		name.Ref = "'" + wb.SheetNames[idx] + "'!" + ref; break;
	}
	if(i == names.length) names.push({ Name: '_xlnm._FilterDatabase', Sheet: idx, Ref: "'" + wb.SheetNames[idx] + "'!" + ref  });
	return writextag("autoFilter", null, {ref:ref});
}

/* 18.3.1.88 sheetViews CT_SheetViews */
/* 18.3.1.87 sheetView CT_SheetView */
var sviewregex = /<(?:\w:)?sheetView(?:[^>a-z][^>]*)?\/?>/;
function parse_ws_xml_sheetviews(data, wb/*:WBWBProps*/) {
	if(!wb.Views) wb.Views = [{}];
	(data.match(sviewregex)||[]).forEach(function(r/*:string*/, i/*:number*/) {
		var tag = parsexmltag(r);
		// $FlowIgnore
		if(!wb.Views[i]) wb.Views[i] = {};
		// $FlowIgnore
		if(+tag.zoomScale) wb.Views[i].zoom = +tag.zoomScale;
		// $FlowIgnore
		if(parsexmlbool(tag.rightToLeft)) wb.Views[i].RTL = true;
	});
}
function write_ws_xml_sheetviews(ws, opts, idx, wb)/*:string*/ {
	var sview = ({workbookViewId:"0"}/*:any*/);
	// $FlowIgnore
	if((((wb||{}).Workbook||{}).Views||[])[0]) sview.rightToLeft = wb.Workbook.Views[0].RTL ? "1" : "0";
	return writextag("sheetViews", writextag("sheetView", null, sview), {});
}

function write_ws_xml_cell(cell/*:Cell*/, ref, ws, opts/*::, idx, wb*/)/*:string*/ {
	if(cell.v === undefined && typeof cell.f !== "string" || cell.t === 'z') return "";
	var vv = "";
	var oldt = cell.t, oldv = cell.v;
	if(cell.t !== "z") switch(cell.t) {
		case 'b': vv = cell.v ? "1" : "0"; break;
		case 'n': vv = ''+cell.v; break;
		case 'e': vv = BErr[cell.v]; break;
		case 'd':
			if(opts && opts.cellDates) vv = parseDate(cell.v, -1).toISOString();
			else {
				cell = dup(cell);
				cell.t = 'n';
				vv = ''+(cell.v = datenum(parseDate(cell.v)));
			}
			if(typeof cell.z === 'undefined') cell.z = SSF._table[14];
			break;
		default: vv = cell.v; break;
	}
	var v = writetag('v', escapexml(vv)), o = ({r:ref}/*:any*/);
	/* TODO: cell style */
	var os = get_cell_style(opts.cellXfs, cell, opts);
	if(os !== 0) o.s = os;
	switch(cell.t) {
		case 'n': break;
		case 'd': o.t = "d"; break;
		case 'b': o.t = "b"; break;
		case 'e': o.t = "e"; break;
		case 'z': break;
		default: if(cell.v == null) { delete cell.t; break; }
			if(cell.v.length > 32767) throw new Error("Text length must not exceed 32767 characters");
			if(opts && opts.bookSST) {
				v = writetag('v', ''+get_sst_id(opts.Strings, cell.v, opts.revStrings));
				o.t = "s"; break;
			}
			o.t = "str"; break;
	}
	if(cell.t != oldt) { cell.t = oldt; cell.v = oldv; }
	if(typeof cell.f == "string" && cell.f) {
		var ff = cell.F && cell.F.slice(0, ref.length) == ref ? {t:"array", ref:cell.F} : null;
		v = writextag('f', escapexml(cell.f), ff) + (cell.v != null ? v : "");
	}
	if(cell.l) ws['!links'].push([ref, cell.l]);
	if(cell.c) ws['!comments'].push([ref, cell.c]);
	return writextag('c', v, o);
}

var parse_ws_xml_data = (function() {
	var cellregex = /<(?:\w+:)?c[ \/>]/, rowregex = /<\/(?:\w+:)?row>/;
	var rregex = /r=["']([^"']*)["']/, isregex = /<(?:\w+:)?is>([\S\s]*?)<\/(?:\w+:)?is>/;
	var refregex = /ref=["']([^"']*)["']/;
	var match_v = matchtag("v"), match_f = matchtag("f");

return function parse_ws_xml_data(sdata/*:string*/, s, opts, guess/*:Range*/, themes, styles) {
	var ri = 0, x = "", cells/*:Array<string>*/ = [], cref/*:?Array<string>*/ = [], idx=0, i=0, cc=0, d="", p/*:any*/;
	var tag, tagr = 0, tagc = 0;
	var sstr, ftag;
	var fmtid = 0, fillid = 0;
	var do_format = Array.isArray(styles.CellXf), cf;
	var arrayf/*:Array<[Range, string]>*/ = [];
	var sharedf = [];
	var dense = Array.isArray(s);
	var rows/*:Array<RowInfo>*/ = [], rowobj = {}, rowrite = false;
	var sheetStubs = !!opts.sheetStubs;
	for(var marr = sdata.split(rowregex), mt = 0, marrlen = marr.length; mt != marrlen; ++mt) {
		x = marr[mt].trim();
		var xlen = x.length;
		if(xlen === 0) continue;

		/* 18.3.1.73 row CT_Row */
		var rstarti = 0;
		outa: for(ri = 0; ri < xlen; ++ri) switch(/*x.charCodeAt(ri)*/x[ri]) {
			case ">" /*62*/:
				if(/*x.charCodeAt(ri-1) != 47*/x[ri-1] != "/") { ++ri; break outa; }
				if(opts && opts.cellStyles) {
					// TODO: avoid duplication
					tag = parsexmltag(x.slice(rstarti,ri), true);
					tagr = tag.r != null ? parseInt(tag.r, 10) : tagr+1; tagc = -1;
					if(opts.sheetRows && opts.sheetRows < tagr) continue;
					rowobj = {}; rowrite = false;
					if(tag.ht) { rowrite = true; rowobj.hpt = parseFloat(tag.ht); rowobj.hpx = pt2px(rowobj.hpt); }
					if(tag.hidden == "1") { rowrite = true; rowobj.hidden = true; }
					if(tag.outlineLevel != null) { rowrite = true; rowobj.level = +tag.outlineLevel; }
					if(rowrite) rows[tagr-1] = rowobj;
				}
				break;
			case "<" /*60*/: rstarti = ri; break;
		}
		if(rstarti >= ri) break;
		tag = parsexmltag(x.slice(rstarti,ri), true);
		tagr = tag.r != null ? parseInt(tag.r, 10) : tagr+1; tagc = -1;
		if(opts.sheetRows && opts.sheetRows < tagr) continue;
		if(guess.s.r > tagr - 1) guess.s.r = tagr - 1;
		if(guess.e.r < tagr - 1) guess.e.r = tagr - 1;

		if(opts && opts.cellStyles) {
			rowobj = {}; rowrite = false;
			if(tag.ht) { rowrite = true; rowobj.hpt = parseFloat(tag.ht); rowobj.hpx = pt2px(rowobj.hpt); }
			if(tag.hidden == "1") { rowrite = true; rowobj.hidden = true; }
			if(tag.outlineLevel != null) { rowrite = true; rowobj.level = +tag.outlineLevel; }
			if(rowrite) rows[tagr-1] = rowobj;
		}

		/* 18.3.1.4 c CT_Cell */
		cells = x.slice(ri).split(cellregex);
		for(var rslice = 0; rslice != cells.length; ++rslice) if(cells[rslice].trim().charAt(0) != "<") break;
		cells = cells.slice(rslice);
		for(ri = 0; ri != cells.length; ++ri) {
			x = cells[ri].trim();
			if(x.length === 0) continue;
			cref = x.match(rregex); idx = ri; i=0; cc=0;
			x = "<c " + (x.slice(0,1)=="<"?">":"") + x;
			if(cref != null && cref.length === 2) {
				idx = 0; d=cref[1];
				for(i=0; i != d.length; ++i) {
					if((cc=d.charCodeAt(i)-64) < 1 || cc > 26) break;
					idx = 26*idx + cc;
				}
				--idx;
				tagc = idx;
			} else ++tagc;
			for(i = 0; i != x.length; ++i) if(x.charCodeAt(i) === 62) break; ++i;
			tag = parsexmltag(x.slice(0,i), true);
			if(!tag.r) tag.r = encode_cell({r:tagr-1, c:tagc});
			d = x.slice(i);
			p = ({t:""}/*:any*/);

			if((cref=d.match(match_v))!= null && /*::cref != null && */cref[1] !== '') p.v=unescapexml(cref[1]);
			if(opts.cellFormula) {
				if((cref=d.match(match_f))!= null && /*::cref != null && */cref[1] !== '') {
					/* TODO: match against XLSXFutureFunctions */
					p.f=unescapexml(utf8read(cref[1])).replace(/\r\n/g, "\n");
					if(!opts.xlfn) p.f = _xlfn(p.f);
					if(/*::cref != null && cref[0] != null && */cref[0].indexOf('t="array"') > -1) {
						p.F = (d.match(refregex)||[])[1];
						if(p.F.indexOf(":") > -1) arrayf.push([safe_decode_range(p.F), p.F]);
					} else if(/*::cref != null && cref[0] != null && */cref[0].indexOf('t="shared"') > -1) {
						// TODO: parse formula
						ftag = parsexmltag(cref[0]);
						var ___f = unescapexml(utf8read(cref[1]));
						if(!opts.xlfn) ___f = _xlfn(___f);
						sharedf[parseInt(ftag.si, 10)] = [ftag, ___f, tag.r];
					}
				} else if((cref=d.match(/<f[^>]*\/>/))) {
					ftag = parsexmltag(cref[0]);
					if(sharedf[ftag.si]) p.f = shift_formula_xlsx(sharedf[ftag.si][1], sharedf[ftag.si][2]/*[0].ref*/, tag.r);
				}
				/* TODO: factor out contains logic */
				var _tag = decode_cell(tag.r);
				for(i = 0; i < arrayf.length; ++i)
					if(_tag.r >= arrayf[i][0].s.r && _tag.r <= arrayf[i][0].e.r)
						if(_tag.c >= arrayf[i][0].s.c && _tag.c <= arrayf[i][0].e.c)
							p.F = arrayf[i][1];
			}

			if(tag.t == null && p.v === undefined) {
				if(p.f || p.F) {
					p.v = 0; p.t = "n";
				} else if(!sheetStubs) continue;
				else p.t = "z";
			}
			else p.t = tag.t || "n";
			if(guess.s.c > tagc) guess.s.c = tagc;
			if(guess.e.c < tagc) guess.e.c = tagc;
			/* 18.18.11 t ST_CellType */
			switch(p.t) {
				case 'n':
					if(p.v == "" || p.v == null) {
						if(!sheetStubs) continue;
						p.t = 'z';
					} else p.v = parseFloat(p.v);
					break;
				case 's':
					if(typeof p.v == 'undefined') {
						if(!sheetStubs) continue;
						p.t = 'z';
					} else {
						sstr = strs[parseInt(p.v, 10)];
						p.v = sstr.t;
						p.r = sstr.r;
						if(opts.cellHTML) p.h = sstr.h;
					}
					break;
				case 'str':
					p.t = "s";
					p.v = (p.v!=null) ? utf8read(p.v) : '';
					if(opts.cellHTML) p.h = escapehtml(p.v);
					break;
				case 'inlineStr':
					cref = d.match(isregex);
					p.t = 's';
					if(cref != null && (sstr = parse_si(cref[1]))) {
						p.v = sstr.t;
						if(opts.cellHTML) p.h = sstr.h;
					} else p.v = "";
					break;
				case 'b': p.v = parsexmlbool(p.v); break;
				case 'd':
					if(opts.cellDates) p.v = parseDate(p.v, 1);
					else { p.v = datenum(parseDate(p.v, 1)); p.t = 'n'; }
					break;
				/* error string in .w, number in .v */
				case 'e':
					if(!opts || opts.cellText !== false) p.w = p.v;
					p.v = RBErr[p.v]; break;
			}
			/* formatting */
			fmtid = fillid = 0;
			cf = null;
			if(do_format && tag.s !== undefined) {
				cf = styles.CellXf[tag.s];
				if(cf != null) {
					if(cf.numFmtId != null) fmtid = cf.numFmtId;
					if(opts.cellStyles) {
						if(cf.fillId != null) fillid = cf.fillId;
					}
				}
			}
			safe_format(p, fmtid, fillid, opts, themes, styles);
			if(opts.cellDates && do_format && p.t == 'n' && SSF.is_date(SSF._table[fmtid])) { p.t = 'd'; p.v = numdate(p.v); }
			if(dense) {
				var _r = decode_cell(tag.r);
				if(!s[_r.r]) s[_r.r] = [];
				s[_r.r][_r.c] = p;
			} else s[tag.r] = p;
		}
	}
	if(rows.length > 0) s['!rows'] = rows;
}; })();

function write_ws_xml_data(ws/*:Worksheet*/, opts, idx/*:number*/, wb/*:Workbook*//*::, rels*/)/*:string*/ {
	var o/*:Array<string>*/ = [], r/*:Array<string>*/ = [], range = safe_decode_range(ws['!ref']), cell="", ref, rr = "", cols/*:Array<string>*/ = [], R=0, C=0, rows = ws['!rows'];
	var dense = Array.isArray(ws);
	var params = ({r:rr}/*:any*/), row/*:RowInfo*/, height = -1;
	for(C = range.s.c; C <= range.e.c; ++C) cols[C] = encode_col(C);
	for(R = range.s.r; R <= range.e.r; ++R) {
		r = [];
		rr = encode_row(R);
		for(C = range.s.c; C <= range.e.c; ++C) {
			ref = cols[C] + rr;
			var _cell = dense ? (ws[R]||[])[C]: ws[ref];
			if(_cell === undefined) continue;
			if((cell = write_ws_xml_cell(_cell, ref, ws, opts)) != null) r.push(cell);
		}
		if(r.length > 0 || (rows && rows[R])) {
			params = ({r:rr}/*:any*/);
			if(rows && rows[R]) {
				row = rows[R];
				if(row.hidden) params.hidden = 1;
				height = -1;
				if(row.hpx) height = px2pt(row.hpx);
				else if(row.hpt) height = row.hpt;
				if(height > -1) { params.ht = height; params.customHeight = 1; }
				if(row.level) { params.outlineLevel = row.level; }
			}
			o[o.length] = (writextag('row', r.join(""), params));
		}
	}
	if(rows) for(; R < rows.length; ++R) {
		if(rows && rows[R]) {
			params = ({r:R+1}/*:any*/);
			row = rows[R];
			if(row.hidden) params.hidden = 1;
			height = -1;
			if (row.hpx) height = px2pt(row.hpx);
			else if (row.hpt) height = row.hpt;
			if (height > -1) { params.ht = height; params.customHeight = 1; }
			if (row.level) { params.outlineLevel = row.level; }
			o[o.length] = (writextag('row', "", params));
		}
	}
	return o.join("");
}

var WS_XML_ROOT = writextag('worksheet', null, {
	'xmlns': XMLNS.main[0],
	'xmlns:r': XMLNS.r
});

function write_ws_xml(idx/*:number*/, opts, wb/*:Workbook*/, rels)/*:string*/ {
	var o = [XML_HEADER, WS_XML_ROOT];
	var s = wb.SheetNames[idx], sidx = 0, rdata = "";
	var ws = wb.Sheets[s];
	if(ws == null) ws = {};
	var ref = ws['!ref'] || 'A1';
	var range = safe_decode_range(ref);
	if(range.e.c > 0x3FFF || range.e.r > 0xFFFFF) {
		if(opts.WTF) throw new Error("Range " + ref + " exceeds format limit A1:XFD1048576");
		range.e.c = Math.min(range.e.c, 0x3FFF);
		range.e.r = Math.min(range.e.c, 0xFFFFF);
		ref = encode_range(range);
	}
	if(!rels) rels = {};
	ws['!comments'] = [];
	var _drawing = [];

	write_ws_xml_sheetpr(ws, wb, idx, opts, o);

	o[o.length] = (writextag('dimension', null, {'ref': ref}));

	o[o.length] = write_ws_xml_sheetviews(ws, opts, idx, wb);

	/* TODO: store in WB, process styles */
	if(opts.sheetFormat) o[o.length] = (writextag('sheetFormatPr', null, {
		defaultRowHeight:opts.sheetFormat.defaultRowHeight||'16',
		baseColWidth:opts.sheetFormat.baseColWidth||'10',
		outlineLevelRow:opts.sheetFormat.outlineLevelRow||'7'
	}));

	if(ws['!cols'] != null && ws['!cols'].length > 0) o[o.length] = (write_ws_xml_cols(ws, ws['!cols']));

	o[sidx = o.length] = '<sheetData/>';
	ws['!links'] = [];
	if(ws['!ref'] != null) {
		rdata = write_ws_xml_data(ws, opts);
		if(rdata.length > 0) o[o.length] = (rdata);
	}
	if(o.length>sidx+1) { o[o.length] = ('</sheetData>'); o[sidx]=o[sidx].replace("/>",">"); }

	/* sheetCalcPr */

	if(ws['!protect']) o[o.length] = write_ws_xml_protection(ws['!protect']);

	/* protectedRanges */
	/* scenarios */

	if(ws['!autofilter'] != null) o[o.length] = write_ws_xml_autofilter(ws['!autofilter'], ws, wb, idx);

	/* sortState */
	/* dataConsolidate */
	/* customSheetViews */

	if(ws['!merges'] != null && ws['!merges'].length > 0) o[o.length] = (write_ws_xml_merges(ws['!merges']));

	/* phoneticPr */
	/* conditionalFormatting */
	/* dataValidations */

	var relc = -1, rel, rId = -1;
	if(/*::(*/ws['!links']/*::||[])*/.length > 0) {
		o[o.length] = "<hyperlinks>";
		/*::(*/ws['!links']/*::||[])*/.forEach(function(l) {
			if(!l[1].Target) return;
			rel = ({"ref":l[0]}/*:any*/);
			if(l[1].Target.charAt(0) != "#") {
				rId = add_rels(rels, -1, escapexml(l[1].Target).replace(/#.*$/, ""), RELS.HLINK);
				rel["r:id"] = "rId"+rId;
			}
			if((relc = l[1].Target.indexOf("#")) > -1) rel.location = escapexml(l[1].Target.slice(relc+1));
			if(l[1].Tooltip) rel.tooltip = escapexml(l[1].Tooltip);
			o[o.length] = writextag("hyperlink",null,rel);
		});
		o[o.length] = "</hyperlinks>";
	}
	delete ws['!links'];

	/* printOptions */

	if(ws['!margins'] != null) o[o.length] =  write_ws_xml_margins(ws['!margins']);

	/* pageSetup */
	/* headerFooter */
	/* rowBreaks */
	/* colBreaks */
	/* customProperties */
	/* cellWatches */

	if(!opts || opts.ignoreEC || (opts.ignoreEC == (void 0))) o[o.length] = writetag("ignoredErrors", writextag("ignoredError", null, {numberStoredAsText:1, sqref:ref}));

	/* smartTags */

	if(_drawing.length > 0) {
		rId = add_rels(rels, -1, "../drawings/drawing" + (idx+1) + ".xml", RELS.DRAW);
		o[o.length] = writextag("drawing", null, {"r:id":"rId" + rId});
		ws['!drawing'] = _drawing;
	}

	if(ws['!comments'].length > 0) {
		rId = add_rels(rels, -1, "../drawings/vmlDrawing" + (idx+1) + ".vml", RELS.VML);
		o[o.length] = writextag("legacyDrawing", null, {"r:id":"rId" + rId});
		ws['!legacy'] = rId;
	}

	/* legacyDrawingHF */
	/* picture */
	/* oleObjects */
	/* controls */
	/* webPublishItems */
	/* tableParts */
	/* extLst */

	if(o.length>1) { o[o.length] = ('</worksheet>'); o[1]=o[1].replace("/>",">"); }
	return o.join("");
}

/* [MS-XLSB] 2.4.726 BrtRowHdr */
function parse_BrtRowHdr(data, length) {
	var z = ({}/*:any*/);
	var tgt = data.l + length;
	z.r = data.read_shift(4);
	data.l += 4; // TODO: ixfe
	var miyRw = data.read_shift(2);
	data.l += 1; // TODO: top/bot padding
	var flags = data.read_shift(1);
	data.l = tgt;
	if(flags & 0x07) z.level = flags & 0x07;
	if(flags & 0x10) z.hidden = true;
	if(flags & 0x20) z.hpt = miyRw / 20;
	return z;
}
function write_BrtRowHdr(R/*:number*/, range, ws) {
	var o = new_buf(17+8*16);
	var row = (ws['!rows']||[])[R]||{};
	o.write_shift(4, R);

	o.write_shift(4, 0); /* TODO: ixfe */

	var miyRw = 0x0140;
	if(row.hpx) miyRw = px2pt(row.hpx) * 20;
	else if(row.hpt) miyRw = row.hpt * 20;
	o.write_shift(2, miyRw);

	o.write_shift(1, 0); /* top/bot padding */

	var flags = 0x0;
	if(row.level) flags |= row.level;
	if(row.hidden) flags |= 0x10;
	if(row.hpx || row.hpt) flags |= 0x20;
	o.write_shift(1, flags);

	o.write_shift(1, 0); /* phonetic guide */

	/* [MS-XLSB] 2.5.8 BrtColSpan explains the mechanism */
	var ncolspan = 0, lcs = o.l;
	o.l += 4;

	var caddr = {r:R, c:0};
	for(var i = 0; i < 16; ++i) {
		if((range.s.c > ((i+1) << 10)) || (range.e.c < (i << 10))) continue;
		var first = -1, last = -1;
		for(var j = (i<<10); j < ((i+1)<<10); ++j) {
			caddr.c = j;
			var cell = Array.isArray(ws) ? (ws[caddr.r]||[])[caddr.c] : ws[encode_cell(caddr)];
			if(cell) { if(first < 0) first = j; last = j; }
		}
		if(first < 0) continue;
		++ncolspan;
		o.write_shift(4, first);
		o.write_shift(4, last);
	}

	var l = o.l;
	o.l = lcs;
	o.write_shift(4, ncolspan);
	o.l = l;

	return o.length > o.l ? o.slice(0, o.l) : o;
}
function write_row_header(ba, ws, range, R) {
	var o = write_BrtRowHdr(R, range, ws);
	if((o.length > 17) || (ws['!rows']||[])[R]) write_record(ba, 'BrtRowHdr', o);
}

/* [MS-XLSB] 2.4.820 BrtWsDim */
var parse_BrtWsDim = parse_UncheckedRfX;
var write_BrtWsDim = write_UncheckedRfX;

/* [MS-XLSB] 2.4.821 BrtWsFmtInfo */
function parse_BrtWsFmtInfo(/*::data, length*/) {
}
//function write_BrtWsFmtInfo(ws, o) { }

/* [MS-XLSB] 2.4.823 BrtWsProp */
function parse_BrtWsProp(data, length) {
	var z = {};
	var f = data[data.l]; ++data.l;
	z.above = !(f & 0x40);
	z.left  = !(f & 0x80);
	/* TODO: pull flags */
	data.l += 18;
	z.name = parse_XLSBCodeName(data);
	return z;
}
function write_BrtWsProp(str, outl, o) {
	if(o == null) o = new_buf(84+4*str.length);
	var f = 0xC0;
	if(outl) {
		if(outl.above) f &= ~0x40;
		if(outl.left)  f &= ~0x80;
	}
	o.write_shift(1, f);
	for(var i = 1; i < 3; ++i) o.write_shift(1,0);
	write_BrtColor({auto:1}, o);
	o.write_shift(-4,-1);
	o.write_shift(-4,-1);
	write_XLSBCodeName(str, o);
	return o.slice(0, o.l);
}

/* [MS-XLSB] 2.4.306 BrtCellBlank */
function parse_BrtCellBlank(data) {
	var cell = parse_XLSBCell(data);
	return [cell];
}
function write_BrtCellBlank(cell, ncell, o) {
	if(o == null) o = new_buf(8);
	return write_XLSBCell(ncell, o);
}
function parse_BrtShortBlank(data) {
	var cell = parse_XLSBShortCell(data);
	return [cell];
}
function write_BrtShortBlank(cell, ncell, o) {
	if(o == null) o = new_buf(4);
	return write_XLSBShortCell(ncell, o);
}

/* [MS-XLSB] 2.4.307 BrtCellBool */
function parse_BrtCellBool(data) {
	var cell = parse_XLSBCell(data);
	var fBool = data.read_shift(1);
	return [cell, fBool, 'b'];
}
function write_BrtCellBool(cell, ncell, o) {
	if(o == null) o = new_buf(9);
	write_XLSBCell(ncell, o);
	o.write_shift(1, cell.v ? 1 : 0);
	return o;
}
function parse_BrtShortBool(data) {
	var cell = parse_XLSBShortCell(data);
	var fBool = data.read_shift(1);
	return [cell, fBool, 'b'];
}
function write_BrtShortBool(cell, ncell, o) {
	if(o == null) o = new_buf(5);
	write_XLSBShortCell(ncell, o);
	o.write_shift(1, cell.v ? 1 : 0);
	return o;
}

/* [MS-XLSB] 2.4.308 BrtCellError */
function parse_BrtCellError(data) {
	var cell = parse_XLSBCell(data);
	var bError = data.read_shift(1);
	return [cell, bError, 'e'];
}
function write_BrtCellError(cell, ncell, o) {
	if(o == null) o = new_buf(9);
	write_XLSBCell(ncell, o);
	o.write_shift(1, cell.v);
	return o;
}
function parse_BrtShortError(data) {
	var cell = parse_XLSBShortCell(data);
	var bError = data.read_shift(1);
	return [cell, bError, 'e'];
}
function write_BrtShortError(cell, ncell, o) {
	if(o == null) o = new_buf(8);
	write_XLSBShortCell(ncell, o);
	o.write_shift(1, cell.v);
	o.write_shift(2, 0);
	o.write_shift(1, 0);
	return o;
}


/* [MS-XLSB] 2.4.311 BrtCellIsst */
function parse_BrtCellIsst(data) {
	var cell = parse_XLSBCell(data);
	var isst = data.read_shift(4);
	return [cell, isst, 's'];
}
function write_BrtCellIsst(cell, ncell, o) {
	if(o == null) o = new_buf(12);
	write_XLSBCell(ncell, o);
	o.write_shift(4, ncell.v);
	return o;
}
function parse_BrtShortIsst(data) {
	var cell = parse_XLSBShortCell(data);
	var isst = data.read_shift(4);
	return [cell, isst, 's'];
}
function write_BrtShortIsst(cell, ncell, o) {
	if(o == null) o = new_buf(8);
	write_XLSBShortCell(ncell, o);
	o.write_shift(4, ncell.v);
	return o;
}

/* [MS-XLSB] 2.4.313 BrtCellReal */
function parse_BrtCellReal(data) {
	var cell = parse_XLSBCell(data);
	var value = parse_Xnum(data);
	return [cell, value, 'n'];
}
function write_BrtCellReal(cell, ncell, o) {
	if(o == null) o = new_buf(16);
	write_XLSBCell(ncell, o);
	write_Xnum(cell.v, o);
	return o;
}
function parse_BrtShortReal(data) {
	var cell = parse_XLSBShortCell(data);
	var value = parse_Xnum(data);
	return [cell, value, 'n'];
}
function write_BrtShortReal(cell, ncell, o) {
	if(o == null) o = new_buf(12);
	write_XLSBShortCell(ncell, o);
	write_Xnum(cell.v, o);
	return o;
}

/* [MS-XLSB] 2.4.314 BrtCellRk */
function parse_BrtCellRk(data) {
	var cell = parse_XLSBCell(data);
	var value = parse_RkNumber(data);
	return [cell, value, 'n'];
}
function write_BrtCellRk(cell, ncell, o) {
	if(o == null) o = new_buf(12);
	write_XLSBCell(ncell, o);
	write_RkNumber(cell.v, o);
	return o;
}
function parse_BrtShortRk(data) {
	var cell = parse_XLSBShortCell(data);
	var value = parse_RkNumber(data);
	return [cell, value, 'n'];
}
function write_BrtShortRk(cell, ncell, o) {
	if(o == null) o = new_buf(8);
	write_XLSBShortCell(ncell, o);
	write_RkNumber(cell.v, o);
	return o;
}

/* [MS-XLSB] 2.4.323 BrtCellRString */
function parse_BrtCellRString(data) {
	var cell = parse_XLSBCell(data);
	var value = parse_RichStr(data);
	return [cell, value, 'is'];
}

/* [MS-XLSB] 2.4.317 BrtCellSt */
function parse_BrtCellSt(data) {
	var cell = parse_XLSBCell(data);
	var value = parse_XLWideString(data);
	return [cell, value, 'str'];
}
function write_BrtCellSt(cell, ncell, o) {
	if(o == null) o = new_buf(12 + 4 * cell.v.length);
	write_XLSBCell(ncell, o);
	write_XLWideString(cell.v, o);
	return o.length > o.l ? o.slice(0, o.l) : o;
}
function parse_BrtShortSt(data) {
	var cell = parse_XLSBShortCell(data);
	var value = parse_XLWideString(data);
	return [cell, value, 'str'];
}
function write_BrtShortSt(cell, ncell, o) {
	if(o == null) o = new_buf(8 + 4 * cell.v.length);
	write_XLSBShortCell(ncell, o);
	write_XLWideString(cell.v, o);
	return o.length > o.l ? o.slice(0, o.l) : o;
}

/* [MS-XLSB] 2.4.653 BrtFmlaBool */
function parse_BrtFmlaBool(data, length, opts) {
	var end = data.l + length;
	var cell = parse_XLSBCell(data);
	cell.r = opts['!row'];
	var value = data.read_shift(1);
	var o = [cell, value, 'b'];
	if(opts.cellFormula) {
		data.l += 2;
		var formula = parse_XLSBCellParsedFormula(data, end - data.l, opts);
		o[3] = stringify_formula(formula, null/*range*/, cell, opts.supbooks, opts);/* TODO */
	}
	else data.l = end;
	return o;
}

/* [MS-XLSB] 2.4.654 BrtFmlaError */
function parse_BrtFmlaError(data, length, opts) {
	var end = data.l + length;
	var cell = parse_XLSBCell(data);
	cell.r = opts['!row'];
	var value = data.read_shift(1);
	var o = [cell, value, 'e'];
	if(opts.cellFormula) {
		data.l += 2;
		var formula = parse_XLSBCellParsedFormula(data, end - data.l, opts);
		o[3] = stringify_formula(formula, null/*range*/, cell, opts.supbooks, opts);/* TODO */
	}
	else data.l = end;
	return o;
}

/* [MS-XLSB] 2.4.655 BrtFmlaNum */
function parse_BrtFmlaNum(data, length, opts) {
	var end = data.l + length;
	var cell = parse_XLSBCell(data);
	cell.r = opts['!row'];
	var value = parse_Xnum(data);
	var o = [cell, value, 'n'];
	if(opts.cellFormula) {
		data.l += 2;
		var formula = parse_XLSBCellParsedFormula(data, end - data.l, opts);
		o[3] = stringify_formula(formula, null/*range*/, cell, opts.supbooks, opts);/* TODO */
	}
	else data.l = end;
	return o;
}

/* [MS-XLSB] 2.4.656 BrtFmlaString */
function parse_BrtFmlaString(data, length, opts) {
	var end = data.l + length;
	var cell = parse_XLSBCell(data);
	cell.r = opts['!row'];
	var value = parse_XLWideString(data);
	var o = [cell, value, 'str'];
	if(opts.cellFormula) {
		data.l += 2;
		var formula = parse_XLSBCellParsedFormula(data, end - data.l, opts);
		o[3] = stringify_formula(formula, null/*range*/, cell, opts.supbooks, opts);/* TODO */
	}
	else data.l = end;
	return o;
}

/* [MS-XLSB] 2.4.682 BrtMergeCell */
var parse_BrtMergeCell = parse_UncheckedRfX;
var write_BrtMergeCell = write_UncheckedRfX;
/* [MS-XLSB] 2.4.107 BrtBeginMergeCells */
function write_BrtBeginMergeCells(cnt, o) {
	if(o == null) o = new_buf(4);
	o.write_shift(4, cnt);
	return o;
}

/* [MS-XLSB] 2.4.662 BrtHLink */
function parse_BrtHLink(data, length/*::, opts*/) {
	var end = data.l + length;
	var rfx = parse_UncheckedRfX(data);
	var relId = parse_XLNullableWideString(data);
	var loc = parse_XLWideString(data);
	var tooltip = parse_XLWideString(data);
	var display = parse_XLWideString(data);
	data.l = end;
	var o = ({rfx:rfx, relId:relId, loc:loc, display:display}/*:any*/);
	if(tooltip) o.Tooltip = tooltip;
	return o;
}
function write_BrtHLink(l, rId) {
	var o = new_buf(50+4*(l[1].Target.length + (l[1].Tooltip || "").length));
	write_UncheckedRfX({s:decode_cell(l[0]), e:decode_cell(l[0])}, o);
	write_RelID("rId" + rId, o);
	var locidx = l[1].Target.indexOf("#");
	var loc = locidx == -1 ? "" : l[1].Target.slice(locidx+1);
	write_XLWideString(loc || "", o);
	write_XLWideString(l[1].Tooltip || "", o);
	write_XLWideString("", o);
	return o.slice(0, o.l);
}

/* [MS-XLSB] 2.4.692 BrtPane */
function parse_BrtPane(/*data, length, opts*/) {
}

/* [MS-XLSB] 2.4.6 BrtArrFmla */
function parse_BrtArrFmla(data, length, opts) {
	var end = data.l + length;
	var rfx = parse_RfX(data);
	var fAlwaysCalc = data.read_shift(1);
	var o = [rfx]; o[2] = fAlwaysCalc;
	if(opts.cellFormula) {
		var formula = parse_XLSBArrayParsedFormula(data, end - data.l, opts);
		o[1] = formula;
	} else data.l = end;
	return o;
}

/* [MS-XLSB] 2.4.750 BrtShrFmla */
function parse_BrtShrFmla(data, length, opts) {
	var end = data.l + length;
	var rfx = parse_UncheckedRfX(data);
	var o = [rfx];
	if(opts.cellFormula) {
		var formula = parse_XLSBSharedParsedFormula(data, end - data.l, opts);
		o[1] = formula;
		data.l = end;
	} else data.l = end;
	return o;
}

/* [MS-XLSB] 2.4.323 BrtColInfo */
/* TODO: once XLS ColInfo is set, combine the functions */
function write_BrtColInfo(C/*:number*/, col, o) {
	if(o == null) o = new_buf(18);
	var p = col_obj_w(C, col);
	o.write_shift(-4, C);
	o.write_shift(-4, C);
	o.write_shift(4, (p.width || 10) * 256);
	o.write_shift(4, 0/*ixfe*/); // style
	var flags = 0;
	if(col.hidden) flags |= 0x01;
	if(typeof p.width == 'number') flags |= 0x02;
	if(col.level) flags |= (col.level << 8);
	o.write_shift(2, flags); // bit flag
	return o;
}

/* [MS-XLSB] 2.4.678 BrtMargins */
var BrtMarginKeys = ["left","right","top","bottom","header","footer"];
function parse_BrtMargins(data/*::, length, opts*/)/*:Margins*/ {
	var margins = ({}/*:any*/);
	BrtMarginKeys.forEach(function(k) { margins[k] = parse_Xnum(data); });
	return margins;
}
function write_BrtMargins(margins/*:Margins*/, o) {
	if(o == null) o = new_buf(6*8);
	default_margins(margins);
	BrtMarginKeys.forEach(function(k) { write_Xnum((margins/*:any*/)[k], o); });
	return o;
}

/* [MS-XLSB] 2.4.299 BrtBeginWsView */
function parse_BrtBeginWsView(data/*::, length, opts*/) {
	var f = data.read_shift(2);
	data.l += 28;
	return { RTL: f & 0x20 };
}
function write_BrtBeginWsView(ws, Workbook, o) {
	if(o == null) o = new_buf(30);
	var f = 0x39c;
	if((((Workbook||{}).Views||[])[0]||{}).RTL) f |= 0x20;
	o.write_shift(2, f); // bit flag
	o.write_shift(4, 0);
	o.write_shift(4, 0); // view first row
	o.write_shift(4, 0); // view first col
	o.write_shift(1, 0); // gridline color ICV
	o.write_shift(1, 0);
	o.write_shift(2, 0);
	o.write_shift(2, 100); // zoom scale
	o.write_shift(2, 0);
	o.write_shift(2, 0);
	o.write_shift(2, 0);
	o.write_shift(4, 0); // workbook view id
	return o;
}

/* [MS-XLSB] 2.4.309 BrtCellIgnoreEC */
function write_BrtCellIgnoreEC(ref) {
	var o = new_buf(24);
	o.write_shift(4, 4);
	o.write_shift(4, 1);
	write_UncheckedRfX(ref, o);
	return o;
}

/* [MS-XLSB] 2.4.748 BrtSheetProtection */
function write_BrtSheetProtection(sp, o) {
	if(o == null) o = new_buf(16*4+2);
	o.write_shift(2, sp.password ? crypto_CreatePasswordVerifier_Method1(sp.password) : 0);
	o.write_shift(4, 1); // this record should not be written if no protection
	[
		["objects",             false], // fObjects
		["scenarios",           false], // fScenarios
		["formatCells",          true], // fFormatCells
		["formatColumns",        true], // fFormatColumns
		["formatRows",           true], // fFormatRows
		["insertColumns",        true], // fInsertColumns
		["insertRows",           true], // fInsertRows
		["insertHyperlinks",     true], // fInsertHyperlinks
		["deleteColumns",        true], // fDeleteColumns
		["deleteRows",           true], // fDeleteRows
		["selectLockedCells",   false], // fSelLockedCells
		["sort",                 true], // fSort
		["autoFilter",           true], // fAutoFilter
		["pivotTables",          true], // fPivotTables
		["selectUnlockedCells", false]  // fSelUnlockedCells
	].forEach(function(n) {
		/*:: if(o == null) throw "unreachable"; */
		if(n[1]) o.write_shift(4, sp[n[0]] != null && !sp[n[0]] ? 1 : 0);
		else      o.write_shift(4, sp[n[0]] != null && sp[n[0]] ? 0 : 1);
	});
	return o;
}

function parse_BrtDVal(/*data, length, opts*/) {
}
function parse_BrtDVal14(/*data, length, opts*/) {
}
/* [MS-XLSB] 2.1.7.61 Worksheet */
function parse_ws_bin(data, _opts, idx, rels, wb/*:WBWBProps*/, themes, styles)/*:Worksheet*/ {
	if(!data) return data;
	var opts = _opts || {};
	if(!rels) rels = {'!id':{}};
	var s/*:Worksheet*/ = (opts.dense ? [] : {});

	var ref;
	var refguess = {s: {r:2000000, c:2000000}, e: {r:0, c:0} };
	var pass = false, end = false;
	var row, p, cf, R, C, addr, sstr, rr, cell/*:Cell*/;
	var merges/*:Array<Range>*/ = [];
	opts.biff = 12;
	opts['!row'] = 0;

	var ai = 0, af = false;

	var arrayf/*:Array<[Range, string]>*/ = [];
	var sharedf = {};
	var supbooks = opts.supbooks || /*::(*/wb/*:: :any)*/.supbooks || ([[]]/*:any*/);
	supbooks.sharedf = sharedf;
	supbooks.arrayf = arrayf;
	supbooks.SheetNames = wb.SheetNames || wb.Sheets.map(function(x) { return x.name; });
	if(!opts.supbooks) {
		opts.supbooks = supbooks;
		if(wb.Names) for(var i = 0; i < wb.Names.length; ++i) supbooks[0][i+1] = wb.Names[i];
	}

	var colinfo/*:Array<ColInfo>*/ = [], rowinfo/*:Array<RowInfo>*/ = [];
	var seencol = false;

	XLSBRecordEnum[0x0010] = { n:"BrtShortReal", f:parse_BrtShortReal };

	recordhopper(data, function ws_parse(val, R_n, RT) {
		if(end) return;
		switch(RT) {
			case 0x0094: /* 'BrtWsDim' */
				ref = val; break;
			case 0x0000: /* 'BrtRowHdr' */
				row = val;
				if(opts.sheetRows && opts.sheetRows <= row.r) end=true;
				rr = encode_row(R = row.r);
				opts['!row'] = row.r;
				if(val.hidden || val.hpt || val.level != null) {
					if(val.hpt) val.hpx = pt2px(val.hpt);
					rowinfo[val.r] = val;
				}
				break;

			case 0x0002: /* 'BrtCellRk' */
			case 0x0003: /* 'BrtCellError' */
			case 0x0004: /* 'BrtCellBool' */
			case 0x0005: /* 'BrtCellReal' */
			case 0x0006: /* 'BrtCellSt' */
			case 0x0007: /* 'BrtCellIsst' */
			case 0x0008: /* 'BrtFmlaString' */
			case 0x0009: /* 'BrtFmlaNum' */
			case 0x000A: /* 'BrtFmlaBool' */
			case 0x000B: /* 'BrtFmlaError' */
			case 0x000D: /* 'BrtShortRk' */
			case 0x000E: /* 'BrtShortError' */
			case 0x000F: /* 'BrtShortBool' */
			case 0x0010: /* 'BrtShortReal' */
			case 0x0011: /* 'BrtShortSt' */
			case 0x0012: /* 'BrtShortIsst' */
			case 0x003E: /* 'BrtCellRString' */
				p = ({t:val[2]}/*:any*/);
				switch(val[2]) {
					case 'n': p.v = val[1]; break;
					case 's': sstr = strs[val[1]]; p.v = sstr.t; p.r = sstr.r; break;
					case 'b': p.v = val[1] ? true : false; break;
					case 'e': p.v = val[1]; if(opts.cellText !== false) p.w = BErr[p.v]; break;
					case 'str': p.t = 's'; p.v = val[1]; break;
					case 'is': p.t = 's'; p.v = val[1].t; break;
				}
				if((cf = styles.CellXf[val[0].iStyleRef])) safe_format(p,cf.numFmtId,null,opts, themes, styles);
				C = val[0].c == -1 ? C + 1 : val[0].c;
				if(opts.dense) { if(!s[R]) s[R] = []; s[R][C] = p; }
				else s[encode_col(C) + rr] = p;
				if(opts.cellFormula) {
					af = false;
					for(ai = 0; ai < arrayf.length; ++ai) {
						var aii = arrayf[ai];
						if(row.r >= aii[0].s.r && row.r <= aii[0].e.r)
							if(C >= aii[0].s.c && C <= aii[0].e.c) {
								p.F = encode_range(aii[0]); af = true;
							}
					}
					if(!af && val.length > 3) p.f = val[3];
				}
				if(refguess.s.r > row.r) refguess.s.r = row.r;
				if(refguess.s.c > C) refguess.s.c = C;
				if(refguess.e.r < row.r) refguess.e.r = row.r;
				if(refguess.e.c < C) refguess.e.c = C;
				if(opts.cellDates && cf && p.t == 'n' && SSF.is_date(SSF._table[cf.numFmtId])) {
					var _d = SSF.parse_date_code(p.v); if(_d) { p.t = 'd'; p.v = new Date(_d.y, _d.m-1,_d.d,_d.H,_d.M,_d.S,_d.u); }
				}
				break;

			case 0x0001: /* 'BrtCellBlank' */
			case 0x000C: /* 'BrtShortBlank' */
				if(!opts.sheetStubs || pass) break;
				p = ({t:'z',v:undefined}/*:any*/);
				C = val[0].c == -1 ? C + 1 : val[0].c;
				if(opts.dense) { if(!s[R]) s[R] = []; s[R][C] = p; }
				else s[encode_col(C) + rr] = p;
				if(refguess.s.r > row.r) refguess.s.r = row.r;
				if(refguess.s.c > C) refguess.s.c = C;
				if(refguess.e.r < row.r) refguess.e.r = row.r;
				if(refguess.e.c < C) refguess.e.c = C;
				break;

			case 0x00B0: /* 'BrtMergeCell' */
				merges.push(val); break;

			case 0x01EE: /* 'BrtHLink' */
				var rel = rels['!id'][val.relId];
				if(rel) {
					val.Target = rel.Target;
					if(val.loc) val.Target += "#"+val.loc;
					val.Rel = rel;
				} else if(val.relId == '') {
					val.Target = "#" + val.loc;
				}
				for(R=val.rfx.s.r;R<=val.rfx.e.r;++R) for(C=val.rfx.s.c;C<=val.rfx.e.c;++C) {
					if(opts.dense) {
						if(!s[R]) s[R] = [];
						if(!s[R][C]) s[R][C] = {t:'z',v:undefined};
						s[R][C].l = val;
					} else {
						addr = encode_cell({c:C,r:R});
						if(!s[addr]) s[addr] = {t:'z',v:undefined};
						s[addr].l = val;
					}
				}
				break;

			case 0x01AA: /* 'BrtArrFmla' */
				if(!opts.cellFormula) break;
				arrayf.push(val);
				cell = ((opts.dense ? s[R][C] : s[encode_col(C) + rr])/*:any*/);
				cell.f = stringify_formula(val[1], refguess, {r:row.r, c:C}, supbooks, opts);
				cell.F = encode_range(val[0]);
				break;
			case 0x01AB: /* 'BrtShrFmla' */
				if(!opts.cellFormula) break;
				sharedf[encode_cell(val[0].s)] = val[1];
				cell = (opts.dense ? s[R][C] : s[encode_col(C) + rr]);
				cell.f = stringify_formula(val[1], refguess, {r:row.r, c:C}, supbooks, opts);
				break;

			/* identical to 'ColInfo' in XLS */
			case 0x003C: /* 'BrtColInfo' */
				if(!opts.cellStyles) break;
				while(val.e >= val.s) {
					colinfo[val.e--] = { width: val.w/256, hidden: !!(val.flags & 0x01), level: val.level };
					if(!seencol) { seencol = true; find_mdw_colw(val.w/256); }
					process_col(colinfo[val.e+1]);
				}
				break;

			case 0x00A1: /* 'BrtBeginAFilter' */
				s['!autofilter'] = { ref:encode_range(val) };
				break;

			case 0x01DC: /* 'BrtMargins' */
				s['!margins'] = val;
				break;

			case 0x0093: /* 'BrtWsProp' */
				if(!wb.Sheets[idx]) wb.Sheets[idx] = {};
				if(val.name) wb.Sheets[idx].CodeName = val.name;
				if(val.above || val.left) s['!outline'] = { above: val.above, left: val.left };
				break;

			case 0x0089: /* 'BrtBeginWsView' */
				if(!wb.Views) wb.Views = [{}];
				if(!wb.Views[0]) wb.Views[0] = {};
				if(val.RTL) wb.Views[0].RTL = true;
				break;

			case 0x01E5: /* 'BrtWsFmtInfo' */
				break;

			case 0x0040: /* 'BrtDVal' */
			case 0x041D: /* 'BrtDVal14' */
				break;

			case 0x0097: /* 'BrtPane' */
				break;
			case 0x0098: /* 'BrtSel' */
			case 0x00AF: /* 'BrtAFilterDateGroupItem' */
			case 0x0284: /* 'BrtActiveX' */
			case 0x0271: /* 'BrtBigName' */
			case 0x0232: /* 'BrtBkHim' */
			case 0x018C: /* 'BrtBrk' */
			case 0x0458: /* 'BrtCFIcon' */
			case 0x047A: /* 'BrtCFRuleExt' */
			case 0x01D7: /* 'BrtCFVO' */
			case 0x041A: /* 'BrtCFVO14' */
			case 0x0289: /* 'BrtCellIgnoreEC' */
			case 0x0451: /* 'BrtCellIgnoreEC14' */
			case 0x0031: /* 'BrtCellMeta' */
			case 0x024D: /* 'BrtCellSmartTagProperty' */
			case 0x025F: /* 'BrtCellWatch' */
			case 0x0234: /* 'BrtColor' */
			case 0x041F: /* 'BrtColor14' */
			case 0x00A8: /* 'BrtColorFilter' */
			case 0x00AE: /* 'BrtCustomFilter' */
			case 0x049C: /* 'BrtCustomFilter14' */
			case 0x01F3: /* 'BrtDRef' */
			case 0x01FB: /* 'BrtDXF' */
			case 0x0226: /* 'BrtDrawing' */
			case 0x00AB: /* 'BrtDynamicFilter' */
			case 0x00A7: /* 'BrtFilter' */
			case 0x0499: /* 'BrtFilter14' */
			case 0x00A9: /* 'BrtIconFilter' */
			case 0x049D: /* 'BrtIconFilter14' */
			case 0x0227: /* 'BrtLegacyDrawing' */
			case 0x0228: /* 'BrtLegacyDrawingHF' */
			case 0x0295: /* 'BrtListPart' */
			case 0x027F: /* 'BrtOleObject' */
			case 0x01DE: /* 'BrtPageSetup' */
			case 0x0219: /* 'BrtPhoneticInfo' */
			case 0x01DD: /* 'BrtPrintOptions' */
			case 0x0218: /* 'BrtRangeProtection' */
			case 0x044F: /* 'BrtRangeProtection14' */
			case 0x02A8: /* 'BrtRangeProtectionIso' */
			case 0x0450: /* 'BrtRangeProtectionIso14' */
			case 0x0400: /* 'BrtRwDescent' */
			case 0x0297: /* 'BrtSheetCalcProp' */
			case 0x0217: /* 'BrtSheetProtection' */
			case 0x02A6: /* 'BrtSheetProtectionIso' */
			case 0x01F8: /* 'BrtSlc' */
			case 0x0413: /* 'BrtSparkline' */
			case 0x01AC: /* 'BrtTable' */
			case 0x00AA: /* 'BrtTop10Filter' */
			case 0x0C00: /* 'BrtUid' */
			case 0x0032: /* 'BrtValueMeta' */
			case 0x0816: /* 'BrtWebExtension' */
			case 0x0415: /* 'BrtWsFmtInfoEx14' */
				break;

			case 0x0023: /* 'BrtFRTBegin' */
				pass = true; break;
			case 0x0024: /* 'BrtFRTEnd' */
				pass = false; break;
			case 0x0025: /* 'BrtACBegin' */
 pass = true; break;
			case 0x0026: /* 'BrtACEnd' */
 pass = false; break;

			default:
				if((R_n||"").indexOf("Begin") > 0);
				else if((R_n||"").indexOf("End") > 0);
				else if(!pass || opts.WTF) throw new Error("Unexpected record " + RT + " " + R_n);
		}
	}, opts);

	delete opts.supbooks;
	delete opts['!row'];

	if(!s["!ref"] && (refguess.s.r < 2000000 || ref && (ref.e.r > 0 || ref.e.c > 0 || ref.s.r > 0 || ref.s.c > 0))) s["!ref"] = encode_range(ref || refguess);
	if(opts.sheetRows && s["!ref"]) {
		var tmpref = safe_decode_range(s["!ref"]);
		if(opts.sheetRows <= +tmpref.e.r) {
			tmpref.e.r = opts.sheetRows - 1;
			if(tmpref.e.r > refguess.e.r) tmpref.e.r = refguess.e.r;
			if(tmpref.e.r < tmpref.s.r) tmpref.s.r = tmpref.e.r;
			if(tmpref.e.c > refguess.e.c) tmpref.e.c = refguess.e.c;
			if(tmpref.e.c < tmpref.s.c) tmpref.s.c = tmpref.e.c;
			s["!fullref"] = s["!ref"];
			s["!ref"] = encode_range(tmpref);
		}
	}
	if(merges.length > 0) s["!merges"] = merges;
	if(colinfo.length > 0) s["!cols"] = colinfo;
	if(rowinfo.length > 0) s["!rows"] = rowinfo;
	return s;
}

/* TODO: something useful -- this is a stub */
function write_ws_bin_cell(ba/*:BufArray*/, cell/*:Cell*/, R/*:number*/, C/*:number*/, opts, ws/*:Worksheet*/, last_seen/*:boolean*/)/*:boolean*/ {
	if(cell.v === undefined) return false;
	var vv = "";
	switch(cell.t) {
		case 'b': vv = cell.v ? "1" : "0"; break;
		case 'd': // no BrtCellDate :(
			cell = dup(cell);
			cell.z = cell.z || SSF._table[14];
			cell.v = datenum(parseDate(cell.v)); cell.t = 'n';
			break;
		/* falls through */
		case 'n': case 'e': vv = ''+cell.v; break;
		default: vv = cell.v; break;
	}
	var o/*:any*/ = ({r:R, c:C}/*:any*/);
	/* TODO: cell style */
	o.s = get_cell_style(opts.cellXfs, cell, opts);
	if(cell.l) ws['!links'].push([encode_cell(o), cell.l]);
	if(cell.c) ws['!comments'].push([encode_cell(o), cell.c]);
	switch(cell.t) {
		case 's': case 'str':
			if(opts.bookSST) {
				vv = get_sst_id(opts.Strings, (cell.v/*:any*/), opts.revStrings);
				o.t = "s"; o.v = vv;
				if(last_seen) write_record(ba, "BrtShortIsst", write_BrtShortIsst(cell, o));
				else write_record(ba, "BrtCellIsst", write_BrtCellIsst(cell, o));
			} else {
				o.t = "str";
				if(last_seen) write_record(ba, "BrtShortSt", write_BrtShortSt(cell, o));
				else write_record(ba, "BrtCellSt", write_BrtCellSt(cell, o));
			}
			return true;
		case 'n':
			/* TODO: determine threshold for Real vs RK */
			if(cell.v == (cell.v | 0) && cell.v > -1000 && cell.v < 1000) {
				if(last_seen) write_record(ba, "BrtShortRk", write_BrtShortRk(cell, o));
				else write_record(ba, "BrtCellRk", write_BrtCellRk(cell, o));
			} else {
				if(last_seen) write_record(ba, "BrtShortReal", write_BrtShortReal(cell, o));
				else write_record(ba, "BrtCellReal", write_BrtCellReal(cell, o));
			} return true;
		case 'b':
			o.t = "b";
			if(last_seen) write_record(ba, "BrtShortBool", write_BrtShortBool(cell, o));
			else write_record(ba, "BrtCellBool", write_BrtCellBool(cell, o));
			return true;
		case 'e':
			o.t = "e";
			if(last_seen) write_record(ba, "BrtShortError", write_BrtShortError(cell, o));
			else write_record(ba, "BrtCellError", write_BrtCellError(cell, o));
			return true;
	}
	if(last_seen) write_record(ba, "BrtShortBlank", write_BrtShortBlank(cell, o));
	else write_record(ba, "BrtCellBlank", write_BrtCellBlank(cell, o));
	return true;
}

function write_CELLTABLE(ba, ws/*:Worksheet*/, idx/*:number*/, opts/*::, wb:Workbook*/) {
	var range = safe_decode_range(ws['!ref'] || "A1"), ref, rr = "", cols/*:Array<string>*/ = [];
	write_record(ba, 'BrtBeginSheetData');
	var dense = Array.isArray(ws);
	var cap = range.e.r;
	if(ws['!rows']) cap = Math.max(range.e.r, ws['!rows'].length - 1);
	for(var R = range.s.r; R <= cap; ++R) {
		rr = encode_row(R);
		/* [ACCELLTABLE] */
		/* BrtRowHdr */
		write_row_header(ba, ws, range, R);
		var last_seen = false;
		if(R <= range.e.r) for(var C = range.s.c; C <= range.e.c; ++C) {
			/* *16384CELL */
			if(R === range.s.r) cols[C] = encode_col(C);
			ref = cols[C] + rr;
			var cell = dense ? (ws[R]||[])[C] : ws[ref];
			if(!cell) { last_seen = false; continue; }
			/* write cell */
			last_seen = write_ws_bin_cell(ba, cell, R, C, opts, ws, last_seen);
		}
	}
	write_record(ba, 'BrtEndSheetData');
}

function write_MERGECELLS(ba, ws/*:Worksheet*/) {
	if(!ws || !ws['!merges']) return;
	write_record(ba, 'BrtBeginMergeCells', write_BrtBeginMergeCells(ws['!merges'].length));
	ws['!merges'].forEach(function(m) { write_record(ba, 'BrtMergeCell', write_BrtMergeCell(m)); });
	write_record(ba, 'BrtEndMergeCells');
}

function write_COLINFOS(ba, ws/*:Worksheet*//*::, idx:number, opts, wb:Workbook*/) {
	if(!ws || !ws['!cols']) return;
	write_record(ba, 'BrtBeginColInfos');
	ws['!cols'].forEach(function(m, i) { if(m) write_record(ba, 'BrtColInfo', write_BrtColInfo(i, m)); });
	write_record(ba, 'BrtEndColInfos');
}

function write_IGNOREECS(ba, ws/*:Worksheet*/) {
	if(!ws || !ws['!ref']) return;
	write_record(ba, 'BrtBeginCellIgnoreECs');
	write_record(ba, 'BrtCellIgnoreEC', write_BrtCellIgnoreEC(safe_decode_range(ws['!ref'])));
	write_record(ba, 'BrtEndCellIgnoreECs');
}

function write_HLINKS(ba, ws/*:Worksheet*/, rels) {
	/* *BrtHLink */
	ws['!links'].forEach(function(l) {
		if(!l[1].Target) return;
		var rId = add_rels(rels, -1, l[1].Target.replace(/#.*$/, ""), RELS.HLINK);
		write_record(ba, "BrtHLink", write_BrtHLink(l, rId));
	});
	delete ws['!links'];
}
function write_LEGACYDRAWING(ba, ws/*:Worksheet*/, idx/*:number*/, rels) {
	/* [BrtLegacyDrawing] */
	if(ws['!comments'].length > 0) {
		var rId = add_rels(rels, -1, "../drawings/vmlDrawing" + (idx+1) + ".vml", RELS.VML);
		write_record(ba, "BrtLegacyDrawing", write_RelID("rId" + rId));
		ws['!legacy'] = rId;
	}
}

function write_AUTOFILTER(ba, ws, wb, idx) {
	if(!ws['!autofilter']) return;
	var data = ws['!autofilter'];
	var ref = typeof data.ref === "string" ? data.ref : encode_range(data.ref);

	/* Update FilterDatabase defined name for the worksheet */
	if(!wb.Workbook) wb.Workbook = ({Sheets:[]}/*:any*/);
	if(!wb.Workbook.Names) wb.Workbook.Names = [];
	var names/*: Array<any> */ = wb.Workbook.Names;
	var range = decode_range(ref);
	if(range.s.r == range.e.r) { range.e.r = decode_range(ws["!ref"]).e.r; ref = encode_range(range); }
	for(var i = 0; i < names.length; ++i) {
		var name = names[i];
		if(name.Name != '_xlnm._FilterDatabase') continue;
		if(name.Sheet != idx) continue;
		name.Ref = "'" + wb.SheetNames[idx] + "'!" + ref; break;
	}
	if(i == names.length) names.push({ Name: '_xlnm._FilterDatabase', Sheet: idx, Ref: "'" + wb.SheetNames[idx] + "'!" + ref  });

	write_record(ba, "BrtBeginAFilter", write_UncheckedRfX(safe_decode_range(ref)));
	/* *FILTERCOLUMN */
	/* [SORTSTATE] */
	/* BrtEndAFilter */
	write_record(ba, "BrtEndAFilter");
}

function write_WSVIEWS2(ba, ws, Workbook) {
	write_record(ba, "BrtBeginWsViews");
	{ /* 1*WSVIEW2 */
		/* [ACUID] */
		write_record(ba, "BrtBeginWsView", write_BrtBeginWsView(ws, Workbook));
		/* [BrtPane] */
		/* *4BrtSel */
		/* *4SXSELECT */
		/* *FRT */
		write_record(ba, "BrtEndWsView");
	}
	/* *FRT */
	write_record(ba, "BrtEndWsViews");
}

function write_SHEETPROTECT(ba, ws) {
	if(!ws['!protect']) return;
	/* [BrtSheetProtectionIso] */
	write_record(ba, "BrtSheetProtection", write_BrtSheetProtection(ws['!protect']));
}

function write_ws_bin(idx/*:number*/, opts, wb/*:Workbook*/, rels) {
	var ba = buf_array();
	var s = wb.SheetNames[idx], ws = wb.Sheets[s] || {};
	var c/*:string*/ = s; try { if(wb && wb.Workbook) c = wb.Workbook.Sheets[idx].CodeName || c; } catch(e) {}
	var r = safe_decode_range(ws['!ref'] || "A1");
	if(r.e.c > 0x3FFF || r.e.r > 0xFFFFF) {
		if(opts.WTF) throw new Error("Range " + (ws['!ref'] || "A1") + " exceeds format limit A1:XFD1048576");
		r.e.c = Math.min(r.e.c, 0x3FFF);
		r.e.r = Math.min(r.e.c, 0xFFFFF);
	}
	ws['!links'] = [];
	/* passed back to write_zip and removed there */
	ws['!comments'] = [];
	write_record(ba, "BrtBeginSheet");
	if(wb.vbaraw || ws['!outline']) write_record(ba, "BrtWsProp", write_BrtWsProp(c, ws['!outline']));
	write_record(ba, "BrtWsDim", write_BrtWsDim(r));
	write_WSVIEWS2(ba, ws, wb.Workbook);
	write_COLINFOS(ba, ws);
	write_CELLTABLE(ba, ws, idx, opts);
	/* [BrtSheetCalcProp] */
	write_SHEETPROTECT(ba, ws);
	/* *([BrtRangeProtectionIso] BrtRangeProtection) */
	/* [SCENMAN] */
	write_AUTOFILTER(ba, ws, wb, idx);
	/* [SORTSTATE] */
	/* [DCON] */
	/* [USERSHVIEWS] */
	write_MERGECELLS(ba, ws);
	/* [BrtPhoneticInfo] */
	/* *CONDITIONALFORMATTING */
	/* [DVALS] */
	write_HLINKS(ba, ws, rels);
	/* [BrtPrintOptions] */
	if(ws['!margins']) write_record(ba, "BrtMargins", write_BrtMargins(ws['!margins']));
	/* [BrtPageSetup] */
	/* [HEADERFOOTER] */
	/* [RWBRK] */
	/* [COLBRK] */
	/* *BrtBigName */
	/* [CELLWATCHES] */
	if(!opts || opts.ignoreEC || (opts.ignoreEC == (void 0))) write_IGNOREECS(ba, ws);
	/* [SMARTTAGS] */
	/* [BrtDrawing] */
	write_LEGACYDRAWING(ba, ws, idx, rels);
	/* [BrtLegacyDrawingHF] */
	/* [BrtBkHim] */
	/* [OLEOBJECTS] */
	/* [ACTIVEXCONTROLS] */
	/* [WEBPUBITEMS] */
	/* [LISTPARTS] */
	/* FRTWORKSHEET */
	write_record(ba, "BrtEndSheet");
	return ba.end();
}
RELS.CHART = "http://schemas.openxmlformats.org/officeDocument/2006/relationships/chart";
RELS.CHARTEX = "http://schemas.microsoft.com/office/2014/relationships/chartEx";

function parse_Cache(data/*:string*/)/*:[Array<number|string>, string, ?string]*/ {
	var col/*:Array<number|string>*/ = [];
	var num = data.match(/^<c:numCache>/);
	var f;

	/* 21.2.2.150 pt CT_NumVal */
	(data.match(/<c:pt idx="(\d*)">(.*?)<\/c:pt>/mg)||[]).forEach(function(pt) {
		var q = pt.match(/<c:pt idx="(\d*?)"><c:v>(.*)<\/c:v><\/c:pt>/);
		if(!q) return;
		col[+q[1]] = num ? +q[2] : q[2];
	});

	/* 21.2.2.71 formatCode CT_Xstring */
	var nf = unescapexml((data.match(/<c:formatCode>([\s\S]*?)<\/c:formatCode>/) || ["","General"])[1]);

	(data.match(/<c:f>(.*?)<\/c:f>/mg)||[]).forEach(function(F) { f = F.replace(/<.*?>/g,""); });

	return [col, nf, f];
}

/* 21.2 DrawingML - Charts */
function parse_chart(data/*:?string*/, name/*:string*/, opts, rels, wb, csheet) {
	var cs/*:Worksheet*/ = ((csheet || {"!type":"chart"})/*:any*/);
	if(!data) return csheet;
	/* 21.2.2.27 chart CT_Chart */

	var C = 0, R = 0, col = "A";
	var refguess = {s: {r:2000000, c:2000000}, e: {r:0, c:0} };

	/* 21.2.2.120 numCache CT_NumData */
	(data.match(/<c:numCache>[\s\S]*?<\/c:numCache>/gm)||[]).forEach(function(nc) {
		var cache = parse_Cache(nc);
		refguess.s.r = refguess.s.c = 0;
		refguess.e.c = C;
		col = encode_col(C);
		cache[0].forEach(function(n,i) {
			cs[col + encode_row(i)] = {t:'n', v:n, z:cache[1] };
			R = i;
		});
		if(refguess.e.r < R) refguess.e.r = R;
		++C;
	});
	if(C > 0) cs["!ref"] = encode_range(refguess);
	return cs;
}
RELS.CS = "http://schemas.openxmlformats.org/officeDocument/2006/relationships/chartsheet";

var CS_XML_ROOT = writextag('chartsheet', null, {
	'xmlns': XMLNS.main[0],
	'xmlns:r': XMLNS.r
});

/* 18.3 Worksheets also covers Chartsheets */
function parse_cs_xml(data/*:?string*/, opts, idx/*:number*/, rels, wb/*::, themes, styles*/)/*:Worksheet*/ {
	if(!data) return data;
	/* 18.3.1.12 chartsheet CT_ChartSheet */
	if(!rels) rels = {'!id':{}};
	var s = ({'!type':"chart", '!drawel':null, '!rel':""}/*:any*/);
	var m;

	/* 18.3.1.83 sheetPr CT_ChartsheetPr */
	var sheetPr = data.match(sheetprregex);
	if(sheetPr) parse_ws_xml_sheetpr(sheetPr[0], s, wb, idx);

	/* 18.3.1.36 drawing CT_Drawing */
	if((m = data.match(/drawing r:id="(.*?)"/))) s['!rel'] = m[1];

	if(rels['!id'][s['!rel']]) s['!drawel'] = rels['!id'][s['!rel']];
	return s;
}

/* [MS-XLSB] 2.4.331 BrtCsProp */
function parse_BrtCsProp(data, length/*:number*/) {
	data.l += 10;
	var name = parse_XLWideString(data);
	return { name: name };
}

/* [MS-XLSB] 2.1.7.7 Chart Sheet */
function parse_cs_bin(data, opts, idx/*:number*/, rels, wb/*::, themes, styles*/)/*:Worksheet*/ {
	if(!data) return data;
	if(!rels) rels = {'!id':{}};
	var s = {'!type':"chart", '!drawel':null, '!rel':""};
	var pass = false;
	recordhopper(data, function cs_parse(val, R_n, RT) {
		switch(RT) {

			case 0x0226: /* 'BrtDrawing' */
				s['!rel'] = val; break;

			case 0x028B: /* 'BrtCsProp' */
				if(!wb.Sheets[idx]) wb.Sheets[idx] = {};
				if(val.name) wb.Sheets[idx].CodeName = val.name;
				break;

			case 0x0232: /* 'BrtBkHim' */
			case 0x028C: /* 'BrtCsPageSetup' */
			case 0x029D: /* 'BrtCsProtection' */
			case 0x02A7: /* 'BrtCsProtectionIso' */
			case 0x0227: /* 'BrtLegacyDrawing' */
			case 0x0228: /* 'BrtLegacyDrawingHF' */
			case 0x01DC: /* 'BrtMargins' */
			case 0x0C00: /* 'BrtUid' */
				break;

			case 0x0023: /* 'BrtFRTBegin' */
				pass = true; break;
			case 0x0024: /* 'BrtFRTEnd' */
				pass = false; break;
			case 0x0025: /* 'BrtACBegin' */
 break;
			case 0x0026: /* 'BrtACEnd' */
 break;

			default:
				if((R_n||"").indexOf("Begin") > 0) ;
				else if((R_n||"").indexOf("End") > 0) ;
				else if(!pass || opts.WTF) throw new Error("Unexpected record " + RT + " " + R_n);
		}
	}, opts);

	if(rels['!id'][s['!rel']]) s['!drawel'] = rels['!id'][s['!rel']];
	return s;
}
/* 18.2.28 (CT_WorkbookProtection) Defaults */
var WBPropsDef = [
	['allowRefreshQuery',           false, "bool"],
	['autoCompressPictures',        true,  "bool"],
	['backupFile',                  false, "bool"],
	['checkCompatibility',          false, "bool"],
	['CodeName',                    ''],
	['date1904',                    false, "bool"],
	['defaultThemeVersion',         0,      "int"],
	['filterPrivacy',               false, "bool"],
	['hidePivotFieldList',          false, "bool"],
	['promptedSolutions',           false, "bool"],
	['publishItems',                false, "bool"],
	['refreshAllConnections',       false, "bool"],
	['saveExternalLinkValues',      true,  "bool"],
	['showBorderUnselectedTables',  true,  "bool"],
	['showInkAnnotation',           true,  "bool"],
	['showObjects',                 'all'],
	['showPivotChartFilter',        false, "bool"],
	['updateLinks', 'userSet']
];

/* 18.2.30 (CT_BookView) Defaults */
var WBViewDef = [
	['activeTab',                   0,      "int"],
	['autoFilterDateGrouping',      true,  "bool"],
	['firstSheet',                  0,      "int"],
	['minimized',                   false, "bool"],
	['showHorizontalScroll',        true,  "bool"],
	['showSheetTabs',               true,  "bool"],
	['showVerticalScroll',          true,  "bool"],
	['tabRatio',                    600,    "int"],
	['visibility',                  'visible']
	//window{Height,Width}, {x,y}Window
];

/* 18.2.19 (CT_Sheet) Defaults */
var SheetDef = [
	//['state', 'visible']
];

/* 18.2.2  (CT_CalcPr) Defaults */
var CalcPrDef = [
	['calcCompleted', 'true'],
	['calcMode', 'auto'],
	['calcOnSave', 'true'],
	['concurrentCalc', 'true'],
	['fullCalcOnLoad', 'false'],
	['fullPrecision', 'true'],
	['iterate', 'false'],
	['iterateCount', '100'],
	['iterateDelta', '0.001'],
	['refMode', 'A1']
];

/* 18.2.3 (CT_CustomWorkbookView) Defaults */
/*var CustomWBViewDef = [
	['autoUpdate', 'false'],
	['changesSavedWin', 'false'],
	['includeHiddenRowCol', 'true'],
	['includePrintSettings', 'true'],
	['maximized', 'false'],
	['minimized', 'false'],
	['onlySync', 'false'],
	['personalView', 'false'],
	['showComments', 'commIndicator'],
	['showFormulaBar', 'true'],
	['showHorizontalScroll', 'true'],
	['showObjects', 'all'],
	['showSheetTabs', 'true'],
	['showStatusbar', 'true'],
	['showVerticalScroll', 'true'],
	['tabRatio', '600'],
	['xWindow', '0'],
	['yWindow', '0']
];*/

function push_defaults_array(target, defaults) {
	for(var j = 0; j != target.length; ++j) { var w = target[j];
		for(var i=0; i != defaults.length; ++i) { var z = defaults[i];
			if(w[z[0]] == null) w[z[0]] = z[1];
			else switch(z[2]) {
			case "bool": if(typeof w[z[0]] == "string") w[z[0]] = parsexmlbool(w[z[0]]); break;
			case "int": if(typeof w[z[0]] == "string") w[z[0]] = parseInt(w[z[0]], 10); break;
			}
		}
	}
}
function push_defaults(target, defaults) {
	for(var i = 0; i != defaults.length; ++i) { var z = defaults[i];
		if(target[z[0]] == null) target[z[0]] = z[1];
		else switch(z[2]) {
			case "bool": if(typeof target[z[0]] == "string") target[z[0]] = parsexmlbool(target[z[0]]); break;
			case "int": if(typeof target[z[0]] == "string") target[z[0]] = parseInt(target[z[0]], 10); break;
		}
	}
}

function parse_wb_defaults(wb) {
	push_defaults(wb.WBProps, WBPropsDef);
	push_defaults(wb.CalcPr, CalcPrDef);

	push_defaults_array(wb.WBView, WBViewDef);
	push_defaults_array(wb.Sheets, SheetDef);

	_ssfopts.date1904 = parsexmlbool(wb.WBProps.date1904);
}

function safe1904(wb/*:Workbook*/)/*:string*/ {
	/* TODO: store date1904 somewhere else */
	if(!wb.Workbook) return "false";
	if(!wb.Workbook.WBProps) return "false";
	return parsexmlbool(wb.Workbook.WBProps.date1904) ? "true" : "false";
}

var badchars = "][*?\/\\".split("");
function check_ws_name(n/*:string*/, safe/*:?boolean*/)/*:boolean*/ {
	if(n.length > 31) { if(safe) return false; throw new Error("Sheet names cannot exceed 31 chars"); }
	var _good = true;
	badchars.forEach(function(c) {
		if(n.indexOf(c) == -1) return;
		if(!safe) throw new Error("Sheet name cannot contain : \\ / ? * [ ]");
		_good = false;
	});
	return _good;
}
function check_wb_names(N, S, codes) {
	N.forEach(function(n,i) {
		check_ws_name(n);
		for(var j = 0; j < i; ++j) if(n == N[j]) throw new Error("Duplicate Sheet Name: " + n);
		if(codes) {
			var cn = (S && S[i] && S[i].CodeName) || n;
			if(cn.charCodeAt(0) == 95 && cn.length > 22) throw new Error("Bad Code Name: Worksheet" + cn);
		}
	});
}
function check_wb(wb) {
	if(!wb || !wb.SheetNames || !wb.Sheets) throw new Error("Invalid Workbook");
	if(!wb.SheetNames.length) throw new Error("Workbook is empty");
	var Sheets = (wb.Workbook && wb.Workbook.Sheets) || [];
	check_wb_names(wb.SheetNames, Sheets, !!wb.vbaraw);
	for(var i = 0; i < wb.SheetNames.length; ++i) check_ws(wb.Sheets[wb.SheetNames[i]], wb.SheetNames[i], i);
	/* TODO: validate workbook */
}
/* 18.2 Workbook */
var wbnsregex = /<\w+:workbook/;
function parse_wb_xml(data, opts)/*:WorkbookFile*/ {
	if(!data) throw new Error("Could not find file");
	var wb = /*::(*/{ AppVersion:{}, WBProps:{}, WBView:[], Sheets:[], CalcPr:{}, Names:[], xmlns: "" }/*::)*/;
	var pass = false, xmlns = "xmlns";
	var dname = {}, dnstart = 0;
	data.replace(tagregex, function xml_wb(x, idx) {
		var y/*:any*/ = parsexmltag(x);
		switch(strip_ns(y[0])) {
			case '<?xml': break;

			/* 18.2.27 workbook CT_Workbook 1 */
			case '<workbook':
				if(x.match(wbnsregex)) xmlns = "xmlns" + x.match(/<(\w+):/)[1];
				wb.xmlns = y[xmlns];
				break;
			case '</workbook>': break;

			/* 18.2.13 fileVersion CT_FileVersion ? */
			case '<fileVersion': delete y[0]; wb.AppVersion = y; break;
			case '<fileVersion/>': case '</fileVersion>': break;

			/* 18.2.12 fileSharing CT_FileSharing ? */
			case '<fileSharing':
				break;
			case '<fileSharing/>': break;

			/* 18.2.28 workbookPr CT_WorkbookPr ? */
			case '<workbookPr':
			case '<workbookPr/>':
				WBPropsDef.forEach(function(w) {
					if(y[w[0]] == null) return;
					switch(w[2]) {
						case "bool": wb.WBProps[w[0]] = parsexmlbool(y[w[0]]); break;
						case "int": wb.WBProps[w[0]] = parseInt(y[w[0]], 10); break;
						default: wb.WBProps[w[0]] = y[w[0]];
					}
				});
				if(y.codeName) wb.WBProps.CodeName = utf8read(y.codeName);
				break;
			case '</workbookPr>': break;

			/* 18.2.29 workbookProtection CT_WorkbookProtection ? */
			case '<workbookProtection':
				break;
			case '<workbookProtection/>': break;

			/* 18.2.1  bookViews CT_BookViews ? */
			case '<bookViews': case '<bookViews>': case '</bookViews>': break;
			/* 18.2.30   workbookView CT_BookView + */
			case '<workbookView': case '<workbookView/>': delete y[0]; wb.WBView.push(y); break;
			case '</workbookView>': break;

			/* 18.2.20 sheets CT_Sheets 1 */
			case '<sheets': case '<sheets>': case '</sheets>': break; // aggregate sheet
			/* 18.2.19   sheet CT_Sheet + */
			case '<sheet':
				switch(y.state) {
					case "hidden": y.Hidden = 1; break;
					case "veryHidden": y.Hidden = 2; break;
					default: y.Hidden = 0;
				}
				delete y.state;
				y.name = unescapexml(utf8read(y.name));
				delete y[0]; wb.Sheets.push(y); break;
			case '</sheet>': break;

			/* 18.2.15 functionGroups CT_FunctionGroups ? */
			case '<functionGroups': case '<functionGroups/>': break;
			/* 18.2.14   functionGroup CT_FunctionGroup + */
			case '<functionGroup': break;

			/* 18.2.9  externalReferences CT_ExternalReferences ? */
			case '<externalReferences': case '</externalReferences>': case '<externalReferences>': break;
			/* 18.2.8    externalReference CT_ExternalReference + */
			case '<externalReference': break;

			/* 18.2.6  definedNames CT_DefinedNames ? */
			case '<definedNames/>': break;
			case '<definedNames>': case '<definedNames': pass=true; break;
			case '</definedNames>': pass=false; break;
			/* 18.2.5    definedName CT_DefinedName + */
			case '<definedName': {
				dname = {};
				dname.Name = utf8read(y.name);
				if(y.comment) dname.Comment = y.comment;
				if(y.localSheetId) dname.Sheet = +y.localSheetId;
				if(parsexmlbool(y.hidden||"0")) dname.Hidden = true;
				dnstart = idx + x.length;
			}	break;
			case '</definedName>': {
				dname.Ref = unescapexml(utf8read(data.slice(dnstart, idx)));
				wb.Names.push(dname);
			} break;
			case '<definedName/>': break;

			/* 18.2.2  calcPr CT_CalcPr ? */
			case '<calcPr': delete y[0]; wb.CalcPr = y; break;
			case '<calcPr/>': delete y[0]; wb.CalcPr = y; break;
			case '</calcPr>': break;

			/* 18.2.16 oleSize CT_OleSize ? (ref required) */
			case '<oleSize': break;

			/* 18.2.4  customWorkbookViews CT_CustomWorkbookViews ? */
			case '<customWorkbookViews>': case '</customWorkbookViews>': case '<customWorkbookViews': break;
			/* 18.2.3  customWorkbookView CT_CustomWorkbookView + */
			case '<customWorkbookView': case '</customWorkbookView>': break;

			/* 18.2.18 pivotCaches CT_PivotCaches ? */
			case '<pivotCaches>': case '</pivotCaches>': case '<pivotCaches': break;
			/* 18.2.17 pivotCache CT_PivotCache ? */
			case '<pivotCache': break;

			/* 18.2.21 smartTagPr CT_SmartTagPr ? */
			case '<smartTagPr': case '<smartTagPr/>': break;

			/* 18.2.23 smartTagTypes CT_SmartTagTypes ? */
			case '<smartTagTypes': case '<smartTagTypes>': case '</smartTagTypes>': break;
			/* 18.2.22 smartTagType CT_SmartTagType ? */
			case '<smartTagType': break;

			/* 18.2.24 webPublishing CT_WebPublishing ? */
			case '<webPublishing': case '<webPublishing/>': break;

			/* 18.2.11 fileRecoveryPr CT_FileRecoveryPr ? */
			case '<fileRecoveryPr': case '<fileRecoveryPr/>': break;

			/* 18.2.26 webPublishObjects CT_WebPublishObjects ? */
			case '<webPublishObjects>': case '<webPublishObjects': case '</webPublishObjects>': break;
			/* 18.2.25 webPublishObject CT_WebPublishObject ? */
			case '<webPublishObject': break;

			/* 18.2.10 extLst CT_ExtensionList ? */
			case '<extLst': case '<extLst>': case '</extLst>': case '<extLst/>': break;
			/* 18.2.7  ext CT_Extension + */
			case '<ext': pass=true; break; //TODO: check with versions of excel
			case '</ext>': pass=false; break;

			/* Others */
			case '<ArchID': break;
			case '<AlternateContent':
			case '<AlternateContent>': pass=true; break;
			case '</AlternateContent>': pass=false; break;

			/* TODO */
			case '<revisionPtr': break;

			default: if(!pass && opts.WTF) throw new Error('unrecognized ' + y[0] + ' in workbook');
		}
		return x;
	});
	if(XMLNS.main.indexOf(wb.xmlns) === -1) throw new Error("Unknown Namespace: " + wb.xmlns);

	parse_wb_defaults(wb);

	return wb;
}

var WB_XML_ROOT = writextag('workbook', null, {
	'xmlns': XMLNS.main[0],
	//'xmlns:mx': XMLNS.mx,
	//'xmlns:s': XMLNS.main[0],
	'xmlns:r': XMLNS.r
});

function write_wb_xml(wb/*:Workbook*//*::, opts:?WriteOpts*/)/*:string*/ {
	var o = [XML_HEADER];
	o[o.length] = WB_XML_ROOT;

	var write_names = (wb.Workbook && (wb.Workbook.Names||[]).length > 0);

	/* fileVersion */
	/* fileSharing */

	var workbookPr/*:any*/ = ({codeName:"ThisWorkbook"}/*:any*/);
	if(wb.Workbook && wb.Workbook.WBProps) {
		WBPropsDef.forEach(function(x) {
			/*:: if(!wb.Workbook || !wb.Workbook.WBProps) throw "unreachable"; */
			if((wb.Workbook.WBProps[x[0]]/*:any*/) == null) return;
			if((wb.Workbook.WBProps[x[0]]/*:any*/) == x[1]) return;
			workbookPr[x[0]] = (wb.Workbook.WBProps[x[0]]/*:any*/);
		});
		/*:: if(!wb.Workbook || !wb.Workbook.WBProps) throw "unreachable"; */
		if(wb.Workbook.WBProps.CodeName) { workbookPr.codeName = wb.Workbook.WBProps.CodeName; delete workbookPr.CodeName; }
	}
	o[o.length] = (writextag('workbookPr', null, workbookPr));

	/* workbookProtection */

	var sheets = wb.Workbook && wb.Workbook.Sheets || [];
	var i = 0;

	/* bookViews only written if first worksheet is hidden */
	if(sheets && sheets[0] && !!sheets[0].Hidden) {
		o[o.length] = "<bookViews>";
		for(i = 0; i != wb.SheetNames.length; ++i) {
			if(!sheets[i]) break;
			if(!sheets[i].Hidden) break;
		}
		if(i == wb.SheetNames.length) i = 0;
		o[o.length] = '<workbookView firstSheet="' + i + '" activeTab="' + i + '"/>';
		o[o.length] = "</bookViews>";
	}

	o[o.length] = "<sheets>";
	for(i = 0; i != wb.SheetNames.length; ++i) {
		var sht = ({name:escapexml(wb.SheetNames[i].slice(0,31))}/*:any*/);
		sht.sheetId = ""+(i+1);
		sht["r:id"] = "rId"+(i+1);
		if(sheets[i]) switch(sheets[i].Hidden) {
			case 1: sht.state = "hidden"; break;
			case 2: sht.state = "veryHidden"; break;
		}
		o[o.length] = (writextag('sheet',null,sht));
	}
	o[o.length] = "</sheets>";

	/* functionGroups */
	/* externalReferences */

	if(write_names) {
		o[o.length] = "<definedNames>";
		if(wb.Workbook && wb.Workbook.Names) wb.Workbook.Names.forEach(function(n) {
			var d/*:any*/ = {name:n.Name};
			if(n.Comment) d.comment = n.Comment;
			if(n.Sheet != null) d.localSheetId = ""+n.Sheet;
			if(n.Hidden) d.hidden = "1";
			if(!n.Ref) return;
			o[o.length] = writextag('definedName', escapexml(n.Ref), d);
		});
		o[o.length] = "</definedNames>";
	}

	/* calcPr */
	/* oleSize */
	/* customWorkbookViews */
	/* pivotCaches */
	/* smartTagPr */
	/* smartTagTypes */
	/* webPublishing */
	/* fileRecoveryPr */
	/* webPublishObjects */
	/* extLst */

	if(o.length>2){ o[o.length] = '</workbook>'; o[1]=o[1].replace("/>",">"); }
	return o.join("");
}
/* [MS-XLSB] 2.4.304 BrtBundleSh */
function parse_BrtBundleSh(data, length/*:number*/) {
	var z = {};
	z.Hidden = data.read_shift(4); //hsState ST_SheetState
	z.iTabID = data.read_shift(4);
	z.strRelID = parse_RelID(data);
	z.name = parse_XLWideString(data);
	return z;
}
function write_BrtBundleSh(data, o) {
	if(!o) o = new_buf(127);
	o.write_shift(4, data.Hidden);
	o.write_shift(4, data.iTabID);
	write_RelID(data.strRelID, o);
	write_XLWideString(data.name.slice(0,31), o);
	return o.length > o.l ? o.slice(0, o.l) : o;
}

/* [MS-XLSB] 2.4.815 BrtWbProp */
function parse_BrtWbProp(data, length)/*:WBProps*/ {
	var o/*:WBProps*/ = ({}/*:any*/);
	var flags = data.read_shift(4);
	o.defaultThemeVersion = data.read_shift(4);
	var strName = (length > 8) ? parse_XLWideString(data) : "";
	if(strName.length > 0) o.CodeName = strName;
	o.autoCompressPictures = !!(flags & 0x10000);
	o.backupFile = !!(flags & 0x40);
	o.checkCompatibility = !!(flags & 0x1000);
	o.date1904 = !!(flags & 0x01);
	o.filterPrivacy = !!(flags & 0x08);
	o.hidePivotFieldList = !!(flags & 0x400);
	o.promptedSolutions = !!(flags & 0x10);
	o.publishItems = !!(flags & 0x800);
	o.refreshAllConnections = !!(flags & 0x40000);
	o.saveExternalLinkValues = !!(flags & 0x80);
	o.showBorderUnselectedTables = !!(flags & 0x04);
	o.showInkAnnotation = !!(flags & 0x20);
	o.showObjects = ["all", "placeholders", "none"][(flags >> 13) & 0x03];
	o.showPivotChartFilter = !!(flags & 0x8000);
	o.updateLinks = ["userSet", "never", "always"][(flags >> 8) & 0x03];
	return o;
}
function write_BrtWbProp(data/*:?WBProps*/, o) {
	if(!o) o = new_buf(72);
	var flags = 0;
	if(data) {
		/* TODO: mirror parse_BrtWbProp fields */
		if(data.filterPrivacy) flags |= 0x08;
	}
	o.write_shift(4, flags);
	o.write_shift(4, 0);
	write_XLSBCodeName(data && data.CodeName || "ThisWorkbook", o);
	return o.slice(0, o.l);
}

function parse_BrtFRTArchID$(data, length) {
	var o = {};
	data.read_shift(4);
	o.ArchID = data.read_shift(4);
	data.l += length - 8;
	return o;
}

/* [MS-XLSB] 2.4.687 BrtName */
function parse_BrtName(data, length, opts) {
	var end = data.l + length;
	data.l += 4; //var flags = data.read_shift(4);
	data.l += 1; //var chKey = data.read_shift(1);
	var itab = data.read_shift(4);
	var name = parse_XLNameWideString(data);
	var formula = parse_XLSBNameParsedFormula(data, 0, opts);
	var comment = parse_XLNullableWideString(data);
	//if(0 /* fProc */) {
		// unusedstring1: XLNullableWideString
		// description: XLNullableWideString
		// helpTopic: XLNullableWideString
		// unusedstring2: XLNullableWideString
	//}
	data.l = end;
	var out = ({Name:name, Ptg:formula}/*:any*/);
	if(itab < 0xFFFFFFF) out.Sheet = itab;
	if(comment) out.Comment = comment;
	return out;
}

/* [MS-XLSB] 2.1.7.61 Workbook */
function parse_wb_bin(data, opts)/*:WorkbookFile*/ {
	var wb = { AppVersion:{}, WBProps:{}, WBView:[], Sheets:[], CalcPr:{}, xmlns: "" };
	var state/*:Array<string>*/ = [];
	var pass = false;

	if(!opts) opts = {};
	opts.biff = 12;

	var Names = [];
	var supbooks = ([[]]/*:any*/);
	supbooks.SheetNames = [];
	supbooks.XTI = [];

	XLSBRecordEnum[0x0010] = { n:"BrtFRTArchID$", f:parse_BrtFRTArchID$ };

	recordhopper(data, function hopper_wb(val, R_n, RT) {
		switch(RT) {
			case 0x009C: /* 'BrtBundleSh' */
				supbooks.SheetNames.push(val.name);
				wb.Sheets.push(val); break;

			case 0x0099: /* 'BrtWbProp' */
				wb.WBProps = val; break;

			case 0x0027: /* 'BrtName' */
				if(val.Sheet != null) opts.SID = val.Sheet;
				val.Ref = stringify_formula(val.Ptg, null, null, supbooks, opts);
				delete opts.SID;
				delete val.Ptg;
				Names.push(val);
				break;
			case 0x040C: /* 'BrtNameExt' */ break;

			case 0x0165: /* 'BrtSupSelf' */
			case 0x0166: /* 'BrtSupSame' */
			case 0x0163: /* 'BrtSupBookSrc' */
			case 0x029B: /* 'BrtSupAddin' */
				if(!supbooks[0].length) supbooks[0] = [RT, val];
				else supbooks.push([RT, val]);
				supbooks[supbooks.length - 1].XTI = [];
				break;
			case 0x016A: /* 'BrtExternSheet' */
				if(supbooks.length === 0) { supbooks[0] = []; supbooks[0].XTI = []; }
				supbooks[supbooks.length - 1].XTI = supbooks[supbooks.length - 1].XTI.concat(val);
				supbooks.XTI = supbooks.XTI.concat(val);
				break;
			case 0x0169: /* 'BrtPlaceholderName' */
				break;

			case 0x0817: /* 'BrtAbsPath15' */
			case 0x009E: /* 'BrtBookView' */
			case 0x008F: /* 'BrtBeginBundleShs' */
			case 0x0298: /* 'BrtBeginFnGroup' */
			case 0x0161: /* 'BrtBeginExternals' */
				break;

			/* case 'BrtModelTimeGroupingCalcCol' */
			case 0x0C00: /* 'BrtUid' */
			case 0x0C01: /* 'BrtRevisionPtr' */
			case 0x0216: /* 'BrtBookProtection' */
			case 0x02A5: /* 'BrtBookProtectionIso' */
			case 0x009D: /* 'BrtCalcProp' */
			case 0x0262: /* 'BrtCrashRecErr' */
			case 0x0802: /* 'BrtDecoupledPivotCacheID' */
			case 0x009B: /* 'BrtFileRecover' */
			case 0x0224: /* 'BrtFileSharing' */
			case 0x02A4: /* 'BrtFileSharingIso' */
			case 0x0080: /* 'BrtFileVersion' */
			case 0x0299: /* 'BrtFnGroup' */
			case 0x0850: /* 'BrtModelRelationship' */
			case 0x084D: /* 'BrtModelTable' */
			case 0x0225: /* 'BrtOleSize' */
			case 0x0805: /* 'BrtPivotTableRef' */
			case 0x0254: /* 'BrtSmartTagType' */
			case 0x081C: /* 'BrtTableSlicerCacheID' */
			case 0x081B: /* 'BrtTableSlicerCacheIDs' */
			case 0x0822: /* 'BrtTimelineCachePivotCacheID' */
			case 0x018D: /* 'BrtUserBookView' */
			case 0x009A: /* 'BrtWbFactoid' */
			case 0x045D: /* 'BrtWbProp14' */
			case 0x0229: /* 'BrtWebOpt' */
			case 0x082B: /* 'BrtWorkBookPr15' */
				break;

			case 0x0023: /* 'BrtFRTBegin' */
				state.push(R_n); pass = true; break;
			case 0x0024: /* 'BrtFRTEnd' */
				state.pop(); pass = false; break;
			case 0x0025: /* 'BrtACBegin' */
				state.push(R_n); pass = true; break;
			case 0x0026: /* 'BrtACEnd' */
				state.pop(); pass = false; break;

			case 0x0010: /* 'BrtFRTArchID$' */ break;

			default:
				if((R_n||"").indexOf("Begin") > 0);
				else if((R_n||"").indexOf("End") > 0);
				else if(!pass || (opts.WTF && state[state.length-1] != "BrtACBegin" && state[state.length-1] != "BrtFRTBegin")) throw new Error("Unexpected record " + RT + " " + R_n);
		}
	}, opts);

	parse_wb_defaults(wb);

	// $FlowIgnore
	wb.Names = Names;

	(wb/*:any*/).supbooks = supbooks;
	return wb;
}

function write_BUNDLESHS(ba, wb/*::, opts*/) {
	write_record(ba, "BrtBeginBundleShs");
	for(var idx = 0; idx != wb.SheetNames.length; ++idx) {
		var viz = wb.Workbook && wb.Workbook.Sheets && wb.Workbook.Sheets[idx] && wb.Workbook.Sheets[idx].Hidden || 0;
		var d = { Hidden: viz, iTabID: idx+1, strRelID: 'rId' + (idx+1), name: wb.SheetNames[idx] };
		write_record(ba, "BrtBundleSh", write_BrtBundleSh(d));
	}
	write_record(ba, "BrtEndBundleShs");
}

/* [MS-XLSB] 2.4.649 BrtFileVersion */
function write_BrtFileVersion(data, o) {
	if(!o) o = new_buf(127);
	for(var i = 0; i != 4; ++i) o.write_shift(4, 0);
	write_XLWideString("SheetJS", o);
	write_XLWideString(XLSX.version, o);
	write_XLWideString(XLSX.version, o);
	write_XLWideString("7262", o);
	return o.length > o.l ? o.slice(0, o.l) : o;
}

/* [MS-XLSB] 2.4.301 BrtBookView */
function write_BrtBookView(idx, o) {
	if(!o) o = new_buf(29);
	o.write_shift(-4, 0);
	o.write_shift(-4, 460);
	o.write_shift(4,  28800);
	o.write_shift(4,  17600);
	o.write_shift(4,  500);
	o.write_shift(4,  idx);
	o.write_shift(4,  idx);
	var flags = 0x78;
	o.write_shift(1,  flags);
	return o.length > o.l ? o.slice(0, o.l) : o;
}

function write_BOOKVIEWS(ba, wb/*::, opts*/) {
	/* required if hidden tab appears before visible tab */
	if(!wb.Workbook || !wb.Workbook.Sheets) return;
	var sheets = wb.Workbook.Sheets;
	var i = 0, vistab = -1, hidden = -1;
	for(; i < sheets.length; ++i) {
		if(!sheets[i] || !sheets[i].Hidden && vistab == -1) vistab = i;
		else if(sheets[i].Hidden == 1 && hidden == -1) hidden = i;
	}
	if(hidden > vistab) return;
	write_record(ba, "BrtBeginBookViews");
	write_record(ba, "BrtBookView", write_BrtBookView(vistab));
	/* 1*(BrtBookView *FRT) */
	write_record(ba, "BrtEndBookViews");
}

/* [MS-XLSB] 2.4.305 BrtCalcProp */
/*function write_BrtCalcProp(data, o) {
	if(!o) o = new_buf(26);
	o.write_shift(4,0); // force recalc
	o.write_shift(4,1);
	o.write_shift(4,0);
	write_Xnum(0, o);
	o.write_shift(-4, 1023);
	o.write_shift(1, 0x33);
	o.write_shift(1, 0x00);
	return o;
}*/

/* [MS-XLSB] 2.4.646 BrtFileRecover */
/*function write_BrtFileRecover(data, o) {
	if(!o) o = new_buf(1);
	o.write_shift(1,0);
	return o;
}*/

/* [MS-XLSB] 2.1.7.61 Workbook */
function write_wb_bin(wb, opts) {
	var ba = buf_array();
	write_record(ba, "BrtBeginBook");
	write_record(ba, "BrtFileVersion", write_BrtFileVersion());
	/* [[BrtFileSharingIso] BrtFileSharing] */
	write_record(ba, "BrtWbProp", write_BrtWbProp(wb.Workbook && wb.Workbook.WBProps || null));
	/* [ACABSPATH] */
	/* [[BrtBookProtectionIso] BrtBookProtection] */
	write_BOOKVIEWS(ba, wb);
	write_BUNDLESHS(ba, wb);
	/* [FNGROUP] */
	/* [EXTERNALS] */
	/* *BrtName */
	/* write_record(ba, "BrtCalcProp", write_BrtCalcProp()); */
	/* [BrtOleSize] */
	/* *(BrtUserBookView *FRT) */
	/* [PIVOTCACHEIDS] */
	/* [BrtWbFactoid] */
	/* [SMARTTAGTYPES] */
	/* [BrtWebOpt] */
	/* write_record(ba, "BrtFileRecover", write_BrtFileRecover()); */
	/* [WEBPUBITEMS] */
	/* [CRERRS] */
	/* FRTWORKBOOK */
	write_record(ba, "BrtEndBook");

	return ba.end();
}
function parse_wb(data, name/*:string*/, opts)/*:WorkbookFile*/ {
	if(name.slice(-4)===".bin") return parse_wb_bin((data/*:any*/), opts);
	return parse_wb_xml((data/*:any*/), opts);
}

function parse_ws(data, name/*:string*/, idx/*:number*/, opts, rels, wb, themes, styles)/*:Worksheet*/ {
	if(name.slice(-4)===".bin") return parse_ws_bin((data/*:any*/), opts, idx, rels, wb, themes, styles);
	return parse_ws_xml((data/*:any*/), opts, idx, rels, wb, themes, styles);
}

function parse_cs(data, name/*:string*/, idx/*:number*/, opts, rels, wb, themes, styles)/*:Worksheet*/ {
	if(name.slice(-4)===".bin") return parse_cs_bin((data/*:any*/), opts, idx, rels, wb);
	return parse_cs_xml((data/*:any*/), opts, idx, rels, wb);
}

function parse_ms(data, name/*:string*/, idx/*:number*/, opts, rels, wb, themes, styles)/*:Worksheet*/ {
	if(name.slice(-4)===".bin") return parse_ms_bin();
	return parse_ms_xml();
}

function parse_ds(data, name/*:string*/, idx/*:number*/, opts, rels, wb, themes, styles)/*:Worksheet*/ {
	if(name.slice(-4)===".bin") return parse_ds_bin();
	return parse_ds_xml();
}

function parse_sty(data, name/*:string*/, themes, opts) {
	if(name.slice(-4)===".bin") return parse_sty_bin((data/*:any*/), themes, opts);
	return parse_sty_xml((data/*:any*/), themes, opts);
}

function parse_theme(data/*:string*/, name/*:string*/, opts) {
	return parse_theme_xml(data, opts);
}

function parse_sst(data, name/*:string*/, opts)/*:SST*/ {
	if(name.slice(-4)===".bin") return parse_sst_bin((data/*:any*/), opts);
	return parse_sst_xml((data/*:any*/), opts);
}

function parse_cmnt(data, name/*:string*/, opts)/*:Array<RawComment>*/ {
	if(name.slice(-4)===".bin") return parse_comments_bin((data/*:any*/), opts);
	return parse_comments_xml((data/*:any*/), opts);
}

function parse_cc(data, name/*:string*/, opts) {
	if(name.slice(-4)===".bin") return parse_cc_bin((data/*:any*/));
	return parse_cc_xml((data/*:any*/));
}

function parse_xlink(data, rel, name/*:string*/, opts) {
	if(name.slice(-4)===".bin") return parse_xlink_bin((data/*:any*/), rel, name, opts);
	return parse_xlink_xml();
}

function write_wb(wb, name/*:string*/, opts) {
	return (name.slice(-4)===".bin" ? write_wb_bin : write_wb_xml)(wb, opts);
}

function write_ws(data/*:number*/, name/*:string*/, opts, wb/*:Workbook*/, rels) {
	return (name.slice(-4)===".bin" ? write_ws_bin : write_ws_xml)(data, opts, wb, rels);
}

function write_sty(data, name/*:string*/, opts) {
	return (name.slice(-4)===".bin" ? write_sty_bin : write_sty_xml)(data, opts);
}

function write_sst(data/*:SST*/, name/*:string*/, opts) {
	return (name.slice(-4)===".bin" ? write_sst_bin : write_sst_xml)(data, opts);
}

function write_cmnt(data/*:Array<any>*/, name/*:string*/, opts) {
	return (name.slice(-4)===".bin" ? write_comments_bin : write_comments_xml)(data, opts);
}
/*
function write_cc(data, name:string, opts) {
	return (name.slice(-4)===".bin" ? write_cc_bin : write_cc_xml)(data, opts);
}
*/
var attregexg2=/([\w:]+)=((?:")([^"]*)(?:")|(?:')([^']*)(?:'))/g;
var attregex2=/([\w:]+)=((?:")(?:[^"]*)(?:")|(?:')(?:[^']*)(?:'))/;
function xlml_parsexmltag(tag/*:string*/, skip_root/*:?boolean*/) {
	var words = tag.split(/\s+/);
	var z/*:any*/ = ([]/*:any*/); if(!skip_root) z[0] = words[0];
	if(words.length === 1) return z;
	var m = tag.match(attregexg2), y, j, w, i;
	if(m) for(i = 0; i != m.length; ++i) {
		y = m[i].match(attregex2);
/*:: if(!y || !y[2]) continue; */
		if((j=y[1].indexOf(":")) === -1) z[y[1]] = y[2].slice(1,y[2].length-1);
		else {
			if(y[1].slice(0,6) === "xmlns:") w = "xmlns"+y[1].slice(6);
			else w = y[1].slice(j+1);
			z[w] = y[2].slice(1,y[2].length-1);
		}
	}
	return z;
}
function xlml_parsexmltagobj(tag/*:string*/) {
	var words = tag.split(/\s+/);
	var z = {};
	if(words.length === 1) return z;
	var m = tag.match(attregexg2), y, j, w, i;
	if(m) for(i = 0; i != m.length; ++i) {
		y = m[i].match(attregex2);
/*:: if(!y || !y[2]) continue; */
		if((j=y[1].indexOf(":")) === -1) z[y[1]] = y[2].slice(1,y[2].length-1);
		else {
			if(y[1].slice(0,6) === "xmlns:") w = "xmlns"+y[1].slice(6);
			else w = y[1].slice(j+1);
			z[w] = y[2].slice(1,y[2].length-1);
		}
	}
	return z;
}

// ----

function xlml_format(format, value)/*:string*/ {
	var fmt = XLMLFormatMap[format] || unescapexml(format);
	if(fmt === "General") return SSF._general(value);
	return SSF.format(fmt, value);
}

function xlml_set_custprop(Custprops, key, cp, val/*:string*/) {
	var oval/*:any*/ = val;
	switch((cp[0].match(/dt:dt="([\w.]+)"/)||["",""])[1]) {
		case "boolean": oval = parsexmlbool(val); break;
		case "i2": case "int": oval = parseInt(val, 10); break;
		case "r4": case "float": oval = parseFloat(val); break;
		case "date": case "dateTime.tz": oval = parseDate(val); break;
		case "i8": case "string": case "fixed": case "uuid": case "bin.base64": break;
		default: throw new Error("bad custprop:" + cp[0]);
	}
	Custprops[unescapexml(key)] = oval;
}

function safe_format_xlml(cell/*:Cell*/, nf, o) {
	if(cell.t === 'z') return;
	if(!o || o.cellText !== false) try {
		if(cell.t === 'e') { cell.w = cell.w || BErr[cell.v]; }
		else if(nf === "General") {
			if(cell.t === 'n') {
				if((cell.v|0) === cell.v) cell.w = SSF._general_int(cell.v);
				else cell.w = SSF._general_num(cell.v);
			}
			else cell.w = SSF._general(cell.v);
		}
		else cell.w = xlml_format(nf||"General", cell.v);
	} catch(e) { if(o.WTF) throw e; }
	try {
		var z = XLMLFormatMap[nf]||nf||"General";
		if(o.cellNF) cell.z = z;
		if(o.cellDates && cell.t == 'n' && SSF.is_date(z)) {
			var _d = SSF.parse_date_code(cell.v); if(_d) { cell.t = 'd'; cell.v = new Date(_d.y, _d.m-1,_d.d,_d.H,_d.M,_d.S,_d.u); }
		}
	} catch(e) { if(o.WTF) throw e; }
}

function process_style_xlml(styles, stag, opts) {
	if(opts.cellStyles) {
		if(stag.Interior) {
			var I = stag.Interior;
			if(I.Pattern) I.patternType = XLMLPatternTypeMap[I.Pattern] || I.Pattern;
		}
	}
	styles[stag.ID] = stag;
}

/* TODO: there must exist some form of OSP-blessed spec */
function parse_xlml_data(xml, ss, data, cell/*:any*/, base, styles, csty, row, arrayf, o) {
	var nf = "General", sid = cell.StyleID, S = {}; o = o || {};
	var interiors = [];
	var i = 0;
	if(sid === undefined && row) sid = row.StyleID;
	if(sid === undefined && csty) sid = csty.StyleID;
	while(styles[sid] !== undefined) {
		if(styles[sid].nf) nf = styles[sid].nf;
		if(styles[sid].Interior) interiors.push(styles[sid].Interior);
		if(!styles[sid].Parent) break;
		sid = styles[sid].Parent;
	}
	switch(data.Type) {
		case 'Boolean':
			cell.t = 'b';
			cell.v = parsexmlbool(xml);
			break;
		case 'String':
			cell.t = 's'; cell.r = xlml_fixstr(unescapexml(xml));
			cell.v = (xml.indexOf("<") > -1 ? unescapexml(ss||xml).replace(/<.*?>/g, "") : cell.r); // todo: BR etc
			break;
		case 'DateTime':
			if(xml.slice(-1) != "Z") xml += "Z";
			cell.v = (parseDate(xml) - new Date(Date.UTC(1899, 11, 30))) / (24 * 60 * 60 * 1000);
			if(cell.v !== cell.v) cell.v = unescapexml(xml);
			else if(cell.v<60) cell.v = cell.v -1;
			if(!nf || nf == "General") nf = "yyyy-mm-dd";
			/* falls through */
		case 'Number':
			if(cell.v === undefined) cell.v=+xml;
			if(!cell.t) cell.t = 'n';
			break;
		case 'Error': cell.t = 'e'; cell.v = RBErr[xml]; if(o.cellText !== false) cell.w = xml; break;
		default:
			if(xml == "" && ss == "") { cell.t = 'z'; }
			else { cell.t = 's'; cell.v = xlml_fixstr(ss||xml); }
			break;
	}
	safe_format_xlml(cell, nf, o);
	if(o.cellFormula !== false) {
		if(cell.Formula) {
			var fstr = unescapexml(cell.Formula);
			/* strictly speaking, the leading = is required but some writers omit */
			if(fstr.charCodeAt(0) == 61 /* = */) fstr = fstr.slice(1);
			cell.f = rc_to_a1(fstr, base);
			delete cell.Formula;
			if(cell.ArrayRange == "RC") cell.F = rc_to_a1("RC:RC", base);
			else if(cell.ArrayRange) {
				cell.F = rc_to_a1(cell.ArrayRange, base);
				arrayf.push([safe_decode_range(cell.F), cell.F]);
			}
		} else {
			for(i = 0; i < arrayf.length; ++i)
				if(base.r >= arrayf[i][0].s.r && base.r <= arrayf[i][0].e.r)
					if(base.c >= arrayf[i][0].s.c && base.c <= arrayf[i][0].e.c)
						cell.F = arrayf[i][1];
		}
	}
	if(o.cellStyles) {
		interiors.forEach(function(x) {
			if(!S.patternType && x.patternType) S.patternType = x.patternType;
		});
		cell.s = S;
	}
	if(cell.StyleID !== undefined) cell.ixfe = cell.StyleID;
}

function xlml_clean_comment(comment/*:any*/) {
	comment.t = comment.v || "";
	comment.t = comment.t.replace(/\r\n/g,"\n").replace(/\r/g,"\n");
	comment.v = comment.w = comment.ixfe = undefined;
}

function xlml_normalize(d)/*:string*/ {
	if(has_buf &&/*::typeof Buffer !== "undefined" && d != null && d instanceof Buffer &&*/ Buffer.isBuffer(d)) return d.toString('utf8');
	if(typeof d === 'string') return d;
	/* duktape */
	if(typeof Uint8Array !== 'undefined' && d instanceof Uint8Array) return utf8read(a2s(ab2a(d)));
	throw new Error("Bad input format: expected Buffer or string");
}

/* TODO: Everything */
/* UOS uses CJK in tags */
var xlmlregex = /<(\/?)([^\s?><!\/:]*:|)([^\s?<>:\/]+)(?:[\s?:\/][^>]*)?>/mg;
//var xlmlregex = /<(\/?)([a-z0-9]*:|)(\w+)[^>]*>/mg;
function parse_xlml_xml(d, _opts)/*:Workbook*/ {
	var opts = _opts || {};
	make_ssf(SSF);
	var str = debom(xlml_normalize(d));
	if(opts.type == 'binary' || opts.type == 'array' || opts.type == 'base64') {
		if(typeof cptable !== 'undefined') str = cptable.utils.decode(65001, char_codes(str));
		else str = utf8read(str);
	}
	var opening = str.slice(0, 1024).toLowerCase(), ishtml = false;
	opening = opening.replace(/".*?"/g, "");
	if((opening.indexOf(">") & 1023) > Math.min((opening.indexOf(",") & 1023), (opening.indexOf(";")&1023))) { var _o = dup(opts); _o.type = "string"; return PRN.to_workbook(str, _o); }
	if(opening.indexOf("<?xml") == -1) ["html", "table", "head", "meta", "script", "style", "div"].forEach(function(tag) { if(opening.indexOf("<" + tag) >= 0) ishtml = true; });
	if(ishtml) return HTML_.to_workbook(str, opts);
	var Rn;
	var state = [], tmp;
	var sheets = {}, sheetnames/*:Array<string>*/ = [], cursheet/*:Worksheet*/ = (opts.dense ? [] : {}), sheetname = "";
	var table = {}, cell = ({}/*:any*/), row = {};// eslint-disable-line no-unused-vars
	var dtag = xlml_parsexmltag('<Data ss:Type="String">'), didx = 0;
	var c = 0, r = 0;
	var refguess/*:Range*/ = {s: {r:2000000, c:2000000}, e: {r:0, c:0} };
	var styles = {}, stag = {};
	var ss = "", fidx = 0;
	var merges/*:Array<Range>*/ = [];
	var Props = {}, Custprops = {}, pidx = 0, cp = [];
	var comments/*:Array<Comment>*/ = [], comment/*:Comment*/ = ({}/*:any*/);
	var cstys = [], csty, seencol = false;
	var arrayf/*:Array<[Range, string]>*/ = [];
	var rowinfo/*:Array<RowInfo>*/ = [], rowobj = {}, cc = 0, rr = 0;
	var Workbook/*:WBWBProps*/ = ({ Sheets:[], WBProps:{date1904:false} }/*:any*/), wsprops = {};
	xlmlregex.lastIndex = 0;
	str = str.replace(/<!--([\s\S]*?)-->/mg,"");
	var raw_Rn3 = "";
	while((Rn = xlmlregex.exec(str))) switch((Rn[3] = (raw_Rn3 = Rn[3]).toLowerCase())) {
		case 'data' /*case 'Data'*/:
			if(raw_Rn3 == "data") {
				if(Rn[1]==='/'){if((tmp=state.pop())[0]!==Rn[3]) throw new Error("Bad state: "+tmp.join("|"));}
				else if(Rn[0].charAt(Rn[0].length-2) !== '/') state.push([Rn[3], true]);
				break;
			}
			if(state[state.length-1][1]) break;
			if(Rn[1]==='/') parse_xlml_data(str.slice(didx, Rn.index), ss, dtag, state[state.length-1][0]==/*"Comment"*/"comment"?comment:cell, {c:c,r:r}, styles, cstys[c], row, arrayf, opts);
			else { ss = ""; dtag = xlml_parsexmltag(Rn[0]); didx = Rn.index + Rn[0].length; }
			break;
		case 'cell' /*case 'Cell'*/:
			if(Rn[1]==='/'){
				if(comments.length > 0) cell.c = comments;
				if((!opts.sheetRows || opts.sheetRows > r) && cell.v !== undefined) {
					if(opts.dense) {
						if(!cursheet[r]) cursheet[r] = [];
						cursheet[r][c] = cell;
					} else cursheet[encode_col(c) + encode_row(r)] = cell;
				}
				if(cell.HRef) {
					cell.l = ({Target:unescapexml(cell.HRef)}/*:any*/);
					if(cell.HRefScreenTip) cell.l.Tooltip = cell.HRefScreenTip;
					delete cell.HRef; delete cell.HRefScreenTip;
				}
				if(cell.MergeAcross || cell.MergeDown) {
					cc = c + (parseInt(cell.MergeAcross,10)|0);
					rr = r + (parseInt(cell.MergeDown,10)|0);
					merges.push({s:{c:c,r:r},e:{c:cc,r:rr}});
				}
				if(!opts.sheetStubs) { if(cell.MergeAcross) c = cc + 1; else ++c; }
				else if(cell.MergeAcross || cell.MergeDown) {
					/*:: if(!cc) cc = 0; if(!rr) rr = 0; */
					for(var cma = c; cma <= cc; ++cma) {
						for(var cmd = r; cmd <= rr; ++cmd) {
							if(cma > c || cmd > r) {
								if(opts.dense) {
									if(!cursheet[cmd]) cursheet[cmd] = [];
									cursheet[cmd][cma] = {t:'z'};
								} else cursheet[encode_col(cma) + encode_row(cmd)] = {t:'z'};
							}
						}
					}
					c = cc + 1;
				}
				else ++c;
			} else {
				cell = xlml_parsexmltagobj(Rn[0]);
				if(cell.Index) c = +cell.Index - 1;
				if(c < refguess.s.c) refguess.s.c = c;
				if(c > refguess.e.c) refguess.e.c = c;
				if(Rn[0].slice(-2) === "/>") ++c;
				comments = [];
			}
			break;
		case 'row' /*case 'Row'*/:
			if(Rn[1]==='/' || Rn[0].slice(-2) === "/>") {
				if(r < refguess.s.r) refguess.s.r = r;
				if(r > refguess.e.r) refguess.e.r = r;
				if(Rn[0].slice(-2) === "/>") {
					row = xlml_parsexmltag(Rn[0]);
					if(row.Index) r = +row.Index - 1;
				}
				c = 0; ++r;
			} else {
				row = xlml_parsexmltag(Rn[0]);
				if(row.Index) r = +row.Index - 1;
				rowobj = {};
				if(row.AutoFitHeight == "0" || row.Height) {
					rowobj.hpx = parseInt(row.Height, 10); rowobj.hpt = px2pt(rowobj.hpx);
					rowinfo[r] = rowobj;
				}
				if(row.Hidden == "1") { rowobj.hidden = true; rowinfo[r] = rowobj; }
			}
			break;
		case 'worksheet' /*case 'Worksheet'*/: /* TODO: read range from FullRows/FullColumns */
			if(Rn[1]==='/'){
				if((tmp=state.pop())[0]!==Rn[3]) throw new Error("Bad state: "+tmp.join("|"));
				sheetnames.push(sheetname);
				if(refguess.s.r <= refguess.e.r && refguess.s.c <= refguess.e.c) {
					cursheet["!ref"] = encode_range(refguess);
					if(opts.sheetRows && opts.sheetRows <= refguess.e.r) {
						cursheet["!fullref"] = cursheet["!ref"];
						refguess.e.r = opts.sheetRows - 1;
						cursheet["!ref"] = encode_range(refguess);
					}
				}
				if(merges.length) cursheet["!merges"] = merges;
				if(cstys.length > 0) cursheet["!cols"] = cstys;
				if(rowinfo.length > 0) cursheet["!rows"] = rowinfo;
				sheets[sheetname] = cursheet;
			} else {
				refguess = {s: {r:2000000, c:2000000}, e: {r:0, c:0} };
				r = c = 0;
				state.push([Rn[3], false]);
				tmp = xlml_parsexmltag(Rn[0]);
				sheetname = unescapexml(tmp.Name);
				cursheet = (opts.dense ? [] : {});
				merges = [];
				arrayf = [];
				rowinfo = [];
				wsprops = {name:sheetname, Hidden:0};
				Workbook.Sheets.push(wsprops);
			}
			break;
		case 'table' /*case 'Table'*/:
			if(Rn[1]==='/'){if((tmp=state.pop())[0]!==Rn[3]) throw new Error("Bad state: "+tmp.join("|"));}
			else if(Rn[0].slice(-2) == "/>") break;
			else {
				table = xlml_parsexmltag(Rn[0]);
				state.push([Rn[3], false]);
				cstys = []; seencol = false;
			}
			break;

		case 'style' /*case 'Style'*/:
			if(Rn[1]==='/') process_style_xlml(styles, stag, opts);
			else stag = xlml_parsexmltag(Rn[0]);
			break;

		case 'numberformat' /*case 'NumberFormat'*/:
			stag.nf = unescapexml(xlml_parsexmltag(Rn[0]).Format || "General");
			if(XLMLFormatMap[stag.nf]) stag.nf = XLMLFormatMap[stag.nf];
			for(var ssfidx = 0; ssfidx != 0x188; ++ssfidx) if(SSF._table[ssfidx] == stag.nf) break;
			if(ssfidx == 0x188) for(ssfidx = 0x39; ssfidx != 0x188; ++ssfidx) if(SSF._table[ssfidx] == null) { SSF.load(stag.nf, ssfidx); break; }
			break;

		case 'column' /*case 'Column'*/:
			if(state[state.length-1][0] !== /*'Table'*/'table') break;
			csty = xlml_parsexmltag(Rn[0]);
			if(csty.Hidden) { csty.hidden = true; delete csty.Hidden; }
			if(csty.Width) csty.wpx = parseInt(csty.Width, 10);
			if(!seencol && csty.wpx > 10) {
				seencol = true; MDW = DEF_MDW; //find_mdw_wpx(csty.wpx);
				for(var _col = 0; _col < cstys.length; ++_col) if(cstys[_col]) process_col(cstys[_col]);
			}
			if(seencol) process_col(csty);
			cstys[(csty.Index-1||cstys.length)] = csty;
			for(var i = 0; i < +csty.Span; ++i) cstys[cstys.length] = dup(csty);
			break;

		case 'namedrange' /*case 'NamedRange'*/:
			if(Rn[1]==='/') break;
			if(!Workbook.Names) Workbook.Names = [];
			var _NamedRange = parsexmltag(Rn[0]);
			var _DefinedName/*:DefinedName*/ = ({
				Name: _NamedRange.Name,
				Ref: rc_to_a1(_NamedRange.RefersTo.slice(1), {r:0, c:0})
			}/*:any*/);
			if(Workbook.Sheets.length>0) _DefinedName.Sheet=Workbook.Sheets.length-1;
			/*:: if(Workbook.Names) */Workbook.Names.push(_DefinedName);
			break;

		case 'namedcell' /*case 'NamedCell'*/: break;
		case 'b' /*case 'B'*/: break;
		case 'i' /*case 'I'*/: break;
		case 'u' /*case 'U'*/: break;
		case 's' /*case 'S'*/: break;
		case 'em' /*case 'EM'*/: break;
		case 'h2' /*case 'H2'*/: break;
		case 'h3' /*case 'H3'*/: break;
		case 'sub' /*case 'Sub'*/: break;
		case 'sup' /*case 'Sup'*/: break;
		case 'span' /*case 'Span'*/: break;
		case 'alignment' /*case 'Alignment'*/:
			break;
		case 'borders' /*case 'Borders'*/: break;
		case 'border' /*case 'Border'*/: break;
		case 'font' /*case 'Font'*/:
			if(Rn[0].slice(-2) === "/>") break;
			else if(Rn[1]==="/") ss += str.slice(fidx, Rn.index);
			else fidx = Rn.index + Rn[0].length;
			break;
		case 'interior' /*case 'Interior'*/:
			if(!opts.cellStyles) break;
			stag.Interior = xlml_parsexmltag(Rn[0]);
			break;
		case 'protection' /*case 'Protection'*/: break;

		case 'author' /*case 'Author'*/:
		case 'title' /*case 'Title'*/:
		case 'description' /*case 'Description'*/:
		case 'created' /*case 'Created'*/:
		case 'keywords' /*case 'Keywords'*/:
		case 'subject' /*case 'Subject'*/:
		case 'category' /*case 'Category'*/:
		case 'company' /*case 'Company'*/:
		case 'lastauthor' /*case 'LastAuthor'*/:
		case 'lastsaved' /*case 'LastSaved'*/:
		case 'lastprinted' /*case 'LastPrinted'*/:
		case 'version' /*case 'Version'*/:
		case 'revision' /*case 'Revision'*/:
		case 'totaltime' /*case 'TotalTime'*/:
		case 'hyperlinkbase' /*case 'HyperlinkBase'*/:
		case 'manager' /*case 'Manager'*/:
		case 'contentstatus' /*case 'ContentStatus'*/:
		case 'identifier' /*case 'Identifier'*/:
		case 'language' /*case 'Language'*/:
		case 'appname' /*case 'AppName'*/:
			if(Rn[0].slice(-2) === "/>") break;
			else if(Rn[1]==="/") xlml_set_prop(Props, raw_Rn3, str.slice(pidx, Rn.index));
			else pidx = Rn.index + Rn[0].length;
			break;
		case 'paragraphs' /*case 'Paragraphs'*/: break;

		case 'styles' /*case 'Styles'*/:
		case 'workbook' /*case 'Workbook'*/:
			if(Rn[1]==='/'){if((tmp=state.pop())[0]!==Rn[3]) throw new Error("Bad state: "+tmp.join("|"));}
			else state.push([Rn[3], false]);
			break;

		case 'comment' /*case 'Comment'*/:
			if(Rn[1]==='/'){
				if((tmp=state.pop())[0]!==Rn[3]) throw new Error("Bad state: "+tmp.join("|"));
				xlml_clean_comment(comment);
				comments.push(comment);
			} else {
				state.push([Rn[3], false]);
				tmp = xlml_parsexmltag(Rn[0]);
				comment = ({a:tmp.Author}/*:any*/);
			}
			break;

		case 'autofilter' /*case 'AutoFilter'*/:
			if(Rn[1]==='/'){if((tmp=state.pop())[0]!==Rn[3]) throw new Error("Bad state: "+tmp.join("|"));}
			else if(Rn[0].charAt(Rn[0].length-2) !== '/') {
				var AutoFilter = xlml_parsexmltag(Rn[0]);
				cursheet['!autofilter'] = { ref:rc_to_a1(AutoFilter.Range).replace(/\$/g,"") };
				state.push([Rn[3], true]);
			}
			break;

		case 'name' /*case 'Name'*/: break;

		case 'datavalidation' /*case 'DataValidation'*/:
			if(Rn[1]==='/'){
				if((tmp=state.pop())[0]!==Rn[3]) throw new Error("Bad state: "+tmp.join("|"));
			} else {
				if(Rn[0].charAt(Rn[0].length-2) !== '/') state.push([Rn[3], true]);
			}
			break;

		case 'pixelsperinch' /*case 'PixelsPerInch'*/:
			break;
		case 'componentoptions' /*case 'ComponentOptions'*/:
		case 'documentproperties' /*case 'DocumentProperties'*/:
		case 'customdocumentproperties' /*case 'CustomDocumentProperties'*/:
		case 'officedocumentsettings' /*case 'OfficeDocumentSettings'*/:
		case 'pivottable' /*case 'PivotTable'*/:
		case 'pivotcache' /*case 'PivotCache'*/:
		case 'names' /*case 'Names'*/:
		case 'mapinfo' /*case 'MapInfo'*/:
		case 'pagebreaks' /*case 'PageBreaks'*/:
		case 'querytable' /*case 'QueryTable'*/:
		case 'sorting' /*case 'Sorting'*/:
		case 'schema' /*case 'Schema'*/: //case 'data' /*case 'data'*/:
		case 'conditionalformatting' /*case 'ConditionalFormatting'*/:
		case 'smarttagtype' /*case 'SmartTagType'*/:
		case 'smarttags' /*case 'SmartTags'*/:
		case 'excelworkbook' /*case 'ExcelWorkbook'*/:
		case 'workbookoptions' /*case 'WorkbookOptions'*/:
		case 'worksheetoptions' /*case 'WorksheetOptions'*/:
			if(Rn[1]==='/'){if((tmp=state.pop())[0]!==Rn[3]) throw new Error("Bad state: "+tmp.join("|"));}
			else if(Rn[0].charAt(Rn[0].length-2) !== '/') state.push([Rn[3], true]);
			break;

		case 'null' /*case 'Null'*/: break;

		default:
			/* FODS file root is <office:document> */
			if(state.length == 0 && Rn[3] == "document") return parse_fods(str, opts);
			/* UOS file root is <uof:UOF> */
			if(state.length == 0 && Rn[3] == "uof"/*"UOF"*/) return parse_fods(str, opts);

			var seen = true;
			switch(state[state.length-1][0]) {
				/* OfficeDocumentSettings */
				case 'officedocumentsettings' /*case 'OfficeDocumentSettings'*/: switch(Rn[3]) {
					case 'allowpng' /*case 'AllowPNG'*/: break;
					case 'removepersonalinformation' /*case 'RemovePersonalInformation'*/: break;
					case 'downloadcomponents' /*case 'DownloadComponents'*/: break;
					case 'locationofcomponents' /*case 'LocationOfComponents'*/: break;
					case 'colors' /*case 'Colors'*/: break;
					case 'color' /*case 'Color'*/: break;
					case 'index' /*case 'Index'*/: break;
					case 'rgb' /*case 'RGB'*/: break;
					case 'targetscreensize' /*case 'TargetScreenSize'*/: break;
					case 'readonlyrecommended' /*case 'ReadOnlyRecommended'*/: break;
					default: seen = false;
				} break;

				/* ComponentOptions */
				case 'componentoptions' /*case 'ComponentOptions'*/: switch(Rn[3]) {
					case 'toolbar' /*case 'Toolbar'*/: break;
					case 'hideofficelogo' /*case 'HideOfficeLogo'*/: break;
					case 'spreadsheetautofit' /*case 'SpreadsheetAutoFit'*/: break;
					case 'label' /*case 'Label'*/: break;
					case 'caption' /*case 'Caption'*/: break;
					case 'maxheight' /*case 'MaxHeight'*/: break;
					case 'maxwidth' /*case 'MaxWidth'*/: break;
					case 'nextsheetnumber' /*case 'NextSheetNumber'*/: break;
					default: seen = false;
				} break;

				/* ExcelWorkbook */
				case 'excelworkbook' /*case 'ExcelWorkbook'*/: switch(Rn[3]) {
					case 'date1904' /*case 'Date1904'*/:
						/*:: if(!Workbook.WBProps) Workbook.WBProps = {}; */
						Workbook.WBProps.date1904 = true;
						break;
					case 'windowheight' /*case 'WindowHeight'*/: break;
					case 'windowwidth' /*case 'WindowWidth'*/: break;
					case 'windowtopx' /*case 'WindowTopX'*/: break;
					case 'windowtopy' /*case 'WindowTopY'*/: break;
					case 'tabratio' /*case 'TabRatio'*/: break;
					case 'protectstructure' /*case 'ProtectStructure'*/: break;
					case 'protectwindow' /*case 'ProtectWindow'*/: break;
					case 'protectwindows' /*case 'ProtectWindows'*/: break;
					case 'activesheet' /*case 'ActiveSheet'*/: break;
					case 'displayinknotes' /*case 'DisplayInkNotes'*/: break;
					case 'firstvisiblesheet' /*case 'FirstVisibleSheet'*/: break;
					case 'supbook' /*case 'SupBook'*/: break;
					case 'sheetname' /*case 'SheetName'*/: break;
					case 'sheetindex' /*case 'SheetIndex'*/: break;
					case 'sheetindexfirst' /*case 'SheetIndexFirst'*/: break;
					case 'sheetindexlast' /*case 'SheetIndexLast'*/: break;
					case 'dll' /*case 'Dll'*/: break;
					case 'acceptlabelsinformulas' /*case 'AcceptLabelsInFormulas'*/: break;
					case 'donotsavelinkvalues' /*case 'DoNotSaveLinkValues'*/: break;
					case 'iteration' /*case 'Iteration'*/: break;
					case 'maxiterations' /*case 'MaxIterations'*/: break;
					case 'maxchange' /*case 'MaxChange'*/: break;
					case 'path' /*case 'Path'*/: break;
					case 'xct' /*case 'Xct'*/: break;
					case 'count' /*case 'Count'*/: break;
					case 'selectedsheets' /*case 'SelectedSheets'*/: break;
					case 'calculation' /*case 'Calculation'*/: break;
					case 'uncalced' /*case 'Uncalced'*/: break;
					case 'startupprompt' /*case 'StartupPrompt'*/: break;
					case 'crn' /*case 'Crn'*/: break;
					case 'externname' /*case 'ExternName'*/: break;
					case 'formula' /*case 'Formula'*/: break;
					case 'colfirst' /*case 'ColFirst'*/: break;
					case 'collast' /*case 'ColLast'*/: break;
					case 'wantadvise' /*case 'WantAdvise'*/: break;
					case 'boolean' /*case 'Boolean'*/: break;
					case 'error' /*case 'Error'*/: break;
					case 'text' /*case 'Text'*/: break;
					case 'ole' /*case 'OLE'*/: break;
					case 'noautorecover' /*case 'NoAutoRecover'*/: break;
					case 'publishobjects' /*case 'PublishObjects'*/: break;
					case 'donotcalculatebeforesave' /*case 'DoNotCalculateBeforeSave'*/: break;
					case 'number' /*case 'Number'*/: break;
					case 'refmoder1c1' /*case 'RefModeR1C1'*/: break;
					case 'embedsavesmarttags' /*case 'EmbedSaveSmartTags'*/: break;
					default: seen = false;
				} break;

				/* WorkbookOptions */
				case 'workbookoptions' /*case 'WorkbookOptions'*/: switch(Rn[3]) {
					case 'owcversion' /*case 'OWCVersion'*/: break;
					case 'height' /*case 'Height'*/: break;
					case 'width' /*case 'Width'*/: break;
					default: seen = false;
				} break;

				/* WorksheetOptions */
				case 'worksheetoptions' /*case 'WorksheetOptions'*/: switch(Rn[3]) {
					case 'visible' /*case 'Visible'*/:
						if(Rn[0].slice(-2) === "/>");
						else if(Rn[1]==="/") switch(str.slice(pidx, Rn.index)) {
							case "SheetHidden": wsprops.Hidden = 1; break;
							case "SheetVeryHidden": wsprops.Hidden = 2; break;
						}
						else pidx = Rn.index + Rn[0].length;
						break;
					case 'header' /*case 'Header'*/:
						if(!cursheet['!margins']) default_margins(cursheet['!margins']={}, 'xlml');
						if(!isNaN(+parsexmltag(Rn[0]).Margin)) cursheet['!margins'].header = +parsexmltag(Rn[0]).Margin;
						break;
					case 'footer' /*case 'Footer'*/:
						if(!cursheet['!margins']) default_margins(cursheet['!margins']={}, 'xlml');
						if(!isNaN(+parsexmltag(Rn[0]).Margin)) cursheet['!margins'].footer = +parsexmltag(Rn[0]).Margin;
						break;
					case 'pagemargins' /*case 'PageMargins'*/:
						var pagemargins = parsexmltag(Rn[0]);
						if(!cursheet['!margins']) default_margins(cursheet['!margins']={},'xlml');
						if(!isNaN(+pagemargins.Top)) cursheet['!margins'].top = +pagemargins.Top;
						if(!isNaN(+pagemargins.Left)) cursheet['!margins'].left = +pagemargins.Left;
						if(!isNaN(+pagemargins.Right)) cursheet['!margins'].right = +pagemargins.Right;
						if(!isNaN(+pagemargins.Bottom)) cursheet['!margins'].bottom = +pagemargins.Bottom;
						break;
					case 'displayrighttoleft' /*case 'DisplayRightToLeft'*/:
						if(!Workbook.Views) Workbook.Views = [];
						if(!Workbook.Views[0]) Workbook.Views[0] = {};
						Workbook.Views[0].RTL = true;
						break;

					case 'freezepanes' /*case 'FreezePanes'*/: break;
					case 'frozennosplit' /*case 'FrozenNoSplit'*/: break;

					case 'splithorizontal' /*case 'SplitHorizontal'*/:
					case 'splitvertical' /*case 'SplitVertical'*/:
						break;

					case 'donotdisplaygridlines' /*case 'DoNotDisplayGridlines'*/:
						break;

					case 'activerow' /*case 'ActiveRow'*/: break;
					case 'activecol' /*case 'ActiveCol'*/: break;
					case 'toprowbottompane' /*case 'TopRowBottomPane'*/: break;
					case 'leftcolumnrightpane' /*case 'LeftColumnRightPane'*/: break;

					case 'unsynced' /*case 'Unsynced'*/: break;
					case 'print' /*case 'Print'*/: break;
					case 'printerrors' /*case 'PrintErrors'*/: break;
					case 'panes' /*case 'Panes'*/: break;
					case 'scale' /*case 'Scale'*/: break;
					case 'pane' /*case 'Pane'*/: break;
					case 'number' /*case 'Number'*/: break;
					case 'layout' /*case 'Layout'*/: break;
					case 'pagesetup' /*case 'PageSetup'*/: break;
					case 'selected' /*case 'Selected'*/: break;
					case 'protectobjects' /*case 'ProtectObjects'*/: break;
					case 'enableselection' /*case 'EnableSelection'*/: break;
					case 'protectscenarios' /*case 'ProtectScenarios'*/: break;
					case 'validprinterinfo' /*case 'ValidPrinterInfo'*/: break;
					case 'horizontalresolution' /*case 'HorizontalResolution'*/: break;
					case 'verticalresolution' /*case 'VerticalResolution'*/: break;
					case 'numberofcopies' /*case 'NumberofCopies'*/: break;
					case 'activepane' /*case 'ActivePane'*/: break;
					case 'toprowvisible' /*case 'TopRowVisible'*/: break;
					case 'leftcolumnvisible' /*case 'LeftColumnVisible'*/: break;
					case 'fittopage' /*case 'FitToPage'*/: break;
					case 'rangeselection' /*case 'RangeSelection'*/: break;
					case 'papersizeindex' /*case 'PaperSizeIndex'*/: break;
					case 'pagelayoutzoom' /*case 'PageLayoutZoom'*/: break;
					case 'pagebreakzoom' /*case 'PageBreakZoom'*/: break;
					case 'filteron' /*case 'FilterOn'*/: break;
					case 'fitwidth' /*case 'FitWidth'*/: break;
					case 'fitheight' /*case 'FitHeight'*/: break;
					case 'commentslayout' /*case 'CommentsLayout'*/: break;
					case 'zoom' /*case 'Zoom'*/: break;
					case 'lefttoright' /*case 'LeftToRight'*/: break;
					case 'gridlines' /*case 'Gridlines'*/: break;
					case 'allowsort' /*case 'AllowSort'*/: break;
					case 'allowfilter' /*case 'AllowFilter'*/: break;
					case 'allowinsertrows' /*case 'AllowInsertRows'*/: break;
					case 'allowdeleterows' /*case 'AllowDeleteRows'*/: break;
					case 'allowinsertcols' /*case 'AllowInsertCols'*/: break;
					case 'allowdeletecols' /*case 'AllowDeleteCols'*/: break;
					case 'allowinserthyperlinks' /*case 'AllowInsertHyperlinks'*/: break;
					case 'allowformatcells' /*case 'AllowFormatCells'*/: break;
					case 'allowsizecols' /*case 'AllowSizeCols'*/: break;
					case 'allowsizerows' /*case 'AllowSizeRows'*/: break;
					case 'nosummaryrowsbelowdetail' /*case 'NoSummaryRowsBelowDetail'*/:
						if(!cursheet["!outline"]) cursheet["!outline"] = {};
						cursheet["!outline"].above = true;
						break;
					case 'tabcolorindex' /*case 'TabColorIndex'*/: break;
					case 'donotdisplayheadings' /*case 'DoNotDisplayHeadings'*/: break;
					case 'showpagelayoutzoom' /*case 'ShowPageLayoutZoom'*/: break;
					case 'nosummarycolumnsrightdetail' /*case 'NoSummaryColumnsRightDetail'*/:
						if(!cursheet["!outline"]) cursheet["!outline"] = {};
						cursheet["!outline"].left = true;
						break;
					case 'blackandwhite' /*case 'BlackAndWhite'*/: break;
					case 'donotdisplayzeros' /*case 'DoNotDisplayZeros'*/: break;
					case 'displaypagebreak' /*case 'DisplayPageBreak'*/: break;
					case 'rowcolheadings' /*case 'RowColHeadings'*/: break;
					case 'donotdisplayoutline' /*case 'DoNotDisplayOutline'*/: break;
					case 'noorientation' /*case 'NoOrientation'*/: break;
					case 'allowusepivottables' /*case 'AllowUsePivotTables'*/: break;
					case 'zeroheight' /*case 'ZeroHeight'*/: break;
					case 'viewablerange' /*case 'ViewableRange'*/: break;
					case 'selection' /*case 'Selection'*/: break;
					case 'protectcontents' /*case 'ProtectContents'*/: break;
					default: seen = false;
				} break;

				/* PivotTable */
				case 'pivottable' /*case 'PivotTable'*/: case 'pivotcache' /*case 'PivotCache'*/: switch(Rn[3]) {
					case 'immediateitemsondrop' /*case 'ImmediateItemsOnDrop'*/: break;
					case 'showpagemultipleitemlabel' /*case 'ShowPageMultipleItemLabel'*/: break;
					case 'compactrowindent' /*case 'CompactRowIndent'*/: break;
					case 'location' /*case 'Location'*/: break;
					case 'pivotfield' /*case 'PivotField'*/: break;
					case 'orientation' /*case 'Orientation'*/: break;
					case 'layoutform' /*case 'LayoutForm'*/: break;
					case 'layoutsubtotallocation' /*case 'LayoutSubtotalLocation'*/: break;
					case 'layoutcompactrow' /*case 'LayoutCompactRow'*/: break;
					case 'position' /*case 'Position'*/: break;
					case 'pivotitem' /*case 'PivotItem'*/: break;
					case 'datatype' /*case 'DataType'*/: break;
					case 'datafield' /*case 'DataField'*/: break;
					case 'sourcename' /*case 'SourceName'*/: break;
					case 'parentfield' /*case 'ParentField'*/: break;
					case 'ptlineitems' /*case 'PTLineItems'*/: break;
					case 'ptlineitem' /*case 'PTLineItem'*/: break;
					case 'countofsameitems' /*case 'CountOfSameItems'*/: break;
					case 'item' /*case 'Item'*/: break;
					case 'itemtype' /*case 'ItemType'*/: break;
					case 'ptsource' /*case 'PTSource'*/: break;
					case 'cacheindex' /*case 'CacheIndex'*/: break;
					case 'consolidationreference' /*case 'ConsolidationReference'*/: break;
					case 'filename' /*case 'FileName'*/: break;
					case 'reference' /*case 'Reference'*/: break;
					case 'nocolumngrand' /*case 'NoColumnGrand'*/: break;
					case 'norowgrand' /*case 'NoRowGrand'*/: break;
					case 'blanklineafteritems' /*case 'BlankLineAfterItems'*/: break;
					case 'hidden' /*case 'Hidden'*/: break;
					case 'subtotal' /*case 'Subtotal'*/: break;
					case 'basefield' /*case 'BaseField'*/: break;
					case 'mapchilditems' /*case 'MapChildItems'*/: break;
					case 'function' /*case 'Function'*/: break;
					case 'refreshonfileopen' /*case 'RefreshOnFileOpen'*/: break;
					case 'printsettitles' /*case 'PrintSetTitles'*/: break;
					case 'mergelabels' /*case 'MergeLabels'*/: break;
					case 'defaultversion' /*case 'DefaultVersion'*/: break;
					case 'refreshname' /*case 'RefreshName'*/: break;
					case 'refreshdate' /*case 'RefreshDate'*/: break;
					case 'refreshdatecopy' /*case 'RefreshDateCopy'*/: break;
					case 'versionlastrefresh' /*case 'VersionLastRefresh'*/: break;
					case 'versionlastupdate' /*case 'VersionLastUpdate'*/: break;
					case 'versionupdateablemin' /*case 'VersionUpdateableMin'*/: break;
					case 'versionrefreshablemin' /*case 'VersionRefreshableMin'*/: break;
					case 'calculation' /*case 'Calculation'*/: break;
					default: seen = false;
				} break;

				/* PageBreaks */
				case 'pagebreaks' /*case 'PageBreaks'*/: switch(Rn[3]) {
					case 'colbreaks' /*case 'ColBreaks'*/: break;
					case 'colbreak' /*case 'ColBreak'*/: break;
					case 'rowbreaks' /*case 'RowBreaks'*/: break;
					case 'rowbreak' /*case 'RowBreak'*/: break;
					case 'colstart' /*case 'ColStart'*/: break;
					case 'colend' /*case 'ColEnd'*/: break;
					case 'rowend' /*case 'RowEnd'*/: break;
					default: seen = false;
				} break;

				/* AutoFilter */
				case 'autofilter' /*case 'AutoFilter'*/: switch(Rn[3]) {
					case 'autofiltercolumn' /*case 'AutoFilterColumn'*/: break;
					case 'autofiltercondition' /*case 'AutoFilterCondition'*/: break;
					case 'autofilterand' /*case 'AutoFilterAnd'*/: break;
					case 'autofilteror' /*case 'AutoFilterOr'*/: break;
					default: seen = false;
				} break;

				/* QueryTable */
				case 'querytable' /*case 'QueryTable'*/: switch(Rn[3]) {
					case 'id' /*case 'Id'*/: break;
					case 'autoformatfont' /*case 'AutoFormatFont'*/: break;
					case 'autoformatpattern' /*case 'AutoFormatPattern'*/: break;
					case 'querysource' /*case 'QuerySource'*/: break;
					case 'querytype' /*case 'QueryType'*/: break;
					case 'enableredirections' /*case 'EnableRedirections'*/: break;
					case 'refreshedinxl9' /*case 'RefreshedInXl9'*/: break;
					case 'urlstring' /*case 'URLString'*/: break;
					case 'htmltables' /*case 'HTMLTables'*/: break;
					case 'connection' /*case 'Connection'*/: break;
					case 'commandtext' /*case 'CommandText'*/: break;
					case 'refreshinfo' /*case 'RefreshInfo'*/: break;
					case 'notitles' /*case 'NoTitles'*/: break;
					case 'nextid' /*case 'NextId'*/: break;
					case 'columninfo' /*case 'ColumnInfo'*/: break;
					case 'overwritecells' /*case 'OverwriteCells'*/: break;
					case 'donotpromptforfile' /*case 'DoNotPromptForFile'*/: break;
					case 'textwizardsettings' /*case 'TextWizardSettings'*/: break;
					case 'source' /*case 'Source'*/: break;
					case 'number' /*case 'Number'*/: break;
					case 'decimal' /*case 'Decimal'*/: break;
					case 'thousandseparator' /*case 'ThousandSeparator'*/: break;
					case 'trailingminusnumbers' /*case 'TrailingMinusNumbers'*/: break;
					case 'formatsettings' /*case 'FormatSettings'*/: break;
					case 'fieldtype' /*case 'FieldType'*/: break;
					case 'delimiters' /*case 'Delimiters'*/: break;
					case 'tab' /*case 'Tab'*/: break;
					case 'comma' /*case 'Comma'*/: break;
					case 'autoformatname' /*case 'AutoFormatName'*/: break;
					case 'versionlastedit' /*case 'VersionLastEdit'*/: break;
					case 'versionlastrefresh' /*case 'VersionLastRefresh'*/: break;
					default: seen = false;
				} break;

				case 'datavalidation' /*case 'DataValidation'*/:
				switch(Rn[3]) {
					case 'range' /*case 'Range'*/: break;

					case 'type' /*case 'Type'*/: break;
					case 'min' /*case 'Min'*/: break;
					case 'max' /*case 'Max'*/: break;
					case 'sort' /*case 'Sort'*/: break;
					case 'descending' /*case 'Descending'*/: break;
					case 'order' /*case 'Order'*/: break;
					case 'casesensitive' /*case 'CaseSensitive'*/: break;
					case 'value' /*case 'Value'*/: break;
					case 'errorstyle' /*case 'ErrorStyle'*/: break;
					case 'errormessage' /*case 'ErrorMessage'*/: break;
					case 'errortitle' /*case 'ErrorTitle'*/: break;
					case 'inputmessage' /*case 'InputMessage'*/: break;
					case 'inputtitle' /*case 'InputTitle'*/: break;
					case 'combohide' /*case 'ComboHide'*/: break;
					case 'inputhide' /*case 'InputHide'*/: break;
					case 'condition' /*case 'Condition'*/: break;
					case 'qualifier' /*case 'Qualifier'*/: break;
					case 'useblank' /*case 'UseBlank'*/: break;
					case 'value1' /*case 'Value1'*/: break;
					case 'value2' /*case 'Value2'*/: break;
					case 'format' /*case 'Format'*/: break;

					case 'cellrangelist' /*case 'CellRangeList'*/: break;
					default: seen = false;
				} break;

				case 'sorting' /*case 'Sorting'*/:
				case 'conditionalformatting' /*case 'ConditionalFormatting'*/:
				switch(Rn[3]) {
					case 'range' /*case 'Range'*/: break;
					case 'type' /*case 'Type'*/: break;
					case 'min' /*case 'Min'*/: break;
					case 'max' /*case 'Max'*/: break;
					case 'sort' /*case 'Sort'*/: break;
					case 'descending' /*case 'Descending'*/: break;
					case 'order' /*case 'Order'*/: break;
					case 'casesensitive' /*case 'CaseSensitive'*/: break;
					case 'value' /*case 'Value'*/: break;
					case 'errorstyle' /*case 'ErrorStyle'*/: break;
					case 'errormessage' /*case 'ErrorMessage'*/: break;
					case 'errortitle' /*case 'ErrorTitle'*/: break;
					case 'cellrangelist' /*case 'CellRangeList'*/: break;
					case 'inputmessage' /*case 'InputMessage'*/: break;
					case 'inputtitle' /*case 'InputTitle'*/: break;
					case 'combohide' /*case 'ComboHide'*/: break;
					case 'inputhide' /*case 'InputHide'*/: break;
					case 'condition' /*case 'Condition'*/: break;
					case 'qualifier' /*case 'Qualifier'*/: break;
					case 'useblank' /*case 'UseBlank'*/: break;
					case 'value1' /*case 'Value1'*/: break;
					case 'value2' /*case 'Value2'*/: break;
					case 'format' /*case 'Format'*/: break;
					default: seen = false;
				} break;

				/* MapInfo (schema) */
				case 'mapinfo' /*case 'MapInfo'*/: case 'schema' /*case 'Schema'*/: case 'data' /*case 'data'*/: switch(Rn[3]) {
					case 'map' /*case 'Map'*/: break;
					case 'entry' /*case 'Entry'*/: break;
					case 'range' /*case 'Range'*/: break;
					case 'xpath' /*case 'XPath'*/: break;
					case 'field' /*case 'Field'*/: break;
					case 'xsdtype' /*case 'XSDType'*/: break;
					case 'filteron' /*case 'FilterOn'*/: break;
					case 'aggregate' /*case 'Aggregate'*/: break;
					case 'elementtype' /*case 'ElementType'*/: break;
					case 'attributetype' /*case 'AttributeType'*/: break;
				/* These are from xsd (XML Schema Definition) */
					case 'schema' /*case 'schema'*/:
					case 'element' /*case 'element'*/:
					case 'complextype' /*case 'complexType'*/:
					case 'datatype' /*case 'datatype'*/:
					case 'all' /*case 'all'*/:
					case 'attribute' /*case 'attribute'*/:
					case 'extends' /*case 'extends'*/: break;

					case 'row' /*case 'row'*/: break;
					default: seen = false;
				} break;

				/* SmartTags (can be anything) */
				case 'smarttags' /*case 'SmartTags'*/: break;

				default: seen = false; break;
			}
			if(seen) break;
			/* CustomDocumentProperties */
			if(Rn[3].match(/!\[CDATA/)) break;
			if(!state[state.length-1][1]) throw 'Unrecognized tag: ' + Rn[3] + "|" + state.join("|");
			if(state[state.length-1][0]===/*'CustomDocumentProperties'*/'customdocumentproperties') {
				if(Rn[0].slice(-2) === "/>") break;
				else if(Rn[1]==="/") xlml_set_custprop(Custprops, raw_Rn3, cp, str.slice(pidx, Rn.index));
				else { cp = Rn; pidx = Rn.index + Rn[0].length; }
				break;
			}
			if(opts.WTF) throw 'Unrecognized tag: ' + Rn[3] + "|" + state.join("|");
	}
	var out = ({}/*:any*/);
	if(!opts.bookSheets && !opts.bookProps) out.Sheets = sheets;
	out.SheetNames = sheetnames;
	out.Workbook = Workbook;
	out.SSF = SSF.get_table();
	out.Props = Props;
	out.Custprops = Custprops;
	return out;
}

function parse_xlml(data/*:RawBytes|string*/, opts)/*:Workbook*/ {
	fix_read_opts(opts=opts||{});
	switch(opts.type||"base64") {
		case "base64": return parse_xlml_xml(Base64.decode(data), opts);
		case "binary": case "buffer": case "file": return parse_xlml_xml(data, opts);
		case "array": return parse_xlml_xml(a2s(data), opts);
	}
	/*:: throw new Error("unsupported type " + opts.type); */
}

/* TODO */
function write_props_xlml(wb/*:Workbook*/, opts)/*:string*/ {
	var o/*:Array<string>*/ = [];
	/* DocumentProperties */
	if(wb.Props) o.push(xlml_write_docprops(wb.Props, opts));
	/* CustomDocumentProperties */
	if(wb.Custprops) o.push(xlml_write_custprops(wb.Props, wb.Custprops));
	return o.join("");
}
/* TODO */
function write_wb_xlml(/*::wb, opts*/)/*:string*/ {
	/* OfficeDocumentSettings */
	/* ExcelWorkbook */
	return "";
}
/* TODO */
function write_sty_xlml(wb, opts)/*:string*/ {
	/* Styles */
	var styles/*:Array<string>*/ = ['<Style ss:ID="Default" ss:Name="Normal"><NumberFormat/></Style>'];
	opts.cellXfs.forEach(function(xf, id) {
		var payload/*:Array<string>*/ = [];
		payload.push(writextag('NumberFormat', null, {"ss:Format": escapexml(SSF._table[xf.numFmtId])}));

		var o = /*::(*/{"ss:ID": "s" + (21+id)}/*:: :any)*/;
		styles.push(writextag('Style', payload.join(""), o));
	});
	return writextag("Styles", styles.join(""));
}
function write_name_xlml(n) { return writextag("NamedRange", null, {"ss:Name": n.Name, "ss:RefersTo":"=" + a1_to_rc(n.Ref, {r:0,c:0})}); }
function write_names_xlml(wb/*::, opts*/)/*:string*/ {
	if(!((wb||{}).Workbook||{}).Names) return "";
	/*:: if(!wb || !wb.Workbook || !wb.Workbook.Names) throw new Error("unreachable"); */
	var names/*:Array<any>*/ = wb.Workbook.Names;
	var out/*:Array<string>*/ = [];
	for(var i = 0; i < names.length; ++i) {
		var n = names[i];
		if(n.Sheet != null) continue;
		if(n.Name.match(/^_xlfn\./)) continue;
		out.push(write_name_xlml(n));
	}
	return writextag("Names", out.join(""));
}
function write_ws_xlml_names(ws/*:Worksheet*/, opts, idx/*:number*/, wb/*:Workbook*/)/*:string*/ {
	if(!ws) return "";
	if(!((wb||{}).Workbook||{}).Names) return "";
	/*:: if(!wb || !wb.Workbook || !wb.Workbook.Names) throw new Error("unreachable"); */
	var names/*:Array<any>*/ = wb.Workbook.Names;
	var out/*:Array<string>*/ = [];
	for(var i = 0; i < names.length; ++i) {
		var n = names[i];
		if(n.Sheet != idx) continue;
		/*switch(n.Name) {
			case "_": continue;
		}*/
		if(n.Name.match(/^_xlfn\./)) continue;
		out.push(write_name_xlml(n));
	}
	return out.join("");
}
/* WorksheetOptions */
function write_ws_xlml_wsopts(ws/*:Worksheet*/, opts, idx/*:number*/, wb/*:Workbook*/)/*:string*/ {
	if(!ws) return "";
	var o/*:Array<string>*/ = [];
	/* NOTE: spec technically allows any order, but stick with implied order */

	/* FitToPage */
	/* DoNotDisplayColHeaders */
	/* DoNotDisplayRowHeaders */
	/* ViewableRange */
	/* Selection */
	/* GridlineColor */
	/* Name */
	/* ExcelWorksheetType */
	/* IntlMacro */
	/* Unsynced */
	/* Selected */
	/* CodeName */

	if(ws['!margins']) {
		o.push("<PageSetup>");
		if(ws['!margins'].header) o.push(writextag("Header", null, {'x:Margin':ws['!margins'].header}));
		if(ws['!margins'].footer) o.push(writextag("Footer", null, {'x:Margin':ws['!margins'].footer}));
		o.push(writextag("PageMargins", null, {
			'x:Bottom': ws['!margins'].bottom || "0.75",
			'x:Left': ws['!margins'].left || "0.7",
			'x:Right': ws['!margins'].right || "0.7",
			'x:Top': ws['!margins'].top || "0.75"
		}));
		o.push("</PageSetup>");
	}

	/* PageSetup */
	/* DisplayPageBreak */
	/* TransitionExpressionEvaluation */
	/* TransitionFormulaEntry */
	/* Print */
	/* Zoom */
	/* PageLayoutZoom */
	/* PageBreakZoom */
	/* ShowPageBreakZoom */
	/* DefaultRowHeight */
	/* DefaultColumnWidth */
	/* StandardWidth */

	if(wb && wb.Workbook && wb.Workbook.Sheets && wb.Workbook.Sheets[idx]) {
		/* Visible */
		if(wb.Workbook.Sheets[idx].Hidden) o.push(writextag("Visible", (wb.Workbook.Sheets[idx].Hidden == 1 ? "SheetHidden" : "SheetVeryHidden"), {}));
		else {
			/* Selected */
			for(var i = 0; i < idx; ++i) if(wb.Workbook.Sheets[i] && !wb.Workbook.Sheets[i].Hidden) break;
			if(i == idx) o.push("<Selected/>");
		}
	}

	/* LeftColumnVisible */

	if(((((wb||{}).Workbook||{}).Views||[])[0]||{}).RTL) o.push("<DisplayRightToLeft/>");

	/* GridlineColorIndex */
	/* DisplayFormulas */
	/* DoNotDisplayGridlines */
	/* DoNotDisplayHeadings */
	/* DoNotDisplayOutline */
	/* ApplyAutomaticOutlineStyles */
	/* NoSummaryRowsBelowDetail */
	/* NoSummaryColumnsRightDetail */
	/* DoNotDisplayZeros */
	/* ActiveRow */
	/* ActiveColumn */
	/* FilterOn */
	/* RangeSelection */
	/* TopRowVisible */
	/* TopRowBottomPane */
	/* LeftColumnRightPane */
	/* ActivePane */
	/* SplitHorizontal */
	/* SplitVertical */
	/* FreezePanes */
	/* FrozenNoSplit */
	/* TabColorIndex */
	/* Panes */

	/* NOTE: Password not supported in XLML Format */
	if(ws['!protect']) {
		o.push(writetag("ProtectContents", "True"));
		if(ws['!protect'].objects) o.push(writetag("ProtectObjects", "True"));
		if(ws['!protect'].scenarios) o.push(writetag("ProtectScenarios", "True"));
		if(ws['!protect'].selectLockedCells != null && !ws['!protect'].selectLockedCells) o.push(writetag("EnableSelection", "NoSelection"));
		else if(ws['!protect'].selectUnlockedCells != null && !ws['!protect'].selectUnlockedCells) o.push(writetag("EnableSelection", "UnlockedCells"));
	[
		[ "formatCells", "AllowFormatCells" ],
		[ "formatColumns", "AllowSizeCols" ],
		[ "formatRows", "AllowSizeRows" ],
		[ "insertColumns", "AllowInsertCols" ],
		[ "insertRows", "AllowInsertRows" ],
		[ "insertHyperlinks", "AllowInsertHyperlinks" ],
		[ "deleteColumns", "AllowDeleteCols" ],
		[ "deleteRows", "AllowDeleteRows" ],
		[ "sort", "AllowSort" ],
		[ "autoFilter", "AllowFilter" ],
		[ "pivotTables", "AllowUsePivotTables" ]
	].forEach(function(x) { if(ws['!protect'][x[0]]) o.push("<"+x[1]+"/>"); });
	}

	if(o.length == 0) return "";
	return writextag("WorksheetOptions", o.join(""), {xmlns:XLMLNS.x});
}
function write_ws_xlml_comment(comments/*:Array<any>*/)/*:string*/ {
	return comments.map(function(c) {
		// TODO: formatted text
		var t = xlml_unfixstr(c.t||"");
		var d =writextag("ss:Data", t, {"xmlns":"http://www.w3.org/TR/REC-html40"});
		return writextag("Comment", d, {"ss:Author":c.a});
	}).join("");
}
function write_ws_xlml_cell(cell, ref/*:string*/, ws, opts, idx/*:number*/, wb, addr)/*:string*/{
	if(!cell || (cell.v == undefined && cell.f == undefined)) return "";

	var attr = {};
	if(cell.f) attr["ss:Formula"] = "=" + escapexml(a1_to_rc(cell.f, addr));
	if(cell.F && cell.F.slice(0, ref.length) == ref) {
		var end = decode_cell(cell.F.slice(ref.length + 1));
		attr["ss:ArrayRange"] = "RC:R" + (end.r == addr.r ? "" : "[" + (end.r - addr.r) + "]") + "C" + (end.c == addr.c ? "" : "[" + (end.c - addr.c) + "]");
	}

	if(cell.l && cell.l.Target) {
		attr["ss:HRef"] = escapexml(cell.l.Target);
		if(cell.l.Tooltip) attr["x:HRefScreenTip"] = escapexml(cell.l.Tooltip);
	}

	if(ws['!merges']) {
		var marr = ws['!merges'];
		for(var mi = 0; mi != marr.length; ++mi) {
			if(marr[mi].s.c != addr.c || marr[mi].s.r != addr.r) continue;
			if(marr[mi].e.c > marr[mi].s.c) attr['ss:MergeAcross'] = marr[mi].e.c - marr[mi].s.c;
			if(marr[mi].e.r > marr[mi].s.r) attr['ss:MergeDown'] = marr[mi].e.r - marr[mi].s.r;
		}
	}

	var t = "", p = "";
	switch(cell.t) {
		case 'z': if(!opts.sheetStubs) return ""; break;
		case 'n': t = 'Number'; p = String(cell.v); break;
		case 'b': t = 'Boolean'; p = (cell.v ? "1" : "0"); break;
		case 'e': t = 'Error'; p = BErr[cell.v]; break;
		case 'd': t = 'DateTime'; p = new Date(cell.v).toISOString(); if(cell.z == null) cell.z = cell.z || SSF._table[14]; break;
		case 's': t = 'String'; p = escapexlml(cell.v||""); break;
	}
	/* TODO: cell style */
	var os = get_cell_style(opts.cellXfs, cell, opts);
	attr["ss:StyleID"] = "s" + (21+os);
	attr["ss:Index"] = addr.c + 1;
	var _v = (cell.v != null ? p : "");
	var m = cell.t == 'z' ? "" : ('<Data ss:Type="' + t + '">' + _v + '</Data>');

	if((cell.c||[]).length > 0) m += write_ws_xlml_comment(cell.c);

	return writextag("Cell", m, attr);
}
function write_ws_xlml_row(R/*:number*/, row)/*:string*/ {
	var o = '<Row ss:Index="' + (R+1) + '"';
	if(row) {
		if(row.hpt && !row.hpx) row.hpx = pt2px(row.hpt);
		if(row.hpx) o += ' ss:AutoFitHeight="0" ss:Height="' + row.hpx + '"';
		if(row.hidden) o += ' ss:Hidden="1"';
	}
	return o + '>';
}
/* TODO */
function write_ws_xlml_table(ws/*:Worksheet*/, opts, idx/*:number*/, wb/*:Workbook*/)/*:string*/ {
	if(!ws['!ref']) return "";
	var range/*:Range*/ = safe_decode_range(ws['!ref']);
	var marr/*:Array<Range>*/ = ws['!merges'] || [], mi = 0;
	var o/*:Array<string>*/ = [];
	if(ws['!cols']) ws['!cols'].forEach(function(n, i) {
		process_col(n);
		var w = !!n.width;
		var p = col_obj_w(i, n);
		var k/*:any*/ = {"ss:Index":i+1};
		if(w) k['ss:Width'] = width2px(p.width);
		if(n.hidden) k['ss:Hidden']="1";
		o.push(writextag("Column",null,k));
	});
	var dense = Array.isArray(ws);
	for(var R = range.s.r; R <= range.e.r; ++R) {
		var row = [write_ws_xlml_row(R, (ws['!rows']||[])[R])];
		for(var C = range.s.c; C <= range.e.c; ++C) {
			var skip = false;
			for(mi = 0; mi != marr.length; ++mi) {
				if(marr[mi].s.c > C) continue;
				if(marr[mi].s.r > R) continue;
				if(marr[mi].e.c < C) continue;
				if(marr[mi].e.r < R) continue;
				if(marr[mi].s.c != C || marr[mi].s.r != R) skip = true;
				break;
			}
			if(skip) continue;
			var addr = {r:R,c:C};
			var ref = encode_cell(addr), cell = dense ? (ws[R]||[])[C] : ws[ref];
			row.push(write_ws_xlml_cell(cell, ref, ws, opts, idx, wb, addr));
		}
		row.push("</Row>");
		if(row.length > 2) o.push(row.join(""));
	}
	return o.join("");
}
function write_ws_xlml(idx/*:number*/, opts, wb/*:Workbook*/)/*:string*/ {
	var o/*:Array<string>*/ = [];
	var s = wb.SheetNames[idx];
	var ws = wb.Sheets[s];

	var t/*:string*/ = ws ? write_ws_xlml_names(ws, opts, idx, wb) : "";
	if(t.length > 0) o.push("<Names>" + t + "</Names>");

	/* Table */
	t = ws ? write_ws_xlml_table(ws, opts, idx, wb) : "";
	if(t.length > 0) o.push("<Table>" + t + "</Table>");

	/* WorksheetOptions */
	o.push(write_ws_xlml_wsopts(ws, opts, idx, wb));

	return o.join("");
}
function write_xlml(wb, opts)/*:string*/ {
	if(!opts) opts = {};
	if(!wb.SSF) wb.SSF = SSF.get_table();
	if(wb.SSF) {
		make_ssf(SSF); SSF.load_table(wb.SSF);
		// $FlowIgnore
		opts.revssf = evert_num(wb.SSF); opts.revssf[wb.SSF[65535]] = 0;
		opts.ssf = wb.SSF;
		opts.cellXfs = [];
		get_cell_style(opts.cellXfs, {}, {revssf:{"General":0}});
	}
	var d/*:Array<string>*/ = [];
	d.push(write_props_xlml(wb, opts));
	d.push(write_wb_xlml());
	d.push("");
	d.push("");
	for(var i = 0; i < wb.SheetNames.length; ++i)
		d.push(writextag("Worksheet", write_ws_xlml(i, opts, wb), {"ss:Name":escapexml(wb.SheetNames[i])}));
	d[2] = write_sty_xlml(wb, opts);
	d[3] = write_names_xlml(wb);
	return XML_HEADER + writextag("Workbook", d.join(""), {
		'xmlns':      XLMLNS.ss,
		'xmlns:o':    XLMLNS.o,
		'xmlns:x':    XLMLNS.x,
		'xmlns:ss':   XLMLNS.ss,
		'xmlns:dt':   XLMLNS.dt,
		'xmlns:html': XLMLNS.html
	});
}
/* [MS-OLEDS] 2.3.8 CompObjStream */
function parse_compobj(obj/*:CFBEntry*/) {
	var v = {};
	var o = obj.content;
	/*:: if(o == null) return; */

	/* [MS-OLEDS] 2.3.7 CompObjHeader -- All fields MUST be ignored */
	o.l = 28;

	v.AnsiUserType = o.read_shift(0, "lpstr-ansi");
	v.AnsiClipboardFormat = parse_ClipboardFormatOrAnsiString(o);

	if(o.length - o.l <= 4) return v;

	var m/*:number*/ = o.read_shift(4);
	if(m == 0 || m > 40) return v;
	o.l-=4; v.Reserved1 = o.read_shift(0, "lpstr-ansi");

	if(o.length - o.l <= 4) return v;
	m = o.read_shift(4);
	if(m !== 0x71b239f4) return v;
	v.UnicodeClipboardFormat = parse_ClipboardFormatOrUnicodeString(o);

	m = o.read_shift(4);
	if(m == 0 || m > 40) return v;
	o.l-=4; v.Reserved2 = o.read_shift(0, "lpwstr");
}

/*
	Continue logic for:
	- 2.4.58 Continue
	- 2.4.59 ContinueBigName
	- 2.4.60 ContinueFrt
	- 2.4.61 ContinueFrt11
	- 2.4.62 ContinueFrt12
*/
function slurp(R, blob, length/*:number*/, opts)/*:any*/ {
	var l = length;
	var bufs = [];
	var d = blob.slice(blob.l,blob.l+l);
	if(opts && opts.enc && opts.enc.insitu && d.length > 0) switch(R.n) {
	case 'BOF': case 'FilePass': case 'FileLock': case 'InterfaceHdr': case 'RRDInfo': case 'RRDHead': case 'UsrExcl': case 'EOF':
		break;
	case 'BoundSheet8':
		break;
	default:
		opts.enc.insitu(d);
	}
	bufs.push(d);
	blob.l += l;
	var next = (XLSRecordEnum[__readUInt16LE(blob,blob.l)]);
	var start = 0;
	while(next != null && next.n.slice(0,8) === 'Continue') {
		l = __readUInt16LE(blob,blob.l+2);
		start = blob.l + 4;
		if(next.n == 'ContinueFrt') start += 4;
		else if(next.n.slice(0,11) == 'ContinueFrt') {
			start += 12;
		}
		d = blob.slice(start,blob.l+4+l);
		bufs.push(d);
		blob.l += 4+l;
		next = (XLSRecordEnum[__readUInt16LE(blob, blob.l)]);
	}
	var b = (bconcat(bufs)/*:any*/);
	prep_blob(b, 0);
	var ll = 0; b.lens = [];
	for(var j = 0; j < bufs.length; ++j) { b.lens.push(ll); ll += bufs[j].length; }
	if(b.length < length) throw "XLS Record " + (R && R.n || "??") + " Truncated: " + b.length + " < " + length;
	return R.f(b, b.length, opts);
}

function safe_format_xf(p/*:any*/, opts/*:ParseOpts*/, date1904/*:?boolean*/) {
	if(p.t === 'z') return;
	if(!p.XF) return;
	var fmtid = 0;
	try {
		fmtid = p.z || p.XF.numFmtId || 0;
		if(opts.cellNF) p.z = SSF._table[fmtid];
	} catch(e) { if(opts.WTF) throw e; }
	if(!opts || opts.cellText !== false) try {
		if(p.t === 'e') { p.w = p.w || BErr[p.v]; }
		else if(fmtid === 0 || fmtid == "General") {
			if(p.t === 'n') {
				if((p.v|0) === p.v) p.w = SSF._general_int(p.v);
				else p.w = SSF._general_num(p.v);
			}
			else p.w = SSF._general(p.v);
		}
		else p.w = SSF.format(fmtid,p.v, {date1904:!!date1904, dateNF: opts && opts.dateNF});
	} catch(e) { if(opts.WTF) throw e; }
	if(opts.cellDates && fmtid && p.t == 'n' && SSF.is_date(SSF._table[fmtid] || String(fmtid))) {
		var _d = SSF.parse_date_code(p.v); if(_d) { p.t = 'd'; p.v = new Date(_d.y, _d.m-1,_d.d,_d.H,_d.M,_d.S,_d.u); }
	}
}

function make_cell(val, ixfe, t)/*:Cell*/ {
	return ({v:val, ixfe:ixfe, t:t}/*:any*/);
}

// 2.3.2
function parse_workbook(blob, options/*:ParseOpts*/)/*:Workbook*/ {
	var wb = ({opts:{}}/*:any*/);
	var Sheets = {};
	var out/*:Worksheet*/ = ((options.dense ? [] : {})/*:any*/);
	var Directory = {};
	var range/*:Range*/ = ({}/*:any*/);
	var last_formula = null;
	var sst/*:SST*/ = ([]/*:any*/);
	var cur_sheet = "";
	var Preamble = {};
	var lastcell, last_cell = "", cc/*:Cell*/, cmnt, rngC, rngR;
	var sharedf = {};
	var arrayf/*:Array<[Range, string]>*/ = [];
	var temp_val/*:Cell*/;
	var country;
	var XFs = []; /* XF records */
	var palette/*:Array<[number, number, number]>*/ = [];
	var Workbook/*:WBWBProps*/ = ({ Sheets:[], WBProps:{date1904:false}, Views:[{}] }/*:any*/), wsprops = {};
	var get_rgb = function getrgb(icv/*:number*/)/*:[number, number, number]*/ {
		if(icv < 8) return XLSIcv[icv];
		if(icv < 64) return palette[icv-8] || XLSIcv[icv];
		return XLSIcv[icv];
	};
	var process_cell_style = function pcs(cell, line/*:any*/, options) {
		var xfd = line.XF.data;
		if(!xfd || !xfd.patternType || !options || !options.cellStyles) return;
		line.s = ({}/*:any*/);
		line.s.patternType = xfd.patternType;
		var t;
		if((t = rgb2Hex(get_rgb(xfd.icvFore)))) { line.s.fgColor = {rgb:t}; }
		if((t = rgb2Hex(get_rgb(xfd.icvBack)))) { line.s.bgColor = {rgb:t}; }
	};
	var addcell = function addcell(cell/*:any*/, line/*:any*/, options/*:any*/) {
		if(file_depth > 1) return;
		if(options.sheetRows && cell.r >= options.sheetRows) return;
		if(options.cellStyles && line.XF && line.XF.data) process_cell_style(cell, line, options);
		delete line.ixfe; delete line.XF;
		lastcell = cell;
		last_cell = encode_cell(cell);
		if(!range || !range.s || !range.e) range = {s:{r:0,c:0},e:{r:0,c:0}};
		if(cell.r < range.s.r) range.s.r = cell.r;
		if(cell.c < range.s.c) range.s.c = cell.c;
		if(cell.r + 1 > range.e.r) range.e.r = cell.r + 1;
		if(cell.c + 1 > range.e.c) range.e.c = cell.c + 1;
		if(options.cellFormula && line.f) {
			for(var afi = 0; afi < arrayf.length; ++afi) {
				if(arrayf[afi][0].s.c > cell.c || arrayf[afi][0].s.r > cell.r) continue;
				if(arrayf[afi][0].e.c < cell.c || arrayf[afi][0].e.r < cell.r) continue;
				line.F = encode_range(arrayf[afi][0]);
				if(arrayf[afi][0].s.c != cell.c || arrayf[afi][0].s.r != cell.r) delete line.f;
				if(line.f) line.f = "" + stringify_formula(arrayf[afi][1], range, cell, supbooks, opts);
				break;
			}
		}
		{
			if(options.dense) {
				if(!out[cell.r]) out[cell.r] = [];
				out[cell.r][cell.c] = line;
			} else out[last_cell] = line;
		}
	};
	var opts = ({
		enc: false, // encrypted
		sbcch: 0, // cch in the preceding SupBook
		snames: [], // sheetnames
		sharedf: sharedf, // shared formulae by address
		arrayf: arrayf, // array formulae array
		rrtabid: [], // RRTabId
		lastuser: "", // Last User from WriteAccess
		biff: 8, // BIFF version
		codepage: 0, // CP from CodePage record
		winlocked: 0, // fLockWn from WinProtect
		cellStyles: !!options && !!options.cellStyles,
		WTF: !!options && !!options.wtf
	}/*:any*/);
	if(options.password) opts.password = options.password;
	var themes;
	var merges/*:Array<Range>*/ = [];
	var objects = [];
	var colinfo/*:Array<ColInfo>*/ = [], rowinfo/*:Array<RowInfo>*/ = [];
	// eslint-disable-next-line no-unused-vars
	var defwidth = 0, defheight = 0; // twips / MDW respectively
	var seencol = false;
	var supbooks = ([]/*:any*/); // 1-indexed, will hold extern names
	supbooks.SheetNames = opts.snames;
	supbooks.sharedf = opts.sharedf;
	supbooks.arrayf = opts.arrayf;
	supbooks.names = [];
	supbooks.XTI = [];
	var last_Rn = '';
	var file_depth = 0; /* TODO: make a real stack */
	var BIFF2Fmt = 0, BIFF2FmtTable/*:Array<string>*/ = [];
	var FilterDatabases = []; /* TODO: sort out supbooks and process elsewhere */
	var last_lbl/*:?DefinedName*/;

	/* explicit override for some broken writers */
	opts.codepage = 1200;
	set_cp(1200);
	var seen_codepage = false;
	while(blob.l < blob.length - 1) {
		var s = blob.l;
		var RecordType = blob.read_shift(2);
		if(RecordType === 0 && last_Rn === 'EOF') break;
		var length = (blob.l === blob.length ? 0 : blob.read_shift(2));
		var R = XLSRecordEnum[RecordType];
		//console.log(RecordType.toString(16), RecordType, R, blob.l, length, blob.length);
		//if(!R) console.log(blob.slice(blob.l, blob.l + length));
		if(R && R.f) {
			if(options.bookSheets) {
				if(last_Rn === 'BoundSheet8' && R.n !== 'BoundSheet8') break;
			}
			last_Rn = R.n;
			if(R.r === 2 || R.r == 12) {
				var rt = blob.read_shift(2); length -= 2;
				if(!opts.enc && rt !== RecordType && (((rt&0xFF)<<8)|(rt>>8)) !== RecordType) throw new Error("rt mismatch: " + rt + "!=" + RecordType);
				if(R.r == 12){
					blob.l += 10; length -= 10;
				} // skip FRT
			}
			//console.error(R,blob.l,length,blob.length);
			var val/*:any*/ = ({}/*:any*/);
			if(R.n === 'EOF') val = /*::(*/R.f(blob, length, opts)/*:: :any)*/;
			else val = /*::(*/slurp(R, blob, length, opts)/*:: :any)*/;
			var Rn = R.n;
			/*:: val = (val:any); */
			if(file_depth == 0 && Rn != 'BOF') continue;
			/* nested switch statements to workaround V8 128 limit */
			switch(Rn) {
				/* Workbook Options */
				case 'Date1904':
					/*:: if(!Workbook.WBProps) Workbook.WBProps = {}; */
					wb.opts.Date1904 = Workbook.WBProps.date1904 = val; break;
				case 'WriteProtect': wb.opts.WriteProtect = true; break;
				case 'FilePass':
					if(!opts.enc) blob.l = 0;
					opts.enc = val;
					if(!options.password) throw new Error("File is password-protected");
					if(val.valid == null) throw new Error("Encryption scheme unsupported");
					if(!val.valid) throw new Error("Password is incorrect");
					break;
				case 'WriteAccess': opts.lastuser = val; break;
				case 'FileSharing': break; //TODO
				case 'CodePage':
					var cpval = Number(val);
					/* overrides based on test cases */
					switch(cpval) {
						case 0x5212: cpval =  1200; break;
						case 0x8000: cpval = 10000; break;
						case 0x8001: cpval =  1252; break;
					}
					set_cp(opts.codepage = cpval);
					seen_codepage = true;
					break;
				case 'RRTabId': opts.rrtabid = val; break;
				case 'WinProtect': opts.winlocked = val; break;
				case 'Template': break; // TODO
				case 'BookBool': break; // TODO
				case 'UsesELFs': break;
				case 'MTRSettings': break;
				case 'RefreshAll':
				case 'CalcCount':
				case 'CalcDelta':
				case 'CalcIter':
				case 'CalcMode':
				case 'CalcPrecision':
				case 'CalcSaveRecalc':
					wb.opts[Rn] = val; break;
				case 'CalcRefMode': opts.CalcRefMode = val; break; // TODO: implement R1C1
				case 'Uncalced': break;
				case 'ForceFullCalculation': wb.opts.FullCalc = val; break;
				case 'WsBool':
					if(val.fDialog) out["!type"] = "dialog";
					if(!val.fBelow) (out["!outline"] || (out["!outline"] = {})).above = true;
					if(!val.fRight) (out["!outline"] || (out["!outline"] = {})).left = true;
					break; // TODO
				case 'XF':
					XFs.push(val); break;
				case 'ExtSST': break; // TODO
				case 'BookExt': break; // TODO
				case 'RichTextStream': break;
				case 'BkHim': break;

				case 'SupBook':
					supbooks.push([val]);
					supbooks[supbooks.length-1].XTI = [];
					break;
				case 'ExternName':
					supbooks[supbooks.length-1].push(val);
					break;
				case 'Index': break; // TODO
				case 'Lbl':
					last_lbl = ({
						Name: val.Name,
						Ref: stringify_formula(val.rgce,range,null,supbooks,opts)
					}/*:DefinedName*/);
					if(val.itab > 0) last_lbl.Sheet = val.itab - 1;
					supbooks.names.push(last_lbl);
					if(!supbooks[0]) { supbooks[0] = []; supbooks[0].XTI = []; }
					supbooks[supbooks.length-1].push(val);
					if(val.Name == "_xlnm._FilterDatabase" && val.itab > 0)
						if(val.rgce && val.rgce[0] && val.rgce[0][0] && val.rgce[0][0][0] == 'PtgArea3d')
							FilterDatabases[val.itab - 1] = { ref: encode_range(val.rgce[0][0][1][2]) };
					break;
				case 'ExternCount': opts.ExternCount = val; break;
				case 'ExternSheet':
					if(supbooks.length == 0) { supbooks[0] = []; supbooks[0].XTI = []; }
					supbooks[supbooks.length - 1].XTI = supbooks[supbooks.length - 1].XTI.concat(val); supbooks.XTI = supbooks.XTI.concat(val); break;
				case 'NameCmt':
					/* TODO: search for correct name */
					if(opts.biff < 8) break;
					if(last_lbl != null) last_lbl.Comment = val[1];
					break;

				case 'Protect': out["!protect"] = val; break; /* for sheet or book */
				case 'Password': if(val !== 0 && opts.WTF) console.error("Password verifier: " + val); break;
				case 'Prot4Rev': case 'Prot4RevPass': break; /*TODO: Revision Control*/

				case 'BoundSheet8': {
					Directory[val.pos] = val;
					opts.snames.push(val.name);
				} break;
				case 'EOF': {
					if(--file_depth) break;
					if(range.e) {
						if(range.e.r > 0 && range.e.c > 0) {
							range.e.r--; range.e.c--;
							out["!ref"] = encode_range(range);
							if(options.sheetRows && options.sheetRows <= range.e.r) {
								var tmpri = range.e.r;
								range.e.r = options.sheetRows - 1;
								out["!fullref"] = out["!ref"];
								out["!ref"] = encode_range(range);
								range.e.r = tmpri;
							}
							range.e.r++; range.e.c++;
						}
						if(merges.length > 0) out["!merges"] = merges;
						if(objects.length > 0) out["!objects"] = objects;
						if(colinfo.length > 0) out["!cols"] = colinfo;
						if(rowinfo.length > 0) out["!rows"] = rowinfo;
						Workbook.Sheets.push(wsprops);
					}
					if(cur_sheet === "") Preamble = out; else Sheets[cur_sheet] = out;
					out = ((options.dense ? [] : {})/*:any*/);
				} break;
				case 'BOF': {
					if(opts.biff === 8) opts.biff = {
						/*::[*/0x0009/*::]*/:2,
						/*::[*/0x0209/*::]*/:3,
						/*::[*/0x0409/*::]*/:4
					}[RecordType] || {
						/*::[*/0x0200/*::]*/:2,
						/*::[*/0x0300/*::]*/:3,
						/*::[*/0x0400/*::]*/:4,
						/*::[*/0x0500/*::]*/:5,
						/*::[*/0x0600/*::]*/:8,
						/*::[*/0x0002/*::]*/:2,
						/*::[*/0x0007/*::]*/:2
					}[val.BIFFVer] || 8;
					opts.biffguess = val.BIFFVer == 0;
					if(val.BIFFVer == 0 && val.dt == 0x1000) { opts.biff = 5; seen_codepage = true; set_cp(opts.codepage = 28591); }
					if(opts.biff == 8 && val.BIFFVer == 0 && val.dt == 16) opts.biff = 2;
					if(file_depth++) break;
					out = ((options.dense ? [] : {})/*:any*/);

					if(opts.biff < 8 && !seen_codepage) { seen_codepage = true; set_cp(opts.codepage = options.codepage || 1252); }

					if(opts.biff < 5 || val.BIFFVer == 0 && val.dt == 0x1000) {
						if(cur_sheet === "") cur_sheet = "Sheet1";
						range = {s:{r:0,c:0},e:{r:0,c:0}};
						/* fake BoundSheet8 */
						var fakebs8 = {pos: blob.l - length, name:cur_sheet};
						Directory[fakebs8.pos] = fakebs8;
						opts.snames.push(cur_sheet);
					}
					else cur_sheet = (Directory[s] || {name:""}).name;
					if(val.dt == 0x20) out["!type"] = "chart";
					if(val.dt == 0x40) out["!type"] = "macro";
					merges = [];
					objects = [];
					opts.arrayf = arrayf = [];
					colinfo = []; rowinfo = [];
					defwidth = defheight = 0;
					seencol = false;
					wsprops = {Hidden:(Directory[s]||{hs:0}).hs, name:cur_sheet };
				} break;

				case 'Number': case 'BIFF2NUM': case 'BIFF2INT': {
					if(out["!type"] == "chart") if(options.dense ? (out[val.r]||[])[val.c]: out[encode_cell({c:val.c, r:val.r})]) ++val.c;
					temp_val = ({ixfe: val.ixfe, XF: XFs[val.ixfe]||{}, v:val.val, t:'n'}/*:any*/);
					if(BIFF2Fmt > 0) temp_val.z = BIFF2FmtTable[(temp_val.ixfe>>8) & 0x3F];
					safe_format_xf(temp_val, options, wb.opts.Date1904);
					addcell({c:val.c, r:val.r}, temp_val, options);
				} break;
				case 'BoolErr': {
					temp_val = ({ixfe: val.ixfe, XF: XFs[val.ixfe], v:val.val, t:val.t}/*:any*/);
					if(BIFF2Fmt > 0) temp_val.z = BIFF2FmtTable[(temp_val.ixfe>>8) & 0x3F];
					safe_format_xf(temp_val, options, wb.opts.Date1904);
					addcell({c:val.c, r:val.r}, temp_val, options);
				} break;
				case 'RK': {
					temp_val = ({ixfe: val.ixfe, XF: XFs[val.ixfe], v:val.rknum, t:'n'}/*:any*/);
					if(BIFF2Fmt > 0) temp_val.z = BIFF2FmtTable[(temp_val.ixfe>>8) & 0x3F];
					safe_format_xf(temp_val, options, wb.opts.Date1904);
					addcell({c:val.c, r:val.r}, temp_val, options);
				} break;
				case 'MulRk': {
					for(var j = val.c; j <= val.C; ++j) {
						var ixfe = val.rkrec[j-val.c][0];
						temp_val= ({ixfe:ixfe, XF:XFs[ixfe], v:val.rkrec[j-val.c][1], t:'n'}/*:any*/);
						if(BIFF2Fmt > 0) temp_val.z = BIFF2FmtTable[(temp_val.ixfe>>8) & 0x3F];
						safe_format_xf(temp_val, options, wb.opts.Date1904);
						addcell({c:j, r:val.r}, temp_val, options);
					}
				} break;
				case 'Formula': {
					if(val.val == 'String') { last_formula = val; break; }
					temp_val = make_cell(val.val, val.cell.ixfe, val.tt);
					temp_val.XF = XFs[temp_val.ixfe];
					if(options.cellFormula) {
						var _f = val.formula;
						if(_f && _f[0] && _f[0][0] && _f[0][0][0] == 'PtgExp') {
							var _fr = _f[0][0][1][0], _fc = _f[0][0][1][1];
							var _fe = encode_cell({r:_fr, c:_fc});
							if(sharedf[_fe]) temp_val.f = ""+stringify_formula(val.formula,range,val.cell,supbooks, opts);
							else temp_val.F = ((options.dense ? (out[_fr]||[])[_fc]: out[_fe]) || {}).F;
						} else temp_val.f = ""+stringify_formula(val.formula,range,val.cell,supbooks, opts);
					}
					if(BIFF2Fmt > 0) temp_val.z = BIFF2FmtTable[(temp_val.ixfe>>8) & 0x3F];
					safe_format_xf(temp_val, options, wb.opts.Date1904);
					addcell(val.cell, temp_val, options);
					last_formula = val;
				} break;
				case 'String': {
					if(last_formula) { /* technically always true */
						last_formula.val = val;
						temp_val = make_cell(val, last_formula.cell.ixfe, 's');
						temp_val.XF = XFs[temp_val.ixfe];
						if(options.cellFormula) {
							temp_val.f = ""+stringify_formula(last_formula.formula, range, last_formula.cell, supbooks, opts);
						}
						if(BIFF2Fmt > 0) temp_val.z = BIFF2FmtTable[(temp_val.ixfe>>8) & 0x3F];
						safe_format_xf(temp_val, options, wb.opts.Date1904);
						addcell(last_formula.cell, temp_val, options);
						last_formula = null;
					} else throw new Error("String record expects Formula");
				} break;
				case 'Array': {
					arrayf.push(val);
					var _arraystart = encode_cell(val[0].s);
					cc = options.dense ? (out[val[0].s.r]||[])[val[0].s.c] : out[_arraystart];
					if(options.cellFormula && cc) {
						if(!last_formula) break; /* technically unreachable */
						if(!_arraystart || !cc) break;
						cc.f = ""+stringify_formula(val[1], range, val[0], supbooks, opts);
						cc.F = encode_range(val[0]);
					}
				} break;
				case 'ShrFmla': {
					if(!options.cellFormula) break;
					if(last_cell) {
						/* TODO: capture range */
						if(!last_formula) break; /* technically unreachable */
						sharedf[encode_cell(last_formula.cell)]= val[0];
						cc = options.dense ? (out[last_formula.cell.r]||[])[last_formula.cell.c] : out[encode_cell(last_formula.cell)];
						(cc||{}).f = ""+stringify_formula(val[0], range, lastcell, supbooks, opts);
					}
				} break;
				case 'LabelSst':
					temp_val=make_cell(sst[val.isst].t, val.ixfe, 's');
					if(sst[val.isst].h) temp_val.h = sst[val.isst].h;
					temp_val.XF = XFs[temp_val.ixfe];
					if(BIFF2Fmt > 0) temp_val.z = BIFF2FmtTable[(temp_val.ixfe>>8) & 0x3F];
					safe_format_xf(temp_val, options, wb.opts.Date1904);
					addcell({c:val.c, r:val.r}, temp_val, options);
					break;
				case 'Blank': if(options.sheetStubs) {
					temp_val = ({ixfe: val.ixfe, XF: XFs[val.ixfe], t:'z'}/*:any*/);
					if(BIFF2Fmt > 0) temp_val.z = BIFF2FmtTable[(temp_val.ixfe>>8) & 0x3F];
					safe_format_xf(temp_val, options, wb.opts.Date1904);
					addcell({c:val.c, r:val.r}, temp_val, options);
				} break;
				case 'MulBlank': if(options.sheetStubs) {
					for(var _j = val.c; _j <= val.C; ++_j) {
						var _ixfe = val.ixfe[_j-val.c];
						temp_val= ({ixfe:_ixfe, XF:XFs[_ixfe], t:'z'}/*:any*/);
						if(BIFF2Fmt > 0) temp_val.z = BIFF2FmtTable[(temp_val.ixfe>>8) & 0x3F];
						safe_format_xf(temp_val, options, wb.opts.Date1904);
						addcell({c:_j, r:val.r}, temp_val, options);
					}
				} break;
				case 'RString':
				case 'Label': case 'BIFF2STR':
					temp_val=make_cell(val.val, val.ixfe, 's');
					temp_val.XF = XFs[temp_val.ixfe];
					if(BIFF2Fmt > 0) temp_val.z = BIFF2FmtTable[(temp_val.ixfe>>8) & 0x3F];
					safe_format_xf(temp_val, options, wb.opts.Date1904);
					addcell({c:val.c, r:val.r}, temp_val, options);
					break;

				case 'Dimensions': {
					if(file_depth === 1) range = val; /* TODO: stack */
				} break;
				case 'SST': {
					sst = val;
				} break;
				case 'Format': { /* val = [id, fmt] */
					if(opts.biff == 4) {
						BIFF2FmtTable[BIFF2Fmt++] = val[1];
						for(var b4idx = 0; b4idx < BIFF2Fmt + 163; ++b4idx) if(SSF._table[b4idx] == val[1]) break;
						if(b4idx >= 163) SSF.load(val[1], BIFF2Fmt + 163);
					}
					else SSF.load(val[1], val[0]);
				} break;
				case 'BIFF2FORMAT': {
					BIFF2FmtTable[BIFF2Fmt++] = val;
					for(var b2idx = 0; b2idx < BIFF2Fmt + 163; ++b2idx) if(SSF._table[b2idx] == val) break;
					if(b2idx >= 163) SSF.load(val, BIFF2Fmt + 163);
				} break;

				case 'MergeCells': merges = merges.concat(val); break;

				case 'Obj': objects[val.cmo[0]] = opts.lastobj = val; break;
				case 'TxO': opts.lastobj.TxO = val; break;
				case 'ImData': opts.lastobj.ImData = val; break;

				case 'HLink': {
					for(rngR = val[0].s.r; rngR <= val[0].e.r; ++rngR)
						for(rngC = val[0].s.c; rngC <= val[0].e.c; ++rngC) {
							cc = options.dense ? (out[rngR]||[])[rngC] : out[encode_cell({c:rngC,r:rngR})];
							if(cc) cc.l = val[1];
						}
				} break;
				case 'HLinkTooltip': {
					for(rngR = val[0].s.r; rngR <= val[0].e.r; ++rngR)
						for(rngC = val[0].s.c; rngC <= val[0].e.c; ++rngC) {
							cc = options.dense ? (out[rngR]||[])[rngC] : out[encode_cell({c:rngC,r:rngR})];
							if(cc && cc.l) cc.l.Tooltip = val[1];
							}
				} break;

				/* Comments */
				case 'Note': {
					if(opts.biff <= 5 && opts.biff >= 2) break; /* TODO: BIFF5 */
					cc = options.dense ? (out[val[0].r]||[])[val[0].c] : out[encode_cell(val[0])];
					var noteobj = objects[val[2]];
					if(!cc) {
						if(options.dense) {
							if(!out[val[0].r]) out[val[0].r] = [];
							cc = out[val[0].r][val[0].c] = ({t:"z"}/*:any*/);
						} else {
							cc = out[encode_cell(val[0])] = ({t:"z"}/*:any*/);
						}
						range.e.r = Math.max(range.e.r, val[0].r);
						range.s.r = Math.min(range.s.r, val[0].r);
						range.e.c = Math.max(range.e.c, val[0].c);
						range.s.c = Math.min(range.s.c, val[0].c);
					}
					if(!cc.c) cc.c = [];
					cmnt = {a:val[1],t:noteobj.TxO.t};
					cc.c.push(cmnt);
				} break;

				default: switch(R.n) { /* nested */
				case 'ClrtClient': break;
				case 'XFExt': update_xfext(XFs[val.ixfe], val.ext); break;

				case 'DefColWidth': defwidth = val; break;
				case 'DefaultRowHeight': defheight = val[1]; break; // TODO: flags

				case 'ColInfo': {
					if(!opts.cellStyles) break;
					while(val.e >= val.s) {
						colinfo[val.e--] = { width: val.w/256, level: (val.level || 0), hidden: !!(val.flags & 1) };
						if(!seencol) { seencol = true; find_mdw_colw(val.w/256); }
						process_col(colinfo[val.e+1]);
					}
				} break;
				case 'Row': {
					var rowobj = {};
					if(val.level != null) { rowinfo[val.r] = rowobj; rowobj.level = val.level; }
					if(val.hidden) { rowinfo[val.r] = rowobj; rowobj.hidden = true; }
					if(val.hpt) {
						rowinfo[val.r] = rowobj;
						rowobj.hpt = val.hpt; rowobj.hpx = pt2px(val.hpt);
					}
				} break;

				case 'LeftMargin':
				case 'RightMargin':
				case 'TopMargin':
				case 'BottomMargin':
					if(!out['!margins']) default_margins(out['!margins'] = {});
					out['!margins'][Rn.slice(0,-6).toLowerCase()] = val;
					break;

				case 'Selection': break;

				case 'Setup': // TODO
					if(!out['!margins']) default_margins(out['!margins'] = {});
					out['!margins'].header = val.header;
					out['!margins'].footer = val.footer;
					break;

				case 'Window2': // TODO
					// $FlowIgnore
					if(val.RTL) Workbook.Views[0].RTL = true;
					break;

				case 'Header': break; // TODO
				case 'Footer': break; // TODO
				case 'HCenter': break; // TODO
				case 'VCenter': break; // TODO
				case 'Pls': break; // TODO
				case 'GCW': break;
				case 'LHRecord': break;
				case 'DBCell': break; // TODO
				case 'EntExU2': break; // TODO
				case 'SxView': break; // TODO
				case 'Sxvd': break; // TODO
				case 'SXVI': break; // TODO
				case 'SXVDEx': break; // TODO
				case 'SxIvd': break; // TODO
				case 'SXString': break; // TODO
				case 'Sync': break;
				case 'Addin': break;
				case 'SXDI': break; // TODO
				case 'SXLI': break; // TODO
				case 'SXEx': break; // TODO
				case 'QsiSXTag': break; // TODO
				case 'Feat': break;
				case 'FeatHdr': case 'FeatHdr11': break;
				case 'Feature11': case 'Feature12': case 'List12': break;
				case 'Country': country = val; break;
				case 'RecalcId': break;
				case 'DxGCol': break; // TODO: htmlify
				case 'Fbi': case 'Fbi2': case 'GelFrame': break;
				case 'Font': break; // TODO
				case 'XFCRC': break; // TODO
				case 'Style': break; // TODO
				case 'StyleExt': break; // TODO
				case 'Palette': palette = val; break;
				case 'Theme': themes = val; break;
				/* Protection */
				case 'ScenarioProtect': break;
				case 'ObjProtect': break;

				/* Conditional Formatting */
				case 'CondFmt12': break;

				/* Table */
				case 'Table': break; // TODO
				case 'TableStyles': break; // TODO
				case 'TableStyle': break; // TODO
				case 'TableStyleElement': break; // TODO

				/* PivotTable */
				case 'SXStreamID': break; // TODO
				case 'SXVS': break; // TODO
				case 'DConRef': break; // TODO
				case 'SXAddl': break; // TODO
				case 'DConBin': break; // TODO
				case 'DConName': break; // TODO
				case 'SXPI': break; // TODO
				case 'SxFormat': break; // TODO
				case 'SxSelect': break; // TODO
				case 'SxRule': break; // TODO
				case 'SxFilt': break; // TODO
				case 'SxItm': break; // TODO
				case 'SxDXF': break; // TODO

				/* Scenario Manager */
				case 'ScenMan': break;

				/* Data Consolidation */
				case 'DCon': break;

				/* Watched Cell */
				case 'CellWatch': break;

				/* Print Settings */
				case 'PrintRowCol': break;
				case 'PrintGrid': break;
				case 'PrintSize': break;

				case 'XCT': break;
				case 'CRN': break;

				case 'Scl': break;
				case 'SheetExt': break;
				case 'SheetExtOptional': break;

				/* VBA */
				case 'ObNoMacros': break;
				case 'ObProj': break;
				case 'CodeName': {
					/*:: if(!Workbook.WBProps) Workbook.WBProps = {}; */
					if(!cur_sheet) Workbook.WBProps.CodeName = val || "ThisWorkbook";
					else wsprops.CodeName = val || wsprops.name;
				} break;
				case 'GUIDTypeLib': break;

				case 'WOpt': break; // TODO: WTF?
				case 'PhoneticInfo': break;

				case 'OleObjectSize': break;

				/* Differential Formatting */
				case 'DXF': case 'DXFN': case 'DXFN12': case 'DXFN12List': case 'DXFN12NoCB': break;

				/* Data Validation */
				case 'Dv': case 'DVal': break;

				/* Data Series */
				case 'BRAI': case 'Series': case 'SeriesText': break;

				/* Data Connection */
				case 'DConn': break;
				case 'DbOrParamQry': break;
				case 'DBQueryExt': break;

				case 'OleDbConn': break;
				case 'ExtString': break;

				/* Formatting */
				case 'IFmtRecord': break;
				case 'CondFmt': case 'CF': case 'CF12': case 'CFEx': break;

				/* Explicitly Ignored */
				case 'Excel9File': break;
				case 'Units': break;
				case 'InterfaceHdr': case 'Mms': case 'InterfaceEnd': case 'DSF': break;
				case 'BuiltInFnGroupCount': /* 2.4.30 0x0E or 0x10 but excel 2011 generates 0x11? */ break;
				/* View Stuff */
				case 'Window1': case 'HideObj': case 'GridSet': case 'Guts':
				case 'UserBView': case 'UserSViewBegin': case 'UserSViewEnd': break;
				case 'Pane': break;
				default: switch(R.n) { /* nested */
				/* Chart */
				case 'Dat':
				case 'Begin': case 'End':
				case 'StartBlock': case 'EndBlock':
				case 'Frame': case 'Area':
				case 'Axis': case 'AxisLine': case 'Tick': break;
				case 'AxesUsed':
				case 'CrtLayout12': case 'CrtLayout12A': case 'CrtLink': case 'CrtLine': case 'CrtMlFrt': case 'CrtMlFrtContinue': break;
				case 'LineFormat': case 'AreaFormat':
				case 'Chart': case 'Chart3d': case 'Chart3DBarShape': case 'ChartFormat': case 'ChartFrtInfo': break;
				case 'PlotArea': case 'PlotGrowth': break;
				case 'SeriesList': case 'SerParent': case 'SerAuxTrend': break;
				case 'DataFormat': case 'SerToCrt': case 'FontX': break;
				case 'CatSerRange': case 'AxcExt': case 'SerFmt': break;
				case 'ShtProps': break;
				case 'DefaultText': case 'Text': case 'CatLab': break;
				case 'DataLabExtContents': break;
				case 'Legend': case 'LegendException': break;
				case 'Pie': case 'Scatter': break;
				case 'PieFormat': case 'MarkerFormat': break;
				case 'StartObject': case 'EndObject': break;
				case 'AlRuns': case 'ObjectLink': break;
				case 'SIIndex': break;
				case 'AttachedLabel': case 'YMult': break;

				/* Chart Group */
				case 'Line': case 'Bar': break;
				case 'Surf': break;

				/* Axis Group */
				case 'AxisParent': break;
				case 'Pos': break;
				case 'ValueRange': break;

				/* Pivot Chart */
				case 'SXViewEx9': break; // TODO
				case 'SXViewLink': break;
				case 'PivotChartBits': break;
				case 'SBaseRef': break;
				case 'TextPropsStream': break;

				/* Chart Misc */
				case 'LnExt': break;
				case 'MkrExt': break;
				case 'CrtCoopt': break;

				/* Query Table */
				case 'Qsi': case 'Qsif': case 'Qsir': case 'QsiSXTag': break;
				case 'TxtQry': break;

				/* Filter */
				case 'FilterMode': break;
				case 'AutoFilter': case 'AutoFilterInfo': break;
				case 'AutoFilter12': break;
				case 'DropDownObjIds': break;
				case 'Sort': break;
				case 'SortData': break;

				/* Drawing */
				case 'ShapePropsStream': break;
				case 'MsoDrawing': case 'MsoDrawingGroup': case 'MsoDrawingSelection': break;
				/* Pub Stuff */
				case 'WebPub': case 'AutoWebPub': break;

				/* Print Stuff */
				case 'HeaderFooter': case 'HFPicture': case 'PLV':
				case 'HorizontalPageBreaks': case 'VerticalPageBreaks': break;
				/* Behavioral */
				case 'Backup': case 'CompressPictures': case 'Compat12': break;

				/* Should not Happen */
				case 'Continue': case 'ContinueFrt12': break;

				/* Future Records */
				case 'FrtFontList': case 'FrtWrapper': break;

				default: switch(R.n) { /* nested */
				/* BIFF5 records */
				case 'TabIdConf': case 'Radar': case 'RadarArea': case 'DropBar': case 'Intl': case 'CoordList': case 'SerAuxErrBar': break;

				/* BIFF2-4 records */
				case 'BIFF2FONTCLR': case 'BIFF2FMTCNT': case 'BIFF2FONTXTRA': break;
				case 'BIFF2XF': case 'BIFF3XF': case 'BIFF4XF': break;
				case 'BIFF2XFINDEX': break;
				case 'BIFF4FMTCNT': case 'BIFF2ROW': case 'BIFF2WINDOW2': break;

				/* Miscellaneous */
				case 'SCENARIO': case 'DConBin': case 'PicF': case 'DataLabExt':
				case 'Lel': case 'BopPop': case 'BopPopCustom': case 'RealTimeData':
				case 'Name': break;
				case 'LHNGraph': case 'FnGroupName': case 'AddMenu': case 'LPr': break;
				case 'ListObj': case 'ListField': break;
				case 'RRSort': break;
				case 'BigName': break;
				case 'ToolbarHdr': case 'ToolbarEnd': break;
				case 'DDEObjName': break;
				case 'FRTArchId$': break;
				default: if(options.WTF) throw 'Unrecognized Record ' + R.n;
			}}}}
		} else blob.l += length;
	}
	wb.SheetNames=keys$1(Directory).sort(function(a,b) { return Number(a) - Number(b); }).map(function(x){return Directory[x].name;});
	if(!options.bookSheets) wb.Sheets=Sheets;
	if(!wb.SheetNames.length && Preamble["!ref"]) {
		wb.SheetNames.push("Sheet1");
		/*jshint -W069 */
		if(wb.Sheets) wb.Sheets["Sheet1"] = Preamble;
		/*jshint +W069 */
	} else wb.Preamble=Preamble;
	if(wb.Sheets) FilterDatabases.forEach(function(r,i) { wb.Sheets[wb.SheetNames[i]]['!autofilter'] = r; });
	wb.Strings = sst;
	wb.SSF = SSF.get_table();
	if(opts.enc) wb.Encryption = opts.enc;
	if(themes) wb.Themes = themes;
	wb.Metadata = {};
	if(country !== undefined) wb.Metadata.Country = country;
	if(supbooks.names.length > 0) Workbook.Names = supbooks.names;
	wb.Workbook = Workbook;
	return wb;
}

/* TODO: split props*/
var PSCLSID = {
	SI: "e0859ff2f94f6810ab9108002b27b3d9",
	DSI: "02d5cdd59c2e1b10939708002b2cf9ae",
	UDI: "05d5cdd59c2e1b10939708002b2cf9ae"
};
function parse_xls_props(cfb/*:CFBContainer*/, props, o) {
	/* [MS-OSHARED] 2.3.3.2.2 Document Summary Information Property Set */
	var DSI = CFB.find(cfb, '/!DocumentSummaryInformation');
	if(DSI && DSI.size > 0) try {
		var DocSummary = parse_PropertySetStream(DSI, DocSummaryPIDDSI, PSCLSID.DSI);
		for(var d in DocSummary) props[d] = DocSummary[d];
	} catch(e) {if(o.WTF) throw e;/* empty */}

	/* [MS-OSHARED] 2.3.3.2.1 Summary Information Property Set*/
	var SI = CFB.find(cfb, '/!SummaryInformation');
	if(SI && SI.size > 0) try {
		var Summary = parse_PropertySetStream(SI, SummaryPIDSI, PSCLSID.SI);
		for(var s in Summary) if(props[s] == null) props[s] = Summary[s];
	} catch(e) {if(o.WTF) throw e;/* empty */}

	if(props.HeadingPairs && props.TitlesOfParts) {
		load_props_pairs(props.HeadingPairs, props.TitlesOfParts, props, o);
		delete props.HeadingPairs; delete props.TitlesOfParts;
	}
}
function write_xls_props(wb/*:Workbook*/, cfb/*:CFBContainer*/) {
	var DSEntries = [], SEntries = [], CEntries = [];
	var i = 0, Keys;
	if(wb.Props) {
		Keys = keys$1(wb.Props);
		// $FlowIgnore
		for(i = 0; i < Keys.length; ++i) (Object.prototype.hasOwnProperty.call(DocSummaryRE, Keys[i]) ? DSEntries : Object.prototype.hasOwnProperty.call(SummaryRE, Keys[i]) ? SEntries : CEntries).push([Keys[i], wb.Props[Keys[i]]]);
	}
	if(wb.Custprops) {
		Keys = keys$1(wb.Custprops);
		// $FlowIgnore
		for(i = 0; i < Keys.length; ++i) if(!Object.prototype.hasOwnProperty.call((wb.Props||{}), Keys[i])) (Object.prototype.hasOwnProperty.call(DocSummaryRE, Keys[i]) ? DSEntries : Object.prototype.hasOwnProperty.call(SummaryRE, Keys[i]) ? SEntries : CEntries).push([Keys[i], wb.Custprops[Keys[i]]]);
	}
	var CEntries2 = [];
	for(i = 0; i < CEntries.length; ++i) {
		if(XLSPSSkip.indexOf(CEntries[i][0]) > -1) continue;
		if(CEntries[i][1] == null) continue;
		CEntries2.push(CEntries[i]);
	}
	if(SEntries.length) CFB.utils.cfb_add(cfb, "/\u0005SummaryInformation", write_PropertySetStream(SEntries, PSCLSID.SI, SummaryRE, SummaryPIDSI));
	if(DSEntries.length || CEntries2.length) CFB.utils.cfb_add(cfb, "/\u0005DocumentSummaryInformation", write_PropertySetStream(DSEntries, PSCLSID.DSI, DocSummaryRE, DocSummaryPIDDSI, CEntries2.length ? CEntries2 : null, PSCLSID.UDI));
}

function parse_xlscfb(cfb/*:any*/, options/*:?ParseOpts*/)/*:Workbook*/ {
if(!options) options = {};
fix_read_opts(options);
reset_cp();
if(options.codepage) set_ansi(options.codepage);
var CompObj/*:?CFBEntry*/, WB/*:?any*/;
if(cfb.FullPaths) {
	if(CFB.find(cfb, '/encryption')) throw new Error("File is password-protected");
	CompObj = CFB.find(cfb, '!CompObj');
	WB = CFB.find(cfb, '/Workbook') || CFB.find(cfb, '/Book');
} else {
	switch(options.type) {
		case 'base64': cfb = s2a(Base64.decode(cfb)); break;
		case 'binary': cfb = s2a(cfb); break;
		case 'buffer': break;
		case 'array': if(!Array.isArray(cfb)) cfb = Array.prototype.slice.call(cfb); break;
	}
	prep_blob(cfb, 0);
	WB = ({content: cfb}/*:any*/);
}
var /*::CompObjP, */WorkbookP/*:: :Workbook = XLSX.utils.book_new(); */;

var _data/*:?any*/;
if(CompObj) /*::CompObjP = */parse_compobj(CompObj);
if(options.bookProps && !options.bookSheets) WorkbookP = ({}/*:any*/);
else/*:: if(cfb instanceof CFBContainer) */ {
	var T = has_buf ? 'buffer' : 'array';
	if(WB && WB.content) WorkbookP = parse_workbook(WB.content, options);
	/* Quattro Pro 7-8 */
	else if((_data=CFB.find(cfb, 'PerfectOffice_MAIN')) && _data.content) WorkbookP = WK_.to_workbook(_data.content, (options.type = T, options));
	/* Quattro Pro 9 */
	else if((_data=CFB.find(cfb, 'NativeContent_MAIN')) && _data.content) WorkbookP = WK_.to_workbook(_data.content, (options.type = T, options));
	/* Works 4 for Mac */
	else if((_data=CFB.find(cfb, 'MN0')) && _data.content) throw new Error("Unsupported Works 4 for Mac file");
	else throw new Error("Cannot find Workbook stream");
	if(options.bookVBA && cfb.FullPaths && CFB.find(cfb, '/_VBA_PROJECT_CUR/VBA/dir')) WorkbookP.vbaraw = make_vba_xls(cfb);
}

var props = {};
if(cfb.FullPaths) parse_xls_props(/*::((*/cfb/*:: :any):CFBContainer)*/, props, options);

WorkbookP.Props = WorkbookP.Custprops = props; /* TODO: split up properties */
if(options.bookFiles) WorkbookP.cfb = cfb;
/*WorkbookP.CompObjP = CompObjP; // TODO: storage? */
return WorkbookP;
}


function write_xlscfb(wb/*:Workbook*/, opts/*:WriteOpts*/)/*:CFBContainer*/ {
	var o = opts || {};
	var cfb = CFB.utils.cfb_new({root:"R"});
	var wbpath = "/Workbook";
	switch(o.bookType || "xls") {
		case "xls": o.bookType = "biff8";
		/* falls through */
		case "xla": if(!o.bookType) o.bookType = "xla";
		/* falls through */
		case "biff8": wbpath = "/Workbook"; o.biff = 8; break;
		case "biff5": wbpath = "/Book"; o.biff = 5; break;
		default: throw new Error("invalid type " + o.bookType + " for XLS CFB");
	}
	CFB.utils.cfb_add(cfb, wbpath, write_biff_buf(wb, o));
	if(o.biff == 8 && (wb.Props || wb.Custprops)) write_xls_props(wb, cfb);
	// TODO: SI, DSI, CO
	if(o.biff == 8 && wb.vbaraw) fill_vba_xls(cfb, CFB.read(wb.vbaraw, {type: typeof wb.vbaraw == "string" ? "binary" : "buffer"}));
	return cfb;
}
/* [MS-XLSB] 2.3 Record Enumeration */
var XLSBRecordEnum = {
	/*::[*/0x0000/*::]*/: { n:"BrtRowHdr", f:parse_BrtRowHdr },
	/*::[*/0x0001/*::]*/: { n:"BrtCellBlank", f:parse_BrtCellBlank },
	/*::[*/0x0002/*::]*/: { n:"BrtCellRk", f:parse_BrtCellRk },
	/*::[*/0x0003/*::]*/: { n:"BrtCellError", f:parse_BrtCellError },
	/*::[*/0x0004/*::]*/: { n:"BrtCellBool", f:parse_BrtCellBool },
	/*::[*/0x0005/*::]*/: { n:"BrtCellReal", f:parse_BrtCellReal },
	/*::[*/0x0006/*::]*/: { n:"BrtCellSt", f:parse_BrtCellSt },
	/*::[*/0x0007/*::]*/: { n:"BrtCellIsst", f:parse_BrtCellIsst },
	/*::[*/0x0008/*::]*/: { n:"BrtFmlaString", f:parse_BrtFmlaString },
	/*::[*/0x0009/*::]*/: { n:"BrtFmlaNum", f:parse_BrtFmlaNum },
	/*::[*/0x000A/*::]*/: { n:"BrtFmlaBool", f:parse_BrtFmlaBool },
	/*::[*/0x000B/*::]*/: { n:"BrtFmlaError", f:parse_BrtFmlaError },
	/*::[*/0x000C/*::]*/: { n:"BrtShortBlank", f:parse_BrtShortBlank },
	/*::[*/0x000D/*::]*/: { n:"BrtShortRk", f:parse_BrtShortRk },
	/*::[*/0x000E/*::]*/: { n:"BrtShortError", f:parse_BrtShortError },
	/*::[*/0x000F/*::]*/: { n:"BrtShortBool", f:parse_BrtShortBool },
	/*::[*/0x0010/*::]*/: { n:"BrtShortReal", f:parse_BrtShortReal },
	/*::[*/0x0011/*::]*/: { n:"BrtShortSt", f:parse_BrtShortSt },
	/*::[*/0x0012/*::]*/: { n:"BrtShortIsst", f:parse_BrtShortIsst },
	/*::[*/0x0013/*::]*/: { n:"BrtSSTItem", f:parse_RichStr },
	/*::[*/0x0014/*::]*/: { n:"BrtPCDIMissing" },
	/*::[*/0x0015/*::]*/: { n:"BrtPCDINumber" },
	/*::[*/0x0016/*::]*/: { n:"BrtPCDIBoolean" },
	/*::[*/0x0017/*::]*/: { n:"BrtPCDIError" },
	/*::[*/0x0018/*::]*/: { n:"BrtPCDIString" },
	/*::[*/0x0019/*::]*/: { n:"BrtPCDIDatetime" },
	/*::[*/0x001A/*::]*/: { n:"BrtPCDIIndex" },
	/*::[*/0x001B/*::]*/: { n:"BrtPCDIAMissing" },
	/*::[*/0x001C/*::]*/: { n:"BrtPCDIANumber" },
	/*::[*/0x001D/*::]*/: { n:"BrtPCDIABoolean" },
	/*::[*/0x001E/*::]*/: { n:"BrtPCDIAError" },
	/*::[*/0x001F/*::]*/: { n:"BrtPCDIAString" },
	/*::[*/0x0020/*::]*/: { n:"BrtPCDIADatetime" },
	/*::[*/0x0021/*::]*/: { n:"BrtPCRRecord" },
	/*::[*/0x0022/*::]*/: { n:"BrtPCRRecordDt" },
	/*::[*/0x0023/*::]*/: { n:"BrtFRTBegin" },
	/*::[*/0x0024/*::]*/: { n:"BrtFRTEnd" },
	/*::[*/0x0025/*::]*/: { n:"BrtACBegin" },
	/*::[*/0x0026/*::]*/: { n:"BrtACEnd" },
	/*::[*/0x0027/*::]*/: { n:"BrtName", f:parse_BrtName },
	/*::[*/0x0028/*::]*/: { n:"BrtIndexRowBlock" },
	/*::[*/0x002A/*::]*/: { n:"BrtIndexBlock" },
	/*::[*/0x002B/*::]*/: { n:"BrtFont", f:parse_BrtFont },
	/*::[*/0x002C/*::]*/: { n:"BrtFmt", f:parse_BrtFmt },
	/*::[*/0x002D/*::]*/: { n:"BrtFill", f:parse_BrtFill },
	/*::[*/0x002E/*::]*/: { n:"BrtBorder", f:parse_BrtBorder },
	/*::[*/0x002F/*::]*/: { n:"BrtXF", f:parse_BrtXF },
	/*::[*/0x0030/*::]*/: { n:"BrtStyle" },
	/*::[*/0x0031/*::]*/: { n:"BrtCellMeta" },
	/*::[*/0x0032/*::]*/: { n:"BrtValueMeta" },
	/*::[*/0x0033/*::]*/: { n:"BrtMdb" },
	/*::[*/0x0034/*::]*/: { n:"BrtBeginFmd" },
	/*::[*/0x0035/*::]*/: { n:"BrtEndFmd" },
	/*::[*/0x0036/*::]*/: { n:"BrtBeginMdx" },
	/*::[*/0x0037/*::]*/: { n:"BrtEndMdx" },
	/*::[*/0x0038/*::]*/: { n:"BrtBeginMdxTuple" },
	/*::[*/0x0039/*::]*/: { n:"BrtEndMdxTuple" },
	/*::[*/0x003A/*::]*/: { n:"BrtMdxMbrIstr" },
	/*::[*/0x003B/*::]*/: { n:"BrtStr" },
	/*::[*/0x003C/*::]*/: { n:"BrtColInfo", f:parse_ColInfo },
	/*::[*/0x003E/*::]*/: { n:"BrtCellRString", f:parse_BrtCellRString },
	/*::[*/0x003F/*::]*/: { n:"BrtCalcChainItem$", f:parse_BrtCalcChainItem$ },
	/*::[*/0x0040/*::]*/: { n:"BrtDVal", f:parse_BrtDVal },
	/*::[*/0x0041/*::]*/: { n:"BrtSxvcellNum" },
	/*::[*/0x0042/*::]*/: { n:"BrtSxvcellStr" },
	/*::[*/0x0043/*::]*/: { n:"BrtSxvcellBool" },
	/*::[*/0x0044/*::]*/: { n:"BrtSxvcellErr" },
	/*::[*/0x0045/*::]*/: { n:"BrtSxvcellDate" },
	/*::[*/0x0046/*::]*/: { n:"BrtSxvcellNil" },
	/*::[*/0x0080/*::]*/: { n:"BrtFileVersion" },
	/*::[*/0x0081/*::]*/: { n:"BrtBeginSheet" },
	/*::[*/0x0082/*::]*/: { n:"BrtEndSheet" },
	/*::[*/0x0083/*::]*/: { n:"BrtBeginBook", f:parsenoop, p:0 },
	/*::[*/0x0084/*::]*/: { n:"BrtEndBook" },
	/*::[*/0x0085/*::]*/: { n:"BrtBeginWsViews" },
	/*::[*/0x0086/*::]*/: { n:"BrtEndWsViews" },
	/*::[*/0x0087/*::]*/: { n:"BrtBeginBookViews" },
	/*::[*/0x0088/*::]*/: { n:"BrtEndBookViews" },
	/*::[*/0x0089/*::]*/: { n:"BrtBeginWsView", f:parse_BrtBeginWsView },
	/*::[*/0x008A/*::]*/: { n:"BrtEndWsView" },
	/*::[*/0x008B/*::]*/: { n:"BrtBeginCsViews" },
	/*::[*/0x008C/*::]*/: { n:"BrtEndCsViews" },
	/*::[*/0x008D/*::]*/: { n:"BrtBeginCsView" },
	/*::[*/0x008E/*::]*/: { n:"BrtEndCsView" },
	/*::[*/0x008F/*::]*/: { n:"BrtBeginBundleShs" },
	/*::[*/0x0090/*::]*/: { n:"BrtEndBundleShs" },
	/*::[*/0x0091/*::]*/: { n:"BrtBeginSheetData" },
	/*::[*/0x0092/*::]*/: { n:"BrtEndSheetData" },
	/*::[*/0x0093/*::]*/: { n:"BrtWsProp", f:parse_BrtWsProp },
	/*::[*/0x0094/*::]*/: { n:"BrtWsDim", f:parse_BrtWsDim, p:16 },
	/*::[*/0x0097/*::]*/: { n:"BrtPane", f:parse_BrtPane },
	/*::[*/0x0098/*::]*/: { n:"BrtSel" },
	/*::[*/0x0099/*::]*/: { n:"BrtWbProp", f:parse_BrtWbProp },
	/*::[*/0x009A/*::]*/: { n:"BrtWbFactoid" },
	/*::[*/0x009B/*::]*/: { n:"BrtFileRecover" },
	/*::[*/0x009C/*::]*/: { n:"BrtBundleSh", f:parse_BrtBundleSh },
	/*::[*/0x009D/*::]*/: { n:"BrtCalcProp" },
	/*::[*/0x009E/*::]*/: { n:"BrtBookView" },
	/*::[*/0x009F/*::]*/: { n:"BrtBeginSst", f:parse_BrtBeginSst },
	/*::[*/0x00A0/*::]*/: { n:"BrtEndSst" },
	/*::[*/0x00A1/*::]*/: { n:"BrtBeginAFilter", f:parse_UncheckedRfX },
	/*::[*/0x00A2/*::]*/: { n:"BrtEndAFilter" },
	/*::[*/0x00A3/*::]*/: { n:"BrtBeginFilterColumn" },
	/*::[*/0x00A4/*::]*/: { n:"BrtEndFilterColumn" },
	/*::[*/0x00A5/*::]*/: { n:"BrtBeginFilters" },
	/*::[*/0x00A6/*::]*/: { n:"BrtEndFilters" },
	/*::[*/0x00A7/*::]*/: { n:"BrtFilter" },
	/*::[*/0x00A8/*::]*/: { n:"BrtColorFilter" },
	/*::[*/0x00A9/*::]*/: { n:"BrtIconFilter" },
	/*::[*/0x00AA/*::]*/: { n:"BrtTop10Filter" },
	/*::[*/0x00AB/*::]*/: { n:"BrtDynamicFilter" },
	/*::[*/0x00AC/*::]*/: { n:"BrtBeginCustomFilters" },
	/*::[*/0x00AD/*::]*/: { n:"BrtEndCustomFilters" },
	/*::[*/0x00AE/*::]*/: { n:"BrtCustomFilter" },
	/*::[*/0x00AF/*::]*/: { n:"BrtAFilterDateGroupItem" },
	/*::[*/0x00B0/*::]*/: { n:"BrtMergeCell", f:parse_BrtMergeCell },
	/*::[*/0x00B1/*::]*/: { n:"BrtBeginMergeCells" },
	/*::[*/0x00B2/*::]*/: { n:"BrtEndMergeCells" },
	/*::[*/0x00B3/*::]*/: { n:"BrtBeginPivotCacheDef" },
	/*::[*/0x00B4/*::]*/: { n:"BrtEndPivotCacheDef" },
	/*::[*/0x00B5/*::]*/: { n:"BrtBeginPCDFields" },
	/*::[*/0x00B6/*::]*/: { n:"BrtEndPCDFields" },
	/*::[*/0x00B7/*::]*/: { n:"BrtBeginPCDField" },
	/*::[*/0x00B8/*::]*/: { n:"BrtEndPCDField" },
	/*::[*/0x00B9/*::]*/: { n:"BrtBeginPCDSource" },
	/*::[*/0x00BA/*::]*/: { n:"BrtEndPCDSource" },
	/*::[*/0x00BB/*::]*/: { n:"BrtBeginPCDSRange" },
	/*::[*/0x00BC/*::]*/: { n:"BrtEndPCDSRange" },
	/*::[*/0x00BD/*::]*/: { n:"BrtBeginPCDFAtbl" },
	/*::[*/0x00BE/*::]*/: { n:"BrtEndPCDFAtbl" },
	/*::[*/0x00BF/*::]*/: { n:"BrtBeginPCDIRun" },
	/*::[*/0x00C0/*::]*/: { n:"BrtEndPCDIRun" },
	/*::[*/0x00C1/*::]*/: { n:"BrtBeginPivotCacheRecords" },
	/*::[*/0x00C2/*::]*/: { n:"BrtEndPivotCacheRecords" },
	/*::[*/0x00C3/*::]*/: { n:"BrtBeginPCDHierarchies" },
	/*::[*/0x00C4/*::]*/: { n:"BrtEndPCDHierarchies" },
	/*::[*/0x00C5/*::]*/: { n:"BrtBeginPCDHierarchy" },
	/*::[*/0x00C6/*::]*/: { n:"BrtEndPCDHierarchy" },
	/*::[*/0x00C7/*::]*/: { n:"BrtBeginPCDHFieldsUsage" },
	/*::[*/0x00C8/*::]*/: { n:"BrtEndPCDHFieldsUsage" },
	/*::[*/0x00C9/*::]*/: { n:"BrtBeginExtConnection" },
	/*::[*/0x00CA/*::]*/: { n:"BrtEndExtConnection" },
	/*::[*/0x00CB/*::]*/: { n:"BrtBeginECDbProps" },
	/*::[*/0x00CC/*::]*/: { n:"BrtEndECDbProps" },
	/*::[*/0x00CD/*::]*/: { n:"BrtBeginECOlapProps" },
	/*::[*/0x00CE/*::]*/: { n:"BrtEndECOlapProps" },
	/*::[*/0x00CF/*::]*/: { n:"BrtBeginPCDSConsol" },
	/*::[*/0x00D0/*::]*/: { n:"BrtEndPCDSConsol" },
	/*::[*/0x00D1/*::]*/: { n:"BrtBeginPCDSCPages" },
	/*::[*/0x00D2/*::]*/: { n:"BrtEndPCDSCPages" },
	/*::[*/0x00D3/*::]*/: { n:"BrtBeginPCDSCPage" },
	/*::[*/0x00D4/*::]*/: { n:"BrtEndPCDSCPage" },
	/*::[*/0x00D5/*::]*/: { n:"BrtBeginPCDSCPItem" },
	/*::[*/0x00D6/*::]*/: { n:"BrtEndPCDSCPItem" },
	/*::[*/0x00D7/*::]*/: { n:"BrtBeginPCDSCSets" },
	/*::[*/0x00D8/*::]*/: { n:"BrtEndPCDSCSets" },
	/*::[*/0x00D9/*::]*/: { n:"BrtBeginPCDSCSet" },
	/*::[*/0x00DA/*::]*/: { n:"BrtEndPCDSCSet" },
	/*::[*/0x00DB/*::]*/: { n:"BrtBeginPCDFGroup" },
	/*::[*/0x00DC/*::]*/: { n:"BrtEndPCDFGroup" },
	/*::[*/0x00DD/*::]*/: { n:"BrtBeginPCDFGItems" },
	/*::[*/0x00DE/*::]*/: { n:"BrtEndPCDFGItems" },
	/*::[*/0x00DF/*::]*/: { n:"BrtBeginPCDFGRange" },
	/*::[*/0x00E0/*::]*/: { n:"BrtEndPCDFGRange" },
	/*::[*/0x00E1/*::]*/: { n:"BrtBeginPCDFGDiscrete" },
	/*::[*/0x00E2/*::]*/: { n:"BrtEndPCDFGDiscrete" },
	/*::[*/0x00E3/*::]*/: { n:"BrtBeginPCDSDTupleCache" },
	/*::[*/0x00E4/*::]*/: { n:"BrtEndPCDSDTupleCache" },
	/*::[*/0x00E5/*::]*/: { n:"BrtBeginPCDSDTCEntries" },
	/*::[*/0x00E6/*::]*/: { n:"BrtEndPCDSDTCEntries" },
	/*::[*/0x00E7/*::]*/: { n:"BrtBeginPCDSDTCEMembers" },
	/*::[*/0x00E8/*::]*/: { n:"BrtEndPCDSDTCEMembers" },
	/*::[*/0x00E9/*::]*/: { n:"BrtBeginPCDSDTCEMember" },
	/*::[*/0x00EA/*::]*/: { n:"BrtEndPCDSDTCEMember" },
	/*::[*/0x00EB/*::]*/: { n:"BrtBeginPCDSDTCQueries" },
	/*::[*/0x00EC/*::]*/: { n:"BrtEndPCDSDTCQueries" },
	/*::[*/0x00ED/*::]*/: { n:"BrtBeginPCDSDTCQuery" },
	/*::[*/0x00EE/*::]*/: { n:"BrtEndPCDSDTCQuery" },
	/*::[*/0x00EF/*::]*/: { n:"BrtBeginPCDSDTCSets" },
	/*::[*/0x00F0/*::]*/: { n:"BrtEndPCDSDTCSets" },
	/*::[*/0x00F1/*::]*/: { n:"BrtBeginPCDSDTCSet" },
	/*::[*/0x00F2/*::]*/: { n:"BrtEndPCDSDTCSet" },
	/*::[*/0x00F3/*::]*/: { n:"BrtBeginPCDCalcItems" },
	/*::[*/0x00F4/*::]*/: { n:"BrtEndPCDCalcItems" },
	/*::[*/0x00F5/*::]*/: { n:"BrtBeginPCDCalcItem" },
	/*::[*/0x00F6/*::]*/: { n:"BrtEndPCDCalcItem" },
	/*::[*/0x00F7/*::]*/: { n:"BrtBeginPRule" },
	/*::[*/0x00F8/*::]*/: { n:"BrtEndPRule" },
	/*::[*/0x00F9/*::]*/: { n:"BrtBeginPRFilters" },
	/*::[*/0x00FA/*::]*/: { n:"BrtEndPRFilters" },
	/*::[*/0x00FB/*::]*/: { n:"BrtBeginPRFilter" },
	/*::[*/0x00FC/*::]*/: { n:"BrtEndPRFilter" },
	/*::[*/0x00FD/*::]*/: { n:"BrtBeginPNames" },
	/*::[*/0x00FE/*::]*/: { n:"BrtEndPNames" },
	/*::[*/0x00FF/*::]*/: { n:"BrtBeginPName" },
	/*::[*/0x0100/*::]*/: { n:"BrtEndPName" },
	/*::[*/0x0101/*::]*/: { n:"BrtBeginPNPairs" },
	/*::[*/0x0102/*::]*/: { n:"BrtEndPNPairs" },
	/*::[*/0x0103/*::]*/: { n:"BrtBeginPNPair" },
	/*::[*/0x0104/*::]*/: { n:"BrtEndPNPair" },
	/*::[*/0x0105/*::]*/: { n:"BrtBeginECWebProps" },
	/*::[*/0x0106/*::]*/: { n:"BrtEndECWebProps" },
	/*::[*/0x0107/*::]*/: { n:"BrtBeginEcWpTables" },
	/*::[*/0x0108/*::]*/: { n:"BrtEndECWPTables" },
	/*::[*/0x0109/*::]*/: { n:"BrtBeginECParams" },
	/*::[*/0x010A/*::]*/: { n:"BrtEndECParams" },
	/*::[*/0x010B/*::]*/: { n:"BrtBeginECParam" },
	/*::[*/0x010C/*::]*/: { n:"BrtEndECParam" },
	/*::[*/0x010D/*::]*/: { n:"BrtBeginPCDKPIs" },
	/*::[*/0x010E/*::]*/: { n:"BrtEndPCDKPIs" },
	/*::[*/0x010F/*::]*/: { n:"BrtBeginPCDKPI" },
	/*::[*/0x0110/*::]*/: { n:"BrtEndPCDKPI" },
	/*::[*/0x0111/*::]*/: { n:"BrtBeginDims" },
	/*::[*/0x0112/*::]*/: { n:"BrtEndDims" },
	/*::[*/0x0113/*::]*/: { n:"BrtBeginDim" },
	/*::[*/0x0114/*::]*/: { n:"BrtEndDim" },
	/*::[*/0x0115/*::]*/: { n:"BrtIndexPartEnd" },
	/*::[*/0x0116/*::]*/: { n:"BrtBeginStyleSheet" },
	/*::[*/0x0117/*::]*/: { n:"BrtEndStyleSheet" },
	/*::[*/0x0118/*::]*/: { n:"BrtBeginSXView" },
	/*::[*/0x0119/*::]*/: { n:"BrtEndSXVI" },
	/*::[*/0x011A/*::]*/: { n:"BrtBeginSXVI" },
	/*::[*/0x011B/*::]*/: { n:"BrtBeginSXVIs" },
	/*::[*/0x011C/*::]*/: { n:"BrtEndSXVIs" },
	/*::[*/0x011D/*::]*/: { n:"BrtBeginSXVD" },
	/*::[*/0x011E/*::]*/: { n:"BrtEndSXVD" },
	/*::[*/0x011F/*::]*/: { n:"BrtBeginSXVDs" },
	/*::[*/0x0120/*::]*/: { n:"BrtEndSXVDs" },
	/*::[*/0x0121/*::]*/: { n:"BrtBeginSXPI" },
	/*::[*/0x0122/*::]*/: { n:"BrtEndSXPI" },
	/*::[*/0x0123/*::]*/: { n:"BrtBeginSXPIs" },
	/*::[*/0x0124/*::]*/: { n:"BrtEndSXPIs" },
	/*::[*/0x0125/*::]*/: { n:"BrtBeginSXDI" },
	/*::[*/0x0126/*::]*/: { n:"BrtEndSXDI" },
	/*::[*/0x0127/*::]*/: { n:"BrtBeginSXDIs" },
	/*::[*/0x0128/*::]*/: { n:"BrtEndSXDIs" },
	/*::[*/0x0129/*::]*/: { n:"BrtBeginSXLI" },
	/*::[*/0x012A/*::]*/: { n:"BrtEndSXLI" },
	/*::[*/0x012B/*::]*/: { n:"BrtBeginSXLIRws" },
	/*::[*/0x012C/*::]*/: { n:"BrtEndSXLIRws" },
	/*::[*/0x012D/*::]*/: { n:"BrtBeginSXLICols" },
	/*::[*/0x012E/*::]*/: { n:"BrtEndSXLICols" },
	/*::[*/0x012F/*::]*/: { n:"BrtBeginSXFormat" },
	/*::[*/0x0130/*::]*/: { n:"BrtEndSXFormat" },
	/*::[*/0x0131/*::]*/: { n:"BrtBeginSXFormats" },
	/*::[*/0x0132/*::]*/: { n:"BrtEndSxFormats" },
	/*::[*/0x0133/*::]*/: { n:"BrtBeginSxSelect" },
	/*::[*/0x0134/*::]*/: { n:"BrtEndSxSelect" },
	/*::[*/0x0135/*::]*/: { n:"BrtBeginISXVDRws" },
	/*::[*/0x0136/*::]*/: { n:"BrtEndISXVDRws" },
	/*::[*/0x0137/*::]*/: { n:"BrtBeginISXVDCols" },
	/*::[*/0x0138/*::]*/: { n:"BrtEndISXVDCols" },
	/*::[*/0x0139/*::]*/: { n:"BrtEndSXLocation" },
	/*::[*/0x013A/*::]*/: { n:"BrtBeginSXLocation" },
	/*::[*/0x013B/*::]*/: { n:"BrtEndSXView" },
	/*::[*/0x013C/*::]*/: { n:"BrtBeginSXTHs" },
	/*::[*/0x013D/*::]*/: { n:"BrtEndSXTHs" },
	/*::[*/0x013E/*::]*/: { n:"BrtBeginSXTH" },
	/*::[*/0x013F/*::]*/: { n:"BrtEndSXTH" },
	/*::[*/0x0140/*::]*/: { n:"BrtBeginISXTHRws" },
	/*::[*/0x0141/*::]*/: { n:"BrtEndISXTHRws" },
	/*::[*/0x0142/*::]*/: { n:"BrtBeginISXTHCols" },
	/*::[*/0x0143/*::]*/: { n:"BrtEndISXTHCols" },
	/*::[*/0x0144/*::]*/: { n:"BrtBeginSXTDMPS" },
	/*::[*/0x0145/*::]*/: { n:"BrtEndSXTDMPs" },
	/*::[*/0x0146/*::]*/: { n:"BrtBeginSXTDMP" },
	/*::[*/0x0147/*::]*/: { n:"BrtEndSXTDMP" },
	/*::[*/0x0148/*::]*/: { n:"BrtBeginSXTHItems" },
	/*::[*/0x0149/*::]*/: { n:"BrtEndSXTHItems" },
	/*::[*/0x014A/*::]*/: { n:"BrtBeginSXTHItem" },
	/*::[*/0x014B/*::]*/: { n:"BrtEndSXTHItem" },
	/*::[*/0x014C/*::]*/: { n:"BrtBeginMetadata" },
	/*::[*/0x014D/*::]*/: { n:"BrtEndMetadata" },
	/*::[*/0x014E/*::]*/: { n:"BrtBeginEsmdtinfo" },
	/*::[*/0x014F/*::]*/: { n:"BrtMdtinfo" },
	/*::[*/0x0150/*::]*/: { n:"BrtEndEsmdtinfo" },
	/*::[*/0x0151/*::]*/: { n:"BrtBeginEsmdb" },
	/*::[*/0x0152/*::]*/: { n:"BrtEndEsmdb" },
	/*::[*/0x0153/*::]*/: { n:"BrtBeginEsfmd" },
	/*::[*/0x0154/*::]*/: { n:"BrtEndEsfmd" },
	/*::[*/0x0155/*::]*/: { n:"BrtBeginSingleCells" },
	/*::[*/0x0156/*::]*/: { n:"BrtEndSingleCells" },
	/*::[*/0x0157/*::]*/: { n:"BrtBeginList" },
	/*::[*/0x0158/*::]*/: { n:"BrtEndList" },
	/*::[*/0x0159/*::]*/: { n:"BrtBeginListCols" },
	/*::[*/0x015A/*::]*/: { n:"BrtEndListCols" },
	/*::[*/0x015B/*::]*/: { n:"BrtBeginListCol" },
	/*::[*/0x015C/*::]*/: { n:"BrtEndListCol" },
	/*::[*/0x015D/*::]*/: { n:"BrtBeginListXmlCPr" },
	/*::[*/0x015E/*::]*/: { n:"BrtEndListXmlCPr" },
	/*::[*/0x015F/*::]*/: { n:"BrtListCCFmla" },
	/*::[*/0x0160/*::]*/: { n:"BrtListTrFmla" },
	/*::[*/0x0161/*::]*/: { n:"BrtBeginExternals" },
	/*::[*/0x0162/*::]*/: { n:"BrtEndExternals" },
	/*::[*/0x0163/*::]*/: { n:"BrtSupBookSrc", f:parse_RelID},
	/*::[*/0x0165/*::]*/: { n:"BrtSupSelf" },
	/*::[*/0x0166/*::]*/: { n:"BrtSupSame" },
	/*::[*/0x0167/*::]*/: { n:"BrtSupTabs" },
	/*::[*/0x0168/*::]*/: { n:"BrtBeginSupBook" },
	/*::[*/0x0169/*::]*/: { n:"BrtPlaceholderName" },
	/*::[*/0x016A/*::]*/: { n:"BrtExternSheet", f:parse_ExternSheet },
	/*::[*/0x016B/*::]*/: { n:"BrtExternTableStart" },
	/*::[*/0x016C/*::]*/: { n:"BrtExternTableEnd" },
	/*::[*/0x016E/*::]*/: { n:"BrtExternRowHdr" },
	/*::[*/0x016F/*::]*/: { n:"BrtExternCellBlank" },
	/*::[*/0x0170/*::]*/: { n:"BrtExternCellReal" },
	/*::[*/0x0171/*::]*/: { n:"BrtExternCellBool" },
	/*::[*/0x0172/*::]*/: { n:"BrtExternCellError" },
	/*::[*/0x0173/*::]*/: { n:"BrtExternCellString" },
	/*::[*/0x0174/*::]*/: { n:"BrtBeginEsmdx" },
	/*::[*/0x0175/*::]*/: { n:"BrtEndEsmdx" },
	/*::[*/0x0176/*::]*/: { n:"BrtBeginMdxSet" },
	/*::[*/0x0177/*::]*/: { n:"BrtEndMdxSet" },
	/*::[*/0x0178/*::]*/: { n:"BrtBeginMdxMbrProp" },
	/*::[*/0x0179/*::]*/: { n:"BrtEndMdxMbrProp" },
	/*::[*/0x017A/*::]*/: { n:"BrtBeginMdxKPI" },
	/*::[*/0x017B/*::]*/: { n:"BrtEndMdxKPI" },
	/*::[*/0x017C/*::]*/: { n:"BrtBeginEsstr" },
	/*::[*/0x017D/*::]*/: { n:"BrtEndEsstr" },
	/*::[*/0x017E/*::]*/: { n:"BrtBeginPRFItem" },
	/*::[*/0x017F/*::]*/: { n:"BrtEndPRFItem" },
	/*::[*/0x0180/*::]*/: { n:"BrtBeginPivotCacheIDs" },
	/*::[*/0x0181/*::]*/: { n:"BrtEndPivotCacheIDs" },
	/*::[*/0x0182/*::]*/: { n:"BrtBeginPivotCacheID" },
	/*::[*/0x0183/*::]*/: { n:"BrtEndPivotCacheID" },
	/*::[*/0x0184/*::]*/: { n:"BrtBeginISXVIs" },
	/*::[*/0x0185/*::]*/: { n:"BrtEndISXVIs" },
	/*::[*/0x0186/*::]*/: { n:"BrtBeginColInfos" },
	/*::[*/0x0187/*::]*/: { n:"BrtEndColInfos" },
	/*::[*/0x0188/*::]*/: { n:"BrtBeginRwBrk" },
	/*::[*/0x0189/*::]*/: { n:"BrtEndRwBrk" },
	/*::[*/0x018A/*::]*/: { n:"BrtBeginColBrk" },
	/*::[*/0x018B/*::]*/: { n:"BrtEndColBrk" },
	/*::[*/0x018C/*::]*/: { n:"BrtBrk" },
	/*::[*/0x018D/*::]*/: { n:"BrtUserBookView" },
	/*::[*/0x018E/*::]*/: { n:"BrtInfo" },
	/*::[*/0x018F/*::]*/: { n:"BrtCUsr" },
	/*::[*/0x0190/*::]*/: { n:"BrtUsr" },
	/*::[*/0x0191/*::]*/: { n:"BrtBeginUsers" },
	/*::[*/0x0193/*::]*/: { n:"BrtEOF" },
	/*::[*/0x0194/*::]*/: { n:"BrtUCR" },
	/*::[*/0x0195/*::]*/: { n:"BrtRRInsDel" },
	/*::[*/0x0196/*::]*/: { n:"BrtRREndInsDel" },
	/*::[*/0x0197/*::]*/: { n:"BrtRRMove" },
	/*::[*/0x0198/*::]*/: { n:"BrtRREndMove" },
	/*::[*/0x0199/*::]*/: { n:"BrtRRChgCell" },
	/*::[*/0x019A/*::]*/: { n:"BrtRREndChgCell" },
	/*::[*/0x019B/*::]*/: { n:"BrtRRHeader" },
	/*::[*/0x019C/*::]*/: { n:"BrtRRUserView" },
	/*::[*/0x019D/*::]*/: { n:"BrtRRRenSheet" },
	/*::[*/0x019E/*::]*/: { n:"BrtRRInsertSh" },
	/*::[*/0x019F/*::]*/: { n:"BrtRRDefName" },
	/*::[*/0x01A0/*::]*/: { n:"BrtRRNote" },
	/*::[*/0x01A1/*::]*/: { n:"BrtRRConflict" },
	/*::[*/0x01A2/*::]*/: { n:"BrtRRTQSIF" },
	/*::[*/0x01A3/*::]*/: { n:"BrtRRFormat" },
	/*::[*/0x01A4/*::]*/: { n:"BrtRREndFormat" },
	/*::[*/0x01A5/*::]*/: { n:"BrtRRAutoFmt" },
	/*::[*/0x01A6/*::]*/: { n:"BrtBeginUserShViews" },
	/*::[*/0x01A7/*::]*/: { n:"BrtBeginUserShView" },
	/*::[*/0x01A8/*::]*/: { n:"BrtEndUserShView" },
	/*::[*/0x01A9/*::]*/: { n:"BrtEndUserShViews" },
	/*::[*/0x01AA/*::]*/: { n:"BrtArrFmla", f:parse_BrtArrFmla },
	/*::[*/0x01AB/*::]*/: { n:"BrtShrFmla", f:parse_BrtShrFmla },
	/*::[*/0x01AC/*::]*/: { n:"BrtTable" },
	/*::[*/0x01AD/*::]*/: { n:"BrtBeginExtConnections" },
	/*::[*/0x01AE/*::]*/: { n:"BrtEndExtConnections" },
	/*::[*/0x01AF/*::]*/: { n:"BrtBeginPCDCalcMems" },
	/*::[*/0x01B0/*::]*/: { n:"BrtEndPCDCalcMems" },
	/*::[*/0x01B1/*::]*/: { n:"BrtBeginPCDCalcMem" },
	/*::[*/0x01B2/*::]*/: { n:"BrtEndPCDCalcMem" },
	/*::[*/0x01B3/*::]*/: { n:"BrtBeginPCDHGLevels" },
	/*::[*/0x01B4/*::]*/: { n:"BrtEndPCDHGLevels" },
	/*::[*/0x01B5/*::]*/: { n:"BrtBeginPCDHGLevel" },
	/*::[*/0x01B6/*::]*/: { n:"BrtEndPCDHGLevel" },
	/*::[*/0x01B7/*::]*/: { n:"BrtBeginPCDHGLGroups" },
	/*::[*/0x01B8/*::]*/: { n:"BrtEndPCDHGLGroups" },
	/*::[*/0x01B9/*::]*/: { n:"BrtBeginPCDHGLGroup" },
	/*::[*/0x01BA/*::]*/: { n:"BrtEndPCDHGLGroup" },
	/*::[*/0x01BB/*::]*/: { n:"BrtBeginPCDHGLGMembers" },
	/*::[*/0x01BC/*::]*/: { n:"BrtEndPCDHGLGMembers" },
	/*::[*/0x01BD/*::]*/: { n:"BrtBeginPCDHGLGMember" },
	/*::[*/0x01BE/*::]*/: { n:"BrtEndPCDHGLGMember" },
	/*::[*/0x01BF/*::]*/: { n:"BrtBeginQSI" },
	/*::[*/0x01C0/*::]*/: { n:"BrtEndQSI" },
	/*::[*/0x01C1/*::]*/: { n:"BrtBeginQSIR" },
	/*::[*/0x01C2/*::]*/: { n:"BrtEndQSIR" },
	/*::[*/0x01C3/*::]*/: { n:"BrtBeginDeletedNames" },
	/*::[*/0x01C4/*::]*/: { n:"BrtEndDeletedNames" },
	/*::[*/0x01C5/*::]*/: { n:"BrtBeginDeletedName" },
	/*::[*/0x01C6/*::]*/: { n:"BrtEndDeletedName" },
	/*::[*/0x01C7/*::]*/: { n:"BrtBeginQSIFs" },
	/*::[*/0x01C8/*::]*/: { n:"BrtEndQSIFs" },
	/*::[*/0x01C9/*::]*/: { n:"BrtBeginQSIF" },
	/*::[*/0x01CA/*::]*/: { n:"BrtEndQSIF" },
	/*::[*/0x01CB/*::]*/: { n:"BrtBeginAutoSortScope" },
	/*::[*/0x01CC/*::]*/: { n:"BrtEndAutoSortScope" },
	/*::[*/0x01CD/*::]*/: { n:"BrtBeginConditionalFormatting" },
	/*::[*/0x01CE/*::]*/: { n:"BrtEndConditionalFormatting" },
	/*::[*/0x01CF/*::]*/: { n:"BrtBeginCFRule" },
	/*::[*/0x01D0/*::]*/: { n:"BrtEndCFRule" },
	/*::[*/0x01D1/*::]*/: { n:"BrtBeginIconSet" },
	/*::[*/0x01D2/*::]*/: { n:"BrtEndIconSet" },
	/*::[*/0x01D3/*::]*/: { n:"BrtBeginDatabar" },
	/*::[*/0x01D4/*::]*/: { n:"BrtEndDatabar" },
	/*::[*/0x01D5/*::]*/: { n:"BrtBeginColorScale" },
	/*::[*/0x01D6/*::]*/: { n:"BrtEndColorScale" },
	/*::[*/0x01D7/*::]*/: { n:"BrtCFVO" },
	/*::[*/0x01D8/*::]*/: { n:"BrtExternValueMeta" },
	/*::[*/0x01D9/*::]*/: { n:"BrtBeginColorPalette" },
	/*::[*/0x01DA/*::]*/: { n:"BrtEndColorPalette" },
	/*::[*/0x01DB/*::]*/: { n:"BrtIndexedColor" },
	/*::[*/0x01DC/*::]*/: { n:"BrtMargins", f:parse_BrtMargins },
	/*::[*/0x01DD/*::]*/: { n:"BrtPrintOptions" },
	/*::[*/0x01DE/*::]*/: { n:"BrtPageSetup" },
	/*::[*/0x01DF/*::]*/: { n:"BrtBeginHeaderFooter" },
	/*::[*/0x01E0/*::]*/: { n:"BrtEndHeaderFooter" },
	/*::[*/0x01E1/*::]*/: { n:"BrtBeginSXCrtFormat" },
	/*::[*/0x01E2/*::]*/: { n:"BrtEndSXCrtFormat" },
	/*::[*/0x01E3/*::]*/: { n:"BrtBeginSXCrtFormats" },
	/*::[*/0x01E4/*::]*/: { n:"BrtEndSXCrtFormats" },
	/*::[*/0x01E5/*::]*/: { n:"BrtWsFmtInfo", f:parse_BrtWsFmtInfo },
	/*::[*/0x01E6/*::]*/: { n:"BrtBeginMgs" },
	/*::[*/0x01E7/*::]*/: { n:"BrtEndMGs" },
	/*::[*/0x01E8/*::]*/: { n:"BrtBeginMGMaps" },
	/*::[*/0x01E9/*::]*/: { n:"BrtEndMGMaps" },
	/*::[*/0x01EA/*::]*/: { n:"BrtBeginMG" },
	/*::[*/0x01EB/*::]*/: { n:"BrtEndMG" },
	/*::[*/0x01EC/*::]*/: { n:"BrtBeginMap" },
	/*::[*/0x01ED/*::]*/: { n:"BrtEndMap" },
	/*::[*/0x01EE/*::]*/: { n:"BrtHLink", f:parse_BrtHLink },
	/*::[*/0x01EF/*::]*/: { n:"BrtBeginDCon" },
	/*::[*/0x01F0/*::]*/: { n:"BrtEndDCon" },
	/*::[*/0x01F1/*::]*/: { n:"BrtBeginDRefs" },
	/*::[*/0x01F2/*::]*/: { n:"BrtEndDRefs" },
	/*::[*/0x01F3/*::]*/: { n:"BrtDRef" },
	/*::[*/0x01F4/*::]*/: { n:"BrtBeginScenMan" },
	/*::[*/0x01F5/*::]*/: { n:"BrtEndScenMan" },
	/*::[*/0x01F6/*::]*/: { n:"BrtBeginSct" },
	/*::[*/0x01F7/*::]*/: { n:"BrtEndSct" },
	/*::[*/0x01F8/*::]*/: { n:"BrtSlc" },
	/*::[*/0x01F9/*::]*/: { n:"BrtBeginDXFs" },
	/*::[*/0x01FA/*::]*/: { n:"BrtEndDXFs" },
	/*::[*/0x01FB/*::]*/: { n:"BrtDXF" },
	/*::[*/0x01FC/*::]*/: { n:"BrtBeginTableStyles" },
	/*::[*/0x01FD/*::]*/: { n:"BrtEndTableStyles" },
	/*::[*/0x01FE/*::]*/: { n:"BrtBeginTableStyle" },
	/*::[*/0x01FF/*::]*/: { n:"BrtEndTableStyle" },
	/*::[*/0x0200/*::]*/: { n:"BrtTableStyleElement" },
	/*::[*/0x0201/*::]*/: { n:"BrtTableStyleClient" },
	/*::[*/0x0202/*::]*/: { n:"BrtBeginVolDeps" },
	/*::[*/0x0203/*::]*/: { n:"BrtEndVolDeps" },
	/*::[*/0x0204/*::]*/: { n:"BrtBeginVolType" },
	/*::[*/0x0205/*::]*/: { n:"BrtEndVolType" },
	/*::[*/0x0206/*::]*/: { n:"BrtBeginVolMain" },
	/*::[*/0x0207/*::]*/: { n:"BrtEndVolMain" },
	/*::[*/0x0208/*::]*/: { n:"BrtBeginVolTopic" },
	/*::[*/0x0209/*::]*/: { n:"BrtEndVolTopic" },
	/*::[*/0x020A/*::]*/: { n:"BrtVolSubtopic" },
	/*::[*/0x020B/*::]*/: { n:"BrtVolRef" },
	/*::[*/0x020C/*::]*/: { n:"BrtVolNum" },
	/*::[*/0x020D/*::]*/: { n:"BrtVolErr" },
	/*::[*/0x020E/*::]*/: { n:"BrtVolStr" },
	/*::[*/0x020F/*::]*/: { n:"BrtVolBool" },
	/*::[*/0x0210/*::]*/: { n:"BrtBeginCalcChain$" },
	/*::[*/0x0211/*::]*/: { n:"BrtEndCalcChain$" },
	/*::[*/0x0212/*::]*/: { n:"BrtBeginSortState" },
	/*::[*/0x0213/*::]*/: { n:"BrtEndSortState" },
	/*::[*/0x0214/*::]*/: { n:"BrtBeginSortCond" },
	/*::[*/0x0215/*::]*/: { n:"BrtEndSortCond" },
	/*::[*/0x0216/*::]*/: { n:"BrtBookProtection" },
	/*::[*/0x0217/*::]*/: { n:"BrtSheetProtection" },
	/*::[*/0x0218/*::]*/: { n:"BrtRangeProtection" },
	/*::[*/0x0219/*::]*/: { n:"BrtPhoneticInfo" },
	/*::[*/0x021A/*::]*/: { n:"BrtBeginECTxtWiz" },
	/*::[*/0x021B/*::]*/: { n:"BrtEndECTxtWiz" },
	/*::[*/0x021C/*::]*/: { n:"BrtBeginECTWFldInfoLst" },
	/*::[*/0x021D/*::]*/: { n:"BrtEndECTWFldInfoLst" },
	/*::[*/0x021E/*::]*/: { n:"BrtBeginECTwFldInfo" },
	/*::[*/0x0224/*::]*/: { n:"BrtFileSharing" },
	/*::[*/0x0225/*::]*/: { n:"BrtOleSize" },
	/*::[*/0x0226/*::]*/: { n:"BrtDrawing", f:parse_RelID },
	/*::[*/0x0227/*::]*/: { n:"BrtLegacyDrawing" },
	/*::[*/0x0228/*::]*/: { n:"BrtLegacyDrawingHF" },
	/*::[*/0x0229/*::]*/: { n:"BrtWebOpt" },
	/*::[*/0x022A/*::]*/: { n:"BrtBeginWebPubItems" },
	/*::[*/0x022B/*::]*/: { n:"BrtEndWebPubItems" },
	/*::[*/0x022C/*::]*/: { n:"BrtBeginWebPubItem" },
	/*::[*/0x022D/*::]*/: { n:"BrtEndWebPubItem" },
	/*::[*/0x022E/*::]*/: { n:"BrtBeginSXCondFmt" },
	/*::[*/0x022F/*::]*/: { n:"BrtEndSXCondFmt" },
	/*::[*/0x0230/*::]*/: { n:"BrtBeginSXCondFmts" },
	/*::[*/0x0231/*::]*/: { n:"BrtEndSXCondFmts" },
	/*::[*/0x0232/*::]*/: { n:"BrtBkHim" },
	/*::[*/0x0234/*::]*/: { n:"BrtColor" },
	/*::[*/0x0235/*::]*/: { n:"BrtBeginIndexedColors" },
	/*::[*/0x0236/*::]*/: { n:"BrtEndIndexedColors" },
	/*::[*/0x0239/*::]*/: { n:"BrtBeginMRUColors" },
	/*::[*/0x023A/*::]*/: { n:"BrtEndMRUColors" },
	/*::[*/0x023C/*::]*/: { n:"BrtMRUColor" },
	/*::[*/0x023D/*::]*/: { n:"BrtBeginDVals" },
	/*::[*/0x023E/*::]*/: { n:"BrtEndDVals" },
	/*::[*/0x0241/*::]*/: { n:"BrtSupNameStart" },
	/*::[*/0x0242/*::]*/: { n:"BrtSupNameValueStart" },
	/*::[*/0x0243/*::]*/: { n:"BrtSupNameValueEnd" },
	/*::[*/0x0244/*::]*/: { n:"BrtSupNameNum" },
	/*::[*/0x0245/*::]*/: { n:"BrtSupNameErr" },
	/*::[*/0x0246/*::]*/: { n:"BrtSupNameSt" },
	/*::[*/0x0247/*::]*/: { n:"BrtSupNameNil" },
	/*::[*/0x0248/*::]*/: { n:"BrtSupNameBool" },
	/*::[*/0x0249/*::]*/: { n:"BrtSupNameFmla" },
	/*::[*/0x024A/*::]*/: { n:"BrtSupNameBits" },
	/*::[*/0x024B/*::]*/: { n:"BrtSupNameEnd" },
	/*::[*/0x024C/*::]*/: { n:"BrtEndSupBook" },
	/*::[*/0x024D/*::]*/: { n:"BrtCellSmartTagProperty" },
	/*::[*/0x024E/*::]*/: { n:"BrtBeginCellSmartTag" },
	/*::[*/0x024F/*::]*/: { n:"BrtEndCellSmartTag" },
	/*::[*/0x0250/*::]*/: { n:"BrtBeginCellSmartTags" },
	/*::[*/0x0251/*::]*/: { n:"BrtEndCellSmartTags" },
	/*::[*/0x0252/*::]*/: { n:"BrtBeginSmartTags" },
	/*::[*/0x0253/*::]*/: { n:"BrtEndSmartTags" },
	/*::[*/0x0254/*::]*/: { n:"BrtSmartTagType" },
	/*::[*/0x0255/*::]*/: { n:"BrtBeginSmartTagTypes" },
	/*::[*/0x0256/*::]*/: { n:"BrtEndSmartTagTypes" },
	/*::[*/0x0257/*::]*/: { n:"BrtBeginSXFilters" },
	/*::[*/0x0258/*::]*/: { n:"BrtEndSXFilters" },
	/*::[*/0x0259/*::]*/: { n:"BrtBeginSXFILTER" },
	/*::[*/0x025A/*::]*/: { n:"BrtEndSXFilter" },
	/*::[*/0x025B/*::]*/: { n:"BrtBeginFills" },
	/*::[*/0x025C/*::]*/: { n:"BrtEndFills" },
	/*::[*/0x025D/*::]*/: { n:"BrtBeginCellWatches" },
	/*::[*/0x025E/*::]*/: { n:"BrtEndCellWatches" },
	/*::[*/0x025F/*::]*/: { n:"BrtCellWatch" },
	/*::[*/0x0260/*::]*/: { n:"BrtBeginCRErrs" },
	/*::[*/0x0261/*::]*/: { n:"BrtEndCRErrs" },
	/*::[*/0x0262/*::]*/: { n:"BrtCrashRecErr" },
	/*::[*/0x0263/*::]*/: { n:"BrtBeginFonts" },
	/*::[*/0x0264/*::]*/: { n:"BrtEndFonts" },
	/*::[*/0x0265/*::]*/: { n:"BrtBeginBorders" },
	/*::[*/0x0266/*::]*/: { n:"BrtEndBorders" },
	/*::[*/0x0267/*::]*/: { n:"BrtBeginFmts" },
	/*::[*/0x0268/*::]*/: { n:"BrtEndFmts" },
	/*::[*/0x0269/*::]*/: { n:"BrtBeginCellXFs" },
	/*::[*/0x026A/*::]*/: { n:"BrtEndCellXFs" },
	/*::[*/0x026B/*::]*/: { n:"BrtBeginStyles" },
	/*::[*/0x026C/*::]*/: { n:"BrtEndStyles" },
	/*::[*/0x0271/*::]*/: { n:"BrtBigName" },
	/*::[*/0x0272/*::]*/: { n:"BrtBeginCellStyleXFs" },
	/*::[*/0x0273/*::]*/: { n:"BrtEndCellStyleXFs" },
	/*::[*/0x0274/*::]*/: { n:"BrtBeginComments" },
	/*::[*/0x0275/*::]*/: { n:"BrtEndComments" },
	/*::[*/0x0276/*::]*/: { n:"BrtBeginCommentAuthors" },
	/*::[*/0x0277/*::]*/: { n:"BrtEndCommentAuthors" },
	/*::[*/0x0278/*::]*/: { n:"BrtCommentAuthor", f:parse_BrtCommentAuthor },
	/*::[*/0x0279/*::]*/: { n:"BrtBeginCommentList" },
	/*::[*/0x027A/*::]*/: { n:"BrtEndCommentList" },
	/*::[*/0x027B/*::]*/: { n:"BrtBeginComment", f:parse_BrtBeginComment},
	/*::[*/0x027C/*::]*/: { n:"BrtEndComment" },
	/*::[*/0x027D/*::]*/: { n:"BrtCommentText", f:parse_BrtCommentText },
	/*::[*/0x027E/*::]*/: { n:"BrtBeginOleObjects" },
	/*::[*/0x027F/*::]*/: { n:"BrtOleObject" },
	/*::[*/0x0280/*::]*/: { n:"BrtEndOleObjects" },
	/*::[*/0x0281/*::]*/: { n:"BrtBeginSxrules" },
	/*::[*/0x0282/*::]*/: { n:"BrtEndSxRules" },
	/*::[*/0x0283/*::]*/: { n:"BrtBeginActiveXControls" },
	/*::[*/0x0284/*::]*/: { n:"BrtActiveX" },
	/*::[*/0x0285/*::]*/: { n:"BrtEndActiveXControls" },
	/*::[*/0x0286/*::]*/: { n:"BrtBeginPCDSDTCEMembersSortBy" },
	/*::[*/0x0288/*::]*/: { n:"BrtBeginCellIgnoreECs" },
	/*::[*/0x0289/*::]*/: { n:"BrtCellIgnoreEC" },
	/*::[*/0x028A/*::]*/: { n:"BrtEndCellIgnoreECs" },
	/*::[*/0x028B/*::]*/: { n:"BrtCsProp", f:parse_BrtCsProp },
	/*::[*/0x028C/*::]*/: { n:"BrtCsPageSetup" },
	/*::[*/0x028D/*::]*/: { n:"BrtBeginUserCsViews" },
	/*::[*/0x028E/*::]*/: { n:"BrtEndUserCsViews" },
	/*::[*/0x028F/*::]*/: { n:"BrtBeginUserCsView" },
	/*::[*/0x0290/*::]*/: { n:"BrtEndUserCsView" },
	/*::[*/0x0291/*::]*/: { n:"BrtBeginPcdSFCIEntries" },
	/*::[*/0x0292/*::]*/: { n:"BrtEndPCDSFCIEntries" },
	/*::[*/0x0293/*::]*/: { n:"BrtPCDSFCIEntry" },
	/*::[*/0x0294/*::]*/: { n:"BrtBeginListParts" },
	/*::[*/0x0295/*::]*/: { n:"BrtListPart" },
	/*::[*/0x0296/*::]*/: { n:"BrtEndListParts" },
	/*::[*/0x0297/*::]*/: { n:"BrtSheetCalcProp" },
	/*::[*/0x0298/*::]*/: { n:"BrtBeginFnGroup" },
	/*::[*/0x0299/*::]*/: { n:"BrtFnGroup" },
	/*::[*/0x029A/*::]*/: { n:"BrtEndFnGroup" },
	/*::[*/0x029B/*::]*/: { n:"BrtSupAddin" },
	/*::[*/0x029C/*::]*/: { n:"BrtSXTDMPOrder" },
	/*::[*/0x029D/*::]*/: { n:"BrtCsProtection" },
	/*::[*/0x029F/*::]*/: { n:"BrtBeginWsSortMap" },
	/*::[*/0x02A0/*::]*/: { n:"BrtEndWsSortMap" },
	/*::[*/0x02A1/*::]*/: { n:"BrtBeginRRSort" },
	/*::[*/0x02A2/*::]*/: { n:"BrtEndRRSort" },
	/*::[*/0x02A3/*::]*/: { n:"BrtRRSortItem" },
	/*::[*/0x02A4/*::]*/: { n:"BrtFileSharingIso" },
	/*::[*/0x02A5/*::]*/: { n:"BrtBookProtectionIso" },
	/*::[*/0x02A6/*::]*/: { n:"BrtSheetProtectionIso" },
	/*::[*/0x02A7/*::]*/: { n:"BrtCsProtectionIso" },
	/*::[*/0x02A8/*::]*/: { n:"BrtRangeProtectionIso" },
	/*::[*/0x02A9/*::]*/: { n:"BrtDValList" },
	/*::[*/0x0400/*::]*/: { n:"BrtRwDescent" },
	/*::[*/0x0401/*::]*/: { n:"BrtKnownFonts" },
	/*::[*/0x0402/*::]*/: { n:"BrtBeginSXTupleSet" },
	/*::[*/0x0403/*::]*/: { n:"BrtEndSXTupleSet" },
	/*::[*/0x0404/*::]*/: { n:"BrtBeginSXTupleSetHeader" },
	/*::[*/0x0405/*::]*/: { n:"BrtEndSXTupleSetHeader" },
	/*::[*/0x0406/*::]*/: { n:"BrtSXTupleSetHeaderItem" },
	/*::[*/0x0407/*::]*/: { n:"BrtBeginSXTupleSetData" },
	/*::[*/0x0408/*::]*/: { n:"BrtEndSXTupleSetData" },
	/*::[*/0x0409/*::]*/: { n:"BrtBeginSXTupleSetRow" },
	/*::[*/0x040A/*::]*/: { n:"BrtEndSXTupleSetRow" },
	/*::[*/0x040B/*::]*/: { n:"BrtSXTupleSetRowItem" },
	/*::[*/0x040C/*::]*/: { n:"BrtNameExt" },
	/*::[*/0x040D/*::]*/: { n:"BrtPCDH14" },
	/*::[*/0x040E/*::]*/: { n:"BrtBeginPCDCalcMem14" },
	/*::[*/0x040F/*::]*/: { n:"BrtEndPCDCalcMem14" },
	/*::[*/0x0410/*::]*/: { n:"BrtSXTH14" },
	/*::[*/0x0411/*::]*/: { n:"BrtBeginSparklineGroup" },
	/*::[*/0x0412/*::]*/: { n:"BrtEndSparklineGroup" },
	/*::[*/0x0413/*::]*/: { n:"BrtSparkline" },
	/*::[*/0x0414/*::]*/: { n:"BrtSXDI14" },
	/*::[*/0x0415/*::]*/: { n:"BrtWsFmtInfoEx14" },
	/*::[*/0x0416/*::]*/: { n:"BrtBeginConditionalFormatting14" },
	/*::[*/0x0417/*::]*/: { n:"BrtEndConditionalFormatting14" },
	/*::[*/0x0418/*::]*/: { n:"BrtBeginCFRule14" },
	/*::[*/0x0419/*::]*/: { n:"BrtEndCFRule14" },
	/*::[*/0x041A/*::]*/: { n:"BrtCFVO14" },
	/*::[*/0x041B/*::]*/: { n:"BrtBeginDatabar14" },
	/*::[*/0x041C/*::]*/: { n:"BrtBeginIconSet14" },
	/*::[*/0x041D/*::]*/: { n:"BrtDVal14", f: parse_BrtDVal14 },
	/*::[*/0x041E/*::]*/: { n:"BrtBeginDVals14" },
	/*::[*/0x041F/*::]*/: { n:"BrtColor14" },
	/*::[*/0x0420/*::]*/: { n:"BrtBeginSparklines" },
	/*::[*/0x0421/*::]*/: { n:"BrtEndSparklines" },
	/*::[*/0x0422/*::]*/: { n:"BrtBeginSparklineGroups" },
	/*::[*/0x0423/*::]*/: { n:"BrtEndSparklineGroups" },
	/*::[*/0x0425/*::]*/: { n:"BrtSXVD14" },
	/*::[*/0x0426/*::]*/: { n:"BrtBeginSXView14" },
	/*::[*/0x0427/*::]*/: { n:"BrtEndSXView14" },
	/*::[*/0x0428/*::]*/: { n:"BrtBeginSXView16" },
	/*::[*/0x0429/*::]*/: { n:"BrtEndSXView16" },
	/*::[*/0x042A/*::]*/: { n:"BrtBeginPCD14" },
	/*::[*/0x042B/*::]*/: { n:"BrtEndPCD14" },
	/*::[*/0x042C/*::]*/: { n:"BrtBeginExtConn14" },
	/*::[*/0x042D/*::]*/: { n:"BrtEndExtConn14" },
	/*::[*/0x042E/*::]*/: { n:"BrtBeginSlicerCacheIDs" },
	/*::[*/0x042F/*::]*/: { n:"BrtEndSlicerCacheIDs" },
	/*::[*/0x0430/*::]*/: { n:"BrtBeginSlicerCacheID" },
	/*::[*/0x0431/*::]*/: { n:"BrtEndSlicerCacheID" },
	/*::[*/0x0433/*::]*/: { n:"BrtBeginSlicerCache" },
	/*::[*/0x0434/*::]*/: { n:"BrtEndSlicerCache" },
	/*::[*/0x0435/*::]*/: { n:"BrtBeginSlicerCacheDef" },
	/*::[*/0x0436/*::]*/: { n:"BrtEndSlicerCacheDef" },
	/*::[*/0x0437/*::]*/: { n:"BrtBeginSlicersEx" },
	/*::[*/0x0438/*::]*/: { n:"BrtEndSlicersEx" },
	/*::[*/0x0439/*::]*/: { n:"BrtBeginSlicerEx" },
	/*::[*/0x043A/*::]*/: { n:"BrtEndSlicerEx" },
	/*::[*/0x043B/*::]*/: { n:"BrtBeginSlicer" },
	/*::[*/0x043C/*::]*/: { n:"BrtEndSlicer" },
	/*::[*/0x043D/*::]*/: { n:"BrtSlicerCachePivotTables" },
	/*::[*/0x043E/*::]*/: { n:"BrtBeginSlicerCacheOlapImpl" },
	/*::[*/0x043F/*::]*/: { n:"BrtEndSlicerCacheOlapImpl" },
	/*::[*/0x0440/*::]*/: { n:"BrtBeginSlicerCacheLevelsData" },
	/*::[*/0x0441/*::]*/: { n:"BrtEndSlicerCacheLevelsData" },
	/*::[*/0x0442/*::]*/: { n:"BrtBeginSlicerCacheLevelData" },
	/*::[*/0x0443/*::]*/: { n:"BrtEndSlicerCacheLevelData" },
	/*::[*/0x0444/*::]*/: { n:"BrtBeginSlicerCacheSiRanges" },
	/*::[*/0x0445/*::]*/: { n:"BrtEndSlicerCacheSiRanges" },
	/*::[*/0x0446/*::]*/: { n:"BrtBeginSlicerCacheSiRange" },
	/*::[*/0x0447/*::]*/: { n:"BrtEndSlicerCacheSiRange" },
	/*::[*/0x0448/*::]*/: { n:"BrtSlicerCacheOlapItem" },
	/*::[*/0x0449/*::]*/: { n:"BrtBeginSlicerCacheSelections" },
	/*::[*/0x044A/*::]*/: { n:"BrtSlicerCacheSelection" },
	/*::[*/0x044B/*::]*/: { n:"BrtEndSlicerCacheSelections" },
	/*::[*/0x044C/*::]*/: { n:"BrtBeginSlicerCacheNative" },
	/*::[*/0x044D/*::]*/: { n:"BrtEndSlicerCacheNative" },
	/*::[*/0x044E/*::]*/: { n:"BrtSlicerCacheNativeItem" },
	/*::[*/0x044F/*::]*/: { n:"BrtRangeProtection14" },
	/*::[*/0x0450/*::]*/: { n:"BrtRangeProtectionIso14" },
	/*::[*/0x0451/*::]*/: { n:"BrtCellIgnoreEC14" },
	/*::[*/0x0457/*::]*/: { n:"BrtList14" },
	/*::[*/0x0458/*::]*/: { n:"BrtCFIcon" },
	/*::[*/0x0459/*::]*/: { n:"BrtBeginSlicerCachesPivotCacheIDs" },
	/*::[*/0x045A/*::]*/: { n:"BrtEndSlicerCachesPivotCacheIDs" },
	/*::[*/0x045B/*::]*/: { n:"BrtBeginSlicers" },
	/*::[*/0x045C/*::]*/: { n:"BrtEndSlicers" },
	/*::[*/0x045D/*::]*/: { n:"BrtWbProp14" },
	/*::[*/0x045E/*::]*/: { n:"BrtBeginSXEdit" },
	/*::[*/0x045F/*::]*/: { n:"BrtEndSXEdit" },
	/*::[*/0x0460/*::]*/: { n:"BrtBeginSXEdits" },
	/*::[*/0x0461/*::]*/: { n:"BrtEndSXEdits" },
	/*::[*/0x0462/*::]*/: { n:"BrtBeginSXChange" },
	/*::[*/0x0463/*::]*/: { n:"BrtEndSXChange" },
	/*::[*/0x0464/*::]*/: { n:"BrtBeginSXChanges" },
	/*::[*/0x0465/*::]*/: { n:"BrtEndSXChanges" },
	/*::[*/0x0466/*::]*/: { n:"BrtSXTupleItems" },
	/*::[*/0x0468/*::]*/: { n:"BrtBeginSlicerStyle" },
	/*::[*/0x0469/*::]*/: { n:"BrtEndSlicerStyle" },
	/*::[*/0x046A/*::]*/: { n:"BrtSlicerStyleElement" },
	/*::[*/0x046B/*::]*/: { n:"BrtBeginStyleSheetExt14" },
	/*::[*/0x046C/*::]*/: { n:"BrtEndStyleSheetExt14" },
	/*::[*/0x046D/*::]*/: { n:"BrtBeginSlicerCachesPivotCacheID" },
	/*::[*/0x046E/*::]*/: { n:"BrtEndSlicerCachesPivotCacheID" },
	/*::[*/0x046F/*::]*/: { n:"BrtBeginConditionalFormattings" },
	/*::[*/0x0470/*::]*/: { n:"BrtEndConditionalFormattings" },
	/*::[*/0x0471/*::]*/: { n:"BrtBeginPCDCalcMemExt" },
	/*::[*/0x0472/*::]*/: { n:"BrtEndPCDCalcMemExt" },
	/*::[*/0x0473/*::]*/: { n:"BrtBeginPCDCalcMemsExt" },
	/*::[*/0x0474/*::]*/: { n:"BrtEndPCDCalcMemsExt" },
	/*::[*/0x0475/*::]*/: { n:"BrtPCDField14" },
	/*::[*/0x0476/*::]*/: { n:"BrtBeginSlicerStyles" },
	/*::[*/0x0477/*::]*/: { n:"BrtEndSlicerStyles" },
	/*::[*/0x0478/*::]*/: { n:"BrtBeginSlicerStyleElements" },
	/*::[*/0x0479/*::]*/: { n:"BrtEndSlicerStyleElements" },
	/*::[*/0x047A/*::]*/: { n:"BrtCFRuleExt" },
	/*::[*/0x047B/*::]*/: { n:"BrtBeginSXCondFmt14" },
	/*::[*/0x047C/*::]*/: { n:"BrtEndSXCondFmt14" },
	/*::[*/0x047D/*::]*/: { n:"BrtBeginSXCondFmts14" },
	/*::[*/0x047E/*::]*/: { n:"BrtEndSXCondFmts14" },
	/*::[*/0x0480/*::]*/: { n:"BrtBeginSortCond14" },
	/*::[*/0x0481/*::]*/: { n:"BrtEndSortCond14" },
	/*::[*/0x0482/*::]*/: { n:"BrtEndDVals14" },
	/*::[*/0x0483/*::]*/: { n:"BrtEndIconSet14" },
	/*::[*/0x0484/*::]*/: { n:"BrtEndDatabar14" },
	/*::[*/0x0485/*::]*/: { n:"BrtBeginColorScale14" },
	/*::[*/0x0486/*::]*/: { n:"BrtEndColorScale14" },
	/*::[*/0x0487/*::]*/: { n:"BrtBeginSxrules14" },
	/*::[*/0x0488/*::]*/: { n:"BrtEndSxrules14" },
	/*::[*/0x0489/*::]*/: { n:"BrtBeginPRule14" },
	/*::[*/0x048A/*::]*/: { n:"BrtEndPRule14" },
	/*::[*/0x048B/*::]*/: { n:"BrtBeginPRFilters14" },
	/*::[*/0x048C/*::]*/: { n:"BrtEndPRFilters14" },
	/*::[*/0x048D/*::]*/: { n:"BrtBeginPRFilter14" },
	/*::[*/0x048E/*::]*/: { n:"BrtEndPRFilter14" },
	/*::[*/0x048F/*::]*/: { n:"BrtBeginPRFItem14" },
	/*::[*/0x0490/*::]*/: { n:"BrtEndPRFItem14" },
	/*::[*/0x0491/*::]*/: { n:"BrtBeginCellIgnoreECs14" },
	/*::[*/0x0492/*::]*/: { n:"BrtEndCellIgnoreECs14" },
	/*::[*/0x0493/*::]*/: { n:"BrtDxf14" },
	/*::[*/0x0494/*::]*/: { n:"BrtBeginDxF14s" },
	/*::[*/0x0495/*::]*/: { n:"BrtEndDxf14s" },
	/*::[*/0x0499/*::]*/: { n:"BrtFilter14" },
	/*::[*/0x049A/*::]*/: { n:"BrtBeginCustomFilters14" },
	/*::[*/0x049C/*::]*/: { n:"BrtCustomFilter14" },
	/*::[*/0x049D/*::]*/: { n:"BrtIconFilter14" },
	/*::[*/0x049E/*::]*/: { n:"BrtPivotCacheConnectionName" },
	/*::[*/0x0800/*::]*/: { n:"BrtBeginDecoupledPivotCacheIDs" },
	/*::[*/0x0801/*::]*/: { n:"BrtEndDecoupledPivotCacheIDs" },
	/*::[*/0x0802/*::]*/: { n:"BrtDecoupledPivotCacheID" },
	/*::[*/0x0803/*::]*/: { n:"BrtBeginPivotTableRefs" },
	/*::[*/0x0804/*::]*/: { n:"BrtEndPivotTableRefs" },
	/*::[*/0x0805/*::]*/: { n:"BrtPivotTableRef" },
	/*::[*/0x0806/*::]*/: { n:"BrtSlicerCacheBookPivotTables" },
	/*::[*/0x0807/*::]*/: { n:"BrtBeginSxvcells" },
	/*::[*/0x0808/*::]*/: { n:"BrtEndSxvcells" },
	/*::[*/0x0809/*::]*/: { n:"BrtBeginSxRow" },
	/*::[*/0x080A/*::]*/: { n:"BrtEndSxRow" },
	/*::[*/0x080C/*::]*/: { n:"BrtPcdCalcMem15" },
	/*::[*/0x0813/*::]*/: { n:"BrtQsi15" },
	/*::[*/0x0814/*::]*/: { n:"BrtBeginWebExtensions" },
	/*::[*/0x0815/*::]*/: { n:"BrtEndWebExtensions" },
	/*::[*/0x0816/*::]*/: { n:"BrtWebExtension" },
	/*::[*/0x0817/*::]*/: { n:"BrtAbsPath15" },
	/*::[*/0x0818/*::]*/: { n:"BrtBeginPivotTableUISettings" },
	/*::[*/0x0819/*::]*/: { n:"BrtEndPivotTableUISettings" },
	/*::[*/0x081B/*::]*/: { n:"BrtTableSlicerCacheIDs" },
	/*::[*/0x081C/*::]*/: { n:"BrtTableSlicerCacheID" },
	/*::[*/0x081D/*::]*/: { n:"BrtBeginTableSlicerCache" },
	/*::[*/0x081E/*::]*/: { n:"BrtEndTableSlicerCache" },
	/*::[*/0x081F/*::]*/: { n:"BrtSxFilter15" },
	/*::[*/0x0820/*::]*/: { n:"BrtBeginTimelineCachePivotCacheIDs" },
	/*::[*/0x0821/*::]*/: { n:"BrtEndTimelineCachePivotCacheIDs" },
	/*::[*/0x0822/*::]*/: { n:"BrtTimelineCachePivotCacheID" },
	/*::[*/0x0823/*::]*/: { n:"BrtBeginTimelineCacheIDs" },
	/*::[*/0x0824/*::]*/: { n:"BrtEndTimelineCacheIDs" },
	/*::[*/0x0825/*::]*/: { n:"BrtBeginTimelineCacheID" },
	/*::[*/0x0826/*::]*/: { n:"BrtEndTimelineCacheID" },
	/*::[*/0x0827/*::]*/: { n:"BrtBeginTimelinesEx" },
	/*::[*/0x0828/*::]*/: { n:"BrtEndTimelinesEx" },
	/*::[*/0x0829/*::]*/: { n:"BrtBeginTimelineEx" },
	/*::[*/0x082A/*::]*/: { n:"BrtEndTimelineEx" },
	/*::[*/0x082B/*::]*/: { n:"BrtWorkBookPr15" },
	/*::[*/0x082C/*::]*/: { n:"BrtPCDH15" },
	/*::[*/0x082D/*::]*/: { n:"BrtBeginTimelineStyle" },
	/*::[*/0x082E/*::]*/: { n:"BrtEndTimelineStyle" },
	/*::[*/0x082F/*::]*/: { n:"BrtTimelineStyleElement" },
	/*::[*/0x0830/*::]*/: { n:"BrtBeginTimelineStylesheetExt15" },
	/*::[*/0x0831/*::]*/: { n:"BrtEndTimelineStylesheetExt15" },
	/*::[*/0x0832/*::]*/: { n:"BrtBeginTimelineStyles" },
	/*::[*/0x0833/*::]*/: { n:"BrtEndTimelineStyles" },
	/*::[*/0x0834/*::]*/: { n:"BrtBeginTimelineStyleElements" },
	/*::[*/0x0835/*::]*/: { n:"BrtEndTimelineStyleElements" },
	/*::[*/0x0836/*::]*/: { n:"BrtDxf15" },
	/*::[*/0x0837/*::]*/: { n:"BrtBeginDxfs15" },
	/*::[*/0x0838/*::]*/: { n:"brtEndDxfs15" },
	/*::[*/0x0839/*::]*/: { n:"BrtSlicerCacheHideItemsWithNoData" },
	/*::[*/0x083A/*::]*/: { n:"BrtBeginItemUniqueNames" },
	/*::[*/0x083B/*::]*/: { n:"BrtEndItemUniqueNames" },
	/*::[*/0x083C/*::]*/: { n:"BrtItemUniqueName" },
	/*::[*/0x083D/*::]*/: { n:"BrtBeginExtConn15" },
	/*::[*/0x083E/*::]*/: { n:"BrtEndExtConn15" },
	/*::[*/0x083F/*::]*/: { n:"BrtBeginOledbPr15" },
	/*::[*/0x0840/*::]*/: { n:"BrtEndOledbPr15" },
	/*::[*/0x0841/*::]*/: { n:"BrtBeginDataFeedPr15" },
	/*::[*/0x0842/*::]*/: { n:"BrtEndDataFeedPr15" },
	/*::[*/0x0843/*::]*/: { n:"BrtTextPr15" },
	/*::[*/0x0844/*::]*/: { n:"BrtRangePr15" },
	/*::[*/0x0845/*::]*/: { n:"BrtDbCommand15" },
	/*::[*/0x0846/*::]*/: { n:"BrtBeginDbTables15" },
	/*::[*/0x0847/*::]*/: { n:"BrtEndDbTables15" },
	/*::[*/0x0848/*::]*/: { n:"BrtDbTable15" },
	/*::[*/0x0849/*::]*/: { n:"BrtBeginDataModel" },
	/*::[*/0x084A/*::]*/: { n:"BrtEndDataModel" },
	/*::[*/0x084B/*::]*/: { n:"BrtBeginModelTables" },
	/*::[*/0x084C/*::]*/: { n:"BrtEndModelTables" },
	/*::[*/0x084D/*::]*/: { n:"BrtModelTable" },
	/*::[*/0x084E/*::]*/: { n:"BrtBeginModelRelationships" },
	/*::[*/0x084F/*::]*/: { n:"BrtEndModelRelationships" },
	/*::[*/0x0850/*::]*/: { n:"BrtModelRelationship" },
	/*::[*/0x0851/*::]*/: { n:"BrtBeginECTxtWiz15" },
	/*::[*/0x0852/*::]*/: { n:"BrtEndECTxtWiz15" },
	/*::[*/0x0853/*::]*/: { n:"BrtBeginECTWFldInfoLst15" },
	/*::[*/0x0854/*::]*/: { n:"BrtEndECTWFldInfoLst15" },
	/*::[*/0x0855/*::]*/: { n:"BrtBeginECTWFldInfo15" },
	/*::[*/0x0856/*::]*/: { n:"BrtFieldListActiveItem" },
	/*::[*/0x0857/*::]*/: { n:"BrtPivotCacheIdVersion" },
	/*::[*/0x0858/*::]*/: { n:"BrtSXDI15" },
	/*::[*/0x0859/*::]*/: { n:"BrtBeginModelTimeGroupings" },
	/*::[*/0x085A/*::]*/: { n:"BrtEndModelTimeGroupings" },
	/*::[*/0x085B/*::]*/: { n:"BrtBeginModelTimeGrouping" },
	/*::[*/0x085C/*::]*/: { n:"BrtEndModelTimeGrouping" },
	/*::[*/0x085D/*::]*/: { n:"BrtModelTimeGroupingCalcCol" },
	/*::[*/0x0C00/*::]*/: { n:"BrtUid" },
	/*::[*/0x0C01/*::]*/: { n:"BrtRevisionPtr" },
	/*::[*/0x13e7/*::]*/: { n:"BrtBeginCalcFeatures" },
	/*::[*/0x13e8/*::]*/: { n:"BrtEndCalcFeatures" },
	/*::[*/0x13e9/*::]*/: { n:"BrtCalcFeature" },
	/*::[*/0xFFFF/*::]*/: { n:"" }
};

var XLSBRE;
function make_XLSBRE() {
	XLSBRE = evert_key(XLSBRecordEnum, 'n');
	/*jshint -W069 */
	XLSBRE["BrtFRTArchID$"] = 0x0010;
	/*jshint +W069 */
}

/* [MS-XLS] 2.3 Record Enumeration (and other sources) */
var XLSRecordEnum = {
	/* [MS-XLS] 2.3 Record Enumeration 2021-08-17 */
	/*::[*/0x0006/*::]*/: { n:"Formula", f:parse_Formula },
	/*::[*/0x000a/*::]*/: { n:'EOF', f:parsenoop2 },
	/*::[*/0x000c/*::]*/: { n:"CalcCount", f:parseuint16 },
	/*::[*/0x000d/*::]*/: { n:"CalcMode", f:parseuint16 },
	/*::[*/0x000e/*::]*/: { n:"CalcPrecision", f:parsebool },
	/*::[*/0x000f/*::]*/: { n:"CalcRefMode", f:parsebool },
	/*::[*/0x0010/*::]*/: { n:"CalcDelta", f:parse_Xnum },
	/*::[*/0x0011/*::]*/: { n:"CalcIter", f:parsebool },
	/*::[*/0x0012/*::]*/: { n:"Protect", f:parsebool },
	/*::[*/0x0013/*::]*/: { n:"Password", f:parseuint16 },
	/*::[*/0x0014/*::]*/: { n:"Header", f:parse_XLHeaderFooter },
	/*::[*/0x0015/*::]*/: { n:"Footer", f:parse_XLHeaderFooter },
	/*::[*/0x0017/*::]*/: { n:"ExternSheet", f:parse_ExternSheet },
	/*::[*/0x0018/*::]*/: { n:"Lbl", f:parse_Lbl },
	/*::[*/0x0019/*::]*/: { n:"WinProtect", f:parsebool },
	/*::[*/0x001a/*::]*/: { n:"VerticalPageBreaks" },
	/*::[*/0x001b/*::]*/: { n:"HorizontalPageBreaks" },
	/*::[*/0x001c/*::]*/: { n:"Note", f:parse_Note },
	/*::[*/0x001d/*::]*/: { n:"Selection" },
	/*::[*/0x0022/*::]*/: { n:"Date1904", f:parsebool },
	/*::[*/0x0023/*::]*/: { n:"ExternName", f:parse_ExternName },
	/*::[*/0x0026/*::]*/: { n:"LeftMargin", f:parse_Xnum },
	/*::[*/0x0027/*::]*/: { n:"RightMargin", f:parse_Xnum },
	/*::[*/0x0028/*::]*/: { n:"TopMargin", f:parse_Xnum },
	/*::[*/0x0029/*::]*/: { n:"BottomMargin", f:parse_Xnum },
	/*::[*/0x002a/*::]*/: { n:"PrintRowCol", f:parsebool },
	/*::[*/0x002b/*::]*/: { n:"PrintGrid", f:parsebool },
	/*::[*/0x002f/*::]*/: { n:"FilePass", f:parse_FilePass },
	/*::[*/0x0031/*::]*/: { n:"Font", f:parse_Font },
	/*::[*/0x0033/*::]*/: { n:"PrintSize", f:parseuint16 },
	/*::[*/0x003c/*::]*/: { n:"Continue" },
	/*::[*/0x003d/*::]*/: { n:"Window1", f:parse_Window1 },
	/*::[*/0x0040/*::]*/: { n:"Backup", f:parsebool },
	/*::[*/0x0041/*::]*/: { n:"Pane", f:parse_Pane },
	/*::[*/0x0042/*::]*/: { n:'CodePage', f:parseuint16 },
	/*::[*/0x004d/*::]*/: { n:"Pls" },
	/*::[*/0x0050/*::]*/: { n:"DCon" },
	/*::[*/0x0051/*::]*/: { n:"DConRef" },
	/*::[*/0x0052/*::]*/: { n:"DConName" },
	/*::[*/0x0055/*::]*/: { n:"DefColWidth", f:parseuint16 },
	/*::[*/0x0059/*::]*/: { n:"XCT" },
	/*::[*/0x005a/*::]*/: { n:"CRN" },
	/*::[*/0x005b/*::]*/: { n:"FileSharing" },
	/*::[*/0x005c/*::]*/: { n:'WriteAccess', f:parse_WriteAccess },
	/*::[*/0x005d/*::]*/: { n:"Obj", f:parse_Obj },
	/*::[*/0x005e/*::]*/: { n:"Uncalced" },
	/*::[*/0x005f/*::]*/: { n:"CalcSaveRecalc", f:parsebool },
	/*::[*/0x0060/*::]*/: { n:"Template" },
	/*::[*/0x0061/*::]*/: { n:"Intl" },
	/*::[*/0x0063/*::]*/: { n:"ObjProtect", f:parsebool },
	/*::[*/0x007d/*::]*/: { n:"ColInfo", f:parse_ColInfo },
	/*::[*/0x0080/*::]*/: { n:"Guts", f:parse_Guts },
	/*::[*/0x0081/*::]*/: { n:"WsBool", f:parse_WsBool },
	/*::[*/0x0082/*::]*/: { n:"GridSet", f:parseuint16 },
	/*::[*/0x0083/*::]*/: { n:"HCenter", f:parsebool },
	/*::[*/0x0084/*::]*/: { n:"VCenter", f:parsebool },
	/*::[*/0x0085/*::]*/: { n:'BoundSheet8', f:parse_BoundSheet8 },
	/*::[*/0x0086/*::]*/: { n:"WriteProtect" },
	/*::[*/0x008c/*::]*/: { n:"Country", f:parse_Country },
	/*::[*/0x008d/*::]*/: { n:"HideObj", f:parseuint16 },
	/*::[*/0x0090/*::]*/: { n:"Sort" },
	/*::[*/0x0092/*::]*/: { n:"Palette", f:parse_Palette },
	/*::[*/0x0097/*::]*/: { n:"Sync" },
	/*::[*/0x0098/*::]*/: { n:"LPr" },
	/*::[*/0x0099/*::]*/: { n:"DxGCol" },
	/*::[*/0x009a/*::]*/: { n:"FnGroupName" },
	/*::[*/0x009b/*::]*/: { n:"FilterMode" },
	/*::[*/0x009c/*::]*/: { n:"BuiltInFnGroupCount", f:parseuint16 },
	/*::[*/0x009d/*::]*/: { n:"AutoFilterInfo" },
	/*::[*/0x009e/*::]*/: { n:"AutoFilter" },
	/*::[*/0x00a0/*::]*/: { n:"Scl", f:parse_Scl },
	/*::[*/0x00a1/*::]*/: { n:"Setup", f:parse_Setup },
	/*::[*/0x00ae/*::]*/: { n:"ScenMan" },
	/*::[*/0x00af/*::]*/: { n:"SCENARIO" },
	/*::[*/0x00b0/*::]*/: { n:"SxView" },
	/*::[*/0x00b1/*::]*/: { n:"Sxvd" },
	/*::[*/0x00b2/*::]*/: { n:"SXVI" },
	/*::[*/0x00b4/*::]*/: { n:"SxIvd" },
	/*::[*/0x00b5/*::]*/: { n:"SXLI" },
	/*::[*/0x00b6/*::]*/: { n:"SXPI" },
	/*::[*/0x00b8/*::]*/: { n:"DocRoute" },
	/*::[*/0x00b9/*::]*/: { n:"RecipName" },
	/*::[*/0x00bd/*::]*/: { n:"MulRk", f:parse_MulRk },
	/*::[*/0x00be/*::]*/: { n:"MulBlank", f:parse_MulBlank },
	/*::[*/0x00c1/*::]*/: { n:'Mms', f:parsenoop2 },
	/*::[*/0x00c5/*::]*/: { n:"SXDI" },
	/*::[*/0x00c6/*::]*/: { n:"SXDB" },
	/*::[*/0x00c7/*::]*/: { n:"SXFDB" },
	/*::[*/0x00c8/*::]*/: { n:"SXDBB" },
	/*::[*/0x00c9/*::]*/: { n:"SXNum" },
	/*::[*/0x00ca/*::]*/: { n:"SxBool", f:parsebool },
	/*::[*/0x00cb/*::]*/: { n:"SxErr" },
	/*::[*/0x00cc/*::]*/: { n:"SXInt" },
	/*::[*/0x00cd/*::]*/: { n:"SXString" },
	/*::[*/0x00ce/*::]*/: { n:"SXDtr" },
	/*::[*/0x00cf/*::]*/: { n:"SxNil" },
	/*::[*/0x00d0/*::]*/: { n:"SXTbl" },
	/*::[*/0x00d1/*::]*/: { n:"SXTBRGIITM" },
	/*::[*/0x00d2/*::]*/: { n:"SxTbpg" },
	/*::[*/0x00d3/*::]*/: { n:"ObProj" },
	/*::[*/0x00d5/*::]*/: { n:"SXStreamID" },
	/*::[*/0x00d7/*::]*/: { n:"DBCell" },
	/*::[*/0x00d8/*::]*/: { n:"SXRng" },
	/*::[*/0x00d9/*::]*/: { n:"SxIsxoper" },
	/*::[*/0x00da/*::]*/: { n:"BookBool", f:parseuint16 },
	/*::[*/0x00dc/*::]*/: { n:"DbOrParamQry" },
	/*::[*/0x00dd/*::]*/: { n:"ScenarioProtect", f:parsebool },
	/*::[*/0x00de/*::]*/: { n:"OleObjectSize" },
	/*::[*/0x00e0/*::]*/: { n:"XF", f:parse_XF },
	/*::[*/0x00e1/*::]*/: { n:'InterfaceHdr', f:parse_InterfaceHdr },
	/*::[*/0x00e2/*::]*/: { n:'InterfaceEnd', f:parsenoop2 },
	/*::[*/0x00e3/*::]*/: { n:"SXVS" },
	/*::[*/0x00e5/*::]*/: { n:"MergeCells", f:parse_MergeCells },
	/*::[*/0x00e9/*::]*/: { n:"BkHim" },
	/*::[*/0x00eb/*::]*/: { n:"MsoDrawingGroup" },
	/*::[*/0x00ec/*::]*/: { n:"MsoDrawing" },
	/*::[*/0x00ed/*::]*/: { n:"MsoDrawingSelection" },
	/*::[*/0x00ef/*::]*/: { n:"PhoneticInfo" },
	/*::[*/0x00f0/*::]*/: { n:"SxRule" },
	/*::[*/0x00f1/*::]*/: { n:"SXEx" },
	/*::[*/0x00f2/*::]*/: { n:"SxFilt" },
	/*::[*/0x00f4/*::]*/: { n:"SxDXF" },
	/*::[*/0x00f5/*::]*/: { n:"SxItm" },
	/*::[*/0x00f6/*::]*/: { n:"SxName" },
	/*::[*/0x00f7/*::]*/: { n:"SxSelect" },
	/*::[*/0x00f8/*::]*/: { n:"SXPair" },
	/*::[*/0x00f9/*::]*/: { n:"SxFmla" },
	/*::[*/0x00fb/*::]*/: { n:"SxFormat" },
	/*::[*/0x00fc/*::]*/: { n:"SST", f:parse_SST },
	/*::[*/0x00fd/*::]*/: { n:"LabelSst", f:parse_LabelSst },
	/*::[*/0x00ff/*::]*/: { n:"ExtSST", f:parse_ExtSST },
	/*::[*/0x0100/*::]*/: { n:"SXVDEx" },
	/*::[*/0x0103/*::]*/: { n:"SXFormula" },
	/*::[*/0x0122/*::]*/: { n:"SXDBEx" },
	/*::[*/0x0137/*::]*/: { n:"RRDInsDel" },
	/*::[*/0x0138/*::]*/: { n:"RRDHead" },
	/*::[*/0x013b/*::]*/: { n:"RRDChgCell" },
	/*::[*/0x013d/*::]*/: { n:"RRTabId", f:parseuint16a },
	/*::[*/0x013e/*::]*/: { n:"RRDRenSheet" },
	/*::[*/0x013f/*::]*/: { n:"RRSort" },
	/*::[*/0x0140/*::]*/: { n:"RRDMove" },
	/*::[*/0x014a/*::]*/: { n:"RRFormat" },
	/*::[*/0x014b/*::]*/: { n:"RRAutoFmt" },
	/*::[*/0x014d/*::]*/: { n:"RRInsertSh" },
	/*::[*/0x014e/*::]*/: { n:"RRDMoveBegin" },
	/*::[*/0x014f/*::]*/: { n:"RRDMoveEnd" },
	/*::[*/0x0150/*::]*/: { n:"RRDInsDelBegin" },
	/*::[*/0x0151/*::]*/: { n:"RRDInsDelEnd" },
	/*::[*/0x0152/*::]*/: { n:"RRDConflict" },
	/*::[*/0x0153/*::]*/: { n:"RRDDefName" },
	/*::[*/0x0154/*::]*/: { n:"RRDRstEtxp" },
	/*::[*/0x015f/*::]*/: { n:"LRng" },
	/*::[*/0x0160/*::]*/: { n:"UsesELFs", f:parsebool },
	/*::[*/0x0161/*::]*/: { n:"DSF", f:parsenoop2 },
	/*::[*/0x0191/*::]*/: { n:"CUsr" },
	/*::[*/0x0192/*::]*/: { n:"CbUsr" },
	/*::[*/0x0193/*::]*/: { n:"UsrInfo" },
	/*::[*/0x0194/*::]*/: { n:"UsrExcl" },
	/*::[*/0x0195/*::]*/: { n:"FileLock" },
	/*::[*/0x0196/*::]*/: { n:"RRDInfo" },
	/*::[*/0x0197/*::]*/: { n:"BCUsrs" },
	/*::[*/0x0198/*::]*/: { n:"UsrChk" },
	/*::[*/0x01a9/*::]*/: { n:"UserBView" },
	/*::[*/0x01aa/*::]*/: { n:"UserSViewBegin" },
	/*::[*/0x01ab/*::]*/: { n:"UserSViewEnd" },
	/*::[*/0x01ac/*::]*/: { n:"RRDUserView" },
	/*::[*/0x01ad/*::]*/: { n:"Qsi" },
	/*::[*/0x01ae/*::]*/: { n:"SupBook", f:parse_SupBook },
	/*::[*/0x01af/*::]*/: { n:"Prot4Rev", f:parsebool },
	/*::[*/0x01b0/*::]*/: { n:"CondFmt" },
	/*::[*/0x01b1/*::]*/: { n:"CF" },
	/*::[*/0x01b2/*::]*/: { n:"DVal" },
	/*::[*/0x01b5/*::]*/: { n:"DConBin" },
	/*::[*/0x01b6/*::]*/: { n:"TxO", f:parse_TxO },
	/*::[*/0x01b7/*::]*/: { n:"RefreshAll", f:parsebool },
	/*::[*/0x01b8/*::]*/: { n:"HLink", f:parse_HLink },
	/*::[*/0x01b9/*::]*/: { n:"Lel" },
	/*::[*/0x01ba/*::]*/: { n:"CodeName", f:parse_XLUnicodeString },
	/*::[*/0x01bb/*::]*/: { n:"SXFDBType" },
	/*::[*/0x01bc/*::]*/: { n:"Prot4RevPass", f:parseuint16 },
	/*::[*/0x01bd/*::]*/: { n:"ObNoMacros" },
	/*::[*/0x01be/*::]*/: { n:"Dv" },
	/*::[*/0x01c0/*::]*/: { n:"Excel9File", f:parsenoop2 },
	/*::[*/0x01c1/*::]*/: { n:"RecalcId", f:parse_RecalcId, r:2},
	/*::[*/0x01c2/*::]*/: { n:"EntExU2", f:parsenoop2 },
	/*::[*/0x0200/*::]*/: { n:"Dimensions", f:parse_Dimensions },
	/*::[*/0x0201/*::]*/: { n:"Blank", f:parse_Blank },
	/*::[*/0x0203/*::]*/: { n:"Number", f:parse_Number },
	/*::[*/0x0204/*::]*/: { n:"Label", f:parse_Label },
	/*::[*/0x0205/*::]*/: { n:"BoolErr", f:parse_BoolErr },
	/*::[*/0x0207/*::]*/: { n:"String", f:parse_String },
	/*::[*/0x0208/*::]*/: { n:'Row', f:parse_Row },
	/*::[*/0x020b/*::]*/: { n:"Index" },
	/*::[*/0x0221/*::]*/: { n:"Array", f:parse_Array },
	/*::[*/0x0225/*::]*/: { n:"DefaultRowHeight", f:parse_DefaultRowHeight },
	/*::[*/0x0236/*::]*/: { n:"Table" },
	/*::[*/0x023e/*::]*/: { n:"Window2", f:parse_Window2 },
	/*::[*/0x027e/*::]*/: { n:"RK", f:parse_RK },
	/*::[*/0x0293/*::]*/: { n:"Style" },
	/*::[*/0x0418/*::]*/: { n:"BigName" },
	/*::[*/0x041e/*::]*/: { n:"Format", f:parse_Format },
	/*::[*/0x043c/*::]*/: { n:"ContinueBigName" },
	/*::[*/0x04bc/*::]*/: { n:"ShrFmla", f:parse_ShrFmla },
	/*::[*/0x0800/*::]*/: { n:"HLinkTooltip", f:parse_HLinkTooltip },
	/*::[*/0x0801/*::]*/: { n:"WebPub" },
	/*::[*/0x0802/*::]*/: { n:"QsiSXTag" },
	/*::[*/0x0803/*::]*/: { n:"DBQueryExt" },
	/*::[*/0x0804/*::]*/: { n:"ExtString" },
	/*::[*/0x0805/*::]*/: { n:"TxtQry" },
	/*::[*/0x0806/*::]*/: { n:"Qsir" },
	/*::[*/0x0807/*::]*/: { n:"Qsif" },
	/*::[*/0x0808/*::]*/: { n:"RRDTQSIF" },
	/*::[*/0x0809/*::]*/: { n:'BOF', f:parse_BOF },
	/*::[*/0x080a/*::]*/: { n:"OleDbConn" },
	/*::[*/0x080b/*::]*/: { n:"WOpt" },
	/*::[*/0x080c/*::]*/: { n:"SXViewEx" },
	/*::[*/0x080d/*::]*/: { n:"SXTH" },
	/*::[*/0x080e/*::]*/: { n:"SXPIEx" },
	/*::[*/0x080f/*::]*/: { n:"SXVDTEx" },
	/*::[*/0x0810/*::]*/: { n:"SXViewEx9" },
	/*::[*/0x0812/*::]*/: { n:"ContinueFrt" },
	/*::[*/0x0813/*::]*/: { n:"RealTimeData" },
	/*::[*/0x0850/*::]*/: { n:"ChartFrtInfo" },
	/*::[*/0x0851/*::]*/: { n:"FrtWrapper" },
	/*::[*/0x0852/*::]*/: { n:"StartBlock" },
	/*::[*/0x0853/*::]*/: { n:"EndBlock" },
	/*::[*/0x0854/*::]*/: { n:"StartObject" },
	/*::[*/0x0855/*::]*/: { n:"EndObject" },
	/*::[*/0x0856/*::]*/: { n:"CatLab" },
	/*::[*/0x0857/*::]*/: { n:"YMult" },
	/*::[*/0x0858/*::]*/: { n:"SXViewLink" },
	/*::[*/0x0859/*::]*/: { n:"PivotChartBits" },
	/*::[*/0x085a/*::]*/: { n:"FrtFontList" },
	/*::[*/0x0862/*::]*/: { n:"SheetExt" },
	/*::[*/0x0863/*::]*/: { n:"BookExt", r:12},
	/*::[*/0x0864/*::]*/: { n:"SXAddl" },
	/*::[*/0x0865/*::]*/: { n:"CrErr" },
	/*::[*/0x0866/*::]*/: { n:"HFPicture" },
	/*::[*/0x0867/*::]*/: { n:'FeatHdr', f:parsenoop2 },
	/*::[*/0x0868/*::]*/: { n:"Feat" },
	/*::[*/0x086a/*::]*/: { n:"DataLabExt" },
	/*::[*/0x086b/*::]*/: { n:"DataLabExtContents" },
	/*::[*/0x086c/*::]*/: { n:"CellWatch" },
	/*::[*/0x0871/*::]*/: { n:"FeatHdr11" },
	/*::[*/0x0872/*::]*/: { n:"Feature11" },
	/*::[*/0x0874/*::]*/: { n:"DropDownObjIds" },
	/*::[*/0x0875/*::]*/: { n:"ContinueFrt11" },
	/*::[*/0x0876/*::]*/: { n:"DConn" },
	/*::[*/0x0877/*::]*/: { n:"List12" },
	/*::[*/0x0878/*::]*/: { n:"Feature12" },
	/*::[*/0x0879/*::]*/: { n:"CondFmt12" },
	/*::[*/0x087a/*::]*/: { n:"CF12" },
	/*::[*/0x087b/*::]*/: { n:"CFEx" },
	/*::[*/0x087c/*::]*/: { n:"XFCRC", f:parse_XFCRC, r:12 },
	/*::[*/0x087d/*::]*/: { n:"XFExt", f:parse_XFExt, r:12 },
	/*::[*/0x087e/*::]*/: { n:"AutoFilter12" },
	/*::[*/0x087f/*::]*/: { n:"ContinueFrt12" },
	/*::[*/0x0884/*::]*/: { n:"MDTInfo" },
	/*::[*/0x0885/*::]*/: { n:"MDXStr" },
	/*::[*/0x0886/*::]*/: { n:"MDXTuple" },
	/*::[*/0x0887/*::]*/: { n:"MDXSet" },
	/*::[*/0x0888/*::]*/: { n:"MDXProp" },
	/*::[*/0x0889/*::]*/: { n:"MDXKPI" },
	/*::[*/0x088a/*::]*/: { n:"MDB" },
	/*::[*/0x088b/*::]*/: { n:"PLV" },
	/*::[*/0x088c/*::]*/: { n:"Compat12", f:parsebool, r:12 },
	/*::[*/0x088d/*::]*/: { n:"DXF" },
	/*::[*/0x088e/*::]*/: { n:"TableStyles", r:12 },
	/*::[*/0x088f/*::]*/: { n:"TableStyle" },
	/*::[*/0x0890/*::]*/: { n:"TableStyleElement" },
	/*::[*/0x0892/*::]*/: { n:"StyleExt" },
	/*::[*/0x0893/*::]*/: { n:"NamePublish" },
	/*::[*/0x0894/*::]*/: { n:"NameCmt", f:parse_NameCmt, r:12 },
	/*::[*/0x0895/*::]*/: { n:"SortData" },
	/*::[*/0x0896/*::]*/: { n:"Theme", f:parse_Theme, r:12 },
	/*::[*/0x0897/*::]*/: { n:"GUIDTypeLib" },
	/*::[*/0x0898/*::]*/: { n:"FnGrp12" },
	/*::[*/0x0899/*::]*/: { n:"NameFnGrp12" },
	/*::[*/0x089a/*::]*/: { n:"MTRSettings", f:parse_MTRSettings, r:12 },
	/*::[*/0x089b/*::]*/: { n:"CompressPictures", f:parsenoop2 },
	/*::[*/0x089c/*::]*/: { n:"HeaderFooter" },
	/*::[*/0x089d/*::]*/: { n:"CrtLayout12" },
	/*::[*/0x089e/*::]*/: { n:"CrtMlFrt" },
	/*::[*/0x089f/*::]*/: { n:"CrtMlFrtContinue" },
	/*::[*/0x08a3/*::]*/: { n:"ForceFullCalculation", f:parse_ForceFullCalculation },
	/*::[*/0x08a4/*::]*/: { n:"ShapePropsStream" },
	/*::[*/0x08a5/*::]*/: { n:"TextPropsStream" },
	/*::[*/0x08a6/*::]*/: { n:"RichTextStream" },
	/*::[*/0x08a7/*::]*/: { n:"CrtLayout12A" },
	/*::[*/0x1001/*::]*/: { n:"Units" },
	/*::[*/0x1002/*::]*/: { n:"Chart" },
	/*::[*/0x1003/*::]*/: { n:"Series" },
	/*::[*/0x1006/*::]*/: { n:"DataFormat" },
	/*::[*/0x1007/*::]*/: { n:"LineFormat" },
	/*::[*/0x1009/*::]*/: { n:"MarkerFormat" },
	/*::[*/0x100a/*::]*/: { n:"AreaFormat" },
	/*::[*/0x100b/*::]*/: { n:"PieFormat" },
	/*::[*/0x100c/*::]*/: { n:"AttachedLabel" },
	/*::[*/0x100d/*::]*/: { n:"SeriesText" },
	/*::[*/0x1014/*::]*/: { n:"ChartFormat" },
	/*::[*/0x1015/*::]*/: { n:"Legend" },
	/*::[*/0x1016/*::]*/: { n:"SeriesList" },
	/*::[*/0x1017/*::]*/: { n:"Bar" },
	/*::[*/0x1018/*::]*/: { n:"Line" },
	/*::[*/0x1019/*::]*/: { n:"Pie" },
	/*::[*/0x101a/*::]*/: { n:"Area" },
	/*::[*/0x101b/*::]*/: { n:"Scatter" },
	/*::[*/0x101c/*::]*/: { n:"CrtLine" },
	/*::[*/0x101d/*::]*/: { n:"Axis" },
	/*::[*/0x101e/*::]*/: { n:"Tick" },
	/*::[*/0x101f/*::]*/: { n:"ValueRange" },
	/*::[*/0x1020/*::]*/: { n:"CatSerRange" },
	/*::[*/0x1021/*::]*/: { n:"AxisLine" },
	/*::[*/0x1022/*::]*/: { n:"CrtLink" },
	/*::[*/0x1024/*::]*/: { n:"DefaultText" },
	/*::[*/0x1025/*::]*/: { n:"Text" },
	/*::[*/0x1026/*::]*/: { n:"FontX", f:parseuint16 },
	/*::[*/0x1027/*::]*/: { n:"ObjectLink" },
	/*::[*/0x1032/*::]*/: { n:"Frame" },
	/*::[*/0x1033/*::]*/: { n:"Begin" },
	/*::[*/0x1034/*::]*/: { n:"End" },
	/*::[*/0x1035/*::]*/: { n:"PlotArea" },
	/*::[*/0x103a/*::]*/: { n:"Chart3d" },
	/*::[*/0x103c/*::]*/: { n:"PicF" },
	/*::[*/0x103d/*::]*/: { n:"DropBar" },
	/*::[*/0x103e/*::]*/: { n:"Radar" },
	/*::[*/0x103f/*::]*/: { n:"Surf" },
	/*::[*/0x1040/*::]*/: { n:"RadarArea" },
	/*::[*/0x1041/*::]*/: { n:"AxisParent" },
	/*::[*/0x1043/*::]*/: { n:"LegendException" },
	/*::[*/0x1044/*::]*/: { n:"ShtProps", f:parse_ShtProps },
	/*::[*/0x1045/*::]*/: { n:"SerToCrt" },
	/*::[*/0x1046/*::]*/: { n:"AxesUsed" },
	/*::[*/0x1048/*::]*/: { n:"SBaseRef" },
	/*::[*/0x104a/*::]*/: { n:"SerParent" },
	/*::[*/0x104b/*::]*/: { n:"SerAuxTrend" },
	/*::[*/0x104e/*::]*/: { n:"IFmtRecord" },
	/*::[*/0x104f/*::]*/: { n:"Pos" },
	/*::[*/0x1050/*::]*/: { n:"AlRuns" },
	/*::[*/0x1051/*::]*/: { n:"BRAI" },
	/*::[*/0x105b/*::]*/: { n:"SerAuxErrBar" },
	/*::[*/0x105c/*::]*/: { n:"ClrtClient", f:parse_ClrtClient },
	/*::[*/0x105d/*::]*/: { n:"SerFmt" },
	/*::[*/0x105f/*::]*/: { n:"Chart3DBarShape" },
	/*::[*/0x1060/*::]*/: { n:"Fbi" },
	/*::[*/0x1061/*::]*/: { n:"BopPop" },
	/*::[*/0x1062/*::]*/: { n:"AxcExt" },
	/*::[*/0x1063/*::]*/: { n:"Dat" },
	/*::[*/0x1064/*::]*/: { n:"PlotGrowth" },
	/*::[*/0x1065/*::]*/: { n:"SIIndex" },
	/*::[*/0x1066/*::]*/: { n:"GelFrame" },
	/*::[*/0x1067/*::]*/: { n:"BopPopCustom" },
	/*::[*/0x1068/*::]*/: { n:"Fbi2" },

	/*::[*/0x0000/*::]*/: { n:"Dimensions", f:parse_Dimensions },
	/*::[*/0x0001/*::]*/: { n:"BIFF2BLANK" },
	/*::[*/0x0002/*::]*/: { n:"BIFF2INT", f:parse_BIFF2INT },
	/*::[*/0x0003/*::]*/: { n:"BIFF2NUM", f:parse_BIFF2NUM },
	/*::[*/0x0004/*::]*/: { n:"BIFF2STR", f:parse_BIFF2STR },
	/*::[*/0x0005/*::]*/: { n:"BoolErr", f:parse_BoolErr },
	/*::[*/0x0007/*::]*/: { n:"String", f:parse_BIFF2STRING },
	/*::[*/0x0008/*::]*/: { n:"BIFF2ROW" },
	/*::[*/0x0009/*::]*/: { n:'BOF', f:parse_BOF },
	/*::[*/0x000b/*::]*/: { n:"Index" },
	/*::[*/0x0016/*::]*/: { n:"ExternCount", f:parseuint16 },
	/*::[*/0x001e/*::]*/: { n:"BIFF2FORMAT", f:parse_BIFF2Format },
	/*::[*/0x001f/*::]*/: { n:"BIFF2FMTCNT" }, /* 16-bit cnt of BIFF2FORMAT records */
	/*::[*/0x0020/*::]*/: { n:"BIFF2COLINFO" },
	/*::[*/0x0021/*::]*/: { n:"Array", f:parse_Array },
	/*::[*/0x0024/*::]*/: { n:"COLWIDTH" },
	/*::[*/0x0025/*::]*/: { n:"DefaultRowHeight", f:parse_DefaultRowHeight },
	// 0x2c ??
	// 0x2d ??
	// 0x2e ??
	// 0x30 FONTCOUNT: number of fonts
	/*::[*/0x0032/*::]*/: { n:"BIFF2FONTXTRA", f:parse_BIFF2FONTXTRA },
	// 0x35: INFOOPTS
	// 0x36: TABLE (BIFF2 only)
	// 0x37: TABLE2 (BIFF2 only)
	// 0x38: WNDESK
	// 0x39 ??
	// 0x3a: BEGINPREF
	// 0x3b: ENDPREF
	/*::[*/0x003e/*::]*/: { n:"BIFF2WINDOW2" },
	// 0x3f ??
	// 0x46: SHOWSCROLL
	// 0x47: SHOWFORMULA
	// 0x48: STATUSBAR
	// 0x49: SHORTMENUS
	// 0x4A:
	// 0x4B:
	// 0x4C:
	// 0x4E:
	// 0x4F:
	// 0x58: TOOLBAR (BIFF3)

	/* - - - */
	/*::[*/0x0034/*::]*/: { n:"DDEObjName" },
	/*::[*/0x0043/*::]*/: { n:"BIFF2XF" },
	/*::[*/0x0044/*::]*/: { n:"BIFF2XFINDEX", f:parseuint16 },
	/*::[*/0x0045/*::]*/: { n:"BIFF2FONTCLR" },
	/*::[*/0x0056/*::]*/: { n:"BIFF4FMTCNT" }, /* 16-bit cnt, similar to BIFF2 */
	/*::[*/0x007e/*::]*/: { n:"RK" }, /* Not necessarily same as 0x027e */
	/*::[*/0x007f/*::]*/: { n:"ImData", f:parse_ImData },
	/*::[*/0x0087/*::]*/: { n:"Addin" },
	/*::[*/0x0088/*::]*/: { n:"Edg" },
	/*::[*/0x0089/*::]*/: { n:"Pub" },
	// 0x8A
	// 0x8B LH: alternate menu key flag (BIFF3/4)
	// 0x8E
	// 0x8F
	/*::[*/0x0091/*::]*/: { n:"Sub" },
	// 0x93 STYLE
	/*::[*/0x0094/*::]*/: { n:"LHRecord" },
	/*::[*/0x0095/*::]*/: { n:"LHNGraph" },
	/*::[*/0x0096/*::]*/: { n:"Sound" },
	// 0xA2 FNPROTO: function prototypes (BIFF4)
	// 0xA3
	// 0xA8
	/*::[*/0x00a9/*::]*/: { n:"CoordList" },
	/*::[*/0x00ab/*::]*/: { n:"GCW" },
	/*::[*/0x00bc/*::]*/: { n:"ShrFmla" }, /* Not necessarily same as 0x04bc */
	/*::[*/0x00bf/*::]*/: { n:"ToolbarHdr" },
	/*::[*/0x00c0/*::]*/: { n:"ToolbarEnd" },
	/*::[*/0x00c2/*::]*/: { n:"AddMenu" },
	/*::[*/0x00c3/*::]*/: { n:"DelMenu" },
	/*::[*/0x00d6/*::]*/: { n:"RString", f:parse_RString },
	/*::[*/0x00df/*::]*/: { n:"UDDesc" },
	/*::[*/0x00ea/*::]*/: { n:"TabIdConf" },
	/*::[*/0x0162/*::]*/: { n:"XL5Modify" },
	/*::[*/0x01a5/*::]*/: { n:"FileSharing2" },
	/*::[*/0x0206/*::]*/: { n:"Formula", f:parse_Formula },
	/*::[*/0x0209/*::]*/: { n:'BOF', f:parse_BOF },
	/*::[*/0x0218/*::]*/: { n:"Lbl", f:parse_Lbl },
	/*::[*/0x0223/*::]*/: { n:"ExternName", f:parse_ExternName },
	/*::[*/0x0231/*::]*/: { n:"Font" },
	/*::[*/0x0243/*::]*/: { n:"BIFF3XF" },
	/*::[*/0x0406/*::]*/: { n:"Formula", f:parse_Formula },
	/*::[*/0x0409/*::]*/: { n:'BOF', f:parse_BOF },
	/*::[*/0x0443/*::]*/: { n:"BIFF4XF" },
	/*::[*/0x086d/*::]*/: { n:"FeatInfo" },
	/*::[*/0x0873/*::]*/: { n:"FeatInfo11" },
	/*::[*/0x0881/*::]*/: { n:"SXAddl12" },
	/*::[*/0x08c0/*::]*/: { n:"AutoWebPub" },
	/*::[*/0x08c1/*::]*/: { n:"ListObj" },
	/*::[*/0x08c2/*::]*/: { n:"ListField" },
	/*::[*/0x08c3/*::]*/: { n:"ListDV" },
	/*::[*/0x08c4/*::]*/: { n:"ListCondFmt" },
	/*::[*/0x08c5/*::]*/: { n:"ListCF" },
	/*::[*/0x08c6/*::]*/: { n:"FMQry" },
	/*::[*/0x08c7/*::]*/: { n:"FMSQry" },
	/*::[*/0x08c8/*::]*/: { n:"PLV" },
	/*::[*/0x08c9/*::]*/: { n:"LnExt" },
	/*::[*/0x08ca/*::]*/: { n:"MkrExt" },
	/*::[*/0x08cb/*::]*/: { n:"CrtCoopt" },
	/*::[*/0x08d6/*::]*/: { n:"FRTArchId$", r:12 },

	/*::[*/0x7262/*::]*/: {}
};

var XLSRE = evert_key(XLSRecordEnum, 'n');
function write_biff_rec(ba/*:BufArray*/, type/*:number|string*/, payload, length/*:?number*/)/*:void*/ {
	var t/*:number*/ = typeof type == "number" ? type : (+type || +XLSRE[/*::String(*/type/*::)*/]);
	if(isNaN(t)) return;
	var len = length || (payload||[]).length || 0;
	var o = ba.next(4);
	o.write_shift(2, t);
	o.write_shift(2, len);
	if(/*:: len != null &&*/len > 0 && is_buf(payload)) ba.push(payload);
}

function write_biff_continue(ba/*:BufArray*/, type/*:number|string*/, payload, length/*:?number*/)/*:void*/ {
	var len = length || (payload||[]).length || 0;
	if(len <= 8224) return write_biff_rec(ba, type, payload, len);
	var t/*:number*/ = +type || +XLSRE[/*::String(*/type/*::)*/];
	if(isNaN(t)) return;
	var parts = payload.parts || [], sidx = 0;
	var i = 0, w = 0;
	while(w + (parts[sidx] || 8224) <= 8224) { w+= (parts[sidx] || 8224); sidx++; }
	var o = ba.next(4);
	o.write_shift(2, t);
	o.write_shift(2, w);
	ba.push(payload.slice(i, i + w));
	i += w;
	while(i < len) {
		o = ba.next(4);
		o.write_shift(2, 0x3c); // TODO: figure out correct continue type
		w = 0;
		while(w + (parts[sidx] || 8224) <= 8224) { w+= (parts[sidx] || 8224); sidx++; }
		o.write_shift(2, w);
		ba.push(payload.slice(i, i+w)); i+= w;
	}
}

function write_BIFF2Cell(out, r/*:number*/, c/*:number*/) {
	if(!out) out = new_buf(7);
	out.write_shift(2, r);
	out.write_shift(2, c);
	out.write_shift(2, 0);
	out.write_shift(1, 0);
	return out;
}

function write_BIFF2BERR(r/*:number*/, c/*:number*/, val, t/*:?string*/) {
	var out = new_buf(9);
	write_BIFF2Cell(out, r, c);
	write_Bes(val, t || 'b', out);
	return out;
}

/* TODO: codepage, large strings */
function write_BIFF2LABEL(r/*:number*/, c/*:number*/, val) {
	var out = new_buf(8 + 2*val.length);
	write_BIFF2Cell(out, r, c);
	out.write_shift(1, val.length);
	out.write_shift(val.length, val, 'sbcs');
	return out.l < out.length ? out.slice(0, out.l) : out;
}

function write_ws_biff2_cell(ba/*:BufArray*/, cell/*:Cell*/, R/*:number*/, C/*:number*//*::, opts*/) {
	if(cell.v != null) switch(cell.t) {
		case 'd': case 'n':
			var v = cell.t == 'd' ? datenum(parseDate(cell.v)) : cell.v;
			if((v == (v|0)) && (v >= 0) && (v < 65536))
				write_biff_rec(ba, 0x0002, write_BIFF2INT(R, C, v));
			else
				write_biff_rec(ba, 0x0003, write_BIFF2NUM(R,C, v));
			return;
		case 'b': case 'e': write_biff_rec(ba, 0x0005, write_BIFF2BERR(R, C, cell.v, cell.t)); return;
		/* TODO: codepage, sst */
		case 's': case 'str':
			write_biff_rec(ba, 0x0004, write_BIFF2LABEL(R, C, (cell.v||"").slice(0,255)));
			return;
	}
	write_biff_rec(ba, 0x0001, write_BIFF2Cell(null, R, C));
}

function write_ws_biff2(ba/*:BufArray*/, ws/*:Worksheet*/, idx/*:number*/, opts/*::, wb:Workbook*/) {
	var dense = Array.isArray(ws);
	var range = safe_decode_range(ws['!ref'] || "A1"), ref/*:string*/, rr = "", cols/*:Array<string>*/ = [];
	if(range.e.c > 0xFF || range.e.r > 0x3FFF) {
		if(opts.WTF) throw new Error("Range " + (ws['!ref'] || "A1") + " exceeds format limit A1:IV16384");
		range.e.c = Math.min(range.e.c, 0xFF);
		range.e.r = Math.min(range.e.c, 0x3FFF);
		ref = encode_range(range);
	}
	for(var R = range.s.r; R <= range.e.r; ++R) {
		rr = encode_row(R);
		for(var C = range.s.c; C <= range.e.c; ++C) {
			if(R === range.s.r) cols[C] = encode_col(C);
			ref = cols[C] + rr;
			var cell = dense ? (ws[R]||[])[C] : ws[ref];
			if(!cell) continue;
			/* write cell */
			write_ws_biff2_cell(ba, cell, R, C);
		}
	}
}

/* Based on test files */
function write_biff2_buf(wb/*:Workbook*/, opts/*:WriteOpts*/) {
	var o = opts || {};
	var ba = buf_array();
	var idx = 0;
	for(var i=0;i<wb.SheetNames.length;++i) if(wb.SheetNames[i] == o.sheet) idx=i;
	if(idx == 0 && !!o.sheet && wb.SheetNames[0] != o.sheet) throw new Error("Sheet not found: " + o.sheet);
	write_biff_rec(ba, (o.biff == 4 ? 0x0409 : (o.biff == 3 ? 0x0209 : 0x0009)), write_BOF(wb, 0x10, o));
	/* ... */
	write_ws_biff2(ba, wb.Sheets[wb.SheetNames[idx]], idx, o);
	/* ... */
	write_biff_rec(ba, 0x000A);
	return ba.end();
}

function write_FONTS_biff8(ba, data, opts) {
	write_biff_rec(ba, "Font", write_Font({
		sz:12,
		color: {theme:1},
		name: "Arial",
		family: 2,
		scheme: "minor"
	}, opts));
}


function write_FMTS_biff8(ba, NF/*:?SSFTable*/, opts) {
	if(!NF) return;
	[[5,8],[23,26],[41,44],[/*63*/50,/*66],[164,*/392]].forEach(function(r) {
		/*:: if(!NF) return; */
		for(var i = r[0]; i <= r[1]; ++i) if(NF[i] != null) write_biff_rec(ba, "Format", write_Format(i, NF[i], opts));
	});
}

function write_FEAT(ba, ws) {
	/* [MS-XLS] 2.4.112 */
	var o = new_buf(19);
	o.write_shift(4, 0x867); o.write_shift(4, 0); o.write_shift(4, 0);
	o.write_shift(2, 3); o.write_shift(1, 1); o.write_shift(4, 0);
	write_biff_rec(ba, "FeatHdr", o);
	/* [MS-XLS] 2.4.111 */
	o = new_buf(39);
	o.write_shift(4, 0x868); o.write_shift(4, 0); o.write_shift(4, 0);
	o.write_shift(2, 3); o.write_shift(1, 0); o.write_shift(4, 0);
	o.write_shift(2, 1); o.write_shift(4, 4); o.write_shift(2, 0);
	write_Ref8U(safe_decode_range(ws['!ref']||"A1"), o);
	o.write_shift(4, 4);
	write_biff_rec(ba, "Feat", o);
}

function write_CELLXFS_biff8(ba, opts) {
	for(var i = 0; i < 16; ++i) write_biff_rec(ba, "XF", write_XF({numFmtId:0, style:true}, 0, opts));
	opts.cellXfs.forEach(function(c) {
		write_biff_rec(ba, "XF", write_XF(c, 0, opts));
	});
}

function write_ws_biff8_hlinks(ba/*:BufArray*/, ws) {
	for(var R=0; R<ws['!links'].length; ++R) {
		var HL = ws['!links'][R];
		write_biff_rec(ba, "HLink", write_HLink(HL));
		if(HL[1].Tooltip) write_biff_rec(ba, "HLinkTooltip", write_HLinkTooltip(HL));
	}
	delete ws['!links'];
}

function write_ws_cols_biff8(ba, cols, ws) {
	if(!cols) return;
	var cnt = 0;
	cols.forEach(function(col, idx) {
		if(++cnt <= 256 && col) {
			write_biff_rec(ba, "ColInfo", write_ColInfo(col_obj_w(idx, col), idx));
		}
	});
}

function write_ws_biff8_cell(ba/*:BufArray*/, cell/*:Cell*/, R/*:number*/, C/*:number*/, opts) {
	var os = 16 + get_cell_style(opts.cellXfs, cell, opts);
	if(cell.v == null && !cell.bf) {
		write_biff_rec(ba, "Blank", write_XLSCell(R, C, os));
		return;
	}
	if(cell.bf) write_biff_rec(ba, "Formula", write_Formula(cell, R, C, opts, os));
	else switch(cell.t) {
		case 'd': case 'n':
			var v = cell.t == 'd' ? datenum(parseDate(cell.v)) : cell.v;
			/* TODO: emit RK as appropriate */
			write_biff_rec(ba, "Number", write_Number(R, C, v, os));
			break;
		case 'b': case 'e':
			write_biff_rec(ba, 0x0205, write_BoolErr(R, C, cell.v, os, opts, cell.t));
			break;
		/* TODO: codepage, sst */
		case 's': case 'str':
			if(opts.bookSST) {
				var isst = get_sst_id(opts.Strings, cell.v, opts.revStrings);
				write_biff_rec(ba, "LabelSst", write_LabelSst(R, C, isst, os));
			} else write_biff_rec(ba, "Label", write_Label(R, C, (cell.v||"").slice(0,255), os, opts));
			break;
		default:
			write_biff_rec(ba, "Blank", write_XLSCell(R, C, os));
	}
}

/* [MS-XLS] 2.1.7.20.5 */
function write_ws_biff8(idx/*:number*/, opts, wb/*:Workbook*/) {
	var ba = buf_array();
	var s = wb.SheetNames[idx], ws = wb.Sheets[s] || {};
	var _WB/*:WBWBProps*/ = ((wb||{}).Workbook||{}/*:any*/);
	var _sheet/*:WBWSProp*/ = ((_WB.Sheets||[])[idx]||{}/*:any*/);
	var dense = Array.isArray(ws);
	var b8 = opts.biff == 8;
	var ref/*:string*/, rr = "", cols/*:Array<string>*/ = [];
	var range = safe_decode_range(ws['!ref'] || "A1");
	var MAX_ROWS = b8 ? 65536 : 16384;
	if(range.e.c > 0xFF || range.e.r >= MAX_ROWS) {
		if(opts.WTF) throw new Error("Range " + (ws['!ref'] || "A1") + " exceeds format limit A1:IV16384");
		range.e.c = Math.min(range.e.c, 0xFF);
		range.e.r = Math.min(range.e.c, MAX_ROWS-1);
	}

	write_biff_rec(ba, 0x0809, write_BOF(wb, 0x10, opts));
	/* [Uncalced] Index */
	write_biff_rec(ba, "CalcMode", writeuint16(1));
	write_biff_rec(ba, "CalcCount", writeuint16(100));
	write_biff_rec(ba, "CalcRefMode", writebool(true));
	write_biff_rec(ba, "CalcIter", writebool(false));
	write_biff_rec(ba, "CalcDelta", write_Xnum(0.001));
	write_biff_rec(ba, "CalcSaveRecalc", writebool(true));
	write_biff_rec(ba, "PrintRowCol", writebool(false));
	write_biff_rec(ba, "PrintGrid", writebool(false));
	write_biff_rec(ba, "GridSet", writeuint16(1));
	write_biff_rec(ba, "Guts", write_Guts([0,0]));
	/* DefaultRowHeight WsBool [Sync] [LPr] [HorizontalPageBreaks] [VerticalPageBreaks] */
	/* Header (string) */
	/* Footer (string) */
	write_biff_rec(ba, "HCenter", writebool(false));
	write_biff_rec(ba, "VCenter", writebool(false));
	/* ... */
	if(b8) write_ws_cols_biff8(ba, ws["!cols"]);
	/* ... */
	write_biff_rec(ba, 0x200, write_Dimensions(range, opts));
	/* ... */

	if(b8) ws['!links'] = [];
	for(var R = range.s.r; R <= range.e.r; ++R) {
		rr = encode_row(R);
		for(var C = range.s.c; C <= range.e.c; ++C) {
			if(R === range.s.r) cols[C] = encode_col(C);
			ref = cols[C] + rr;
			var cell = dense ? (ws[R]||[])[C] : ws[ref];
			if(!cell) continue;
			/* write cell */
			write_ws_biff8_cell(ba, cell, R, C, opts);
			if(b8 && cell.l) ws['!links'].push([ref, cell.l]);
		}
	}
	var cname/*:string*/ = _sheet.CodeName || _sheet.name || s;
	/* ... */
	if(b8) write_biff_rec(ba, "Window2", write_Window2((_WB.Views||[])[0]));
	/* ... */
	if(b8 && (ws['!merges']||[]).length) write_biff_rec(ba, "MergeCells", write_MergeCells(ws['!merges']));
	/* [LRng] *QUERYTABLE [PHONETICINFO] CONDFMTS */
	if(b8) write_ws_biff8_hlinks(ba, ws);
	/* [DVAL] */
	write_biff_rec(ba, "CodeName", write_XLUnicodeString(cname));
	/* *WebPub *CellWatch [SheetExt] */
	if(b8) write_FEAT(ba, ws);
	/* *FEAT11 *RECORD12 */
	write_biff_rec(ba, "EOF");
	return ba.end();
}

/* [MS-XLS] 2.1.7.20.3 */
function write_biff8_global(wb/*:Workbook*/, bufs, opts/*:WriteOpts*/) {
	var A = buf_array();
	var _WB/*:WBWBProps*/ = ((wb||{}).Workbook||{}/*:any*/);
	var _sheets/*:Array<WBWSProp>*/ = (_WB.Sheets||[]);
	var _wb/*:WBProps*/ = /*::((*/_WB.WBProps||{/*::CodeName:"ThisWorkbook"*/}/*:: ):any)*/;
	var b8 = opts.biff == 8, b5 = opts.biff == 5;
	write_biff_rec(A, 0x0809, write_BOF(wb, 0x05, opts));
	if(opts.bookType == "xla") write_biff_rec(A, "Addin");
	write_biff_rec(A, "InterfaceHdr", b8 ? writeuint16(0x04b0) : null);
	write_biff_rec(A, "Mms", writezeroes(2));
	if(b5) write_biff_rec(A, "ToolbarHdr");
	if(b5) write_biff_rec(A, "ToolbarEnd");
	write_biff_rec(A, "InterfaceEnd");
	write_biff_rec(A, "WriteAccess", write_WriteAccess("SheetJS", opts));
	/* [FileSharing] */
	write_biff_rec(A, "CodePage", writeuint16(b8 ? 0x04b0 : 0x04E4));
	/* *2047 Lel */
	if(b8) write_biff_rec(A, "DSF", writeuint16(0));
	if(b8) write_biff_rec(A, "Excel9File");
	write_biff_rec(A, "RRTabId", write_RRTabId(wb.SheetNames.length));
	if(b8 && wb.vbaraw) write_biff_rec(A, "ObProj");
	/* [ObNoMacros] */
	if(b8 && wb.vbaraw) {
		var cname/*:string*/ = _wb.CodeName || "ThisWorkbook";
		write_biff_rec(A, "CodeName", write_XLUnicodeString(cname));
	}
	write_biff_rec(A, "BuiltInFnGroupCount", writeuint16(0x11));
	/* *FnGroupName *FnGrp12 */
	/* *Lbl */
	/* [OleObjectSize] */
	write_biff_rec(A, "WinProtect", writebool(false));
	write_biff_rec(A, "Protect", writebool(false));
	write_biff_rec(A, "Password", writeuint16(0));
	if(b8) write_biff_rec(A, "Prot4Rev", writebool(false));
	if(b8) write_biff_rec(A, "Prot4RevPass", writeuint16(0));
	write_biff_rec(A, "Window1", write_Window1());
	write_biff_rec(A, "Backup", writebool(false));
	write_biff_rec(A, "HideObj", writeuint16(0));
	write_biff_rec(A, "Date1904", writebool(safe1904(wb)=="true"));
	write_biff_rec(A, "CalcPrecision", writebool(true));
	if(b8) write_biff_rec(A, "RefreshAll", writebool(false));
	write_biff_rec(A, "BookBool", writeuint16(0));
	/* ... */
	write_FONTS_biff8(A, wb, opts);
	write_FMTS_biff8(A, wb.SSF, opts);
	write_CELLXFS_biff8(A, opts);
	/* ... */
	if(b8) write_biff_rec(A, "UsesELFs", writebool(false));
	var a = A.end();

	var C = buf_array();
	/* METADATA [MTRSettings] [ForceFullCalculation] */
	if(b8) write_biff_rec(C, "Country", write_Country());
	/* *SUPBOOK *LBL *RTD [RecalcId] *HFPicture *MSODRAWINGGROUP */

	/* BIFF8: [SST *Continue] ExtSST */
	if(b8 && opts.Strings) write_biff_continue(C, "SST", write_SST(opts.Strings));

	/* *WebPub [WOpt] [CrErr] [BookExt] *FeatHdr *DConn [THEME] [CompressPictures] [Compat12] [GUIDTypeLib] */
	write_biff_rec(C, "EOF");
	var c = C.end();

	var B = buf_array();
	var blen = 0, j = 0;
	for(j = 0; j < wb.SheetNames.length; ++j) blen += (b8 ? 12 : 11) + (b8 ? 2 : 1) * wb.SheetNames[j].length;
	var start = a.length + blen + c.length;
	for(j = 0; j < wb.SheetNames.length; ++j) {
		var _sheet/*:WBWSProp*/ = _sheets[j] || ({}/*:any*/);
		write_biff_rec(B, "BoundSheet8", write_BoundSheet8({pos:start, hs:_sheet.Hidden||0, dt:0, name:wb.SheetNames[j]}, opts));
		start += bufs[j].length;
	}
	/* 1*BoundSheet8 */
	var b = B.end();
	if(blen != b.length) throw new Error("BS8 " + blen + " != " + b.length);

	var out = [];
	if(a.length) out.push(a);
	if(b.length) out.push(b);
	if(c.length) out.push(c);
	return bconcat(out);
}

/* [MS-XLS] 2.1.7.20 Workbook Stream */
function write_biff8_buf(wb/*:Workbook*/, opts/*:WriteOpts*/) {
	var o = opts || {};
	var bufs = [];

	if(wb && !wb.SSF) {
		wb.SSF = SSF.get_table();
	}
	if(wb && wb.SSF) {
		make_ssf(SSF); SSF.load_table(wb.SSF);
		// $FlowIgnore
		o.revssf = evert_num(wb.SSF); o.revssf[wb.SSF[65535]] = 0;
		o.ssf = wb.SSF;
	}

	o.Strings = /*::((*/[]/*:: :any):SST)*/; o.Strings.Count = 0; o.Strings.Unique = 0;
	fix_write_opts(o);

	o.cellXfs = [];
	get_cell_style(o.cellXfs, {}, {revssf:{"General":0}});

	if(!wb.Props) wb.Props = {};

	for(var i = 0; i < wb.SheetNames.length; ++i) bufs[bufs.length] = write_ws_biff8(i, o, wb);
	bufs.unshift(write_biff8_global(wb, bufs, o));
	return bconcat(bufs);
}

function write_biff_buf(wb/*:Workbook*/, opts/*:WriteOpts*/) {
	for(var i = 0; i <= wb.SheetNames.length; ++i) {
		var ws = wb.Sheets[wb.SheetNames[i]];
		if(!ws || !ws["!ref"]) continue;
		var range = decode_range(ws["!ref"]);
		if(range.e.c > 255) { // note: 255 is IV
		  if(typeof console != "undefined" && console.error) console.error("Worksheet '" + wb.SheetNames[i] + "' extends beyond column IV (255).  Data may be lost.");
		}
	}

	var o = opts || {};
	switch(o.biff || 2) {
		case 8: case 5: return write_biff8_buf(wb, opts);
		case 4: case 3: case 2: return write_biff2_buf(wb, opts);
	}
	throw new Error("invalid type " + o.bookType + " for BIFF");
}
/* note: browser DOM element cannot see mso- style attrs, must parse */
var HTML_ = (function() {
	function html_to_sheet(str/*:string*/, _opts)/*:Workbook*/ {
		var opts = _opts || {};
		var ws/*:Worksheet*/ = opts.dense ? ([]/*:any*/) : ({}/*:any*/);
		str = str.replace(/<!--.*?-->/g, "");
		var mtch/*:any*/ = str.match(/<table/i);
		if(!mtch) throw new Error("Invalid HTML: could not find <table>");
		var mtch2/*:any*/ = str.match(/<\/table/i);
		var i/*:number*/ = mtch.index, j/*:number*/ = mtch2 && mtch2.index || str.length;
		var rows = split_regex(str.slice(i, j), /(:?<tr[^>]*>)/i, "<tr>");
		var R = -1, C = 0, RS = 0, CS = 0;
		var range/*:Range*/ = {s:{r:10000000, c:10000000},e:{r:0,c:0}};
		var merges/*:Array<Range>*/ = [];
		for(i = 0; i < rows.length; ++i) {
			var row = rows[i].trim();
			var hd = row.slice(0,3).toLowerCase();
			if(hd == "<tr") { ++R; if(opts.sheetRows && opts.sheetRows <= R) { --R; break; } C = 0; continue; }
			if(hd != "<td" && hd != "<th") continue;
			var cells = row.split(/<\/t[dh]>/i);
			for(j = 0; j < cells.length; ++j) {
				var cell = cells[j].trim();
				if(!cell.match(/<t[dh]/i)) continue;
				var m = cell, cc = 0;
				/* TODO: parse styles etc */
				while(m.charAt(0) == "<" && (cc = m.indexOf(">")) > -1) m = m.slice(cc+1);
				for(var midx = 0; midx < merges.length; ++midx) {
					var _merge/*:Range*/ = merges[midx];
					if(_merge.s.c == C && _merge.s.r < R && R <= _merge.e.r) { C = _merge.e.c + 1; midx = -1; }
				}
				var tag = parsexmltag(cell.slice(0, cell.indexOf(">")));
				CS = tag.colspan ? +tag.colspan : 1;
				if((RS = +tag.rowspan)>1 || CS>1) merges.push({s:{r:R,c:C},e:{r:R + (RS||1) - 1, c:C + CS - 1}});
				var _t/*:string*/ = tag.t || tag["data-t"] || "";
				/* TODO: generate stub cells */
				if(!m.length) { C += CS; continue; }
				m = htmldecode(m);
				if(range.s.r > R) range.s.r = R; if(range.e.r < R) range.e.r = R;
				if(range.s.c > C) range.s.c = C; if(range.e.c < C) range.e.c = C;
				if(!m.length) continue;
				var o/*:Cell*/ = {t:'s', v:m};
				if(opts.raw || !m.trim().length || _t == 's');
				else if(m === 'TRUE') o = {t:'b', v:true};
				else if(m === 'FALSE') o = {t:'b', v:false};
				else if(!isNaN(fuzzynum(m))) o = {t:'n', v:fuzzynum(m)};
				else if(!isNaN(fuzzydate(m).getDate())) {
					o = ({t:'d', v:parseDate(m)}/*:any*/);
					if(!opts.cellDates) o = ({t:'n', v:datenum(o.v)}/*:any*/);
					o.z = opts.dateNF || SSF._table[14];
				}
				if(opts.dense) { if(!ws[R]) ws[R] = []; ws[R][C] = o; }
				else ws[encode_cell({r:R, c:C})] = o;
				C += CS;
			}
		}
		ws['!ref'] = encode_range(range);
		if(merges.length) ws["!merges"] = merges;
		return ws;
	}
	function html_to_book(str/*:string*/, opts)/*:Workbook*/ {
		var mtch = str.match(/<table.*?>[\s\S]*?<\/table>/gi);
		if(!mtch || mtch.length == 0) throw new Error("Invalid HTML: could not find <table>");
		if(mtch.length == 1) return sheet_to_workbook(html_to_sheet(mtch[0], opts), opts);
		var wb = utils.book_new();
		mtch.forEach(function(s, idx) { utils.book_append_sheet(wb, html_to_sheet(s, opts), "Sheet" + (idx+1)); });
		return wb;
	}
	function make_html_row(ws/*:Worksheet*/, r/*:Range*/, R/*:number*/, o/*:Sheet2HTMLOpts*/)/*:string*/ {
		var M/*:Array<Range>*/ = (ws['!merges'] ||[]);
		var oo/*:Array<string>*/ = [];
		for(var C = r.s.c; C <= r.e.c; ++C) {
			var RS = 0, CS = 0;
			for(var j = 0; j < M.length; ++j) {
				if(M[j].s.r > R || M[j].s.c > C) continue;
				if(M[j].e.r < R || M[j].e.c < C) continue;
				if(M[j].s.r < R || M[j].s.c < C) { RS = -1; break; }
				RS = M[j].e.r - M[j].s.r + 1; CS = M[j].e.c - M[j].s.c + 1; break;
			}
			if(RS < 0) continue;
			var coord = encode_cell({r:R,c:C});
			var cell = o.dense ? (ws[R]||[])[C] : ws[coord];
			/* TODO: html entities */
			var w = (cell && cell.v != null) && (cell.h || escapehtml(cell.w || (format_cell(cell), cell.w) || "")) || "";
			var sp = ({}/*:any*/);
			if(RS > 1) sp.rowspan = RS;
			if(CS > 1) sp.colspan = CS;
			if(o.editable) w = '<span contenteditable="true">' + w + '</span>';
			else if(cell) {
				sp["data-t"] = cell && cell.t || 'z';
				if(cell.v != null) sp["data-v"] = cell.v;
				if(cell.z != null) sp["data-z"] = cell.z;
				if(cell.l && (cell.l.Target || "#").charAt(0) != "#") w = '<a href="' + cell.l.Target +'">' + w + '</a>';
			}
			sp.id = (o.id || "sjs") + "-" + coord;
			oo.push(writextag('td', w, sp));
		}
		var preamble = "<tr>";
		return preamble + oo.join("") + "</tr>";
	}
	function make_html_preamble(ws/*:Worksheet*/, R/*:Range*/, o/*:Sheet2HTMLOpts*/)/*:string*/ {
		var out/*:Array<string>*/ = [];
		return out.join("") + '<table' + (o && o.id ? ' id="' + o.id + '"' : "") + '>';
	}
	var _BEGIN = '<html><head><meta charset="utf-8"/><title>SheetJS Table Export</title></head><body>';
	var _END = '</body></html>';
	function sheet_to_html(ws/*:Worksheet*/, opts/*:?Sheet2HTMLOpts*//*, wb:?Workbook*/)/*:string*/ {
		var o = opts || {};
		var header = o.header != null ? o.header : _BEGIN;
		var footer = o.footer != null ? o.footer : _END;
		var out/*:Array<string>*/ = [header];
		var r = decode_range(ws['!ref']);
		o.dense = Array.isArray(ws);
		out.push(make_html_preamble(ws, r, o));
		for(var R = r.s.r; R <= r.e.r; ++R) out.push(make_html_row(ws, r, R, o));
		out.push("</table>" + footer);
		return out.join("");

	}
	return {
		to_workbook: html_to_book,
		to_sheet: html_to_sheet,
		_row: make_html_row,
		BEGIN: _BEGIN,
		END: _END,
		_preamble: make_html_preamble,
		from_sheet: sheet_to_html
	};
})();

function sheet_add_dom(ws/*:Worksheet*/, table/*:HTMLElement*/, _opts/*:?any*/)/*:Worksheet*/ {
	var opts = _opts || {};
	var or_R = 0, or_C = 0;
	if(opts.origin != null) {
		if(typeof opts.origin == 'number') or_R = opts.origin;
		else {
			var _origin/*:CellAddress*/ = typeof opts.origin == "string" ? decode_cell(opts.origin) : opts.origin;
			or_R = _origin.r; or_C = _origin.c;
		}
	}

	var rows/*:HTMLCollection<HTMLTableRowElement>*/ = table.getElementsByTagName('tr');
	var sheetRows = Math.min(opts.sheetRows||10000000, rows.length);
	var range/*:Range*/ = {s:{r:0,c:0},e:{r:or_R,c:or_C}};
	if(ws["!ref"]) {
		var _range/*:Range*/ = decode_range(ws["!ref"]);
		range.s.r = Math.min(range.s.r, _range.s.r);
		range.s.c = Math.min(range.s.c, _range.s.c);
		range.e.r = Math.max(range.e.r, _range.e.r);
		range.e.c = Math.max(range.e.c, _range.e.c);
		if(or_R == -1) range.e.r = or_R = _range.e.r + 1;
	}
	var merges/*:Array<Range>*/ = [], midx = 0;
	var rowinfo/*:Array<RowInfo>*/ = ws["!rows"] || (ws["!rows"] = []);
	var _R = 0, R = 0, _C = 0, C = 0, RS = 0, CS = 0;
	if(!ws["!cols"]) ws['!cols'] = [];
	for(; _R < rows.length && R < sheetRows; ++_R) {
		var row/*:HTMLTableRowElement*/ = rows[_R];
		if (is_dom_element_hidden(row)) {
			if (opts.display) continue;
			rowinfo[R] = {hidden: true};
		}
		var elts/*:HTMLCollection<HTMLTableCellElement>*/ = (row.children/*:any*/);
		for(_C = C = 0; _C < elts.length; ++_C) {
			var elt/*:HTMLTableCellElement*/ = elts[_C];
			if (opts.display && is_dom_element_hidden(elt)) continue;
			var v/*:?string*/ = elt.hasAttribute('data-v') ? elt.getAttribute('data-v') : elt.hasAttribute('v') ? elt.getAttribute('v') : htmldecode(elt.innerHTML);
			var z/*:?string*/ = elt.getAttribute('data-z') || elt.getAttribute('z');
			for(midx = 0; midx < merges.length; ++midx) {
				var m/*:Range*/ = merges[midx];
				if(m.s.c == C + or_C && m.s.r < R + or_R && R + or_R <= m.e.r) { C = m.e.c+1 - or_C; midx = -1; }
			}
			/* TODO: figure out how to extract nonstandard mso- style */
			CS = +elt.getAttribute("colspan") || 1;
			if( ((RS = (+elt.getAttribute("rowspan") || 1)))>1 || CS>1) merges.push({s:{r:R + or_R,c:C + or_C},e:{r:R + or_R + (RS||1) - 1, c:C + or_C + (CS||1) - 1}});
			var o/*:Cell*/ = {t:'s', v:v};
			var _t/*:string*/ = elt.getAttribute("data-t") || elt.getAttribute("t") || "";
			if(v != null) {
				if(v.length == 0) o.t = _t || 'z';
				else if(opts.raw || v.trim().length == 0 || _t == "s");
				else if(v === 'TRUE') o = {t:'b', v:true};
				else if(v === 'FALSE') o = {t:'b', v:false};
				else if(!isNaN(fuzzynum(v))) o = {t:'n', v:fuzzynum(v)};
				else if(!isNaN(fuzzydate(v).getDate())) {
					o = ({t:'d', v:parseDate(v)}/*:any*/);
					if(!opts.cellDates) o = ({t:'n', v:datenum(o.v)}/*:any*/);
					o.z = opts.dateNF || SSF._table[14];
				}
			}
			if(o.z === undefined && z != null) o.z = z;
			/* The first link is used.  Links are assumed to be fully specified.
			 * TODO: The right way to process relative links is to make a new <a> */
			var l = "", Aelts = elt.getElementsByTagName("A");
			if(Aelts && Aelts.length) for(var Aelti = 0; Aelti < Aelts.length; ++Aelti)	if(Aelts[Aelti].hasAttribute("href")) {
				l = Aelts[Aelti].getAttribute("href"); if(l.charAt(0) != "#") break;
			}
			if(l && l.charAt(0) != "#") o.l = ({ Target: l });
			if(opts.dense) { if(!ws[R + or_R]) ws[R + or_R] = []; ws[R + or_R][C + or_C] = o; }
			else ws[encode_cell({c:C + or_C, r:R + or_R})] = o;
			if(range.e.c < C + or_C) range.e.c = C + or_C;
			C += CS;
		}
		++R;
	}
	if(merges.length) ws['!merges'] = (ws["!merges"] || []).concat(merges);
	range.e.r = Math.max(range.e.r, R - 1 + or_R);
	ws['!ref'] = encode_range(range);
	if(R >= sheetRows) ws['!fullref'] = encode_range((range.e.r = rows.length-_R+R-1 + or_R,range)); // We can count the real number of rows to parse but we don't to improve the performance
	return ws;
}

function parse_dom_table(table/*:HTMLElement*/, _opts/*:?any*/)/*:Worksheet*/ {
	var opts = _opts || {};
	var ws/*:Worksheet*/ = opts.dense ? ([]/*:any*/) : ({}/*:any*/);
	return sheet_add_dom(ws, table, _opts);
}

function table_to_book(table/*:HTMLElement*/, opts/*:?any*/)/*:Workbook*/ {
	return sheet_to_workbook(parse_dom_table(table, opts), opts);
}

function is_dom_element_hidden(element/*:HTMLElement*/)/*:boolean*/ {
	var display/*:string*/ = '';
	var get_computed_style/*:?function*/ = get_get_computed_style_function(element);
	if(get_computed_style) display = get_computed_style(element).getPropertyValue('display');
	if(!display) display = element.style && element.style.display;
	return display === 'none';
}

/* global getComputedStyle */
function get_get_computed_style_function(element/*:HTMLElement*/)/*:?function*/ {
	// The proper getComputedStyle implementation is the one defined in the element window
	if(element.ownerDocument.defaultView && typeof element.ownerDocument.defaultView.getComputedStyle === 'function') return element.ownerDocument.defaultView.getComputedStyle;
	// If it is not available, try to get one from the global namespace
	if(typeof getComputedStyle === 'function') return getComputedStyle;
	return null;
}
/* OpenDocument */
var parse_content_xml = (function() {

	var parse_text_p = function(text/*:string*//*::, tag*/)/*:Array<any>*/ {
		/* 6.1.2 White Space Characters */
		var fixed = text
			.replace(/[\t\r\n]/g, " ").trim().replace(/ +/g, " ")
			.replace(/<text:s\/>/g," ")
			.replace(/<text:s text:c="(\d+)"\/>/g, function($$,$1) { return Array(parseInt($1,10)+1).join(" "); })
			.replace(/<text:tab[^>]*\/>/g,"\t")
			.replace(/<text:line-break\/>/g,"\n");
		var v = unescapexml(fixed.replace(/<[^>]*>/g,""));

		return [v];
	};

	var number_formats = {
		/* ods name: [short ssf fmt, long ssf fmt] */
		day:           ["d",   "dd"],
		month:         ["m",   "mm"],
		year:          ["y",   "yy"],
		hours:         ["h",   "hh"],
		minutes:       ["m",   "mm"],
		seconds:       ["s",   "ss"],
		"am-pm":       ["A/P", "AM/PM"],
		"day-of-week": ["ddd", "dddd"],
		era:           ["e",   "ee"],
		/* there is no native representation of LO "Q" format */
		quarter:       ["\\Qm", "m\\\"th quarter\""]
	};

	return function pcx(d/*:string*/, _opts)/*:Workbook*/ {
		var opts = _opts || {};
		var str = xlml_normalize(d);
		var state/*:Array<any>*/ = [], tmp;
		var tag/*:: = {}*/;
		var NFtag = {name:""}, NF = "", pidx = 0;
		var sheetag/*:: = {name:"", '名称':""}*/;
		var rowtag/*:: = {'行号':""}*/;
		var Sheets = {}, SheetNames/*:Array<string>*/ = [];
		var ws = opts.dense ? ([]/*:any*/) : ({}/*:any*/);
		var Rn, q/*:: :any = ({t:"", v:null, z:null, w:"",c:[],}:any)*/;
		var ctag = ({value:""}/*:any*/);
		var textp = "", textpidx = 0, textptag/*:: = {}*/;
		var textR = [];
		var R = -1, C = -1, range = {s: {r:1000000,c:10000000}, e: {r:0, c:0}};
		var row_ol = 0;
		var number_format_map = {};
		var merges/*:Array<Range>*/ = [], mrange = {}, mR = 0, mC = 0;
		var rowinfo/*:Array<RowInfo>*/ = [], rowpeat = 1, colpeat = 1;
		var arrayf/*:Array<[Range, string]>*/ = [];
		var WB = {Names:[]};
		var atag = ({}/*:any*/);
		var _Ref/*:[string, string]*/ = ["", ""];
		var comments/*:Array<Comment>*/ = [], comment/*:Comment*/ = ({}/*:any*/);
		var creator = "", creatoridx = 0;
		var isstub = false, intable = false;
		var i = 0;
		xlmlregex.lastIndex = 0;
		str = str.replace(/<!--([\s\S]*?)-->/mg,"").replace(/<!DOCTYPE[^\[]*\[[^\]]*\]>/gm,"");
		while((Rn = xlmlregex.exec(str))) switch((Rn[3]=Rn[3].replace(/_.*$/,""))) {

			case 'table': case '工作表': // 9.1.2 <table:table>
				if(Rn[1]==='/') {
					if(range.e.c >= range.s.c && range.e.r >= range.s.r) ws['!ref'] = encode_range(range);
					else ws['!ref'] = "A1:A1";
					if(opts.sheetRows > 0 && opts.sheetRows <= range.e.r) {
						ws['!fullref'] = ws['!ref'];
						range.e.r = opts.sheetRows - 1;
						ws['!ref'] = encode_range(range);
					}
					if(merges.length) ws['!merges'] = merges;
					if(rowinfo.length) ws["!rows"] = rowinfo;
					sheetag.name = sheetag['名称'] || sheetag.name;
					if(typeof JSON !== 'undefined') JSON.stringify(sheetag);
					SheetNames.push(sheetag.name);
					Sheets[sheetag.name] = ws;
					intable = false;
				}
				else if(Rn[0].charAt(Rn[0].length-2) !== '/') {
					sheetag = parsexmltag(Rn[0], false);
					R = C = -1;
					range.s.r = range.s.c = 10000000; range.e.r = range.e.c = 0;
					ws = opts.dense ? ([]/*:any*/) : ({}/*:any*/); merges = [];
					rowinfo = [];
					intable = true;
				}
				break;

			case 'table-row-group': // 9.1.9 <table:table-row-group>
				if(Rn[1] === "/") --row_ol; else ++row_ol;
				break;
			case 'table-row': case '行': // 9.1.3 <table:table-row>
				if(Rn[1] === '/') { R+=rowpeat; rowpeat = 1; break; }
				rowtag = parsexmltag(Rn[0], false);
				if(rowtag['行号']) R = rowtag['行号'] - 1; else if(R == -1) R = 0;
				rowpeat = +rowtag['number-rows-repeated'] || 1;
				/* TODO: remove magic */
				if(rowpeat < 10) for(i = 0; i < rowpeat; ++i) if(row_ol > 0) rowinfo[R + i] = {level: row_ol};
				C = -1; break;
			case 'covered-table-cell': // 9.1.5 <table:covered-table-cell>
				if(Rn[1] !== '/') ++C;
				if(opts.sheetStubs) {
					if(opts.dense) { if(!ws[R]) ws[R] = []; ws[R][C] = {t:'z'}; }
					else ws[encode_cell({r:R,c:C})] = {t:'z'};
				}
				textp = ""; textR = [];
				break; /* stub */
			case 'table-cell': case '数据':
				if(Rn[0].charAt(Rn[0].length-2) === '/') {
					++C;
					ctag = parsexmltag(Rn[0], false);
					colpeat = parseInt(ctag['number-columns-repeated']||"1", 10);
					q = ({t:'z', v:null/*:: , z:null, w:"",c:[]*/}/*:any*/);
					if(ctag.formula && opts.cellFormula != false) q.f = ods_to_csf_formula(unescapexml(ctag.formula));
					if((ctag['数据类型'] || ctag['value-type']) == "string") {
						q.t = "s"; q.v = unescapexml(ctag['string-value'] || "");
						if(opts.dense) {
							if(!ws[R]) ws[R] = [];
							ws[R][C] = q;
						} else {
							ws[encode_cell({r:R,c:C})] = q;
						}
					}
					C+= colpeat-1;
				} else if(Rn[1]!=='/') {
					++C;
					textp = ""; textpidx = 0; textR = [];
					colpeat = 1;
					var rptR = rowpeat ? R + rowpeat - 1 : R;
					if(C > range.e.c) range.e.c = C;
					if(C < range.s.c) range.s.c = C;
					if(R < range.s.r) range.s.r = R;
					if(rptR > range.e.r) range.e.r = rptR;
					ctag = parsexmltag(Rn[0], false);
					comments = []; comment = ({}/*:any*/);
					q = ({t:ctag['数据类型'] || ctag['value-type'], v:null/*:: , z:null, w:"",c:[]*/}/*:any*/);
					if(opts.cellFormula) {
						if(ctag.formula) ctag.formula = unescapexml(ctag.formula);
						if(ctag['number-matrix-columns-spanned'] && ctag['number-matrix-rows-spanned']) {
							mR = parseInt(ctag['number-matrix-rows-spanned'],10) || 0;
							mC = parseInt(ctag['number-matrix-columns-spanned'],10) || 0;
							mrange = {s: {r:R,c:C}, e:{r:R + mR-1,c:C + mC-1}};
							q.F = encode_range(mrange);
							arrayf.push([mrange, q.F]);
						}
						if(ctag.formula) q.f = ods_to_csf_formula(ctag.formula);
						else for(i = 0; i < arrayf.length; ++i)
							if(R >= arrayf[i][0].s.r && R <= arrayf[i][0].e.r)
								if(C >= arrayf[i][0].s.c && C <= arrayf[i][0].e.c)
									q.F = arrayf[i][1];
					}
					if(ctag['number-columns-spanned'] || ctag['number-rows-spanned']) {
						mR = parseInt(ctag['number-rows-spanned'],10) || 0;
						mC = parseInt(ctag['number-columns-spanned'],10) || 0;
						mrange = {s: {r:R,c:C}, e:{r:R + mR-1,c:C + mC-1}};
						merges.push(mrange);
					}

					/* 19.675.2 table:number-columns-repeated */
					if(ctag['number-columns-repeated']) colpeat = parseInt(ctag['number-columns-repeated'], 10);

					/* 19.385 office:value-type */
					switch(q.t) {
						case 'boolean': q.t = 'b'; q.v = parsexmlbool(ctag['boolean-value']); break;
						case 'float': q.t = 'n'; q.v = parseFloat(ctag.value); break;
						case 'percentage': q.t = 'n'; q.v = parseFloat(ctag.value); break;
						case 'currency': q.t = 'n'; q.v = parseFloat(ctag.value); break;
						case 'date': q.t = 'd'; q.v = parseDate(ctag['date-value']);
							if(!opts.cellDates) { q.t = 'n'; q.v = datenum(q.v); }
							q.z = 'm/d/yy'; break;
						case 'time': q.t = 'n'; q.v = parse_isodur(ctag['time-value'])/86400;
							if(opts.cellDates) { q.t = 'd'; q.v = numdate(q.v); }
							q.z = 'HH:MM:SS'; break;
						case 'number': q.t = 'n'; q.v = parseFloat(ctag['数据数值']); break;
						default:
							if(q.t === 'string' || q.t === 'text' || !q.t) {
								q.t = 's';
								if(ctag['string-value'] != null) { textp = unescapexml(ctag['string-value']); textR = []; }
							} else throw new Error('Unsupported value type ' + q.t);
					}
				} else {
					isstub = false;
					if(q.t === 's') {
						q.v = textp || '';
						if(textR.length) q.R = textR;
						isstub = textpidx == 0;
					}
					if(atag.Target) q.l = atag;
					if(comments.length > 0) { q.c = comments; comments = []; }
					if(textp && opts.cellText !== false) q.w = textp;
					if(isstub) { q.t = "z"; delete q.v; }
					if(!isstub || opts.sheetStubs) {
						if(!(opts.sheetRows && opts.sheetRows <= R)) {
							for(var rpt = 0; rpt < rowpeat; ++rpt) {
								colpeat = parseInt(ctag['number-columns-repeated']||"1", 10);
								if(opts.dense) {
									if(!ws[R + rpt]) ws[R + rpt] = [];
									ws[R + rpt][C] = rpt == 0 ? q : dup(q);
									while(--colpeat > 0) ws[R + rpt][C + colpeat] = dup(q);
								} else {
									ws[encode_cell({r:R + rpt,c:C})] = q;
									while(--colpeat > 0) ws[encode_cell({r:R + rpt,c:C + colpeat})] = dup(q);
								}
								if(range.e.c <= C) range.e.c = C;
							}
						}
					}
					colpeat = parseInt(ctag['number-columns-repeated']||"1", 10);
					C += colpeat-1; colpeat = 0;
					q = {/*:: t:"", v:null, z:null, w:"",c:[]*/};
					textp = ""; textR = [];
				}
				atag = ({}/*:any*/);
				break; // 9.1.4 <table:table-cell>

			/* pure state */
			case 'document': // TODO: <office:document> is the root for FODS
			case 'document-content': case '电子表格文档': // 3.1.3.2 <office:document-content>
			case 'spreadsheet': case '主体': // 3.7 <office:spreadsheet>
			case 'scripts': // 3.12 <office:scripts>
			case 'styles': // TODO <office:styles>
			case 'font-face-decls': // 3.14 <office:font-face-decls>
			case 'master-styles': // 3.15.4 <office:master-styles> -- relevant for FODS
				if(Rn[1]==='/'){if((tmp=state.pop())[0]!==Rn[3]) throw "Bad state: "+tmp;}
				else if(Rn[0].charAt(Rn[0].length-2) !== '/') state.push([Rn[3], true]);
				break;

			case 'annotation': // 14.1 <office:annotation>
				if(Rn[1]==='/'){
					if((tmp=state.pop())[0]!==Rn[3]) throw "Bad state: "+tmp;
					comment.t = textp;
					if(textR.length) /*::(*/comment/*:: :any)*/.R = textR;
					comment.a = creator;
					comments.push(comment);
				}
				else if(Rn[0].charAt(Rn[0].length-2) !== '/') {state.push([Rn[3], false]);}
				creator = ""; creatoridx = 0;
				textp = ""; textpidx = 0; textR = [];
				break;

			case 'creator': // 4.3.2.7 <dc:creator>
				if(Rn[1]==='/') { creator = str.slice(creatoridx,Rn.index); }
				else creatoridx = Rn.index + Rn[0].length;
				break;

			/* ignore state */
			case 'meta': case '元数据': // TODO: <office:meta> <uof:元数据> FODS/UOF
			case 'settings': // TODO: <office:settings>
			case 'config-item-set': // TODO: <office:config-item-set>
			case 'config-item-map-indexed': // TODO: <office:config-item-map-indexed>
			case 'config-item-map-entry': // TODO: <office:config-item-map-entry>
			case 'config-item-map-named': // TODO: <office:config-item-map-entry>
			case 'shapes': // 9.2.8 <table:shapes>
			case 'frame': // 10.4.2 <draw:frame>
			case 'text-box': // 10.4.3 <draw:text-box>
			case 'image': // 10.4.4 <draw:image>
			case 'data-pilot-tables': // 9.6.2 <table:data-pilot-tables>
			case 'list-style': // 16.30 <text:list-style>
			case 'form': // 13.13 <form:form>
			case 'dde-links': // 9.8 <table:dde-links>
			case 'event-listeners': // TODO
			case 'chart': // TODO
				if(Rn[1]==='/'){if((tmp=state.pop())[0]!==Rn[3]) throw "Bad state: "+tmp;}
				else if(Rn[0].charAt(Rn[0].length-2) !== '/') state.push([Rn[3], false]);
				textp = ""; textpidx = 0; textR = [];
				break;

			case 'scientific-number': // TODO: <number:scientific-number>
				break;
			case 'currency-symbol': // TODO: <number:currency-symbol>
				break;
			case 'currency-style': // TODO: <number:currency-style>
				break;
			case 'number-style': // 16.27.2 <number:number-style>
			case 'percentage-style': // 16.27.9 <number:percentage-style>
			case 'date-style': // 16.27.10 <number:date-style>
			case 'time-style': // 16.27.18 <number:time-style>
				if(Rn[1]==='/'){
					number_format_map[NFtag.name] = NF;
					if((tmp=state.pop())[0]!==Rn[3]) throw "Bad state: "+tmp;
				} else if(Rn[0].charAt(Rn[0].length-2) !== '/') {
					NF = "";
					NFtag = parsexmltag(Rn[0], false);
					state.push([Rn[3], true]);
				} break;

			case 'script': break; // 3.13 <office:script>
			case 'libraries': break; // TODO: <ooo:libraries>
			case 'automatic-styles': break; // 3.15.3 <office:automatic-styles>

			case 'default-style': // TODO: <style:default-style>
			case 'page-layout': break; // TODO: <style:page-layout>
			case 'style': // 16.2 <style:style>
				break;
			case 'map': break; // 16.3 <style:map>
			case 'font-face': break; // 16.21 <style:font-face>

			case 'paragraph-properties': break; // 17.6 <style:paragraph-properties>
			case 'table-properties': break; // 17.15 <style:table-properties>
			case 'table-column-properties': break; // 17.16 <style:table-column-properties>
			case 'table-row-properties': break; // 17.17 <style:table-row-properties>
			case 'table-cell-properties': break; // 17.18 <style:table-cell-properties>

			case 'number': // 16.27.3 <number:number>
				switch(state[state.length-1][0]) {
					case 'time-style':
					case 'date-style':
						tag = parsexmltag(Rn[0], false);
						NF += number_formats[Rn[3]][tag.style==='long'?1:0]; break;
				} break;

			case 'fraction': break; // TODO 16.27.6 <number:fraction>

			case 'day': // 16.27.11 <number:day>
			case 'month': // 16.27.12 <number:month>
			case 'year': // 16.27.13 <number:year>
			case 'era': // 16.27.14 <number:era>
			case 'day-of-week': // 16.27.15 <number:day-of-week>
			case 'week-of-year': // 16.27.16 <number:week-of-year>
			case 'quarter': // 16.27.17 <number:quarter>
			case 'hours': // 16.27.19 <number:hours>
			case 'minutes': // 16.27.20 <number:minutes>
			case 'seconds': // 16.27.21 <number:seconds>
			case 'am-pm': // 16.27.22 <number:am-pm>
				switch(state[state.length-1][0]) {
					case 'time-style':
					case 'date-style':
						tag = parsexmltag(Rn[0], false);
						NF += number_formats[Rn[3]][tag.style==='long'?1:0]; break;
				} break;

			case 'boolean-style': break; // 16.27.23 <number:boolean-style>
			case 'boolean': break; // 16.27.24 <number:boolean>
			case 'text-style': break; // 16.27.25 <number:text-style>
			case 'text': // 16.27.26 <number:text>
				if(Rn[0].slice(-2) === "/>") break;
				else if(Rn[1]==="/") switch(state[state.length-1][0]) {
					case 'number-style':
					case 'date-style':
					case 'time-style':
						NF += str.slice(pidx, Rn.index);
						break;
				}
				else pidx = Rn.index + Rn[0].length;
				break;

			case 'named-range': // 9.4.12 <table:named-range>
				tag = parsexmltag(Rn[0], false);
				_Ref = ods_to_csf_3D(tag['cell-range-address']);
				var nrange = ({Name:tag.name, Ref:_Ref[0] + '!' + _Ref[1]}/*:any*/);
				if(intable) nrange.Sheet = SheetNames.length;
				WB.Names.push(nrange);
				break;

			case 'text-content': break; // 16.27.27 <number:text-content>
			case 'text-properties': break; // 16.27.27 <style:text-properties>
			case 'embedded-text': break; // 16.27.4 <number:embedded-text>

			case 'body': case '电子表格': break; // 3.3 16.9.6 19.726.3

			case 'forms': break; // 12.25.2 13.2
			case 'table-column': break; // 9.1.6 <table:table-column>
			case 'table-header-rows': break; // 9.1.7 <table:table-header-rows>
			case 'table-rows': break; // 9.1.12 <table:table-rows>
			/* TODO: outline levels */
			case 'table-column-group': break; // 9.1.10 <table:table-column-group>
			case 'table-header-columns': break; // 9.1.11 <table:table-header-columns>
			case 'table-columns': break; // 9.1.12 <table:table-columns>

			case 'null-date': break; // 9.4.2 <table:null-date> TODO: date1904

			case 'graphic-properties': break; // 17.21 <style:graphic-properties>
			case 'calculation-settings': break; // 9.4.1 <table:calculation-settings>
			case 'named-expressions': break; // 9.4.11 <table:named-expressions>
			case 'label-range': break; // 9.4.9 <table:label-range>
			case 'label-ranges': break; // 9.4.10 <table:label-ranges>
			case 'named-expression': break; // 9.4.13 <table:named-expression>
			case 'sort': break; // 9.4.19 <table:sort>
			case 'sort-by': break; // 9.4.20 <table:sort-by>
			case 'sort-groups': break; // 9.4.22 <table:sort-groups>

			case 'tab': break; // 6.1.4 <text:tab>
			case 'line-break': break; // 6.1.5 <text:line-break>
			case 'span': break; // 6.1.7 <text:span>
			case 'p': case '文本串': // 5.1.3 <text:p>
				if(['master-styles'].indexOf(state[state.length-1][0]) > -1) break;
				if(Rn[1]==='/' && (!ctag || !ctag['string-value'])) {
					var ptp = parse_text_p(str.slice(textpidx,Rn.index));
					textp = (textp.length > 0 ? textp + "\n" : "") + ptp[0];
				} else { textptag = parsexmltag(Rn[0], false); textpidx = Rn.index + Rn[0].length; }
				break; // <text:p>
			case 's': break; // <text:s>

			case 'database-range': // 9.4.15 <table:database-range>
				if(Rn[1]==='/') break;
				try {
					_Ref = ods_to_csf_3D(parsexmltag(Rn[0])['target-range-address']);
					Sheets[_Ref[0]]['!autofilter'] = { ref:_Ref[1] };
				} catch(e) {/* empty */}
				break;

			case 'date': break; // <*:date>

			case 'object': break; // 10.4.6.2 <draw:object>
			case 'title': case '标题': break; // <*:title> OR <uof:标题>
			case 'desc': break; // <*:desc>
			case 'binary-data': break; // 10.4.5 TODO: b64 blob

			/* 9.2 Advanced Tables */
			case 'table-source': break; // 9.2.6
			case 'scenario': break; // 9.2.6

			case 'iteration': break; // 9.4.3 <table:iteration>
			case 'content-validations': break; // 9.4.4 <table:
			case 'content-validation': break; // 9.4.5 <table:
			case 'help-message': break; // 9.4.6 <table:
			case 'error-message': break; // 9.4.7 <table:
			case 'database-ranges': break; // 9.4.14 <table:database-ranges>
			case 'filter': break; // 9.5.2 <table:filter>
			case 'filter-and': break; // 9.5.3 <table:filter-and>
			case 'filter-or': break; // 9.5.4 <table:filter-or>
			case 'filter-condition': break; // 9.5.5 <table:filter-condition>

			case 'list-level-style-bullet': break; // 16.31 <text:
			case 'list-level-style-number': break; // 16.32 <text:
			case 'list-level-properties': break; // 17.19 <style:

			/* 7.3 Document Fields */
			case 'sender-firstname': // 7.3.6.2
			case 'sender-lastname': // 7.3.6.3
			case 'sender-initials': // 7.3.6.4
			case 'sender-title': // 7.3.6.5
			case 'sender-position': // 7.3.6.6
			case 'sender-email': // 7.3.6.7
			case 'sender-phone-private': // 7.3.6.8
			case 'sender-fax': // 7.3.6.9
			case 'sender-company': // 7.3.6.10
			case 'sender-phone-work': // 7.3.6.11
			case 'sender-street': // 7.3.6.12
			case 'sender-city': // 7.3.6.13
			case 'sender-postal-code': // 7.3.6.14
			case 'sender-country': // 7.3.6.15
			case 'sender-state-or-province': // 7.3.6.16
			case 'author-name': // 7.3.7.1
			case 'author-initials': // 7.3.7.2
			case 'chapter': // 7.3.8
			case 'file-name': // 7.3.9
			case 'template-name': // 7.3.9
			case 'sheet-name': // 7.3.9
				break;

			case 'event-listener':
				break;
			/* TODO: FODS Properties */
			case 'initial-creator':
			case 'creation-date':
			case 'print-date':
			case 'generator':
			case 'document-statistic':
			case 'user-defined':
			case 'editing-duration':
			case 'editing-cycles':
				break;

			/* TODO: FODS Config */
			case 'config-item':
				break;

			/* TODO: style tokens */
			case 'page-number': break; // TODO <text:page-number>
			case 'page-count': break; // TODO <text:page-count>
			case 'time': break; // TODO <text:time>

			/* 9.3 Advanced Table Cells */
			case 'cell-range-source': break; // 9.3.1 <table:
			case 'detective': break; // 9.3.2 <table:
			case 'operation': break; // 9.3.3 <table:
			case 'highlighted-range': break; // 9.3.4 <table:

			/* 9.6 Data Pilot Tables <table: */
			case 'data-pilot-table': // 9.6.3
			case 'source-cell-range': // 9.6.5
			case 'source-service': // 9.6.6
			case 'data-pilot-field': // 9.6.7
			case 'data-pilot-level': // 9.6.8
			case 'data-pilot-subtotals': // 9.6.9
			case 'data-pilot-subtotal': // 9.6.10
			case 'data-pilot-members': // 9.6.11
			case 'data-pilot-member': // 9.6.12
			case 'data-pilot-display-info': // 9.6.13
			case 'data-pilot-sort-info': // 9.6.14
			case 'data-pilot-layout-info': // 9.6.15
			case 'data-pilot-field-reference': // 9.6.16
			case 'data-pilot-groups': // 9.6.17
			case 'data-pilot-group': // 9.6.18
			case 'data-pilot-group-member': // 9.6.19
				break;

			/* 10.3 Drawing Shapes */
			case 'rect': // 10.3.2
				break;

			/* 14.6 DDE Connections */
			case 'dde-connection-decls': // 14.6.2 <text:
			case 'dde-connection-decl': // 14.6.3 <text:
			case 'dde-link': // 14.6.4 <table:
			case 'dde-source': // 14.6.5 <office:
				break;

			case 'properties': break; // 13.7 <form:properties>
			case 'property': break; // 13.8 <form:property>

			case 'a': // 6.1.8 hyperlink
				if(Rn[1]!== '/') {
					atag = parsexmltag(Rn[0], false);
					if(!atag.href) break;
					atag.Target = unescapexml(atag.href); delete atag.href;
					if(atag.Target.charAt(0) == "#" && atag.Target.indexOf(".") > -1) {
						_Ref = ods_to_csf_3D(atag.Target.slice(1));
						atag.Target = "#" + _Ref[0] + "!" + _Ref[1];
					} else if(atag.Target.match(/^\.\.[\\\/]/)) atag.Target = atag.Target.slice(3);
				}
				break;

			/* non-standard */
			case 'table-protection': break;
			case 'data-pilot-grand-total': break; // <table:
			case 'office-document-common-attrs': break; // bare
			default: switch(Rn[2]) {
				case 'dc:':       // TODO: properties
				case 'calcext:':  // ignore undocumented extensions
				case 'loext:':    // ignore undocumented extensions
				case 'ooo:':      // ignore undocumented extensions
				case 'chartooo:': // ignore undocumented extensions
				case 'draw:':     // TODO: drawing
				case 'style:':    // TODO: styles
				case 'chart:':    // TODO: charts
				case 'form:':     // TODO: forms
				case 'uof:':      // TODO: uof
				case '表:':       // TODO: uof
				case '字:':       // TODO: uof
					break;
				default: if(opts.WTF) throw new Error(Rn);
			}
		}
		var out/*:Workbook*/ = ({
			Sheets: Sheets,
			SheetNames: SheetNames,
			Workbook: WB
		}/*:any*/);
		if(opts.bookSheets) delete /*::(*/out/*:: :any)*/.Sheets;
		return out;
	};
})();

function parse_ods(zip/*:ZIPFile*/, opts/*:?ParseOpts*/)/*:Workbook*/ {
	opts = opts || ({}/*:any*/);
	if(safegetzipfile(zip, 'META-INF/manifest.xml')) parse_manifest(getzipdata(zip, 'META-INF/manifest.xml'), opts);
	var content = getzipstr(zip, 'content.xml');
	if(!content) throw new Error("Missing content.xml in ODS / UOF file");
	var wb = parse_content_xml(utf8read(content), opts);
	if(safegetzipfile(zip, 'meta.xml')) wb.Props = parse_core_props(getzipdata(zip, 'meta.xml'));
	return wb;
}
function parse_fods(data/*:string*/, opts/*:?ParseOpts*/)/*:Workbook*/ {
	return parse_content_xml(data, opts);
}

/* OpenDocument */
var write_styles_ods/*:{(wb:any, opts:any):string}*/ = (function() {
	var master_styles = [
		'<office:master-styles>',
			'<style:master-page style:name="mp1" style:page-layout-name="mp1">',
				'<style:header/>',
				'<style:header-left style:display="false"/>',
				'<style:footer/>',
				'<style:footer-left style:display="false"/>',
			'</style:master-page>',
		'</office:master-styles>'
	].join("");

	var payload = '<office:document-styles ' + wxt_helper({
		'xmlns:office':   "urn:oasis:names:tc:opendocument:xmlns:office:1.0",
		'xmlns:table':    "urn:oasis:names:tc:opendocument:xmlns:table:1.0",
		'xmlns:style':    "urn:oasis:names:tc:opendocument:xmlns:style:1.0",
		'xmlns:text':     "urn:oasis:names:tc:opendocument:xmlns:text:1.0",
		'xmlns:draw':     "urn:oasis:names:tc:opendocument:xmlns:drawing:1.0",
		'xmlns:fo':       "urn:oasis:names:tc:opendocument:xmlns:xsl-fo-compatible:1.0",
		'xmlns:xlink':    "http://www.w3.org/1999/xlink",
		'xmlns:dc':       "http://purl.org/dc/elements/1.1/",
		'xmlns:number':   "urn:oasis:names:tc:opendocument:xmlns:datastyle:1.0",
		'xmlns:svg':      "urn:oasis:names:tc:opendocument:xmlns:svg-compatible:1.0",
		'xmlns:of':       "urn:oasis:names:tc:opendocument:xmlns:of:1.2",
		'office:version': "1.2"
	}) + '>' + master_styles + '</office:document-styles>';

	return function wso(/*::wb, opts*/) {
		return XML_HEADER + payload;
	};
})();
var write_content_ods/*:{(wb:any, opts:any):string}*/ = (function() {
	/* 6.1.2 White Space Characters */
	var write_text_p = function(text/*:string*/)/*:string*/ {
		return escapexml(text)
			.replace(/  +/g, function($$){return '<text:s text:c="'+$$.length+'"/>';})
			.replace(/\t/g, "<text:tab/>")
			.replace(/\n/g, "</text:p><text:p>")
			.replace(/^ /, "<text:s/>").replace(/ $/, "<text:s/>");
	};

	var null_cell_xml = '          <table:table-cell />\n';
	var covered_cell_xml = '          <table:covered-table-cell/>\n';
	var write_ws = function(ws, wb/*:Workbook*/, i/*:number*//*::, opts*/)/*:string*/ {
		/* Section 9 Tables */
		var o/*:Array<string>*/ = [];
		o.push('      <table:table table:name="' + escapexml(wb.SheetNames[i]) + '" table:style-name="ta1">\n');
		var R=0,C=0, range = decode_range(ws['!ref']||"A1");
		var marr/*:Array<Range>*/ = ws['!merges'] || [], mi = 0;
		var dense = Array.isArray(ws);
		if(ws["!cols"]) {
			for(C = 0; C <= range.e.c; ++C) o.push('        <table:table-column' + (ws["!cols"][C] ? ' table:style-name="co' + ws["!cols"][C].ods + '"' : '') + '></table:table-column>\n');
		}
		var H = "", ROWS = ws["!rows"]||[];
		for(R = 0; R < range.s.r; ++R) {
			H = ROWS[R] ? ' table:style-name="ro' + ROWS[R].ods + '"' : "";
			o.push('        <table:table-row' + H + '></table:table-row>\n');
		}
		for(; R <= range.e.r; ++R) {
			H = ROWS[R] ? ' table:style-name="ro' + ROWS[R].ods + '"' : "";
			o.push('        <table:table-row' + H + '>\n');
			for(C=0; C < range.s.c; ++C) o.push(null_cell_xml);
			for(; C <= range.e.c; ++C) {
				var skip = false, ct = {}, textp = "";
				for(mi = 0; mi != marr.length; ++mi) {
					if(marr[mi].s.c > C) continue;
					if(marr[mi].s.r > R) continue;
					if(marr[mi].e.c < C) continue;
					if(marr[mi].e.r < R) continue;
					if(marr[mi].s.c != C || marr[mi].s.r != R) skip = true;
					ct['table:number-columns-spanned'] = (marr[mi].e.c - marr[mi].s.c + 1);
					ct['table:number-rows-spanned'] =    (marr[mi].e.r - marr[mi].s.r + 1);
					break;
				}
				if(skip) { o.push(covered_cell_xml); continue; }
				var ref = encode_cell({r:R, c:C}), cell = dense ? (ws[R]||[])[C]: ws[ref];
				if(cell && cell.f) {
					ct['table:formula'] = escapexml(csf_to_ods_formula(cell.f));
					if(cell.F) {
						if(cell.F.slice(0, ref.length) == ref) {
							var _Fref = decode_range(cell.F);
							ct['table:number-matrix-columns-spanned'] = (_Fref.e.c - _Fref.s.c + 1);
							ct['table:number-matrix-rows-spanned'] =    (_Fref.e.r - _Fref.s.r + 1);
						}
					}
				}
				if(!cell) { o.push(null_cell_xml); continue; }
				switch(cell.t) {
					case 'b':
						textp = (cell.v ? 'TRUE' : 'FALSE');
						ct['office:value-type'] = "boolean";
						ct['office:boolean-value'] = (cell.v ? 'true' : 'false');
						break;
					case 'n':
						textp = (cell.w||String(cell.v||0));
						ct['office:value-type'] = "float";
						ct['office:value'] = (cell.v||0);
						break;
					case 's': case 'str':
						textp = cell.v == null ? "" : cell.v;
						ct['office:value-type'] = "string";
						break;
					case 'd':
						textp = (cell.w||(parseDate(cell.v).toISOString()));
						ct['office:value-type'] = "date";
						ct['office:date-value'] = (parseDate(cell.v).toISOString());
						ct['table:style-name'] = "ce1";
						break;
					//case 'e':
					default: o.push(null_cell_xml); continue;
				}
				var text_p = write_text_p(textp);
				if(cell.l && cell.l.Target) {
					var _tgt = cell.l.Target;
					_tgt = _tgt.charAt(0) == "#" ? "#" + csf_to_ods_3D(_tgt.slice(1)) : _tgt;
					// TODO: choose correct parent path format based on link delimiters
					if(_tgt.charAt(0) != "#" && !_tgt.match(/^\w+:/)) _tgt = '../' + _tgt;
					text_p = writextag('text:a', text_p, {'xlink:href': _tgt.replace(/&/g, "&amp;")});
				}
				o.push('          ' + writextag('table:table-cell', writextag('text:p', text_p, {}), ct) + '\n');
			}
			o.push('        </table:table-row>\n');
		}
		o.push('      </table:table>\n');
		return o.join("");
	};

	var write_automatic_styles_ods = function(o/*:Array<string>*/, wb) {
		o.push(' <office:automatic-styles>\n');

		o.push('  <number:date-style style:name="N37" number:automatic-order="true">\n');
		o.push('   <number:month number:style="long"/>\n');
		o.push('   <number:text>/</number:text>\n');
		o.push('   <number:day number:style="long"/>\n');
		o.push('   <number:text>/</number:text>\n');
		o.push('   <number:year/>\n');
		o.push('  </number:date-style>\n');

		/* column styles */
		var cidx = 0;
		wb.SheetNames.map(function(n) { return wb.Sheets[n]; }).forEach(function(ws) {
			if(!ws) return;
			if(ws["!cols"]) {
				for(var C = 0; C < ws["!cols"].length; ++C) if(ws["!cols"][C]) {
					var colobj = ws["!cols"][C];
					if(colobj.width == null && colobj.wpx == null && colobj.wch == null) continue;
					process_col(colobj);
					colobj.ods = cidx;
					var w = ws["!cols"][C].wpx + "px";
					o.push('  <style:style style:name="co' + cidx + '" style:family="table-column">\n');
					o.push('   <style:table-column-properties fo:break-before="auto" style:column-width="' + w + '"/>\n');
					o.push('  </style:style>\n');
					++cidx;
				}
			}
		});

		/* row styles */
		var ridx = 0;
		wb.SheetNames.map(function(n) { return wb.Sheets[n]; }).forEach(function(ws) {
			if(!ws) return;
			if(ws["!rows"]) {
				for(var R = 0; R < ws["!rows"].length; ++R) if(ws["!rows"][R]) {
					ws["!rows"][R].ods = ridx;
					var h = ws["!rows"][R].hpx + "px";
					o.push('  <style:style style:name="ro' + ridx + '" style:family="table-row">\n');
					o.push('   <style:table-row-properties fo:break-before="auto" style:row-height="' + h + '"/>\n');
					o.push('  </style:style>\n');
					++ridx;
				}
			}
		});

		/* table */
		o.push('  <style:style style:name="ta1" style:family="table" style:master-page-name="mp1">\n');
		o.push('   <style:table-properties table:display="true" style:writing-mode="lr-tb"/>\n');
		o.push('  </style:style>\n');

		/* table cells, text */
		o.push('  <style:style style:name="ce1" style:family="table-cell" style:parent-style-name="Default" style:data-style-name="N37"/>\n');

		/* page-layout */

		o.push(' </office:automatic-styles>\n');
	};

	return function wcx(wb, opts) {
		var o = [XML_HEADER];
		/* 3.1.3.2 */
		var attr = wxt_helper({
			'xmlns:office':       "urn:oasis:names:tc:opendocument:xmlns:office:1.0",
			'xmlns:table':        "urn:oasis:names:tc:opendocument:xmlns:table:1.0",
			'xmlns:style':        "urn:oasis:names:tc:opendocument:xmlns:style:1.0",
			'xmlns:text':         "urn:oasis:names:tc:opendocument:xmlns:text:1.0",
			'xmlns:draw':         "urn:oasis:names:tc:opendocument:xmlns:drawing:1.0",
			'xmlns:fo':           "urn:oasis:names:tc:opendocument:xmlns:xsl-fo-compatible:1.0",
			'xmlns:xlink':        "http://www.w3.org/1999/xlink",
			'xmlns:dc':           "http://purl.org/dc/elements/1.1/",
			'xmlns:meta':         "urn:oasis:names:tc:opendocument:xmlns:meta:1.0",
			'xmlns:number':       "urn:oasis:names:tc:opendocument:xmlns:datastyle:1.0",
			'xmlns:presentation': "urn:oasis:names:tc:opendocument:xmlns:presentation:1.0",
			'xmlns:svg':          "urn:oasis:names:tc:opendocument:xmlns:svg-compatible:1.0",
			'xmlns:chart':        "urn:oasis:names:tc:opendocument:xmlns:chart:1.0",
			'xmlns:dr3d':         "urn:oasis:names:tc:opendocument:xmlns:dr3d:1.0",
			'xmlns:math':         "http://www.w3.org/1998/Math/MathML",
			'xmlns:form':         "urn:oasis:names:tc:opendocument:xmlns:form:1.0",
			'xmlns:script':       "urn:oasis:names:tc:opendocument:xmlns:script:1.0",
			'xmlns:ooo':          "http://openoffice.org/2004/office",
			'xmlns:ooow':         "http://openoffice.org/2004/writer",
			'xmlns:oooc':         "http://openoffice.org/2004/calc",
			'xmlns:dom':          "http://www.w3.org/2001/xml-events",
			'xmlns:xforms':       "http://www.w3.org/2002/xforms",
			'xmlns:xsd':          "http://www.w3.org/2001/XMLSchema",
			'xmlns:xsi':          "http://www.w3.org/2001/XMLSchema-instance",
			'xmlns:sheet':        "urn:oasis:names:tc:opendocument:sh33tjs:1.0",
			'xmlns:rpt':          "http://openoffice.org/2005/report",
			'xmlns:of':           "urn:oasis:names:tc:opendocument:xmlns:of:1.2",
			'xmlns:xhtml':        "http://www.w3.org/1999/xhtml",
			'xmlns:grddl':        "http://www.w3.org/2003/g/data-view#",
			'xmlns:tableooo':     "http://openoffice.org/2009/table",
			'xmlns:drawooo':      "http://openoffice.org/2010/draw",
			'xmlns:calcext':      "urn:org:documentfoundation:names:experimental:calc:xmlns:calcext:1.0",
			'xmlns:loext':        "urn:org:documentfoundation:names:experimental:office:xmlns:loext:1.0",
			'xmlns:field':        "urn:openoffice:names:experimental:ooo-ms-interop:xmlns:field:1.0",
			'xmlns:formx':        "urn:openoffice:names:experimental:ooxml-odf-interop:xmlns:form:1.0",
			'xmlns:css3t':        "http://www.w3.org/TR/css3-text/",
			'office:version':     "1.2"
		});

		var fods = wxt_helper({
			'xmlns:config':    "urn:oasis:names:tc:opendocument:xmlns:config:1.0",
			'office:mimetype': "application/vnd.oasis.opendocument.spreadsheet"
		});

		if(opts.bookType == "fods") {
			o.push('<office:document' + attr + fods + '>\n');
			o.push(write_meta_ods().replace(/office:document-meta/g, "office:meta"));
			// TODO: settings (equiv of settings.xml for ODS)
		} else o.push('<office:document-content' + attr  + '>\n');
		// o.push('  <office:scripts/>\n');
		write_automatic_styles_ods(o, wb);
		o.push('  <office:body>\n');
		o.push('    <office:spreadsheet>\n');
		for(var i = 0; i != wb.SheetNames.length; ++i) o.push(write_ws(wb.Sheets[wb.SheetNames[i]], wb, i));
		o.push('    </office:spreadsheet>\n');
		o.push('  </office:body>\n');
		if(opts.bookType == "fods") o.push('</office:document>');
		else o.push('</office:document-content>');
		return o.join("");
	};
})();

function write_ods(wb/*:any*/, opts/*:any*/) {
	if(opts.bookType == "fods") return write_content_ods(wb, opts);

	var zip = zip_new();
	var f = "";

	var manifest/*:Array<Array<string> >*/ = [];
	var rdf/*:Array<[string, string]>*/ = [];

	/* Part 3 Section 3.3 MIME Media Type */
	f = "mimetype";
	zip_add_file(zip, f, "application/vnd.oasis.opendocument.spreadsheet");

	/* Part 1 Section 2.2 Documents */
	f = "content.xml";
	zip_add_file(zip, f, write_content_ods(wb, opts));
	manifest.push([f, "text/xml"]);
	rdf.push([f, "ContentFile"]);

	/* TODO: these are hard-coded styles to satiate excel */
	f = "styles.xml";
	zip_add_file(zip, f, write_styles_ods(wb, opts));
	manifest.push([f, "text/xml"]);
	rdf.push([f, "StylesFile"]);

	/* TODO: this is hard-coded to satiate excel */
	f = "meta.xml";
	zip_add_file(zip, f, XML_HEADER + write_meta_ods(/*::wb, opts*/));
	manifest.push([f, "text/xml"]);
	rdf.push([f, "MetadataFile"]);

	/* Part 3 Section 6 Metadata Manifest File */
	f = "manifest.rdf";
	zip_add_file(zip, f, write_rdf(rdf/*, opts*/));
	manifest.push([f, "application/rdf+xml"]);

	/* Part 3 Section 4 Manifest File */
	f = "META-INF/manifest.xml";
	zip_add_file(zip, f, write_manifest(manifest/*, opts*/));

	return zip;
}

var NUMBERS = !Object.defineProperty ? (void 0) :(function() {
  var __defProp = Object.defineProperty;
  var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
  var __getOwnPropNames = Object.getOwnPropertyNames;
  var __hasOwnProp = Object.prototype.hasOwnProperty;
  var __markAsModule = function(target) {
    return __defProp(target, "__esModule", { value: true });
  };
  var __export = function(target, all) {
    for (var name in all)
      __defProp(target, name, { get: all[name], enumerable: true });
  };
  var __reExport = function(target, module, copyDefault, desc) {
    if (module && typeof module === "object" || typeof module === "function")
      for (var keys = __getOwnPropNames(module), i = 0, n = keys.length, key; i < n; i++) {
        key = keys[i];
        if (!__hasOwnProp.call(target, key) && (copyDefault || key !== "default"))
          __defProp(target, key, { get: function(k) {
            return module[k];
          }.bind(null, key), enumerable: !(desc = __getOwnPropDesc(module, key)) || desc.enumerable });
      }
    return target;
  };
  var __toCommonJS = /* @__PURE__ */ function(cache) {
    return function(module, temp) {
      return cache && cache.get(module) || (temp = __reExport(__markAsModule({}), module, 1), cache && cache.set(module, temp), temp);
    };
  }(typeof WeakMap !== "undefined" ? /* @__PURE__ */ new WeakMap() : 0);

  // 83_numbers.ts
  var numbers_exports = {};
  __export(numbers_exports, {
    parse_numbers: function() {
      return numbers_default;
    }
  });

  // src/util.ts
  var u8_to_dataview = function(array) {
    return new DataView(array.buffer, array.byteOffset, array.byteLength);
  };
  var u8str = function(u8) {
    return typeof TextDecoder != "undefined" ? new TextDecoder().decode(u8) : utf8read(a2s(u8));
  };
  var u8concat = function(u8a) {
    var len = u8a.reduce(function(acc, x) {
      return acc + x.length;
    }, 0);
    var out = new Uint8Array(len);
    var off = 0;
    u8a.forEach(function(u8) {
      out.set(u8, off);
      off += u8.length;
    });
    return out;
  };
  var popcnt = function(x) {
    x -= x >> 1 & 1431655765;
    x = (x & 858993459) + (x >> 2 & 858993459);
    return (x + (x >> 4) & 252645135) * 16843009 >>> 24;
  };
  var readDecimal128LE = function(buf, offset) {
    var exp = (buf[offset + 15] & 127) << 7 | buf[offset + 14] >> 1;
    var mantissa = buf[offset + 14] & 1;
    for (var j = offset + 13; j >= offset; --j)
      mantissa = mantissa * 256 + buf[j];
    return (buf[offset + 15] & 128 ? -mantissa : mantissa) * Math.pow(10, exp - 6176);
  };

  // src/proto.ts
  function parse_varint49(buf, ptr) {
    var l = ptr ? ptr[0] : 0;
    var usz = buf[l] & 127;
    varint:
      if (buf[l++] >= 128) {
        usz |= (buf[l] & 127) << 7;
        if (buf[l++] < 128)
          break varint;
        usz |= (buf[l] & 127) << 14;
        if (buf[l++] < 128)
          break varint;
        usz |= (buf[l] & 127) << 21;
        if (buf[l++] < 128)
          break varint;
        usz += (buf[l] & 127) * Math.pow(2, 28);
        ++l;
        if (buf[l++] < 128)
          break varint;
        usz += (buf[l] & 127) * Math.pow(2, 35);
        ++l;
        if (buf[l++] < 128)
          break varint;
        usz += (buf[l] & 127) * Math.pow(2, 42);
        ++l;
        if (buf[l++] < 128)
          break varint;
      }
    if (ptr)
      ptr[0] = l;
    return usz;
  }
  function varint_to_i32(buf) {
    var l = 0, i32 = buf[l] & 127;
    varint:
      if (buf[l++] >= 128) {
        i32 |= (buf[l] & 127) << 7;
        if (buf[l++] < 128)
          break varint;
        i32 |= (buf[l] & 127) << 14;
        if (buf[l++] < 128)
          break varint;
        i32 |= (buf[l] & 127) << 21;
        if (buf[l++] < 128)
          break varint;
        i32 |= (buf[l] & 127) << 28;
      }
    return i32;
  }
  function parse_shallow(buf) {
    var out = [], ptr = [0];
    while (ptr[0] < buf.length) {
      var off = ptr[0];
      var num = parse_varint49(buf, ptr);
      var type = num & 7;
      num = Math.floor(num / 8);
      var len = 0;
      var res;
      if (num == 0)
        break;
      switch (type) {
        case 0:
          {
            var l = ptr[0];
            while (buf[ptr[0]++] >= 128)
              ;
            res = buf.slice(l, ptr[0]);
          }
          break;
        case 5:
          len = 4;
          res = buf.slice(ptr[0], ptr[0] + len);
          ptr[0] += len;
          break;
        case 1:
          len = 8;
          res = buf.slice(ptr[0], ptr[0] + len);
          ptr[0] += len;
          break;
        case 2:
          len = parse_varint49(buf, ptr);
          res = buf.slice(ptr[0], ptr[0] + len);
          ptr[0] += len;
          break;
        case 3:
        case 4:
        default:
          throw new Error("PB Type ".concat(type, " for Field ").concat(num, " at offset ").concat(off));
      }
      var v = { offset: off, data: res, type: type };
      if (out[num] == null)
        out[num] = [v];
      else
        out[num].push(v);
    }
    return out;
  }
  function mappa(data, cb) {
    if (!data)
      return [];
    return data.map(function(d) {
      var _a;
      try {
        return cb(d.data);
      } catch (e) {
        var m = (_a = e.message) == null ? void 0 : _a.match(/at offset (\d+)/);
        if (m)
          e.message = e.message.replace(/at offset (\d+)/, "at offset " + (+m[1] + d.offset));
        throw e;
      }
    });
  }

  // src/frame.ts
  function deframe(buf) {
    var out = [];
    var l = 0;
    while (l < buf.length) {
      var t = buf[l++];
      var len = buf[l] | buf[l + 1] << 8 | buf[l + 2] << 16;
      l += 3;
      out.push(parse_snappy_chunk(t, buf.slice(l, l + len)));
      l += len;
    }
    if (l !== buf.length)
      throw new Error("data is not a valid framed stream!");
    return u8concat(out);
  }
  function parse_snappy_chunk(type, buf) {
    if (type != 0)
      throw new Error("Unexpected Snappy chunk type ".concat(type));
    var ptr = [0];
    var usz = parse_varint49(buf, ptr);
    var chunks = [];
    while (ptr[0] < buf.length) {
      var tag = buf[ptr[0]] & 3;
      if (tag == 0) {
        var len = buf[ptr[0]++] >> 2;
        if (len < 60)
          ++len;
        else {
          var c = len - 59;
          len = buf[ptr[0]];
          if (c > 1)
            len |= buf[ptr[0] + 1] << 8;
          if (c > 2)
            len |= buf[ptr[0] + 2] << 16;
          if (c > 3)
            len |= buf[ptr[0] + 3] << 24;
          len >>>= 0;
          len++;
          ptr[0] += c;
        }
        chunks.push(buf.slice(ptr[0], ptr[0] + len));
        ptr[0] += len;
        continue;
      } else {
        var offset = 0, length = 0;
        if (tag == 1) {
          length = (buf[ptr[0]] >> 2 & 7) + 4;
          offset = (buf[ptr[0]++] & 224) << 3;
          offset |= buf[ptr[0]++];
        } else {
          length = (buf[ptr[0]++] >> 2) + 1;
          if (tag == 2) {
            offset = buf[ptr[0]] | buf[ptr[0] + 1] << 8;
            ptr[0] += 2;
          } else {
            offset = (buf[ptr[0]] | buf[ptr[0] + 1] << 8 | buf[ptr[0] + 2] << 16 | buf[ptr[0] + 3] << 24) >>> 0;
            ptr[0] += 4;
          }
        }
        chunks = [u8concat(chunks)];
        if (offset == 0)
          throw new Error("Invalid offset 0");
        if (offset > chunks[0].length)
          throw new Error("Invalid offset beyond length");
        if (length >= offset) {
          chunks.push(chunks[0].slice(-offset));
          length -= offset;
          while (length >= chunks[chunks.length - 1].length) {
            chunks.push(chunks[chunks.length - 1]);
            length -= chunks[chunks.length - 1].length;
          }
        }
        chunks.push(chunks[0].slice(-offset, -offset + length));
      }
    }
    var o = u8concat(chunks);
    if (o.length != usz)
      throw new Error("Unexpected length: ".concat(o.length, " != ").concat(usz));
    return o;
  }

  // src/iwa.ts
  function parse_iwa(buf) {
    var out = [], ptr = [0];
    while (ptr[0] < buf.length) {
      var len = parse_varint49(buf, ptr);
      var ai = parse_shallow(buf.slice(ptr[0], ptr[0] + len));
      ptr[0] += len;
      var res = {
        id: varint_to_i32(ai[1][0].data),
        messages: []
      };
      ai[2].forEach(function(b) {
        var mi = parse_shallow(b.data);
        var fl = varint_to_i32(mi[3][0].data);
        res.messages.push({
          meta: mi,
          data: buf.slice(ptr[0], ptr[0] + fl)
        });
        ptr[0] += fl;
      });
      out.push(res);
    }
    return out;
  }

  // src/cell.ts
  function parse_old_storage(buf, sst, rsst) {
    var dv = u8_to_dataview(buf);
    var ctype = buf[buf[0] == 4 ? 1 : 2];
    var flags = dv.getUint32(4, true);
    var data_offset = 12 + popcnt(flags & 3470) * 4;
    var ridx = -1, sidx = -1, ieee = NaN, dt = new Date(2001, 0, 1);
    if (flags & 512) {
      ridx = dv.getUint32(data_offset, true);
      data_offset += 4;
    }
    data_offset += popcnt(flags & 12288) * 4;
    if (flags & 16) {
      sidx = dv.getUint32(data_offset, true);
      data_offset += 4;
    }
    if (flags & 32) {
      ieee = dv.getFloat64(data_offset, true);
      data_offset += 8;
    }
    if (flags & 64) {
      dt.setTime(dt.getTime() + dv.getFloat64(data_offset, true) * 1e3);
      data_offset += 8;
    }
    var ret;
    switch (ctype) {
      case 0:
        break;
      case 2:
        ret = { t: "n", v: ieee };
        break;
      case 3:
        ret = { t: "s", v: sst[sidx] };
        break;
      case 5:
        ret = { t: "d", v: dt };
        break;
      case 6:
        ret = { t: "b", v: ieee > 0 };
        break;
      case 7:
        ret = { t: "n", v: ieee };
        break;
      case 8:
        ret = { t: "e", v: 0 };
        break;
      case 9:
        {
          if (ridx > -1)
            ret = { t: "s", v: rsst[ridx] };
          else if (sidx > -1)
            ret = { t: "s", v: sst[sidx] };
          else if (!isNaN(ieee))
            ret = { t: "n", v: ieee };
          else
            throw new Error("Unsupported cell type ".concat(buf.slice(0, 4)));
        }
        break;
      default:
        throw new Error("Unsupported cell type ".concat(buf.slice(0, 4)));
    }
    return ret;
  }
  function parse_storage(buf, sst, rsst) {
    var dv = u8_to_dataview(buf);
    var ctype = buf[1];
    var flags = dv.getUint32(8, true);
    var data_offset = 12;
    var ridx = -1, sidx = -1, d128 = NaN, ieee = NaN, dt = new Date(2001, 0, 1);
    if (flags & 1) {
      d128 = readDecimal128LE(buf, data_offset);
      data_offset += 16;
    }
    if (flags & 2) {
      ieee = dv.getFloat64(data_offset, true);
      data_offset += 8;
    }
    if (flags & 4) {
      dt.setTime(dt.getTime() + dv.getFloat64(data_offset, true) * 1e3);
      data_offset += 8;
    }
    if (flags & 8) {
      sidx = dv.getUint32(data_offset, true);
      data_offset += 4;
    }
    if (flags & 16) {
      ridx = dv.getUint32(data_offset, true);
      data_offset += 4;
    }
    var ret;
    switch (ctype) {
      case 0:
        break;
      case 2:
        ret = { t: "n", v: d128 };
        break;
      case 3:
        ret = { t: "s", v: sst[sidx] };
        break;
      case 5:
        ret = { t: "d", v: dt };
        break;
      case 6:
        ret = { t: "b", v: ieee > 0 };
        break;
      case 7:
        ret = { t: "n", v: ieee };
        break;
      case 8:
        ret = { t: "e", v: 0 };
        break;
      case 9:
        {
          if (ridx > -1)
            ret = { t: "s", v: rsst[ridx] };
          else
            throw new Error("Unsupported cell type ".concat(ctype, " : ").concat(flags & 31, " : ").concat(buf.slice(0, 4)));
        }
        break;
      case 10:
        ret = { t: "n", v: d128 };
        break;
      default:
        throw new Error("Unsupported cell type ".concat(ctype, " : ").concat(flags & 31, " : ").concat(buf.slice(0, 4)));
    }
    return ret;
  }
  function parse(buf, sst, rsst) {
    switch (buf[0]) {
      case 3:
      case 4:
        return parse_old_storage(buf, sst, rsst);
      case 5:
        return parse_storage(buf, sst, rsst);
      default:
        throw new Error("Unsupported payload version ".concat(buf[0]));
    }
  }

  // src/numbers.ts
  var encode_col = function(C) {
    var s = "";
    for (++C; C; C = Math.floor((C - 1) / 26))
      s = String.fromCharCode((C - 1) % 26 + 65) + s;
    return s;
  };
  var encode_cell = function(c) {
    return "".concat(encode_col(c.c)).concat(c.r + 1);
  };
  var encode_range = function(r) {
    return encode_cell(r.s) + ":" + encode_cell(r.e);
  };
  var book_new = function() {
    return { Sheets: {}, SheetNames: [] };
  };
  var book_append_sheet = function(wb, ws, name) {
    if (!name)
      for (var i = 1; i < 9999; ++i) {
        if (wb.SheetNames.indexOf(name = "Sheet ".concat(i)) == -1)
          break;
      }
    else if (wb.SheetNames.indexOf(name) > -1)
      for (var i = 1; i < 9999; ++i) {
        if (wb.SheetNames.indexOf("".concat(name, "_").concat(i)) == -1) {
          name = "".concat(name, "_").concat(i);
          break;
        }
      }
    wb.SheetNames.push(name);
    wb.Sheets[name] = ws;
  };
  function parse_numbers(cfb) {
    var out = [];
    cfb.FullPaths.forEach(function(p) {
      if (p.match(/\.iwpv2/))
        throw new Error("Unsupported password protection");
    });
    cfb.FileIndex.forEach(function(s) {
      if (!s.name.match(/\.iwa$/))
        return;
      var o;
      try {
        o = deframe(s.content);
      } catch (e) {
        return console.log("?? " + s.content.length + " " + (e.message || e));
      }
      var packets;
      try {
        packets = parse_iwa(o);
      } catch (e) {
        return console.log("## " + (e.message || e));
      }
      packets.forEach(function(packet) {
        out[+packet.id] = packet.messages;
      });
    });
    if (!out.length)
      throw new Error("File has no messages");
    var docroot;
    out.forEach(function(iwams) {
      iwams.forEach(function(iwam) {
        var mtype = varint_to_i32(iwam.meta[1][0].data) >>> 0;
        if (mtype == 1) {
          if (!docroot)
            docroot = iwam;
          else
            throw new Error("Document has multiple roots");
        }
      });
    });
    if (!docroot)
      throw new Error("Cannot find Document root");
    return parse_docroot(out, docroot);
  }
  var numbers_default = parse_numbers;
  function parse_Reference(buf) {
    var pb = parse_shallow(buf);
    return parse_varint49(pb[1][0].data);
  }
  function parse_TST_TableDataList(M, root) {
    var pb = parse_shallow(root.data);
    var type = varint_to_i32(pb[1][0].data);
    var entries = pb[3];
    var data = [];
    (entries || []).forEach(function(entry) {
      var le = parse_shallow(entry.data);
      var key = varint_to_i32(le[1][0].data) >>> 0;
      switch (type) {
        case 1:
          data[key] = u8str(le[3][0].data);
          break;
        case 8:
          {
            var rt = M[parse_Reference(le[9][0].data)][0];
            var rtp = parse_shallow(rt.data);
            var rtpref = M[parse_Reference(rtp[1][0].data)][0];
            var mtype = varint_to_i32(rtpref.meta[1][0].data);
            if (mtype != 2001)
              throw new Error("2000 unexpected reference to ".concat(mtype));
            var tswpsa = parse_shallow(rtpref.data);
            data[key] = tswpsa[3].map(function(x) {
              return u8str(x.data);
            }).join("");
          }
          break;
      }
    });
    return data;
  }
  function parse_TST_TileRowInfo(u8) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j;
    var pb = parse_shallow(u8);
    var R = varint_to_i32(pb[1][0].data) >>> 0;
    var pre_bnc = (_b = (_a = pb[3]) == null ? void 0 : _a[0]) == null ? void 0 : _b.data;
    var pre_bnc_offsets = ((_d = (_c = pb[4]) == null ? void 0 : _c[0]) == null ? void 0 : _d.data) && u8_to_dataview(pb[4][0].data);
    var storage = (_f = (_e = pb[6]) == null ? void 0 : _e[0]) == null ? void 0 : _f.data;
    var storage_offsets = ((_h = (_g = pb[7]) == null ? void 0 : _g[0]) == null ? void 0 : _h.data) && u8_to_dataview(pb[7][0].data);
    var wide_offsets = ((_j = (_i = pb[8]) == null ? void 0 : _i[0]) == null ? void 0 : _j.data) && varint_to_i32(pb[8][0].data) > 0 || false;
    var width = wide_offsets ? 4 : 1;
    var cells = [];
    var off = 0;
    for (var C = 0; C < pre_bnc_offsets.byteLength / 2; ++C) {
      if (storage && storage_offsets) {
        off = storage_offsets.getUint16(C * 2, true) * width;
        if (off < storage.length) {
          cells[C] = storage.subarray(off, storage_offsets.getUint16(C * 2 + 2, true) * width);
          continue;
        }
      }
      if (pre_bnc && pre_bnc_offsets) {
        off = pre_bnc_offsets.getUint16(C * 2, true) * width;
        if (off < pre_bnc.length)
          cells[C] = pre_bnc.subarray(off, pre_bnc_offsets.getUint16(C * 2 + 2, true) * width);
      }
    }
    return { R: R, cells: cells };
  }
  function parse_TST_Tile(M, root) {
    var pb = parse_shallow(root.data);
    var ri = mappa(pb[5], parse_TST_TileRowInfo);
    return ri.reduce(function(acc, x) {
      if (!acc[x.R])
        acc[x.R] = [];
      x.cells.forEach(function(cell, C) {
        if (acc[x.R][C])
          throw new Error("Duplicate cell r=".concat(x.R, " c=").concat(C));
        acc[x.R][C] = cell;
      });
      return acc;
    }, []);
  }
  function parse_TST_TableModelArchive(M, root, ws) {
    var _a;
    var pb = parse_shallow(root.data);
    var range = { s: { r: 0, c: 0 }, e: { r: 0, c: 0 } };
    range.e.r = (varint_to_i32(pb[6][0].data) >>> 0) - 1;
    if (range.e.r < 0)
      throw new Error("Invalid row varint ".concat(pb[6][0].data));
    range.e.c = (varint_to_i32(pb[7][0].data) >>> 0) - 1;
    if (range.e.c < 0)
      throw new Error("Invalid col varint ".concat(pb[7][0].data));
    ws["!ref"] = encode_range(range);
    {
      var store = parse_shallow(pb[4][0].data);
      var sst = parse_TST_TableDataList(M, M[parse_Reference(store[4][0].data)][0]);
      var rsst = ((_a = store[17]) == null ? void 0 : _a[0]) ? parse_TST_TableDataList(M, M[parse_Reference(store[17][0].data)][0]) : [];
      {
        var tile = parse_shallow(store[3][0].data);
        var tiles = [];
        tile[1].forEach(function(t) {
          var tl = parse_shallow(t.data);
          var ref = M[parse_Reference(tl[2][0].data)][0];
          var mtype = varint_to_i32(ref.meta[1][0].data);
          if (mtype != 6002)
            throw new Error("6001 unexpected reference to ".concat(mtype));
          tiles.push({ id: varint_to_i32(tl[1][0].data), ref: parse_TST_Tile(M, ref) });
        });
        tiles.forEach(function(tile2) {
          tile2.ref.forEach(function(row, R) {
            row.forEach(function(buf, C) {
              var addr = encode_cell({ r: R, c: C });
              var res = parse(buf, sst, rsst);
              if (res)
                ws[addr] = res;
            });
          });
        });
      }
    }
  }
  function parse_TST_TableInfoArchive(M, root) {
    var pb = parse_shallow(root.data);
    var out = { "!ref": "A1" };
    var tableref = M[parse_Reference(pb[2][0].data)];
    var mtype = varint_to_i32(tableref[0].meta[1][0].data);
    if (mtype != 6001)
      throw new Error("6000 unexpected reference to ".concat(mtype));
    parse_TST_TableModelArchive(M, tableref[0], out);
    return out;
  }
  function parse_sheetroot(M, root) {
    var _a;
    var pb = parse_shallow(root.data);
    var out = {
      name: ((_a = pb[1]) == null ? void 0 : _a[0]) ? u8str(pb[1][0].data) : "",
      sheets: []
    };
    var shapeoffs = mappa(pb[2], parse_Reference);
    shapeoffs.forEach(function(off) {
      M[off].forEach(function(m) {
        var mtype = varint_to_i32(m.meta[1][0].data);
        if (mtype == 6e3)
          out.sheets.push(parse_TST_TableInfoArchive(M, m));
      });
    });
    return out;
  }
  function parse_docroot(M, root) {
    var out = book_new();
    var pb = parse_shallow(root.data);
    var sheetoffs = mappa(pb[1], parse_Reference);
    sheetoffs.forEach(function(off) {
      M[off].forEach(function(m) {
        var mtype = varint_to_i32(m.meta[1][0].data);
        if (mtype == 2) {
          var root2 = parse_sheetroot(M, m);
          root2.sheets.forEach(function(sheet) {
            book_append_sheet(out, sheet, root2.name);
          });
        }
      });
    });
    if (out.SheetNames.length == 0)
      throw new Error("Empty NUMBERS file");
    return out;
  }
  return __toCommonJS(numbers_exports);
})();
/*! sheetjs (C) 2013-present SheetJS -- http://sheetjs.com */
function fix_opts_func(defaults/*:Array<Array<any> >*/)/*:{(o:any):void}*/ {
	return function fix_opts(opts) {
		for(var i = 0; i != defaults.length; ++i) {
			var d = defaults[i];
			if(opts[d[0]] === undefined) opts[d[0]] = d[1];
			if(d[2] === 'n') opts[d[0]] = Number(opts[d[0]]);
		}
	};
}

var fix_read_opts = function(opts) {
fix_opts_func([
	['cellNF', false], /* emit cell number format string as .z */
	['cellHTML', true], /* emit html string as .h */
	['cellFormula', true], /* emit formulae as .f */
	['cellStyles', false], /* emits style/theme as .s */
	['cellText', true], /* emit formatted text as .w */
	['cellDates', false], /* emit date cells with type `d` */

	['sheetStubs', false], /* emit empty cells */
	['sheetRows', 0, 'n'], /* read n rows (0 = read all rows) */

	['bookDeps', false], /* parse calculation chains */
	['bookSheets', false], /* only try to get sheet names (no Sheets) */
	['bookProps', false], /* only try to get properties (no Sheets) */
	['bookFiles', false], /* include raw file structure (keys, files, cfb) */
	['bookVBA', false], /* include vba raw data (vbaraw) */

	['password',''], /* password */
	['WTF', false] /* WTF mode (throws errors) */
])(opts);
};

var fix_write_opts = fix_opts_func([
	['cellDates', false], /* write date cells with type `d` */

	['bookSST', false], /* Generate Shared String Table */

	['bookType', 'xlsx'], /* Type of workbook (xlsx/m/b) */

	['compression', false], /* Use file compression */

	['WTF', false] /* WTF mode (throws errors) */
]);
function get_sheet_type(n/*:string*/)/*:string*/ {
	if(RELS.WS.indexOf(n) > -1) return "sheet";
	if(RELS.CS && n == RELS.CS) return "chart";
	if(RELS.DS && n == RELS.DS) return "dialog";
	if(RELS.MS && n == RELS.MS) return "macro";
	return (n && n.length) ? n : "sheet";
}
function safe_parse_wbrels(wbrels, sheets) {
	if(!wbrels) return 0;
	try {
		wbrels = sheets.map(function pwbr(w) { if(!w.id) w.id = w.strRelID; return [w.name, wbrels['!id'][w.id].Target, get_sheet_type(wbrels['!id'][w.id].Type)]; });
	} catch(e) { return null; }
	return !wbrels || wbrels.length === 0 ? null : wbrels;
}

function safe_parse_sheet(zip, path/*:string*/, relsPath/*:string*/, sheet, idx/*:number*/, sheetRels, sheets, stype/*:string*/, opts, wb, themes, styles) {
	try {
		sheetRels[sheet]=parse_rels(getzipstr(zip, relsPath, true), path);
		var data = getzipdata(zip, path);
		var _ws;
		switch(stype) {
			case 'sheet':  _ws = parse_ws(data, path, idx, opts, sheetRels[sheet], wb, themes, styles); break;
			case 'chart':  _ws = parse_cs(data, path, idx, opts, sheetRels[sheet], wb, themes, styles);
				if(!_ws || !_ws['!drawel']) break;
				var dfile = resolve_path(_ws['!drawel'].Target, path);
				var drelsp = get_rels_path(dfile);
				var draw = parse_drawing(getzipstr(zip, dfile, true), parse_rels(getzipstr(zip, drelsp, true), dfile));
				var chartp = resolve_path(draw, dfile);
				var crelsp = get_rels_path(chartp);
				_ws = parse_chart(getzipstr(zip, chartp, true), chartp, opts, parse_rels(getzipstr(zip, crelsp, true), chartp), wb, _ws);
				break;
			case 'macro':  _ws = parse_ms(data, path, idx, opts, sheetRels[sheet], wb, themes, styles); break;
			case 'dialog': _ws = parse_ds(data, path, idx, opts, sheetRels[sheet], wb, themes, styles); break;
			default: throw new Error("Unrecognized sheet type " + stype);
		}
		sheets[sheet] = _ws;

		/* scan rels for comments */
		var comments = [];
		if(sheetRels && sheetRels[sheet]) keys$1(sheetRels[sheet]).forEach(function(n) {
			if(sheetRels[sheet][n].Type == RELS.CMNT) {
				var dfile = resolve_path(sheetRels[sheet][n].Target, path);
				comments = parse_cmnt(getzipdata(zip, dfile, true), dfile, opts);
				if(!comments || !comments.length) return;
				sheet_insert_comments(_ws, comments);
			}
		});
	} catch(e) { if(opts.WTF) throw e; }
}

function strip_front_slash(x/*:string*/)/*:string*/ { return x.charAt(0) == '/' ? x.slice(1) : x; }

function parse_zip(zip/*:ZIP*/, opts/*:?ParseOpts*/)/*:Workbook*/ {
	make_ssf(SSF);
	opts = opts || {};
	fix_read_opts(opts);

	/* OpenDocument Part 3 Section 2.2.1 OpenDocument Package */
	if(safegetzipfile(zip, 'META-INF/manifest.xml')) return parse_ods(zip, opts);
	/* UOC */
	if(safegetzipfile(zip, 'objectdata.xml')) return parse_ods(zip, opts);
	/* Numbers */
	if(safegetzipfile(zip, 'Index/Document.iwa')) {
		if(typeof Uint8Array == "undefined") throw new Error('NUMBERS file parsing requires Uint8Array support');
		if(typeof NUMBERS != "undefined") {
			if(zip.FileIndex) return NUMBERS.parse_numbers(zip);
			var _zip = CFB.utils.cfb_new();
			zipentries(zip).forEach(function(e) { zip_add_file(_zip, e, getzipbin(zip, e)); });
			return NUMBERS.parse_numbers(_zip);
		}
		throw new Error('Unsupported NUMBERS file');
	}
	if(!safegetzipfile(zip, '[Content_Types].xml')) {
		if(safegetzipfile(zip, 'index.xml.gz')) throw new Error('Unsupported NUMBERS 08 file');
		if(safegetzipfile(zip, 'index.xml')) throw new Error('Unsupported NUMBERS 09 file');
		throw new Error('Unsupported ZIP file');
	}

	var entries = zipentries(zip);
	var dir = parse_ct((getzipstr(zip, '[Content_Types].xml')/*:?any*/));
	var xlsb = false;
	var sheets, binname;
	if(dir.workbooks.length === 0) {
		binname = "xl/workbook.xml";
		if(getzipdata(zip,binname, true)) dir.workbooks.push(binname);
	}
	if(dir.workbooks.length === 0) {
		binname = "xl/workbook.bin";
		if(!getzipdata(zip,binname,true)) throw new Error("Could not find workbook");
		dir.workbooks.push(binname);
		xlsb = true;
	}
	if(dir.workbooks[0].slice(-3) == "bin") xlsb = true;

	var themes = ({}/*:any*/);
	var styles = ({}/*:any*/);
	if(!opts.bookSheets && !opts.bookProps) {
		strs = [];
		if(dir.sst) try { strs=parse_sst(getzipdata(zip, strip_front_slash(dir.sst)), dir.sst, opts); } catch(e) { if(opts.WTF) throw e; }

		if(opts.cellStyles && dir.themes.length) themes = parse_theme(getzipstr(zip, dir.themes[0].replace(/^\//,''), true)||"",dir.themes[0], opts);

		if(dir.style) styles = parse_sty(getzipdata(zip, strip_front_slash(dir.style)), dir.style, themes, opts);
	}

	/*var externbooks = */dir.links.map(function(link) {
		try {
			var rels = parse_rels(getzipstr(zip, get_rels_path(strip_front_slash(link))), link);
			return parse_xlink(getzipdata(zip, strip_front_slash(link)), rels, link, opts);
		} catch(e) {}
	});

	var wb = parse_wb(getzipdata(zip, strip_front_slash(dir.workbooks[0])), dir.workbooks[0], opts);

	var props = {}, propdata = "";

	if(dir.coreprops.length) {
		propdata = getzipdata(zip, strip_front_slash(dir.coreprops[0]), true);
		if(propdata) props = parse_core_props(propdata);
		if(dir.extprops.length !== 0) {
			propdata = getzipdata(zip, strip_front_slash(dir.extprops[0]), true);
			if(propdata) parse_ext_props(propdata, props, opts);
		}
	}

	var custprops = {};
	if(!opts.bookSheets || opts.bookProps) {
		if (dir.custprops.length !== 0) {
			propdata = getzipstr(zip, strip_front_slash(dir.custprops[0]), true);
			if(propdata) custprops = parse_cust_props(propdata, opts);
		}
	}

	var out = ({}/*:any*/);
	if(opts.bookSheets || opts.bookProps) {
		if(wb.Sheets) sheets = wb.Sheets.map(function pluck(x){ return x.name; });
		else if(props.Worksheets && props.SheetNames.length > 0) sheets=props.SheetNames;
		if(opts.bookProps) { out.Props = props; out.Custprops = custprops; }
		if(opts.bookSheets && typeof sheets !== 'undefined') out.SheetNames = sheets;
		if(opts.bookSheets ? out.SheetNames : opts.bookProps) return out;
	}
	sheets = {};

	var deps = {};
	if(opts.bookDeps && dir.calcchain) deps=parse_cc(getzipdata(zip, strip_front_slash(dir.calcchain)),dir.calcchain);

	var i=0;
	var sheetRels = ({}/*:any*/);
	var path, relsPath;

	{
		var wbsheets = wb.Sheets;
		props.Worksheets = wbsheets.length;
		props.SheetNames = [];
		for(var j = 0; j != wbsheets.length; ++j) {
			props.SheetNames[j] = wbsheets[j].name;
		}
	}

	var wbext = xlsb ? "bin" : "xml";
	var wbrelsi = dir.workbooks[0].lastIndexOf("/");
	var wbrelsfile = (dir.workbooks[0].slice(0, wbrelsi+1) + "_rels/" + dir.workbooks[0].slice(wbrelsi+1) + ".rels").replace(/^\//,"");
	if(!safegetzipfile(zip, wbrelsfile)) wbrelsfile = 'xl/_rels/workbook.' + wbext + '.rels';
	var wbrels = parse_rels(getzipstr(zip, wbrelsfile, true), wbrelsfile);
	if(wbrels) wbrels = safe_parse_wbrels(wbrels, wb.Sheets);

	/* Numbers iOS hack */
	var nmode = (getzipdata(zip,"xl/worksheets/sheet.xml",true))?1:0;
	wsloop: for(i = 0; i != props.Worksheets; ++i) {
		var stype = "sheet";
		if(wbrels && wbrels[i]) {
			path = 'xl/' + (wbrels[i][1]).replace(/[\/]?xl\//, "");
			if(!safegetzipfile(zip, path)) path = wbrels[i][1];
			if(!safegetzipfile(zip, path)) path = wbrelsfile.replace(/_rels\/.*$/,"") + wbrels[i][1];
			stype = wbrels[i][2];
		} else {
			path = 'xl/worksheets/sheet'+(i+1-nmode)+"." + wbext;
			path = path.replace(/sheet0\./,"sheet.");
		}
		relsPath = path.replace(/^(.*)(\/)([^\/]*)$/, "$1/_rels/$3.rels");
		if(opts && opts.sheets != null) switch(typeof opts.sheets) {
			case "number": if(i != opts.sheets) continue wsloop; break;
			case "string": if(props.SheetNames[i].toLowerCase() != opts.sheets.toLowerCase()) continue wsloop; break;
			default: if(Array.isArray && Array.isArray(opts.sheets)) {
				var snjseen = false;
				for(var snj = 0; snj != opts.sheets.length; ++snj) {
					if(typeof opts.sheets[snj] == "number" && opts.sheets[snj] == i) snjseen=1;
					if(typeof opts.sheets[snj] == "string" && opts.sheets[snj].toLowerCase() == props.SheetNames[i].toLowerCase()) snjseen = 1;
				}
				if(!snjseen) continue wsloop;
			}
		}
		safe_parse_sheet(zip, path, relsPath, props.SheetNames[i], i, sheetRels, sheets, stype, opts, wb, themes, styles);
	}

	out = ({
		Directory: dir,
		Workbook: wb,
		Props: props,
		Custprops: custprops,
		Deps: deps,
		Sheets: sheets,
		SheetNames: props.SheetNames,
		Strings: strs,
		Styles: styles,
		Themes: themes,
		SSF: SSF.get_table()
	}/*:any*/);
	if(opts && opts.bookFiles) {
		if(zip.files) {
			out.keys = entries;
			out.files = zip.files;
		} else {
			out.keys = [];
			out.files = {};
			zip.FullPaths.forEach(function(p, idx) {
				p = p.replace(/^Root Entry[\/]/, "");
				out.keys.push(p);
				out.files[p] = zip.FileIndex[idx];
			});
		}
	}
	if(opts && opts.bookVBA) {
		if(dir.vba.length > 0) out.vbaraw = getzipdata(zip,strip_front_slash(dir.vba[0]),true);
		else if(dir.defaults && dir.defaults.bin === CT_VBA) out.vbaraw = getzipdata(zip, 'xl/vbaProject.bin',true);
	}
	return out;
}

/* [MS-OFFCRYPTO] 2.1.1 */
function parse_xlsxcfb(cfb, _opts/*:?ParseOpts*/)/*:Workbook*/ {
	var opts = _opts || {};
	var f = 'Workbook', data = CFB.find(cfb, f);
	try {
	f = '/!DataSpaces/Version';
	data = CFB.find(cfb, f); if(!data || !data.content) throw new Error("ECMA-376 Encrypted file missing " + f);
	/*var version = */parse_DataSpaceVersionInfo(data.content);

	/* 2.3.4.1 */
	f = '/!DataSpaces/DataSpaceMap';
	data = CFB.find(cfb, f); if(!data || !data.content) throw new Error("ECMA-376 Encrypted file missing " + f);
	var dsm = parse_DataSpaceMap(data.content);
	if(dsm.length !== 1 || dsm[0].comps.length !== 1 || dsm[0].comps[0].t !== 0 || dsm[0].name !== "StrongEncryptionDataSpace" || dsm[0].comps[0].v !== "EncryptedPackage")
		throw new Error("ECMA-376 Encrypted file bad " + f);

	/* 2.3.4.2 */
	f = '/!DataSpaces/DataSpaceInfo/StrongEncryptionDataSpace';
	data = CFB.find(cfb, f); if(!data || !data.content) throw new Error("ECMA-376 Encrypted file missing " + f);
	var seds = parse_DataSpaceDefinition(data.content);
	if(seds.length != 1 || seds[0] != "StrongEncryptionTransform")
		throw new Error("ECMA-376 Encrypted file bad " + f);

	/* 2.3.4.3 */
	f = '/!DataSpaces/TransformInfo/StrongEncryptionTransform/!Primary';
	data = CFB.find(cfb, f); if(!data || !data.content) throw new Error("ECMA-376 Encrypted file missing " + f);
	/*var hdr = */parse_Primary(data.content);
	} catch(e) {}

	f = '/EncryptionInfo';
	data = CFB.find(cfb, f); if(!data || !data.content) throw new Error("ECMA-376 Encrypted file missing " + f);
	var einfo = parse_EncryptionInfo(data.content);

	/* 2.3.4.4 */
	f = '/EncryptedPackage';
	data = CFB.find(cfb, f); if(!data || !data.content) throw new Error("ECMA-376 Encrypted file missing " + f);

/*global decrypt_agile */
/*:: declare var decrypt_agile:any; */
	if(einfo[0] == 0x04 && typeof decrypt_agile !== 'undefined') return decrypt_agile(einfo[1], data.content, opts.password || "", opts);
/*global decrypt_std76 */
/*:: declare var decrypt_std76:any; */
	if(einfo[0] == 0x02 && typeof decrypt_std76 !== 'undefined') return decrypt_std76(einfo[1], data.content, opts.password || "", opts);
	throw new Error("File is password-protected");
}

function write_zip(wb/*:Workbook*/, opts/*:WriteOpts*/)/*:ZIP*/ {
	if(opts.bookType == "ods") return write_ods(wb, opts);
	return write_zip_xlsxb(wb, opts);
}

function write_zip_xlsxb(wb/*:Workbook*/, opts/*:WriteOpts*/)/*:ZIP*/ {
	_shapeid = 1024;
	if(wb && !wb.SSF) {
		wb.SSF = SSF.get_table();
	}
	if(wb && wb.SSF) {
		make_ssf(SSF); SSF.load_table(wb.SSF);
		// $FlowIgnore
		opts.revssf = evert_num(wb.SSF); opts.revssf[wb.SSF[65535]] = 0;
		opts.ssf = wb.SSF;
	}
	opts.rels = {}; opts.wbrels = {};
	opts.Strings = /*::((*/[]/*:: :any):SST)*/; opts.Strings.Count = 0; opts.Strings.Unique = 0;
	if(browser_has_Map) opts.revStrings = new Map();
	else { opts.revStrings = {}; opts.revStrings.foo = []; delete opts.revStrings.foo; }
	var wbext = opts.bookType == "xlsb" ? "bin" : "xml";
	var vbafmt = VBAFMTS.indexOf(opts.bookType) > -1;
	var ct = new_ct();
	fix_write_opts(opts = opts || {});
	var zip = zip_new();
	var f = "", rId = 0;

	opts.cellXfs = [];
	get_cell_style(opts.cellXfs, {}, {revssf:{"General":0}});

	if(!wb.Props) wb.Props = {};

	f = "docProps/core.xml";
	zip_add_file(zip, f, write_core_props(wb.Props, opts));
	ct.coreprops.push(f);
	add_rels(opts.rels, 2, f, RELS.CORE_PROPS);

	/*::if(!wb.Props) throw "unreachable"; */
	f = "docProps/app.xml";
	if(wb.Props && wb.Props.SheetNames);
	else if(!wb.Workbook || !wb.Workbook.Sheets) wb.Props.SheetNames = wb.SheetNames;
	else {
		var _sn = [];
		for(var _i = 0; _i < wb.SheetNames.length; ++_i)
			if((wb.Workbook.Sheets[_i]||{}).Hidden != 2) _sn.push(wb.SheetNames[_i]);
		wb.Props.SheetNames = _sn;
	}
	wb.Props.Worksheets = wb.Props.SheetNames.length;
	zip_add_file(zip, f, write_ext_props(wb.Props));
	ct.extprops.push(f);
	add_rels(opts.rels, 3, f, RELS.EXT_PROPS);

	if(wb.Custprops !== wb.Props && keys$1(wb.Custprops||{}).length > 0) {
		f = "docProps/custom.xml";
		zip_add_file(zip, f, write_cust_props(wb.Custprops));
		ct.custprops.push(f);
		add_rels(opts.rels, 4, f, RELS.CUST_PROPS);
	}

	for(rId=1;rId <= wb.SheetNames.length; ++rId) {
		var wsrels = {'!id':{}};
		var ws = wb.Sheets[wb.SheetNames[rId-1]];
		var _type = (ws || {})["!type"] || "sheet";
		switch(_type) {
		case "chart":
			/* falls through */
		default:
			f = "xl/worksheets/sheet" + rId + "." + wbext;
			zip_add_file(zip, f, write_ws(rId-1, f, opts, wb, wsrels));
			ct.sheets.push(f);
			add_rels(opts.wbrels, -1, "worksheets/sheet" + rId + "." + wbext, RELS.WS[0]);
		}

		if(ws) {
			var comments = ws['!comments'];
			var need_vml = false;
			if(comments && comments.length > 0) {
				var cf = "xl/comments" + rId + "." + wbext;
				zip_add_file(zip, cf, write_cmnt(comments, cf, opts));
				ct.comments.push(cf);
				add_rels(wsrels, -1, "../comments" + rId + "." + wbext, RELS.CMNT);
				need_vml = true;
			}
			if(ws['!legacy']) {
				if(need_vml) zip_add_file(zip, "xl/drawings/vmlDrawing" + (rId) + ".vml", write_comments_vml(rId, ws['!comments']));
			}
			delete ws['!comments'];
			delete ws['!legacy'];
		}

		if(wsrels['!id'].rId1) zip_add_file(zip, get_rels_path(f), write_rels(wsrels));
	}

	if(opts.Strings != null && opts.Strings.length > 0) {
		f = "xl/sharedStrings." + wbext;
		zip_add_file(zip, f, write_sst(opts.Strings, f, opts));
		ct.strs.push(f);
		add_rels(opts.wbrels, -1, "sharedStrings." + wbext, RELS.SST);
	}

	f = "xl/workbook." + wbext;
	zip_add_file(zip, f, write_wb(wb, f, opts));
	ct.workbooks.push(f);
	add_rels(opts.rels, 1, f, RELS.WB);

	/* TODO: something more intelligent with themes */

	f = "xl/theme/theme1.xml";
	zip_add_file(zip, f, write_theme(wb.Themes, opts));
	ct.themes.push(f);
	add_rels(opts.wbrels, -1, "theme/theme1.xml", RELS.THEME);

	/* TODO: something more intelligent with styles */

	f = "xl/styles." + wbext;
	zip_add_file(zip, f, write_sty(wb, f, opts));
	ct.styles.push(f);
	add_rels(opts.wbrels, -1, "styles." + wbext, RELS.STY);

	if(wb.vbaraw && vbafmt) {
		f = "xl/vbaProject.bin";
		zip_add_file(zip, f, wb.vbaraw);
		ct.vba.push(f);
		add_rels(opts.wbrels, -1, "vbaProject.bin", RELS.VBA);
	}

	zip_add_file(zip, "[Content_Types].xml", write_ct(ct, opts));
	zip_add_file(zip, '_rels/.rels', write_rels(opts.rels));
	zip_add_file(zip, 'xl/_rels/workbook.' + wbext + '.rels', write_rels(opts.wbrels));

	delete opts.revssf; delete opts.ssf;
	return zip;
}


function write_zip_xlsx(wb/*:Workbook*/, opts/*:WriteOpts*/)/*:ZIP*/ {
	_shapeid = 1024;
	if(wb && !wb.SSF) {
		wb.SSF = SSF.get_table();
	}
	if(wb && wb.SSF) {
		make_ssf(SSF); SSF.load_table(wb.SSF);
		// $FlowIgnore
		opts.revssf = evert_num(wb.SSF); opts.revssf[wb.SSF[65535]] = 0;
		opts.ssf = wb.SSF;
	}
	opts.rels = {}; opts.wbrels = {};
	opts.Strings = /*::((*/[]/*:: :any):SST)*/; opts.Strings.Count = 0; opts.Strings.Unique = 0;
	if(browser_has_Map) opts.revStrings = new Map();
	else { opts.revStrings = {}; opts.revStrings.foo = []; delete opts.revStrings.foo; }
	var wbext = "xml";
	var vbafmt = VBAFMTS.indexOf(opts.bookType) > -1;
	var ct = new_ct();
	fix_write_opts(opts = opts || {});
	var zip = zip_new();
	var f = "", rId = 0;

	opts.cellXfs = [];
	get_cell_style(opts.cellXfs, {}, {revssf:{"General":0}});

	if(!wb.Props) wb.Props = {};

	f = "docProps/core.xml";
	zip_add_file(zip, f, write_core_props(wb.Props, opts));
	ct.coreprops.push(f);
	add_rels(opts.rels, 2, f, RELS.CORE_PROPS);

	/*::if(!wb.Props) throw "unreachable"; */
	f = "docProps/app.xml";
	if(wb.Props && wb.Props.SheetNames);
	else if(!wb.Workbook || !wb.Workbook.Sheets) wb.Props.SheetNames = wb.SheetNames;
	else {
		var _sn = [];
		for(var _i = 0; _i < wb.SheetNames.length; ++_i)
			if((wb.Workbook.Sheets[_i]||{}).Hidden != 2) _sn.push(wb.SheetNames[_i]);
		wb.Props.SheetNames = _sn;
	}
	wb.Props.Worksheets = wb.Props.SheetNames.length;
	zip_add_file(zip, f, write_ext_props(wb.Props));
	ct.extprops.push(f);
	add_rels(opts.rels, 3, f, RELS.EXT_PROPS);

	if(wb.Custprops !== wb.Props && keys$1(wb.Custprops||{}).length > 0) {
		f = "docProps/custom.xml";
		zip_add_file(zip, f, write_cust_props(wb.Custprops));
		ct.custprops.push(f);
		add_rels(opts.rels, 4, f, RELS.CUST_PROPS);
	}

	for(rId=1;rId <= wb.SheetNames.length; ++rId) {
		var wsrels = {'!id':{}};
		var ws = wb.Sheets[wb.SheetNames[rId-1]];
		var _type = (ws || {})["!type"] || "sheet";
		switch(_type) {
		case "chart":
			/* falls through */
		default:
			f = "xl/worksheets/sheet" + rId + "." + wbext;
			zip_add_file(zip, f, write_ws_xml(rId-1, opts, wb, wsrels));
			ct.sheets.push(f);
			add_rels(opts.wbrels, -1, "worksheets/sheet" + rId + "." + wbext, RELS.WS[0]);
		}

		if(ws) {
			var comments = ws['!comments'];
			var need_vml = false;
			if(comments && comments.length > 0) {
				var cf = "xl/comments" + rId + "." + wbext;
				zip_add_file(zip, cf, write_comments_xml(comments));
				ct.comments.push(cf);
				add_rels(wsrels, -1, "../comments" + rId + "." + wbext, RELS.CMNT);
				need_vml = true;
			}
			if(ws['!legacy']) {
				if(need_vml) zip_add_file(zip, "xl/drawings/vmlDrawing" + (rId) + ".vml", write_comments_vml(rId, ws['!comments']));
			}
			delete ws['!comments'];
			delete ws['!legacy'];
		}

		if(wsrels['!id'].rId1) zip_add_file(zip, get_rels_path(f), write_rels(wsrels));
	}

	if(opts.Strings != null && opts.Strings.length > 0) {
		f = "xl/sharedStrings." + wbext;
		zip_add_file(zip, f, write_sst_xml(opts.Strings, opts));
		ct.strs.push(f);
		add_rels(opts.wbrels, -1, "sharedStrings." + wbext, RELS.SST);
	}

	f = "xl/workbook." + wbext;
	zip_add_file(zip, f, write_wb_xml(wb));
	ct.workbooks.push(f);
	add_rels(opts.rels, 1, f, RELS.WB);

	/* TODO: something more intelligent with themes */

	f = "xl/theme/theme1.xml";
	zip_add_file(zip, f, write_theme(wb.Themes, opts));
	ct.themes.push(f);
	add_rels(opts.wbrels, -1, "theme/theme1.xml", RELS.THEME);

	/* TODO: something more intelligent with styles */

	f = "xl/styles." + wbext;
	zip_add_file(zip, f, write_sty_xml(wb, opts));
	ct.styles.push(f);
	add_rels(opts.wbrels, -1, "styles." + wbext, RELS.STY);

	if(wb.vbaraw && vbafmt) {
		f = "xl/vbaProject.bin";
		zip_add_file(zip, f, wb.vbaraw);
		ct.vba.push(f);
		add_rels(opts.wbrels, -1, "vbaProject.bin", RELS.VBA);
	}

	zip_add_file(zip, "[Content_Types].xml", write_ct(ct, opts));
	zip_add_file(zip, '_rels/.rels', write_rels(opts.rels));
	zip_add_file(zip, 'xl/_rels/workbook.' + wbext + '.rels', write_rels(opts.wbrels));

	delete opts.revssf; delete opts.ssf;
	return zip;
}

function firstbyte(f/*:RawData*/,o/*:?TypeOpts*/)/*:Array<number>*/ {
	var x = "";
	switch((o||{}).type || "base64") {
		case 'buffer': return [f[0], f[1], f[2], f[3], f[4], f[5], f[6], f[7]];
		case 'base64': x = Base64.decode(f.slice(0,12)); break;
		case 'binary': x = f; break;
		case 'array':  return [f[0], f[1], f[2], f[3], f[4], f[5], f[6], f[7]];
		default: throw new Error("Unrecognized type " + (o && o.type || "undefined"));
	}
	return [x.charCodeAt(0), x.charCodeAt(1), x.charCodeAt(2), x.charCodeAt(3), x.charCodeAt(4), x.charCodeAt(5), x.charCodeAt(6), x.charCodeAt(7)];
}

function read_cfb(cfb/*:CFBContainer*/, opts/*:?ParseOpts*/)/*:Workbook*/ {
	if(CFB.find(cfb, "EncryptedPackage")) return parse_xlsxcfb(cfb, opts);
	return parse_xlscfb(cfb, opts);
}

function read_zip(data/*:RawData*/, opts/*:?ParseOpts*/)/*:Workbook*/ {
	var zip, d = data;
	var o = opts||{};
	if(!o.type) o.type = (has_buf && Buffer.isBuffer(data)) ? "buffer" : "base64";
	zip = zip_read(d, o);
	return parse_zip(zip, o);
}

function read_plaintext(data/*:string*/, o/*:ParseOpts*/)/*:Workbook*/ {
	var i = 0;
	main: while(i < data.length) switch(data.charCodeAt(i)) {
		case 0x0A: case 0x0D: case 0x20: ++i; break;
		case 0x3C: return parse_xlml(data.slice(i),o);
		default: break main;
	}
	return PRN.to_workbook(data, o);
}

function read_plaintext_raw(data/*:RawData*/, o/*:ParseOpts*/)/*:Workbook*/ {
	var str = "", bytes = firstbyte(data, o);
	switch(o.type) {
		case 'base64': str = Base64.decode(data); break;
		case 'binary': str = data; break;
		case 'buffer': str = data.toString('binary'); break;
		case 'array': str = cc2str(data); break;
		default: throw new Error("Unrecognized type " + o.type);
	}
	if(bytes[0] == 0xEF && bytes[1] == 0xBB && bytes[2] == 0xBF) str = utf8read(str);
	return read_plaintext(str, o);
}

function read_utf16(data/*:RawData*/, o/*:ParseOpts*/)/*:Workbook*/ {
	var d = data;
	if(o.type == 'base64') d = Base64.decode(d);
	d = cptable.utils.decode(1200, d.slice(2), 'str');
	o.type = "binary";
	return read_plaintext(d, o);
}

function bstrify(data/*:string*/)/*:string*/ {
	return !data.match(/[^\x00-\x7F]/) ? data : utf8write(data);
}

function read_prn(data, d, o, str) {
	if(str) { o.type = "string"; return PRN.to_workbook(data, o); }
	return PRN.to_workbook(d, o);
}

function readSync(data/*:RawData*/, opts/*:?ParseOpts*/)/*:Workbook*/ {
	reset_cp();
	var o = opts||{};
	if(typeof ArrayBuffer !== 'undefined' && data instanceof ArrayBuffer) return readSync(new Uint8Array(data), (o = dup(o), o.type = "array", o));
	if(typeof Uint8Array !== 'undefined' && data instanceof Uint8Array && !o.type) o.type = typeof Deno !== "undefined" ? "buffer" : "array";
	var d = data, n = [0,0,0,0], str = false;
	if(o.cellStyles) { o.cellNF = true; o.sheetStubs = true; }
	_ssfopts = {};
	if(o.dateNF) _ssfopts.dateNF = o.dateNF;
	if(!o.type) o.type = (has_buf && Buffer.isBuffer(data)) ? "buffer" : "base64";
	if(o.type == "file") { o.type = has_buf ? "buffer" : "binary"; d = read_binary(data); if(typeof Uint8Array !== 'undefined' && !has_buf) o.type = "array"; }
	if(o.type == "string") { str = true; o.type = "binary"; o.codepage = 65001; d = bstrify(data); }
	if(o.type == 'array' && typeof Uint8Array !== 'undefined' && data instanceof Uint8Array && typeof ArrayBuffer !== 'undefined') {
		// $FlowIgnore
		var ab=new ArrayBuffer(3), vu=new Uint8Array(ab); vu.foo="bar";
		// $FlowIgnore
		if(!vu.foo) {o=dup(o); o.type='array'; return readSync(ab2a(d), o);}
	}
	switch((n = firstbyte(d, o))[0]) {
		case 0xD0: if(n[1] === 0xCF && n[2] === 0x11 && n[3] === 0xE0 && n[4] === 0xA1 && n[5] === 0xB1 && n[6] === 0x1A && n[7] === 0xE1) return read_cfb(CFB.read(d, o), o); break;
		case 0x09: if(n[1] <= 0x08) return parse_xlscfb(d, o); break;
		case 0x3C: return parse_xlml(d, o);
		case 0x49:
			if(n[1] === 0x49 && n[2] === 0x2a && n[3] === 0x00) throw new Error("TIFF Image File is not a spreadsheet");
			if(n[1] === 0x44) return read_wb_ID(d, o);
			break;
		case 0x54: if(n[1] === 0x41 && n[2] === 0x42 && n[3] === 0x4C) return DIF.to_workbook(d, o); break;
		case 0x50: return (n[1] === 0x4B && n[2] < 0x09 && n[3] < 0x09) ? read_zip(d, o) : read_prn(data, d, o, str);
		case 0xEF: return n[3] === 0x3C ? parse_xlml(d, o) : read_prn(data, d, o, str);
		case 0xFF:
			if(n[1] === 0xFE) { return read_utf16(d, o); }
			else if(n[1] === 0x00 && n[2] === 0x02 && n[3] === 0x00) return WK_.to_workbook(d, o);
			break;
		case 0x00:
			if(n[1] === 0x00) {
				if(n[2] >= 0x02 && n[3] === 0x00) return WK_.to_workbook(d, o);
				if(n[2] === 0x00 && (n[3] === 0x08 || n[3] === 0x09)) return WK_.to_workbook(d, o);
			}
			break;
		case 0x03: case 0x83: case 0x8B: case 0x8C: return DBF.to_workbook(d, o);
		case 0x7B: if(n[1] === 0x5C && n[2] === 0x72 && n[3] === 0x74) return RTF.to_workbook(d, o); break;
		case 0x0A: case 0x0D: case 0x20: return read_plaintext_raw(d, o);
		case 0x89: if(n[1] === 0x50 && n[2] === 0x4E && n[3] === 0x47) throw new Error("PNG Image File is not a spreadsheet"); break;
	}
	if(DBF.versions.indexOf(n[0]) > -1 && n[2] <= 12 && n[3] <= 31) return DBF.to_workbook(d, o);
	return read_prn(data, d, o, str);
}

function readFileSync(filename/*:string*/, opts/*:?ParseOpts*/)/*:Workbook*/ {
	var o = opts||{}; o.type = 'file';
	return readSync(filename, o);
}
function write_obj_str(factory/*:WriteObjStrFactory*/) {
	return function write_str(wb/*:Workbook*/, o/*:WriteOpts*/)/*:string*/ {
		var idx = 0;
		if(o.sheet) {
			if(typeof o.sheet == "number") idx = o.sheet;
			else idx = wb.SheetNames.indexOf(o.sheet);
			if(!wb.SheetNames[idx]) throw new Error("Sheet not found: " + o.sheet + " : " + (typeof o.sheet));
		}
		return factory.from_sheet(wb.Sheets[wb.SheetNames[idx]], o, wb);
	};
}

var write_htm_str = write_obj_str(HTML_);
var write_csv_str = write_obj_str({from_sheet:sheet_to_csv});
var write_slk_str = write_obj_str(typeof SYLK !== "undefined" ? SYLK : {});
var write_dif_str = write_obj_str(typeof DIF !== "undefined" ? DIF : {});
var write_prn_str = write_obj_str(typeof PRN !== "undefined" ? PRN : {});
var write_rtf_str = write_obj_str(typeof RTF !== "undefined" ? RTF : {});
var write_txt_str = write_obj_str({from_sheet:sheet_to_txt});
var write_dbf_buf = write_obj_str(typeof DBF !== "undefined" ? DBF : {});
var write_eth_str = write_obj_str(typeof ETH !== "undefined" ? ETH : {});
var write_wk1_buf = write_obj_str(typeof WK_ !== "undefined" ? {from_sheet:WK_.sheet_to_wk1} : {});

function write_cfb_ctr(cfb/*:CFBContainer*/, o/*:WriteOpts*/)/*:any*/ {
	switch(o.type) {
		case "base64": case "binary": break;
		case "buffer": case "array": o.type = ""; break;
		case "file": return write_dl(o.file, CFB.write(cfb, {type:has_buf ? 'buffer' : ""}));
		case "string": throw new Error("'string' output type invalid for '" + o.bookType + "' files");
		default: throw new Error("Unrecognized type " + o.type);
	}
	return CFB.write(cfb, o);
}

/*:: declare var encrypt_agile:any; */
function write_zip_type(wb/*:Workbook*/, opts/*:?WriteOpts*/)/*:any*/ {
	var o = dup(opts||{});
	var z = write_zip(wb, o);
	return write_zip_denouement(z, o);
}
function write_zip_typeXLSX(wb/*:Workbook*/, opts/*:?WriteOpts*/)/*:any*/ {
	var o = dup(opts||{});
	var z = write_zip_xlsx(wb, o);
	return write_zip_denouement(z, o);
}
function write_zip_denouement(z/*:any*/, o/*:?WriteOpts*/)/*:any*/ {
	var oopts = {};
	if(o.compression) oopts.compression = 'DEFLATE';
	if(o.password) oopts.type = has_buf ? "nodebuffer" : "string";
	else switch(o.type) {
		case "base64": oopts.type = "base64"; break;
		case "binary": oopts.type = "string"; break;
		case "string": throw new Error("'string' output type invalid for '" + o.bookType + "' files");
		case "buffer":
		case "file": oopts.type = has_buf ? "nodebuffer" : "string"; break;
		default: throw new Error("Unrecognized type " + o.type);
	}
	var out = z.FullPaths ? CFB.write(z, {fileType:"zip", type: /*::(*/{"nodebuffer": "buffer", "string": "binary"}/*:: :any)*/[oopts.type] || oopts.type, compression: !!o.compression}) : z.generate(oopts);
	if(typeof Deno !== "undefined") {
		if(typeof out == "string") {
			if(o.type == "binary" || o.type == "base64") return out;
			out = new Uint8Array(s2ab(out));
		}
	}
/*jshint -W083 */
	if(o.password && typeof encrypt_agile !== 'undefined') return write_cfb_ctr(encrypt_agile(out, o.password), o); // eslint-disable-line no-undef
/*jshint +W083 */
	if(o.type === "file") return write_dl(o.file, out);
	return o.type == "string" ? utf8read(/*::(*/out/*:: :any)*/) : out;
}

function write_cfb_type(wb/*:Workbook*/, opts/*:?WriteOpts*/)/*:any*/ {
	var o = opts||{};
	var cfb/*:CFBContainer*/ = write_xlscfb(wb, o);
	return write_cfb_ctr(cfb, o);
}

function write_string_type(out/*:string*/, opts/*:WriteOpts*/, bom/*:?string*/)/*:any*/ {
	if(!bom) bom = "";
	var o = bom + out;
	switch(opts.type) {
		case "base64": return Base64.encode(utf8write(o));
		case "binary": return utf8write(o);
		case "string": return out;
		case "file": return write_dl(opts.file, o, 'utf8');
		case "buffer": {
			if(has_buf) return Buffer_from(o, 'utf8');
			else if(typeof TextEncoder !== "undefined") return new TextEncoder().encode(o);
			else return write_string_type(o, {type:'binary'}).split("").map(function(c) { return c.charCodeAt(0); });
		}
	}
	throw new Error("Unrecognized type " + opts.type);
}

function write_stxt_type(out/*:string*/, opts/*:WriteOpts*/)/*:any*/ {
	switch(opts.type) {
		case "base64": return Base64.encode(out);
		case "binary": return out;
		case "string": return out; /* override in sheet_to_txt */
		case "file": return write_dl(opts.file, out, 'binary');
		case "buffer": {
			if(has_buf) return Buffer_from(out, 'binary');
			else return out.split("").map(function(c) { return c.charCodeAt(0); });
		}
	}
	throw new Error("Unrecognized type " + opts.type);
}

/* TODO: test consistency */
function write_binary_type(out, opts/*:WriteOpts*/)/*:any*/ {
	switch(opts.type) {
		case "string":
		case "base64":
		case "binary":
			var bstr = "";
			// $FlowIgnore
			for(var i = 0; i < out.length; ++i) bstr += String.fromCharCode(out[i]);
			return opts.type == 'base64' ? Base64.encode(bstr) : opts.type == 'string' ? utf8read(bstr) : bstr;
		case "file": return write_dl(opts.file, out);
		case "buffer": return out;
		default: throw new Error("Unrecognized type " + opts.type);
	}
}

function writeSyncXLSX(wb/*:Workbook*/, opts/*:?WriteOpts*/) {
	reset_cp();
	check_wb(wb);
	var o = dup(opts||{});
	if(o.cellStyles) { o.cellNF = true; o.sheetStubs = true; }
	if(o.type == "array") { o.type = "binary"; var out/*:string*/ = (writeSyncXLSX(wb, o)/*:any*/); o.type = "array"; return s2ab(out); }
	return write_zip_typeXLSX(wb, o);
}

function writeSync(wb/*:Workbook*/, opts/*:?WriteOpts*/) {
	reset_cp();
	check_wb(wb);
	var o = dup(opts||{});
	if(o.cellStyles) { o.cellNF = true; o.sheetStubs = true; }
	if(o.type == "array") { o.type = "binary"; var out/*:string*/ = (writeSync(wb, o)/*:any*/); o.type = "array"; return s2ab(out); }
	switch(o.bookType || 'xlsb') {
		case 'xml':
		case 'xlml': return write_string_type(write_xlml(wb, o), o);
		case 'slk':
		case 'sylk': return write_string_type(write_slk_str(wb, o), o);
		case 'htm':
		case 'html': return write_string_type(write_htm_str(wb, o), o);
		case 'txt': return write_stxt_type(write_txt_str(wb, o), o);
		case 'csv': return write_string_type(write_csv_str(wb, o), o, "\ufeff");
		case 'dif': return write_string_type(write_dif_str(wb, o), o);
		case 'dbf': return write_binary_type(write_dbf_buf(wb, o), o);
		case 'prn': return write_string_type(write_prn_str(wb, o), o);
		case 'rtf': return write_string_type(write_rtf_str(wb, o), o);
		case 'eth': return write_string_type(write_eth_str(wb, o), o);
		case 'fods': return write_string_type(write_ods(wb, o), o);
		case 'wk1': return write_binary_type(write_wk1_buf(wb, o), o);
		case 'wk3': return write_binary_type(WK_.book_to_wk3(wb, o), o);
		case 'biff2': if(!o.biff) o.biff = 2; /* falls through */
		case 'biff3': if(!o.biff) o.biff = 3; /* falls through */
		case 'biff4': if(!o.biff) o.biff = 4; return write_binary_type(write_biff_buf(wb, o), o);
		case 'biff5': if(!o.biff) o.biff = 5; /* falls through */
		case 'biff8':
		case 'xla':
		case 'xls': if(!o.biff) o.biff = 8; return write_cfb_type(wb, o);
		case 'xlsx':
		case 'xlsm':
		case 'xlam':
		case 'xlsb':
		case 'ods': return write_zip_type(wb, o);
		default: throw new Error ("Unrecognized bookType |" + o.bookType + "|");
	}
}

function resolve_book_type(o/*:WriteFileOpts*/) {
	if(o.bookType) return;
	var _BT = {
		"xls": "biff8",
		"htm": "html",
		"slk": "sylk",
		"socialcalc": "eth",
		"Sh33tJS": "WTF"
	};
	var ext = o.file.slice(o.file.lastIndexOf(".")).toLowerCase();
	if(ext.match(/^\.[a-z]+$/)) o.bookType = ext.slice(1);
	o.bookType = _BT[o.bookType] || o.bookType;
}

function writeFileSync(wb/*:Workbook*/, filename/*:string*/, opts/*:?WriteFileOpts*/) {
	var o = opts||{}; o.type = 'file';
	o.file = filename;
	resolve_book_type(o);
	return writeSync(wb, o);
}

function writeFileSyncXLSX(wb/*:Workbook*/, filename/*:string*/, opts/*:?WriteFileOpts*/) {
	var o = opts||{}; o.type = 'file';
	o.file = filename;
	resolve_book_type(o);
	return writeSyncXLSX(wb, o);
}


function writeFileAsync(filename/*:string*/, wb/*:Workbook*/, opts/*:?WriteFileOpts*/, cb/*:?(e?:ErrnoError)=>void*/) {
	var o = opts||{}; o.type = 'file';
	o.file = filename;
	resolve_book_type(o);
	o.type = 'buffer';
	var _cb = cb; if(!(_cb instanceof Function)) _cb = (opts/*:any*/);
	return _fs.writeFile(filename, writeSync(wb, o), _cb);
}
/*::
type MJRObject = {
	row: any;
	isempty: boolean;
};
*/
function make_json_row(sheet/*:Worksheet*/, r/*:Range*/, R/*:number*/, cols/*:Array<string>*/, header/*:number*/, hdr/*:Array<any>*/, dense/*:boolean*/, o/*:Sheet2JSONOpts*/)/*:MJRObject*/ {
	var rr = encode_row(R);
	var defval = o.defval, raw = o.raw || !Object.prototype.hasOwnProperty.call(o, "raw");
	var isempty = true;
	var row/*:any*/ = (header === 1) ? [] : {};
	if(header !== 1) {
		if(Object.defineProperty) try { Object.defineProperty(row, '__rowNum__', {value:R, enumerable:false}); } catch(e) { row.__rowNum__ = R; }
		else row.__rowNum__ = R;
	}
	if(!dense || sheet[R]) for (var C = r.s.c; C <= r.e.c; ++C) {
		var val = dense ? sheet[R][C] : sheet[cols[C] + rr];
		if(val === undefined || val.t === undefined) {
			if(defval === undefined) continue;
			if(hdr[C] != null) { row[hdr[C]] = defval; }
			continue;
		}
		var v = val.v;
		switch(val.t){
			case 'z': if(v == null) break; continue;
			case 'e': v = (v == 0 ? null : void 0); break;
			case 's': case 'd': case 'b': case 'n': break;
			default: throw new Error('unrecognized type ' + val.t);
		}
		if(hdr[C] != null) {
			if(v == null) {
				if(val.t == "e" && v === null) row[hdr[C]] = null;
				else if(defval !== undefined) row[hdr[C]] = defval;
				else if(raw && v === null) row[hdr[C]] = null;
				else continue;
			} else {
				row[hdr[C]] = raw || (o.rawNumbers && val.t == "n") ? v : format_cell(val,v,o);
			}
			if(v != null) isempty = false;
		}
	}
	return { row: row, isempty: isempty };
}


function sheet_to_json(sheet/*:Worksheet*/, opts/*:?Sheet2JSONOpts*/) {
	if(sheet == null || sheet["!ref"] == null) return [];
	var val = {t:'n',v:0}, header = 0, offset = 1, hdr/*:Array<any>*/ = [], v=0, vv="";
	var r = {s:{r:0,c:0},e:{r:0,c:0}};
	var o = opts || {};
	var range = o.range != null ? o.range : sheet["!ref"];
	if(o.header === 1) header = 1;
	else if(o.header === "A") header = 2;
	else if(Array.isArray(o.header)) header = 3;
	else if(o.header == null) header = 0;
	switch(typeof range) {
		case 'string': r = safe_decode_range(range); break;
		case 'number': r = safe_decode_range(sheet["!ref"]); r.s.r = range; break;
		default: r = range;
	}
	if(header > 0) offset = 0;
	var rr = encode_row(r.s.r);
	var cols/*:Array<string>*/ = [];
	var out/*:Array<any>*/ = [];
	var outi = 0, counter = 0;
	var dense = Array.isArray(sheet);
	var R = r.s.r, C = 0, CC = 0;
	if(dense && !sheet[R]) sheet[R] = [];
	for(C = r.s.c; C <= r.e.c; ++C) {
		cols[C] = encode_col(C);
		val = dense ? sheet[R][C] : sheet[cols[C] + rr];
		switch(header) {
			case 1: hdr[C] = C - r.s.c; break;
			case 2: hdr[C] = cols[C]; break;
			case 3: hdr[C] = o.header[C - r.s.c]; break;
			default:
				if(val == null) val = {w: "__EMPTY", t: "s"};
				vv = v = format_cell(val, null, o);
				counter = 0;
				for(CC = 0; CC < hdr.length; ++CC) if(hdr[CC] == vv) vv = v + "_" + (++counter);
				hdr[C] = vv;
		}
	}
	for (R = r.s.r + offset; R <= r.e.r; ++R) {
		var row = make_json_row(sheet, r, R, cols, header, hdr, dense, o);
		if((row.isempty === false) || (header === 1 ? o.blankrows !== false : !!o.blankrows)) out[outi++] = row.row;
	}
	out.length = outi;
	return out;
}

var qreg = /"/g;
function make_csv_row(sheet/*:Worksheet*/, r/*:Range*/, R/*:number*/, cols/*:Array<string>*/, fs/*:number*/, rs/*:number*/, FS/*:string*/, o/*:Sheet2CSVOpts*/)/*:?string*/ {
	var isempty = true;
	var row/*:Array<string>*/ = [], txt = "", rr = encode_row(R);
	for(var C = r.s.c; C <= r.e.c; ++C) {
		if (!cols[C]) continue;
		var val = o.dense ? (sheet[R]||[])[C]: sheet[cols[C] + rr];
		if(val == null) txt = "";
		else if(val.v != null) {
			isempty = false;
			txt = ''+(o.rawNumbers && val.t == "n" ? val.v : format_cell(val, null, o));
			for(var i = 0, cc = 0; i !== txt.length; ++i) if((cc = txt.charCodeAt(i)) === fs || cc === rs || cc === 34 || o.forceQuotes) {txt = "\"" + txt.replace(qreg, '""') + "\""; break; }
			if(txt == "ID") txt = '"ID"';
		} else if(val.f != null && !val.F) {
			isempty = false;
			txt = '=' + val.f; if(txt.indexOf(",") >= 0) txt = '"' + txt.replace(qreg, '""') + '"';
		} else txt = "";
		/* NOTE: Excel CSV does not support array formulae */
		row.push(txt);
	}
	if(o.blankrows === false && isempty) return null;
	return row.join(FS);
}

function sheet_to_csv(sheet/*:Worksheet*/, opts/*:?Sheet2CSVOpts*/)/*:string*/ {
	var out/*:Array<string>*/ = [];
	var o = opts == null ? {} : opts;
	if(sheet == null || sheet["!ref"] == null) return "";
	var r = safe_decode_range(sheet["!ref"]);
	var FS = o.FS !== undefined ? o.FS : ",", fs = FS.charCodeAt(0);
	var RS = o.RS !== undefined ? o.RS : "\n", rs = RS.charCodeAt(0);
	var endregex = new RegExp((FS=="|" ? "\\|" : FS)+"+$");
	var row = "", cols/*:Array<string>*/ = [];
	o.dense = Array.isArray(sheet);
	var colinfo/*:Array<ColInfo>*/ = o.skipHidden && sheet["!cols"] || [];
	var rowinfo/*:Array<ColInfo>*/ = o.skipHidden && sheet["!rows"] || [];
	for(var C = r.s.c; C <= r.e.c; ++C) if (!((colinfo[C]||{}).hidden)) cols[C] = encode_col(C);
	for(var R = r.s.r; R <= r.e.r; ++R) {
		if ((rowinfo[R]||{}).hidden) continue;
		row = make_csv_row(sheet, r, R, cols, fs, rs, FS, o);
		if(row == null) { continue; }
		if(o.strip) row = row.replace(endregex,"");
		out.push(row + RS);
	}
	delete o.dense;
	return out.join("");
}

function sheet_to_txt(sheet/*:Worksheet*/, opts/*:?Sheet2CSVOpts*/) {
	if(!opts) opts = {}; opts.FS = "\t"; opts.RS = "\n";
	var s = sheet_to_csv(sheet, opts);
	if(typeof cptable == 'undefined' || opts.type == 'string') return s;
	var o = cptable.utils.encode(1200, s, 'str');
	return String.fromCharCode(255) + String.fromCharCode(254) + o;
}

function sheet_to_formulae(sheet/*:Worksheet*/)/*:Array<string>*/ {
	var y = "", x, val="";
	if(sheet == null || sheet["!ref"] == null) return [];
	var r = safe_decode_range(sheet['!ref']), rr = "", cols/*:Array<string>*/ = [], C;
	var cmds/*:Array<string>*/ = [];
	var dense = Array.isArray(sheet);
	for(C = r.s.c; C <= r.e.c; ++C) cols[C] = encode_col(C);
	for(var R = r.s.r; R <= r.e.r; ++R) {
		rr = encode_row(R);
		for(C = r.s.c; C <= r.e.c; ++C) {
			y = cols[C] + rr;
			x = dense ? (sheet[R]||[])[C] : sheet[y];
			val = "";
			if(x === undefined) continue;
			else if(x.F != null) {
				y = x.F;
				if(!x.f) continue;
				val = x.f;
				if(y.indexOf(":") == -1) y = y + ":" + y;
			}
			if(x.f != null) val = x.f;
			else if(x.t == 'z') continue;
			else if(x.t == 'n' && x.v != null) val = "" + x.v;
			else if(x.t == 'b') val = x.v ? "TRUE" : "FALSE";
			else if(x.w !== undefined) val = "'" + x.w;
			else if(x.v === undefined) continue;
			else if(x.t == 's') val = "'" + x.v;
			else val = ""+x.v;
			cmds[cmds.length] = y + "=" + val;
		}
	}
	return cmds;
}

function sheet_add_json(_ws/*:?Worksheet*/, js/*:Array<any>*/, opts)/*:Worksheet*/ {
	var o = opts || {};
	var offset = +!o.skipHeader;
	var ws/*:Worksheet*/ = _ws || ({}/*:any*/);
	var _R = 0, _C = 0;
	if(ws && o.origin != null) {
		if(typeof o.origin == 'number') _R = o.origin;
		else {
			var _origin/*:CellAddress*/ = typeof o.origin == "string" ? decode_cell(o.origin) : o.origin;
			_R = _origin.r; _C = _origin.c;
		}
	}
	var cell/*:Cell*/;
	var range/*:Range*/ = ({s: {c:0, r:0}, e: {c:_C, r:_R + js.length - 1 + offset}}/*:any*/);
	if(ws['!ref']) {
		var _range = safe_decode_range(ws['!ref']);
		range.e.c = Math.max(range.e.c, _range.e.c);
		range.e.r = Math.max(range.e.r, _range.e.r);
		if(_R == -1) { _R = _range.e.r + 1; range.e.r = _R + js.length - 1 + offset; }
	} else {
		if(_R == -1) { _R = 0; range.e.r = js.length - 1 + offset; }
	}
	var hdr/*:Array<string>*/ = o.header || [], C = 0;

	js.forEach(function (JS, R/*:number*/) {
		keys$1(JS).forEach(function(k) {
			if((C=hdr.indexOf(k)) == -1) hdr[C=hdr.length] = k;
			var v = JS[k];
			var t = 'z';
			var z = "";
			var ref = encode_cell({c:_C + C,r:_R + R + offset});
			cell = utils.sheet_get_cell(ws, ref);
			if(v && typeof v === 'object' && !(v instanceof Date)){
				ws[ref] = v;
			} else {
				if(typeof v == 'number') t = 'n';
				else if(typeof v == 'boolean') t = 'b';
				else if(typeof v == 'string') t = 's';
				else if(v instanceof Date) {
					t = 'd';
					if(!o.cellDates) { t = 'n'; v = datenum(v); }
					z = (o.dateNF || SSF._table[14]);
				}
				else if(v === null && o.nullError) { t = 'e'; v = 0; }
				if(!cell) ws[ref] = cell = ({t:t, v:v}/*:any*/);
				else {
					cell.t = t; cell.v = v;
					delete cell.w; delete cell.R;
					if(z) cell.z = z;
				}
				if(z) cell.z = z;
			}
		});
	});
	range.e.c = Math.max(range.e.c, _C + hdr.length - 1);
	var __R = encode_row(_R);
	if(offset) for(C = 0; C < hdr.length; ++C) ws[encode_col(C + _C) + __R] = {t:'s', v:hdr[C]};
	ws['!ref'] = encode_range(range);
	return ws;
}
function json_to_sheet(js/*:Array<any>*/, opts)/*:Worksheet*/ { return sheet_add_json(null, js, opts); }

var utils/*:any*/ = {
	encode_col: encode_col,
	encode_row: encode_row,
	encode_cell: encode_cell,
	encode_range: encode_range,
	decode_col: decode_col,
	decode_row: decode_row,
	split_cell: split_cell,
	decode_cell: decode_cell,
	decode_range: decode_range,
	format_cell: format_cell,
	sheet_add_aoa: sheet_add_aoa,
	sheet_add_json: sheet_add_json,
	sheet_add_dom: sheet_add_dom,
	aoa_to_sheet: aoa_to_sheet,
	json_to_sheet: json_to_sheet,
	table_to_sheet: parse_dom_table,
	table_to_book: table_to_book,
	sheet_to_csv: sheet_to_csv,
	sheet_to_txt: sheet_to_txt,
	sheet_to_json: sheet_to_json,
	sheet_to_html: HTML_.from_sheet,
	sheet_to_formulae: sheet_to_formulae,
	sheet_to_row_object_array: sheet_to_json
};

(function(utils) {
utils.consts = utils.consts || {};
function add_consts(R/*Array<any>*/) { R.forEach(function(a){ utils.consts[a[0]] = a[1]; }); }

function get_default(x/*:any*/, y/*:any*/, z/*:any*/)/*:any*/ { return x[y] != null ? x[y] : (x[y] = z); }

/* get cell, creating a stub if necessary */
function ws_get_cell_stub(ws/*:Worksheet*/, R, C/*:?number*/)/*:Cell*/ {
	/* A1 cell address */
	if(typeof R == "string") {
		/* dense */
		if(Array.isArray(ws)) {
			var RC = decode_cell(R);
			if(!ws[RC.r]) ws[RC.r] = [];
			return ws[RC.r][RC.c] || (ws[RC.r][RC.c] = {t:'z'});
		}
		return ws[R] || (ws[R] = {t:'z'});
	}
	/* cell address object */
	if(typeof R != "number") return ws_get_cell_stub(ws, encode_cell(R));
	/* R and C are 0-based indices */
	return ws_get_cell_stub(ws, encode_cell({r:R,c:C||0}));
}
utils.sheet_get_cell = ws_get_cell_stub;

/* find sheet index for given name / validate index */
function wb_sheet_idx(wb/*:Workbook*/, sh/*:number|string*/) {
	if(typeof sh == "number") {
		if(sh >= 0 && wb.SheetNames.length > sh) return sh;
		throw new Error("Cannot find sheet # " + sh);
	} else if(typeof sh == "string") {
		var idx = wb.SheetNames.indexOf(sh);
		if(idx > -1) return idx;
		throw new Error("Cannot find sheet name |" + sh + "|");
	} else throw new Error("Cannot find sheet |" + sh + "|");
}

/* simple blank workbook object */
utils.book_new = function()/*:Workbook*/ {
	return { SheetNames: [], Sheets: {} };
};

/* add a worksheet to the end of a given workbook */
utils.book_append_sheet = function(wb/*:Workbook*/, ws/*:Worksheet*/, name/*:?string*/) {
	if(!name) for(var i = 1; i <= 0xFFFF; ++i, name = undefined) if(wb.SheetNames.indexOf(name = "Sheet" + i) == -1) break;
	if(!name || wb.SheetNames.length >= 0xFFFF) throw new Error("Too many worksheets");
	check_ws_name(name);
	if(wb.SheetNames.indexOf(name) >= 0) throw new Error("Worksheet with name |" + name + "| already exists!");

	wb.SheetNames.push(name);
	wb.Sheets[name] = ws;
};

/* set sheet visibility (visible/hidden/very hidden) */
utils.book_set_sheet_visibility = function(wb/*:Workbook*/, sh/*:number|string*/, vis/*:number*/) {
	get_default(wb,"Workbook",{});
	get_default(wb.Workbook,"Sheets",[]);

	var idx = wb_sheet_idx(wb, sh);
	// $FlowIgnore
	get_default(wb.Workbook.Sheets,idx, {});

	switch(vis) {
		case 0: case 1: case 2: break;
		default: throw new Error("Bad sheet visibility setting " + vis);
	}
	// $FlowIgnore
	wb.Workbook.Sheets[idx].Hidden = vis;
};
add_consts([
	["SHEET_VISIBLE", 0],
	["SHEET_HIDDEN", 1],
	["SHEET_VERY_HIDDEN", 2]
]);

/* set number format */
utils.cell_set_number_format = function(cell/*:Cell*/, fmt/*:string|number*/) {
	cell.z = fmt;
	return cell;
};

/* set cell hyperlink */
utils.cell_set_hyperlink = function(cell/*:Cell*/, target/*:string*/, tooltip/*:?string*/) {
	if(!target) {
		delete cell.l;
	} else {
		cell.l = ({ Target: target }/*:Hyperlink*/);
		if(tooltip) cell.l.Tooltip = tooltip;
	}
	return cell;
};
utils.cell_set_internal_link = function(cell/*:Cell*/, range/*:string*/, tooltip/*:?string*/) { return utils.cell_set_hyperlink(cell, "#" + range, tooltip); };

/* add to cell comments */
utils.cell_add_comment = function(cell/*:Cell*/, text/*:string*/, author/*:?string*/) {
	if(!cell.c) cell.c = [];
	cell.c.push({t:text, a:author||"SheetJS"});
};

/* set array formula and flush related cells */
utils.sheet_set_array_formula = function(ws/*:Worksheet*/, range, formula/*:string*/) {
	var rng = typeof range != "string" ? range : safe_decode_range(range);
	var rngstr = typeof range == "string" ? range : encode_range(range);
	for(var R = rng.s.r; R <= rng.e.r; ++R) for(var C = rng.s.c; C <= rng.e.c; ++C) {
		var cell = ws_get_cell_stub(ws, R, C);
		cell.t = 'n';
		cell.F = rngstr;
		delete cell.v;
		if(R == rng.s.r && C == rng.s.c) cell.f = formula;
	}
	return ws;
};

return utils;
})(utils);

const version = XLSX.version;

var xlsx = /*#__PURE__*/Object.freeze({
	__proto__: null,
	set_cptable: set_cptable,
	set_fs: set_fs,
	version: version,
	parse_xlscfb: parse_xlscfb,
	parse_zip: parse_zip,
	read: readSync,
	readFile: readFileSync,
	readFileSync: readFileSync,
	write: writeSync,
	writeFile: writeFileSync,
	writeFileSync: writeFileSync,
	writeFileAsync: writeFileAsync,
	writeXLSX: writeSyncXLSX,
	writeFileXLSX: writeFileSyncXLSX,
	utils: utils,
	SSF: SSF,
	CFB: CFB
});

export { ADBLOCK_MESSAGE, AdvancedVideoTargeting, ApiService, AuthService, BASIC_AUTH_HEADER_VALUE, CAPSLOCK_MESSAGE, CacheableActionQueue, CampaignAdvanced, CampaignAudience, CampaignBidStrategy, CampaignBudget, CampaignCreatives, CampaignDemographic, CampaignDetails, CampaignInventory, CampaignLocation, CampaignPoliticalAdvertiser, CampaignScheduling, CampaignTechnology, ColumnOptions, CreativeCard, CustomerLazySelect, DataDogRumRoute, CSVDownloadingProgress as DownloadCsvProgress, XLSXDownloadingProgress as DownloadXlsxProgress, EpochDatePicker, EpochDateRangePicker, EpochSingleDateRangePicker, GENERAL_API_ERROR, GroupManager, GroupedLazyLoad, Header, INTERCOM_APP_ID, IQMRouter, LazySelect, ModalCreativePreview, NestedCustomerSelect, ORIGIN_URL, SelectWithCreatingBlock, SimpleHeader, Skeleton, TableBaseRoot, TableBodyMapping, TableComponent, TableDownloadOptions, TableHeaderMapping, TableSortedOptions, TimezonePicker$1 as TimezonePicker, TimezoneProvider, TwoPartScreen, styles$j as TwoPartScreenStyles, WaitIndicator, bootIntercomFn, copyText, ddRum as datadogRum, enableLogRocket, filesUtils, getAccountType, getApiErrorContext, getApiErrorMsg, getHeaders, getOwId, getPathNumber, identifyLogRocket, initDataDog, isIHPOwner, logDataDogAction, parseVASTDAAST, selectText, setDataDogSessionUser, useAdblockCheck, useCapslockCheck, userAuth, validate as validationUtils, withDataDogCallbackLogging };
//# sourceMappingURL=index.es.js.map
